webpackJsonp([1,0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(9);
	var core = __webpack_require__(36);
	var hide = __webpack_require__(26);
	var redefine = __webpack_require__(27);
	var ctx = __webpack_require__(37);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(247)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(904)(module)))

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(25),
		__webpack_require__(210),
		__webpack_require__(325),
		__webpack_require__(208),
		__webpack_require__(828),
		__webpack_require__(400),
		__webpack_require__(827),
		__webpack_require__(333),
		__webpack_require__(842),
		__webpack_require__(817),
		__webpack_require__(209),
		__webpack_require__(835),
		__webpack_require__(243),
		__webpack_require__(839),
		__webpack_require__(848),
		__webpack_require__(221),
		__webpack_require__(824),
		__webpack_require__(417),
		__webpack_require__(206),
		__webpack_require__(816),
		__webpack_require__(814),
		__webpack_require__(811),
		__webpack_require__(812),
		__webpack_require__(833),
		__webpack_require__(331),
		__webpack_require__(832),
		__webpack_require__(841),
		__webpack_require__(830),
		__webpack_require__(829),
		__webpack_require__(837),
		__webpack_require__(838)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	return jQuery;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(222),
		__webpack_require__(21),
		__webpack_require__(847),
		__webpack_require__(246),
		__webpack_require__(420),
		__webpack_require__(423),
		__webpack_require__(335),
		__webpack_require__(244),
		__webpack_require__(424),
		__webpack_require__(334),
		__webpack_require__(421),
		__webpack_require__(846),
		__webpack_require__(201),
		__webpack_require__(20),
		__webpack_require__(223),
		__webpack_require__(399),
		__webpack_require__(207)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr, document, getProto, slice, concat, push, indexOf,
		class2type, toString, hasOwn, fnToString, ObjectFunctionString,
		support, isFunction, isWindow, DOMEval, toType ) {
	
	"use strict";
	
	var
		version = "3.4.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code, options ) {
			DOMEval( code, { nonce: options && options.nonce } );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(14);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

	module.exports = {"version":"1.0.0","locale":"nl-BE","localization":{"todo.title":"Oeps...","todo.text":"Dit onderdeel is nog niet klaar.","__navigation.home":"Home","__navigation.about":"About us","__navigation.contact":"Contact us","__navigation.help":"Information","__navigation.faq":"FAQ","__navigation.login":"Log in","navigation.edit_profile":"Profiel aanpassen","navigation.logout":"Afmelden","navigation.cms.cases":"Cases","navigation.cms.website":"Website","navigation.cms.feedback":"Feedback","navigation.cms.logout":"Uitloggen","navigation.marketing.welcome":"Welkom","navigation.marketing.teacher_platform":"Leerkrachtenplatform","navigation.marketing.faq":"FAQ","navigation.marketing.contact":"Contact","landings_page.title":"Circonopoly","login.page_title":"Leerkrachtenplatform","login.title":"Log in","login.forms.title":"Mijn sessies","login.forms.1.description":"Vul je e-mailadres in om naar Mijn Sessies te gaan.","login.forms.2.description":"Vul nu je wachtwoord in.","login.form.labels.username":"E-mail","login.form.labels.password":"Wachtwoord","login.steps.next.btn":"Volgende","login.actions.login":"Log in","login.actions.password_lost":"Wachtwoord vergeten?","login.actions.register":"Nog niet geregistreerd?","login.errors.username_not_found":"Er bestaat geen account voor dit e-mailadres","login.errors.password_incorrect":"Wachtwoord is onjuist.","login.errors.unexpected":"Er liep iets fout, gelieve opnieuw te proberen","register.page_title":"Leerkrachtenplatform","register.title":"Registreren","register.terms_and_conditions.title":"Algemene voorwaarden","register.description":"Je bent nog niet geregistreerd. Vul onderstaande velden in.","register.form.labels.email":"E-mail","register.form.labels.password":"Wachtwoord","register.form.labels.password_repeat":"Herhaal wachtwoord","register.form.terms_and_conditions.summary":"<p>Circonopoly is een product gerealiseerd door de POM West-Vlaanderen in samenwerking met de sectorfondsen Cobot en Plastiq, met steun van Vlaanderen Circulair, hierna ‘de partners’ genoemd.</p>  <p>De doelstelling is om via een <b>educatief spel</b> de jongeren onder te dompelen in de wereld van circulair ondernemerschap. Het zet jongeren aan om na te denken over <b>duurzaam materiaalgebruik</b> en <b>consumptiegedrag</b> en prikkelt hun <b>ondernemingszin</b>. Het project wilt hiermee de brug slaan tussen drie pijlers van de POM; het aanjagen van innovatie in speerpuntsectoren als nieuwe materialen (Fabrieken voor de Toekomst), het stimuleren van ondernemerschap en het informeren en enthousiasmeren van toekomstige werkzoekenden voor jobs en opleidingen in deze speerpuntsectoren</p>  <p>Om toegang te krijgen tot het spelen van het spel Circonopoly, dient u zich te registreren als gebruiker en akkoord te gaan met onze algemene voorwaarden.</p>","register.form.labels.terms_and_conditions":"Ik ga akkoord met de <a href='/terms-of-use' class='link-c-blue' target='_blank'>algemene voorwaarden</a>.","register.actions.send":"Verzenden","register.actions.confirm":"Akkoord","register.errors.password_mismatch":"De herhaling van het wachtwoord is niet correct.","register.errors.username_exists":"Er bestaat al een account voor dit e-mailadres","register.errors.unexpected":"Registreren mislukt, probeer het later opnieuw","reset_password.title":"Wachtwoord vergeten?","reset_password.form_title":"Wachtwoord vergeten?","reset_password.description":"Vul hier je e-mailadres in dat is gekoppeld aan jouw account. Hierna ontvang je een e-mail met een link om jouw wachtwoord te wijzigen.","reset_password.form.labels.email":"Email","reset_password.result.success.text":"Er is een e-mail verstuurd naar jouw e-mailadres","reset_password.result.fail.unknown_user.text":"Er is geen gebruiker gekoppeld aan dit e-mailadres","reset_password.result.fail.unexpected.text":"Er liep iets fout, gelieve opnieuw te proberen","reset_password.buttons.reset_password":"Verstuur e-mail","edit_profile.page_title":"Profiel aanpassen","edit_profile.form.labels.name":"Naam","edit_profile.form.labels.name.placeholder":"jouw naam","edit_profile.form.labels.email":"E-mail","edit_profile.form.labels.email.placeholder":"E-mail","edit_profile.form.labels.current_password":"Huidig wachtwoord","edit_profile.form.labels.current_password.placeholder":"huidig wachtwoord","edit_profile.form.labels.new_password":"Nieuw wachtwoord","edit_profile.form.labels.new_password.placeholder":"nieuw wachtwoord","edit_profile.form.labels.repeat_password":"Herhaling nieuw wachtwoord","edit_profile.form.labels.repeat_password.placeholder":"herhaling nieuw wachtwoord","edit_profile.form.actions.save":"Bewaren","edit_profile.shared.back.teacher_platform":"Leerkrachtenplatform","edit_profile.success.feedback":"Je profiel is aangepast","edit_profile.errors.password_incorrect":"Je wachtwoord is incorrect","edit_profile.errors.unexpected":"Er liep iets fout, gelieve opnieuw te proberen","change_password_token.title":"Wachtwoord wijzigen","change_password_token.form_title":"Wachtwoord wijzigen","change_password_token.form_description":"","change_password_token.form.labels.new_password":"Nieuw wachtwoord","change_password_token.form.labels.new_password.placeholder":"nieuw wachtwoord","change_password_token.form.labels.new_password_repeat":"Herhaling nieuw wachtwoord","change_password_token.form.labels.new_password_repeat.placeholder":"herhaling nieuw wachtwoord","change_password_token.success.text":"Je wachtwoord is gewijzigd","change_password.result.fail.unknown_user.text":"Er is geen gebruiker gekoppeld aan dit e-mailadres","change_password.errors.modal.title":"Wachtwoord wijzigen mislukt","change_password.errors.modal.user_not_found":"User not found","change_password.errors.modal.ticket_not_found":"Code not found","change_password.errors.modal.ticket_invalid":"Code cannot be used to change your password","change_password.errors.modal.ticket_disabled":"Code has been disabled","change_password.errors.modal.ticket_expired":"Code has expired","change_password.errors.modal.ticket_used":"Code has already been used","change_password_token.buttons.change_password":"Wachtwoord wijzigen","contact.title":"Contacteer ons","contact.intro":"Heb je verder nog vragen of opmerkingen?<br/>Neem dan contact met ons op.","contact.form.name.label":"Naam","contact.form.name.placeholder":"Naam","contact.form.email.label":"E-mail","contact.form.email.placeholder":"E-mail","contact.form.message.label":"Bericht","contact.form.message.placeholder":"Stel hier jouw vraag","contact.form.submit":"Verzenden","contact.submit.success.dialog.title":"Bericht verstuurd","contact.submit.success.dialog.message":"Jouw bericht is verzonden, we zullen zo snel mogelijk contact met jou opnemen.","about.title":"About us","help.title":"Information","faq.title":"Veelgestelde vragen","verify_email.title":"E-mail verificatie","verify_email.result.success":"Jouw e-mailadres is geverifieerd. Ga verder naar de <a href='login'>login pagina</a>.","serious_game.page_title.default":"Serious game","serious_game.page_title.introduction":"Instructie-video","serious_game.page_title.quiz":"Quiz","serious_game.page_title.score":"Score","serious_game.page_title.business_model":"Serious game","serious_game.page_title.team_overview":"Resultaat {0}","serious_game.rounds_breadcrumb.labels.quiz":"Quizvraag","serious_game.rounds_breadcrumb.labels.business_model":"Ronde","serious_game.session.title":"Deelnemen","serious_game.session.intro_text":"Vul de sessie-ID in van de sessie waaraan je&nbsp;wil&nbsp;deelnemen","serious_game.session.form.session_id.input":"Sessie-ID","serious_game.session.form.session_id.placeholder":"","serious_game.session.form.session_name.input":"Teamnaam","serious_game.session.form.session_name.placeholder":"","serious_game.session.form.session_name.tooltip":"Dit is een verplicht veld, enkel letters, cijfers, - en _ zijn toegelaten.","serious_game.session.form.join_btn":"Deelnemen","serious_game.session.form.waiting":"Wachten op deelnemers","serious_game.session.form.teamname.":"Wachten op deelnemers","serious_game.reconnect.title":"Herconnecteren","serious_game.reconnect.intro_text":"De connectie werd onverwacht afgesloten. We connecteren je opnieuw.","serious_game.reconnect.loading.text":"Wachten op connectie...","serious_game.reconnect.failed.text":"Herconnecteren mislukt","serious_game.reconnect.cancel_btn":"Annuleren","serious_game.introduction.skip_btn":"Overslaan","serious_game.quiz.waiting":"Wachten op andere teams","serious_game.quiz.result.title":"Startkapitaal","serious_game.business_model.back_to_score_btn":"Score","serious_game.business_model.loading":"Spel aan het laden...","serious_game.business_model.investments.cost.label":"Kost","serious_game.business_model.investments.yield.label":"Opbrengst","serious_game.business_model.investments.approval":"Volgende ronde indien goedgekeurd","serious_game.business_model.data_history.labels.round":"Ronde {0}:","serious_game.business_model.data_history.labels.start_budget":"Startbudget:","serious_game.business_model.data_history.labels.start_income":"Inkomen:","serious_game.business_model.data_history.labels.event":"Event:","serious_game.business_model.data_history.labels.investments":"Investeringen:","serious_game.business_model.data_history.labels.subsidy":"Subsidie:","serious_game.business_model.data_history.labels.loan":"Lening:","serious_game.business_model.data_history.labels.total_budget":"Totaal","serious_game.business_model.data_history.labels.total_points":"Totaal","serious_game.business_model.investments.categories.all":"Alle","serious_game.business_model.investments.categories.available":"Beschikbare","serious_game.business_model.investments.front.titles.biomaterials":"Materialen&nbsp;Met<br/>Bio-label&nbsp;Kopen","serious_game.business_model.investments.front.titles.extraproduct":"Uitbreiding<br/>Productgamma","serious_game.business_model.investments.front.titles.greenenergy":"Aankoop<br/>Groene&nbsp;Energie","serious_game.business_model.investments.front.titles.localproduction":"Lokaal<br/>Produceren","serious_game.business_model.investments.front.titles.paas":"Product/Service<br/>Systeem&nbsp;Aanbieden","serious_game.business_model.investments.front.titles.productredesign":"Product<br/>Redesign","serious_game.business_model.investments.front.titles.renewablematerials":"Hernieuwbare<br/>Materialen&nbsp;Gebruiken","serious_game.business_model.investments.front.titles.repairservice":"Hersteldienst<br/>Opzetten","serious_game.business_model.investments.front.titles.residualflows":"Reststromen<br/>Inkopen","serious_game.business_model.investments.front.titles.returnprogram":"Terugnname<br/>Oude&nbsp;Producten","serious_game.business_model.investments.front.titles.reuse":"Hergebruik<br/>stimuleren","serious_game.business_model.investments.front.titles.solarpanels":"Investering<br/>Zonnepanelen","serious_game.business_model.investments.front.titles.spareparts":"Wisselstukken<br/>Aanbieden","serious_game.business_model.investments.front.titles.subsidy":"Subsidiedossier<br/>Indienen","serious_game.business_model.investments.front.titles.wastevalorization":"Verdien&nbsp;Geld<br/>Met&nbsp;Afval","serious_game.business_model.investments.back.titles.biomaterials":"Materialen&nbsp;Met Bio-label&nbsp;Kopen","serious_game.business_model.investments.back.titles.extraproduct":"Uitbreiding Productgamma","serious_game.business_model.investments.back.titles.greenenergy":"Aankoop Groene&nbsp;Energie","serious_game.business_model.investments.back.titles.localproduction":"Lokaal Produceren","serious_game.business_model.investments.back.titles.paas":"Product/Service Systeem&nbsp;Aanbieden","serious_game.business_model.investments.back.titles.productredesign":"Product Redesign","serious_game.business_model.investments.back.titles.renewablematerials":"Hernieuwbare Materialen&nbsp;Gebruiken","serious_game.business_model.investments.back.titles.repairservice":"Hersteldienst Opzetten","serious_game.business_model.investments.back.titles.residualflows":"Reststromen Inkopen","serious_game.business_model.investments.back.titles.returnprogram":"Terugnname Oude&nbsp;Producten","serious_game.business_model.investments.back.titles.reuse":"Hergebruik stimuleren","serious_game.business_model.investments.back.titles.solarpanels":"Investering Zonnepanelen","serious_game.business_model.investments.back.titles.spareparts":"Wisselstukken Aanbieden","serious_game.business_model.investments.back.titles.subsidy":"Subsidiedossier Indienen","serious_game.business_model.investments.back.titles.wastevalorization":"Verdien&nbsp;Geld Met&nbsp;Afval","serious_game.business_model.investments.front.locked.unlimited_resources.description":"Deze investering is niet beschikbaar, investeer eerst in hernieuwbare materialen.","serious_game.business_model.investments.front.locked.product_redesign.description":"Deze investering is niet beschikbaar, investeer eerst in een grondig onderzoek en re-designproces.","serious_game.business_model.investments.actions.examples_btn":"Voorbeeldcase","serious_game.business_model.investments.actions.preview_btn":"Impact","serious_game.business_model.investments.actions.purchase_btn":"Aankopen","serious_game.business_model.investments.extra.titles.subsidy":"Subsidiedossier","serious_game.business_model.investments.extra.content.subsidy.shared":"Het subsidiedossier werd voorgelegd aan het kabinet voor Milieu en Klimaat.","serious_game.business_model.investments.extra.content.subsidy.approved":"Goedgekeurd","serious_game.business_model.investments.extra.content.subsidy.denied":"Afgekeurd","serious_game.business_model.investments.extra.titles.extraproduct":"Uitbreiding productgamma","serious_game.business_model.investments.extra.content.extraproduct1":"Kies het nieuwe product.","serious_game.business_model.actions.close_preview":"Sluit bedrijfsmodel","serious_game.business_model.actions.close_faq":"Sluit faq","serious_game.business_model.actions.show_tutorial":"Tutorial","serious_game.business_model.close_round.dialog.title":"Einde van de ronde","serious_game.business_model.close_round.dialog.text.2":"Ben je zeker dat je deze ronde wil beëindigen?<br/>Je kan nog 2 investeringen doen.","serious_game.business_model.close_round.dialog.text.1":"Ben je zeker dat je deze ronde wil beëindigen?<br/>Je kan nog 1 investering doen.","serious_game.business_model.close_round.dialog.text.0":"Ben je zeker dat je deze ronde wil beëindigen?","serious_game.business_model.close_round.dialog.actions.investments":"Ga naar investeringen","serious_game.business_model.close_round.dialog.actions.close_round":"Beëindig ronde","serious_game.business_model.tutorial.dialog.title":"Tutorial","serious_game.business_model.tutorial.dialog.steps.0.text":"<p>Er zijn vijf rondes, waar je telkens maximaal 2 investeringen kan doen. Zorg dat je bij het aankopen van investeringen niet bankroet gaat. Ga uit van een realistisch scenario en handel als een ondernemer, let op je inkomen en plan vooruit!</p>","serious_game.business_model.tutorial.dialog.steps.1.text":"<p>Het resterende aantal investeringen in een ronde wordt\naangeduid bij de investeringsknop.</p>","serious_game.business_model.tutorial.dialog.steps.2.text":"<p>Sommige investeringen kan je pas doen als je een andere investering hebt gedaan.\nIs de 'PRODUCT REDESIGN' investering vereist, dan wordt dit aangeduid.</p>","serious_game.business_model.tutorial.dialog.steps.3.text":"<p>Investeringen hebben een kostprijs. Meestal zijn die vast, soms variabel. 'R' staat voor ronde. In ronde 1 kost de investering 1 munt, in ronde 2 kost het 2 munten,...<br/>De circulaire punten worden éénmalig toegekend, de opbrengsten tellen iedere ronde.</p>","serious_game.business_model.tutorial.dialog.steps.4.text":"<p>Je huidig inkomen wordt weergegeven bij je bedrijf. Dit bedrag krijg je aan de start van iedere ronde. Investeringen kunnen je inkomen beïnvloeden. Zorg dat je niet bankroet gaat!</p>","serious_game.business_model.tutorial.dialog.steps.5.text":"<p>Vanaf de derde ronde krijg je te maken met willekeurige events. Deze kunnen je kapitaal of bedrijfsmodel positief of negatief beïnvloeden. Wees op je hoede!</p>","serious_game.business_model.tutorial.dialog.steps.6.text":"<p>Het bedrijfsmodel is het hoofdscherm van Circonopoly.\nDe knoppen onderaan het scherm worden hier kort uitgelegd.</p>","serious_game.business_model.tutorial.dialog.steps.7.text":"<p>Na 5 rondes weten we wie de winnaar van het spel is!\nElke 3 munten tellen dan nog voor 1 circulair punt.</p>","serious_game.business_model.score_screen.title.end_score":"Eind score","serious_game.business_model.score_screen.title.round_result":"Resultaat einde ronde {0}","serious_game.business_model.score_screen.waiting.indicator":"Nog bezig...","serious_game.business_model.score_screen.interact_btn":"Spelverloop","serious_game.business_model.events.labels.per_product":"per product","serious_game.business_model.events.labels.cost":"kost","serious_game.business_model.investments.examples.credit.prefix":"foto credits: ","serious_game.business_mode.game_bonus.dialog.title":"Circulaire verrassing!","serious_game.business_mode.game_bonus.dialog.text":"Je deed zonet je eerste circulaire investering. Hiervoor willen we je belonen met een extra circulair punt!\nKijk altijd goed naar je bedrijfsmodel en ga van een lineair naar een circulair model. Doe zo voort!","serious_game.business_mode.game_bonus.dialog.circular.text":"Je deed zonet je eerste circulaire investering. Hiervoor willen we je belonen met twee extra circulaire punten!\nKijk altijd goed naar je bedrijfsmodel en ga van een lineair naar een circulair model. Doe zo voort!","serious_game.business_model.loan.dialog.request.title":"Lening aangaan","serious_game.business_model.loan.dialog.request.text":"Je kan drie munten lenen zodat je opnieuw investeringen kan doen. Let op, op het einde van het spel worden drie circulaire punten afgetrokken van je score.","serious_game.business_model.loan.dialog.actions.request_loan":"Lening bevestigen","serious_game.business_model.loan.dialog.auto.title":"Failliet","serious_game.business_model.loan.dialog.auto.text":"Je budget aan de start van deze ronde was negatief. Om je schulden af te lossen moest je een lening aangegaan.<br/><br/>Optioneel kan je nog meer lenen, zodat je opnieuw kan investeren. Let op, op het einde van het spel wordt het geleende bedrag afgetrokken van je circulaire punten.","serious_game.business_model.loan.dialog.optional.title":"Geldnood?","serious_game.business_model.loan.dialog.optional.text":"Je budget staat momenteel op nul. Je kan ervoor kiezen om te lenen zodat je opnieuw kan investeren. Let op, op het einde van het spel wordt het geleende bedrag afgetrokken van je circulaire punten.","serious_game.business_model.faq.dialog.actions.investment":"Bijhorende investering","business_model.sectors.labels.limited_resources":"Eindige\ngrondstoffen","business_model.sectors.labels.unlimited_resources":"Oneindige grondstoffen","business_model.sectors.labels.your_company":"Je bedrijf","business_model.sectors.labels.own_channel":"Eigen kanaal","business_model.sectors.labels.stores":"Winkels","business_model.sectors.labels.product_service_system":"Product / diensten systeem","business_model.sectors.labels.repair_service":"Hersteldienst","business_model.sectors.labels.users":"Gebruikers","business_model.sectors.labels.recycling":"Recycleren","business_model.sectors.labels.collection":"Ophaling","business_model.sectors.labels.composting":"Composteren","business_model.sectors.labels.waste":"Afvalberg","teacher_platform.landings_page.title":"Leerkrachtenplatform","teacher_platform.landings_page.links.instruction":"Bekijk instructie-video","teacher_platform.landings_page.links.course_material":"Download lesmateriaal","teacher_platform.landings_page.links.sessions":"Mijn sessies","teacher_platform.shared.back.teacher_platform":"Leerkrachtenplatform","teacher_platform.shared.back.sessions_overview":"Sessies beheren","teacher_platform.instruction_video.page_title":"Instructie-video","teacher_platform.course_material.page_title":"Lesmateriaal","teacher_platform.course_material.necessities.title":"Benodigheden","teacher_platform.course_material.necessities.p1":"Circonopoly is een klasspel dat parallel gespeeld wordt in verschillende groepen. Afhankelijk van het aantal leerlingen, spelen we in groepen van 3-4 personen.","teacher_platform.course_material.necessities.list.title":"benodigdheden per groep","teacher_platform.course_material.necessities.list.1":"laptop of tablet","teacher_platform.course_material.necessities.list.2":"toegang tot internet","teacher_platform.course_material.necessities.list.3":"15 investeringskaarten","teacher_platform.course_material.necessities.download_btn":"Handleiding","teacher_platform.course_material.investment_cards.title":"Investeringskaarten","teacher_platform.course_material.investment_cards.p1":"Tijdens het spel hebben de leerlingen de kans om investeringen te doen die hen meer geld kunnen doen opleveren of kunnen bijdragen aan hun circulair bedrijfsmodel.","teacher_platform.course_material.investment_cards.download_btn":"Investeringskaarten","teacher_platform.create_session.page_title":"Sessie toevoegen","teacher_platform.create_session.form.labels.school_zip":"Postcode school","teacher_platform.create_session.form.labels.school_zip.placeholder":"postcode school","teacher_platform.create_session.form.labels.class_type":"Studierichting","teacher_platform.create_session.form.labels.study":"Studierichting","teacher_platform.create_session.form.labels.student_count":"Leerlingen in de klas","teacher_platform.create_session.form.labels.student_count.placeholder":"# leerlingen","teacher_platform.create_session.form.labels.class_name":"Klasnaam","teacher_platform.create_session.form.labels.class_name.placeholder":"klasnaam","teacher_platform.create_session.form.labels.class_name.tooltip":"Dit is een verplicht veld, enkel letters, cijfers, -, _, / en haakjes zijn toegelaten.","teacher_platform.create_session.form.labels.case":"Case","teacher_platform.create_session.form.actions.create_session":"Sessie aanmaken","teacher_platform.create_session.form.feedback.error.cases":"Het laden van de cases is mislukt, probeer het later opnieuw","teacher_platform.create_session.form.feedback.error.create":"Het maken van de sessie is mislukt, probeer het later opnieuw","teacher_platform.sessions_overview.page_title":"Sessies beheren","teacher_platform.sessions_overview.create_session.link":"Sessie toevoegen","teacher_platform.sessions_overview.table.labels.class":"Klas","teacher_platform.sessions_overview.table.labels.study":"Studierichting","teacher_platform.sessions_overview.table.labels.student_count":"Aantal leerlingen","teacher_platform.sessions_overview.table.labels.result":"Resultaat","teacher_platform.sessions_overview.table.labels.session":"Sessie","teacher_platform.sessions_overview.table.labels.action":"","teacher_platform.sessions_overview.table.labels.finished":"Voltooide sessies","teacher_platform.sessions_overview.table.student_count.suffix":"{0} leerlingen","teacher_platform.sessions_overview.table.actions.download":"Download","teacher_platform.sessions_overview.table.actions.start":"Starten","teacher_platform.sessions_overview.table.actions.duplicate":"Dupliceren","teacher_platform.sessions_overview.actions.remove.confirm_dialog.title":"Sessie verwijderen","teacher_platform.sessions_overview.actions.remove.confirm_dialog.text":"Ben je zeker dat je deze sessie wil verwijderen? Je kan deze actie niet ongedaan maken.","teacher_platform.sessions_overview.ongoing.empty":"Er zijn nog geen sessies aangemaakt.","teacher_platform.sessions_overview.finished.empty":"Er zijn nog geen voltooide sessies.","teacher_platform.session_overview.loading.text":"Connectie aan het opzetten...","teacher_platform.session_overview.instruction.page_title":"Instructie-video","teacher_platform.session_overview.session_lobby.page_title":"Sessie starten","teacher_platform.session_overview.overview.page_title":"Overzicht","teacher_platform.session_overview.score.page_title":"Score","teacher_platform.session_overview.game_progress.page_title":"Resultaat {0}","teacher_platform.session_overview.default.page_title":"Sessie","teacher_platform.session_overview.actions.skip_instruction":"Overslaan","teacher_platform.session_lobby.instructions.1":"Verdeel de klas in teams.","teacher_platform.session_lobby.instructions.2":"Zorg ervoor dat ieder team over een PC of tablet<br/>met internetverbinding beschikt.","teacher_platform.session_lobby.instructions.3":"Elk team surft naar<br/><b>www.circonopoly.be/game</b> en<br/>vult onderstaand sessie-ID of scant de QR-code in.","teacher_platform.session_lobby.instructions.4":"Druk op START als alle teams in de sessie aanwezig zijn.","teacher_platform.session_lobby.instructions.session_id.label":"sessie-ID","teacher_platform.session_lobby.teams.title":"Teams","teacher_platform.session_lobby.teams.loading.text":"wachten op deelnemers","teacher_platform.session_lobby.teams.max.label":"max. 10 teams","teacher_platform.session_lobby.teams.start_session.btn":"Start","teacher_platform.session_lobby.teams.requirement_alert.title":"Nog geen deelnemers aanwezig","teacher_platform.session_lobby.teams.requirement_alert.text":"Wacht totdat minstens één deelnemer geconnecteerd is vooraleer de sessie te starten.","teacher_platform.round_overview.previous_score.btn":"Vorige score","teacher_platform.round_overview.page_title.quiz":"Quiz","teacher_platform.round_overview.page_title.round":"Ronde {0}","teacher_platform.round_overview.events.close_btn":"Ok","teacher_platform.round_overview.round_status.quiz_question":"Quizvraag {0}","teacher_platform.round_overview.round_status.busy":"bezig","teacher_platform.round_overview.round_status.done":"klaar","teacher_platform.round_overview.show_tutorial_btn":"Toon tutorial","teacher_platform.round_overview.timer.label":"Timer:","teacher_platform.round_overview.timer.edit.label":"Wijzig de tijdslimiet per ronde:","teacher_platform.round_overview.close_round_btn":"Ronde beëindigen","teacher_platform.round_overview.close_round.confirm_dialog.title":"Ronde beëindigen","teacher_platform.round_overview.close_round.confirm_dialog.message":"Groepjes die nog bezig zijn zullen niets meer kunnen doen voor deze ronde. Ben je zeker dat je de ronde wil beëindigen?","teacher_platform.score_overview.actions.return.btn":"Terug naar overzicht","teacher_platform.score_overview.actions.return_to_sessions.btn":"leerkrachtenplatform","teacher_platform.score_overview.actions.start_round.btn":"Start ronde {0}","teacher_platform.score_overview.actions.show_quiz_questions.btn":"Toon quiz vragen","teacher_platform.score_overview.actions.show_score_screen.btn":"Toon score scherm","teacher_platform.score_overview.quiz.start_budget.title":"Startkapitaal","teacher_platform.score_overview.quiz.title":"Quiz score","teacher_platform.score_overview.round.title":"Ronde {0}","teacher_platform.score_overview.endgame.title":"Eindscore","teacher_platform.quiz_review.title":"Quiz","teacher_platform.game_progress.back_to_score.btn":"score","teacher_platform.game_progress.back_to_endscore.btn":"eindscore","teacher_platform.game_progress.loading.text":"Overzicht aan het laden...","teacher_platform.game_progress.round_selector.label":"Ronde","teacher_platform.game_progress.overview.labels.round":"Ronde","teacher_platform.game_progress.overview.labels.event":"Event","teacher_platform.game_progress.overview.labels.investments":"Investeringen","teacher_platform.game_progress.data.no_event.label":"Geen event\nplaatsgevonden","teacher_platform.game_progress.data.investment_not_used.label":"Investering\nniet gebruikt","teacher_platform.errors.session_closed.dialog.title":"Connectie verbroken","teacher_platform.errors.session_closed.dialog.message":"De sessie is afgesloten, klik op ok om terug te connecteren.","teacher_platform.errors.not_authenticated.dialog.title":"Afgemeld","teacher_platform.errors.not_authenticated.dialog.message":"Je bent niet langer aangemeld, klik op ok om terug naar de login pagina te gaan.","errors.404.title":"Error 404 - pagina niet gevonden","__footer.info.title":"Cartamundi","__footer.info.address":"Visbeekstraat 22<br>2300 Turnhout<br>Belgium<br/>","__footer.info.contact":"Tel. <a href='tel:+32 (0)14 42 02 01'>+32 (0)14 42 02 01</a><br>Fax. <a href='fax:+32 (0)14 42 02 01'>+32 (0)14 42 82 54</a><br><a href='mailto:info@circonopoly.be'>info@circonopoly.be</a>","footer.links.privacy_policy":"<a href='/privacy-policy' target='_blank'>Privacy policy</a>","__footer.links.eula":"<a href='/terms-of-use' target='_blank'>End user license agreement</a>","__footer.links.website_use":"<a href='#website-use' target='_blank'>Website use</a>","__footer.links.sales_conditions":"<a href='#sales-conditions' target='_blank'>Sales conditions</a>","__footer.links.supply_chain":"<a href='#supply-chain' target='_blank'>Supply chain</a>","__footer.info.locations":"<a href='http://cartamundi.com/en/our-locations/' target='_blank'>View all locations</a>","footer.marketing.links.eula":"Algemene voorwaarden","footer.marketing.links.privacy_policy":"Privacy","footer.marketing.links.disclaimer":"Disclaimer","footer.marketing.links.cookie_policy":"Cookies","cookies.message.old":"Circonopoly.be maakt gebruik van cookies om uw surfervaring op onze websites en softwareplatforms te verbeteren en om u gebruik te laten maken van onze diensten.","cookies.message":"Circonopoly.be gebruikt cookies. De noodzakelijke cookies zijn nodig voor het goed functioneren van het platform en kunnen niet geweigerd worden. We gebruiken enkel analytische cookies om informatie te verzamelen over het gebruik van het platform indien u hiermee instemt.","cookies.link.text":"Meer informatie","cookies.link":"/cookie-policy","cookies.button.text":"Aanvaarden en doorgaan","cookies.button.deny.text":"Verdergaan met noodzakelijke cookies","cookies.button.allow.text":"Verdergaan met analytische cookies","outdated.pagetitle":"Oeps!","outdated.oldbrowser.title":"Je lijkt nog een oude versie van je browser te gebruiken.","outdated.oldbrowser.text":"Dit kan er voor zorgen dat onze website niet correct weergegeven wordt of foutief reageert. <br>Je kan je browser up-to-date brengen via de download hieronder.","outdated.updatebrowser":"Update je browser","modal.errors.general.title":"Error","modal.errors.general.text":"Een oververwachte fout deed zich voor. Probeer even opnieuw. Indien dit probleem zich blijft voordoen, contacteer je best <a href='mailto://info@circonopoly.be'>support</a>","modal.buttons.ok":"Ok","modal.buttons.yes":"Ja","modal.buttons.no":"Neen","modal.buttons.cancel":"Annuleren","errors.services.general.title":"Oeps","errors.services.general.message":"Er is iets foutgelopen met je aanvraag. Refresh de pagina en probeer even opnieuw.","errors.services.E91489.title":"Inloggen mislukt","errors.services.E91489.message":"De gebruikersnaam is niet gekend.","errors.services.E73550.title":"Inloggen mislukt","errors.services.E73550.message":"Het opgegeven wachtwoord is niet correct.","errors.services.401.title":"Actie mislukt","errors.services.401.message":"Je hebt geen toegang (meer) tot het beveiligde gedeelte van de website. Gelieve opnieuw in te loggen.","errors.servlet.title":"Error","errors.servlet.user_not_found":"User not found","errors.servlet.ticket_not_found":"Code not found","errors.servlet.ticket_invalid":"Code cannot be used to change your password","errors.servlet.ticket_disabled":"Code has been disabled","errors.servlet.ticket_expired":"Code has expired","errors.servlet.ticket_used":"Code has already been used","errors.websocket.E45370.message":"Er is iets fout gelopen bij het connecteren, probeer het opnieuw.","errors.websocket.E88315.message":"Er is iets fout gelopen bij het connecteren, probeer het opnieuw.","errors.websocket.E88318.message":"Het maximum aantal teams voor deze sessie is reeds bereikt.","errors.websocket.E88319.message":"De sessie is al gestart, je kan geen nieuw team meer aanmaken. Gelieve deel te nemen met een teamnaam dat al is aangemaakt.","errors.websocket.E31248.message":"Er is geen sessie gevonden met het gegeven sessie-id.","errors.websocket.E88320.message":"De sessie voor het gegeven sessie-id is al voltooid.","global.video.unsupported":"Sorry, jouw browser ondersteund geen embedded video's. Je kan de video bekijken door op <a href='{0} target='_blank'>deze link</a> te klikken.","global.file_upload.choose":"Upload","global.file_upload.uploading":"Uploading...","global.file_upload.type.dialog.title":"Ongeldig bestandsformaat","global.file_upload.type.dialog.text":"Het bestandsformaat is niet correct. Gebruik JP(E)G of PNG voor afbeeldingen en een MP4 voor video's.","global.file_upload.max_size.dialog.title":"Het bestand is te groot","global.file_upload.max_size.dialog.text":"Het bestand is te groot. Verklein het bestand om een optimale downloadsnelheid te bekomen.","global.file_upload.dimensions.dialog.title":"Ongeldig afbeeldingsformaat","global.file_upload.dimensions.dialog.text":"Het bestand heeft niet de juiste afmetingen.","global.countries.placeholder":"Selecteer een land...","global.labels.minutes":"minuten","global.credits.text.initiative":"Een initiatief van","global.credits.text.realised":"Gerealiseerd door","global.credits.text.ism":"ism.","global.credits.text.support":"Met de steun van","global.credits.footer.links.privacy_policy":"Privacy policy","global.credits.footer.links.terms_and_conditions":"Algemene voorwaarden","global.forms.select.placeholder":"Maak een keuze","global.class_types.aso.label":"ASO","global.class_types.tso.label":"TSO","global.class_types.kso.label":"KSO","global.class_types.aso.studies.ECONOMIE_MODERNE_TALEN":"Economie-moderne talen","global.class_types.aso.studies.ECONOMIE_WETENSCHAPPEN":"Economie-wetenschappen","global.class_types.aso.studies.ECONOMIE_WISKUNDE":"Economie-wiskunde","global.class_types.aso.studies.GRIEKS_LATIJN":"Grieks-Latijn","global.class_types.aso.studies.GRIEKS_MODERNE_TALEN":"Grieks-moderne talen","global.class_types.aso.studies.GRIEKS_WETENSCHAPPEN":"Grieks-wetenschappen","global.class_types.aso.studies.GRIEKS_WISKUNDE":"Grieks-wiskunde","global.class_types.aso.studies.HUMANE_WETENSCHAPPEN":"Humane wetenschappen","global.class_types.aso.studies.LATIJN_MODERNE_TALEN":"Latijn-moderne talen","global.class_types.aso.studies.LATIJN_WETENSCHAPPEN":"Latijn-wetenschappen","global.class_types.aso.studies.LATIJN_WISKUNDE":"Latijn-wiskunde","global.class_types.aso.studies.MODERNE_TALEN_TOPSPORT":"Moderne talen-topsport","global.class_types.aso.studies.MODERNE_TALEN_WETENSCHAPPEN":"Moderne talen-wetenschappen","global.class_types.aso.studies.MODERNE_TALEN_WISKUNDE":"Moderne talen-wiskunde","global.class_types.aso.studies.RUDOLF_STEINERPEDAGOGIE":"Rudolf Steinerpedagogie","global.class_types.aso.studies.SPORTWETENSCHAPPEN":"Sportwetenschappen","global.class_types.aso.studies.WETENSCHAPPEN_TOPSPORT":"Wetenschappen-topsport","global.class_types.aso.studies.WETENSCHAPPEN_WISKUNDE":"Wetenschappen-wiskunde","global.class_types.aso.studies.WISKUNDE_TOPSPORT":"Wiskunde-topsport","global.class_types.aso.studies.YESHIVA":"Yeshiva","global.class_types.tso.studies.AUTOTECHNIEKEN":"Autotechnieken","global.class_types.tso.studies.AUTOTECHNIEKEN_DUAAL":"Autotechnieken duaal","global.class_types.tso.studies.BIOTECHNISCHE_WETENSCHAPPEN":"Biotechnische wetenschappen","global.class_types.tso.studies.BOEKHOUDEN_INFORMATICA":"Boekhouden - informatica","global.class_types.tso.studies.BOUW_EN_HOUTKUNDE":"Bouw- en houtkunde","global.class_types.tso.studies.BOUWTECHNIEKEN":"Bouwtechnieken","global.class_types.tso.studies.BROOD_EN_BANKET":"Brood en banket","global.class_types.tso.studies.CHEMIE":"Chemie","global.class_types.tso.studies.CREATIE_EN_MODE":"Creatie en mode","global.class_types.tso.studies.DIER_EN_LANDBOUWTECHNISCHE_WETENSCHAPPEN":"Dier- en landbouwtechnische wetenschappen","global.class_types.tso.studies.ELEKTRICITEIT_ELEKTRONICA":"Elektriciteit-elektronica","global.class_types.tso.studies.ELEKTRISCHE_INSTALLATIETECHNIEKEN":"Elektrische installatietechnieken","global.class_types.tso.studies.ELEKTROMECHANICA":"Elektromechanica","global.class_types.tso.studies.ELEKTROMECHANISCHE_TECHNIEKEN_DUAAL":"Elektromechanische technieken duaal","global.class_types.tso.studies.ELEKTRONISCHE_INSTALLATIETECHNIEKEN":"Elektronische installatietechnieken","global.class_types.tso.studies.FARMACEUTISCH_TECHNISCH_ASSISTENT":"Farmaceutisch-technisch assistent","global.class_types.tso.studies.FOTOGRAFIE":"Fotografie","global.class_types.tso.studies.GEZONDHEIDS_EN_WELZIJNSWETENSCHAPPEN":"Gezondheids- en welzijnswetenschappen","global.class_types.tso.studies.GRAFISCHE_COMMUNICATIE":"Grafische communicatie","global.class_types.tso.studies.HANDEL":"Handel","global.class_types.tso.studies.HOSPITALITY":"Hospitality","global.class_types.tso.studies.HOTEL":"Hotel","global.class_types.tso.studies.HOUTTECHNIEKEN":"Houttechnieken","global.class_types.tso.studies.INDUSTRIELE_ICT":"Industriële ICT","global.class_types.tso.studies.INDUSTRIELE_WETENSCHAPPEN":"Industriële wetenschappen","global.class_types.tso.studies.INFORMATICABEHEER":"Informaticabeheer","global.class_types.tso.studies.JEUGD_EN_GEHANDICAPTENZORG":"Jeugd- en gehandicaptenzorg","global.class_types.tso.studies.KOEL_EN_WARMTECHNIEKEN":"Koel- en warmtechnieken","global.class_types.tso.studies.LICHAMELIJKE_OPVOEDING_EN_SPORT":"Lichamelijke opvoeding en sport","global.class_types.tso.studies.MARITIEME_TECHNIEKEN_DEK":"Maritieme technieken Dek","global.class_types.tso.studies.MARITIEME_TECHNIEKEN_MOTOREN":"Maritieme technieken Motoren","global.class_types.tso.studies.MECHANISCHE_VORMGEVINGSTECHNIEKEN":"Mechanische vormgevingstechnieken","global.class_types.tso.studies.MECHANISCHE_VORMGEVINGSTECHNIEKEN_DUAAL":"Mechanische vormgevingstechnieken duaal","global.class_types.tso.studies.MULTIMEDIA":"Multimedia","global.class_types.tso.studies.NATUUR_EN_GROENTECHNISCHE_WETENSCHAPPEN":"Natuur- en groentechnische wetenschappen","global.class_types.tso.studies.ONTHAAL_EN_PUBLIC_RELATIONS":"Onthaal en public relations","global.class_types.tso.studies.OPTIEKTECHNIEKEN":"Optiektechnieken","global.class_types.tso.studies.ORTHOPEDIETECHNIEKEN":"Orthopedietechnieken","global.class_types.tso.studies.PLANTTECHNISCHE_WETENSCHAPPEN":"Planttechnische wetenschappen","global.class_types.tso.studies.PODIUMTECHNIEKEN":"Podiumtechnieken","global.class_types.tso.studies.PODIUMTECHNIEKEN_DUAAL":"Podiumtechnieken duaal","global.class_types.tso.studies.PRINTMEDIA":"Printmedia","global.class_types.tso.studies.SCHOONHEIDSVERZORGING":"Schoonheidsverzorging","global.class_types.tso.studies.SECRETARIAAT_TALEN":"Secretariaat-talen","global.class_types.tso.studies.SLAGERIJ_EN_VLEESWAREN":"Slagerij en vleeswaren","global.class_types.tso.studies.SOCIALE_EN_TECHNISCHE_WETENSCHAPPEN":"Sociale en technische wetenschappen","global.class_types.tso.studies.TANDTECHNIEKEN":"Tandtechnieken","global.class_types.tso.studies.TECHNIEK_WETENSCHAPPEN":"Techniek-wetenschappen","global.class_types.tso.studies.TEXTIEL_EN_DESIGNTECHNIEKEN":"Textiel- en designtechnieken","global.class_types.tso.studies.TEXTIELPRODUCTIETECHNIEKEN":"Textielproductietechnieken","global.class_types.tso.studies.TOERISME":"Toerisme","global.class_types.tso.studies.TOPSPORT":"Topsport","global.class_types.tso.studies.VLIEGTUIGTECHNIEKEN":"Vliegtuigtechnieken","global.class_types.tso.studies.VOEDINGSTECHNIEKEN":"Voedingstechnieken","global.class_types.kso.studies.ARCHITECTURALE_EN_BINNENHUISKUNST":"Architecturale en binnenhuiskunst","global.class_types.kso.studies.ARCHITECTURALE_VORMING":"Architecturale vorming","global.class_types.kso.studies.ARTISTIEKE_OPLEIDING":"Artistieke opleiding","global.class_types.kso.studies.AUDIOVISUELE_VORMING":"Audiovisuele vorming","global.class_types.kso.studies.BALLET":"Ballet","global.class_types.kso.studies.BEELDENDE_VORMING":"Beeldende vorming","global.class_types.kso.studies.DANS":"Dans","global.class_types.kso.studies.INDUSTRIELE_KUNST":"Industriële kunst","global.class_types.kso.studies.MUZIEK":"Muziek","global.class_types.kso.studies.TOEGEPASTE_BEELDENDE_KUNST":"Toegepaste beeldende kunst","global.class_types.kso.studies.VRIJE_BEELDENDE_KUNST":"Vrije beeldende kunst","global.class_types.kso.studies.WOORDKUNST_DRAMA":"Woordkunst-drama","cms.login.title":"Inloggen","cms.login.form.labels.username":"Gebruikersnaam","cms.login.form.labels.password":"Wachtwoord","cms.login.actions.login":"Log in","cms.login.fail.dialog.title":"Login failed","cms.login.fail.dialog.text":"Je gebruikersnaam of wachtwoord is niet correct.","cms.login.fail.unexpected.dialog.title":"Aanmelden mislukt","cms.login.fail.unexpected.dialog.text":"Er liep iets fout bij het aanmelden. Probleer het later opnieuw.","__cms.login.fail.no_catalog.dialog.title":"Aanmelden mislukt","__cms.login.fail.no_catalog.dialog.text":"We are still verifying your account, please try again later. Contact us if the problem persists.","__cms.login.fail.not_verified.dialog.title":"Login failed","__cms.login.fail.not_verified.dialog.text":"Your account is not yet verified. Please check your inbox and follow the link to verify your email.","cms.login_dialog.fail.text":"Je gebruikersnaam of wachtwoord is niet correct.","cms.cases.overview.title":"Overzicht cases","cms.cases.form.labels.name":"Naam case","cms.cases.form.labels.select.base":"Case op basis van bestaande case","cms.cases.btn.new":"Case toevoegen","cms.cases.btn.add":"Bewaren","cms.cases.btn.edit":"Case bewerken","cms.cases.btn.delete":"Case verwijderen","cms.cases.dialog.delete.confirmation.title":"Case verwijderen","cms.cases.dialog.delete.confirmation.text":"Weet je zeker dat je deze case wil verwijderen?","cms.cases.dialog.requiredfields.title":"Verplichte velden","cms.cases.dialog.requiredfields.text":"Controleer of alle verplichte velden zijn ingevuld. Je wijzigingen werden nog niet bewaard!","cms.case.navigation.general":"Algemeen","cms.case.navigation.quiz":"Quiz","cms.case.navigation.icons":"Iconen","cms.case.navigation.investments":"Investeringen","cms.case.navigation.events":"Events","cms.case.navigation.faq":"FAQ","cms.case.btn.save":"Bewaar","cms.case.btn.preview":"Preview","cms.case.general.published.label":"Gepubliceerd op {0}","cms.case.general.edited.label":"Aangepast op {0}","cms.case.general.form.labels.name":"Naam case","cms.case.general.form.labels.movie":"Introductiefilmpje <span class='form-label-info'>max 10Mb","cms.case.general.form.labels.movie.uploadbutton":"Uploaden","cms.case.general.form.labels.startbudget":"Startbudget","cms.case.general.form.labels.quizbonus":"Winnaarsbonus quiz","cms.case.general.form.actions.publish":"Case live zetten","cms.case.general.form.actions.unpublish":"Case offline halen","cms.case.general.publish.dialog.title":"Case online zetten","cms.case.general.publish.dialog.message":"Kijk goed na of <strong>alle</strong> gegevens correct zijn ingevuld. Als deze case online staat zullen leerkrachten deze kunnen gebruiken om nieuwe sessies aan te maken.<br/><br/>Ben je zeker dat je deze case wil live zetten?","cms.case.general.unpublish.dialog.title":"Case offline halen","cms.case.general.unpublish.dialog.message":"Als je deze case offline haalt zal hij niet meer beschikbaar zijn voor nieuwe sessies. Sessies die reeds zijn aangemaakt zullen deze case kunnen blijven gebruiken. Ben je zeker dat je de case wil offline halen?","cms.case.quiz.labels.question":"Quizvraag {0}","cms.case.quiz.form.labels.question":"Quizvraag","cms.case.quiz.form.labels.correct":"Antwoord","cms.case.quiz.form.labels.correct.image":"Afbeelding max 1Mb, formaat 300x400 px","cms.case.quiz.form.labels.correct.image.uploadbutton":"Afbeelding uploaden","cms.case.quiz.form.labels.correct.text":"Tekst knop","cms.case.quiz.form.labels.wrong":"Fout antwoord","cms.case.quiz.form.labels.wrong.image":"Afbeelding max 1Mb, formaat 300x400 px","cms.case.quiz.form.labels.wrong.image.uploadbutton":"Afbeelding uploaden","cms.case.quiz.form.labels.wrong.text":"Tekst knop","cms.case.icons.form.labels.product":"Je bedrijf","cms.case.icons.form.labels.product.image":"Afbeelding max 1Mb, formaat 170x170 px","cms.case.icons.form.labels.extension":"Uitbreiding productgamma ","cms.case.icons.form.labels.extension.image":"Afbeelding max 1Mb, formaat 170x170 px","cms.case.investments.form.labels.category":"Categorieën","cms.case.investments.form.labels.category.1":"Materialen","cms.case.investments.form.labels.category.2":"Energie","cms.case.investments.form.labels.category.4":"Productie","cms.case.investments.form.labels.category.8":"Ontwerp","cms.case.investments.form.labels.category.16":"Afval vermijden","cms.case.investments.form.labels.category.32":"Diensten","cms.case.investments.form.labels.summary":"Tekst kaart","cms.case.investments.form.labels.description":"Extra tekst","cms.case.investments.form.labels.cost":"Kostprijs","cms.case.investments.form.labels.cost.value":"Waarde","cms.case.investments.form.labels.gains":"Opbrengst","cms.case.investments.form.labels.points.value":"Waarde","cms.case.investments.form.labels.income.value":"Waarde","cms.case.investments.productredesign.title":"Product redesign","cms.case.investments.productredesign.text":"Product redesign","cms.case.investments.extraproduct.title":"Extra product","cms.case.investments.extraproduct.text":"uitbreiding productgamma","cms.case.investments.renewablematerials.title":"Hernieuwbare materialen","cms.case.investments.renewablematerials.text":"hernieuwbare materialen gebruiken","cms.case.investments.biomaterials.title":"Biomaterialen","cms.case.investments.biomaterials.text":"MATERIALEN MET BIO-LABEL KOPEN","cms.case.investments.residualflows.title":"Reststromen inkopen","cms.case.investments.residualflows.text":"RESTSTROMEN INKOPEN","cms.case.investments.wastevalorization.title":"Afval valorisatie","cms.case.investments.wastevalorization.text":"VERDIEN GELD MET AFVAL","cms.case.investments.returnprogram.title":"Terugname programma","cms.case.investments.returnprogram.text":"TERUGNAME OUDE PRODUCTEN","cms.case.investments.greenenergy.title":"Groene energie","cms.case.investments.greenenergy.text":"AANKOOP GROENE ENERGIE","cms.case.investments.solarpanels.title":"Zonnepanelen","cms.case.investments.solarpanels.text":"INVESTERING ZONNEPANELEN","cms.case.investments.paas.title":"PaaS","cms.case.investments.paas.text":"PRODUCT/SERVICE SYSTEEM AANBIEDEN","cms.case.investments.reuse.title":"Hergebruik","cms.case.investments.reuse.text":"HERGEBRUIK STIMULEREN","cms.case.investments.localproduction.title":"Lokale productie","cms.case.investments.localproduction.text":"LOKAAL PRODUCEREN","cms.case.investments.repairservice.title":"Hersteldienst","cms.case.investments.repairservice.text":"HERSTELDIENST OPZETTEN","cms.case.investments.spareparts.title":"Reserveonderdelen","cms.case.investments.spareparts.text":"WISSELSTUKKEN AANBIEDEN","cms.case.investments.subsidy.title":"Subsidiedossier","cms.case.investments.subsidy.text":"SUBSIDIEDOSSIER INDIENEN","cms.case.investments.form.labels.example":"Voorbeeldcase","cms.case.investments.example.btn.add":"Voorbeeldcase toevoegen","cms.case.investments.example.btn.delete":"Voorbeeldcase verwijderen","cms.case.investments.example.dialog.maximumreached.title":"Maximum bereikt","cms.case.investments.example.dialog.maximumreached.text":"Je kan maximum vijf voorbeeldcases toevoegen per investering.","cms.case.investments.example.labels.title":"Titel","cms.case.investments.example.labels.image.uploadbutton":"Afbeelding uploaden","cms.case.investments.example.labels.image.credits":"Foto credits","cms.case.investments.example.labels.description":"Tekst","cms.case.events.form.labels.title":"Titel","cms.case.events.energy.form.labels.text1":"Tekst boven","cms.case.events.energy.form.labels.value":"/product","cms.case.events.energy.form.labels.text2":"Tekst onder","cms.case.events.tax.form.labels.text1":"Tekst","cms.case.events.energy.form.labels.min":"Minder dan","cms.case.events.energy.form.labels.max":"Meer dan","cms.case.events.energy.form.labels.tax":"Waarde","cms.case.events.subsidy.form.labels.text":"Tekst","cms.case.events.subsidy.form.labels.value":"Waarde","cms.case.events.tradewar.form.labels.text1":"Tekst boven","cms.case.events.tradewar.form.labels.value":"/product","cms.case.events.tradewar.form.labels.text2":"Tekst midden","cms.case.faqs.form.labels.text":"Tekst","cms.case.faqs.form.labels.button":"Knop","cms.case.faqs.form.labels.button.label":"bijhorende investering","cms.case.faqs.form.labels.investment":"Investering","cms.case.faqs.form.button.save":"Bewaar","cms.marketing.title":"Website","cms.marketing.shared.upload_image.change_btn":"Verander foto","cms.marketing.shared.upload_file.change_btn":"Verander bestand","cms.marketing.shared.upload_pdf.change_btn":"Verander PDF","cms.marketing.shared.upload_video.change_btn":"Verander video","cms.marketing.btn.save":"Bewaar","cms.marketing.btn.preview":"Preview","cms.marketing.navigation.welcome":"Welkom","cms.marketing.navigation.teacher_platform":"Leerkrachtenplatform","cms.marketing.navigation.faq":"FAQ","cms.marketing.welcome.side_nav.intro":"Intro","cms.marketing.welcome.side_nav.gamegoal":"Speldoel","cms.marketing.welcome.side_nav.necessities":"Benodigdheden","cms.marketing.welcome.side_nav.materials":"Materialen","cms.marketing.welcome.side_nav.learnplan":"Leerplan","cms.marketing.welcome.intro.form.title.label":"Titel","cms.marketing.welcome.intro.form.title.placeholder":"titel","cms.marketing.welcome.intro.form.background_image.label":"Afbeelding achtergrond","cms.marketing.welcome.intro.form.foreground_image.label":"Afbeelding voorgrond","cms.marketing.welcome.intro.form.text.label":"Tekst","cms.marketing.welcome.intro.form.text.max_length":"max 680 tekens","cms.marketing.welcome.intro.form.text.placeholder":"tekst","cms.marketing.welcome.intro.form.content_image.label":"Content afbeelding","cms.marketing.welcome.game_goal.form.title.label":"Titel","cms.marketing.welcome.game_goal.form.text.label":"Tekst","cms.marketing.welcome.game_goal.form.text.max_length":"","cms.marketing.welcome.game_goal.form.background_image.label":"Afbeelding achtergrond","cms.marketing.welcome.game_goal.form.foreground_image.label":"Afbeelding voorgrond","cms.marketing.welcome.necessities.form.title.label":"Titel","cms.marketing.welcome.necessities.form.text.label":"Tekst","cms.marketing.welcome.necessities.form.text.max_length":"","cms.marketing.welcome.necessities.form.background_image.label":"Afbeelding achtergrond","cms.marketing.welcome.necessities.form.foreground_image.label":"Afbeelding voorgrond","cms.marketing.welcome.materials.form.title.label":"Titel","cms.marketing.welcome.materials.form.text.label":"Tekst","cms.marketing.welcome.materials.form.text.max_length":"","cms.marketing.welcome.materials.form.video.label":"Instructie video","cms.marketing.welcome.materials.form.video.result_link":"video link","cms.marketing.welcome.materials.form.instructions_pdf.label":"Handleiding","cms.marketing.welcome.materials.form.instructions_pdf.result_link":"PDF link","cms.marketing.welcome.materials.form.investment_cards.label":"Investeringskaarten","cms.marketing.welcome.materials.form.investment_cards.result_link":"PDF link","cms.marketing.welcome.materials.form.background_image.label":"Afbeelding achtergrond","cms.marketing.welcome.materials.form.foreground_image.label":"Afbeelding voorgrond","cms.marketing.welcome.learn_plan.form.title.label":"Titel","cms.marketing.welcome.learn_plan.form.text.label":"Tekst","cms.marketing.welcome.learn_plan.form.text.max_length":"","cms.marketing.teacher_platform.side_nav.intro":"Intro","cms.marketing.teacher_platform.side_nav.session_start":"Sessie starten","cms.marketing.teacher_platform.side_nav.game_progress":"Spelverloop","cms.marketing.teacher_platform.intro.form.background_image.label":"Afbeelding achtergrond","cms.marketing.teacher_platform.intro.form.foreground_image.label":"Afbeelding voorgrond","cms.marketing.teacher_platform.intro.form.title.label":"Titel","cms.marketing.teacher_platform.intro.form.teacher_platform_link.label":"Leerkrachtenplatform link tekst","cms.marketing.teacher_platform.intro.form.text.label":"Tekst","cms.marketing.teacher_platform.intro.form.text.max_length":"","cms.marketing.teacher_platform.start_session.form.title.label":"Titel","cms.marketing.teacher_platform.start_session.form.text.label":"Tekst","cms.marketing.teacher_platform.start_session.form.text.max_length":"","cms.marketing.teacher_platform.start_session.form.background_image.label":"Afbeelding achtergrond","cms.marketing.teacher_platform.start_session.form.foreground_image.label":"Afbeelding voorgrond","cms.marketing.teacher_platform.game_progress.form.title.label":"Titel","cms.marketing.teacher_platform.game_progress.form.text.label":"Tekst","cms.marketing.teacher_platform.game_progress.form.text.max_length":"","cms.marketing.faq.entry.title":"FAQ","cms.marketing.faq.entry.form.question.label":"Vraag","cms.marketing.faq.entry.form.question.placeholder":"Vraag","cms.marketing.faq.entry.form.answer.label":"Antwoord","cms.marketing.faq.entry.form.answer.placeholder":"Antwoord","cms.marketing.faq.entry.form.actions.add_btn":"FAQ toevoegen","cms.marketing.faq.delete.dialog.title":"FAQ item verwijderen?","cms.marketing.faq.delete.dialog.message":"Ben je zeker dat je deze FAQ wil verwijderen? Je kan deze actie niet ongedaan maken.<br/>Deze wijziging wordt maar doorgevoerd nadat je bewaard hebt."}}

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(218)('wks');
	var uid = __webpack_require__(197);
	var Symbol = __webpack_require__(9).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(39);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(13)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(8);
	var IE8_DOM_DEFINE = __webpack_require__(365);
	var toPrimitive = __webpack_require__(46);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(17) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(44);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return function isFunction( obj ) {
	
	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return window.document;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * --------------------------------------------------------------------------
	 * Bootstrap (v4.3.1): util/index.js
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * --------------------------------------------------------------------------
	 */
	
	var MAX_UID = 1000000;
	var MILLISECONDS_MULTIPLIER = 1000;
	var TRANSITION_END = 'transitionend';
	var _window = window,
	    jQuery = _window.jQuery;
	
	// Shoutout AngusCroll (https://goo.gl/pxwQGp)
	
	var toType = function toType(obj) {
	  return {}.toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
	};
	
	/**
	 * --------------------------------------------------------------------------
	 * Public Util Api
	 * --------------------------------------------------------------------------
	 */
	
	var getUID = function getUID(prefix) {
	  do {
	    // eslint-disable-next-line no-bitwise
	    prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
	  } while (document.getElementById(prefix));
	
	  return prefix;
	};
	
	var getSelectorFromElement = function getSelectorFromElement(element) {
	  var selector = element.getAttribute('data-target');
	
	  if (!selector || selector === '#') {
	    var hrefAttr = element.getAttribute('href');
	
	    selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : '';
	  }
	
	  try {
	    return document.querySelector(selector) ? selector : null;
	  } catch (error) {
	    return null;
	  }
	};
	
	var getTransitionDurationFromElement = function getTransitionDurationFromElement(element) {
	  if (!element) {
	    return 0;
	  }
	
	  // Get transition-duration of the element
	
	  var _window$getComputedSt = window.getComputedStyle(element),
	      transitionDuration = _window$getComputedSt.transitionDuration,
	      transitionDelay = _window$getComputedSt.transitionDelay;
	
	  var floatTransitionDuration = parseFloat(transitionDuration);
	  var floatTransitionDelay = parseFloat(transitionDelay);
	
	  // Return 0 if element or transition duration is not found
	  if (!floatTransitionDuration && !floatTransitionDelay) {
	    return 0;
	  }
	
	  // If multiple durations are defined, take the first
	  transitionDuration = transitionDuration.split(',')[0];
	  transitionDelay = transitionDelay.split(',')[0];
	
	  return (parseFloat(transitionDuration) + parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
	};
	
	var triggerTransitionEnd = function triggerTransitionEnd(element) {
	  var evt = document.createEvent('HTMLEvents');
	
	  evt.initEvent(TRANSITION_END, true, true);
	  element.dispatchEvent(evt);
	};
	
	var isElement = function isElement(obj) {
	  return (obj[0] || obj).nodeType;
	};
	
	var emulateTransitionEnd = function emulateTransitionEnd(element, duration) {
	  var called = false;
	  var durationPadding = 5;
	  var emulatedDuration = duration + durationPadding;
	
	  function listener() {
	    called = true;
	    element.removeEventListener(TRANSITION_END, listener);
	  }
	
	  element.addEventListener(TRANSITION_END, listener);
	  setTimeout(function () {
	    if (!called) {
	      triggerTransitionEnd(element);
	    }
	  }, emulatedDuration);
	};
	
	var typeCheckConfig = function typeCheckConfig(componentName, config, configTypes) {
	  Object.keys(configTypes).forEach(function (property) {
	    var expectedTypes = configTypes[property];
	    var value = config[property];
	    var valueType = value && isElement(value) ? 'element' : toType(value);
	
	    if (!new RegExp(expectedTypes).test(valueType)) {
	      throw new Error(componentName.toUpperCase() + ': ' + ('Option "' + property + '" provided type "' + valueType + '" ') + ('but expected type "' + expectedTypes + '".'));
	    }
	  });
	};
	
	var makeArray = function makeArray(nodeList) {
	  if (!nodeList) {
	    return [];
	  }
	
	  return [].slice.call(nodeList);
	};
	
	var isVisible = function isVisible(element) {
	  if (!element) {
	    return false;
	  }
	
	  if (element.style && element.parentNode && element.parentNode.style) {
	    return element.style.display !== 'none' && element.parentNode.style.display !== 'none' && element.style.visibility !== 'hidden';
	  }
	
	  return false;
	};
	
	var findShadowRoot = function findShadowRoot(element) {
	  if (!document.documentElement.attachShadow) {
	    return null;
	  }
	
	  // Can find the shadow root otherwise it'll return the document
	  if (typeof element.getRootNode === 'function') {
	    var root = element.getRootNode();
	    return root instanceof ShadowRoot ? root : null;
	  }
	
	  if (element instanceof ShadowRoot) {
	    return element;
	  }
	
	  // when we don't find a shadow root
	  if (!element.parentNode) {
	    return null;
	  }
	
	  return findShadowRoot(element.parentNode);
	};
	
	// eslint-disable-next-line no-empty-function
	var noop = function noop() {
	  return function () {};
	};
	
	var reflow = function reflow(element) {
	  return element.offsetHeight;
	};
	
	exports.jQuery = jQuery;
	exports.TRANSITION_END = TRANSITION_END;
	exports.getUID = getUID;
	exports.getSelectorFromElement = getSelectorFromElement;
	exports.getTransitionDurationFromElement = getTransitionDurationFromElement;
	exports.triggerTransitionEnd = triggerTransitionEnd;
	exports.isElement = isElement;
	exports.emulateTransitionEnd = emulateTransitionEnd;
	exports.typeCheckConfig = typeCheckConfig;
	exports.makeArray = makeArray;
	exports.isVisible = isVisible;
	exports.findShadowRoot = findShadowRoot;
	exports.noop = noop;
	exports.reflow = reflow;

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(843) ], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(18);
	var createDesc = __webpack_require__(193);
	module.exports = __webpack_require__(17) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(9);
	var hide = __webpack_require__(26);
	var has = __webpack_require__(29);
	var SRC = __webpack_require__(197)('src');
	var $toString = __webpack_require__(527);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(36).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var fails = __webpack_require__(13);
	var defined = __webpack_require__(44);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(217);
	var createDesc = __webpack_require__(193);
	var toIObject = __webpack_require__(32);
	var toPrimitive = __webpack_require__(46);
	var has = __webpack_require__(29);
	var IE8_DOM_DEFINE = __webpack_require__(365);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(17) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(29);
	var toObject = __webpack_require__(19);
	var IE_PROTO = __webpack_require__(312)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(216);
	var defined = __webpack_require__(44);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 33 */,
/* 34 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * --------------------------------------------------------------------------
	 * Bootstrap (v4.3.1): dom/data.js
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * --------------------------------------------------------------------------
	 */
	
	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */
	
	var mapData = function () {
	  var storeData = {};
	  var id = 1;
	  return {
	    set: function set(element, key, data) {
	      if (typeof element.key === 'undefined') {
	        element.key = {
	          key: key,
	          id: id
	        };
	        id++;
	      }
	
	      storeData[element.key.id] = data;
	    },
	    get: function get(element, key) {
	      if (!element || typeof element.key === 'undefined') {
	        return null;
	      }
	
	      var keyProperties = element.key;
	      if (keyProperties.key === key) {
	        return storeData[keyProperties.id];
	      }
	
	      return null;
	    },
	    delete: function _delete(element, key) {
	      if (typeof element.key === 'undefined') {
	        return;
	      }
	
	      var keyProperties = element.key;
	      if (keyProperties.key === key) {
	        delete storeData[keyProperties.id];
	        delete element.key;
	      }
	    }
	  };
	}();
	
	var Data = {
	  setData: function setData(instance, key, data) {
	    mapData.set(instance, key, data);
	  },
	  getData: function getData(instance, key) {
	    return mapData.get(instance, key);
	  },
	  removeData: function removeData(instance, key) {
	    mapData.delete(instance, key);
	  }
	};
	
	exports.default = Data;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.9' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(23);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(13);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Initialize a jQuery object
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(21),
		__webpack_require__(20),
		__webpack_require__(401),
	
		__webpack_require__(418)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, isFunction, rsingleTag ) {
	
	"use strict";
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	return init;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Bootstrap (v4.3.1): dom/event-handler.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */
	
	var _util = __webpack_require__(22);
	
	var _polyfill = __webpack_require__(354);
	
	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */
	
	var namespaceRegex = /[^.]*(?=\..*)\.|.*/;
	var stripNameRegex = /\..*/;
	var keyEventRegex = /^key/;
	var stripUidRegex = /::\d+$/;
	var eventRegistry = {}; // Events storage
	var uidEvent = 1;
	var customEvents = {
	  mouseenter: 'mouseover',
	  mouseleave: 'mouseout'
	};
	var nativeEvents = ['click', 'dblclick', 'mouseup', 'mousedown', 'contextmenu', 'mousewheel', 'DOMMouseScroll', 'mouseover', 'mouseout', 'mousemove', 'selectstart', 'selectend', 'keydown', 'keypress', 'keyup', 'orientationchange', 'touchstart', 'touchmove', 'touchend', 'touchcancel', 'pointerdown', 'pointermove', 'pointerup', 'pointerleave', 'pointercancel', 'gesturestart', 'gesturechange', 'gestureend', 'focus', 'blur', 'change', 'reset', 'select', 'submit', 'focusin', 'focusout', 'load', 'unload', 'beforeunload', 'resize', 'move', 'DOMContentLoaded', 'readystatechange', 'error', 'abort', 'scroll'];
	
	/**
	 * ------------------------------------------------------------------------
	 * Private methods
	 * ------------------------------------------------------------------------
	 */
	
	function getUidEvent(element, uid) {
	  return uid && uid + '::' + uidEvent++ || element.uidEvent || uidEvent++;
	}
	
	function getEvent(element) {
	  var uid = getUidEvent(element);
	
	  element.uidEvent = uid;
	  eventRegistry[uid] = eventRegistry[uid] || {};
	
	  return eventRegistry[uid];
	}
	
	function fixEvent(event, element) {
	  // Add which for key events
	  if (event.which === null && keyEventRegex.test(event.type)) {
	    event.which = event.charCode === null ? event.keyCode : event.charCode;
	  }
	
	  event.delegateTarget = element;
	}
	
	function bootstrapHandler(element, fn) {
	  return function handler(event) {
	    fixEvent(event, element);
	    if (handler.oneOff) {
	      EventHandler.off(element, event.type, fn);
	    }
	
	    return fn.apply(element, [event]);
	  };
	}
	
	function bootstrapDelegationHandler(element, selector, fn) {
	  return function handler(event) {
	    var domElements = element.querySelectorAll(selector);
	
	    for (var target = event.target; target && target !== this; target = target.parentNode) {
	      for (var i = domElements.length; i--;) {
	        if (domElements[i] === target) {
	          fixEvent(event, target);
	
	          if (handler.oneOff) {
	            EventHandler.off(element, event.type, fn);
	          }
	
	          return fn.apply(target, [event]);
	        }
	      }
	    }
	
	    // To please ESLint
	    return null;
	  };
	}
	
	function findHandler(events, handler) {
	  var delegationSelector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var uidEventList = Object.keys(events);
	
	  for (var i = 0, len = uidEventList.length; i < len; i++) {
	    var event = events[uidEventList[i]];
	
	    if (event.originalHandler === handler && event.delegationSelector === delegationSelector) {
	      return event;
	    }
	  }
	
	  return null;
	}
	
	function normalizeParams(originalTypeEvent, handler, delegationFn) {
	  var delegation = typeof handler === 'string';
	  var originalHandler = delegation ? delegationFn : handler;
	
	  // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
	  var typeEvent = originalTypeEvent.replace(stripNameRegex, '');
	  var custom = customEvents[typeEvent];
	
	  if (custom) {
	    typeEvent = custom;
	  }
	
	  var isNative = nativeEvents.indexOf(typeEvent) > -1;
	
	  if (!isNative) {
	    typeEvent = originalTypeEvent;
	  }
	
	  return [delegation, originalHandler, typeEvent];
	}
	
	function addHandler(element, originalTypeEvent, handler, delegationFn, oneOff) {
	  if (typeof originalTypeEvent !== 'string' || !element) {
	    return;
	  }
	
	  if (!handler) {
	    handler = delegationFn;
	    delegationFn = null;
	  }
	
	  var _normalizeParams = normalizeParams(originalTypeEvent, handler, delegationFn),
	      _normalizeParams2 = _slicedToArray(_normalizeParams, 3),
	      delegation = _normalizeParams2[0],
	      originalHandler = _normalizeParams2[1],
	      typeEvent = _normalizeParams2[2];
	
	  var events = getEvent(element);
	  var handlers = events[typeEvent] || (events[typeEvent] = {});
	  var previousFn = findHandler(handlers, originalHandler, delegation ? handler : null);
	
	  if (previousFn) {
	    previousFn.oneOff = previousFn.oneOff && oneOff;
	
	    return;
	  }
	
	  var uid = getUidEvent(originalHandler, originalTypeEvent.replace(namespaceRegex, ''));
	  var fn = delegation ? bootstrapDelegationHandler(element, handler, delegationFn) : bootstrapHandler(element, handler);
	
	  fn.delegationSelector = delegation ? handler : null;
	  fn.originalHandler = originalHandler;
	  fn.oneOff = oneOff;
	  fn.uidEvent = uid;
	  handlers[uid] = fn;
	
	  element.addEventListener(typeEvent, fn, delegation);
	}
	
	function removeHandler(element, events, typeEvent, handler, delegationSelector) {
	  var fn = findHandler(events[typeEvent], handler, delegationSelector);
	
	  if (!fn) {
	    return;
	  }
	
	  element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
	  delete events[typeEvent][fn.uidEvent];
	}
	
	function removeNamespacedHandlers(element, events, typeEvent, namespace) {
	  var storeElementEvent = events[typeEvent] || {};
	
	  Object.keys(storeElementEvent).forEach(function (handlerKey) {
	    if (handlerKey.indexOf(namespace) > -1) {
	      var event = storeElementEvent[handlerKey];
	
	      removeHandler(element, events, typeEvent, event.originalHandler, event.delegationSelector);
	    }
	  });
	}
	
	var EventHandler = {
	  on: function on(element, event, handler, delegationFn) {
	    addHandler(element, event, handler, delegationFn, false);
	  },
	  one: function one(element, event, handler, delegationFn) {
	    addHandler(element, event, handler, delegationFn, true);
	  },
	  off: function off(element, originalTypeEvent, handler, delegationFn) {
	    if (typeof originalTypeEvent !== 'string' || !element) {
	      return;
	    }
	
	    var _normalizeParams3 = normalizeParams(originalTypeEvent, handler, delegationFn),
	        _normalizeParams4 = _slicedToArray(_normalizeParams3, 3),
	        delegation = _normalizeParams4[0],
	        originalHandler = _normalizeParams4[1],
	        typeEvent = _normalizeParams4[2];
	
	    var inNamespace = typeEvent !== originalTypeEvent;
	    var events = getEvent(element);
	    var isNamespace = originalTypeEvent.charAt(0) === '.';
	
	    if (typeof originalHandler !== 'undefined') {
	      // Simplest case: handler is passed, remove that listener ONLY.
	      if (!events || !events[typeEvent]) {
	        return;
	      }
	
	      removeHandler(element, events, typeEvent, originalHandler, delegation ? handler : null);
	      return;
	    }
	
	    if (isNamespace) {
	      Object.keys(events).forEach(function (elementEvent) {
	        removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.substr(1));
	      });
	    }
	
	    var storeElementEvent = events[typeEvent] || {};
	    Object.keys(storeElementEvent).forEach(function (keyHandlers) {
	      var handlerKey = keyHandlers.replace(stripUidRegex, '');
	
	      if (!inNamespace || originalTypeEvent.indexOf(handlerKey) > -1) {
	        var event = storeElementEvent[keyHandlers];
	
	        removeHandler(element, events, typeEvent, event.originalHandler, event.delegationSelector);
	      }
	    });
	  },
	  trigger: function trigger(element, event, args) {
	    if (typeof event !== 'string' || !element) {
	      return null;
	    }
	
	    var typeEvent = event.replace(stripNameRegex, '');
	    var inNamespace = event !== typeEvent;
	    var isNative = nativeEvents.indexOf(typeEvent) > -1;
	
	    var jQueryEvent = void 0;
	    var bubbles = true;
	    var nativeDispatch = true;
	    var defaultPrevented = false;
	    var evt = null;
	
	    if (inNamespace && typeof _util.jQuery !== 'undefined') {
	      jQueryEvent = _util.jQuery.Event(event, args);
	
	      (0, _util.jQuery)(element).trigger(jQueryEvent);
	      bubbles = !jQueryEvent.isPropagationStopped();
	      nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
	      defaultPrevented = jQueryEvent.isDefaultPrevented();
	    }
	
	    if (isNative) {
	      evt = document.createEvent('HTMLEvents');
	      evt.initEvent(typeEvent, bubbles, true);
	    } else {
	      evt = (0, _polyfill.createCustomEvent)(event, {
	        bubbles: bubbles,
	        cancelable: true
	      });
	    }
	
	    // merge custom informations in our event
	    if (typeof args !== 'undefined') {
	      Object.keys(args).forEach(function (key) {
	        Object.defineProperty(evt, key, {
	          get: function get() {
	            return args[key];
	          }
	        });
	      });
	    }
	
	    if (defaultPrevented) {
	      evt.preventDefault();
	
	      if (!_polyfill.defaultPreventedPreservedOnDispatch) {
	        Object.defineProperty(evt, 'defaultPrevented', {
	          get: function get() {
	            return true;
	          }
	        });
	      }
	    }
	
	    if (nativeDispatch) {
	      element.dispatchEvent(evt);
	    }
	
	    if (evt.defaultPrevented && typeof jQueryEvent !== 'undefined') {
	      jQueryEvent.preventDefault();
	    }
	
	    return evt;
	  }
	};
	
	exports.default = EventHandler;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _polyfill = __webpack_require__(354);
	
	var _util = __webpack_require__(22);
	
	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */
	
	/**
	 * --------------------------------------------------------------------------
	 * Bootstrap (v4.3.1): dom/selector-engine.js
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * --------------------------------------------------------------------------
	 */
	
	var NODE_TEXT = 3;
	
	var SelectorEngine = {
	  matches: function matches(element, selector) {
	    return _polyfill.matches.call(element, selector);
	  },
	  find: function find(selector) {
	    var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.documentElement;
	
	    if (typeof selector !== 'string') {
	      return null;
	    }
	
	    return _polyfill.find.call(element, selector);
	  },
	  findOne: function findOne(selector) {
	    var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.documentElement;
	
	    if (typeof selector !== 'string') {
	      return null;
	    }
	
	    return _polyfill.findOne.call(element, selector);
	  },
	  children: function children(element, selector) {
	    var _this = this;
	
	    if (typeof selector !== 'string') {
	      return null;
	    }
	
	    var children = (0, _util.makeArray)(element.children);
	
	    return children.filter(function (child) {
	      return _this.matches(child, selector);
	    });
	  },
	  parents: function parents(element, selector) {
	    if (typeof selector !== 'string') {
	      return null;
	    }
	
	    var parents = [];
	    var ancestor = element.parentNode;
	
	    while (ancestor && ancestor.nodeType === Node.ELEMENT_NODE && ancestor.nodeType !== NODE_TEXT) {
	      if (this.matches(ancestor, selector)) {
	        parents.push(ancestor);
	      }
	
	      ancestor = ancestor.parentNode;
	    }
	
	    return parents;
	  },
	  closest: function closest(element, selector) {
	    if (typeof selector !== 'string') {
	      return null;
	    }
	
	    return _polyfill.closest.call(element, selector);
	  },
	  prev: function prev(element, selector) {
	    if (typeof selector !== 'string') {
	      return null;
	    }
	
	    var siblings = [];
	    var previous = element.previousSibling;
	
	    while (previous && previous.nodeType === Node.ELEMENT_NODE && previous.nodeType !== NODE_TEXT) {
	      if (this.matches(previous, selector)) {
	        siblings.push(previous);
	      }
	
	      previous = previous.previousSibling;
	    }
	
	    return siblings;
	  }
	};
	
	exports.default = SelectorEngine;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(37);
	var IObject = __webpack_require__(216);
	var toObject = __webpack_require__(19);
	var toLength = __webpack_require__(16);
	var asc = __webpack_require__(296);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(1);
	var core = __webpack_require__(36);
	var fails = __webpack_require__(13);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(14);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(409)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( Data ) {
		"use strict";
	
		return new Data();
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"26.468\" height=\"26.468\" viewBox=\"0 0 26.468 26.468\">\n  <g transform=\"translate(0 0)\">\n    <line x2=\"26.468\" transform=\"translate(0 13.234)\" fill=\"#fff\" stroke=\"#0a2b30\" stroke-miterlimit=\"10\"\n          stroke-width=\"4\"/>\n    <line y2=\"26.468\" transform=\"translate(13.234 0)\" fill=\"#fff\" stroke=\"#0a2b30\" stroke-miterlimit=\"10\"\n          stroke-width=\"4\"/>\n  </g>\n</svg>\n"

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(387);
	var $export = __webpack_require__(1);
	var shared = __webpack_require__(218)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(391))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(17)) {
	  var LIBRARY = __webpack_require__(56);
	  var global = __webpack_require__(9);
	  var fails = __webpack_require__(13);
	  var $export = __webpack_require__(1);
	  var $typed = __webpack_require__(240);
	  var $buffer = __webpack_require__(317);
	  var ctx = __webpack_require__(37);
	  var anInstance = __webpack_require__(188);
	  var propertyDesc = __webpack_require__(193);
	  var hide = __webpack_require__(26);
	  var redefineAll = __webpack_require__(194);
	  var toInteger = __webpack_require__(39);
	  var toLength = __webpack_require__(16);
	  var toIndex = __webpack_require__(385);
	  var toAbsoluteIndex = __webpack_require__(196);
	  var toPrimitive = __webpack_require__(46);
	  var has = __webpack_require__(29);
	  var classof = __webpack_require__(202);
	  var isObject = __webpack_require__(14);
	  var toObject = __webpack_require__(19);
	  var isArrayIter = __webpack_require__(303);
	  var create = __webpack_require__(190);
	  var getPrototypeOf = __webpack_require__(31);
	  var gOPN = __webpack_require__(191).f;
	  var getIterFn = __webpack_require__(319);
	  var uid = __webpack_require__(197);
	  var wks = __webpack_require__(15);
	  var createArrayMethod = __webpack_require__(43);
	  var createArrayIncludes = __webpack_require__(228);
	  var speciesConstructor = __webpack_require__(219);
	  var ArrayIterators = __webpack_require__(320);
	  var Iterators = __webpack_require__(203);
	  var $iterDetect = __webpack_require__(233);
	  var setSpecies = __webpack_require__(195);
	  var arrayFill = __webpack_require__(295);
	  var arrayCopyWithin = __webpack_require__(357);
	  var $DP = __webpack_require__(18);
	  var $GOPD = __webpack_require__(30);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(15)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(26)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(197)('meta');
	var isObject = __webpack_require__(14);
	var has = __webpack_require__(29);
	var setDesc = __webpack_require__(18).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(13)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		// Only count HTML whitespace
		// Other whitespace should count in values
		// https://infra.spec.whatwg.org/#ascii-whitespace
		return ( /[^\x20\t\r\n\f]+/g );
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	
	    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
	    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enSG = moment.defineLocale('en-SG', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enSG;
	
	})));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minuttur',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaður',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	    var months = [
	        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
	    ];
	
	    var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];
	
	    var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];
	
	    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];
	
	    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné aig] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d mí',
	            y: 'bliain',
	            yy: '%d bliain'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka voran', 'ek vor'],
	            'hh': [number + ' voranim', number + ' voram'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var itCh = moment.defineLocale('it-ch', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    },
	    months = [
	        'کانونی دووەم',
	        'شوبات',
	        'ئازار',
	        'نیسان',
	        'ئایار',
	        'حوزەیران',
	        'تەمموز',
	        'ئاب',
	        'ئەیلوول',
	        'تشرینی یەكەم',
	        'تشرینی دووەم',
	        'كانونی یەکەم'
	    ];
	
	
	    var ku = moment.defineLocale('ku', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar : {
	            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay : '[به‌یانی كاتژمێر] LT',
	            nextWeek : 'dddd [كاتژمێر] LT',
	            lastDay : '[دوێنێ كاتژمێر] LT',
	            lastWeek : 'dddd [كاتژمێر] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'له‌ %s',
	            past : '%s',
	            s : 'چه‌ند چركه‌یه‌ك',
	            ss : 'چركه‌ %d',
	            m : 'یه‌ك خوله‌ك',
	            mm : '%d خوله‌ك',
	            h : 'یه‌ك كاتژمێر',
	            hh : '%d كاتژمێر',
	            d : 'یه‌ك ڕۆژ',
	            dd : '%d ڕۆژ',
	            M : 'یه‌ك مانگ',
	            MM : '%d مانگ',
	            y : 'یه‌ك ساڵ',
	            yy : '%d ساڵ'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кечээ саат] LT',
	            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (m === true) {
	            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 186 */,
/* 187 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * --------------------------------------------------------------------------
	 * Bootstrap (v4.3.1): dom/manipulator.js
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * --------------------------------------------------------------------------
	 */
	
	function normalizeData(val) {
	  if (val === 'true') {
	    return true;
	  }
	
	  if (val === 'false') {
	    return false;
	  }
	
	  if (val === Number(val).toString()) {
	    return Number(val);
	  }
	
	  if (val === '' || val === 'null') {
	    return null;
	  }
	
	  return val;
	}
	
	function normalizeDataKey(key) {
	  return key.replace(/[A-Z]/g, function (chr) {
	    return chr.toLowerCase();
	  });
	}
	
	var Manipulator = {
	  setDataAttribute: function setDataAttribute(element, key, value) {
	    element.setAttribute('data-' + normalizeDataKey(key), value);
	  },
	  removeDataAttribute: function removeDataAttribute(element, key) {
	    element.removeAttribute('data-' + normalizeDataKey(key));
	  },
	  getDataAttributes: function getDataAttributes(element) {
	    if (!element) {
	      return {};
	    }
	
	    var attributes = _extends({}, element.dataset);
	
	    Object.keys(attributes).forEach(function (key) {
	      attributes[key] = normalizeData(attributes[key]);
	    });
	
	    return attributes;
	  },
	  getDataAttribute: function getDataAttribute(element, key) {
	    return normalizeData(element.getAttribute('data-' + normalizeDataKey(key)));
	  },
	  offset: function offset(element) {
	    var rect = element.getBoundingClientRect();
	
	    return {
	      top: rect.top + document.body.scrollTop,
	      left: rect.left + document.body.scrollLeft
	    };
	  },
	  position: function position(element) {
	    return {
	      top: element.offsetTop,
	      left: element.offsetLeft
	    };
	  },
	  toggleClass: function toggleClass(element, className) {
	    if (!element) {
	      return;
	    }
	
	    if (element.classList.contains(className)) {
	      element.classList.remove(className);
	    } else {
	      element.classList.add(className);
	    }
	  }
	};
	
	exports.default = Manipulator;

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(37);
	var call = __webpack_require__(368);
	var isArrayIter = __webpack_require__(303);
	var anObject = __webpack_require__(8);
	var toLength = __webpack_require__(16);
	var getIterFn = __webpack_require__(319);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(8);
	var dPs = __webpack_require__(374);
	var enumBugKeys = __webpack_require__(299);
	var IE_PROTO = __webpack_require__(312)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(298)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(301).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(376);
	var hiddenKeys = __webpack_require__(299).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(376);
	var enumBugKeys = __webpack_require__(299);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 193 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(27);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(9);
	var dP = __webpack_require__(18);
	var DESCRIPTORS = __webpack_require__(17);
	var SPECIES = __webpack_require__(15)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(39);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 197 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(14);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(207),
		__webpack_require__(20)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, toType, isFunction ) {
	
	"use strict";
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	return access;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	
	return nodeName;
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		// All support tests are defined in their respective modules.
		return {};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(35);
	var TAG = __webpack_require__(15)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 203 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(18).f;
	var has = __webpack_require__(29);
	var TAG = __webpack_require__(15)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var defined = __webpack_require__(44);
	var fails = __webpack_require__(13);
	var spaces = __webpack_require__(315);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(21),
		__webpack_require__(20),
		__webpack_require__(58),
		__webpack_require__(815),
		__webpack_require__(396),
		__webpack_require__(397),
	
		__webpack_require__(40),
		__webpack_require__(813),
		__webpack_require__(332),
		__webpack_require__(208),
		__webpack_require__(417) // jQuery.param
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, isFunction, rnothtmlwhite, location, nonce, rquery ) {
	
	"use strict";
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(244),
		__webpack_require__(424)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( class2type, toString ) {
	
	"use strict";
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	
	return toType;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(20),
		__webpack_require__(246),
		__webpack_require__(325)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, isFunction, slice ) {
	
	"use strict";
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(21),
		__webpack_require__(245),
		__webpack_require__(20),
		__webpack_require__(58),
		__webpack_require__(336),
		__webpack_require__(246),
		__webpack_require__(48),
		__webpack_require__(200),
	
		__webpack_require__(40),
		__webpack_require__(25)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, documentElement, isFunction, rnothtmlwhite,
		rcheckableType, slice, dataPriv, nodeName ) {
	
	"use strict";
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {
	
		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
							return result.value;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {
	
					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );
	
					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );
	
				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			delegateType: delegateType
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(335),
		__webpack_require__(844),
		__webpack_require__(845),
		__webpack_require__(419),
		__webpack_require__(200),
	
		__webpack_require__(40),
		__webpack_require__(418),
		__webpack_require__(25)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, indexOf, dir, siblings, rneedsContext, nodeName ) {
	
	"use strict";
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( typeof elem.contentDocument !== "undefined" ) {
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 211 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(8);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(35);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 217 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(36);
	var global = __webpack_require__(9);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(56) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(8);
	var aFunction = __webpack_require__(23);
	var SPECIES = __webpack_require__(15)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	
	return camelCase;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(199),
		__webpack_require__(220),
		__webpack_require__(337),
		__webpack_require__(329),
		__webpack_require__(328),
		__webpack_require__(406),
		__webpack_require__(408),
		__webpack_require__(404),
		__webpack_require__(403),
		__webpack_require__(402),
		__webpack_require__(327),
		__webpack_require__(405),
	
		__webpack_require__(40),
		__webpack_require__(400),
		__webpack_require__(25) // contains
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, camelCase, rcssNum, rnumnonpx, cssExpand,
		getStyles, swap, curCSS, adjustCSS, addGetHookIf, support, finalPropName ) {
	
	"use strict";
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		// Support: IE 9-11 only
		// Also use offsetWidth/offsetHeight for when box sizing is unreliable
		// We use getClientRects() to check for hidden/disconnected.
		// In those cases, the computed value can be trusted to be border-box
		if ( ( !support.boxSizingReliable() && isBorderBox ||
			val === "auto" ||
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return [];
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(32);
	var toLength = __webpack_require__(16);
	var toAbsoluteIndex = __webpack_require__(196);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(9);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(27);
	var redefineAll = __webpack_require__(194);
	var meta = __webpack_require__(57);
	var forOf = __webpack_require__(189);
	var anInstance = __webpack_require__(188);
	var isObject = __webpack_require__(14);
	var fails = __webpack_require__(13);
	var $iterDetect = __webpack_require__(233);
	var setToStringTag = __webpack_require__(204);
	var inheritIfRequired = __webpack_require__(302);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(388);
	var redefine = __webpack_require__(27);
	var hide = __webpack_require__(26);
	var fails = __webpack_require__(13);
	var defined = __webpack_require__(44);
	var wks = __webpack_require__(15);
	var regexpExec = __webpack_require__(310);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(35);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(14);
	var cof = __webpack_require__(35);
	var MATCH = __webpack_require__(15)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(15)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(56) || !__webpack_require__(13)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(9)[K];
	});


/***/ }),
/* 235 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(202);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(23);
	var ctx = __webpack_require__(37);
	var forOf = __webpack_require__(189);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(1);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(39);
	var defined = __webpack_require__(44);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(9);
	var hide = __webpack_require__(26);
	var uid = __webpack_require__(197);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(9);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(245),
		__webpack_require__(25) // jQuery.contains
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, documentElement ) {
		"use strict";
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	
		return isAttached;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(242),
		__webpack_require__(420),
		__webpack_require__(20),
		__webpack_require__(423),
		__webpack_require__(336),
		__webpack_require__(199),
		__webpack_require__(415),
		__webpack_require__(414),
		__webpack_require__(416),
		__webpack_require__(412),
		__webpack_require__(413),
		__webpack_require__(411),
		__webpack_require__(840),
	
		__webpack_require__(48),
		__webpack_require__(410),
		__webpack_require__(330),
		__webpack_require__(399),
		__webpack_require__(200),
	
		__webpack_require__(40),
		__webpack_require__(210),
		__webpack_require__(25),
		__webpack_require__(209)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, isAttached, concat, isFunction, push, rcheckableType,
		access, rtagName, rscriptType,
		wrapMap, getAll, setGlobalEval, buildFragment, support,
		dataPriv, dataUser, acceptData, DOMEval, nodeName ) {
	
	"use strict";
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									} );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		// [[Class]] -> type pairs
		return {};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(21)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( document ) {
		"use strict";
	
		return document.documentElement;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(222)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr ) {
		"use strict";
	
		return arr.slice;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 247 */,
/* 248 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	module.exports = function(src) {
		function log(error) {
			(typeof console !== "undefined")
			&& (console.error || console.log)("[Script Loader]", error);
		}
	
		// Check for IE =< 8
		function isIE() {
			return typeof attachEvent !== "undefined" && typeof addEventListener === "undefined";
		}
	
		try {
			if (typeof execScript !== "undefined" && isIE()) {
				execScript(src);
			} else if (typeof eval !== "undefined") {
				eval.call(null, src);
			} else {
				log("EvalError: No eval function available");
			}
		} catch (error) {
			log(error);
		}
	}


/***/ }),
/* 249 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIKICAgICB5PSIwcHgiCiAgICAgdmlld0JveD0iMCAwIDQuNCA2LjYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQuNCA2LjY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDpub25lO3N0cm9rZTojNjk5Q0QzO3N0cm9rZS13aWR0aDoxLjU7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQo8L3N0eWxlPgogIDxwYXRoIGlkPSJQYXRoXzcwMF8xXyIgY2xhc3M9InN0MCIgZD0iTTAuOCwwLjhsMi41LDIuNUwwLjgsNS44Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/background.6a5ed3b.png";

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/background.deecabd.svg";

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIKICAgICB5PSIwcHgiCiAgICAgdmlld0JveD0iMCAwIDE0LjggOC4xIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxNC44IDguMTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtvcGFjaXR5OjAuNTt9Cgkuc3Qxe2ZpbGw6bm9uZTtzdHJva2U6I0FDQkJDODtzdHJva2Utd2lkdGg6Mi41ODtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cjwvc3R5bGU+CiAgPGcgaWQ9Ikdyb3VwXzkwNl8xXyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjM2Mi41NzIgLTE0OTEuMjcyKSIgY2xhc3M9InN0MCI+Cgk8bGluZSBpZD0iTGluZV81MzlfMV8iIGNsYXNzPSJzdDEiIHgxPSItMjM2MS4xIiB5MT0iMTQ5MS4zIiB4Mj0iLTIzNjEuMSIgeTI9IjE0OTkuNCIvPgogICAgPGxpbmUgaWQ9IkxpbmVfNTQwXzFfIiBjbGFzcz0ic3QxIiB4MT0iLTIzNTcuMiIgeTE9IjE0OTEuMyIgeDI9Ii0yMzU3LjIiIHkyPSIxNDk5LjQiLz4KICAgIDxsaW5lIGlkPSJMaW5lXzU0MV8xXyIgY2xhc3M9InN0MSIgeDE9Ii0yMzUzLjIiIHkxPSIxNDkxLjMiIHgyPSItMjM1My4yIiB5Mj0iMTQ5OS40Ii8+CiAgICA8bGluZSBpZD0iTGluZV81NDJfMV8iIGNsYXNzPSJzdDEiIHgxPSItMjM0OS4yIiB5MT0iMTQ5MS4zIiB4Mj0iLTIzNDkuMiIgeTI9IjE0OTkuNCIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIKICAgICB5PSIwcHgiCiAgICAgdmlld0JveD0iMCAwIDM5LjkgMzkuOCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzkuOSAzOS44OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0ZGRkZGRjt9Cgkuc3Qxe2ZpbGw6IzBCMkMzMTt9Cjwvc3R5bGU+CiAgPGNpcmNsZSBpZD0iRWxsaXBzZV83OF8xXyIgY2xhc3M9InN0MCIgY3g9IjE5LjkiIGN5PSIxOS45IiByPSIxOS45Ii8+CiAgPHBhdGggaWQ9IlBhdGhfOTE0XzFfIiBjbGFzcz0ic3QxIiBkPSJNMTQuMiwyMmw2LjUtMTIuOHY4LjZoNGwtNi41LDEyLjhWMjJIMTQuMnoiLz4KPC9zdmc+Cg=="

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIKICAgICB5PSIwcHgiCiAgICAgdmlld0JveD0iMCAwIDIxLjUgMjEuNSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjEuNSAyMS41OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6I0YzRjZGODt9Cgkuc3Qxe2ZpbGw6IzY5OUNEMzt9Cjwvc3R5bGU+CiAgPGcgaWQ9Ikdyb3VwXzExMTFfMV8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI0MDEuNDQxIC0xNDU2LjQwMykiPgoJPGNpcmNsZSBpZD0iRWxsaXBzZV84MS0zXzFfIiBjbGFzcz0ic3QwIiBjeD0iLTIzOTAuNyIgY3k9IjE0NjcuMSIgcj0iMTAuNyIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTE1LTNfMV8iIGNsYXNzPSJzdDEiIGQ9Ik0tMjM5NC4yLDE0NjguNWw0LjMtOC41djUuN2gyLjdsLTQuMyw4LjV2LTUuN0gtMjM5NC4yeiIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIKICAgICB5PSIwcHgiCiAgICAgdmlld0JveD0iMCAwIDE3MiAxNzIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE3MiAxNzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRTlFRUYyO30KCS5zdDF7ZmlsbDpub25lO3N0cm9rZTojQjNENEYwO3N0cm9rZS13aWR0aDowLjc2MjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cgkuc3Qye2ZpbGw6I0ZGRkZGRjt9Cgkuc3Qze2ZpbGw6I0ZGRkZGRjtzdHJva2U6IzY5OUNEMztzdHJva2Utd2lkdGg6MC43NjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQoJLnN0NHtmaWxsOiNGRkZGRkY7c3Ryb2tlOiMwQjJDMzE7c3Ryb2tlLXdpZHRoOjAuNzYyO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDt9Cgkuc3Q1e2ZpbGw6I0ZGRkZGRjtzdHJva2U6I0VBNjAzNjtzdHJva2Utd2lkdGg6MS41ODQ7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQoJLnN0NntmaWxsOiNGRkZGRkY7c3Ryb2tlOiMwQjJDMzE7c3Ryb2tlLXdpZHRoOjEuNTg0O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDd7ZmlsbDojRkZGRkZGO3N0cm9rZTojQjNENEYwO3N0cm9rZS13aWR0aDowLjc2MjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cgkuc3Q4e2ZpbGw6I0ZGRkZGRjtzdHJva2U6I0YzQjhCMztzdHJva2Utd2lkdGg6MS41ODQ7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQo8L3N0eWxlPgogIDxnIGlkPSJHcm91cF85ODFfMl8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1NjMuNjEyIC0xNzQ0Ljc0NSkiPgoJPGcgaWQ9Ikdyb3VwXzk4MF8yXyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE1MjkuNjEgMTc4OC41NTkpIj4KCQk8bGluZSBpZD0iTGluZV82NTFfMl8iIGNsYXNzPSJzdDEiIHgxPSIxMC4yIiB5MT0iNTkuMiIgeDI9IjEwMS40IiB5Mj0iNTkuMiIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTU2XzJfIiBjbGFzcz0ic3QyIiBkPSJNMjQuNSwxOC44aC0xMUw1LjcsNDQuNkgyLjZ2NGwxMS42LDEuOWg1LjZMMjQuNSwxOC44eiIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTU3XzJfIiBjbGFzcz0ic3QzIiBkPSJNMjQuNSwxOC44aC0xMUw1LjcsNDQuNkgyLjZ2NGwxMS42LDEuOSIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTU4XzJfIiBjbGFzcz0ic3Q0IiBkPSJNNzIuOCw1MS41SDE5Yy0xLjYsMC0yLjktMS4zLTIuOS0yLjljMC0wLjMsMC0wLjUsMC4xLTAuOEwyNSwxNy4yaDQ1LjNsMi42LDMuMkw3Mi44LDUxLjV6CgkJCSIvPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8yMTNfMl8iIHg9IjU5LjkiIHk9IjE1LjEiIGNsYXNzPSJzdDMiIHdpZHRoPSI1LjQiIGhlaWdodD0iMzYuNSIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTYwXzJfIiBjbGFzcz0ic3QzIiBkPSJNNTAuNSw0NC42VjE1LjFoLTUuNHYzNCIvPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8yMTRfMl8iIHg9IjMwLjQiIHk9IjE1LjEiIGNsYXNzPSJzdDMiIHdpZHRoPSI1LjQiIGhlaWdodD0iMzYuNSIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTYxXzJfIiBjbGFzcz0ic3Q0IiBkPSJNNzUuMyw1MS41SDk3VjM3LjJsLTUuMi0zLjlMODkuMSwyNmMtMC43LTEuOS0yLjUtMy4xLTQuNS0zLjFoLTkuMSIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTYyXzJfIiBjbGFzcz0ic3QzIiBkPSJNNzYuOSw1Mi42YzAtNC40LDMuNi04LDgtOGM0LjQsMCw4LDMuNiw4LDgiLz4KICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfODZfMl8iIGNsYXNzPSJzdDYiIGN4PSI4NC45IiBjeT0iNTIuNiIgcj0iNS40Ii8+CiAgICA8cGF0aCBpZD0iUGF0aF85NjNfMl8iIGNsYXNzPSJzdDMiIGQ9Ik01MC4yLDUyLjZjMC00LjQsMy42LTgsOC04bDAsMGM0LjQsMCw4LDMuNiw4LDgiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzk2NF8yXyIgY2xhc3M9InN0MyIgZD0iTTI0LjQsNTIuNmMwLTQuNCwzLjYtOCw4LThjNC40LDAsOCwzLjYsOCw4Ii8+CiAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzg3XzJfIiBjbGFzcz0ic3Q2IiBjeD0iNTguMiIgY3k9IjUyLjYiIHI9IjUuNCIvPgogICAgPGNpcmNsZSBpZD0iRWxsaXBzZV84OF8yXyIgY2xhc3M9InN0NiIgY3g9IjMyLjQiIGN5PSI1Mi42IiByPSI1LjQiLz4KICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfODlfMl8iIGNsYXNzPSJzdDciIGN4PSIzMi40IiBjeT0iNTIuNiIgcj0iMS42Ii8+CiAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzkwXzJfIiBjbGFzcz0ic3Q3IiBjeD0iNTguMiIgY3k9IjUyLjYiIHI9IjEuNiIvPgogICAgPGNpcmNsZSBpZD0iRWxsaXBzZV85MV8yXyIgY2xhc3M9InN0NyIgY3g9Ijg0LjkiIGN5PSI1Mi42IiByPSIxLjYiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzk2NV8yXyIgY2xhc3M9InN0MyIgZD0iTTg2LjYsMjYuNWgtNS4ydjMuM2MwLDEuOSwxLjYsMy41LDMuNSwzLjVsMCwwSDg5Ii8+CiAgICA8cGF0aCBpZD0iUGF0aF85NjZfMl8iIGNsYXNzPSJzdDciIGQ9Ik0yNy41LDM5LjVMMjcuNSwzOS41Yy0wLjMsMS40LTEuOCwyLjMtMy4yLDJjMCwwLDAsMC0wLjEsMGwtOS4yLTIuMgoJCQljLTEuNC0wLjQtMi4zLTEuOC0yLTMuMmwwLDBjMC4zLTEuNCwxLjgtMi4zLDMuMi0yYzAsMCwwLDAsMC4xLDBsOS4yLDIuMkMyNywzNi42LDI3LjgsMzguMSwyNy41LDM5LjV6Ii8+CiAgICA8bGluZSBpZD0iTGluZV82NTJfMl8iIGNsYXNzPSJzdDEiIHgxPSI5NCIgeTE9IjQxLjYiIHgyPSI5NCIgeTI9IjM4LjgiLz4KCTwvZz4KPC9nPgo8L3N2Zz4K"

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 259 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 260 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 262 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 263 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIKICAgICB5PSIwcHgiCiAgICAgdmlld0JveD0iMCAwIDE3MiAxNzIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE3MiAxNzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRTlFRUYyO30KCS5zdDF7ZmlsbDojQjNENEYwO30KCS5zdDJ7ZmlsbDojRTlFRUYyO3N0cm9rZTojNjk5Q0QzO3N0cm9rZS13aWR0aDowLjkxNjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cgkuc3Qze2ZpbGw6I0U5RUVGMjtzdHJva2U6IzBCMkMzMTtzdHJva2Utd2lkdGg6MC45MTY7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQoJLnN0NHtmaWxsOm5vbmU7c3Ryb2tlOiNCM0Q0RjA7c3Ryb2tlLXdpZHRoOjAuOTE2O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDV7ZmlsbDpub25lO3N0cm9rZTojRjNCOEIzO3N0cm9rZS13aWR0aDoxLjkwNjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cjwvc3R5bGU+CiAgPGcgaWQ9IlZlcndlcmtpbmdfNF8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIyNC41NyA5Ni45NikiPgoJPGcgaWQ9Ikdyb3VwXzk2Ml80XyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjE2MS4zMDcgLTE1NzMuMDgyKSI+CgkJPHBhdGggaWQ9IlBhdGhfOTE5XzRfIiBjbGFzcz0ic3QxIiBkPSJNLTIyODEuOSwxNTQ0LjloMTEuMmw2LjcsNTkuN2wtMjEuNC0yOC43TC0yMjgxLjksMTU0NC45eiIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTIwXzRfIiBjbGFzcz0ic3QyIiBkPSJNLTIyODAuOCwxNTY1LjNsMi4yLTE5LjhoMTEuMmw2LjcsNTkuN2gtMjQuNyIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTIxXzRfIiBjbGFzcz0ic3QzIiBkPSJNLTIyOTQuMiwxNTY5LjhsNy00LjdsMy4yLDYuN2w5LjgtNi43bDMuMiw2LjdsMy42LDMzLjUiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzkyMl80XyIgY2xhc3M9InN0MyIgZD0iTS0yMzIwLjIsMTU2OS43bDYuOS00LjdsMy4yLDYuN2wxLjMtMC45bDEuMy0wLjlsNy4yLTQuOWwzLjIsNi43Ii8+CiAgICA8cGF0aCBpZD0iUGF0aF85MjNfNF8iIGNsYXNzPSJzdDMiIGQ9Ik0tMjI2Ny40LDE2MDUuMmgtNzIuM2wzLjYtMzMuNWw5LjgtNi43bDMuMiw2LjciLz4KICAgIDxwYXRoIGlkPSJQYXRoXzkyNF80XyIgY2xhc3M9InN0MiIgZD0iTS0yMzEyLjIsMTYwMi40di05LjloMTcuM3Y5LjkiLz4KICAgIDxsaW5lIGlkPSJMaW5lXzYwM180XyIgY2xhc3M9InN0NCIgeDE9Ii0yMjc1LjIiIHkxPSIxNTQ5LjYiIHgyPSItMjI2OS40IiB5Mj0iMTU0OS42Ii8+CiAgICA8bGluZSBpZD0iTGluZV82MDRfNF8iIGNsYXNzPSJzdDQiIHgxPSItMjI3Mi4yIiB5MT0iMTU1MyIgeDI9Ii0yMjY5LjEiIHkyPSIxNTUzIi8+CiAgICA8cGF0aCBpZD0iUGF0aF85MjVfNF8iIGNsYXNzPSJzdDQiIGQ9Ik0tMjMzMi4yLDE1ODMuMnYyLjZoNTcuMnYtNS4yaC01Ny4yIi8+CiAgICA8bGluZSBpZD0iTGluZV82MDVfNF8iIGNsYXNzPSJzdDQiIHgxPSItMjMyNi43IiB5MT0iMTU4MC42IiB4Mj0iLTIzMjYuNyIgeTI9IjE1ODUuOCIvPgogICAgPGxpbmUgaWQ9IkxpbmVfNjA2XzRfIiBjbGFzcz0ic3Q0IiB4MT0iLTIzMjAuOSIgeTE9IjE1ODAuNiIgeDI9Ii0yMzIwLjkiIHkyPSIxNTg1LjgiLz4KICAgIDxsaW5lIGlkPSJMaW5lXzYwN180XyIgY2xhc3M9InN0NCIgeDE9Ii0yMzE1LjEiIHkxPSIxNTgwLjYiIHgyPSItMjMxNS4xIiB5Mj0iMTU4NS44Ii8+CiAgICA8bGluZSBpZD0iTGluZV82MDhfNF8iIGNsYXNzPSJzdDQiIHgxPSItMjMwOS4zIiB5MT0iMTU4MC42IiB4Mj0iLTIzMDkuMyIgeTI9IjE1ODUuOCIvPgogICAgPGxpbmUgaWQ9IkxpbmVfNjA5XzRfIiBjbGFzcz0ic3Q0IiB4MT0iLTIzMDMuNiIgeTE9IjE1ODAuNiIgeDI9Ii0yMzAzLjYiIHkyPSIxNTg1LjgiLz4KICAgIDxsaW5lIGlkPSJMaW5lXzYxMF80XyIgY2xhc3M9InN0NCIgeDE9Ii0yMjk3LjgiIHkxPSIxNTgwLjYiIHgyPSItMjI5Ny44IiB5Mj0iMTU4NS44Ii8+CiAgICA8bGluZSBpZD0iTGluZV82MTFfNF8iIGNsYXNzPSJzdDQiIHgxPSItMjI5MiIgeTE9IjE1ODAuNiIgeDI9Ii0yMjkyIiB5Mj0iMTU4NS44Ii8+CiAgICA8bGluZSBpZD0iTGluZV82MTJfNF8iIGNsYXNzPSJzdDQiIHgxPSItMjI4Ni4yIiB5MT0iMTU4MC42IiB4Mj0iLTIyODYuMiIgeTI9IjE1ODUuOCIvPgogICAgPGxpbmUgaWQ9IkxpbmVfNjEzXzRfIiBjbGFzcz0ic3Q0IiB4MT0iLTIyODAuNSIgeTE9IjE1ODAuNiIgeDI9Ii0yMjgwLjUiIHkyPSIxNTg1LjgiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzkyNl80XyIgY2xhc3M9InN0NCIgZD0iTS0yMjc1LDE1OTV2Mi42aC0xMS4zdi01LjJoMTEuMyIvPgogICAgPGxpbmUgaWQ9IkxpbmVfNjE0XzRfIiBjbGFzcz0ic3Q0IiB4MT0iLTIyODAuNSIgeTE9IjE1OTIuNCIgeDI9Ii0yMjgwLjUiIHkyPSIxNTk3LjYiLz4KICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTk5XzRfIiB4PSItMjMzMi4zIiB5PSIxNTkyLjQiIGNsYXNzPSJzdDQiIHdpZHRoPSIxMS4zIiBoZWlnaHQ9IjUuMiIvPgogICAgPGxpbmUgaWQ9IkxpbmVfNjE1XzRfIiBjbGFzcz0ic3Q0IiB4MT0iLTIzMjYuNSIgeTE9IjE1OTIuNCIgeDI9Ii0yMzI2LjUiIHkyPSIxNTk1Ii8+CiAgICA8bGluZSBpZD0iTGluZV82MTZfNF8iIGNsYXNzPSJzdDQiIHgxPSItMjMwMy42IiB5MT0iMTU5NS4yIiB4Mj0iLTIzMDMuNiIgeTI9IjE2MDIuNCIvPgogICAgPGxpbmUgaWQ9IkxpbmVfNjE3XzRfIiBjbGFzcz0ic3Q0IiB4MT0iLTIzNDguOSIgeTE9IjE2MDUuMiIgeDI9Ii0yMjUxLjYiIHkyPSIxNjA1LjIiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzkyOV80XyIgY2xhc3M9InN0MSIgZD0iTS0yMjg1LjksMTUyN2MwLjIsMCwwLjUsMCwwLjcsMC4xYzEtMiwzLjEtMy4zLDUuNC0zLjNjMC4zLDAsMC43LDAsMSwwLjEKCQkJYzEuMy0zLjUsNC42LTUuOCw4LjQtNS44YzMuNywwLDcsMi4zLDguNCw1LjhjMC4xLDAsMC4zLDAsMC40LDBjMy40LDAsNi4xLDIuNyw2LjEsNi4xYzAsMCwwLDAsMCwwYzAsMy40LTIuNyw2LjEtNi4xLDYuMWwwLDAKCQkJaC0yNC4zYy0yLjUsMC00LjUtMi00LjUtNC41YzAsMCwwLDAsMCwwQy0yMjkwLjQsMTUyOS0yMjg4LjMsMTUyNy0yMjg1LjksMTUyN0MtMjI4NS45LDE1MjctMjI4NS45LDE1MjctMjI4NS45LDE1Mjd6Ii8+CiAgICA8cGF0aCBpZD0iUGF0aF85MzBfNF8iIGNsYXNzPSJzdDEiIGQ9Ik0tMjI3My41LDE1MzUuNXY2LjJsNi41LTYuNUwtMjI3My41LDE1MzUuNXoiLz4KCTwvZz4KPC9nPgo8L3N2Zz4K"

/***/ }),
/* 264 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 266 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIKICAgICB5PSIwcHgiCiAgICAgdmlld0JveD0iMCAwIDE3MiAxNzIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE3MiAxNzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRTlFRUYyO30KCS5zdDF7ZmlsbDojRTlFRUYyO3N0cm9rZTojMEIyQzMxO3N0cm9rZS13aWR0aDowLjc2MjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cgkuc3Qye2ZpbGw6I0IzRDRGMDt9Cgkuc3Qze2ZpbGw6I0U5RUVGMjtzdHJva2U6IzY5OUNEMztzdHJva2Utd2lkdGg6MC43NjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQoJLnN0NHtmaWxsOm5vbmU7c3Ryb2tlOiNCM0Q0RjA7c3Ryb2tlLXdpZHRoOjAuNzYyO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KICA8ZyBpZD0iRWlnZW5LYW5hYWxfMl8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ3NS41MDcgMTQwLjcyMykiPgoJPGcgaWQ9Ikdyb3VwXzk5MV8yXyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ3NS41MDcgLTI4MC43MjMpIj4KCQk8ZyBpZD0iR3JvdXBfOTc0XzJfIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMzg0Ljg3NiAtMTM0NC4xMjIpIj4KCQkJPGcgaWQ9Ikdyb3VwXzk3M18yXyI+CgkJCQk8cGF0aCBpZD0iUGF0aF85MzdfMl8iIGNsYXNzPSJzdDEiIGQ9Ik0tMjI4MC4xLDE1NTcuM2MwLjcsMC43LDEuNCwxLjMsMi4yLDEuOWMxLjksMS41LDMuMSwzLjgsMy4yLDYuMwoJCQkJCWMwLjIsMy41LDAuNSw4LjQsMC45LDEyLjJjMS4xLDguOCw0LjQsMTksNS4xLDI0LjUiLz4KICAgICAgICA8cGF0aCBpZD0iUGF0aF85MzhfMl8iIGNsYXNzPSJzdDEiIGQ9Ik0tMjMwMi4xLDE1ODYuMmMtMC4xLDAuOS0wLjEsMS45LDAsMi45YzAuMyw2LjEsMi41LDEyLDYuNSwxNi42Ii8+CiAgICAgICAgPHBhdGggaWQ9IlJlY3RhbmdsZV8yMDdfMl8iIGNsYXNzPSJzdDEiIGQ9Ik0tMjMxNC43LDE1NjYuN2wzLjQsMS4xbDAsMGwtMi4yLDYuN2wwLDBsLTMuNC0xLjFjLTEuOS0wLjYtMi45LTIuNi0yLjMtNC41CgkJCQkJYzAsMCwwLDAsMCwwbDAsMEMtMjMxOC42LDE1NjcuMS0yMzE2LjYsMTU2Ni4xLTIzMTQuNywxNTY2LjdMLTIzMTQuNywxNTY2Ljd6Ii8+CiAgICAgICAgPHBhdGggaWQ9IlBhdGhfOTM5XzJfIiBjbGFzcz0ic3QxIiBkPSJNLTIzMTQuNywxNTY0LjZsMi4yLTYuN2wtMy40LTEuMWMtMS45LTAuNi0zLjksMC40LTQuNSwyLjNsMCwwYy0wLjYsMS45LDAuNCwzLjksMi4zLDQuNQoJCQkJCWMwLDAsMCwwLDAsMGwwLjcsMC4zIi8+CiAgICAgICAgPHBhdGggaWQ9IlJlY3RhbmdsZV8yMDhfMl8iIGNsYXNzPSJzdDEiIGQ9Ik0tMjMxMy42LDE1NDguMmwzLjQsMS4xbDAsMGwtMi4yLDYuN2wwLDBsLTMuNC0xLjFjLTEuOS0wLjYtMi45LTIuNi0yLjMtNC41CgkJCQkJYzAsMCwwLDAsMCwwbDAsMEMtMjMxNy41LDE1NDguNi0yMzE1LjUsMTU0Ny42LTIzMTMuNiwxNTQ4LjJMLTIzMTMuNiwxNTQ4LjJ6Ii8+CiAgICAgICAgPHBhdGggaWQ9IlBhdGhfOTQwXzJfIiBjbGFzcz0ic3QxIiBkPSJNLTIyOTYuNiwxNTg2LjdoLTE1LjVjLTEuOCwwLTMuMi0xLjQtMy4yLTMuMlYxNTI4YzAtMS44LDEuNC0zLjIsMy4yLTMuMmMwLDAsMCwwLDAsMAoJCQkJCWgyNi40YzEuOCwwLDMuMiwxLjQsMy4yLDMuMmMwLDAsMCwwLDAsMHY1NS41YzAsMS44LTEuNCwzLjItMy4yLDMuMmwwLDBoLTYiLz4KICAgICAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzg1XzJfIiBjbGFzcz0ic3QyIiBjeD0iLTIyOTguOSIgY3k9IjE1ODEuNSIgcj0iMi4zIi8+CiAgICAgICAgPHBhdGggaWQ9IlBhdGhfOTQxXzJfIiBjbGFzcz0ic3QzIiBkPSJNLTIyODUsMTU3Ni4yaC0yNy44di00My45aDI3Ljh2MzMuNiIvPgogICAgICAgIDxsaW5lIGlkPSJMaW5lXzYzN18yXyIgY2xhc3M9InN0NCIgeDE9Ii0yMzAyLjQiIHkxPSIxNTI4LjYiIHgyPSItMjI5Ni42IiB5Mj0iMTUyOC42Ii8+CiAgICAgICAgPHBhdGggaWQ9IlBhdGhfOTQyXzJfIiBjbGFzcz0ic3QxIiBkPSJNLTIyNzkuNCwxNTg1LjdsLTEwLjItMjUuMWMtMC45LTIuMi0zLjQtMy40LTUuNy0yLjVsMCwwYy0yLjEsMC44LTMuMywzLTIuNyw1LjJsNSwxOS41CgkJCQkJYy0yLjUsNi44LTEuNiwxNC40LDIuNiwyMC4zIi8+CiAgICAgICAgPGxpbmUgaWQ9IkxpbmVfNjM4XzJfIiBjbGFzcz0ic3Q0IiB4MT0iLTIyOTAiIHkxPSIxNTY0LjYiIHgyPSItMjI5My41IiB5Mj0iMTU2NiIvPgoJCQk8L2c+CgkJPC9nPgoJPC9nPgo8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 268 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIKICAgICB5PSIwcHgiCiAgICAgdmlld0JveD0iMCAwIDcwLjkgNzAuOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNzAuOSA3MC45OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+Cgkuc3Qwe2ZpbGw6bm9uZTtzdHJva2U6I0IzRDRGMDtzdHJva2Utd2lkdGg6MS4xMzk7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQo8L3N0eWxlPgogIDxnIGlkPSJHcm91cF85NjctM180XyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAyKSI+Cgk8ZyBpZD0iR3JvdXBfOTY2LTNfNF8iPgoJCTxsaW5lIGlkPSJMaW5lXzYyMC0zXzRfIiBjbGFzcz0ic3QwIiB4MT0iMTIuNiIgeTE9IjMzLjkiIHgyPSI1NC44IiB5Mj0iMzMuOSIvPgogICAgPGxpbmUgaWQ9IkxpbmVfNjIxLTNfNF8iIGNsYXNzPSJzdDAiIHgxPSIzMy43IiB5MT0iMTIuOCIgeDI9IjMzLjciIHkyPSI1NSIvPgoJPC9nPgo8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 270 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 271 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIKICAgICB5PSIwcHgiCiAgICAgdmlld0JveD0iMCAwIDE3MiAxNzIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE3MiAxNzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRTlFRUYyO30KCS5zdDF7ZmlsbDojQjNENEYwO30KCS5zdDJ7ZmlsbDojRTlFRUYyO3N0cm9rZTojNjk5Q0QzO3N0cm9rZS13aWR0aDowLjc2MjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cgkuc3Qze2ZpbGw6bm9uZTtzdHJva2U6I0IzRDRGMDtzdHJva2Utd2lkdGg6MC43NjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQoJLnN0NHtmaWxsOm5vbmU7c3Ryb2tlOiMwQjJDMzE7c3Ryb2tlLXdpZHRoOjAuNzYyO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDt9Cgkuc3Q1e2ZpbGw6I0U5RUVGMjtzdHJva2U6I0IzRDRGMDtzdHJva2Utd2lkdGg6MC43NjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQoJLnN0NntmaWxsOiNFOUVFRjI7c3Ryb2tlOiMwQjJDMzE7c3Ryb2tlLXdpZHRoOjAuNzYyO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDt9Cgkuc3Q3e2ZpbGw6bm9uZTtzdHJva2U6IzY5OUNEMztzdHJva2Utd2lkdGg6MC43NjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQo8L3N0eWxlPgogIDxnIGlkPSJSZWN5Y2xlcmVuXzJfIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4MTguMDY3IDc0LjYzMykiPgoJPGcgaWQ9Ikdyb3VwXzkzMF8yXyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOS40MTUgOS42NzUpIj4KCQk8ZyBpZD0iR3JvdXBfOTI5XzJfIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNS41NzEgMjAuMjA1KSI+CgkJCTxwYXRoIGlkPSJQYXRoXzg1NF8yXyIgY2xhc3M9InN0MSIgZD0iTS03NTQuNC0yMS40YzAuMy0wLjUsMC41LTEsMC42LTEuNWwyLjYtMC43bC0wLjEtMi4ybC0yLjYtMC41Yy0wLjMtMS0wLjktMi0xLjctMi43CgkJCQlsMC43LTIuNWwtMi0xLjFsLTEuOCwyYy0xLjEtMC4yLTIuMi0wLjItMy4yLDAuMWwtMS45LTEuOWwtMS45LDEuMmwwLjgsMi41Yy0wLjQsMC40LTAuNywwLjgtMSwxLjNjLTAuMywwLjUtMC41LDEtMC42LDEuNQoJCQkJbC0yLjYsMC43bDAuMSwyLjJsMi42LDAuNWMwLjMsMSwwLjksMiwxLjcsMi43bC0wLjcsMi41bDIsMS4xbDEuOC0yYzEuMSwwLjIsMi4yLDAuMiwzLjItMC4xbDEuOSwxLjlsMS45LTEuMmwtMC44LTIuNQoJCQkJQy03NTQuOS0yMC40LTc1NC42LTIwLjktNzU0LjQtMjEuNHoiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfODU1XzJfIiBjbGFzcz0ic3QxIiBkPSJNLTc4Mi4xLTI1bC0wLjMtMi43bC0xLjYsMGMtMC4zLTAuOC0wLjctMS41LTEuMi0yLjJsMC44LTEuNGwtMi4yLTEuN2wtMS4xLDEuMQoJCQkJYy0wLjgtMC40LTEuNi0wLjYtMi41LTAuN2wtMC40LTEuNWwtMi43LDAuM2wwLDEuNWMtMC44LDAuMy0xLjYsMC43LTIuMiwxLjNsLTEuMy0wLjhsLTEuNywyLjFsMS4xLDEuMQoJCQkJYy0wLjQsMC44LTAuNiwxLjYtMC43LDIuNGwtMS41LDAuNGwwLjMsMi43bDEuNiwwYzAuMywwLjgsMC43LDEuNSwxLjIsMi4ybC0wLjgsMS40bDIuMSwxLjdsMS4xLTEuMWMwLjgsMC40LDEuNiwwLjYsMi41LDAuNwoJCQkJbDAuNCwxLjVsMi43LTAuM2wwLTEuNWMwLjgtMC4zLDEuNi0wLjcsMi4yLTEuM2wxLjMsMC44bDEuNy0yLjFsLTEuMS0xLjFjMC40LTAuOCwwLjYtMS42LDAuNy0yLjRMLTc4Mi4xLTI1eiIvPgogICAgICA8cGF0aCBpZD0iUGF0aF84NTZfMl8iIGNsYXNzPSJzdDAiIGQ9Ik0tNzg5LjItMTAuMnYtMTUuMWwxLjItMS40di01LjJsLTEuMi0xLjR2LTYuMWwxLjItMS41Vi00NmwtMS4yLTEuNHYtMC41CgkJCQljMC0yLjUsMS4zLTQuOSwzLjQtNi4zbDIuNi0xLjdjMC45LTAuNiwxLjQtMS42LDEuNC0yLjZ2LTUuNmgxMC43djUuNmMwLDEuMSwwLjUsMi4xLDEuNCwyLjZsMi42LDEuN2MyLjEsMS40LDMuNCwzLjcsMy40LDYuMwoJCQkJdjAuNmwtMC45LDEuM3Y1LjFsMC45LDEuNXY2LjFsLTAuOSwxLjR2NS4ybDAuOSwxLjR2MTcuOSIvPgogICAgICA8cGF0aCBpZD0iUGF0aF84NTdfMl8iIGNsYXNzPSJzdDIiCiAgICAgICAgICAgIGQ9Ik0tNzcxLjItNjQuMXYtNGMwLTAuOS0wLjctMS42LTEuNi0xLjZoLTcuNGMtMC45LDAtMS42LDAuNy0xLjYsMS42YzAsMCwwLDAsMCwwdjQiLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfNTgzXzJfIiBjbGFzcz0ic3QzIiB4MT0iLTc4OCIgeTE9Ii00MC45IiB4Mj0iLTc3OS42IiB5Mj0iLTQwLjkiLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfNTg0XzJfIiBjbGFzcz0ic3QzIiB4MT0iLTc4OCIgeTE9Ii0zMS41IiB4Mj0iLTc3MC4yIiB5Mj0iLTMxLjUiLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfNTg1XzJfIiBjbGFzcz0ic3QzIiB4MT0iLTc2NC43IiB5MT0iLTQ2IiB4Mj0iLTc3NCIgeTI9Ii00NiIvPgogICAgICA8bGluZSBpZD0iTGluZV81ODZfMl8iIGNsYXNzPSJzdDMiIHgxPSItNzY0LjciIHkxPSItNDAuOSIgeDI9Ii03NjkuNCIgeTI9Ii00MC45Ii8+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzU4N18yXyIgY2xhc3M9InN0MyIgeDE9Ii03NjQuNyIgeTE9Ii0yNi42IiB4Mj0iLTc4MC41IiB5Mj0iLTI2LjYiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfODU4XzJfIiBjbGFzcz0ic3Q0IiBkPSJNLTc4OS4yLTIxLjd2LTMuNmwxLjItMS40di01LjJsLTEuMi0xLjR2LTYuMWwxLjItMS41Vi00NmwtMS4yLTEuNHYtMC41CgkJCQljMC0yLjUsMS4zLTQuOSwzLjQtNi4zbDIuNi0xLjdjMC45LTAuNiwxLjQtMS42LDEuNC0yLjZ2LTUuNmgxMC43djUuNmMwLDEuMSwwLjUsMi4xLDEuNCwyLjZsMi42LDEuN2MyLjEsMS40LDMuNCwzLjcsMy40LDYuMwoJCQkJdjAuNmwtMC45LDEuM3Y1LjFsMC45LDEuNXY2LjFsLTAuOSwxLjR2NS4ybDAuOSwxLjR2NC45Ii8+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzU4OF8yXyIgY2xhc3M9InN0NCIgeDE9Ii03ODMiIHkxPSItNjQuMSIgeDI9Ii03NzAiIHkyPSItNjQuMSIvPgogICAgICA8cGF0aCBpZD0iUGF0aF84NTlfMl8iIGNsYXNzPSJzdDIiIGQ9Ik0tNzUwLjUtMS4xdi00LjJsLTIuNC0wLjNjLTAuMy0xLjMtMC44LTIuNS0xLjQtMy41bDEuNS0xLjlsLTMtM2wtMS45LDEuNAoJCQkJYy0xLjEtMC43LTIuMy0xLjItMy42LTEuNWwtMC4zLTIuM2gtNC4ybC0wLjMsMi4zYy0xLjMsMC4zLTIuNSwwLjgtMy42LDEuNWwtMS45LTEuNGwtMywzbDEuNSwxLjljLTAuNywxLjEtMS4yLDIuMy0xLjQsMy41CgkJCQlsLTIuNCwwLjN2NC4ybDIuNCwwLjNjMC4zLDEuMywwLjgsMi41LDEuNCwzLjVsLTEuNSwxLjlsMywzbDEuOS0xLjRjMS4xLDAuNywyLjMsMS4yLDMuNiwxLjVsMC4zLDIuM2g0LjJsMC4zLTIuMwoJCQkJYzEuMy0wLjMsMi41LTAuOCwzLjYtMS41bDEuOSwxLjRsMy0zbC0xLjUtMS45YzAuNy0xLjEsMS4yLTIuMywxLjQtMy41TC03NTAuNS0xLjF6Ii8+CiAgICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfNjlfMl8iIGNsYXNzPSJzdDUiIGN4PSItNzYzLjgiIGN5PSItMy4yIiByPSI0LjciLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfODYwXzJfIiBjbGFzcz0ic3Q2IiBkPSJNLTc4MS4zLTQuNGMwLjEtMC43LDAuMi0xLjUsMC4xLTIuMmwzLjEtMmwtMS0yLjlsLTMuNiwwLjRjLTAuOS0xLjItMi0yLjItMy40LTIuOQoJCQkJbC0wLjEtMy43bC0zLjEtMC42bC0xLjUsMy4zYy0xLjUsMC4xLTMsMC42LTQuMiwxLjRsLTMuMi0xLjdsLTIsMi4zbDIuMSwzYy0wLjMsMC43LTAuNiwxLjQtMC43LDIuMWMtMC4xLDAuNy0wLjIsMS41LTAuMSwyLjIKCQkJCWwtMy4xLDJsMSwyLjlsMy42LTAuNGMwLjksMS4yLDIsMi4yLDMuNCwyLjlsMC4xLDMuN2wzLjEsMC42bDEuNS0zLjNjMS41LTAuMSwzLTAuNiw0LjItMS40bDMuMiwxLjdsMi0yLjNsLTIuMS0zCgkJCQlDLTc4MS43LTMtNzgxLjUtMy43LTc4MS4zLTQuNHoiLz4KICAgICAgPGNpcmNsZSBpZD0iRWxsaXBzZV83MF8yXyIgY2xhc3M9InN0NSIgY3g9Ii03OTAuMSIgY3k9Ii02LjEiIHI9IjMuNyIvPgogICAgICA8cGF0aCBpZD0iUGF0aF84NjFfMl8iIGNsYXNzPSJzdDciIGQ9Ik0tNzg2LjQsNy42djUuM2MwLDIuMS0xLjcsMy44LTMuOCwzLjhsMCwwaC0wLjYiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfODYyXzJfIiBjbGFzcz0ic3QzIiBkPSJNLTc4Mi4yLDEwLjd2Ni43YzAsMS44LDEuNSwzLjMsMy4zLDMuM2wwLDBoMC4yIi8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzg2M18yXyIgY2xhc3M9InN0NyIgZD0iTS03NzUuMiwxMi45djguN2MwLDIuMS0xLjcsMy45LTMuOSwzLjljMCwwLDAsMCwwLDBoLTEuNiIvPgogICAgICA8cGF0aCBpZD0iUGF0aF84NjRfMl8iIGNsYXNzPSJzdDMiIGQ9Ik0tNzY0LjcsMTMuOXYzLjZjMCwxLjksMS42LDMuNSwzLjUsMy41YzAsMCwwLDAsMCwwaDEuMiIvPgogICAgICA8cGF0aCBpZD0iUGF0aF84NjVfMl8iIGNsYXNzPSJzdDciIGQ9Ik0tNzY5LjksMTFjMCwwLTAuMSw5LjIsMCw5LjIiLz4KCQk8L2c+Cgk8L2c+CjwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 272 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 273 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 274 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 276 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIKICAgICB5PSIwcHgiCiAgICAgdmlld0JveD0iMCAwIDE3MiAxNzIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE3MiAxNzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojQjNENEYwO30KCS5zdDF7ZmlsbDojRTlFRUYyO3N0cm9rZTojMEIyQzMxO3N0cm9rZS13aWR0aDowLjc2MjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cgkuc3Qye2ZpbGw6I0U5RUVGMjtzdHJva2U6IzY5OUNEMztzdHJva2Utd2lkdGg6MC43NjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQoJLnN0M3tmaWxsOm5vbmU7c3Ryb2tlOiNCM0Q0RjA7c3Ryb2tlLXdpZHRoOjAuNzYyO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDR7ZmlsbDojRTlFRUYyO3N0cm9rZTojQjNENEYwO3N0cm9rZS13aWR0aDowLjc2MjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cjwvc3R5bGU+CiAgPGcgaWQ9IldpbmtlbHNfMl8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ1MS4wNTggMjU5LjYzNCkiPgoJPGcgaWQ9Ikdyb3VwXzk3Ml8yXyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTkzMy44MTggLTE3NDMuNzU2KSI+CgkJPGcgaWQ9Ikdyb3VwXzk3MV8yXyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMikiPgoJCQk8cGF0aCBpZD0iUGF0aF85MzFfMl8iIGNsYXNzPSJzdDAiIGQ9Ik0tMjI1NC42LDE1ODEuM2MwLjEtMC4zLDAuMS0wLjYsMC4yLTAuOWMwLTEuNS0xLjItMi44LTIuOC0yLjhoMAoJCQkJYy0wLjItMi45LTIuNi01LjItNS41LTUuMmMtMC4yLDAtMC41LDAtMC43LDAuMWMwLTAuMSwwLTAuMiwwLTAuM2MwLTEuMy0xLTIuMy0yLjMtMi4zYzAsMCwwLDAsMCwwYy0xLjMsMC0yLjMsMS0yLjMsMi4zCgkJCQljMCwwLDAsMCwwLDBjMCwwLjksMC41LDEuNywxLjMsMi4xYy0wLjksMS0xLjQsMi4zLTEuNCwzLjdjMCwwLjMsMCwwLjUsMC4xLDAuOGwtMS42LTAuMmwzLjUsMTFoNmMwLjMsMC4xLDAuNiwwLjEsMSwwLjEKCQkJCWMzLjEsMCw1LjUtMi41LDUuNS01LjVDLTIyNTMuOCwxNTgzLjItMjI1NC4xLDE1ODIuMi0yMjU0LjYsMTU4MS4zeiIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85MzJfMl8iIGNsYXNzPSJzdDAiIGQ9Ik0tMjMzMS4xLDE1NzcuOGMxLjMtMC44LDItMi4yLDItMy43YzAtMi40LTEuOS00LjMtNC4zLTQuM2MwLDAsMCwwLDAsMAoJCQkJYy0yLjQsMC00LjMsMS45LTQuMyw0LjNjMCwwLjMsMCwwLjYsMC4xLDAuOWMtMi44LDAuNi00LjgsMy4xLTQuOCw1LjljMCwwLDAsMC4xLDAsMC4xYy0yLDAuNC0zLjQsMi4yLTMuNCw0LjIKCQkJCWMwLDIuNCwxLjksNC4zLDQuMyw0LjNoMTAuMXYtNS4xYzAuNy0xLDEuMS0yLjMsMS4xLTMuNUMtMjMzMC4zLDE1NzkuOS0yMzMwLjYsMTU3OC44LTIzMzEuMSwxNTc3Ljh6Ii8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzkzM18yXyIgY2xhc3M9InN0MSIgZD0iTS0yMjY2LjQsMTU1OS4xdjMwLjVoLTY1LjF2LTQ2LjhoNjUuMXYxMyIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85MzRfMl8iIGNsYXNzPSJzdDEiIGQ9Ik0tMjMyMC43LDE1ODcuMnYtMjAuN2gxMy44djIwLjciLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTM1XzJfIiBjbGFzcz0ic3QxIiBkPSJNLTIyNjguOSwxNTgxLjhoLTMxLjh2LTE1LjNoMzEuNSIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85MzZfMl8iIGNsYXNzPSJzdDIiIGQ9Ik0tMjI2My41LDE1NTRsLTMtN2gtNjQuOGwtMyw3LjhjMCwxLDEuMywxLjgsMi44LDEuOHMyLjgtMC44LDIuOC0xLjhjMCwxLDEuMywxLjgsMywxLjgKCQkJCWMxLjYsMCwzLTAuOCwzLTEuOGMwLDEsMS4zLDEuOCwzLDEuOHMzLTAuOCwzLTEuOGMwLDEsMS4zLDEuOCwzLDEuOHMzLTAuOCwzLTEuOGMwLDEsMS4zLDEuOCwzLDEuOHMzLTAuOCwzLTEuOAoJCQkJYzAsMSwxLjMsMS44LDMsMS44czMtMC44LDMtMS44YzAsMSwxLjMsMS44LDMsMS44czMtMC44LDMtMS44YzAsMSwxLjMsMS44LDMsMS44czMtMC44LDMtMS44YzAsMSwxLjMsMS44LDMsMS44czMtMC44LDMtMS44CgkJCQljMCwxLDEuMywxLjgsMywxLjhzMy0wLjgsMy0xLjhjMCwxLDEuMywxLjgsMywxLjhzMy0wLjgsMy0xLjhjMCwxLDEuMywxLjgsMywxLjhzMi43LTAuOCwyLjctMS44CgkJCQlDLTIyNjMuNSwxNTU0LjUtMjI2My41LDE1NTQuMy0yMjYzLjUsMTU1NHoiLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfNjI0XzJfIiBjbGFzcz0ic3QzIiB4MT0iLTIzMjYuOCIgeTE9IjE1NDkiIHgyPSItMjMyOC43IiB5Mj0iMTU1NC43Ii8+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzYyNV8yXyIgY2xhc3M9InN0MyIgeDE9Ii0yMzIxLjIiIHkxPSIxNTQ5IiB4Mj0iLTIzMjIuNyIgeTI9IjE1NTQuNyIvPgogICAgICA8bGluZSBpZD0iTGluZV82MjZfMl8iIGNsYXNzPSJzdDMiIHgxPSItMjMxNS43IiB5MT0iMTU0OSIgeDI9Ii0yMzE2LjgiIHkyPSIxNTU0LjciLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfNjI3XzJfIiBjbGFzcz0ic3QzIiB4MT0iLTIzMTAuMSIgeTE9IjE1NDkiIHgyPSItMjMxMC44IiB5Mj0iMTU1NC43Ii8+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzYyOF8yXyIgY2xhc3M9InN0MyIgeDE9Ii0yMzA0LjUiIHkxPSIxNTQ4LjciIHgyPSItMjMwNC45IiB5Mj0iMTU1NC43Ii8+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzYyOV8yXyIgY2xhc3M9InN0MyIgeDE9Ii0yMjk4LjkiIHkxPSIxNTQ4LjciIHgyPSItMjI5OC45IiB5Mj0iMTU1NC43Ii8+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzYzMF8yXyIgY2xhc3M9InN0MyIgeDE9Ii0yMjkzLjQiIHkxPSIxNTQ4LjciIHgyPSItMjI5MyIgeTI9IjE1NTQuNyIvPgogICAgICA8bGluZSBpZD0iTGluZV82MzFfMl8iIGNsYXNzPSJzdDMiIHgxPSItMjI4Ny44IiB5MT0iMTU0OC43IiB4Mj0iLTIyODciIHkyPSIxNTU0LjciLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfNjMyXzJfIiBjbGFzcz0ic3QzIiB4MT0iLTIyODIuMiIgeTE9IjE1NDguNyIgeDI9Ii0yMjgxLjEiIHkyPSIxNTU0LjciLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfNjMzXzJfIiBjbGFzcz0ic3QzIiB4MT0iLTIyNzYuNyIgeTE9IjE1NDguNyIgeDI9Ii0yMjc1LjEiIHkyPSIxNTU0LjciLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfNjM0XzJfIiBjbGFzcz0ic3QzIiB4MT0iLTIyNzEuMSIgeTE9IjE1NDguNyIgeDI9Ii0yMjY5LjIiIHkyPSIxNTU0LjciLz4KICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8yMDRfMl8iIHg9Ii0yMzAyLjciIHk9IjE1ODAuMSIgY2xhc3M9InN0NCIgd2lkdGg9IjM4LjUiIGhlaWdodD0iMi43Ii8+CiAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfMjA1XzJfIiB4PSItMjMxOC4zIiB5PSIxNTY5LjUiIGNsYXNzPSJzdDQiIHdpZHRoPSI5IiBoZWlnaHQ9IjcuMiIvPgogICAgICA8bGluZSBpZD0iTGluZV82MzVfMl8iIGNsYXNzPSJzdDMiIHgxPSItMjMwOS4zIiB5MT0iMTU3OS43IiB4Mj0iLTIzMTIiIHkyPSIxNTc5LjciLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfNjM2XzJfIiBjbGFzcz0ic3QzIiB4MT0iLTIzNDcuNyIgeTE9IjE1ODkuNiIgeDI9Ii0yMjUyLjQiIHkyPSIxNTg5LjYiLz4KCQk8L2c+Cgk8L2c+CjwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 277 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIKICAgICB5PSIwcHgiCiAgICAgdmlld0JveD0iMCAwIDE3MiAxNzIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE3MiAxNzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRTlFRUYyO30KCS5zdDF7ZmlsbDojQjNENEYwO30KCS5zdDJ7ZmlsbDojRkZGRkZGO3N0cm9rZTojMEIyQzMxO3N0cm9rZS13aWR0aDowLjc2MjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cgkuc3Qze2ZpbGw6I0ZGRkZGRjtzdHJva2U6IzY5OUNEMztzdHJva2Utd2lkdGg6MC43NjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQoJLnN0NHtmaWxsOm5vbmU7c3Ryb2tlOiNCM0Q0RjA7c3Ryb2tlLXdpZHRoOjAuNzYyO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDV7ZmlsbDojRkZGRkZGO3N0cm9rZTojQjNENEYwO3N0cm9rZS13aWR0aDowLjc2MjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cjwvc3R5bGU+CiAgPGcgaWQ9IldpbmtlbHNfMl8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ1MS4wNTggMjU5LjYzNCkiPgoJPGcgaWQ9Ikdyb3VwXzk3Ml8yXyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTkzMy44MTggLTE3NDMuNzU2KSI+CgkJPGcgaWQ9Ikdyb3VwXzk3MV8yXyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMikiPgoJCQk8cGF0aCBpZD0iUGF0aF85MzFfMl8iIGNsYXNzPSJzdDEiIGQ9Ik0tMjI1NC42LDE1ODEuM2MwLjEtMC4zLDAuMS0wLjYsMC4yLTAuOWMwLTEuNS0xLjItMi44LTIuOC0yLjhoMAoJCQkJYy0wLjItMi45LTIuNi01LjItNS41LTUuMmMtMC4yLDAtMC41LDAtMC43LDAuMWMwLTAuMSwwLTAuMiwwLTAuM2MwLTEuMy0xLTIuMy0yLjMtMi4zYzAsMCwwLDAsMCwwYy0xLjMsMC0yLjMsMS0yLjMsMi4zCgkJCQljMCwwLDAsMCwwLDBjMCwwLjksMC41LDEuNywxLjMsMi4xYy0wLjksMS0xLjQsMi4zLTEuNCwzLjdjMCwwLjMsMCwwLjUsMC4xLDAuOGwtMS42LTAuMmwzLjUsMTFoNmMwLjMsMC4xLDAuNiwwLjEsMSwwLjEKCQkJCWMzLjEsMCw1LjUtMi41LDUuNS01LjVDLTIyNTMuOCwxNTgzLjItMjI1NC4xLDE1ODIuMi0yMjU0LjYsMTU4MS4zeiIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85MzJfMl8iIGNsYXNzPSJzdDEiIGQ9Ik0tMjMzMS4xLDE1NzcuOGMxLjMtMC44LDItMi4yLDItMy43YzAtMi40LTEuOS00LjMtNC4zLTQuM2MwLDAsMCwwLDAsMAoJCQkJYy0yLjQsMC00LjMsMS45LTQuMyw0LjNjMCwwLjMsMCwwLjYsMC4xLDAuOWMtMi44LDAuNi00LjgsMy4xLTQuOCw1LjljMCwwLDAsMC4xLDAsMC4xYy0yLDAuNC0zLjQsMi4yLTMuNCw0LjIKCQkJCWMwLDIuNCwxLjksNC4zLDQuMyw0LjNoMTAuMXYtNS4xYzAuNy0xLDEuMS0yLjMsMS4xLTMuNUMtMjMzMC4zLDE1NzkuOS0yMzMwLjYsMTU3OC44LTIzMzEuMSwxNTc3Ljh6Ii8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzkzM18yXyIgY2xhc3M9InN0MiIgZD0iTS0yMjY2LjQsMTU1OS4xdjMwLjVoLTY1LjF2LTQ2LjhoNjUuMXYxMyIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85MzRfMl8iIGNsYXNzPSJzdDIiIGQ9Ik0tMjMyMC43LDE1ODcuMnYtMjAuN2gxMy44djIwLjciLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTM1XzJfIiBjbGFzcz0ic3QyIiBkPSJNLTIyNjguOSwxNTgxLjhoLTMxLjh2LTE1LjNoMzEuNSIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85MzZfMl8iIGNsYXNzPSJzdDMiIGQ9Ik0tMjI2My41LDE1NTRsLTMtN2gtNjQuOGwtMyw3LjhjMCwxLDEuMywxLjgsMi44LDEuOHMyLjgtMC44LDIuOC0xLjhjMCwxLDEuMywxLjgsMywxLjgKCQkJCWMxLjYsMCwzLTAuOCwzLTEuOGMwLDEsMS4zLDEuOCwzLDEuOHMzLTAuOCwzLTEuOGMwLDEsMS4zLDEuOCwzLDEuOHMzLTAuOCwzLTEuOGMwLDEsMS4zLDEuOCwzLDEuOHMzLTAuOCwzLTEuOAoJCQkJYzAsMSwxLjMsMS44LDMsMS44czMtMC44LDMtMS44YzAsMSwxLjMsMS44LDMsMS44czMtMC44LDMtMS44YzAsMSwxLjMsMS44LDMsMS44czMtMC44LDMtMS44YzAsMSwxLjMsMS44LDMsMS44czMtMC44LDMtMS44CgkJCQljMCwxLDEuMywxLjgsMywxLjhzMy0wLjgsMy0xLjhjMCwxLDEuMywxLjgsMywxLjhzMy0wLjgsMy0xLjhjMCwxLDEuMywxLjgsMywxLjhzMi43LTAuOCwyLjctMS44CgkJCQlDLTIyNjMuNSwxNTU0LjUtMjI2My41LDE1NTQuMy0yMjYzLjUsMTU1NHoiLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfNjI0XzJfIiBjbGFzcz0ic3Q0IiB4MT0iLTIzMjYuOCIgeTE9IjE1NDkiIHgyPSItMjMyOC43IiB5Mj0iMTU1NC43Ii8+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzYyNV8yXyIgY2xhc3M9InN0NCIgeDE9Ii0yMzIxLjIiIHkxPSIxNTQ5IiB4Mj0iLTIzMjIuNyIgeTI9IjE1NTQuNyIvPgogICAgICA8bGluZSBpZD0iTGluZV82MjZfMl8iIGNsYXNzPSJzdDQiIHgxPSItMjMxNS43IiB5MT0iMTU0OSIgeDI9Ii0yMzE2LjgiIHkyPSIxNTU0LjciLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfNjI3XzJfIiBjbGFzcz0ic3Q0IiB4MT0iLTIzMTAuMSIgeTE9IjE1NDkiIHgyPSItMjMxMC44IiB5Mj0iMTU1NC43Ii8+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzYyOF8yXyIgY2xhc3M9InN0NCIgeDE9Ii0yMzA0LjUiIHkxPSIxNTQ4LjciIHgyPSItMjMwNC45IiB5Mj0iMTU1NC43Ii8+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzYyOV8yXyIgY2xhc3M9InN0NCIgeDE9Ii0yMjk4LjkiIHkxPSIxNTQ4LjciIHgyPSItMjI5OC45IiB5Mj0iMTU1NC43Ii8+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzYzMF8yXyIgY2xhc3M9InN0NCIgeDE9Ii0yMjkzLjQiIHkxPSIxNTQ4LjciIHgyPSItMjI5MyIgeTI9IjE1NTQuNyIvPgogICAgICA8bGluZSBpZD0iTGluZV82MzFfMl8iIGNsYXNzPSJzdDQiIHgxPSItMjI4Ny44IiB5MT0iMTU0OC43IiB4Mj0iLTIyODciIHkyPSIxNTU0LjciLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfNjMyXzJfIiBjbGFzcz0ic3Q0IiB4MT0iLTIyODIuMiIgeTE9IjE1NDguNyIgeDI9Ii0yMjgxLjEiIHkyPSIxNTU0LjciLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfNjMzXzJfIiBjbGFzcz0ic3Q0IiB4MT0iLTIyNzYuNyIgeTE9IjE1NDguNyIgeDI9Ii0yMjc1LjEiIHkyPSIxNTU0LjciLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfNjM0XzJfIiBjbGFzcz0ic3Q0IiB4MT0iLTIyNzEuMSIgeTE9IjE1NDguNyIgeDI9Ii0yMjY5LjIiIHkyPSIxNTU0LjciLz4KICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8yMDRfMl8iIHg9Ii0yMzAyLjciIHk9IjE1ODAuMSIgY2xhc3M9InN0NSIgd2lkdGg9IjM4LjUiIGhlaWdodD0iMi43Ii8+CiAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfMjA1XzJfIiB4PSItMjMxOC4zIiB5PSIxNTY5LjUiIGNsYXNzPSJzdDUiIHdpZHRoPSI5IiBoZWlnaHQ9IjcuMiIvPgogICAgICA8bGluZSBpZD0iTGluZV82MzVfMl8iIGNsYXNzPSJzdDQiIHgxPSItMjMwOS4zIiB5MT0iMTU3OS43IiB4Mj0iLTIzMTIiIHkyPSIxNTc5LjciLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfNjM2XzJfIiBjbGFzcz0ic3Q0IiB4MT0iLTIzNDcuNyIgeTE9IjE1ODkuNiIgeDI9Ii0yMjUyLjQiIHkyPSIxNTg5LjYiLz4KCQk8L2c+Cgk8L2c+CjwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 278 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 279 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuMywgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIKICAgICB5PSIwcHgiCiAgICAgdmlld0JveD0iMCAwIDE3MiAxNzIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE3MiAxNzI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRkZGRkZGO3N0cm9rZTojMEIyQzMxO3N0cm9rZS13aWR0aDowLjc2MjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cgkuc3Qxe2ZpbGw6bm9uZTtzdHJva2U6IzBCMkMzMTtzdHJva2Utd2lkdGg6MC43NjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQoJLnN0MntmaWxsOiNCM0Q0RjA7fQoJLnN0M3tmaWxsOm5vbmU7c3Ryb2tlOiM2OTlDRDM7c3Ryb2tlLXdpZHRoOjAuNzYyO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KCS5zdDR7ZmlsbDojRkZGRkZGO3N0cm9rZTojQjNENEYwO3N0cm9rZS13aWR0aDowLjc2MjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDt9Cgkuc3Q1e2ZpbGw6I0ZGRkZGRjtzdHJva2U6IzY5OUNEMztzdHJva2Utd2lkdGg6MC43NjI7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fQoJLnN0NntmaWxsOm5vbmU7c3Ryb2tlOiNCM0Q0RjA7c3Ryb2tlLXdpZHRoOjAuNzYyO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KICA8ZyBpZD0iT25laW5kaWdlR3JvbmRzdG9mZmVuXzJfIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1NS4xNyA0NDUuMTk4KSI+Cgk8ZyBpZD0iR3JvdXBfMTAwMF8yXyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU1LjE3IC01ODUuMTk4KSI+CgkJPGcgaWQ9Ikdyb3VwXzk5OV8yXyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNCAyKSI+CgkJCTxwYXRoIGlkPSJQYXRoXzk2OF8yXyIgY2xhc3M9InN0MCIgZD0iTTEwNC40LDIzOC4yYy0zLjUsMi41LTEwLjksNC4zLTE5LjQsNC4zYy0xMS45LDAtMjEuNi0zLjQtMjEuNi03Ljd2LTQuMWwtMC43LTQuN2wxLjQtNi44CgkJCQlsLTEuNC05LjlsMC43LTNsLTAuNy00LjdsMC41LTQuNSIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85NjlfMl8iIGNsYXNzPSJzdDAiIGQ9Ik0xMDcuNiwyMDUuOGwtMC45LDcuM2wwLjcsNS4xbC0xLjksOS45bDAuOSwyLjlsMC4yLDMuOCIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85NzBfMl8iIGNsYXNzPSJzdDAiIGQ9Ik02My40LDE3Ny41bC0wLjcsMTAuNGwwLjMsMy41Ii8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzk3MV8yXyIgY2xhc3M9InN0MSIgZD0iTTEwNy41LDIwMi44bC0wLjgtNS42di03LjZsMC44LTYuMWwtMC44LTUuOUg2My40Ii8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzk3Ml8yXyIgY2xhc3M9InN0MCIgZD0iTTEwMi4yLDE4Mi4yYy01LjUsMi4yLTExLjMsMy4yLTE3LjIsM2MtNS42LDAuMS0xMS4xLTAuOC0xNi40LTIuN2MtMy4yLTEuMy01LjItMy4xLTUuMi01CgkJCQljMC00LjIsOS43LTcuNywyMS42LTcuN3MyMS42LDMuNCwyMS42LDcuNyIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85NzNfMl8iIGNsYXNzPSJzdDIiIGQ9Ik04NSwxODEuOGMtNS4yLDAuMS0xMC4zLTAuNy0xNS4xLTIuNWMtMS0wLjQtMS41LTEuNi0xLjEtMi42YzAuMi0wLjUsMC42LTAuOSwxLjEtMS4xCgkJCQljNC44LTEuOCwxMC0yLjYsMTUuMS0yLjVjNS4yLTAuMSwxMC4zLDAuNywxNS4xLDIuNWMxLDAuNCwxLjUsMS42LDEuMSwyLjZjLTAuMiwwLjUtMC42LDAuOS0xLjEsMS4xCgkJCQlDOTUuMywxODEuMSw5MC4yLDE4Miw4NSwxODEuOHoiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTc0XzJfIiBjbGFzcz0ic3QzIiBkPSJNMTAxLjQsMTg5LjRsMS4yLDIuOWwtMC40LDQuMSIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85NzVfMl8iIGNsYXNzPSJzdDQiIGQ9Ik05OS45LDE5OC42YzMuMy0yLjUsOS45LTYsMTMuNS02LjJsMS42LDUuNWMwLDAtOS41LDguOS0xMi40LDE1LjIiLz4KCiAgICAgIDxlbGxpcHNlIGlkPSJFbGxpcHNlXzk0XzJfIiB0cmFuc2Zvcm09Im1hdHJpeCgwLjk2MDcgLTAuMjc3NiAwLjI3NzYgMC45NjA3IC00OS42ODQ2IDM5LjM3NTkpIiBjbGFzcz0ic3Q1IgogICAgICAgICAgICAgICBjeD0iMTE0LjIiIGN5PSIxOTUuMiIgcng9IjEiIHJ5PSIyLjkiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTc2XzJfIiBjbGFzcz0ic3QzIiBkPSJNNzAsMTg3LjJ2NS4ybDEuMiw1LjkiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTc3XzJfIiBjbGFzcz0ic3QzIiBkPSJNODIuNSwyMzRsLTAuNy01LjNsMS4yLTQuN2wtMi43LTE0LjciLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTc4XzJfIiBjbGFzcz0ic3Q1IiBkPSJNODUuNSwxOTQuNmwtMS43LDUuM3YyLjgiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTc5XzJfIiBjbGFzcz0ic3QzIiBkPSJNOTEuMiwyMDNsLTEuNCw3LjJsMi42LDcuMWwtMC41LDQiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTgwXzJfIiBjbGFzcz0ic3QzIiBkPSJNOTcuMiwyMzYuM2wyLjctOS42bC0xLjMtNy41Ii8+CgkJPC9nPgogICAgPGcgaWQ9Ikdyb3VwXzk4M18yXyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjM4OC44NzYgLTEzNDIuMTIyKSI+CgkJCTxwYXRoIGlkPSJQYXRoXzk4MV8yXyIgY2xhc3M9InN0MCIgZD0iTS0yMzEyLjQsMTU2OC4yYzAuMiwxMi44LTMuOCwxNy4yLTguNywxNy4zYy00LjksMC4xLTktNC4zLTkuMS0xNy4xCgkJCQljLTAuMi0xMi44LDMuNi0yOC4xLDguNS0yOC4xYzMuOS0wLjEsNy40LDkuNyw4LjcsMjAuMSIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85ODJfMl8iIGNsYXNzPSJzdDUiIGQ9Ik0tMjMxNy4zLDE1ODUuM2wtMy40LDEuMmMtNi4xLTAuOS0xMC43LTYuMS0xMC44LTEyLjNsMCwwYzAtMi4xLTAuNi00LjEtMS43LTUuOWwtMi45LTQuNgoJCQkJYzQuNy0wLjQsOS40LDEuMiwxMi45LDQuNCIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85ODNfMl8iIGNsYXNzPSJzdDQiIGQ9Ik0tMjMyMC44LDE1ODYuNWM2LTEuMSwxMC40LTYuNCwxMC4zLTEyLjZsMCwwYzAtMi4xLDAuNS00LjEsMS42LTUuOWwyLjgtNC43CgkJCQljMCwwLTE4LTEuMy0xOC4zLDIyLjFMLTIzMjAuOCwxNTg2LjV6Ii8+CiAgICAgIDxwYXRoIGlkPSJSZWN0YW5nbGVfMjE1XzJfIiBjbGFzcz0ic3QwIiBkPSJNLTIzMjQuNywxNTg1LjhsNy40LTAuMWMwLjcsMCwxLjQsMC42LDEuNCwxLjNsMCwyLjhjMCwwLjctMC42LDEuNC0xLjMsMS40bC03LjQsMC4xCgkJCQljLTAuNywwLTEuNC0wLjYtMS40LTEuM2wwLTIuOEMtMjMyNiwxNTg2LjQtMjMyNS40LDE1ODUuOC0yMzI0LjcsMTU4NS44eiIvPgogICAgICA8bGluZSBpZD0iTGluZV82NTNfMl8iIGNsYXNzPSJzdDYiIHgxPSItMjMyMyIgeTE9IjE1NDUuNiIgeDI9Ii0yMzIwLjEiIHkyPSIxNTQ1LjUiLz4KICAgICAgPGxpbmUgaWQ9IkxpbmVfNjU0XzJfIiBjbGFzcz0ic3Q2IiB4MT0iLTIzMjEuOCIgeTE9IjE1NjYuMSIgeDI9Ii0yMzIwLjMiIHkyPSIxNTY2Ii8+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzY1NV8yXyIgY2xhc3M9InN0NiIgeDE9Ii0yMzIxLjQiIHkxPSIxNTQ5LjciIHgyPSItMjMxOC42IiB5Mj0iMTU0OS42Ii8+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzY1Nl8yXyIgY2xhc3M9InN0NiIgeDE9Ii0yMzIyLjkiIHkxPSIxNTUzLjgiIHgyPSItMjMxNy43IiB5Mj0iMTU1My43Ii8+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzY1N18yXyIgY2xhc3M9InN0NiIgeDE9Ii0yMzI2LjUiIHkxPSIxNTU3LjkiIHgyPSItMjMyMC4yIiB5Mj0iMTU1Ny44Ii8+CiAgICAgIDxsaW5lIGlkPSJMaW5lXzY1OF8yXyIgY2xhc3M9InN0NiIgeDE9Ii0yMzI1LjkiIHkxPSIxNTYyIiB4Mj0iLTIzMTcuMiIgeTI9IjE1NjEuOSIvPgoJCTwvZz4KCTwvZz4KPC9nPgo8L3N2Zz4K"

/***/ }),
/* 281 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 282 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 284 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(239)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(19);
	var toAbsoluteIndex = __webpack_require__(196);
	var toLength = __webpack_require__(16);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(523);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(18);
	var createDesc = __webpack_require__(193);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(14);
	var document = __webpack_require__(9).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 299 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(15)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(9).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(14);
	var setPrototypeOf = __webpack_require__(311).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(203);
	var ITERATOR = __webpack_require__(15)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(190);
	var descriptor = __webpack_require__(193);
	var setToStringTag = __webpack_require__(204);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(26)(IteratorPrototype, __webpack_require__(15)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(56);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(27);
	var hide = __webpack_require__(26);
	var Iterators = __webpack_require__(203);
	var $iterCreate = __webpack_require__(304);
	var setToStringTag = __webpack_require__(204);
	var getPrototypeOf = __webpack_require__(31);
	var ITERATOR = __webpack_require__(15)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 306 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 307 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(9);
	var macrotask = __webpack_require__(316).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(35)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(23);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(215);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(14);
	var anObject = __webpack_require__(8);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(37)(Function.call, __webpack_require__(30).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(218)('keys');
	var uid = __webpack_require__(197);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(232);
	var defined = __webpack_require__(44);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(39);
	var defined = __webpack_require__(44);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 315 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(37);
	var invoke = __webpack_require__(366);
	var html = __webpack_require__(301);
	var cel = __webpack_require__(298);
	var global = __webpack_require__(9);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(35)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(9);
	var DESCRIPTORS = __webpack_require__(17);
	var LIBRARY = __webpack_require__(56);
	var $typed = __webpack_require__(240);
	var hide = __webpack_require__(26);
	var redefineAll = __webpack_require__(194);
	var fails = __webpack_require__(13);
	var anInstance = __webpack_require__(188);
	var toInteger = __webpack_require__(39);
	var toLength = __webpack_require__(16);
	var toIndex = __webpack_require__(385);
	var gOPN = __webpack_require__(191).f;
	var dP = __webpack_require__(18).f;
	var arrayFill = __webpack_require__(295);
	var setToStringTag = __webpack_require__(204);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(9);
	var core = __webpack_require__(36);
	var LIBRARY = __webpack_require__(56);
	var wksExt = __webpack_require__(386);
	var defineProperty = __webpack_require__(18).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(202);
	var ITERATOR = __webpack_require__(15)('iterator');
	var Iterators = __webpack_require__(203);
	module.exports = __webpack_require__(36).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(55);
	var step = __webpack_require__(369);
	var Iterators = __webpack_require__(203);
	var toIObject = __webpack_require__(32);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(305)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 321 */,
/* 322 */
47,
/* 323 */
47,
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(21),
		__webpack_require__(201)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( document, support ) {
	
	"use strict";
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	return support;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(207),
		__webpack_require__(20),
		__webpack_require__(58)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, toType, isFunction, rnothtmlwhite ) {
	
	"use strict";
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(58)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( rnothtmlwhite ) {
		"use strict";
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
		return stripAndCollapse;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(21),
		__webpack_require__(245),
		__webpack_require__(201)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, documentElement, support ) {
	
	"use strict";
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			}
		} );
	} )();
	
	return support;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return [ "Top", "Right", "Bottom", "Left" ];
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(422)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( pnum ) {
		"use strict";
	
		return new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	/**
	 * Determines whether an object can have data
	 */
	return function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(220),
		__webpack_require__(21),
		__webpack_require__(20),
		__webpack_require__(337),
		__webpack_require__(58),
		__webpack_require__(328),
		__webpack_require__(407),
		__webpack_require__(408),
		__webpack_require__(403),
		__webpack_require__(48),
		__webpack_require__(825),
	
		__webpack_require__(40),
		__webpack_require__(333),
		__webpack_require__(208),
		__webpack_require__(210),
		__webpack_require__(243),
		__webpack_require__(221),
		__webpack_require__(831)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, camelCase, document, isFunction, rcssNum, rnothtmlwhite, cssExpand,
		isHiddenWithinTree, swap, adjustCSS, dataPriv, showHide ) {
	
	"use strict";
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(21),
		__webpack_require__(48),
		__webpack_require__(330),
		__webpack_require__(334),
		__webpack_require__(20),
		__webpack_require__(223),
		__webpack_require__(209)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, dataPriv, acceptData, hasOwn, isFunction, isWindow ) {
	
	"use strict";
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(48),
		__webpack_require__(208),
		__webpack_require__(325)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, dataPriv ) {
	
	"use strict";
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(244)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( class2type ) {
		"use strict";
	
		return class2type.hasOwnProperty;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(222)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr ) {
		"use strict";
	
		return arr.indexOf;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return ( /^(?:checkbox|radio)$/i );
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(422)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( pnum ) {
	
	"use strict";
	
	return new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 338 */
/***/ (function(module, exports) {

	module.exports = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<!-- Generator: Adobe Illustrator 23.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->\n<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\"\n     y=\"0px\" viewBox=\"0 0 4.4 6.6\">\n  <path fill=\"none\" stroke=\"#699CD3\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"\n        d=\"M0.8,0.8l2.5,2.5L0.8,5.8\"/>\n</svg>\n"

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	     _ _      _       _
	 ___| (_) ___| | __  (_)___
	/ __| | |/ __| |/ /  | / __|
	\__ \ | | (__|   < _ | \__ \
	|___/_|_|\___|_|\_(_)/ |___/
	                   |__/
	
	 Version: 1.8.1
	  Author: Ken Wheeler
	 Website: http://kenwheeler.github.io
	    Docs: http://kenwheeler.github.io/slick
	    Repo: http://github.com/kenwheeler/slick
	  Issues: http://github.com/kenwheeler/slick/issues
	
	 */
	/* global window, document, define, jQuery, setInterval, clearInterval */
	;(function(factory) {
	    'use strict';
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== 'undefined') {
	        module.exports = factory(require('jquery'));
	    } else {
	        factory(jQuery);
	    }
	
	}(function($) {
	    'use strict';
	    var Slick = window.Slick || {};
	
	    Slick = (function() {
	
	        var instanceUid = 0;
	
	        function Slick(element, settings) {
	
	            var _ = this, dataSettings;
	
	            _.defaults = {
	                accessibility: true,
	                adaptiveHeight: false,
	                appendArrows: $(element),
	                appendDots: $(element),
	                arrows: true,
	                asNavFor: null,
	                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
	                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
	                autoplay: false,
	                autoplaySpeed: 3000,
	                centerMode: false,
	                centerPadding: '50px',
	                cssEase: 'ease',
	                customPaging: function(slider, i) {
	                    return $('<button type="button" />').text(i + 1);
	                },
	                dots: false,
	                dotsClass: 'slick-dots',
	                draggable: true,
	                easing: 'linear',
	                edgeFriction: 0.35,
	                fade: false,
	                focusOnSelect: false,
	                focusOnChange: false,
	                infinite: true,
	                initialSlide: 0,
	                lazyLoad: 'ondemand',
	                mobileFirst: false,
	                pauseOnHover: true,
	                pauseOnFocus: true,
	                pauseOnDotsHover: false,
	                respondTo: 'window',
	                responsive: null,
	                rows: 1,
	                rtl: false,
	                slide: '',
	                slidesPerRow: 1,
	                slidesToShow: 1,
	                slidesToScroll: 1,
	                speed: 500,
	                swipe: true,
	                swipeToSlide: false,
	                touchMove: true,
	                touchThreshold: 5,
	                useCSS: true,
	                useTransform: true,
	                variableWidth: false,
	                vertical: false,
	                verticalSwiping: false,
	                waitForAnimate: true,
	                zIndex: 1000
	            };
	
	            _.initials = {
	                animating: false,
	                dragging: false,
	                autoPlayTimer: null,
	                currentDirection: 0,
	                currentLeft: null,
	                currentSlide: 0,
	                direction: 1,
	                $dots: null,
	                listWidth: null,
	                listHeight: null,
	                loadIndex: 0,
	                $nextArrow: null,
	                $prevArrow: null,
	                scrolling: false,
	                slideCount: null,
	                slideWidth: null,
	                $slideTrack: null,
	                $slides: null,
	                sliding: false,
	                slideOffset: 0,
	                swipeLeft: null,
	                swiping: false,
	                $list: null,
	                touchObject: {},
	                transformsEnabled: false,
	                unslicked: false
	            };
	
	            $.extend(_, _.initials);
	
	            _.activeBreakpoint = null;
	            _.animType = null;
	            _.animProp = null;
	            _.breakpoints = [];
	            _.breakpointSettings = [];
	            _.cssTransitions = false;
	            _.focussed = false;
	            _.interrupted = false;
	            _.hidden = 'hidden';
	            _.paused = true;
	            _.positionProp = null;
	            _.respondTo = null;
	            _.rowCount = 1;
	            _.shouldClick = true;
	            _.$slider = $(element);
	            _.$slidesCache = null;
	            _.transformType = null;
	            _.transitionType = null;
	            _.visibilityChange = 'visibilitychange';
	            _.windowWidth = 0;
	            _.windowTimer = null;
	
	            dataSettings = $(element).data('slick') || {};
	
	            _.options = $.extend({}, _.defaults, settings, dataSettings);
	
	            _.currentSlide = _.options.initialSlide;
	
	            _.originalSettings = _.options;
	
	            if (typeof document.mozHidden !== 'undefined') {
	                _.hidden = 'mozHidden';
	                _.visibilityChange = 'mozvisibilitychange';
	            } else if (typeof document.webkitHidden !== 'undefined') {
	                _.hidden = 'webkitHidden';
	                _.visibilityChange = 'webkitvisibilitychange';
	            }
	
	            _.autoPlay = $.proxy(_.autoPlay, _);
	            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
	            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
	            _.changeSlide = $.proxy(_.changeSlide, _);
	            _.clickHandler = $.proxy(_.clickHandler, _);
	            _.selectHandler = $.proxy(_.selectHandler, _);
	            _.setPosition = $.proxy(_.setPosition, _);
	            _.swipeHandler = $.proxy(_.swipeHandler, _);
	            _.dragHandler = $.proxy(_.dragHandler, _);
	            _.keyHandler = $.proxy(_.keyHandler, _);
	
	            _.instanceUid = instanceUid++;
	
	            // A simple way to check for HTML strings
	            // Strict HTML recognition (must start with <)
	            // Extracted from jQuery v1.11 source
	            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
	
	
	            _.registerBreakpoints();
	            _.init(true);
	
	        }
	
	        return Slick;
	
	    }());
	
	    Slick.prototype.activateADA = function() {
	        var _ = this;
	
	        _.$slideTrack.find('.slick-active').attr({
	            'aria-hidden': 'false'
	        }).find('a, input, button, select').attr({
	            'tabindex': '0'
	        });
	
	    };
	
	    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {
	
	        var _ = this;
	
	        if (typeof(index) === 'boolean') {
	            addBefore = index;
	            index = null;
	        } else if (index < 0 || (index >= _.slideCount)) {
	            return false;
	        }
	
	        _.unload();
	
	        if (typeof(index) === 'number') {
	            if (index === 0 && _.$slides.length === 0) {
	                $(markup).appendTo(_.$slideTrack);
	            } else if (addBefore) {
	                $(markup).insertBefore(_.$slides.eq(index));
	            } else {
	                $(markup).insertAfter(_.$slides.eq(index));
	            }
	        } else {
	            if (addBefore === true) {
	                $(markup).prependTo(_.$slideTrack);
	            } else {
	                $(markup).appendTo(_.$slideTrack);
	            }
	        }
	
	        _.$slides = _.$slideTrack.children(this.options.slide);
	
	        _.$slideTrack.children(this.options.slide).detach();
	
	        _.$slideTrack.append(_.$slides);
	
	        _.$slides.each(function(index, element) {
	            $(element).attr('data-slick-index', index);
	        });
	
	        _.$slidesCache = _.$slides;
	
	        _.reinit();
	
	    };
	
	    Slick.prototype.animateHeight = function() {
	        var _ = this;
	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.animate({
	                height: targetHeight
	            }, _.options.speed);
	        }
	    };
	
	    Slick.prototype.animateSlide = function(targetLeft, callback) {
	
	        var animProps = {},
	            _ = this;
	
	        _.animateHeight();
	
	        if (_.options.rtl === true && _.options.vertical === false) {
	            targetLeft = -targetLeft;
	        }
	        if (_.transformsEnabled === false) {
	            if (_.options.vertical === false) {
	                _.$slideTrack.animate({
	                    left: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            } else {
	                _.$slideTrack.animate({
	                    top: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            }
	
	        } else {
	
	            if (_.cssTransitions === false) {
	                if (_.options.rtl === true) {
	                    _.currentLeft = -(_.currentLeft);
	                }
	                $({
	                    animStart: _.currentLeft
	                }).animate({
	                    animStart: targetLeft
	                }, {
	                    duration: _.options.speed,
	                    easing: _.options.easing,
	                    step: function(now) {
	                        now = Math.ceil(now);
	                        if (_.options.vertical === false) {
	                            animProps[_.animType] = 'translate(' +
	                                now + 'px, 0px)';
	                            _.$slideTrack.css(animProps);
	                        } else {
	                            animProps[_.animType] = 'translate(0px,' +
	                                now + 'px)';
	                            _.$slideTrack.css(animProps);
	                        }
	                    },
	                    complete: function() {
	                        if (callback) {
	                            callback.call();
	                        }
	                    }
	                });
	
	            } else {
	
	                _.applyTransition();
	                targetLeft = Math.ceil(targetLeft);
	
	                if (_.options.vertical === false) {
	                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
	                } else {
	                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
	                }
	                _.$slideTrack.css(animProps);
	
	                if (callback) {
	                    setTimeout(function() {
	
	                        _.disableTransition();
	
	                        callback.call();
	                    }, _.options.speed);
	                }
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.getNavTarget = function() {
	
	        var _ = this,
	            asNavFor = _.options.asNavFor;
	
	        if ( asNavFor && asNavFor !== null ) {
	            asNavFor = $(asNavFor).not(_.$slider);
	        }
	
	        return asNavFor;
	
	    };
	
	    Slick.prototype.asNavFor = function(index) {
	
	        var _ = this,
	            asNavFor = _.getNavTarget();
	
	        if ( asNavFor !== null && typeof asNavFor === 'object' ) {
	            asNavFor.each(function() {
	                var target = $(this).slick('getSlick');
	                if(!target.unslicked) {
	                    target.slideHandler(index, true);
	                }
	            });
	        }
	
	    };
	
	    Slick.prototype.applyTransition = function(slide) {
	
	        var _ = this,
	            transition = {};
	
	        if (_.options.fade === false) {
	            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
	        } else {
	            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
	        }
	
	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }
	
	    };
	
	    Slick.prototype.autoPlay = function() {
	
	        var _ = this;
	
	        _.autoPlayClear();
	
	        if ( _.slideCount > _.options.slidesToShow ) {
	            _.autoPlayTimer = setInterval( _.autoPlayIterator, _.options.autoplaySpeed );
	        }
	
	    };
	
	    Slick.prototype.autoPlayClear = function() {
	
	        var _ = this;
	
	        if (_.autoPlayTimer) {
	            clearInterval(_.autoPlayTimer);
	        }
	
	    };
	
	    Slick.prototype.autoPlayIterator = function() {
	
	        var _ = this,
	            slideTo = _.currentSlide + _.options.slidesToScroll;
	
	        if ( !_.paused && !_.interrupted && !_.focussed ) {
	
	            if ( _.options.infinite === false ) {
	
	                if ( _.direction === 1 && ( _.currentSlide + 1 ) === ( _.slideCount - 1 )) {
	                    _.direction = 0;
	                }
	
	                else if ( _.direction === 0 ) {
	
	                    slideTo = _.currentSlide - _.options.slidesToScroll;
	
	                    if ( _.currentSlide - 1 === 0 ) {
	                        _.direction = 1;
	                    }
	
	                }
	
	            }
	
	            _.slideHandler( slideTo );
	
	        }
	
	    };
	
	    Slick.prototype.buildArrows = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true ) {
	
	            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
	            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
	
	            if( _.slideCount > _.options.slidesToShow ) {
	
	                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
	                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
	
	                if (_.htmlExpr.test(_.options.prevArrow)) {
	                    _.$prevArrow.prependTo(_.options.appendArrows);
	                }
	
	                if (_.htmlExpr.test(_.options.nextArrow)) {
	                    _.$nextArrow.appendTo(_.options.appendArrows);
	                }
	
	                if (_.options.infinite !== true) {
	                    _.$prevArrow
	                        .addClass('slick-disabled')
	                        .attr('aria-disabled', 'true');
	                }
	
	            } else {
	
	                _.$prevArrow.add( _.$nextArrow )
	
	                    .addClass('slick-hidden')
	                    .attr({
	                        'aria-disabled': 'true',
	                        'tabindex': '-1'
	                    });
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.buildDots = function() {
	
	        var _ = this,
	            i, dot;
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$slider.addClass('slick-dotted');
	
	            dot = $('<ul />').addClass(_.options.dotsClass);
	
	            for (i = 0; i <= _.getDotCount(); i += 1) {
	                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
	            }
	
	            _.$dots = dot.appendTo(_.options.appendDots);
	
	            _.$dots.find('li').first().addClass('slick-active');
	
	        }
	
	    };
	
	    Slick.prototype.buildOut = function() {
	
	        var _ = this;
	
	        _.$slides =
	            _.$slider
	                .children( _.options.slide + ':not(.slick-cloned)')
	                .addClass('slick-slide');
	
	        _.slideCount = _.$slides.length;
	
	        _.$slides.each(function(index, element) {
	            $(element)
	                .attr('data-slick-index', index)
	                .data('originalStyling', $(element).attr('style') || '');
	        });
	
	        _.$slider.addClass('slick-slider');
	
	        _.$slideTrack = (_.slideCount === 0) ?
	            $('<div class="slick-track"/>').appendTo(_.$slider) :
	            _.$slides.wrapAll('<div class="slick-track"/>').parent();
	
	        _.$list = _.$slideTrack.wrap(
	            '<div class="slick-list"/>').parent();
	        _.$slideTrack.css('opacity', 0);
	
	        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
	            _.options.slidesToScroll = 1;
	        }
	
	        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
	
	        _.setupInfinite();
	
	        _.buildArrows();
	
	        _.buildDots();
	
	        _.updateDots();
	
	
	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
	
	        if (_.options.draggable === true) {
	            _.$list.addClass('draggable');
	        }
	
	    };
	
	    Slick.prototype.buildRows = function() {
	
	        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides,slidesPerSection;
	
	        newSlides = document.createDocumentFragment();
	        originalSlides = _.$slider.children();
	
	        if(_.options.rows > 0) {
	
	            slidesPerSection = _.options.slidesPerRow * _.options.rows;
	            numOfSlides = Math.ceil(
	                originalSlides.length / slidesPerSection
	            );
	
	            for(a = 0; a < numOfSlides; a++){
	                var slide = document.createElement('div');
	                for(b = 0; b < _.options.rows; b++) {
	                    var row = document.createElement('div');
	                    for(c = 0; c < _.options.slidesPerRow; c++) {
	                        var target = (a * slidesPerSection + ((b * _.options.slidesPerRow) + c));
	                        if (originalSlides.get(target)) {
	                            row.appendChild(originalSlides.get(target));
	                        }
	                    }
	                    slide.appendChild(row);
	                }
	                newSlides.appendChild(slide);
	            }
	
	            _.$slider.empty().append(newSlides);
	            _.$slider.children().children().children()
	                .css({
	                    'width':(100 / _.options.slidesPerRow) + '%',
	                    'display': 'inline-block'
	                });
	
	        }
	
	    };
	
	    Slick.prototype.checkResponsive = function(initial, forceUpdate) {
	
	        var _ = this,
	            breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
	        var sliderWidth = _.$slider.width();
	        var windowWidth = window.innerWidth || $(window).width();
	
	        if (_.respondTo === 'window') {
	            respondToWidth = windowWidth;
	        } else if (_.respondTo === 'slider') {
	            respondToWidth = sliderWidth;
	        } else if (_.respondTo === 'min') {
	            respondToWidth = Math.min(windowWidth, sliderWidth);
	        }
	
	        if ( _.options.responsive &&
	            _.options.responsive.length &&
	            _.options.responsive !== null) {
	
	            targetBreakpoint = null;
	
	            for (breakpoint in _.breakpoints) {
	                if (_.breakpoints.hasOwnProperty(breakpoint)) {
	                    if (_.originalSettings.mobileFirst === false) {
	                        if (respondToWidth < _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    } else {
	                        if (respondToWidth > _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    }
	                }
	            }
	
	            if (targetBreakpoint !== null) {
	                if (_.activeBreakpoint !== null) {
	                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
	                        _.activeBreakpoint =
	                            targetBreakpoint;
	                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                            _.unslick(targetBreakpoint);
	                        } else {
	                            _.options = $.extend({}, _.originalSettings,
	                                _.breakpointSettings[
	                                    targetBreakpoint]);
	                            if (initial === true) {
	                                _.currentSlide = _.options.initialSlide;
	                            }
	                            _.refresh(initial);
	                        }
	                        triggerBreakpoint = targetBreakpoint;
	                    }
	                } else {
	                    _.activeBreakpoint = targetBreakpoint;
	                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                        _.unslick(targetBreakpoint);
	                    } else {
	                        _.options = $.extend({}, _.originalSettings,
	                            _.breakpointSettings[
	                                targetBreakpoint]);
	                        if (initial === true) {
	                            _.currentSlide = _.options.initialSlide;
	                        }
	                        _.refresh(initial);
	                    }
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            } else {
	                if (_.activeBreakpoint !== null) {
	                    _.activeBreakpoint = null;
	                    _.options = _.originalSettings;
	                    if (initial === true) {
	                        _.currentSlide = _.options.initialSlide;
	                    }
	                    _.refresh(initial);
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            }
	
	            // only trigger breakpoints during an actual break. not on initialize.
	            if( !initial && triggerBreakpoint !== false ) {
	                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
	            }
	        }
	
	    };
	
	    Slick.prototype.changeSlide = function(event, dontAnimate) {
	
	        var _ = this,
	            $target = $(event.currentTarget),
	            indexOffset, slideOffset, unevenOffset;
	
	        // If target is a link, prevent default action.
	        if($target.is('a')) {
	            event.preventDefault();
	        }
	
	        // If target is not the <li> element (ie: a child), find the <li>.
	        if(!$target.is('li')) {
	            $target = $target.closest('li');
	        }
	
	        unevenOffset = (_.slideCount % _.options.slidesToScroll !== 0);
	        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
	
	        switch (event.data.message) {
	
	            case 'previous':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
	                }
	                break;
	
	            case 'next':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
	                }
	                break;
	
	            case 'index':
	                var index = event.data.index === 0 ? 0 :
	                    event.data.index || $target.index() * _.options.slidesToScroll;
	
	                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
	                $target.children().trigger('focus');
	                break;
	
	            default:
	                return;
	        }
	
	    };
	
	    Slick.prototype.checkNavigable = function(index) {
	
	        var _ = this,
	            navigables, prevNavigable;
	
	        navigables = _.getNavigableIndexes();
	        prevNavigable = 0;
	        if (index > navigables[navigables.length - 1]) {
	            index = navigables[navigables.length - 1];
	        } else {
	            for (var n in navigables) {
	                if (index < navigables[n]) {
	                    index = prevNavigable;
	                    break;
	                }
	                prevNavigable = navigables[n];
	            }
	        }
	
	        return index;
	    };
	
	    Slick.prototype.cleanUpEvents = function() {
	
	        var _ = this;
	
	        if (_.options.dots && _.$dots !== null) {
	
	            $('li', _.$dots)
	                .off('click.slick', _.changeSlide)
	                .off('mouseenter.slick', $.proxy(_.interrupt, _, true))
	                .off('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	            if (_.options.accessibility === true) {
	                _.$dots.off('keydown.slick', _.keyHandler);
	            }
	        }
	
	        _.$slider.off('focus.slick blur.slick');
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
	            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
	
	            if (_.options.accessibility === true) {
	                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
	                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
	            }
	        }
	
	        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
	        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
	        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
	        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
	
	        _.$list.off('click.slick', _.clickHandler);
	
	        $(document).off(_.visibilityChange, _.visibility);
	
	        _.cleanUpSlideEvents();
	
	        if (_.options.accessibility === true) {
	            _.$list.off('keydown.slick', _.keyHandler);
	        }
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
	        }
	
	        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
	
	        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
	
	        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
	
	        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
	
	    };
	
	    Slick.prototype.cleanUpSlideEvents = function() {
	
	        var _ = this;
	
	        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
	        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	    };
	
	    Slick.prototype.cleanUpRows = function() {
	
	        var _ = this, originalSlides;
	
	        if(_.options.rows > 0) {
	            originalSlides = _.$slides.children().children();
	            originalSlides.removeAttr('style');
	            _.$slider.empty().append(originalSlides);
	        }
	
	    };
	
	    Slick.prototype.clickHandler = function(event) {
	
	        var _ = this;
	
	        if (_.shouldClick === false) {
	            event.stopImmediatePropagation();
	            event.stopPropagation();
	            event.preventDefault();
	        }
	
	    };
	
	    Slick.prototype.destroy = function(refresh) {
	
	        var _ = this;
	
	        _.autoPlayClear();
	
	        _.touchObject = {};
	
	        _.cleanUpEvents();
	
	        $('.slick-cloned', _.$slider).detach();
	
	        if (_.$dots) {
	            _.$dots.remove();
	        }
	
	        if ( _.$prevArrow && _.$prevArrow.length ) {
	
	            _.$prevArrow
	                .removeClass('slick-disabled slick-arrow slick-hidden')
	                .removeAttr('aria-hidden aria-disabled tabindex')
	                .css('display','');
	
	            if ( _.htmlExpr.test( _.options.prevArrow )) {
	                _.$prevArrow.remove();
	            }
	        }
	
	        if ( _.$nextArrow && _.$nextArrow.length ) {
	
	            _.$nextArrow
	                .removeClass('slick-disabled slick-arrow slick-hidden')
	                .removeAttr('aria-hidden aria-disabled tabindex')
	                .css('display','');
	
	            if ( _.htmlExpr.test( _.options.nextArrow )) {
	                _.$nextArrow.remove();
	            }
	        }
	
	
	        if (_.$slides) {
	
	            _.$slides
	                .removeClass('slick-slide slick-active slick-center slick-visible slick-current')
	                .removeAttr('aria-hidden')
	                .removeAttr('data-slick-index')
	                .each(function(){
	                    $(this).attr('style', $(this).data('originalStyling'));
	                });
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slideTrack.detach();
	
	            _.$list.detach();
	
	            _.$slider.append(_.$slides);
	        }
	
	        _.cleanUpRows();
	
	        _.$slider.removeClass('slick-slider');
	        _.$slider.removeClass('slick-initialized');
	        _.$slider.removeClass('slick-dotted');
	
	        _.unslicked = true;
	
	        if(!refresh) {
	            _.$slider.trigger('destroy', [_]);
	        }
	
	    };
	
	    Slick.prototype.disableTransition = function(slide) {
	
	        var _ = this,
	            transition = {};
	
	        transition[_.transitionType] = '';
	
	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }
	
	    };
	
	    Slick.prototype.fadeSlide = function(slideIndex, callback) {
	
	        var _ = this;
	
	        if (_.cssTransitions === false) {
	
	            _.$slides.eq(slideIndex).css({
	                zIndex: _.options.zIndex
	            });
	
	            _.$slides.eq(slideIndex).animate({
	                opacity: 1
	            }, _.options.speed, _.options.easing, callback);
	
	        } else {
	
	            _.applyTransition(slideIndex);
	
	            _.$slides.eq(slideIndex).css({
	                opacity: 1,
	                zIndex: _.options.zIndex
	            });
	
	            if (callback) {
	                setTimeout(function() {
	
	                    _.disableTransition(slideIndex);
	
	                    callback.call();
	                }, _.options.speed);
	            }
	
	        }
	
	    };
	
	    Slick.prototype.fadeSlideOut = function(slideIndex) {
	
	        var _ = this;
	
	        if (_.cssTransitions === false) {
	
	            _.$slides.eq(slideIndex).animate({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            }, _.options.speed, _.options.easing);
	
	        } else {
	
	            _.applyTransition(slideIndex);
	
	            _.$slides.eq(slideIndex).css({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            });
	
	        }
	
	    };
	
	    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {
	
	        var _ = this;
	
	        if (filter !== null) {
	
	            _.$slidesCache = _.$slides;
	
	            _.unload();
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
	
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.focusHandler = function() {
	
	        var _ = this;
	
	        _.$slider
	            .off('focus.slick blur.slick')
	            .on('focus.slick blur.slick', '*', function(event) {
	
	            event.stopImmediatePropagation();
	            var $sf = $(this);
	
	            setTimeout(function() {
	
	                if( _.options.pauseOnFocus ) {
	                    _.focussed = $sf.is(':focus');
	                    _.autoPlay();
	                }
	
	            }, 0);
	
	        });
	    };
	
	    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {
	
	        var _ = this;
	        return _.currentSlide;
	
	    };
	
	    Slick.prototype.getDotCount = function() {
	
	        var _ = this;
	
	        var breakPoint = 0;
	        var counter = 0;
	        var pagerQty = 0;
	
	        if (_.options.infinite === true) {
	            if (_.slideCount <= _.options.slidesToShow) {
	                 ++pagerQty;
	            } else {
	                while (breakPoint < _.slideCount) {
	                    ++pagerQty;
	                    breakPoint = counter + _.options.slidesToScroll;
	                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	                }
	            }
	        } else if (_.options.centerMode === true) {
	            pagerQty = _.slideCount;
	        } else if(!_.options.asNavFor) {
	            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
	        }else {
	            while (breakPoint < _.slideCount) {
	                ++pagerQty;
	                breakPoint = counter + _.options.slidesToScroll;
	                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	            }
	        }
	
	        return pagerQty - 1;
	
	    };
	
	    Slick.prototype.getLeft = function(slideIndex) {
	
	        var _ = this,
	            targetLeft,
	            verticalHeight,
	            verticalOffset = 0,
	            targetSlide,
	            coef;
	
	        _.slideOffset = 0;
	        verticalHeight = _.$slides.first().outerHeight(true);
	
	        if (_.options.infinite === true) {
	            if (_.slideCount > _.options.slidesToShow) {
	                _.slideOffset = (_.slideWidth * _.options.slidesToShow) * -1;
	                coef = -1
	
	                if (_.options.vertical === true && _.options.centerMode === true) {
	                    if (_.options.slidesToShow === 2) {
	                        coef = -1.5;
	                    } else if (_.options.slidesToShow === 1) {
	                        coef = -2
	                    }
	                }
	                verticalOffset = (verticalHeight * _.options.slidesToShow) * coef;
	            }
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
	                    if (slideIndex > _.slideCount) {
	                        _.slideOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth) * -1;
	                        verticalOffset = ((_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight) * -1;
	                    } else {
	                        _.slideOffset = ((_.slideCount % _.options.slidesToScroll) * _.slideWidth) * -1;
	                        verticalOffset = ((_.slideCount % _.options.slidesToScroll) * verticalHeight) * -1;
	                    }
	                }
	            }
	        } else {
	            if (slideIndex + _.options.slidesToShow > _.slideCount) {
	                _.slideOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * _.slideWidth;
	                verticalOffset = ((slideIndex + _.options.slidesToShow) - _.slideCount) * verticalHeight;
	            }
	        }
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            _.slideOffset = 0;
	            verticalOffset = 0;
	        }
	
	        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
	            _.slideOffset = ((_.slideWidth * Math.floor(_.options.slidesToShow)) / 2) - ((_.slideWidth * _.slideCount) / 2);
	        } else if (_.options.centerMode === true && _.options.infinite === true) {
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
	        } else if (_.options.centerMode === true) {
	            _.slideOffset = 0;
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
	        }
	
	        if (_.options.vertical === false) {
	            targetLeft = ((slideIndex * _.slideWidth) * -1) + _.slideOffset;
	        } else {
	            targetLeft = ((slideIndex * verticalHeight) * -1) + verticalOffset;
	        }
	
	        if (_.options.variableWidth === true) {
	
	            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	            } else {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
	            }
	
	            if (_.options.rtl === true) {
	                if (targetSlide[0]) {
	                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                } else {
	                    targetLeft =  0;
	                }
	            } else {
	                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	            }
	
	            if (_.options.centerMode === true) {
	                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	                } else {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
	                }
	
	                if (_.options.rtl === true) {
	                    if (targetSlide[0]) {
	                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                    } else {
	                        targetLeft =  0;
	                    }
	                } else {
	                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	                }
	
	                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
	            }
	        }
	
	        return targetLeft;
	
	    };
	
	    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {
	
	        var _ = this;
	
	        return _.options[option];
	
	    };
	
	    Slick.prototype.getNavigableIndexes = function() {
	
	        var _ = this,
	            breakPoint = 0,
	            counter = 0,
	            indexes = [],
	            max;
	
	        if (_.options.infinite === false) {
	            max = _.slideCount;
	        } else {
	            breakPoint = _.options.slidesToScroll * -1;
	            counter = _.options.slidesToScroll * -1;
	            max = _.slideCount * 2;
	        }
	
	        while (breakPoint < max) {
	            indexes.push(breakPoint);
	            breakPoint = counter + _.options.slidesToScroll;
	            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	        }
	
	        return indexes;
	
	    };
	
	    Slick.prototype.getSlick = function() {
	
	        return this;
	
	    };
	
	    Slick.prototype.getSlideCount = function() {
	
	        var _ = this,
	            slidesTraversed, swipedSlide, centerOffset;
	
	        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
	
	        if (_.options.swipeToSlide === true) {
	            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
	                if (slide.offsetLeft - centerOffset + ($(slide).outerWidth() / 2) > (_.swipeLeft * -1)) {
	                    swipedSlide = slide;
	                    return false;
	                }
	            });
	
	            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
	
	            return slidesTraversed;
	
	        } else {
	            return _.options.slidesToScroll;
	        }
	
	    };
	
	    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'index',
	                index: parseInt(slide)
	            }
	        }, dontAnimate);
	
	    };
	
	    Slick.prototype.init = function(creation) {
	
	        var _ = this;
	
	        if (!$(_.$slider).hasClass('slick-initialized')) {
	
	            $(_.$slider).addClass('slick-initialized');
	
	            _.buildRows();
	            _.buildOut();
	            _.setProps();
	            _.startLoad();
	            _.loadSlider();
	            _.initializeEvents();
	            _.updateArrows();
	            _.updateDots();
	            _.checkResponsive(true);
	            _.focusHandler();
	
	        }
	
	        if (creation) {
	            _.$slider.trigger('init', [_]);
	        }
	
	        if (_.options.accessibility === true) {
	            _.initADA();
	        }
	
	        if ( _.options.autoplay ) {
	
	            _.paused = false;
	            _.autoPlay();
	
	        }
	
	    };
	
	    Slick.prototype.initADA = function() {
	        var _ = this,
	                numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
	                tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
	                    return (val >= 0) && (val < _.slideCount);
	                });
	
	        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
	            'aria-hidden': 'true',
	            'tabindex': '-1'
	        }).find('a, input, button, select').attr({
	            'tabindex': '-1'
	        });
	
	        if (_.$dots !== null) {
	            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
	                var slideControlIndex = tabControlIndexes.indexOf(i);
	
	                $(this).attr({
	                    'role': 'tabpanel',
	                    'id': 'slick-slide' + _.instanceUid + i,
	                    'tabindex': -1
	                });
	
	                if (slideControlIndex !== -1) {
	                   var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex
	                   if ($('#' + ariaButtonControl).length) {
	                     $(this).attr({
	                         'aria-describedby': ariaButtonControl
	                     });
	                   }
	                }
	            });
	
	            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
	                var mappedSlideIndex = tabControlIndexes[i];
	
	                $(this).attr({
	                    'role': 'presentation'
	                });
	
	                $(this).find('button').first().attr({
	                    'role': 'tab',
	                    'id': 'slick-slide-control' + _.instanceUid + i,
	                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
	                    'aria-label': (i + 1) + ' of ' + numDotGroups,
	                    'aria-selected': null,
	                    'tabindex': '-1'
	                });
	
	            }).eq(_.currentSlide).find('button').attr({
	                'aria-selected': 'true',
	                'tabindex': '0'
	            }).end();
	        }
	
	        for (var i=_.currentSlide, max=i+_.options.slidesToShow; i < max; i++) {
	          if (_.options.focusOnChange) {
	            _.$slides.eq(i).attr({'tabindex': '0'});
	          } else {
	            _.$slides.eq(i).removeAttr('tabindex');
	          }
	        }
	
	        _.activateADA();
	
	    };
	
	    Slick.prototype.initArrowEvents = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow
	               .off('click.slick')
	               .on('click.slick', {
	                    message: 'previous'
	               }, _.changeSlide);
	            _.$nextArrow
	               .off('click.slick')
	               .on('click.slick', {
	                    message: 'next'
	               }, _.changeSlide);
	
	            if (_.options.accessibility === true) {
	                _.$prevArrow.on('keydown.slick', _.keyHandler);
	                _.$nextArrow.on('keydown.slick', _.keyHandler);
	            }
	        }
	
	    };
	
	    Slick.prototype.initDotEvents = function() {
	
	        var _ = this;
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	            $('li', _.$dots).on('click.slick', {
	                message: 'index'
	            }, _.changeSlide);
	
	            if (_.options.accessibility === true) {
	                _.$dots.on('keydown.slick', _.keyHandler);
	            }
	        }
	
	        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {
	
	            $('li', _.$dots)
	                .on('mouseenter.slick', $.proxy(_.interrupt, _, true))
	                .on('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	        }
	
	    };
	
	    Slick.prototype.initSlideEvents = function() {
	
	        var _ = this;
	
	        if ( _.options.pauseOnHover ) {
	
	            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
	            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
	
	        }
	
	    };
	
	    Slick.prototype.initializeEvents = function() {
	
	        var _ = this;
	
	        _.initArrowEvents();
	
	        _.initDotEvents();
	        _.initSlideEvents();
	
	        _.$list.on('touchstart.slick mousedown.slick', {
	            action: 'start'
	        }, _.swipeHandler);
	        _.$list.on('touchmove.slick mousemove.slick', {
	            action: 'move'
	        }, _.swipeHandler);
	        _.$list.on('touchend.slick mouseup.slick', {
	            action: 'end'
	        }, _.swipeHandler);
	        _.$list.on('touchcancel.slick mouseleave.slick', {
	            action: 'end'
	        }, _.swipeHandler);
	
	        _.$list.on('click.slick', _.clickHandler);
	
	        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
	
	        if (_.options.accessibility === true) {
	            _.$list.on('keydown.slick', _.keyHandler);
	        }
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }
	
	        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
	
	        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
	
	        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
	
	        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
	        $(_.setPosition);
	
	    };
	
	    Slick.prototype.initUI = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$prevArrow.show();
	            _.$nextArrow.show();
	
	        }
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$dots.show();
	
	        }
	
	    };
	
	    Slick.prototype.keyHandler = function(event) {
	
	        var _ = this;
	         //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	        if(!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	            if (event.keyCode === 37 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'next' :  'previous'
	                    }
	                });
	            } else if (event.keyCode === 39 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'previous' : 'next'
	                    }
	                });
	            }
	        }
	
	    };
	
	    Slick.prototype.lazyLoad = function() {
	
	        var _ = this,
	            loadRange, cloneRange, rangeStart, rangeEnd;
	
	        function loadImages(imagesScope) {
	
	            $('img[data-lazy]', imagesScope).each(function() {
	
	                var image = $(this),
	                    imageSource = $(this).attr('data-lazy'),
	                    imageSrcSet = $(this).attr('data-srcset'),
	                    imageSizes  = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
	                    imageToLoad = document.createElement('img');
	
	                imageToLoad.onload = function() {
	
	                    image
	                        .animate({ opacity: 0 }, 100, function() {
	
	                            if (imageSrcSet) {
	                                image
	                                    .attr('srcset', imageSrcSet );
	
	                                if (imageSizes) {
	                                    image
	                                        .attr('sizes', imageSizes );
	                                }
	                            }
	
	                            image
	                                .attr('src', imageSource)
	                                .animate({ opacity: 1 }, 200, function() {
	                                    image
	                                        .removeAttr('data-lazy data-srcset data-sizes')
	                                        .removeClass('slick-loading');
	                                });
	                            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
	                        });
	
	                };
	
	                imageToLoad.onerror = function() {
	
	                    image
	                        .removeAttr( 'data-lazy' )
	                        .removeClass( 'slick-loading' )
	                        .addClass( 'slick-lazyload-error' );
	
	                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);
	
	                };
	
	                imageToLoad.src = imageSource;
	
	            });
	
	        }
	
	        if (_.options.centerMode === true) {
	            if (_.options.infinite === true) {
	                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
	                rangeEnd = rangeStart + _.options.slidesToShow + 2;
	            } else {
	                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
	                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
	            }
	        } else {
	            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
	            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
	            if (_.options.fade === true) {
	                if (rangeStart > 0) rangeStart--;
	                if (rangeEnd <= _.slideCount) rangeEnd++;
	            }
	        }
	
	        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
	
	        if (_.options.lazyLoad === 'anticipated') {
	            var prevSlide = rangeStart - 1,
	                nextSlide = rangeEnd,
	                $slides = _.$slider.find('.slick-slide');
	
	            for (var i = 0; i < _.options.slidesToScroll; i++) {
	                if (prevSlide < 0) prevSlide = _.slideCount - 1;
	                loadRange = loadRange.add($slides.eq(prevSlide));
	                loadRange = loadRange.add($slides.eq(nextSlide));
	                prevSlide--;
	                nextSlide++;
	            }
	        }
	
	        loadImages(loadRange);
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-slide');
	            loadImages(cloneRange);
	        } else
	        if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
	            loadImages(cloneRange);
	        } else if (_.currentSlide === 0) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
	            loadImages(cloneRange);
	        }
	
	    };
	
	    Slick.prototype.loadSlider = function() {
	
	        var _ = this;
	
	        _.setPosition();
	
	        _.$slideTrack.css({
	            opacity: 1
	        });
	
	        _.$slider.removeClass('slick-loading');
	
	        _.initUI();
	
	        if (_.options.lazyLoad === 'progressive') {
	            _.progressiveLazyLoad();
	        }
	
	    };
	
	    Slick.prototype.next = Slick.prototype.slickNext = function() {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'next'
	            }
	        });
	
	    };
	
	    Slick.prototype.orientationChange = function() {
	
	        var _ = this;
	
	        _.checkResponsive();
	        _.setPosition();
	
	    };
	
	    Slick.prototype.pause = Slick.prototype.slickPause = function() {
	
	        var _ = this;
	
	        _.autoPlayClear();
	        _.paused = true;
	
	    };
	
	    Slick.prototype.play = Slick.prototype.slickPlay = function() {
	
	        var _ = this;
	
	        _.autoPlay();
	        _.options.autoplay = true;
	        _.paused = false;
	        _.focussed = false;
	        _.interrupted = false;
	
	    };
	
	    Slick.prototype.postSlide = function(index) {
	
	        var _ = this;
	
	        if( !_.unslicked ) {
	
	            _.$slider.trigger('afterChange', [_, index]);
	
	            _.animating = false;
	
	            if (_.slideCount > _.options.slidesToShow) {
	                _.setPosition();
	            }
	
	            _.swipeLeft = null;
	
	            if ( _.options.autoplay ) {
	                _.autoPlay();
	            }
	
	            if (_.options.accessibility === true) {
	                _.initADA();
	
	                if (_.options.focusOnChange) {
	                    var $currentSlide = $(_.$slides.get(_.currentSlide));
	                    $currentSlide.attr('tabindex', 0).focus();
	                }
	            }
	
	        }
	
	    };
	
	    Slick.prototype.prev = Slick.prototype.slickPrev = function() {
	
	        var _ = this;
	
	        _.changeSlide({
	            data: {
	                message: 'previous'
	            }
	        });
	
	    };
	
	    Slick.prototype.preventDefault = function(event) {
	
	        event.preventDefault();
	
	    };
	
	    Slick.prototype.progressiveLazyLoad = function( tryCount ) {
	
	        tryCount = tryCount || 1;
	
	        var _ = this,
	            $imgsToLoad = $( 'img[data-lazy]', _.$slider ),
	            image,
	            imageSource,
	            imageSrcSet,
	            imageSizes,
	            imageToLoad;
	
	        if ( $imgsToLoad.length ) {
	
	            image = $imgsToLoad.first();
	            imageSource = image.attr('data-lazy');
	            imageSrcSet = image.attr('data-srcset');
	            imageSizes  = image.attr('data-sizes') || _.$slider.attr('data-sizes');
	            imageToLoad = document.createElement('img');
	
	            imageToLoad.onload = function() {
	
	                if (imageSrcSet) {
	                    image
	                        .attr('srcset', imageSrcSet );
	
	                    if (imageSizes) {
	                        image
	                            .attr('sizes', imageSizes );
	                    }
	                }
	
	                image
	                    .attr( 'src', imageSource )
	                    .removeAttr('data-lazy data-srcset data-sizes')
	                    .removeClass('slick-loading');
	
	                if ( _.options.adaptiveHeight === true ) {
	                    _.setPosition();
	                }
	
	                _.$slider.trigger('lazyLoaded', [ _, image, imageSource ]);
	                _.progressiveLazyLoad();
	
	            };
	
	            imageToLoad.onerror = function() {
	
	                if ( tryCount < 3 ) {
	
	                    /**
	                     * try to load the image 3 times,
	                     * leave a slight delay so we don't get
	                     * servers blocking the request.
	                     */
	                    setTimeout( function() {
	                        _.progressiveLazyLoad( tryCount + 1 );
	                    }, 500 );
	
	                } else {
	
	                    image
	                        .removeAttr( 'data-lazy' )
	                        .removeClass( 'slick-loading' )
	                        .addClass( 'slick-lazyload-error' );
	
	                    _.$slider.trigger('lazyLoadError', [ _, image, imageSource ]);
	
	                    _.progressiveLazyLoad();
	
	                }
	
	            };
	
	            imageToLoad.src = imageSource;
	
	        } else {
	
	            _.$slider.trigger('allImagesLoaded', [ _ ]);
	
	        }
	
	    };
	
	    Slick.prototype.refresh = function( initializing ) {
	
	        var _ = this, currentSlide, lastVisibleIndex;
	
	        lastVisibleIndex = _.slideCount - _.options.slidesToShow;
	
	        // in non-infinite sliders, we don't want to go past the
	        // last visible index.
	        if( !_.options.infinite && ( _.currentSlide > lastVisibleIndex )) {
	            _.currentSlide = lastVisibleIndex;
	        }
	
	        // if less slides than to show, go to start.
	        if ( _.slideCount <= _.options.slidesToShow ) {
	            _.currentSlide = 0;
	
	        }
	
	        currentSlide = _.currentSlide;
	
	        _.destroy(true);
	
	        $.extend(_, _.initials, { currentSlide: currentSlide });
	
	        _.init();
	
	        if( !initializing ) {
	
	            _.changeSlide({
	                data: {
	                    message: 'index',
	                    index: currentSlide
	                }
	            }, false);
	
	        }
	
	    };
	
	    Slick.prototype.registerBreakpoints = function() {
	
	        var _ = this, breakpoint, currentBreakpoint, l,
	            responsiveSettings = _.options.responsive || null;
	
	        if ( $.type(responsiveSettings) === 'array' && responsiveSettings.length ) {
	
	            _.respondTo = _.options.respondTo || 'window';
	
	            for ( breakpoint in responsiveSettings ) {
	
	                l = _.breakpoints.length-1;
	
	                if (responsiveSettings.hasOwnProperty(breakpoint)) {
	                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;
	
	                    // loop through the breakpoints and cut out any existing
	                    // ones with the same breakpoint number, we don't want dupes.
	                    while( l >= 0 ) {
	                        if( _.breakpoints[l] && _.breakpoints[l] === currentBreakpoint ) {
	                            _.breakpoints.splice(l,1);
	                        }
	                        l--;
	                    }
	
	                    _.breakpoints.push(currentBreakpoint);
	                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
	
	                }
	
	            }
	
	            _.breakpoints.sort(function(a, b) {
	                return ( _.options.mobileFirst ) ? a-b : b-a;
	            });
	
	        }
	
	    };
	
	    Slick.prototype.reinit = function() {
	
	        var _ = this;
	
	        _.$slides =
	            _.$slideTrack
	                .children(_.options.slide)
	                .addClass('slick-slide');
	
	        _.slideCount = _.$slides.length;
	
	        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
	            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
	        }
	
	        if (_.slideCount <= _.options.slidesToShow) {
	            _.currentSlide = 0;
	        }
	
	        _.registerBreakpoints();
	
	        _.setProps();
	        _.setupInfinite();
	        _.buildArrows();
	        _.updateArrows();
	        _.initArrowEvents();
	        _.buildDots();
	        _.updateDots();
	        _.initDotEvents();
	        _.cleanUpSlideEvents();
	        _.initSlideEvents();
	
	        _.checkResponsive(false, true);
	
	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }
	
	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
	
	        _.setPosition();
	        _.focusHandler();
	
	        _.paused = !_.options.autoplay;
	        _.autoPlay();
	
	        _.$slider.trigger('reInit', [_]);
	
	    };
	
	    Slick.prototype.resize = function() {
	
	        var _ = this;
	
	        if ($(window).width() !== _.windowWidth) {
	            clearTimeout(_.windowDelay);
	            _.windowDelay = window.setTimeout(function() {
	                _.windowWidth = $(window).width();
	                _.checkResponsive();
	                if( !_.unslicked ) { _.setPosition(); }
	            }, 50);
	        }
	    };
	
	    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {
	
	        var _ = this;
	
	        if (typeof(index) === 'boolean') {
	            removeBefore = index;
	            index = removeBefore === true ? 0 : _.slideCount - 1;
	        } else {
	            index = removeBefore === true ? --index : index;
	        }
	
	        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
	            return false;
	        }
	
	        _.unload();
	
	        if (removeAll === true) {
	            _.$slideTrack.children().remove();
	        } else {
	            _.$slideTrack.children(this.options.slide).eq(index).remove();
	        }
	
	        _.$slides = _.$slideTrack.children(this.options.slide);
	
	        _.$slideTrack.children(this.options.slide).detach();
	
	        _.$slideTrack.append(_.$slides);
	
	        _.$slidesCache = _.$slides;
	
	        _.reinit();
	
	    };
	
	    Slick.prototype.setCSS = function(position) {
	
	        var _ = this,
	            positionProps = {},
	            x, y;
	
	        if (_.options.rtl === true) {
	            position = -position;
	        }
	        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
	        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
	
	        positionProps[_.positionProp] = position;
	
	        if (_.transformsEnabled === false) {
	            _.$slideTrack.css(positionProps);
	        } else {
	            positionProps = {};
	            if (_.cssTransitions === false) {
	                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
	                _.$slideTrack.css(positionProps);
	            } else {
	                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
	                _.$slideTrack.css(positionProps);
	            }
	        }
	
	    };
	
	    Slick.prototype.setDimensions = function() {
	
	        var _ = this;
	
	        if (_.options.vertical === false) {
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: ('0px ' + _.options.centerPadding)
	                });
	            }
	        } else {
	            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: (_.options.centerPadding + ' 0px')
	                });
	            }
	        }
	
	        _.listWidth = _.$list.width();
	        _.listHeight = _.$list.height();
	
	
	        if (_.options.vertical === false && _.options.variableWidth === false) {
	            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
	            _.$slideTrack.width(Math.ceil((_.slideWidth * _.$slideTrack.children('.slick-slide').length)));
	
	        } else if (_.options.variableWidth === true) {
	            _.$slideTrack.width(5000 * _.slideCount);
	        } else {
	            _.slideWidth = Math.ceil(_.listWidth);
	            _.$slideTrack.height(Math.ceil((_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length)));
	        }
	
	        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
	        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
	
	    };
	
	    Slick.prototype.setFade = function() {
	
	        var _ = this,
	            targetLeft;
	
	        _.$slides.each(function(index, element) {
	            targetLeft = (_.slideWidth * index) * -1;
	            if (_.options.rtl === true) {
	                $(element).css({
	                    position: 'relative',
	                    right: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            } else {
	                $(element).css({
	                    position: 'relative',
	                    left: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            }
	        });
	
	        _.$slides.eq(_.currentSlide).css({
	            zIndex: _.options.zIndex - 1,
	            opacity: 1
	        });
	
	    };
	
	    Slick.prototype.setHeight = function() {
	
	        var _ = this;
	
	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.css('height', targetHeight);
	        }
	
	    };
	
	    Slick.prototype.setOption =
	    Slick.prototype.slickSetOption = function() {
	
	        /**
	         * accepts arguments in format of:
	         *
	         *  - for changing a single option's value:
	         *     .slick("setOption", option, value, refresh )
	         *
	         *  - for changing a set of responsive options:
	         *     .slick("setOption", 'responsive', [{}, ...], refresh )
	         *
	         *  - for updating multiple values at once (not responsive)
	         *     .slick("setOption", { 'option': value, ... }, refresh )
	         */
	
	        var _ = this, l, item, option, value, refresh = false, type;
	
	        if( $.type( arguments[0] ) === 'object' ) {
	
	            option =  arguments[0];
	            refresh = arguments[1];
	            type = 'multiple';
	
	        } else if ( $.type( arguments[0] ) === 'string' ) {
	
	            option =  arguments[0];
	            value = arguments[1];
	            refresh = arguments[2];
	
	            if ( arguments[0] === 'responsive' && $.type( arguments[1] ) === 'array' ) {
	
	                type = 'responsive';
	
	            } else if ( typeof arguments[1] !== 'undefined' ) {
	
	                type = 'single';
	
	            }
	
	        }
	
	        if ( type === 'single' ) {
	
	            _.options[option] = value;
	
	
	        } else if ( type === 'multiple' ) {
	
	            $.each( option , function( opt, val ) {
	
	                _.options[opt] = val;
	
	            });
	
	
	        } else if ( type === 'responsive' ) {
	
	            for ( item in value ) {
	
	                if( $.type( _.options.responsive ) !== 'array' ) {
	
	                    _.options.responsive = [ value[item] ];
	
	                } else {
	
	                    l = _.options.responsive.length-1;
	
	                    // loop through the responsive object and splice out duplicates.
	                    while( l >= 0 ) {
	
	                        if( _.options.responsive[l].breakpoint === value[item].breakpoint ) {
	
	                            _.options.responsive.splice(l,1);
	
	                        }
	
	                        l--;
	
	                    }
	
	                    _.options.responsive.push( value[item] );
	
	                }
	
	            }
	
	        }
	
	        if ( refresh ) {
	
	            _.unload();
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.setPosition = function() {
	
	        var _ = this;
	
	        _.setDimensions();
	
	        _.setHeight();
	
	        if (_.options.fade === false) {
	            _.setCSS(_.getLeft(_.currentSlide));
	        } else {
	            _.setFade();
	        }
	
	        _.$slider.trigger('setPosition', [_]);
	
	    };
	
	    Slick.prototype.setProps = function() {
	
	        var _ = this,
	            bodyStyle = document.body.style;
	
	        _.positionProp = _.options.vertical === true ? 'top' : 'left';
	
	        if (_.positionProp === 'top') {
	            _.$slider.addClass('slick-vertical');
	        } else {
	            _.$slider.removeClass('slick-vertical');
	        }
	
	        if (bodyStyle.WebkitTransition !== undefined ||
	            bodyStyle.MozTransition !== undefined ||
	            bodyStyle.msTransition !== undefined) {
	            if (_.options.useCSS === true) {
	                _.cssTransitions = true;
	            }
	        }
	
	        if ( _.options.fade ) {
	            if ( typeof _.options.zIndex === 'number' ) {
	                if( _.options.zIndex < 3 ) {
	                    _.options.zIndex = 3;
	                }
	            } else {
	                _.options.zIndex = _.defaults.zIndex;
	            }
	        }
	
	        if (bodyStyle.OTransform !== undefined) {
	            _.animType = 'OTransform';
	            _.transformType = '-o-transform';
	            _.transitionType = 'OTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.MozTransform !== undefined) {
	            _.animType = 'MozTransform';
	            _.transformType = '-moz-transform';
	            _.transitionType = 'MozTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.webkitTransform !== undefined) {
	            _.animType = 'webkitTransform';
	            _.transformType = '-webkit-transform';
	            _.transitionType = 'webkitTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.msTransform !== undefined) {
	            _.animType = 'msTransform';
	            _.transformType = '-ms-transform';
	            _.transitionType = 'msTransition';
	            if (bodyStyle.msTransform === undefined) _.animType = false;
	        }
	        if (bodyStyle.transform !== undefined && _.animType !== false) {
	            _.animType = 'transform';
	            _.transformType = 'transform';
	            _.transitionType = 'transition';
	        }
	        _.transformsEnabled = _.options.useTransform && (_.animType !== null && _.animType !== false);
	    };
	
	
	    Slick.prototype.setSlideClasses = function(index) {
	
	        var _ = this,
	            centerOffset, allSlides, indexOffset, remainder;
	
	        allSlides = _.$slider
	            .find('.slick-slide')
	            .removeClass('slick-active slick-center slick-current')
	            .attr('aria-hidden', 'true');
	
	        _.$slides
	            .eq(index)
	            .addClass('slick-current');
	
	        if (_.options.centerMode === true) {
	
	            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
	
	            centerOffset = Math.floor(_.options.slidesToShow / 2);
	
	            if (_.options.infinite === true) {
	
	                if (index >= centerOffset && index <= (_.slideCount - 1) - centerOffset) {
	                    _.$slides
	                        .slice(index - centerOffset + evenCoef, index + centerOffset + 1)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                } else {
	
	                    indexOffset = _.options.slidesToShow + index;
	                    allSlides
	                        .slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                }
	
	                if (index === 0) {
	
	                    allSlides
	                        .eq(allSlides.length - 1 - _.options.slidesToShow)
	                        .addClass('slick-center');
	
	                } else if (index === _.slideCount - 1) {
	
	                    allSlides
	                        .eq(_.options.slidesToShow)
	                        .addClass('slick-center');
	
	                }
	
	            }
	
	            _.$slides
	                .eq(index)
	                .addClass('slick-center');
	
	        } else {
	
	            if (index >= 0 && index <= (_.slideCount - _.options.slidesToShow)) {
	
	                _.$slides
	                    .slice(index, index + _.options.slidesToShow)
	                    .addClass('slick-active')
	                    .attr('aria-hidden', 'false');
	
	            } else if (allSlides.length <= _.options.slidesToShow) {
	
	                allSlides
	                    .addClass('slick-active')
	                    .attr('aria-hidden', 'false');
	
	            } else {
	
	                remainder = _.slideCount % _.options.slidesToShow;
	                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
	
	                if (_.options.slidesToShow == _.options.slidesToScroll && (_.slideCount - index) < _.options.slidesToShow) {
	
	                    allSlides
	                        .slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                } else {
	
	                    allSlides
	                        .slice(indexOffset, indexOffset + _.options.slidesToShow)
	                        .addClass('slick-active')
	                        .attr('aria-hidden', 'false');
	
	                }
	
	            }
	
	        }
	
	        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
	            _.lazyLoad();
	        }
	    };
	
	    Slick.prototype.setupInfinite = function() {
	
	        var _ = this,
	            i, slideIndex, infiniteCount;
	
	        if (_.options.fade === true) {
	            _.options.centerMode = false;
	        }
	
	        if (_.options.infinite === true && _.options.fade === false) {
	
	            slideIndex = null;
	
	            if (_.slideCount > _.options.slidesToShow) {
	
	                if (_.options.centerMode === true) {
	                    infiniteCount = _.options.slidesToShow + 1;
	                } else {
	                    infiniteCount = _.options.slidesToShow;
	                }
	
	                for (i = _.slideCount; i > (_.slideCount -
	                        infiniteCount); i -= 1) {
	                    slideIndex = i - 1;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
	                        .attr('data-slick-index', slideIndex - _.slideCount)
	                        .prependTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                for (i = 0; i < infiniteCount  + _.slideCount; i += 1) {
	                    slideIndex = i;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '')
	                        .attr('data-slick-index', slideIndex + _.slideCount)
	                        .appendTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
	                    $(this).attr('id', '');
	                });
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.interrupt = function( toggle ) {
	
	        var _ = this;
	
	        if( !toggle ) {
	            _.autoPlay();
	        }
	        _.interrupted = toggle;
	
	    };
	
	    Slick.prototype.selectHandler = function(event) {
	
	        var _ = this;
	
	        var targetElement =
	            $(event.target).is('.slick-slide') ?
	                $(event.target) :
	                $(event.target).parents('.slick-slide');
	
	        var index = parseInt(targetElement.attr('data-slick-index'));
	
	        if (!index) index = 0;
	
	        if (_.slideCount <= _.options.slidesToShow) {
	
	            _.slideHandler(index, false, true);
	            return;
	
	        }
	
	        _.slideHandler(index);
	
	    };
	
	    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {
	
	        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null,
	            _ = this, navTarget;
	
	        sync = sync || false;
	
	        if (_.animating === true && _.options.waitForAnimate === true) {
	            return;
	        }
	
	        if (_.options.fade === true && _.currentSlide === index) {
	            return;
	        }
	
	        if (sync === false) {
	            _.asNavFor(index);
	        }
	
	        targetSlide = index;
	        targetLeft = _.getLeft(targetSlide);
	        slideLeft = _.getLeft(_.currentSlide);
	
	        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
	
	        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	                    _.animateSlide(slideLeft, function() {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > (_.slideCount - _.options.slidesToScroll))) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	                    _.animateSlide(slideLeft, function() {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        }
	
	        if ( _.options.autoplay ) {
	            clearInterval(_.autoPlayTimer);
	        }
	
	        if (targetSlide < 0) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = _.slideCount - (_.slideCount % _.options.slidesToScroll);
	            } else {
	                animSlide = _.slideCount + targetSlide;
	            }
	        } else if (targetSlide >= _.slideCount) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = 0;
	            } else {
	                animSlide = targetSlide - _.slideCount;
	            }
	        } else {
	            animSlide = targetSlide;
	        }
	
	        _.animating = true;
	
	        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);
	
	        oldSlide = _.currentSlide;
	        _.currentSlide = animSlide;
	
	        _.setSlideClasses(_.currentSlide);
	
	        if ( _.options.asNavFor ) {
	
	            navTarget = _.getNavTarget();
	            navTarget = navTarget.slick('getSlick');
	
	            if ( navTarget.slideCount <= navTarget.options.slidesToShow ) {
	                navTarget.setSlideClasses(_.currentSlide);
	            }
	
	        }
	
	        _.updateDots();
	        _.updateArrows();
	
	        if (_.options.fade === true) {
	            if (dontAnimate !== true) {
	
	                _.fadeSlideOut(oldSlide);
	
	                _.fadeSlide(animSlide, function() {
	                    _.postSlide(animSlide);
	                });
	
	            } else {
	                _.postSlide(animSlide);
	            }
	            _.animateHeight();
	            return;
	        }
	
	        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	            _.animateSlide(targetLeft, function() {
	                _.postSlide(animSlide);
	            });
	        } else {
	            _.postSlide(animSlide);
	        }
	
	    };
	
	    Slick.prototype.startLoad = function() {
	
	        var _ = this;
	
	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$prevArrow.hide();
	            _.$nextArrow.hide();
	
	        }
	
	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	
	            _.$dots.hide();
	
	        }
	
	        _.$slider.addClass('slick-loading');
	
	    };
	
	    Slick.prototype.swipeDirection = function() {
	
	        var xDist, yDist, r, swipeAngle, _ = this;
	
	        xDist = _.touchObject.startX - _.touchObject.curX;
	        yDist = _.touchObject.startY - _.touchObject.curY;
	        r = Math.atan2(yDist, xDist);
	
	        swipeAngle = Math.round(r * 180 / Math.PI);
	        if (swipeAngle < 0) {
	            swipeAngle = 360 - Math.abs(swipeAngle);
	        }
	
	        if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
	            return (_.options.rtl === false ? 'left' : 'right');
	        }
	        if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
	            return (_.options.rtl === false ? 'left' : 'right');
	        }
	        if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
	            return (_.options.rtl === false ? 'right' : 'left');
	        }
	        if (_.options.verticalSwiping === true) {
	            if ((swipeAngle >= 35) && (swipeAngle <= 135)) {
	                return 'down';
	            } else {
	                return 'up';
	            }
	        }
	
	        return 'vertical';
	
	    };
	
	    Slick.prototype.swipeEnd = function(event) {
	
	        var _ = this,
	            slideCount,
	            direction;
	
	        _.dragging = false;
	        _.swiping = false;
	
	        if (_.scrolling) {
	            _.scrolling = false;
	            return false;
	        }
	
	        _.interrupted = false;
	        _.shouldClick = ( _.touchObject.swipeLength > 10 ) ? false : true;
	
	        if ( _.touchObject.curX === undefined ) {
	            return false;
	        }
	
	        if ( _.touchObject.edgeHit === true ) {
	            _.$slider.trigger('edge', [_, _.swipeDirection() ]);
	        }
	
	        if ( _.touchObject.swipeLength >= _.touchObject.minSwipe ) {
	
	            direction = _.swipeDirection();
	
	            switch ( direction ) {
	
	                case 'left':
	                case 'down':
	
	                    slideCount =
	                        _.options.swipeToSlide ?
	                            _.checkNavigable( _.currentSlide + _.getSlideCount() ) :
	                            _.currentSlide + _.getSlideCount();
	
	                    _.currentDirection = 0;
	
	                    break;
	
	                case 'right':
	                case 'up':
	
	                    slideCount =
	                        _.options.swipeToSlide ?
	                            _.checkNavigable( _.currentSlide - _.getSlideCount() ) :
	                            _.currentSlide - _.getSlideCount();
	
	                    _.currentDirection = 1;
	
	                    break;
	
	                default:
	
	
	            }
	
	            if( direction != 'vertical' ) {
	
	                _.slideHandler( slideCount );
	                _.touchObject = {};
	                _.$slider.trigger('swipe', [_, direction ]);
	
	            }
	
	        } else {
	
	            if ( _.touchObject.startX !== _.touchObject.curX ) {
	
	                _.slideHandler( _.currentSlide );
	                _.touchObject = {};
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.swipeHandler = function(event) {
	
	        var _ = this;
	
	        if ((_.options.swipe === false) || ('ontouchend' in document && _.options.swipe === false)) {
	            return;
	        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
	            return;
	        }
	
	        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ?
	            event.originalEvent.touches.length : 1;
	
	        _.touchObject.minSwipe = _.listWidth / _.options
	            .touchThreshold;
	
	        if (_.options.verticalSwiping === true) {
	            _.touchObject.minSwipe = _.listHeight / _.options
	                .touchThreshold;
	        }
	
	        switch (event.data.action) {
	
	            case 'start':
	                _.swipeStart(event);
	                break;
	
	            case 'move':
	                _.swipeMove(event);
	                break;
	
	            case 'end':
	                _.swipeEnd(event);
	                break;
	
	        }
	
	    };
	
	    Slick.prototype.swipeMove = function(event) {
	
	        var _ = this,
	            edgeWasHit = false,
	            curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;
	
	        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
	
	        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
	            return false;
	        }
	
	        curLeft = _.getLeft(_.currentSlide);
	
	        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
	        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
	
	        _.touchObject.swipeLength = Math.round(Math.sqrt(
	            Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
	
	        verticalSwipeLength = Math.round(Math.sqrt(
	            Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
	
	        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
	            _.scrolling = true;
	            return false;
	        }
	
	        if (_.options.verticalSwiping === true) {
	            _.touchObject.swipeLength = verticalSwipeLength;
	        }
	
	        swipeDirection = _.swipeDirection();
	
	        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
	            _.swiping = true;
	            event.preventDefault();
	        }
	
	        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
	        if (_.options.verticalSwiping === true) {
	            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
	        }
	
	
	        swipeLength = _.touchObject.swipeLength;
	
	        _.touchObject.edgeHit = false;
	
	        if (_.options.infinite === false) {
	            if ((_.currentSlide === 0 && swipeDirection === 'right') || (_.currentSlide >= _.getDotCount() && swipeDirection === 'left')) {
	                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
	                _.touchObject.edgeHit = true;
	            }
	        }
	
	        if (_.options.vertical === false) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        } else {
	            _.swipeLeft = curLeft + (swipeLength * (_.$list.height() / _.listWidth)) * positionOffset;
	        }
	        if (_.options.verticalSwiping === true) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        }
	
	        if (_.options.fade === true || _.options.touchMove === false) {
	            return false;
	        }
	
	        if (_.animating === true) {
	            _.swipeLeft = null;
	            return false;
	        }
	
	        _.setCSS(_.swipeLeft);
	
	    };
	
	    Slick.prototype.swipeStart = function(event) {
	
	        var _ = this,
	            touches;
	
	        _.interrupted = true;
	
	        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
	            _.touchObject = {};
	            return false;
	        }
	
	        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
	            touches = event.originalEvent.touches[0];
	        }
	
	        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
	        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
	
	        _.dragging = true;
	
	    };
	
	    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {
	
	        var _ = this;
	
	        if (_.$slidesCache !== null) {
	
	            _.unload();
	
	            _.$slideTrack.children(this.options.slide).detach();
	
	            _.$slidesCache.appendTo(_.$slideTrack);
	
	            _.reinit();
	
	        }
	
	    };
	
	    Slick.prototype.unload = function() {
	
	        var _ = this;
	
	        $('.slick-cloned', _.$slider).remove();
	
	        if (_.$dots) {
	            _.$dots.remove();
	        }
	
	        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
	            _.$prevArrow.remove();
	        }
	
	        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
	            _.$nextArrow.remove();
	        }
	
	        _.$slides
	            .removeClass('slick-slide slick-active slick-visible slick-current')
	            .attr('aria-hidden', 'true')
	            .css('width', '');
	
	    };
	
	    Slick.prototype.unslick = function(fromBreakpoint) {
	
	        var _ = this;
	        _.$slider.trigger('unslick', [_, fromBreakpoint]);
	        _.destroy();
	
	    };
	
	    Slick.prototype.updateArrows = function() {
	
	        var _ = this,
	            centerOffset;
	
	        centerOffset = Math.floor(_.options.slidesToShow / 2);
	
	        if ( _.options.arrows === true &&
	            _.slideCount > _.options.slidesToShow &&
	            !_.options.infinite ) {
	
	            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            if (_.currentSlide === 0) {
	
	                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
	
	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
	
	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	
	            }
	
	        }
	
	    };
	
	    Slick.prototype.updateDots = function() {
	
	        var _ = this;
	
	        if (_.$dots !== null) {
	
	            _.$dots
	                .find('li')
	                    .removeClass('slick-active')
	                    .end();
	
	            _.$dots
	                .find('li')
	                .eq(Math.floor(_.currentSlide / _.options.slidesToScroll))
	                .addClass('slick-active');
	
	        }
	
	    };
	
	    Slick.prototype.visibility = function() {
	
	        var _ = this;
	
	        if ( _.options.autoplay ) {
	
	            if ( document[_.hidden] ) {
	
	                _.interrupted = true;
	
	            } else {
	
	                _.interrupted = false;
	
	            }
	
	        }
	
	    };
	
	    $.fn.slick = function() {
	        var _ = this,
	            opt = arguments[0],
	            args = Array.prototype.slice.call(arguments, 1),
	            l = _.length,
	            i,
	            ret;
	        for (i = 0; i < l; i++) {
	            if (typeof opt == 'object' || typeof opt == 'undefined')
	                _[i].slick = new Slick(_[i], opt);
	            else
	                ret = _[i].slick[opt].apply(_[i].slick, args);
	            if (typeof ret != 'undefined') return ret;
	        }
	        return _;
	    };
	
	}));


/***/ }),
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultPreventedPreservedOnDispatch = exports.closest = exports.matches = exports.findOne = exports.find = exports.createCustomEvent = undefined;
	
	var _util = __webpack_require__(22);
	
	var _Element$prototype = Element.prototype,
	    matches = _Element$prototype.matches,
	    closest = _Element$prototype.closest; /* istanbul ignore file */
	
	/**
	 * --------------------------------------------------------------------------
	 * Bootstrap (v4.3.1): dom/polyfill.js
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * --------------------------------------------------------------------------
	 */
	
	var find = Element.prototype.querySelectorAll;
	var findOne = Element.prototype.querySelector;
	var createCustomEvent = function createCustomEvent(eventName, params) {
	  var cEvent = new CustomEvent(eventName, params);
	
	  return cEvent;
	};
	
	if (typeof window.CustomEvent !== 'function') {
	  exports.createCustomEvent = createCustomEvent = function createCustomEvent(eventName, params) {
	    params = params || { bubbles: false, cancelable: false, detail: null };
	
	    var evt = document.createEvent('CustomEvent');
	
	    evt.initCustomEvent(eventName, params.bubbles, params.cancelable, params.detail);
	    return evt;
	  };
	}
	
	var workingDefaultPrevented = function () {
	  var e = document.createEvent('CustomEvent');
	
	  e.initEvent('Bootstrap', true, true);
	  e.preventDefault();
	  return e.defaultPrevented;
	}();
	
	if (!workingDefaultPrevented) {
	  var origPreventDefault = Event.prototype.preventDefault;
	
	  Event.prototype.preventDefault = function () {
	    if (!this.cancelable) {
	      return;
	    }
	
	    origPreventDefault.call(this);
	    Object.defineProperty(this, 'defaultPrevented', {
	      get: function get() {
	        return true;
	      },
	
	      configurable: true
	    });
	  };
	}
	
	// MSEdge resets defaultPrevented flag upon dispatchEvent call if at least one listener is attached
	var defaultPreventedPreservedOnDispatch = function () {
	  var e = createCustomEvent('Bootstrap', {
	    cancelable: true
	  });
	
	  var element = document.createElement('div');
	  element.addEventListener('Bootstrap', function () {
	    return null;
	  });
	
	  e.preventDefault();
	  element.dispatchEvent(e);
	  return e.defaultPrevented;
	}();
	
	if (!matches) {
	  exports.matches = matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	}
	
	if (!closest) {
	  exports.closest = closest = function closest(selector) {
	    var element = this;
	
	    do {
	      if (matches.call(element, selector)) {
	        return element;
	      }
	
	      element = element.parentElement || element.parentNode;
	    } while (element !== null && element.nodeType === 1);
	
	    return null;
	  };
	}
	
	var scopeSelectorRegex = /:scope\b/;
	var supportScopeQuery = function () {
	  var element = document.createElement('div');
	
	  try {
	    element.querySelectorAll(':scope *');
	  } catch (error) {
	    return false;
	  }
	
	  return true;
	}();
	
	if (!supportScopeQuery) {
	  exports.find = find = function find(selector) {
	    if (!scopeSelectorRegex.test(selector)) {
	      return this.querySelectorAll(selector);
	    }
	
	    var hasId = Boolean(this.id);
	
	    if (!hasId) {
	      this.id = (0, _util.getUID)('scope');
	    }
	
	    var nodeList = null;
	    try {
	      selector = selector.replace(scopeSelectorRegex, '#' + this.id);
	      nodeList = this.querySelectorAll(selector);
	    } finally {
	      if (!hasId) {
	        this.removeAttribute('id');
	      }
	    }
	
	    return nodeList;
	  };
	
	  exports.findOne = findOne = function findOne(selector) {
	    if (!scopeSelectorRegex.test(selector)) {
	      return this.querySelector(selector);
	    }
	
	    var matches = find.call(this, selector);
	
	    if (typeof matches[0] !== 'undefined') {
	      return matches[0];
	    }
	
	    return null;
	  };
	}
	
	exports.createCustomEvent = createCustomEvent;
	exports.find = find;
	exports.findOne = findOne;
	exports.matches = matches;
	exports.closest = closest;
	exports.defaultPreventedPreservedOnDispatch = defaultPreventedPreservedOnDispatch;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Bootstrap (v4.3.1): tooltip.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _util = __webpack_require__(22);
	
	var _sanitizer = __webpack_require__(516);
	
	var _data = __webpack_require__(34);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _eventHandler = __webpack_require__(41);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _manipulator = __webpack_require__(187);
	
	var _manipulator2 = _interopRequireDefault(_manipulator);
	
	var _popper = __webpack_require__(426);
	
	var _popper2 = _interopRequireDefault(_popper);
	
	var _selectorEngine = __webpack_require__(42);
	
	var _selectorEngine2 = _interopRequireDefault(_selectorEngine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */
	
	var NAME = 'tooltip';
	var VERSION = '4.3.1';
	var DATA_KEY = 'bs.tooltip';
	var EVENT_KEY = '.' + DATA_KEY;
	var CLASS_PREFIX = 'bs-tooltip';
	var BSCLS_PREFIX_REGEX = new RegExp('(^|\\s)' + CLASS_PREFIX + '\\S+', 'g');
	var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn'];
	
	var DefaultType = {
	  animation: 'boolean',
	  template: 'string',
	  title: '(string|element|function)',
	  trigger: 'string',
	  delay: '(number|object)',
	  html: 'boolean',
	  selector: '(string|boolean)',
	  placement: '(string|function)',
	  offset: '(number|string|function)',
	  container: '(string|element|boolean)',
	  fallbackPlacement: '(string|array)',
	  boundary: '(string|element)',
	  sanitize: 'boolean',
	  sanitizeFn: '(null|function)',
	  whiteList: 'object'
	};
	
	var AttachmentMap = {
	  AUTO: 'auto',
	  TOP: 'top',
	  RIGHT: 'right',
	  BOTTOM: 'bottom',
	  LEFT: 'left'
	};
	
	var Default = {
	  animation: true,
	  template: '<div class="tooltip" role="tooltip">' + '<div class="tooltip-arrow"></div>' + '<div class="tooltip-inner"></div></div>',
	  trigger: 'hover focus',
	  title: '',
	  delay: 0,
	  html: false,
	  selector: false,
	  placement: 'top',
	  offset: 0,
	  container: false,
	  fallbackPlacement: 'flip',
	  boundary: 'scrollParent',
	  sanitize: true,
	  sanitizeFn: null,
	  whiteList: _sanitizer.DefaultWhitelist
	};
	
	var HoverState = {
	  SHOW: 'show',
	  OUT: 'out'
	};
	
	var Event = {
	  HIDE: 'hide' + EVENT_KEY,
	  HIDDEN: 'hidden' + EVENT_KEY,
	  SHOW: 'show' + EVENT_KEY,
	  SHOWN: 'shown' + EVENT_KEY,
	  INSERTED: 'inserted' + EVENT_KEY,
	  CLICK: 'click' + EVENT_KEY,
	  FOCUSIN: 'focusin' + EVENT_KEY,
	  FOCUSOUT: 'focusout' + EVENT_KEY,
	  MOUSEENTER: 'mouseenter' + EVENT_KEY,
	  MOUSELEAVE: 'mouseleave' + EVENT_KEY
	};
	
	var ClassName = {
	  FADE: 'fade',
	  SHOW: 'show'
	};
	
	var Selector = {
	  TOOLTIP_INNER: '.tooltip-inner'
	};
	
	var Trigger = {
	  HOVER: 'hover',
	  FOCUS: 'focus',
	  CLICK: 'click',
	  MANUAL: 'manual'
	
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	};
	var Tooltip = function () {
	  function Tooltip(element, config) {
	    _classCallCheck(this, Tooltip);
	
	    /**
	     * Check for Popper dependency
	     * Popper - https://popper.js.org
	     */
	    if (typeof _popper2.default === 'undefined') {
	      throw new TypeError('Bootstrap\'s tooltips require Popper.js (https://popper.js.org)');
	    }
	
	    // private
	    this._isEnabled = true;
	    this._timeout = 0;
	    this._hoverState = '';
	    this._activeTrigger = {};
	    this._popper = null;
	
	    // Protected
	    this.element = element;
	    this.config = this._getConfig(config);
	    this.tip = null;
	
	    this._setListeners();
	    _data2.default.setData(element, this.constructor.DATA_KEY, this);
	  }
	
	  // Getters
	
	  _createClass(Tooltip, [{
	    key: 'enable',
	
	
	    // Public
	
	    value: function enable() {
	      this._isEnabled = true;
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      this._isEnabled = false;
	    }
	  }, {
	    key: 'toggleEnabled',
	    value: function toggleEnabled() {
	      this._isEnabled = !this._isEnabled;
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle(event) {
	      if (!this._isEnabled) {
	        return;
	      }
	
	      if (event) {
	        var dataKey = this.constructor.DATA_KEY;
	        var context = _data2.default.getData(event.delegateTarget, dataKey);
	
	        if (!context) {
	          context = new this.constructor(event.delegateTarget, this._getDelegateConfig());
	          _data2.default.setData(event.delegateTarget, dataKey, context);
	        }
	
	        context._activeTrigger.click = !context._activeTrigger.click;
	
	        if (context._isWithActiveTrigger()) {
	          context._enter(null, context);
	        } else {
	          context._leave(null, context);
	        }
	      } else {
	        if (this.getTipElement().classList.contains(ClassName.SHOW)) {
	          this._leave(null, this);
	          return;
	        }
	
	        this._enter(null, this);
	      }
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      clearTimeout(this._timeout);
	
	      _data2.default.removeData(this.element, this.constructor.DATA_KEY);
	
	      _eventHandler2.default.off(this.element, this.constructor.EVENT_KEY);
	      _eventHandler2.default.off(_selectorEngine2.default.closest(this.element, '.modal'), 'hide.bs.modal', this._hideModalHandler);
	
	      if (this.tip) {
	        this.tip.parentNode.removeChild(this.tip);
	      }
	
	      this._isEnabled = null;
	      this._timeout = null;
	      this._hoverState = null;
	      this._activeTrigger = null;
	      if (this._popper !== null) {
	        this._popper.destroy();
	      }
	
	      this._popper = null;
	      this.element = null;
	      this.config = null;
	      this.tip = null;
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      var _this = this;
	
	      if (this.element.style.display === 'none') {
	        throw new Error('Please use show on visible elements');
	      }
	
	      if (this.isWithContent() && this._isEnabled) {
	        var showEvent = _eventHandler2.default.trigger(this.element, this.constructor.Event.SHOW);
	        var shadowRoot = (0, _util.findShadowRoot)(this.element);
	        var isInTheDom = shadowRoot === null ? this.element.ownerDocument.documentElement.contains(this.element) : shadowRoot.contains(this.element);
	
	        if (showEvent.defaultPrevented || !isInTheDom) {
	          return;
	        }
	
	        var tip = this.getTipElement();
	        var tipId = (0, _util.getUID)(this.constructor.NAME);
	
	        tip.setAttribute('id', tipId);
	        this.element.setAttribute('aria-describedby', tipId);
	
	        this.setContent();
	
	        if (this.config.animation) {
	          tip.classList.add(ClassName.FADE);
	        }
	
	        var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;
	
	        var attachment = this._getAttachment(placement);
	        this.addAttachmentClass(attachment);
	
	        var container = this._getContainer();
	        _data2.default.setData(tip, this.constructor.DATA_KEY, this);
	
	        if (!this.element.ownerDocument.documentElement.contains(this.tip)) {
	          container.appendChild(tip);
	        }
	
	        _eventHandler2.default.trigger(this.element, this.constructor.Event.INSERTED);
	
	        this._popper = new _popper2.default(this.element, tip, {
	          placement: attachment,
	          modifiers: {
	            offset: this._getOffset(),
	            flip: {
	              behavior: this.config.fallbackPlacement
	            },
	            arrow: {
	              element: '.' + this.constructor.NAME + '-arrow'
	            },
	            preventOverflow: {
	              boundariesElement: this.config.boundary
	            }
	          },
	          onCreate: function onCreate(data) {
	            if (data.originalPlacement !== data.placement) {
	              _this._handlePopperPlacementChange(data);
	            }
	          },
	          onUpdate: function onUpdate(data) {
	            return _this._handlePopperPlacementChange(data);
	          }
	        });
	
	        tip.classList.add(ClassName.SHOW);
	
	        // If this is a touch-enabled device we add extra
	        // empty mouseover listeners to the body's immediate children;
	        // only needed because of broken event delegation on iOS
	        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
	        if ('ontouchstart' in document.documentElement) {
	          (0, _util.makeArray)(document.body.children).forEach(function (element) {
	            _eventHandler2.default.on(element, 'mouseover', (0, _util.noop)());
	          });
	        }
	
	        var complete = function complete() {
	          if (_this.config.animation) {
	            _this._fixTransition();
	          }
	
	          var prevHoverState = _this._hoverState;
	          _this._hoverState = null;
	
	          _eventHandler2.default.trigger(_this.element, _this.constructor.Event.SHOWN);
	
	          if (prevHoverState === HoverState.OUT) {
	            _this._leave(null, _this);
	          }
	        };
	
	        if (this.tip.classList.contains(ClassName.FADE)) {
	          var transitionDuration = (0, _util.getTransitionDurationFromElement)(this.tip);
	          _eventHandler2.default.one(this.tip, _util.TRANSITION_END, complete);
	          (0, _util.emulateTransitionEnd)(this.tip, transitionDuration);
	        } else {
	          complete();
	        }
	      }
	    }
	  }, {
	    key: 'hide',
	    value: function hide(callback) {
	      var _this2 = this;
	
	      var tip = this.getTipElement();
	      var complete = function complete() {
	        if (_this2._hoverState !== HoverState.SHOW && tip.parentNode) {
	          tip.parentNode.removeChild(tip);
	        }
	
	        _this2._cleanTipClass();
	        _this2.element.removeAttribute('aria-describedby');
	        _eventHandler2.default.trigger(_this2.element, _this2.constructor.Event.HIDDEN);
	        if (_this2._popper !== null) {
	          _this2._popper.destroy();
	        }
	
	        if (callback) {
	          callback();
	        }
	      };
	
	      var hideEvent = _eventHandler2.default.trigger(this.element, this.constructor.Event.HIDE);
	      if (hideEvent.defaultPrevented) {
	        return;
	      }
	
	      tip.classList.remove(ClassName.SHOW);
	
	      // If this is a touch-enabled device we remove the extra
	      // empty mouseover listeners we added for iOS support
	      if ('ontouchstart' in document.documentElement) {
	        (0, _util.makeArray)(document.body.children).forEach(function (element) {
	          return _eventHandler2.default.off(element, 'mouseover', _util.noop);
	        });
	      }
	
	      this._activeTrigger[Trigger.CLICK] = false;
	      this._activeTrigger[Trigger.FOCUS] = false;
	      this._activeTrigger[Trigger.HOVER] = false;
	
	      if (this.tip.classList.contains(ClassName.FADE)) {
	        var transitionDuration = (0, _util.getTransitionDurationFromElement)(tip);
	
	        _eventHandler2.default.one(tip, _util.TRANSITION_END, complete);
	        (0, _util.emulateTransitionEnd)(tip, transitionDuration);
	      } else {
	        complete();
	      }
	
	      this._hoverState = '';
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      if (this._popper !== null) {
	        this._popper.scheduleUpdate();
	      }
	    }
	
	    // Protected
	
	  }, {
	    key: 'isWithContent',
	    value: function isWithContent() {
	      return Boolean(this.getTitle());
	    }
	  }, {
	    key: 'addAttachmentClass',
	    value: function addAttachmentClass(attachment) {
	      this.getTipElement().classList.add(CLASS_PREFIX + '-' + attachment);
	    }
	  }, {
	    key: 'getTipElement',
	    value: function getTipElement() {
	      if (this.tip) {
	        return this.tip;
	      }
	
	      var element = document.createElement('div');
	      element.innerHTML = this.config.template;
	
	      this.tip = element.children[0];
	      return this.tip;
	    }
	  }, {
	    key: 'setContent',
	    value: function setContent() {
	      var tip = this.getTipElement();
	      this.setElementContent(_selectorEngine2.default.findOne(Selector.TOOLTIP_INNER, tip), this.getTitle());
	      tip.classList.remove(ClassName.FADE);
	      tip.classList.remove(ClassName.SHOW);
	    }
	  }, {
	    key: 'setElementContent',
	    value: function setElementContent(element, content) {
	      if (element === null) {
	        return;
	      }
	
	      if ((typeof content === 'undefined' ? 'undefined' : _typeof(content)) === 'object' && (content.nodeType || content.jquery)) {
	        if (content.jquery) {
	          content = content[0];
	        }
	
	        // content is a DOM node or a jQuery
	        if (this.config.html) {
	          if (content.parentNode !== element) {
	            element.innerHTML = '';
	            element.appendChild(content);
	          }
	        } else {
	          element.innerText = content.textContent;
	        }
	
	        return;
	      }
	
	      if (this.config.html) {
	        if (this.config.sanitize) {
	          content = (0, _sanitizer.sanitizeHtml)(content, this.config.whiteList, this.config.sanitizeFn);
	        }
	
	        element.innerHTML = content;
	      } else {
	        element.innerText = content;
	      }
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      var title = this.element.getAttribute('data-original-title');
	
	      if (!title) {
	        title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
	      }
	
	      return title;
	    }
	
	    // Private
	
	  }, {
	    key: '_getOffset',
	    value: function _getOffset() {
	      var _this3 = this;
	
	      var offset = {};
	
	      if (typeof this.config.offset === 'function') {
	        offset.fn = function (data) {
	          data.offsets = _extends({}, data.offsets, _this3.config.offset(data.offsets, _this3.element) || {});
	
	          return data;
	        };
	      } else {
	        offset.offset = this.config.offset;
	      }
	
	      return offset;
	    }
	  }, {
	    key: '_getContainer',
	    value: function _getContainer() {
	      if (this.config.container === false) {
	        return document.body;
	      }
	
	      if ((0, _util.isElement)(this.config.container)) {
	        return this.config.container;
	      }
	
	      return _selectorEngine2.default.findOne(this.config.container);
	    }
	  }, {
	    key: '_getAttachment',
	    value: function _getAttachment(placement) {
	      return AttachmentMap[placement.toUpperCase()];
	    }
	  }, {
	    key: '_setListeners',
	    value: function _setListeners() {
	      var _this4 = this;
	
	      var triggers = this.config.trigger.split(' ');
	
	      triggers.forEach(function (trigger) {
	        if (trigger === 'click') {
	          _eventHandler2.default.on(_this4.element, _this4.constructor.Event.CLICK, _this4.config.selector, function (event) {
	            return _this4.toggle(event);
	          });
	        } else if (trigger !== Trigger.MANUAL) {
	          var eventIn = trigger === Trigger.HOVER ? _this4.constructor.Event.MOUSEENTER : _this4.constructor.Event.FOCUSIN;
	          var eventOut = trigger === Trigger.HOVER ? _this4.constructor.Event.MOUSELEAVE : _this4.constructor.Event.FOCUSOUT;
	
	          _eventHandler2.default.on(_this4.element, eventIn, _this4.config.selector, function (event) {
	            return _this4._enter(event);
	          });
	          _eventHandler2.default.on(_this4.element, eventOut, _this4.config.selector, function (event) {
	            return _this4._leave(event);
	          });
	        }
	      });
	
	      this._hideModalHandler = function () {
	        if (_this4.element) {
	          _this4.hide();
	        }
	      };
	
	      _eventHandler2.default.on(_selectorEngine2.default.closest(this.element, '.modal'), 'hide.bs.modal', this._hideModalHandler);
	
	      if (this.config.selector) {
	        this.config = _extends({}, this.config, {
	          trigger: 'manual',
	          selector: ''
	        });
	      } else {
	        this._fixTitle();
	      }
	    }
	  }, {
	    key: '_fixTitle',
	    value: function _fixTitle() {
	      var titleType = _typeof(this.element.getAttribute('data-original-title'));
	
	      if (this.element.getAttribute('title') || titleType !== 'string') {
	        this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
	
	        this.element.setAttribute('title', '');
	      }
	    }
	  }, {
	    key: '_enter',
	    value: function _enter(event, context) {
	      var dataKey = this.constructor.DATA_KEY;
	      context = context || _data2.default.getData(event.delegateTarget, dataKey);
	
	      if (!context) {
	        context = new this.constructor(event.delegateTarget, this._getDelegateConfig());
	        _data2.default.setData(event.delegateTarget, dataKey, context);
	      }
	
	      if (event) {
	        context._activeTrigger[event.type === 'focusin' ? Trigger.FOCUS : Trigger.HOVER] = true;
	      }
	
	      if (context.getTipElement().classList.contains(ClassName.SHOW) || context._hoverState === HoverState.SHOW) {
	        context._hoverState = HoverState.SHOW;
	        return;
	      }
	
	      clearTimeout(context._timeout);
	
	      context._hoverState = HoverState.SHOW;
	
	      if (!context.config.delay || !context.config.delay.show) {
	        context.show();
	        return;
	      }
	
	      context._timeout = setTimeout(function () {
	        if (context._hoverState === HoverState.SHOW) {
	          context.show();
	        }
	      }, context.config.delay.show);
	    }
	  }, {
	    key: '_leave',
	    value: function _leave(event, context) {
	      var dataKey = this.constructor.DATA_KEY;
	      context = context || _data2.default.getData(event.delegateTarget, dataKey);
	
	      if (!context) {
	        context = new this.constructor(event.delegateTarget, this._getDelegateConfig());
	        _data2.default.setData(event.delegateTarget, dataKey, context);
	      }
	
	      if (event) {
	        context._activeTrigger[event.type === 'focusout' ? Trigger.FOCUS : Trigger.HOVER] = false;
	      }
	
	      if (context._isWithActiveTrigger()) {
	        return;
	      }
	
	      clearTimeout(context._timeout);
	
	      context._hoverState = HoverState.OUT;
	
	      if (!context.config.delay || !context.config.delay.hide) {
	        context.hide();
	        return;
	      }
	
	      context._timeout = setTimeout(function () {
	        if (context._hoverState === HoverState.OUT) {
	          context.hide();
	        }
	      }, context.config.delay.hide);
	    }
	  }, {
	    key: '_isWithActiveTrigger',
	    value: function _isWithActiveTrigger() {
	      for (var trigger in this._activeTrigger) {
	        if (this._activeTrigger[trigger]) {
	          return true;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: '_getConfig',
	    value: function _getConfig(config) {
	      var dataAttributes = _manipulator2.default.getDataAttributes(this.element);
	
	      Object.keys(dataAttributes).forEach(function (dataAttr) {
	        if (DISALLOWED_ATTRIBUTES.indexOf(dataAttr) !== -1) {
	          delete dataAttributes[dataAttr];
	        }
	      });
	
	      if (config && _typeof(config.container) === 'object' && config.container.jquery) {
	        config.container = config.container[0];
	      }
	
	      config = _extends({}, this.constructor.Default, dataAttributes, (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config ? config : {});
	
	      if (typeof config.delay === 'number') {
	        config.delay = {
	          show: config.delay,
	          hide: config.delay
	        };
	      }
	
	      if (typeof config.title === 'number') {
	        config.title = config.title.toString();
	      }
	
	      if (typeof config.content === 'number') {
	        config.content = config.content.toString();
	      }
	
	      (0, _util.typeCheckConfig)(NAME, config, this.constructor.DefaultType);
	
	      if (config.sanitize) {
	        config.template = (0, _sanitizer.sanitizeHtml)(config.template, config.whiteList, config.sanitizeFn);
	      }
	
	      return config;
	    }
	  }, {
	    key: '_getDelegateConfig',
	    value: function _getDelegateConfig() {
	      var config = {};
	
	      if (this.config) {
	        for (var key in this.config) {
	          if (this.constructor.Default[key] !== this.config[key]) {
	            config[key] = this.config[key];
	          }
	        }
	      }
	
	      return config;
	    }
	  }, {
	    key: '_cleanTipClass',
	    value: function _cleanTipClass() {
	      var tip = this.getTipElement();
	      var tabClass = tip.getAttribute('class').match(BSCLS_PREFIX_REGEX);
	      if (tabClass !== null && tabClass.length) {
	        tabClass.map(function (token) {
	          return token.trim();
	        }).forEach(function (tClass) {
	          return tip.classList.remove(tClass);
	        });
	      }
	    }
	  }, {
	    key: '_handlePopperPlacementChange',
	    value: function _handlePopperPlacementChange(popperData) {
	      var popperInstance = popperData.instance;
	      this.tip = popperInstance.popper;
	      this._cleanTipClass();
	      this.addAttachmentClass(this._getAttachment(popperData.placement));
	    }
	  }, {
	    key: '_fixTransition',
	    value: function _fixTransition() {
	      var tip = this.getTipElement();
	      var initConfigAnimation = this.config.animation;
	      if (tip.getAttribute('x-placement') !== null) {
	        return;
	      }
	
	      tip.classList.remove(ClassName.FADE);
	      this.config.animation = false;
	      this.hide();
	      this.show();
	      this.config.animation = initConfigAnimation;
	    }
	
	    // Static
	
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(config) {
	      return this.each(function () {
	        var data = _data2.default.getData(this, DATA_KEY);
	        var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config;
	
	        if (!data && /dispose|hide/.test(config)) {
	          return;
	        }
	
	        if (!data) {
	          data = new Tooltip(this, _config);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError('No method named "' + config + '"');
	          }
	
	          data[config]();
	        }
	      });
	    }
	  }, {
	    key: '_getInstance',
	    value: function _getInstance(element) {
	      return _data2.default.getData(element, DATA_KEY);
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }, {
	    key: 'Default',
	    get: function get() {
	      return Default;
	    }
	  }, {
	    key: 'NAME',
	    get: function get() {
	      return NAME;
	    }
	  }, {
	    key: 'DATA_KEY',
	    get: function get() {
	      return DATA_KEY;
	    }
	  }, {
	    key: 'Event',
	    get: function get() {
	      return Event;
	    }
	  }, {
	    key: 'EVENT_KEY',
	    get: function get() {
	      return EVENT_KEY;
	    }
	  }, {
	    key: 'DefaultType',
	    get: function get() {
	      return DefaultType;
	    }
	  }]);
	
	  return Tooltip;
	}();
	
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 * add .tooltip to jQuery only if jQuery is present
	 */
	
	if (typeof _util.jQuery !== 'undefined') {
	  var JQUERY_NO_CONFLICT = _util.jQuery.fn[NAME];
	  _util.jQuery.fn[NAME] = Tooltip._jQueryInterface;
	  _util.jQuery.fn[NAME].Constructor = Tooltip;
	  _util.jQuery.fn[NAME].noConflict = function () {
	    _util.jQuery.fn[NAME] = JQUERY_NO_CONFLICT;
	    return Tooltip._jQueryInterface;
	  };
	}
	
	exports.default = Tooltip;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(35);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(19);
	var toAbsoluteIndex = __webpack_require__(196);
	var toLength = __webpack_require__(16);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(189);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(23);
	var toObject = __webpack_require__(19);
	var IObject = __webpack_require__(216);
	var toLength = __webpack_require__(16);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(23);
	var isObject = __webpack_require__(14);
	var invoke = __webpack_require__(366);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(18).f;
	var create = __webpack_require__(190);
	var redefineAll = __webpack_require__(194);
	var ctx = __webpack_require__(37);
	var anInstance = __webpack_require__(188);
	var forOf = __webpack_require__(189);
	var $iterDefine = __webpack_require__(305);
	var step = __webpack_require__(369);
	var setSpecies = __webpack_require__(195);
	var DESCRIPTORS = __webpack_require__(17);
	var fastKey = __webpack_require__(57).fastKey;
	var validate = __webpack_require__(198);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(202);
	var from = __webpack_require__(358);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(194);
	var getWeak = __webpack_require__(57).getWeak;
	var anObject = __webpack_require__(8);
	var isObject = __webpack_require__(14);
	var anInstance = __webpack_require__(188);
	var forOf = __webpack_require__(189);
	var createArrayMethod = __webpack_require__(43);
	var $has = __webpack_require__(29);
	var validate = __webpack_require__(198);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(231);
	var isObject = __webpack_require__(14);
	var toLength = __webpack_require__(16);
	var ctx = __webpack_require__(37);
	var IS_CONCAT_SPREADABLE = __webpack_require__(15)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(17) && !__webpack_require__(13)(function () {
	  return Object.defineProperty(__webpack_require__(298)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 366 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(14);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(8);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 369 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(307);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 371 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 372 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(17);
	var getKeys = __webpack_require__(192);
	var gOPS = __webpack_require__(235);
	var pIE = __webpack_require__(217);
	var toObject = __webpack_require__(19);
	var IObject = __webpack_require__(216);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(13)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(18);
	var anObject = __webpack_require__(8);
	var getKeys = __webpack_require__(192);
	
	module.exports = __webpack_require__(17) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(32);
	var gOPN = __webpack_require__(191).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(29);
	var toIObject = __webpack_require__(32);
	var arrayIndexOf = __webpack_require__(228)(false);
	var IE_PROTO = __webpack_require__(312)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(17);
	var getKeys = __webpack_require__(192);
	var toIObject = __webpack_require__(32);
	var isEnum = __webpack_require__(217).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(191);
	var gOPS = __webpack_require__(235);
	var anObject = __webpack_require__(8);
	var Reflect = __webpack_require__(9).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(9).parseFloat;
	var $trim = __webpack_require__(205).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(315) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(9).parseInt;
	var $trim = __webpack_require__(205).trim;
	var ws = __webpack_require__(315);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 381 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(8);
	var isObject = __webpack_require__(14);
	var newPromiseCapability = __webpack_require__(309);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 383 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(16);
	var repeat = __webpack_require__(314);
	var defined = __webpack_require__(44);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(39);
	var toLength = __webpack_require__(16);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(15);


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(361);
	var validate = __webpack_require__(198);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(229)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(310);
	__webpack_require__(1)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(17) && /./g.flags != 'g') __webpack_require__(18).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(215)
	});


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(361);
	var validate = __webpack_require__(198);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(229)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(9);
	var each = __webpack_require__(43)(0);
	var redefine = __webpack_require__(27);
	var meta = __webpack_require__(57);
	var assign = __webpack_require__(373);
	var weak = __webpack_require__(363);
	var isObject = __webpack_require__(14);
	var validate = __webpack_require__(198);
	var NATIVE_WEAK_MAP = __webpack_require__(198);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(229)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 392 */
47,
/* 393 */
47,
/* 394 */
47,
/* 395 */
47,
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return Date.now();
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return ( /\?/ );
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(199),
		__webpack_require__(324),
		__webpack_require__(25)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, support ) {
	
	"use strict";
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(21)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( document ) {
		"use strict";
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
		return DOMEval;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(21),
		__webpack_require__(822),
		__webpack_require__(208)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document ) {
	
	"use strict";
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		// rsingleTag matches a string consisting of a single HTML element with no attributes
		// and captures the element's name
		return ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	return addGetHookIf;
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(337)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, rcssNum ) {
	
	"use strict";
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	return adjustCSS;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(242),
		__webpack_require__(826),
		__webpack_require__(329),
		__webpack_require__(406),
		__webpack_require__(327)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, isAttached, rboxStyle, rnumnonpx, getStyles, support ) {
	
	"use strict";
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	return curCSS;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(21),
		__webpack_require__(7)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( document, jQuery ) {
	
	"use strict";
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	return finalPropName;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(242)
	
		// css is assumed
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, isAttached ) {
		"use strict";
	
		// isHiddenWithinTree reports if an element has a non-"none" display style (inline and/or
		// through the CSS cascade), which is useful in deciding whether or not to make it visible.
		// It differs from the :hidden selector (jQuery.expr.pseudos.hidden) in two important ways:
		// * A hidden ancestor does not force an element to be classified as hidden.
		// * Being disconnected from the document does not force an element to be classified as hidden.
		// These differences improve the behavior of .toggle() et al. when applied to elements that are
		// detached or contained within hidden ancestors (gh-2404, gh-2863).
		return function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	// A method for quickly swapping in/out CSS properties to get correct calculations.
	return function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(220),
		__webpack_require__(58),
		__webpack_require__(330)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, camelCase, rnothtmlwhite, acceptData ) {
	
	"use strict";
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	
	return Data;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 410 */
48,
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(207),
		__webpack_require__(242),
		__webpack_require__(415),
		__webpack_require__(414),
		__webpack_require__(416),
		__webpack_require__(412),
		__webpack_require__(413)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, toType, isAttached, rtagName, rscriptType, wrapMap, getAll, setGlobalEval ) {
	
	"use strict";
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	return buildFragment;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(200)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, nodeName ) {
	
	"use strict";
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	return getAll;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(48)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( dataPriv ) {
	
	"use strict";
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	return setGlobalEval;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return ( /^$|^module$|\/(?:java|ecma)script/i );
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		// rtagName captures the name from the first start tag in a string of HTML
		// https://html.spec.whatwg.org/multipage/syntax.html#tag-open-state
		// https://html.spec.whatwg.org/multipage/syntax.html#tag-name-state
		return ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	return wrapMap;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(207),
		__webpack_require__(336),
		__webpack_require__(20),
		__webpack_require__(40),
		__webpack_require__(210), // filter
		__webpack_require__(398)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, toType, rcheckableType, isFunction ) {
	
	"use strict";
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(335),
		__webpack_require__(20),
		__webpack_require__(419),
		__webpack_require__(25)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, indexOf, isFunction, rneedsContext ) {
	
	"use strict";
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(25)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
		"use strict";
	
		return jQuery.expr.match.needsContext;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(222)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr ) {
		"use strict";
	
		return arr.concat;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(334)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( hasOwn ) {
		"use strict";
	
		return hasOwn.toString;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(222)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr ) {
		"use strict";
	
		return arr.push;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(244)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( class2type ) {
		"use strict";
	
		return class2type.toString;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	/*! js-cookie v3.0.1 | MIT */
	;
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global = global || self, (function () {
	    var current = global.Cookies;
	    var exports = global.Cookies = factory();
	    exports.noConflict = function () { global.Cookies = current; return exports; };
	  }()));
	}(this, (function () { 'use strict';
	
	  /* eslint-disable no-var */
	  function assign (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	      for (var key in source) {
	        target[key] = source[key];
	      }
	    }
	    return target
	  }
	  /* eslint-enable no-var */
	
	  /* eslint-disable no-var */
	  var defaultConverter = {
	    read: function (value) {
	      if (value[0] === '"') {
	        value = value.slice(1, -1);
	      }
	      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
	    },
	    write: function (value) {
	      return encodeURIComponent(value).replace(
	        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
	        decodeURIComponent
	      )
	    }
	  };
	  /* eslint-enable no-var */
	
	  /* eslint-disable no-var */
	
	  function init (converter, defaultAttributes) {
	    function set (key, value, attributes) {
	      if (typeof document === 'undefined') {
	        return
	      }
	
	      attributes = assign({}, defaultAttributes, attributes);
	
	      if (typeof attributes.expires === 'number') {
	        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
	      }
	      if (attributes.expires) {
	        attributes.expires = attributes.expires.toUTCString();
	      }
	
	      key = encodeURIComponent(key)
	        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
	        .replace(/[()]/g, escape);
	
	      var stringifiedAttributes = '';
	      for (var attributeName in attributes) {
	        if (!attributes[attributeName]) {
	          continue
	        }
	
	        stringifiedAttributes += '; ' + attributeName;
	
	        if (attributes[attributeName] === true) {
	          continue
	        }
	
	        // Considers RFC 6265 section 5.2:
	        // ...
	        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
	        //     character:
	        // Consume the characters of the unparsed-attributes up to,
	        // not including, the first %x3B (";") character.
	        // ...
	        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
	      }
	
	      return (document.cookie =
	        key + '=' + converter.write(value, key) + stringifiedAttributes)
	    }
	
	    function get (key) {
	      if (typeof document === 'undefined' || (arguments.length && !key)) {
	        return
	      }
	
	      // To prevent the for loop in the first place assign an empty array
	      // in case there are no cookies at all.
	      var cookies = document.cookie ? document.cookie.split('; ') : [];
	      var jar = {};
	      for (var i = 0; i < cookies.length; i++) {
	        var parts = cookies[i].split('=');
	        var value = parts.slice(1).join('=');
	
	        try {
	          var foundKey = decodeURIComponent(parts[0]);
	          jar[foundKey] = converter.read(value, foundKey);
	
	          if (key === foundKey) {
	            break
	          }
	        } catch (e) {}
	      }
	
	      return key ? jar[key] : jar
	    }
	
	    return Object.create(
	      {
	        set: set,
	        get: get,
	        remove: function (key, attributes) {
	          set(
	            key,
	            '',
	            assign({}, attributes, {
	              expires: -1
	            })
	          );
	        },
	        withAttributes: function (attributes) {
	          return init(this.converter, assign({}, this.attributes, attributes))
	        },
	        withConverter: function (converter) {
	          return init(assign({}, this.converter, converter), this.attributes)
	        }
	      },
	      {
	        attributes: { value: Object.freeze(defaultAttributes) },
	        converter: { value: Object.freeze(converter) }
	      }
	    )
	  }
	
	  var api = init(defaultConverter, { path: '/' });
	  /* eslint-enable no-var */
	
	  return api;
	
	})));


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.15.0
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
	
	var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	var timeoutDuration = 0;
	for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	    timeoutDuration = 1;
	    break;
	  }
	}
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.right - result.left;
	  var height = sizes.height || element.clientHeight || result.bottom - result.top;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop, 10);
	    var marginLeft = parseFloat(styles.marginLeft, 10);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicity asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 427 */
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70.87 70.87\">\n  <title>renewablematerials1-03</title>\n  <path\n    d=\"M37.65,32.5a1.73,1.73,0,0,0-.58-3.27l0-.16a1.73,1.73,0,0,0-.7-3.32h0a1.71,1.71,0,0,0,.89-1.5,1.74,1.74,0,0,0-1.73-1.73l-.22,0c0-.09-.07-.18-.11-.28A1.71,1.71,0,0,0,36,20.79a1.73,1.73,0,0,0-1.73-1.73,1.66,1.66,0,0,0-.32,0,1.7,1.7,0,0,0,.46-1.17,1.73,1.73,0,0,0-2.57-1.51c-.13-.12-.27-.22-.4-.32a2.85,2.85,0,0,0,0-.29,1.74,1.74,0,0,0-3.47,0,1.86,1.86,0,0,0,0,.34l-.21.18a1.8,1.8,0,0,0-.66-.13,1.72,1.72,0,0,0-1.73,1.73,1.75,1.75,0,0,0,.44,1.15v0a1.36,1.36,0,0,0-.29,0,1.73,1.73,0,0,0-1,3.14c0,.11-.07.22-.11.33h-.11a1.74,1.74,0,0,0-1.73,1.73,1.71,1.71,0,0,0,.89,1.5h0a1.73,1.73,0,0,0-.66,3.33l0,.15a1.72,1.72,0,0,0-.5,3.32.88.88,0,0,0,0,.16A1.73,1.73,0,0,0,22,36c-.15,1.9-.21,3.82-.19,5.67.16,12,3.94,16,8.53,15.93s8.25-4.19,8.09-16.15l-.25-2.56\"\n    fill=\"#fff\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <path id=\"Path_982\" data-name=\"Path 982\"\n        d=\"M33.86,57.46l-3.21,1.13A11.78,11.78,0,0,1,20.56,47.1h0a10.54,10.54,0,0,0-1.62-5.49l-2.73-4.32a15.59,15.59,0,0,1,12,4.14\"\n        fill=\"#d9ebda\" stroke=\"#55a969\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n  <path id=\"Path_983\" data-name=\"Path 983\"\n        d=\"M30.59,58.57a11.78,11.78,0,0,0,9.58-11.72h0a10.55,10.55,0,0,1,1.48-5.53l2.61-4.39S27.5,35.68,27.17,57.53C27.17,57.53,27.76,59.45,30.59,58.57Z\"\n        fill=\"#d9ebda\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n  <path\n    d=\"M42.42,27.13v5.69a.48.48,0,0,0,.49.48H48.6a1.62,1.62,0,0,0,1.52-.44l7.73-7.72a1.67,1.67,0,0,0,0-2.34l-4.92-4.92a1.65,1.65,0,0,0-2.34,0l-7.73,7.73A1.67,1.67,0,0,0,42.42,27.13Z\"\n    fill=\"#d9ebda\" stroke=\"#55a969\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n  <path\n    d=\"M48.22,30a.17.17,0,0,1-.1,0l-2.49-2.49a.18.18,0,0,1,0-.1.19.19,0,0,1,0-.09L46.8,26.1a1.59,1.59,0,0,1,.92-.52.94.94,0,0,1,.79.33.73.73,0,0,1,.23.42.92.92,0,0,1,0,.41.84.84,0,0,1,.5,0,.9.9,0,0,1,.47.25,1.05,1.05,0,0,1,.34.85,1.51,1.51,0,0,1-.51.93L48.31,30A.12.12,0,0,1,48.22,30Zm-.43-2.74a.45.45,0,0,0,.15-.31.38.38,0,0,0-.12-.29.42.42,0,0,0-.29-.12.45.45,0,0,0-.31.15l-.49.5.56.57Zm1.15,1.08a.39.39,0,0,0,.15-.33.4.4,0,0,0-.13-.31.45.45,0,0,0-.32-.14.48.48,0,0,0-.33.15l-.53.53.63.64Z\"\n    fill=\"#181716\"/>\n  <path\n    d=\"M50.91,27.29a.1.1,0,0,1-.09,0l-2.49-2.48a.14.14,0,0,1,0-.1.13.13,0,0,1,0-.1l.51-.51a.15.15,0,0,1,.2,0l2.48,2.48a.1.1,0,0,1,0,.1.13.13,0,0,1,0,.1l-.51.51A.13.13,0,0,1,50.91,27.29Z\"\n    fill=\"#181716\"/>\n  <path\n    d=\"M52.17,25.64a1.46,1.46,0,0,1-1.11-.45l-.33-.33-.33-.33A1.46,1.46,0,0,1,50,23.41a1.76,1.76,0,0,1,.57-1.11,1.72,1.72,0,0,1,1.12-.57,1.42,1.42,0,0,1,1.11.44c.15.14.27.25.34.33l.32.33a1.46,1.46,0,0,1,.45,1.11,2.15,2.15,0,0,1-1.7,1.7Zm.77-1.6a.81.81,0,0,0-.25-.52l-.31-.32-.32-.31a.81.81,0,0,0-.52-.25.72.72,0,0,0-.67.67.85.85,0,0,0,.26.52l.31.32c.13.13.24.23.31.31a.83.83,0,0,0,.52.25.72.72,0,0,0,.67-.67Z\"\n    fill=\"#181716\"/>\n  <circle cx=\"29.68\" cy=\"18.09\" r=\"0.81\" fill=\"#d9ebda\" stroke=\"#d9ebda\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"\n          stroke-width=\"0.25\"/>\n  <circle cx=\"27.45\" cy=\"22.02\" r=\"0.81\" fill=\"#d9ebda\" stroke=\"#d9ebda\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"\n          stroke-width=\"0.25\"/>\n  <circle cx=\"32.46\" cy=\"23.94\" r=\"0.81\" fill=\"#d9ebda\" stroke=\"#d9ebda\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"\n          stroke-width=\"0.25\"/>\n  <circle cx=\"25.04\" cy=\"28.44\" r=\"0.81\" fill=\"#d9ebda\" stroke=\"#d9ebda\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"\n          stroke-width=\"0.25\"/>\n  <circle cx=\"29.42\" cy=\"26.5\" r=\"0.81\" fill=\"#d9ebda\" stroke=\"#d9ebda\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"\n          stroke-width=\"0.25\"/>\n  <circle cx=\"33.86\" cy=\"29.25\" r=\"0.81\" fill=\"#d9ebda\" stroke=\"#d9ebda\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"\n          stroke-width=\"0.25\"/>\n  <circle cx=\"29.42\" cy=\"31.34\" r=\"0.81\" fill=\"#d9ebda\" stroke=\"#d9ebda\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"\n          stroke-width=\"0.25\"/>\n  <circle cx=\"29.68\" cy=\"38.03\" r=\"0.81\" fill=\"#d9ebda\" stroke=\"#d9ebda\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"\n          stroke-width=\"0.25\"/>\n  <circle cx=\"34.68\" cy=\"34.57\" r=\"0.81\" fill=\"#d9ebda\" stroke=\"#d9ebda\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"\n          stroke-width=\"0.25\"/>\n  <circle cx=\"25.41\" cy=\"34.4\" r=\"0.81\" fill=\"#d9ebda\" stroke=\"#d9ebda\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"\n          stroke-width=\"0.25\"/>\n</svg>\n"

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70.87 70.87\">\n  <title>renewablematerials4</title>\n  <polygon points=\"21.48 44.64 21.48 26.97 35.73 32.66 35.73 50.12 21.48 44.64\" fill=\"none\" stroke=\"#0a2b30\"\n           stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <polyline points=\"49.89 37.51 49.89 44.75 35.73 50.12 35.73 32.66 49.89 27.08\" fill=\"none\" stroke=\"#0a2b30\"\n            stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <polygon points=\"35.73 21.28 49.89 27.08 35.73 32.66 21.48 26.97 35.73 21.28\" fill=\"none\" stroke=\"#0a2b30\"\n           stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <polygon\n    points=\"26.99 29.66 26.91 34.09 27.64 33.85 28.24 34.49 28.66 34.14 29.31 35.11 29.31 30.61 43.87 24.61 40.67 23.27 27 28.79 26.99 29.66\"\n    fill=\"#b3d4f0\" stroke=\"#3d78af\" stroke-miterlimit=\"10\"/>\n  <g id=\"Group_1023\" data-name=\"Group 1023\">\n    <g id=\"Group_1022\" data-name=\"Group 1022\">\n      <path id=\"Path_1034\" data-name=\"Path 1034\" d=\"M45.12,37.81c1.43,0,2.2,1.34,1.73,2.93\" fill=\"none\" stroke=\"#3d78af\"\n            stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"0.75\"/>\n      <path id=\"Path_1035\" data-name=\"Path 1035\" d=\"M41.46,42.15a4,4,0,0,1,2.16-3.94\" fill=\"none\" stroke=\"#3d78af\"\n            stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"0.75\"/>\n      <path id=\"Path_1036\" data-name=\"Path 1036\" d=\"M46,42.27c-1.15,1.36-2.88,1.81-3.89,1\" fill=\"none\" stroke=\"#3d78af\"\n            stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"0.75\"/>\n    </g>\n    <path id=\"Path_1037\" data-name=\"Path 1037\" d=\"M43,42.89l-.85.39.12.82\" fill=\"none\" stroke=\"#3d78af\"\n          stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"0.75\"/>\n    <path id=\"Path_1038\" data-name=\"Path 1038\" d=\"M43.29,39.11l.33-.9-.8-.07\" fill=\"none\" stroke=\"#3d78af\"\n          stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"0.75\"/>\n    <path id=\"Path_1039\" data-name=\"Path 1039\" d=\"M46.33,40.23l.52.51.68-.75\" fill=\"none\" stroke=\"#3d78af\"\n          stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"0.75\"/>\n  </g>\n  <path d=\"M38.5,14.49c.37-.59.49-2.3.74-2.68\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <path d=\"M48.54,19c.92-.52,1.13-2.15,1.84-2.09\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <path d=\"M55.88,27.51a21,21,0,0,0,2.78-.15\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <path d=\"M56.37,38.31s2.4.23,2.68.74\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <path d=\"M51.84,49.48c0,.64,2.15,1.14,2.09,1.85\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <path d=\"M43.35,55.69s.7,2.33.15,2.78\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <path d=\"M32.41,56.05c-.46.45-.4,2.38-.93,2.62\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <path d=\"M21.37,52.16s-1.92,1.38-1.92,2\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <path d=\"M14.34,43.4s-2.35.62-2.79.05\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <path d=\"M14.24,32.59a14,14,0,0,1-2.66-.83\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <path d=\"M19.17,21.59s-1.38-1.92-2-1.92\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <path d=\"M27.88,15.7s-.61-2.36-.05-2.79\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n"

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70.87 70.87\">\n  <title>renewablematerials1-03</title>\n  <line x1=\"37.56\" y1=\"37.64\" x2=\"37.56\" y2=\"41.06\" fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\"\n        stroke-miterlimit=\"10\"/>\n  <path id=\"Path_990\" data-name=\"Path 990\"\n        d=\"M40.41,57.5S22.64,62.94,15.79,42.07a.81.81,0,0,1,.52-1l.08,0C20.05,40.24,34.6,38.38,40.41,57.5Z\"\n        fill=\"#fff\"/>\n  <path id=\"Path_991\" data-name=\"Path 991\"\n        d=\"M42.59,54.58S25.14,59.92,18.16,39.71A1.29,1.29,0,0,1,19,38.06l.19-.05c6-1.21,14.07.75,17.88,6.28\"\n        fill=\"#d9ebda\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n  <path id=\"Path_992\" data-name=\"Path 992\"\n        d=\"M38.2,58.88S32.86,41.42,53.07,34.44a1.3,1.3,0,0,1,1.65.79,1.33,1.33,0,0,1,.05.19c.74,4,1.51,15.59-12.17,21.81\"\n        fill=\"#d9ebda\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n  <path id=\"Path_993\" data-name=\"Path 993\" d=\"M48.39,40.59s-7.38,5.3-8.08,14\" fill=\"none\" stroke=\"#55a969\"\n        stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <path id=\"Path_994\" data-name=\"Path 994\" d=\"M26.47,43A20.59,20.59,0,0,1,35,50.11\" fill=\"none\" stroke=\"#55a969\"\n        stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <path d=\"M32.27,20.83V16A1.86,1.86,0,0,1,34,14h0a1.86,1.86,0,0,1,1.74,2v4.88\" fill=\"none\" stroke=\"#0a2b30\"\n        stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n  <path d=\"M39.37,20.83V16a1.87,1.87,0,0,1,1.74-2h0a1.86,1.86,0,0,1,1.74,2v4.88\" fill=\"none\" stroke=\"#0a2b30\"\n        stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n  <path d=\"M45.18,30A7.62,7.62,0,1,1,30,30V22.87H45.18Z\" fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\"\n        stroke-miterlimit=\"10\"/>\n  <line x1=\"33.45\" y1=\"27.19\" x2=\"41.68\" y2=\"27.19\" fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\"\n        stroke-miterlimit=\"10\"/>\n  <line x1=\"33.45\" y1=\"31\" x2=\"41.68\" y2=\"31\" fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\"\n        stroke-miterlimit=\"10\"/>\n</svg>\n"

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70.87 70.87\">\n  <title>localproduction</title>\n  <polygon\n    points=\"36.43 18.59 42.98 18.59 46 24.48 50.57 24.48 52.49 26.4 49.91 32.66 52.04 34.87 56.32 34.87 60.22 39.95 60.22 42.6 57.86 44.81 54.55 44.81 51.45 53.06 54.4 56.16 53.22 58.22 49.61 59.4 48.12 54.98 41.29 52.55 41.14 50.05 42.84 44.81 38.27 44.89 37.02 49.38 30.9 49.38 32.52 44.01 30.17 41.87 26.56 41.87 26.56 39 20.59 39 20.59 35.24 18.68 31.48 15.21 33.1 14.11 33.1 10.64 26.77 20.96 21.91 22.28 24.48 28.91 24.48 35.43 21.1 36.43 18.59\"\n    fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <path\n    d=\"M35.13,37.11s-9.27-6.83-9.27-14h0v0c0-4.52,4.29-8.76,9.57-8.76S45,18.59,45,23.11C45,30.33,35.13,37.11,35.13,37.11Z\"\n    fill=\"#fff\" stroke=\"#0a2b30\" stroke-miterlimit=\"10\"/>\n  <circle cx=\"35.43\" cy=\"23.23\" r=\"3\" fill=\"#55a969\"/>\n  <path\n    d=\"M35.43,20.72a2.51,2.51,0,1,1-2.49,2.5,2.5,2.5,0,0,1,2.49-2.5m0-1a3.51,3.51,0,1,0,3.5,3.5,3.5,3.5,0,0,0-3.5-3.5Z\"\n    fill=\"#0a2b30\"/>\n</svg>\n"

/***/ }),
/* 431 */
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70.87 70.87\">\n  <title>renewablematerials</title>\n  <g id=\"Group_1017\" data-name=\"Group 1017\">\n    <path id=\"Path_1032\" data-name=\"Path 1032\"\n          d=\"M53.69,59.79c-4.61,0-7.86,1.16-13.37,2.19h0c-2.21.86-6.18-.4-7.79-1a98.46,98.46,0,0,1-9.88-4.32A1.71,1.71,0,0,1,22,54.36h0a1.76,1.76,0,0,1,2.08-.91l5.52,1.9\"\n          fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <path id=\"Path_1033\" data-name=\"Path 1033\"\n          d=\"M52.79,51.93c-2.3-.71-3.19-1.65-6.58-1.15s-3.63,1.71-7.53,2.28l-6,.89a1.54,1.54,0,0,0-1.3,1.75h0A1.55,1.55,0,0,0,33.11,57h0l9.43-.12\"\n          fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  </g>\n  <g id=\"Group_1017-2\" data-name=\"Group 1017\">\n    <path id=\"Path_1032-2\" data-name=\"Path 1032\"\n          d=\"M17.18,13.07c4.6,0,7.86-1.15,13.37-2.18h0c2.2-.87,6.17.39,7.79,1a98.46,98.46,0,0,1,9.88,4.32,1.7,1.7,0,0,1,.65,2.25h0a1.77,1.77,0,0,1-2.08.92l-5.53-1.91\"\n          fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <path id=\"Path_1033-2\" data-name=\"Path 1033\"\n          d=\"M18.08,20.93c2.29.72,3.19,1.66,6.58,1.16s3.62-1.71,7.52-2.29l6-.89a1.55,1.55,0,0,0,1.3-1.75h0a1.54,1.54,0,0,0-1.75-1.3h0L28.33,16\"\n          fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  </g>\n  <polygon points=\"22.59 44.65 22.59 28.58 35.62 33.84 35.62 49.65 22.59 44.65\" fill=\"none\" stroke=\"#0a2b30\"\n           stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <polyline points=\"48.57 38.12 48.57 44.75 35.62 49.65 35.62 33.89 48.57 28.88\" fill=\"none\" stroke=\"#0a2b30\"\n            stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <polygon points=\"35.62 23.28 48.57 28.58 35.62 33.69 22.59 28.48 35.62 23.28\" fill=\"none\" stroke=\"#0a2b30\"\n           stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <polygon\n    points=\"27.63 30.95 27.55 34.99 28.22 34.78 28.77 35.36 29.16 35.04 29.75 35.93 29.75 31.81 43.06 26.32 40.14 25.1 27.64 30.15 27.63 30.95\"\n    fill=\"#d9ebda\" stroke=\"#fff\" stroke-miterlimit=\"10\"/>\n</svg>\n"

/***/ }),
/* 432 */
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70.87 70.87\">\n  <title>renewablematerials3</title>\n  <circle cx=\"35.43\" cy=\"35.43\" r=\"23.62\" fill=\"none\" stroke=\"#fff\" stroke-miterlimit=\"10\"/>\n  <line x1=\"26.7\" y1=\"27.49\" x2=\"25.04\" y2=\"29.17\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <line x1=\"38.45\" y1=\"39.07\" x2=\"36.79\" y2=\"40.75\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <line x1=\"41.97\" y1=\"42.64\" x2=\"40.31\" y2=\"44.32\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <line x1=\"30.05\" y1=\"30.81\" x2=\"28.38\" y2=\"32.49\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <line x1=\"28.98\" y1=\"28.56\" x2=\"26.7\" y2=\"30.82\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <line x1=\"40.82\" y1=\"40.27\" x2=\"38.53\" y2=\"42.53\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <line x1=\"44.37\" y1=\"43.81\" x2=\"42.08\" y2=\"46.07\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <line x1=\"32.41\" y1=\"31.8\" x2=\"30.12\" y2=\"34.06\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <polygon points=\"43.5 47.5 47.46 43.44 27.31 23.57 23.36 27.5 43.5 47.5\" fill=\"none\" stroke=\"#3d78af\"\n           stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <path d=\"M31.78,42.64,29.62,44.8l0,0L23.91,47a.1.1,0,0,1-.13-.14l1-2.67,1.17-3,0,0,2.12-2.12\" fill=\"none\"\n        stroke=\"#0a2b30\" stroke-miterlimit=\"10\"/>\n  <line x1=\"26.59\" y1=\"46.01\" x2=\"24.81\" y2=\"44.22\" fill=\"none\" stroke=\"#0a2b30\" stroke-miterlimit=\"10\"/>\n  <rect x=\"43.22\" y=\"23.54\" width=\"3.86\" height=\"4.36\" rx=\"1.32\" transform=\"translate(31.42 -24.39) rotate(45)\"\n        fill=\"none\" stroke=\"#0a2b30\" stroke-miterlimit=\"10\"/>\n  <polygon\n    points=\"31.13 43.29 46.66 27.76 43.05 24.14 27.42 39.76 27.26 39.92 27.57 42 28.63 42.17 28.81 43.23 30.88 43.54 31.13 43.29\"\n    fill=\"#b3d4f0\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n"

/***/ }),
/* 433 */
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70.87 70.87\">\n  <title>renewablematerials1-01</title>\n  <g id=\"Group_1006\" data-name=\"Group 1006\">\n    <path id=\"Path_990\" data-name=\"Path 990\"\n          d=\"M37.8,37.83s-11.26,3.44-15.6-9.78a.49.49,0,0,1,.33-.63l0,0C24.9,26.9,34.12,25.72,37.8,37.83Z\" fill=\"#fff\"/>\n    <path id=\"Path_991\" data-name=\"Path 991\"\n          d=\"M39.18,36S28.12,39.36,23.7,26.56a.82.82,0,0,1,.5-1l.12,0a12,12,0,0,1,10.61,3\" fill=\"#d9ebda\"\n          stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <path id=\"Path_992\" data-name=\"Path 992\"\n          d=\"M36.4,38.7S33,27.64,45.82,23.22a.82.82,0,0,1,1,.5l0,.12c.47,2.55,1,9.88-7.72,13.82\" fill=\"#d9ebda\"\n          stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <path id=\"Path_993\" data-name=\"Path 993\" d=\"M42.85,27.12S38.18,30.48,37.74,36\" fill=\"none\" stroke=\"#55a969\"\n          stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <path id=\"Path_994\" data-name=\"Path 994\" d=\"M29,28.63a13,13,0,0,1,5.42,4.52\" fill=\"none\" stroke=\"#55a969\"\n          stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <line id=\"Line_659\" data-name=\"Line 659\" x1=\"21.18\" y1=\"40.18\" x2=\"33.46\" y2=\"40.18\" fill=\"none\" stroke=\"#0a2b30\"\n          stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <line id=\"Line_660\" data-name=\"Line 660\" x1=\"39.18\" y1=\"40.18\" x2=\"47.97\" y2=\"40.18\" fill=\"none\" stroke=\"#0a2b30\"\n          stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <path id=\"Path_995\" data-name=\"Path 995\" d=\"M36.74,40.87c.78,3.24,0,7.11-6.07,6.69\" fill=\"none\" stroke=\"#fff\"\n          stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <path id=\"Path_996\" data-name=\"Path 996\" d=\"M44.08,46.13s-3.49-.25-5-1.86\" fill=\"none\" stroke=\"#fff\"\n          stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <path id=\"Path_997\" data-name=\"Path 997\" d=\"M38.25,46.71a5.5,5.5,0,0,0,2,4\" fill=\"none\" stroke=\"#fff\"\n          stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <path id=\"Path_998\" data-name=\"Path 998\" d=\"M32,43.34a5.12,5.12,0,0,0,2.63-.63\" fill=\"none\" stroke=\"#fff\"\n          stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <g id=\"Group_1005\" data-name=\"Group 1005\">\n      <g id=\"Group_1004\" data-name=\"Group 1004\">\n        <path id=\"Path_999\" data-name=\"Path 999\" d=\"M52.17,53a23.85,23.85,0,0,1-33.33,0\" fill=\"none\" stroke=\"#55a969\"\n              stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n        <path id=\"Path_1000\" data-name=\"Path 1000\" d=\"M42,13A23.76,23.76,0,0,1,58.62,41.84\" fill=\"none\" stroke=\"#55a969\"\n              stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n        <path id=\"Path_1001\" data-name=\"Path 1001\" d=\"M12.39,41.84A23.76,23.76,0,0,1,29,13\" fill=\"none\" stroke=\"#55a969\"\n              stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n      </g>\n      <path id=\"Path_1002\" data-name=\"Path 1002\" d=\"M26.69,20,29,13l-7-2.35\" fill=\"none\" stroke=\"#55a969\"\n            stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n      <path id=\"Path_1003\" data-name=\"Path 1003\" d=\"M53.76,36.32l4.86,5.52L64.14,37\" fill=\"none\" stroke=\"#55a969\"\n            stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n      <path id=\"Path_1004\" data-name=\"Path 1004\" d=\"M26.05,51.57,18.84,53l1.45,7.21\" fill=\"none\" stroke=\"#55a969\"\n            stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    </g>\n  </g>\n</svg>\n"

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70.87 70.87\">\n  <title>renewablematerials1</title>\n  <g id=\"Group_978\" data-name=\"Group 978\">\n    <path id=\"Path_949\" data-name=\"Path 949\"\n          d=\"M41.38,31.15l10.9-10.89,1.24,1.23L57,16.3l-2.07-2.08-5.2,3.44,1.24,1.24L31.62,38.19,33,39.55l3-3\"\n          fill=\"#d9ebda\" stroke=\"#55a969\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <path id=\"Path_950\" data-name=\"Path 950\" d=\"M29.94,37.66l4.3,4.3-1.69,1.68L26.91,38l1.69-1.69\" fill=\"#d9ebda\"\n          stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <path id=\"Path_951\" data-name=\"Path 951\" d=\"M26.44,41.26l4.25,4.24-10,10a4,4,0,0,1-5.64,0h0a4,4,0,0,1,0-5.64l10-10\"\n          fill=\"#d9ebda\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <path id=\"Path_953\" data-name=\"Path 953\" d=\"M25.05,39.87A1.87,1.87,0,0,0,26.91,38\" fill=\"#eaeaea\" stroke=\"#0a2b30\"\n          stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <line id=\"Line_649\" data-name=\"Line 649\" x1=\"24.8\" y1=\"43.65\" x2=\"18.24\" y2=\"50.21\" fill=\"#d9ebda\" stroke=\"#55a969\"\n          stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <line id=\"Line_650\" data-name=\"Line 650\" x1=\"26.91\" y1=\"45.75\" x2=\"20.35\" y2=\"52.31\" fill=\"#d9ebda\" stroke=\"#55a969\"\n          stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n  </g>\n  <path id=\"Path_954\" data-name=\"Path 954\"\n        d=\"M46.14,41.07,29.85,24.78a7.93,7.93,0,0,0-5-10,8,8,0,0,0-3.8-.31l3.74,3.75-1.38,5.16-5.16,1.38L14.55,21a7.9,7.9,0,0,0,10.33,8.76L41.17,46a7.9,7.9,0,0,0,8.76,10.34l-3.75-3.75,1.39-5.16,5.16-1.38,3.74,3.74a7.9,7.9,0,0,0-10.33-8.76Z\"\n        fill=\"#d9ebda\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n  <path id=\"Path_955\" data-name=\"Path 955\" d=\"M21.86,21.62l.83-3.05-2.23-2.25-3.05.81-.83,3.05,2.23,2.24Z\" fill=\"#fff\"/>\n</svg>\n"

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70.87 70.87\">\n  <title>renewablematerials1-03</title>\n  <g id=\"Group_929\" data-name=\"Group 929\">\n    <path id=\"Path_854\" data-name=\"Path 854\"\n          d=\"M47.92,36.88a3.76,3.76,0,0,0,.34-.86l1.45-.38,0-1.27-1.47-.31a3.7,3.7,0,0,0-1-1.56l.4-1.45-1.12-.61-1,1.12a3.66,3.66,0,0,0-1.83.05l-1.06-1.07-1.09.66L42,32.63a4,4,0,0,0-.55.75,4.25,4.25,0,0,0-.33.86l-1.45.37,0,1.28,1.47.3a3.6,3.6,0,0,0,.95,1.56l-.4,1.45,1.12.61,1-1.12a3.66,3.66,0,0,0,1.83,0l1,1.07,1.09-.67-.47-1.43A3.27,3.27,0,0,0,47.92,36.88Z\"\n          fill=\"#fff\"/>\n    <path id=\"Path_855\" data-name=\"Path 855\"\n          d=\"M32.13,34.79l-.19-1.55-.91,0A4.17,4.17,0,0,0,30.35,32l.45-.78-1.22-1-.63.61a4,4,0,0,0-1.4-.41l-.22-.83-1.54.18,0,.86a4,4,0,0,0-1.27.73l-.75-.44-1,1.22.62.65A4,4,0,0,0,23,34.18l-.88.23L22.34,36l.91,0a4.19,4.19,0,0,0,.69,1.24l-.46.78,1.23,1,.63-.6a4.19,4.19,0,0,0,1.4.41l.21.82,1.55-.18,0-.86a4,4,0,0,0,1.26-.72l.75.44,1-1.22-.63-.65A4.12,4.12,0,0,0,31.25,35Z\"\n          fill=\"#fff\"/>\n    <path id=\"Path_856\" data-name=\"Path 856\"\n          d=\"M28.12,43.2V34.63l.67-.8v-3l-.67-.8V26.6l.67-.86V22.86l-.67-.81v-.3A4.28,4.28,0,0,1,30,18.19l1.46-1a1.8,1.8,0,0,0,.81-1.51V12.54h6.07v3.18a1.82,1.82,0,0,0,.8,1.51l1.46,1a4.28,4.28,0,0,1,1.91,3.56v.36l-.51.75v2.88l.51.87v3.46l-.51.8v3l.51.8V44.79\"\n          fill=\"#d9ebda\"/>\n    <path id=\"Path_857\" data-name=\"Path 857\"\n          d=\"M38.37,12.54V10.26a.93.93,0,0,0-.93-.93H33.23a.93.93,0,0,0-.93.93h0v2.28\" fill=\"#d9ebda\" stroke=\"#55a969\"\n          stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <line id=\"Line_583\" data-name=\"Line 583\" x1=\"28.79\" y1=\"25.74\" x2=\"33.57\" y2=\"25.74\" fill=\"none\" stroke=\"#fff\"\n          stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <line id=\"Line_584\" data-name=\"Line 584\" x1=\"28.79\" y1=\"31.1\" x2=\"38.92\" y2=\"31.1\" fill=\"none\" stroke=\"#fff\"\n          stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <line id=\"Line_585\" data-name=\"Line 585\" x1=\"42.03\" y1=\"22.86\" x2=\"36.76\" y2=\"22.86\" fill=\"none\" stroke=\"#fff\"\n          stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <line id=\"Line_586\" data-name=\"Line 586\" x1=\"42.03\" y1=\"25.74\" x2=\"39.39\" y2=\"25.74\" fill=\"none\" stroke=\"#fff\"\n          stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <line id=\"Line_587\" data-name=\"Line 587\" x1=\"42.03\" y1=\"33.89\" x2=\"33.03\" y2=\"33.89\" fill=\"none\" stroke=\"#fff\"\n          stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <path id=\"Path_858\" data-name=\"Path 858\"\n          d=\"M28.12,36.68v-2l.67-.8v-3l-.67-.79V26.61l.67-.87V22.86l-.67-.81v-.3A4.29,4.29,0,0,1,30,18.19l1.46-1a1.79,1.79,0,0,0,.81-1.5V12.54h6.07v3.18a1.82,1.82,0,0,0,.8,1.51l1.46,1a4.28,4.28,0,0,1,1.91,3.56v.36l-.51.75v2.88l.51.87v3.46l-.51.8v3l.51.8v2.8\"\n          fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <line id=\"Line_588\" data-name=\"Line 588\" x1=\"31.62\" y1=\"12.54\" x2=\"39.04\" y2=\"12.54\" fill=\"none\" stroke=\"#0a2b30\"\n          stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <path id=\"Path_859\" data-name=\"Path 859\"\n          d=\"M50.11,48.38V46l-1.39-.19a6.34,6.34,0,0,0-.81-2l.83-1.1L47.05,41,46,41.8a6.39,6.39,0,0,0-2.06-.88l-.18-1.3H41.35l-.18,1.3a6.34,6.34,0,0,0-2.05.88L38.05,41l-1.69,1.69.83,1.1a6.61,6.61,0,0,0-.82,2L35,46v2.39l1.38.2a6.65,6.65,0,0,0,.82,2l-.83,1.11,1.69,1.69,1.07-.81a6.1,6.1,0,0,0,2.05.87l.18,1.31h2.39l.18-1.31A6.15,6.15,0,0,0,46,52.58l1.07.81,1.69-1.69-.83-1.11a6.38,6.38,0,0,0,.81-2Z\"\n          fill=\"#d9ebda\" stroke=\"#55a969\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <circle id=\"Ellipse_69\" data-name=\"Ellipse 69\" cx=\"42.54\" cy=\"47.19\" r=\"2.67\" fill=\"#d9ebda\" stroke=\"#fff\"\n            stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <path id=\"Path_860\" data-name=\"Path 860\"\n          d=\"M32.58,46.52a5.43,5.43,0,0,0,.08-1.27l1.77-1.11-.58-1.68-2.07.21A5.13,5.13,0,0,0,29.86,41l-.07-2.09-1.74-.34-.86,1.91a5.07,5.07,0,0,0-2.4.82l-1.84-1-1.16,1.34L23,43.36a5.21,5.21,0,0,0-.4,1.21,4.94,4.94,0,0,0-.08,1.27L20.76,47l.57,1.68,2.08-.21a4.94,4.94,0,0,0,1.91,1.66l.08,2.09,1.74.34L28,50.6a5,5,0,0,0,2.4-.82l1.84,1,1.16-1.34-1.22-1.69A5.23,5.23,0,0,0,32.58,46.52Z\"\n          fill=\"#d9ebda\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <circle id=\"Ellipse_70\" data-name=\"Ellipse 70\" cx=\"27.59\" cy=\"45.55\" r=\"2.09\" fill=\"#d9ebda\" stroke=\"#fff\"\n            stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <path id=\"Path_861\" data-name=\"Path 861\" d=\"M29.68,53.38v3a2.18,2.18,0,0,1-2.18,2.18h-.36\" fill=\"none\"\n          stroke=\"#55a969\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <path id=\"Path_862\" data-name=\"Path 862\" d=\"M32.06,55.1v3.79a1.86,1.86,0,0,0,1.86,1.86H34\" fill=\"none\" stroke=\"#fff\"\n          stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <path id=\"Path_863\" data-name=\"Path 863\" d=\"M36.08,56.4v4.93a2.19,2.19,0,0,1-2.2,2.2H33\" fill=\"none\"\n          stroke=\"#55a969\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <path id=\"Path_864\" data-name=\"Path 864\" d=\"M42,57V59a2,2,0,0,0,2,2h.67\" fill=\"none\" stroke=\"#fff\"\n          stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <path id=\"Path_865\" data-name=\"Path 865\" d=\"M39.09,55.32s-.07,5.22,0,5.21\" fill=\"none\" stroke=\"#55a969\"\n          stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n  </g>\n</svg>\n"

/***/ }),
/* 436 */
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70.87 70.87\">\n  <title>renewablematerials1-03</title>\n  <g id=\"Group_1011\" data-name=\"Group 1011\">\n    <path id=\"Path_1013\" data-name=\"Path 1013\" d=\"M31,17.9H28.59l-5.19,9,7.38,4.26,3.88-6.72-3.75-6.5Z\" fill=\"none\"\n          stroke=\"#55a969\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"0.76\"/>\n    <path id=\"Path_1014\" data-name=\"Path 1014\"\n          d=\"M44.33,24l-3.6-6.08H31l-.05,0,3.75,6.5L37,28.24l-3.52,2,10.74,2,3.68-10.29Z\" fill=\"#fff\" stroke=\"#0a2b30\"\n          stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n  </g>\n  <g id=\"Group_1012\" data-name=\"Group 1012\">\n    <path id=\"Path_1015\" data-name=\"Path 1015\" d=\"M19.91,51.7l1.18,2H31.47V45.23H23.71L20,51.73Z\" fill=\"none\"\n          stroke=\"#55a969\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"0.76\"/>\n    <path id=\"Path_1016\" data-name=\"Path 1016\"\n          d=\"M18.49,37.08,15,43.24l1.19,2,3.7,6.41.05,0,3.75-6.5,2.16-3.89,3.52,2L25.71,33.09,15,35.05Z\" fill=\"#fff\"\n          stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n  </g>\n  <g id=\"Group_1013\" data-name=\"Group 1013\">\n    <path id=\"Path_1017\" data-name=\"Path 1017\" d=\"M54.71,44.36l1.19-2-5.19-9-7.38,4.26L47.2,44.3h7.51Z\" fill=\"none\"\n          stroke=\"#55a969\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"0.76\"/>\n    <path id=\"Path_1018\" data-name=\"Path 1018\"\n          d=\"M42.76,52.91l7.06-.08,1.19-2,3.7-6.41v-.06H47.2l-4.44.07V40.32l-7.07,8.33L42.76,57Z\" fill=\"#fff\"\n          stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n  </g>\n</svg>\n"

/***/ }),
/* 437 */
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70.87 70.87\">\n  <title>renewablematerials1-03</title>\n  <path id=\"Path_872\" data-name=\"Path 872\" d=\"M36,39.15H31.12l.59-6h3.71Z\" fill=\"#d9ebda\" stroke=\"#fff\"\n        stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n  <path id=\"Path_870\" data-name=\"Path 870\" d=\"M21.9,37.57s-3,.12-4.22-1.11a3.68,3.68,0,0,0,1.23-2.7\" fill=\"#d9ebda\"\n        stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"0.76\"/>\n  <path id=\"Path_871\" data-name=\"Path 871\" d=\"M21.9,37.57s3.14.26,4.22-1.11a3.72,3.72,0,0,1-1.23-2.7\" fill=\"#d9ebda\"\n        stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"0.76\"/>\n  <path id=\"Path_873\" data-name=\"Path 873\"\n        d=\"M23.34,36.54l-.28.14a2.54,2.54,0,0,1-2.31,0l-.28-.14A2.82,2.82,0,0,1,18.91,34V32.4a3,3,0,0,1,3-3h0a3,3,0,0,1,3,3h0V34A2.81,2.81,0,0,1,23.34,36.54Z\"\n        fill=\"#d9ebda\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"0.76\"/>\n  <path id=\"Path_874\" data-name=\"Path 874\" d=\"M18.91,34V32.4a3,3,0,0,1,3-3h0a3,3,0,0,1,3,3h0V34\" fill=\"#d9ebda\"\n        stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"0.76\"/>\n  <path id=\"Path_876\" data-name=\"Path 876\"\n        d=\"M26.66,46.29H17.14l-.26-4.06A3.29,3.29,0,0,1,20,38.76h.18s.77,1.15,1.7,1.15,1.78-1.15,1.78-1.15a3.29,3.29,0,0,1,3.29,3.29v.18Z\"\n        fill=\"#d9ebda\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"0.76\"/>\n  <path id=\"Path_877\" data-name=\"Path 877\"\n        d=\"M19.79,32.91a4.77,4.77,0,0,0,2.87-1.21s.32.75,0,1.07A4,4,0,0,0,24,32.29a3.85,3.85,0,0,0,.8-.59\"\n        fill=\"#d9ebda\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n  <path id=\"Path_869\" data-name=\"Path 869\"\n        d=\"M39.72,46.12l-.28-4.21a3.41,3.41,0,0,1,2.37-3.44,3.7,3.7,0,0,1,1-.16,4.48,4.48,0,0,0,1.83.48,4,4,0,0,0,1.78-.48,3.42,3.42,0,0,1,3.42,3.42c0,.06,0,.12,0,.18l-.28,4.21h-7\"\n        fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n  <path id=\"Path_869-2\" data-name=\"Path 869\"\n        d=\"M25.61,49.26l-.45-6.78A5.52,5.52,0,0,1,29,36.93a5.59,5.59,0,0,1,1.67-.25,7,7,0,0,0,3,.76,6.49,6.49,0,0,0,2.86-.76A5.51,5.51,0,0,1,42,42.18c0,.1,0,.2,0,.3l-.45,6.78H25.61\"\n        fill=\"#d9ebda\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n  <path id=\"Path_875\" data-name=\"Path 875\"\n        d=\"M46.05,36.57l-.26.13a2.48,2.48,0,0,1-2.22,0l-.26-.13a2.7,2.7,0,0,1-1.49-2.41V32.61a2.86,2.86,0,0,1,2.86-2.86h0a2.86,2.86,0,0,1,2.86,2.86h0v1.55A2.7,2.7,0,0,1,46.05,36.57Z\"\n        fill=\"#d9ebda\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n  <path id=\"Path_878\" data-name=\"Path 878\"\n        d=\"M47.46,32a5.84,5.84,0,0,0-2.78.42v-.65a4,4,0,0,0-2.85.65c-1.26-.94-.81-3.23-.81-3.23a4.64,4.64,0,0,0,3.45.6A2.79,2.79,0,0,1,47.46,32Z\"\n        fill=\"#d9ebda\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n  <circle id=\"Ellipse_71\" data-name=\"Ellipse 71\" cx=\"44.68\" cy=\"40.98\" r=\"0.31\" fill=\"#fff\"/>\n  <circle id=\"Ellipse_72\" data-name=\"Ellipse 72\" cx=\"44.68\" cy=\"42.69\" r=\"0.31\" fill=\"#fff\"/>\n  <circle id=\"Ellipse_73\" data-name=\"Ellipse 73\" cx=\"44.68\" cy=\"44.4\" r=\"0.31\" fill=\"#fff\"/>\n  <path id=\"Path_867\" data-name=\"Path 867\"\n        d=\"M35.77,34.49l-.42.22a4,4,0,0,1-3.57,0l-.42-.22A4.33,4.33,0,0,1,29,30.61v-2.5a4.6,4.6,0,0,1,4.6-4.6h0a4.6,4.6,0,0,1,4.61,4.6h0v2.5A4.33,4.33,0,0,1,35.77,34.49Z\"\n        fill=\"#d9ebda\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n  <path id=\"Path_868\" data-name=\"Path 868\" d=\"M29,28.11a4.6,4.6,0,0,1,4.6-4.6h0a4.6,4.6,0,0,1,4.61,4.6h0\" fill=\"#d9ebda\"\n        stroke=\"#55a969\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"0.76\"/>\n  <path id=\"Rectangle_191\" data-name=\"Rectangle 191\"\n        d=\"M29,41.17h3.6V43a1.81,1.81,0,0,1-1.8,1.8h0A1.8,1.8,0,0,1,29,43v-1.8Z\" fill=\"#55a969\"/>\n  <path id=\"Path_880\" data-name=\"Path 880\" d=\"M29,28.11c-3.23-2.32,3.6-5.57,9.11,0A19.22,19.22,0,0,0,29,28.11Z\"\n        fill=\"#d9ebda\" stroke=\"#55a969\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"0.76\"/>\n  <g id=\"Group_1005\" data-name=\"Group 1005\">\n    <g id=\"Group_1004\" data-name=\"Group 1004\">\n      <path id=\"Path_999\" data-name=\"Path 999\" d=\"M50.93,54.4a23.71,23.71,0,0,1-33.15,0\" fill=\"none\" stroke=\"#55a969\"\n            stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n      <path id=\"Path_1000\" data-name=\"Path 1000\" d=\"M40.78,14.56a23.62,23.62,0,0,1,16.57,28.7\" fill=\"none\"\n            stroke=\"#55a969\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n      <path id=\"Path_1001\" data-name=\"Path 1001\" d=\"M11.36,43.26a23.62,23.62,0,0,1,16.57-28.7\" fill=\"none\"\n            stroke=\"#55a969\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    </g>\n    <path id=\"Path_1002\" data-name=\"Path 1002\" d=\"M25.59,21.49l2.34-6.93L21,12.22\" fill=\"none\" stroke=\"#55a969\"\n          stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <path id=\"Path_1003\" data-name=\"Path 1003\" d=\"M52.51,37.77l4.84,5.49,5.49-4.84\" fill=\"none\" stroke=\"#55a969\"\n          stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <path id=\"Path_1004\" data-name=\"Path 1004\" d=\"M25,52.94l-7.17,1.44,1.44,7.18\" fill=\"none\" stroke=\"#55a969\"\n          stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  </g>\n  <path id=\"Path_879\" data-name=\"Path 879\" d=\"M32.6,32.74s1.36.23,1.92-.55\" fill=\"#fff\" stroke=\"#55a969\"\n        stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n</svg>\n"

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70.87 70.87\">\n  <title>sloticon</title>\n  <g id=\"Group_1289\" data-name=\"Group 1289\">\n    <line id=\"Line_680\" data-name=\"Line 680\" x1=\"26.04\" y1=\"39.9\" x2=\"31.54\" y2=\"39.9\" fill=\"none\" stroke=\"#689cd3\"\n          stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <line id=\"Line_681\" data-name=\"Line 681\" x1=\"26.13\" y1=\"43.33\" x2=\"30.59\" y2=\"43.33\" fill=\"none\" stroke=\"#689cd3\"\n          stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <path id=\"Path_1195\" data-name=\"Path 1195\"\n          d=\"M37.56,41.93a2.84,2.84,0,0,0,1.73-2.65,3,3,0,0,0-5.91,0,3.1,3.1,0,0,0,1.3,2.53v4.81a.41.41,0,0,0,.41.41h2.06a.41.41,0,0,0,.41-.41Z\"\n          fill=\"none\" stroke=\"#689cd3\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <rect id=\"Rectangle_279\" data-name=\"Rectangle 279\" x=\"26.01\" y=\"32.35\" width=\"20.66\" height=\"18.86\" rx=\"2.78\"\n          fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <path id=\"Path_1198\" data-name=\"Path 1198\" d=\"M30.3,32.35v-7a6,6,0,0,1,6-6h0a6,6,0,0,1,6,6v7\" fill=\"none\"\n          stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <path id=\"Path_1201\" data-name=\"Path 1201\" d=\"M58.83,43.62A23.93,23.93,0,0,1,12.26,35.9c0-.72,0-1.43.1-2.13\"\n          fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <path id=\"Path_1202\" data-name=\"Path 1202\" d=\"M60.06,34.4c0,.49,0,1,0,1.5a24.71,24.71,0,0,1-.33,4\" fill=\"none\"\n          stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <path id=\"Path_1205\" data-name=\"Path 1205\" d=\"M59.21,29.39c.2.74.38,1.48.51,2.24\" fill=\"none\" stroke=\"#0a2b30\"\n          stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    <path id=\"Path_1208\" data-name=\"Path 1208\" d=\"M13.71,27.71a23.93,23.93,0,0,1,44.08-2.09\" fill=\"none\"\n          stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n  </g>\n</svg>\n"

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70.87 70.87\">\n  <title>renewablematerials1-03</title>\n  <rect x=\"29.52\" y=\"40.09\" width=\"7.68\" height=\"1.14\" fill=\"#fff\"/>\n  <rect x=\"25.35\" y=\"35.57\" width=\"7.68\" height=\"1.14\" fill=\"#fff\"/>\n  <rect x=\"34.19\" y=\"44.38\" width=\"7.68\" height=\"1.14\" fill=\"#fff\"/>\n  <rect x=\"16.42\" y=\"40.03\" width=\"6.69\" height=\"1.14\" fill=\"#fff\"/>\n  <rect x=\"20.49\" y=\"44.32\" width=\"6.69\" height=\"1.14\" fill=\"#fff\"/>\n  <polygon points=\"40.28 37.09 47.97 44.87 51.78 48.65 56.45 48.65 44.86 37.09 40.28 37.09\" fill=\"none\"/>\n  <circle cx=\"46.64\" cy=\"23.74\" r=\"4.11\" fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n  <line x1=\"46.64\" y1=\"14.65\" x2=\"46.64\" y2=\"17.53\" fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\"\n        stroke-miterlimit=\"10\"/>\n  <line x1=\"55.72\" y1=\"23.74\" x2=\"52.84\" y2=\"23.74\" fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\"\n        stroke-miterlimit=\"10\"/>\n  <line x1=\"40.26\" y1=\"23.74\" x2=\"37.38\" y2=\"23.74\" fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\"\n        stroke-miterlimit=\"10\"/>\n  <line x1=\"46.64\" y1=\"30.22\" x2=\"46.64\" y2=\"32.76\" fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\"\n        stroke-miterlimit=\"10\"/>\n  <line x1=\"53.22\" y1=\"17.15\" x2=\"51.18\" y2=\"19.19\" fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\"\n        stroke-miterlimit=\"10\"/>\n  <line x1=\"42.15\" y1=\"28.22\" x2=\"40.11\" y2=\"30.26\" fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\"\n        stroke-miterlimit=\"10\"/>\n  <line x1=\"40.11\" y1=\"17.15\" x2=\"42.15\" y2=\"19.19\" fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\"\n        stroke-miterlimit=\"10\"/>\n  <line x1=\"51.18\" y1=\"28.22\" x2=\"53.22\" y2=\"30.26\" fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\"\n        stroke-miterlimit=\"10\"/>\n  <polyline points=\"11.98 53.64 20.92 53.64 20.92 45.05 25.24 49.34 31.88 49.34 18.9 36.4 12.38 36.4 21.6 45.69\"\n            fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.1\"/>\n  <polyline points=\"25.64 53.53 33.89 53.53 33.89 44.93 38.22 49.23 46.23 49.23 29.28 32.3 21.38 32.3 34.58 45.57\"\n            fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.1\"/>\n  <line x1=\"23.11\" y1=\"53.64\" x2=\"23.11\" y2=\"50.45\" fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\" stroke-width=\"1.1\"/>\n  <line x1=\"36.08\" y1=\"53.62\" x2=\"36.08\" y2=\"50.43\" fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\" stroke-width=\"1.1\"/>\n  <rect x=\"42.86\" y=\"40.03\" width=\"6.69\" height=\"1.14\" fill=\"#fff\"/>\n  <rect x=\"46.93\" y=\"44.32\" width=\"6.69\" height=\"1.14\" fill=\"#fff\"/>\n  <line x1=\"49.55\" y1=\"53.64\" x2=\"49.55\" y2=\"50.45\" fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <line x1=\"45.24\" y1=\"53.64\" x2=\"53.19\" y2=\"53.64\" fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <path d=\"M40.19,37l8.26,8.31a.65.65,0,0,1,.1.15l3.37,3.34h5L45.1,37Z\" fill=\"none\"/>\n  <polygon points=\"46.78 53.07 46.78 52.02 45.74 53.07 46.78 53.07\" fill=\"none\"/>\n  <path\n    d=\"M58.72,48.94,45.74,36a.54.54,0,0,0-.4-.17H38.82a.58.58,0,0,0-.41,1l8.38,8.43v2.3l1.14,1.15V46.42l3.35,3.33a.56.56,0,0,0,.4.17h6.64a.57.57,0,0,0,.53-.36A.59.59,0,0,0,58.72,48.94Zm-6.8-.17-3.37-3.34a.65.65,0,0,0-.1-.15L40.19,37H45.1l11.83,11.8Z\"\n    fill=\"#0a2b30\"/>\n  <path d=\"M46.79,51.35v1.73H39.11a.54.54,0,1,0,0,1.07h8.25a.56.56,0,0,0,.57-.54V50.27Z\" fill=\"#0a2b30\"/>\n</svg>\n"

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70.87 70.87\">\n  <title>spareparts</title>\n  <circle cx=\"17.03\" cy=\"20.09\" r=\"0.59\" fill=\"#55a969\"/>\n  <circle cx=\"20.71\" cy=\"20.09\" r=\"0.59\" fill=\"#fff\"/>\n  <circle cx=\"24.53\" cy=\"20.09\" r=\"0.59\" fill=\"#fff\"/>\n  <line x1=\"16.03\" y1=\"40.94\" x2=\"26.69\" y2=\"40.94\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <line x1=\"16.03\" y1=\"44.93\" x2=\"26.69\" y2=\"44.93\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <line x1=\"16.03\" y1=\"48.75\" x2=\"22.29\" y2=\"48.75\" fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <line x1=\"29.93\" y1=\"40.94\" x2=\"40.58\" y2=\"40.94\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <line x1=\"29.93\" y1=\"44.93\" x2=\"40.58\" y2=\"44.93\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <line x1=\"29.93\" y1=\"48.75\" x2=\"36.19\" y2=\"48.75\" fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <line x1=\"44.67\" y1=\"40.94\" x2=\"55.32\" y2=\"40.94\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <line x1=\"44.67\" y1=\"44.93\" x2=\"55.32\" y2=\"44.93\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <line x1=\"44.67\" y1=\"48.75\" x2=\"50.93\" y2=\"48.75\" fill=\"none\" stroke=\"#55a969\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <path\n    d=\"M14.74,22.91H59.32v-4a1.69,1.69,0,0,0-1.69-1.69H13.23a1.68,1.68,0,0,0-1.68,1.69V52.39a1.24,1.24,0,0,0,1.24,1.25H58.25a1.07,1.07,0,0,0,1.07-1.07V27.62\"\n    fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n  <polygon points=\"16.3 34.77 16.3 28.52 21.38 30.56 21.38 36.72 16.3 34.77\" fill=\"none\" stroke=\"#0a2b30\"\n           stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <polyline points=\"26.42 32.23 26.42 34.81 21.38 36.72 21.38 30.58 26.42 28.63\" fill=\"none\" stroke=\"#0a2b30\"\n            stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <polygon points=\"21.38 26.45 26.42 28.52 21.38 30.5 16.3 28.48 21.38 26.45\" fill=\"none\" stroke=\"#0a2b30\"\n           stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <polygon points=\"44.92 33.25 44.92 29.46 50 30.7 50 34.43 44.92 33.25\" fill=\"none\" stroke=\"#0a2b30\"\n           stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <polyline points=\"55.04 31.71 55.04 33.27 50 34.43 50 30.71 55.04 29.54\" fill=\"none\" stroke=\"#0a2b30\"\n            stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <polygon points=\"50 28.21 55.04 29.46 50 30.67 44.92 29.44 50 28.21\" fill=\"none\" stroke=\"#0a2b30\"\n           stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <polygon points=\"32.77 34.6 32.77 28.35 35.78 30.39 35.78 36.55 32.77 34.6\" fill=\"none\" stroke=\"#0a2b30\"\n           stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <polyline points=\"38.77 32.06 38.77 34.64 35.78 36.55 35.78 30.41 38.77 28.46\" fill=\"none\" stroke=\"#0a2b30\"\n            stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <polygon points=\"35.78 26.28 38.77 28.35 35.78 30.34 32.77 28.31 35.78 26.28\" fill=\"none\" stroke=\"#0a2b30\"\n           stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n"

/***/ }),
/* 441 */
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70.87 70.87\">\n  <title>renewablematerials2</title>\n  <g id=\"Group_1326\" data-name=\"Group 1326\">\n    <path id=\"Path_1228\" data-name=\"Path 1228\" d=\"M43.38,27.79l-1.71,3.08c-.43.77,1.54.43,1.71.43s1.45-.43,1.45-.43Z\"\n          fill=\"#fff\"/>\n    <path id=\"Path_1229\" data-name=\"Path 1229\" d=\"M40.82,33.72h5.12V56.6H40.82Z\" fill=\"#d8ab4f\"/>\n    <g id=\"Group_1325\" data-name=\"Group 1325\">\n      <line id=\"Line_676\" data-name=\"Line 676\" x1=\"40.53\" y1=\"33.62\" x2=\"45.72\" y2=\"33.62\" fill=\"none\" stroke=\"#0a2b30\"\n            stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n      <line id=\"Line_678\" data-name=\"Line 678\" x1=\"40.53\" y1=\"56.92\" x2=\"45.72\" y2=\"56.92\" fill=\"none\" stroke=\"#0a2b30\"\n            stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n      <path id=\"Path_1100\" data-name=\"Path 1100\" d=\"M44.69,30.6a2.49,2.49,0,0,1-3.14.15\" fill=\"none\" stroke=\"#0a2b30\"\n            stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n      <path id=\"Path_1099\" data-name=\"Path 1099\" d=\"M41.31,11V17.7h7.2\" fill=\"#d8ab4f\"/>\n      <path id=\"Path_1097\" data-name=\"Path 1097\" d=\"M47.31,46.05h1.2V17.81L41.31,11h-19v35H38.59\" fill=\"none\"\n            stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n      <line id=\"Line_672\" data-name=\"Line 672\" x1=\"25.22\" y1=\"20.15\" x2=\"40.51\" y2=\"20.15\" fill=\"none\" stroke=\"#0a2b30\"\n            stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n      <line id=\"Line_673\" data-name=\"Line 673\" x1=\"25.22\" y1=\"26.94\" x2=\"37.1\" y2=\"26.94\" fill=\"none\" stroke=\"#0a2b30\"\n            stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n      <line id=\"Line_674\" data-name=\"Line 674\" x1=\"25.22\" y1=\"33.71\" x2=\"37.23\" y2=\"33.71\" fill=\"none\" stroke=\"#0a2b30\"\n            stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n      <line id=\"Line_675\" data-name=\"Line 675\" x1=\"25.22\" y1=\"39.6\" x2=\"34.37\" y2=\"39.6\" fill=\"none\" stroke=\"#0a2b30\"\n            stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n      <path id=\"Path_1098\" data-name=\"Path 1098\"\n            d=\"M43.47,27.71l2.25,5.36a.31.31,0,0,1,0,.13V59.5a.35.35,0,0,1-.35.35H40.86a.35.35,0,0,1-.35-.35h0V33.29a.32.32,0,0,1,0-.14l2.28-5.44a.36.36,0,0,1,.47-.18A.32.32,0,0,1,43.47,27.71Z\"\n            fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n    </g>\n  </g>\n</svg>\n"

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 70.87 70.87\">\n  <title>renewablematerials1-03</title>\n  <path d=\"M32.58,24.09s-1.76-3.42-1.76-5.27\" fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <path\n    d=\"M37.07,16.77a10.34,10.34,0,0,1,5.17-1.66c.78,1.66-.3,6.15-3.42,9H29.75S26,21.36,26,15.11C29.26,14.43,35.9,15.7,37.07,16.77Z\"\n    fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <line x1=\"39.41\" y1=\"18.04\" x2=\"37.07\" y2=\"16.77\" fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <path d=\"M34.24,57.45H24.86c-2.23-.1-7-1.27-7-7.51s.74-17,11.9-25.85\" fill=\"none\" stroke=\"#0a2b30\"\n        stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <path d=\"M33.85,57.45h9.37c2.24-.1,7-1.27,7-7.51s-.75-17-11.91-25.85\" fill=\"#d9ebda\" stroke=\"#0a2b30\"\n        stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  <path d=\"M35.7,24.09a27.6,27.6,0,0,1,4.1,6.73\" fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\"\n        stroke-linejoin=\"round\"/>\n  <g id=\"Group_1005\" data-name=\"Group 1005\">\n    <g id=\"Group_1004\" data-name=\"Group 1004\">\n      <path id=\"Path_999\" data-name=\"Path 999\" d=\"M38.34,48a5.91,5.91,0,0,1-8.27,0\" fill=\"none\" stroke=\"#55a969\"\n            stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n      <path id=\"Path_1000\" data-name=\"Path 1000\" d=\"M35.81,38.07a5.9,5.9,0,0,1,4.12,7.16\" fill=\"none\" stroke=\"#55a969\"\n            stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n      <path id=\"Path_1001\" data-name=\"Path 1001\" d=\"M28.47,45.23a5.89,5.89,0,0,1,4.13-7.16\" fill=\"none\" stroke=\"#55a969\"\n            stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    </g>\n    <path id=\"Path_1002\" data-name=\"Path 1002\" d=\"M32,39.8l.58-1.73-1.73-.58\" fill=\"none\" stroke=\"#55a969\"\n          stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <path id=\"Path_1003\" data-name=\"Path 1003\" d=\"M38.73,43.86l1.2,1.37L41.3,44\" fill=\"none\" stroke=\"#55a969\"\n          stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <path id=\"Path_1004\" data-name=\"Path 1004\" d=\"M31.86,47.64,30.07,48l.36,1.79\" fill=\"none\" stroke=\"#55a969\"\n          stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  </g>\n  <path\n    d=\"M43.86,22.11v4.36a.37.37,0,0,0,.37.37h4.36a1.27,1.27,0,0,0,1.17-.33l5.93-5.93a1.27,1.27,0,0,0,0-1.79L51.91,15a1.26,1.26,0,0,0-1.79,0L44.2,20.94A1.26,1.26,0,0,0,43.86,22.11Z\"\n    fill=\"#fff\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"/>\n  <text transform=\"translate(49.52 25.31) rotate(-45)\" font-size=\"7.87\" fill=\"#00282f\" font-family=\"Rubik-Medium, Rubik\"\n        font-weight=\"500\">€\n  </text>\n</svg>\n"

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"60\" height=\"60\" viewBox=\"0 0 60 60\">\n  <g transform=\"translate(-20 -20)\">\n    <g transform=\"translate(-69.477 -73.723)\">\n      <rect width=\"60\" height=\"60\" transform=\"translate(89.477 93.723)\" fill=\"#f4b8b3\" opacity=\"0\"/>\n    </g>\n    <path d=\"M-2277.982,1803.42l9.391-18.591V1797.3h5.986l-9.391,18.591V1803.42Z\"\n          transform=\"translate(2319.982 -1750.829)\" fill=\"#eb6036\"/>\n    <g transform=\"translate(-335.522 466.348) rotate(-90)\">\n      <path d=\"M499.948,385.375a21.453,21.453,0,0,0-21.453-21.453\" transform=\"translate(-61.8)\" fill=\"none\"\n            stroke=\"#eb6036\" stroke-miterlimit=\"10\" stroke-width=\"1\"/>\n      <path d=\"M478.495,363.922\" transform=\"translate(-61.8)\" fill=\"none\" stroke=\"#5c84c7\" stroke-miterlimit=\"10\"\n            stroke-width=\"1\"/>\n      <path d=\"M561.748,447.175\" transform=\"translate(-123.6 -61.8)\" fill=\"none\" stroke=\"#5c84c7\" stroke-miterlimit=\"10\"\n            stroke-width=\"1\"/>\n      <path d=\"M416.7,363.922a21.452,21.452,0,1,0,21.453,21.453\" transform=\"translate(0)\" fill=\"none\" stroke=\"#0a2b30\"\n            stroke-miterlimit=\"10\" stroke-width=\"1\"/>\n    </g>\n  </g>\n</svg>\n"

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"60\" height=\"60\" viewBox=\"0 0 60 60\">\n  <g transform=\"translate(-89.477 -93.723)\" opacity=\"0.996\">\n    <rect width=\"60\" height=\"60\" transform=\"translate(89.477 93.723)\" fill=\"#f4b8b3\" opacity=\"0\"/>\n    <path d=\"M0,0H5.236V24.721H0Z\" transform=\"translate(121.238 116.635)\" fill=\"#eb6036\"/>\n    <path d=\"M121.336,116.631s7.954-1.552,9.722-3.32a4.527,4.527,0,1,0-6.4-6.4c-.76.76-1.479,2.661-2.053,4.582\"\n          transform=\"translate(-2.568 0)\" fill=\"none\" stroke=\"#eb6036\" stroke-linecap=\"round\" stroke-linejoin=\"round\"\n          stroke-width=\"0.76\"/>\n    <g transform=\"translate(94.083 116.269)\">\n      <rect width=\"8.84\" height=\"25.087\" transform=\"translate(5.918)\" fill=\"#eb6036\"/>\n      <rect width=\"2.36\" height=\"25.087\" transform=\"translate(8.737)\" fill=\"#f4b8b3\"/>\n      <path d=\"M138.544,142.505H110.376V117.785h28.168v16.492\" transform=\"translate(-95.618 -117.418)\" fill=\"none\"\n            stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n      <line y2=\"5.183\" transform=\"translate(42.926 19.903)\" fill=\"#fff\" stroke=\"#0a2b30\" stroke-linecap=\"round\"\n            stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n      <path d=\"M0,0H50.12\" transform=\"translate(0 25.087)\" fill=\"none\" stroke=\"#eb6036\" stroke-linecap=\"round\"\n            stroke-width=\"0.76\"/>\n    </g>\n    <path d=\"M121.428,116.631s-7.953-1.552-9.721-3.32a4.527,4.527,0,0,1,6.4-6.4c1.189,1.19,2.281,5.18,2.868,7.663\"\n          transform=\"translate(-1.535 0)\" fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-linejoin=\"round\"\n          stroke-width=\"0.76\"/>\n  </g>\n</svg>\n"

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"60\" height=\"60\" viewBox=\"0 0 60 60\">\n  <g transform=\"translate(-20 -20)\">\n    <g transform=\"translate(-69.477 -73.723)\">\n      <rect width=\"60\" height=\"60\" transform=\"translate(89.477 93.723)\" fill=\"#f4b8b3\" opacity=\"0\"/>\n    </g>\n    <g transform=\"translate(-2 0.5)\">\n      <g transform=\"translate(-186.126 -109.149)\">\n        <path\n          d=\"M253.8,152.577a9.662,9.662,0,0,0-14.554-6.066,12.587,12.587,0,0,0-22.831,9.848,12.978,12.978,0,0,0,17.458,18.433,9.667,9.667,0,0,0,10.14.974,12.586,12.586,0,1,0,9.788-23.189Z\"\n          transform=\"translate(0 0)\" fill=\"none\" stroke=\"#0a2b30\" stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n        <g transform=\"translate(223.604 154.687)\">\n          <path\n            d=\"M306.921,274.027a.77.77,0,0,1-.37.648,5.253,5.253,0,0,1-3.018.889,4.906,4.906,0,1,1,0-9.813,5.252,5.252,0,0,1,3.018.889.77.77,0,0,1,.37.648.762.762,0,0,1-.7.741.716.716,0,0,1-.407-.111,4.071,4.071,0,0,0-2.129-.592,3.333,3.333,0,1,0,0,6.665,4.072,4.072,0,0,0,2.129-.592.715.715,0,0,1,.407-.111A.762.762,0,0,1,306.921,274.027Z\"\n            transform=\"translate(-298.59 -265.751)\" fill=\"#eb6036\"/>\n          <path\n            d=\"M396.179,270.657a4.742,4.742,0,1,1-4.74-4.906A4.564,4.564,0,0,1,396.179,270.657Zm-1.685-.019a3.071,3.071,0,1,0-3.055,3.388A3.021,3.021,0,0,0,394.494,270.639Z\"\n            transform=\"translate(-376.813 -265.751)\" fill=\"#eb6036\"/>\n        </g>\n        <g transform=\"translate(245.082 158.392)\">\n          <path\n            d=\"M495.465,305.584c.011.236.034.382.034.483a.415.415,0,0,1-.1.3c-.135.236-.572.258-.785.258H491.2c-.808,0-.988-.034-1.077-.3a.628.628,0,0,1-.034-.224,4.263,4.263,0,0,1,.146-.909,2.612,2.612,0,0,1,.864-1.145c.752-.741,1.986-1.638,2.48-2.222a.689.689,0,0,0,.191-.471,1.045,1.045,0,0,0-1.089-.909,1.253,1.253,0,0,0-.819.325c-.3.3-.18.651-.236.808,0,.292-.426.494-.853.494-.37,0-.729-.146-.752-.516-.011-.213-.023-.393-.023-.539a1.44,1.44,0,0,1,.258-.954,2.807,2.807,0,0,1,2.424-1.291c1.414,0,2.794.92,2.794,2.256a2.985,2.985,0,0,1-.976,2.02s-1.3,1.178-1.964,1.885c.741,0,1.4-.056,2.155-.056.191,0,.382,0,.584.011C495.521,305.056,495.431,305.09,495.465,305.584Z\"\n            transform=\"translate(-490 -298.772)\" fill=\"#eb6036\"/>\n        </g>\n      </g>\n    </g>\n    <path d=\"M412.625,811.313c-1.187.125-5.187.25-7.062-2.625\" transform=\"translate(-372 -747)\" fill=\"none\"\n          stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-width=\"0.76\"/>\n    <path d=\"M412.625,811.313c-1.187.125-5.187.25-7.062-2.625\"\n          transform=\"matrix(-0.966, -0.259, 0.259, -0.966, 244.598, 930.331)\" fill=\"none\" stroke=\"#0a2b30\"\n          stroke-linecap=\"round\" stroke-width=\"0.76\"/>\n  </g>\n</svg>\n"

/***/ }),
/* 446 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"60\" height=\"60\" viewBox=\"0 0 60 60\">\n  <g transform=\"translate(-20 -20)\">\n    <g transform=\"translate(-69.477 -73.723)\">\n      <rect width=\"60\" height=\"60\" transform=\"translate(89.477 93.723)\" fill=\"#f4b8b3\" opacity=\"0\"/>\n    </g>\n    <g transform=\"translate(-124.259 -133.042)\">\n      <path\n        d=\"M184.329,173.431l-4.313-5.491,9.188,3.32L187.1,160.879l8.811,10.147,9.029-10.233L202.411,171.5l8.511-4-4.641,5.707\"\n        transform=\"translate(-21.022)\" fill=\"none\" stroke=\"#eb6036\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"\n        stroke-width=\"0.76\"/>\n      <path\n        d=\"M206.61,290.871l4.313,5.491-9.188-3.32,2.107,10.383-8.811-10.147L186,303.51l2.525-10.705-8.511,4,4.641-5.707\"\n        transform=\"translate(-21.022 -98.468)\" fill=\"none\" stroke=\"#eb6036\" stroke-linecap=\"round\"\n        stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n      <path\n        d=\"M154.859,240.119h2.074a1.166,1.166,0,0,0,1.166-1.166V233.5a1.167,1.167,0,0,0-1.166-1.167h-3.52a1.167,1.167,0,0,0-1.167,1.167v8.149a1.167,1.167,0,0,0,1.167,1.166h3.52a1.166,1.166,0,0,0,1.166-1.166h0\"\n        transform=\"translate(0 -54.156)\" fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\"\n        stroke-width=\"0.76\"/>\n      <path\n        d=\"M183,237.845l2.615,1.859a2.421,2.421,0,0,0,1.209.44l6.984.56a2.35,2.35,0,0,0,1.2-.211c1-.475,2.72-1.99,2.62-6.456-.125-5.609-1-6.848-2.964-7.15-1.847-.284-5.14-.72-6.891,1.238\"\n        transform=\"translate(-23.281 -49.843)\" fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\"\n        stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n      <path d=\"M183,221.662c.081-.081,1.877-1.678,3.159-3.078.731-.8,4.876-1.761,6.193-1.3s1.108,2.268,1.108,2.268\"\n            transform=\"translate(-23.281 -42.675)\" fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\"\n            stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n      <path\n        d=\"M313.313,239.724h-2.074a1.167,1.167,0,0,1-1.166-1.167V233.1a1.167,1.167,0,0,1,1.166-1.167h3.521a1.167,1.167,0,0,1,1.166,1.167v8.149a1.166,1.166,0,0,1-1.166,1.166h-3.521a1.166,1.166,0,0,1-1.166-1.166h0\"\n        transform=\"translate(-119.474 -53.857)\" fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\"\n        stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n      <path\n        d=\"M257.825,237.45l-2.615,1.859a2.423,2.423,0,0,1-1.209.44l-6.984.56a2.351,2.351,0,0,1-1.2-.211c-1-.475-2.72-1.99-2.62-6.456.125-5.609,1-6.848,2.964-7.15,1.847-.284,5.14-.72,6.891,1.238\"\n        transform=\"translate(-68.847 -49.544)\" fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\"\n        stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n      <path\n        d=\"M270.784,221.267c-.081-.081-1.877-1.678-3.159-3.078-.731-.8-4.876-1.761-6.193-1.3s-1.108,2.268-1.108,2.268\"\n        transform=\"translate(-81.806 -42.376)\" fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\"\n        stroke-miterlimit=\"10\" stroke-width=\"0.76\"/>\n    </g>\n  </g>\n</svg>\n"

/***/ }),
/* 447 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"21\" height=\"24\" viewBox=\"0 0 21 24\">\n  <g transform=\"translate(548.558 -188.586)\">\n    <path\n      d=\"M-542.6,191.609c0-.24,0-.458,0-.677a2.186,2.186,0,0,1,2.167-2.246c.889,0,1.779.009,2.668.01.614,0,1.228-.023,1.841,0a2.16,2.16,0,0,1,2.106,2.18c0,.236,0,.472,0,.735h5.076a.727.727,0,0,1,.783.743.714.714,0,0,1-.682.7c-.231.008-.462.005-.693,0-.1,0-.147.032-.155.143q-.114,1.593-.237,3.185-.117,1.542-.237,3.083-.186,2.417-.373,4.835c-.09,1.167-.177,2.335-.269,3.5-.063.809-.122,1.618-.2,2.425a2.143,2.143,0,0,1-1.968,1.866c-.659.026-1.319.012-1.978.01-.822,0-1.644-.016-2.466-.017-.512,0-1.025.016-1.537.017-1.566,0-3.131.006-4.7,0a2.13,2.13,0,0,1-2.137-1.735,12.1,12.1,0,0,1-.124-1.345q-.082-1.011-.159-2.021-.109-1.423-.216-2.847t-.219-2.83q-.094-1.213-.186-2.426-.11-1.424-.222-2.847c-.05-.657-.1-1.315-.147-1.972-.023-.3-.043-.607-.077-.909a.169.169,0,0,0-.122-.108c-.214-.011-.428,0-.642-.006a.713.713,0,0,1-.756-.715.72.72,0,0,1,.759-.734q2.435,0,4.87,0Zm-2.876,1.453c0,.083,0,.139,0,.195.074.943.15,1.885.223,2.828.063.814.121,1.629.184,2.443.085,1.1.173,2.2.258,3.3q.137,1.767.269,3.535c.082,1.089.161,2.177.245,3.266.036.472.069.944.124,1.414a.721.721,0,0,0,.712.622l3.16,0,4.662,0q1.294,0,2.587,0a.756.756,0,0,0,.827-.782q.026-.379.057-.758c.049-.584.106-1.167.149-1.75.077-1.022.144-2.045.22-3.067.071-.955.147-1.909.221-2.864q.093-1.2.186-2.409.092-1.179.185-2.359.095-1.22.187-2.441c.029-.386.058-.772.088-1.173Zm4.329-1.469h5.881c0-.217,0-.418,0-.618a.772.772,0,0,0-.844-.854c-.291,0-.582,0-.874,0-1.12,0-2.239,0-3.359,0a.748.748,0,0,0-.8.7C-541.162,191.075-541.148,191.327-541.148,191.593Z\"\n      transform=\"translate(0 0)\" fill=\"#0a2b30\" stroke=\"#0a2b30\" stroke-width=\"0.2\"/>\n    <path\n      d=\"M-297.493,377.457a2.327,2.327,0,0,1,.032.275c0,1.8-.006,3.606-.006,5.409,0,1.73.005,3.46.007,5.189a.7.7,0,0,1-.627.751.709.709,0,0,1-.8-.605,2.669,2.669,0,0,1-.015-.287q0-3.153,0-6.305,0-1.41,0-2.819c0-.084.011-.168.017-.252a1.069,1.069,0,0,0,.148-.106Q-298.111,378.084-297.493,377.457Z\"\n      transform=\"translate(-237.835 -179.904)\" fill=\"#0a2b30\" stroke=\"#0a2b30\" stroke-width=\"0.2\"/>\n    <path\n      d=\"M-392.521,322.11c-.006-.094-.018-.188-.018-.283q0-2.729,0-5.458c0-.732,0-1.463,0-2.195a.738.738,0,0,1,.5-.822.711.711,0,0,1,.93.572,1.939,1.939,0,0,1,.007.2q0,3.151,0,6.3a2.325,2.325,0,0,1-.037.3Z\"\n      transform=\"translate(-148.589 -118.771)\" fill=\"#0a2b30\" stroke=\"#0a2b30\" stroke-width=\"0.2\"/>\n    <path\n      d=\"M-392.44,472.492l1.38-1.386a.528.528,0,0,1,.038.136q0,3.186,0,6.372a.692.692,0,0,1-.573.71.7.7,0,0,1-.791-.4,1.21,1.21,0,0,1-.069-.444q-.007-2.282,0-4.563C-392.458,472.771-392.447,472.632-392.44,472.492Z\"\n      transform=\"translate(-148.67 -269.153)\" fill=\"#0a2b30\" stroke=\"#0a2b30\" stroke-width=\"0.2\"/>\n    <path\n      d=\"M-297.474,316.384q-.62.626-1.241,1.25a1.068,1.068,0,0,1-.148.106c-.006-.066-.018-.132-.018-.2,0-1.116,0-2.232,0-3.348a.733.733,0,0,1,.475-.774.7.7,0,0,1,.949.553c.027.777.01,1.555.01,2.333A.253.253,0,0,1-297.474,316.384Z\"\n      transform=\"translate(-237.853 -118.831)\" fill=\"#0a2b30\" stroke=\"#0a2b30\" stroke-width=\"0.2\"/>\n  </g>\n</svg>\n"

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(248)(__webpack_require__(858))

/***/ }),
/* 449 */,
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/GrowTalent-logo.7350b21.png";

/***/ }),
/* 451 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/tutorial1.a8be5d4.png";

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/tutorial2.6f9ab4d.png";

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/tutorial3.fef44e6.png";

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/tutorial4.7933a73.png";

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/tutorial5.072a0bd.png";

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/tutorial6.8b2e5c3.png";

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/tutorial7.c3c7331.png";

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/tutorial8.649ecee.png";

/***/ }),
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _alert = __webpack_require__(506);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _button = __webpack_require__(507);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _carousel = __webpack_require__(508);
	
	var _carousel2 = _interopRequireDefault(_carousel);
	
	var _collapse = __webpack_require__(509);
	
	var _collapse2 = _interopRequireDefault(_collapse);
	
	var _dropdown = __webpack_require__(510);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _modal = __webpack_require__(511);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _popover = __webpack_require__(512);
	
	var _popover2 = _interopRequireDefault(_popover);
	
	var _scrollspy = __webpack_require__(513);
	
	var _scrollspy2 = _interopRequireDefault(_scrollspy);
	
	var _tab = __webpack_require__(514);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	var _toast = __webpack_require__(515);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _tooltip = __webpack_require__(355);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  Alert: _alert2.default,
	  Button: _button2.default,
	  Carousel: _carousel2.default,
	  Collapse: _collapse2.default,
	  Dropdown: _dropdown2.default,
	  Modal: _modal2.default,
	  Popover: _popover2.default,
	  ScrollSpy: _scrollspy2.default,
	  Tab: _tab2.default,
	  Toast: _toast2.default,
	  Tooltip: _tooltip2.default
	}; /**
	    * --------------------------------------------------------------------------
	    * Bootstrap (v4.3.1): index.umd.js
	    * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	    * --------------------------------------------------------------------------
	    */

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Bootstrap (v4.3.1): alert.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _util = __webpack_require__(22);
	
	var _data = __webpack_require__(34);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _eventHandler = __webpack_require__(41);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _selectorEngine = __webpack_require__(42);
	
	var _selectorEngine2 = _interopRequireDefault(_selectorEngine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */
	
	var NAME = 'alert';
	var VERSION = '4.3.1';
	var DATA_KEY = 'bs.alert';
	var EVENT_KEY = '.' + DATA_KEY;
	var DATA_API_KEY = '.data-api';
	
	var Selector = {
	  DISMISS: '[data-dismiss="alert"]'
	};
	
	var Event = {
	  CLOSE: 'close' + EVENT_KEY,
	  CLOSED: 'closed' + EVENT_KEY,
	  CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
	};
	
	var ClassName = {
	  ALERT: 'alert',
	  FADE: 'fade',
	  SHOW: 'show'
	
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	};
	var Alert = function () {
	  function Alert(element) {
	    _classCallCheck(this, Alert);
	
	    this._element = element;
	    if (this._element) {
	      _data2.default.setData(element, DATA_KEY, this);
	    }
	  }
	
	  // Getters
	
	  _createClass(Alert, [{
	    key: 'close',
	
	
	    // Public
	
	    value: function close(element) {
	      var rootElement = this._element;
	      if (element) {
	        rootElement = this._getRootElement(element);
	      }
	
	      var customEvent = this._triggerCloseEvent(rootElement);
	
	      if (customEvent === null || customEvent.defaultPrevented) {
	        return;
	      }
	
	      this._removeElement(rootElement);
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      _data2.default.removeData(this._element, DATA_KEY);
	      this._element = null;
	    }
	
	    // Private
	
	  }, {
	    key: '_getRootElement',
	    value: function _getRootElement(element) {
	      var selector = (0, _util.getSelectorFromElement)(element);
	      var parent = false;
	
	      if (selector) {
	        parent = _selectorEngine2.default.findOne(selector);
	      }
	
	      if (!parent) {
	        parent = _selectorEngine2.default.closest(element, '.' + ClassName.ALERT);
	      }
	
	      return parent;
	    }
	  }, {
	    key: '_triggerCloseEvent',
	    value: function _triggerCloseEvent(element) {
	      return _eventHandler2.default.trigger(element, Event.CLOSE);
	    }
	  }, {
	    key: '_removeElement',
	    value: function _removeElement(element) {
	      var _this = this;
	
	      element.classList.remove(ClassName.SHOW);
	
	      if (!element.classList.contains(ClassName.FADE)) {
	        this._destroyElement(element);
	        return;
	      }
	
	      var transitionDuration = (0, _util.getTransitionDurationFromElement)(element);
	
	      _eventHandler2.default.one(element, _util.TRANSITION_END, function (event) {
	        return _this._destroyElement(element, event);
	      });
	      (0, _util.emulateTransitionEnd)(element, transitionDuration);
	    }
	  }, {
	    key: '_destroyElement',
	    value: function _destroyElement(element) {
	      if (element.parentNode) {
	        element.parentNode.removeChild(element);
	      }
	
	      _eventHandler2.default.trigger(element, Event.CLOSED);
	    }
	
	    // Static
	
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(config) {
	      return this.each(function () {
	        var data = _data2.default.getData(this, DATA_KEY);
	
	        if (!data) {
	          data = new Alert(this);
	        }
	
	        if (config === 'close') {
	          data[config](this);
	        }
	      });
	    }
	  }, {
	    key: '_handleDismiss',
	    value: function _handleDismiss(alertInstance) {
	      return function (event) {
	        if (event) {
	          event.preventDefault();
	        }
	
	        alertInstance.close(this);
	      };
	    }
	  }, {
	    key: '_getInstance',
	    value: function _getInstance(element) {
	      return _data2.default.getData(element, DATA_KEY);
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return Alert;
	}();
	
	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */
	
	
	_eventHandler2.default.on(document, Event.CLICK_DATA_API, Selector.DISMISS, Alert._handleDismiss(new Alert()));
	
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 * add .alert to jQuery only if jQuery is present
	 */
	
	if (typeof _util.jQuery !== 'undefined') {
	  var JQUERY_NO_CONFLICT = _util.jQuery.fn[NAME];
	  _util.jQuery.fn[NAME] = Alert._jQueryInterface;
	  _util.jQuery.fn[NAME].Constructor = Alert;
	  _util.jQuery.fn[NAME].noConflict = function () {
	    _util.jQuery.fn[NAME] = JQUERY_NO_CONFLICT;
	    return Alert._jQueryInterface;
	  };
	}
	
	exports.default = Alert;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Bootstrap (v4.3.1): button.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _util = __webpack_require__(22);
	
	var _data = __webpack_require__(34);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _eventHandler = __webpack_require__(41);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _selectorEngine = __webpack_require__(42);
	
	var _selectorEngine2 = _interopRequireDefault(_selectorEngine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */
	
	var NAME = 'button';
	var VERSION = '4.3.1';
	var DATA_KEY = 'bs.button';
	var EVENT_KEY = '.' + DATA_KEY;
	var DATA_API_KEY = '.data-api';
	
	var ClassName = {
	  ACTIVE: 'active',
	  BUTTON: 'btn',
	  FOCUS: 'focus'
	};
	
	var Selector = {
	  DATA_TOGGLE_CARROT: '[data-toggle^="button"]',
	  DATA_TOGGLE: '[data-toggle="buttons"]',
	  INPUT: 'input:not([type="hidden"])',
	  ACTIVE: '.active',
	  BUTTON: '.btn'
	};
	
	var Event = {
	  CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY,
	  FOCUS_DATA_API: 'focus' + EVENT_KEY + DATA_API_KEY,
	  BLUR_DATA_API: 'blur' + EVENT_KEY + DATA_API_KEY
	
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	};
	var Button = function () {
	  function Button(element) {
	    _classCallCheck(this, Button);
	
	    this._element = element;
	    _data2.default.setData(element, DATA_KEY, this);
	  }
	
	  // Getters
	
	  _createClass(Button, [{
	    key: 'toggle',
	
	
	    // Public
	
	    value: function toggle() {
	      var triggerChangeEvent = true;
	      var addAriaPressed = true;
	
	      var rootElement = _selectorEngine2.default.closest(this._element, Selector.DATA_TOGGLE);
	
	      if (rootElement) {
	        var input = _selectorEngine2.default.findOne(Selector.INPUT, this._element);
	
	        if (input) {
	          if (input.type === 'radio') {
	            if (input.checked && this._element.classList.contains(ClassName.ACTIVE)) {
	              triggerChangeEvent = false;
	            } else {
	              var activeElement = _selectorEngine2.default.findOne(Selector.ACTIVE, rootElement);
	
	              if (activeElement) {
	                activeElement.classList.remove(ClassName.ACTIVE);
	              }
	            }
	          }
	
	          if (triggerChangeEvent) {
	            if (input.hasAttribute('disabled') || rootElement.hasAttribute('disabled') || input.classList.contains('disabled') || rootElement.classList.contains('disabled')) {
	              return;
	            }
	
	            input.checked = !this._element.classList.contains(ClassName.ACTIVE);
	            _eventHandler2.default.trigger(input, 'change');
	          }
	
	          input.focus();
	          addAriaPressed = false;
	        }
	      }
	
	      if (addAriaPressed) {
	        this._element.setAttribute('aria-pressed', !this._element.classList.contains(ClassName.ACTIVE));
	      }
	
	      if (triggerChangeEvent) {
	        this._element.classList.toggle(ClassName.ACTIVE);
	      }
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      _data2.default.removeData(this._element, DATA_KEY);
	      this._element = null;
	    }
	
	    // Static
	
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(config) {
	      return this.each(function () {
	        var data = _data2.default.getData(this, DATA_KEY);
	
	        if (!data) {
	          data = new Button(this);
	        }
	
	        if (config === 'toggle') {
	          data[config]();
	        }
	      });
	    }
	  }, {
	    key: '_getInstance',
	    value: function _getInstance(element) {
	      return _data2.default.getData(element, DATA_KEY);
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return Button;
	}();
	
	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */
	
	_eventHandler2.default.on(document, Event.CLICK_DATA_API, Selector.DATA_TOGGLE_CARROT, function (event) {
	  event.preventDefault();
	
	  var button = event.target;
	  if (!button.classList.contains(ClassName.BUTTON)) {
	    button = _selectorEngine2.default.closest(button, Selector.BUTTON);
	  }
	
	  var data = _data2.default.getData(button, DATA_KEY);
	  if (!data) {
	    data = new Button(button);
	    _data2.default.setData(button, DATA_KEY, data);
	  }
	
	  data.toggle();
	});
	
	_eventHandler2.default.on(document, Event.FOCUS_DATA_API, Selector.DATA_TOGGLE_CARROT, function (event) {
	  var button = _selectorEngine2.default.closest(event.target, Selector.BUTTON);
	
	  if (button) {
	    button.classList.add(ClassName.FOCUS);
	  }
	});
	
	_eventHandler2.default.on(document, Event.BLUR_DATA_API, Selector.DATA_TOGGLE_CARROT, function (event) {
	  var button = _selectorEngine2.default.closest(event.target, Selector.BUTTON);
	
	  if (button) {
	    button.classList.remove(ClassName.FOCUS);
	  }
	});
	
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 * add .button to jQuery only if jQuery is present
	 */
	
	if (typeof _util.jQuery !== 'undefined') {
	  var JQUERY_NO_CONFLICT = _util.jQuery.fn[NAME];
	  _util.jQuery.fn[NAME] = Button._jQueryInterface;
	  _util.jQuery.fn[NAME].Constructor = Button;
	
	  _util.jQuery.fn[NAME].noConflict = function () {
	    _util.jQuery.fn[NAME] = JQUERY_NO_CONFLICT;
	    return Button._jQueryInterface;
	  };
	}
	
	exports.default = Button;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Bootstrap (v4.3.1): carousel.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _util = __webpack_require__(22);
	
	var _data = __webpack_require__(34);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _eventHandler = __webpack_require__(41);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _manipulator = __webpack_require__(187);
	
	var _manipulator2 = _interopRequireDefault(_manipulator);
	
	var _selectorEngine = __webpack_require__(42);
	
	var _selectorEngine2 = _interopRequireDefault(_selectorEngine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */
	
	var NAME = 'carousel';
	var VERSION = '4.3.1';
	var DATA_KEY = 'bs.carousel';
	var EVENT_KEY = '.' + DATA_KEY;
	var DATA_API_KEY = '.data-api';
	var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key
	var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key
	var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
	var SWIPE_THRESHOLD = 40;
	
	var Default = {
	  interval: 5000,
	  keyboard: true,
	  slide: false,
	  pause: 'hover',
	  wrap: true,
	  touch: true
	};
	
	var DefaultType = {
	  interval: '(number|boolean)',
	  keyboard: 'boolean',
	  slide: '(boolean|string)',
	  pause: '(string|boolean)',
	  wrap: 'boolean',
	  touch: 'boolean'
	};
	
	var Direction = {
	  NEXT: 'next',
	  PREV: 'prev',
	  LEFT: 'left',
	  RIGHT: 'right'
	};
	
	var Event = {
	  SLIDE: 'slide' + EVENT_KEY,
	  SLID: 'slid' + EVENT_KEY,
	  KEYDOWN: 'keydown' + EVENT_KEY,
	  MOUSEENTER: 'mouseenter' + EVENT_KEY,
	  MOUSELEAVE: 'mouseleave' + EVENT_KEY,
	  TOUCHSTART: 'touchstart' + EVENT_KEY,
	  TOUCHMOVE: 'touchmove' + EVENT_KEY,
	  TOUCHEND: 'touchend' + EVENT_KEY,
	  POINTERDOWN: 'pointerdown' + EVENT_KEY,
	  POINTERUP: 'pointerup' + EVENT_KEY,
	  DRAG_START: 'dragstart' + EVENT_KEY,
	  LOAD_DATA_API: 'load' + EVENT_KEY + DATA_API_KEY,
	  CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
	};
	
	var ClassName = {
	  CAROUSEL: 'carousel',
	  ACTIVE: 'active',
	  SLIDE: 'slide',
	  RIGHT: 'carousel-item-right',
	  LEFT: 'carousel-item-left',
	  NEXT: 'carousel-item-next',
	  PREV: 'carousel-item-prev',
	  ITEM: 'carousel-item',
	  POINTER_EVENT: 'pointer-event'
	};
	
	var Selector = {
	  ACTIVE: '.active',
	  ACTIVE_ITEM: '.active.carousel-item',
	  ITEM: '.carousel-item',
	  ITEM_IMG: '.carousel-item img',
	  NEXT_PREV: '.carousel-item-next, .carousel-item-prev',
	  INDICATORS: '.carousel-indicators',
	  DATA_SLIDE: '[data-slide], [data-slide-to]',
	  DATA_RIDE: '[data-ride="carousel"]'
	};
	
	var PointerType = {
	  TOUCH: 'touch',
	  PEN: 'pen'
	
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	};
	var Carousel = function () {
	  function Carousel(element, config) {
	    _classCallCheck(this, Carousel);
	
	    this._items = null;
	    this._interval = null;
	    this._activeElement = null;
	    this._isPaused = false;
	    this._isSliding = false;
	    this.touchTimeout = null;
	    this.touchStartX = 0;
	    this.touchDeltaX = 0;
	
	    this._config = this._getConfig(config);
	    this._element = element;
	    this._indicatorsElement = _selectorEngine2.default.findOne(Selector.INDICATORS, this._element);
	    this._touchSupported = 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
	    this._pointerEvent = Boolean(window.PointerEvent || window.MSPointerEvent);
	
	    this._addEventListeners();
	    _data2.default.setData(element, DATA_KEY, this);
	  }
	
	  // Getters
	
	  _createClass(Carousel, [{
	    key: 'next',
	
	
	    // Public
	
	    value: function next() {
	      if (!this._isSliding) {
	        this._slide(Direction.NEXT);
	      }
	    }
	  }, {
	    key: 'nextWhenVisible',
	    value: function nextWhenVisible() {
	      // Don't call next when the page isn't visible
	      // or the carousel or its parent isn't visible
	      if (!document.hidden && (0, _util.isVisible)(this._element)) {
	        this.next();
	      }
	    }
	  }, {
	    key: 'prev',
	    value: function prev() {
	      if (!this._isSliding) {
	        this._slide(Direction.PREV);
	      }
	    }
	  }, {
	    key: 'pause',
	    value: function pause(event) {
	      if (!event) {
	        this._isPaused = true;
	      }
	
	      if (_selectorEngine2.default.findOne(Selector.NEXT_PREV, this._element)) {
	        (0, _util.triggerTransitionEnd)(this._element);
	        this.cycle(true);
	      }
	
	      clearInterval(this._interval);
	      this._interval = null;
	    }
	  }, {
	    key: 'cycle',
	    value: function cycle(event) {
	      if (!event) {
	        this._isPaused = false;
	      }
	
	      if (this._interval) {
	        clearInterval(this._interval);
	        this._interval = null;
	      }
	
	      if (this._config && this._config.interval && !this._isPaused) {
	        this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
	      }
	    }
	  }, {
	    key: 'to',
	    value: function to(index) {
	      var _this = this;
	
	      this._activeElement = _selectorEngine2.default.findOne(Selector.ACTIVE_ITEM, this._element);
	      var activeIndex = this._getItemIndex(this._activeElement);
	
	      if (index > this._items.length - 1 || index < 0) {
	        return;
	      }
	
	      if (this._isSliding) {
	        _eventHandler2.default.one(this._element, Event.SLID, function () {
	          return _this.to(index);
	        });
	        return;
	      }
	
	      if (activeIndex === index) {
	        this.pause();
	        this.cycle();
	        return;
	      }
	
	      var direction = index > activeIndex ? Direction.NEXT : Direction.PREV;
	
	      this._slide(direction, this._items[index]);
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      _eventHandler2.default.off(this._element, EVENT_KEY);
	      _data2.default.removeData(this._element, DATA_KEY);
	
	      this._items = null;
	      this._config = null;
	      this._element = null;
	      this._interval = null;
	      this._isPaused = null;
	      this._isSliding = null;
	      this._activeElement = null;
	      this._indicatorsElement = null;
	    }
	
	    // Private
	
	  }, {
	    key: '_getConfig',
	    value: function _getConfig(config) {
	      config = _extends({}, Default, config);
	      (0, _util.typeCheckConfig)(NAME, config, DefaultType);
	      return config;
	    }
	  }, {
	    key: '_handleSwipe',
	    value: function _handleSwipe() {
	      var absDeltax = Math.abs(this.touchDeltaX);
	
	      if (absDeltax <= SWIPE_THRESHOLD) {
	        return;
	      }
	
	      var direction = absDeltax / this.touchDeltaX;
	
	      this.touchDeltaX = 0;
	
	      // swipe left
	      if (direction > 0) {
	        this.prev();
	      }
	
	      // swipe right
	      if (direction < 0) {
	        this.next();
	      }
	    }
	  }, {
	    key: '_addEventListeners',
	    value: function _addEventListeners() {
	      var _this2 = this;
	
	      if (this._config.keyboard) {
	        _eventHandler2.default.on(this._element, Event.KEYDOWN, function (event) {
	          return _this2._keydown(event);
	        });
	      }
	
	      if (this._config.pause === 'hover') {
	        _eventHandler2.default.on(this._element, Event.MOUSEENTER, function (event) {
	          return _this2.pause(event);
	        });
	        _eventHandler2.default.on(this._element, Event.MOUSELEAVE, function (event) {
	          return _this2.cycle(event);
	        });
	      }
	
	      if (this._config.touch) {
	        this._addTouchEventListeners();
	      }
	    }
	  }, {
	    key: '_addTouchEventListeners',
	    value: function _addTouchEventListeners() {
	      var _this3 = this;
	
	      if (!this._touchSupported) {
	        return;
	      }
	
	      var start = function start(event) {
	        if (_this3._pointerEvent && PointerType[event.pointerType.toUpperCase()]) {
	          _this3.touchStartX = event.clientX;
	        } else if (!_this3._pointerEvent) {
	          _this3.touchStartX = event.touches[0].clientX;
	        }
	      };
	
	      var move = function move(event) {
	        // ensure swiping with one touch and not pinching
	        if (event.touches && event.touches.length > 1) {
	          _this3.touchDeltaX = 0;
	        } else {
	          _this3.touchDeltaX = event.touches[0].clientX - _this3.touchStartX;
	        }
	      };
	
	      var end = function end(event) {
	        if (_this3._pointerEvent && PointerType[event.pointerType.toUpperCase()]) {
	          _this3.touchDeltaX = event.clientX - _this3.touchStartX;
	        }
	
	        _this3._handleSwipe();
	        if (_this3._config.pause === 'hover') {
	          // If it's a touch-enabled device, mouseenter/leave are fired as
	          // part of the mouse compatibility events on first tap - the carousel
	          // would stop cycling until user tapped out of it;
	          // here, we listen for touchend, explicitly pause the carousel
	          // (as if it's the second time we tap on it, mouseenter compat event
	          // is NOT fired) and after a timeout (to allow for mouse compatibility
	          // events to fire) we explicitly restart cycling
	
	          _this3.pause();
	          if (_this3.touchTimeout) {
	            clearTimeout(_this3.touchTimeout);
	          }
	
	          _this3.touchTimeout = setTimeout(function (event) {
	            return _this3.cycle(event);
	          }, TOUCHEVENT_COMPAT_WAIT + _this3._config.interval);
	        }
	      };
	
	      (0, _util.makeArray)(_selectorEngine2.default.find(Selector.ITEM_IMG, this._element)).forEach(function (itemImg) {
	        _eventHandler2.default.on(itemImg, Event.DRAG_START, function (e) {
	          return e.preventDefault();
	        });
	      });
	
	      if (this._pointerEvent) {
	        _eventHandler2.default.on(this._element, Event.POINTERDOWN, function (event) {
	          return start(event);
	        });
	        _eventHandler2.default.on(this._element, Event.POINTERUP, function (event) {
	          return end(event);
	        });
	
	        this._element.classList.add(ClassName.POINTER_EVENT);
	      } else {
	        _eventHandler2.default.on(this._element, Event.TOUCHSTART, function (event) {
	          return start(event);
	        });
	        _eventHandler2.default.on(this._element, Event.TOUCHMOVE, function (event) {
	          return move(event);
	        });
	        _eventHandler2.default.on(this._element, Event.TOUCHEND, function (event) {
	          return end(event);
	        });
	      }
	    }
	  }, {
	    key: '_keydown',
	    value: function _keydown(event) {
	      if (/input|textarea/i.test(event.target.tagName)) {
	        return;
	      }
	
	      switch (event.which) {
	        case ARROW_LEFT_KEYCODE:
	          event.preventDefault();
	          this.prev();
	          break;
	        case ARROW_RIGHT_KEYCODE:
	          event.preventDefault();
	          this.next();
	          break;
	        default:
	      }
	    }
	  }, {
	    key: '_getItemIndex',
	    value: function _getItemIndex(element) {
	      this._items = element && element.parentNode ? (0, _util.makeArray)(_selectorEngine2.default.find(Selector.ITEM, element.parentNode)) : [];
	
	      return this._items.indexOf(element);
	    }
	  }, {
	    key: '_getItemByDirection',
	    value: function _getItemByDirection(direction, activeElement) {
	      var isNextDirection = direction === Direction.NEXT;
	      var isPrevDirection = direction === Direction.PREV;
	      var activeIndex = this._getItemIndex(activeElement);
	      var lastItemIndex = this._items.length - 1;
	      var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;
	
	      if (isGoingToWrap && !this._config.wrap) {
	        return activeElement;
	      }
	
	      var delta = direction === Direction.PREV ? -1 : 1;
	      var itemIndex = (activeIndex + delta) % this._items.length;
	
	      return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
	    }
	  }, {
	    key: '_triggerSlideEvent',
	    value: function _triggerSlideEvent(relatedTarget, eventDirectionName) {
	      var targetIndex = this._getItemIndex(relatedTarget);
	      var fromIndex = this._getItemIndex(_selectorEngine2.default.findOne(Selector.ACTIVE_ITEM, this._element));
	
	      return _eventHandler2.default.trigger(this._element, Event.SLIDE, {
	        relatedTarget: relatedTarget,
	        direction: eventDirectionName,
	        from: fromIndex,
	        to: targetIndex
	      });
	    }
	  }, {
	    key: '_setActiveIndicatorElement',
	    value: function _setActiveIndicatorElement(element) {
	      if (this._indicatorsElement) {
	        var indicators = _selectorEngine2.default.find(Selector.ACTIVE, this._indicatorsElement);
	        for (var i = 0; i < indicators.length; i++) {
	          indicators[i].classList.remove(ClassName.ACTIVE);
	        }
	
	        var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];
	
	        if (nextIndicator) {
	          nextIndicator.classList.add(ClassName.ACTIVE);
	        }
	      }
	    }
	  }, {
	    key: '_slide',
	    value: function _slide(direction, element) {
	      var _this4 = this;
	
	      var activeElement = _selectorEngine2.default.findOne(Selector.ACTIVE_ITEM, this._element);
	      var activeElementIndex = this._getItemIndex(activeElement);
	      var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);
	
	      var nextElementIndex = this._getItemIndex(nextElement);
	      var isCycling = Boolean(this._interval);
	
	      var directionalClassName = void 0;
	      var orderClassName = void 0;
	      var eventDirectionName = void 0;
	
	      if (direction === Direction.NEXT) {
	        directionalClassName = ClassName.LEFT;
	        orderClassName = ClassName.NEXT;
	        eventDirectionName = Direction.LEFT;
	      } else {
	        directionalClassName = ClassName.RIGHT;
	        orderClassName = ClassName.PREV;
	        eventDirectionName = Direction.RIGHT;
	      }
	
	      if (nextElement && nextElement.classList.contains(ClassName.ACTIVE)) {
	        this._isSliding = false;
	        return;
	      }
	
	      var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);
	      if (slideEvent.defaultPrevented) {
	        return;
	      }
	
	      if (!activeElement || !nextElement) {
	        // Some weirdness is happening, so we bail
	        return;
	      }
	
	      this._isSliding = true;
	
	      if (isCycling) {
	        this.pause();
	      }
	
	      this._setActiveIndicatorElement(nextElement);
	
	      if (this._element.classList.contains(ClassName.SLIDE)) {
	        nextElement.classList.add(orderClassName);
	
	        (0, _util.reflow)(nextElement);
	
	        activeElement.classList.add(directionalClassName);
	        nextElement.classList.add(directionalClassName);
	
	        var nextElementInterval = parseInt(nextElement.getAttribute('data-interval'), 10);
	        if (nextElementInterval) {
	          this._config.defaultInterval = this._config.defaultInterval || this._config.interval;
	          this._config.interval = nextElementInterval;
	        } else {
	          this._config.interval = this._config.defaultInterval || this._config.interval;
	        }
	
	        var transitionDuration = (0, _util.getTransitionDurationFromElement)(activeElement);
	
	        _eventHandler2.default.one(activeElement, _util.TRANSITION_END, function () {
	          nextElement.classList.remove(directionalClassName);
	          nextElement.classList.remove(orderClassName);
	          nextElement.classList.add(ClassName.ACTIVE);
	
	          activeElement.classList.remove(ClassName.ACTIVE);
	          activeElement.classList.remove(orderClassName);
	          activeElement.classList.remove(directionalClassName);
	
	          _this4._isSliding = false;
	
	          setTimeout(function () {
	            _eventHandler2.default.trigger(_this4._element, Event.SLID, {
	              relatedTarget: nextElement,
	              direction: eventDirectionName,
	              from: activeElementIndex,
	              to: nextElementIndex
	            });
	          }, 0);
	        });
	
	        (0, _util.emulateTransitionEnd)(activeElement, transitionDuration);
	      } else {
	        activeElement.classList.remove(ClassName.ACTIVE);
	        nextElement.classList.add(ClassName.ACTIVE);
	
	        this._isSliding = false;
	        _eventHandler2.default.trigger(this._element, Event.SLID, {
	          relatedTarget: nextElement,
	          direction: eventDirectionName,
	          from: activeElementIndex,
	          to: nextElementIndex
	        });
	      }
	
	      if (isCycling) {
	        this.cycle();
	      }
	    }
	
	    // Static
	
	  }], [{
	    key: '_carouselInterface',
	    value: function _carouselInterface(element, config) {
	      var data = _data2.default.getData(element, DATA_KEY);
	      var _config = _extends({}, Default, _manipulator2.default.getDataAttributes(element));
	
	      if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') {
	        _config = _extends({}, _config, config);
	      }
	
	      var action = typeof config === 'string' ? config : _config.slide;
	
	      if (!data) {
	        data = new Carousel(element, _config);
	      }
	
	      if (typeof config === 'number') {
	        data.to(config);
	      } else if (typeof action === 'string') {
	        if (typeof data[action] === 'undefined') {
	          throw new TypeError('No method named "' + action + '"');
	        }
	
	        data[action]();
	      } else if (_config.interval && _config.ride) {
	        data.pause();
	        data.cycle();
	      }
	    }
	  }, {
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(config) {
	      return this.each(function () {
	        Carousel._carouselInterface(this, config);
	      });
	    }
	  }, {
	    key: '_dataApiClickHandler',
	    value: function _dataApiClickHandler(event) {
	      var selector = (0, _util.getSelectorFromElement)(this);
	
	      if (!selector) {
	        return;
	      }
	
	      var target = _selectorEngine2.default.findOne(selector);
	
	      if (!target || !target.classList.contains(ClassName.CAROUSEL)) {
	        return;
	      }
	
	      var config = _extends({}, _manipulator2.default.getDataAttributes(target), _manipulator2.default.getDataAttributes(this));
	      var slideIndex = this.getAttribute('data-slide-to');
	
	      if (slideIndex) {
	        config.interval = false;
	      }
	
	      Carousel._carouselInterface(target, config);
	
	      if (slideIndex) {
	        _data2.default.getData(target, DATA_KEY).to(slideIndex);
	      }
	
	      event.preventDefault();
	    }
	  }, {
	    key: '_getInstance',
	    value: function _getInstance(element) {
	      return _data2.default.getData(element, DATA_KEY);
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }, {
	    key: 'Default',
	    get: function get() {
	      return Default;
	    }
	  }]);
	
	  return Carousel;
	}();
	
	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */
	
	_eventHandler2.default.on(document, Event.CLICK_DATA_API, Selector.DATA_SLIDE, Carousel._dataApiClickHandler);
	
	_eventHandler2.default.on(window, Event.LOAD_DATA_API, function () {
	  var carousels = (0, _util.makeArray)(_selectorEngine2.default.find(Selector.DATA_RIDE));
	  for (var i = 0, len = carousels.length; i < len; i++) {
	    Carousel._carouselInterface(carousels[i], _data2.default.getData(carousels[i], DATA_KEY));
	  }
	});
	
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 * add .carousel to jQuery only if jQuery is present
	 */
	
	if (typeof _util.jQuery !== 'undefined') {
	  var JQUERY_NO_CONFLICT = _util.jQuery.fn[NAME];
	  _util.jQuery.fn[NAME] = Carousel._jQueryInterface;
	  _util.jQuery.fn[NAME].Constructor = Carousel;
	  _util.jQuery.fn[NAME].noConflict = function () {
	    _util.jQuery.fn[NAME] = JQUERY_NO_CONFLICT;
	    return Carousel._jQueryInterface;
	  };
	}
	
	exports.default = Carousel;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Bootstrap (v4.3.1): collapse.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _util = __webpack_require__(22);
	
	var _data = __webpack_require__(34);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _eventHandler = __webpack_require__(41);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _manipulator = __webpack_require__(187);
	
	var _manipulator2 = _interopRequireDefault(_manipulator);
	
	var _selectorEngine = __webpack_require__(42);
	
	var _selectorEngine2 = _interopRequireDefault(_selectorEngine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */
	
	var NAME = 'collapse';
	var VERSION = '4.3.1';
	var DATA_KEY = 'bs.collapse';
	var EVENT_KEY = '.' + DATA_KEY;
	var DATA_API_KEY = '.data-api';
	
	var Default = {
	  toggle: true,
	  parent: ''
	};
	
	var DefaultType = {
	  toggle: 'boolean',
	  parent: '(string|element)'
	};
	
	var Event = {
	  SHOW: 'show' + EVENT_KEY,
	  SHOWN: 'shown' + EVENT_KEY,
	  HIDE: 'hide' + EVENT_KEY,
	  HIDDEN: 'hidden' + EVENT_KEY,
	  CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
	};
	
	var ClassName = {
	  SHOW: 'show',
	  COLLAPSE: 'collapse',
	  COLLAPSING: 'collapsing',
	  COLLAPSED: 'collapsed'
	};
	
	var Dimension = {
	  WIDTH: 'width',
	  HEIGHT: 'height'
	};
	
	var Selector = {
	  ACTIVES: '.show, .collapsing',
	  DATA_TOGGLE: '[data-toggle="collapse"]'
	
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	};
	var Collapse = function () {
	  function Collapse(element, config) {
	    _classCallCheck(this, Collapse);
	
	    this._isTransitioning = false;
	    this._element = element;
	    this._config = this._getConfig(config);
	    this._triggerArray = (0, _util.makeArray)(_selectorEngine2.default.find('[data-toggle="collapse"][href="#' + element.id + '"],' + ('[data-toggle="collapse"][data-target="#' + element.id + '"]')));
	
	    var toggleList = (0, _util.makeArray)(_selectorEngine2.default.find(Selector.DATA_TOGGLE));
	    for (var i = 0, len = toggleList.length; i < len; i++) {
	      var elem = toggleList[i];
	      var selector = (0, _util.getSelectorFromElement)(elem);
	      var filterElement = (0, _util.makeArray)(_selectorEngine2.default.find(selector)).filter(function (foundElem) {
	        return foundElem === element;
	      });
	
	      if (selector !== null && filterElement.length) {
	        this._selector = selector;
	        this._triggerArray.push(elem);
	      }
	    }
	
	    this._parent = this._config.parent ? this._getParent() : null;
	
	    if (!this._config.parent) {
	      this._addAriaAndCollapsedClass(this._element, this._triggerArray);
	    }
	
	    if (this._config.toggle) {
	      this.toggle();
	    }
	
	    _data2.default.setData(element, DATA_KEY, this);
	  }
	
	  // Getters
	
	  _createClass(Collapse, [{
	    key: 'toggle',
	
	
	    // Public
	
	    value: function toggle() {
	      if (this._element.classList.contains(ClassName.SHOW)) {
	        this.hide();
	      } else {
	        this.show();
	      }
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      var _this = this;
	
	      if (this._isTransitioning || this._element.classList.contains(ClassName.SHOW)) {
	        return;
	      }
	
	      var actives = void 0;
	      var activesData = void 0;
	
	      if (this._parent) {
	        actives = (0, _util.makeArray)(_selectorEngine2.default.find(Selector.ACTIVES, this._parent)).filter(function (elem) {
	          if (typeof _this._config.parent === 'string') {
	            return elem.getAttribute('data-parent') === _this._config.parent;
	          }
	
	          return elem.classList.contains(ClassName.COLLAPSE);
	        });
	
	        if (actives.length === 0) {
	          actives = null;
	        }
	      }
	
	      var container = _selectorEngine2.default.findOne(this._selector);
	      if (actives) {
	        var tempActiveData = actives.filter(function (elem) {
	          return container !== elem;
	        });
	        activesData = tempActiveData[0] ? _data2.default.getData(tempActiveData[0], DATA_KEY) : null;
	
	        if (activesData && activesData._isTransitioning) {
	          return;
	        }
	      }
	
	      var startEvent = _eventHandler2.default.trigger(this._element, Event.SHOW);
	      if (startEvent.defaultPrevented) {
	        return;
	      }
	
	      if (actives) {
	        actives.forEach(function (elemActive) {
	          if (container !== elemActive) {
	            Collapse._collapseInterface(elemActive, 'hide');
	          }
	
	          if (!activesData) {
	            _data2.default.setData(elemActive, DATA_KEY, null);
	          }
	        });
	      }
	
	      var dimension = this._getDimension();
	
	      this._element.classList.remove(ClassName.COLLAPSE);
	      this._element.classList.add(ClassName.COLLAPSING);
	
	      this._element.style[dimension] = 0;
	
	      if (this._triggerArray.length) {
	        this._triggerArray.forEach(function (element) {
	          element.classList.remove(ClassName.COLLAPSED);
	          element.setAttribute('aria-expanded', true);
	        });
	      }
	
	      this.setTransitioning(true);
	
	      var complete = function complete() {
	        _this._element.classList.remove(ClassName.COLLAPSING);
	        _this._element.classList.add(ClassName.COLLAPSE);
	        _this._element.classList.add(ClassName.SHOW);
	
	        _this._element.style[dimension] = '';
	
	        _this.setTransitioning(false);
	
	        _eventHandler2.default.trigger(_this._element, Event.SHOWN);
	      };
	
	      var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
	      var scrollSize = 'scroll' + capitalizedDimension;
	      var transitionDuration = (0, _util.getTransitionDurationFromElement)(this._element);
	
	      _eventHandler2.default.one(this._element, _util.TRANSITION_END, complete);
	
	      (0, _util.emulateTransitionEnd)(this._element, transitionDuration);
	      this._element.style[dimension] = this._element[scrollSize] + 'px';
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      var _this2 = this;
	
	      if (this._isTransitioning || !this._element.classList.contains(ClassName.SHOW)) {
	        return;
	      }
	
	      var startEvent = _eventHandler2.default.trigger(this._element, Event.HIDE);
	      if (startEvent.defaultPrevented) {
	        return;
	      }
	
	      var dimension = this._getDimension();
	
	      this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + 'px';
	
	      (0, _util.reflow)(this._element);
	
	      this._element.classList.add(ClassName.COLLAPSING);
	      this._element.classList.remove(ClassName.COLLAPSE);
	      this._element.classList.remove(ClassName.SHOW);
	
	      var triggerArrayLength = this._triggerArray.length;
	      if (triggerArrayLength > 0) {
	        for (var i = 0; i < triggerArrayLength; i++) {
	          var trigger = this._triggerArray[i];
	          var selector = (0, _util.getSelectorFromElement)(trigger);
	
	          if (selector !== null) {
	            var elem = _selectorEngine2.default.findOne(selector);
	
	            if (!elem.classList.contains(ClassName.SHOW)) {
	              trigger.classList.add(ClassName.COLLAPSED);
	              trigger.setAttribute('aria-expanded', false);
	            }
	          }
	        }
	      }
	
	      this.setTransitioning(true);
	
	      var complete = function complete() {
	        _this2.setTransitioning(false);
	        _this2._element.classList.remove(ClassName.COLLAPSING);
	        _this2._element.classList.add(ClassName.COLLAPSE);
	        _eventHandler2.default.trigger(_this2._element, Event.HIDDEN);
	      };
	
	      this._element.style[dimension] = '';
	      var transitionDuration = (0, _util.getTransitionDurationFromElement)(this._element);
	
	      _eventHandler2.default.one(this._element, _util.TRANSITION_END, complete);
	      (0, _util.emulateTransitionEnd)(this._element, transitionDuration);
	    }
	  }, {
	    key: 'setTransitioning',
	    value: function setTransitioning(isTransitioning) {
	      this._isTransitioning = isTransitioning;
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      _data2.default.removeData(this._element, DATA_KEY);
	
	      this._config = null;
	      this._parent = null;
	      this._element = null;
	      this._triggerArray = null;
	      this._isTransitioning = null;
	    }
	
	    // Private
	
	  }, {
	    key: '_getConfig',
	    value: function _getConfig(config) {
	      config = _extends({}, Default, config);
	      config.toggle = Boolean(config.toggle); // Coerce string values
	      (0, _util.typeCheckConfig)(NAME, config, DefaultType);
	      return config;
	    }
	  }, {
	    key: '_getDimension',
	    value: function _getDimension() {
	      var hasWidth = this._element.classList.contains(Dimension.WIDTH);
	      return hasWidth ? Dimension.WIDTH : Dimension.HEIGHT;
	    }
	  }, {
	    key: '_getParent',
	    value: function _getParent() {
	      var _this3 = this;
	
	      var parent = this._config.parent;
	
	
	      if ((0, _util.isElement)(parent)) {
	        // it's a jQuery object
	        if (typeof parent.jquery !== 'undefined' || typeof parent[0] !== 'undefined') {
	          parent = parent[0];
	        }
	      } else {
	        parent = _selectorEngine2.default.findOne(parent);
	      }
	
	      var selector = '[data-toggle="collapse"][data-parent="' + parent + '"]';
	
	      (0, _util.makeArray)(_selectorEngine2.default.find(selector, parent)).forEach(function (element) {
	        _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [element]);
	      });
	
	      return parent;
	    }
	  }, {
	    key: '_addAriaAndCollapsedClass',
	    value: function _addAriaAndCollapsedClass(element, triggerArray) {
	      if (element) {
	        var isOpen = element.classList.contains(ClassName.SHOW);
	
	        if (triggerArray.length) {
	          triggerArray.forEach(function (elem) {
	            if (isOpen) {
	              elem.classList.remove(ClassName.COLLAPSED);
	            } else {
	              elem.classList.add(ClassName.COLLAPSED);
	            }
	
	            elem.setAttribute('aria-expanded', isOpen);
	          });
	        }
	      }
	    }
	
	    // Static
	
	  }], [{
	    key: '_getTargetFromElement',
	    value: function _getTargetFromElement(element) {
	      var selector = (0, _util.getSelectorFromElement)(element);
	      return selector ? _selectorEngine2.default.findOne(selector) : null;
	    }
	  }, {
	    key: '_collapseInterface',
	    value: function _collapseInterface(element, config) {
	      var data = _data2.default.getData(element, DATA_KEY);
	      var _config = _extends({}, Default, _manipulator2.default.getDataAttributes(element), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config ? config : {});
	
	      if (!data && _config.toggle && /show|hide/.test(config)) {
	        _config.toggle = false;
	      }
	
	      if (!data) {
	        data = new Collapse(element, _config);
	      }
	
	      if (typeof config === 'string') {
	        if (typeof data[config] === 'undefined') {
	          throw new TypeError('No method named "' + config + '"');
	        }
	
	        data[config]();
	      }
	    }
	  }, {
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(config) {
	      return this.each(function () {
	        Collapse._collapseInterface(this, config);
	      });
	    }
	  }, {
	    key: '_getInstance',
	    value: function _getInstance(element) {
	      return _data2.default.getData(element, DATA_KEY);
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }, {
	    key: 'Default',
	    get: function get() {
	      return Default;
	    }
	  }]);
	
	  return Collapse;
	}();
	
	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */
	
	_eventHandler2.default.on(document, Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
	  // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
	  if (event.target.tagName === 'A') {
	    event.preventDefault();
	  }
	
	  var triggerData = _manipulator2.default.getDataAttributes(this);
	  var selector = (0, _util.getSelectorFromElement)(this);
	  var selectorElements = (0, _util.makeArray)(_selectorEngine2.default.find(selector));
	
	  selectorElements.forEach(function (element) {
	    var data = _data2.default.getData(element, DATA_KEY);
	    var config = void 0;
	    if (data) {
	      // update parent attribute
	      if (data._parent === null && typeof triggerData.parent === 'string') {
	        data._config.parent = triggerData.parent;
	        data._parent = data._getParent();
	      }
	
	      config = 'toggle';
	    } else {
	      config = triggerData;
	    }
	
	    Collapse._collapseInterface(element, config);
	  });
	});
	
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 * add .collapse to jQuery only if jQuery is present
	 */
	
	if (typeof _util.jQuery !== 'undefined') {
	  var JQUERY_NO_CONFLICT = _util.jQuery.fn[NAME];
	  _util.jQuery.fn[NAME] = Collapse._jQueryInterface;
	  _util.jQuery.fn[NAME].Constructor = Collapse;
	  _util.jQuery.fn[NAME].noConflict = function () {
	    _util.jQuery.fn[NAME] = JQUERY_NO_CONFLICT;
	    return Collapse._jQueryInterface;
	  };
	}
	
	exports.default = Collapse;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Bootstrap (v4.3.1): dropdown.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _util = __webpack_require__(22);
	
	var _data = __webpack_require__(34);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _eventHandler = __webpack_require__(41);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _manipulator = __webpack_require__(187);
	
	var _manipulator2 = _interopRequireDefault(_manipulator);
	
	var _popper = __webpack_require__(426);
	
	var _popper2 = _interopRequireDefault(_popper);
	
	var _selectorEngine = __webpack_require__(42);
	
	var _selectorEngine2 = _interopRequireDefault(_selectorEngine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */
	
	var NAME = 'dropdown';
	var VERSION = '4.3.1';
	var DATA_KEY = 'bs.dropdown';
	var EVENT_KEY = '.' + DATA_KEY;
	var DATA_API_KEY = '.data-api';
	var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key
	var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key
	var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key
	var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key
	var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key
	var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)
	var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + '|' + ARROW_DOWN_KEYCODE + '|' + ESCAPE_KEYCODE);
	
	var Event = {
	  HIDE: 'hide' + EVENT_KEY,
	  HIDDEN: 'hidden' + EVENT_KEY,
	  SHOW: 'show' + EVENT_KEY,
	  SHOWN: 'shown' + EVENT_KEY,
	  CLICK: 'click' + EVENT_KEY,
	  CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY,
	  KEYDOWN_DATA_API: 'keydown' + EVENT_KEY + DATA_API_KEY,
	  KEYUP_DATA_API: 'keyup' + EVENT_KEY + DATA_API_KEY
	};
	
	var ClassName = {
	  DISABLED: 'disabled',
	  SHOW: 'show',
	  DROPUP: 'dropup',
	  DROPRIGHT: 'dropright',
	  DROPLEFT: 'dropleft',
	  MENURIGHT: 'dropdown-menu-right',
	  POSITION_STATIC: 'position-static'
	};
	
	var Selector = {
	  DATA_TOGGLE: '[data-toggle="dropdown"]',
	  FORM_CHILD: '.dropdown form',
	  MENU: '.dropdown-menu',
	  NAVBAR_NAV: '.navbar-nav',
	  VISIBLE_ITEMS: '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)'
	};
	
	var AttachmentMap = {
	  TOP: 'top-start',
	  TOPEND: 'top-end',
	  BOTTOM: 'bottom-start',
	  BOTTOMEND: 'bottom-end',
	  RIGHT: 'right-start',
	  RIGHTEND: 'right-end',
	  LEFT: 'left-start',
	  LEFTEND: 'left-end'
	};
	
	var Default = {
	  offset: 0,
	  flip: true,
	  boundary: 'scrollParent',
	  reference: 'toggle',
	  display: 'dynamic'
	};
	
	var DefaultType = {
	  offset: '(number|string|function)',
	  flip: 'boolean',
	  boundary: '(string|element)',
	  reference: '(string|element)',
	  display: 'string'
	
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	};
	var Dropdown = function () {
	  function Dropdown(element, config) {
	    _classCallCheck(this, Dropdown);
	
	    this._element = element;
	    this._popper = null;
	    this._config = this._getConfig(config);
	    this._menu = this._getMenuElement();
	    this._inNavbar = this._detectNavbar();
	
	    this._addEventListeners();
	    _data2.default.setData(element, DATA_KEY, this);
	  }
	
	  // Getters
	
	  _createClass(Dropdown, [{
	    key: 'toggle',
	
	
	    // Public
	
	    value: function toggle() {
	      if (this._element.disabled || this._element.classList.contains(ClassName.DISABLED)) {
	        return;
	      }
	
	      var parent = Dropdown._getParentFromElement(this._element);
	      var isActive = this._menu.classList.contains(ClassName.SHOW);
	
	      Dropdown._clearMenus();
	
	      if (isActive) {
	        return;
	      }
	
	      var relatedTarget = {
	        relatedTarget: this._element
	      };
	      var showEvent = _eventHandler2.default.trigger(parent, Event.SHOW, relatedTarget);
	
	      if (showEvent.defaultPrevented) {
	        return;
	      }
	
	      // Disable totally Popper.js for Dropdown in Navbar
	      if (!this._inNavbar) {
	        /**
	         * Check for Popper dependency
	         * Popper - https://popper.js.org
	         */
	        if (typeof _popper2.default === 'undefined') {
	          throw new TypeError('Bootstrap\'s dropdowns require Popper.js (https://popper.js.org)');
	        }
	
	        var referenceElement = this._element;
	
	        if (this._config.reference === 'parent') {
	          referenceElement = parent;
	        } else if ((0, _util.isElement)(this._config.reference)) {
	          referenceElement = this._config.reference;
	
	          // Check if it's jQuery element
	          if (typeof this._config.reference.jquery !== 'undefined') {
	            referenceElement = this._config.reference[0];
	          }
	        }
	
	        // If boundary is not `scrollParent`, then set position to `static`
	        // to allow the menu to "escape" the scroll parent's boundaries
	        // https://github.com/twbs/bootstrap/issues/24251
	        if (this._config.boundary !== 'scrollParent') {
	          parent.classList.add(ClassName.POSITION_STATIC);
	        }
	
	        this._popper = new _popper2.default(referenceElement, this._menu, this._getPopperConfig());
	      }
	
	      // If this is a touch-enabled device we add extra
	      // empty mouseover listeners to the body's immediate children;
	      // only needed because of broken event delegation on iOS
	      // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
	      if ('ontouchstart' in document.documentElement && !(0, _util.makeArray)(_selectorEngine2.default.closest(parent, Selector.NAVBAR_NAV)).length) {
	        (0, _util.makeArray)(document.body.children).forEach(function (elem) {
	          return _eventHandler2.default.on(elem, 'mouseover', null, (0, _util.noop)());
	        });
	      }
	
	      this._element.focus();
	      this._element.setAttribute('aria-expanded', true);
	
	      _manipulator2.default.toggleClass(this._menu, ClassName.SHOW);
	      _manipulator2.default.toggleClass(parent, ClassName.SHOW);
	      _eventHandler2.default.trigger(parent, Event.SHOWN, relatedTarget);
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      if (this._element.disabled || this._element.classList.contains(ClassName.DISABLED) || this._menu.classList.contains(ClassName.SHOW)) {
	        return;
	      }
	
	      var parent = Dropdown._getParentFromElement(this._element);
	      var relatedTarget = {
	        relatedTarget: this._element
	      };
	
	      var showEvent = _eventHandler2.default.trigger(parent, Event.SHOW, relatedTarget);
	
	      if (showEvent.defaultPrevented) {
	        return;
	      }
	
	      _manipulator2.default.toggleClass(this._menu, ClassName.SHOW);
	      _manipulator2.default.toggleClass(parent, ClassName.SHOW);
	      _eventHandler2.default.trigger(parent, Event.SHOWN, relatedTarget);
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      if (this._element.disabled || this._element.classList.contains(ClassName.DISABLED) || !this._menu.classList.contains(ClassName.SHOW)) {
	        return;
	      }
	
	      var parent = Dropdown._getParentFromElement(this._element);
	      var relatedTarget = {
	        relatedTarget: this._element
	      };
	
	      var hideEvent = _eventHandler2.default.trigger(parent, Event.HIDE, relatedTarget);
	
	      if (hideEvent.defaultPrevented) {
	        return;
	      }
	
	      _manipulator2.default.toggleClass(this._menu, ClassName.SHOW);
	      _manipulator2.default.toggleClass(parent, ClassName.SHOW);
	      _eventHandler2.default.trigger(parent, Event.HIDDEN, relatedTarget);
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      _data2.default.removeData(this._element, DATA_KEY);
	      _eventHandler2.default.off(this._element, EVENT_KEY);
	      this._element = null;
	      this._menu = null;
	      if (this._popper !== null) {
	        this._popper.destroy();
	        this._popper = null;
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      this._inNavbar = this._detectNavbar();
	      if (this._popper !== null) {
	        this._popper.scheduleUpdate();
	      }
	    }
	
	    // Private
	
	  }, {
	    key: '_addEventListeners',
	    value: function _addEventListeners() {
	      var _this = this;
	
	      _eventHandler2.default.on(this._element, Event.CLICK, function (event) {
	        event.preventDefault();
	        event.stopPropagation();
	        _this.toggle();
	      });
	    }
	  }, {
	    key: '_getConfig',
	    value: function _getConfig(config) {
	      config = _extends({}, this.constructor.Default, _manipulator2.default.getDataAttributes(this._element), config);
	
	      (0, _util.typeCheckConfig)(NAME, config, this.constructor.DefaultType);
	
	      return config;
	    }
	  }, {
	    key: '_getMenuElement',
	    value: function _getMenuElement() {
	      if (!this._menu) {
	        var parent = Dropdown._getParentFromElement(this._element);
	
	        if (parent) {
	          this._menu = _selectorEngine2.default.findOne(Selector.MENU, parent);
	        }
	      }
	
	      return this._menu;
	    }
	  }, {
	    key: '_getPlacement',
	    value: function _getPlacement() {
	      var parentDropdown = this._element.parentNode;
	      var placement = AttachmentMap.BOTTOM;
	
	      // Handle dropup
	      if (parentDropdown.classList.contains(ClassName.DROPUP)) {
	        placement = AttachmentMap.TOP;
	        if (this._menu.classList.contains(ClassName.MENURIGHT)) {
	          placement = AttachmentMap.TOPEND;
	        }
	      } else if (parentDropdown.classList.contains(ClassName.DROPRIGHT)) {
	        placement = AttachmentMap.RIGHT;
	      } else if (parentDropdown.classList.contains(ClassName.DROPLEFT)) {
	        placement = AttachmentMap.LEFT;
	      } else if (this._menu.classList.contains(ClassName.MENURIGHT)) {
	        placement = AttachmentMap.BOTTOMEND;
	      }
	
	      return placement;
	    }
	  }, {
	    key: '_detectNavbar',
	    value: function _detectNavbar() {
	      return Boolean(_selectorEngine2.default.closest(this._element, '.navbar'));
	    }
	  }, {
	    key: '_getOffset',
	    value: function _getOffset() {
	      var _this2 = this;
	
	      var offset = {};
	
	      if (typeof this._config.offset === 'function') {
	        offset.fn = function (data) {
	          data.offsets = _extends({}, data.offsets, _this2._config.offset(data.offsets, _this2._element) || {});
	
	          return data;
	        };
	      } else {
	        offset.offset = this._config.offset;
	      }
	
	      return offset;
	    }
	  }, {
	    key: '_getPopperConfig',
	    value: function _getPopperConfig() {
	      var popperConfig = {
	        placement: this._getPlacement(),
	        modifiers: {
	          offset: this._getOffset(),
	          flip: {
	            enabled: this._config.flip
	          },
	          preventOverflow: {
	            boundariesElement: this._config.boundary
	          }
	        }
	
	        // Disable Popper.js if we have a static display
	      };if (this._config.display === 'static') {
	        popperConfig.modifiers.applyStyle = {
	          enabled: false
	        };
	      }
	
	      return popperConfig;
	    }
	
	    // Static
	
	  }], [{
	    key: '_dropdownInterface',
	    value: function _dropdownInterface(element, config) {
	      var data = _data2.default.getData(element, DATA_KEY);
	      var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' ? config : null;
	
	      if (!data) {
	        data = new Dropdown(element, _config);
	      }
	
	      if (typeof config === 'string') {
	        if (typeof data[config] === 'undefined') {
	          throw new TypeError('No method named "' + config + '"');
	        }
	
	        data[config]();
	      }
	    }
	  }, {
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(config) {
	      return this.each(function () {
	        Dropdown._dropdownInterface(this, config);
	      });
	    }
	  }, {
	    key: '_clearMenus',
	    value: function _clearMenus(event) {
	      if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === 'keyup' && event.which !== TAB_KEYCODE)) {
	        return;
	      }
	
	      var toggles = (0, _util.makeArray)(_selectorEngine2.default.find(Selector.DATA_TOGGLE));
	      for (var i = 0, len = toggles.length; i < len; i++) {
	        var parent = Dropdown._getParentFromElement(toggles[i]);
	        var context = _data2.default.getData(toggles[i], DATA_KEY);
	        var relatedTarget = {
	          relatedTarget: toggles[i]
	        };
	
	        if (event && event.type === 'click') {
	          relatedTarget.clickEvent = event;
	        }
	
	        if (!context) {
	          continue;
	        }
	
	        var dropdownMenu = context._menu;
	        if (!parent.classList.contains(ClassName.SHOW)) {
	          continue;
	        }
	
	        if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'keyup' && event.which === TAB_KEYCODE) && parent.contains(event.target)) {
	          continue;
	        }
	
	        var hideEvent = _eventHandler2.default.trigger(parent, Event.HIDE, relatedTarget);
	        if (hideEvent.defaultPrevented) {
	          continue;
	        }
	
	        // If this is a touch-enabled device we remove the extra
	        // empty mouseover listeners we added for iOS support
	        if ('ontouchstart' in document.documentElement) {
	          (0, _util.makeArray)(document.body.children).forEach(function (elem) {
	            return _eventHandler2.default.off(elem, 'mouseover', null, (0, _util.noop)());
	          });
	        }
	
	        toggles[i].setAttribute('aria-expanded', 'false');
	
	        dropdownMenu.classList.remove(ClassName.SHOW);
	        parent.classList.remove(ClassName.SHOW);
	        _eventHandler2.default.trigger(parent, Event.HIDDEN, relatedTarget);
	      }
	    }
	  }, {
	    key: '_getParentFromElement',
	    value: function _getParentFromElement(element) {
	      var parent = void 0;
	      var selector = (0, _util.getSelectorFromElement)(element);
	
	      if (selector) {
	        parent = _selectorEngine2.default.findOne(selector);
	      }
	
	      return parent || element.parentNode;
	    }
	  }, {
	    key: '_dataApiKeydownHandler',
	    value: function _dataApiKeydownHandler(event) {
	      // If not input/textarea:
	      //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
	      // If input/textarea:
	      //  - If space key => not a dropdown command
	      //  - If key is other than escape
	      //    - If key is not up or down => not a dropdown command
	      //    - If trigger inside the menu => not a dropdown command
	      if (/input|textarea/i.test(event.target.tagName) ? event.which === SPACE_KEYCODE || event.which !== ESCAPE_KEYCODE && (event.which !== ARROW_DOWN_KEYCODE && event.which !== ARROW_UP_KEYCODE || _selectorEngine2.default.closest(event.target, Selector.MENU)) : !REGEXP_KEYDOWN.test(event.which)) {
	        return;
	      }
	
	      event.preventDefault();
	      event.stopPropagation();
	
	      if (this.disabled || this.classList.contains(ClassName.DISABLED)) {
	        return;
	      }
	
	      var parent = Dropdown._getParentFromElement(this);
	      var isActive = parent.classList.contains(ClassName.SHOW);
	
	      if (!isActive || isActive && (event.which === ESCAPE_KEYCODE || event.which === SPACE_KEYCODE)) {
	        if (event.which === ESCAPE_KEYCODE) {
	          _selectorEngine2.default.findOne(Selector.DATA_TOGGLE, parent).focus();
	        }
	
	        Dropdown._clearMenus();
	        return;
	      }
	
	      var items = (0, _util.makeArray)(_selectorEngine2.default.find(Selector.VISIBLE_ITEMS, parent));
	
	      if (!items.length) {
	        return;
	      }
	
	      var index = items.indexOf(event.target);
	
	      if (event.which === ARROW_UP_KEYCODE && index > 0) {
	        // Up
	        index--;
	      }
	
	      if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
	        // Down
	        index++;
	      }
	
	      if (index < 0) {
	        index = 0;
	      }
	
	      items[index].focus();
	    }
	  }, {
	    key: '_getInstance',
	    value: function _getInstance(element) {
	      return _data2.default.getData(element, DATA_KEY);
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }, {
	    key: 'Default',
	    get: function get() {
	      return Default;
	    }
	  }, {
	    key: 'DefaultType',
	    get: function get() {
	      return DefaultType;
	    }
	  }]);
	
	  return Dropdown;
	}();
	
	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */
	
	_eventHandler2.default.on(document, Event.KEYDOWN_DATA_API, Selector.DATA_TOGGLE, Dropdown._dataApiKeydownHandler);
	_eventHandler2.default.on(document, Event.KEYDOWN_DATA_API, Selector.MENU, Dropdown._dataApiKeydownHandler);
	_eventHandler2.default.on(document, Event.CLICK_DATA_API, Dropdown._clearMenus);
	_eventHandler2.default.on(document, Event.KEYUP_DATA_API, Dropdown._clearMenus);
	_eventHandler2.default.on(document, Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
	  event.preventDefault();
	  event.stopPropagation();
	  Dropdown._dropdownInterface(this, 'toggle');
	});
	_eventHandler2.default.on(document, Event.CLICK_DATA_API, Selector.FORM_CHILD, function (e) {
	  return e.stopPropagation();
	});
	
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 * add .dropdown to jQuery only if jQuery is present
	 */
	
	if (typeof _util.jQuery !== 'undefined') {
	  var JQUERY_NO_CONFLICT = _util.jQuery.fn[NAME];
	  _util.jQuery.fn[NAME] = Dropdown._jQueryInterface;
	  _util.jQuery.fn[NAME].Constructor = Dropdown;
	  _util.jQuery.fn[NAME].noConflict = function () {
	    _util.jQuery.fn[NAME] = JQUERY_NO_CONFLICT;
	    return Dropdown._jQueryInterface;
	  };
	}
	
	exports.default = Dropdown;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Bootstrap (v4.3.1): modal.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _util = __webpack_require__(22);
	
	var _data = __webpack_require__(34);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _eventHandler = __webpack_require__(41);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _manipulator = __webpack_require__(187);
	
	var _manipulator2 = _interopRequireDefault(_manipulator);
	
	var _selectorEngine = __webpack_require__(42);
	
	var _selectorEngine2 = _interopRequireDefault(_selectorEngine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */
	
	var NAME = 'modal';
	var VERSION = '4.3.1';
	var DATA_KEY = 'bs.modal';
	var EVENT_KEY = '.' + DATA_KEY;
	var DATA_API_KEY = '.data-api';
	var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key
	
	var Default = {
	  backdrop: true,
	  keyboard: true,
	  focus: true,
	  show: true
	};
	
	var DefaultType = {
	  backdrop: '(boolean|string)',
	  keyboard: 'boolean',
	  focus: 'boolean',
	  show: 'boolean'
	};
	
	var Event = {
	  HIDE: 'hide' + EVENT_KEY,
	  HIDDEN: 'hidden' + EVENT_KEY,
	  SHOW: 'show' + EVENT_KEY,
	  SHOWN: 'shown' + EVENT_KEY,
	  FOCUSIN: 'focusin' + EVENT_KEY,
	  RESIZE: 'resize' + EVENT_KEY,
	  CLICK_DISMISS: 'click.dismiss' + EVENT_KEY,
	  KEYDOWN_DISMISS: 'keydown.dismiss' + EVENT_KEY,
	  MOUSEUP_DISMISS: 'mouseup.dismiss' + EVENT_KEY,
	  MOUSEDOWN_DISMISS: 'mousedown.dismiss' + EVENT_KEY,
	  CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
	};
	
	var ClassName = {
	  SCROLLABLE: 'modal-dialog-scrollable',
	  SCROLLBAR_MEASURER: 'modal-scrollbar-measure',
	  BACKDROP: 'modal-backdrop',
	  OPEN: 'modal-open',
	  FADE: 'fade',
	  SHOW: 'show'
	};
	
	var Selector = {
	  DIALOG: '.modal-dialog',
	  MODAL_BODY: '.modal-body',
	  DATA_TOGGLE: '[data-toggle="modal"]',
	  DATA_DISMISS: '[data-dismiss="modal"]',
	  FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
	  STICKY_CONTENT: '.sticky-top'
	
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	};
	var Modal = function () {
	  function Modal(element, config) {
	    _classCallCheck(this, Modal);
	
	    this._config = this._getConfig(config);
	    this._element = element;
	    this._dialog = _selectorEngine2.default.findOne(Selector.DIALOG, element);
	    this._backdrop = null;
	    this._isShown = false;
	    this._isBodyOverflowing = false;
	    this._ignoreBackdropClick = false;
	    this._isTransitioning = false;
	    this._scrollbarWidth = 0;
	    _data2.default.setData(element, DATA_KEY, this);
	  }
	
	  // Getters
	
	  _createClass(Modal, [{
	    key: 'toggle',
	
	
	    // Public
	
	    value: function toggle(relatedTarget) {
	      return this._isShown ? this.hide() : this.show(relatedTarget);
	    }
	  }, {
	    key: 'show',
	    value: function show(relatedTarget) {
	      var _this = this;
	
	      if (this._isShown || this._isTransitioning) {
	        return;
	      }
	
	      if (this._element.classList.contains(ClassName.FADE)) {
	        this._isTransitioning = true;
	      }
	
	      var showEvent = _eventHandler2.default.trigger(this._element, Event.SHOW, {
	        relatedTarget: relatedTarget
	      });
	
	      if (this._isShown || showEvent.defaultPrevented) {
	        return;
	      }
	
	      this._isShown = true;
	
	      this._checkScrollbar();
	      this._setScrollbar();
	
	      this._adjustDialog();
	
	      this._setEscapeEvent();
	      this._setResizeEvent();
	
	      _eventHandler2.default.on(this._element, Event.CLICK_DISMISS, Selector.DATA_DISMISS, function (event) {
	        return _this.hide(event);
	      });
	
	      _eventHandler2.default.on(this._dialog, Event.MOUSEDOWN_DISMISS, function () {
	        _eventHandler2.default.one(_this._element, Event.MOUSEUP_DISMISS, function (event) {
	          if (event.target === _this._element) {
	            _this._ignoreBackdropClick = true;
	          }
	        });
	      });
	
	      this._showBackdrop(function () {
	        return _this._showElement(relatedTarget);
	      });
	    }
	  }, {
	    key: 'hide',
	    value: function hide(event) {
	      var _this2 = this;
	
	      if (event) {
	        event.preventDefault();
	      }
	
	      if (!this._isShown || this._isTransitioning) {
	        return;
	      }
	
	      var hideEvent = _eventHandler2.default.trigger(this._element, Event.HIDE);
	
	      if (!this._isShown || hideEvent.defaultPrevented) {
	        return;
	      }
	
	      this._isShown = false;
	      var transition = this._element.classList.contains(ClassName.FADE);
	
	      if (transition) {
	        this._isTransitioning = true;
	      }
	
	      this._setEscapeEvent();
	      this._setResizeEvent();
	
	      _eventHandler2.default.off(document, Event.FOCUSIN);
	
	      this._element.classList.remove(ClassName.SHOW);
	
	      _eventHandler2.default.off(this._element, Event.CLICK_DISMISS);
	      _eventHandler2.default.off(this._dialog, Event.MOUSEDOWN_DISMISS);
	
	      if (transition) {
	        var transitionDuration = (0, _util.getTransitionDurationFromElement)(this._element);
	
	        _eventHandler2.default.one(this._element, _util.TRANSITION_END, function (event) {
	          return _this2._hideModal(event);
	        });
	        (0, _util.emulateTransitionEnd)(this._element, transitionDuration);
	      } else {
	        this._hideModal();
	      }
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      [window, this._element, this._dialog].forEach(function (htmlElement) {
	        return _eventHandler2.default.off(htmlElement, EVENT_KEY);
	      });
	
	      /**
	       * `document` has 2 events `Event.FOCUSIN` and `Event.CLICK_DATA_API`
	       * Do not move `document` in `htmlElements` array
	       * It will remove `Event.CLICK_DATA_API` event that should remain
	       */
	      _eventHandler2.default.off(document, Event.FOCUSIN);
	
	      _data2.default.removeData(this._element, DATA_KEY);
	
	      this._config = null;
	      this._element = null;
	      this._dialog = null;
	      this._backdrop = null;
	      this._isShown = null;
	      this._isBodyOverflowing = null;
	      this._ignoreBackdropClick = null;
	      this._isTransitioning = null;
	      this._scrollbarWidth = null;
	    }
	  }, {
	    key: 'handleUpdate',
	    value: function handleUpdate() {
	      this._adjustDialog();
	    }
	
	    // Private
	
	  }, {
	    key: '_getConfig',
	    value: function _getConfig(config) {
	      config = _extends({}, Default, config);
	      (0, _util.typeCheckConfig)(NAME, config, DefaultType);
	      return config;
	    }
	  }, {
	    key: '_showElement',
	    value: function _showElement(relatedTarget) {
	      var _this3 = this;
	
	      var transition = this._element.classList.contains(ClassName.FADE);
	
	      if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
	        // Don't move modal's DOM position
	        document.body.appendChild(this._element);
	      }
	
	      this._element.style.display = 'block';
	      this._element.removeAttribute('aria-hidden');
	      this._element.setAttribute('aria-modal', true);
	
	      if (this._dialog.classList.contains(ClassName.SCROLLABLE)) {
	        _selectorEngine2.default.findOne(Selector.MODAL_BODY, this._dialog).scrollTop = 0;
	      } else {
	        this._element.scrollTop = 0;
	      }
	
	      if (transition) {
	        (0, _util.reflow)(this._element);
	      }
	
	      this._element.classList.add(ClassName.SHOW);
	
	      if (this._config.focus) {
	        this._enforceFocus();
	      }
	
	      var transitionComplete = function transitionComplete() {
	        if (_this3._config.focus) {
	          _this3._element.focus();
	        }
	
	        _this3._isTransitioning = false;
	        _eventHandler2.default.trigger(_this3._element, Event.SHOWN, {
	          relatedTarget: relatedTarget
	        });
	      };
	
	      if (transition) {
	        var transitionDuration = (0, _util.getTransitionDurationFromElement)(this._dialog);
	
	        _eventHandler2.default.one(this._dialog, _util.TRANSITION_END, transitionComplete);
	        (0, _util.emulateTransitionEnd)(this._dialog, transitionDuration);
	      } else {
	        transitionComplete();
	      }
	    }
	  }, {
	    key: '_enforceFocus',
	    value: function _enforceFocus() {
	      var _this4 = this;
	
	      _eventHandler2.default.off(document, Event.FOCUSIN); // guard against infinite focus loop
	      _eventHandler2.default.on(document, Event.FOCUSIN, function (event) {
	        if (document !== event.target && _this4._element !== event.target && !_this4._element.contains(event.target)) {
	          _this4._element.focus();
	        }
	      });
	    }
	  }, {
	    key: '_setEscapeEvent',
	    value: function _setEscapeEvent() {
	      var _this5 = this;
	
	      if (this._isShown && this._config.keyboard) {
	        _eventHandler2.default.on(this._element, Event.KEYDOWN_DISMISS, function (event) {
	          if (event.which === ESCAPE_KEYCODE) {
	            event.preventDefault();
	            _this5.hide();
	          }
	        });
	      } else if (!this._isShown) {
	        _eventHandler2.default.off(this._element, Event.KEYDOWN_DISMISS);
	      }
	    }
	  }, {
	    key: '_setResizeEvent',
	    value: function _setResizeEvent() {
	      var _this6 = this;
	
	      if (this._isShown) {
	        _eventHandler2.default.on(window, Event.RESIZE, function (event) {
	          return _this6.handleUpdate(event);
	        });
	      } else {
	        _eventHandler2.default.off(window, Event.RESIZE);
	      }
	    }
	  }, {
	    key: '_hideModal',
	    value: function _hideModal() {
	      var _this7 = this;
	
	      this._element.style.display = 'none';
	      this._element.setAttribute('aria-hidden', true);
	      this._element.removeAttribute('aria-modal');
	      this._isTransitioning = false;
	      this._showBackdrop(function () {
	        document.body.classList.remove(ClassName.OPEN);
	        _this7._resetAdjustments();
	        _this7._resetScrollbar();
	        _eventHandler2.default.trigger(_this7._element, Event.HIDDEN);
	      });
	    }
	  }, {
	    key: '_removeBackdrop',
	    value: function _removeBackdrop() {
	      if (this._backdrop) {
	        this._backdrop.parentNode.removeChild(this._backdrop);
	        this._backdrop = null;
	      }
	    }
	  }, {
	    key: '_showBackdrop',
	    value: function _showBackdrop(callback) {
	      var _this8 = this;
	
	      var animate = this._element.classList.contains(ClassName.FADE) ? ClassName.FADE : '';
	
	      if (this._isShown && this._config.backdrop) {
	        this._backdrop = document.createElement('div');
	        this._backdrop.className = ClassName.BACKDROP;
	
	        if (animate) {
	          this._backdrop.classList.add(animate);
	        }
	
	        document.body.appendChild(this._backdrop);
	
	        _eventHandler2.default.on(this._element, Event.CLICK_DISMISS, function (event) {
	          if (_this8._ignoreBackdropClick) {
	            _this8._ignoreBackdropClick = false;
	            return;
	          }
	
	          if (event.target !== event.currentTarget) {
	            return;
	          }
	
	          if (_this8._config.backdrop === 'static') {
	            _this8._element.focus();
	          } else {
	            _this8.hide();
	          }
	        });
	
	        if (animate) {
	          (0, _util.reflow)(this._backdrop);
	        }
	
	        this._backdrop.classList.add(ClassName.SHOW);
	
	        if (!callback) {
	          return;
	        }
	
	        if (!animate) {
	          callback();
	          return;
	        }
	
	        var backdropTransitionDuration = (0, _util.getTransitionDurationFromElement)(this._backdrop);
	
	        _eventHandler2.default.one(this._backdrop, _util.TRANSITION_END, callback);
	        (0, _util.emulateTransitionEnd)(this._backdrop, backdropTransitionDuration);
	      } else if (!this._isShown && this._backdrop) {
	        this._backdrop.classList.remove(ClassName.SHOW);
	
	        var callbackRemove = function callbackRemove() {
	          _this8._removeBackdrop();
	          if (callback) {
	            callback();
	          }
	        };
	
	        if (this._element.classList.contains(ClassName.FADE)) {
	          var _backdropTransitionDuration = (0, _util.getTransitionDurationFromElement)(this._backdrop);
	          _eventHandler2.default.one(this._backdrop, _util.TRANSITION_END, callbackRemove);
	          (0, _util.emulateTransitionEnd)(this._backdrop, _backdropTransitionDuration);
	        } else {
	          callbackRemove();
	        }
	      } else if (callback) {
	        callback();
	      }
	    }
	
	    // ----------------------------------------------------------------------
	    // the following methods are used to handle overflowing modals
	    // ----------------------------------------------------------------------
	
	  }, {
	    key: '_adjustDialog',
	    value: function _adjustDialog() {
	      var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
	
	      if (!this._isBodyOverflowing && isModalOverflowing) {
	        this._element.style.paddingLeft = this._scrollbarWidth + 'px';
	      }
	
	      if (this._isBodyOverflowing && !isModalOverflowing) {
	        this._element.style.paddingRight = this._scrollbarWidth + 'px';
	      }
	    }
	  }, {
	    key: '_resetAdjustments',
	    value: function _resetAdjustments() {
	      this._element.style.paddingLeft = '';
	      this._element.style.paddingRight = '';
	    }
	  }, {
	    key: '_checkScrollbar',
	    value: function _checkScrollbar() {
	      var rect = document.body.getBoundingClientRect();
	      this._isBodyOverflowing = rect.left + rect.right < window.innerWidth;
	      this._scrollbarWidth = this._getScrollbarWidth();
	    }
	  }, {
	    key: '_setScrollbar',
	    value: function _setScrollbar() {
	      var _this9 = this;
	
	      if (this._isBodyOverflowing) {
	        // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
	        //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
	
	        // Adjust fixed content padding
	        (0, _util.makeArray)(_selectorEngine2.default.find(Selector.FIXED_CONTENT)).forEach(function (element) {
	          var actualPadding = element.style.paddingRight;
	          var calculatedPadding = window.getComputedStyle(element)['padding-right'];
	          _manipulator2.default.setDataAttribute(element, 'padding-right', actualPadding);
	          element.style.paddingRight = parseFloat(calculatedPadding) + _this9._scrollbarWidth + 'px';
	        });
	
	        // Adjust sticky content margin
	        (0, _util.makeArray)(_selectorEngine2.default.find(Selector.STICKY_CONTENT)).forEach(function (element) {
	          var actualMargin = element.style.marginRight;
	          var calculatedMargin = window.getComputedStyle(element)['margin-right'];
	          _manipulator2.default.setDataAttribute(element, 'margin-right', actualMargin);
	          element.style.marginRight = parseFloat(calculatedMargin) - _this9._scrollbarWidth + 'px';
	        });
	
	        // Adjust body padding
	        var actualPadding = document.body.style.paddingRight;
	        var calculatedPadding = window.getComputedStyle(document.body)['padding-right'];
	
	        _manipulator2.default.setDataAttribute(document.body, 'padding-right', actualPadding);
	        document.body.style.paddingRight = parseFloat(calculatedPadding) + this._scrollbarWidth + 'px';
	      }
	
	      document.body.classList.add(ClassName.OPEN);
	    }
	  }, {
	    key: '_resetScrollbar',
	    value: function _resetScrollbar() {
	      // Restore fixed content padding
	      (0, _util.makeArray)(_selectorEngine2.default.find(Selector.FIXED_CONTENT)).forEach(function (element) {
	        var padding = _manipulator2.default.getDataAttribute(element, 'padding-right');
	        if (typeof padding !== 'undefined') {
	          _manipulator2.default.removeDataAttribute(element, 'padding-right');
	          element.style.paddingRight = padding;
	        }
	      });
	
	      // Restore sticky content and navbar-toggler margin
	      (0, _util.makeArray)(_selectorEngine2.default.find('' + Selector.STICKY_CONTENT)).forEach(function (element) {
	        var margin = _manipulator2.default.getDataAttribute(element, 'margin-right');
	        if (typeof margin !== 'undefined') {
	          _manipulator2.default.removeDataAttribute(element, 'margin-right');
	          element.style.marginRight = margin;
	        }
	      });
	
	      // Restore body padding
	      var padding = _manipulator2.default.getDataAttribute(document.body, 'padding-right');
	      if (typeof padding === 'undefined') {
	        document.body.style.paddingRight = '';
	      } else {
	        _manipulator2.default.removeDataAttribute(document.body, 'padding-right');
	        document.body.style.paddingRight = padding;
	      }
	    }
	  }, {
	    key: '_getScrollbarWidth',
	    value: function _getScrollbarWidth() {
	      // thx d.walsh
	      var scrollDiv = document.createElement('div');
	      scrollDiv.className = ClassName.SCROLLBAR_MEASURER;
	      document.body.appendChild(scrollDiv);
	      var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	      return scrollbarWidth;
	    }
	
	    // Static
	
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(config, relatedTarget) {
	      return this.each(function () {
	        var data = _data2.default.getData(this, DATA_KEY);
	        var _config = _extends({}, Default, _manipulator2.default.getDataAttributes(this), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config ? config : {});
	
	        if (!data) {
	          data = new Modal(this, _config);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError('No method named "' + config + '"');
	          }
	
	          data[config](relatedTarget);
	        } else if (_config.show) {
	          data.show(relatedTarget);
	        }
	      });
	    }
	  }, {
	    key: '_getInstance',
	    value: function _getInstance(element) {
	      return _data2.default.getData(element, DATA_KEY);
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }, {
	    key: 'Default',
	    get: function get() {
	      return Default;
	    }
	  }]);
	
	  return Modal;
	}();
	
	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */
	
	_eventHandler2.default.on(document, Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
	  var _this10 = this;
	
	  var target = void 0;
	  var selector = (0, _util.getSelectorFromElement)(this);
	
	  if (selector) {
	    target = _selectorEngine2.default.findOne(selector);
	  }
	
	  var config = _data2.default.getData(target, DATA_KEY) ? 'toggle' : _extends({}, _manipulator2.default.getDataAttributes(target), _manipulator2.default.getDataAttributes(this));
	
	  if (this.tagName === 'A' || this.tagName === 'AREA') {
	    event.preventDefault();
	  }
	
	  _eventHandler2.default.one(target, Event.SHOW, function (showEvent) {
	    if (showEvent.defaultPrevented) {
	      // only register focus restorer if modal will actually get shown
	      return;
	    }
	
	    _eventHandler2.default.one(target, Event.HIDDEN, function () {
	      if ((0, _util.isVisible)(_this10)) {
	        _this10.focus();
	      }
	    });
	  });
	
	  var data = _data2.default.getData(target, DATA_KEY);
	  if (!data) {
	    data = new Modal(target, config);
	  }
	
	  data.show(this);
	});
	
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 */
	
	if (typeof _util.jQuery !== 'undefined') {
	  var JQUERY_NO_CONFLICT = _util.jQuery.fn[NAME];
	  _util.jQuery.fn[NAME] = Modal._jQueryInterface;
	  _util.jQuery.fn[NAME].Constructor = Modal;
	  _util.jQuery.fn[NAME].noConflict = function () {
	    _util.jQuery.fn[NAME] = JQUERY_NO_CONFLICT;
	    return Modal._jQueryInterface;
	  };
	}
	
	exports.default = Modal;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                   * Bootstrap (v4.3.1): popover.js
	                                                                                                                                                                                                                                                                   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                   * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                   */
	
	var _util = __webpack_require__(22);
	
	var _data = __webpack_require__(34);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _selectorEngine = __webpack_require__(42);
	
	var _selectorEngine2 = _interopRequireDefault(_selectorEngine);
	
	var _tooltip = __webpack_require__(355);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */
	
	var NAME = 'popover';
	var VERSION = '4.3.1';
	var DATA_KEY = 'bs.popover';
	var EVENT_KEY = '.' + DATA_KEY;
	var CLASS_PREFIX = 'bs-popover';
	var BSCLS_PREFIX_REGEX = new RegExp('(^|\\s)' + CLASS_PREFIX + '\\S+', 'g');
	
	var Default = _extends({}, _tooltip2.default.Default, {
	  placement: 'right',
	  trigger: 'click',
	  content: '',
	  template: '<div class="popover" role="tooltip">' + '<div class="popover-arrow"></div>' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div></div>'
	});
	
	var DefaultType = _extends({}, _tooltip2.default.DefaultType, {
	  content: '(string|element|function)'
	});
	
	var ClassName = {
	  FADE: 'fade',
	  SHOW: 'show'
	};
	
	var Selector = {
	  TITLE: '.popover-header',
	  CONTENT: '.popover-body'
	};
	
	var Event = {
	  HIDE: 'hide' + EVENT_KEY,
	  HIDDEN: 'hidden' + EVENT_KEY,
	  SHOW: 'show' + EVENT_KEY,
	  SHOWN: 'shown' + EVENT_KEY,
	  INSERTED: 'inserted' + EVENT_KEY,
	  CLICK: 'click' + EVENT_KEY,
	  FOCUSIN: 'focusin' + EVENT_KEY,
	  FOCUSOUT: 'focusout' + EVENT_KEY,
	  MOUSEENTER: 'mouseenter' + EVENT_KEY,
	  MOUSELEAVE: 'mouseleave' + EVENT_KEY
	
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	};
	var Popover = function (_Tooltip) {
	  _inherits(Popover, _Tooltip);
	
	  function Popover() {
	    _classCallCheck(this, Popover);
	
	    return _possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).apply(this, arguments));
	  }
	
	  _createClass(Popover, [{
	    key: 'isWithContent',
	
	
	    // Overrides
	
	    value: function isWithContent() {
	      return this.getTitle() || this._getContent();
	    }
	  }, {
	    key: 'addAttachmentClass',
	    value: function addAttachmentClass(attachment) {
	      this.getTipElement().classList.add(CLASS_PREFIX + '-' + attachment);
	    }
	  }, {
	    key: 'setContent',
	    value: function setContent() {
	      var tip = this.getTipElement();
	
	      // we use append for html objects to maintain js events
	      this.setElementContent(_selectorEngine2.default.findOne(Selector.TITLE, tip), this.getTitle());
	      var content = this._getContent();
	      if (typeof content === 'function') {
	        content = content.call(this.element);
	      }
	
	      this.setElementContent(_selectorEngine2.default.findOne(Selector.CONTENT, tip), content);
	
	      tip.classList.remove(ClassName.FADE);
	      tip.classList.remove(ClassName.SHOW);
	    }
	
	    // Private
	
	  }, {
	    key: '_getContent',
	    value: function _getContent() {
	      return this.element.getAttribute('data-content') || this.config.content;
	    }
	  }, {
	    key: '_cleanTipClass',
	    value: function _cleanTipClass() {
	      var tip = this.getTipElement();
	      var tabClass = tip.getAttribute('class').match(BSCLS_PREFIX_REGEX);
	
	      if (tabClass !== null && tabClass.length > 0) {
	        tabClass.map(function (token) {
	          return token.trim();
	        }).forEach(function (tClass) {
	          return tip.classList.remove(tClass);
	        });
	      }
	    }
	
	    // Static
	
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(config) {
	      return this.each(function () {
	        var data = _data2.default.getData(this, DATA_KEY);
	        var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' ? config : null;
	
	        if (!data && /dispose|hide/.test(config)) {
	          return;
	        }
	
	        if (!data) {
	          data = new Popover(this, _config);
	          _data2.default.setData(this, DATA_KEY, data);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError('No method named "' + config + '"');
	          }
	
	          data[config]();
	        }
	      });
	    }
	  }, {
	    key: '_getInstance',
	    value: function _getInstance(element) {
	      return _data2.default.getData(element, DATA_KEY);
	    }
	  }, {
	    key: 'VERSION',
	
	    // Getters
	
	    get: function get() {
	      return VERSION;
	    }
	  }, {
	    key: 'Default',
	    get: function get() {
	      return Default;
	    }
	  }, {
	    key: 'NAME',
	    get: function get() {
	      return NAME;
	    }
	  }, {
	    key: 'DATA_KEY',
	    get: function get() {
	      return DATA_KEY;
	    }
	  }, {
	    key: 'Event',
	    get: function get() {
	      return Event;
	    }
	  }, {
	    key: 'EVENT_KEY',
	    get: function get() {
	      return EVENT_KEY;
	    }
	  }, {
	    key: 'DefaultType',
	    get: function get() {
	      return DefaultType;
	    }
	  }]);
	
	  return Popover;
	}(_tooltip2.default);
	
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 */
	
	if (typeof _util.jQuery !== 'undefined') {
	  var JQUERY_NO_CONFLICT = _util.jQuery.fn[NAME];
	  _util.jQuery.fn[NAME] = Popover._jQueryInterface;
	  _util.jQuery.fn[NAME].Constructor = Popover;
	  _util.jQuery.fn[NAME].noConflict = function () {
	    _util.jQuery.fn[NAME] = JQUERY_NO_CONFLICT;
	    return Popover._jQueryInterface;
	  };
	}
	
	exports.default = Popover;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Bootstrap (v4.3.1): scrollspy.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _util = __webpack_require__(22);
	
	var _data = __webpack_require__(34);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _eventHandler = __webpack_require__(41);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _manipulator = __webpack_require__(187);
	
	var _manipulator2 = _interopRequireDefault(_manipulator);
	
	var _selectorEngine = __webpack_require__(42);
	
	var _selectorEngine2 = _interopRequireDefault(_selectorEngine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */
	
	var NAME = 'scrollspy';
	var VERSION = '4.3.1';
	var DATA_KEY = 'bs.scrollspy';
	var EVENT_KEY = '.' + DATA_KEY;
	var DATA_API_KEY = '.data-api';
	
	var Default = {
	  offset: 10,
	  method: 'auto',
	  target: ''
	};
	
	var DefaultType = {
	  offset: 'number',
	  method: 'string',
	  target: '(string|element)'
	};
	
	var Event = {
	  ACTIVATE: 'activate' + EVENT_KEY,
	  SCROLL: 'scroll' + EVENT_KEY,
	  LOAD_DATA_API: 'load' + EVENT_KEY + DATA_API_KEY
	};
	
	var ClassName = {
	  DROPDOWN_ITEM: 'dropdown-item',
	  ACTIVE: 'active'
	};
	
	var Selector = {
	  DATA_SPY: '[data-spy="scroll"]',
	  NAV_LIST_GROUP: '.nav, .list-group',
	  NAV_LINKS: '.nav-link',
	  NAV_ITEMS: '.nav-item',
	  LIST_ITEMS: '.list-group-item',
	  DROPDOWN: '.dropdown',
	  DROPDOWN_TOGGLE: '.dropdown-toggle'
	};
	
	var OffsetMethod = {
	  OFFSET: 'offset',
	  POSITION: 'position'
	
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	};
	var ScrollSpy = function () {
	  function ScrollSpy(element, config) {
	    var _this = this;
	
	    _classCallCheck(this, ScrollSpy);
	
	    this._element = element;
	    this._scrollElement = element.tagName === 'BODY' ? window : element;
	    this._config = this._getConfig(config);
	    this._selector = this._config.target + ' ' + Selector.NAV_LINKS + ',' + (this._config.target + ' ' + Selector.LIST_ITEMS + ',') + (this._config.target + ' .' + ClassName.DROPDOWN_ITEM);
	    this._offsets = [];
	    this._targets = [];
	    this._activeTarget = null;
	    this._scrollHeight = 0;
	
	    _eventHandler2.default.on(this._scrollElement, Event.SCROLL, function (event) {
	      return _this._process(event);
	    });
	
	    this.refresh();
	    this._process();
	
	    _data2.default.setData(element, DATA_KEY, this);
	  }
	
	  // Getters
	
	  _createClass(ScrollSpy, [{
	    key: 'refresh',
	
	
	    // Public
	
	    value: function refresh() {
	      var _this2 = this;
	
	      var autoMethod = this._scrollElement === this._scrollElement.window ? OffsetMethod.OFFSET : OffsetMethod.POSITION;
	
	      var offsetMethod = this._config.method === 'auto' ? autoMethod : this._config.method;
	
	      var offsetBase = offsetMethod === OffsetMethod.POSITION ? this._getScrollTop() : 0;
	
	      this._offsets = [];
	      this._targets = [];
	
	      this._scrollHeight = this._getScrollHeight();
	
	      var targets = (0, _util.makeArray)(_selectorEngine2.default.find(this._selector));
	
	      targets.map(function (element) {
	        var target = void 0;
	        var targetSelector = (0, _util.getSelectorFromElement)(element);
	
	        if (targetSelector) {
	          target = _selectorEngine2.default.findOne(targetSelector);
	        }
	
	        if (target) {
	          var targetBCR = target.getBoundingClientRect();
	          if (targetBCR.width || targetBCR.height) {
	            return [_manipulator2.default[offsetMethod](target).top + offsetBase, targetSelector];
	          }
	        }
	
	        return null;
	      }).filter(function (item) {
	        return item;
	      }).sort(function (a, b) {
	        return a[0] - b[0];
	      }).forEach(function (item) {
	        _this2._offsets.push(item[0]);
	        _this2._targets.push(item[1]);
	      });
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      _data2.default.removeData(this._element, DATA_KEY);
	      _eventHandler2.default.off(this._scrollElement, EVENT_KEY);
	
	      this._element = null;
	      this._scrollElement = null;
	      this._config = null;
	      this._selector = null;
	      this._offsets = null;
	      this._targets = null;
	      this._activeTarget = null;
	      this._scrollHeight = null;
	    }
	
	    // Private
	
	  }, {
	    key: '_getConfig',
	    value: function _getConfig(config) {
	      config = _extends({}, Default, (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config ? config : {});
	
	      if (typeof config.target !== 'string') {
	        var id = config.target.id;
	
	        if (!id) {
	          id = (0, _util.getUID)(NAME);
	          config.target.id = id;
	        }
	
	        config.target = '#' + id;
	      }
	
	      (0, _util.typeCheckConfig)(NAME, config, DefaultType);
	
	      return config;
	    }
	  }, {
	    key: '_getScrollTop',
	    value: function _getScrollTop() {
	      return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
	    }
	  }, {
	    key: '_getScrollHeight',
	    value: function _getScrollHeight() {
	      return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
	    }
	  }, {
	    key: '_getOffsetHeight',
	    value: function _getOffsetHeight() {
	      return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
	    }
	  }, {
	    key: '_process',
	    value: function _process() {
	      var scrollTop = this._getScrollTop() + this._config.offset;
	      var scrollHeight = this._getScrollHeight();
	      var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();
	
	      if (this._scrollHeight !== scrollHeight) {
	        this.refresh();
	      }
	
	      if (scrollTop >= maxScroll) {
	        var target = this._targets[this._targets.length - 1];
	
	        if (this._activeTarget !== target) {
	          this._activate(target);
	        }
	
	        return;
	      }
	
	      if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
	        this._activeTarget = null;
	        this._clear();
	        return;
	      }
	
	      var offsetLength = this._offsets.length;
	      for (var i = offsetLength; i--;) {
	        var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === 'undefined' || scrollTop < this._offsets[i + 1]);
	
	        if (isActiveTarget) {
	          this._activate(this._targets[i]);
	        }
	      }
	    }
	  }, {
	    key: '_activate',
	    value: function _activate(target) {
	      this._activeTarget = target;
	
	      this._clear();
	
	      var queries = this._selector.split(',').map(function (selector) {
	        return selector + '[data-target="' + target + '"],' + selector + '[href="' + target + '"]';
	      });
	
	      var link = _selectorEngine2.default.findOne(queries.join(','));
	
	      if (link.classList.contains(ClassName.DROPDOWN_ITEM)) {
	        _selectorEngine2.default.findOne(Selector.DROPDOWN_TOGGLE, _selectorEngine2.default.closest(link, Selector.DROPDOWN)).classList.add(ClassName.ACTIVE);
	
	        link.classList.add(ClassName.ACTIVE);
	      } else {
	        // Set triggered link as active
	        link.classList.add(ClassName.ACTIVE);
	
	        _selectorEngine2.default.parents(link, Selector.NAV_LIST_GROUP).forEach(function (listGroup) {
	          // Set triggered links parents as active
	          // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
	          _selectorEngine2.default.prev(listGroup, Selector.NAV_LINKS + ', ' + Selector.LIST_ITEMS).forEach(function (item) {
	            return item.classList.add(ClassName.ACTIVE);
	          });
	
	          // Handle special case when .nav-link is inside .nav-item
	          _selectorEngine2.default.prev(listGroup, Selector.NAV_ITEMS).forEach(function (navItem) {
	            _selectorEngine2.default.children(navItem, Selector.NAV_LINKS).forEach(function (item) {
	              return item.classList.add(ClassName.ACTIVE);
	            });
	          });
	        });
	      }
	
	      _eventHandler2.default.trigger(this._scrollElement, Event.ACTIVATE, {
	        relatedTarget: target
	      });
	    }
	  }, {
	    key: '_clear',
	    value: function _clear() {
	      (0, _util.makeArray)(_selectorEngine2.default.find(this._selector)).filter(function (node) {
	        return node.classList.contains(ClassName.ACTIVE);
	      }).forEach(function (node) {
	        return node.classList.remove(ClassName.ACTIVE);
	      });
	    }
	
	    // Static
	
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(config) {
	      return this.each(function () {
	        var data = _data2.default.getData(this, DATA_KEY);
	        var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config;
	
	        if (!data) {
	          data = new ScrollSpy(this, _config);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError('No method named "' + config + '"');
	          }
	
	          data[config]();
	        }
	      });
	    }
	  }, {
	    key: '_getInstance',
	    value: function _getInstance(element) {
	      return _data2.default.getData(element, DATA_KEY);
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }, {
	    key: 'Default',
	    get: function get() {
	      return Default;
	    }
	  }]);
	
	  return ScrollSpy;
	}();
	
	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */
	
	_eventHandler2.default.on(window, Event.LOAD_DATA_API, function () {
	  (0, _util.makeArray)(_selectorEngine2.default.find(Selector.DATA_SPY)).forEach(function (spy) {
	    return new ScrollSpy(spy, _manipulator2.default.getDataAttributes(spy));
	  });
	});
	
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 */
	
	if (typeof _util.jQuery !== 'undefined') {
	  var JQUERY_NO_CONFLICT = _util.jQuery.fn[NAME];
	  _util.jQuery.fn[NAME] = ScrollSpy._jQueryInterface;
	  _util.jQuery.fn[NAME].Constructor = ScrollSpy;
	  _util.jQuery.fn[NAME].noConflict = function () {
	    _util.jQuery.fn[NAME] = JQUERY_NO_CONFLICT;
	    return ScrollSpy._jQueryInterface;
	  };
	}
	
	exports.default = ScrollSpy;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Bootstrap (v4.3.1): tab.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _util = __webpack_require__(22);
	
	var _data = __webpack_require__(34);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _eventHandler = __webpack_require__(41);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _selectorEngine = __webpack_require__(42);
	
	var _selectorEngine2 = _interopRequireDefault(_selectorEngine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */
	
	var NAME = 'tab';
	var VERSION = '4.3.1';
	var DATA_KEY = 'bs.tab';
	var EVENT_KEY = '.' + DATA_KEY;
	var DATA_API_KEY = '.data-api';
	
	var Event = {
	  HIDE: 'hide' + EVENT_KEY,
	  HIDDEN: 'hidden' + EVENT_KEY,
	  SHOW: 'show' + EVENT_KEY,
	  SHOWN: 'shown' + EVENT_KEY,
	  CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
	};
	
	var ClassName = {
	  DROPDOWN_MENU: 'dropdown-menu',
	  ACTIVE: 'active',
	  DISABLED: 'disabled',
	  FADE: 'fade',
	  SHOW: 'show'
	};
	
	var Selector = {
	  DROPDOWN: '.dropdown',
	  NAV_LIST_GROUP: '.nav, .list-group',
	  ACTIVE: '.active',
	  ACTIVE_UL: ':scope > li > .active',
	  DATA_TOGGLE: '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',
	  DROPDOWN_TOGGLE: '.dropdown-toggle',
	  DROPDOWN_ACTIVE_CHILD: ':scope > .dropdown-menu .active'
	
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	};
	var Tab = function () {
	  function Tab(element) {
	    _classCallCheck(this, Tab);
	
	    this._element = element;
	
	    _data2.default.setData(this._element, DATA_KEY, this);
	  }
	
	  // Getters
	
	  _createClass(Tab, [{
	    key: 'show',
	
	
	    // Public
	
	    value: function show() {
	      var _this = this;
	
	      if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && this._element.classList.contains(ClassName.ACTIVE) || this._element.classList.contains(ClassName.DISABLED)) {
	        return;
	      }
	
	      var target = void 0;
	      var previous = void 0;
	      var listElement = _selectorEngine2.default.closest(this._element, Selector.NAV_LIST_GROUP);
	      var selector = (0, _util.getSelectorFromElement)(this._element);
	
	      if (listElement) {
	        var itemSelector = listElement.nodeName === 'UL' || listElement.nodeName === 'OL' ? Selector.ACTIVE_UL : Selector.ACTIVE;
	        previous = (0, _util.makeArray)(_selectorEngine2.default.find(itemSelector, listElement));
	        previous = previous[previous.length - 1];
	      }
	
	      var hideEvent = null;
	
	      if (previous) {
	        hideEvent = _eventHandler2.default.trigger(previous, Event.HIDE, {
	          relatedTarget: this._element
	        });
	      }
	
	      var showEvent = _eventHandler2.default.trigger(this._element, Event.SHOW, {
	        relatedTarget: previous
	      });
	
	      if (showEvent.defaultPrevented || hideEvent !== null && hideEvent.defaultPrevented) {
	        return;
	      }
	
	      if (selector) {
	        target = _selectorEngine2.default.findOne(selector);
	      }
	
	      this._activate(this._element, listElement);
	
	      var complete = function complete() {
	        _eventHandler2.default.trigger(previous, Event.HIDDEN, {
	          relatedTarget: _this._element
	        });
	        _eventHandler2.default.trigger(_this._element, Event.SHOWN, {
	          relatedTarget: previous
	        });
	      };
	
	      if (target) {
	        this._activate(target, target.parentNode, complete);
	      } else {
	        complete();
	      }
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      _data2.default.removeData(this._element, DATA_KEY);
	      this._element = null;
	    }
	
	    // Private
	
	  }, {
	    key: '_activate',
	    value: function _activate(element, container, callback) {
	      var _this2 = this;
	
	      var activeElements = container && (container.nodeName === 'UL' || container.nodeName === 'OL') ? _selectorEngine2.default.find(Selector.ACTIVE_UL, container) : _selectorEngine2.default.children(container, Selector.ACTIVE);
	
	      var active = activeElements[0];
	      var isTransitioning = callback && active && active.classList.contains(ClassName.FADE);
	
	      var complete = function complete() {
	        return _this2._transitionComplete(element, active, callback);
	      };
	
	      if (active && isTransitioning) {
	        var transitionDuration = (0, _util.getTransitionDurationFromElement)(active);
	        active.classList.remove(ClassName.SHOW);
	
	        _eventHandler2.default.one(active, _util.TRANSITION_END, complete);
	        (0, _util.emulateTransitionEnd)(active, transitionDuration);
	      } else {
	        complete();
	      }
	    }
	  }, {
	    key: '_transitionComplete',
	    value: function _transitionComplete(element, active, callback) {
	      if (active) {
	        active.classList.remove(ClassName.ACTIVE);
	
	        var dropdownChild = _selectorEngine2.default.findOne(Selector.DROPDOWN_ACTIVE_CHILD, active.parentNode);
	
	        if (dropdownChild) {
	          dropdownChild.classList.remove(ClassName.ACTIVE);
	        }
	
	        if (active.getAttribute('role') === 'tab') {
	          active.setAttribute('aria-selected', false);
	        }
	      }
	
	      element.classList.add(ClassName.ACTIVE);
	      if (element.getAttribute('role') === 'tab') {
	        element.setAttribute('aria-selected', true);
	      }
	
	      (0, _util.reflow)(element);
	
	      if (element.classList.contains(ClassName.FADE)) {
	        element.classList.add(ClassName.SHOW);
	      }
	
	      if (element.parentNode && element.parentNode.classList.contains(ClassName.DROPDOWN_MENU)) {
	        var dropdownElement = _selectorEngine2.default.closest(element, Selector.DROPDOWN);
	
	        if (dropdownElement) {
	          (0, _util.makeArray)(_selectorEngine2.default.find(Selector.DROPDOWN_TOGGLE)).forEach(function (dropdown) {
	            return dropdown.classList.add(ClassName.ACTIVE);
	          });
	        }
	
	        element.setAttribute('aria-expanded', true);
	      }
	
	      if (callback) {
	        callback();
	      }
	    }
	
	    // Static
	
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(config) {
	      return this.each(function () {
	        var data = _data2.default.getData(this, DATA_KEY) || new Tab(this);
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError('No method named "' + config + '"');
	          }
	
	          data[config]();
	        }
	      });
	    }
	  }, {
	    key: '_getInstance',
	    value: function _getInstance(element) {
	      return _data2.default.getData(element, DATA_KEY);
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);
	
	  return Tab;
	}();
	
	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */
	
	_eventHandler2.default.on(document, Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
	  event.preventDefault();
	
	  var data = _data2.default.getData(this, DATA_KEY) || new Tab(this);
	  data.show();
	});
	
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 * add .tab to jQuery only if jQuery is present
	 */
	
	if (typeof _util.jQuery !== 'undefined') {
	  var JQUERY_NO_CONFLICT = _util.jQuery.fn[NAME];
	  _util.jQuery.fn[NAME] = Tab._jQueryInterface;
	  _util.jQuery.fn[NAME].Constructor = Tab;
	  _util.jQuery.fn[NAME].noConflict = function () {
	    _util.jQuery.fn[NAME] = JQUERY_NO_CONFLICT;
	    return Tab._jQueryInterface;
	  };
	}
	
	exports.default = Tab;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Bootstrap (v4.3.1): toast.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	var _util = __webpack_require__(22);
	
	var _data = __webpack_require__(34);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _eventHandler = __webpack_require__(41);
	
	var _eventHandler2 = _interopRequireDefault(_eventHandler);
	
	var _manipulator = __webpack_require__(187);
	
	var _manipulator2 = _interopRequireDefault(_manipulator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */
	
	var NAME = 'toast';
	var VERSION = '4.3.1';
	var DATA_KEY = 'bs.toast';
	var EVENT_KEY = '.' + DATA_KEY;
	
	var Event = {
	  CLICK_DISMISS: 'click.dismiss' + EVENT_KEY,
	  HIDE: 'hide' + EVENT_KEY,
	  HIDDEN: 'hidden' + EVENT_KEY,
	  SHOW: 'show' + EVENT_KEY,
	  SHOWN: 'shown' + EVENT_KEY
	};
	
	var ClassName = {
	  FADE: 'fade',
	  HIDE: 'hide',
	  SHOW: 'show',
	  SHOWING: 'showing'
	};
	
	var DefaultType = {
	  animation: 'boolean',
	  autohide: 'boolean',
	  delay: 'number'
	};
	
	var Default = {
	  animation: true,
	  autohide: true,
	  delay: 500
	};
	
	var Selector = {
	  DATA_DISMISS: '[data-dismiss="toast"]'
	
	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	
	};
	var Toast = function () {
	  function Toast(element, config) {
	    _classCallCheck(this, Toast);
	
	    this._element = element;
	    this._config = this._getConfig(config);
	    this._timeout = null;
	    this._setListeners();
	    _data2.default.setData(element, DATA_KEY, this);
	  }
	
	  // Getters
	
	  _createClass(Toast, [{
	    key: 'show',
	
	
	    // Public
	
	    value: function show() {
	      var _this = this;
	
	      var showEvent = _eventHandler2.default.trigger(this._element, Event.SHOW);
	
	      if (showEvent.defaultPrevented) {
	        return;
	      }
	
	      if (this._config.animation) {
	        this._element.classList.add(ClassName.FADE);
	      }
	
	      var complete = function complete() {
	        _this._element.classList.remove(ClassName.SHOWING);
	        _this._element.classList.add(ClassName.SHOW);
	
	        _eventHandler2.default.trigger(_this._element, Event.SHOWN);
	
	        if (_this._config.autohide) {
	          _this._timeout = setTimeout(function () {
	            _this.hide();
	          }, _this._config.delay);
	        }
	      };
	
	      this._element.classList.remove(ClassName.HIDE);
	      this._element.classList.add(ClassName.SHOWING);
	      if (this._config.animation) {
	        var transitionDuration = (0, _util.getTransitionDurationFromElement)(this._element);
	
	        _eventHandler2.default.one(this._element, _util.TRANSITION_END, complete);
	        (0, _util.emulateTransitionEnd)(this._element, transitionDuration);
	      } else {
	        complete();
	      }
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      var _this2 = this;
	
	      if (!this._element.classList.contains(ClassName.SHOW)) {
	        return;
	      }
	
	      var hideEvent = _eventHandler2.default.trigger(this._element, Event.HIDE);
	
	      if (hideEvent.defaultPrevented) {
	        return;
	      }
	
	      var complete = function complete() {
	        _this2._element.classList.add(ClassName.HIDE);
	        _eventHandler2.default.trigger(_this2._element, Event.HIDDEN);
	      };
	
	      this._element.classList.remove(ClassName.SHOW);
	      if (this._config.animation) {
	        var transitionDuration = (0, _util.getTransitionDurationFromElement)(this._element);
	
	        _eventHandler2.default.one(this._element, _util.TRANSITION_END, complete);
	        (0, _util.emulateTransitionEnd)(this._element, transitionDuration);
	      } else {
	        complete();
	      }
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      clearTimeout(this._timeout);
	      this._timeout = null;
	
	      if (this._element.classList.contains(ClassName.SHOW)) {
	        this._element.classList.remove(ClassName.SHOW);
	      }
	
	      _eventHandler2.default.off(this._element, Event.CLICK_DISMISS);
	      _data2.default.removeData(this._element, DATA_KEY);
	
	      this._element = null;
	      this._config = null;
	    }
	
	    // Private
	
	  }, {
	    key: '_getConfig',
	    value: function _getConfig(config) {
	      config = _extends({}, Default, _manipulator2.default.getDataAttributes(this._element), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config ? config : {});
	
	      (0, _util.typeCheckConfig)(NAME, config, this.constructor.DefaultType);
	
	      return config;
	    }
	  }, {
	    key: '_setListeners',
	    value: function _setListeners() {
	      var _this3 = this;
	
	      _eventHandler2.default.on(this._element, Event.CLICK_DISMISS, Selector.DATA_DISMISS, function () {
	        return _this3.hide();
	      });
	    }
	
	    // Static
	
	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(config) {
	      return this.each(function () {
	        var data = _data2.default.getData(this, DATA_KEY);
	        var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config;
	
	        if (!data) {
	          data = new Toast(this, _config);
	        }
	
	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError('No method named "' + config + '"');
	          }
	
	          data[config](this);
	        }
	      });
	    }
	  }, {
	    key: '_getInstance',
	    value: function _getInstance(element) {
	      return _data2.default.getData(element, DATA_KEY);
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }, {
	    key: 'DefaultType',
	    get: function get() {
	      return DefaultType;
	    }
	  }, {
	    key: 'Default',
	    get: function get() {
	      return Default;
	    }
	  }]);
	
	  return Toast;
	}();
	
	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 *  add .toast to jQuery only if jQuery is present
	 */
	
	if (typeof _util.jQuery !== 'undefined') {
	  var JQUERY_NO_CONFLICT = _util.jQuery.fn[NAME];
	  _util.jQuery.fn[NAME] = Toast._jQueryInterface;
	  _util.jQuery.fn[NAME].Constructor = Toast;
	  _util.jQuery.fn[NAME].noConflict = function () {
	    _util.jQuery.fn[NAME] = JQUERY_NO_CONFLICT;
	    return Toast._jQueryInterface;
	  };
	}
	
	exports.default = Toast;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DefaultWhitelist = undefined;
	exports.sanitizeHtml = sanitizeHtml;
	
	var _index = __webpack_require__(22);
	
	var uriAttrs = ['background', 'cite', 'href', 'itemtype', 'longdesc', 'poster', 'src', 'xlink:href']; /**
	                                                                                                       * --------------------------------------------------------------------------
	                                                                                                       * Bootstrap (v4.3.1): util/sanitizer.js
	                                                                                                       * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                       * --------------------------------------------------------------------------
	                                                                                                       */
	
	var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
	
	/**
	 * A pattern that recognizes a commonly useful subset of URLs that are safe.
	 *
	 * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	 */
	var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;
	
	/**
	 * A pattern that matches safe data URLs. Only matches image, video and audio types.
	 *
	 * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	 */
	var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;
	
	var allowedAttribute = function allowedAttribute(attr, allowedAttributeList) {
	  var attrName = attr.nodeName.toLowerCase();
	
	  if (allowedAttributeList.indexOf(attrName) !== -1) {
	    if (uriAttrs.indexOf(attrName) !== -1) {
	      return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN));
	    }
	
	    return true;
	  }
	
	  var regExp = allowedAttributeList.filter(function (attrRegex) {
	    return attrRegex instanceof RegExp;
	  });
	
	  // Check if a regular expression validates the attribute.
	  for (var i = 0, l = regExp.length; i < l; i++) {
	    if (attrName.match(regExp[i])) {
	      return true;
	    }
	  }
	
	  return false;
	};
	
	var DefaultWhitelist = exports.DefaultWhitelist = {
	  // Global attributes allowed on any supplied element below.
	  '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
	  a: ['target', 'href', 'title', 'rel'],
	  area: [],
	  b: [],
	  br: [],
	  col: [],
	  code: [],
	  div: [],
	  em: [],
	  hr: [],
	  h1: [],
	  h2: [],
	  h3: [],
	  h4: [],
	  h5: [],
	  h6: [],
	  i: [],
	  img: ['src', 'alt', 'title', 'width', 'height'],
	  li: [],
	  ol: [],
	  p: [],
	  pre: [],
	  s: [],
	  small: [],
	  span: [],
	  sub: [],
	  sup: [],
	  strong: [],
	  u: [],
	  ul: []
	};
	
	function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
	  if (!unsafeHtml.length) {
	    return unsafeHtml;
	  }
	
	  if (sanitizeFn && typeof sanitizeFn === 'function') {
	    return sanitizeFn(unsafeHtml);
	  }
	
	  var domParser = new window.DOMParser();
	  var createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
	  var whitelistKeys = Object.keys(whiteList);
	  var elements = (0, _index.makeArray)(createdDocument.body.querySelectorAll('*'));
	
	  var _loop = function _loop(i, len) {
	    var el = elements[i];
	    var elName = el.nodeName.toLowerCase();
	
	    if (whitelistKeys.indexOf(elName) === -1) {
	      el.parentNode.removeChild(el);
	
	      return 'continue';
	    }
	
	    var attributeList = (0, _index.makeArray)(el.attributes);
	    var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || []);
	
	    attributeList.forEach(function (attr) {
	      if (!allowedAttribute(attr, whitelistedAttributes)) {
	        el.removeAttribute(attr.nodeName);
	      }
	    });
	  };
	
	  for (var i = 0, len = elements.length; i < len; i++) {
	    var _ret = _loop(i, len);
	
	    if (_ret === 'continue') continue;
	  }
	
	  return createdDocument.body.innerHTML;
	}

/***/ }),
/* 517 */,
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(721);
	
	__webpack_require__(519);
	
	__webpack_require__(522);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(520)
	var ieee754 = __webpack_require__(808)
	var isArray = __webpack_require__(809)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(529);
	module.exports = __webpack_require__(36).RegExp.escape;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(14);
	var isArray = __webpack_require__(231);
	var SPECIES = __webpack_require__(15)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(13);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(8);
	var toPrimitive = __webpack_require__(46);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(192);
	var gOPS = __webpack_require__(235);
	var pIE = __webpack_require__(217);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(218)('native-function-to-string', Function.toString);


/***/ }),
/* 528 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(1);
	var $re = __webpack_require__(528)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(357) });
	
	__webpack_require__(55)('copyWithin');


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $every = __webpack_require__(43)(4);
	
	$export($export.P + $export.F * !__webpack_require__(38)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', { fill: __webpack_require__(295) });
	
	__webpack_require__(55)('fill');


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $filter = __webpack_require__(43)(2);
	
	$export($export.P + $export.F * !__webpack_require__(38)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(1);
	var $find = __webpack_require__(43)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(55)(KEY);


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(1);
	var $find = __webpack_require__(43)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(55)(KEY);


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $forEach = __webpack_require__(43)(0);
	var STRICT = __webpack_require__(38)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(37);
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(19);
	var call = __webpack_require__(368);
	var isArrayIter = __webpack_require__(303);
	var toLength = __webpack_require__(16);
	var createProperty = __webpack_require__(297);
	var getIterFn = __webpack_require__(319);
	
	$export($export.S + $export.F * !__webpack_require__(233)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $indexOf = __webpack_require__(228)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(38)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(231) });


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(32);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(216) != Object || !__webpack_require__(38)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(32);
	var toInteger = __webpack_require__(39);
	var toLength = __webpack_require__(16);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(38)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $map = __webpack_require__(43)(1);
	
	$export($export.P + $export.F * !__webpack_require__(38)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var createProperty = __webpack_require__(297);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(13)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $reduce = __webpack_require__(359);
	
	$export($export.P + $export.F * !__webpack_require__(38)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $reduce = __webpack_require__(359);
	
	$export($export.P + $export.F * !__webpack_require__(38)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var html = __webpack_require__(301);
	var cof = __webpack_require__(35);
	var toAbsoluteIndex = __webpack_require__(196);
	var toLength = __webpack_require__(16);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(13)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $some = __webpack_require__(43)(3);
	
	$export($export.P + $export.F * !__webpack_require__(38)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(23);
	var toObject = __webpack_require__(19);
	var fails = __webpack_require__(13);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(38)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(195)('Array');


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(1);
	var toISOString = __webpack_require__(524);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(19);
	var toPrimitive = __webpack_require__(46);
	
	$export($export.P + $export.F * __webpack_require__(13)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(15)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(26)(proto, TO_PRIMITIVE, __webpack_require__(525));


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(27)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Function', { bind: __webpack_require__(360) });


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(14);
	var getPrototypeOf = __webpack_require__(31);
	var HAS_INSTANCE = __webpack_require__(15)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(18).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(18).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(17) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(1);
	var log1p = __webpack_require__(371);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(1);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(1);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(1);
	var sign = __webpack_require__(307);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(1);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(1);
	var $expm1 = __webpack_require__(306);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { fround: __webpack_require__(370) });


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(1);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(1);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(13)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(371) });


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { sign: __webpack_require__(307) });


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(1);
	var expm1 = __webpack_require__(306);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(13)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(1);
	var expm1 = __webpack_require__(306);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(9);
	var has = __webpack_require__(29);
	var cof = __webpack_require__(35);
	var inheritIfRequired = __webpack_require__(302);
	var toPrimitive = __webpack_require__(46);
	var fails = __webpack_require__(13);
	var gOPN = __webpack_require__(191).f;
	var gOPD = __webpack_require__(30).f;
	var dP = __webpack_require__(18).f;
	var $trim = __webpack_require__(205).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(190)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(17) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(27)(global, NUMBER, $Number);
	}


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(1);
	var _isFinite = __webpack_require__(9).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(367) });


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(1);
	var isInteger = __webpack_require__(367);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseFloat = __webpack_require__(379);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseInt = __webpack_require__(380);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toInteger = __webpack_require__(39);
	var aNumberValue = __webpack_require__(356);
	var repeat = __webpack_require__(314);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(13)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $fails = __webpack_require__(13);
	var aNumberValue = __webpack_require__(356);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(1);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(373) });


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(190) });


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(17), 'Object', { defineProperties: __webpack_require__(374) });


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(17), 'Object', { defineProperty: __webpack_require__(18).f });


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(14);
	var meta = __webpack_require__(57).onFreeze;
	
	__webpack_require__(45)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(32);
	var $getOwnPropertyDescriptor = __webpack_require__(30).f;
	
	__webpack_require__(45)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(45)('getOwnPropertyNames', function () {
	  return __webpack_require__(375).f;
	});


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(19);
	var $getPrototypeOf = __webpack_require__(31);
	
	__webpack_require__(45)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(14);
	
	__webpack_require__(45)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(14);
	
	__webpack_require__(45)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(14);
	
	__webpack_require__(45)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', { is: __webpack_require__(383) });


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(19);
	var $keys = __webpack_require__(192);
	
	__webpack_require__(45)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(14);
	var meta = __webpack_require__(57).onFreeze;
	
	__webpack_require__(45)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(14);
	var meta = __webpack_require__(57).onFreeze;
	
	__webpack_require__(45)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(311).set });


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(202);
	var test = {};
	test[__webpack_require__(15)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(27)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseFloat = __webpack_require__(379);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseInt = __webpack_require__(380);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(56);
	var global = __webpack_require__(9);
	var ctx = __webpack_require__(37);
	var classof = __webpack_require__(202);
	var $export = __webpack_require__(1);
	var isObject = __webpack_require__(14);
	var aFunction = __webpack_require__(23);
	var anInstance = __webpack_require__(188);
	var forOf = __webpack_require__(189);
	var speciesConstructor = __webpack_require__(219);
	var task = __webpack_require__(316).set;
	var microtask = __webpack_require__(308)();
	var newPromiseCapabilityModule = __webpack_require__(309);
	var perform = __webpack_require__(381);
	var userAgent = __webpack_require__(241);
	var promiseResolve = __webpack_require__(382);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(15)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(194)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(204)($Promise, PROMISE);
	__webpack_require__(195)(PROMISE);
	Wrapper = __webpack_require__(36)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(233)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(23);
	var anObject = __webpack_require__(8);
	var rApply = (__webpack_require__(9).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(13)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(1);
	var create = __webpack_require__(190);
	var aFunction = __webpack_require__(23);
	var anObject = __webpack_require__(8);
	var isObject = __webpack_require__(14);
	var fails = __webpack_require__(13);
	var bind = __webpack_require__(360);
	var rConstruct = (__webpack_require__(9).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(18);
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(8);
	var toPrimitive = __webpack_require__(46);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(13)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(1);
	var gOPD = __webpack_require__(30).f;
	var anObject = __webpack_require__(8);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(8);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(304)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(30);
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(8);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(1);
	var getProto = __webpack_require__(31);
	var anObject = __webpack_require__(8);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(30);
	var getPrototypeOf = __webpack_require__(31);
	var has = __webpack_require__(29);
	var $export = __webpack_require__(1);
	var isObject = __webpack_require__(14);
	var anObject = __webpack_require__(8);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(8);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(378) });


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(8);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(1);
	var setProto = __webpack_require__(311);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(18);
	var gOPD = __webpack_require__(30);
	var getPrototypeOf = __webpack_require__(31);
	var has = __webpack_require__(29);
	var $export = __webpack_require__(1);
	var createDesc = __webpack_require__(193);
	var anObject = __webpack_require__(8);
	var isObject = __webpack_require__(14);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(9);
	var inheritIfRequired = __webpack_require__(302);
	var dP = __webpack_require__(18).f;
	var gOPN = __webpack_require__(191).f;
	var isRegExp = __webpack_require__(232);
	var $flags = __webpack_require__(215);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(17) && (!CORRECT_NEW || __webpack_require__(13)(function () {
	  re2[__webpack_require__(15)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(27)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(195)('RegExp');


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(8);
	var toLength = __webpack_require__(16);
	var advanceStringIndex = __webpack_require__(294);
	var regExpExec = __webpack_require__(236);
	
	// @@match logic
	__webpack_require__(230)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(8);
	var toObject = __webpack_require__(19);
	var toLength = __webpack_require__(16);
	var toInteger = __webpack_require__(39);
	var advanceStringIndex = __webpack_require__(294);
	var regExpExec = __webpack_require__(236);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(230)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(8);
	var sameValue = __webpack_require__(383);
	var regExpExec = __webpack_require__(236);
	
	// @@search logic
	__webpack_require__(230)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(232);
	var anObject = __webpack_require__(8);
	var speciesConstructor = __webpack_require__(219);
	var advanceStringIndex = __webpack_require__(294);
	var toLength = __webpack_require__(16);
	var callRegExpExec = __webpack_require__(236);
	var regexpExec = __webpack_require__(310);
	var fails = __webpack_require__(13);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(230)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(389);
	var anObject = __webpack_require__(8);
	var $flags = __webpack_require__(215);
	var DESCRIPTORS = __webpack_require__(17);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(27)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(13)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(28)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(28)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(28)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(28)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $at = __webpack_require__(239)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(1);
	var toLength = __webpack_require__(16);
	var context = __webpack_require__(313);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(300)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(28)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(28)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(28)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var toAbsoluteIndex = __webpack_require__(196);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(1);
	var context = __webpack_require__(313);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(300)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(28)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(239)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(305)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(28)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(32);
	var toLength = __webpack_require__(16);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(314)
	});


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(28)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(1);
	var toLength = __webpack_require__(16);
	var context = __webpack_require__(313);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(300)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(28)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(28)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(28)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(205)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(9);
	var has = __webpack_require__(29);
	var DESCRIPTORS = __webpack_require__(17);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(27);
	var META = __webpack_require__(57).KEY;
	var $fails = __webpack_require__(13);
	var shared = __webpack_require__(218);
	var setToStringTag = __webpack_require__(204);
	var uid = __webpack_require__(197);
	var wks = __webpack_require__(15);
	var wksExt = __webpack_require__(386);
	var wksDefine = __webpack_require__(318);
	var enumKeys = __webpack_require__(526);
	var isArray = __webpack_require__(231);
	var anObject = __webpack_require__(8);
	var isObject = __webpack_require__(14);
	var toObject = __webpack_require__(19);
	var toIObject = __webpack_require__(32);
	var toPrimitive = __webpack_require__(46);
	var createDesc = __webpack_require__(193);
	var _create = __webpack_require__(190);
	var gOPNExt = __webpack_require__(375);
	var $GOPD = __webpack_require__(30);
	var $GOPS = __webpack_require__(235);
	var $DP = __webpack_require__(18);
	var $keys = __webpack_require__(192);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(191).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(217).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(56)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(26)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $typed = __webpack_require__(240);
	var buffer = __webpack_require__(317);
	var anObject = __webpack_require__(8);
	var toAbsoluteIndex = __webpack_require__(196);
	var toLength = __webpack_require__(16);
	var isObject = __webpack_require__(14);
	var ArrayBuffer = __webpack_require__(9).ArrayBuffer;
	var speciesConstructor = __webpack_require__(219);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(13)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(195)(ARRAY_BUFFER);


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	$export($export.G + $export.W + $export.F * !__webpack_require__(240).ABV, {
	  DataView: __webpack_require__(317).DataView
	});


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(53)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(53)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(53)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(53)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(53)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(53)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(53)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(53)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(53)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(363);
	var validate = __webpack_require__(198);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(229)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(1);
	var flattenIntoArray = __webpack_require__(364);
	var toObject = __webpack_require__(19);
	var toLength = __webpack_require__(16);
	var aFunction = __webpack_require__(23);
	var arraySpeciesCreate = __webpack_require__(296);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(55)('flatMap');


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(1);
	var flattenIntoArray = __webpack_require__(364);
	var toObject = __webpack_require__(19);
	var toLength = __webpack_require__(16);
	var toInteger = __webpack_require__(39);
	var arraySpeciesCreate = __webpack_require__(296);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(55)('flatten');


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(1);
	var $includes = __webpack_require__(228)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(55)('includes');


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(1);
	var microtask = __webpack_require__(308)();
	var process = __webpack_require__(9).process;
	var isNode = __webpack_require__(35)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(1);
	var cof = __webpack_require__(35);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(1);
	
	$export($export.G, { global: __webpack_require__(9) });


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(237)('Map');


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(238)('Map');


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(362)('Map') });


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var scale = __webpack_require__(372);
	var fround = __webpack_require__(370);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { scale: __webpack_require__(372) });


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(19);
	var aFunction = __webpack_require__(23);
	var $defineProperty = __webpack_require__(18);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(17) && $export($export.P + __webpack_require__(234), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(19);
	var aFunction = __webpack_require__(23);
	var $defineProperty = __webpack_require__(18);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(17) && $export($export.P + __webpack_require__(234), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(1);
	var $entries = __webpack_require__(377)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(1);
	var ownKeys = __webpack_require__(378);
	var toIObject = __webpack_require__(32);
	var gOPD = __webpack_require__(30);
	var createProperty = __webpack_require__(297);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(19);
	var toPrimitive = __webpack_require__(46);
	var getPrototypeOf = __webpack_require__(31);
	var getOwnPropertyDescriptor = __webpack_require__(30).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(17) && $export($export.P + __webpack_require__(234), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(19);
	var toPrimitive = __webpack_require__(46);
	var getPrototypeOf = __webpack_require__(31);
	var getOwnPropertyDescriptor = __webpack_require__(30).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(17) && $export($export.P + __webpack_require__(234), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(1);
	var $values = __webpack_require__(377)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(1);
	var global = __webpack_require__(9);
	var core = __webpack_require__(36);
	var microtask = __webpack_require__(308)();
	var OBSERVABLE = __webpack_require__(15)('observable');
	var aFunction = __webpack_require__(23);
	var anObject = __webpack_require__(8);
	var anInstance = __webpack_require__(188);
	var redefineAll = __webpack_require__(194);
	var hide = __webpack_require__(26);
	var forOf = __webpack_require__(189);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(195)('Observable');


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(1);
	var core = __webpack_require__(36);
	var global = __webpack_require__(9);
	var speciesConstructor = __webpack_require__(219);
	var promiseResolve = __webpack_require__(382);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(1);
	var newPromiseCapability = __webpack_require__(309);
	var perform = __webpack_require__(381);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(52);
	var anObject = __webpack_require__(8);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(52);
	var anObject = __webpack_require__(8);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(390);
	var from = __webpack_require__(358);
	var metadata = __webpack_require__(52);
	var anObject = __webpack_require__(8);
	var getPrototypeOf = __webpack_require__(31);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(52);
	var anObject = __webpack_require__(8);
	var getPrototypeOf = __webpack_require__(31);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(52);
	var anObject = __webpack_require__(8);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(52);
	var anObject = __webpack_require__(8);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(52);
	var anObject = __webpack_require__(8);
	var getPrototypeOf = __webpack_require__(31);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(52);
	var anObject = __webpack_require__(8);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(52);
	var anObject = __webpack_require__(8);
	var aFunction = __webpack_require__(23);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(237)('Set');


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(238)('Set');


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(362)('Set') });


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(1);
	var $at = __webpack_require__(239)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(1);
	var defined = __webpack_require__(44);
	var toLength = __webpack_require__(16);
	var isRegExp = __webpack_require__(232);
	var getFlags = __webpack_require__(215);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(304)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1);
	var $pad = __webpack_require__(384);
	var userAgent = __webpack_require__(241);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1);
	var $pad = __webpack_require__(384);
	var userAgent = __webpack_require__(241);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(205)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(205)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(318)('asyncIterator');


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(318)('observable');


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(1);
	
	$export($export.S, 'System', { global: __webpack_require__(9) });


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(237)('WeakMap');


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(238)('WeakMap');


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(237)('WeakSet');


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(238)('WeakSet');


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(320);
	var getKeys = __webpack_require__(192);
	var redefine = __webpack_require__(27);
	var global = __webpack_require__(9);
	var hide = __webpack_require__(26);
	var Iterators = __webpack_require__(203);
	var wks = __webpack_require__(15);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $task = __webpack_require__(316);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(9);
	var $export = __webpack_require__(1);
	var userAgent = __webpack_require__(241);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(649);
	__webpack_require__(588);
	__webpack_require__(590);
	__webpack_require__(589);
	__webpack_require__(592);
	__webpack_require__(594);
	__webpack_require__(599);
	__webpack_require__(593);
	__webpack_require__(591);
	__webpack_require__(601);
	__webpack_require__(600);
	__webpack_require__(596);
	__webpack_require__(597);
	__webpack_require__(595);
	__webpack_require__(587);
	__webpack_require__(598);
	__webpack_require__(602);
	__webpack_require__(603);
	__webpack_require__(555);
	__webpack_require__(557);
	__webpack_require__(556);
	__webpack_require__(605);
	__webpack_require__(604);
	__webpack_require__(575);
	__webpack_require__(585);
	__webpack_require__(586);
	__webpack_require__(576);
	__webpack_require__(577);
	__webpack_require__(578);
	__webpack_require__(579);
	__webpack_require__(580);
	__webpack_require__(581);
	__webpack_require__(582);
	__webpack_require__(583);
	__webpack_require__(584);
	__webpack_require__(558);
	__webpack_require__(559);
	__webpack_require__(560);
	__webpack_require__(561);
	__webpack_require__(562);
	__webpack_require__(563);
	__webpack_require__(564);
	__webpack_require__(565);
	__webpack_require__(566);
	__webpack_require__(567);
	__webpack_require__(568);
	__webpack_require__(569);
	__webpack_require__(570);
	__webpack_require__(571);
	__webpack_require__(572);
	__webpack_require__(573);
	__webpack_require__(574);
	__webpack_require__(636);
	__webpack_require__(641);
	__webpack_require__(648);
	__webpack_require__(639);
	__webpack_require__(631);
	__webpack_require__(632);
	__webpack_require__(637);
	__webpack_require__(642);
	__webpack_require__(644);
	__webpack_require__(627);
	__webpack_require__(628);
	__webpack_require__(629);
	__webpack_require__(630);
	__webpack_require__(633);
	__webpack_require__(634);
	__webpack_require__(635);
	__webpack_require__(638);
	__webpack_require__(640);
	__webpack_require__(643);
	__webpack_require__(645);
	__webpack_require__(646);
	__webpack_require__(647);
	__webpack_require__(550);
	__webpack_require__(552);
	__webpack_require__(551);
	__webpack_require__(554);
	__webpack_require__(553);
	__webpack_require__(539);
	__webpack_require__(537);
	__webpack_require__(543);
	__webpack_require__(540);
	__webpack_require__(546);
	__webpack_require__(548);
	__webpack_require__(536);
	__webpack_require__(542);
	__webpack_require__(533);
	__webpack_require__(547);
	__webpack_require__(531);
	__webpack_require__(545);
	__webpack_require__(544);
	__webpack_require__(538);
	__webpack_require__(541);
	__webpack_require__(530);
	__webpack_require__(532);
	__webpack_require__(535);
	__webpack_require__(534);
	__webpack_require__(549);
	__webpack_require__(320);
	__webpack_require__(621);
	__webpack_require__(388);
	__webpack_require__(626);
	__webpack_require__(389);
	__webpack_require__(622);
	__webpack_require__(623);
	__webpack_require__(624);
	__webpack_require__(625);
	__webpack_require__(606);
	__webpack_require__(387);
	__webpack_require__(390);
	__webpack_require__(391);
	__webpack_require__(661);
	__webpack_require__(650);
	__webpack_require__(651);
	__webpack_require__(656);
	__webpack_require__(659);
	__webpack_require__(660);
	__webpack_require__(654);
	__webpack_require__(657);
	__webpack_require__(655);
	__webpack_require__(658);
	__webpack_require__(652);
	__webpack_require__(653);
	__webpack_require__(607);
	__webpack_require__(608);
	__webpack_require__(609);
	__webpack_require__(610);
	__webpack_require__(611);
	__webpack_require__(614);
	__webpack_require__(612);
	__webpack_require__(613);
	__webpack_require__(615);
	__webpack_require__(616);
	__webpack_require__(617);
	__webpack_require__(618);
	__webpack_require__(620);
	__webpack_require__(619);
	__webpack_require__(664);
	__webpack_require__(662);
	__webpack_require__(663);
	__webpack_require__(705);
	__webpack_require__(708);
	__webpack_require__(707);
	__webpack_require__(709);
	__webpack_require__(710);
	__webpack_require__(706);
	__webpack_require__(711);
	__webpack_require__(712);
	__webpack_require__(686);
	__webpack_require__(689);
	__webpack_require__(685);
	__webpack_require__(683);
	__webpack_require__(684);
	__webpack_require__(687);
	__webpack_require__(688);
	__webpack_require__(670);
	__webpack_require__(704);
	__webpack_require__(669);
	__webpack_require__(703);
	__webpack_require__(715);
	__webpack_require__(717);
	__webpack_require__(668);
	__webpack_require__(702);
	__webpack_require__(714);
	__webpack_require__(716);
	__webpack_require__(667);
	__webpack_require__(713);
	__webpack_require__(666);
	__webpack_require__(671);
	__webpack_require__(672);
	__webpack_require__(673);
	__webpack_require__(674);
	__webpack_require__(675);
	__webpack_require__(677);
	__webpack_require__(676);
	__webpack_require__(678);
	__webpack_require__(679);
	__webpack_require__(680);
	__webpack_require__(682);
	__webpack_require__(681);
	__webpack_require__(691);
	__webpack_require__(692);
	__webpack_require__(693);
	__webpack_require__(694);
	__webpack_require__(696);
	__webpack_require__(695);
	__webpack_require__(698);
	__webpack_require__(697);
	__webpack_require__(699);
	__webpack_require__(700);
	__webpack_require__(701);
	__webpack_require__(665);
	__webpack_require__(690);
	__webpack_require__(720);
	__webpack_require__(719);
	__webpack_require__(718);
	module.exports = __webpack_require__(36);


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	// This file can be required in Browserify and Node.js for automatic polyfill
	// To use it:  require('es6-promise/auto');
	'use strict';
	module.exports = __webpack_require__(723).polyfill();


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
	 * @version   v4.2.8+1e68dce6
	 */
	
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ES6Promise = factory());
	}(this, (function () { 'use strict';
	
	function objectOrFunction(x) {
	  var type = typeof x;
	  return x !== null && (type === 'object' || type === 'function');
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	
	
	var _isArray = void 0;
	if (Array.isArray) {
	  _isArray = Array.isArray;
	} else {
	  _isArray = function (x) {
	    return Object.prototype.toString.call(x) === '[object Array]';
	  };
	}
	
	var isArray = _isArray;
	
	var len = 0;
	var vertxNext = void 0;
	var customSchedulerFn = void 0;
	
	var asap = function asap(callback, arg) {
	  queue[len] = callback;
	  queue[len + 1] = arg;
	  len += 2;
	  if (len === 2) {
	    // If len is 2, that means that we need to schedule an async flush.
	    // If additional callbacks are queued before the queue is flushed, they
	    // will be processed by this flush that we are scheduling.
	    if (customSchedulerFn) {
	      customSchedulerFn(flush);
	    } else {
	      scheduleFlush();
	    }
	  }
	};
	
	function setScheduler(scheduleFn) {
	  customSchedulerFn = scheduleFn;
	}
	
	function setAsap(asapFn) {
	  asap = asapFn;
	}
	
	var browserWindow = typeof window !== 'undefined' ? window : undefined;
	var browserGlobal = browserWindow || {};
	var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
	
	// test for web worker but not in IE10
	var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	// node
	function useNextTick() {
	  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	  // see https://github.com/cujojs/when/issues/410 for details
	  return function () {
	    return process.nextTick(flush);
	  };
	}
	
	// vertx
	function useVertxTimer() {
	  if (typeof vertxNext !== 'undefined') {
	    return function () {
	      vertxNext(flush);
	    };
	  }
	
	  return useSetTimeout();
	}
	
	function useMutationObserver() {
	  var iterations = 0;
	  var observer = new BrowserMutationObserver(flush);
	  var node = document.createTextNode('');
	  observer.observe(node, { characterData: true });
	
	  return function () {
	    node.data = iterations = ++iterations % 2;
	  };
	}
	
	// web worker
	function useMessageChannel() {
	  var channel = new MessageChannel();
	  channel.port1.onmessage = flush;
	  return function () {
	    return channel.port2.postMessage(0);
	  };
	}
	
	function useSetTimeout() {
	  // Store setTimeout reference so es6-promise will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var globalSetTimeout = setTimeout;
	  return function () {
	    return globalSetTimeout(flush, 1);
	  };
	}
	
	var queue = new Array(1000);
	function flush() {
	  for (var i = 0; i < len; i += 2) {
	    var callback = queue[i];
	    var arg = queue[i + 1];
	
	    callback(arg);
	
	    queue[i] = undefined;
	    queue[i + 1] = undefined;
	  }
	
	  len = 0;
	}
	
	function attemptVertx() {
	  try {
	    var vertx = Function('return this')().require('vertx');
	    vertxNext = vertx.runOnLoop || vertx.runOnContext;
	    return useVertxTimer();
	  } catch (e) {
	    return useSetTimeout();
	  }
	}
	
	var scheduleFlush = void 0;
	// Decide what async method to use to triggering processing of queued callbacks:
	if (isNode) {
	  scheduleFlush = useNextTick();
	} else if (BrowserMutationObserver) {
	  scheduleFlush = useMutationObserver();
	} else if (isWorker) {
	  scheduleFlush = useMessageChannel();
	} else if (browserWindow === undefined && "function" === 'function') {
	  scheduleFlush = attemptVertx();
	} else {
	  scheduleFlush = useSetTimeout();
	}
	
	function then(onFulfillment, onRejection) {
	  var parent = this;
	
	  var child = new this.constructor(noop);
	
	  if (child[PROMISE_ID] === undefined) {
	    makePromise(child);
	  }
	
	  var _state = parent._state;
	
	
	  if (_state) {
	    var callback = arguments[_state - 1];
	    asap(function () {
	      return invokeCallback(_state, child, callback, parent._result);
	    });
	  } else {
	    subscribe(parent, child, onFulfillment, onRejection);
	  }
	
	  return child;
	}
	
	/**
	  `Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    resolve(1);
	  });
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.resolve(1);
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  @method resolve
	  @static
	  @param {Any} value value that the returned promise will be resolved with
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve$1(object) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (object && typeof object === 'object' && object.constructor === Constructor) {
	    return object;
	  }
	
	  var promise = new Constructor(noop);
	  resolve(promise, object);
	  return promise;
	}
	
	var PROMISE_ID = Math.random().toString(36).substring(2);
	
	function noop() {}
	
	var PENDING = void 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	
	function selfFulfillment() {
	  return new TypeError("You cannot resolve a promise with itself");
	}
	
	function cannotReturnOwn() {
	  return new TypeError('A promises callback cannot return that same promise.');
	}
	
	function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
	  try {
	    then$$1.call(value, fulfillmentHandler, rejectionHandler);
	  } catch (e) {
	    return e;
	  }
	}
	
	function handleForeignThenable(promise, thenable, then$$1) {
	  asap(function (promise) {
	    var sealed = false;
	    var error = tryThen(then$$1, thenable, function (value) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	      if (thenable !== value) {
	        resolve(promise, value);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	
	      reject(promise, reason);
	    }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	    if (!sealed && error) {
	      sealed = true;
	      reject(promise, error);
	    }
	  }, promise);
	}
	
	function handleOwnThenable(promise, thenable) {
	  if (thenable._state === FULFILLED) {
	    fulfill(promise, thenable._result);
	  } else if (thenable._state === REJECTED) {
	    reject(promise, thenable._result);
	  } else {
	    subscribe(thenable, undefined, function (value) {
	      return resolve(promise, value);
	    }, function (reason) {
	      return reject(promise, reason);
	    });
	  }
	}
	
	function handleMaybeThenable(promise, maybeThenable, then$$1) {
	  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
	    handleOwnThenable(promise, maybeThenable);
	  } else {
	    if (then$$1 === undefined) {
	      fulfill(promise, maybeThenable);
	    } else if (isFunction(then$$1)) {
	      handleForeignThenable(promise, maybeThenable, then$$1);
	    } else {
	      fulfill(promise, maybeThenable);
	    }
	  }
	}
	
	function resolve(promise, value) {
	  if (promise === value) {
	    reject(promise, selfFulfillment());
	  } else if (objectOrFunction(value)) {
	    var then$$1 = void 0;
	    try {
	      then$$1 = value.then;
	    } catch (error) {
	      reject(promise, error);
	      return;
	    }
	    handleMaybeThenable(promise, value, then$$1);
	  } else {
	    fulfill(promise, value);
	  }
	}
	
	function publishRejection(promise) {
	  if (promise._onerror) {
	    promise._onerror(promise._result);
	  }
	
	  publish(promise);
	}
	
	function fulfill(promise, value) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	
	  promise._result = value;
	  promise._state = FULFILLED;
	
	  if (promise._subscribers.length !== 0) {
	    asap(publish, promise);
	  }
	}
	
	function reject(promise, reason) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	  promise._state = REJECTED;
	  promise._result = reason;
	
	  asap(publishRejection, promise);
	}
	
	function subscribe(parent, child, onFulfillment, onRejection) {
	  var _subscribers = parent._subscribers;
	  var length = _subscribers.length;
	
	
	  parent._onerror = null;
	
	  _subscribers[length] = child;
	  _subscribers[length + FULFILLED] = onFulfillment;
	  _subscribers[length + REJECTED] = onRejection;
	
	  if (length === 0 && parent._state) {
	    asap(publish, parent);
	  }
	}
	
	function publish(promise) {
	  var subscribers = promise._subscribers;
	  var settled = promise._state;
	
	  if (subscribers.length === 0) {
	    return;
	  }
	
	  var child = void 0,
	      callback = void 0,
	      detail = promise._result;
	
	  for (var i = 0; i < subscribers.length; i += 3) {
	    child = subscribers[i];
	    callback = subscribers[i + settled];
	
	    if (child) {
	      invokeCallback(settled, child, callback, detail);
	    } else {
	      callback(detail);
	    }
	  }
	
	  promise._subscribers.length = 0;
	}
	
	function invokeCallback(settled, promise, callback, detail) {
	  var hasCallback = isFunction(callback),
	      value = void 0,
	      error = void 0,
	      succeeded = true;
	
	  if (hasCallback) {
	    try {
	      value = callback(detail);
	    } catch (e) {
	      succeeded = false;
	      error = e;
	    }
	
	    if (promise === value) {
	      reject(promise, cannotReturnOwn());
	      return;
	    }
	  } else {
	    value = detail;
	  }
	
	  if (promise._state !== PENDING) {
	    // noop
	  } else if (hasCallback && succeeded) {
	    resolve(promise, value);
	  } else if (succeeded === false) {
	    reject(promise, error);
	  } else if (settled === FULFILLED) {
	    fulfill(promise, value);
	  } else if (settled === REJECTED) {
	    reject(promise, value);
	  }
	}
	
	function initializePromise(promise, resolver) {
	  try {
	    resolver(function resolvePromise(value) {
	      resolve(promise, value);
	    }, function rejectPromise(reason) {
	      reject(promise, reason);
	    });
	  } catch (e) {
	    reject(promise, e);
	  }
	}
	
	var id = 0;
	function nextId() {
	  return id++;
	}
	
	function makePromise(promise) {
	  promise[PROMISE_ID] = id++;
	  promise._state = undefined;
	  promise._result = undefined;
	  promise._subscribers = [];
	}
	
	function validationError() {
	  return new Error('Array Methods must be provided an Array');
	}
	
	var Enumerator = function () {
	  function Enumerator(Constructor, input) {
	    this._instanceConstructor = Constructor;
	    this.promise = new Constructor(noop);
	
	    if (!this.promise[PROMISE_ID]) {
	      makePromise(this.promise);
	    }
	
	    if (isArray(input)) {
	      this.length = input.length;
	      this._remaining = input.length;
	
	      this._result = new Array(this.length);
	
	      if (this.length === 0) {
	        fulfill(this.promise, this._result);
	      } else {
	        this.length = this.length || 0;
	        this._enumerate(input);
	        if (this._remaining === 0) {
	          fulfill(this.promise, this._result);
	        }
	      }
	    } else {
	      reject(this.promise, validationError());
	    }
	  }
	
	  Enumerator.prototype._enumerate = function _enumerate(input) {
	    for (var i = 0; this._state === PENDING && i < input.length; i++) {
	      this._eachEntry(input[i], i);
	    }
	  };
	
	  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
	    var c = this._instanceConstructor;
	    var resolve$$1 = c.resolve;
	
	
	    if (resolve$$1 === resolve$1) {
	      var _then = void 0;
	      var error = void 0;
	      var didError = false;
	      try {
	        _then = entry.then;
	      } catch (e) {
	        didError = true;
	        error = e;
	      }
	
	      if (_then === then && entry._state !== PENDING) {
	        this._settledAt(entry._state, i, entry._result);
	      } else if (typeof _then !== 'function') {
	        this._remaining--;
	        this._result[i] = entry;
	      } else if (c === Promise$1) {
	        var promise = new c(noop);
	        if (didError) {
	          reject(promise, error);
	        } else {
	          handleMaybeThenable(promise, entry, _then);
	        }
	        this._willSettleAt(promise, i);
	      } else {
	        this._willSettleAt(new c(function (resolve$$1) {
	          return resolve$$1(entry);
	        }), i);
	      }
	    } else {
	      this._willSettleAt(resolve$$1(entry), i);
	    }
	  };
	
	  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
	    var promise = this.promise;
	
	
	    if (promise._state === PENDING) {
	      this._remaining--;
	
	      if (state === REJECTED) {
	        reject(promise, value);
	      } else {
	        this._result[i] = value;
	      }
	    }
	
	    if (this._remaining === 0) {
	      fulfill(promise, this._result);
	    }
	  };
	
	  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
	    var enumerator = this;
	
	    subscribe(promise, undefined, function (value) {
	      return enumerator._settledAt(FULFILLED, i, value);
	    }, function (reason) {
	      return enumerator._settledAt(REJECTED, i, reason);
	    });
	  };
	
	  return Enumerator;
	}();
	
	/**
	  `Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = resolve(2);
	  let promise3 = resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```
	
	  If any of the `promises` given to `all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = reject(new Error("2"));
	  let promise3 = reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```
	
	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
	function all(entries) {
	  return new Enumerator(this, entries).promise;
	}
	
	/**
	  `Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.
	
	  Example:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```
	
	  `Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```
	
	  An example real-world use case is implementing timeouts:
	
	  ```javascript
	  Promise.race([ajax('foo.json'), timeout(5000)])
	  ```
	
	  @method race
	  @static
	  @param {Array} promises array of promises to observe
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
	function race(entries) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (!isArray(entries)) {
	    return new Constructor(function (_, reject) {
	      return reject(new TypeError('You must pass an array to race.'));
	    });
	  } else {
	    return new Constructor(function (resolve, reject) {
	      var length = entries.length;
	      for (var i = 0; i < length; i++) {
	        Constructor.resolve(entries[i]).then(resolve, reject);
	      }
	    });
	  }
	}
	
	/**
	  `Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.reject(new Error('WHOOPS'));
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  @method reject
	  @static
	  @param {Any} reason value that the returned promise will be rejected with.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject$1(reason) {
	  /*jshint validthis:true */
	  var Constructor = this;
	  var promise = new Constructor(noop);
	  reject(promise, reason);
	  return promise;
	}
	
	function needsResolver() {
	  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	}
	
	function needsNew() {
	  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	}
	
	/**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise's eventual value or the reason
	  why the promise cannot be fulfilled.
	
	  Terminology
	  -----------
	
	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.
	
	  A promise can be in one of three states: pending, fulfilled, or rejected.
	
	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.
	
	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.
	
	
	  Basic Usage:
	  ------------
	
	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);
	
	    // on failure
	    reject(reason);
	  });
	
	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Advanced Usage:
	  ---------------
	
	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.
	
	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();
	
	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();
	
	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }
	
	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Unlike callbacks, promises are great composable primitives.
	
	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON
	
	    return values;
	  });
	  ```
	
	  @class Promise
	  @param {Function} resolver
	  Useful for tooling.
	  @constructor
	*/
	
	var Promise$1 = function () {
	  function Promise(resolver) {
	    this[PROMISE_ID] = nextId();
	    this._result = this._state = undefined;
	    this._subscribers = [];
	
	    if (noop !== resolver) {
	      typeof resolver !== 'function' && needsResolver();
	      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
	    }
	  }
	
	  /**
	  The primary way of interacting with a promise is through its `then` method,
	  which registers callbacks to receive either a promise's eventual value or the
	  reason why the promise cannot be fulfilled.
	   ```js
	  findUser().then(function(user){
	    // user is available
	  }, function(reason){
	    // user is unavailable, and you are given the reason why
	  });
	  ```
	   Chaining
	  --------
	   The return value of `then` is itself a promise.  This second, 'downstream'
	  promise is resolved with the return value of the first promise's fulfillment
	  or rejection handler, or rejected if the handler throws an exception.
	   ```js
	  findUser().then(function (user) {
	    return user.name;
	  }, function (reason) {
	    return 'default name';
	  }).then(function (userName) {
	    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	    // will be `'default name'`
	  });
	   findUser().then(function (user) {
	    throw new Error('Found user, but still unhappy');
	  }, function (reason) {
	    throw new Error('`findUser` rejected and we're unhappy');
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	  });
	  ```
	  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	   ```js
	  findUser().then(function (user) {
	    throw new PedagogicalException('Upstream error');
	  }).then(function (value) {
	    // never reached
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // The `PedgagocialException` is propagated all the way down to here
	  });
	  ```
	   Assimilation
	  ------------
	   Sometimes the value you want to propagate to a downstream promise can only be
	  retrieved asynchronously. This can be achieved by returning a promise in the
	  fulfillment or rejection handler. The downstream promise will then be pending
	  until the returned promise is settled. This is called *assimilation*.
	   ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // The user's comments are now available
	  });
	  ```
	   If the assimliated promise rejects, then the downstream promise will also reject.
	   ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // If `findCommentsByAuthor` fulfills, we'll have the value here
	  }, function (reason) {
	    // If `findCommentsByAuthor` rejects, we'll have the reason here
	  });
	  ```
	   Simple Example
	  --------------
	   Synchronous Example
	   ```javascript
	  let result;
	   try {
	    result = findResult();
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	   Errback Example
	   ```js
	  findResult(function(result, err){
	    if (err) {
	      // failure
	    } else {
	      // success
	    }
	  });
	  ```
	   Promise Example;
	   ```javascript
	  findResult().then(function(result){
	    // success
	  }, function(reason){
	    // failure
	  });
	  ```
	   Advanced Example
	  --------------
	   Synchronous Example
	   ```javascript
	  let author, books;
	   try {
	    author = findAuthor();
	    books  = findBooksByAuthor(author);
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	   Errback Example
	   ```js
	   function foundBooks(books) {
	   }
	   function failure(reason) {
	   }
	   findAuthor(function(author, err){
	    if (err) {
	      failure(err);
	      // failure
	    } else {
	      try {
	        findBoooksByAuthor(author, function(books, err) {
	          if (err) {
	            failure(err);
	          } else {
	            try {
	              foundBooks(books);
	            } catch(reason) {
	              failure(reason);
	            }
	          }
	        });
	      } catch(error) {
	        failure(err);
	      }
	      // success
	    }
	  });
	  ```
	   Promise Example;
	   ```javascript
	  findAuthor().
	    then(findBooksByAuthor).
	    then(function(books){
	      // found books
	  }).catch(function(reason){
	    // something went wrong
	  });
	  ```
	   @method then
	  @param {Function} onFulfilled
	  @param {Function} onRejected
	  Useful for tooling.
	  @return {Promise}
	  */
	
	  /**
	  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	  as the catch block of a try/catch statement.
	  ```js
	  function findAuthor(){
	  throw new Error('couldn't find that author');
	  }
	  // synchronous
	  try {
	  findAuthor();
	  } catch(reason) {
	  // something went wrong
	  }
	  // async with promises
	  findAuthor().catch(function(reason){
	  // something went wrong
	  });
	  ```
	  @method catch
	  @param {Function} onRejection
	  Useful for tooling.
	  @return {Promise}
	  */
	
	
	  Promise.prototype.catch = function _catch(onRejection) {
	    return this.then(null, onRejection);
	  };
	
	  /**
	    `finally` will be invoked regardless of the promise's fate just as native
	    try/catch/finally behaves
	  
	    Synchronous example:
	  
	    ```js
	    findAuthor() {
	      if (Math.random() > 0.5) {
	        throw new Error();
	      }
	      return new Author();
	    }
	  
	    try {
	      return findAuthor(); // succeed or fail
	    } catch(error) {
	      return findOtherAuther();
	    } finally {
	      // always runs
	      // doesn't affect the return value
	    }
	    ```
	  
	    Asynchronous example:
	  
	    ```js
	    findAuthor().catch(function(reason){
	      return findOtherAuther();
	    }).finally(function(){
	      // author was either found, or not
	    });
	    ```
	  
	    @method finally
	    @param {Function} callback
	    @return {Promise}
	  */
	
	
	  Promise.prototype.finally = function _finally(callback) {
	    var promise = this;
	    var constructor = promise.constructor;
	
	    if (isFunction(callback)) {
	      return promise.then(function (value) {
	        return constructor.resolve(callback()).then(function () {
	          return value;
	        });
	      }, function (reason) {
	        return constructor.resolve(callback()).then(function () {
	          throw reason;
	        });
	      });
	    }
	
	    return promise.then(callback, callback);
	  };
	
	  return Promise;
	}();
	
	Promise$1.prototype.then = then;
	Promise$1.all = all;
	Promise$1.race = race;
	Promise$1.resolve = resolve$1;
	Promise$1.reject = reject$1;
	Promise$1._setScheduler = setScheduler;
	Promise$1._setAsap = setAsap;
	Promise$1._asap = asap;
	
	/*global self*/
	function polyfill() {
	  var local = void 0;
	
	  if (typeof global !== 'undefined') {
	    local = global;
	  } else if (typeof self !== 'undefined') {
	    local = self;
	  } else {
	    try {
	      local = Function('return this')();
	    } catch (e) {
	      throw new Error('polyfill failed because global object is unavailable in this environment');
	    }
	  }
	
	  var P = local.Promise;
	
	  if (P) {
	    var promiseToString = null;
	    try {
	      promiseToString = Object.prototype.toString.call(P.resolve());
	    } catch (e) {
	      // silently ignored
	    }
	
	    if (promiseToString === '[object Promise]' && !P.cast) {
	      return;
	    }
	  }
	
	  local.Promise = Promise$1;
	}
	
	// Strange compat..
	Promise$1.polyfill = polyfill;
	Promise$1.Promise = Promise$1;
	
	return Promise$1;
	
	})));
	
	
	
	//# sourceMappingURL=es6-promise.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(850), (function() { return this; }())))

/***/ }),
/* 724 */
47,
/* 725 */
47,
/* 726 */,
/* 727 */,
/* 728 */
47,
/* 729 */,
/* 730 */,
/* 731 */
47,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */
47,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */
47,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */
47,
/* 749 */,
/* 750 */
47,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */
47,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/* build: `node build.js modules=ALL exclude=gestures,accessors requirejs minifier=uglifyjs` */
	/*! Fabric.js Copyright 2008-2015, Printio (Juriy Zaytsev, Maxim Chernyak) */
	
	var fabric = fabric || { version: '3.3.0' };
	if (true) {
	  exports.fabric = fabric;
	}
	/* _AMD_START_ */
	else if (typeof define === 'function' && define.amd) {
	  define([], function() { return fabric; });
	}
	/* _AMD_END_ */
	if (typeof document !== 'undefined' && typeof window !== 'undefined') {
	  if (document instanceof (typeof HTMLDocument !== 'undefined' ? HTMLDocument : Document)) {
	    fabric.document = document;
	  }
	  else {
	    fabric.document = document.implementation.createHTMLDocument('');
	  }
	  fabric.window = window;
	}
	else {
	  // assume we're running under node.js when document/window are not present
	  var jsdom = __webpack_require__(285);
	  var virtualWindow = new jsdom.JSDOM(
	    decodeURIComponent('%3C!DOCTYPE%20html%3E%3Chtml%3E%3Chead%3E%3C%2Fhead%3E%3Cbody%3E%3C%2Fbody%3E%3C%2Fhtml%3E'),
	    {
	      features: {
	        FetchExternalResources: ['img']
	      },
	      resources: 'usable'
	    }).window;
	  fabric.document = virtualWindow.document;
	  fabric.jsdomImplForWrapper = __webpack_require__(286).implForWrapper;
	  fabric.nodeCanvas = __webpack_require__(287).Canvas;
	  fabric.window = virtualWindow;
	  DOMParser = fabric.window.DOMParser;
	}
	
	/**
	 * True when in environment that supports touch events
	 * @type boolean
	 */
	fabric.isTouchSupported = 'ontouchstart' in fabric.window || 'ontouchstart' in fabric.document ||
	  (fabric.window && fabric.window.navigator && fabric.window.navigator.maxTouchPoints > 0);
	
	/**
	 * True when in environment that's probably Node.js
	 * @type boolean
	 */
	fabric.isLikelyNode = typeof Buffer !== 'undefined' &&
	                      typeof window === 'undefined';
	
	/* _FROM_SVG_START_ */
	/**
	 * Attributes parsed from all SVG elements
	 * @type array
	 */
	fabric.SHARED_ATTRIBUTES = [
	  'display',
	  'transform',
	  'fill', 'fill-opacity', 'fill-rule',
	  'opacity',
	  'stroke', 'stroke-dasharray', 'stroke-linecap', 'stroke-dashoffset',
	  'stroke-linejoin', 'stroke-miterlimit',
	  'stroke-opacity', 'stroke-width',
	  'id', 'paint-order', 'vector-effect',
	  'instantiated_by_use', 'clip-path'
	];
	/* _FROM_SVG_END_ */
	
	/**
	 * Pixel per Inch as a default value set to 96. Can be changed for more realistic conversion.
	 */
	fabric.DPI = 96;
	fabric.reNum = '(?:[-+]?(?:\\d+|\\d*\\.\\d+)(?:[eE][-+]?\\d+)?)';
	fabric.fontPaths = { };
	fabric.iMatrix = [1, 0, 0, 1, 0, 0];
	
	/**
	 * Pixel limit for cache canvases. 1Mpx , 4Mpx should be fine.
	 * @since 1.7.14
	 * @type Number
	 * @default
	 */
	fabric.perfLimitSizeTotal = 2097152;
	
	/**
	 * Pixel limit for cache canvases width or height. IE fixes the maximum at 5000
	 * @since 1.7.14
	 * @type Number
	 * @default
	 */
	fabric.maxCacheSideLimit = 4096;
	
	/**
	 * Lowest pixel limit for cache canvases, set at 256PX
	 * @since 1.7.14
	 * @type Number
	 * @default
	 */
	fabric.minCacheSideLimit = 256;
	
	/**
	 * Cache Object for widths of chars in text rendering.
	 */
	fabric.charWidthsCache = { };
	
	/**
	 * if webgl is enabled and available, textureSize will determine the size
	 * of the canvas backend
	 * @since 2.0.0
	 * @type Number
	 * @default
	 */
	fabric.textureSize = 2048;
	
	/**
	 * When 'true', style information is not retained when copy/pasting text, making
	 * pasted text use destination style.
	 * Defaults to 'false'.
	 * @type Boolean
	 * @default
	 */
	fabric.disableStyleCopyPaste = false;
	
	/**
	 * Enable webgl for filtering picture is available
	 * A filtering backend will be initialized, this will both take memory and
	 * time since a default 2048x2048 canvas will be created for the gl context
	 * @since 2.0.0
	 * @type Boolean
	 * @default
	 */
	fabric.enableGLFiltering = true;
	
	/**
	 * Device Pixel Ratio
	 * @see https://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/HTML-canvas-guide/SettingUptheCanvas/SettingUptheCanvas.html
	 */
	fabric.devicePixelRatio = fabric.window.devicePixelRatio ||
	                          fabric.window.webkitDevicePixelRatio ||
	                          fabric.window.mozDevicePixelRatio ||
	                          1;
	/**
	 * Browser-specific constant to adjust CanvasRenderingContext2D.shadowBlur value,
	 * which is unitless and not rendered equally across browsers.
	 *
	 * Values that work quite well (as of October 2017) are:
	 * - Chrome: 1.5
	 * - Edge: 1.75
	 * - Firefox: 0.9
	 * - Safari: 0.95
	 *
	 * @since 2.0.0
	 * @type Number
	 * @default 1
	 */
	fabric.browserShadowBlurConstant = 1;
	
	/**
	 * This object contains the result of arc to beizer conversion for faster retrieving if the same arc needs to be converted again.
	 * It was an internal variable, is accessible since version 2.3.4
	 */
	fabric.arcToSegmentsCache = { };
	
	/**
	 * This object keeps the results of the boundsOfCurve calculation mapped by the joined arguments necessary to calculate it.
	 * It does speed up calculation, if you parse and add always the same paths, but in case of heavy usage of freedrawing
	 * you do not get any speed benefit and you get a big object in memory.
	 * The object was a private variable before, while now is appended to the lib so that you have access to it and you
	 * can eventually clear it.
	 * It was an internal variable, is accessible since version 2.3.4
	 */
	fabric.boundsOfCurveCache = { };
	
	/**
	 * If disabled boundsOfCurveCache is not used. For apps that make heavy usage of pencil drawing probably disabling it is better
	 * @default true
	 */
	fabric.cachesBoundsOfCurve = true;
	
	/**
	 * Skip performance testing of setupGLContext and force the use of putImageData that seems to be the one that works best on
	 * Chrome + old hardware. if your users are experiencing empty images after filtering you may try to force this to true
	 * this has to be set before instantiating the filtering backend ( before filtering the first image )
	 * @type Boolean
	 * @default false
	 */
	fabric.forceGLPutImageData = false;
	
	fabric.initFilterBackend = function() {
	  if (fabric.enableGLFiltering && fabric.isWebglSupported && fabric.isWebglSupported(fabric.textureSize)) {
	    console.log('max texture size: ' + fabric.maxTextureSize);
	    return (new fabric.WebglFilterBackend({ tileSize: fabric.textureSize }));
	  }
	  else if (fabric.Canvas2dFilterBackend) {
	    return (new fabric.Canvas2dFilterBackend());
	  }
	};
	
	
	if (typeof document !== 'undefined' && typeof window !== 'undefined') {
	  // ensure globality even if entire library were function wrapped (as in Meteor.js packaging system)
	  window.fabric = fabric;
	}
	
	
	(function() {
	
	  /**
	   * @private
	   * @param {String} eventName
	   * @param {Function} handler
	   */
	  function _removeEventListener(eventName, handler) {
	    if (!this.__eventListeners[eventName]) {
	      return;
	    }
	    var eventListener = this.__eventListeners[eventName];
	    if (handler) {
	      eventListener[eventListener.indexOf(handler)] = false;
	    }
	    else {
	      fabric.util.array.fill(eventListener, false);
	    }
	  }
	
	  /**
	   * Observes specified event
	   * @deprecated `observe` deprecated since 0.8.34 (use `on` instead)
	   * @memberOf fabric.Observable
	   * @alias on
	   * @param {String|Object} eventName Event name (eg. 'after:render') or object with key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
	   * @param {Function} handler Function that receives a notification when an event of the specified type occurs
	   * @return {Self} thisArg
	   * @chainable
	   */
	  function observe(eventName, handler) {
	    if (!this.__eventListeners) {
	      this.__eventListeners = { };
	    }
	    // one object with key/value pairs was passed
	    if (arguments.length === 1) {
	      for (var prop in eventName) {
	        this.on(prop, eventName[prop]);
	      }
	    }
	    else {
	      if (!this.__eventListeners[eventName]) {
	        this.__eventListeners[eventName] = [];
	      }
	      this.__eventListeners[eventName].push(handler);
	    }
	    return this;
	  }
	
	  /**
	   * Stops event observing for a particular event handler. Calling this method
	   * without arguments removes all handlers for all events
	   * @deprecated `stopObserving` deprecated since 0.8.34 (use `off` instead)
	   * @memberOf fabric.Observable
	   * @alias off
	   * @param {String|Object} eventName Event name (eg. 'after:render') or object with key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
	   * @param {Function} handler Function to be deleted from EventListeners
	   * @return {Self} thisArg
	   * @chainable
	   */
	  function stopObserving(eventName, handler) {
	    if (!this.__eventListeners) {
	      return this;
	    }
	
	    // remove all key/value pairs (event name -> event handler)
	    if (arguments.length === 0) {
	      for (eventName in this.__eventListeners) {
	        _removeEventListener.call(this, eventName);
	      }
	    }
	    // one object with key/value pairs was passed
	    else if (arguments.length === 1 && typeof arguments[0] === 'object') {
	      for (var prop in eventName) {
	        _removeEventListener.call(this, prop, eventName[prop]);
	      }
	    }
	    else {
	      _removeEventListener.call(this, eventName, handler);
	    }
	    return this;
	  }
	
	  /**
	   * Fires event with an optional options object
	   * @deprecated `fire` deprecated since 1.0.7 (use `trigger` instead)
	   * @memberOf fabric.Observable
	   * @alias trigger
	   * @param {String} eventName Event name to fire
	   * @param {Object} [options] Options object
	   * @return {Self} thisArg
	   * @chainable
	   */
	  function fire(eventName, options) {
	    if (!this.__eventListeners) {
	      return this;
	    }
	
	    var listenersForEvent = this.__eventListeners[eventName];
	    if (!listenersForEvent) {
	      return this;
	    }
	
	    for (var i = 0, len = listenersForEvent.length; i < len; i++) {
	      listenersForEvent[i] && listenersForEvent[i].call(this, options || { });
	    }
	    this.__eventListeners[eventName] = listenersForEvent.filter(function(value) {
	      return value !== false;
	    });
	    return this;
	  }
	
	  /**
	   * @namespace fabric.Observable
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#events}
	   * @see {@link http://fabricjs.com/events|Events demo}
	   */
	  fabric.Observable = {
	    observe: observe,
	    stopObserving: stopObserving,
	    fire: fire,
	
	    on: observe,
	    off: stopObserving,
	    trigger: fire
	  };
	})();
	
	
	/**
	 * @namespace fabric.Collection
	 */
	fabric.Collection = {
	
	  _objects: [],
	
	  /**
	   * Adds objects to collection, Canvas or Group, then renders canvas
	   * (if `renderOnAddRemove` is not `false`).
	   * in case of Group no changes to bounding box are made.
	   * Objects should be instances of (or inherit from) fabric.Object
	   * Use of this function is highly discouraged for groups.
	   * you can add a bunch of objects with the add method but then you NEED
	   * to run a addWithUpdate call for the Group class or position/bbox will be wrong.
	   * @param {...fabric.Object} object Zero or more fabric instances
	   * @return {Self} thisArg
	   * @chainable
	   */
	  add: function () {
	    this._objects.push.apply(this._objects, arguments);
	    if (this._onObjectAdded) {
	      for (var i = 0, length = arguments.length; i < length; i++) {
	        this._onObjectAdded(arguments[i]);
	      }
	    }
	    this.renderOnAddRemove && this.requestRenderAll();
	    return this;
	  },
	
	  /**
	   * Inserts an object into collection at specified index, then renders canvas (if `renderOnAddRemove` is not `false`)
	   * An object should be an instance of (or inherit from) fabric.Object
	   * Use of this function is highly discouraged for groups.
	   * you can add a bunch of objects with the insertAt method but then you NEED
	   * to run a addWithUpdate call for the Group class or position/bbox will be wrong.
	   * @param {Object} object Object to insert
	   * @param {Number} index Index to insert object at
	   * @param {Boolean} nonSplicing When `true`, no splicing (shifting) of objects occurs
	   * @return {Self} thisArg
	   * @chainable
	   */
	  insertAt: function (object, index, nonSplicing) {
	    var objects = this._objects;
	    if (nonSplicing) {
	      objects[index] = object;
	    }
	    else {
	      objects.splice(index, 0, object);
	    }
	    this._onObjectAdded && this._onObjectAdded(object);
	    this.renderOnAddRemove && this.requestRenderAll();
	    return this;
	  },
	
	  /**
	   * Removes objects from a collection, then renders canvas (if `renderOnAddRemove` is not `false`)
	   * @param {...fabric.Object} object Zero or more fabric instances
	   * @return {Self} thisArg
	   * @chainable
	   */
	  remove: function() {
	    var objects = this._objects,
	        index, somethingRemoved = false;
	
	    for (var i = 0, length = arguments.length; i < length; i++) {
	      index = objects.indexOf(arguments[i]);
	
	      // only call onObjectRemoved if an object was actually removed
	      if (index !== -1) {
	        somethingRemoved = true;
	        objects.splice(index, 1);
	        this._onObjectRemoved && this._onObjectRemoved(arguments[i]);
	      }
	    }
	
	    this.renderOnAddRemove && somethingRemoved && this.requestRenderAll();
	    return this;
	  },
	
	  /**
	   * Executes given function for each object in this group
	   * @param {Function} callback
	   *                   Callback invoked with current object as first argument,
	   *                   index - as second and an array of all objects - as third.
	   *                   Callback is invoked in a context of Global Object (e.g. `window`)
	   *                   when no `context` argument is given
	   *
	   * @param {Object} context Context (aka thisObject)
	   * @return {Self} thisArg
	   * @chainable
	   */
	  forEachObject: function(callback, context) {
	    var objects = this.getObjects();
	    for (var i = 0, len = objects.length; i < len; i++) {
	      callback.call(context, objects[i], i, objects);
	    }
	    return this;
	  },
	
	  /**
	   * Returns an array of children objects of this instance
	   * Type parameter introduced in 1.3.10
	   * since 2.3.5 this method return always a COPY of the array;
	   * @param {String} [type] When specified, only objects of this type are returned
	   * @return {Array}
	   */
	  getObjects: function(type) {
	    if (typeof type === 'undefined') {
	      return this._objects.concat();
	    }
	    return this._objects.filter(function(o) {
	      return o.type === type;
	    });
	  },
	
	  /**
	   * Returns object at specified index
	   * @param {Number} index
	   * @return {Self} thisArg
	   */
	  item: function (index) {
	    return this._objects[index];
	  },
	
	  /**
	   * Returns true if collection contains no objects
	   * @return {Boolean} true if collection is empty
	   */
	  isEmpty: function () {
	    return this._objects.length === 0;
	  },
	
	  /**
	   * Returns a size of a collection (i.e: length of an array containing its objects)
	   * @return {Number} Collection size
	   */
	  size: function() {
	    return this._objects.length;
	  },
	
	  /**
	   * Returns true if collection contains an object
	   * @param {Object} object Object to check against
	   * @return {Boolean} `true` if collection contains an object
	   */
	  contains: function(object) {
	    return this._objects.indexOf(object) > -1;
	  },
	
	  /**
	   * Returns number representation of a collection complexity
	   * @return {Number} complexity
	   */
	  complexity: function () {
	    return this._objects.reduce(function (memo, current) {
	      memo += current.complexity ? current.complexity() : 0;
	      return memo;
	    }, 0);
	  }
	};
	
	
	/**
	 * @namespace fabric.CommonMethods
	 */
	fabric.CommonMethods = {
	
	  /**
	   * Sets object's properties from options
	   * @param {Object} [options] Options object
	   */
	  _setOptions: function(options) {
	    for (var prop in options) {
	      this.set(prop, options[prop]);
	    }
	  },
	
	  /**
	   * @private
	   * @param {Object} [filler] Options object
	   * @param {String} [property] property to set the Gradient to
	   */
	  _initGradient: function(filler, property) {
	    if (filler && filler.colorStops && !(filler instanceof fabric.Gradient)) {
	      this.set(property, new fabric.Gradient(filler));
	    }
	  },
	
	  /**
	   * @private
	   * @param {Object} [filler] Options object
	   * @param {String} [property] property to set the Pattern to
	   * @param {Function} [callback] callback to invoke after pattern load
	   */
	  _initPattern: function(filler, property, callback) {
	    if (filler && filler.source && !(filler instanceof fabric.Pattern)) {
	      this.set(property, new fabric.Pattern(filler, callback));
	    }
	    else {
	      callback && callback();
	    }
	  },
	
	  /**
	   * @private
	   * @param {Object} [options] Options object
	   */
	  _initClipping: function(options) {
	    if (!options.clipTo || typeof options.clipTo !== 'string') {
	      return;
	    }
	
	    var functionBody = fabric.util.getFunctionBody(options.clipTo);
	    if (typeof functionBody !== 'undefined') {
	      this.clipTo = new Function('ctx', functionBody);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _setObject: function(obj) {
	    for (var prop in obj) {
	      this._set(prop, obj[prop]);
	    }
	  },
	
	  /**
	   * Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
	   * @param {String|Object} key Property name or object (if object, iterate over the object properties)
	   * @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
	   * @return {fabric.Object} thisArg
	   * @chainable
	   */
	  set: function(key, value) {
	    if (typeof key === 'object') {
	      this._setObject(key);
	    }
	    else {
	      if (typeof value === 'function' && key !== 'clipTo') {
	        this._set(key, value(this.get(key)));
	      }
	      else {
	        this._set(key, value);
	      }
	    }
	    return this;
	  },
	
	  _set: function(key, value) {
	    this[key] = value;
	  },
	
	  /**
	   * Toggles specified property from `true` to `false` or from `false` to `true`
	   * @param {String} property Property to toggle
	   * @return {fabric.Object} thisArg
	   * @chainable
	   */
	  toggle: function(property) {
	    var value = this.get(property);
	    if (typeof value === 'boolean') {
	      this.set(property, !value);
	    }
	    return this;
	  },
	
	  /**
	   * Basic getter
	   * @param {String} property Property name
	   * @return {*} value of a property
	   */
	  get: function(property) {
	    return this[property];
	  }
	};
	
	
	(function(global) {
	
	  var sqrt = Math.sqrt,
	      atan2 = Math.atan2,
	      pow = Math.pow,
	      abs = Math.abs,
	      PiBy180 = Math.PI / 180,
	      PiBy2 = Math.PI / 2;
	
	  /**
	   * @namespace fabric.util
	   */
	  fabric.util = {
	
	    /**
	     * Calculate the cos of an angle, avoiding returning floats for known results
	     * @static
	     * @memberOf fabric.util
	     * @param {Number} angle the angle in radians or in degree
	     * @return {Number}
	     */
	    cos: function(angle) {
	      if (angle === 0) { return 1; }
	      if (angle < 0) {
	        // cos(a) = cos(-a)
	        angle = -angle;
	      }
	      var angleSlice = angle / PiBy2;
	      switch (angleSlice) {
	        case 1: case 3: return 0;
	        case 2: return -1;
	      }
	      return Math.cos(angle);
	    },
	
	    /**
	     * Calculate the sin of an angle, avoiding returning floats for known results
	     * @static
	     * @memberOf fabric.util
	     * @param {Number} angle the angle in radians or in degree
	     * @return {Number}
	     */
	    sin: function(angle) {
	      if (angle === 0) { return 0; }
	      var angleSlice = angle / PiBy2, sign = 1;
	      if (angle < 0) {
	        // sin(-a) = -sin(a)
	        sign = -1;
	      }
	      switch (angleSlice) {
	        case 1: return sign;
	        case 2: return 0;
	        case 3: return -sign;
	      }
	      return Math.sin(angle);
	    },
	
	    /**
	     * Removes value from an array.
	     * Presence of value (and its position in an array) is determined via `Array.prototype.indexOf`
	     * @static
	     * @memberOf fabric.util
	     * @param {Array} array
	     * @param {*} value
	     * @return {Array} original array
	     */
	    removeFromArray: function(array, value) {
	      var idx = array.indexOf(value);
	      if (idx !== -1) {
	        array.splice(idx, 1);
	      }
	      return array;
	    },
	
	    /**
	     * Returns random number between 2 specified ones.
	     * @static
	     * @memberOf fabric.util
	     * @param {Number} min lower limit
	     * @param {Number} max upper limit
	     * @return {Number} random value (between min and max)
	     */
	    getRandomInt: function(min, max) {
	      return Math.floor(Math.random() * (max - min + 1)) + min;
	    },
	
	    /**
	     * Transforms degrees to radians.
	     * @static
	     * @memberOf fabric.util
	     * @param {Number} degrees value in degrees
	     * @return {Number} value in radians
	     */
	    degreesToRadians: function(degrees) {
	      return degrees * PiBy180;
	    },
	
	    /**
	     * Transforms radians to degrees.
	     * @static
	     * @memberOf fabric.util
	     * @param {Number} radians value in radians
	     * @return {Number} value in degrees
	     */
	    radiansToDegrees: function(radians) {
	      return radians / PiBy180;
	    },
	
	    /**
	     * Rotates `point` around `origin` with `radians`
	     * @static
	     * @memberOf fabric.util
	     * @param {fabric.Point} point The point to rotate
	     * @param {fabric.Point} origin The origin of the rotation
	     * @param {Number} radians The radians of the angle for the rotation
	     * @return {fabric.Point} The new rotated point
	     */
	    rotatePoint: function(point, origin, radians) {
	      point.subtractEquals(origin);
	      var v = fabric.util.rotateVector(point, radians);
	      return new fabric.Point(v.x, v.y).addEquals(origin);
	    },
	
	    /**
	     * Rotates `vector` with `radians`
	     * @static
	     * @memberOf fabric.util
	     * @param {Object} vector The vector to rotate (x and y)
	     * @param {Number} radians The radians of the angle for the rotation
	     * @return {Object} The new rotated point
	     */
	    rotateVector: function(vector, radians) {
	      var sin = fabric.util.sin(radians),
	          cos = fabric.util.cos(radians),
	          rx = vector.x * cos - vector.y * sin,
	          ry = vector.x * sin + vector.y * cos;
	      return {
	        x: rx,
	        y: ry
	      };
	    },
	
	    /**
	     * Apply transform t to point p
	     * @static
	     * @memberOf fabric.util
	     * @param  {fabric.Point} p The point to transform
	     * @param  {Array} t The transform
	     * @param  {Boolean} [ignoreOffset] Indicates that the offset should not be applied
	     * @return {fabric.Point} The transformed point
	     */
	    transformPoint: function(p, t, ignoreOffset) {
	      if (ignoreOffset) {
	        return new fabric.Point(
	          t[0] * p.x + t[2] * p.y,
	          t[1] * p.x + t[3] * p.y
	        );
	      }
	      return new fabric.Point(
	        t[0] * p.x + t[2] * p.y + t[4],
	        t[1] * p.x + t[3] * p.y + t[5]
	      );
	    },
	
	    /**
	     * Returns coordinates of points's bounding rectangle (left, top, width, height)
	     * @param {Array} points 4 points array
	     * @return {Object} Object with left, top, width, height properties
	     */
	    makeBoundingBoxFromPoints: function(points) {
	      var xPoints = [points[0].x, points[1].x, points[2].x, points[3].x],
	          minX = fabric.util.array.min(xPoints),
	          maxX = fabric.util.array.max(xPoints),
	          width = maxX - minX,
	          yPoints = [points[0].y, points[1].y, points[2].y, points[3].y],
	          minY = fabric.util.array.min(yPoints),
	          maxY = fabric.util.array.max(yPoints),
	          height = maxY - minY;
	
	      return {
	        left: minX,
	        top: minY,
	        width: width,
	        height: height
	      };
	    },
	
	    /**
	     * Invert transformation t
	     * @static
	     * @memberOf fabric.util
	     * @param {Array} t The transform
	     * @return {Array} The inverted transform
	     */
	    invertTransform: function(t) {
	      var a = 1 / (t[0] * t[3] - t[1] * t[2]),
	          r = [a * t[3], -a * t[1], -a * t[2], a * t[0]],
	          o = fabric.util.transformPoint({ x: t[4], y: t[5] }, r, true);
	      r[4] = -o.x;
	      r[5] = -o.y;
	      return r;
	    },
	
	    /**
	     * A wrapper around Number#toFixed, which contrary to native method returns number, not string.
	     * @static
	     * @memberOf fabric.util
	     * @param {Number|String} number number to operate on
	     * @param {Number} fractionDigits number of fraction digits to "leave"
	     * @return {Number}
	     */
	    toFixed: function(number, fractionDigits) {
	      return parseFloat(Number(number).toFixed(fractionDigits));
	    },
	
	    /**
	     * Converts from attribute value to pixel value if applicable.
	     * Returns converted pixels or original value not converted.
	     * @param {Number|String} value number to operate on
	     * @param {Number} fontSize
	     * @return {Number|String}
	     */
	    parseUnit: function(value, fontSize) {
	      var unit = /\D{0,2}$/.exec(value),
	          number = parseFloat(value);
	      if (!fontSize) {
	        fontSize = fabric.Text.DEFAULT_SVG_FONT_SIZE;
	      }
	      switch (unit[0]) {
	        case 'mm':
	          return number * fabric.DPI / 25.4;
	
	        case 'cm':
	          return number * fabric.DPI / 2.54;
	
	        case 'in':
	          return number * fabric.DPI;
	
	        case 'pt':
	          return number * fabric.DPI / 72; // or * 4 / 3
	
	        case 'pc':
	          return number * fabric.DPI / 72 * 12; // or * 16
	
	        case 'em':
	          return number * fontSize;
	
	        default:
	          return number;
	      }
	    },
	
	    /**
	     * Function which always returns `false`.
	     * @static
	     * @memberOf fabric.util
	     * @return {Boolean}
	     */
	    falseFunction: function() {
	      return false;
	    },
	
	    /**
	     * Returns klass "Class" object of given namespace
	     * @memberOf fabric.util
	     * @param {String} type Type of object (eg. 'circle')
	     * @param {String} namespace Namespace to get klass "Class" object from
	     * @return {Object} klass "Class"
	     */
	    getKlass: function(type, namespace) {
	      // capitalize first letter only
	      type = fabric.util.string.camelize(type.charAt(0).toUpperCase() + type.slice(1));
	      return fabric.util.resolveNamespace(namespace)[type];
	    },
	
	    /**
	     * Returns array of attributes for given svg that fabric parses
	     * @memberOf fabric.util
	     * @param {String} type Type of svg element (eg. 'circle')
	     * @return {Array} string names of supported attributes
	     */
	    getSvgAttributes: function(type) {
	      var attributes = [
	        'instantiated_by_use',
	        'style',
	        'id',
	        'class'
	      ];
	      switch (type) {
	        case 'linearGradient':
	          attributes = attributes.concat(['x1', 'y1', 'x2', 'y2', 'gradientUnits', 'gradientTransform']);
	          break;
	        case 'radialGradient':
	          attributes = attributes.concat(['gradientUnits', 'gradientTransform', 'cx', 'cy', 'r', 'fx', 'fy', 'fr']);
	          break;
	        case 'stop':
	          attributes = attributes.concat(['offset', 'stop-color', 'stop-opacity']);
	          break;
	      }
	      return attributes;
	    },
	
	    /**
	     * Returns object of given namespace
	     * @memberOf fabric.util
	     * @param {String} namespace Namespace string e.g. 'fabric.Image.filter' or 'fabric'
	     * @return {Object} Object for given namespace (default fabric)
	     */
	    resolveNamespace: function(namespace) {
	      if (!namespace) {
	        return fabric;
	      }
	
	      var parts = namespace.split('.'),
	          len = parts.length, i,
	          obj = global || fabric.window;
	
	      for (i = 0; i < len; ++i) {
	        obj = obj[parts[i]];
	      }
	
	      return obj;
	    },
	
	    /**
	     * Loads image element from given url and passes it to a callback
	     * @memberOf fabric.util
	     * @param {String} url URL representing an image
	     * @param {Function} callback Callback; invoked with loaded image
	     * @param {*} [context] Context to invoke callback in
	     * @param {Object} [crossOrigin] crossOrigin value to set image element to
	     */
	    loadImage: function(url, callback, context, crossOrigin) {
	      if (!url) {
	        callback && callback.call(context, url);
	        return;
	      }
	
	      var img = fabric.util.createImage();
	
	      /** @ignore */
	      var onLoadCallback = function () {
	        callback && callback.call(context, img);
	        img = img.onload = img.onerror = null;
	      };
	
	      img.onload = onLoadCallback;
	      /** @ignore */
	      img.onerror = function() {
	        fabric.log('Error loading ' + img.src);
	        callback && callback.call(context, null, true);
	        img = img.onload = img.onerror = null;
	      };
	
	      // data-urls appear to be buggy with crossOrigin
	      // https://github.com/kangax/fabric.js/commit/d0abb90f1cd5c5ef9d2a94d3fb21a22330da3e0a#commitcomment-4513767
	      // see https://code.google.com/p/chromium/issues/detail?id=315152
	      //     https://bugzilla.mozilla.org/show_bug.cgi?id=935069
	      if (url.indexOf('data') !== 0 && crossOrigin) {
	        img.crossOrigin = crossOrigin;
	      }
	
	      // IE10 / IE11-Fix: SVG contents from data: URI
	      // will only be available if the IMG is present
	      // in the DOM (and visible)
	      if (url.substring(0,14) === 'data:image/svg') {
	        img.onload = null;
	        fabric.util.loadImageInDom(img, onLoadCallback);
	      }
	
	      img.src = url;
	    },
	
	    /**
	     * Attaches SVG image with data: URL to the dom
	     * @memberOf fabric.util
	     * @param {Object} img Image object with data:image/svg src
	     * @param {Function} callback Callback; invoked with loaded image
	     * @return {Object} DOM element (div containing the SVG image)
	     */
	    loadImageInDom: function(img, onLoadCallback) {
	      var div = fabric.document.createElement('div');
	      div.style.width = div.style.height = '1px';
	      div.style.left = div.style.top = '-100%';
	      div.style.position = 'absolute';
	      div.appendChild(img);
	      fabric.document.querySelector('body').appendChild(div);
	      /**
	       * Wrap in function to:
	       *   1. Call existing callback
	       *   2. Cleanup DOM
	       */
	      img.onload = function () {
	        onLoadCallback();
	        div.parentNode.removeChild(div);
	        div = null;
	      };
	    },
	
	    /**
	     * Creates corresponding fabric instances from their object representations
	     * @static
	     * @memberOf fabric.util
	     * @param {Array} objects Objects to enliven
	     * @param {Function} callback Callback to invoke when all objects are created
	     * @param {String} namespace Namespace to get klass "Class" object from
	     * @param {Function} reviver Method for further parsing of object elements,
	     * called after each fabric object created.
	     */
	    enlivenObjects: function(objects, callback, namespace, reviver) {
	      objects = objects || [];
	
	      var enlivenedObjects = [],
	          numLoadedObjects = 0,
	          numTotalObjects = objects.length;
	
	      function onLoaded() {
	        if (++numLoadedObjects === numTotalObjects) {
	          callback && callback(enlivenedObjects.filter(function(obj) {
	            // filter out undefined objects (objects that gave error)
	            return obj;
	          }));
	        }
	      }
	
	      if (!numTotalObjects) {
	        callback && callback(enlivenedObjects);
	        return;
	      }
	
	      objects.forEach(function (o, index) {
	        // if sparse array
	        if (!o || !o.type) {
	          onLoaded();
	          return;
	        }
	        var klass = fabric.util.getKlass(o.type, namespace);
	        klass.fromObject(o, function (obj, error) {
	          error || (enlivenedObjects[index] = obj);
	          reviver && reviver(o, obj, error);
	          onLoaded();
	        });
	      });
	    },
	
	    /**
	     * Create and wait for loading of patterns
	     * @static
	     * @memberOf fabric.util
	     * @param {Array} patterns Objects to enliven
	     * @param {Function} callback Callback to invoke when all objects are created
	     * called after each fabric object created.
	     */
	    enlivenPatterns: function(patterns, callback) {
	      patterns = patterns || [];
	
	      function onLoaded() {
	        if (++numLoadedPatterns === numPatterns) {
	          callback && callback(enlivenedPatterns);
	        }
	      }
	
	      var enlivenedPatterns = [],
	          numLoadedPatterns = 0,
	          numPatterns = patterns.length;
	
	      if (!numPatterns) {
	        callback && callback(enlivenedPatterns);
	        return;
	      }
	
	      patterns.forEach(function (p, index) {
	        if (p && p.source) {
	          new fabric.Pattern(p, function(pattern) {
	            enlivenedPatterns[index] = pattern;
	            onLoaded();
	          });
	        }
	        else {
	          enlivenedPatterns[index] = p;
	          onLoaded();
	        }
	      });
	    },
	
	    /**
	     * Groups SVG elements (usually those retrieved from SVG document)
	     * @static
	     * @memberOf fabric.util
	     * @param {Array} elements SVG elements to group
	     * @param {Object} [options] Options object
	     * @param {String} path Value to set sourcePath to
	     * @return {fabric.Object|fabric.Group}
	     */
	    groupSVGElements: function(elements, options, path) {
	      var object;
	      if (elements && elements.length === 1) {
	        return elements[0];
	      }
	      if (options) {
	        if (options.width && options.height) {
	          options.centerPoint = {
	            x: options.width / 2,
	            y: options.height / 2
	          };
	        }
	        else {
	          delete options.width;
	          delete options.height;
	        }
	      }
	      object = new fabric.Group(elements, options);
	      if (typeof path !== 'undefined') {
	        object.sourcePath = path;
	      }
	      return object;
	    },
	
	    /**
	     * Populates an object with properties of another object
	     * @static
	     * @memberOf fabric.util
	     * @param {Object} source Source object
	     * @param {Object} destination Destination object
	     * @return {Array} properties Properties names to include
	     */
	    populateWithProperties: function(source, destination, properties) {
	      if (properties && Object.prototype.toString.call(properties) === '[object Array]') {
	        for (var i = 0, len = properties.length; i < len; i++) {
	          if (properties[i] in source) {
	            destination[properties[i]] = source[properties[i]];
	          }
	        }
	      }
	    },
	
	    /**
	     * Draws a dashed line between two points
	     *
	     * This method is used to draw dashed line around selection area.
	     * See <a href="http://stackoverflow.com/questions/4576724/dotted-stroke-in-canvas">dotted stroke in canvas</a>
	     *
	     * @param {CanvasRenderingContext2D} ctx context
	     * @param {Number} x  start x coordinate
	     * @param {Number} y start y coordinate
	     * @param {Number} x2 end x coordinate
	     * @param {Number} y2 end y coordinate
	     * @param {Array} da dash array pattern
	     */
	    drawDashedLine: function(ctx, x, y, x2, y2, da) {
	      var dx = x2 - x,
	          dy = y2 - y,
	          len = sqrt(dx * dx + dy * dy),
	          rot = atan2(dy, dx),
	          dc = da.length,
	          di = 0,
	          draw = true;
	
	      ctx.save();
	      ctx.translate(x, y);
	      ctx.moveTo(0, 0);
	      ctx.rotate(rot);
	
	      x = 0;
	      while (len > x) {
	        x += da[di++ % dc];
	        if (x > len) {
	          x = len;
	        }
	        ctx[draw ? 'lineTo' : 'moveTo'](x, 0);
	        draw = !draw;
	      }
	
	      ctx.restore();
	    },
	
	    /**
	     * Creates canvas element
	     * @static
	     * @memberOf fabric.util
	     * @return {CanvasElement} initialized canvas element
	     */
	    createCanvasElement: function() {
	      return fabric.document.createElement('canvas');
	    },
	
	    /**
	     * Creates a canvas element that is a copy of another and is also painted
	     * @param {CanvasElement} canvas to copy size and content of
	     * @static
	     * @memberOf fabric.util
	     * @return {CanvasElement} initialized canvas element
	     */
	    copyCanvasElement: function(canvas) {
	      var newCanvas = fabric.util.createCanvasElement();
	      newCanvas.width = canvas.width;
	      newCanvas.height = canvas.height;
	      newCanvas.getContext('2d').drawImage(canvas, 0, 0);
	      return newCanvas;
	    },
	
	    /**
	     * since 2.6.0 moved from canvas instance to utility.
	     * @param {CanvasElement} canvasEl to copy size and content of
	     * @param {String} format 'jpeg' or 'png', in some browsers 'webp' is ok too
	     * @param {Number} quality <= 1 and > 0
	     * @static
	     * @memberOf fabric.util
	     * @return {String} data url
	     */
	    toDataURL: function(canvasEl, format, quality) {
	      return canvasEl.toDataURL('image/' + format, quality);
	    },
	
	    /**
	     * Creates image element (works on client and node)
	     * @static
	     * @memberOf fabric.util
	     * @return {HTMLImageElement} HTML image element
	     */
	    createImage: function() {
	      return fabric.document.createElement('img');
	    },
	
	    /**
	     * @static
	     * @memberOf fabric.util
	     * @deprecated since 2.0.0
	     * @param {fabric.Object} receiver Object implementing `clipTo` method
	     * @param {CanvasRenderingContext2D} ctx Context to clip
	     */
	    clipContext: function(receiver, ctx) {
	      ctx.save();
	      ctx.beginPath();
	      receiver.clipTo(ctx);
	      ctx.clip();
	    },
	
	    /**
	     * Multiply matrix A by matrix B to nest transformations
	     * @static
	     * @memberOf fabric.util
	     * @param  {Array} a First transformMatrix
	     * @param  {Array} b Second transformMatrix
	     * @param  {Boolean} is2x2 flag to multiply matrices as 2x2 matrices
	     * @return {Array} The product of the two transform matrices
	     */
	    multiplyTransformMatrices: function(a, b, is2x2) {
	      // Matrix multiply a * b
	      return [
	        a[0] * b[0] + a[2] * b[1],
	        a[1] * b[0] + a[3] * b[1],
	        a[0] * b[2] + a[2] * b[3],
	        a[1] * b[2] + a[3] * b[3],
	        is2x2 ? 0 : a[0] * b[4] + a[2] * b[5] + a[4],
	        is2x2 ? 0 : a[1] * b[4] + a[3] * b[5] + a[5]
	      ];
	    },
	
	    /**
	     * Decomposes standard 2x2 matrix into transform componentes
	     * @static
	     * @memberOf fabric.util
	     * @param  {Array} a transformMatrix
	     * @return {Object} Components of transform
	     */
	    qrDecompose: function(a) {
	      var angle = atan2(a[1], a[0]),
	          denom = pow(a[0], 2) + pow(a[1], 2),
	          scaleX = sqrt(denom),
	          scaleY = (a[0] * a[3] - a[2] * a [1]) / scaleX,
	          skewX = atan2(a[0] * a[2] + a[1] * a [3], denom);
	      return {
	        angle: angle  / PiBy180,
	        scaleX: scaleX,
	        scaleY: scaleY,
	        skewX: skewX / PiBy180,
	        skewY: 0,
	        translateX: a[4],
	        translateY: a[5]
	      };
	    },
	
	    customTransformMatrix: function(scaleX, scaleY, skewX) {
	      var skewMatrixX = [1, 0, abs(Math.tan(skewX * PiBy180)), 1],
	          scaleMatrix = [abs(scaleX), 0, 0, abs(scaleY)];
	      return fabric.util.multiplyTransformMatrices(scaleMatrix, skewMatrixX, true);
	    },
	
	    /**
	     * reset an object transform state to neutral. Top and left are not accounted for
	     * @static
	     * @memberOf fabric.util
	     * @param  {fabric.Object} target object to transform
	     */
	    resetObjectTransform: function (target) {
	      target.scaleX = 1;
	      target.scaleY = 1;
	      target.skewX = 0;
	      target.skewY = 0;
	      target.flipX = false;
	      target.flipY = false;
	      target.rotate(0);
	    },
	
	    /**
	     * Extract Object transform values
	     * @static
	     * @memberOf fabric.util
	     * @param  {fabric.Object} target object to read from
	     * @return {Object} Components of transform
	     */
	    saveObjectTransform: function (target) {
	      return {
	        scaleX: target.scaleX,
	        scaleY: target.scaleY,
	        skewX: target.skewX,
	        skewY: target.skewY,
	        angle: target.angle,
	        left: target.left,
	        flipX: target.flipX,
	        flipY: target.flipY,
	        top: target.top
	      };
	    },
	
	    /**
	     * Returns string representation of function body
	     * @param {Function} fn Function to get body of
	     * @return {String} Function body
	     */
	    getFunctionBody: function(fn) {
	      return (String(fn).match(/function[^{]*\{([\s\S]*)\}/) || {})[1];
	    },
	
	    /**
	     * Returns true if context has transparent pixel
	     * at specified location (taking tolerance into account)
	     * @param {CanvasRenderingContext2D} ctx context
	     * @param {Number} x x coordinate
	     * @param {Number} y y coordinate
	     * @param {Number} tolerance Tolerance
	     */
	    isTransparent: function(ctx, x, y, tolerance) {
	
	      // If tolerance is > 0 adjust start coords to take into account.
	      // If moves off Canvas fix to 0
	      if (tolerance > 0) {
	        if (x > tolerance) {
	          x -= tolerance;
	        }
	        else {
	          x = 0;
	        }
	        if (y > tolerance) {
	          y -= tolerance;
	        }
	        else {
	          y = 0;
	        }
	      }
	
	      var _isTransparent = true, i, temp,
	          imageData = ctx.getImageData(x, y, (tolerance * 2) || 1, (tolerance * 2) || 1),
	          l = imageData.data.length;
	
	      // Split image data - for tolerance > 1, pixelDataSize = 4;
	      for (i = 3; i < l; i += 4) {
	        temp = imageData.data[i];
	        _isTransparent = temp <= 0;
	        if (_isTransparent === false) {
	          break; // Stop if colour found
	        }
	      }
	
	      imageData = null;
	
	      return _isTransparent;
	    },
	
	    /**
	     * Parse preserveAspectRatio attribute from element
	     * @param {string} attribute to be parsed
	     * @return {Object} an object containing align and meetOrSlice attribute
	     */
	    parsePreserveAspectRatioAttribute: function(attribute) {
	      var meetOrSlice = 'meet', alignX = 'Mid', alignY = 'Mid',
	          aspectRatioAttrs = attribute.split(' '), align;
	
	      if (aspectRatioAttrs && aspectRatioAttrs.length) {
	        meetOrSlice = aspectRatioAttrs.pop();
	        if (meetOrSlice !== 'meet' && meetOrSlice !== 'slice') {
	          align = meetOrSlice;
	          meetOrSlice = 'meet';
	        }
	        else if (aspectRatioAttrs.length) {
	          align = aspectRatioAttrs.pop();
	        }
	      }
	      //divide align in alignX and alignY
	      alignX = align !== 'none' ? align.slice(1, 4) : 'none';
	      alignY = align !== 'none' ? align.slice(5, 8) : 'none';
	      return {
	        meetOrSlice: meetOrSlice,
	        alignX: alignX,
	        alignY: alignY
	      };
	    },
	
	    /**
	     * Clear char widths cache for the given font family or all the cache if no
	     * fontFamily is specified.
	     * Use it if you know you are loading fonts in a lazy way and you are not waiting
	     * for custom fonts to load properly when adding text objects to the canvas.
	     * If a text object is added when its own font is not loaded yet, you will get wrong
	     * measurement and so wrong bounding boxes.
	     * After the font cache is cleared, either change the textObject text content or call
	     * initDimensions() to trigger a recalculation
	     * @memberOf fabric.util
	     * @param {String} [fontFamily] font family to clear
	     */
	    clearFabricFontCache: function(fontFamily) {
	      fontFamily = (fontFamily || '').toLowerCase();
	      if (!fontFamily) {
	        fabric.charWidthsCache = { };
	      }
	      else if (fabric.charWidthsCache[fontFamily]) {
	        delete fabric.charWidthsCache[fontFamily];
	      }
	    },
	
	    /**
	     * Given current aspect ratio, determines the max width and height that can
	     * respect the total allowed area for the cache.
	     * @memberOf fabric.util
	     * @param {Number} ar aspect ratio
	     * @param {Number} maximumArea Maximum area you want to achieve
	     * @return {Object.x} Limited dimensions by X
	     * @return {Object.y} Limited dimensions by Y
	     */
	    limitDimsByArea: function(ar, maximumArea) {
	      var roughWidth = Math.sqrt(maximumArea * ar),
	          perfLimitSizeY = Math.floor(maximumArea / roughWidth);
	      return { x: Math.floor(roughWidth), y: perfLimitSizeY };
	    },
	
	    capValue: function(min, value, max) {
	      return Math.max(min, Math.min(value, max));
	    },
	
	    findScaleToFit: function(source, destination) {
	      return Math.min(destination.width / source.width, destination.height / source.height);
	    },
	
	    findScaleToCover: function(source, destination) {
	      return Math.max(destination.width / source.width, destination.height / source.height);
	    },
	
	    /**
	     * given an array of 6 number returns something like `"matrix(...numbers)"`
	     * @memberOf fabric.util
	     * @param {Array} trasnform an array with 6 numbers
	     * @return {String} transform matrix for svg
	     * @return {Object.y} Limited dimensions by Y
	     */
	    matrixToSVG: function(transform) {
	      return 'matrix(' + transform.map(function(value) {
	        return fabric.util.toFixed(value, fabric.Object.NUM_FRACTION_DIGITS);
	      }).join(' ') + ')';
	    }
	  };
	})( true ? exports : this);
	
	
	(function() {
	
	  var _join = Array.prototype.join;
	
	  /* Adapted from http://dxr.mozilla.org/mozilla-central/source/content/svg/content/src/nsSVGPathDataParser.cpp
	   * by Andrea Bogazzi code is under MPL. if you don't have a copy of the license you can take it here
	   * http://mozilla.org/MPL/2.0/
	   */
	  function arcToSegments(toX, toY, rx, ry, large, sweep, rotateX) {
	    var argsString = _join.call(arguments);
	    if (fabric.arcToSegmentsCache[argsString]) {
	      return fabric.arcToSegmentsCache[argsString];
	    }
	
	    var PI = Math.PI, th = rotateX * PI / 180,
	        sinTh = fabric.util.sin(th),
	        cosTh = fabric.util.cos(th),
	        fromX = 0, fromY = 0;
	
	    rx = Math.abs(rx);
	    ry = Math.abs(ry);
	
	    var px = -cosTh * toX * 0.5 - sinTh * toY * 0.5,
	        py = -cosTh * toY * 0.5 + sinTh * toX * 0.5,
	        rx2 = rx * rx, ry2 = ry * ry, py2 = py * py, px2 = px * px,
	        pl = rx2 * ry2 - rx2 * py2 - ry2 * px2,
	        root = 0;
	
	    if (pl < 0) {
	      var s = Math.sqrt(1 - pl / (rx2 * ry2));
	      rx *= s;
	      ry *= s;
	    }
	    else {
	      root = (large === sweep ? -1.0 : 1.0) *
	              Math.sqrt( pl / (rx2 * py2 + ry2 * px2));
	    }
	
	    var cx = root * rx * py / ry,
	        cy = -root * ry * px / rx,
	        cx1 = cosTh * cx - sinTh * cy + toX * 0.5,
	        cy1 = sinTh * cx + cosTh * cy + toY * 0.5,
	        mTheta = calcVectorAngle(1, 0, (px - cx) / rx, (py - cy) / ry),
	        dtheta = calcVectorAngle((px - cx) / rx, (py - cy) / ry, (-px - cx) / rx, (-py - cy) / ry);
	
	    if (sweep === 0 && dtheta > 0) {
	      dtheta -= 2 * PI;
	    }
	    else if (sweep === 1 && dtheta < 0) {
	      dtheta += 2 * PI;
	    }
	
	    // Convert into cubic bezier segments <= 90deg
	    var segments = Math.ceil(Math.abs(dtheta / PI * 2)),
	        result = [], mDelta = dtheta / segments,
	        mT = 8 / 3 * Math.sin(mDelta / 4) * Math.sin(mDelta / 4) / Math.sin(mDelta / 2),
	        th3 = mTheta + mDelta;
	
	    for (var i = 0; i < segments; i++) {
	      result[i] = segmentToBezier(mTheta, th3, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY);
	      fromX = result[i][4];
	      fromY = result[i][5];
	      mTheta = th3;
	      th3 += mDelta;
	    }
	    fabric.arcToSegmentsCache[argsString] = result;
	    return result;
	  }
	
	  function segmentToBezier(th2, th3, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY) {
	    var costh2 = fabric.util.cos(th2),
	        sinth2 = fabric.util.sin(th2),
	        costh3 = fabric.util.cos(th3),
	        sinth3 = fabric.util.sin(th3),
	        toX = cosTh * rx * costh3 - sinTh * ry * sinth3 + cx1,
	        toY = sinTh * rx * costh3 + cosTh * ry * sinth3 + cy1,
	        cp1X = fromX + mT * ( -cosTh * rx * sinth2 - sinTh * ry * costh2),
	        cp1Y = fromY + mT * ( -sinTh * rx * sinth2 + cosTh * ry * costh2),
	        cp2X = toX + mT * ( cosTh * rx * sinth3 + sinTh * ry * costh3),
	        cp2Y = toY + mT * ( sinTh * rx * sinth3 - cosTh * ry * costh3);
	
	    return [
	      cp1X, cp1Y,
	      cp2X, cp2Y,
	      toX, toY
	    ];
	  }
	
	  /*
	   * Private
	   */
	  function calcVectorAngle(ux, uy, vx, vy) {
	    var ta = Math.atan2(uy, ux),
	        tb = Math.atan2(vy, vx);
	    if (tb >= ta) {
	      return tb - ta;
	    }
	    else {
	      return 2 * Math.PI - (ta - tb);
	    }
	  }
	
	  /**
	   * Draws arc
	   * @param {CanvasRenderingContext2D} ctx
	   * @param {Number} fx
	   * @param {Number} fy
	   * @param {Array} coords
	   */
	  fabric.util.drawArc = function(ctx, fx, fy, coords) {
	    var rx = coords[0],
	        ry = coords[1],
	        rot = coords[2],
	        large = coords[3],
	        sweep = coords[4],
	        tx = coords[5],
	        ty = coords[6],
	        segs = [[], [], [], []],
	        segsNorm = arcToSegments(tx - fx, ty - fy, rx, ry, large, sweep, rot);
	
	    for (var i = 0, len = segsNorm.length; i < len; i++) {
	      segs[i][0] = segsNorm[i][0] + fx;
	      segs[i][1] = segsNorm[i][1] + fy;
	      segs[i][2] = segsNorm[i][2] + fx;
	      segs[i][3] = segsNorm[i][3] + fy;
	      segs[i][4] = segsNorm[i][4] + fx;
	      segs[i][5] = segsNorm[i][5] + fy;
	      ctx.bezierCurveTo.apply(ctx, segs[i]);
	    }
	  };
	
	  /**
	   * Calculate bounding box of a elliptic-arc
	   * @param {Number} fx start point of arc
	   * @param {Number} fy
	   * @param {Number} rx horizontal radius
	   * @param {Number} ry vertical radius
	   * @param {Number} rot angle of horizontal axe
	   * @param {Number} large 1 or 0, whatever the arc is the big or the small on the 2 points
	   * @param {Number} sweep 1 or 0, 1 clockwise or counterclockwise direction
	   * @param {Number} tx end point of arc
	   * @param {Number} ty
	   */
	  fabric.util.getBoundsOfArc = function(fx, fy, rx, ry, rot, large, sweep, tx, ty) {
	
	    var fromX = 0, fromY = 0, bound, bounds = [],
	        segs = arcToSegments(tx - fx, ty - fy, rx, ry, large, sweep, rot);
	
	    for (var i = 0, len = segs.length; i < len; i++) {
	      bound = getBoundsOfCurve(fromX, fromY, segs[i][0], segs[i][1], segs[i][2], segs[i][3], segs[i][4], segs[i][5]);
	      bounds.push({ x: bound[0].x + fx, y: bound[0].y + fy });
	      bounds.push({ x: bound[1].x + fx, y: bound[1].y + fy });
	      fromX = segs[i][4];
	      fromY = segs[i][5];
	    }
	    return bounds;
	  };
	
	  /**
	   * Calculate bounding box of a beziercurve
	   * @param {Number} x0 starting point
	   * @param {Number} y0
	   * @param {Number} x1 first control point
	   * @param {Number} y1
	   * @param {Number} x2 secondo control point
	   * @param {Number} y2
	   * @param {Number} x3 end of beizer
	   * @param {Number} y3
	   */
	  // taken from http://jsbin.com/ivomiq/56/edit  no credits available for that.
	  function getBoundsOfCurve(x0, y0, x1, y1, x2, y2, x3, y3) {
	    var argsString;
	    if (fabric.cachesBoundsOfCurve) {
	      argsString = _join.call(arguments);
	      if (fabric.boundsOfCurveCache[argsString]) {
	        return fabric.boundsOfCurveCache[argsString];
	      }
	    }
	
	    var sqrt = Math.sqrt,
	        min = Math.min, max = Math.max,
	        abs = Math.abs, tvalues = [],
	        bounds = [[], []],
	        a, b, c, t, t1, t2, b2ac, sqrtb2ac;
	
	    b = 6 * x0 - 12 * x1 + 6 * x2;
	    a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
	    c = 3 * x1 - 3 * x0;
	
	    for (var i = 0; i < 2; ++i) {
	      if (i > 0) {
	        b = 6 * y0 - 12 * y1 + 6 * y2;
	        a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
	        c = 3 * y1 - 3 * y0;
	      }
	
	      if (abs(a) < 1e-12) {
	        if (abs(b) < 1e-12) {
	          continue;
	        }
	        t = -c / b;
	        if (0 < t && t < 1) {
	          tvalues.push(t);
	        }
	        continue;
	      }
	      b2ac = b * b - 4 * c * a;
	      if (b2ac < 0) {
	        continue;
	      }
	      sqrtb2ac = sqrt(b2ac);
	      t1 = (-b + sqrtb2ac) / (2 * a);
	      if (0 < t1 && t1 < 1) {
	        tvalues.push(t1);
	      }
	      t2 = (-b - sqrtb2ac) / (2 * a);
	      if (0 < t2 && t2 < 1) {
	        tvalues.push(t2);
	      }
	    }
	
	    var x, y, j = tvalues.length, jlen = j, mt;
	    while (j--) {
	      t = tvalues[j];
	      mt = 1 - t;
	      x = (mt * mt * mt * x0) + (3 * mt * mt * t * x1) + (3 * mt * t * t * x2) + (t * t * t * x3);
	      bounds[0][j] = x;
	
	      y = (mt * mt * mt * y0) + (3 * mt * mt * t * y1) + (3 * mt * t * t * y2) + (t * t * t * y3);
	      bounds[1][j] = y;
	    }
	
	    bounds[0][jlen] = x0;
	    bounds[1][jlen] = y0;
	    bounds[0][jlen + 1] = x3;
	    bounds[1][jlen + 1] = y3;
	    var result = [
	      {
	        x: min.apply(null, bounds[0]),
	        y: min.apply(null, bounds[1])
	      },
	      {
	        x: max.apply(null, bounds[0]),
	        y: max.apply(null, bounds[1])
	      }
	    ];
	    if (fabric.cachesBoundsOfCurve) {
	      fabric.boundsOfCurveCache[argsString] = result;
	    }
	    return result;
	  }
	
	  fabric.util.getBoundsOfCurve = getBoundsOfCurve;
	
	})();
	
	
	(function() {
	
	  var slice = Array.prototype.slice;
	
	  /**
	   * Invokes method on all items in a given array
	   * @memberOf fabric.util.array
	   * @param {Array} array Array to iterate over
	   * @param {String} method Name of a method to invoke
	   * @return {Array}
	   */
	  function invoke(array, method) {
	    var args = slice.call(arguments, 2), result = [];
	    for (var i = 0, len = array.length; i < len; i++) {
	      result[i] = args.length ? array[i][method].apply(array[i], args) : array[i][method].call(array[i]);
	    }
	    return result;
	  }
	
	  /**
	   * Finds maximum value in array (not necessarily "first" one)
	   * @memberOf fabric.util.array
	   * @param {Array} array Array to iterate over
	   * @param {String} byProperty
	   * @return {*}
	   */
	  function max(array, byProperty) {
	    return find(array, byProperty, function(value1, value2) {
	      return value1 >= value2;
	    });
	  }
	
	  /**
	   * Finds minimum value in array (not necessarily "first" one)
	   * @memberOf fabric.util.array
	   * @param {Array} array Array to iterate over
	   * @param {String} byProperty
	   * @return {*}
	   */
	  function min(array, byProperty) {
	    return find(array, byProperty, function(value1, value2) {
	      return value1 < value2;
	    });
	  }
	
	  /**
	   * @private
	   */
	  function fill(array, value) {
	    var k = array.length;
	    while (k--) {
	      array[k] = value;
	    }
	    return array;
	  }
	
	  /**
	   * @private
	   */
	  function find(array, byProperty, condition) {
	    if (!array || array.length === 0) {
	      return;
	    }
	
	    var i = array.length - 1,
	        result = byProperty ? array[i][byProperty] : array[i];
	    if (byProperty) {
	      while (i--) {
	        if (condition(array[i][byProperty], result)) {
	          result = array[i][byProperty];
	        }
	      }
	    }
	    else {
	      while (i--) {
	        if (condition(array[i], result)) {
	          result = array[i];
	        }
	      }
	    }
	    return result;
	  }
	
	  /**
	   * @namespace fabric.util.array
	   */
	  fabric.util.array = {
	    fill: fill,
	    invoke: invoke,
	    min: min,
	    max: max
	  };
	
	})();
	
	
	(function() {
	  /**
	   * Copies all enumerable properties of one js object to another
	   * this does not and cannot compete with generic utils.
	   * Does not clone or extend fabric.Object subclasses.
	   * This is mostly for internal use and has extra handling for fabricJS objects
	   * it skips the canvas property in deep cloning.
	   * @memberOf fabric.util.object
	   * @param {Object} destination Where to copy to
	   * @param {Object} source Where to copy from
	   * @return {Object}
	   */
	
	  function extend(destination, source, deep) {
	    // JScript DontEnum bug is not taken care of
	    // the deep clone is for internal use, is not meant to avoid
	    // javascript traps or cloning html element or self referenced objects.
	    if (deep) {
	      if (!fabric.isLikelyNode && source instanceof Element) {
	        // avoid cloning deep images, canvases,
	        destination = source;
	      }
	      else if (source instanceof Array) {
	        destination = [];
	        for (var i = 0, len = source.length; i < len; i++) {
	          destination[i] = extend({ }, source[i], deep);
	        }
	      }
	      else if (source && typeof source === 'object') {
	        for (var property in source) {
	          if (property === 'canvas') {
	            destination[property] = extend({ }, source[property]);
	          }
	          else if (source.hasOwnProperty(property)) {
	            destination[property] = extend({ }, source[property], deep);
	          }
	        }
	      }
	      else {
	        // this sounds odd for an extend but is ok for recursive use
	        destination = source;
	      }
	    }
	    else {
	      for (var property in source) {
	        destination[property] = source[property];
	      }
	    }
	    return destination;
	  }
	
	  /**
	   * Creates an empty object and copies all enumerable properties of another object to it
	   * @memberOf fabric.util.object
	   * TODO: this function return an empty object if you try to clone null
	   * @param {Object} object Object to clone
	   * @return {Object}
	   */
	  function clone(object, deep) {
	    return extend({ }, object, deep);
	  }
	
	  /** @namespace fabric.util.object */
	  fabric.util.object = {
	    extend: extend,
	    clone: clone
	  };
	  fabric.util.object.extend(fabric.util, fabric.Observable);
	})();
	
	
	(function() {
	
	  /**
	   * Camelizes a string
	   * @memberOf fabric.util.string
	   * @param {String} string String to camelize
	   * @return {String} Camelized version of a string
	   */
	  function camelize(string) {
	    return string.replace(/-+(.)?/g, function(match, character) {
	      return character ? character.toUpperCase() : '';
	    });
	  }
	
	  /**
	   * Capitalizes a string
	   * @memberOf fabric.util.string
	   * @param {String} string String to capitalize
	   * @param {Boolean} [firstLetterOnly] If true only first letter is capitalized
	   * and other letters stay untouched, if false first letter is capitalized
	   * and other letters are converted to lowercase.
	   * @return {String} Capitalized version of a string
	   */
	  function capitalize(string, firstLetterOnly) {
	    return string.charAt(0).toUpperCase() +
	      (firstLetterOnly ? string.slice(1) : string.slice(1).toLowerCase());
	  }
	
	  /**
	   * Escapes XML in a string
	   * @memberOf fabric.util.string
	   * @param {String} string String to escape
	   * @return {String} Escaped version of a string
	   */
	  function escapeXml(string) {
	    return string.replace(/&/g, '&amp;')
	      .replace(/"/g, '&quot;')
	      .replace(/'/g, '&apos;')
	      .replace(/</g, '&lt;')
	      .replace(/>/g, '&gt;');
	  }
	
	  /**
	   * Divide a string in the user perceived single units
	   * @memberOf fabric.util.string
	   * @param {String} textstring String to escape
	   * @return {Array} array containing the graphemes
	   */
	  function graphemeSplit(textstring) {
	    var i = 0, chr, graphemes = [];
	    for (i = 0, chr; i < textstring.length; i++) {
	      if ((chr = getWholeChar(textstring, i)) === false) {
	        continue;
	      }
	      graphemes.push(chr);
	    }
	    return graphemes;
	  }
	
	  // taken from mdn in the charAt doc page.
	  function getWholeChar(str, i) {
	    var code = str.charCodeAt(i);
	
	    if (isNaN(code)) {
	      return ''; // Position not found
	    }
	    if (code < 0xD800 || code > 0xDFFF) {
	      return str.charAt(i);
	    }
	
	    // High surrogate (could change last hex to 0xDB7F to treat high private
	    // surrogates as single characters)
	    if (0xD800 <= code && code <= 0xDBFF) {
	      if (str.length <= (i + 1)) {
	        throw 'High surrogate without following low surrogate';
	      }
	      var next = str.charCodeAt(i + 1);
	      if (0xDC00 > next || next > 0xDFFF) {
	        throw 'High surrogate without following low surrogate';
	      }
	      return str.charAt(i) + str.charAt(i + 1);
	    }
	    // Low surrogate (0xDC00 <= code && code <= 0xDFFF)
	    if (i === 0) {
	      throw 'Low surrogate without preceding high surrogate';
	    }
	    var prev = str.charCodeAt(i - 1);
	
	    // (could change last hex to 0xDB7F to treat high private
	    // surrogates as single characters)
	    if (0xD800 > prev || prev > 0xDBFF) {
	      throw 'Low surrogate without preceding high surrogate';
	    }
	    // We can pass over low surrogates now as the second component
	    // in a pair which we have already processed
	    return false;
	  }
	
	
	  /**
	   * String utilities
	   * @namespace fabric.util.string
	   */
	  fabric.util.string = {
	    camelize: camelize,
	    capitalize: capitalize,
	    escapeXml: escapeXml,
	    graphemeSplit: graphemeSplit
	  };
	})();
	
	
	(function() {
	
	  var slice = Array.prototype.slice, emptyFunction = function() { },
	
	      IS_DONTENUM_BUGGY = (function() {
	        for (var p in { toString: 1 }) {
	          if (p === 'toString') {
	            return false;
	          }
	        }
	        return true;
	      })(),
	
	      /** @ignore */
	      addMethods = function(klass, source, parent) {
	        for (var property in source) {
	
	          if (property in klass.prototype &&
	              typeof klass.prototype[property] === 'function' &&
	              (source[property] + '').indexOf('callSuper') > -1) {
	
	            klass.prototype[property] = (function(property) {
	              return function() {
	
	                var superclass = this.constructor.superclass;
	                this.constructor.superclass = parent;
	                var returnValue = source[property].apply(this, arguments);
	                this.constructor.superclass = superclass;
	
	                if (property !== 'initialize') {
	                  return returnValue;
	                }
	              };
	            })(property);
	          }
	          else {
	            klass.prototype[property] = source[property];
	          }
	
	          if (IS_DONTENUM_BUGGY) {
	            if (source.toString !== Object.prototype.toString) {
	              klass.prototype.toString = source.toString;
	            }
	            if (source.valueOf !== Object.prototype.valueOf) {
	              klass.prototype.valueOf = source.valueOf;
	            }
	          }
	        }
	      };
	
	  function Subclass() { }
	
	  function callSuper(methodName) {
	    var parentMethod = null,
	        _this = this;
	
	    // climb prototype chain to find method not equal to callee's method
	    while (_this.constructor.superclass) {
	      var superClassMethod = _this.constructor.superclass.prototype[methodName];
	      if (_this[methodName] !== superClassMethod) {
	        parentMethod = superClassMethod;
	        break;
	      }
	      // eslint-disable-next-line
	      _this = _this.constructor.superclass.prototype;
	    }
	
	    if (!parentMethod) {
	      return console.log('tried to callSuper ' + methodName + ', method not found in prototype chain', this);
	    }
	
	    return (arguments.length > 1)
	      ? parentMethod.apply(this, slice.call(arguments, 1))
	      : parentMethod.call(this);
	  }
	
	  /**
	   * Helper for creation of "classes".
	   * @memberOf fabric.util
	   * @param {Function} [parent] optional "Class" to inherit from
	   * @param {Object} [properties] Properties shared by all instances of this class
	   *                  (be careful modifying objects defined here as this would affect all instances)
	   */
	  function createClass() {
	    var parent = null,
	        properties = slice.call(arguments, 0);
	
	    if (typeof properties[0] === 'function') {
	      parent = properties.shift();
	    }
	    function klass() {
	      this.initialize.apply(this, arguments);
	    }
	
	    klass.superclass = parent;
	    klass.subclasses = [];
	
	    if (parent) {
	      Subclass.prototype = parent.prototype;
	      klass.prototype = new Subclass();
	      parent.subclasses.push(klass);
	    }
	    for (var i = 0, length = properties.length; i < length; i++) {
	      addMethods(klass, properties[i], parent);
	    }
	    if (!klass.prototype.initialize) {
	      klass.prototype.initialize = emptyFunction;
	    }
	    klass.prototype.constructor = klass;
	    klass.prototype.callSuper = callSuper;
	    return klass;
	  }
	
	  fabric.util.createClass = createClass;
	})();
	
	
	(function () {
	  // since ie10 or ie9 can use addEventListener but they do not support options, i need to check
	  var couldUseAttachEvent = !!fabric.document.createElement('div').attachEvent;
	  /**
	   * Adds an event listener to an element
	   * @function
	   * @memberOf fabric.util
	   * @param {HTMLElement} element
	   * @param {String} eventName
	   * @param {Function} handler
	   */
	  fabric.util.addListener = function(element, eventName, handler, options) {
	    element && element.addEventListener(eventName, handler, couldUseAttachEvent ? false : options);
	  };
	
	  /**
	   * Removes an event listener from an element
	   * @function
	   * @memberOf fabric.util
	   * @param {HTMLElement} element
	   * @param {String} eventName
	   * @param {Function} handler
	   */
	  fabric.util.removeListener = function(element, eventName, handler, options) {
	    element && element.removeEventListener(eventName, handler, couldUseAttachEvent ? false : options);
	  };
	
	  function getTouchInfo(event) {
	    var touchProp = event.changedTouches;
	    if (touchProp && touchProp[0]) {
	      return touchProp[0];
	    }
	    return event;
	  }
	
	  fabric.util.getPointer = function(event) {
	    var element = event.target,
	        scroll = fabric.util.getScrollLeftTop(element),
	        _evt = getTouchInfo(event);
	    return {
	      x: _evt.clientX + scroll.left,
	      y: _evt.clientY + scroll.top
	    };
	  };
	})();
	
	
	(function () {
	
	  /**
	   * Cross-browser wrapper for setting element's style
	   * @memberOf fabric.util
	   * @param {HTMLElement} element
	   * @param {Object} styles
	   * @return {HTMLElement} Element that was passed as a first argument
	   */
	  function setStyle(element, styles) {
	    var elementStyle = element.style;
	    if (!elementStyle) {
	      return element;
	    }
	    if (typeof styles === 'string') {
	      element.style.cssText += ';' + styles;
	      return styles.indexOf('opacity') > -1
	        ? setOpacity(element, styles.match(/opacity:\s*(\d?\.?\d*)/)[1])
	        : element;
	    }
	    for (var property in styles) {
	      if (property === 'opacity') {
	        setOpacity(element, styles[property]);
	      }
	      else {
	        var normalizedProperty = (property === 'float' || property === 'cssFloat')
	          ? (typeof elementStyle.styleFloat === 'undefined' ? 'cssFloat' : 'styleFloat')
	          : property;
	        elementStyle[normalizedProperty] = styles[property];
	      }
	    }
	    return element;
	  }
	
	  var parseEl = fabric.document.createElement('div'),
	      supportsOpacity = typeof parseEl.style.opacity === 'string',
	      supportsFilters = typeof parseEl.style.filter === 'string',
	      reOpacity = /alpha\s*\(\s*opacity\s*=\s*([^\)]+)\)/,
	
	      /** @ignore */
	      setOpacity = function (element) { return element; };
	
	  if (supportsOpacity) {
	    /** @ignore */
	    setOpacity = function(element, value) {
	      element.style.opacity = value;
	      return element;
	    };
	  }
	  else if (supportsFilters) {
	    /** @ignore */
	    setOpacity = function(element, value) {
	      var es = element.style;
	      if (element.currentStyle && !element.currentStyle.hasLayout) {
	        es.zoom = 1;
	      }
	      if (reOpacity.test(es.filter)) {
	        value = value >= 0.9999 ? '' : ('alpha(opacity=' + (value * 100) + ')');
	        es.filter = es.filter.replace(reOpacity, value);
	      }
	      else {
	        es.filter += ' alpha(opacity=' + (value * 100) + ')';
	      }
	      return element;
	    };
	  }
	
	  fabric.util.setStyle = setStyle;
	
	})();
	
	
	(function() {
	
	  var _slice = Array.prototype.slice;
	
	  /**
	   * Takes id and returns an element with that id (if one exists in a document)
	   * @memberOf fabric.util
	   * @param {String|HTMLElement} id
	   * @return {HTMLElement|null}
	   */
	  function getById(id) {
	    return typeof id === 'string' ? fabric.document.getElementById(id) : id;
	  }
	
	  var sliceCanConvertNodelists,
	      /**
	       * Converts an array-like object (e.g. arguments or NodeList) to an array
	       * @memberOf fabric.util
	       * @param {Object} arrayLike
	       * @return {Array}
	       */
	      toArray = function(arrayLike) {
	        return _slice.call(arrayLike, 0);
	      };
	
	  try {
	    sliceCanConvertNodelists = toArray(fabric.document.childNodes) instanceof Array;
	  }
	  catch (err) { }
	
	  if (!sliceCanConvertNodelists) {
	    toArray = function(arrayLike) {
	      var arr = new Array(arrayLike.length), i = arrayLike.length;
	      while (i--) {
	        arr[i] = arrayLike[i];
	      }
	      return arr;
	    };
	  }
	
	  /**
	   * Creates specified element with specified attributes
	   * @memberOf fabric.util
	   * @param {String} tagName Type of an element to create
	   * @param {Object} [attributes] Attributes to set on an element
	   * @return {HTMLElement} Newly created element
	   */
	  function makeElement(tagName, attributes) {
	    var el = fabric.document.createElement(tagName);
	    for (var prop in attributes) {
	      if (prop === 'class') {
	        el.className = attributes[prop];
	      }
	      else if (prop === 'for') {
	        el.htmlFor = attributes[prop];
	      }
	      else {
	        el.setAttribute(prop, attributes[prop]);
	      }
	    }
	    return el;
	  }
	
	  /**
	   * Adds class to an element
	   * @memberOf fabric.util
	   * @param {HTMLElement} element Element to add class to
	   * @param {String} className Class to add to an element
	   */
	  function addClass(element, className) {
	    if (element && (' ' + element.className + ' ').indexOf(' ' + className + ' ') === -1) {
	      element.className += (element.className ? ' ' : '') + className;
	    }
	  }
	
	  /**
	   * Wraps element with another element
	   * @memberOf fabric.util
	   * @param {HTMLElement} element Element to wrap
	   * @param {HTMLElement|String} wrapper Element to wrap with
	   * @param {Object} [attributes] Attributes to set on a wrapper
	   * @return {HTMLElement} wrapper
	   */
	  function wrapElement(element, wrapper, attributes) {
	    if (typeof wrapper === 'string') {
	      wrapper = makeElement(wrapper, attributes);
	    }
	    if (element.parentNode) {
	      element.parentNode.replaceChild(wrapper, element);
	    }
	    wrapper.appendChild(element);
	    return wrapper;
	  }
	
	  /**
	   * Returns element scroll offsets
	   * @memberOf fabric.util
	   * @param {HTMLElement} element Element to operate on
	   * @return {Object} Object with left/top values
	   */
	  function getScrollLeftTop(element) {
	
	    var left = 0,
	        top = 0,
	        docElement = fabric.document.documentElement,
	        body = fabric.document.body || {
	          scrollLeft: 0, scrollTop: 0
	        };
	
	    // While loop checks (and then sets element to) .parentNode OR .host
	    //  to account for ShadowDOM. We still want to traverse up out of ShadowDOM,
	    //  but the .parentNode of a root ShadowDOM node will always be null, instead
	    //  it should be accessed through .host. See http://stackoverflow.com/a/24765528/4383938
	    while (element && (element.parentNode || element.host)) {
	
	      // Set element to element parent, or 'host' in case of ShadowDOM
	      element = element.parentNode || element.host;
	
	      if (element === fabric.document) {
	        left = body.scrollLeft || docElement.scrollLeft || 0;
	        top = body.scrollTop ||  docElement.scrollTop || 0;
	      }
	      else {
	        left += element.scrollLeft || 0;
	        top += element.scrollTop || 0;
	      }
	
	      if (element.nodeType === 1 && element.style.position === 'fixed') {
	        break;
	      }
	    }
	
	    return { left: left, top: top };
	  }
	
	  /**
	   * Returns offset for a given element
	   * @function
	   * @memberOf fabric.util
	   * @param {HTMLElement} element Element to get offset for
	   * @return {Object} Object with "left" and "top" properties
	   */
	  function getElementOffset(element) {
	    var docElem,
	        doc = element && element.ownerDocument,
	        box = { left: 0, top: 0 },
	        offset = { left: 0, top: 0 },
	        scrollLeftTop,
	        offsetAttributes = {
	          borderLeftWidth: 'left',
	          borderTopWidth:  'top',
	          paddingLeft:     'left',
	          paddingTop:      'top'
	        };
	
	    if (!doc) {
	      return offset;
	    }
	
	    for (var attr in offsetAttributes) {
	      offset[offsetAttributes[attr]] += parseInt(getElementStyle(element, attr), 10) || 0;
	    }
	
	    docElem = doc.documentElement;
	    if ( typeof element.getBoundingClientRect !== 'undefined' ) {
	      box = element.getBoundingClientRect();
	    }
	
	    scrollLeftTop = getScrollLeftTop(element);
	
	    return {
	      left: box.left + scrollLeftTop.left - (docElem.clientLeft || 0) + offset.left,
	      top: box.top + scrollLeftTop.top - (docElem.clientTop || 0)  + offset.top
	    };
	  }
	
	  /**
	   * Returns style attribute value of a given element
	   * @memberOf fabric.util
	   * @param {HTMLElement} element Element to get style attribute for
	   * @param {String} attr Style attribute to get for element
	   * @return {String} Style attribute value of the given element.
	   */
	  var getElementStyle;
	  if (fabric.document.defaultView && fabric.document.defaultView.getComputedStyle) {
	    getElementStyle = function(element, attr) {
	      var style = fabric.document.defaultView.getComputedStyle(element, null);
	      return style ? style[attr] : undefined;
	    };
	  }
	  else {
	    getElementStyle = function(element, attr) {
	      var value = element.style[attr];
	      if (!value && element.currentStyle) {
	        value = element.currentStyle[attr];
	      }
	      return value;
	    };
	  }
	
	  (function () {
	    var style = fabric.document.documentElement.style,
	        selectProp = 'userSelect' in style
	          ? 'userSelect'
	          : 'MozUserSelect' in style
	            ? 'MozUserSelect'
	            : 'WebkitUserSelect' in style
	              ? 'WebkitUserSelect'
	              : 'KhtmlUserSelect' in style
	                ? 'KhtmlUserSelect'
	                : '';
	
	    /**
	     * Makes element unselectable
	     * @memberOf fabric.util
	     * @param {HTMLElement} element Element to make unselectable
	     * @return {HTMLElement} Element that was passed in
	     */
	    function makeElementUnselectable(element) {
	      if (typeof element.onselectstart !== 'undefined') {
	        element.onselectstart = fabric.util.falseFunction;
	      }
	      if (selectProp) {
	        element.style[selectProp] = 'none';
	      }
	      else if (typeof element.unselectable === 'string') {
	        element.unselectable = 'on';
	      }
	      return element;
	    }
	
	    /**
	     * Makes element selectable
	     * @memberOf fabric.util
	     * @param {HTMLElement} element Element to make selectable
	     * @return {HTMLElement} Element that was passed in
	     */
	    function makeElementSelectable(element) {
	      if (typeof element.onselectstart !== 'undefined') {
	        element.onselectstart = null;
	      }
	      if (selectProp) {
	        element.style[selectProp] = '';
	      }
	      else if (typeof element.unselectable === 'string') {
	        element.unselectable = '';
	      }
	      return element;
	    }
	
	    fabric.util.makeElementUnselectable = makeElementUnselectable;
	    fabric.util.makeElementSelectable = makeElementSelectable;
	  })();
	
	  (function() {
	
	    /**
	     * Inserts a script element with a given url into a document; invokes callback, when that script is finished loading
	     * @memberOf fabric.util
	     * @param {String} url URL of a script to load
	     * @param {Function} callback Callback to execute when script is finished loading
	     */
	    function getScript(url, callback) {
	      var headEl = fabric.document.getElementsByTagName('head')[0],
	          scriptEl = fabric.document.createElement('script'),
	          loading = true;
	
	      /** @ignore */
	      scriptEl.onload = /** @ignore */ scriptEl.onreadystatechange = function(e) {
	        if (loading) {
	          if (typeof this.readyState === 'string' &&
	              this.readyState !== 'loaded' &&
	              this.readyState !== 'complete') {
	            return;
	          }
	          loading = false;
	          callback(e || fabric.window.event);
	          scriptEl = scriptEl.onload = scriptEl.onreadystatechange = null;
	        }
	      };
	      scriptEl.src = url;
	      headEl.appendChild(scriptEl);
	      // causes issue in Opera
	      // headEl.removeChild(scriptEl);
	    }
	
	    fabric.util.getScript = getScript;
	  })();
	
	  function getNodeCanvas(element) {
	    var impl = fabric.jsdomImplForWrapper(element);
	    return impl._canvas || impl._image;
	  };
	
	  function cleanUpJsdomNode(element) {
	    if (!fabric.isLikelyNode) {
	      return;
	    }
	    var impl = fabric.jsdomImplForWrapper(element);
	    if (impl) {
	      impl._image = null;
	      impl._canvas = null;
	      // unsure if necessary
	      impl._currentSrc = null;
	      impl._attributes = null;
	      impl._classList = null;
	    }
	  }
	
	  fabric.util.getById = getById;
	  fabric.util.toArray = toArray;
	  fabric.util.makeElement = makeElement;
	  fabric.util.addClass = addClass;
	  fabric.util.wrapElement = wrapElement;
	  fabric.util.getScrollLeftTop = getScrollLeftTop;
	  fabric.util.getElementOffset = getElementOffset;
	  fabric.util.getElementStyle = getElementStyle;
	  fabric.util.getNodeCanvas = getNodeCanvas;
	  fabric.util.cleanUpJsdomNode = cleanUpJsdomNode;
	
	})();
	
	
	(function() {
	
	  function addParamToUrl(url, param) {
	    return url + (/\?/.test(url) ? '&' : '?') + param;
	  }
	
	  function emptyFn() { }
	
	  /**
	   * Cross-browser abstraction for sending XMLHttpRequest
	   * @memberOf fabric.util
	   * @param {String} url URL to send XMLHttpRequest to
	   * @param {Object} [options] Options object
	   * @param {String} [options.method="GET"]
	   * @param {String} [options.parameters] parameters to append to url in GET or in body
	   * @param {String} [options.body] body to send with POST or PUT request
	   * @param {Function} options.onComplete Callback to invoke when request is completed
	   * @return {XMLHttpRequest} request
	   */
	  function request(url, options) {
	    options || (options = { });
	
	    var method = options.method ? options.method.toUpperCase() : 'GET',
	        onComplete = options.onComplete || function() { },
	        xhr = new fabric.window.XMLHttpRequest(),
	        body = options.body || options.parameters;
	
	    /** @ignore */
	    xhr.onreadystatechange = function() {
	      if (xhr.readyState === 4) {
	        onComplete(xhr);
	        xhr.onreadystatechange = emptyFn;
	      }
	    };
	
	    if (method === 'GET') {
	      body = null;
	      if (typeof options.parameters === 'string') {
	        url = addParamToUrl(url, options.parameters);
	      }
	    }
	
	    xhr.open(method, url, true);
	
	    if (method === 'POST' || method === 'PUT') {
	      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	    }
	
	    xhr.send(body);
	    return xhr;
	  }
	
	  fabric.util.request = request;
	})();
	
	
	/**
	 * Wrapper around `console.log` (when available)
	 * @param {*} [values] Values to log
	 */
	fabric.log = function() { };
	
	/**
	 * Wrapper around `console.warn` (when available)
	 * @param {*} [values] Values to log as a warning
	 */
	fabric.warn = function() { };
	
	/* eslint-disable */
	if (typeof console !== 'undefined') {
	
	  ['log', 'warn'].forEach(function(methodName) {
	
	    if (typeof console[methodName] !== 'undefined' &&
	        typeof console[methodName].apply === 'function') {
	
	      fabric[methodName] = function() {
	        return console[methodName].apply(console, arguments);
	      };
	    }
	  });
	}
	/* eslint-enable */
	
	
	(function() {
	
	  function noop() {
	    return false;
	  }
	
	  /**
	   * Changes value from one to another within certain period of time, invoking callbacks as value is being changed.
	   * @memberOf fabric.util
	   * @param {Object} [options] Animation options
	   * @param {Function} [options.onChange] Callback; invoked on every value change
	   * @param {Function} [options.onComplete] Callback; invoked when value change is completed
	   * @param {Number} [options.startValue=0] Starting value
	   * @param {Number} [options.endValue=100] Ending value
	   * @param {Number} [options.byValue=100] Value to modify the property by
	   * @param {Function} [options.easing] Easing function
	   * @param {Number} [options.duration=500] Duration of change (in ms)
	   * @param {Function} [options.abort] Additional function with logic. If returns true, onComplete is called.
	   */
	  function animate(options) {
	
	    requestAnimFrame(function(timestamp) {
	      options || (options = { });
	
	      var start = timestamp || +new Date(),
	          duration = options.duration || 500,
	          finish = start + duration, time,
	          onChange = options.onChange || noop,
	          abort = options.abort || noop,
	          onComplete = options.onComplete || noop,
	          easing = options.easing || function(t, b, c, d) {return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;},
	          startValue = 'startValue' in options ? options.startValue : 0,
	          endValue = 'endValue' in options ? options.endValue : 100,
	          byValue = options.byValue || endValue - startValue;
	
	      options.onStart && options.onStart();
	
	      (function tick(ticktime) {
	        // TODO: move abort call after calculation
	        // and pass (current,valuePerc, timePerc) as arguments
	        if (abort()) {
	          onComplete(endValue, 1, 1);
	          return;
	        }
	        time = ticktime || +new Date();
	        var currentTime = time > finish ? duration : (time - start),
	            timePerc = currentTime / duration,
	            current = easing(currentTime, startValue, byValue, duration),
	            valuePerc = Math.abs((current - startValue) / byValue);
	        onChange(current, valuePerc, timePerc);
	        if (time > finish) {
	          options.onComplete && options.onComplete();
	          return;
	        }
	        requestAnimFrame(tick);
	      })(start);
	    });
	
	  }
	
	  var _requestAnimFrame = fabric.window.requestAnimationFrame       ||
	                          fabric.window.webkitRequestAnimationFrame ||
	                          fabric.window.mozRequestAnimationFrame    ||
	                          fabric.window.oRequestAnimationFrame      ||
	                          fabric.window.msRequestAnimationFrame     ||
	                          function(callback) {
	                            return fabric.window.setTimeout(callback, 1000 / 60);
	                          };
	
	  var _cancelAnimFrame = fabric.window.cancelAnimationFrame || fabric.window.clearTimeout;
	
	  /**
	   * requestAnimationFrame polyfill based on http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	   * In order to get a precise start time, `requestAnimFrame` should be called as an entry into the method
	   * @memberOf fabric.util
	   * @param {Function} callback Callback to invoke
	   * @param {DOMElement} element optional Element to associate with animation
	   */
	  function requestAnimFrame() {
	    return _requestAnimFrame.apply(fabric.window, arguments);
	  }
	
	  function cancelAnimFrame() {
	    return _cancelAnimFrame.apply(fabric.window, arguments);
	  }
	
	  fabric.util.animate = animate;
	  fabric.util.requestAnimFrame = requestAnimFrame;
	  fabric.util.cancelAnimFrame = cancelAnimFrame;
	})();
	
	
	(function() {
	  // Calculate an in-between color. Returns a "rgba()" string.
	  // Credit: Edwin Martin <edwin@bitstorm.org>
	  //         http://www.bitstorm.org/jquery/color-animation/jquery.animate-colors.js
	  function calculateColor(begin, end, pos) {
	    var color = 'rgba('
	        + parseInt((begin[0] + pos * (end[0] - begin[0])), 10) + ','
	        + parseInt((begin[1] + pos * (end[1] - begin[1])), 10) + ','
	        + parseInt((begin[2] + pos * (end[2] - begin[2])), 10);
	
	    color += ',' + (begin && end ? parseFloat(begin[3] + pos * (end[3] - begin[3])) : 1);
	    color += ')';
	    return color;
	  }
	
	  /**
	   * Changes the color from one to another within certain period of time, invoking callbacks as value is being changed.
	   * @memberOf fabric.util
	   * @param {String} fromColor The starting color in hex or rgb(a) format.
	   * @param {String} toColor The starting color in hex or rgb(a) format.
	   * @param {Number} [duration] Duration of change (in ms).
	   * @param {Object} [options] Animation options
	   * @param {Function} [options.onChange] Callback; invoked on every value change
	   * @param {Function} [options.onComplete] Callback; invoked when value change is completed
	   * @param {Function} [options.colorEasing] Easing function. Note that this function only take two arguments (currentTime, duration). Thus the regular animation easing functions cannot be used.
	   * @param {Function} [options.abort] Additional function with logic. If returns true, onComplete is called.
	   */
	  function animateColor(fromColor, toColor, duration, options) {
	    var startColor = new fabric.Color(fromColor).getSource(),
	        endColor = new fabric.Color(toColor).getSource();
	
	    options = options || {};
	
	    fabric.util.animate(fabric.util.object.extend(options, {
	      duration: duration || 500,
	      startValue: startColor,
	      endValue: endColor,
	      byValue: endColor,
	      easing: function (currentTime, startValue, byValue, duration) {
	        var posValue = options.colorEasing
	          ? options.colorEasing(currentTime, duration)
	          : 1 - Math.cos(currentTime / duration * (Math.PI / 2));
	        return calculateColor(startValue, byValue, posValue);
	      }
	    }));
	  }
	
	  fabric.util.animateColor = animateColor;
	
	})();
	
	
	(function() {
	
	  function normalize(a, c, p, s) {
	    if (a < Math.abs(c)) {
	      a = c;
	      s = p / 4;
	    }
	    else {
	      //handle the 0/0 case:
	      if (c === 0 && a === 0) {
	        s = p / (2 * Math.PI) * Math.asin(1);
	      }
	      else {
	        s = p / (2 * Math.PI) * Math.asin(c / a);
	      }
	    }
	    return { a: a, c: c, p: p, s: s };
	  }
	
	  function elastic(opts, t, d) {
	    return opts.a *
	      Math.pow(2, 10 * (t -= 1)) *
	      Math.sin( (t * d - opts.s) * (2 * Math.PI) / opts.p );
	  }
	
	  /**
	   * Cubic easing out
	   * @memberOf fabric.util.ease
	   */
	  function easeOutCubic(t, b, c, d) {
	    return c * ((t = t / d - 1) * t * t + 1) + b;
	  }
	
	  /**
	   * Cubic easing in and out
	   * @memberOf fabric.util.ease
	   */
	  function easeInOutCubic(t, b, c, d) {
	    t /= d / 2;
	    if (t < 1) {
	      return c / 2 * t * t * t + b;
	    }
	    return c / 2 * ((t -= 2) * t * t + 2) + b;
	  }
	
	  /**
	   * Quartic easing in
	   * @memberOf fabric.util.ease
	   */
	  function easeInQuart(t, b, c, d) {
	    return c * (t /= d) * t * t * t + b;
	  }
	
	  /**
	   * Quartic easing out
	   * @memberOf fabric.util.ease
	   */
	  function easeOutQuart(t, b, c, d) {
	    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
	  }
	
	  /**
	   * Quartic easing in and out
	   * @memberOf fabric.util.ease
	   */
	  function easeInOutQuart(t, b, c, d) {
	    t /= d / 2;
	    if (t < 1) {
	      return c / 2 * t * t * t * t + b;
	    }
	    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
	  }
	
	  /**
	   * Quintic easing in
	   * @memberOf fabric.util.ease
	   */
	  function easeInQuint(t, b, c, d) {
	    return c * (t /= d) * t * t * t * t + b;
	  }
	
	  /**
	   * Quintic easing out
	   * @memberOf fabric.util.ease
	   */
	  function easeOutQuint(t, b, c, d) {
	    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
	  }
	
	  /**
	   * Quintic easing in and out
	   * @memberOf fabric.util.ease
	   */
	  function easeInOutQuint(t, b, c, d) {
	    t /= d / 2;
	    if (t < 1) {
	      return c / 2 * t * t * t * t * t + b;
	    }
	    return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
	  }
	
	  /**
	   * Sinusoidal easing in
	   * @memberOf fabric.util.ease
	   */
	  function easeInSine(t, b, c, d) {
	    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
	  }
	
	  /**
	   * Sinusoidal easing out
	   * @memberOf fabric.util.ease
	   */
	  function easeOutSine(t, b, c, d) {
	    return c * Math.sin(t / d * (Math.PI / 2)) + b;
	  }
	
	  /**
	   * Sinusoidal easing in and out
	   * @memberOf fabric.util.ease
	   */
	  function easeInOutSine(t, b, c, d) {
	    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
	  }
	
	  /**
	   * Exponential easing in
	   * @memberOf fabric.util.ease
	   */
	  function easeInExpo(t, b, c, d) {
	    return (t === 0) ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
	  }
	
	  /**
	   * Exponential easing out
	   * @memberOf fabric.util.ease
	   */
	  function easeOutExpo(t, b, c, d) {
	    return (t === d) ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
	  }
	
	  /**
	   * Exponential easing in and out
	   * @memberOf fabric.util.ease
	   */
	  function easeInOutExpo(t, b, c, d) {
	    if (t === 0) {
	      return b;
	    }
	    if (t === d) {
	      return b + c;
	    }
	    t /= d / 2;
	    if (t < 1) {
	      return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
	    }
	    return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
	  }
	
	  /**
	   * Circular easing in
	   * @memberOf fabric.util.ease
	   */
	  function easeInCirc(t, b, c, d) {
	    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
	  }
	
	  /**
	   * Circular easing out
	   * @memberOf fabric.util.ease
	   */
	  function easeOutCirc(t, b, c, d) {
	    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
	  }
	
	  /**
	   * Circular easing in and out
	   * @memberOf fabric.util.ease
	   */
	  function easeInOutCirc(t, b, c, d) {
	    t /= d / 2;
	    if (t < 1) {
	      return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
	    }
	    return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
	  }
	
	  /**
	   * Elastic easing in
	   * @memberOf fabric.util.ease
	   */
	  function easeInElastic(t, b, c, d) {
	    var s = 1.70158, p = 0, a = c;
	    if (t === 0) {
	      return b;
	    }
	    t /= d;
	    if (t === 1) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * 0.3;
	    }
	    var opts = normalize(a, c, p, s);
	    return -elastic(opts, t, d) + b;
	  }
	
	  /**
	   * Elastic easing out
	   * @memberOf fabric.util.ease
	   */
	  function easeOutElastic(t, b, c, d) {
	    var s = 1.70158, p = 0, a = c;
	    if (t === 0) {
	      return b;
	    }
	    t /= d;
	    if (t === 1) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * 0.3;
	    }
	    var opts = normalize(a, c, p, s);
	    return opts.a * Math.pow(2, -10 * t) * Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p ) + opts.c + b;
	  }
	
	  /**
	   * Elastic easing in and out
	   * @memberOf fabric.util.ease
	   */
	  function easeInOutElastic(t, b, c, d) {
	    var s = 1.70158, p = 0, a = c;
	    if (t === 0) {
	      return b;
	    }
	    t /= d / 2;
	    if (t === 2) {
	      return b + c;
	    }
	    if (!p) {
	      p = d * (0.3 * 1.5);
	    }
	    var opts = normalize(a, c, p, s);
	    if (t < 1) {
	      return -0.5 * elastic(opts, t, d) + b;
	    }
	    return opts.a * Math.pow(2, -10 * (t -= 1)) *
	      Math.sin((t * d - opts.s) * (2 * Math.PI) / opts.p ) * 0.5 + opts.c + b;
	  }
	
	  /**
	   * Backwards easing in
	   * @memberOf fabric.util.ease
	   */
	  function easeInBack(t, b, c, d, s) {
	    if (s === undefined) {
	      s = 1.70158;
	    }
	    return c * (t /= d) * t * ((s + 1) * t - s) + b;
	  }
	
	  /**
	   * Backwards easing out
	   * @memberOf fabric.util.ease
	   */
	  function easeOutBack(t, b, c, d, s) {
	    if (s === undefined) {
	      s = 1.70158;
	    }
	    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
	  }
	
	  /**
	   * Backwards easing in and out
	   * @memberOf fabric.util.ease
	   */
	  function easeInOutBack(t, b, c, d, s) {
	    if (s === undefined) {
	      s = 1.70158;
	    }
	    t /= d / 2;
	    if (t < 1) {
	      return c / 2 * (t * t * (((s *= (1.525)) + 1) * t - s)) + b;
	    }
	    return c / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2) + b;
	  }
	
	  /**
	   * Bouncing easing in
	   * @memberOf fabric.util.ease
	   */
	  function easeInBounce(t, b, c, d) {
	    return c - easeOutBounce (d - t, 0, c, d) + b;
	  }
	
	  /**
	   * Bouncing easing out
	   * @memberOf fabric.util.ease
	   */
	  function easeOutBounce(t, b, c, d) {
	    if ((t /= d) < (1 / 2.75)) {
	      return c * (7.5625 * t * t) + b;
	    }
	    else if (t < (2 / 2.75)) {
	      return c * (7.5625 * (t -= (1.5 / 2.75)) * t + 0.75) + b;
	    }
	    else if (t < (2.5 / 2.75)) {
	      return c * (7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375) + b;
	    }
	    else {
	      return c * (7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375) + b;
	    }
	  }
	
	  /**
	   * Bouncing easing in and out
	   * @memberOf fabric.util.ease
	   */
	  function easeInOutBounce(t, b, c, d) {
	    if (t < d / 2) {
	      return easeInBounce (t * 2, 0, c, d) * 0.5 + b;
	    }
	    return easeOutBounce(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
	  }
	
	  /**
	   * Easing functions
	   * See <a href="http://gizma.com/easing/">Easing Equations by Robert Penner</a>
	   * @namespace fabric.util.ease
	   */
	  fabric.util.ease = {
	
	    /**
	     * Quadratic easing in
	     * @memberOf fabric.util.ease
	     */
	    easeInQuad: function(t, b, c, d) {
	      return c * (t /= d) * t + b;
	    },
	
	    /**
	     * Quadratic easing out
	     * @memberOf fabric.util.ease
	     */
	    easeOutQuad: function(t, b, c, d) {
	      return -c * (t /= d) * (t - 2) + b;
	    },
	
	    /**
	     * Quadratic easing in and out
	     * @memberOf fabric.util.ease
	     */
	    easeInOutQuad: function(t, b, c, d) {
	      t /= (d / 2);
	      if (t < 1) {
	        return c / 2 * t * t + b;
	      }
	      return -c / 2 * ((--t) * (t - 2) - 1) + b;
	    },
	
	    /**
	     * Cubic easing in
	     * @memberOf fabric.util.ease
	     */
	    easeInCubic: function(t, b, c, d) {
	      return c * (t /= d) * t * t + b;
	    },
	
	    easeOutCubic: easeOutCubic,
	    easeInOutCubic: easeInOutCubic,
	    easeInQuart: easeInQuart,
	    easeOutQuart: easeOutQuart,
	    easeInOutQuart: easeInOutQuart,
	    easeInQuint: easeInQuint,
	    easeOutQuint: easeOutQuint,
	    easeInOutQuint: easeInOutQuint,
	    easeInSine: easeInSine,
	    easeOutSine: easeOutSine,
	    easeInOutSine: easeInOutSine,
	    easeInExpo: easeInExpo,
	    easeOutExpo: easeOutExpo,
	    easeInOutExpo: easeInOutExpo,
	    easeInCirc: easeInCirc,
	    easeOutCirc: easeOutCirc,
	    easeInOutCirc: easeInOutCirc,
	    easeInElastic: easeInElastic,
	    easeOutElastic: easeOutElastic,
	    easeInOutElastic: easeInOutElastic,
	    easeInBack: easeInBack,
	    easeOutBack: easeOutBack,
	    easeInOutBack: easeInOutBack,
	    easeInBounce: easeInBounce,
	    easeOutBounce: easeOutBounce,
	    easeInOutBounce: easeInOutBounce
	  };
	
	})();
	
	
	(function(global) {
	
	  'use strict';
	
	  /**
	   * @name fabric
	   * @namespace
	   */
	
	  var fabric = global.fabric || (global.fabric = { }),
	      extend = fabric.util.object.extend,
	      clone = fabric.util.object.clone,
	      toFixed = fabric.util.toFixed,
	      parseUnit = fabric.util.parseUnit,
	      multiplyTransformMatrices = fabric.util.multiplyTransformMatrices,
	
	      svgValidTagNames = ['path', 'circle', 'polygon', 'polyline', 'ellipse', 'rect', 'line',
	        'image', 'text'],
	      svgViewBoxElements = ['symbol', 'image', 'marker', 'pattern', 'view', 'svg'],
	      svgInvalidAncestors = ['pattern', 'defs', 'symbol', 'metadata', 'clipPath', 'mask', 'desc'],
	      svgValidParents = ['symbol', 'g', 'a', 'svg', 'clipPath', 'defs'],
	
	      attributesMap = {
	        cx:                   'left',
	        x:                    'left',
	        r:                    'radius',
	        cy:                   'top',
	        y:                    'top',
	        display:              'visible',
	        visibility:           'visible',
	        transform:            'transformMatrix',
	        'fill-opacity':       'fillOpacity',
	        'fill-rule':          'fillRule',
	        'font-family':        'fontFamily',
	        'font-size':          'fontSize',
	        'font-style':         'fontStyle',
	        'font-weight':        'fontWeight',
	        'letter-spacing':     'charSpacing',
	        'paint-order':        'paintFirst',
	        'stroke-dasharray':   'strokeDashArray',
	        'stroke-dashoffset':  'strokeDashOffset',
	        'stroke-linecap':     'strokeLineCap',
	        'stroke-linejoin':    'strokeLineJoin',
	        'stroke-miterlimit':  'strokeMiterLimit',
	        'stroke-opacity':     'strokeOpacity',
	        'stroke-width':       'strokeWidth',
	        'text-decoration':    'textDecoration',
	        'text-anchor':        'textAnchor',
	        opacity:              'opacity',
	        'clip-path':          'clipPath',
	        'clip-rule':          'clipRule',
	        'vector-effect':      'strokeUniform'
	      },
	
	      colorAttributes = {
	        stroke: 'strokeOpacity',
	        fill:   'fillOpacity'
	      };
	
	  fabric.svgValidTagNamesRegEx = getSvgRegex(svgValidTagNames);
	  fabric.svgViewBoxElementsRegEx = getSvgRegex(svgViewBoxElements);
	  fabric.svgInvalidAncestorsRegEx = getSvgRegex(svgInvalidAncestors);
	  fabric.svgValidParentsRegEx = getSvgRegex(svgValidParents);
	
	  fabric.cssRules = { };
	  fabric.gradientDefs = { };
	  fabric.clipPaths = { };
	
	  function normalizeAttr(attr) {
	    // transform attribute names
	    if (attr in attributesMap) {
	      return attributesMap[attr];
	    }
	    return attr;
	  }
	
	  function normalizeValue(attr, value, parentAttributes, fontSize) {
	    var isArray = Object.prototype.toString.call(value) === '[object Array]',
	        parsed;
	
	    if ((attr === 'fill' || attr === 'stroke') && value === 'none') {
	      value = '';
	    }
	    else if (attr === 'vector-effect') {
	      value = value === 'non-scaling-stroke';
	    }
	    else if (attr === 'strokeDashArray') {
	      if (value === 'none') {
	        value = null;
	      }
	      else {
	        value = value.replace(/,/g, ' ').split(/\s+/).map(parseFloat);
	      }
	    }
	    else if (attr === 'transformMatrix') {
	      if (parentAttributes && parentAttributes.transformMatrix) {
	        value = multiplyTransformMatrices(
	          parentAttributes.transformMatrix, fabric.parseTransformAttribute(value));
	      }
	      else {
	        value = fabric.parseTransformAttribute(value);
	      }
	    }
	    else if (attr === 'visible') {
	      value = value !== 'none' && value !== 'hidden';
	      // display=none on parent element always takes precedence over child element
	      if (parentAttributes && parentAttributes.visible === false) {
	        value = false;
	      }
	    }
	    else if (attr === 'opacity') {
	      value = parseFloat(value);
	      if (parentAttributes && typeof parentAttributes.opacity !== 'undefined') {
	        value *= parentAttributes.opacity;
	      }
	    }
	    else if (attr === 'textAnchor' /* text-anchor */) {
	      value = value === 'start' ? 'left' : value === 'end' ? 'right' : 'center';
	    }
	    else if (attr === 'charSpacing') {
	      // parseUnit returns px and we convert it to em
	      parsed = parseUnit(value, fontSize) / fontSize * 1000;
	    }
	    else if (attr === 'paintFirst') {
	      var fillIndex = value.indexOf('fill');
	      var strokeIndex = value.indexOf('stroke');
	      var value = 'fill';
	      if (fillIndex > -1 && strokeIndex > -1 && strokeIndex < fillIndex) {
	        value = 'stroke';
	      }
	      else if (fillIndex === -1 && strokeIndex > -1) {
	        value = 'stroke';
	      }
	    }
	    else if (attr === 'href' || attr === 'xlink:href') {
	      return value;
	    }
	    else {
	      parsed = isArray ? value.map(parseUnit) : parseUnit(value, fontSize);
	    }
	
	    return (!isArray && isNaN(parsed) ? value : parsed);
	  }
	
	  /**
	    * @private
	    */
	  function getSvgRegex(arr) {
	    return new RegExp('^(' + arr.join('|') + ')\\b', 'i');
	  }
	
	  /**
	   * @private
	   * @param {Object} attributes Array of attributes to parse
	   */
	  function _setStrokeFillOpacity(attributes) {
	    for (var attr in colorAttributes) {
	
	      if (typeof attributes[colorAttributes[attr]] === 'undefined' || attributes[attr] === '') {
	        continue;
	      }
	
	      if (typeof attributes[attr] === 'undefined') {
	        if (!fabric.Object.prototype[attr]) {
	          continue;
	        }
	        attributes[attr] = fabric.Object.prototype[attr];
	      }
	
	      if (attributes[attr].indexOf('url(') === 0) {
	        continue;
	      }
	
	      var color = new fabric.Color(attributes[attr]);
	      attributes[attr] = color.setAlpha(toFixed(color.getAlpha() * attributes[colorAttributes[attr]], 2)).toRgba();
	    }
	    return attributes;
	  }
	
	  /**
	   * @private
	   */
	  function _getMultipleNodes(doc, nodeNames) {
	    var nodeName, nodeArray = [], nodeList, i, len;
	    for (i = 0, len = nodeNames.length; i < len; i++) {
	      nodeName = nodeNames[i];
	      nodeList = doc.getElementsByTagName(nodeName);
	      nodeArray = nodeArray.concat(Array.prototype.slice.call(nodeList));
	    }
	    return nodeArray;
	  }
	
	  /**
	   * Parses "transform" attribute, returning an array of values
	   * @static
	   * @function
	   * @memberOf fabric
	   * @param {String} attributeValue String containing attribute value
	   * @return {Array} Array of 6 elements representing transformation matrix
	   */
	  fabric.parseTransformAttribute = (function() {
	    function rotateMatrix(matrix, args) {
	      var cos = fabric.util.cos(args[0]), sin = fabric.util.sin(args[0]),
	          x = 0, y = 0;
	      if (args.length === 3) {
	        x = args[1];
	        y = args[2];
	      }
	
	      matrix[0] = cos;
	      matrix[1] = sin;
	      matrix[2] = -sin;
	      matrix[3] = cos;
	      matrix[4] = x - (cos * x - sin * y);
	      matrix[5] = y - (sin * x + cos * y);
	    }
	
	    function scaleMatrix(matrix, args) {
	      var multiplierX = args[0],
	          multiplierY = (args.length === 2) ? args[1] : args[0];
	
	      matrix[0] = multiplierX;
	      matrix[3] = multiplierY;
	    }
	
	    function skewMatrix(matrix, args, pos) {
	      matrix[pos] = Math.tan(fabric.util.degreesToRadians(args[0]));
	    }
	
	    function translateMatrix(matrix, args) {
	      matrix[4] = args[0];
	      if (args.length === 2) {
	        matrix[5] = args[1];
	      }
	    }
	
	    // identity matrix
	    var iMatrix = fabric.iMatrix,
	
	        // == begin transform regexp
	        number = fabric.reNum,
	
	        commaWsp = '(?:\\s+,?\\s*|,\\s*)',
	
	        skewX = '(?:(skewX)\\s*\\(\\s*(' + number + ')\\s*\\))',
	
	        skewY = '(?:(skewY)\\s*\\(\\s*(' + number + ')\\s*\\))',
	
	        rotate = '(?:(rotate)\\s*\\(\\s*(' + number + ')(?:' +
	                    commaWsp + '(' + number + ')' +
	                    commaWsp + '(' + number + '))?\\s*\\))',
	
	        scale = '(?:(scale)\\s*\\(\\s*(' + number + ')(?:' +
	                    commaWsp + '(' + number + '))?\\s*\\))',
	
	        translate = '(?:(translate)\\s*\\(\\s*(' + number + ')(?:' +
	                    commaWsp + '(' + number + '))?\\s*\\))',
	
	        matrix = '(?:(matrix)\\s*\\(\\s*' +
	                  '(' + number + ')' + commaWsp +
	                  '(' + number + ')' + commaWsp +
	                  '(' + number + ')' + commaWsp +
	                  '(' + number + ')' + commaWsp +
	                  '(' + number + ')' + commaWsp +
	                  '(' + number + ')' +
	                  '\\s*\\))',
	
	        transform = '(?:' +
	                    matrix + '|' +
	                    translate + '|' +
	                    scale + '|' +
	                    rotate + '|' +
	                    skewX + '|' +
	                    skewY +
	                    ')',
	
	        transforms = '(?:' + transform + '(?:' + commaWsp + '*' + transform + ')*' + ')',
	
	        transformList = '^\\s*(?:' + transforms + '?)\\s*$',
	
	        // http://www.w3.org/TR/SVG/coords.html#TransformAttribute
	        reTransformList = new RegExp(transformList),
	        // == end transform regexp
	
	        reTransform = new RegExp(transform, 'g');
	
	    return function(attributeValue) {
	
	      // start with identity matrix
	      var matrix = iMatrix.concat(),
	          matrices = [];
	
	      // return if no argument was given or
	      // an argument does not match transform attribute regexp
	      if (!attributeValue || (attributeValue && !reTransformList.test(attributeValue))) {
	        return matrix;
	      }
	
	      attributeValue.replace(reTransform, function(match) {
	
	        var m = new RegExp(transform).exec(match).filter(function (match) {
	              // match !== '' && match != null
	              return (!!match);
	            }),
	            operation = m[1],
	            args = m.slice(2).map(parseFloat);
	
	        switch (operation) {
	          case 'translate':
	            translateMatrix(matrix, args);
	            break;
	          case 'rotate':
	            args[0] = fabric.util.degreesToRadians(args[0]);
	            rotateMatrix(matrix, args);
	            break;
	          case 'scale':
	            scaleMatrix(matrix, args);
	            break;
	          case 'skewX':
	            skewMatrix(matrix, args, 2);
	            break;
	          case 'skewY':
	            skewMatrix(matrix, args, 1);
	            break;
	          case 'matrix':
	            matrix = args;
	            break;
	        }
	
	        // snapshot current matrix into matrices array
	        matrices.push(matrix.concat());
	        // reset
	        matrix = iMatrix.concat();
	      });
	
	      var combinedMatrix = matrices[0];
	      while (matrices.length > 1) {
	        matrices.shift();
	        combinedMatrix = fabric.util.multiplyTransformMatrices(combinedMatrix, matrices[0]);
	      }
	      return combinedMatrix;
	    };
	  })();
	
	  /**
	   * @private
	   */
	  function parseStyleString(style, oStyle) {
	    var attr, value;
	    style.replace(/;\s*$/, '').split(';').forEach(function (chunk) {
	      var pair = chunk.split(':');
	
	      attr = pair[0].trim().toLowerCase();
	      value =  pair[1].trim();
	
	      oStyle[attr] = value;
	    });
	  }
	
	  /**
	   * @private
	   */
	  function parseStyleObject(style, oStyle) {
	    var attr, value;
	    for (var prop in style) {
	      if (typeof style[prop] === 'undefined') {
	        continue;
	      }
	
	      attr = prop.toLowerCase();
	      value = style[prop];
	
	      oStyle[attr] = value;
	    }
	  }
	
	  /**
	   * @private
	   */
	  function getGlobalStylesForElement(element, svgUid) {
	    var styles = { };
	    for (var rule in fabric.cssRules[svgUid]) {
	      if (elementMatchesRule(element, rule.split(' '))) {
	        for (var property in fabric.cssRules[svgUid][rule]) {
	          styles[property] = fabric.cssRules[svgUid][rule][property];
	        }
	      }
	    }
	    return styles;
	  }
	
	  /**
	   * @private
	   */
	  function elementMatchesRule(element, selectors) {
	    var firstMatching, parentMatching = true;
	    //start from rightmost selector.
	    firstMatching = selectorMatches(element, selectors.pop());
	    if (firstMatching && selectors.length) {
	      parentMatching = doesSomeParentMatch(element, selectors);
	    }
	    return firstMatching && parentMatching && (selectors.length === 0);
	  }
	
	  function doesSomeParentMatch(element, selectors) {
	    var selector, parentMatching = true;
	    while (element.parentNode && element.parentNode.nodeType === 1 && selectors.length) {
	      if (parentMatching) {
	        selector = selectors.pop();
	      }
	      element = element.parentNode;
	      parentMatching = selectorMatches(element, selector);
	    }
	    return selectors.length === 0;
	  }
	
	  /**
	   * @private
	   */
	  function selectorMatches(element, selector) {
	    var nodeName = element.nodeName,
	        classNames = element.getAttribute('class'),
	        id = element.getAttribute('id'), matcher, i;
	    // i check if a selector matches slicing away part from it.
	    // if i get empty string i should match
	    matcher = new RegExp('^' + nodeName, 'i');
	    selector = selector.replace(matcher, '');
	    if (id && selector.length) {
	      matcher = new RegExp('#' + id + '(?![a-zA-Z\\-]+)', 'i');
	      selector = selector.replace(matcher, '');
	    }
	    if (classNames && selector.length) {
	      classNames = classNames.split(' ');
	      for (i = classNames.length; i--;) {
	        matcher = new RegExp('\\.' + classNames[i] + '(?![a-zA-Z\\-]+)', 'i');
	        selector = selector.replace(matcher, '');
	      }
	    }
	    return selector.length === 0;
	  }
	
	  /**
	   * @private
	   * to support IE8 missing getElementById on SVGdocument and on node xmlDOM
	   */
	  function elementById(doc, id) {
	    var el;
	    doc.getElementById && (el = doc.getElementById(id));
	    if (el) {
	      return el;
	    }
	    var node, i, len, nodelist = doc.getElementsByTagName('*');
	    for (i = 0, len = nodelist.length; i < len; i++) {
	      node = nodelist[i];
	      if (id === node.getAttribute('id')) {
	        return node;
	      }
	    }
	  }
	
	  /**
	   * @private
	   */
	  function parseUseDirectives(doc) {
	    var nodelist = _getMultipleNodes(doc, ['use', 'svg:use']), i = 0;
	    while (nodelist.length && i < nodelist.length) {
	      var el = nodelist[i],
	          xlink = (el.getAttribute('xlink:href') || el.getAttribute('href')).substr(1),
	          x = el.getAttribute('x') || 0,
	          y = el.getAttribute('y') || 0,
	          el2 = elementById(doc, xlink).cloneNode(true),
	          currentTrans = (el2.getAttribute('transform') || '') + ' translate(' + x + ', ' + y + ')',
	          parentNode, oldLength = nodelist.length, attr, j, attrs, len;
	
	      applyViewboxTransform(el2);
	      if (/^svg$/i.test(el2.nodeName)) {
	        var el3 = el2.ownerDocument.createElement('g');
	        for (j = 0, attrs = el2.attributes, len = attrs.length; j < len; j++) {
	          attr = attrs.item(j);
	          el3.setAttribute(attr.nodeName, attr.nodeValue);
	        }
	        // el2.firstChild != null
	        while (el2.firstChild) {
	          el3.appendChild(el2.firstChild);
	        }
	        el2 = el3;
	      }
	
	      for (j = 0, attrs = el.attributes, len = attrs.length; j < len; j++) {
	        attr = attrs.item(j);
	        if (attr.nodeName === 'x' || attr.nodeName === 'y' ||
	          attr.nodeName === 'xlink:href' || attr.nodeName === 'href') {
	          continue;
	        }
	
	        if (attr.nodeName === 'transform') {
	          currentTrans = attr.nodeValue + ' ' + currentTrans;
	        }
	        else {
	          el2.setAttribute(attr.nodeName, attr.nodeValue);
	        }
	      }
	
	      el2.setAttribute('transform', currentTrans);
	      el2.setAttribute('instantiated_by_use', '1');
	      el2.removeAttribute('id');
	      parentNode = el.parentNode;
	      parentNode.replaceChild(el2, el);
	      // some browsers do not shorten nodelist after replaceChild (IE8)
	      if (nodelist.length === oldLength) {
	        i++;
	      }
	    }
	  }
	
	  // http://www.w3.org/TR/SVG/coords.html#ViewBoxAttribute
	  // matches, e.g.: +14.56e-12, etc.
	  var reViewBoxAttrValue = new RegExp(
	    '^' +
	    '\\s*(' + fabric.reNum + '+)\\s*,?' +
	    '\\s*(' + fabric.reNum + '+)\\s*,?' +
	    '\\s*(' + fabric.reNum + '+)\\s*,?' +
	    '\\s*(' + fabric.reNum + '+)\\s*' +
	    '$'
	  );
	
	  /**
	   * Add a <g> element that envelop all child elements and makes the viewbox transformMatrix descend on all elements
	   */
	  function applyViewboxTransform(element) {
	
	    var viewBoxAttr = element.getAttribute('viewBox'),
	        scaleX = 1,
	        scaleY = 1,
	        minX = 0,
	        minY = 0,
	        viewBoxWidth, viewBoxHeight, matrix, el,
	        widthAttr = element.getAttribute('width'),
	        heightAttr = element.getAttribute('height'),
	        x = element.getAttribute('x') || 0,
	        y = element.getAttribute('y') || 0,
	        preserveAspectRatio = element.getAttribute('preserveAspectRatio') || '',
	        missingViewBox = (!viewBoxAttr || !fabric.svgViewBoxElementsRegEx.test(element.nodeName)
	                           || !(viewBoxAttr = viewBoxAttr.match(reViewBoxAttrValue))),
	        missingDimAttr = (!widthAttr || !heightAttr || widthAttr === '100%' || heightAttr === '100%'),
	        toBeParsed = missingViewBox && missingDimAttr,
	        parsedDim = { }, translateMatrix = '', widthDiff = 0, heightDiff = 0;
	
	    parsedDim.width = 0;
	    parsedDim.height = 0;
	    parsedDim.toBeParsed = toBeParsed;
	
	    if (toBeParsed) {
	      return parsedDim;
	    }
	
	    if (missingViewBox) {
	      parsedDim.width = parseUnit(widthAttr);
	      parsedDim.height = parseUnit(heightAttr);
	      return parsedDim;
	    }
	
	    minX = -parseFloat(viewBoxAttr[1]);
	    minY = -parseFloat(viewBoxAttr[2]);
	    viewBoxWidth = parseFloat(viewBoxAttr[3]);
	    viewBoxHeight = parseFloat(viewBoxAttr[4]);
	
	    if (!missingDimAttr) {
	      parsedDim.width = parseUnit(widthAttr);
	      parsedDim.height = parseUnit(heightAttr);
	      scaleX = parsedDim.width / viewBoxWidth;
	      scaleY = parsedDim.height / viewBoxHeight;
	    }
	    else {
	      parsedDim.width = viewBoxWidth;
	      parsedDim.height = viewBoxHeight;
	    }
	
	    // default is to preserve aspect ratio
	    preserveAspectRatio = fabric.util.parsePreserveAspectRatioAttribute(preserveAspectRatio);
	    if (preserveAspectRatio.alignX !== 'none') {
	      //translate all container for the effect of Mid, Min, Max
	      if (preserveAspectRatio.meetOrSlice === 'meet') {
	        scaleY = scaleX = (scaleX > scaleY ? scaleY : scaleX);
	        // calculate additional translation to move the viewbox
	      }
	      if (preserveAspectRatio.meetOrSlice === 'slice') {
	        scaleY = scaleX = (scaleX > scaleY ? scaleX : scaleY);
	        // calculate additional translation to move the viewbox
	      }
	      widthDiff = parsedDim.width - viewBoxWidth * scaleX;
	      heightDiff = parsedDim.height - viewBoxHeight * scaleX;
	      if (preserveAspectRatio.alignX === 'Mid') {
	        widthDiff /= 2;
	      }
	      if (preserveAspectRatio.alignY === 'Mid') {
	        heightDiff /= 2;
	      }
	      if (preserveAspectRatio.alignX === 'Min') {
	        widthDiff = 0;
	      }
	      if (preserveAspectRatio.alignY === 'Min') {
	        heightDiff = 0;
	      }
	    }
	
	    if (scaleX === 1 && scaleY === 1 && minX === 0 && minY === 0 && x === 0 && y === 0) {
	      return parsedDim;
	    }
	
	    if (x || y) {
	      translateMatrix = ' translate(' + parseUnit(x) + ' ' + parseUnit(y) + ') ';
	    }
	
	    matrix = translateMatrix + ' matrix(' + scaleX +
	                  ' 0' +
	                  ' 0 ' +
	                  scaleY + ' ' +
	                  (minX * scaleX + widthDiff) + ' ' +
	                  (minY * scaleY + heightDiff) + ') ';
	    parsedDim.viewboxTransform = fabric.parseTransformAttribute(matrix);
	    if (element.nodeName === 'svg') {
	      el = element.ownerDocument.createElement('g');
	      // element.firstChild != null
	      while (element.firstChild) {
	        el.appendChild(element.firstChild);
	      }
	      element.appendChild(el);
	    }
	    else {
	      el = element;
	      matrix = el.getAttribute('transform') + matrix;
	    }
	    el.setAttribute('transform', matrix);
	    return parsedDim;
	  }
	
	  function hasAncestorWithNodeName(element, nodeName) {
	    while (element && (element = element.parentNode)) {
	      if (element.nodeName && nodeName.test(element.nodeName.replace('svg:', ''))
	        && !element.getAttribute('instantiated_by_use')) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Parses an SVG document, converts it to an array of corresponding fabric.* instances and passes them to a callback
	   * @static
	   * @function
	   * @memberOf fabric
	   * @param {SVGDocument} doc SVG document to parse
	   * @param {Function} callback Callback to call when parsing is finished;
	   * It's being passed an array of elements (parsed from a document).
	   * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
	   * @param {Object} [parsingOptions] options for parsing document
	   * @param {String} [parsingOptions.crossOrigin] crossOrigin settings
	   */
	  fabric.parseSVGDocument = function(doc, callback, reviver, parsingOptions) {
	    if (!doc) {
	      return;
	    }
	
	    parseUseDirectives(doc);
	
	    var svgUid =  fabric.Object.__uid++, i, len,
	        options = applyViewboxTransform(doc),
	        descendants = fabric.util.toArray(doc.getElementsByTagName('*'));
	    options.crossOrigin = parsingOptions && parsingOptions.crossOrigin;
	    options.svgUid = svgUid;
	
	    if (descendants.length === 0 && fabric.isLikelyNode) {
	      // we're likely in node, where "o3-xml" library fails to gEBTN("*")
	      // https://github.com/ajaxorg/node-o3-xml/issues/21
	      descendants = doc.selectNodes('//*[name(.)!="svg"]');
	      var arr = [];
	      for (i = 0, len = descendants.length; i < len; i++) {
	        arr[i] = descendants[i];
	      }
	      descendants = arr;
	    }
	
	    var elements = descendants.filter(function(el) {
	      applyViewboxTransform(el);
	      return fabric.svgValidTagNamesRegEx.test(el.nodeName.replace('svg:', '')) &&
	            !hasAncestorWithNodeName(el, fabric.svgInvalidAncestorsRegEx); // http://www.w3.org/TR/SVG/struct.html#DefsElement
	    });
	
	    if (!elements || (elements && !elements.length)) {
	      callback && callback([], {});
	      return;
	    }
	    var clipPaths = { };
	    descendants.filter(function(el) {
	      return el.nodeName.replace('svg:', '') === 'clipPath';
	    }).forEach(function(el) {
	      var id = el.getAttribute('id');
	      clipPaths[id] = fabric.util.toArray(el.getElementsByTagName('*')).filter(function(el) {
	        return fabric.svgValidTagNamesRegEx.test(el.nodeName.replace('svg:', ''));
	      });
	    });
	    fabric.gradientDefs[svgUid] = fabric.getGradientDefs(doc);
	    fabric.cssRules[svgUid] = fabric.getCSSRules(doc);
	    fabric.clipPaths[svgUid] = clipPaths;
	    // Precedence of rules:   style > class > attribute
	    fabric.parseElements(elements, function(instances, elements) {
	      if (callback) {
	        callback(instances, options, elements, descendants);
	        delete fabric.gradientDefs[svgUid];
	        delete fabric.cssRules[svgUid];
	        delete fabric.clipPaths[svgUid];
	      }
	    }, clone(options), reviver, parsingOptions);
	  };
	
	  function recursivelyParseGradientsXlink(doc, gradient) {
	    var gradientsAttrs = ['gradientTransform', 'x1', 'x2', 'y1', 'y2', 'gradientUnits', 'cx', 'cy', 'r', 'fx', 'fy'],
	        xlinkAttr = 'xlink:href',
	        xLink = gradient.getAttribute(xlinkAttr).substr(1),
	        referencedGradient = elementById(doc, xLink);
	    if (referencedGradient && referencedGradient.getAttribute(xlinkAttr)) {
	      recursivelyParseGradientsXlink(doc, referencedGradient);
	    }
	    gradientsAttrs.forEach(function(attr) {
	      if (!gradient.hasAttribute(attr)) {
	        gradient.setAttribute(attr, referencedGradient.getAttribute(attr));
	      }
	    });
	    if (!gradient.children.length) {
	      var referenceClone = referencedGradient.cloneNode(true);
	      while (referenceClone.firstChild) {
	        gradient.appendChild(referenceClone.firstChild);
	      }
	    }
	    gradient.removeAttribute(xlinkAttr);
	  }
	
	  var reFontDeclaration = new RegExp(
	    '(normal|italic)?\\s*(normal|small-caps)?\\s*' +
	    '(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*(' +
	      fabric.reNum +
	    '(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|' + fabric.reNum + '))?\\s+(.*)');
	
	  extend(fabric, {
	    /**
	     * Parses a short font declaration, building adding its properties to a style object
	     * @static
	     * @function
	     * @memberOf fabric
	     * @param {String} value font declaration
	     * @param {Object} oStyle definition
	     */
	    parseFontDeclaration: function(value, oStyle) {
	      var match = value.match(reFontDeclaration);
	
	      if (!match) {
	        return;
	      }
	      var fontStyle = match[1],
	          // font variant is not used
	          // fontVariant = match[2],
	          fontWeight = match[3],
	          fontSize = match[4],
	          lineHeight = match[5],
	          fontFamily = match[6];
	
	      if (fontStyle) {
	        oStyle.fontStyle = fontStyle;
	      }
	      if (fontWeight) {
	        oStyle.fontWeight = isNaN(parseFloat(fontWeight)) ? fontWeight : parseFloat(fontWeight);
	      }
	      if (fontSize) {
	        oStyle.fontSize = parseUnit(fontSize);
	      }
	      if (fontFamily) {
	        oStyle.fontFamily = fontFamily;
	      }
	      if (lineHeight) {
	        oStyle.lineHeight = lineHeight === 'normal' ? 1 : lineHeight;
	      }
	    },
	
	    /**
	     * Parses an SVG document, returning all of the gradient declarations found in it
	     * @static
	     * @function
	     * @memberOf fabric
	     * @param {SVGDocument} doc SVG document to parse
	     * @return {Object} Gradient definitions; key corresponds to element id, value -- to gradient definition element
	     */
	    getGradientDefs: function(doc) {
	      var tagArray = [
	            'linearGradient',
	            'radialGradient',
	            'svg:linearGradient',
	            'svg:radialGradient'],
	          elList = _getMultipleNodes(doc, tagArray),
	          el, j = 0, gradientDefs = { };
	      j = elList.length;
	      while (j--) {
	        el = elList[j];
	        if (el.getAttribute('xlink:href')) {
	          recursivelyParseGradientsXlink(doc, el);
	        }
	        gradientDefs[el.getAttribute('id')] = el;
	      }
	      return gradientDefs;
	    },
	
	    /**
	     * Returns an object of attributes' name/value, given element and an array of attribute names;
	     * Parses parent "g" nodes recursively upwards.
	     * @static
	     * @memberOf fabric
	     * @param {DOMElement} element Element to parse
	     * @param {Array} attributes Array of attributes to parse
	     * @return {Object} object containing parsed attributes' names/values
	     */
	    parseAttributes: function(element, attributes, svgUid) {
	
	      if (!element) {
	        return;
	      }
	
	      var value,
	          parentAttributes = { },
	          fontSize, parentFontSize;
	
	      if (typeof svgUid === 'undefined') {
	        svgUid = element.getAttribute('svgUid');
	      }
	      // if there's a parent container (`g` or `a` or `symbol` node), parse its attributes recursively upwards
	      if (element.parentNode && fabric.svgValidParentsRegEx.test(element.parentNode.nodeName)) {
	        parentAttributes = fabric.parseAttributes(element.parentNode, attributes, svgUid);
	      }
	
	      var ownAttributes = attributes.reduce(function(memo, attr) {
	        value = element.getAttribute(attr);
	        if (value) { // eslint-disable-line
	          memo[attr] = value;
	        }
	        return memo;
	      }, { });
	      // add values parsed from style, which take precedence over attributes
	      // (see: http://www.w3.org/TR/SVG/styling.html#UsingPresentationAttributes)
	      ownAttributes = extend(ownAttributes,
	        extend(getGlobalStylesForElement(element, svgUid), fabric.parseStyleAttribute(element)));
	
	      fontSize = parentFontSize = parentAttributes.fontSize || fabric.Text.DEFAULT_SVG_FONT_SIZE;
	      if (ownAttributes['font-size']) {
	        // looks like the minimum should be 9px when dealing with ems. this is what looks like in browsers.
	        ownAttributes['font-size'] = fontSize = parseUnit(ownAttributes['font-size'], parentFontSize);
	      }
	
	      var normalizedAttr, normalizedValue, normalizedStyle = {};
	      for (var attr in ownAttributes) {
	        normalizedAttr = normalizeAttr(attr);
	        normalizedValue = normalizeValue(normalizedAttr, ownAttributes[attr], parentAttributes, fontSize);
	        normalizedStyle[normalizedAttr] = normalizedValue;
	      }
	      if (normalizedStyle && normalizedStyle.font) {
	        fabric.parseFontDeclaration(normalizedStyle.font, normalizedStyle);
	      }
	      var mergedAttrs = extend(parentAttributes, normalizedStyle);
	      return fabric.svgValidParentsRegEx.test(element.nodeName) ? mergedAttrs : _setStrokeFillOpacity(mergedAttrs);
	    },
	
	    /**
	     * Transforms an array of svg elements to corresponding fabric.* instances
	     * @static
	     * @memberOf fabric
	     * @param {Array} elements Array of elements to parse
	     * @param {Function} callback Being passed an array of fabric instances (transformed from SVG elements)
	     * @param {Object} [options] Options object
	     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
	     */
	    parseElements: function(elements, callback, options, reviver, parsingOptions) {
	      new fabric.ElementsParser(elements, callback, options, reviver, parsingOptions).parse();
	    },
	
	    /**
	     * Parses "style" attribute, retuning an object with values
	     * @static
	     * @memberOf fabric
	     * @param {SVGElement} element Element to parse
	     * @return {Object} Objects with values parsed from style attribute of an element
	     */
	    parseStyleAttribute: function(element) {
	      var oStyle = { },
	          style = element.getAttribute('style');
	
	      if (!style) {
	        return oStyle;
	      }
	
	      if (typeof style === 'string') {
	        parseStyleString(style, oStyle);
	      }
	      else {
	        parseStyleObject(style, oStyle);
	      }
	
	      return oStyle;
	    },
	
	    /**
	     * Parses "points" attribute, returning an array of values
	     * @static
	     * @memberOf fabric
	     * @param {String} points points attribute string
	     * @return {Array} array of points
	     */
	    parsePointsAttribute: function(points) {
	
	      // points attribute is required and must not be empty
	      if (!points) {
	        return null;
	      }
	
	      // replace commas with whitespace and remove bookending whitespace
	      points = points.replace(/,/g, ' ').trim();
	
	      points = points.split(/\s+/);
	      var parsedPoints = [], i, len;
	
	      for (i = 0, len = points.length; i < len; i += 2) {
	        parsedPoints.push({
	          x: parseFloat(points[i]),
	          y: parseFloat(points[i + 1])
	        });
	      }
	
	      // odd number of points is an error
	      // if (parsedPoints.length % 2 !== 0) {
	      //   return null;
	      // }
	
	      return parsedPoints;
	    },
	
	    /**
	     * Returns CSS rules for a given SVG document
	     * @static
	     * @function
	     * @memberOf fabric
	     * @param {SVGDocument} doc SVG document to parse
	     * @return {Object} CSS rules of this document
	     */
	    getCSSRules: function(doc) {
	      var styles = doc.getElementsByTagName('style'), i, len,
	          allRules = { }, rules;
	
	      // very crude parsing of style contents
	      for (i = 0, len = styles.length; i < len; i++) {
	        // IE9 doesn't support textContent, but provides text instead.
	        var styleContents = styles[i].textContent || styles[i].text;
	
	        // remove comments
	        styleContents = styleContents.replace(/\/\*[\s\S]*?\*\//g, '');
	        if (styleContents.trim() === '') {
	          continue;
	        }
	        rules = styleContents.match(/[^{]*\{[\s\S]*?\}/g);
	        rules = rules.map(function(rule) { return rule.trim(); });
	        // eslint-disable-next-line no-loop-func
	        rules.forEach(function(rule) {
	
	          var match = rule.match(/([\s\S]*?)\s*\{([^}]*)\}/),
	              ruleObj = { }, declaration = match[2].trim(),
	              propertyValuePairs = declaration.replace(/;$/, '').split(/\s*;\s*/);
	
	          for (i = 0, len = propertyValuePairs.length; i < len; i++) {
	            var pair = propertyValuePairs[i].split(/\s*:\s*/),
	                property = pair[0],
	                value = pair[1];
	            ruleObj[property] = value;
	          }
	          rule = match[1];
	          rule.split(',').forEach(function(_rule) {
	            _rule = _rule.replace(/^svg/i, '').trim();
	            if (_rule === '') {
	              return;
	            }
	            if (allRules[_rule]) {
	              fabric.util.object.extend(allRules[_rule], ruleObj);
	            }
	            else {
	              allRules[_rule] = fabric.util.object.clone(ruleObj);
	            }
	          });
	        });
	      }
	      return allRules;
	    },
	
	    /**
	     * Takes url corresponding to an SVG document, and parses it into a set of fabric objects.
	     * Note that SVG is fetched via XMLHttpRequest, so it needs to conform to SOP (Same Origin Policy)
	     * @memberOf fabric
	     * @param {String} url
	     * @param {Function} callback
	     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
	     * @param {Object} [options] Object containing options for parsing
	     * @param {String} [options.crossOrigin] crossOrigin crossOrigin setting to use for external resources
	     */
	    loadSVGFromURL: function(url, callback, reviver, options) {
	
	      url = url.replace(/^\n\s*/, '').trim();
	      new fabric.util.request(url, {
	        method: 'get',
	        onComplete: onComplete
	      });
	
	      function onComplete(r) {
	
	        var xml = r.responseXML;
	        if (xml && !xml.documentElement && fabric.window.ActiveXObject && r.responseText) {
	          xml = new ActiveXObject('Microsoft.XMLDOM');
	          xml.async = 'false';
	          //IE chokes on DOCTYPE
	          xml.loadXML(r.responseText.replace(/<!DOCTYPE[\s\S]*?(\[[\s\S]*\])*?>/i, ''));
	        }
	        if (!xml || !xml.documentElement) {
	          callback && callback(null);
	          return false;
	        }
	
	        fabric.parseSVGDocument(xml.documentElement, function (results, _options, elements, allElements) {
	          callback && callback(results, _options, elements, allElements);
	        }, reviver, options);
	      }
	    },
	
	    /**
	     * Takes string corresponding to an SVG document, and parses it into a set of fabric objects
	     * @memberOf fabric
	     * @param {String} string
	     * @param {Function} callback
	     * @param {Function} [reviver] Method for further parsing of SVG elements, called after each fabric object created.
	     * @param {Object} [options] Object containing options for parsing
	     * @param {String} [options.crossOrigin] crossOrigin crossOrigin setting to use for external resources
	     */
	    loadSVGFromString: function(string, callback, reviver, options) {
	      string = string.trim();
	      var doc;
	      if (typeof fabric.window.DOMParser !== 'undefined') {
	        var parser = new fabric.window.DOMParser();
	        if (parser && parser.parseFromString) {
	          doc = parser.parseFromString(string, 'text/xml');
	        }
	      }
	      else if (fabric.window.ActiveXObject) {
	        doc = new ActiveXObject('Microsoft.XMLDOM');
	        doc.async = 'false';
	        // IE chokes on DOCTYPE
	        doc.loadXML(string.replace(/<!DOCTYPE[\s\S]*?(\[[\s\S]*\])*?>/i, ''));
	      }
	
	      fabric.parseSVGDocument(doc.documentElement, function (results, _options, elements, allElements) {
	        callback(results, _options, elements, allElements);
	      }, reviver, options);
	    }
	  });
	
	})( true ? exports : this);
	
	
	fabric.ElementsParser = function(elements, callback, options, reviver, parsingOptions) {
	  this.elements = elements;
	  this.callback = callback;
	  this.options = options;
	  this.reviver = reviver;
	  this.svgUid = (options && options.svgUid) || 0;
	  this.parsingOptions = parsingOptions;
	  this.regexUrl = /^url\(['"]?#([^'"]+)['"]?\)/g;
	};
	
	(function(proto) {
	  proto.parse = function() {
	    this.instances = new Array(this.elements.length);
	    this.numElements = this.elements.length;
	    this.createObjects();
	  };
	
	  proto.createObjects = function() {
	    var _this = this;
	    this.elements.forEach(function(element, i) {
	      element.setAttribute('svgUid', _this.svgUid);
	      _this.createObject(element, i);
	    });
	  };
	
	  proto.findTag = function(el) {
	    return fabric[fabric.util.string.capitalize(el.tagName.replace('svg:', ''))];
	  };
	
	  proto.createObject = function(el, index) {
	    var klass = this.findTag(el);
	    if (klass && klass.fromElement) {
	      try {
	        klass.fromElement(el, this.createCallback(index, el), this.options);
	      }
	      catch (err) {
	        fabric.log(err);
	      }
	    }
	    else {
	      this.checkIfDone();
	    }
	  };
	
	  proto.createCallback = function(index, el) {
	    var _this = this;
	    return function(obj) {
	      var _options;
	      _this.resolveGradient(obj, 'fill');
	      _this.resolveGradient(obj, 'stroke');
	      if (obj instanceof fabric.Image && obj._originalElement) {
	        _options = obj.parsePreserveAspectRatioAttribute(el);
	      }
	      obj._removeTransformMatrix(_options);
	      _this.resolveClipPath(obj);
	      _this.reviver && _this.reviver(el, obj);
	      _this.instances[index] = obj;
	      _this.checkIfDone();
	    };
	  };
	
	  proto.extractPropertyDefinition = function(obj, property, storage) {
	    var value = obj[property];
	    if (!(/^url\(/).test(value)) {
	      return;
	    }
	    var id = this.regexUrl.exec(value)[1];
	    this.regexUrl.lastIndex = 0;
	    return fabric[storage][this.svgUid][id];
	  };
	
	  proto.resolveGradient = function(obj, property) {
	    var gradientDef = this.extractPropertyDefinition(obj, property, 'gradientDefs');
	    if (gradientDef) {
	      obj.set(property, fabric.Gradient.fromElement(gradientDef, obj));
	    }
	  };
	
	  proto.createClipPathCallback = function(obj, container) {
	    return function(_newObj) {
	      _newObj._removeTransformMatrix();
	      _newObj.fillRule = _newObj.clipRule;
	      container.push(_newObj);
	    };
	  };
	
	  proto.resolveClipPath = function(obj) {
	    var clipPath = this.extractPropertyDefinition(obj, 'clipPath', 'clipPaths'),
	        element, klass, objTransformInv, container, gTransform, options;
	    if (clipPath) {
	      container = [];
	      objTransformInv = fabric.util.invertTransform(obj.calcTransformMatrix());
	      for (var i = 0; i < clipPath.length; i++) {
	        element = clipPath[i];
	        klass = this.findTag(element);
	        klass.fromElement(
	          element,
	          this.createClipPathCallback(obj, container),
	          this.options
	        );
	      }
	      if (container.length === 1) {
	        clipPath = container[0];
	      }
	      else {
	        clipPath = new fabric.Group(container);
	      }
	      gTransform = fabric.util.multiplyTransformMatrices(
	        objTransformInv,
	        clipPath.calcTransformMatrix()
	      );
	      var options = fabric.util.qrDecompose(gTransform);
	      clipPath.flipX = false;
	      clipPath.flipY = false;
	      clipPath.set('scaleX', options.scaleX);
	      clipPath.set('scaleY', options.scaleY);
	      clipPath.angle = options.angle;
	      clipPath.skewX = options.skewX;
	      clipPath.skewY = 0;
	      clipPath.setPositionByOrigin({ x: options.translateX, y: options.translateY }, 'center', 'center');
	      obj.clipPath = clipPath;
	    }
	  };
	
	  proto.checkIfDone = function() {
	    if (--this.numElements === 0) {
	      this.instances = this.instances.filter(function(el) {
	        // eslint-disable-next-line no-eq-null, eqeqeq
	        return el != null;
	      });
	      this.callback(this.instances, this.elements);
	    }
	  };
	})(fabric.ElementsParser.prototype);
	
	
	(function(global) {
	
	  'use strict';
	
	  /* Adaptation of work of Kevin Lindsey (kevin@kevlindev.com) */
	
	  var fabric = global.fabric || (global.fabric = { });
	
	  if (fabric.Point) {
	    fabric.warn('fabric.Point is already defined');
	    return;
	  }
	
	  fabric.Point = Point;
	
	  /**
	   * Point class
	   * @class fabric.Point
	   * @memberOf fabric
	   * @constructor
	   * @param {Number} x
	   * @param {Number} y
	   * @return {fabric.Point} thisArg
	   */
	  function Point(x, y) {
	    this.x = x;
	    this.y = y;
	  }
	
	  Point.prototype = /** @lends fabric.Point.prototype */ {
	
	    type: 'point',
	
	    constructor: Point,
	
	    /**
	     * Adds another point to this one and returns another one
	     * @param {fabric.Point} that
	     * @return {fabric.Point} new Point instance with added values
	     */
	    add: function (that) {
	      return new Point(this.x + that.x, this.y + that.y);
	    },
	
	    /**
	     * Adds another point to this one
	     * @param {fabric.Point} that
	     * @return {fabric.Point} thisArg
	     * @chainable
	     */
	    addEquals: function (that) {
	      this.x += that.x;
	      this.y += that.y;
	      return this;
	    },
	
	    /**
	     * Adds value to this point and returns a new one
	     * @param {Number} scalar
	     * @return {fabric.Point} new Point with added value
	     */
	    scalarAdd: function (scalar) {
	      return new Point(this.x + scalar, this.y + scalar);
	    },
	
	    /**
	     * Adds value to this point
	     * @param {Number} scalar
	     * @return {fabric.Point} thisArg
	     * @chainable
	     */
	    scalarAddEquals: function (scalar) {
	      this.x += scalar;
	      this.y += scalar;
	      return this;
	    },
	
	    /**
	     * Subtracts another point from this point and returns a new one
	     * @param {fabric.Point} that
	     * @return {fabric.Point} new Point object with subtracted values
	     */
	    subtract: function (that) {
	      return new Point(this.x - that.x, this.y - that.y);
	    },
	
	    /**
	     * Subtracts another point from this point
	     * @param {fabric.Point} that
	     * @return {fabric.Point} thisArg
	     * @chainable
	     */
	    subtractEquals: function (that) {
	      this.x -= that.x;
	      this.y -= that.y;
	      return this;
	    },
	
	    /**
	     * Subtracts value from this point and returns a new one
	     * @param {Number} scalar
	     * @return {fabric.Point}
	     */
	    scalarSubtract: function (scalar) {
	      return new Point(this.x - scalar, this.y - scalar);
	    },
	
	    /**
	     * Subtracts value from this point
	     * @param {Number} scalar
	     * @return {fabric.Point} thisArg
	     * @chainable
	     */
	    scalarSubtractEquals: function (scalar) {
	      this.x -= scalar;
	      this.y -= scalar;
	      return this;
	    },
	
	    /**
	     * Multiplies this point by a value and returns a new one
	     * TODO: rename in scalarMultiply in 2.0
	     * @param {Number} scalar
	     * @return {fabric.Point}
	     */
	    multiply: function (scalar) {
	      return new Point(this.x * scalar, this.y * scalar);
	    },
	
	    /**
	     * Multiplies this point by a value
	     * TODO: rename in scalarMultiplyEquals in 2.0
	     * @param {Number} scalar
	     * @return {fabric.Point} thisArg
	     * @chainable
	     */
	    multiplyEquals: function (scalar) {
	      this.x *= scalar;
	      this.y *= scalar;
	      return this;
	    },
	
	    /**
	     * Divides this point by a value and returns a new one
	     * TODO: rename in scalarDivide in 2.0
	     * @param {Number} scalar
	     * @return {fabric.Point}
	     */
	    divide: function (scalar) {
	      return new Point(this.x / scalar, this.y / scalar);
	    },
	
	    /**
	     * Divides this point by a value
	     * TODO: rename in scalarDivideEquals in 2.0
	     * @param {Number} scalar
	     * @return {fabric.Point} thisArg
	     * @chainable
	     */
	    divideEquals: function (scalar) {
	      this.x /= scalar;
	      this.y /= scalar;
	      return this;
	    },
	
	    /**
	     * Returns true if this point is equal to another one
	     * @param {fabric.Point} that
	     * @return {Boolean}
	     */
	    eq: function (that) {
	      return (this.x === that.x && this.y === that.y);
	    },
	
	    /**
	     * Returns true if this point is less than another one
	     * @param {fabric.Point} that
	     * @return {Boolean}
	     */
	    lt: function (that) {
	      return (this.x < that.x && this.y < that.y);
	    },
	
	    /**
	     * Returns true if this point is less than or equal to another one
	     * @param {fabric.Point} that
	     * @return {Boolean}
	     */
	    lte: function (that) {
	      return (this.x <= that.x && this.y <= that.y);
	    },
	
	    /**
	
	     * Returns true if this point is greater another one
	     * @param {fabric.Point} that
	     * @return {Boolean}
	     */
	    gt: function (that) {
	      return (this.x > that.x && this.y > that.y);
	    },
	
	    /**
	     * Returns true if this point is greater than or equal to another one
	     * @param {fabric.Point} that
	     * @return {Boolean}
	     */
	    gte: function (that) {
	      return (this.x >= that.x && this.y >= that.y);
	    },
	
	    /**
	     * Returns new point which is the result of linear interpolation with this one and another one
	     * @param {fabric.Point} that
	     * @param {Number} t , position of interpolation, between 0 and 1 default 0.5
	     * @return {fabric.Point}
	     */
	    lerp: function (that, t) {
	      if (typeof t === 'undefined') {
	        t = 0.5;
	      }
	      t = Math.max(Math.min(1, t), 0);
	      return new Point(this.x + (that.x - this.x) * t, this.y + (that.y - this.y) * t);
	    },
	
	    /**
	     * Returns distance from this point and another one
	     * @param {fabric.Point} that
	     * @return {Number}
	     */
	    distanceFrom: function (that) {
	      var dx = this.x - that.x,
	          dy = this.y - that.y;
	      return Math.sqrt(dx * dx + dy * dy);
	    },
	
	    /**
	     * Returns the point between this point and another one
	     * @param {fabric.Point} that
	     * @return {fabric.Point}
	     */
	    midPointFrom: function (that) {
	      return this.lerp(that);
	    },
	
	    /**
	     * Returns a new point which is the min of this and another one
	     * @param {fabric.Point} that
	     * @return {fabric.Point}
	     */
	    min: function (that) {
	      return new Point(Math.min(this.x, that.x), Math.min(this.y, that.y));
	    },
	
	    /**
	     * Returns a new point which is the max of this and another one
	     * @param {fabric.Point} that
	     * @return {fabric.Point}
	     */
	    max: function (that) {
	      return new Point(Math.max(this.x, that.x), Math.max(this.y, that.y));
	    },
	
	    /**
	     * Returns string representation of this point
	     * @return {String}
	     */
	    toString: function () {
	      return this.x + ',' + this.y;
	    },
	
	    /**
	     * Sets x/y of this point
	     * @param {Number} x
	     * @param {Number} y
	     * @chainable
	     */
	    setXY: function (x, y) {
	      this.x = x;
	      this.y = y;
	      return this;
	    },
	
	    /**
	     * Sets x of this point
	     * @param {Number} x
	     * @chainable
	     */
	    setX: function (x) {
	      this.x = x;
	      return this;
	    },
	
	    /**
	     * Sets y of this point
	     * @param {Number} y
	     * @chainable
	     */
	    setY: function (y) {
	      this.y = y;
	      return this;
	    },
	
	    /**
	     * Sets x/y of this point from another point
	     * @param {fabric.Point} that
	     * @chainable
	     */
	    setFromPoint: function (that) {
	      this.x = that.x;
	      this.y = that.y;
	      return this;
	    },
	
	    /**
	     * Swaps x/y of this point and another point
	     * @param {fabric.Point} that
	     */
	    swap: function (that) {
	      var x = this.x,
	          y = this.y;
	      this.x = that.x;
	      this.y = that.y;
	      that.x = x;
	      that.y = y;
	    },
	
	    /**
	     * return a cloned instance of the point
	     * @return {fabric.Point}
	     */
	    clone: function () {
	      return new Point(this.x, this.y);
	    }
	  };
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  /* Adaptation of work of Kevin Lindsey (kevin@kevlindev.com) */
	  var fabric = global.fabric || (global.fabric = { });
	
	  if (fabric.Intersection) {
	    fabric.warn('fabric.Intersection is already defined');
	    return;
	  }
	
	  /**
	   * Intersection class
	   * @class fabric.Intersection
	   * @memberOf fabric
	   * @constructor
	   */
	  function Intersection(status) {
	    this.status = status;
	    this.points = [];
	  }
	
	  fabric.Intersection = Intersection;
	
	  fabric.Intersection.prototype = /** @lends fabric.Intersection.prototype */ {
	
	    constructor: Intersection,
	
	    /**
	     * Appends a point to intersection
	     * @param {fabric.Point} point
	     * @return {fabric.Intersection} thisArg
	     * @chainable
	     */
	    appendPoint: function (point) {
	      this.points.push(point);
	      return this;
	    },
	
	    /**
	     * Appends points to intersection
	     * @param {Array} points
	     * @return {fabric.Intersection} thisArg
	     * @chainable
	     */
	    appendPoints: function (points) {
	      this.points = this.points.concat(points);
	      return this;
	    }
	  };
	
	  /**
	   * Checks if one line intersects another
	   * TODO: rename in intersectSegmentSegment
	   * @static
	   * @param {fabric.Point} a1
	   * @param {fabric.Point} a2
	   * @param {fabric.Point} b1
	   * @param {fabric.Point} b2
	   * @return {fabric.Intersection}
	   */
	  fabric.Intersection.intersectLineLine = function (a1, a2, b1, b2) {
	    var result,
	        uaT = (b2.x - b1.x) * (a1.y - b1.y) - (b2.y - b1.y) * (a1.x - b1.x),
	        ubT = (a2.x - a1.x) * (a1.y - b1.y) - (a2.y - a1.y) * (a1.x - b1.x),
	        uB = (b2.y - b1.y) * (a2.x - a1.x) - (b2.x - b1.x) * (a2.y - a1.y);
	    if (uB !== 0) {
	      var ua = uaT / uB,
	          ub = ubT / uB;
	      if (0 <= ua && ua <= 1 && 0 <= ub && ub <= 1) {
	        result = new Intersection('Intersection');
	        result.appendPoint(new fabric.Point(a1.x + ua * (a2.x - a1.x), a1.y + ua * (a2.y - a1.y)));
	      }
	      else {
	        result = new Intersection();
	      }
	    }
	    else {
	      if (uaT === 0 || ubT === 0) {
	        result = new Intersection('Coincident');
	      }
	      else {
	        result = new Intersection('Parallel');
	      }
	    }
	    return result;
	  };
	
	  /**
	   * Checks if line intersects polygon
	   * TODO: rename in intersectSegmentPolygon
	   * fix detection of coincident
	   * @static
	   * @param {fabric.Point} a1
	   * @param {fabric.Point} a2
	   * @param {Array} points
	   * @return {fabric.Intersection}
	   */
	  fabric.Intersection.intersectLinePolygon = function(a1, a2, points) {
	    var result = new Intersection(),
	        length = points.length,
	        b1, b2, inter, i;
	
	    for (i = 0; i < length; i++) {
	      b1 = points[i];
	      b2 = points[(i + 1) % length];
	      inter = Intersection.intersectLineLine(a1, a2, b1, b2);
	
	      result.appendPoints(inter.points);
	    }
	    if (result.points.length > 0) {
	      result.status = 'Intersection';
	    }
	    return result;
	  };
	
	  /**
	   * Checks if polygon intersects another polygon
	   * @static
	   * @param {Array} points1
	   * @param {Array} points2
	   * @return {fabric.Intersection}
	   */
	  fabric.Intersection.intersectPolygonPolygon = function (points1, points2) {
	    var result = new Intersection(),
	        length = points1.length, i;
	
	    for (i = 0; i < length; i++) {
	      var a1 = points1[i],
	          a2 = points1[(i + 1) % length],
	          inter = Intersection.intersectLinePolygon(a1, a2, points2);
	
	      result.appendPoints(inter.points);
	    }
	    if (result.points.length > 0) {
	      result.status = 'Intersection';
	    }
	    return result;
	  };
	
	  /**
	   * Checks if polygon intersects rectangle
	   * @static
	   * @param {Array} points
	   * @param {fabric.Point} r1
	   * @param {fabric.Point} r2
	   * @return {fabric.Intersection}
	   */
	  fabric.Intersection.intersectPolygonRectangle = function (points, r1, r2) {
	    var min = r1.min(r2),
	        max = r1.max(r2),
	        topRight = new fabric.Point(max.x, min.y),
	        bottomLeft = new fabric.Point(min.x, max.y),
	        inter1 = Intersection.intersectLinePolygon(min, topRight, points),
	        inter2 = Intersection.intersectLinePolygon(topRight, max, points),
	        inter3 = Intersection.intersectLinePolygon(max, bottomLeft, points),
	        inter4 = Intersection.intersectLinePolygon(bottomLeft, min, points),
	        result = new Intersection();
	
	    result.appendPoints(inter1.points);
	    result.appendPoints(inter2.points);
	    result.appendPoints(inter3.points);
	    result.appendPoints(inter4.points);
	
	    if (result.points.length > 0) {
	      result.status = 'Intersection';
	    }
	    return result;
	  };
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric = global.fabric || (global.fabric = { });
	
	  if (fabric.Color) {
	    fabric.warn('fabric.Color is already defined.');
	    return;
	  }
	
	  /**
	   * Color class
	   * The purpose of {@link fabric.Color} is to abstract and encapsulate common color operations;
	   * {@link fabric.Color} is a constructor and creates instances of {@link fabric.Color} objects.
	   *
	   * @class fabric.Color
	   * @param {String} color optional in hex or rgb(a) or hsl format or from known color list
	   * @return {fabric.Color} thisArg
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2/#colors}
	   */
	  function Color(color) {
	    if (!color) {
	      this.setSource([0, 0, 0, 1]);
	    }
	    else {
	      this._tryParsingColor(color);
	    }
	  }
	
	  fabric.Color = Color;
	
	  fabric.Color.prototype = /** @lends fabric.Color.prototype */ {
	
	    /**
	     * @private
	     * @param {String|Array} color Color value to parse
	     */
	    _tryParsingColor: function(color) {
	      var source;
	
	      if (color in Color.colorNameMap) {
	        color = Color.colorNameMap[color];
	      }
	
	      if (color === 'transparent') {
	        source = [255, 255, 255, 0];
	      }
	
	      if (!source) {
	        source = Color.sourceFromHex(color);
	      }
	      if (!source) {
	        source = Color.sourceFromRgb(color);
	      }
	      if (!source) {
	        source = Color.sourceFromHsl(color);
	      }
	      if (!source) {
	        //if color is not recognize let's make black as canvas does
	        source = [0, 0, 0, 1];
	      }
	      if (source) {
	        this.setSource(source);
	      }
	    },
	
	    /**
	     * Adapted from <a href="https://rawgithub.com/mjijackson/mjijackson.github.com/master/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript.html">https://github.com/mjijackson</a>
	     * @private
	     * @param {Number} r Red color value
	     * @param {Number} g Green color value
	     * @param {Number} b Blue color value
	     * @return {Array} Hsl color
	     */
	    _rgbToHsl: function(r, g, b) {
	      r /= 255; g /= 255; b /= 255;
	
	      var h, s, l,
	          max = fabric.util.array.max([r, g, b]),
	          min = fabric.util.array.min([r, g, b]);
	
	      l = (max + min) / 2;
	
	      if (max === min) {
	        h = s = 0; // achromatic
	      }
	      else {
	        var d = max - min;
	        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	        switch (max) {
	          case r:
	            h = (g - b) / d + (g < b ? 6 : 0);
	            break;
	          case g:
	            h = (b - r) / d + 2;
	            break;
	          case b:
	            h = (r - g) / d + 4;
	            break;
	        }
	        h /= 6;
	      }
	
	      return [
	        Math.round(h * 360),
	        Math.round(s * 100),
	        Math.round(l * 100)
	      ];
	    },
	
	    /**
	     * Returns source of this color (where source is an array representation; ex: [200, 200, 100, 1])
	     * @return {Array}
	     */
	    getSource: function() {
	      return this._source;
	    },
	
	    /**
	     * Sets source of this color (where source is an array representation; ex: [200, 200, 100, 1])
	     * @param {Array} source
	     */
	    setSource: function(source) {
	      this._source = source;
	    },
	
	    /**
	     * Returns color representation in RGB format
	     * @return {String} ex: rgb(0-255,0-255,0-255)
	     */
	    toRgb: function() {
	      var source = this.getSource();
	      return 'rgb(' + source[0] + ',' + source[1] + ',' + source[2] + ')';
	    },
	
	    /**
	     * Returns color representation in RGBA format
	     * @return {String} ex: rgba(0-255,0-255,0-255,0-1)
	     */
	    toRgba: function() {
	      var source = this.getSource();
	      return 'rgba(' + source[0] + ',' + source[1] + ',' + source[2] + ',' + source[3] + ')';
	    },
	
	    /**
	     * Returns color representation in HSL format
	     * @return {String} ex: hsl(0-360,0%-100%,0%-100%)
	     */
	    toHsl: function() {
	      var source = this.getSource(),
	          hsl = this._rgbToHsl(source[0], source[1], source[2]);
	
	      return 'hsl(' + hsl[0] + ',' + hsl[1] + '%,' + hsl[2] + '%)';
	    },
	
	    /**
	     * Returns color representation in HSLA format
	     * @return {String} ex: hsla(0-360,0%-100%,0%-100%,0-1)
	     */
	    toHsla: function() {
	      var source = this.getSource(),
	          hsl = this._rgbToHsl(source[0], source[1], source[2]);
	
	      return 'hsla(' + hsl[0] + ',' + hsl[1] + '%,' + hsl[2] + '%,' + source[3] + ')';
	    },
	
	    /**
	     * Returns color representation in HEX format
	     * @return {String} ex: FF5555
	     */
	    toHex: function() {
	      var source = this.getSource(), r, g, b;
	
	      r = source[0].toString(16);
	      r = (r.length === 1) ? ('0' + r) : r;
	
	      g = source[1].toString(16);
	      g = (g.length === 1) ? ('0' + g) : g;
	
	      b = source[2].toString(16);
	      b = (b.length === 1) ? ('0' + b) : b;
	
	      return r.toUpperCase() + g.toUpperCase() + b.toUpperCase();
	    },
	
	    /**
	     * Returns color representation in HEXA format
	     * @return {String} ex: FF5555CC
	     */
	    toHexa: function() {
	      var source = this.getSource(), a;
	
	      a = Math.round(source[3] * 255);
	      a = a.toString(16);
	      a = (a.length === 1) ? ('0' + a) : a;
	
	      return this.toHex() + a.toUpperCase();
	    },
	
	    /**
	     * Gets value of alpha channel for this color
	     * @return {Number} 0-1
	     */
	    getAlpha: function() {
	      return this.getSource()[3];
	    },
	
	    /**
	     * Sets value of alpha channel for this color
	     * @param {Number} alpha Alpha value 0-1
	     * @return {fabric.Color} thisArg
	     */
	    setAlpha: function(alpha) {
	      var source = this.getSource();
	      source[3] = alpha;
	      this.setSource(source);
	      return this;
	    },
	
	    /**
	     * Transforms color to its grayscale representation
	     * @return {fabric.Color} thisArg
	     */
	    toGrayscale: function() {
	      var source = this.getSource(),
	          average = parseInt((source[0] * 0.3 + source[1] * 0.59 + source[2] * 0.11).toFixed(0), 10),
	          currentAlpha = source[3];
	      this.setSource([average, average, average, currentAlpha]);
	      return this;
	    },
	
	    /**
	     * Transforms color to its black and white representation
	     * @param {Number} threshold
	     * @return {fabric.Color} thisArg
	     */
	    toBlackWhite: function(threshold) {
	      var source = this.getSource(),
	          average = (source[0] * 0.3 + source[1] * 0.59 + source[2] * 0.11).toFixed(0),
	          currentAlpha = source[3];
	
	      threshold = threshold || 127;
	
	      average = (Number(average) < Number(threshold)) ? 0 : 255;
	      this.setSource([average, average, average, currentAlpha]);
	      return this;
	    },
	
	    /**
	     * Overlays color with another color
	     * @param {String|fabric.Color} otherColor
	     * @return {fabric.Color} thisArg
	     */
	    overlayWith: function(otherColor) {
	      if (!(otherColor instanceof Color)) {
	        otherColor = new Color(otherColor);
	      }
	
	      var result = [],
	          alpha = this.getAlpha(),
	          otherAlpha = 0.5,
	          source = this.getSource(),
	          otherSource = otherColor.getSource(), i;
	
	      for (i = 0; i < 3; i++) {
	        result.push(Math.round((source[i] * (1 - otherAlpha)) + (otherSource[i] * otherAlpha)));
	      }
	
	      result[3] = alpha;
	      this.setSource(result);
	      return this;
	    }
	  };
	
	  /**
	   * Regex matching color in RGB or RGBA formats (ex: rgb(0, 0, 0), rgba(255, 100, 10, 0.5), rgba( 255 , 100 , 10 , 0.5 ), rgb(1,1,1), rgba(100%, 60%, 10%, 0.5))
	   * @static
	   * @field
	   * @memberOf fabric.Color
	   */
	  // eslint-disable-next-line max-len
	  fabric.Color.reRGBa = /^rgba?\(\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*(?:\s*,\s*((?:\d*\.?\d+)?)\s*)?\)$/i;
	
	  /**
	   * Regex matching color in HSL or HSLA formats (ex: hsl(200, 80%, 10%), hsla(300, 50%, 80%, 0.5), hsla( 300 , 50% , 80% , 0.5 ))
	   * @static
	   * @field
	   * @memberOf fabric.Color
	   */
	  fabric.Color.reHSLa = /^hsla?\(\s*(\d{1,3})\s*,\s*(\d{1,3}\%)\s*,\s*(\d{1,3}\%)\s*(?:\s*,\s*(\d+(?:\.\d+)?)\s*)?\)$/i;
	
	  /**
	   * Regex matching color in HEX format (ex: #FF5544CC, #FF5555, 010155, aff)
	   * @static
	   * @field
	   * @memberOf fabric.Color
	   */
	  fabric.Color.reHex = /^#?([0-9a-f]{8}|[0-9a-f]{6}|[0-9a-f]{4}|[0-9a-f]{3})$/i;
	
	  /**
	   * Map of the 148 color names with HEX code
	   * @static
	   * @field
	   * @memberOf fabric.Color
	   * @see: https://www.w3.org/TR/css3-color/#svg-color
	   */
	  fabric.Color.colorNameMap = {
	    aliceblue:            '#F0F8FF',
	    antiquewhite:         '#FAEBD7',
	    aqua:                 '#00FFFF',
	    aquamarine:           '#7FFFD4',
	    azure:                '#F0FFFF',
	    beige:                '#F5F5DC',
	    bisque:               '#FFE4C4',
	    black:                '#000000',
	    blanchedalmond:       '#FFEBCD',
	    blue:                 '#0000FF',
	    blueviolet:           '#8A2BE2',
	    brown:                '#A52A2A',
	    burlywood:            '#DEB887',
	    cadetblue:            '#5F9EA0',
	    chartreuse:           '#7FFF00',
	    chocolate:            '#D2691E',
	    coral:                '#FF7F50',
	    cornflowerblue:       '#6495ED',
	    cornsilk:             '#FFF8DC',
	    crimson:              '#DC143C',
	    cyan:                 '#00FFFF',
	    darkblue:             '#00008B',
	    darkcyan:             '#008B8B',
	    darkgoldenrod:        '#B8860B',
	    darkgray:             '#A9A9A9',
	    darkgrey:             '#A9A9A9',
	    darkgreen:            '#006400',
	    darkkhaki:            '#BDB76B',
	    darkmagenta:          '#8B008B',
	    darkolivegreen:       '#556B2F',
	    darkorange:           '#FF8C00',
	    darkorchid:           '#9932CC',
	    darkred:              '#8B0000',
	    darksalmon:           '#E9967A',
	    darkseagreen:         '#8FBC8F',
	    darkslateblue:        '#483D8B',
	    darkslategray:        '#2F4F4F',
	    darkslategrey:        '#2F4F4F',
	    darkturquoise:        '#00CED1',
	    darkviolet:           '#9400D3',
	    deeppink:             '#FF1493',
	    deepskyblue:          '#00BFFF',
	    dimgray:              '#696969',
	    dimgrey:              '#696969',
	    dodgerblue:           '#1E90FF',
	    firebrick:            '#B22222',
	    floralwhite:          '#FFFAF0',
	    forestgreen:          '#228B22',
	    fuchsia:              '#FF00FF',
	    gainsboro:            '#DCDCDC',
	    ghostwhite:           '#F8F8FF',
	    gold:                 '#FFD700',
	    goldenrod:            '#DAA520',
	    gray:                 '#808080',
	    grey:                 '#808080',
	    green:                '#008000',
	    greenyellow:          '#ADFF2F',
	    honeydew:             '#F0FFF0',
	    hotpink:              '#FF69B4',
	    indianred:            '#CD5C5C',
	    indigo:               '#4B0082',
	    ivory:                '#FFFFF0',
	    khaki:                '#F0E68C',
	    lavender:             '#E6E6FA',
	    lavenderblush:        '#FFF0F5',
	    lawngreen:            '#7CFC00',
	    lemonchiffon:         '#FFFACD',
	    lightblue:            '#ADD8E6',
	    lightcoral:           '#F08080',
	    lightcyan:            '#E0FFFF',
	    lightgoldenrodyellow: '#FAFAD2',
	    lightgray:            '#D3D3D3',
	    lightgrey:            '#D3D3D3',
	    lightgreen:           '#90EE90',
	    lightpink:            '#FFB6C1',
	    lightsalmon:          '#FFA07A',
	    lightseagreen:        '#20B2AA',
	    lightskyblue:         '#87CEFA',
	    lightslategray:       '#778899',
	    lightslategrey:       '#778899',
	    lightsteelblue:       '#B0C4DE',
	    lightyellow:          '#FFFFE0',
	    lime:                 '#00FF00',
	    limegreen:            '#32CD32',
	    linen:                '#FAF0E6',
	    magenta:              '#FF00FF',
	    maroon:               '#800000',
	    mediumaquamarine:     '#66CDAA',
	    mediumblue:           '#0000CD',
	    mediumorchid:         '#BA55D3',
	    mediumpurple:         '#9370DB',
	    mediumseagreen:       '#3CB371',
	    mediumslateblue:      '#7B68EE',
	    mediumspringgreen:    '#00FA9A',
	    mediumturquoise:      '#48D1CC',
	    mediumvioletred:      '#C71585',
	    midnightblue:         '#191970',
	    mintcream:            '#F5FFFA',
	    mistyrose:            '#FFE4E1',
	    moccasin:             '#FFE4B5',
	    navajowhite:          '#FFDEAD',
	    navy:                 '#000080',
	    oldlace:              '#FDF5E6',
	    olive:                '#808000',
	    olivedrab:            '#6B8E23',
	    orange:               '#FFA500',
	    orangered:            '#FF4500',
	    orchid:               '#DA70D6',
	    palegoldenrod:        '#EEE8AA',
	    palegreen:            '#98FB98',
	    paleturquoise:        '#AFEEEE',
	    palevioletred:        '#DB7093',
	    papayawhip:           '#FFEFD5',
	    peachpuff:            '#FFDAB9',
	    peru:                 '#CD853F',
	    pink:                 '#FFC0CB',
	    plum:                 '#DDA0DD',
	    powderblue:           '#B0E0E6',
	    purple:               '#800080',
	    rebeccapurple:        '#663399',
	    red:                  '#FF0000',
	    rosybrown:            '#BC8F8F',
	    royalblue:            '#4169E1',
	    saddlebrown:          '#8B4513',
	    salmon:               '#FA8072',
	    sandybrown:           '#F4A460',
	    seagreen:             '#2E8B57',
	    seashell:             '#FFF5EE',
	    sienna:               '#A0522D',
	    silver:               '#C0C0C0',
	    skyblue:              '#87CEEB',
	    slateblue:            '#6A5ACD',
	    slategray:            '#708090',
	    slategrey:            '#708090',
	    snow:                 '#FFFAFA',
	    springgreen:          '#00FF7F',
	    steelblue:            '#4682B4',
	    tan:                  '#D2B48C',
	    teal:                 '#008080',
	    thistle:              '#D8BFD8',
	    tomato:               '#FF6347',
	    turquoise:            '#40E0D0',
	    violet:               '#EE82EE',
	    wheat:                '#F5DEB3',
	    white:                '#FFFFFF',
	    whitesmoke:           '#F5F5F5',
	    yellow:               '#FFFF00',
	    yellowgreen:          '#9ACD32'
	  };
	
	  /**
	   * @private
	   * @param {Number} p
	   * @param {Number} q
	   * @param {Number} t
	   * @return {Number}
	   */
	  function hue2rgb(p, q, t) {
	    if (t < 0) {
	      t += 1;
	    }
	    if (t > 1) {
	      t -= 1;
	    }
	    if (t < 1 / 6) {
	      return p + (q - p) * 6 * t;
	    }
	    if (t < 1 / 2) {
	      return q;
	    }
	    if (t < 2 / 3) {
	      return p + (q - p) * (2 / 3 - t) * 6;
	    }
	    return p;
	  }
	
	  /**
	   * Returns new color object, when given a color in RGB format
	   * @memberOf fabric.Color
	   * @param {String} color Color value ex: rgb(0-255,0-255,0-255)
	   * @return {fabric.Color}
	   */
	  fabric.Color.fromRgb = function(color) {
	    return Color.fromSource(Color.sourceFromRgb(color));
	  };
	
	  /**
	   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in RGB or RGBA format
	   * @memberOf fabric.Color
	   * @param {String} color Color value ex: rgb(0-255,0-255,0-255), rgb(0%-100%,0%-100%,0%-100%)
	   * @return {Array} source
	   */
	  fabric.Color.sourceFromRgb = function(color) {
	    var match = color.match(Color.reRGBa);
	    if (match) {
	      var r = parseInt(match[1], 10) / (/%$/.test(match[1]) ? 100 : 1) * (/%$/.test(match[1]) ? 255 : 1),
	          g = parseInt(match[2], 10) / (/%$/.test(match[2]) ? 100 : 1) * (/%$/.test(match[2]) ? 255 : 1),
	          b = parseInt(match[3], 10) / (/%$/.test(match[3]) ? 100 : 1) * (/%$/.test(match[3]) ? 255 : 1);
	
	      return [
	        parseInt(r, 10),
	        parseInt(g, 10),
	        parseInt(b, 10),
	        match[4] ? parseFloat(match[4]) : 1
	      ];
	    }
	  };
	
	  /**
	   * Returns new color object, when given a color in RGBA format
	   * @static
	   * @function
	   * @memberOf fabric.Color
	   * @param {String} color
	   * @return {fabric.Color}
	   */
	  fabric.Color.fromRgba = Color.fromRgb;
	
	  /**
	   * Returns new color object, when given a color in HSL format
	   * @param {String} color Color value ex: hsl(0-260,0%-100%,0%-100%)
	   * @memberOf fabric.Color
	   * @return {fabric.Color}
	   */
	  fabric.Color.fromHsl = function(color) {
	    return Color.fromSource(Color.sourceFromHsl(color));
	  };
	
	  /**
	   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HSL or HSLA format.
	   * Adapted from <a href="https://rawgithub.com/mjijackson/mjijackson.github.com/master/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript.html">https://github.com/mjijackson</a>
	   * @memberOf fabric.Color
	   * @param {String} color Color value ex: hsl(0-360,0%-100%,0%-100%) or hsla(0-360,0%-100%,0%-100%, 0-1)
	   * @return {Array} source
	   * @see http://http://www.w3.org/TR/css3-color/#hsl-color
	   */
	  fabric.Color.sourceFromHsl = function(color) {
	    var match = color.match(Color.reHSLa);
	    if (!match) {
	      return;
	    }
	
	    var h = (((parseFloat(match[1]) % 360) + 360) % 360) / 360,
	        s = parseFloat(match[2]) / (/%$/.test(match[2]) ? 100 : 1),
	        l = parseFloat(match[3]) / (/%$/.test(match[3]) ? 100 : 1),
	        r, g, b;
	
	    if (s === 0) {
	      r = g = b = l;
	    }
	    else {
	      var q = l <= 0.5 ? l * (s + 1) : l + s - l * s,
	          p = l * 2 - q;
	
	      r = hue2rgb(p, q, h + 1 / 3);
	      g = hue2rgb(p, q, h);
	      b = hue2rgb(p, q, h - 1 / 3);
	    }
	
	    return [
	      Math.round(r * 255),
	      Math.round(g * 255),
	      Math.round(b * 255),
	      match[4] ? parseFloat(match[4]) : 1
	    ];
	  };
	
	  /**
	   * Returns new color object, when given a color in HSLA format
	   * @static
	   * @function
	   * @memberOf fabric.Color
	   * @param {String} color
	   * @return {fabric.Color}
	   */
	  fabric.Color.fromHsla = Color.fromHsl;
	
	  /**
	   * Returns new color object, when given a color in HEX format
	   * @static
	   * @memberOf fabric.Color
	   * @param {String} color Color value ex: FF5555
	   * @return {fabric.Color}
	   */
	  fabric.Color.fromHex = function(color) {
	    return Color.fromSource(Color.sourceFromHex(color));
	  };
	
	  /**
	   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HEX format
	   * @static
	   * @memberOf fabric.Color
	   * @param {String} color ex: FF5555 or FF5544CC (RGBa)
	   * @return {Array} source
	   */
	  fabric.Color.sourceFromHex = function(color) {
	    if (color.match(Color.reHex)) {
	      var value = color.slice(color.indexOf('#') + 1),
	          isShortNotation = (value.length === 3 || value.length === 4),
	          isRGBa = (value.length === 8 || value.length === 4),
	          r = isShortNotation ? (value.charAt(0) + value.charAt(0)) : value.substring(0, 2),
	          g = isShortNotation ? (value.charAt(1) + value.charAt(1)) : value.substring(2, 4),
	          b = isShortNotation ? (value.charAt(2) + value.charAt(2)) : value.substring(4, 6),
	          a = isRGBa ? (isShortNotation ? (value.charAt(3) + value.charAt(3)) : value.substring(6, 8)) : 'FF';
	
	      return [
	        parseInt(r, 16),
	        parseInt(g, 16),
	        parseInt(b, 16),
	        parseFloat((parseInt(a, 16) / 255).toFixed(2))
	      ];
	    }
	  };
	
	  /**
	   * Returns new color object, when given color in array representation (ex: [200, 100, 100, 0.5])
	   * @static
	   * @memberOf fabric.Color
	   * @param {Array} source
	   * @return {fabric.Color}
	   */
	  fabric.Color.fromSource = function(source) {
	    var oColor = new Color();
	    oColor.setSource(source);
	    return oColor;
	  };
	
	})( true ? exports : this);
	
	
	(function() {
	
	  /* _FROM_SVG_START_ */
	  function getColorStop(el) {
	    var style = el.getAttribute('style'),
	        offset = el.getAttribute('offset') || 0,
	        color, colorAlpha, opacity, i;
	
	    // convert percents to absolute values
	    offset = parseFloat(offset) / (/%$/.test(offset) ? 100 : 1);
	    offset = offset < 0 ? 0 : offset > 1 ? 1 : offset;
	    if (style) {
	      var keyValuePairs = style.split(/\s*;\s*/);
	
	      if (keyValuePairs[keyValuePairs.length - 1] === '') {
	        keyValuePairs.pop();
	      }
	
	      for (i = keyValuePairs.length; i--; ) {
	
	        var split = keyValuePairs[i].split(/\s*:\s*/),
	            key = split[0].trim(),
	            value = split[1].trim();
	
	        if (key === 'stop-color') {
	          color = value;
	        }
	        else if (key === 'stop-opacity') {
	          opacity = value;
	        }
	      }
	    }
	
	    if (!color) {
	      color = el.getAttribute('stop-color') || 'rgb(0,0,0)';
	    }
	    if (!opacity) {
	      opacity = el.getAttribute('stop-opacity');
	    }
	
	    color = new fabric.Color(color);
	    colorAlpha = color.getAlpha();
	    opacity = isNaN(parseFloat(opacity)) ? 1 : parseFloat(opacity);
	    opacity *= colorAlpha;
	
	    return {
	      offset: offset,
	      color: color.toRgb(),
	      opacity: opacity
	    };
	  }
	
	  function getLinearCoords(el) {
	    return {
	      x1: el.getAttribute('x1') || 0,
	      y1: el.getAttribute('y1') || 0,
	      x2: el.getAttribute('x2') || '100%',
	      y2: el.getAttribute('y2') || 0
	    };
	  }
	
	  function getRadialCoords(el) {
	    return {
	      x1: el.getAttribute('fx') || el.getAttribute('cx') || '50%',
	      y1: el.getAttribute('fy') || el.getAttribute('cy') || '50%',
	      r1: 0,
	      x2: el.getAttribute('cx') || '50%',
	      y2: el.getAttribute('cy') || '50%',
	      r2: el.getAttribute('r') || '50%'
	    };
	  }
	  /* _FROM_SVG_END_ */
	
	  var clone = fabric.util.object.clone;
	
	  /**
	   * Gradient class
	   * @class fabric.Gradient
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#gradients}
	   * @see {@link fabric.Gradient#initialize} for constructor definition
	   */
	  fabric.Gradient = fabric.util.createClass(/** @lends fabric.Gradient.prototype */ {
	
	    /**
	     * Horizontal offset for aligning gradients coming from SVG when outside pathgroups
	     * @type Number
	     * @default 0
	     */
	    offsetX: 0,
	
	    /**
	     * Vertical offset for aligning gradients coming from SVG when outside pathgroups
	     * @type Number
	     * @default 0
	     */
	    offsetY: 0,
	
	    /**
	     * Constructor
	     * @param {Object} [options] Options object with type, coords, gradientUnits and colorStops
	     * @return {fabric.Gradient} thisArg
	     */
	    initialize: function(options) {
	      options || (options = { });
	
	      var coords = { };
	
	      this.id = fabric.Object.__uid++;
	      this.type = options.type || 'linear';
	
	      coords = {
	        x1: options.coords.x1 || 0,
	        y1: options.coords.y1 || 0,
	        x2: options.coords.x2 || 0,
	        y2: options.coords.y2 || 0
	      };
	
	      if (this.type === 'radial') {
	        coords.r1 = options.coords.r1 || 0;
	        coords.r2 = options.coords.r2 || 0;
	      }
	      this.coords = coords;
	      this.colorStops = options.colorStops.slice();
	      if (options.gradientTransform) {
	        this.gradientTransform = options.gradientTransform;
	      }
	      this.offsetX = options.offsetX || this.offsetX;
	      this.offsetY = options.offsetY || this.offsetY;
	    },
	
	    /**
	     * Adds another colorStop
	     * @param {Object} colorStop Object with offset and color
	     * @return {fabric.Gradient} thisArg
	     */
	    addColorStop: function(colorStops) {
	      for (var position in colorStops) {
	        var color = new fabric.Color(colorStops[position]);
	        this.colorStops.push({
	          offset: parseFloat(position),
	          color: color.toRgb(),
	          opacity: color.getAlpha()
	        });
	      }
	      return this;
	    },
	
	    /**
	     * Returns object representation of a gradient
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object}
	     */
	    toObject: function(propertiesToInclude) {
	      var object = {
	        type: this.type,
	        coords: this.coords,
	        colorStops: this.colorStops,
	        offsetX: this.offsetX,
	        offsetY: this.offsetY,
	        gradientTransform: this.gradientTransform ? this.gradientTransform.concat() : this.gradientTransform
	      };
	      fabric.util.populateWithProperties(this, object, propertiesToInclude);
	
	      return object;
	    },
	
	    /* _TO_SVG_START_ */
	    /**
	     * Returns SVG representation of an gradient
	     * @param {Object} object Object to create a gradient for
	     * @return {String} SVG representation of an gradient (linear/radial)
	     */
	    toSVG: function(object, options) {
	      var coords = clone(this.coords, true), i, len, options = options || {},
	          markup, commonAttributes, colorStops = clone(this.colorStops, true),
	          needsSwap = coords.r1 > coords.r2,
	          transform = this.gradientTransform ? this.gradientTransform.concat() : fabric.iMatrix.concat(),
	          offsetX = object.width / 2 - this.offsetX, offsetY = object.height / 2 - this.offsetY,
	          withViewport = !!options.additionalTransform;
	      // colorStops must be sorted ascending
	      colorStops.sort(function(a, b) {
	        return a.offset - b.offset;
	      });
	
	      if (object.type === 'path') {
	        offsetX -= object.pathOffset.x;
	        offsetY -= object.pathOffset.y;
	      }
	
	      transform[4] -= offsetX;
	      transform[5] -= offsetY;
	
	      commonAttributes = 'id="SVGID_' + this.id +
	                     '" gradientUnits="userSpaceOnUse"';
	      commonAttributes += ' gradientTransform="' + (withViewport ?
	        options.additionalTransform + ' ' : '') + fabric.util.matrixToSVG(transform) + '" ';
	
	      if (this.type === 'linear') {
	        markup = [
	          '<linearGradient ',
	          commonAttributes,
	          ' x1="', coords.x1,
	          '" y1="', coords.y1,
	          '" x2="', coords.x2,
	          '" y2="', coords.y2,
	          '">\n'
	        ];
	      }
	      else if (this.type === 'radial') {
	        // svg radial gradient has just 1 radius. the biggest.
	        markup = [
	          '<radialGradient ',
	          commonAttributes,
	          ' cx="', needsSwap ? coords.x1 : coords.x2,
	          '" cy="', needsSwap ? coords.y1 : coords.y2,
	          '" r="', needsSwap ? coords.r1 : coords.r2,
	          '" fx="', needsSwap ? coords.x2 : coords.x1,
	          '" fy="', needsSwap ? coords.y2 : coords.y1,
	          '">\n'
	        ];
	      }
	
	      if (this.type === 'radial') {
	        if (needsSwap) {
	          // svg goes from internal to external radius. if radius are inverted, swap color stops.
	          colorStops = colorStops.concat();
	          colorStops.reverse();
	          for (i = 0, len = colorStops.length; i < len; i++) {
	            colorStops[i].offset = 1 - colorStops[i].offset;
	          }
	        }
	        var minRadius = Math.min(coords.r1, coords.r2);
	        if (minRadius > 0) {
	          // i have to shift all colorStops and add new one in 0.
	          var maxRadius = Math.max(coords.r1, coords.r2),
	              percentageShift = minRadius / maxRadius;
	          for (i = 0, len = colorStops.length; i < len; i++) {
	            colorStops[i].offset += percentageShift * (1 - colorStops[i].offset);
	          }
	        }
	      }
	
	      for (i = 0, len = colorStops.length; i < len; i++) {
	        var colorStop = colorStops[i];
	        markup.push(
	          '<stop ',
	          'offset="', (colorStop.offset * 100) + '%',
	          '" style="stop-color:', colorStop.color,
	          (typeof colorStop.opacity !== 'undefined' ? ';stop-opacity: ' + colorStop.opacity : ';'),
	          '"/>\n'
	        );
	      }
	
	      markup.push((this.type === 'linear' ? '</linearGradient>\n' : '</radialGradient>\n'));
	
	      return markup.join('');
	    },
	    /* _TO_SVG_END_ */
	
	    /**
	     * Returns an instance of CanvasGradient
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @return {CanvasGradient}
	     */
	    toLive: function(ctx) {
	      var gradient, coords = fabric.util.object.clone(this.coords), i, len;
	
	      if (!this.type) {
	        return;
	      }
	
	      if (this.type === 'linear') {
	        gradient = ctx.createLinearGradient(
	          coords.x1, coords.y1, coords.x2, coords.y2);
	      }
	      else if (this.type === 'radial') {
	        gradient = ctx.createRadialGradient(
	          coords.x1, coords.y1, coords.r1, coords.x2, coords.y2, coords.r2);
	      }
	
	      for (i = 0, len = this.colorStops.length; i < len; i++) {
	        var color = this.colorStops[i].color,
	            opacity = this.colorStops[i].opacity,
	            offset = this.colorStops[i].offset;
	
	        if (typeof opacity !== 'undefined') {
	          color = new fabric.Color(color).setAlpha(opacity).toRgba();
	        }
	        gradient.addColorStop(offset, color);
	      }
	
	      return gradient;
	    }
	  });
	
	  fabric.util.object.extend(fabric.Gradient, {
	
	    /* _FROM_SVG_START_ */
	    /**
	     * Returns {@link fabric.Gradient} instance from an SVG element
	     * @static
	     * @memberOf fabric.Gradient
	     * @param {SVGGradientElement} el SVG gradient element
	     * @param {fabric.Object} instance
	     * @return {fabric.Gradient} Gradient instance
	     * @see http://www.w3.org/TR/SVG/pservers.html#LinearGradientElement
	     * @see http://www.w3.org/TR/SVG/pservers.html#RadialGradientElement
	     */
	    fromElement: function(el, instance) {
	      /**
	       *  @example:
	       *
	       *  <linearGradient id="linearGrad1">
	       *    <stop offset="0%" stop-color="white"/>
	       *    <stop offset="100%" stop-color="black"/>
	       *  </linearGradient>
	       *
	       *  OR
	       *
	       *  <linearGradient id="linearGrad2">
	       *    <stop offset="0" style="stop-color:rgb(255,255,255)"/>
	       *    <stop offset="1" style="stop-color:rgb(0,0,0)"/>
	       *  </linearGradient>
	       *
	       *  OR
	       *
	       *  <radialGradient id="radialGrad1">
	       *    <stop offset="0%" stop-color="white" stop-opacity="1" />
	       *    <stop offset="50%" stop-color="black" stop-opacity="0.5" />
	       *    <stop offset="100%" stop-color="white" stop-opacity="1" />
	       *  </radialGradient>
	       *
	       *  OR
	       *
	       *  <radialGradient id="radialGrad2">
	       *    <stop offset="0" stop-color="rgb(255,255,255)" />
	       *    <stop offset="0.5" stop-color="rgb(0,0,0)" />
	       *    <stop offset="1" stop-color="rgb(255,255,255)" />
	       *  </radialGradient>
	       *
	       */
	
	      var colorStopEls = el.getElementsByTagName('stop'),
	          type,
	          gradientUnits = el.getAttribute('gradientUnits') || 'objectBoundingBox',
	          gradientTransform = el.getAttribute('gradientTransform'),
	          colorStops = [],
	          coords, ellipseMatrix, i;
	
	      if (el.nodeName === 'linearGradient' || el.nodeName === 'LINEARGRADIENT') {
	        type = 'linear';
	      }
	      else {
	        type = 'radial';
	      }
	
	      if (type === 'linear') {
	        coords = getLinearCoords(el);
	      }
	      else if (type === 'radial') {
	        coords = getRadialCoords(el);
	      }
	
	      for (i = colorStopEls.length; i--; ) {
	        colorStops.push(getColorStop(colorStopEls[i]));
	      }
	
	      ellipseMatrix = _convertPercentUnitsToValues(instance, coords, gradientUnits);
	
	      var gradient = new fabric.Gradient({
	        type: type,
	        coords: coords,
	        colorStops: colorStops,
	        offsetX: -instance.left,
	        offsetY: -instance.top
	      });
	
	      if (gradientTransform || ellipseMatrix !== '') {
	        gradient.gradientTransform = fabric.parseTransformAttribute((gradientTransform || '') + ellipseMatrix);
	      }
	
	      return gradient;
	    },
	    /* _FROM_SVG_END_ */
	
	    /**
	     * Returns {@link fabric.Gradient} instance from its object representation
	     * @static
	     * @memberOf fabric.Gradient
	     * @param {Object} obj
	     * @param {Object} [options] Options object
	     */
	    forObject: function(obj, options) {
	      options || (options = { });
	      _convertPercentUnitsToValues(obj, options.coords, 'userSpaceOnUse');
	      return new fabric.Gradient(options);
	    }
	  });
	
	  /**
	   * @private
	   */
	  function _convertPercentUnitsToValues(object, options, gradientUnits) {
	    var propValue, addFactor = 0, multFactor = 1, ellipseMatrix = '';
	    for (var prop in options) {
	      if (options[prop] === 'Infinity') {
	        options[prop] = 1;
	      }
	      else if (options[prop] === '-Infinity') {
	        options[prop] = 0;
	      }
	      propValue = parseFloat(options[prop], 10);
	      if (typeof options[prop] === 'string' && /^(\d+\.\d+)%|(\d+)%$/.test(options[prop])) {
	        multFactor = 0.01;
	      }
	      else {
	        multFactor = 1;
	      }
	      if (prop === 'x1' || prop === 'x2' || prop === 'r2') {
	        multFactor *= gradientUnits === 'objectBoundingBox' ? object.width : 1;
	        addFactor = gradientUnits === 'objectBoundingBox' ? object.left || 0 : 0;
	      }
	      else if (prop === 'y1' || prop === 'y2') {
	        multFactor *= gradientUnits === 'objectBoundingBox' ? object.height : 1;
	        addFactor = gradientUnits === 'objectBoundingBox' ? object.top || 0 : 0;
	      }
	      options[prop] = propValue * multFactor + addFactor;
	    }
	    if (object.type === 'ellipse' &&
	        options.r2 !== null &&
	        gradientUnits === 'objectBoundingBox' &&
	        object.rx !== object.ry) {
	
	      var scaleFactor = object.ry / object.rx;
	      ellipseMatrix = ' scale(1, ' + scaleFactor + ')';
	      if (options.y1) {
	        options.y1 /= scaleFactor;
	      }
	      if (options.y2) {
	        options.y2 /= scaleFactor;
	      }
	    }
	    return ellipseMatrix;
	  }
	})();
	
	
	(function() {
	
	  'use strict';
	
	  var toFixed = fabric.util.toFixed;
	
	  /**
	   * Pattern class
	   * @class fabric.Pattern
	   * @see {@link http://fabricjs.com/patterns|Pattern demo}
	   * @see {@link http://fabricjs.com/dynamic-patterns|DynamicPattern demo}
	   * @see {@link fabric.Pattern#initialize} for constructor definition
	   */
	
	
	  fabric.Pattern = fabric.util.createClass(/** @lends fabric.Pattern.prototype */ {
	
	    /**
	     * Repeat property of a pattern (one of repeat, repeat-x, repeat-y or no-repeat)
	     * @type String
	     * @default
	     */
	    repeat: 'repeat',
	
	    /**
	     * Pattern horizontal offset from object's left/top corner
	     * @type Number
	     * @default
	     */
	    offsetX: 0,
	
	    /**
	     * Pattern vertical offset from object's left/top corner
	     * @type Number
	     * @default
	     */
	    offsetY: 0,
	
	    /**
	     * crossOrigin value (one of "", "anonymous", "use-credentials")
	     * @see https://developer.mozilla.org/en-US/docs/HTML/CORS_settings_attributes
	     * @type String
	     * @default
	     */
	    crossOrigin: '',
	
	    /**
	     * transform matrix to change the pattern, imported from svgs.
	     * @type Array
	     * @default
	     */
	    patternTransform: null,
	
	    /**
	     * Constructor
	     * @param {Object} [options] Options object
	     * @param {Function} [callback] function to invoke after callback init.
	     * @return {fabric.Pattern} thisArg
	     */
	    initialize: function(options, callback) {
	      options || (options = { });
	
	      this.id = fabric.Object.__uid++;
	      this.setOptions(options);
	      if (!options.source || (options.source && typeof options.source !== 'string')) {
	        callback && callback(this);
	        return;
	      }
	      // function string
	      if (typeof fabric.util.getFunctionBody(options.source) !== 'undefined') {
	        this.source = new Function(fabric.util.getFunctionBody(options.source));
	        callback && callback(this);
	      }
	      else {
	        // img src string
	        var _this = this;
	        this.source = fabric.util.createImage();
	        fabric.util.loadImage(options.source, function(img) {
	          _this.source = img;
	          callback && callback(_this);
	        }, null, this.crossOrigin);
	      }
	    },
	
	    /**
	     * Returns object representation of a pattern
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} Object representation of a pattern instance
	     */
	    toObject: function(propertiesToInclude) {
	      var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS,
	          source, object;
	
	      // callback
	      if (typeof this.source === 'function') {
	        source = String(this.source);
	      }
	      // <img> element
	      else if (typeof this.source.src === 'string') {
	        source = this.source.src;
	      }
	      // <canvas> element
	      else if (typeof this.source === 'object' && this.source.toDataURL) {
	        source = this.source.toDataURL();
	      }
	
	      object = {
	        type: 'pattern',
	        source: source,
	        repeat: this.repeat,
	        crossOrigin: this.crossOrigin,
	        offsetX: toFixed(this.offsetX, NUM_FRACTION_DIGITS),
	        offsetY: toFixed(this.offsetY, NUM_FRACTION_DIGITS),
	        patternTransform: this.patternTransform ? this.patternTransform.concat() : null
	      };
	      fabric.util.populateWithProperties(this, object, propertiesToInclude);
	
	      return object;
	    },
	
	    /* _TO_SVG_START_ */
	    /**
	     * Returns SVG representation of a pattern
	     * @param {fabric.Object} object
	     * @return {String} SVG representation of a pattern
	     */
	    toSVG: function(object) {
	      var patternSource = typeof this.source === 'function' ? this.source() : this.source,
	          patternWidth = patternSource.width / object.width,
	          patternHeight = patternSource.height / object.height,
	          patternOffsetX = this.offsetX / object.width,
	          patternOffsetY = this.offsetY / object.height,
	          patternImgSrc = '';
	      if (this.repeat === 'repeat-x' || this.repeat === 'no-repeat') {
	        patternHeight = 1;
	        if (patternOffsetY) {
	          patternHeight += Math.abs(patternOffsetY);
	        }
	      }
	      if (this.repeat === 'repeat-y' || this.repeat === 'no-repeat') {
	        patternWidth = 1;
	        if (patternOffsetX) {
	          patternWidth += Math.abs(patternOffsetX);
	        }
	
	      }
	      if (patternSource.src) {
	        patternImgSrc = patternSource.src;
	      }
	      else if (patternSource.toDataURL) {
	        patternImgSrc = patternSource.toDataURL();
	      }
	
	      return '<pattern id="SVGID_' + this.id +
	                    '" x="' + patternOffsetX +
	                    '" y="' + patternOffsetY +
	                    '" width="' + patternWidth +
	                    '" height="' + patternHeight + '">\n' +
	               '<image x="0" y="0"' +
	                      ' width="' + patternSource.width +
	                      '" height="' + patternSource.height +
	                      '" xlink:href="' + patternImgSrc +
	               '"></image>\n' +
	             '</pattern>\n';
	    },
	    /* _TO_SVG_END_ */
	
	    setOptions: function(options) {
	      for (var prop in options) {
	        this[prop] = options[prop];
	      }
	    },
	
	    /**
	     * Returns an instance of CanvasPattern
	     * @param {CanvasRenderingContext2D} ctx Context to create pattern
	     * @return {CanvasPattern}
	     */
	    toLive: function(ctx) {
	      var source = typeof this.source === 'function' ? this.source() : this.source;
	
	      // if the image failed to load, return, and allow rest to continue loading
	      if (!source) {
	        return '';
	      }
	
	      // if an image
	      if (typeof source.src !== 'undefined') {
	        if (!source.complete) {
	          return '';
	        }
	        if (source.naturalWidth === 0 || source.naturalHeight === 0) {
	          return '';
	        }
	      }
	      return ctx.createPattern(source, this.repeat);
	    }
	  });
	})();
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric = global.fabric || (global.fabric = { }),
	      toFixed = fabric.util.toFixed;
	
	  if (fabric.Shadow) {
	    fabric.warn('fabric.Shadow is already defined.');
	    return;
	  }
	
	  /**
	   * Shadow class
	   * @class fabric.Shadow
	   * @see {@link http://fabricjs.com/shadows|Shadow demo}
	   * @see {@link fabric.Shadow#initialize} for constructor definition
	   */
	  fabric.Shadow = fabric.util.createClass(/** @lends fabric.Shadow.prototype */ {
	
	    /**
	     * Shadow color
	     * @type String
	     * @default
	     */
	    color: 'rgb(0,0,0)',
	
	    /**
	     * Shadow blur
	     * @type Number
	     */
	    blur: 0,
	
	    /**
	     * Shadow horizontal offset
	     * @type Number
	     * @default
	     */
	    offsetX: 0,
	
	    /**
	     * Shadow vertical offset
	     * @type Number
	     * @default
	     */
	    offsetY: 0,
	
	    /**
	     * Whether the shadow should affect stroke operations
	     * @type Boolean
	     * @default
	     */
	    affectStroke: false,
	
	    /**
	     * Indicates whether toObject should include default values
	     * @type Boolean
	     * @default
	     */
	    includeDefaultValues: true,
	
	    /**
	     * When `false`, the shadow will scale with the object.
	     * When `true`, the shadow's offsetX, offsetY, and blur will not be affected by the object's scale.
	     * default to false
	     * @type Boolean
	     * @default
	     */
	    nonScaling: false,
	
	    /**
	     * Constructor
	     * @param {Object|String} [options] Options object with any of color, blur, offsetX, offsetY properties or string (e.g. "rgba(0,0,0,0.2) 2px 2px 10px")
	     * @return {fabric.Shadow} thisArg
	     */
	    initialize: function(options) {
	
	      if (typeof options === 'string') {
	        options = this._parseShadow(options);
	      }
	
	      for (var prop in options) {
	        this[prop] = options[prop];
	      }
	
	      this.id = fabric.Object.__uid++;
	    },
	
	    /**
	     * @private
	     * @param {String} shadow Shadow value to parse
	     * @return {Object} Shadow object with color, offsetX, offsetY and blur
	     */
	    _parseShadow: function(shadow) {
	      var shadowStr = shadow.trim(),
	          offsetsAndBlur = fabric.Shadow.reOffsetsAndBlur.exec(shadowStr) || [],
	          color = shadowStr.replace(fabric.Shadow.reOffsetsAndBlur, '') || 'rgb(0,0,0)';
	
	      return {
	        color: color.trim(),
	        offsetX: parseInt(offsetsAndBlur[1], 10) || 0,
	        offsetY: parseInt(offsetsAndBlur[2], 10) || 0,
	        blur: parseInt(offsetsAndBlur[3], 10) || 0
	      };
	    },
	
	    /**
	     * Returns a string representation of an instance
	     * @see http://www.w3.org/TR/css-text-decor-3/#text-shadow
	     * @return {String} Returns CSS3 text-shadow declaration
	     */
	    toString: function() {
	      return [this.offsetX, this.offsetY, this.blur, this.color].join('px ');
	    },
	
	    /* _TO_SVG_START_ */
	    /**
	     * Returns SVG representation of a shadow
	     * @param {fabric.Object} object
	     * @return {String} SVG representation of a shadow
	     */
	    toSVG: function(object) {
	      var fBoxX = 40, fBoxY = 40, NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS,
	          offset = fabric.util.rotateVector(
	            { x: this.offsetX, y: this.offsetY },
	            fabric.util.degreesToRadians(-object.angle)),
	          BLUR_BOX = 20, color = new fabric.Color(this.color);
	
	      if (object.width && object.height) {
	        //http://www.w3.org/TR/SVG/filters.html#FilterEffectsRegion
	        // we add some extra space to filter box to contain the blur ( 20 )
	        fBoxX = toFixed((Math.abs(offset.x) + this.blur) / object.width, NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
	        fBoxY = toFixed((Math.abs(offset.y) + this.blur) / object.height, NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
	      }
	      if (object.flipX) {
	        offset.x *= -1;
	      }
	      if (object.flipY) {
	        offset.y *= -1;
	      }
	
	      return (
	        '<filter id="SVGID_' + this.id + '" y="-' + fBoxY + '%" height="' + (100 + 2 * fBoxY) + '%" ' +
	          'x="-' + fBoxX + '%" width="' + (100 + 2 * fBoxX) + '%" ' + '>\n' +
	          '\t<feGaussianBlur in="SourceAlpha" stdDeviation="' +
	            toFixed(this.blur ? this.blur / 2 : 0, NUM_FRACTION_DIGITS) + '"></feGaussianBlur>\n' +
	          '\t<feOffset dx="' + toFixed(offset.x, NUM_FRACTION_DIGITS) +
	          '" dy="' + toFixed(offset.y, NUM_FRACTION_DIGITS) + '" result="oBlur" ></feOffset>\n' +
	          '\t<feFlood flood-color="' + color.toRgb() + '" flood-opacity="' + color.getAlpha() + '"/>\n' +
	          '\t<feComposite in2="oBlur" operator="in" />\n' +
	          '\t<feMerge>\n' +
	            '\t\t<feMergeNode></feMergeNode>\n' +
	            '\t\t<feMergeNode in="SourceGraphic"></feMergeNode>\n' +
	          '\t</feMerge>\n' +
	        '</filter>\n');
	    },
	    /* _TO_SVG_END_ */
	
	    /**
	     * Returns object representation of a shadow
	     * @return {Object} Object representation of a shadow instance
	     */
	    toObject: function() {
	      if (this.includeDefaultValues) {
	        return {
	          color: this.color,
	          blur: this.blur,
	          offsetX: this.offsetX,
	          offsetY: this.offsetY,
	          affectStroke: this.affectStroke,
	          nonScaling: this.nonScaling
	        };
	      }
	      var obj = { }, proto = fabric.Shadow.prototype;
	
	      ['color', 'blur', 'offsetX', 'offsetY', 'affectStroke', 'nonScaling'].forEach(function(prop) {
	        if (this[prop] !== proto[prop]) {
	          obj[prop] = this[prop];
	        }
	      }, this);
	
	      return obj;
	    }
	  });
	
	  /**
	   * Regex matching shadow offsetX, offsetY and blur (ex: "2px 2px 10px rgba(0,0,0,0.2)", "rgb(0,255,0) 2px 2px")
	   * @static
	   * @field
	   * @memberOf fabric.Shadow
	   */
	  // eslint-disable-next-line max-len
	  fabric.Shadow.reOffsetsAndBlur = /(?:\s|^)(-?\d+(?:px)?(?:\s?|$))?(-?\d+(?:px)?(?:\s?|$))?(\d+(?:px)?)?(?:\s?|$)(?:$|\s)/;
	
	})( true ? exports : this);
	
	
	(function () {
	
	  'use strict';
	
	  if (fabric.StaticCanvas) {
	    fabric.warn('fabric.StaticCanvas is already defined.');
	    return;
	  }
	
	  // aliases for faster resolution
	  var extend = fabric.util.object.extend,
	      getElementOffset = fabric.util.getElementOffset,
	      removeFromArray = fabric.util.removeFromArray,
	      toFixed = fabric.util.toFixed,
	      transformPoint = fabric.util.transformPoint,
	      invertTransform = fabric.util.invertTransform,
	      getNodeCanvas = fabric.util.getNodeCanvas,
	      createCanvasElement = fabric.util.createCanvasElement,
	
	      CANVAS_INIT_ERROR = new Error('Could not initialize `canvas` element');
	
	  /**
	   * Static canvas class
	   * @class fabric.StaticCanvas
	   * @mixes fabric.Collection
	   * @mixes fabric.Observable
	   * @see {@link http://fabricjs.com/static_canvas|StaticCanvas demo}
	   * @see {@link fabric.StaticCanvas#initialize} for constructor definition
	   * @fires before:render
	   * @fires after:render
	   * @fires canvas:cleared
	   * @fires object:added
	   * @fires object:removed
	   */
	  fabric.StaticCanvas = fabric.util.createClass(fabric.CommonMethods, /** @lends fabric.StaticCanvas.prototype */ {
	
	    /**
	     * Constructor
	     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
	     * @param {Object} [options] Options object
	     * @return {Object} thisArg
	     */
	    initialize: function(el, options) {
	      options || (options = { });
	      this.renderAndResetBound = this.renderAndReset.bind(this);
	      this.requestRenderAllBound = this.requestRenderAll.bind(this);
	      this._initStatic(el, options);
	    },
	
	    /**
	     * Background color of canvas instance.
	     * Should be set via {@link fabric.StaticCanvas#setBackgroundColor}.
	     * @type {(String|fabric.Pattern)}
	     * @default
	     */
	    backgroundColor: '',
	
	    /**
	     * Background image of canvas instance.
	     * Should be set via {@link fabric.StaticCanvas#setBackgroundImage}.
	     * <b>Backwards incompatibility note:</b> The "backgroundImageOpacity"
	     * and "backgroundImageStretch" properties are deprecated since 1.3.9.
	     * Use {@link fabric.Image#opacity}, {@link fabric.Image#width} and {@link fabric.Image#height}.
	     * since 2.4.0 image caching is active, please when putting an image as background, add to the
	     * canvas property a reference to the canvas it is on. Otherwise the image cannot detect the zoom
	     * vale. As an alternative you can disable image objectCaching
	     * @type fabric.Image
	     * @default
	     */
	    backgroundImage: null,
	
	    /**
	     * Overlay color of canvas instance.
	     * Should be set via {@link fabric.StaticCanvas#setOverlayColor}
	     * @since 1.3.9
	     * @type {(String|fabric.Pattern)}
	     * @default
	     */
	    overlayColor: '',
	
	    /**
	     * Overlay image of canvas instance.
	     * Should be set via {@link fabric.StaticCanvas#setOverlayImage}.
	     * <b>Backwards incompatibility note:</b> The "overlayImageLeft"
	     * and "overlayImageTop" properties are deprecated since 1.3.9.
	     * Use {@link fabric.Image#left} and {@link fabric.Image#top}.
	     * since 2.4.0 image caching is active, please when putting an image as overlay, add to the
	     * canvas property a reference to the canvas it is on. Otherwise the image cannot detect the zoom
	     * vale. As an alternative you can disable image objectCaching
	     * @type fabric.Image
	     * @default
	     */
	    overlayImage: null,
	
	    /**
	     * Indicates whether toObject/toDatalessObject should include default values
	     * if set to false, takes precedence over the object value.
	     * @type Boolean
	     * @default
	     */
	    includeDefaultValues: true,
	
	    /**
	     * Indicates whether objects' state should be saved
	     * @type Boolean
	     * @default
	     */
	    stateful: false,
	
	    /**
	     * Indicates whether {@link fabric.Collection.add}, {@link fabric.Collection.insertAt} and {@link fabric.Collection.remove},
	     * {@link fabric.StaticCanvas.moveTo}, {@link fabric.StaticCanvas.clear} and many more, should also re-render canvas.
	     * Disabling this option will not give a performance boost when adding/removing a lot of objects to/from canvas at once
	     * since the renders are quequed and executed one per frame.
	     * Disabling is suggested anyway and managing the renders of the app manually is not a big effort ( canvas.requestRenderAll() )
	     * Left default to true to do not break documentation and old app, fiddles.
	     * @type Boolean
	     * @default
	     */
	    renderOnAddRemove: true,
	
	    /**
	     * Function that determines clipping of entire canvas area
	     * Being passed context as first argument.
	     * If you are using code minification, ctx argument can be minified/manglied you should use
	     * as a workaround `var ctx = arguments[0];` in the function;
	     * See clipping canvas area in {@link https://github.com/kangax/fabric.js/wiki/FAQ}
	     * @deprecated since 2.0.0
	     * @type Function
	     * @default
	     */
	    clipTo: null,
	
	    /**
	     * Indicates whether object controls (borders/controls) are rendered above overlay image
	     * @type Boolean
	     * @default
	     */
	    controlsAboveOverlay: false,
	
	    /**
	     * Indicates whether the browser can be scrolled when using a touchscreen and dragging on the canvas
	     * @type Boolean
	     * @default
	     */
	    allowTouchScrolling: false,
	
	    /**
	     * Indicates whether this canvas will use image smoothing, this is on by default in browsers
	     * @type Boolean
	     * @default
	     */
	    imageSmoothingEnabled: true,
	
	    /**
	     * The transformation (in the format of Canvas transform) which focuses the viewport
	     * @type Array
	     * @default
	     */
	    viewportTransform: fabric.iMatrix.concat(),
	
	    /**
	     * if set to false background image is not affected by viewport transform
	     * @since 1.6.3
	     * @type Boolean
	     * @default
	     */
	    backgroundVpt: true,
	
	    /**
	     * if set to false overlya image is not affected by viewport transform
	     * @since 1.6.3
	     * @type Boolean
	     * @default
	     */
	    overlayVpt: true,
	
	    /**
	     * Callback; invoked right before object is about to be scaled/rotated
	     * @deprecated since 2.3.0
	     * Use before:transform event
	     */
	    onBeforeScaleRotate: function () {
	      /* NOOP */
	    },
	
	    /**
	     * When true, canvas is scaled by devicePixelRatio for better rendering on retina screens
	     * @type Boolean
	     * @default
	     */
	    enableRetinaScaling: true,
	
	    /**
	     * Describe canvas element extension over design
	     * properties are tl,tr,bl,br.
	     * if canvas is not zoomed/panned those points are the four corner of canvas
	     * if canvas is viewportTransformed you those points indicate the extension
	     * of canvas element in plain untrasformed coordinates
	     * The coordinates get updated with @method calcViewportBoundaries.
	     * @memberOf fabric.StaticCanvas.prototype
	     */
	    vptCoords: { },
	
	    /**
	     * Based on vptCoords and object.aCoords, skip rendering of objects that
	     * are not included in current viewport.
	     * May greatly help in applications with crowded canvas and use of zoom/pan
	     * If One of the corner of the bounding box of the object is on the canvas
	     * the objects get rendered.
	     * @memberOf fabric.StaticCanvas.prototype
	     * @type Boolean
	     * @default
	     */
	    skipOffscreen: true,
	
	    /**
	     * a fabricObject that, without stroke define a clipping area with their shape. filled in black
	     * the clipPath object gets used when the canvas has rendered, and the context is placed in the
	     * top left corner of the canvas.
	     * clipPath will clip away controls, if you do not want this to happen use controlsAboveOverlay = true
	     * @type fabric.Object
	     */
	    clipPath: undefined,
	
	    /**
	     * @private
	     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
	     * @param {Object} [options] Options object
	     */
	    _initStatic: function(el, options) {
	      var cb = this.requestRenderAllBound;
	      this._objects = [];
	      this._createLowerCanvas(el);
	      this._initOptions(options);
	      this._setImageSmoothing();
	      // only initialize retina scaling once
	      if (!this.interactive) {
	        this._initRetinaScaling();
	      }
	
	      if (options.overlayImage) {
	        this.setOverlayImage(options.overlayImage, cb);
	      }
	      if (options.backgroundImage) {
	        this.setBackgroundImage(options.backgroundImage, cb);
	      }
	      if (options.backgroundColor) {
	        this.setBackgroundColor(options.backgroundColor, cb);
	      }
	      if (options.overlayColor) {
	        this.setOverlayColor(options.overlayColor, cb);
	      }
	      this.calcOffset();
	    },
	
	    /**
	     * @private
	     */
	    _isRetinaScaling: function() {
	      return (fabric.devicePixelRatio !== 1 && this.enableRetinaScaling);
	    },
	
	    /**
	     * @private
	     * @return {Number} retinaScaling if applied, otherwise 1;
	     */
	    getRetinaScaling: function() {
	      return this._isRetinaScaling() ? fabric.devicePixelRatio : 1;
	    },
	
	    /**
	     * @private
	     */
	    _initRetinaScaling: function() {
	      if (!this._isRetinaScaling()) {
	        return;
	      }
	      this.lowerCanvasEl.setAttribute('width', this.width * fabric.devicePixelRatio);
	      this.lowerCanvasEl.setAttribute('height', this.height * fabric.devicePixelRatio);
	
	      this.contextContainer.scale(fabric.devicePixelRatio, fabric.devicePixelRatio);
	    },
	
	    /**
	     * Calculates canvas element offset relative to the document
	     * This method is also attached as "resize" event handler of window
	     * @return {fabric.Canvas} instance
	     * @chainable
	     */
	    calcOffset: function () {
	      this._offset = getElementOffset(this.lowerCanvasEl);
	      return this;
	    },
	
	    /**
	     * Sets {@link fabric.StaticCanvas#overlayImage|overlay image} for this canvas
	     * @param {(fabric.Image|String)} image fabric.Image instance or URL of an image to set overlay to
	     * @param {Function} callback callback to invoke when image is loaded and set as an overlay
	     * @param {Object} [options] Optional options to set for the {@link fabric.Image|overlay image}.
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     * @see {@link http://jsfiddle.net/fabricjs/MnzHT/|jsFiddle demo}
	     * @example <caption>Normal overlayImage with left/top = 0</caption>
	     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
	     *   // Needed to position overlayImage at 0/0
	     *   originX: 'left',
	     *   originY: 'top'
	     * });
	     * @example <caption>overlayImage with different properties</caption>
	     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
	     *   opacity: 0.5,
	     *   angle: 45,
	     *   left: 400,
	     *   top: 400,
	     *   originX: 'left',
	     *   originY: 'top'
	     * });
	     * @example <caption>Stretched overlayImage #1 - width/height correspond to canvas width/height</caption>
	     * fabric.Image.fromURL('http://fabricjs.com/assets/jail_cell_bars.png', function(img) {
	     *    img.set({width: canvas.width, height: canvas.height, originX: 'left', originY: 'top'});
	     *    canvas.setOverlayImage(img, canvas.renderAll.bind(canvas));
	     * });
	     * @example <caption>Stretched overlayImage #2 - width/height correspond to canvas width/height</caption>
	     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
	     *   width: canvas.width,
	     *   height: canvas.height,
	     *   // Needed to position overlayImage at 0/0
	     *   originX: 'left',
	     *   originY: 'top'
	     * });
	     * @example <caption>overlayImage loaded from cross-origin</caption>
	     * canvas.setOverlayImage('http://fabricjs.com/assets/jail_cell_bars.png', canvas.renderAll.bind(canvas), {
	     *   opacity: 0.5,
	     *   angle: 45,
	     *   left: 400,
	     *   top: 400,
	     *   originX: 'left',
	     *   originY: 'top',
	     *   crossOrigin: 'anonymous'
	     * });
	     */
	    setOverlayImage: function (image, callback, options) {
	      return this.__setBgOverlayImage('overlayImage', image, callback, options);
	    },
	
	    /**
	     * Sets {@link fabric.StaticCanvas#backgroundImage|background image} for this canvas
	     * @param {(fabric.Image|String)} image fabric.Image instance or URL of an image to set background to
	     * @param {Function} callback Callback to invoke when image is loaded and set as background
	     * @param {Object} [options] Optional options to set for the {@link fabric.Image|background image}.
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     * @see {@link http://jsfiddle.net/djnr8o7a/28/|jsFiddle demo}
	     * @example <caption>Normal backgroundImage with left/top = 0</caption>
	     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
	     *   // Needed to position backgroundImage at 0/0
	     *   originX: 'left',
	     *   originY: 'top'
	     * });
	     * @example <caption>backgroundImage with different properties</caption>
	     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
	     *   opacity: 0.5,
	     *   angle: 45,
	     *   left: 400,
	     *   top: 400,
	     *   originX: 'left',
	     *   originY: 'top'
	     * });
	     * @example <caption>Stretched backgroundImage #1 - width/height correspond to canvas width/height</caption>
	     * fabric.Image.fromURL('http://fabricjs.com/assets/honey_im_subtle.png', function(img) {
	     *    img.set({width: canvas.width, height: canvas.height, originX: 'left', originY: 'top'});
	     *    canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));
	     * });
	     * @example <caption>Stretched backgroundImage #2 - width/height correspond to canvas width/height</caption>
	     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
	     *   width: canvas.width,
	     *   height: canvas.height,
	     *   // Needed to position backgroundImage at 0/0
	     *   originX: 'left',
	     *   originY: 'top'
	     * });
	     * @example <caption>backgroundImage loaded from cross-origin</caption>
	     * canvas.setBackgroundImage('http://fabricjs.com/assets/honey_im_subtle.png', canvas.renderAll.bind(canvas), {
	     *   opacity: 0.5,
	     *   angle: 45,
	     *   left: 400,
	     *   top: 400,
	     *   originX: 'left',
	     *   originY: 'top',
	     *   crossOrigin: 'anonymous'
	     * });
	     */
	    // TODO: fix stretched examples
	    setBackgroundImage: function (image, callback, options) {
	      return this.__setBgOverlayImage('backgroundImage', image, callback, options);
	    },
	
	    /**
	     * Sets {@link fabric.StaticCanvas#overlayColor|foreground color} for this canvas
	     * @param {(String|fabric.Pattern)} overlayColor Color or pattern to set foreground color to
	     * @param {Function} callback Callback to invoke when foreground color is set
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     * @see {@link http://jsfiddle.net/fabricjs/pB55h/|jsFiddle demo}
	     * @example <caption>Normal overlayColor - color value</caption>
	     * canvas.setOverlayColor('rgba(255, 73, 64, 0.6)', canvas.renderAll.bind(canvas));
	     * @example <caption>fabric.Pattern used as overlayColor</caption>
	     * canvas.setOverlayColor({
	     *   source: 'http://fabricjs.com/assets/escheresque_ste.png'
	     * }, canvas.renderAll.bind(canvas));
	     * @example <caption>fabric.Pattern used as overlayColor with repeat and offset</caption>
	     * canvas.setOverlayColor({
	     *   source: 'http://fabricjs.com/assets/escheresque_ste.png',
	     *   repeat: 'repeat',
	     *   offsetX: 200,
	     *   offsetY: 100
	     * }, canvas.renderAll.bind(canvas));
	     */
	    setOverlayColor: function(overlayColor, callback) {
	      return this.__setBgOverlayColor('overlayColor', overlayColor, callback);
	    },
	
	    /**
	     * Sets {@link fabric.StaticCanvas#backgroundColor|background color} for this canvas
	     * @param {(String|fabric.Pattern)} backgroundColor Color or pattern to set background color to
	     * @param {Function} callback Callback to invoke when background color is set
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     * @see {@link http://jsfiddle.net/fabricjs/hXzvk/|jsFiddle demo}
	     * @example <caption>Normal backgroundColor - color value</caption>
	     * canvas.setBackgroundColor('rgba(255, 73, 64, 0.6)', canvas.renderAll.bind(canvas));
	     * @example <caption>fabric.Pattern used as backgroundColor</caption>
	     * canvas.setBackgroundColor({
	     *   source: 'http://fabricjs.com/assets/escheresque_ste.png'
	     * }, canvas.renderAll.bind(canvas));
	     * @example <caption>fabric.Pattern used as backgroundColor with repeat and offset</caption>
	     * canvas.setBackgroundColor({
	     *   source: 'http://fabricjs.com/assets/escheresque_ste.png',
	     *   repeat: 'repeat',
	     *   offsetX: 200,
	     *   offsetY: 100
	     * }, canvas.renderAll.bind(canvas));
	     */
	    setBackgroundColor: function(backgroundColor, callback) {
	      return this.__setBgOverlayColor('backgroundColor', backgroundColor, callback);
	    },
	
	    /**
	     * @private
	     * @see {@link http://www.whatwg.org/specs/web-apps/current-work/multipage/the-canvas-element.html#dom-context-2d-imagesmoothingenabled|WhatWG Canvas Standard}
	     */
	    _setImageSmoothing: function() {
	      var ctx = this.getContext();
	
	      ctx.imageSmoothingEnabled = ctx.imageSmoothingEnabled || ctx.webkitImageSmoothingEnabled
	        || ctx.mozImageSmoothingEnabled || ctx.msImageSmoothingEnabled || ctx.oImageSmoothingEnabled;
	      ctx.imageSmoothingEnabled = this.imageSmoothingEnabled;
	    },
	
	    /**
	     * @private
	     * @param {String} property Property to set ({@link fabric.StaticCanvas#backgroundImage|backgroundImage}
	     * or {@link fabric.StaticCanvas#overlayImage|overlayImage})
	     * @param {(fabric.Image|String|null)} image fabric.Image instance, URL of an image or null to set background or overlay to
	     * @param {Function} callback Callback to invoke when image is loaded and set as background or overlay
	     * @param {Object} [options] Optional options to set for the {@link fabric.Image|image}.
	     */
	    __setBgOverlayImage: function(property, image, callback, options) {
	      if (typeof image === 'string') {
	        fabric.util.loadImage(image, function(img) {
	          if (img) {
	            var instance = new fabric.Image(img, options);
	            this[property] = instance;
	            instance.canvas = this;
	          }
	          callback && callback(img);
	        }, this, options && options.crossOrigin);
	      }
	      else {
	        options && image.setOptions(options);
	        this[property] = image;
	        image && (image.canvas = this);
	        callback && callback(image);
	      }
	
	      return this;
	    },
	
	    /**
	     * @private
	     * @param {String} property Property to set ({@link fabric.StaticCanvas#backgroundColor|backgroundColor}
	     * or {@link fabric.StaticCanvas#overlayColor|overlayColor})
	     * @param {(Object|String|null)} color Object with pattern information, color value or null
	     * @param {Function} [callback] Callback is invoked when color is set
	     */
	    __setBgOverlayColor: function(property, color, callback) {
	      this[property] = color;
	      this._initGradient(color, property);
	      this._initPattern(color, property, callback);
	      return this;
	    },
	
	    /**
	     * @private
	     */
	    _createCanvasElement: function() {
	      var element = createCanvasElement();
	      if (!element) {
	        throw CANVAS_INIT_ERROR;
	      }
	      if (!element.style) {
	        element.style = { };
	      }
	      if (typeof element.getContext === 'undefined') {
	        throw CANVAS_INIT_ERROR;
	      }
	      return element;
	    },
	
	    /**
	     * @private
	     * @param {Object} [options] Options object
	     */
	    _initOptions: function (options) {
	      var lowerCanvasEl = this.lowerCanvasEl;
	      this._setOptions(options);
	
	      this.width = this.width || parseInt(lowerCanvasEl.width, 10) || 0;
	      this.height = this.height || parseInt(lowerCanvasEl.height, 10) || 0;
	
	      if (!this.lowerCanvasEl.style) {
	        return;
	      }
	
	      lowerCanvasEl.width = this.width;
	      lowerCanvasEl.height = this.height;
	
	      lowerCanvasEl.style.width = this.width + 'px';
	      lowerCanvasEl.style.height = this.height + 'px';
	
	      this.viewportTransform = this.viewportTransform.slice();
	    },
	
	    /**
	     * Creates a bottom canvas
	     * @private
	     * @param {HTMLElement} [canvasEl]
	     */
	    _createLowerCanvas: function (canvasEl) {
	      // canvasEl === 'HTMLCanvasElement' does not work on jsdom/node
	      if (canvasEl && canvasEl.getContext) {
	        this.lowerCanvasEl = canvasEl;
	      }
	      else {
	        this.lowerCanvasEl = fabric.util.getById(canvasEl) || this._createCanvasElement();
	      }
	
	      fabric.util.addClass(this.lowerCanvasEl, 'lower-canvas');
	
	      if (this.interactive) {
	        this._applyCanvasStyle(this.lowerCanvasEl);
	      }
	
	      this.contextContainer = this.lowerCanvasEl.getContext('2d');
	    },
	
	    /**
	     * Returns canvas width (in px)
	     * @return {Number}
	     */
	    getWidth: function () {
	      return this.width;
	    },
	
	    /**
	     * Returns canvas height (in px)
	     * @return {Number}
	     */
	    getHeight: function () {
	      return this.height;
	    },
	
	    /**
	     * Sets width of this canvas instance
	     * @param {Number|String} value                         Value to set width to
	     * @param {Object}        [options]                     Options object
	     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
	     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
	     * @return {fabric.Canvas} instance
	     * @chainable true
	     */
	    setWidth: function (value, options) {
	      return this.setDimensions({ width: value }, options);
	    },
	
	    /**
	     * Sets height of this canvas instance
	     * @param {Number|String} value                         Value to set height to
	     * @param {Object}        [options]                     Options object
	     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
	     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
	     * @return {fabric.Canvas} instance
	     * @chainable true
	     */
	    setHeight: function (value, options) {
	      return this.setDimensions({ height: value }, options);
	    },
	
	    /**
	     * Sets dimensions (width, height) of this canvas instance. when options.cssOnly flag active you should also supply the unit of measure (px/%/em)
	     * @param {Object}        dimensions                    Object with width/height properties
	     * @param {Number|String} [dimensions.width]            Width of canvas element
	     * @param {Number|String} [dimensions.height]           Height of canvas element
	     * @param {Object}        [options]                     Options object
	     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
	     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    setDimensions: function (dimensions, options) {
	      var cssValue;
	
	      options = options || {};
	
	      for (var prop in dimensions) {
	        cssValue = dimensions[prop];
	
	        if (!options.cssOnly) {
	          this._setBackstoreDimension(prop, dimensions[prop]);
	          cssValue += 'px';
	          this.hasLostContext = true;
	        }
	
	        if (!options.backstoreOnly) {
	          this._setCssDimension(prop, cssValue);
	        }
	      }
	      if (this._isCurrentlyDrawing) {
	        this.freeDrawingBrush && this.freeDrawingBrush._setBrushStyles();
	      }
	      this._initRetinaScaling();
	      this._setImageSmoothing();
	      this.calcOffset();
	
	      if (!options.cssOnly) {
	        this.requestRenderAll();
	      }
	
	      return this;
	    },
	
	    /**
	     * Helper for setting width/height
	     * @private
	     * @param {String} prop property (width|height)
	     * @param {Number} value value to set property to
	     * @return {fabric.Canvas} instance
	     * @chainable true
	     */
	    _setBackstoreDimension: function (prop, value) {
	      this.lowerCanvasEl[prop] = value;
	
	      if (this.upperCanvasEl) {
	        this.upperCanvasEl[prop] = value;
	      }
	
	      if (this.cacheCanvasEl) {
	        this.cacheCanvasEl[prop] = value;
	      }
	
	      this[prop] = value;
	
	      return this;
	    },
	
	    /**
	     * Helper for setting css width/height
	     * @private
	     * @param {String} prop property (width|height)
	     * @param {String} value value to set property to
	     * @return {fabric.Canvas} instance
	     * @chainable true
	     */
	    _setCssDimension: function (prop, value) {
	      this.lowerCanvasEl.style[prop] = value;
	
	      if (this.upperCanvasEl) {
	        this.upperCanvasEl.style[prop] = value;
	      }
	
	      if (this.wrapperEl) {
	        this.wrapperEl.style[prop] = value;
	      }
	
	      return this;
	    },
	
	    /**
	     * Returns canvas zoom level
	     * @return {Number}
	     */
	    getZoom: function () {
	      return this.viewportTransform[0];
	    },
	
	    /**
	     * Sets viewport transform of this canvas instance
	     * @param {Array} vpt the transform in the form of context.transform
	     * @return {fabric.Canvas} instance
	     * @chainable true
	     */
	    setViewportTransform: function (vpt) {
	      var activeObject = this._activeObject, object, ignoreVpt = false, skipAbsolute = true, i, len;
	      this.viewportTransform = vpt;
	      for (i = 0, len = this._objects.length; i < len; i++) {
	        object = this._objects[i];
	        object.group || object.setCoords(ignoreVpt, skipAbsolute);
	      }
	      if (activeObject && activeObject.type === 'activeSelection') {
	        activeObject.setCoords(ignoreVpt, skipAbsolute);
	      }
	      this.calcViewportBoundaries();
	      this.renderOnAddRemove && this.requestRenderAll();
	      return this;
	    },
	
	    /**
	     * Sets zoom level of this canvas instance, zoom centered around point
	     * @param {fabric.Point} point to zoom with respect to
	     * @param {Number} value to set zoom to, less than 1 zooms out
	     * @return {fabric.Canvas} instance
	     * @chainable true
	     */
	    zoomToPoint: function (point, value) {
	      // TODO: just change the scale, preserve other transformations
	      var before = point, vpt = this.viewportTransform.slice(0);
	      point = transformPoint(point, invertTransform(this.viewportTransform));
	      vpt[0] = value;
	      vpt[3] = value;
	      var after = transformPoint(point, vpt);
	      vpt[4] += before.x - after.x;
	      vpt[5] += before.y - after.y;
	      return this.setViewportTransform(vpt);
	    },
	
	    /**
	     * Sets zoom level of this canvas instance
	     * @param {Number} value to set zoom to, less than 1 zooms out
	     * @return {fabric.Canvas} instance
	     * @chainable true
	     */
	    setZoom: function (value) {
	      this.zoomToPoint(new fabric.Point(0, 0), value);
	      return this;
	    },
	
	    /**
	     * Pan viewport so as to place point at top left corner of canvas
	     * @param {fabric.Point} point to move to
	     * @return {fabric.Canvas} instance
	     * @chainable true
	     */
	    absolutePan: function (point) {
	      var vpt = this.viewportTransform.slice(0);
	      vpt[4] = -point.x;
	      vpt[5] = -point.y;
	      return this.setViewportTransform(vpt);
	    },
	
	    /**
	     * Pans viewpoint relatively
	     * @param {fabric.Point} point (position vector) to move by
	     * @return {fabric.Canvas} instance
	     * @chainable true
	     */
	    relativePan: function (point) {
	      return this.absolutePan(new fabric.Point(
	        -point.x - this.viewportTransform[4],
	        -point.y - this.viewportTransform[5]
	      ));
	    },
	
	    /**
	     * Returns &lt;canvas> element corresponding to this instance
	     * @return {HTMLCanvasElement}
	     */
	    getElement: function () {
	      return this.lowerCanvasEl;
	    },
	
	    /**
	     * @private
	     * @param {fabric.Object} obj Object that was added
	     */
	    _onObjectAdded: function(obj) {
	      this.stateful && obj.setupState();
	      obj._set('canvas', this);
	      obj.setCoords();
	      this.fire('object:added', { target: obj });
	      obj.fire('added');
	    },
	
	    /**
	     * @private
	     * @param {fabric.Object} obj Object that was removed
	     */
	    _onObjectRemoved: function(obj) {
	      this.fire('object:removed', { target: obj });
	      obj.fire('removed');
	      delete obj.canvas;
	    },
	
	    /**
	     * Clears specified context of canvas element
	     * @param {CanvasRenderingContext2D} ctx Context to clear
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    clearContext: function(ctx) {
	      ctx.clearRect(0, 0, this.width, this.height);
	      return this;
	    },
	
	    /**
	     * Returns context of canvas where objects are drawn
	     * @return {CanvasRenderingContext2D}
	     */
	    getContext: function () {
	      return this.contextContainer;
	    },
	
	    /**
	     * Clears all contexts (background, main, top) of an instance
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    clear: function () {
	      this._objects.length = 0;
	      this.backgroundImage = null;
	      this.overlayImage = null;
	      this.backgroundColor = '';
	      this.overlayColor = '';
	      if (this._hasITextHandlers) {
	        this.off('mouse:up', this._mouseUpITextHandler);
	        this._iTextInstances = null;
	        this._hasITextHandlers = false;
	      }
	      this.clearContext(this.contextContainer);
	      this.fire('canvas:cleared');
	      this.renderOnAddRemove && this.requestRenderAll();
	      return this;
	    },
	
	    /**
	     * Renders the canvas
	     * @return {fabric.Canvas} instance
	     * @chainable
	     */
	    renderAll: function () {
	      var canvasToDrawOn = this.contextContainer;
	      this.renderCanvas(canvasToDrawOn, this._objects);
	      return this;
	    },
	
	    /**
	     * Function created to be instance bound at initialization
	     * used in requestAnimationFrame rendering
	     * Let the fabricJS call it. If you call it manually you could have more
	     * animationFrame stacking on to of each other
	     * for an imperative rendering, use canvas.renderAll
	     * @private
	     * @return {fabric.Canvas} instance
	     * @chainable
	     */
	    renderAndReset: function() {
	      this.isRendering = 0;
	      this.renderAll();
	    },
	
	    /**
	     * Append a renderAll request to next animation frame.
	     * unless one is already in progress, in that case nothing is done
	     * a boolean flag will avoid appending more.
	     * @return {fabric.Canvas} instance
	     * @chainable
	     */
	    requestRenderAll: function () {
	      if (!this.isRendering) {
	        this.isRendering = fabric.util.requestAnimFrame(this.renderAndResetBound);
	      }
	      return this;
	    },
	
	    /**
	     * Calculate the position of the 4 corner of canvas with current viewportTransform.
	     * helps to determinate when an object is in the current rendering viewport using
	     * object absolute coordinates ( aCoords )
	     * @return {Object} points.tl
	     * @chainable
	     */
	    calcViewportBoundaries: function() {
	      var points = { }, width = this.width, height = this.height,
	          iVpt = invertTransform(this.viewportTransform);
	      points.tl = transformPoint({ x: 0, y: 0 }, iVpt);
	      points.br = transformPoint({ x: width, y: height }, iVpt);
	      points.tr = new fabric.Point(points.br.x, points.tl.y);
	      points.bl = new fabric.Point(points.tl.x, points.br.y);
	      this.vptCoords = points;
	      return points;
	    },
	
	    cancelRequestedRender: function() {
	      if (this.isRendering) {
	        fabric.util.cancelAnimFrame(this.isRendering);
	        this.isRendering = 0;
	      }
	    },
	
	    /**
	     * Renders background, objects, overlay and controls.
	     * @param {CanvasRenderingContext2D} ctx
	     * @param {Array} objects to render
	     * @return {fabric.Canvas} instance
	     * @chainable
	     */
	    renderCanvas: function(ctx, objects) {
	      var v = this.viewportTransform, path = this.clipPath;
	      this.cancelRequestedRender();
	      this.calcViewportBoundaries();
	      this.clearContext(ctx);
	      this.fire('before:render', { ctx: ctx, });
	      if (this.clipTo) {
	        fabric.util.clipContext(this, ctx);
	      }
	      this._renderBackground(ctx);
	
	      ctx.save();
	      //apply viewport transform once for all rendering process
	      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
	      this._renderObjects(ctx, objects);
	      ctx.restore();
	      if (!this.controlsAboveOverlay && this.interactive) {
	        this.drawControls(ctx);
	      }
	      if (this.clipTo) {
	        ctx.restore();
	      }
	      if (path) {
	        path.canvas = this;
	        // needed to setup a couple of variables
	        path.shouldCache();
	        path._transformDone = true;
	        path.renderCache({ forClipping: true });
	        this.drawClipPathOnCanvas(ctx);
	      }
	      this._renderOverlay(ctx);
	      if (this.controlsAboveOverlay && this.interactive) {
	        this.drawControls(ctx);
	      }
	      this.fire('after:render', { ctx: ctx, });
	    },
	
	    /**
	     * Paint the cached clipPath on the lowerCanvasEl
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    drawClipPathOnCanvas: function(ctx) {
	      var v = this.viewportTransform, path = this.clipPath;
	      ctx.save();
	      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
	      // DEBUG: uncomment this line, comment the following
	      // ctx.globalAlpha = 0.4;
	      ctx.globalCompositeOperation = 'destination-in';
	      path.transform(ctx);
	      ctx.scale(1 / path.zoomX, 1 / path.zoomY);
	      ctx.drawImage(path._cacheCanvas, -path.cacheTranslationX, -path.cacheTranslationY);
	      ctx.restore();
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {Array} objects to render
	     */
	    _renderObjects: function(ctx, objects) {
	      var i, len;
	      for (i = 0, len = objects.length; i < len; ++i) {
	        objects[i] && objects[i].render(ctx);
	      }
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {string} property 'background' or 'overlay'
	     */
	    _renderBackgroundOrOverlay: function(ctx, property) {
	      var fill = this[property + 'Color'], object = this[property + 'Image'],
	          v = this.viewportTransform, needsVpt = this[property + 'Vpt'];
	      if (!fill && !object) {
	        return;
	      }
	      if (fill) {
	        ctx.save();
	        ctx.beginPath();
	        ctx.moveTo(0, 0);
	        ctx.lineTo(this.width, 0);
	        ctx.lineTo(this.width, this.height);
	        ctx.lineTo(0, this.height);
	        ctx.closePath();
	        ctx.fillStyle = fill.toLive
	          ? fill.toLive(ctx, this)
	          : fill;
	        if (needsVpt) {
	          ctx.transform(
	            v[0], v[1], v[2], v[3],
	            v[4] + (fill.offsetX || 0),
	            v[5] + (fill.offsetY || 0)
	          );
	        }
	        var m = fill.gradientTransform || fill.patternTransform;
	        m && ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
	        ctx.fill();
	        ctx.restore();
	      }
	      if (object) {
	        ctx.save();
	        if (needsVpt) {
	          ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
	        }
	        object.render(ctx);
	        ctx.restore();
	      }
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderBackground: function(ctx) {
	      this._renderBackgroundOrOverlay(ctx, 'background');
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderOverlay: function(ctx) {
	      this._renderBackgroundOrOverlay(ctx, 'overlay');
	    },
	
	    /**
	     * Returns coordinates of a center of canvas.
	     * Returned value is an object with top and left properties
	     * @return {Object} object with "top" and "left" number values
	     */
	    getCenter: function () {
	      return {
	        top: this.height / 2,
	        left: this.width / 2
	      };
	    },
	
	    /**
	     * Centers object horizontally in the canvas
	     * @param {fabric.Object} object Object to center horizontally
	     * @return {fabric.Canvas} thisArg
	     */
	    centerObjectH: function (object) {
	      return this._centerObject(object, new fabric.Point(this.getCenter().left, object.getCenterPoint().y));
	    },
	
	    /**
	     * Centers object vertically in the canvas
	     * @param {fabric.Object} object Object to center vertically
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    centerObjectV: function (object) {
	      return this._centerObject(object, new fabric.Point(object.getCenterPoint().x, this.getCenter().top));
	    },
	
	    /**
	     * Centers object vertically and horizontally in the canvas
	     * @param {fabric.Object} object Object to center vertically and horizontally
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    centerObject: function(object) {
	      var center = this.getCenter();
	
	      return this._centerObject(object, new fabric.Point(center.left, center.top));
	    },
	
	    /**
	     * Centers object vertically and horizontally in the viewport
	     * @param {fabric.Object} object Object to center vertically and horizontally
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    viewportCenterObject: function(object) {
	      var vpCenter = this.getVpCenter();
	
	      return this._centerObject(object, vpCenter);
	    },
	
	    /**
	     * Centers object horizontally in the viewport, object.top is unchanged
	     * @param {fabric.Object} object Object to center vertically and horizontally
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    viewportCenterObjectH: function(object) {
	      var vpCenter = this.getVpCenter();
	      this._centerObject(object, new fabric.Point(vpCenter.x, object.getCenterPoint().y));
	      return this;
	    },
	
	    /**
	     * Centers object Vertically in the viewport, object.top is unchanged
	     * @param {fabric.Object} object Object to center vertically and horizontally
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    viewportCenterObjectV: function(object) {
	      var vpCenter = this.getVpCenter();
	
	      return this._centerObject(object, new fabric.Point(object.getCenterPoint().x, vpCenter.y));
	    },
	
	    /**
	     * Calculate the point in canvas that correspond to the center of actual viewport.
	     * @return {fabric.Point} vpCenter, viewport center
	     * @chainable
	     */
	    getVpCenter: function() {
	      var center = this.getCenter(),
	          iVpt = invertTransform(this.viewportTransform);
	      return transformPoint({ x: center.left, y: center.top }, iVpt);
	    },
	
	    /**
	     * @private
	     * @param {fabric.Object} object Object to center
	     * @param {fabric.Point} center Center point
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    _centerObject: function(object, center) {
	      object.setPositionByOrigin(center, 'center', 'center');
	      object.setCoords();
	      this.renderOnAddRemove && this.requestRenderAll();
	      return this;
	    },
	
	    /**
	     * Returs dataless JSON representation of canvas
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {String} json string
	     */
	    toDatalessJSON: function (propertiesToInclude) {
	      return this.toDatalessObject(propertiesToInclude);
	    },
	
	    /**
	     * Returns object representation of canvas
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toObject: function (propertiesToInclude) {
	      return this._toObjectMethod('toObject', propertiesToInclude);
	    },
	
	    /**
	     * Returns dataless object representation of canvas
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toDatalessObject: function (propertiesToInclude) {
	      return this._toObjectMethod('toDatalessObject', propertiesToInclude);
	    },
	
	    /**
	     * @private
	     */
	    _toObjectMethod: function (methodName, propertiesToInclude) {
	
	      var clipPath = this.clipPath, data = {
	        version: fabric.version,
	        objects: this._toObjects(methodName, propertiesToInclude),
	      };
	      if (clipPath) {
	        data.clipPath = this._toObject(this.clipPath, methodName, propertiesToInclude);
	      }
	      extend(data, this.__serializeBgOverlay(methodName, propertiesToInclude));
	
	      fabric.util.populateWithProperties(this, data, propertiesToInclude);
	
	      return data;
	    },
	
	    /**
	     * @private
	     */
	    _toObjects: function(methodName, propertiesToInclude) {
	      return this._objects.filter(function(object) {
	        return !object.excludeFromExport;
	      }).map(function(instance) {
	        return this._toObject(instance, methodName, propertiesToInclude);
	      }, this);
	    },
	
	    /**
	     * @private
	     */
	    _toObject: function(instance, methodName, propertiesToInclude) {
	      var originalValue;
	
	      if (!this.includeDefaultValues) {
	        originalValue = instance.includeDefaultValues;
	        instance.includeDefaultValues = false;
	      }
	
	      var object = instance[methodName](propertiesToInclude);
	      if (!this.includeDefaultValues) {
	        instance.includeDefaultValues = originalValue;
	      }
	      return object;
	    },
	
	    /**
	     * @private
	     */
	    __serializeBgOverlay: function(methodName, propertiesToInclude) {
	      var data = { }, bgImage = this.backgroundImage, overlay = this.overlayImage;
	
	      if (this.backgroundColor) {
	        data.background = this.backgroundColor.toObject
	          ? this.backgroundColor.toObject(propertiesToInclude)
	          : this.backgroundColor;
	      }
	
	      if (this.overlayColor) {
	        data.overlay = this.overlayColor.toObject
	          ? this.overlayColor.toObject(propertiesToInclude)
	          : this.overlayColor;
	      }
	      if (bgImage && !bgImage.excludeFromExport) {
	        data.backgroundImage = this._toObject(bgImage, methodName, propertiesToInclude);
	      }
	      if (overlay && !overlay.excludeFromExport) {
	        data.overlayImage = this._toObject(overlay, methodName, propertiesToInclude);
	      }
	
	      return data;
	    },
	
	    /* _TO_SVG_START_ */
	    /**
	     * When true, getSvgTransform() will apply the StaticCanvas.viewportTransform to the SVG transformation. When true,
	     * a zoomed canvas will then produce zoomed SVG output.
	     * @type Boolean
	     * @default
	     */
	    svgViewportTransformation: true,
	
	    /**
	     * Returns SVG representation of canvas
	     * @function
	     * @param {Object} [options] Options object for SVG output
	     * @param {Boolean} [options.suppressPreamble=false] If true xml tag is not included
	     * @param {Object} [options.viewBox] SVG viewbox object
	     * @param {Number} [options.viewBox.x] x-cooridnate of viewbox
	     * @param {Number} [options.viewBox.y] y-coordinate of viewbox
	     * @param {Number} [options.viewBox.width] Width of viewbox
	     * @param {Number} [options.viewBox.height] Height of viewbox
	     * @param {String} [options.encoding=UTF-8] Encoding of SVG output
	     * @param {String} [options.width] desired width of svg with or without units
	     * @param {String} [options.height] desired height of svg with or without units
	     * @param {Function} [reviver] Method for further parsing of svg elements, called after each fabric object converted into svg representation.
	     * @return {String} SVG string
	     * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
	     * @see {@link http://jsfiddle.net/fabricjs/jQ3ZZ/|jsFiddle demo}
	     * @example <caption>Normal SVG output</caption>
	     * var svg = canvas.toSVG();
	     * @example <caption>SVG output without preamble (without &lt;?xml ../>)</caption>
	     * var svg = canvas.toSVG({suppressPreamble: true});
	     * @example <caption>SVG output with viewBox attribute</caption>
	     * var svg = canvas.toSVG({
	     *   viewBox: {
	     *     x: 100,
	     *     y: 100,
	     *     width: 200,
	     *     height: 300
	     *   }
	     * });
	     * @example <caption>SVG output with different encoding (default: UTF-8)</caption>
	     * var svg = canvas.toSVG({encoding: 'ISO-8859-1'});
	     * @example <caption>Modify SVG output with reviver function</caption>
	     * var svg = canvas.toSVG(null, function(svg) {
	     *   return svg.replace('stroke-dasharray: ; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; ', '');
	     * });
	     */
	    toSVG: function(options, reviver) {
	      options || (options = { });
	      options.reviver = reviver;
	      var markup = [];
	
	      this._setSVGPreamble(markup, options);
	      this._setSVGHeader(markup, options);
	      if (this.clipPath) {
	        markup.push('<g clip-path="url(#' + this.clipPath.clipPathId + ')" >\n');
	      }
	      this._setSVGBgOverlayColor(markup, 'background');
	      this._setSVGBgOverlayImage(markup, 'backgroundImage', reviver);
	      this._setSVGObjects(markup, reviver);
	      if (this.clipPath) {
	        markup.push('</g>\n');
	      }
	      this._setSVGBgOverlayColor(markup, 'overlay');
	      this._setSVGBgOverlayImage(markup, 'overlayImage', reviver);
	
	      markup.push('</svg>');
	
	      return markup.join('');
	    },
	
	    /**
	     * @private
	     */
	    _setSVGPreamble: function(markup, options) {
	      if (options.suppressPreamble) {
	        return;
	      }
	      markup.push(
	        '<?xml version="1.0" encoding="', (options.encoding || 'UTF-8'), '" standalone="no" ?>\n',
	        '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" ',
	        '"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n'
	      );
	    },
	
	    /**
	     * @private
	     */
	    _setSVGHeader: function(markup, options) {
	      var width = options.width || this.width,
	          height = options.height || this.height,
	          vpt, viewBox = 'viewBox="0 0 ' + this.width + ' ' + this.height + '" ',
	          NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;
	
	      if (options.viewBox) {
	        viewBox = 'viewBox="' +
	                options.viewBox.x + ' ' +
	                options.viewBox.y + ' ' +
	                options.viewBox.width + ' ' +
	                options.viewBox.height + '" ';
	      }
	      else {
	        if (this.svgViewportTransformation) {
	          vpt = this.viewportTransform;
	          viewBox = 'viewBox="' +
	                  toFixed(-vpt[4] / vpt[0], NUM_FRACTION_DIGITS) + ' ' +
	                  toFixed(-vpt[5] / vpt[3], NUM_FRACTION_DIGITS) + ' ' +
	                  toFixed(this.width / vpt[0], NUM_FRACTION_DIGITS) + ' ' +
	                  toFixed(this.height / vpt[3], NUM_FRACTION_DIGITS) + '" ';
	        }
	      }
	
	      markup.push(
	        '<svg ',
	        'xmlns="http://www.w3.org/2000/svg" ',
	        'xmlns:xlink="http://www.w3.org/1999/xlink" ',
	        'version="1.1" ',
	        'width="', width, '" ',
	        'height="', height, '" ',
	        viewBox,
	        'xml:space="preserve">\n',
	        '<desc>Created with Fabric.js ', fabric.version, '</desc>\n',
	        '<defs>\n',
	        this.createSVGFontFacesMarkup(),
	        this.createSVGRefElementsMarkup(),
	        this.createSVGClipPathMarkup(options),
	        '</defs>\n'
	      );
	    },
	
	    createSVGClipPathMarkup: function(options) {
	      var clipPath = this.clipPath;
	      if (clipPath) {
	        clipPath.clipPathId = 'CLIPPATH_' + fabric.Object.__uid++;
	        return  '<clipPath id="' + clipPath.clipPathId + '" >\n' +
	          this.clipPath.toClipPathSVG(options.reviver) +
	          '</clipPath>\n';
	      }
	      return '';
	    },
	
	    /**
	     * Creates markup containing SVG referenced elements like patterns, gradients etc.
	     * @return {String}
	     */
	    createSVGRefElementsMarkup: function() {
	      var _this = this,
	          markup = ['background', 'overlay'].map(function(prop) {
	            var fill = _this[prop + 'Color'];
	            if (fill && fill.toLive) {
	              var shouldTransform = _this[prop + 'Vpt'], vpt = _this.viewportTransform,
	                  object = {
	                    width: _this.width / (shouldTransform ? vpt[0] : 1),
	                    height: _this.height / (shouldTransform ? vpt[3] : 1)
	                  };
	              return fill.toSVG(
	                object,
	                { additionalTransform: shouldTransform ? fabric.util.matrixToSVG(vpt) : '' }
	              );
	            }
	          });
	      return markup.join('');
	    },
	
	    /**
	     * Creates markup containing SVG font faces,
	     * font URLs for font faces must be collected by developers
	     * and are not extracted from the DOM by fabricjs
	     * @param {Array} objects Array of fabric objects
	     * @return {String}
	     */
	    createSVGFontFacesMarkup: function() {
	      var markup = '', fontList = { }, obj, fontFamily,
	          style, row, rowIndex, _char, charIndex, i, len,
	          fontPaths = fabric.fontPaths, objects = this._objects;
	
	      for (i = 0, len = objects.length; i < len; i++) {
	        obj = objects[i];
	        fontFamily = obj.fontFamily;
	        if (obj.type.indexOf('text') === -1 || fontList[fontFamily] || !fontPaths[fontFamily]) {
	          continue;
	        }
	        fontList[fontFamily] = true;
	        if (!obj.styles) {
	          continue;
	        }
	        style = obj.styles;
	        for (rowIndex in style) {
	          row = style[rowIndex];
	          for (charIndex in row) {
	            _char = row[charIndex];
	            fontFamily = _char.fontFamily;
	            if (!fontList[fontFamily] && fontPaths[fontFamily]) {
	              fontList[fontFamily] = true;
	            }
	          }
	        }
	      }
	
	      for (var j in fontList) {
	        markup += [
	          '\t\t@font-face {\n',
	          '\t\t\tfont-family: \'', j, '\';\n',
	          '\t\t\tsrc: url(\'', fontPaths[j], '\');\n',
	          '\t\t}\n'
	        ].join('');
	      }
	
	      if (markup) {
	        markup = [
	          '\t<style type="text/css">',
	          '<![CDATA[\n',
	          markup,
	          ']]>',
	          '</style>\n'
	        ].join('');
	      }
	
	      return markup;
	    },
	
	    /**
	     * @private
	     */
	    _setSVGObjects: function(markup, reviver) {
	      var instance, i, len, objects = this._objects;
	      for (i = 0, len = objects.length; i < len; i++) {
	        instance = objects[i];
	        if (instance.excludeFromExport) {
	          continue;
	        }
	        this._setSVGObject(markup, instance, reviver);
	      }
	    },
	
	    /**
	     * @private
	     */
	    _setSVGObject: function(markup, instance, reviver) {
	      markup.push(instance.toSVG(reviver));
	    },
	
	    /**
	     * @private
	     */
	    _setSVGBgOverlayImage: function(markup, property, reviver) {
	      if (this[property] && !this[property].excludeFromExport && this[property].toSVG) {
	        markup.push(this[property].toSVG(reviver));
	      }
	    },
	
	    /**
	     * @private
	     */
	    _setSVGBgOverlayColor: function(markup, property) {
	      var filler = this[property + 'Color'], vpt = this.viewportTransform, finalWidth = this.width,
	          finalHeight = this.height;
	      if (!filler) {
	        return;
	      }
	      if (filler.toLive) {
	        var repeat = filler.repeat, iVpt = fabric.util.invertTransform(vpt), shouldInvert = this[property + 'Vpt'],
	            additionalTransform = shouldInvert ? fabric.util.matrixToSVG(iVpt) : '';
	        markup.push(
	          '<rect transform="' + additionalTransform + ' translate(', finalWidth / 2, ',', finalHeight / 2, ')"',
	          ' x="', filler.offsetX - finalWidth / 2,
	          '" y="', filler.offsetY - finalHeight / 2, '" ',
	          'width="',
	          (repeat === 'repeat-y' || repeat === 'no-repeat'
	            ? filler.source.width
	            : finalWidth ),
	          '" height="',
	          (repeat === 'repeat-x' || repeat === 'no-repeat'
	            ? filler.source.height
	            : finalHeight),
	          '" fill="url(#SVGID_' + filler.id + ')"',
	          '></rect>\n'
	        );
	      }
	      else {
	        markup.push(
	          '<rect x="0" y="0" width="100%" height="100%" ',
	          'fill="', filler, '"',
	          '></rect>\n'
	        );
	      }
	    },
	    /* _TO_SVG_END_ */
	
	    /**
	     * Moves an object or the objects of a multiple selection
	     * to the bottom of the stack of drawn objects
	     * @param {fabric.Object} object Object to send to back
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    sendToBack: function (object) {
	      if (!object) {
	        return this;
	      }
	      var activeSelection = this._activeObject,
	          i, obj, objs;
	      if (object === activeSelection && object.type === 'activeSelection') {
	        objs = activeSelection._objects;
	        for (i = objs.length; i--;) {
	          obj = objs[i];
	          removeFromArray(this._objects, obj);
	          this._objects.unshift(obj);
	        }
	      }
	      else {
	        removeFromArray(this._objects, object);
	        this._objects.unshift(object);
	      }
	      this.renderOnAddRemove && this.requestRenderAll();
	      return this;
	    },
	
	    /**
	     * Moves an object or the objects of a multiple selection
	     * to the top of the stack of drawn objects
	     * @param {fabric.Object} object Object to send
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    bringToFront: function (object) {
	      if (!object) {
	        return this;
	      }
	      var activeSelection = this._activeObject,
	          i, obj, objs;
	      if (object === activeSelection && object.type === 'activeSelection') {
	        objs = activeSelection._objects;
	        for (i = 0; i < objs.length; i++) {
	          obj = objs[i];
	          removeFromArray(this._objects, obj);
	          this._objects.push(obj);
	        }
	      }
	      else {
	        removeFromArray(this._objects, object);
	        this._objects.push(object);
	      }
	      this.renderOnAddRemove && this.requestRenderAll();
	      return this;
	    },
	
	    /**
	     * Moves an object or a selection down in stack of drawn objects
	     * An optional paramter, intersecting allowes to move the object in behind
	     * the first intersecting object. Where intersection is calculated with
	     * bounding box. If no intersection is found, there will not be change in the
	     * stack.
	     * @param {fabric.Object} object Object to send
	     * @param {Boolean} [intersecting] If `true`, send object behind next lower intersecting object
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    sendBackwards: function (object, intersecting) {
	      if (!object) {
	        return this;
	      }
	      var activeSelection = this._activeObject,
	          i, obj, idx, newIdx, objs, objsMoved = 0;
	
	      if (object === activeSelection && object.type === 'activeSelection') {
	        objs = activeSelection._objects;
	        for (i = 0; i < objs.length; i++) {
	          obj = objs[i];
	          idx = this._objects.indexOf(obj);
	          if (idx > 0 + objsMoved) {
	            newIdx = idx - 1;
	            removeFromArray(this._objects, obj);
	            this._objects.splice(newIdx, 0, obj);
	          }
	          objsMoved++;
	        }
	      }
	      else {
	        idx = this._objects.indexOf(object);
	        if (idx !== 0) {
	          // if object is not on the bottom of stack
	          newIdx = this._findNewLowerIndex(object, idx, intersecting);
	          removeFromArray(this._objects, object);
	          this._objects.splice(newIdx, 0, object);
	        }
	      }
	      this.renderOnAddRemove && this.requestRenderAll();
	      return this;
	    },
	
	    /**
	     * @private
	     */
	    _findNewLowerIndex: function(object, idx, intersecting) {
	      var newIdx, i;
	
	      if (intersecting) {
	        newIdx = idx;
	
	        // traverse down the stack looking for the nearest intersecting object
	        for (i = idx - 1; i >= 0; --i) {
	
	          var isIntersecting = object.intersectsWithObject(this._objects[i]) ||
	                               object.isContainedWithinObject(this._objects[i]) ||
	                               this._objects[i].isContainedWithinObject(object);
	
	          if (isIntersecting) {
	            newIdx = i;
	            break;
	          }
	        }
	      }
	      else {
	        newIdx = idx - 1;
	      }
	
	      return newIdx;
	    },
	
	    /**
	     * Moves an object or a selection up in stack of drawn objects
	     * An optional paramter, intersecting allowes to move the object in front
	     * of the first intersecting object. Where intersection is calculated with
	     * bounding box. If no intersection is found, there will not be change in the
	     * stack.
	     * @param {fabric.Object} object Object to send
	     * @param {Boolean} [intersecting] If `true`, send object in front of next upper intersecting object
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    bringForward: function (object, intersecting) {
	      if (!object) {
	        return this;
	      }
	      var activeSelection = this._activeObject,
	          i, obj, idx, newIdx, objs, objsMoved = 0;
	
	      if (object === activeSelection && object.type === 'activeSelection') {
	        objs = activeSelection._objects;
	        for (i = objs.length; i--;) {
	          obj = objs[i];
	          idx = this._objects.indexOf(obj);
	          if (idx < this._objects.length - 1 - objsMoved) {
	            newIdx = idx + 1;
	            removeFromArray(this._objects, obj);
	            this._objects.splice(newIdx, 0, obj);
	          }
	          objsMoved++;
	        }
	      }
	      else {
	        idx = this._objects.indexOf(object);
	        if (idx !== this._objects.length - 1) {
	          // if object is not on top of stack (last item in an array)
	          newIdx = this._findNewUpperIndex(object, idx, intersecting);
	          removeFromArray(this._objects, object);
	          this._objects.splice(newIdx, 0, object);
	        }
	      }
	      this.renderOnAddRemove && this.requestRenderAll();
	      return this;
	    },
	
	    /**
	     * @private
	     */
	    _findNewUpperIndex: function(object, idx, intersecting) {
	      var newIdx, i, len;
	
	      if (intersecting) {
	        newIdx = idx;
	
	        // traverse up the stack looking for the nearest intersecting object
	        for (i = idx + 1, len = this._objects.length; i < len; ++i) {
	
	          var isIntersecting = object.intersectsWithObject(this._objects[i]) ||
	                               object.isContainedWithinObject(this._objects[i]) ||
	                               this._objects[i].isContainedWithinObject(object);
	
	          if (isIntersecting) {
	            newIdx = i;
	            break;
	          }
	        }
	      }
	      else {
	        newIdx = idx + 1;
	      }
	
	      return newIdx;
	    },
	
	    /**
	     * Moves an object to specified level in stack of drawn objects
	     * @param {fabric.Object} object Object to send
	     * @param {Number} index Position to move to
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    moveTo: function (object, index) {
	      removeFromArray(this._objects, object);
	      this._objects.splice(index, 0, object);
	      return this.renderOnAddRemove && this.requestRenderAll();
	    },
	
	    /**
	     * Clears a canvas element and dispose objects
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    dispose: function () {
	      // cancel eventually ongoing renders
	      if (this.isRendering) {
	        fabric.util.cancelAnimFrame(this.isRendering);
	        this.isRendering = 0;
	      }
	      this.forEachObject(function(object) {
	        object.dispose && object.dispose();
	      });
	      this._objects = [];
	      if (this.backgroundImage && this.backgroundImage.dispose) {
	        this.backgroundImage.dispose();
	      }
	      this.backgroundImage = null;
	      if (this.overlayImage && this.overlayImage.dispose) {
	        this.overlayImage.dispose();
	      }
	      this.overlayImage = null;
	      this._iTextInstances = null;
	      this.contextContainer = null;
	      fabric.util.cleanUpJsdomNode(this.lowerCanvasEl);
	      this.lowerCanvasEl = undefined;
	      return this;
	    },
	
	    /**
	     * Returns a string representation of an instance
	     * @return {String} string representation of an instance
	     */
	    toString: function () {
	      return '#<fabric.Canvas (' + this.complexity() + '): ' +
	               '{ objects: ' + this._objects.length + ' }>';
	    }
	  });
	
	  extend(fabric.StaticCanvas.prototype, fabric.Observable);
	  extend(fabric.StaticCanvas.prototype, fabric.Collection);
	  extend(fabric.StaticCanvas.prototype, fabric.DataURLExporter);
	
	  extend(fabric.StaticCanvas, /** @lends fabric.StaticCanvas */ {
	
	    /**
	     * @static
	     * @type String
	     * @default
	     */
	    EMPTY_JSON: '{"objects": [], "background": "white"}',
	
	    /**
	     * Provides a way to check support of some of the canvas methods
	     * (either those of HTMLCanvasElement itself, or rendering context)
	     *
	     * @param {String} methodName Method to check support for;
	     *                            Could be one of "setLineDash"
	     * @return {Boolean | null} `true` if method is supported (or at least exists),
	     *                          `null` if canvas element or context can not be initialized
	     */
	    supports: function (methodName) {
	      var el = createCanvasElement();
	
	      if (!el || !el.getContext) {
	        return null;
	      }
	
	      var ctx = el.getContext('2d');
	      if (!ctx) {
	        return null;
	      }
	
	      switch (methodName) {
	
	        case 'setLineDash':
	          return typeof ctx.setLineDash !== 'undefined';
	
	        default:
	          return null;
	      }
	    }
	  });
	
	  /**
	   * Returns JSON representation of canvas
	   * @function
	   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	   * @return {String} JSON string
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
	   * @see {@link http://jsfiddle.net/fabricjs/pec86/|jsFiddle demo}
	   * @example <caption>JSON without additional properties</caption>
	   * var json = canvas.toJSON();
	   * @example <caption>JSON with additional properties included</caption>
	   * var json = canvas.toJSON(['lockMovementX', 'lockMovementY', 'lockRotation', 'lockScalingX', 'lockScalingY', 'lockUniScaling']);
	   * @example <caption>JSON without default values</caption>
	   * canvas.includeDefaultValues = false;
	   * var json = canvas.toJSON();
	   */
	  fabric.StaticCanvas.prototype.toJSON = fabric.StaticCanvas.prototype.toObject;
	
	  if (fabric.isLikelyNode) {
	    fabric.StaticCanvas.prototype.createPNGStream = function() {
	      var impl = getNodeCanvas(this.lowerCanvasEl);
	      return impl && impl.createPNGStream();
	    };
	    fabric.StaticCanvas.prototype.createJPEGStream = function(opts) {
	      var impl = getNodeCanvas(this.lowerCanvasEl);
	      return impl && impl.createJPEGStream(opts);
	    };
	  }
	})();
	
	
	/**
	 * BaseBrush class
	 * @class fabric.BaseBrush
	 * @see {@link http://fabricjs.com/freedrawing|Freedrawing demo}
	 */
	fabric.BaseBrush = fabric.util.createClass(/** @lends fabric.BaseBrush.prototype */ {
	
	  /**
	   * Color of a brush
	   * @type String
	   * @default
	   */
	  color: 'rgb(0, 0, 0)',
	
	  /**
	   * Width of a brush, has to be a Number, no string literals
	   * @type Number
	   * @default
	   */
	  width: 1,
	
	  /**
	   * Shadow object representing shadow of this shape.
	   * <b>Backwards incompatibility note:</b> This property replaces "shadowColor" (String), "shadowOffsetX" (Number),
	   * "shadowOffsetY" (Number) and "shadowBlur" (Number) since v1.2.12
	   * @type fabric.Shadow
	   * @default
	   */
	  shadow: null,
	
	  /**
	   * Line endings style of a brush (one of "butt", "round", "square")
	   * @type String
	   * @default
	   */
	  strokeLineCap: 'round',
	
	  /**
	   * Corner style of a brush (one of "bevel", "round", "miter")
	   * @type String
	   * @default
	   */
	  strokeLineJoin: 'round',
	
	  /**
	   * Maximum miter length (used for strokeLineJoin = "miter") of a brush's
	   * @type Number
	   * @default
	   */
	  strokeMiterLimit:         10,
	
	  /**
	   * Stroke Dash Array.
	   * @type Array
	   * @default
	   */
	  strokeDashArray: null,
	
	  /**
	   * Sets shadow of an object
	   * @param {Object|String} [options] Options object or string (e.g. "2px 2px 10px rgba(0,0,0,0.2)")
	   * @return {fabric.Object} thisArg
	   * @chainable
	   */
	  setShadow: function(options) {
	    this.shadow = new fabric.Shadow(options);
	    return this;
	  },
	
	  /**
	   * Sets brush styles
	   * @private
	   */
	  _setBrushStyles: function() {
	    var ctx = this.canvas.contextTop;
	    ctx.strokeStyle = this.color;
	    ctx.lineWidth = this.width;
	    ctx.lineCap = this.strokeLineCap;
	    ctx.miterLimit = this.strokeMiterLimit;
	    ctx.lineJoin = this.strokeLineJoin;
	    if (fabric.StaticCanvas.supports('setLineDash')) {
	      ctx.setLineDash(this.strokeDashArray || []);
	    }
	  },
	
	  /**
	   * Sets the transformation on given context
	   * @param {RenderingContext2d} ctx context to render on
	   * @private
	   */
	  _saveAndTransform: function(ctx) {
	    var v = this.canvas.viewportTransform;
	    ctx.save();
	    ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
	  },
	
	  /**
	   * Sets brush shadow styles
	   * @private
	   */
	  _setShadow: function() {
	    if (!this.shadow) {
	      return;
	    }
	
	    var ctx = this.canvas.contextTop,
	        zoom = this.canvas.getZoom();
	
	    ctx.shadowColor = this.shadow.color;
	    ctx.shadowBlur = this.shadow.blur * zoom;
	    ctx.shadowOffsetX = this.shadow.offsetX * zoom;
	    ctx.shadowOffsetY = this.shadow.offsetY * zoom;
	  },
	
	  needsFullRender: function() {
	    var color = new fabric.Color(this.color);
	    return color.getAlpha() < 1 || !!this.shadow;
	  },
	
	  /**
	   * Removes brush shadow styles
	   * @private
	   */
	  _resetShadow: function() {
	    var ctx = this.canvas.contextTop;
	
	    ctx.shadowColor = '';
	    ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
	  }
	});
	
	
	(function() {
	  /**
	   * PencilBrush class
	   * @class fabric.PencilBrush
	   * @extends fabric.BaseBrush
	   */
	  fabric.PencilBrush = fabric.util.createClass(fabric.BaseBrush, /** @lends fabric.PencilBrush.prototype */ {
	
	    /**
	     * Discard points that are less than `decimate` pixel distant from each other
	     * @type Number
	     * @default 0.4
	     */
	    decimate: 0.4,
	
	    /**
	     * Constructor
	     * @param {fabric.Canvas} canvas
	     * @return {fabric.PencilBrush} Instance of a pencil brush
	     */
	    initialize: function(canvas) {
	      this.canvas = canvas;
	      this._points = [];
	    },
	
	    /**
	     * Invoked inside on mouse down and mouse move
	     * @param {Object} pointer
	     */
	    _drawSegment: function (ctx, p1, p2) {
	      var midPoint = p1.midPointFrom(p2);
	      ctx.quadraticCurveTo(p1.x, p1.y, midPoint.x, midPoint.y);
	      return midPoint;
	    },
	
	    /**
	     * Inovoked on mouse down
	     * @param {Object} pointer
	     */
	    onMouseDown: function(pointer, options) {
	      if (!this.canvas._isMainEvent(options.e)) {
	        return;
	      }
	      this._prepareForDrawing(pointer);
	      // capture coordinates immediately
	      // this allows to draw dots (when movement never occurs)
	      this._captureDrawingPath(pointer);
	      this._render();
	    },
	
	    /**
	     * Inovoked on mouse move
	     * @param {Object} pointer
	     */
	    onMouseMove: function(pointer, options) {
	      if (!this.canvas._isMainEvent(options.e)) {
	        return;
	      }
	      if (this._captureDrawingPath(pointer) && this._points.length > 1) {
	        if (this.needsFullRender()) {
	          // redraw curve
	          // clear top canvas
	          this.canvas.clearContext(this.canvas.contextTop);
	          this._render();
	        }
	        else {
	          var points = this._points, length = points.length, ctx = this.canvas.contextTop;
	          // draw the curve update
	          this._saveAndTransform(ctx);
	          if (this.oldEnd) {
	            ctx.beginPath();
	            ctx.moveTo(this.oldEnd.x, this.oldEnd.y);
	          }
	          this.oldEnd = this._drawSegment(ctx, points[length - 2], points[length - 1], true);
	          ctx.stroke();
	          ctx.restore();
	        }
	      }
	    },
	
	    /**
	     * Invoked on mouse up
	     */
	    onMouseUp: function(options) {
	      if (!this.canvas._isMainEvent(options.e)) {
	        return true;
	      }
	      this.oldEnd = undefined;
	      this._finalizeAndAddPath();
	      return false;
	    },
	
	    /**
	     * @private
	     * @param {Object} pointer Actual mouse position related to the canvas.
	     */
	    _prepareForDrawing: function(pointer) {
	
	      var p = new fabric.Point(pointer.x, pointer.y);
	
	      this._reset();
	      this._addPoint(p);
	      this.canvas.contextTop.moveTo(p.x, p.y);
	    },
	
	    /**
	     * @private
	     * @param {fabric.Point} point Point to be added to points array
	     */
	    _addPoint: function(point) {
	      if (this._points.length > 1 && point.eq(this._points[this._points.length - 1])) {
	        return false;
	      }
	      this._points.push(point);
	      return true;
	    },
	
	    /**
	     * Clear points array and set contextTop canvas style.
	     * @private
	     */
	    _reset: function() {
	      this._points = [];
	      this._setBrushStyles();
	      this._setShadow();
	    },
	
	    /**
	     * @private
	     * @param {Object} pointer Actual mouse position related to the canvas.
	     */
	    _captureDrawingPath: function(pointer) {
	      var pointerPoint = new fabric.Point(pointer.x, pointer.y);
	      return this._addPoint(pointerPoint);
	    },
	
	    /**
	     * Draw a smooth path on the topCanvas using quadraticCurveTo
	     * @private
	     */
	    _render: function() {
	      var ctx  = this.canvas.contextTop, i, len,
	          p1 = this._points[0],
	          p2 = this._points[1];
	
	      this._saveAndTransform(ctx);
	      ctx.beginPath();
	      //if we only have 2 points in the path and they are the same
	      //it means that the user only clicked the canvas without moving the mouse
	      //then we should be drawing a dot. A path isn't drawn between two identical dots
	      //that's why we set them apart a bit
	      if (this._points.length === 2 && p1.x === p2.x && p1.y === p2.y) {
	        var width = this.width / 1000;
	        p1 = new fabric.Point(p1.x, p1.y);
	        p2 = new fabric.Point(p2.x, p2.y);
	        p1.x -= width;
	        p2.x += width;
	      }
	      ctx.moveTo(p1.x, p1.y);
	
	      for (i = 1, len = this._points.length; i < len; i++) {
	        // we pick the point between pi + 1 & pi + 2 as the
	        // end point and p1 as our control point.
	        this._drawSegment(ctx, p1, p2);
	        p1 = this._points[i];
	        p2 = this._points[i + 1];
	      }
	      // Draw last line as a straight line while
	      // we wait for the next point to be able to calculate
	      // the bezier control point
	      ctx.lineTo(p1.x, p1.y);
	      ctx.stroke();
	      ctx.restore();
	    },
	
	    /**
	     * Converts points to SVG path
	     * @param {Array} points Array of points
	     * @return {String} SVG path
	     */
	    convertPointsToSVGPath: function(points) {
	      var path = [], i, width = this.width / 1000,
	          p1 = new fabric.Point(points[0].x, points[0].y),
	          p2 = new fabric.Point(points[1].x, points[1].y),
	          len = points.length, multSignX = 1, multSignY = 0, manyPoints = len > 2;
	
	      if (manyPoints) {
	        multSignX = points[2].x < p2.x ? -1 : points[2].x === p2.x ? 0 : 1;
	        multSignY = points[2].y < p2.y ? -1 : points[2].y === p2.y ? 0 : 1;
	      }
	      path.push('M ', p1.x - multSignX * width, ' ', p1.y - multSignY * width, ' ');
	      for (i = 1; i < len; i++) {
	        if (!p1.eq(p2)) {
	          var midPoint = p1.midPointFrom(p2);
	          // p1 is our bezier control point
	          // midpoint is our endpoint
	          // start point is p(i-1) value.
	          path.push('Q ', p1.x, ' ', p1.y, ' ', midPoint.x, ' ', midPoint.y, ' ');
	        }
	        p1 = points[i];
	        if ((i + 1) < points.length) {
	          p2 = points[i + 1];
	        }
	      }
	      if (manyPoints) {
	        multSignX = p1.x > points[i - 2].x ? 1 : p1.x === points[i - 2].x ? 0 : -1;
	        multSignY = p1.y > points[i - 2].y ? 1 : p1.y === points[i - 2].y ? 0 : -1;
	      }
	      path.push('L ', p1.x + multSignX * width, ' ', p1.y + multSignY * width);
	      return path;
	    },
	
	    /**
	     * Creates fabric.Path object to add on canvas
	     * @param {String} pathData Path data
	     * @return {fabric.Path} Path to add on canvas
	     */
	    createPath: function(pathData) {
	      var path = new fabric.Path(pathData, {
	        fill: null,
	        stroke: this.color,
	        strokeWidth: this.width,
	        strokeLineCap: this.strokeLineCap,
	        strokeMiterLimit: this.strokeMiterLimit,
	        strokeLineJoin: this.strokeLineJoin,
	        strokeDashArray: this.strokeDashArray,
	      });
	      if (this.shadow) {
	        this.shadow.affectStroke = true;
	        path.setShadow(this.shadow);
	      }
	
	      return path;
	    },
	
	    /**
	     * Decimate poins array with the decimate value
	     */
	    decimatePoints: function(points, distance) {
	      if (points.length <= 2) {
	        return points;
	      }
	      var zoom = this.canvas.getZoom(), adjustedDistance = Math.pow(distance / zoom, 2),
	          i, l = points.length - 1, lastPoint = points[0], newPoints = [lastPoint],
	          cDistance;
	      for (i = 1; i < l; i++) {
	        cDistance = Math.pow(lastPoint.x - points[i].x, 2) + Math.pow(lastPoint.y - points[i].y, 2);
	        if (cDistance >= adjustedDistance) {
	          lastPoint = points[i];
	          newPoints.push(lastPoint);
	        }
	      }
	      if (newPoints.length === 1) {
	        newPoints.push(new fabric.Point(newPoints[0].x, newPoints[0].y));
	      }
	      return newPoints;
	    },
	
	    /**
	     * On mouseup after drawing the path on contextTop canvas
	     * we use the points captured to create an new fabric path object
	     * and add it to the fabric canvas.
	     */
	    _finalizeAndAddPath: function() {
	      var ctx = this.canvas.contextTop;
	      ctx.closePath();
	      if (this.decimate) {
	        this._points = this.decimatePoints(this._points, this.decimate);
	      }
	      var pathData = this.convertPointsToSVGPath(this._points).join('');
	      if (pathData === 'M 0 0 Q 0 0 0 0 L 0 0') {
	        // do not create 0 width/height paths, as they are
	        // rendered inconsistently across browsers
	        // Firefox 4, for example, renders a dot,
	        // whereas Chrome 10 renders nothing
	        this.canvas.requestRenderAll();
	        return;
	      }
	
	      var path = this.createPath(pathData);
	      this.canvas.clearContext(this.canvas.contextTop);
	      this.canvas.add(path);
	      this.canvas.renderAll();
	      path.setCoords();
	      this._resetShadow();
	
	
	      // fire event 'path' created
	      this.canvas.fire('path:created', { path: path });
	    }
	  });
	})();
	
	
	/**
	 * CircleBrush class
	 * @class fabric.CircleBrush
	 */
	fabric.CircleBrush = fabric.util.createClass(fabric.BaseBrush, /** @lends fabric.CircleBrush.prototype */ {
	
	  /**
	   * Width of a brush
	   * @type Number
	   * @default
	   */
	  width: 10,
	
	  /**
	   * Constructor
	   * @param {fabric.Canvas} canvas
	   * @return {fabric.CircleBrush} Instance of a circle brush
	   */
	  initialize: function(canvas) {
	    this.canvas = canvas;
	    this.points = [];
	  },
	
	  /**
	   * Invoked inside on mouse down and mouse move
	   * @param {Object} pointer
	   */
	  drawDot: function(pointer) {
	    var point = this.addPoint(pointer),
	        ctx = this.canvas.contextTop;
	    this._saveAndTransform(ctx);
	    this.dot(ctx, point);
	    ctx.restore();
	  },
	
	  dot: function(ctx, point) {
	    ctx.fillStyle = point.fill;
	    ctx.beginPath();
	    ctx.arc(point.x, point.y, point.radius, 0, Math.PI * 2, false);
	    ctx.closePath();
	    ctx.fill();
	  },
	
	  /**
	   * Invoked on mouse down
	   */
	  onMouseDown: function(pointer) {
	    this.points.length = 0;
	    this.canvas.clearContext(this.canvas.contextTop);
	    this._setShadow();
	    this.drawDot(pointer);
	  },
	
	  /**
	   * Render the full state of the brush
	   * @private
	   */
	  _render: function() {
	    var ctx  = this.canvas.contextTop, i, len,
	        points = this.points;
	    this._saveAndTransform(ctx);
	    for (i = 0, len = points.length; i < len; i++) {
	      this.dot(ctx, points[i]);
	    }
	    ctx.restore();
	  },
	
	  /**
	   * Invoked on mouse move
	   * @param {Object} pointer
	   */
	  onMouseMove: function(pointer) {
	    if (this.needsFullRender()) {
	      this.canvas.clearContext(this.canvas.contextTop);
	      this.addPoint(pointer);
	      this._render();
	    }
	    else {
	      this.drawDot(pointer);
	    }
	  },
	
	  /**
	   * Invoked on mouse up
	   */
	  onMouseUp: function() {
	    var originalRenderOnAddRemove = this.canvas.renderOnAddRemove, i, len;
	    this.canvas.renderOnAddRemove = false;
	
	    var circles = [];
	
	    for (i = 0, len = this.points.length; i < len; i++) {
	      var point = this.points[i],
	          circle = new fabric.Circle({
	            radius: point.radius,
	            left: point.x,
	            top: point.y,
	            originX: 'center',
	            originY: 'center',
	            fill: point.fill
	          });
	
	      this.shadow && circle.setShadow(this.shadow);
	
	      circles.push(circle);
	    }
	    var group = new fabric.Group(circles);
	    group.canvas = this.canvas;
	
	    this.canvas.add(group);
	    this.canvas.fire('path:created', { path: group });
	
	    this.canvas.clearContext(this.canvas.contextTop);
	    this._resetShadow();
	    this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
	    this.canvas.requestRenderAll();
	  },
	
	  /**
	   * @param {Object} pointer
	   * @return {fabric.Point} Just added pointer point
	   */
	  addPoint: function(pointer) {
	    var pointerPoint = new fabric.Point(pointer.x, pointer.y),
	
	        circleRadius = fabric.util.getRandomInt(
	          Math.max(0, this.width - 20), this.width + 20) / 2,
	
	        circleColor = new fabric.Color(this.color)
	          .setAlpha(fabric.util.getRandomInt(0, 100) / 100)
	          .toRgba();
	
	    pointerPoint.radius = circleRadius;
	    pointerPoint.fill = circleColor;
	
	    this.points.push(pointerPoint);
	
	    return pointerPoint;
	  }
	});
	
	
	/**
	 * SprayBrush class
	 * @class fabric.SprayBrush
	 */
	fabric.SprayBrush = fabric.util.createClass( fabric.BaseBrush, /** @lends fabric.SprayBrush.prototype */ {
	
	  /**
	   * Width of a spray
	   * @type Number
	   * @default
	   */
	  width:              10,
	
	  /**
	   * Density of a spray (number of dots per chunk)
	   * @type Number
	   * @default
	   */
	  density:            20,
	
	  /**
	   * Width of spray dots
	   * @type Number
	   * @default
	   */
	  dotWidth:           1,
	
	  /**
	   * Width variance of spray dots
	   * @type Number
	   * @default
	   */
	  dotWidthVariance:   1,
	
	  /**
	   * Whether opacity of a dot should be random
	   * @type Boolean
	   * @default
	   */
	  randomOpacity:        false,
	
	  /**
	   * Whether overlapping dots (rectangles) should be removed (for performance reasons)
	   * @type Boolean
	   * @default
	   */
	  optimizeOverlapping:  true,
	
	  /**
	   * Constructor
	   * @param {fabric.Canvas} canvas
	   * @return {fabric.SprayBrush} Instance of a spray brush
	   */
	  initialize: function(canvas) {
	    this.canvas = canvas;
	    this.sprayChunks = [];
	  },
	
	  /**
	   * Invoked on mouse down
	   * @param {Object} pointer
	   */
	  onMouseDown: function(pointer) {
	    this.sprayChunks.length = 0;
	    this.canvas.clearContext(this.canvas.contextTop);
	    this._setShadow();
	
	    this.addSprayChunk(pointer);
	    this.render(this.sprayChunkPoints);
	  },
	
	  /**
	   * Invoked on mouse move
	   * @param {Object} pointer
	   */
	  onMouseMove: function(pointer) {
	    this.addSprayChunk(pointer);
	    this.render(this.sprayChunkPoints);
	  },
	
	  /**
	   * Invoked on mouse up
	   */
	  onMouseUp: function() {
	    var originalRenderOnAddRemove = this.canvas.renderOnAddRemove;
	    this.canvas.renderOnAddRemove = false;
	
	    var rects = [];
	
	    for (var i = 0, ilen = this.sprayChunks.length; i < ilen; i++) {
	      var sprayChunk = this.sprayChunks[i];
	
	      for (var j = 0, jlen = sprayChunk.length; j < jlen; j++) {
	
	        var rect = new fabric.Rect({
	          width: sprayChunk[j].width,
	          height: sprayChunk[j].width,
	          left: sprayChunk[j].x + 1,
	          top: sprayChunk[j].y + 1,
	          originX: 'center',
	          originY: 'center',
	          fill: this.color
	        });
	        rects.push(rect);
	      }
	    }
	
	    if (this.optimizeOverlapping) {
	      rects = this._getOptimizedRects(rects);
	    }
	
	    var group = new fabric.Group(rects);
	    this.shadow && group.setShadow(this.shadow);
	    this.canvas.add(group);
	    this.canvas.fire('path:created', { path: group });
	
	    this.canvas.clearContext(this.canvas.contextTop);
	    this._resetShadow();
	    this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
	    this.canvas.requestRenderAll();
	  },
	
	  /**
	   * @private
	   * @param {Array} rects
	   */
	  _getOptimizedRects: function(rects) {
	
	    // avoid creating duplicate rects at the same coordinates
	    var uniqueRects = { }, key, i, len;
	
	    for (i = 0, len = rects.length; i < len; i++) {
	      key = rects[i].left + '' + rects[i].top;
	      if (!uniqueRects[key]) {
	        uniqueRects[key] = rects[i];
	      }
	    }
	    var uniqueRectsArray = [];
	    for (key in uniqueRects) {
	      uniqueRectsArray.push(uniqueRects[key]);
	    }
	
	    return uniqueRectsArray;
	  },
	
	  /**
	   * Render new chunk of spray brush
	   */
	  render: function(sprayChunk) {
	    var ctx = this.canvas.contextTop, i, len;
	    ctx.fillStyle = this.color;
	
	    this._saveAndTransform(ctx);
	
	    for (i = 0, len = sprayChunk.length; i < len; i++) {
	      var point = sprayChunk[i];
	      if (typeof point.opacity !== 'undefined') {
	        ctx.globalAlpha = point.opacity;
	      }
	      ctx.fillRect(point.x, point.y, point.width, point.width);
	    }
	    ctx.restore();
	  },
	
	  /**
	   * Render all spray chunks
	   */
	  _render: function() {
	    var ctx = this.canvas.contextTop, i, ilen;
	    ctx.fillStyle = this.color;
	
	    this._saveAndTransform(ctx);
	
	    for (i = 0, ilen = this.sprayChunks.length; i < ilen; i++) {
	      this.render(this.sprayChunks[i]);
	    }
	    ctx.restore();
	  },
	
	  /**
	   * @param {Object} pointer
	   */
	  addSprayChunk: function(pointer) {
	    this.sprayChunkPoints = [];
	
	    var x, y, width, radius = this.width / 2, i;
	
	    for (i = 0; i < this.density; i++) {
	
	      x = fabric.util.getRandomInt(pointer.x - radius, pointer.x + radius);
	      y = fabric.util.getRandomInt(pointer.y - radius, pointer.y + radius);
	
	      if (this.dotWidthVariance) {
	        width = fabric.util.getRandomInt(
	          // bottom clamp width to 1
	          Math.max(1, this.dotWidth - this.dotWidthVariance),
	          this.dotWidth + this.dotWidthVariance);
	      }
	      else {
	        width = this.dotWidth;
	      }
	
	      var point = new fabric.Point(x, y);
	      point.width = width;
	
	      if (this.randomOpacity) {
	        point.opacity = fabric.util.getRandomInt(0, 100) / 100;
	      }
	
	      this.sprayChunkPoints.push(point);
	    }
	
	    this.sprayChunks.push(this.sprayChunkPoints);
	  }
	});
	
	
	/**
	 * PatternBrush class
	 * @class fabric.PatternBrush
	 * @extends fabric.BaseBrush
	 */
	fabric.PatternBrush = fabric.util.createClass(fabric.PencilBrush, /** @lends fabric.PatternBrush.prototype */ {
	
	  getPatternSrc: function() {
	
	    var dotWidth = 20,
	        dotDistance = 5,
	        patternCanvas = fabric.util.createCanvasElement(),
	        patternCtx = patternCanvas.getContext('2d');
	
	    patternCanvas.width = patternCanvas.height = dotWidth + dotDistance;
	
	    patternCtx.fillStyle = this.color;
	    patternCtx.beginPath();
	    patternCtx.arc(dotWidth / 2, dotWidth / 2, dotWidth / 2, 0, Math.PI * 2, false);
	    patternCtx.closePath();
	    patternCtx.fill();
	
	    return patternCanvas;
	  },
	
	  getPatternSrcFunction: function() {
	    return String(this.getPatternSrc).replace('this.color', '"' + this.color + '"');
	  },
	
	  /**
	   * Creates "pattern" instance property
	   */
	  getPattern: function() {
	    return this.canvas.contextTop.createPattern(this.source || this.getPatternSrc(), 'repeat');
	  },
	
	  /**
	   * Sets brush styles
	   */
	  _setBrushStyles: function() {
	    this.callSuper('_setBrushStyles');
	    this.canvas.contextTop.strokeStyle = this.getPattern();
	  },
	
	  /**
	   * Creates path
	   */
	  createPath: function(pathData) {
	    var path = this.callSuper('createPath', pathData),
	        topLeft = path._getLeftTopCoords().scalarAdd(path.strokeWidth / 2);
	
	    path.stroke = new fabric.Pattern({
	      source: this.source || this.getPatternSrcFunction(),
	      offsetX: -topLeft.x,
	      offsetY: -topLeft.y
	    });
	    return path;
	  }
	});
	
	
	(function() {
	
	  var getPointer = fabric.util.getPointer,
	      degreesToRadians = fabric.util.degreesToRadians,
	      radiansToDegrees = fabric.util.radiansToDegrees,
	      atan2 = Math.atan2,
	      abs = Math.abs,
	      supportLineDash = fabric.StaticCanvas.supports('setLineDash'),
	
	      STROKE_OFFSET = 0.5;
	
	  /**
	   * Canvas class
	   * @class fabric.Canvas
	   * @extends fabric.StaticCanvas
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#canvas}
	   * @see {@link fabric.Canvas#initialize} for constructor definition
	   *
	   * @fires object:modified
	   * @fires object:rotated
	   * @fires object:scaled
	   * @fires object:moved
	   * @fires object:skewed
	   * @fires object:rotating
	   * @fires object:scaling
	   * @fires object:moving
	   * @fires object:skewing
	   * @fires object:selected this event is deprecated. use selection:created
	   *
	   * @fires before:transform
	   * @fires before:selection:cleared
	   * @fires selection:cleared
	   * @fires selection:updated
	   * @fires selection:created
	   *
	   * @fires path:created
	   * @fires mouse:down
	   * @fires mouse:move
	   * @fires mouse:up
	   * @fires mouse:down:before
	   * @fires mouse:move:before
	   * @fires mouse:up:before
	   * @fires mouse:over
	   * @fires mouse:out
	   * @fires mouse:dblclick
	   *
	   * @fires dragover
	   * @fires dragenter
	   * @fires dragleave
	   * @fires drop
	   *
	   */
	  fabric.Canvas = fabric.util.createClass(fabric.StaticCanvas, /** @lends fabric.Canvas.prototype */ {
	
	    /**
	     * Constructor
	     * @param {HTMLElement | String} el &lt;canvas> element to initialize instance on
	     * @param {Object} [options] Options object
	     * @return {Object} thisArg
	     */
	    initialize: function(el, options) {
	      options || (options = { });
	      this.renderAndResetBound = this.renderAndReset.bind(this);
	      this.requestRenderAllBound = this.requestRenderAll.bind(this);
	      this._initStatic(el, options);
	      this._initInteractive();
	      this._createCacheCanvas();
	    },
	
	    /**
	     * When true, objects can be transformed by one side (unproportionally)
	     * @type Boolean
	     * @default
	     */
	    uniScaleTransform:      false,
	
	    /**
	     * Indicates which key enable unproportional scaling
	     * values: 'altKey', 'shiftKey', 'ctrlKey'.
	     * If `null` or 'none' or any other string that is not a modifier key
	     * feature is disabled feature disabled.
	     * @since 1.6.2
	     * @type String
	     * @default
	     */
	    uniScaleKey:           'shiftKey',
	
	    /**
	     * When true, objects use center point as the origin of scale transformation.
	     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
	     * @since 1.3.4
	     * @type Boolean
	     * @default
	     */
	    centeredScaling:        false,
	
	    /**
	     * When true, objects use center point as the origin of rotate transformation.
	     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
	     * @since 1.3.4
	     * @type Boolean
	     * @default
	     */
	    centeredRotation:       false,
	
	    /**
	     * Indicates which key enable centered Transform
	     * values: 'altKey', 'shiftKey', 'ctrlKey'.
	     * If `null` or 'none' or any other string that is not a modifier key
	     * feature is disabled feature disabled.
	     * @since 1.6.2
	     * @type String
	     * @default
	     */
	    centeredKey:           'altKey',
	
	    /**
	     * Indicates which key enable alternate action on corner
	     * values: 'altKey', 'shiftKey', 'ctrlKey'.
	     * If `null` or 'none' or any other string that is not a modifier key
	     * feature is disabled feature disabled.
	     * @since 1.6.2
	     * @type String
	     * @default
	     */
	    altActionKey:           'shiftKey',
	
	    /**
	     * Indicates that canvas is interactive. This property should not be changed.
	     * @type Boolean
	     * @default
	     */
	    interactive:            true,
	
	    /**
	     * Indicates whether group selection should be enabled
	     * @type Boolean
	     * @default
	     */
	    selection:              true,
	
	    /**
	     * Indicates which key or keys enable multiple click selection
	     * Pass value as a string or array of strings
	     * values: 'altKey', 'shiftKey', 'ctrlKey'.
	     * If `null` or empty or containing any other string that is not a modifier key
	     * feature is disabled.
	     * @since 1.6.2
	     * @type String|Array
	     * @default
	     */
	    selectionKey:           'shiftKey',
	
	    /**
	     * Indicates which key enable alternative selection
	     * in case of target overlapping with active object
	     * values: 'altKey', 'shiftKey', 'ctrlKey'.
	     * For a series of reason that come from the general expectations on how
	     * things should work, this feature works only for preserveObjectStacking true.
	     * If `null` or 'none' or any other string that is not a modifier key
	     * feature is disabled.
	     * @since 1.6.5
	     * @type null|String
	     * @default
	     */
	    altSelectionKey:           null,
	
	    /**
	     * Color of selection
	     * @type String
	     * @default
	     */
	    selectionColor:         'rgba(100, 100, 255, 0.3)', // blue
	
	    /**
	     * Default dash array pattern
	     * If not empty the selection border is dashed
	     * @type Array
	     */
	    selectionDashArray:     [],
	
	    /**
	     * Color of the border of selection (usually slightly darker than color of selection itself)
	     * @type String
	     * @default
	     */
	    selectionBorderColor:   'rgba(255, 255, 255, 0.3)',
	
	    /**
	     * Width of a line used in object/group selection
	     * @type Number
	     * @default
	     */
	    selectionLineWidth:     1,
	
	    /**
	     * Select only shapes that are fully contained in the dragged selection rectangle.
	     * @type Boolean
	     * @default
	     */
	    selectionFullyContained: false,
	
	    /**
	     * Default cursor value used when hovering over an object on canvas
	     * @type String
	     * @default
	     */
	    hoverCursor:            'move',
	
	    /**
	     * Default cursor value used when moving an object on canvas
	     * @type String
	     * @default
	     */
	    moveCursor:             'move',
	
	    /**
	     * Default cursor value used for the entire canvas
	     * @type String
	     * @default
	     */
	    defaultCursor:          'default',
	
	    /**
	     * Cursor value used during free drawing
	     * @type String
	     * @default
	     */
	    freeDrawingCursor:      'crosshair',
	
	    /**
	     * Cursor value used for rotation point
	     * @type String
	     * @default
	     */
	    rotationCursor:         'crosshair',
	
	    /**
	     * Cursor value used for disabled elements ( corners with disabled action )
	     * @type String
	     * @since 2.0.0
	     * @default
	     */
	    notAllowedCursor:         'not-allowed',
	
	    /**
	     * Default element class that's given to wrapper (div) element of canvas
	     * @type String
	     * @default
	     */
	    containerClass:         'canvas-container',
	
	    /**
	     * When true, object detection happens on per-pixel basis rather than on per-bounding-box
	     * @type Boolean
	     * @default
	     */
	    perPixelTargetFind:     false,
	
	    /**
	     * Number of pixels around target pixel to tolerate (consider active) during object detection
	     * @type Number
	     * @default
	     */
	    targetFindTolerance:    0,
	
	    /**
	     * When true, target detection is skipped when hovering over canvas. This can be used to improve performance.
	     * @type Boolean
	     * @default
	     */
	    skipTargetFind:         false,
	
	    /**
	     * When true, mouse events on canvas (mousedown/mousemove/mouseup) result in free drawing.
	     * After mousedown, mousemove creates a shape,
	     * and then mouseup finalizes it and adds an instance of `fabric.Path` onto canvas.
	     * @tutorial {@link http://fabricjs.com/fabric-intro-part-4#free_drawing}
	     * @type Boolean
	     * @default
	     */
	    isDrawingMode:          false,
	
	    /**
	     * Indicates whether objects should remain in current stack position when selected.
	     * When false objects are brought to top and rendered as part of the selection group
	     * @type Boolean
	     * @default
	     */
	    preserveObjectStacking: false,
	
	    /**
	     * Indicates the angle that an object will lock to while rotating.
	     * @type Number
	     * @since 1.6.7
	     * @default
	     */
	    snapAngle: 0,
	
	    /**
	     * Indicates the distance from the snapAngle the rotation will lock to the snapAngle.
	     * When `null`, the snapThreshold will default to the snapAngle.
	     * @type null|Number
	     * @since 1.6.7
	     * @default
	     */
	    snapThreshold: null,
	
	    /**
	     * Indicates if the right click on canvas can output the context menu or not
	     * @type Boolean
	     * @since 1.6.5
	     * @default
	     */
	    stopContextMenu: false,
	
	    /**
	     * Indicates if the canvas can fire right click events
	     * @type Boolean
	     * @since 1.6.5
	     * @default
	     */
	    fireRightClick: false,
	
	    /**
	     * Indicates if the canvas can fire middle click events
	     * @type Boolean
	     * @since 1.7.8
	     * @default
	     */
	    fireMiddleClick: false,
	
	    /**
	     * @private
	     */
	    _initInteractive: function() {
	      this._currentTransform = null;
	      this._groupSelector = null;
	      this._initWrapperElement();
	      this._createUpperCanvas();
	      this._initEventListeners();
	
	      this._initRetinaScaling();
	
	      this.freeDrawingBrush = fabric.PencilBrush && new fabric.PencilBrush(this);
	
	      this.calcOffset();
	    },
	
	    /**
	     * Divides objects in two groups, one to render immediately
	     * and one to render as activeGroup.
	     * @return {Array} objects to render immediately and pushes the other in the activeGroup.
	     */
	    _chooseObjectsToRender: function() {
	      var activeObjects = this.getActiveObjects(),
	          object, objsToRender, activeGroupObjects;
	
	      if (activeObjects.length > 0 && !this.preserveObjectStacking) {
	        objsToRender = [];
	        activeGroupObjects = [];
	        for (var i = 0, length = this._objects.length; i < length; i++) {
	          object = this._objects[i];
	          if (activeObjects.indexOf(object) === -1 ) {
	            objsToRender.push(object);
	          }
	          else {
	            activeGroupObjects.push(object);
	          }
	        }
	        if (activeObjects.length > 1) {
	          this._activeObject._objects = activeGroupObjects;
	        }
	        objsToRender.push.apply(objsToRender, activeGroupObjects);
	      }
	      else {
	        objsToRender = this._objects;
	      }
	      return objsToRender;
	    },
	
	    /**
	     * Renders both the top canvas and the secondary container canvas.
	     * @return {fabric.Canvas} instance
	     * @chainable
	     */
	    renderAll: function () {
	      if (this.contextTopDirty && !this._groupSelector && !this.isDrawingMode) {
	        this.clearContext(this.contextTop);
	        this.contextTopDirty = false;
	      }
	      if (this.hasLostContext) {
	        this.renderTopLayer(this.contextTop);
	      }
	      var canvasToDrawOn = this.contextContainer;
	      this.renderCanvas(canvasToDrawOn, this._chooseObjectsToRender());
	      return this;
	    },
	
	    renderTopLayer: function(ctx) {
	      ctx.save();
	      if (this.isDrawingMode && this._isCurrentlyDrawing) {
	        this.freeDrawingBrush && this.freeDrawingBrush._render();
	        this.contextTopDirty = true;
	      }
	      // we render the top context - last object
	      if (this.selection && this._groupSelector) {
	        this._drawSelection(ctx);
	        this.contextTopDirty = true;
	      }
	      ctx.restore();
	    },
	
	    /**
	     * Method to render only the top canvas.
	     * Also used to render the group selection box.
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    renderTop: function () {
	      var ctx = this.contextTop;
	      this.clearContext(ctx);
	      this.renderTopLayer(ctx);
	      this.fire('after:render');
	      return this;
	    },
	
	    /**
	     * Resets the current transform to its original values and chooses the type of resizing based on the event
	     * @private
	     */
	    _resetCurrentTransform: function() {
	      var t = this._currentTransform;
	
	      t.target.set({
	        scaleX: t.original.scaleX,
	        scaleY: t.original.scaleY,
	        skewX: t.original.skewX,
	        skewY: t.original.skewY,
	        left: t.original.left,
	        top: t.original.top
	      });
	
	      if (this._shouldCenterTransform(t.target)) {
	        if (t.originX !== 'center') {
	          if (t.originX === 'right') {
	            t.mouseXSign = -1;
	          }
	          else {
	            t.mouseXSign = 1;
	          }
	        }
	        if (t.originY !== 'center') {
	          if (t.originY === 'bottom') {
	            t.mouseYSign = -1;
	          }
	          else {
	            t.mouseYSign = 1;
	          }
	        }
	
	        t.originX = 'center';
	        t.originY = 'center';
	      }
	      else {
	        t.originX = t.original.originX;
	        t.originY = t.original.originY;
	      }
	    },
	
	    /**
	     * Checks if point is contained within an area of given object
	     * @param {Event} e Event object
	     * @param {fabric.Object} target Object to test against
	     * @param {Object} [point] x,y object of point coordinates we want to check.
	     * @return {Boolean} true if point is contained within an area of given object
	     */
	    containsPoint: function (e, target, point) {
	      var ignoreZoom = true,
	          pointer = point || this.getPointer(e, ignoreZoom),
	          xy;
	
	      if (target.group && target.group === this._activeObject && target.group.type === 'activeSelection') {
	        xy = this._normalizePointer(target.group, pointer);
	      }
	      else {
	        xy = { x: pointer.x, y: pointer.y };
	      }
	      // http://www.geog.ubc.ca/courses/klink/gis.notes/ncgia/u32.html
	      // http://idav.ucdavis.edu/~okreylos/TAship/Spring2000/PointInPolygon.html
	      return (target.containsPoint(xy) || target._findTargetCorner(pointer));
	    },
	
	    /**
	     * @private
	     */
	    _normalizePointer: function (object, pointer) {
	      var m = object.calcTransformMatrix(),
	          invertedM = fabric.util.invertTransform(m),
	          vptPointer = this.restorePointerVpt(pointer);
	      return fabric.util.transformPoint(vptPointer, invertedM);
	    },
	
	    /**
	     * Returns true if object is transparent at a certain location
	     * @param {fabric.Object} target Object to check
	     * @param {Number} x Left coordinate
	     * @param {Number} y Top coordinate
	     * @return {Boolean}
	     */
	    isTargetTransparent: function (target, x, y) {
	      // in case the target is the activeObject, we cannot execute this optimization
	      // because we need to draw controls too.
	      if (target.shouldCache() && target._cacheCanvas && target !== this._activeObject) {
	        var normalizedPointer = this._normalizePointer(target, {x: x, y: y}),
	            targetRelativeX = Math.max(target.cacheTranslationX + (normalizedPointer.x * target.zoomX), 0),
	            targetRelativeY = Math.max(target.cacheTranslationY + (normalizedPointer.y * target.zoomY), 0);
	
	        var isTransparent = fabric.util.isTransparent(
	          target._cacheContext, Math.round(targetRelativeX), Math.round(targetRelativeY), this.targetFindTolerance);
	
	        return isTransparent;
	      }
	
	      var ctx = this.contextCache,
	          originalColor = target.selectionBackgroundColor, v = this.viewportTransform;
	
	      target.selectionBackgroundColor = '';
	
	      this.clearContext(ctx);
	
	      ctx.save();
	      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
	      target.render(ctx);
	      ctx.restore();
	
	      target === this._activeObject && target._renderControls(ctx, {
	        hasBorders: false,
	        transparentCorners: false
	      }, {
	        hasBorders: false,
	      });
	
	      target.selectionBackgroundColor = originalColor;
	
	      var isTransparent = fabric.util.isTransparent(
	        ctx, x, y, this.targetFindTolerance);
	
	      return isTransparent;
	    },
	
	    /**
	     * takes an event and determins if selection key has been pressed
	     * @private
	     * @param {Event} e Event object
	     */
	    _isSelectionKeyPressed: function(e) {
	      var selectionKeyPressed = false;
	
	      if (Object.prototype.toString.call(this.selectionKey) === '[object Array]') {
	        selectionKeyPressed = !!this.selectionKey.find(function(key) { return e[key] === true; });
	      }
	      else {
	        selectionKeyPressed = e[this.selectionKey];
	      }
	
	      return selectionKeyPressed;
	    },
	
	    /**
	     * @private
	     * @param {Event} e Event object
	     * @param {fabric.Object} target
	     */
	    _shouldClearSelection: function (e, target) {
	      var activeObjects = this.getActiveObjects(),
	          activeObject = this._activeObject;
	
	      return (
	        !target
	        ||
	        (target &&
	          activeObject &&
	          activeObjects.length > 1 &&
	          activeObjects.indexOf(target) === -1 &&
	          activeObject !== target &&
	          !this._isSelectionKeyPressed(e))
	        ||
	        (target && !target.evented)
	        ||
	        (target &&
	          !target.selectable &&
	          activeObject &&
	          activeObject !== target)
	      );
	    },
	
	    /**
	     * centeredScaling from object can't override centeredScaling from canvas.
	     * this should be fixed, since object setting should take precedence over canvas.
	     * @private
	     * @param {fabric.Object} target
	     */
	    _shouldCenterTransform: function (target) {
	      if (!target) {
	        return;
	      }
	
	      var t = this._currentTransform,
	          centerTransform;
	
	      if (t.action === 'scale' || t.action === 'scaleX' || t.action === 'scaleY') {
	        centerTransform = this.centeredScaling || target.centeredScaling;
	      }
	      else if (t.action === 'rotate') {
	        centerTransform = this.centeredRotation || target.centeredRotation;
	      }
	
	      return centerTransform ? !t.altKey : t.altKey;
	    },
	
	    /**
	     * @private
	     */
	    _getOriginFromCorner: function(target, corner) {
	      var origin = {
	        x: target.originX,
	        y: target.originY
	      };
	
	      if (corner === 'ml' || corner === 'tl' || corner === 'bl') {
	        origin.x = 'right';
	      }
	      else if (corner === 'mr' || corner === 'tr' || corner === 'br') {
	        origin.x = 'left';
	      }
	
	      if (corner === 'tl' || corner === 'mt' || corner === 'tr') {
	        origin.y = 'bottom';
	      }
	      else if (corner === 'bl' || corner === 'mb' || corner === 'br') {
	        origin.y = 'top';
	      }
	
	      return origin;
	    },
	
	    /**
	     * @private
	     * @param {Boolean} alreadySelected true if target is already selected
	     * @param {String} corner a string representing the corner ml, mr, tl ...
	     * @param {Event} e Event object
	     * @param {fabric.Object} [target] inserted back to help overriding. Unused
	     */
	    _getActionFromCorner: function(alreadySelected, corner, e /* target */) {
	      if (!corner || !alreadySelected) {
	        return 'drag';
	      }
	
	      switch (corner) {
	        case 'mtr':
	          return 'rotate';
	        case 'ml':
	        case 'mr':
	          return e[this.altActionKey] ? 'skewY' : 'scaleX';
	        case 'mt':
	        case 'mb':
	          return e[this.altActionKey] ? 'skewX' : 'scaleY';
	        default:
	          return 'scale';
	      }
	    },
	
	    /**
	     * @private
	     * @param {Event} e Event object
	     * @param {fabric.Object} target
	     */
	    _setupCurrentTransform: function (e, target, alreadySelected) {
	      if (!target) {
	        return;
	      }
	
	      var pointer = this.getPointer(e),
	          corner = target._findTargetCorner(this.getPointer(e, true)),
	          action = this._getActionFromCorner(alreadySelected, corner, e, target),
	          origin = this._getOriginFromCorner(target, corner);
	
	      this._currentTransform = {
	        target: target,
	        action: action,
	        corner: corner,
	        scaleX: target.scaleX,
	        scaleY: target.scaleY,
	        skewX: target.skewX,
	        skewY: target.skewY,
	        // used by transation
	        offsetX: pointer.x - target.left,
	        offsetY: pointer.y - target.top,
	        originX: origin.x,
	        originY: origin.y,
	        ex: pointer.x,
	        ey: pointer.y,
	        lastX: pointer.x,
	        lastY: pointer.y,
	        // unsure they are usefull anymore.
	        // left: target.left,
	        // top: target.top,
	        theta: degreesToRadians(target.angle),
	        // end of unsure
	        width: target.width * target.scaleX,
	        mouseXSign: 1,
	        mouseYSign: 1,
	        shiftKey: e.shiftKey,
	        altKey: e[this.centeredKey],
	        original: fabric.util.saveObjectTransform(target),
	      };
	
	      this._currentTransform.original.originX = origin.x;
	      this._currentTransform.original.originY = origin.y;
	
	      this._resetCurrentTransform();
	      this._beforeTransform(e);
	    },
	
	    /**
	     * Translates object by "setting" its left/top
	     * @private
	     * @param {Number} x pointer's x coordinate
	     * @param {Number} y pointer's y coordinate
	     * @return {Boolean} true if the translation occurred
	     */
	    _translateObject: function (x, y) {
	      var transform = this._currentTransform,
	          target = transform.target,
	          newLeft = x - transform.offsetX,
	          newTop = y - transform.offsetY,
	          moveX = !target.get('lockMovementX') && target.left !== newLeft,
	          moveY = !target.get('lockMovementY') && target.top !== newTop;
	
	      moveX && target.set('left', newLeft);
	      moveY && target.set('top', newTop);
	      return moveX || moveY;
	    },
	
	    /**
	     * Check if we are increasing a positive skew or lower it,
	     * checking mouse direction and pressed corner.
	     * @private
	     */
	    _changeSkewTransformOrigin: function(mouseMove, t, by) {
	      var property = 'originX', origins = { 0: 'center' },
	          skew = t.target.skewX, originA = 'left', originB = 'right',
	          corner = t.corner === 'mt' || t.corner === 'ml' ? 1 : -1,
	          flipSign = 1;
	
	      mouseMove = mouseMove > 0 ? 1 : -1;
	      if (by === 'y') {
	        skew = t.target.skewY;
	        originA = 'top';
	        originB = 'bottom';
	        property = 'originY';
	      }
	      origins[-1] = originA;
	      origins[1] = originB;
	
	      t.target.flipX && (flipSign *= -1);
	      t.target.flipY && (flipSign *= -1);
	
	      if (skew === 0) {
	        t.skewSign = -corner * mouseMove * flipSign;
	        t[property] = origins[-mouseMove];
	      }
	      else {
	        skew = skew > 0 ? 1 : -1;
	        t.skewSign = skew;
	        t[property] = origins[skew * corner * flipSign];
	      }
	    },
	
	    /**
	     * Skew object by mouse events
	     * @private
	     * @param {Number} x pointer's x coordinate
	     * @param {Number} y pointer's y coordinate
	     * @param {String} by Either 'x' or 'y'
	     * @return {Boolean} true if the skewing occurred
	     */
	    _skewObject: function (x, y, by) {
	      var t = this._currentTransform,
	          target = t.target, skewed = false,
	          lockSkewingX = target.get('lockSkewingX'),
	          lockSkewingY = target.get('lockSkewingY');
	
	      if ((lockSkewingX && by === 'x') || (lockSkewingY && by === 'y')) {
	        return false;
	      }
	
	      // Get the constraint point
	      var center = target.getCenterPoint(),
	          actualMouseByCenter = target.toLocalPoint(new fabric.Point(x, y), 'center', 'center')[by],
	          lastMouseByCenter = target.toLocalPoint(new fabric.Point(t.lastX, t.lastY), 'center', 'center')[by],
	          actualMouseByOrigin, constraintPosition, dim = target._getTransformedDimensions();
	
	      this._changeSkewTransformOrigin(actualMouseByCenter - lastMouseByCenter, t, by);
	      actualMouseByOrigin = target.toLocalPoint(new fabric.Point(x, y), t.originX, t.originY)[by];
	      constraintPosition = target.translateToOriginPoint(center, t.originX, t.originY);
	      // Actually skew the object
	      skewed = this._setObjectSkew(actualMouseByOrigin, t, by, dim);
	      t.lastX = x;
	      t.lastY = y;
	      // Make sure the constraints apply
	      target.setPositionByOrigin(constraintPosition, t.originX, t.originY);
	      return skewed;
	    },
	
	    /**
	     * Set object skew
	     * @private
	     * @return {Boolean} true if the skewing occurred
	     */
	    _setObjectSkew: function(localMouse, transform, by, _dim) {
	      var target = transform.target, newValue, skewed = false,
	          skewSign = transform.skewSign, newDim, dimNoSkew,
	          otherBy, _otherBy, _by, newDimMouse, skewX, skewY;
	
	      if (by === 'x') {
	        otherBy = 'y';
	        _otherBy = 'Y';
	        _by = 'X';
	        skewX = 0;
	        skewY = target.skewY;
	      }
	      else {
	        otherBy = 'x';
	        _otherBy = 'X';
	        _by = 'Y';
	        skewX = target.skewX;
	        skewY = 0;
	      }
	
	      dimNoSkew = target._getTransformedDimensions(skewX, skewY);
	      newDimMouse = 2 * Math.abs(localMouse) - dimNoSkew[by];
	      if (newDimMouse <= 2) {
	        newValue = 0;
	      }
	      else {
	        newValue = skewSign * Math.atan((newDimMouse / target['scale' + _by]) /
	                                        (dimNoSkew[otherBy] / target['scale' + _otherBy]));
	        newValue = fabric.util.radiansToDegrees(newValue);
	      }
	      skewed = target['skew' + _by] !== newValue;
	      target.set('skew' + _by, newValue);
	      if (target['skew' + _otherBy] !== 0) {
	        newDim = target._getTransformedDimensions();
	        newValue = (_dim[otherBy] / newDim[otherBy]) * target['scale' + _otherBy];
	        target.set('scale' + _otherBy, newValue);
	      }
	      return skewed;
	    },
	
	    /**
	     * Scales object by invoking its scaleX/scaleY methods
	     * @private
	     * @param {Number} x pointer's x coordinate
	     * @param {Number} y pointer's y coordinate
	     * @param {String} by Either 'x' or 'y' - specifies dimension constraint by which to scale an object.
	     *                    When not provided, an object is scaled by both dimensions equally
	     * @return {Boolean} true if the scaling occurred
	     */
	    _scaleObject: function (x, y, by) {
	      var t = this._currentTransform,
	          target = t.target,
	          lockScalingX = target.lockScalingX,
	          lockScalingY = target.lockScalingY,
	          lockScalingFlip = target.lockScalingFlip;
	
	      if (lockScalingX && lockScalingY) {
	        return false;
	      }
	
	      // Get the constraint point
	      var constraintPosition = target.translateToOriginPoint(target.getCenterPoint(), t.originX, t.originY),
	          localMouse = target.toLocalPoint(new fabric.Point(x, y), t.originX, t.originY),
	          dim = target._getTransformedDimensions(), scaled = false;
	
	      this._setLocalMouse(localMouse, t);
	
	      // Actually scale the object
	      scaled = this._setObjectScale(localMouse, t, lockScalingX, lockScalingY, by, lockScalingFlip, dim);
	
	      // Make sure the constraints apply
	      target.setPositionByOrigin(constraintPosition, t.originX, t.originY);
	      return scaled;
	    },
	
	    /**
	     * @private
	     * @return {Boolean} true if the scaling occurred
	     */
	    _setObjectScale: function(localMouse, transform, lockScalingX, lockScalingY, by, lockScalingFlip, _dim) {
	      var target = transform.target, forbidScalingX = false, forbidScalingY = false, scaled = false,
	          scaleX = localMouse.x * target.scaleX / _dim.x,
	          scaleY = localMouse.y * target.scaleY / _dim.y,
	          changeX = target.scaleX !== scaleX,
	          changeY = target.scaleY !== scaleY;
	
	      transform.newScaleX = scaleX;
	      transform.newScaleY = scaleY;
	      if (by === 'x' && target instanceof fabric.Textbox) {
	        var w = target.width * (localMouse.x / _dim.x);
	        if (w >= target.getMinWidth()) {
	          scaled = w !== target.width;
	          target.set('width', w);
	          return scaled;
	        }
	        return false;
	      }
	
	      if (lockScalingFlip && scaleX <= 0 && scaleX < target.scaleX) {
	        forbidScalingX = true;
	        localMouse.x = 0;
	      }
	
	      if (lockScalingFlip && scaleY <= 0 && scaleY < target.scaleY) {
	        forbidScalingY = true;
	        localMouse.y = 0;
	      }
	
	      if (by === 'equally' && !lockScalingX && !lockScalingY) {
	        scaled = this._scaleObjectEqually(localMouse, target, transform, _dim);
	      }
	      else if (!by) {
	        forbidScalingX || lockScalingX || (target.set('scaleX', scaleX) && (scaled = scaled || changeX));
	        forbidScalingY || lockScalingY || (target.set('scaleY', scaleY) && (scaled = scaled || changeY));
	      }
	      else if (by === 'x' && !target.get('lockUniScaling')) {
	        forbidScalingX || lockScalingX || (target.set('scaleX', scaleX) && (scaled = changeX));
	      }
	      else if (by === 'y' && !target.get('lockUniScaling')) {
	        forbidScalingY || lockScalingY || (target.set('scaleY', scaleY) && (scaled = changeY));
	      }
	      forbidScalingX || forbidScalingY || this._flipObject(transform, by);
	      return scaled;
	    },
	
	    /**
	     * @private
	     * @return {Boolean} true if the scaling occurred
	     */
	    _scaleObjectEqually: function(localMouse, target, transform, _dim) {
	
	      var dist = localMouse.y + localMouse.x,
	          lastDist = _dim.y * transform.original.scaleY / target.scaleY +
	                     _dim.x * transform.original.scaleX / target.scaleX,
	          scaled, signX = localMouse.x < 0 ? -1 : 1,
	          signY = localMouse.y < 0 ? -1 : 1, newScaleX, newScaleY;
	
	      // We use transform.scaleX/Y instead of target.scaleX/Y
	      // because the object may have a min scale and we'll loose the proportions
	      newScaleX = signX * Math.abs(transform.original.scaleX * dist / lastDist);
	      newScaleY = signY * Math.abs(transform.original.scaleY * dist / lastDist);
	      scaled = newScaleX !== target.scaleX || newScaleY !== target.scaleY;
	      target.set('scaleX', newScaleX);
	      target.set('scaleY', newScaleY);
	      return scaled;
	    },
	
	    /**
	     * @private
	     */
	    _flipObject: function(transform, by) {
	      if (transform.newScaleX < 0 && by !== 'y') {
	        if (transform.originX === 'left') {
	          transform.originX = 'right';
	        }
	        else if (transform.originX === 'right') {
	          transform.originX = 'left';
	        }
	      }
	
	      if (transform.newScaleY < 0 && by !== 'x') {
	        if (transform.originY === 'top') {
	          transform.originY = 'bottom';
	        }
	        else if (transform.originY === 'bottom') {
	          transform.originY = 'top';
	        }
	      }
	    },
	
	    /**
	     * @private
	     */
	    _setLocalMouse: function(localMouse, t) {
	      var target = t.target, zoom = this.getZoom(),
	          padding = target.padding / zoom;
	
	      if (t.originX === 'right') {
	        localMouse.x *= -1;
	      }
	      else if (t.originX === 'center') {
	        localMouse.x *= t.mouseXSign * 2;
	        if (localMouse.x < 0) {
	          t.mouseXSign = -t.mouseXSign;
	        }
	      }
	
	      if (t.originY === 'bottom') {
	        localMouse.y *= -1;
	      }
	      else if (t.originY === 'center') {
	        localMouse.y *= t.mouseYSign * 2;
	        if (localMouse.y < 0) {
	          t.mouseYSign = -t.mouseYSign;
	        }
	      }
	
	      // adjust the mouse coordinates when dealing with padding
	      if (abs(localMouse.x) > padding) {
	        if (localMouse.x < 0) {
	          localMouse.x += padding;
	        }
	        else {
	          localMouse.x -= padding;
	        }
	      }
	      else { // mouse is within the padding, set to 0
	        localMouse.x = 0;
	      }
	
	      if (abs(localMouse.y) > padding) {
	        if (localMouse.y < 0) {
	          localMouse.y += padding;
	        }
	        else {
	          localMouse.y -= padding;
	        }
	      }
	      else {
	        localMouse.y = 0;
	      }
	    },
	
	    /**
	     * Rotates object by invoking its rotate method
	     * @private
	     * @param {Number} x pointer's x coordinate
	     * @param {Number} y pointer's y coordinate
	     * @return {Boolean} true if the rotation occurred
	     */
	    _rotateObject: function (x, y) {
	
	      var t = this._currentTransform,
	          target = t.target, constraintPosition,
	          constraintPosition = target.translateToOriginPoint(target.getCenterPoint(), t.originX, t.originY);
	
	      if (target.lockRotation) {
	        return false;
	      }
	
	      var lastAngle = atan2(t.ey - constraintPosition.y, t.ex - constraintPosition.x),
	          curAngle = atan2(y - constraintPosition.y, x - constraintPosition.x),
	          angle = radiansToDegrees(curAngle - lastAngle + t.theta),
	          hasRotated = true;
	
	      if (target.snapAngle > 0) {
	        var snapAngle  = target.snapAngle,
	            snapThreshold  = target.snapThreshold || snapAngle,
	            rightAngleLocked = Math.ceil(angle / snapAngle) * snapAngle,
	            leftAngleLocked = Math.floor(angle / snapAngle) * snapAngle;
	
	        if (Math.abs(angle - leftAngleLocked) < snapThreshold) {
	          angle = leftAngleLocked;
	        }
	        else if (Math.abs(angle - rightAngleLocked) < snapThreshold) {
	          angle = rightAngleLocked;
	        }
	      }
	
	      // normalize angle to positive value
	      if (angle < 0) {
	        angle = 360 + angle;
	      }
	      angle %= 360;
	
	      if (target.angle === angle) {
	        hasRotated = false;
	      }
	      else {
	        // rotation only happen here
	        target.angle = angle;
	        // Make sure the constraints apply
	        target.setPositionByOrigin(constraintPosition, t.originX, t.originY);
	      }
	
	      return hasRotated;
	    },
	
	    /**
	     * Set the cursor type of the canvas element
	     * @param {String} value Cursor type of the canvas element.
	     * @see http://www.w3.org/TR/css3-ui/#cursor
	     */
	    setCursor: function (value) {
	      this.upperCanvasEl.style.cursor = value;
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx to draw the selection on
	     */
	    _drawSelection: function (ctx) {
	      var groupSelector = this._groupSelector,
	          left = groupSelector.left,
	          top = groupSelector.top,
	          aleft = abs(left),
	          atop = abs(top);
	
	      if (this.selectionColor) {
	        ctx.fillStyle = this.selectionColor;
	
	        ctx.fillRect(
	          groupSelector.ex - ((left > 0) ? 0 : -left),
	          groupSelector.ey - ((top > 0) ? 0 : -top),
	          aleft,
	          atop
	        );
	      }
	
	      if (!this.selectionLineWidth || !this.selectionBorderColor) {
	        return;
	      }
	      ctx.lineWidth = this.selectionLineWidth;
	      ctx.strokeStyle = this.selectionBorderColor;
	
	      // selection border
	      if (this.selectionDashArray.length > 1 && !supportLineDash) {
	
	        var px = groupSelector.ex + STROKE_OFFSET - ((left > 0) ? 0 : aleft),
	            py = groupSelector.ey + STROKE_OFFSET - ((top > 0) ? 0 : atop);
	
	        ctx.beginPath();
	
	        fabric.util.drawDashedLine(ctx, px, py, px + aleft, py, this.selectionDashArray);
	        fabric.util.drawDashedLine(ctx, px, py + atop - 1, px + aleft, py + atop - 1, this.selectionDashArray);
	        fabric.util.drawDashedLine(ctx, px, py, px, py + atop, this.selectionDashArray);
	        fabric.util.drawDashedLine(ctx, px + aleft - 1, py, px + aleft - 1, py + atop, this.selectionDashArray);
	
	        ctx.closePath();
	        ctx.stroke();
	      }
	      else {
	        fabric.Object.prototype._setLineDash.call(this, ctx, this.selectionDashArray);
	        ctx.strokeRect(
	          groupSelector.ex + STROKE_OFFSET - ((left > 0) ? 0 : aleft),
	          groupSelector.ey + STROKE_OFFSET - ((top > 0) ? 0 : atop),
	          aleft,
	          atop
	        );
	      }
	    },
	
	    /**
	     * Method that determines what object we are clicking on
	     * the skipGroup parameter is for internal use, is needed for shift+click action
	     * 11/09/2018 TODO: would be cool if findTarget could discern between being a full target
	     * or the outside part of the corner.
	     * @param {Event} e mouse event
	     * @param {Boolean} skipGroup when true, activeGroup is skipped and only objects are traversed through
	     * @return {fabric.Object} the target found
	     */
	    findTarget: function (e, skipGroup) {
	      if (this.skipTargetFind) {
	        return;
	      }
	
	      var ignoreZoom = true,
	          pointer = this.getPointer(e, ignoreZoom),
	          activeObject = this._activeObject,
	          aObjects = this.getActiveObjects(),
	          activeTarget, activeTargetSubs;
	
	      // first check current group (if one exists)
	      // active group does not check sub targets like normal groups.
	      // if active group just exits.
	      this.targets = [];
	
	      if (aObjects.length > 1 && !skipGroup && activeObject === this._searchPossibleTargets([activeObject], pointer)) {
	        return activeObject;
	      }
	      // if we hit the corner of an activeObject, let's return that.
	      if (aObjects.length === 1 && activeObject._findTargetCorner(pointer)) {
	        return activeObject;
	      }
	      if (aObjects.length === 1 &&
	        activeObject === this._searchPossibleTargets([activeObject], pointer)) {
	        if (!this.preserveObjectStacking) {
	          return activeObject;
	        }
	        else {
	          activeTarget = activeObject;
	          activeTargetSubs = this.targets;
	          this.targets = [];
	        }
	      }
	      var target = this._searchPossibleTargets(this._objects, pointer);
	      if (e[this.altSelectionKey] && target && activeTarget && target !== activeTarget) {
	        target = activeTarget;
	        this.targets = activeTargetSubs;
	      }
	      return target;
	    },
	
	    /**
	     * Checks point is inside the object.
	     * @param {Object} [pointer] x,y object of point coordinates we want to check.
	     * @param {fabric.Object} obj Object to test against
	     * @param {Object} [globalPointer] x,y object of point coordinates relative to canvas used to search per pixel target.
	     * @return {Boolean} true if point is contained within an area of given object
	     * @private
	     */
	    _checkTarget: function(pointer, obj, globalPointer) {
	      if (obj &&
	          obj.visible &&
	          obj.evented &&
	          this.containsPoint(null, obj, pointer)){
	        if ((this.perPixelTargetFind || obj.perPixelTargetFind) && !obj.isEditing) {
	          var isTransparent = this.isTargetTransparent(obj, globalPointer.x, globalPointer.y);
	          if (!isTransparent) {
	            return true;
	          }
	        }
	        else {
	          return true;
	        }
	      }
	    },
	
	    /**
	     * Function used to search inside objects an object that contains pointer in bounding box or that contains pointerOnCanvas when painted
	     * @param {Array} [objects] objects array to look into
	     * @param {Object} [pointer] x,y object of point coordinates we want to check.
	     * @return {fabric.Object} object that contains pointer
	     * @private
	     */
	    _searchPossibleTargets: function(objects, pointer) {
	      // Cache all targets where their bounding box contains point.
	      var target, i = objects.length, subTarget;
	      // Do not check for currently grouped objects, since we check the parent group itself.
	      // until we call this function specifically to search inside the activeGroup
	      while (i--) {
	        var objToCheck = objects[i];
	        var pointerToUse = objToCheck.group && objToCheck.group.type !== 'activeSelection' ?
	          this._normalizePointer(objToCheck.group, pointer) : pointer;
	        if (this._checkTarget(pointerToUse, objToCheck, pointer)) {
	          target = objects[i];
	          if (target.subTargetCheck && target instanceof fabric.Group) {
	            subTarget = this._searchPossibleTargets(target._objects, pointer);
	            subTarget && this.targets.push(subTarget);
	          }
	          break;
	        }
	      }
	      return target;
	    },
	
	    /**
	     * Returns pointer coordinates without the effect of the viewport
	     * @param {Object} pointer with "x" and "y" number values
	     * @return {Object} object with "x" and "y" number values
	     */
	    restorePointerVpt: function(pointer) {
	      return fabric.util.transformPoint(
	        pointer,
	        fabric.util.invertTransform(this.viewportTransform)
	      );
	    },
	
	    /**
	     * Returns pointer coordinates relative to canvas.
	     * Can return coordinates with or without viewportTransform.
	     * ignoreZoom false gives back coordinates that represent
	     * the point clicked on canvas element.
	     * ignoreZoom true gives back coordinates after being processed
	     * by the viewportTransform ( sort of coordinates of what is displayed
	     * on the canvas where you are clicking.
	     * ignoreZoom true = HTMLElement coordinates relative to top,left
	     * ignoreZoom false, default = fabric space coordinates, the same used for shape position
	     * To interact with your shapes top and left you want to use ignoreZoom true
	     * most of the time, while ignoreZoom false will give you coordinates
	     * compatible with the object.oCoords system.
	     * of the time.
	     * @param {Event} e
	     * @param {Boolean} ignoreZoom
	     * @return {Object} object with "x" and "y" number values
	     */
	    getPointer: function (e, ignoreZoom) {
	      // return cached values if we are in the event processing chain
	      if (this._absolutePointer && !ignoreZoom) {
	        return this._absolutePointer;
	      }
	      if (this._pointer && ignoreZoom) {
	        return this._pointer;
	      }
	
	      var pointer = getPointer(e),
	          upperCanvasEl = this.upperCanvasEl,
	          bounds = upperCanvasEl.getBoundingClientRect(),
	          boundsWidth = bounds.width || 0,
	          boundsHeight = bounds.height || 0,
	          cssScale;
	
	      if (!boundsWidth || !boundsHeight ) {
	        if ('top' in bounds && 'bottom' in bounds) {
	          boundsHeight = Math.abs( bounds.top - bounds.bottom );
	        }
	        if ('right' in bounds && 'left' in bounds) {
	          boundsWidth = Math.abs( bounds.right - bounds.left );
	        }
	      }
	
	      this.calcOffset();
	      pointer.x = pointer.x - this._offset.left;
	      pointer.y = pointer.y - this._offset.top;
	      if (!ignoreZoom) {
	        pointer = this.restorePointerVpt(pointer);
	      }
	
	      if (boundsWidth === 0 || boundsHeight === 0) {
	        // If bounds are not available (i.e. not visible), do not apply scale.
	        cssScale = { width: 1, height: 1 };
	      }
	      else {
	        cssScale = {
	          width: upperCanvasEl.width / boundsWidth,
	          height: upperCanvasEl.height / boundsHeight
	        };
	      }
	
	      return {
	        x: pointer.x * cssScale.width,
	        y: pointer.y * cssScale.height
	      };
	    },
	
	    /**
	     * @private
	     * @throws {CANVAS_INIT_ERROR} If canvas can not be initialized
	     */
	    _createUpperCanvas: function () {
	      var lowerCanvasClass = this.lowerCanvasEl.className.replace(/\s*lower-canvas\s*/, '');
	
	      // there is no need to create a new upperCanvas element if we have already one.
	      if (this.upperCanvasEl) {
	        this.upperCanvasEl.className = '';
	      }
	      else {
	        this.upperCanvasEl = this._createCanvasElement();
	      }
	      fabric.util.addClass(this.upperCanvasEl, 'upper-canvas ' + lowerCanvasClass);
	
	      this.wrapperEl.appendChild(this.upperCanvasEl);
	
	      this._copyCanvasStyle(this.lowerCanvasEl, this.upperCanvasEl);
	      this._applyCanvasStyle(this.upperCanvasEl);
	      this.contextTop = this.upperCanvasEl.getContext('2d');
	    },
	
	    /**
	     * @private
	     */
	    _createCacheCanvas: function () {
	      this.cacheCanvasEl = this._createCanvasElement();
	      this.cacheCanvasEl.setAttribute('width', this.width);
	      this.cacheCanvasEl.setAttribute('height', this.height);
	      this.contextCache = this.cacheCanvasEl.getContext('2d');
	    },
	
	    /**
	     * @private
	     */
	    _initWrapperElement: function () {
	      this.wrapperEl = fabric.util.wrapElement(this.lowerCanvasEl, 'div', {
	        'class': this.containerClass
	      });
	      fabric.util.setStyle(this.wrapperEl, {
	        width: this.width + 'px',
	        height: this.height + 'px',
	        position: 'relative'
	      });
	      fabric.util.makeElementUnselectable(this.wrapperEl);
	    },
	
	    /**
	     * @private
	     * @param {HTMLElement} element canvas element to apply styles on
	     */
	    _applyCanvasStyle: function (element) {
	      var width = this.width || element.width,
	          height = this.height || element.height;
	
	      fabric.util.setStyle(element, {
	        position: 'absolute',
	        width: width + 'px',
	        height: height + 'px',
	        left: 0,
	        top: 0,
	        'touch-action': this.allowTouchScrolling ? 'manipulation' : 'none',
	        '-ms-touch-action': this.allowTouchScrolling ? 'manipulation' : 'none'
	      });
	      element.width = width;
	      element.height = height;
	      fabric.util.makeElementUnselectable(element);
	    },
	
	    /**
	     * Copy the entire inline style from one element (fromEl) to another (toEl)
	     * @private
	     * @param {Element} fromEl Element style is copied from
	     * @param {Element} toEl Element copied style is applied to
	     */
	    _copyCanvasStyle: function (fromEl, toEl) {
	      toEl.style.cssText = fromEl.style.cssText;
	    },
	
	    /**
	     * Returns context of canvas where object selection is drawn
	     * @return {CanvasRenderingContext2D}
	     */
	    getSelectionContext: function() {
	      return this.contextTop;
	    },
	
	    /**
	     * Returns &lt;canvas> element on which object selection is drawn
	     * @return {HTMLCanvasElement}
	     */
	    getSelectionElement: function () {
	      return this.upperCanvasEl;
	    },
	
	    /**
	     * Returns currently active object
	     * @return {fabric.Object} active object
	     */
	    getActiveObject: function () {
	      return this._activeObject;
	    },
	
	    /**
	     * Returns an array with the current selected objects
	     * @return {fabric.Object} active object
	     */
	    getActiveObjects: function () {
	      var active = this._activeObject;
	      if (active) {
	        if (active.type === 'activeSelection' && active._objects) {
	          return active._objects.slice(0);
	        }
	        else {
	          return [active];
	        }
	      }
	      return [];
	    },
	
	    /**
	     * @private
	     * @param {fabric.Object} obj Object that was removed
	     */
	    _onObjectRemoved: function(obj) {
	      // removing active object should fire "selection:cleared" events
	      if (obj === this._activeObject) {
	        this.fire('before:selection:cleared', { target: obj });
	        this._discardActiveObject();
	        this.fire('selection:cleared', { target: obj });
	        obj.fire('deselected');
	      }
	      if (this._hoveredTarget === obj) {
	        this._hoveredTarget = null;
	      }
	      this.callSuper('_onObjectRemoved', obj);
	    },
	
	    /**
	     * @private
	     * Compares the old activeObject with the current one and fires correct events
	     * @param {fabric.Object} obj old activeObject
	     */
	    _fireSelectionEvents: function(oldObjects, e) {
	      var somethingChanged = false, objects = this.getActiveObjects(),
	          added = [], removed = [], opt = { e: e };
	      oldObjects.forEach(function(oldObject) {
	        if (objects.indexOf(oldObject) === -1) {
	          somethingChanged = true;
	          oldObject.fire('deselected', opt);
	          removed.push(oldObject);
	        }
	      });
	      objects.forEach(function(object) {
	        if (oldObjects.indexOf(object) === -1) {
	          somethingChanged = true;
	          object.fire('selected', opt);
	          added.push(object);
	        }
	      });
	      if (oldObjects.length > 0 && objects.length > 0) {
	        opt.selected = added;
	        opt.deselected = removed;
	        // added for backward compatibility
	        opt.updated = added[0] || removed[0];
	        opt.target = this._activeObject;
	        somethingChanged && this.fire('selection:updated', opt);
	      }
	      else if (objects.length > 0) {
	        // deprecated event
	        if (objects.length === 1) {
	          opt.target = added[0];
	          this.fire('object:selected', opt);
	        }
	        opt.selected = added;
	        // added for backward compatibility
	        opt.target = this._activeObject;
	        this.fire('selection:created', opt);
	      }
	      else if (oldObjects.length > 0) {
	        opt.deselected = removed;
	        this.fire('selection:cleared', opt);
	      }
	    },
	
	    /**
	     * Sets given object as the only active object on canvas
	     * @param {fabric.Object} object Object to set as an active one
	     * @param {Event} [e] Event (passed along when firing "object:selected")
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    setActiveObject: function (object, e) {
	      var currentActives = this.getActiveObjects();
	      this._setActiveObject(object, e);
	      this._fireSelectionEvents(currentActives, e);
	      return this;
	    },
	
	    /**
	     * @private
	     * @param {Object} object to set as active
	     * @param {Event} [e] Event (passed along when firing "object:selected")
	     * @return {Boolean} true if the selection happened
	     */
	    _setActiveObject: function(object, e) {
	      if (this._activeObject === object) {
	        return false;
	      }
	      if (!this._discardActiveObject(e, object)) {
	        return false;
	      }
	      if (object.onSelect({ e: e })) {
	        return false;
	      }
	      this._activeObject = object;
	      return true;
	    },
	
	    /**
	     * @private
	     */
	    _discardActiveObject: function(e, object) {
	      var obj = this._activeObject;
	      if (obj) {
	        // onDeselect return TRUE to cancel selection;
	        if (obj.onDeselect({ e: e, object: object })) {
	          return false;
	        }
	        this._activeObject = null;
	      }
	      return true;
	    },
	
	    /**
	     * Discards currently active object and fire events. If the function is called by fabric
	     * as a consequence of a mouse event, the event is passed as a parameter and
	     * sent to the fire function for the custom events. When used as a method the
	     * e param does not have any application.
	     * @param {event} e
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    discardActiveObject: function (e) {
	      var currentActives = this.getActiveObjects(), activeObject = this.getActiveObject();
	      if (currentActives.length) {
	        this.fire('before:selection:cleared', { target: activeObject, e: e });
	      }
	      this._discardActiveObject(e);
	      this._fireSelectionEvents(currentActives, e);
	      return this;
	    },
	
	    /**
	     * Clears a canvas element and removes all event listeners
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    dispose: function () {
	      var wrapper = this.wrapperEl;
	      this.removeListeners();
	      wrapper.removeChild(this.upperCanvasEl);
	      wrapper.removeChild(this.lowerCanvasEl);
	      this.contextCache = null;
	      this.contextTop = null;
	      ['upperCanvasEl', 'cacheCanvasEl'].forEach((function(element) {
	        fabric.util.cleanUpJsdomNode(this[element]);
	        this[element] = undefined;
	      }).bind(this));
	      if (wrapper.parentNode) {
	        wrapper.parentNode.replaceChild(this.lowerCanvasEl, this.wrapperEl);
	      }
	      delete this.wrapperEl;
	      fabric.StaticCanvas.prototype.dispose.call(this);
	      return this;
	    },
	
	    /**
	     * Clears all contexts (background, main, top) of an instance
	     * @return {fabric.Canvas} thisArg
	     * @chainable
	     */
	    clear: function () {
	      // this.discardActiveGroup();
	      this.discardActiveObject();
	      this.clearContext(this.contextTop);
	      return this.callSuper('clear');
	    },
	
	    /**
	     * Draws objects' controls (borders/controls)
	     * @param {CanvasRenderingContext2D} ctx Context to render controls on
	     */
	    drawControls: function(ctx) {
	      var activeObject = this._activeObject;
	
	      if (activeObject) {
	        activeObject._renderControls(ctx);
	      }
	    },
	
	    /**
	     * @private
	     */
	    _toObject: function(instance, methodName, propertiesToInclude) {
	      //If the object is part of the current selection group, it should
	      //be transformed appropriately
	      //i.e. it should be serialised as it would appear if the selection group
	      //were to be destroyed.
	      var originalProperties = this._realizeGroupTransformOnObject(instance),
	          object = this.callSuper('_toObject', instance, methodName, propertiesToInclude);
	      //Undo the damage we did by changing all of its properties
	      this._unwindGroupTransformOnObject(instance, originalProperties);
	      return object;
	    },
	
	    /**
	     * Realises an object's group transformation on it
	     * @private
	     * @param {fabric.Object} [instance] the object to transform (gets mutated)
	     * @returns the original values of instance which were changed
	     */
	    _realizeGroupTransformOnObject: function(instance) {
	      if (instance.group && instance.group.type === 'activeSelection' && this._activeObject === instance.group) {
	        var layoutProps = ['angle', 'flipX', 'flipY', 'left', 'scaleX', 'scaleY', 'skewX', 'skewY', 'top'];
	        //Copy all the positionally relevant properties across now
	        var originalValues = {};
	        layoutProps.forEach(function(prop) {
	          originalValues[prop] = instance[prop];
	        });
	        this._activeObject.realizeTransform(instance);
	        return originalValues;
	      }
	      else {
	        return null;
	      }
	    },
	
	    /**
	     * Restores the changed properties of instance
	     * @private
	     * @param {fabric.Object} [instance] the object to un-transform (gets mutated)
	     * @param {Object} [originalValues] the original values of instance, as returned by _realizeGroupTransformOnObject
	     */
	    _unwindGroupTransformOnObject: function(instance, originalValues) {
	      if (originalValues) {
	        instance.set(originalValues);
	      }
	    },
	
	    /**
	     * @private
	     */
	    _setSVGObject: function(markup, instance, reviver) {
	      //If the object is in a selection group, simulate what would happen to that
	      //object when the group is deselected
	      var originalProperties = this._realizeGroupTransformOnObject(instance);
	      this.callSuper('_setSVGObject', markup, instance, reviver);
	      this._unwindGroupTransformOnObject(instance, originalProperties);
	    },
	
	    setViewportTransform: function (vpt) {
	      if (this.renderOnAddRemove && this._activeObject && this._activeObject.isEditing) {
	        this._activeObject.clearContextTop();
	      }
	      fabric.StaticCanvas.prototype.setViewportTransform.call(this, vpt);
	    }
	  });
	
	  // copying static properties manually to work around Opera's bug,
	  // where "prototype" property is enumerable and overrides existing prototype
	  for (var prop in fabric.StaticCanvas) {
	    if (prop !== 'prototype') {
	      fabric.Canvas[prop] = fabric.StaticCanvas[prop];
	    }
	  }
	})();
	
	
	(function() {
	
	  var cursorOffset = {
	        mt: 0, // n
	        tr: 1, // ne
	        mr: 2, // e
	        br: 3, // se
	        mb: 4, // s
	        bl: 5, // sw
	        ml: 6, // w
	        tl: 7 // nw
	      },
	      addListener = fabric.util.addListener,
	      removeListener = fabric.util.removeListener,
	      RIGHT_CLICK = 3, MIDDLE_CLICK = 2, LEFT_CLICK = 1,
	      addEventOptions = { passive: false };
	
	  function checkClick(e, value) {
	    return e.button && (e.button === value - 1);
	  }
	
	  fabric.util.object.extend(fabric.Canvas.prototype, /** @lends fabric.Canvas.prototype */ {
	
	    /**
	     * Map of cursor style values for each of the object controls
	     * @private
	     */
	    cursorMap: [
	      'n-resize',
	      'ne-resize',
	      'e-resize',
	      'se-resize',
	      's-resize',
	      'sw-resize',
	      'w-resize',
	      'nw-resize'
	    ],
	
	    /**
	     * Contains the id of the touch event that owns the fabric transform
	     * @type Number
	     * @private
	     */
	    mainTouchId: null,
	
	    /**
	     * Adds mouse listeners to canvas
	     * @private
	     */
	    _initEventListeners: function () {
	      // in case we initialized the class twice. This should not happen normally
	      // but in some kind of applications where the canvas element may be changed
	      // this is a workaround to having double listeners.
	      this.removeListeners();
	      this._bindEvents();
	      this.addOrRemove(addListener, 'add');
	    },
	
	    /**
	     * return an event prefix pointer or mouse.
	     * @private
	     */
	    _getEventPrefix: function () {
	      return this.enablePointerEvents ? 'pointer' : 'mouse';
	    },
	
	    addOrRemove: function(functor, eventjsFunctor) {
	      var canvasElement = this.upperCanvasEl,
	          eventTypePrefix = this._getEventPrefix();
	      functor(fabric.window, 'resize', this._onResize);
	      functor(canvasElement, eventTypePrefix + 'down', this._onMouseDown);
	      functor(canvasElement, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
	      functor(canvasElement, eventTypePrefix + 'out', this._onMouseOut);
	      functor(canvasElement, eventTypePrefix + 'enter', this._onMouseEnter);
	      functor(canvasElement, 'wheel', this._onMouseWheel);
	      functor(canvasElement, 'contextmenu', this._onContextMenu);
	      functor(canvasElement, 'dblclick', this._onDoubleClick);
	      functor(canvasElement, 'dragover', this._onDragOver);
	      functor(canvasElement, 'dragenter', this._onDragEnter);
	      functor(canvasElement, 'dragleave', this._onDragLeave);
	      functor(canvasElement, 'drop', this._onDrop);
	      if (!this.enablePointerEvents) {
	        functor(canvasElement, 'touchstart', this._onTouchStart, addEventOptions);
	      }
	      if (typeof eventjs !== 'undefined' && eventjsFunctor in eventjs) {
	        eventjs[eventjsFunctor](canvasElement, 'gesture', this._onGesture);
	        eventjs[eventjsFunctor](canvasElement, 'drag', this._onDrag);
	        eventjs[eventjsFunctor](canvasElement, 'orientation', this._onOrientationChange);
	        eventjs[eventjsFunctor](canvasElement, 'shake', this._onShake);
	        eventjs[eventjsFunctor](canvasElement, 'longpress', this._onLongPress);
	      }
	    },
	
	    /**
	     * Removes all event listeners
	     */
	    removeListeners: function() {
	      this.addOrRemove(removeListener, 'remove');
	      // if you dispose on a mouseDown, before mouse up, you need to clean document to...
	      var eventTypePrefix = this._getEventPrefix();
	      removeListener(fabric.document, eventTypePrefix + 'up', this._onMouseUp);
	      removeListener(fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
	      removeListener(fabric.document, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
	      removeListener(fabric.document, 'touchmove', this._onMouseMove, addEventOptions);
	    },
	
	    /**
	     * @private
	     */
	    _bindEvents: function() {
	      if (this.eventsBound) {
	        // for any reason we pass here twice we do not want to bind events twice.
	        return;
	      }
	      this._onMouseDown = this._onMouseDown.bind(this);
	      this._onTouchStart = this._onTouchStart.bind(this);
	      this._onMouseMove = this._onMouseMove.bind(this);
	      this._onMouseUp = this._onMouseUp.bind(this);
	      this._onTouchEnd = this._onTouchEnd.bind(this);
	      this._onResize = this._onResize.bind(this);
	      this._onGesture = this._onGesture.bind(this);
	      this._onDrag = this._onDrag.bind(this);
	      this._onShake = this._onShake.bind(this);
	      this._onLongPress = this._onLongPress.bind(this);
	      this._onOrientationChange = this._onOrientationChange.bind(this);
	      this._onMouseWheel = this._onMouseWheel.bind(this);
	      this._onMouseOut = this._onMouseOut.bind(this);
	      this._onMouseEnter = this._onMouseEnter.bind(this);
	      this._onContextMenu = this._onContextMenu.bind(this);
	      this._onDoubleClick = this._onDoubleClick.bind(this);
	      this._onDragOver = this._onDragOver.bind(this);
	      this._onDragEnter = this._simpleEventHandler.bind(this, 'dragenter');
	      this._onDragLeave = this._simpleEventHandler.bind(this, 'dragleave');
	      this._onDrop = this._simpleEventHandler.bind(this, 'drop');
	      this.eventsBound = true;
	    },
	
	    /**
	     * @private
	     * @param {Event} [e] Event object fired on Event.js gesture
	     * @param {Event} [self] Inner Event object
	     */
	    _onGesture: function(e, self) {
	      this.__onTransformGesture && this.__onTransformGesture(e, self);
	    },
	
	    /**
	     * @private
	     * @param {Event} [e] Event object fired on Event.js drag
	     * @param {Event} [self] Inner Event object
	     */
	    _onDrag: function(e, self) {
	      this.__onDrag && this.__onDrag(e, self);
	    },
	
	    /**
	     * @private
	     * @param {Event} [e] Event object fired on wheel event
	     */
	    _onMouseWheel: function(e) {
	      this.__onMouseWheel(e);
	    },
	
	    /**
	     * @private
	     * @param {Event} e Event object fired on mousedown
	     */
	    _onMouseOut: function(e) {
	      var target = this._hoveredTarget;
	      this.fire('mouse:out', { target: target, e: e });
	      this._hoveredTarget = null;
	      target && target.fire('mouseout', { e: e });
	      if (this._iTextInstances) {
	        this._iTextInstances.forEach(function(obj) {
	          if (obj.isEditing) {
	            obj.hiddenTextarea.focus();
	          }
	        });
	      }
	    },
	
	    /**
	     * @private
	     * @param {Event} e Event object fired on mouseenter
	     */
	    _onMouseEnter: function(e) {
	      // This find target and consequent 'mouse:over' is used to
	      // clear old instances on hovered target.
	      // calling findTarget has the side effect of killing target.__corner.
	      // as a short term fix we are not firing this if we are currently transforming.
	      // as a long term fix we need to separate the action of finding a target with the
	      // side effects we added to it.
	      if (!this.currentTransform && !this.findTarget(e)) {
	        this.fire('mouse:over', { target: null, e: e });
	        this._hoveredTarget = null;
	      }
	    },
	
	    /**
	     * @private
	     * @param {Event} [e] Event object fired on Event.js orientation change
	     * @param {Event} [self] Inner Event object
	     */
	    _onOrientationChange: function(e, self) {
	      this.__onOrientationChange && this.__onOrientationChange(e, self);
	    },
	
	    /**
	     * @private
	     * @param {Event} [e] Event object fired on Event.js shake
	     * @param {Event} [self] Inner Event object
	     */
	    _onShake: function(e, self) {
	      this.__onShake && this.__onShake(e, self);
	    },
	
	    /**
	     * @private
	     * @param {Event} [e] Event object fired on Event.js shake
	     * @param {Event} [self] Inner Event object
	     */
	    _onLongPress: function(e, self) {
	      this.__onLongPress && this.__onLongPress(e, self);
	    },
	
	    /**
	     * prevent default to allow drop event to be fired
	     * @private
	     * @param {Event} [e] Event object fired on Event.js shake
	     */
	    _onDragOver: function(e) {
	      e.preventDefault();
	      var target = this._simpleEventHandler('dragover', e);
	      this._fireEnterLeaveEvents(target, e);
	    },
	
	    /**
	     * @private
	     * @param {Event} e Event object fired on mousedown
	     */
	    _onContextMenu: function (e) {
	      if (this.stopContextMenu) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	      return false;
	    },
	
	    /**
	     * @private
	     * @param {Event} e Event object fired on mousedown
	     */
	    _onDoubleClick: function (e) {
	      this._cacheTransformEventData(e);
	      this._handleEvent(e, 'dblclick');
	      this._resetTransformEventData(e);
	    },
	
	    /**
	     * Return a the id of an event.
	     * returns either the pointerId or the identifier or 0 for the mouse event
	     * @private
	     * @param {Event} evt Event object
	     */
	    getPointerId: function(evt) {
	      var changedTouches = evt.changedTouches;
	
	      if (changedTouches) {
	        return changedTouches[0] && changedTouches[0].identifier;
	      }
	
	      if (this.enablePointerEvents) {
	        return evt.pointerId;
	      }
	
	      return -1;
	    },
	
	    /**
	     * Determines if an event has the id of the event that is considered main
	     * @private
	     * @param {evt} event Event object
	     */
	    _isMainEvent: function(evt) {
	      if (evt.isPrimary === true) {
	        return true;
	      }
	      if (evt.isPrimary === false) {
	        return false;
	      }
	      if (evt.type === 'touchend' && evt.touches.length === 0) {
	        return true;
	      }
	      if (evt.changedTouches) {
	        return evt.changedTouches[0].identifier === this.mainTouchId;
	      }
	      return true;
	    },
	
	    /**
	     * @private
	     * @param {Event} e Event object fired on mousedown
	     */
	    _onTouchStart: function(e) {
	      e.preventDefault();
	      if (this.mainTouchId === null) {
	        this.mainTouchId = this.getPointerId(e);
	      }
	      this.__onMouseDown(e);
	      this._resetTransformEventData();
	      var canvasElement = this.upperCanvasEl,
	          eventTypePrefix = this._getEventPrefix();
	      addListener(fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
	      addListener(fabric.document, 'touchmove', this._onMouseMove, addEventOptions);
	      // Unbind mousedown to prevent double triggers from touch devices
	      removeListener(canvasElement, eventTypePrefix + 'down', this._onMouseDown);
	    },
	
	    /**
	     * @private
	     * @param {Event} e Event object fired on mousedown
	     */
	    _onMouseDown: function (e) {
	      this.__onMouseDown(e);
	      this._resetTransformEventData();
	      var canvasElement = this.upperCanvasEl,
	          eventTypePrefix = this._getEventPrefix();
	      removeListener(canvasElement, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
	      addListener(fabric.document, eventTypePrefix + 'up', this._onMouseUp);
	      addListener(fabric.document, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
	    },
	
	    /**
	     * @private
	     * @param {Event} e Event object fired on mousedown
	     */
	    _onTouchEnd: function(e) {
	      if (e.touches.length > 0) {
	        // if there are still touches stop here
	        return;
	      }
	      this.__onMouseUp(e);
	      this._resetTransformEventData();
	      this.mainTouchId = null;
	      var eventTypePrefix = this._getEventPrefix();
	      removeListener(fabric.document, 'touchend', this._onTouchEnd, addEventOptions);
	      removeListener(fabric.document, 'touchmove', this._onMouseMove, addEventOptions);
	      var _this = this;
	      if (this._willAddMouseDown) {
	        clearTimeout(this._willAddMouseDown);
	      }
	      this._willAddMouseDown = setTimeout(function() {
	        // Wait 400ms before rebinding mousedown to prevent double triggers
	        // from touch devices
	        addListener(_this.upperCanvasEl, eventTypePrefix + 'down', _this._onMouseDown);
	        _this._willAddMouseDown = 0;
	      }, 400);
	    },
	
	    /**
	     * @private
	     * @param {Event} e Event object fired on mouseup
	     */
	    _onMouseUp: function (e) {
	      this.__onMouseUp(e);
	      this._resetTransformEventData();
	      var canvasElement = this.upperCanvasEl,
	          eventTypePrefix = this._getEventPrefix();
	      if (this._isMainEvent(e)) {
	        removeListener(fabric.document, eventTypePrefix + 'up', this._onMouseUp);
	        removeListener(fabric.document, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
	        addListener(canvasElement, eventTypePrefix + 'move', this._onMouseMove, addEventOptions);
	      }
	    },
	
	    /**
	     * @private
	     * @param {Event} e Event object fired on mousemove
	     */
	    _onMouseMove: function (e) {
	      !this.allowTouchScrolling && e.preventDefault && e.preventDefault();
	      this.__onMouseMove(e);
	    },
	
	    /**
	     * @private
	     */
	    _onResize: function () {
	      this.calcOffset();
	    },
	
	    /**
	     * Decides whether the canvas should be redrawn in mouseup and mousedown events.
	     * @private
	     * @param {Object} target
	     */
	    _shouldRender: function(target) {
	      var activeObject = this._activeObject;
	
	      if (
	        !!activeObject !== !!target ||
	        (activeObject && target && (activeObject !== target))
	      ) {
	        // this covers: switch of target, from target to no target, selection of target
	        // multiSelection with key and mouse
	        return true;
	      }
	      else if (activeObject && activeObject.isEditing) {
	        // if we mouse up/down over a editing textbox a cursor change,
	        // there is no need to re render
	        return false;
	      }
	      return false;
	    },
	
	    /**
	     * Method that defines the actions when mouse is released on canvas.
	     * The method resets the currentTransform parameters, store the image corner
	     * position in the image object and render the canvas on top.
	     * @private
	     * @param {Event} e Event object fired on mouseup
	     */
	    __onMouseUp: function (e) {
	      var target, transform = this._currentTransform,
	          groupSelector = this._groupSelector, shouldRender = false,
	          isClick = (!groupSelector || (groupSelector.left === 0 && groupSelector.top === 0));
	      this._cacheTransformEventData(e);
	      target = this._target;
	      this._handleEvent(e, 'up:before');
	      // if right/middle click just fire events and return
	      // target undefined will make the _handleEvent search the target
	      if (checkClick(e, RIGHT_CLICK)) {
	        if (this.fireRightClick) {
	          this._handleEvent(e, 'up', RIGHT_CLICK, isClick);
	        }
	        return;
	      }
	
	      if (checkClick(e, MIDDLE_CLICK)) {
	        if (this.fireMiddleClick) {
	          this._handleEvent(e, 'up', MIDDLE_CLICK, isClick);
	        }
	        this._resetTransformEventData();
	        return;
	      }
	
	      if (this.isDrawingMode && this._isCurrentlyDrawing) {
	        this._onMouseUpInDrawingMode(e);
	        return;
	      }
	
	      if (!this._isMainEvent(e)) {
	        return;
	      }
	      if (transform) {
	        this._finalizeCurrentTransform(e);
	        shouldRender = transform.actionPerformed;
	      }
	
	      if (!isClick) {
	        this._maybeGroupObjects(e);
	        shouldRender || (shouldRender = this._shouldRender(target));
	      }
	      if (target) {
	        target.isMoving = false;
	      }
	      this._setCursorFromEvent(e, target);
	      this._handleEvent(e, 'up', LEFT_CLICK, isClick);
	      this._groupSelector = null;
	      this._currentTransform = null;
	      // reset the target information about which corner is selected
	      target && (target.__corner = 0);
	      if (shouldRender) {
	        this.requestRenderAll();
	      }
	      else if (!isClick) {
	        this.renderTop();
	      }
	    },
	
	    /**
	     * @private
	     * Handle event firing for target and subtargets
	     * @param {Event} e event from mouse
	     * @param {String} eventType event to fire (up, down or move)
	     * @return {Fabric.Object} target return the the target found, for internal reasons.
	     */
	    _simpleEventHandler: function(eventType, e) {
	      var target = this.findTarget(e),
	          targets = this.targets,
	          options = {
	            e: e,
	            target: target,
	            subTargets: targets,
	          };
	      this.fire(eventType, options);
	      target && target.fire(eventType, options);
	      if (!targets) {
	        return target;
	      }
	      for (var i = 0; i < targets.length; i++) {
	        targets[i].fire(eventType, options);
	      }
	      return target;
	    },
	
	    /**
	     * @private
	     * Handle event firing for target and subtargets
	     * @param {Event} e event from mouse
	     * @param {String} eventType event to fire (up, down or move)
	     * @param {fabric.Object} targetObj receiving event
	     * @param {Number} [button] button used in the event 1 = left, 2 = middle, 3 = right
	     * @param {Boolean} isClick for left button only, indicates that the mouse up happened without move.
	     */
	    _handleEvent: function(e, eventType, button, isClick) {
	      var target = this._target,
	          targets = this.targets || [],
	          options = {
	            e: e,
	            target: target,
	            subTargets: targets,
	            button: button || LEFT_CLICK,
	            isClick: isClick || false,
	            pointer: this._pointer,
	            absolutePointer: this._absolutePointer,
	            transform: this._currentTransform
	          };
	      this.fire('mouse:' + eventType, options);
	      target && target.fire('mouse' + eventType, options);
	      for (var i = 0; i < targets.length; i++) {
	        targets[i].fire('mouse' + eventType, options);
	      }
	    },
	
	    /**
	     * @private
	     * @param {Event} e send the mouse event that generate the finalize down, so it can be used in the event
	     */
	    _finalizeCurrentTransform: function(e) {
	
	      var transform = this._currentTransform,
	          target = transform.target,
	          eventName,
	          options = {
	            e: e,
	            target: target,
	            transform: transform,
	          };
	
	      if (target._scaling) {
	        target._scaling = false;
	      }
	
	      target.setCoords();
	
	      if (transform.actionPerformed || (this.stateful && target.hasStateChanged())) {
	        if (transform.actionPerformed) {
	          eventName = this._addEventOptions(options, transform);
	          this._fire(eventName, options);
	        }
	        this._fire('modified', options);
	      }
	    },
	
	    /**
	     * Mutate option object in order to add by property and give back the event name.
	     * @private
	     * @param {Object} options to mutate
	     * @param {Object} transform to inspect action from
	     */
	    _addEventOptions: function(options, transform) {
	      // we can probably add more details at low cost
	      // scale change, rotation changes, translation changes
	      var eventName, by;
	      switch (transform.action) {
	        case 'scaleX':
	          eventName = 'scaled';
	          by = 'x';
	          break;
	        case 'scaleY':
	          eventName = 'scaled';
	          by = 'y';
	          break;
	        case 'skewX':
	          eventName = 'skewed';
	          by = 'x';
	          break;
	        case 'skewY':
	          eventName = 'skewed';
	          by = 'y';
	          break;
	        case 'scale':
	          eventName = 'scaled';
	          by = 'equally';
	          break;
	        case 'rotate':
	          eventName = 'rotated';
	          break;
	        case 'drag':
	          eventName = 'moved';
	          break;
	      }
	      options.by = by;
	      return eventName;
	    },
	
	    /**
	     * @private
	     * @param {Event} e Event object fired on mousedown
	     */
	    _onMouseDownInDrawingMode: function(e) {
	      this._isCurrentlyDrawing = true;
	      if (this.getActiveObject()) {
	        this.discardActiveObject(e).requestRenderAll();
	      }
	      if (this.clipTo) {
	        fabric.util.clipContext(this, this.contextTop);
	      }
	      var pointer = this.getPointer(e);
	      this.freeDrawingBrush.onMouseDown(pointer, { e: e, pointer: pointer });
	      this._handleEvent(e, 'down');
	    },
	
	    /**
	     * @private
	     * @param {Event} e Event object fired on mousemove
	     */
	    _onMouseMoveInDrawingMode: function(e) {
	      if (this._isCurrentlyDrawing) {
	        var pointer = this.getPointer(e);
	        this.freeDrawingBrush.onMouseMove(pointer, { e: e, pointer: pointer });
	      }
	      this.setCursor(this.freeDrawingCursor);
	      this._handleEvent(e, 'move');
	    },
	
	    /**
	     * @private
	     * @param {Event} e Event object fired on mouseup
	     */
	    _onMouseUpInDrawingMode: function(e) {
	      if (this.clipTo) {
	        this.contextTop.restore();
	      }
	      var pointer = this.getPointer(e);
	      this._isCurrentlyDrawing = this.freeDrawingBrush.onMouseUp({ e: e, pointer: pointer });
	      this._handleEvent(e, 'up');
	    },
	
	    /**
	     * Method that defines the actions when mouse is clicked on canvas.
	     * The method inits the currentTransform parameters and renders all the
	     * canvas so the current image can be placed on the top canvas and the rest
	     * in on the container one.
	     * @private
	     * @param {Event} e Event object fired on mousedown
	     */
	    __onMouseDown: function (e) {
	      this._cacheTransformEventData(e);
	      this._handleEvent(e, 'down:before');
	      var target = this._target;
	      // if right click just fire events
	      if (checkClick(e, RIGHT_CLICK)) {
	        if (this.fireRightClick) {
	          this._handleEvent(e, 'down', RIGHT_CLICK);
	        }
	        return;
	      }
	
	      if (checkClick(e, MIDDLE_CLICK)) {
	        if (this.fireMiddleClick) {
	          this._handleEvent(e, 'down', MIDDLE_CLICK);
	        }
	        return;
	      }
	
	      if (this.isDrawingMode) {
	        this._onMouseDownInDrawingMode(e);
	        return;
	      }
	
	      if (!this._isMainEvent(e)) {
	        return;
	      }
	
	      // ignore if some object is being transformed at this moment
	      if (this._currentTransform) {
	        return;
	      }
	
	      var pointer = this._pointer;
	      // save pointer for check in __onMouseUp event
	      this._previousPointer = pointer;
	      var shouldRender = this._shouldRender(target),
	          shouldGroup = this._shouldGroup(e, target);
	      if (this._shouldClearSelection(e, target)) {
	        this.discardActiveObject(e);
	      }
	      else if (shouldGroup) {
	        this._handleGrouping(e, target);
	        target = this._activeObject;
	      }
	
	      if (this.selection && (!target ||
	        (!target.selectable && !target.isEditing && target !== this._activeObject))) {
	        this._groupSelector = {
	          ex: pointer.x,
	          ey: pointer.y,
	          top: 0,
	          left: 0
	        };
	      }
	
	      if (target) {
	        var alreadySelected = target === this._activeObject;
	        if (target.selectable) {
	          this.setActiveObject(target, e);
	        }
	        if (target === this._activeObject && (target.__corner || !shouldGroup)) {
	          this._setupCurrentTransform(e, target, alreadySelected);
	        }
	      }
	      this._handleEvent(e, 'down');
	      // we must renderAll so that we update the visuals
	      (shouldRender || shouldGroup) && this.requestRenderAll();
	    },
	
	    /**
	     * reset cache form common information needed during event processing
	     * @private
	     */
	    _resetTransformEventData: function() {
	      this._target = null;
	      this._pointer = null;
	      this._absolutePointer = null;
	    },
	
	    /**
	     * Cache common information needed during event processing
	     * @private
	     * @param {Event} e Event object fired on event
	     */
	    _cacheTransformEventData: function(e) {
	      // reset in order to avoid stale caching
	      this._resetTransformEventData();
	      this._pointer = this.getPointer(e, true);
	      this._absolutePointer = this.restorePointerVpt(this._pointer);
	      this._target = this._currentTransform ? this._currentTransform.target : this.findTarget(e) || null;
	    },
	
	    /**
	     * @private
	     */
	    _beforeTransform: function(e) {
	      var t = this._currentTransform;
	      this.stateful && t.target.saveState();
	      this.fire('before:transform', {
	        e: e,
	        transform: t,
	      });
	      // determine if it's a drag or rotate case
	      if (t.corner) {
	        this.onBeforeScaleRotate(t.target);
	      }
	    },
	
	    /**
	     * Method that defines the actions when mouse is hovering the canvas.
	     * The currentTransform parameter will define whether the user is rotating/scaling/translating
	     * an image or neither of them (only hovering). A group selection is also possible and would cancel
	     * all any other type of action.
	     * In case of an image transformation only the top canvas will be rendered.
	     * @private
	     * @param {Event} e Event object fired on mousemove
	     */
	    __onMouseMove: function (e) {
	      this._handleEvent(e, 'move:before');
	      this._cacheTransformEventData(e);
	      var target, pointer;
	
	      if (this.isDrawingMode) {
	        this._onMouseMoveInDrawingMode(e);
	        return;
	      }
	
	      if (!this._isMainEvent(e)) {
	        return;
	      }
	
	      var groupSelector = this._groupSelector;
	
	      // We initially clicked in an empty area, so we draw a box for multiple selection
	      if (groupSelector) {
	        pointer = this._pointer;
	
	        groupSelector.left = pointer.x - groupSelector.ex;
	        groupSelector.top = pointer.y - groupSelector.ey;
	
	        this.renderTop();
	      }
	      else if (!this._currentTransform) {
	        target = this.findTarget(e) || null;
	        this._setCursorFromEvent(e, target);
	        this._fireOverOutEvents(target, e);
	      }
	      else {
	        this._transformObject(e);
	      }
	      this._handleEvent(e, 'move');
	      this._resetTransformEventData();
	    },
	
	    /**
	     * Manage the mouseout, mouseover events for the fabric object on the canvas
	     * @param {Fabric.Object} target the target where the target from the mousemove event
	     * @param {Event} e Event object fired on mousemove
	     * @private
	     */
	    _fireOverOutEvents: function(target, e) {
	      this.fireSyntheticInOutEvents(target, e, {
	        targetName: '_hoveredTarget',
	        canvasEvtOut: 'mouse:out',
	        evtOut: 'mouseout',
	        canvasEvtIn: 'mouse:over',
	        evtIn: 'mouseover',
	      });
	    },
	
	    /**
	     * Manage the dragEnter, dragLeave events for the fabric objects on the canvas
	     * @param {Fabric.Object} target the target where the target from the onDrag event
	     * @param {Event} e Event object fired on ondrag
	     * @private
	     */
	    _fireEnterLeaveEvents: function(target, e) {
	      this.fireSyntheticInOutEvents(target, e, {
	        targetName: '_draggedoverTarget',
	        evtOut: 'dragleave',
	        evtIn: 'dragenter',
	      });
	    },
	
	    /**
	     * Manage the synthetic in/out events for the fabric objects on the canvas
	     * @param {Fabric.Object} target the target where the target from the supported events
	     * @param {Event} e Event object fired
	     * @param {Object} config configuration for the function to work
	     * @param {String} config.targetName property on the canvas where the old target is stored
	     * @param {String} [config.canvasEvtOut] name of the event to fire at canvas level for out
	     * @param {String} config.evtOut name of the event to fire for out
	     * @param {String} [config.canvasEvtIn] name of the event to fire at canvas level for in
	     * @param {String} config.evtIn name of the event to fire for in
	     * @private
	     */
	    fireSyntheticInOutEvents: function(target, e, config) {
	      var inOpt, outOpt, oldTarget = this[config.targetName], outFires, inFires,
	          targetChanged = oldTarget !== target, canvasEvtIn = config.canvasEvtIn, canvasEvtOut = config.canvasEvtOut;
	      if (targetChanged) {
	        inOpt = { e: e, target: target, previousTarget: oldTarget };
	        outOpt = { e: e, target: oldTarget, nextTarget: target };
	        this[config.targetName] = target;
	      }
	      inFires = target && targetChanged;
	      outFires = oldTarget && targetChanged;
	      if (outFires) {
	        canvasEvtOut && this.fire(canvasEvtOut, outOpt);
	        oldTarget.fire(config.evtOut, outOpt);
	      }
	      if (inFires) {
	        canvasEvtIn && this.fire(canvasEvtIn, inOpt);
	        target.fire(config.evtIn, inOpt);
	      }
	    },
	
	    /**
	     * Method that defines actions when an Event Mouse Wheel
	     * @param {Event} e Event object fired on mouseup
	     */
	    __onMouseWheel: function(e) {
	      this._cacheTransformEventData(e);
	      this._handleEvent(e, 'wheel');
	      this._resetTransformEventData();
	    },
	
	    /**
	     * @private
	     * @param {Event} e Event fired on mousemove
	     */
	    _transformObject: function(e) {
	      var pointer = this.getPointer(e),
	          transform = this._currentTransform;
	
	      transform.reset = false;
	      transform.target.isMoving = true;
	      transform.shiftKey = e.shiftKey;
	      transform.altKey = e[this.centeredKey];
	
	      this._beforeScaleTransform(e, transform);
	      this._performTransformAction(e, transform, pointer);
	
	      transform.actionPerformed && this.requestRenderAll();
	    },
	
	    /**
	     * @private
	     */
	    _performTransformAction: function(e, transform, pointer) {
	      var x = pointer.x,
	          y = pointer.y,
	          action = transform.action,
	          actionPerformed = false,
	          options = {
	            target: transform.target,
	            e: e,
	            transform: transform,
	            pointer: pointer
	          };
	
	      if (action === 'rotate') {
	        (actionPerformed = this._rotateObject(x, y)) && this._fire('rotating', options);
	      }
	      else if (action === 'scale') {
	        (actionPerformed = this._onScale(e, transform, x, y)) && this._fire('scaling', options);
	      }
	      else if (action === 'scaleX') {
	        (actionPerformed = this._scaleObject(x, y, 'x')) && this._fire('scaling', options);
	      }
	      else if (action === 'scaleY') {
	        (actionPerformed = this._scaleObject(x, y, 'y')) && this._fire('scaling', options);
	      }
	      else if (action === 'skewX') {
	        (actionPerformed = this._skewObject(x, y, 'x')) && this._fire('skewing', options);
	      }
	      else if (action === 'skewY') {
	        (actionPerformed = this._skewObject(x, y, 'y')) && this._fire('skewing', options);
	      }
	      else {
	        actionPerformed = this._translateObject(x, y);
	        if (actionPerformed) {
	          this._fire('moving', options);
	          this.setCursor(options.target.moveCursor || this.moveCursor);
	        }
	      }
	      transform.actionPerformed = transform.actionPerformed || actionPerformed;
	    },
	
	    /**
	     * @private
	     */
	    _fire: function(eventName, options) {
	      this.fire('object:' + eventName, options);
	      options.target.fire(eventName, options);
	    },
	
	    /**
	     * @private
	     */
	    _beforeScaleTransform: function(e, transform) {
	      if (transform.action === 'scale' || transform.action === 'scaleX' || transform.action === 'scaleY') {
	        var centerTransform = this._shouldCenterTransform(transform.target);
	
	        // Switch from a normal resize to center-based
	        if ((centerTransform && (transform.originX !== 'center' || transform.originY !== 'center')) ||
	           // Switch from center-based resize to normal one
	           (!centerTransform && transform.originX === 'center' && transform.originY === 'center')
	        ) {
	          this._resetCurrentTransform();
	          transform.reset = true;
	        }
	      }
	    },
	
	    /**
	     * @private
	     * @param {Event} e Event object
	     * @param {Object} transform current transform
	     * @param {Number} x mouse position x from origin
	     * @param {Number} y mouse position y from origin
	     * @return {Boolean} true if the scaling occurred
	     */
	    _onScale: function(e, transform, x, y) {
	      if (this._isUniscalePossible(e, transform.target)) {
	        transform.currentAction = 'scale';
	        return this._scaleObject(x, y);
	      }
	      else {
	        // Switch from a normal resize to proportional
	        if (!transform.reset && transform.currentAction === 'scale') {
	          this._resetCurrentTransform();
	        }
	
	        transform.currentAction = 'scaleEqually';
	        return this._scaleObject(x, y, 'equally');
	      }
	    },
	
	    /**
	     * @private
	     * @param {Event} e Event object
	     * @param {fabric.Object} target current target
	     * @return {Boolean} true if unproportional scaling is possible
	     */
	    _isUniscalePossible: function(e, target) {
	      return (e[this.uniScaleKey] || this.uniScaleTransform) && !target.get('lockUniScaling');
	    },
	
	    /**
	     * Sets the cursor depending on where the canvas is being hovered.
	     * Note: very buggy in Opera
	     * @param {Event} e Event object
	     * @param {Object} target Object that the mouse is hovering, if so.
	     */
	    _setCursorFromEvent: function (e, target) {
	      if (!target) {
	        this.setCursor(this.defaultCursor);
	        return false;
	      }
	      var hoverCursor = target.hoverCursor || this.hoverCursor,
	          activeSelection = this._activeObject && this._activeObject.type === 'activeSelection' ?
	            this._activeObject : null,
	          // only show proper corner when group selection is not active
	          corner = (!activeSelection || !activeSelection.contains(target))
	                    && target._findTargetCorner(this.getPointer(e, true));
	
	      if (!corner) {
	        this.setCursor(hoverCursor);
	      }
	      else {
	        this.setCursor(this.getCornerCursor(corner, target, e));
	      }
	    },
	
	    /**
	     * @private
	     */
	    getCornerCursor: function(corner, target, e) {
	      if (this.actionIsDisabled(corner, target, e)) {
	        return this.notAllowedCursor;
	      }
	      else if (corner in cursorOffset) {
	        return this._getRotatedCornerCursor(corner, target, e);
	      }
	      else if (corner === 'mtr' && target.hasRotatingPoint) {
	        return this.rotationCursor;
	      }
	      else {
	        return this.defaultCursor;
	      }
	    },
	
	    actionIsDisabled: function(corner, target, e) {
	      if (corner === 'mt' || corner === 'mb') {
	        return e[this.altActionKey] ? target.lockSkewingX : target.lockScalingY;
	      }
	      else if (corner === 'ml' || corner === 'mr') {
	        return e[this.altActionKey] ? target.lockSkewingY : target.lockScalingX;
	      }
	      else if (corner === 'mtr') {
	        return target.lockRotation;
	      }
	      else {
	        return this._isUniscalePossible(e, target) ?
	          target.lockScalingX && target.lockScalingY : target.lockScalingX || target.lockScalingY;
	      }
	    },
	
	    /**
	     * @private
	     */
	    _getRotatedCornerCursor: function(corner, target, e) {
	      var n = Math.round((target.angle % 360) / 45);
	
	      if (n < 0) {
	        n += 8; // full circle ahead
	      }
	      n += cursorOffset[corner];
	      if (e[this.altActionKey] && cursorOffset[corner] % 2 === 0) {
	        //if we are holding shift and we are on a mx corner...
	        n += 2;
	      }
	      // normalize n to be from 0 to 7
	      n %= 8;
	
	      return this.cursorMap[n];
	    }
	  });
	})();
	
	
	(function() {
	
	  var min = Math.min,
	      max = Math.max;
	
	  fabric.util.object.extend(fabric.Canvas.prototype, /** @lends fabric.Canvas.prototype */ {
	
	    /**
	     * @private
	     * @param {Event} e Event object
	     * @param {fabric.Object} target
	     * @return {Boolean}
	     */
	    _shouldGroup: function(e, target) {
	      var activeObject = this._activeObject;
	      return activeObject && this._isSelectionKeyPressed(e) && target && target.selectable && this.selection &&
	            (activeObject !== target || activeObject.type === 'activeSelection') && !target.onSelect({ e: e });
	    },
	
	    /**
	     * @private
	     * @param {Event} e Event object
	     * @param {fabric.Object} target
	     */
	    _handleGrouping: function (e, target) {
	      var activeObject = this._activeObject;
	      // avoid multi select when shift click on a corner
	      if (activeObject.__corner) {
	        return;
	      }
	      if (target === activeObject) {
	        // if it's a group, find target again, using activeGroup objects
	        target = this.findTarget(e, true);
	        // if even object is not found or we are on activeObjectCorner, bail out
	        if (!target || !target.selectable) {
	          return;
	        }
	      }
	      if (activeObject && activeObject.type === 'activeSelection') {
	        this._updateActiveSelection(target, e);
	      }
	      else {
	        this._createActiveSelection(target, e);
	      }
	    },
	
	    /**
	     * @private
	     */
	    _updateActiveSelection: function(target, e) {
	      var activeSelection = this._activeObject,
	          currentActiveObjects = activeSelection._objects.slice(0);
	      if (activeSelection.contains(target)) {
	        activeSelection.removeWithUpdate(target);
	        this._hoveredTarget = target;
	        if (activeSelection.size() === 1) {
	          // activate last remaining object
	          this._setActiveObject(activeSelection.item(0), e);
	        }
	      }
	      else {
	        activeSelection.addWithUpdate(target);
	        this._hoveredTarget = activeSelection;
	      }
	      this._fireSelectionEvents(currentActiveObjects, e);
	    },
	
	    /**
	     * @private
	     */
	    _createActiveSelection: function(target, e) {
	      var currentActives = this.getActiveObjects(), group = this._createGroup(target);
	      this._hoveredTarget = group;
	      this._setActiveObject(group, e);
	      this._fireSelectionEvents(currentActives, e);
	    },
	
	    /**
	     * @private
	     * @param {Object} target
	     */
	    _createGroup: function(target) {
	      var objects = this._objects,
	          isActiveLower = objects.indexOf(this._activeObject) < objects.indexOf(target),
	          groupObjects = isActiveLower
	            ? [this._activeObject, target]
	            : [target, this._activeObject];
	      this._activeObject.isEditing && this._activeObject.exitEditing();
	      return new fabric.ActiveSelection(groupObjects, {
	        canvas: this
	      });
	    },
	
	    /**
	     * @private
	     * @param {Event} e mouse event
	     */
	    _groupSelectedObjects: function (e) {
	
	      var group = this._collectObjects(e),
	          aGroup;
	
	      // do not create group for 1 element only
	      if (group.length === 1) {
	        this.setActiveObject(group[0], e);
	      }
	      else if (group.length > 1) {
	        aGroup = new fabric.ActiveSelection(group.reverse(), {
	          canvas: this
	        });
	        this.setActiveObject(aGroup, e);
	      }
	    },
	
	    /**
	     * @private
	     */
	    _collectObjects: function(e) {
	      var group = [],
	          currentObject,
	          x1 = this._groupSelector.ex,
	          y1 = this._groupSelector.ey,
	          x2 = x1 + this._groupSelector.left,
	          y2 = y1 + this._groupSelector.top,
	          selectionX1Y1 = new fabric.Point(min(x1, x2), min(y1, y2)),
	          selectionX2Y2 = new fabric.Point(max(x1, x2), max(y1, y2)),
	          allowIntersect = !this.selectionFullyContained,
	          isClick = x1 === x2 && y1 === y2;
	      // we iterate reverse order to collect top first in case of click.
	      for (var i = this._objects.length; i--; ) {
	        currentObject = this._objects[i];
	
	        if (!currentObject || !currentObject.selectable || !currentObject.visible) {
	          continue;
	        }
	
	        if ((allowIntersect && currentObject.intersectsWithRect(selectionX1Y1, selectionX2Y2)) ||
	            currentObject.isContainedWithinRect(selectionX1Y1, selectionX2Y2) ||
	            (allowIntersect && currentObject.containsPoint(selectionX1Y1)) ||
	            (allowIntersect && currentObject.containsPoint(selectionX2Y2))
	        ) {
	          group.push(currentObject);
	          // only add one object if it's a click
	          if (isClick) {
	            break;
	          }
	        }
	      }
	
	      if (group.length > 1) {
	        group = group.filter(function(object) {
	          return !object.onSelect({ e: e });
	        });
	      }
	
	      return group;
	    },
	
	    /**
	     * @private
	     */
	    _maybeGroupObjects: function(e) {
	      if (this.selection && this._groupSelector) {
	        this._groupSelectedObjects(e);
	      }
	      this.setCursor(this.defaultCursor);
	      // clear selection and current transformation
	      this._groupSelector = null;
	    }
	  });
	
	})();
	
	
	(function () {
	  fabric.util.object.extend(fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {
	
	    /**
	     * Exports canvas element to a dataurl image. Note that when multiplier is used, cropping is scaled appropriately
	     * @param {Object} [options] Options object
	     * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
	     * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
	     * @param {Number} [options.multiplier=1] Multiplier to scale by, to have consistent
	     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
	     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
	     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
	     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
	     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 2.0.0
	     * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
	     * @see {@link http://jsfiddle.net/fabricjs/NfZVb/|jsFiddle demo}
	     * @example <caption>Generate jpeg dataURL with lower quality</caption>
	     * var dataURL = canvas.toDataURL({
	     *   format: 'jpeg',
	     *   quality: 0.8
	     * });
	     * @example <caption>Generate cropped png dataURL (clipping of canvas)</caption>
	     * var dataURL = canvas.toDataURL({
	     *   format: 'png',
	     *   left: 100,
	     *   top: 100,
	     *   width: 200,
	     *   height: 200
	     * });
	     * @example <caption>Generate double scaled png dataURL</caption>
	     * var dataURL = canvas.toDataURL({
	     *   format: 'png',
	     *   multiplier: 2
	     * });
	     */
	    toDataURL: function (options) {
	      options || (options = { });
	
	      var format = options.format || 'png',
	          quality = options.quality || 1,
	          multiplier = (options.multiplier || 1) * (options.enableRetinaScaling ? this.getRetinaScaling() : 1),
	          canvasEl = this.toCanvasElement(multiplier, options);
	      return fabric.util.toDataURL(canvasEl, format, quality);
	    },
	
	    /**
	     * Create a new HTMLCanvas element painted with the current canvas content.
	     * No need to resize the actual one or repaint it.
	     * Will transfer object ownership to a new canvas, paint it, and set everything back.
	     * This is an intermediary step used to get to a dataUrl but also it is useful to
	     * create quick image copies of a canvas without passing for the dataUrl string
	     * @param {Number} [multiplier] a zoom factor.
	     * @param {Object} [cropping] Cropping informations
	     * @param {Number} [cropping.left] Cropping left offset.
	     * @param {Number} [cropping.top] Cropping top offset.
	     * @param {Number} [cropping.width] Cropping width.
	     * @param {Number} [cropping.height] Cropping height.
	     */
	    toCanvasElement: function(multiplier, cropping) {
	      multiplier = multiplier || 1;
	      cropping = cropping || { };
	      var scaledWidth = (cropping.width || this.width) * multiplier,
	          scaledHeight = (cropping.height || this.height) * multiplier,
	          zoom = this.getZoom(),
	          originalWidth = this.width,
	          originalHeight = this.height,
	          newZoom = zoom * multiplier,
	          vp = this.viewportTransform,
	          translateX = (vp[4] - (cropping.left || 0)) * multiplier,
	          translateY = (vp[5] - (cropping.top || 0)) * multiplier,
	          originalInteractive = this.interactive,
	          newVp = [newZoom, 0, 0, newZoom, translateX, translateY],
	          originalRetina = this.enableRetinaScaling,
	          canvasEl = fabric.util.createCanvasElement(),
	          originalContextTop = this.contextTop;
	      canvasEl.width = scaledWidth;
	      canvasEl.height = scaledHeight;
	      this.contextTop = null;
	      this.enableRetinaScaling = false;
	      this.interactive = false;
	      this.viewportTransform = newVp;
	      this.width = scaledWidth;
	      this.height = scaledHeight;
	      this.calcViewportBoundaries();
	      this.renderCanvas(canvasEl.getContext('2d'), this._objects);
	      this.viewportTransform = vp;
	      this.width = originalWidth;
	      this.height = originalHeight;
	      this.calcViewportBoundaries();
	      this.interactive = originalInteractive;
	      this.enableRetinaScaling = originalRetina;
	      this.contextTop = originalContextTop;
	      return canvasEl;
	    },
	  });
	
	})();
	
	
	fabric.util.object.extend(fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {
	
	  /**
	   * Populates canvas with data from the specified dataless JSON.
	   * JSON format must conform to the one of {@link fabric.Canvas#toDatalessJSON}
	   * @deprecated since 1.2.2
	   * @param {String|Object} json JSON string or object
	   * @param {Function} callback Callback, invoked when json is parsed
	   *                            and corresponding objects (e.g: {@link fabric.Image})
	   *                            are initialized
	   * @param {Function} [reviver] Method for further parsing of JSON elements, called after each fabric object created.
	   * @return {fabric.Canvas} instance
	   * @chainable
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#deserialization}
	   */
	  loadFromDatalessJSON: function (json, callback, reviver) {
	    return this.loadFromJSON(json, callback, reviver);
	  },
	
	  /**
	   * Populates canvas with data from the specified JSON.
	   * JSON format must conform to the one of {@link fabric.Canvas#toJSON}
	   * @param {String|Object} json JSON string or object
	   * @param {Function} callback Callback, invoked when json is parsed
	   *                            and corresponding objects (e.g: {@link fabric.Image})
	   *                            are initialized
	   * @param {Function} [reviver] Method for further parsing of JSON elements, called after each fabric object created.
	   * @return {fabric.Canvas} instance
	   * @chainable
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#deserialization}
	   * @see {@link http://jsfiddle.net/fabricjs/fmgXt/|jsFiddle demo}
	   * @example <caption>loadFromJSON</caption>
	   * canvas.loadFromJSON(json, canvas.renderAll.bind(canvas));
	   * @example <caption>loadFromJSON with reviver</caption>
	   * canvas.loadFromJSON(json, canvas.renderAll.bind(canvas), function(o, object) {
	   *   // `o` = json object
	   *   // `object` = fabric.Object instance
	   *   // ... do some stuff ...
	   * });
	   */
	  loadFromJSON: function (json, callback, reviver) {
	    if (!json) {
	      return;
	    }
	
	    // serialize if it wasn't already
	    var serialized = (typeof json === 'string')
	      ? JSON.parse(json)
	      : fabric.util.object.clone(json);
	
	    var _this = this,
	        clipPath = serialized.clipPath,
	        renderOnAddRemove = this.renderOnAddRemove;
	
	    this.renderOnAddRemove = false;
	
	    delete serialized.clipPath;
	
	    this._enlivenObjects(serialized.objects, function (enlivenedObjects) {
	      _this.clear();
	      _this._setBgOverlay(serialized, function () {
	        if (clipPath) {
	          _this._enlivenObjects([clipPath], function (enlivenedCanvasClip) {
	            _this.clipPath = enlivenedCanvasClip[0];
	            _this.__setupCanvas.call(_this, serialized, enlivenedObjects, renderOnAddRemove, callback);
	          });
	        }
	        else {
	          _this.__setupCanvas.call(_this, serialized, enlivenedObjects, renderOnAddRemove, callback);
	        }
	      });
	    }, reviver);
	    return this;
	  },
	
	  /**
	   * @private
	   * @param {Object} serialized Object with background and overlay information
	   * @param {Array} restored canvas objects
	   * @param {Function} cached renderOnAddRemove callback
	   * @param {Function} callback Invoked after all background and overlay images/patterns loaded
	   */
	  __setupCanvas: function(serialized, enlivenedObjects, renderOnAddRemove, callback) {
	    var _this = this;
	    enlivenedObjects.forEach(function(obj, index) {
	      // we splice the array just in case some custom classes restored from JSON
	      // will add more object to canvas at canvas init.
	      _this.insertAt(obj, index);
	    });
	    this.renderOnAddRemove = renderOnAddRemove;
	    // remove parts i cannot set as options
	    delete serialized.objects;
	    delete serialized.backgroundImage;
	    delete serialized.overlayImage;
	    delete serialized.background;
	    delete serialized.overlay;
	    // this._initOptions does too many things to just
	    // call it. Normally loading an Object from JSON
	    // create the Object instance. Here the Canvas is
	    // already an instance and we are just loading things over it
	    this._setOptions(serialized);
	    this.renderAll();
	    callback && callback();
	  },
	
	  /**
	   * @private
	   * @param {Object} serialized Object with background and overlay information
	   * @param {Function} callback Invoked after all background and overlay images/patterns loaded
	   */
	  _setBgOverlay: function(serialized, callback) {
	    var loaded = {
	      backgroundColor: false,
	      overlayColor: false,
	      backgroundImage: false,
	      overlayImage: false
	    };
	
	    if (!serialized.backgroundImage && !serialized.overlayImage && !serialized.background && !serialized.overlay) {
	      callback && callback();
	      return;
	    }
	
	    var cbIfLoaded = function () {
	      if (loaded.backgroundImage && loaded.overlayImage && loaded.backgroundColor && loaded.overlayColor) {
	        callback && callback();
	      }
	    };
	
	    this.__setBgOverlay('backgroundImage', serialized.backgroundImage, loaded, cbIfLoaded);
	    this.__setBgOverlay('overlayImage', serialized.overlayImage, loaded, cbIfLoaded);
	    this.__setBgOverlay('backgroundColor', serialized.background, loaded, cbIfLoaded);
	    this.__setBgOverlay('overlayColor', serialized.overlay, loaded, cbIfLoaded);
	  },
	
	  /**
	   * @private
	   * @param {String} property Property to set (backgroundImage, overlayImage, backgroundColor, overlayColor)
	   * @param {(Object|String)} value Value to set
	   * @param {Object} loaded Set loaded property to true if property is set
	   * @param {Object} callback Callback function to invoke after property is set
	   */
	  __setBgOverlay: function(property, value, loaded, callback) {
	    var _this = this;
	
	    if (!value) {
	      loaded[property] = true;
	      callback && callback();
	      return;
	    }
	
	    if (property === 'backgroundImage' || property === 'overlayImage') {
	      fabric.util.enlivenObjects([value], function(enlivedObject){
	        _this[property] = enlivedObject[0];
	        loaded[property] = true;
	        callback && callback();
	      });
	    }
	    else {
	      this['set' + fabric.util.string.capitalize(property, true)](value, function() {
	        loaded[property] = true;
	        callback && callback();
	      });
	    }
	  },
	
	  /**
	   * @private
	   * @param {Array} objects
	   * @param {Function} callback
	   * @param {Function} [reviver]
	   */
	  _enlivenObjects: function (objects, callback, reviver) {
	    if (!objects || objects.length === 0) {
	      callback && callback([]);
	      return;
	    }
	
	    fabric.util.enlivenObjects(objects, function(enlivenedObjects) {
	      callback && callback(enlivenedObjects);
	    }, null, reviver);
	  },
	
	  /**
	   * @private
	   * @param {String} format
	   * @param {Function} callback
	   */
	  _toDataURL: function (format, callback) {
	    this.clone(function (clone) {
	      callback(clone.toDataURL(format));
	    });
	  },
	
	  /**
	   * @private
	   * @param {String} format
	   * @param {Number} multiplier
	   * @param {Function} callback
	   */
	  _toDataURLWithMultiplier: function (format, multiplier, callback) {
	    this.clone(function (clone) {
	      callback(clone.toDataURLWithMultiplier(format, multiplier));
	    });
	  },
	
	  /**
	   * Clones canvas instance
	   * @param {Object} [callback] Receives cloned instance as a first argument
	   * @param {Array} [properties] Array of properties to include in the cloned canvas and children
	   */
	  clone: function (callback, properties) {
	    var data = JSON.stringify(this.toJSON(properties));
	    this.cloneWithoutData(function(clone) {
	      clone.loadFromJSON(data, function() {
	        callback && callback(clone);
	      });
	    });
	  },
	
	  /**
	   * Clones canvas instance without cloning existing data.
	   * This essentially copies canvas dimensions, clipping properties, etc.
	   * but leaves data empty (so that you can populate it with your own)
	   * @param {Object} [callback] Receives cloned instance as a first argument
	   */
	  cloneWithoutData: function(callback) {
	    var el = fabric.util.createCanvasElement();
	
	    el.width = this.width;
	    el.height = this.height;
	
	    var clone = new fabric.Canvas(el);
	    clone.clipTo = this.clipTo;
	    if (this.backgroundImage) {
	      clone.setBackgroundImage(this.backgroundImage.src, function() {
	        clone.renderAll();
	        callback && callback(clone);
	      });
	      clone.backgroundImageOpacity = this.backgroundImageOpacity;
	      clone.backgroundImageStretch = this.backgroundImageStretch;
	    }
	    else {
	      callback && callback(clone);
	    }
	  }
	});
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric = global.fabric || (global.fabric = { }),
	      extend = fabric.util.object.extend,
	      clone = fabric.util.object.clone,
	      toFixed = fabric.util.toFixed,
	      capitalize = fabric.util.string.capitalize,
	      degreesToRadians = fabric.util.degreesToRadians,
	      supportsLineDash = fabric.StaticCanvas.supports('setLineDash'),
	      objectCaching = !fabric.isLikelyNode,
	      ALIASING_LIMIT = 2;
	
	  if (fabric.Object) {
	    return;
	  }
	
	  /**
	   * Root object class from which all 2d shape classes inherit from
	   * @class fabric.Object
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#objects}
	   * @see {@link fabric.Object#initialize} for constructor definition
	   *
	   * @fires added
	   * @fires removed
	   *
	   * @fires selected
	   * @fires deselected
	   * @fires modified
	   * @fires modified
	   * @fires moved
	   * @fires scaled
	   * @fires rotated
	   * @fires skewed
	   *
	   * @fires rotating
	   * @fires scaling
	   * @fires moving
	   * @fires skewing
	   *
	   * @fires mousedown
	   * @fires mouseup
	   * @fires mouseover
	   * @fires mouseout
	   * @fires mousewheel
	   * @fires mousedblclick
	   *
	   * @fires dragover
	   * @fires dragenter
	   * @fires dragleave
	   * @fires drop
	   */
	  fabric.Object = fabric.util.createClass(fabric.CommonMethods, /** @lends fabric.Object.prototype */ {
	
	    /**
	     * Type of an object (rect, circle, path, etc.).
	     * Note that this property is meant to be read-only and not meant to be modified.
	     * If you modify, certain parts of Fabric (such as JSON loading) won't work correctly.
	     * @type String
	     * @default
	     */
	    type:                     'object',
	
	    /**
	     * Horizontal origin of transformation of an object (one of "left", "right", "center")
	     * See http://jsfiddle.net/1ow02gea/244/ on how originX/originY affect objects in groups
	     * @type String
	     * @default
	     */
	    originX:                  'left',
	
	    /**
	     * Vertical origin of transformation of an object (one of "top", "bottom", "center")
	     * See http://jsfiddle.net/1ow02gea/244/ on how originX/originY affect objects in groups
	     * @type String
	     * @default
	     */
	    originY:                  'top',
	
	    /**
	     * Top position of an object. Note that by default it's relative to object top. You can change this by setting originY={top/center/bottom}
	     * @type Number
	     * @default
	     */
	    top:                      0,
	
	    /**
	     * Left position of an object. Note that by default it's relative to object left. You can change this by setting originX={left/center/right}
	     * @type Number
	     * @default
	     */
	    left:                     0,
	
	    /**
	     * Object width
	     * @type Number
	     * @default
	     */
	    width:                    0,
	
	    /**
	     * Object height
	     * @type Number
	     * @default
	     */
	    height:                   0,
	
	    /**
	     * Object scale factor (horizontal)
	     * @type Number
	     * @default
	     */
	    scaleX:                   1,
	
	    /**
	     * Object scale factor (vertical)
	     * @type Number
	     * @default
	     */
	    scaleY:                   1,
	
	    /**
	     * When true, an object is rendered as flipped horizontally
	     * @type Boolean
	     * @default
	     */
	    flipX:                    false,
	
	    /**
	     * When true, an object is rendered as flipped vertically
	     * @type Boolean
	     * @default
	     */
	    flipY:                    false,
	
	    /**
	     * Opacity of an object
	     * @type Number
	     * @default
	     */
	    opacity:                  1,
	
	    /**
	     * Angle of rotation of an object (in degrees)
	     * @type Number
	     * @default
	     */
	    angle:                    0,
	
	    /**
	     * Angle of skew on x axes of an object (in degrees)
	     * @type Number
	     * @default
	     */
	    skewX:                    0,
	
	    /**
	     * Angle of skew on y axes of an object (in degrees)
	     * @type Number
	     * @default
	     */
	    skewY:                    0,
	
	    /**
	     * Size of object's controlling corners (in pixels)
	     * @type Number
	     * @default
	     */
	    cornerSize:               13,
	
	    /**
	     * When true, object's controlling corners are rendered as transparent inside (i.e. stroke instead of fill)
	     * @type Boolean
	     * @default
	     */
	    transparentCorners:       true,
	
	    /**
	     * Default cursor value used when hovering over this object on canvas
	     * @type String
	     * @default
	     */
	    hoverCursor:              null,
	
	    /**
	     * Default cursor value used when moving this object on canvas
	     * @type String
	     * @default
	     */
	    moveCursor:               null,
	
	    /**
	     * Padding between object and its controlling borders (in pixels)
	     * @type Number
	     * @default
	     */
	    padding:                  0,
	
	    /**
	     * Color of controlling borders of an object (when it's active)
	     * @type String
	     * @default
	     */
	    borderColor:              'rgba(102,153,255,0.75)',
	
	    /**
	     * Array specifying dash pattern of an object's borders (hasBorder must be true)
	     * @since 1.6.2
	     * @type Array
	     */
	    borderDashArray:          null,
	
	    /**
	     * Color of controlling corners of an object (when it's active)
	     * @type String
	     * @default
	     */
	    cornerColor:              'rgba(102,153,255,0.5)',
	
	    /**
	     * Color of controlling corners of an object (when it's active and transparentCorners false)
	     * @since 1.6.2
	     * @type String
	     * @default
	     */
	    cornerStrokeColor:        null,
	
	    /**
	     * Specify style of control, 'rect' or 'circle'
	     * @since 1.6.2
	     * @type String
	     */
	    cornerStyle:          'rect',
	
	    /**
	     * Array specifying dash pattern of an object's control (hasBorder must be true)
	     * @since 1.6.2
	     * @type Array
	     */
	    cornerDashArray:          null,
	
	    /**
	     * When true, this object will use center point as the origin of transformation
	     * when being scaled via the controls.
	     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
	     * @since 1.3.4
	     * @type Boolean
	     * @default
	     */
	    centeredScaling:          false,
	
	    /**
	     * When true, this object will use center point as the origin of transformation
	     * when being rotated via the controls.
	     * <b>Backwards incompatibility note:</b> This property replaces "centerTransform" (Boolean).
	     * @since 1.3.4
	     * @type Boolean
	     * @default
	     */
	    centeredRotation:         true,
	
	    /**
	     * Color of object's fill
	     * takes css colors https://www.w3.org/TR/css-color-3/
	     * @type String
	     * @default
	     */
	    fill:                     'rgb(0,0,0)',
	
	    /**
	     * Fill rule used to fill an object
	     * accepted values are nonzero, evenodd
	     * <b>Backwards incompatibility note:</b> This property was used for setting globalCompositeOperation until v1.4.12 (use `fabric.Object#globalCompositeOperation` instead)
	     * @type String
	     * @default
	     */
	    fillRule:                 'nonzero',
	
	    /**
	     * Composite rule used for canvas globalCompositeOperation
	     * @type String
	     * @default
	     */
	    globalCompositeOperation: 'source-over',
	
	    /**
	     * Background color of an object.
	     * takes css colors https://www.w3.org/TR/css-color-3/
	     * @type String
	     * @default
	     */
	    backgroundColor:          '',
	
	    /**
	     * Selection Background color of an object. colored layer behind the object when it is active.
	     * does not mix good with globalCompositeOperation methods.
	     * @type String
	     * @default
	     */
	    selectionBackgroundColor:          '',
	
	    /**
	     * When defined, an object is rendered via stroke and this property specifies its color
	     * takes css colors https://www.w3.org/TR/css-color-3/
	     * @type String
	     * @default
	     */
	    stroke:                   null,
	
	    /**
	     * Width of a stroke used to render this object
	     * @type Number
	     * @default
	     */
	    strokeWidth:              1,
	
	    /**
	     * Array specifying dash pattern of an object's stroke (stroke must be defined)
	     * @type Array
	     */
	    strokeDashArray:          null,
	
	    /**
	     * Line offset of an object's stroke
	     * @type Number
	     * @default
	     */
	    strokeDashOffset: 0,
	
	    /**
	     * Line endings style of an object's stroke (one of "butt", "round", "square")
	     * @type String
	     * @default
	     */
	    strokeLineCap:            'butt',
	
	    /**
	     * Corner style of an object's stroke (one of "bevil", "round", "miter")
	     * @type String
	     * @default
	     */
	    strokeLineJoin:           'miter',
	
	    /**
	     * Maximum miter length (used for strokeLineJoin = "miter") of an object's stroke
	     * @type Number
	     * @default
	     */
	    strokeMiterLimit:         4,
	
	    /**
	     * Shadow object representing shadow of this shape
	     * @type fabric.Shadow
	     * @default
	     */
	    shadow:                   null,
	
	    /**
	     * Opacity of object's controlling borders when object is active and moving
	     * @type Number
	     * @default
	     */
	    borderOpacityWhenMoving:  0.4,
	
	    /**
	     * Scale factor of object's controlling borders
	     * @type Number
	     * @default
	     */
	    borderScaleFactor:        1,
	
	    /**
	     * Transform matrix (similar to SVG's transform matrix)
	     * This property has been depreacted. Since caching and and qrDecompose this
	     * property can be handled with the standard top,left,scaleX,scaleY,angle and skewX.
	     * A documentation example on how to parse and merge a transformMatrix will be provided before
	     * completely removing it in fabric 4.0
	     * If you are starting a project now, DO NOT use it.
	     * @deprecated since 3.2.0
	     * @type Array
	     */
	    transformMatrix:          null,
	
	    /**
	     * Minimum allowed scale value of an object
	     * @type Number
	     * @default
	     */
	    minScaleLimit:            0,
	
	    /**
	     * When set to `false`, an object can not be selected for modification (using either point-click-based or group-based selection).
	     * But events still fire on it.
	     * @type Boolean
	     * @default
	     */
	    selectable:               true,
	
	    /**
	     * When set to `false`, an object can not be a target of events. All events propagate through it. Introduced in v1.3.4
	     * @type Boolean
	     * @default
	     */
	    evented:                  true,
	
	    /**
	     * When set to `false`, an object is not rendered on canvas
	     * @type Boolean
	     * @default
	     */
	    visible:                  true,
	
	    /**
	     * When set to `false`, object's controls are not displayed and can not be used to manipulate object
	     * @type Boolean
	     * @default
	     */
	    hasControls:              true,
	
	    /**
	     * When set to `false`, object's controlling borders are not rendered
	     * @type Boolean
	     * @default
	     */
	    hasBorders:               true,
	
	    /**
	     * When set to `false`, object's controlling rotating point will not be visible or selectable
	     * @type Boolean
	     * @default
	     */
	    hasRotatingPoint:         true,
	
	    /**
	     * Offset for object's controlling rotating point (when enabled via `hasRotatingPoint`)
	     * @type Number
	     * @default
	     */
	    rotatingPointOffset:      40,
	
	    /**
	     * When set to `true`, objects are "found" on canvas on per-pixel basis rather than according to bounding box
	     * @type Boolean
	     * @default
	     */
	    perPixelTargetFind:       false,
	
	    /**
	     * When `false`, default object's values are not included in its serialization
	     * @type Boolean
	     * @default
	     */
	    includeDefaultValues:     true,
	
	    /**
	     * Function that determines clipping of an object (context is passed as a first argument).
	     * If you are using code minification, ctx argument can be minified/manglied you should use
	     * as a workaround `var ctx = arguments[0];` in the function;
	     * Note that context origin is at the object's center point (not left/top corner)
	     * @deprecated since 2.0.0
	     * @type Function
	     */
	    clipTo:                   null,
	
	    /**
	     * When `true`, object horizontal movement is locked
	     * @type Boolean
	     * @default
	     */
	    lockMovementX:            false,
	
	    /**
	     * When `true`, object vertical movement is locked
	     * @type Boolean
	     * @default
	     */
	    lockMovementY:            false,
	
	    /**
	     * When `true`, object rotation is locked
	     * @type Boolean
	     * @default
	     */
	    lockRotation:             false,
	
	    /**
	     * When `true`, object horizontal scaling is locked
	     * @type Boolean
	     * @default
	     */
	    lockScalingX:             false,
	
	    /**
	     * When `true`, object vertical scaling is locked
	     * @type Boolean
	     * @default
	     */
	    lockScalingY:             false,
	
	    /**
	     * When `true`, object non-uniform scaling is locked
	     * @type Boolean
	     * @default
	     */
	    lockUniScaling:           false,
	
	    /**
	     * When `true`, object horizontal skewing is locked
	     * @type Boolean
	     * @default
	     */
	    lockSkewingX:             false,
	
	    /**
	     * When `true`, object vertical skewing is locked
	     * @type Boolean
	     * @default
	     */
	    lockSkewingY:             false,
	
	    /**
	     * When `true`, object cannot be flipped by scaling into negative values
	     * @type Boolean
	     * @default
	     */
	    lockScalingFlip:          false,
	
	    /**
	     * When `true`, object is not exported in OBJECT/JSON
	     * @since 1.6.3
	     * @type Boolean
	     * @default
	     */
	    excludeFromExport:        false,
	
	    /**
	     * When `true`, object is cached on an additional canvas.
	     * When `false`, object is not cached unless necessary ( clipPath )
	     * default to true
	     * @since 1.7.0
	     * @type Boolean
	     * @default true
	     */
	    objectCaching:            objectCaching,
	
	    /**
	     * When `true`, object properties are checked for cache invalidation. In some particular
	     * situation you may want this to be disabled ( spray brush, very big, groups)
	     * or if your application does not allow you to modify properties for groups child you want
	     * to disable it for groups.
	     * default to false
	     * since 1.7.0
	     * @type Boolean
	     * @default false
	     */
	    statefullCache:            false,
	
	    /**
	     * When `true`, cache does not get updated during scaling. The picture will get blocky if scaled
	     * too much and will be redrawn with correct details at the end of scaling.
	     * this setting is performance and application dependant.
	     * default to true
	     * since 1.7.0
	     * @type Boolean
	     * @default true
	     */
	    noScaleCache:              true,
	
	    /**
	     * When `false`, the stoke width will scale with the object.
	     * When `true`, the stroke will always match the exact pixel size entered for stroke width.
	     * default to false
	     * @since 2.6.0
	     * @type Boolean
	     * @default false
	     * @type Boolean
	     * @default false
	     */
	    strokeUniform:              false,
	
	    /**
	     * When set to `true`, object's cache will be rerendered next render call.
	     * since 1.7.0
	     * @type Boolean
	     * @default true
	     */
	    dirty:                true,
	
	    /**
	     * keeps the value of the last hovered corner during mouse move.
	     * 0 is no corner, or 'mt', 'ml', 'mtr' etc..
	     * It should be private, but there is no harm in using it as
	     * a read-only property.
	     * @type number|string|any
	     * @default 0
	     */
	    __corner: 0,
	
	    /**
	     * Determines if the fill or the stroke is drawn first (one of "fill" or "stroke")
	     * @type String
	     * @default
	     */
	    paintFirst:           'fill',
	
	    /**
	     * List of properties to consider when checking if state
	     * of an object is changed (fabric.Object#hasStateChanged)
	     * as well as for history (undo/redo) purposes
	     * @type Array
	     */
	    stateProperties: (
	      'top left width height scaleX scaleY flipX flipY originX originY transformMatrix ' +
	      'stroke strokeWidth strokeDashArray strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit ' +
	      'angle opacity fill globalCompositeOperation shadow clipTo visible backgroundColor ' +
	      'skewX skewY fillRule paintFirst clipPath strokeUniform'
	    ).split(' '),
	
	    /**
	     * List of properties to consider when checking if cache needs refresh
	     * Those properties are checked by statefullCache ON ( or lazy mode if we want ) or from single
	     * calls to Object.set(key, value). If the key is in this list, the object is marked as dirty
	     * and refreshed at the next render
	     * @type Array
	     */
	    cacheProperties: (
	      'fill stroke strokeWidth strokeDashArray width height paintFirst strokeUniform' +
	      ' strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit backgroundColor clipPath'
	    ).split(' '),
	
	    /**
	     * a fabricObject that, without stroke define a clipping area with their shape. filled in black
	     * the clipPath object gets used when the object has rendered, and the context is placed in the center
	     * of the object cacheCanvas.
	     * If you want 0,0 of a clipPath to align with an object center, use clipPath.originX/Y to 'center'
	     * @type fabric.Object
	     */
	    clipPath: undefined,
	
	    /**
	     * Meaningful ONLY when the object is used as clipPath.
	     * if true, the clipPath will make the object clip to the outside of the clipPath
	     * since 2.4.0
	     * @type boolean
	     * @default false
	     */
	    inverted: false,
	
	    /**
	     * Meaningful ONLY when the object is used as clipPath.
	     * if true, the clipPath will have its top and left relative to canvas, and will
	     * not be influenced by the object transform. This will make the clipPath relative
	     * to the canvas, but clipping just a particular object.
	     * WARNING this is beta, this feature may change or be renamed.
	     * since 2.4.0
	     * @type boolean
	     * @default false
	     */
	    absolutePositioned: false,
	
	    /**
	     * Constructor
	     * @param {Object} [options] Options object
	     */
	    initialize: function(options) {
	      if (options) {
	        this.setOptions(options);
	      }
	    },
	
	    /**
	     * Create a the canvas used to keep the cached copy of the object
	     * @private
	     */
	    _createCacheCanvas: function() {
	      this._cacheProperties = {};
	      this._cacheCanvas = fabric.util.createCanvasElement();
	      this._cacheContext = this._cacheCanvas.getContext('2d');
	      this._updateCacheCanvas();
	      // if canvas gets created, is empty, so dirty.
	      this.dirty = true;
	    },
	
	    /**
	     * Limit the cache dimensions so that X * Y do not cross fabric.perfLimitSizeTotal
	     * and each side do not cross fabric.cacheSideLimit
	     * those numbers are configurable so that you can get as much detail as you want
	     * making bargain with performances.
	     * @param {Object} dims
	     * @param {Object} dims.width width of canvas
	     * @param {Object} dims.height height of canvas
	     * @param {Object} dims.zoomX zoomX zoom value to unscale the canvas before drawing cache
	     * @param {Object} dims.zoomY zoomY zoom value to unscale the canvas before drawing cache
	     * @return {Object}.width width of canvas
	     * @return {Object}.height height of canvas
	     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
	     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
	     */
	    _limitCacheSize: function(dims) {
	      var perfLimitSizeTotal = fabric.perfLimitSizeTotal,
	          width = dims.width, height = dims.height,
	          max = fabric.maxCacheSideLimit, min = fabric.minCacheSideLimit;
	      if (width <= max && height <= max && width * height <= perfLimitSizeTotal) {
	        if (width < min) {
	          dims.width = min;
	        }
	        if (height < min) {
	          dims.height = min;
	        }
	        return dims;
	      }
	      var ar = width / height, limitedDims = fabric.util.limitDimsByArea(ar, perfLimitSizeTotal),
	          capValue = fabric.util.capValue,
	          x = capValue(min, limitedDims.x, max),
	          y = capValue(min, limitedDims.y, max);
	      if (width > x) {
	        dims.zoomX /= width / x;
	        dims.width = x;
	        dims.capped = true;
	      }
	      if (height > y) {
	        dims.zoomY /= height / y;
	        dims.height = y;
	        dims.capped = true;
	      }
	      return dims;
	    },
	
	    /**
	     * Return the dimension and the zoom level needed to create a cache canvas
	     * big enough to host the object to be cached.
	     * @private
	     * @return {Object}.x width of object to be cached
	     * @return {Object}.y height of object to be cached
	     * @return {Object}.width width of canvas
	     * @return {Object}.height height of canvas
	     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
	     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
	     */
	    _getCacheCanvasDimensions: function() {
	      var objectScale = this.getTotalObjectScaling(),
	          // caculate dimensions without skewing
	          dim = this._getTransformedDimensions(0, 0),
	          neededX = dim.x * objectScale.scaleX / this.scaleX,
	          neededY = dim.y * objectScale.scaleY / this.scaleY;
	      return {
	        // for sure this ALIASING_LIMIT is slightly creating problem
	        // in situation in which the cache canvas gets an upper limit
	        // also objectScale contains already scaleX and scaleY
	        width: neededX + ALIASING_LIMIT,
	        height: neededY + ALIASING_LIMIT,
	        zoomX: objectScale.scaleX,
	        zoomY: objectScale.scaleY,
	        x: neededX,
	        y: neededY
	      };
	    },
	
	    /**
	     * Update width and height of the canvas for cache
	     * returns true or false if canvas needed resize.
	     * @private
	     * @return {Boolean} true if the canvas has been resized
	     */
	    _updateCacheCanvas: function() {
	      var targetCanvas = this.canvas;
	      if (this.noScaleCache && targetCanvas && targetCanvas._currentTransform) {
	        var target = targetCanvas._currentTransform.target,
	            action = targetCanvas._currentTransform.action;
	        if (this === target && action.slice && action.slice(0, 5) === 'scale') {
	          return false;
	        }
	      }
	      var canvas = this._cacheCanvas,
	          dims = this._limitCacheSize(this._getCacheCanvasDimensions()),
	          minCacheSize = fabric.minCacheSideLimit,
	          width = dims.width, height = dims.height, drawingWidth, drawingHeight,
	          zoomX = dims.zoomX, zoomY = dims.zoomY,
	          dimensionsChanged = width !== this.cacheWidth || height !== this.cacheHeight,
	          zoomChanged = this.zoomX !== zoomX || this.zoomY !== zoomY,
	          shouldRedraw = dimensionsChanged || zoomChanged,
	          additionalWidth = 0, additionalHeight = 0, shouldResizeCanvas = false;
	      if (dimensionsChanged) {
	        var canvasWidth = this._cacheCanvas.width,
	            canvasHeight = this._cacheCanvas.height,
	            sizeGrowing = width > canvasWidth || height > canvasHeight,
	            sizeShrinking = (width < canvasWidth * 0.9 || height < canvasHeight * 0.9) &&
	              canvasWidth > minCacheSize && canvasHeight > minCacheSize;
	        shouldResizeCanvas = sizeGrowing || sizeShrinking;
	        if (sizeGrowing && !dims.capped && (width > minCacheSize || height > minCacheSize)) {
	          additionalWidth = width * 0.1;
	          additionalHeight = height * 0.1;
	        }
	      }
	      if (shouldRedraw) {
	        if (shouldResizeCanvas) {
	          canvas.width = Math.ceil(width + additionalWidth);
	          canvas.height = Math.ceil(height + additionalHeight);
	        }
	        else {
	          this._cacheContext.setTransform(1, 0, 0, 1, 0, 0);
	          this._cacheContext.clearRect(0, 0, canvas.width, canvas.height);
	        }
	        drawingWidth = dims.x / 2;
	        drawingHeight = dims.y / 2;
	        this.cacheTranslationX = Math.round(canvas.width / 2 - drawingWidth) + drawingWidth;
	        this.cacheTranslationY = Math.round(canvas.height / 2 - drawingHeight) + drawingHeight;
	        this.cacheWidth = width;
	        this.cacheHeight = height;
	        this._cacheContext.translate(this.cacheTranslationX, this.cacheTranslationY);
	        this._cacheContext.scale(zoomX, zoomY);
	        this.zoomX = zoomX;
	        this.zoomY = zoomY;
	        return true;
	      }
	      return false;
	    },
	
	    /**
	     * Sets object's properties from options
	     * @param {Object} [options] Options object
	     */
	    setOptions: function(options) {
	      this._setOptions(options);
	      this._initGradient(options.fill, 'fill');
	      this._initGradient(options.stroke, 'stroke');
	      this._initClipping(options);
	      this._initPattern(options.fill, 'fill');
	      this._initPattern(options.stroke, 'stroke');
	    },
	
	    /**
	     * Transforms context when rendering an object
	     * @param {CanvasRenderingContext2D} ctx Context
	     */
	    transform: function(ctx) {
	      var m;
	      if (this.group && !this.group._transformDone) {
	        m = this.calcTransformMatrix();
	      }
	      else {
	        m = this.calcOwnMatrix();
	      }
	      ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
	    },
	
	    /**
	     * Returns an object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS,
	
	          object = {
	            type:                     this.type,
	            version:                  fabric.version,
	            originX:                  this.originX,
	            originY:                  this.originY,
	            left:                     toFixed(this.left, NUM_FRACTION_DIGITS),
	            top:                      toFixed(this.top, NUM_FRACTION_DIGITS),
	            width:                    toFixed(this.width, NUM_FRACTION_DIGITS),
	            height:                   toFixed(this.height, NUM_FRACTION_DIGITS),
	            fill:                     (this.fill && this.fill.toObject) ? this.fill.toObject() : this.fill,
	            stroke:                   (this.stroke && this.stroke.toObject) ? this.stroke.toObject() : this.stroke,
	            strokeWidth:              toFixed(this.strokeWidth, NUM_FRACTION_DIGITS),
	            strokeDashArray:          this.strokeDashArray ? this.strokeDashArray.concat() : this.strokeDashArray,
	            strokeLineCap:            this.strokeLineCap,
	            strokeDashOffset:         this.strokeDashOffset,
	            strokeLineJoin:           this.strokeLineJoin,
	            strokeMiterLimit:         toFixed(this.strokeMiterLimit, NUM_FRACTION_DIGITS),
	            scaleX:                   toFixed(this.scaleX, NUM_FRACTION_DIGITS),
	            scaleY:                   toFixed(this.scaleY, NUM_FRACTION_DIGITS),
	            angle:                    toFixed(this.angle, NUM_FRACTION_DIGITS),
	            flipX:                    this.flipX,
	            flipY:                    this.flipY,
	            opacity:                  toFixed(this.opacity, NUM_FRACTION_DIGITS),
	            shadow:                   (this.shadow && this.shadow.toObject) ? this.shadow.toObject() : this.shadow,
	            visible:                  this.visible,
	            clipTo:                   this.clipTo && String(this.clipTo),
	            backgroundColor:          this.backgroundColor,
	            fillRule:                 this.fillRule,
	            paintFirst:               this.paintFirst,
	            globalCompositeOperation: this.globalCompositeOperation,
	            transformMatrix:          this.transformMatrix ? this.transformMatrix.concat() : null,
	            skewX:                    toFixed(this.skewX, NUM_FRACTION_DIGITS),
	            skewY:                    toFixed(this.skewY, NUM_FRACTION_DIGITS),
	          };
	
	      if (this.clipPath) {
	        object.clipPath = this.clipPath.toObject(propertiesToInclude);
	        object.clipPath.inverted = this.clipPath.inverted;
	        object.clipPath.absolutePositioned = this.clipPath.absolutePositioned;
	      }
	
	      fabric.util.populateWithProperties(this, object, propertiesToInclude);
	      if (!this.includeDefaultValues) {
	        object = this._removeDefaultValues(object);
	      }
	
	      return object;
	    },
	
	    /**
	     * Returns (dataless) object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} Object representation of an instance
	     */
	    toDatalessObject: function(propertiesToInclude) {
	      // will be overwritten by subclasses
	      return this.toObject(propertiesToInclude);
	    },
	
	    /**
	     * @private
	     * @param {Object} object
	     */
	    _removeDefaultValues: function(object) {
	      var prototype = fabric.util.getKlass(object.type).prototype,
	          stateProperties = prototype.stateProperties;
	      stateProperties.forEach(function(prop) {
	        if (prop === 'left' || prop === 'top') {
	          return;
	        }
	        if (object[prop] === prototype[prop]) {
	          delete object[prop];
	        }
	        var isArray = Object.prototype.toString.call(object[prop]) === '[object Array]' &&
	                      Object.prototype.toString.call(prototype[prop]) === '[object Array]';
	
	        // basically a check for [] === []
	        if (isArray && object[prop].length === 0 && prototype[prop].length === 0) {
	          delete object[prop];
	        }
	      });
	
	      return object;
	    },
	
	    /**
	     * Returns a string representation of an instance
	     * @return {String}
	     */
	    toString: function() {
	      return '#<fabric.' + capitalize(this.type) + '>';
	    },
	
	    /**
	     * Return the object scale factor counting also the group scaling
	     * @return {Object} object with scaleX and scaleY properties
	     */
	    getObjectScaling: function() {
	      var scaleX = this.scaleX, scaleY = this.scaleY;
	      if (this.group) {
	        var scaling = this.group.getObjectScaling();
	        scaleX *= scaling.scaleX;
	        scaleY *= scaling.scaleY;
	      }
	      return { scaleX: scaleX, scaleY: scaleY };
	    },
	
	    /**
	     * Return the object scale factor counting also the group scaling, zoom and retina
	     * @return {Object} object with scaleX and scaleY properties
	     */
	    getTotalObjectScaling: function() {
	      var scale = this.getObjectScaling(), scaleX = scale.scaleX, scaleY = scale.scaleY;
	      if (this.canvas) {
	        var zoom = this.canvas.getZoom();
	        var retina = this.canvas.getRetinaScaling();
	        scaleX *= zoom * retina;
	        scaleY *= zoom * retina;
	      }
	      return { scaleX: scaleX, scaleY: scaleY };
	    },
	
	    /**
	     * Return the object opacity counting also the group property
	     * @return {Number}
	     */
	    getObjectOpacity: function() {
	      var opacity = this.opacity;
	      if (this.group) {
	        opacity *= this.group.getObjectOpacity();
	      }
	      return opacity;
	    },
	
	    /**
	     * @private
	     * @param {String} key
	     * @param {*} value
	     * @return {fabric.Object} thisArg
	     */
	    _set: function(key, value) {
	      var shouldConstrainValue = (key === 'scaleX' || key === 'scaleY'),
	          isChanged = this[key] !== value, groupNeedsUpdate = false;
	
	      if (shouldConstrainValue) {
	        value = this._constrainScale(value);
	      }
	      if (key === 'scaleX' && value < 0) {
	        this.flipX = !this.flipX;
	        value *= -1;
	      }
	      else if (key === 'scaleY' && value < 0) {
	        this.flipY = !this.flipY;
	        value *= -1;
	      }
	      else if (key === 'shadow' && value && !(value instanceof fabric.Shadow)) {
	        value = new fabric.Shadow(value);
	      }
	      else if (key === 'dirty' && this.group) {
	        this.group.set('dirty', value);
	      }
	
	      this[key] = value;
	
	      if (isChanged) {
	        groupNeedsUpdate = this.group && this.group.isOnACache();
	        if (this.cacheProperties.indexOf(key) > -1) {
	          this.dirty = true;
	          groupNeedsUpdate && this.group.set('dirty', true);
	        }
	        else if (groupNeedsUpdate && this.stateProperties.indexOf(key) > -1) {
	          this.group.set('dirty', true);
	        }
	      }
	
	      return this;
	    },
	
	    /**
	     * This callback function is called by the parent group of an object every
	     * time a non-delegated property changes on the group. It is passed the key
	     * and value as parameters. Not adding in this function's signature to avoid
	     * Travis build error about unused variables.
	     */
	    setOnGroup: function() {
	      // implemented by sub-classes, as needed.
	    },
	
	    /**
	     * Retrieves viewportTransform from Object's canvas if possible
	     * @method getViewportTransform
	     * @memberOf fabric.Object.prototype
	     * @return {Array}
	     */
	    getViewportTransform: function() {
	      if (this.canvas && this.canvas.viewportTransform) {
	        return this.canvas.viewportTransform;
	      }
	      return fabric.iMatrix.concat();
	    },
	
	    /*
	     * @private
	     * return if the object would be visible in rendering
	     * @memberOf fabric.Object.prototype
	     * @return {Boolean}
	     */
	    isNotVisible: function() {
	      return this.opacity === 0 ||
	        (this.width === 0 && this.height === 0 && this.strokeWidth === 0) ||
	        !this.visible;
	    },
	
	    /**
	     * Renders an object on a specified context
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    render: function(ctx) {
	      // do not render if width/height are zeros or object is not visible
	      if (this.isNotVisible()) {
	        return;
	      }
	      if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) {
	        return;
	      }
	      ctx.save();
	      this._setupCompositeOperation(ctx);
	      this.drawSelectionBackground(ctx);
	      this.transform(ctx);
	      this._setOpacity(ctx);
	      this._setShadow(ctx, this);
	      if (this.transformMatrix) {
	        ctx.transform.apply(ctx, this.transformMatrix);
	      }
	      this.clipTo && fabric.util.clipContext(this, ctx);
	      if (this.shouldCache()) {
	        this.renderCache();
	        this.drawCacheOnCanvas(ctx);
	      }
	      else {
	        this._removeCacheCanvas();
	        this.dirty = false;
	        this.drawObject(ctx);
	        if (this.objectCaching && this.statefullCache) {
	          this.saveState({ propertySet: 'cacheProperties' });
	        }
	      }
	      this.clipTo && ctx.restore();
	      ctx.restore();
	    },
	
	    renderCache: function(options) {
	      options = options || {};
	      if (!this._cacheCanvas) {
	        this._createCacheCanvas();
	      }
	      if (this.isCacheDirty()) {
	        this.statefullCache && this.saveState({ propertySet: 'cacheProperties' });
	        this.drawObject(this._cacheContext, options.forClipping);
	        this.dirty = false;
	      }
	    },
	
	    /**
	     * Remove cacheCanvas and its dimensions from the objects
	     */
	    _removeCacheCanvas: function() {
	      this._cacheCanvas = null;
	      this.cacheWidth = 0;
	      this.cacheHeight = 0;
	    },
	
	    /**
	     * return true if the object will draw a stroke
	     * Does not consider text styles. This is just a shortcut used at rendering time
	     * We want it to be an aproximation and be fast.
	     * wrote to avoid extra caching, it has to return true when stroke happens,
	     * can guess when it will not happen at 100% chance, does not matter if it misses
	     * some use case where the stroke is invisible.
	     * @since 3.0.0
	     * @returns Boolean
	     */
	    hasStroke: function() {
	      return this.stroke && this.stroke !== 'transparent' && this.strokeWidth !== 0;
	    },
	
	    /**
	     * return true if the object will draw a fill
	     * Does not consider text styles. This is just a shortcut used at rendering time
	     * We want it to be an aproximation and be fast.
	     * wrote to avoid extra caching, it has to return true when fill happens,
	     * can guess when it will not happen at 100% chance, does not matter if it misses
	     * some use case where the fill is invisible.
	     * @since 3.0.0
	     * @returns Boolean
	     */
	    hasFill: function() {
	      return this.fill && this.fill !== 'transparent';
	    },
	
	    /**
	     * When set to `true`, force the object to have its own cache, even if it is inside a group
	     * it may be needed when your object behave in a particular way on the cache and always needs
	     * its own isolated canvas to render correctly.
	     * Created to be overridden
	     * since 1.7.12
	     * @returns Boolean
	     */
	    needsItsOwnCache: function() {
	      if (this.paintFirst === 'stroke' &&
	        this.hasFill() && this.hasStroke() && typeof this.shadow === 'object') {
	        return true;
	      }
	      if (this.clipPath) {
	        return true;
	      }
	      return false;
	    },
	
	    /**
	     * Decide if the object should cache or not. Create its own cache level
	     * objectCaching is a global flag, wins over everything
	     * needsItsOwnCache should be used when the object drawing method requires
	     * a cache step. None of the fabric classes requires it.
	     * Generally you do not cache objects in groups because the group outside is cached.
	     * Read as: cache if is needed, or if the feature is enabled but we are not already caching.
	     * @return {Boolean}
	     */
	    shouldCache: function() {
	      this.ownCaching = this.needsItsOwnCache() || (
	        this.objectCaching &&
	        (!this.group || !this.group.isOnACache())
	      );
	      return this.ownCaching;
	    },
	
	    /**
	     * Check if this object or a child object will cast a shadow
	     * used by Group.shouldCache to know if child has a shadow recursively
	     * @return {Boolean}
	     */
	    willDrawShadow: function() {
	      return !!this.shadow && (this.shadow.offsetX !== 0 || this.shadow.offsetY !== 0);
	    },
	
	    /**
	     * Execute the drawing operation for an object clipPath
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    drawClipPathOnCache: function(ctx) {
	      var path = this.clipPath;
	      ctx.save();
	      // DEBUG: uncomment this line, comment the following
	      // ctx.globalAlpha = 0.4
	      if (path.inverted) {
	        ctx.globalCompositeOperation = 'destination-out';
	      }
	      else {
	        ctx.globalCompositeOperation = 'destination-in';
	      }
	      //ctx.scale(1 / 2, 1 / 2);
	      if (path.absolutePositioned) {
	        var m = fabric.util.invertTransform(this.calcTransformMatrix());
	        ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
	      }
	      path.transform(ctx);
	      ctx.scale(1 / path.zoomX, 1 / path.zoomY);
	      ctx.drawImage(path._cacheCanvas, -path.cacheTranslationX, -path.cacheTranslationY);
	      ctx.restore();
	    },
	
	    /**
	     * Execute the drawing operation for an object on a specified context
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    drawObject: function(ctx, forClipping) {
	      var originalFill = this.fill, originalStroke = this.stroke;
	      if (forClipping) {
	        this.fill = 'black';
	        this.stroke = '';
	        this._setClippingProperties(ctx);
	      }
	      else {
	        this._renderBackground(ctx);
	        this._setStrokeStyles(ctx, this);
	        this._setFillStyles(ctx, this);
	      }
	      this._render(ctx);
	      this._drawClipPath(ctx);
	      this.fill = originalFill;
	      this.stroke = originalStroke;
	    },
	
	    _drawClipPath: function(ctx) {
	      var path = this.clipPath;
	      if (!path) { return; }
	      // needed to setup a couple of variables
	      // path canvas gets overridden with this one.
	      // TODO find a better solution?
	      path.canvas = this.canvas;
	      path.shouldCache();
	      path._transformDone = true;
	      path.renderCache({ forClipping: true });
	      this.drawClipPathOnCache(ctx);
	    },
	
	    /**
	     * Paint the cached copy of the object on the target context.
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    drawCacheOnCanvas: function(ctx) {
	      ctx.scale(1 / this.zoomX, 1 / this.zoomY);
	      ctx.drawImage(this._cacheCanvas, -this.cacheTranslationX, -this.cacheTranslationY);
	    },
	
	    /**
	     * Check if cache is dirty
	     * @param {Boolean} skipCanvas skip canvas checks because this object is painted
	     * on parent canvas.
	     */
	    isCacheDirty: function(skipCanvas) {
	      if (this.isNotVisible()) {
	        return false;
	      }
	      if (this._cacheCanvas && !skipCanvas && this._updateCacheCanvas()) {
	        // in this case the context is already cleared.
	        return true;
	      }
	      else {
	        if (this.dirty ||
	          (this.clipPath && this.clipPath.absolutePositioned) ||
	          (this.statefullCache && this.hasStateChanged('cacheProperties'))
	        ) {
	          if (this._cacheCanvas && !skipCanvas) {
	            var width = this.cacheWidth / this.zoomX;
	            var height = this.cacheHeight / this.zoomY;
	            this._cacheContext.clearRect(-width / 2, -height / 2, width, height);
	          }
	          return true;
	        }
	      }
	      return false;
	    },
	
	    /**
	     * Draws a background for the object big as its untransformed dimensions
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderBackground: function(ctx) {
	      if (!this.backgroundColor) {
	        return;
	      }
	      var dim = this._getNonTransformedDimensions();
	      ctx.fillStyle = this.backgroundColor;
	
	      ctx.fillRect(
	        -dim.x / 2,
	        -dim.y / 2,
	        dim.x,
	        dim.y
	      );
	      // if there is background color no other shadows
	      // should be casted
	      this._removeShadow(ctx);
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _setOpacity: function(ctx) {
	      if (this.group && !this.group._transformDone) {
	        ctx.globalAlpha = this.getObjectOpacity();
	      }
	      else {
	        ctx.globalAlpha *= this.opacity;
	      }
	    },
	
	    _setStrokeStyles: function(ctx, decl) {
	      if (decl.stroke) {
	        ctx.lineWidth = decl.strokeWidth;
	        ctx.lineCap = decl.strokeLineCap;
	        ctx.lineDashOffset = decl.strokeDashOffset;
	        ctx.lineJoin = decl.strokeLineJoin;
	        ctx.miterLimit = decl.strokeMiterLimit;
	        ctx.strokeStyle = decl.stroke.toLive
	          ? decl.stroke.toLive(ctx, this)
	          : decl.stroke;
	      }
	    },
	
	    _setFillStyles: function(ctx, decl) {
	      if (decl.fill) {
	        ctx.fillStyle = decl.fill.toLive
	          ? decl.fill.toLive(ctx, this)
	          : decl.fill;
	      }
	    },
	
	    _setClippingProperties: function(ctx) {
	      ctx.globalAlpha = 1;
	      ctx.strokeStyle = 'transparent';
	      ctx.fillStyle = '#000000';
	    },
	
	    /**
	     * @private
	     * Sets line dash
	     * @param {CanvasRenderingContext2D} ctx Context to set the dash line on
	     * @param {Array} dashArray array representing dashes
	     * @param {Function} alternative function to call if browser does not support lineDash
	     */
	    _setLineDash: function(ctx, dashArray, alternative) {
	      if (!dashArray) {
	        return;
	      }
	      // Spec requires the concatenation of two copies the dash list when the number of elements is odd
	      if (1 & dashArray.length) {
	        dashArray.push.apply(dashArray, dashArray);
	      }
	      if (supportsLineDash) {
	        ctx.setLineDash(dashArray);
	      }
	      else {
	        alternative && alternative(ctx);
	      }
	      if (this.strokeUniform) {
	        ctx.setLineDash(ctx.getLineDash().map(function(value) { return value * ctx.lineWidth; }));
	      }
	    },
	
	    /**
	     * Renders controls and borders for the object
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {Object} [styleOverride] properties to override the object style
	     */
	    _renderControls: function(ctx, styleOverride) {
	      var vpt = this.getViewportTransform(),
	          matrix = this.calcTransformMatrix(),
	          options, drawBorders, drawControls;
	      styleOverride = styleOverride || { };
	      drawBorders = typeof styleOverride.hasBorders !== 'undefined' ? styleOverride.hasBorders : this.hasBorders;
	      drawControls = typeof styleOverride.hasControls !== 'undefined' ? styleOverride.hasControls : this.hasControls;
	      matrix = fabric.util.multiplyTransformMatrices(vpt, matrix);
	      options = fabric.util.qrDecompose(matrix);
	      ctx.save();
	      ctx.translate(options.translateX, options.translateY);
	      ctx.lineWidth = 1 * this.borderScaleFactor;
	      if (!this.group) {
	        ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
	      }
	      if (styleOverride.forActiveSelection) {
	        ctx.rotate(degreesToRadians(options.angle));
	        drawBorders && this.drawBordersInGroup(ctx, options, styleOverride);
	      }
	      else {
	        ctx.rotate(degreesToRadians(this.angle));
	        drawBorders && this.drawBorders(ctx, styleOverride);
	      }
	      drawControls && this.drawControls(ctx, styleOverride);
	      ctx.restore();
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _setShadow: function(ctx) {
	      if (!this.shadow) {
	        return;
	      }
	
	      var shadow = this.shadow, canvas = this.canvas, scaling,
	          multX = (canvas && canvas.viewportTransform[0]) || 1,
	          multY = (canvas && canvas.viewportTransform[3]) || 1;
	      if (shadow.nonScaling) {
	        scaling = { scaleX: 1, scaleY: 1 };
	      }
	      else {
	        scaling = this.getObjectScaling();
	      }
	      if (canvas && canvas._isRetinaScaling()) {
	        multX *= fabric.devicePixelRatio;
	        multY *= fabric.devicePixelRatio;
	      }
	      ctx.shadowColor = shadow.color;
	      ctx.shadowBlur = shadow.blur * fabric.browserShadowBlurConstant *
	        (multX + multY) * (scaling.scaleX + scaling.scaleY) / 4;
	      ctx.shadowOffsetX = shadow.offsetX * multX * scaling.scaleX;
	      ctx.shadowOffsetY = shadow.offsetY * multY * scaling.scaleY;
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _removeShadow: function(ctx) {
	      if (!this.shadow) {
	        return;
	      }
	
	      ctx.shadowColor = '';
	      ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {Object} filler fabric.Pattern or fabric.Gradient
	     * @return {Object} offset.offsetX offset for text rendering
	     * @return {Object} offset.offsetY offset for text rendering
	     */
	    _applyPatternGradientTransform: function(ctx, filler) {
	      if (!filler || !filler.toLive) {
	        return { offsetX: 0, offsetY: 0 };
	      }
	      var t = filler.gradientTransform || filler.patternTransform;
	      var offsetX = -this.width / 2 + filler.offsetX || 0,
	          offsetY = -this.height / 2 + filler.offsetY || 0;
	      ctx.translate(offsetX, offsetY);
	      if (t) {
	        ctx.transform(t[0], t[1], t[2], t[3], t[4], t[5]);
	      }
	      return { offsetX: offsetX, offsetY: offsetY };
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderPaintInOrder: function(ctx) {
	      if (this.paintFirst === 'stroke') {
	        this._renderStroke(ctx);
	        this._renderFill(ctx);
	      }
	      else {
	        this._renderFill(ctx);
	        this._renderStroke(ctx);
	      }
	    },
	
	    /**
	     * @private
	     * function that actually render something on the context.
	     * empty here to allow Obects to work on tests to benchmark fabric functionalites
	     * not related to rendering
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _render: function(/* ctx */) {
	
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderFill: function(ctx) {
	      if (!this.fill) {
	        return;
	      }
	
	      ctx.save();
	      this._applyPatternGradientTransform(ctx, this.fill);
	      if (this.fillRule === 'evenodd') {
	        ctx.fill('evenodd');
	      }
	      else {
	        ctx.fill();
	      }
	      ctx.restore();
	    },
	
	    _renderStroke: function(ctx) {
	      if (!this.stroke || this.strokeWidth === 0) {
	        return;
	      }
	
	      if (this.shadow && !this.shadow.affectStroke) {
	        this._removeShadow(ctx);
	      }
	
	      ctx.save();
	      if (this.strokeUniform) {
	        ctx.scale(1 / this.scaleX, 1 / this.scaleY);
	      }
	      this._setLineDash(ctx, this.strokeDashArray, this._renderDashedStroke);
	      this._applyPatternGradientTransform(ctx, this.stroke);
	      ctx.stroke();
	      ctx.restore();
	    },
	
	    /**
	     * This function is an helper for svg import. it returns the center of the object in the svg
	     * untransformed coordinates
	     * @private
	     * @return {Object} center point from element coordinates
	     */
	    _findCenterFromElement: function() {
	      return { x: this.left + this.width / 2, y: this.top + this.height / 2 };
	    },
	
	    /**
	     * This function is an helper for svg import. it decompose the transformMatrix
	     * and assign properties to object.
	     * untransformed coordinates
	     * @private
	     * @chainable
	     */
	    _assignTransformMatrixProps: function() {
	      if (this.transformMatrix) {
	        var options = fabric.util.qrDecompose(this.transformMatrix);
	        this.flipX = false;
	        this.flipY = false;
	        this.set('scaleX', options.scaleX);
	        this.set('scaleY', options.scaleY);
	        this.angle = options.angle;
	        this.skewX = options.skewX;
	        this.skewY = 0;
	      }
	    },
	
	    /**
	     * This function is an helper for svg import. it removes the transform matrix
	     * and set to object properties that fabricjs can handle
	     * @private
	     * @param {Object} preserveAspectRatioOptions
	     * @return {thisArg}
	     */
	    _removeTransformMatrix: function(preserveAspectRatioOptions) {
	      var center = this._findCenterFromElement();
	      if (this.transformMatrix) {
	        this._assignTransformMatrixProps();
	        center = fabric.util.transformPoint(center, this.transformMatrix);
	      }
	      this.transformMatrix = null;
	      if (preserveAspectRatioOptions) {
	        this.scaleX *= preserveAspectRatioOptions.scaleX;
	        this.scaleY *= preserveAspectRatioOptions.scaleY;
	        this.cropX = preserveAspectRatioOptions.cropX;
	        this.cropY = preserveAspectRatioOptions.cropY;
	        center.x += preserveAspectRatioOptions.offsetLeft;
	        center.y += preserveAspectRatioOptions.offsetTop;
	        this.width = preserveAspectRatioOptions.width;
	        this.height = preserveAspectRatioOptions.height;
	      }
	      this.setPositionByOrigin(center, 'center', 'center');
	    },
	
	    /**
	     * Clones an instance, using a callback method will work for every object.
	     * @param {Function} callback Callback is invoked with a clone as a first argument
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     */
	    clone: function(callback, propertiesToInclude) {
	      var objectForm = this.toObject(propertiesToInclude);
	      if (this.constructor.fromObject) {
	        this.constructor.fromObject(objectForm, callback);
	      }
	      else {
	        fabric.Object._fromObject('Object', objectForm, callback);
	      }
	    },
	
	    /**
	     * Creates an instance of fabric.Image out of an object
	     * could make use of both toDataUrl or toCanvasElement.
	     * @param {Function} callback callback, invoked with an instance as a first argument
	     * @param {Object} [options] for clone as image, passed to toDataURL
	     * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
	     * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
	     * @param {Number} [options.multiplier=1] Multiplier to scale by
	     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
	     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
	     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
	     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
	     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
	     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
	     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
	     * @return {fabric.Object} thisArg
	     */
	    cloneAsImage: function(callback, options) {
	      var canvasEl = this.toCanvasElement(options);
	      if (callback) {
	        callback(new fabric.Image(canvasEl));
	      }
	      return this;
	    },
	
	    /**
	     * Converts an object into a HTMLCanvas element
	     * @param {Object} options Options object
	     * @param {Number} [options.multiplier=1] Multiplier to scale by
	     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
	     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
	     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
	     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
	     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
	     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
	     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
	     * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
	     */
	    toCanvasElement: function(options) {
	      options || (options = { });
	
	      var utils = fabric.util, origParams = utils.saveObjectTransform(this),
	          originalShadow = this.shadow, abs = Math.abs,
	          multiplier = (options.multiplier || 1) * (options.enableRetinaScaling ? fabric.devicePixelRatio : 1);
	
	      if (options.withoutTransform) {
	        utils.resetObjectTransform(this);
	      }
	      if (options.withoutShadow) {
	        this.shadow = null;
	      }
	
	      var el = fabric.util.createCanvasElement(),
	          // skip canvas zoom and calculate with setCoords now.
	          boundingRect = this.getBoundingRect(true, true),
	          shadow = this.shadow, scaling,
	          shadowOffset = { x: 0, y: 0 }, shadowBlur;
	
	      if (shadow) {
	        shadowBlur = shadow.blur;
	        if (shadow.nonScaling) {
	          scaling = { scaleX: 1, scaleY: 1 };
	        }
	        else {
	          scaling = this.getObjectScaling();
	        }
	        shadowOffset.x = 2 * Math.round(abs(shadow.offsetX) + shadowBlur) * (abs(scaling.scaleX));
	        shadowOffset.y = 2 * Math.round(abs(shadow.offsetY) + shadowBlur) * (abs(scaling.scaleY));
	      }
	      el.width = boundingRect.width + shadowOffset.x;
	      el.height = boundingRect.height + shadowOffset.y;
	      el.width += el.width % 2 ? 2 - el.width % 2 : 0;
	      el.height += el.height % 2 ? 2 - el.height % 2 : 0;
	      var canvas = new fabric.StaticCanvas(el, {
	        enableRetinaScaling: false,
	        renderOnAddRemove: false,
	        skipOffscreen: false,
	      });
	      if (options.format === 'jpeg') {
	        canvas.backgroundColor = '#fff';
	      }
	      this.setPositionByOrigin(new fabric.Point(canvas.width / 2, canvas.height / 2), 'center', 'center');
	
	      var originalCanvas = this.canvas;
	      canvas.add(this);
	      var canvasEl = canvas.toCanvasElement(multiplier || 1, options);
	      this.shadow = originalShadow;
	      this.canvas = originalCanvas;
	      this.set(origParams).setCoords();
	      // canvas.dispose will call image.dispose that will nullify the elements
	      // since this canvas is a simple element for the process, we remove references
	      // to objects in this way in order to avoid object trashing.
	      canvas._objects = [];
	      canvas.dispose();
	      canvas = null;
	
	      return canvasEl;
	    },
	
	    /**
	     * Converts an object into a data-url-like string
	     * @param {Object} options Options object
	     * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
	     * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
	     * @param {Number} [options.multiplier=1] Multiplier to scale by
	     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
	     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
	     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
	     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
	     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
	     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
	     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
	     * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
	     */
	    toDataURL: function(options) {
	      options || (options = { });
	      return fabric.util.toDataURL(this.toCanvasElement(options), options.format || 'png', options.quality || 1);
	    },
	
	    /**
	     * Returns true if specified type is identical to the type of an instance
	     * @param {String} type Type to check against
	     * @return {Boolean}
	     */
	    isType: function(type) {
	      return this.type === type;
	    },
	
	    /**
	     * Returns complexity of an instance
	     * @return {Number} complexity of this instance (is 1 unless subclassed)
	     */
	    complexity: function() {
	      return 1;
	    },
	
	    /**
	     * Returns a JSON representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} JSON
	     */
	    toJSON: function(propertiesToInclude) {
	      // delegate, not alias
	      return this.toObject(propertiesToInclude);
	    },
	
	    /**
	     * Sets gradient (fill or stroke) of an object
	     * <b>Backwards incompatibility note:</b> This method was named "setGradientFill" until v1.1.0
	     * @param {String} property Property name 'stroke' or 'fill'
	     * @param {Object} [options] Options object
	     * @param {String} [options.type] Type of gradient 'radial' or 'linear'
	     * @param {Number} [options.x1=0] x-coordinate of start point
	     * @param {Number} [options.y1=0] y-coordinate of start point
	     * @param {Number} [options.x2=0] x-coordinate of end point
	     * @param {Number} [options.y2=0] y-coordinate of end point
	     * @param {Number} [options.r1=0] Radius of start point (only for radial gradients)
	     * @param {Number} [options.r2=0] Radius of end point (only for radial gradients)
	     * @param {Object} [options.colorStops] Color stops object eg. {0: 'ff0000', 1: '000000'}
	     * @param {Object} [options.gradientTransform] transformMatrix for gradient
	     * @return {fabric.Object} thisArg
	     * @chainable
	     * @see {@link http://jsfiddle.net/fabricjs/58y8b/|jsFiddle demo}
	     * @example <caption>Set linear gradient</caption>
	     * object.setGradient('fill', {
	     *   type: 'linear',
	     *   x1: -object.width / 2,
	     *   y1: 0,
	     *   x2: object.width / 2,
	     *   y2: 0,
	     *   colorStops: {
	     *     0: 'red',
	     *     0.5: '#005555',
	     *     1: 'rgba(0,0,255,0.5)'
	     *   }
	     * });
	     * canvas.renderAll();
	     * @example <caption>Set radial gradient</caption>
	     * object.setGradient('fill', {
	     *   type: 'radial',
	     *   x1: 0,
	     *   y1: 0,
	     *   x2: 0,
	     *   y2: 0,
	     *   r1: object.width / 2,
	     *   r2: 10,
	     *   colorStops: {
	     *     0: 'red',
	     *     0.5: '#005555',
	     *     1: 'rgba(0,0,255,0.5)'
	     *   }
	     * });
	     * canvas.renderAll();
	     */
	    setGradient: function(property, options) {
	      options || (options = { });
	
	      var gradient = { colorStops: [] };
	
	      gradient.type = options.type || (options.r1 || options.r2 ? 'radial' : 'linear');
	      gradient.coords = {
	        x1: options.x1,
	        y1: options.y1,
	        x2: options.x2,
	        y2: options.y2
	      };
	
	      if (options.r1 || options.r2) {
	        gradient.coords.r1 = options.r1;
	        gradient.coords.r2 = options.r2;
	      }
	
	      gradient.gradientTransform = options.gradientTransform;
	      fabric.Gradient.prototype.addColorStop.call(gradient, options.colorStops);
	
	      return this.set(property, fabric.Gradient.forObject(this, gradient));
	    },
	
	    /**
	     * Sets pattern fill of an object
	     * @param {Object} options Options object
	     * @param {(String|HTMLImageElement)} options.source Pattern source
	     * @param {String} [options.repeat=repeat] Repeat property of a pattern (one of repeat, repeat-x, repeat-y or no-repeat)
	     * @param {Number} [options.offsetX=0] Pattern horizontal offset from object's left/top corner
	     * @param {Number} [options.offsetY=0] Pattern vertical offset from object's left/top corner
	     * @param {Function} [callback] Callback to invoke when image set as a pattern
	     * @return {fabric.Object} thisArg
	     * @chainable
	     * @see {@link http://jsfiddle.net/fabricjs/QT3pa/|jsFiddle demo}
	     * @example <caption>Set pattern</caption>
	     * object.setPatternFill({
	     *   source: 'http://fabricjs.com/assets/escheresque_ste.png',
	     *   repeat: 'repeat'
	     * },canvas.renderAll.bind(canvas));
	     */
	    setPatternFill: function(options, callback) {
	      return this.set('fill', new fabric.Pattern(options, callback));
	    },
	
	    /**
	     * Sets {@link fabric.Object#shadow|shadow} of an object
	     * @param {Object|String} [options] Options object or string (e.g. "2px 2px 10px rgba(0,0,0,0.2)")
	     * @param {String} [options.color=rgb(0,0,0)] Shadow color
	     * @param {Number} [options.blur=0] Shadow blur
	     * @param {Number} [options.offsetX=0] Shadow horizontal offset
	     * @param {Number} [options.offsetY=0] Shadow vertical offset
	     * @return {fabric.Object} thisArg
	     * @chainable
	     * @see {@link http://jsfiddle.net/fabricjs/7gvJG/|jsFiddle demo}
	     * @example <caption>Set shadow with string notation</caption>
	     * object.setShadow('2px 2px 10px rgba(0,0,0,0.2)');
	     * canvas.renderAll();
	     * @example <caption>Set shadow with object notation</caption>
	     * object.setShadow({
	     *   color: 'red',
	     *   blur: 10,
	     *   offsetX: 20,
	     *   offsetY: 20
	     * });
	     * canvas.renderAll();
	     */
	    setShadow: function(options) {
	      return this.set('shadow', options ? new fabric.Shadow(options) : null);
	    },
	
	    /**
	     * Sets "color" of an instance (alias of `set('fill', &hellip;)`)
	     * @param {String} color Color value
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    setColor: function(color) {
	      this.set('fill', color);
	      return this;
	    },
	
	    /**
	     * Sets "angle" of an instance with centered rotation
	     * @param {Number} angle Angle value (in degrees)
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    rotate: function(angle) {
	      var shouldCenterOrigin = (this.originX !== 'center' || this.originY !== 'center') && this.centeredRotation;
	
	      if (shouldCenterOrigin) {
	        this._setOriginToCenter();
	      }
	
	      this.set('angle', angle);
	
	      if (shouldCenterOrigin) {
	        this._resetOrigin();
	      }
	
	      return this;
	    },
	
	    /**
	     * Centers object horizontally on canvas to which it was added last.
	     * You might need to call `setCoords` on an object after centering, to update controls area.
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    centerH: function () {
	      this.canvas && this.canvas.centerObjectH(this);
	      return this;
	    },
	
	    /**
	     * Centers object horizontally on current viewport of canvas to which it was added last.
	     * You might need to call `setCoords` on an object after centering, to update controls area.
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    viewportCenterH: function () {
	      this.canvas && this.canvas.viewportCenterObjectH(this);
	      return this;
	    },
	
	    /**
	     * Centers object vertically on canvas to which it was added last.
	     * You might need to call `setCoords` on an object after centering, to update controls area.
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    centerV: function () {
	      this.canvas && this.canvas.centerObjectV(this);
	      return this;
	    },
	
	    /**
	     * Centers object vertically on current viewport of canvas to which it was added last.
	     * You might need to call `setCoords` on an object after centering, to update controls area.
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    viewportCenterV: function () {
	      this.canvas && this.canvas.viewportCenterObjectV(this);
	      return this;
	    },
	
	    /**
	     * Centers object vertically and horizontally on canvas to which is was added last
	     * You might need to call `setCoords` on an object after centering, to update controls area.
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    center: function () {
	      this.canvas && this.canvas.centerObject(this);
	      return this;
	    },
	
	    /**
	     * Centers object on current viewport of canvas to which it was added last.
	     * You might need to call `setCoords` on an object after centering, to update controls area.
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    viewportCenter: function () {
	      this.canvas && this.canvas.viewportCenterObject(this);
	      return this;
	    },
	
	    /**
	     * Returns coordinates of a pointer relative to an object
	     * @param {Event} e Event to operate upon
	     * @param {Object} [pointer] Pointer to operate upon (instead of event)
	     * @return {Object} Coordinates of a pointer (x, y)
	     */
	    getLocalPointer: function(e, pointer) {
	      pointer = pointer || this.canvas.getPointer(e);
	      var pClicked = new fabric.Point(pointer.x, pointer.y),
	          objectLeftTop = this._getLeftTopCoords();
	      if (this.angle) {
	        pClicked = fabric.util.rotatePoint(
	          pClicked, objectLeftTop, degreesToRadians(-this.angle));
	      }
	      return {
	        x: pClicked.x - objectLeftTop.x,
	        y: pClicked.y - objectLeftTop.y
	      };
	    },
	
	    /**
	     * Sets canvas globalCompositeOperation for specific object
	     * custom composition operation for the particular object can be specified using globalCompositeOperation property
	     * @param {CanvasRenderingContext2D} ctx Rendering canvas context
	     */
	    _setupCompositeOperation: function (ctx) {
	      if (this.globalCompositeOperation) {
	        ctx.globalCompositeOperation = this.globalCompositeOperation;
	      }
	    }
	  });
	
	  fabric.util.createAccessors && fabric.util.createAccessors(fabric.Object);
	
	  extend(fabric.Object.prototype, fabric.Observable);
	
	  /**
	   * Defines the number of fraction digits to use when serializing object values.
	   * You can use it to increase/decrease precision of such values like left, top, scaleX, scaleY, etc.
	   * @static
	   * @memberOf fabric.Object
	   * @constant
	   * @type Number
	   */
	  fabric.Object.NUM_FRACTION_DIGITS = 2;
	
	  fabric.Object._fromObject = function(className, object, callback, extraParam) {
	    var klass = fabric[className];
	    object = clone(object, true);
	    fabric.util.enlivenPatterns([object.fill, object.stroke], function(patterns) {
	      if (typeof patterns[0] !== 'undefined') {
	        object.fill = patterns[0];
	      }
	      if (typeof patterns[1] !== 'undefined') {
	        object.stroke = patterns[1];
	      }
	      fabric.util.enlivenObjects([object.clipPath], function(enlivedProps) {
	        object.clipPath = enlivedProps[0];
	        var instance = extraParam ? new klass(object[extraParam], object) : new klass(object);
	        callback && callback(instance);
	      });
	    });
	  };
	
	  /**
	   * Unique id used internally when creating SVG elements
	   * @static
	   * @memberOf fabric.Object
	   * @type Number
	   */
	  fabric.Object.__uid = 0;
	
	})( true ? exports : this);
	
	
	(function() {
	
	  var degreesToRadians = fabric.util.degreesToRadians,
	      originXOffset = {
	        left: -0.5,
	        center: 0,
	        right: 0.5
	      },
	      originYOffset = {
	        top: -0.5,
	        center: 0,
	        bottom: 0.5
	      };
	
	  fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
	
	    /**
	     * Translates the coordinates from a set of origin to another (based on the object's dimensions)
	     * @param {fabric.Point} point The point which corresponds to the originX and originY params
	     * @param {String} fromOriginX Horizontal origin: 'left', 'center' or 'right'
	     * @param {String} fromOriginY Vertical origin: 'top', 'center' or 'bottom'
	     * @param {String} toOriginX Horizontal origin: 'left', 'center' or 'right'
	     * @param {String} toOriginY Vertical origin: 'top', 'center' or 'bottom'
	     * @return {fabric.Point}
	     */
	    translateToGivenOrigin: function(point, fromOriginX, fromOriginY, toOriginX, toOriginY) {
	      var x = point.x,
	          y = point.y,
	          offsetX, offsetY, dim;
	
	      if (typeof fromOriginX === 'string') {
	        fromOriginX = originXOffset[fromOriginX];
	      }
	      else {
	        fromOriginX -= 0.5;
	      }
	
	      if (typeof toOriginX === 'string') {
	        toOriginX = originXOffset[toOriginX];
	      }
	      else {
	        toOriginX -= 0.5;
	      }
	
	      offsetX = toOriginX - fromOriginX;
	
	      if (typeof fromOriginY === 'string') {
	        fromOriginY = originYOffset[fromOriginY];
	      }
	      else {
	        fromOriginY -= 0.5;
	      }
	
	      if (typeof toOriginY === 'string') {
	        toOriginY = originYOffset[toOriginY];
	      }
	      else {
	        toOriginY -= 0.5;
	      }
	
	      offsetY = toOriginY - fromOriginY;
	
	      if (offsetX || offsetY) {
	        dim = this._getTransformedDimensions();
	        x = point.x + offsetX * dim.x;
	        y = point.y + offsetY * dim.y;
	      }
	
	      return new fabric.Point(x, y);
	    },
	
	    /**
	     * Translates the coordinates from origin to center coordinates (based on the object's dimensions)
	     * @param {fabric.Point} point The point which corresponds to the originX and originY params
	     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
	     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
	     * @return {fabric.Point}
	     */
	    translateToCenterPoint: function(point, originX, originY) {
	      var p = this.translateToGivenOrigin(point, originX, originY, 'center', 'center');
	      if (this.angle) {
	        return fabric.util.rotatePoint(p, point, degreesToRadians(this.angle));
	      }
	      return p;
	    },
	
	    /**
	     * Translates the coordinates from center to origin coordinates (based on the object's dimensions)
	     * @param {fabric.Point} center The point which corresponds to center of the object
	     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
	     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
	     * @return {fabric.Point}
	     */
	    translateToOriginPoint: function(center, originX, originY) {
	      var p = this.translateToGivenOrigin(center, 'center', 'center', originX, originY);
	      if (this.angle) {
	        return fabric.util.rotatePoint(p, center, degreesToRadians(this.angle));
	      }
	      return p;
	    },
	
	    /**
	     * Returns the real center coordinates of the object
	     * @return {fabric.Point}
	     */
	    getCenterPoint: function() {
	      var leftTop = new fabric.Point(this.left, this.top);
	      return this.translateToCenterPoint(leftTop, this.originX, this.originY);
	    },
	
	    /**
	     * Returns the coordinates of the object based on center coordinates
	     * @param {fabric.Point} point The point which corresponds to the originX and originY params
	     * @return {fabric.Point}
	     */
	    // getOriginPoint: function(center) {
	    //   return this.translateToOriginPoint(center, this.originX, this.originY);
	    // },
	
	    /**
	     * Returns the coordinates of the object as if it has a different origin
	     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
	     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
	     * @return {fabric.Point}
	     */
	    getPointByOrigin: function(originX, originY) {
	      var center = this.getCenterPoint();
	      return this.translateToOriginPoint(center, originX, originY);
	    },
	
	    /**
	     * Returns the point in local coordinates
	     * @param {fabric.Point} point The point relative to the global coordinate system
	     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
	     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
	     * @return {fabric.Point}
	     */
	    toLocalPoint: function(point, originX, originY) {
	      var center = this.getCenterPoint(),
	          p, p2;
	
	      if (typeof originX !== 'undefined' && typeof originY !== 'undefined' ) {
	        p = this.translateToGivenOrigin(center, 'center', 'center', originX, originY);
	      }
	      else {
	        p = new fabric.Point(this.left, this.top);
	      }
	
	      p2 = new fabric.Point(point.x, point.y);
	      if (this.angle) {
	        p2 = fabric.util.rotatePoint(p2, center, -degreesToRadians(this.angle));
	      }
	      return p2.subtractEquals(p);
	    },
	
	    /**
	     * Returns the point in global coordinates
	     * @param {fabric.Point} The point relative to the local coordinate system
	     * @return {fabric.Point}
	     */
	    // toGlobalPoint: function(point) {
	    //   return fabric.util.rotatePoint(point, this.getCenterPoint(), degreesToRadians(this.angle)).addEquals(new fabric.Point(this.left, this.top));
	    // },
	
	    /**
	     * Sets the position of the object taking into consideration the object's origin
	     * @param {fabric.Point} pos The new position of the object
	     * @param {String} originX Horizontal origin: 'left', 'center' or 'right'
	     * @param {String} originY Vertical origin: 'top', 'center' or 'bottom'
	     * @return {void}
	     */
	    setPositionByOrigin: function(pos, originX, originY) {
	      var center = this.translateToCenterPoint(pos, originX, originY),
	          position = this.translateToOriginPoint(center, this.originX, this.originY);
	      this.set('left', position.x);
	      this.set('top', position.y);
	    },
	
	    /**
	     * @param {String} to One of 'left', 'center', 'right'
	     */
	    adjustPosition: function(to) {
	      var angle = degreesToRadians(this.angle),
	          hypotFull = this.getScaledWidth(),
	          xFull = fabric.util.cos(angle) * hypotFull,
	          yFull = fabric.util.sin(angle) * hypotFull,
	          offsetFrom, offsetTo;
	
	      //TODO: this function does not consider mixed situation like top, center.
	      if (typeof this.originX === 'string') {
	        offsetFrom = originXOffset[this.originX];
	      }
	      else {
	        offsetFrom = this.originX - 0.5;
	      }
	      if (typeof to === 'string') {
	        offsetTo = originXOffset[to];
	      }
	      else {
	        offsetTo = to - 0.5;
	      }
	      this.left += xFull * (offsetTo - offsetFrom);
	      this.top += yFull * (offsetTo - offsetFrom);
	      this.setCoords();
	      this.originX = to;
	    },
	
	    /**
	     * Sets the origin/position of the object to it's center point
	     * @private
	     * @return {void}
	     */
	    _setOriginToCenter: function() {
	      this._originalOriginX = this.originX;
	      this._originalOriginY = this.originY;
	
	      var center = this.getCenterPoint();
	
	      this.originX = 'center';
	      this.originY = 'center';
	
	      this.left = center.x;
	      this.top = center.y;
	    },
	
	    /**
	     * Resets the origin/position of the object to it's original origin
	     * @private
	     * @return {void}
	     */
	    _resetOrigin: function() {
	      var originPoint = this.translateToOriginPoint(
	        this.getCenterPoint(),
	        this._originalOriginX,
	        this._originalOriginY);
	
	      this.originX = this._originalOriginX;
	      this.originY = this._originalOriginY;
	
	      this.left = originPoint.x;
	      this.top = originPoint.y;
	
	      this._originalOriginX = null;
	      this._originalOriginY = null;
	    },
	
	    /**
	     * @private
	     */
	    _getLeftTopCoords: function() {
	      return this.translateToOriginPoint(this.getCenterPoint(), 'left', 'top');
	    },
	  });
	
	})();
	
	
	(function() {
	
	  function getCoords(coords) {
	    return [
	      new fabric.Point(coords.tl.x, coords.tl.y),
	      new fabric.Point(coords.tr.x, coords.tr.y),
	      new fabric.Point(coords.br.x, coords.br.y),
	      new fabric.Point(coords.bl.x, coords.bl.y)
	    ];
	  }
	
	  var degreesToRadians = fabric.util.degreesToRadians,
	      multiplyMatrices = fabric.util.multiplyTransformMatrices,
	      transformPoint = fabric.util.transformPoint;
	
	  fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
	
	    /**
	     * Describe object's corner position in canvas element coordinates.
	     * properties are tl,mt,tr,ml,mr,bl,mb,br,mtr for the main controls.
	     * each property is an object with x, y and corner.
	     * The `corner` property contains in a similar manner the 4 points of the
	     * interactive area of the corner.
	     * The coordinates depends from this properties: width, height, scaleX, scaleY
	     * skewX, skewY, angle, strokeWidth, viewportTransform, top, left, padding.
	     * The coordinates get updated with @method setCoords.
	     * You can calculate them without updating with @method calcCoords;
	     * @memberOf fabric.Object.prototype
	     */
	    oCoords: null,
	
	    /**
	     * Describe object's corner position in canvas object absolute coordinates
	     * properties are tl,tr,bl,br and describe the four main corner.
	     * each property is an object with x, y, instance of Fabric.Point.
	     * The coordinates depends from this properties: width, height, scaleX, scaleY
	     * skewX, skewY, angle, strokeWidth, top, left.
	     * Those coordinates are useful to understand where an object is. They get updated
	     * with oCoords but they do not need to be updated when zoom or panning change.
	     * The coordinates get updated with @method setCoords.
	     * You can calculate them without updating with @method calcCoords(true);
	     * @memberOf fabric.Object.prototype
	     */
	    aCoords: null,
	
	    /**
	     * storage for object transform matrix
	     */
	    ownMatrixCache: null,
	
	    /**
	     * storage for object full transform matrix
	     */
	    matrixCache: null,
	
	    /**
	     * return correct set of coordinates for intersection
	     */
	    getCoords: function(absolute, calculate) {
	      if (!this.oCoords) {
	        this.setCoords();
	      }
	      var coords = absolute ? this.aCoords : this.oCoords;
	      return getCoords(calculate ? this.calcCoords(absolute) : coords);
	    },
	
	    /**
	     * Checks if object intersects with an area formed by 2 points
	     * @param {Object} pointTL top-left point of area
	     * @param {Object} pointBR bottom-right point of area
	     * @param {Boolean} [absolute] use coordinates without viewportTransform
	     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
	     * @return {Boolean} true if object intersects with an area formed by 2 points
	     */
	    intersectsWithRect: function(pointTL, pointBR, absolute, calculate) {
	      var coords = this.getCoords(absolute, calculate),
	          intersection = fabric.Intersection.intersectPolygonRectangle(
	            coords,
	            pointTL,
	            pointBR
	          );
	      return intersection.status === 'Intersection';
	    },
	
	    /**
	     * Checks if object intersects with another object
	     * @param {Object} other Object to test
	     * @param {Boolean} [absolute] use coordinates without viewportTransform
	     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
	     * @return {Boolean} true if object intersects with another object
	     */
	    intersectsWithObject: function(other, absolute, calculate) {
	      var intersection = fabric.Intersection.intersectPolygonPolygon(
	        this.getCoords(absolute, calculate),
	        other.getCoords(absolute, calculate)
	      );
	
	      return intersection.status === 'Intersection'
	        || other.isContainedWithinObject(this, absolute, calculate)
	        || this.isContainedWithinObject(other, absolute, calculate);
	    },
	
	    /**
	     * Checks if object is fully contained within area of another object
	     * @param {Object} other Object to test
	     * @param {Boolean} [absolute] use coordinates without viewportTransform
	     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
	     * @return {Boolean} true if object is fully contained within area of another object
	     */
	    isContainedWithinObject: function(other, absolute, calculate) {
	      var points = this.getCoords(absolute, calculate),
	          i = 0, lines = other._getImageLines(
	            calculate ? other.calcCoords(absolute) : absolute ? other.aCoords : other.oCoords
	          );
	      for (; i < 4; i++) {
	        if (!other.containsPoint(points[i], lines)) {
	          return false;
	        }
	      }
	      return true;
	    },
	
	    /**
	     * Checks if object is fully contained within area formed by 2 points
	     * @param {Object} pointTL top-left point of area
	     * @param {Object} pointBR bottom-right point of area
	     * @param {Boolean} [absolute] use coordinates without viewportTransform
	     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
	     * @return {Boolean} true if object is fully contained within area formed by 2 points
	     */
	    isContainedWithinRect: function(pointTL, pointBR, absolute, calculate) {
	      var boundingRect = this.getBoundingRect(absolute, calculate);
	
	      return (
	        boundingRect.left >= pointTL.x &&
	        boundingRect.left + boundingRect.width <= pointBR.x &&
	        boundingRect.top >= pointTL.y &&
	        boundingRect.top + boundingRect.height <= pointBR.y
	      );
	    },
	
	    /**
	     * Checks if point is inside the object
	     * @param {fabric.Point} point Point to check against
	     * @param {Object} [lines] object returned from @method _getImageLines
	     * @param {Boolean} [absolute] use coordinates without viewportTransform
	     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
	     * @return {Boolean} true if point is inside the object
	     */
	    containsPoint: function(point, lines, absolute, calculate) {
	      var lines = lines || this._getImageLines(
	            calculate ? this.calcCoords(absolute) : absolute ? this.aCoords : this.oCoords
	          ),
	          xPoints = this._findCrossPoints(point, lines);
	
	      // if xPoints is odd then point is inside the object
	      return (xPoints !== 0 && xPoints % 2 === 1);
	    },
	
	    /**
	     * Checks if object is contained within the canvas with current viewportTransform
	     * the check is done stopping at first point that appears on screen
	     * @param {Boolean} [calculate] use coordinates of current position instead of .aCoords
	     * @return {Boolean} true if object is fully or partially contained within canvas
	     */
	    isOnScreen: function(calculate) {
	      if (!this.canvas) {
	        return false;
	      }
	      var pointTL = this.canvas.vptCoords.tl, pointBR = this.canvas.vptCoords.br;
	      var points = this.getCoords(true, calculate), point;
	      for (var i = 0; i < 4; i++) {
	        point = points[i];
	        if (point.x <= pointBR.x && point.x >= pointTL.x && point.y <= pointBR.y && point.y >= pointTL.y) {
	          return true;
	        }
	      }
	      // no points on screen, check intersection with absolute coordinates
	      if (this.intersectsWithRect(pointTL, pointBR, true, calculate)) {
	        return true;
	      }
	      return this._containsCenterOfCanvas(pointTL, pointBR, calculate);
	    },
	
	    /**
	     * Checks if the object contains the midpoint between canvas extremities
	     * Does not make sense outside the context of isOnScreen and isPartiallyOnScreen
	     * @private
	     * @param {Fabric.Point} pointTL Top Left point
	     * @param {Fabric.Point} pointBR Top Right point
	     * @param {Boolean} calculate use coordinates of current position instead of .oCoords
	     * @return {Boolean} true if the object contains the point
	     */
	    _containsCenterOfCanvas: function(pointTL, pointBR, calculate) {
	      // worst case scenario the object is so big that contains the screen
	      var centerPoint = { x: (pointTL.x + pointBR.x) / 2, y: (pointTL.y + pointBR.y) / 2 };
	      if (this.containsPoint(centerPoint, null, true, calculate)) {
	        return true;
	      }
	      return false;
	    },
	
	    /**
	     * Checks if object is partially contained within the canvas with current viewportTransform
	     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords
	     * @return {Boolean} true if object is partially contained within canvas
	     */
	    isPartiallyOnScreen: function(calculate) {
	      if (!this.canvas) {
	        return false;
	      }
	      var pointTL = this.canvas.vptCoords.tl, pointBR = this.canvas.vptCoords.br;
	      if (this.intersectsWithRect(pointTL, pointBR, true, calculate)) {
	        return true;
	      }
	      return this._containsCenterOfCanvas(pointTL, pointBR, calculate);
	    },
	
	    /**
	     * Method that returns an object with the object edges in it, given the coordinates of the corners
	     * @private
	     * @param {Object} oCoords Coordinates of the object corners
	     */
	    _getImageLines: function(oCoords) {
	      return {
	        topline: {
	          o: oCoords.tl,
	          d: oCoords.tr
	        },
	        rightline: {
	          o: oCoords.tr,
	          d: oCoords.br
	        },
	        bottomline: {
	          o: oCoords.br,
	          d: oCoords.bl
	        },
	        leftline: {
	          o: oCoords.bl,
	          d: oCoords.tl
	        }
	      };
	    },
	
	    /**
	     * Helper method to determine how many cross points are between the 4 object edges
	     * and the horizontal line determined by a point on canvas
	     * @private
	     * @param {fabric.Point} point Point to check
	     * @param {Object} lines Coordinates of the object being evaluated
	     */
	    // remove yi, not used but left code here just in case.
	    _findCrossPoints: function(point, lines) {
	      var b1, b2, a1, a2, xi, // yi,
	          xcount = 0,
	          iLine;
	
	      for (var lineKey in lines) {
	        iLine = lines[lineKey];
	        // optimisation 1: line below point. no cross
	        if ((iLine.o.y < point.y) && (iLine.d.y < point.y)) {
	          continue;
	        }
	        // optimisation 2: line above point. no cross
	        if ((iLine.o.y >= point.y) && (iLine.d.y >= point.y)) {
	          continue;
	        }
	        // optimisation 3: vertical line case
	        if ((iLine.o.x === iLine.d.x) && (iLine.o.x >= point.x)) {
	          xi = iLine.o.x;
	          // yi = point.y;
	        }
	        // calculate the intersection point
	        else {
	          b1 = 0;
	          b2 = (iLine.d.y - iLine.o.y) / (iLine.d.x - iLine.o.x);
	          a1 = point.y - b1 * point.x;
	          a2 = iLine.o.y - b2 * iLine.o.x;
	
	          xi = -(a1 - a2) / (b1 - b2);
	          // yi = a1 + b1 * xi;
	        }
	        // dont count xi < point.x cases
	        if (xi >= point.x) {
	          xcount += 1;
	        }
	        // optimisation 4: specific for square images
	        if (xcount === 2) {
	          break;
	        }
	      }
	      return xcount;
	    },
	
	    /**
	     * Returns coordinates of object's bounding rectangle (left, top, width, height)
	     * the box is intended as aligned to axis of canvas.
	     * @param {Boolean} [absolute] use coordinates without viewportTransform
	     * @param {Boolean} [calculate] use coordinates of current position instead of .oCoords / .aCoords
	     * @return {Object} Object with left, top, width, height properties
	     */
	    getBoundingRect: function(absolute, calculate) {
	      var coords = this.getCoords(absolute, calculate);
	      return fabric.util.makeBoundingBoxFromPoints(coords);
	    },
	
	    /**
	     * Returns width of an object's bounding box counting transformations
	     * before 2.0 it was named getWidth();
	     * @return {Number} width value
	     */
	    getScaledWidth: function() {
	      return this._getTransformedDimensions().x;
	    },
	
	    /**
	     * Returns height of an object bounding box counting transformations
	     * before 2.0 it was named getHeight();
	     * @return {Number} height value
	     */
	    getScaledHeight: function() {
	      return this._getTransformedDimensions().y;
	    },
	
	    /**
	     * Makes sure the scale is valid and modifies it if necessary
	     * @private
	     * @param {Number} value
	     * @return {Number}
	     */
	    _constrainScale: function(value) {
	      if (Math.abs(value) < this.minScaleLimit) {
	        if (value < 0) {
	          return -this.minScaleLimit;
	        }
	        else {
	          return this.minScaleLimit;
	        }
	      }
	      else if (value === 0) {
	        return 0.0001;
	      }
	      return value;
	    },
	
	    /**
	     * Scales an object (equally by x and y)
	     * @param {Number} value Scale factor
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    scale: function(value) {
	      this._set('scaleX', value);
	      this._set('scaleY', value);
	      return this.setCoords();
	    },
	
	    /**
	     * Scales an object to a given width, with respect to bounding box (scaling by x/y equally)
	     * @param {Number} value New width value
	     * @param {Boolean} absolute ignore viewport
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    scaleToWidth: function(value, absolute) {
	      // adjust to bounding rect factor so that rotated shapes would fit as well
	      var boundingRectFactor = this.getBoundingRect(absolute).width / this.getScaledWidth();
	      return this.scale(value / this.width / boundingRectFactor);
	    },
	
	    /**
	     * Scales an object to a given height, with respect to bounding box (scaling by x/y equally)
	     * @param {Number} value New height value
	     * @param {Boolean} absolute ignore viewport
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    scaleToHeight: function(value, absolute) {
	      // adjust to bounding rect factor so that rotated shapes would fit as well
	      var boundingRectFactor = this.getBoundingRect(absolute).height / this.getScaledHeight();
	      return this.scale(value / this.height / boundingRectFactor);
	    },
	
	    /**
	     * Calculates and returns the .coords of an object.
	     * @return {Object} Object with tl, tr, br, bl ....
	     * @chainable
	     */
	    calcCoords: function(absolute) {
	      var rotateMatrix = this._calcRotateMatrix(),
	          translateMatrix = this._calcTranslateMatrix(),
	          startMatrix = multiplyMatrices(translateMatrix, rotateMatrix),
	          vpt = this.getViewportTransform(),
	          finalMatrix = absolute ? startMatrix : multiplyMatrices(vpt, startMatrix),
	          dim = this._getTransformedDimensions(),
	          w = dim.x / 2, h = dim.y / 2,
	          tl = transformPoint({ x: -w, y: -h }, finalMatrix),
	          tr = transformPoint({ x: w, y: -h }, finalMatrix),
	          bl = transformPoint({ x: -w, y: h }, finalMatrix),
	          br = transformPoint({ x: w, y: h }, finalMatrix);
	      if (!absolute) {
	        var padding = this.padding, angle = degreesToRadians(this.angle),
	            cos = fabric.util.cos(angle), sin = fabric.util.sin(angle),
	            cosP = cos * padding, sinP = sin * padding, cosPSinP = cosP + sinP,
	            cosPMinusSinP = cosP - sinP;
	        if (padding) {
	          tl.x -= cosPMinusSinP;
	          tl.y -= cosPSinP;
	          tr.x += cosPSinP;
	          tr.y -= cosPMinusSinP;
	          bl.x -= cosPSinP;
	          bl.y += cosPMinusSinP;
	          br.x += cosPMinusSinP;
	          br.y += cosPSinP;
	        }
	        var ml  = new fabric.Point((tl.x + bl.x) / 2, (tl.y + bl.y) / 2),
	            mt  = new fabric.Point((tr.x + tl.x) / 2, (tr.y + tl.y) / 2),
	            mr  = new fabric.Point((br.x + tr.x) / 2, (br.y + tr.y) / 2),
	            mb  = new fabric.Point((br.x + bl.x) / 2, (br.y + bl.y) / 2),
	            mtr = new fabric.Point(mt.x + sin * this.rotatingPointOffset, mt.y - cos * this.rotatingPointOffset);
	      }
	
	      // if (!absolute) {
	      //   var canvas = this.canvas;
	      //   setTimeout(function() {
	      //     canvas.contextTop.clearRect(0, 0, 700, 700);
	      //     canvas.contextTop.fillStyle = 'green';
	      //     canvas.contextTop.fillRect(mb.x, mb.y, 3, 3);
	      //     canvas.contextTop.fillRect(bl.x, bl.y, 3, 3);
	      //     canvas.contextTop.fillRect(br.x, br.y, 3, 3);
	      //     canvas.contextTop.fillRect(tl.x, tl.y, 3, 3);
	      //     canvas.contextTop.fillRect(tr.x, tr.y, 3, 3);
	      //     canvas.contextTop.fillRect(ml.x, ml.y, 3, 3);
	      //     canvas.contextTop.fillRect(mr.x, mr.y, 3, 3);
	      //     canvas.contextTop.fillRect(mt.x, mt.y, 3, 3);
	      //     canvas.contextTop.fillRect(mtr.x, mtr.y, 3, 3);
	      //   }, 50);
	      // }
	
	      var coords = {
	        // corners
	        tl: tl, tr: tr, br: br, bl: bl,
	      };
	      if (!absolute) {
	        // middle
	        coords.ml = ml;
	        coords.mt = mt;
	        coords.mr = mr;
	        coords.mb = mb;
	        // rotating point
	        coords.mtr = mtr;
	      }
	      return coords;
	    },
	
	    /**
	     * Sets corner position coordinates based on current angle, width and height.
	     * See {@link https://github.com/kangax/fabric.js/wiki/When-to-call-setCoords|When-to-call-setCoords}
	     * @param {Boolean} [ignoreZoom] set oCoords with or without the viewport transform.
	     * @param {Boolean} [skipAbsolute] skip calculation of aCoords, useful in setViewportTransform
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    setCoords: function(ignoreZoom, skipAbsolute) {
	      this.oCoords = this.calcCoords(ignoreZoom);
	      if (!skipAbsolute) {
	        this.aCoords = this.calcCoords(true);
	      }
	
	      // set coordinates of the draggable boxes in the corners used to scale/rotate the image
	      ignoreZoom || (this._setCornerCoords && this._setCornerCoords());
	
	      return this;
	    },
	
	    /**
	     * calculate rotation matrix of an object
	     * @return {Array} rotation matrix for the object
	     */
	    _calcRotateMatrix: function() {
	      if (this.angle) {
	        var theta = degreesToRadians(this.angle), cos = fabric.util.cos(theta), sin = fabric.util.sin(theta);
	        return [cos, sin, -sin, cos, 0, 0];
	      }
	      return fabric.iMatrix.concat();
	    },
	
	    /**
	     * calculate the translation matrix for an object transform
	     * @return {Array} rotation matrix for the object
	     */
	    _calcTranslateMatrix: function() {
	      var center = this.getCenterPoint();
	      return [1, 0, 0, 1, center.x, center.y];
	    },
	
	    transformMatrixKey: function(skipGroup) {
	      var sep = '_', prefix = '';
	      if (!skipGroup && this.group) {
	        prefix = this.group.transformMatrixKey(skipGroup) + sep;
	      };
	      return prefix + this.top + sep + this.left + sep + this.scaleX + sep + this.scaleY +
	        sep + this.skewX + sep + this.skewY + sep + this.angle + sep + this.originX + sep + this.originY +
	        sep + this.width + sep + this.height + sep + this.strokeWidth + this.flipX + this.flipY;
	    },
	
	    /**
	     * calculate transform matrix that represents the current transformations from the
	     * object's properties.
	     * @param {Boolean} [skipGroup] return transform matrix for object not counting parent transformations
	     * @return {Array} transform matrix for the object
	     */
	    calcTransformMatrix: function(skipGroup) {
	      if (skipGroup) {
	        return this.calcOwnMatrix();
	      }
	      var key = this.transformMatrixKey(), cache = this.matrixCache || (this.matrixCache = {});
	      if (cache.key === key) {
	        return cache.value;
	      }
	      var matrix = this.calcOwnMatrix();
	      if (this.group) {
	        matrix = multiplyMatrices(this.group.calcTransformMatrix(), matrix);
	      }
	      cache.key = key;
	      cache.value = matrix;
	      return matrix;
	    },
	
	    calcOwnMatrix: function() {
	      var key = this.transformMatrixKey(true), cache = this.ownMatrixCache || (this.ownMatrixCache = {});
	      if (cache.key === key) {
	        return cache.value;
	      }
	      var matrix = this._calcTranslateMatrix(),
	          rotateMatrix,
	          dimensionMatrix = this._calcDimensionsTransformMatrix(this.skewX, this.skewY, true);
	      if (this.angle) {
	        rotateMatrix = this._calcRotateMatrix();
	        matrix = multiplyMatrices(matrix, rotateMatrix);
	      }
	      matrix = multiplyMatrices(matrix, dimensionMatrix);
	      cache.key = key;
	      cache.value = matrix;
	      return matrix;
	    },
	
	    _calcDimensionsTransformMatrix: function(skewX, skewY, flipping) {
	      var skewMatrix,
	          scaleX = this.scaleX * (flipping && this.flipX ? -1 : 1),
	          scaleY = this.scaleY * (flipping && this.flipY ? -1 : 1),
	          scaleMatrix = [scaleX, 0, 0, scaleY, 0, 0];
	      if (skewX) {
	        skewMatrix = [1, 0, Math.tan(degreesToRadians(skewX)), 1];
	        scaleMatrix = multiplyMatrices(scaleMatrix, skewMatrix, true);
	      }
	      if (skewY) {
	        skewMatrix = [1, Math.tan(degreesToRadians(skewY)), 0, 1];
	        scaleMatrix = multiplyMatrices(scaleMatrix, skewMatrix, true);
	      }
	      return scaleMatrix;
	    },
	
	
	    /*
	     * Calculate object dimensions from its properties
	     * @private
	     * @return {Object} .x width dimension
	     * @return {Object} .y height dimension
	     */
	    _getNonTransformedDimensions: function() {
	      var strokeWidth = this.strokeWidth,
	          w = this.width + strokeWidth,
	          h = this.height + strokeWidth;
	      return { x: w, y: h };
	    },
	
	    /*
	     * Calculate object bounding box dimensions from its properties scale, skew.
	     * @param {Number} skewX, a value to override current skewX
	     * @param {Number} skewY, a value to override current skewY
	     * @private
	     * @return {Object} .x width dimension
	     * @return {Object} .y height dimension
	     */
	    _getTransformedDimensions: function(skewX, skewY) {
	      if (typeof skewX === 'undefined') {
	        skewX = this.skewX;
	      }
	      if (typeof skewY === 'undefined') {
	        skewY = this.skewY;
	      }
	      var dimensions = this._getNonTransformedDimensions(), dimX, dimY,
	          noSkew = skewX === 0 && skewY === 0;
	
	      if (this.strokeUniform) {
	        dimX = this.width;
	        dimY = this.height;
	      }
	      else {
	        dimX = dimensions.x;
	        dimY = dimensions.y;
	      }
	      if (noSkew) {
	        return this._finalizeDimensions(dimX * this.scaleX, dimY * this.scaleY);
	      }
	      else {
	        dimX /= 2;
	        dimY /= 2;
	      }
	      var points = [
	            {
	              x: -dimX,
	              y: -dimY
	            },
	            {
	              x: dimX,
	              y: -dimY
	            },
	            {
	              x: -dimX,
	              y: dimY
	            },
	            {
	              x: dimX,
	              y: dimY
	            }],
	          i, transformMatrix = this._calcDimensionsTransformMatrix(skewX, skewY, false),
	          bbox;
	      for (i = 0; i < points.length; i++) {
	        points[i] = fabric.util.transformPoint(points[i], transformMatrix);
	      }
	      bbox = fabric.util.makeBoundingBoxFromPoints(points);
	      return this._finalizeDimensions(bbox.width, bbox.height);
	    },
	
	    /*
	     * Calculate object bounding box dimensions from its properties scale, skew.
	     * @param Number width width of the bbox
	     * @param Number height height of the bbox
	     * @private
	     * @return {Object} .x finalized width dimension
	     * @return {Object} .y finalized height dimension
	     */
	    _finalizeDimensions: function(width, height) {
	      return this.strokeUniform ?
	        { x: width + this.strokeWidth, y: height + this.strokeWidth }
	        :
	        { x: width, y: height };
	    },
	    /*
	     * Calculate object dimensions for controls, including padding and canvas zoom.
	     * private
	     */
	    _calculateCurrentDimensions: function()  {
	      var vpt = this.getViewportTransform(),
	          dim = this._getTransformedDimensions(),
	          p = fabric.util.transformPoint(dim, vpt, true);
	
	      return p.scalarAdd(2 * this.padding);
	    },
	  });
	})();
	
	
	fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
	
	  /**
	   * Moves an object to the bottom of the stack of drawn objects
	   * @return {fabric.Object} thisArg
	   * @chainable
	   */
	  sendToBack: function() {
	    if (this.group) {
	      fabric.StaticCanvas.prototype.sendToBack.call(this.group, this);
	    }
	    else {
	      this.canvas.sendToBack(this);
	    }
	    return this;
	  },
	
	  /**
	   * Moves an object to the top of the stack of drawn objects
	   * @return {fabric.Object} thisArg
	   * @chainable
	   */
	  bringToFront: function() {
	    if (this.group) {
	      fabric.StaticCanvas.prototype.bringToFront.call(this.group, this);
	    }
	    else {
	      this.canvas.bringToFront(this);
	    }
	    return this;
	  },
	
	  /**
	   * Moves an object down in stack of drawn objects
	   * @param {Boolean} [intersecting] If `true`, send object behind next lower intersecting object
	   * @return {fabric.Object} thisArg
	   * @chainable
	   */
	  sendBackwards: function(intersecting) {
	    if (this.group) {
	      fabric.StaticCanvas.prototype.sendBackwards.call(this.group, this, intersecting);
	    }
	    else {
	      this.canvas.sendBackwards(this, intersecting);
	    }
	    return this;
	  },
	
	  /**
	   * Moves an object up in stack of drawn objects
	   * @param {Boolean} [intersecting] If `true`, send object in front of next upper intersecting object
	   * @return {fabric.Object} thisArg
	   * @chainable
	   */
	  bringForward: function(intersecting) {
	    if (this.group) {
	      fabric.StaticCanvas.prototype.bringForward.call(this.group, this, intersecting);
	    }
	    else {
	      this.canvas.bringForward(this, intersecting);
	    }
	    return this;
	  },
	
	  /**
	   * Moves an object to specified level in stack of drawn objects
	   * @param {Number} index New position of object
	   * @return {fabric.Object} thisArg
	   * @chainable
	   */
	  moveTo: function(index) {
	    if (this.group && this.group.type !== 'activeSelection') {
	      fabric.StaticCanvas.prototype.moveTo.call(this.group, this, index);
	    }
	    else {
	      this.canvas.moveTo(this, index);
	    }
	    return this;
	  }
	});
	
	
	/* _TO_SVG_START_ */
	(function() {
	  function getSvgColorString(prop, value) {
	    if (!value) {
	      return prop + ': none; ';
	    }
	    else if (value.toLive) {
	      return prop + ': url(#SVGID_' + value.id + '); ';
	    }
	    else {
	      var color = new fabric.Color(value),
	          str = prop + ': ' + color.toRgb() + '; ',
	          opacity = color.getAlpha();
	      if (opacity !== 1) {
	        //change the color in rgb + opacity
	        str += prop + '-opacity: ' + opacity.toString() + '; ';
	      }
	      return str;
	    }
	  }
	
	  var toFixed = fabric.util.toFixed;
	
	  fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
	    /**
	     * Returns styles-string for svg-export
	     * @param {Boolean} skipShadow a boolean to skip shadow filter output
	     * @return {String}
	     */
	    getSvgStyles: function(skipShadow) {
	
	      var fillRule = this.fillRule ? this.fillRule : 'nonzero',
	          strokeWidth = this.strokeWidth ? this.strokeWidth : '0',
	          strokeDashArray = this.strokeDashArray ? this.strokeDashArray.join(' ') : 'none',
	          strokeDashOffset = this.strokeDashOffset ? this.strokeDashOffset : '0',
	          strokeLineCap = this.strokeLineCap ? this.strokeLineCap : 'butt',
	          strokeLineJoin = this.strokeLineJoin ? this.strokeLineJoin : 'miter',
	          strokeMiterLimit = this.strokeMiterLimit ? this.strokeMiterLimit : '4',
	          opacity = typeof this.opacity !== 'undefined' ? this.opacity : '1',
	          visibility = this.visible ? '' : ' visibility: hidden;',
	          filter = skipShadow ? '' : this.getSvgFilter(),
	          fill = getSvgColorString('fill', this.fill),
	          stroke = getSvgColorString('stroke', this.stroke);
	
	      return [
	        stroke,
	        'stroke-width: ', strokeWidth, '; ',
	        'stroke-dasharray: ', strokeDashArray, '; ',
	        'stroke-linecap: ', strokeLineCap, '; ',
	        'stroke-dashoffset: ', strokeDashOffset, '; ',
	        'stroke-linejoin: ', strokeLineJoin, '; ',
	        'stroke-miterlimit: ', strokeMiterLimit, '; ',
	        fill,
	        'fill-rule: ', fillRule, '; ',
	        'opacity: ', opacity, ';',
	        filter,
	        visibility
	      ].join('');
	    },
	
	    /**
	     * Returns styles-string for svg-export
	     * @param {Object} style the object from which to retrieve style properties
	     * @param {Boolean} useWhiteSpace a boolean to include an additional attribute in the style.
	     * @return {String}
	     */
	    getSvgSpanStyles: function(style, useWhiteSpace) {
	      var term = '; ';
	      var fontFamily = style.fontFamily ?
	        'font-family: ' + (((style.fontFamily.indexOf('\'') === -1 && style.fontFamily.indexOf('"') === -1) ?
	          '\'' + style.fontFamily  + '\'' : style.fontFamily)) + term : '';
	      var strokeWidth = style.strokeWidth ? 'stroke-width: ' + style.strokeWidth + term : '',
	          fontFamily = fontFamily,
	          fontSize = style.fontSize ? 'font-size: ' + style.fontSize + 'px' + term : '',
	          fontStyle = style.fontStyle ? 'font-style: ' + style.fontStyle + term : '',
	          fontWeight = style.fontWeight ? 'font-weight: ' + style.fontWeight + term : '',
	          fill = style.fill ? getSvgColorString('fill', style.fill) : '',
	          stroke = style.stroke ? getSvgColorString('stroke', style.stroke) : '',
	          textDecoration = this.getSvgTextDecoration(style),
	          deltaY = style.deltaY ? 'baseline-shift: ' + (-style.deltaY) + '; ' : '';
	      if (textDecoration) {
	        textDecoration = 'text-decoration: ' + textDecoration + term;
	      }
	
	      return [
	        stroke,
	        strokeWidth,
	        fontFamily,
	        fontSize,
	        fontStyle,
	        fontWeight,
	        textDecoration,
	        fill,
	        deltaY,
	        useWhiteSpace ? 'white-space: pre; ' : ''
	      ].join('');
	    },
	
	    /**
	     * Returns text-decoration property for svg-export
	     * @param {Object} style the object from which to retrieve style properties
	     * @return {String}
	     */
	    getSvgTextDecoration: function(style) {
	      if ('overline' in style || 'underline' in style || 'linethrough' in style) {
	        return (style.overline ? 'overline ' : '') +
	          (style.underline ? 'underline ' : '') + (style.linethrough ? 'line-through ' : '');
	      }
	      return '';
	    },
	
	    /**
	     * Returns filter for svg shadow
	     * @return {String}
	     */
	    getSvgFilter: function() {
	      return this.shadow ? 'filter: url(#SVGID_' + this.shadow.id + ');' : '';
	    },
	
	    /**
	     * Returns id attribute for svg output
	     * @return {String}
	     */
	    getSvgCommons: function() {
	      return [
	        this.id ? 'id="' + this.id + '" ' : '',
	        this.clipPath ? 'clip-path="url(#' + this.clipPath.clipPathId + ')" ' : '',
	      ].join('');
	    },
	
	    /**
	     * Returns transform-string for svg-export
	     * @param {Boolean} use the full transform or the single object one.
	     * @return {String}
	     */
	    getSvgTransform: function(full, additionalTransform) {
	      var transform = full ? this.calcTransformMatrix() : this.calcOwnMatrix(),
	          svgTransform = 'transform="' + fabric.util.matrixToSVG(transform);
	      return svgTransform +
	        (additionalTransform || '') + this.getSvgTransformMatrix() + '" ';
	    },
	
	    /**
	     * Returns transform-string for svg-export from the transform matrix of single elements
	     * @return {String}
	     */
	    getSvgTransformMatrix: function() {
	      return this.transformMatrix ? ' ' + fabric.util.matrixToSVG(this.transformMatrix) : '';
	    },
	
	    _setSVGBg: function(textBgRects) {
	      if (this.backgroundColor) {
	        var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;
	        textBgRects.push(
	          '\t\t<rect ',
	          this._getFillAttributes(this.backgroundColor),
	          ' x="',
	          toFixed(-this.width / 2, NUM_FRACTION_DIGITS),
	          '" y="',
	          toFixed(-this.height / 2, NUM_FRACTION_DIGITS),
	          '" width="',
	          toFixed(this.width, NUM_FRACTION_DIGITS),
	          '" height="',
	          toFixed(this.height, NUM_FRACTION_DIGITS),
	          '"></rect>\n');
	      }
	    },
	
	    /**
	     * Returns svg representation of an instance
	     * @param {Function} [reviver] Method for further parsing of svg representation.
	     * @return {String} svg representation of an instance
	     */
	    toSVG: function(reviver) {
	      return this._createBaseSVGMarkup(this._toSVG(reviver), { reviver: reviver });
	    },
	
	    /**
	     * Returns svg clipPath representation of an instance
	     * @param {Function} [reviver] Method for further parsing of svg representation.
	     * @return {String} svg representation of an instance
	     */
	    toClipPathSVG: function(reviver) {
	      return '\t' + this._createBaseClipPathSVGMarkup(this._toSVG(reviver), { reviver: reviver });
	    },
	
	    /**
	     * @private
	     */
	    _createBaseClipPathSVGMarkup: function(objectMarkup, options) {
	      options = options || {};
	      var reviver = options.reviver,
	          additionalTransform = options.additionalTransform || '',
	          commonPieces = [
	            this.getSvgTransform(true, additionalTransform),
	            this.getSvgCommons(),
	          ].join(''),
	          // insert commons in the markup, style and svgCommons
	          index = objectMarkup.indexOf('COMMON_PARTS');
	      objectMarkup[index] = commonPieces;
	      return reviver ? reviver(objectMarkup.join('')) : objectMarkup.join('');
	    },
	
	    /**
	     * @private
	     */
	    _createBaseSVGMarkup: function(objectMarkup, options) {
	      options = options || {};
	      var noStyle = options.noStyle,
	          reviver = options.reviver,
	          styleInfo = noStyle ? '' : 'style="' + this.getSvgStyles() + '" ',
	          shadowInfo = options.withShadow ? 'style="' + this.getSvgFilter() + '" ' : '',
	          clipPath = this.clipPath,
	          vectorEffect = this.strokeUniform ? 'vector-effect="non-scaling-stroke" ' : '',
	          absoluteClipPath = clipPath && clipPath.absolutePositioned,
	          stroke = this.stroke, fill = this.fill, shadow = this.shadow,
	          commonPieces, markup = [], clipPathMarkup,
	          // insert commons in the markup, style and svgCommons
	          index = objectMarkup.indexOf('COMMON_PARTS'),
	          additionalTransform = options.additionalTransform;
	      if (clipPath) {
	        clipPath.clipPathId = 'CLIPPATH_' + fabric.Object.__uid++;
	        clipPathMarkup = '<clipPath id="' + clipPath.clipPathId + '" >\n' +
	          clipPath.toClipPathSVG(reviver) +
	          '</clipPath>\n';
	      }
	      if (absoluteClipPath) {
	        markup.push(
	          '<g ', shadowInfo, this.getSvgCommons(), ' >\n'
	        );
	      }
	      markup.push(
	        '<g ',
	        this.getSvgTransform(false),
	        !absoluteClipPath ? shadowInfo + this.getSvgCommons() : '',
	        ' >\n'
	      );
	      commonPieces = [
	        styleInfo,
	        vectorEffect,
	        noStyle ? '' : this.addPaintOrder(), ' ',
	        additionalTransform ? 'transform="' + additionalTransform + '" ' : '',
	      ].join('');
	      objectMarkup[index] = commonPieces;
	      if (fill && fill.toLive) {
	        markup.push(fill.toSVG(this));
	      }
	      if (stroke && stroke.toLive) {
	        markup.push(stroke.toSVG(this));
	      }
	      if (shadow) {
	        markup.push(shadow.toSVG(this));
	      }
	      if (clipPath) {
	        markup.push(clipPathMarkup);
	      }
	      markup.push(objectMarkup.join(''));
	      markup.push('</g>\n');
	      absoluteClipPath && markup.push('</g>\n');
	      return reviver ? reviver(markup.join('')) : markup.join('');
	    },
	
	    addPaintOrder: function() {
	      return this.paintFirst !== 'fill' ? ' paint-order="' + this.paintFirst + '" ' : '';
	    }
	  });
	})();
	/* _TO_SVG_END_ */
	
	
	(function() {
	
	  var extend = fabric.util.object.extend,
	      originalSet = 'stateProperties';
	
	  /*
	    Depends on `stateProperties`
	  */
	  function saveProps(origin, destination, props) {
	    var tmpObj = { }, deep = true;
	    props.forEach(function(prop) {
	      tmpObj[prop] = origin[prop];
	    });
	    extend(origin[destination], tmpObj, deep);
	  }
	
	  function _isEqual(origValue, currentValue, firstPass) {
	    if (origValue === currentValue) {
	      // if the objects are identical, return
	      return true;
	    }
	    else if (Array.isArray(origValue)) {
	      if (!Array.isArray(currentValue) || origValue.length !== currentValue.length) {
	        return false;
	      }
	      for (var i = 0, len = origValue.length; i < len; i++) {
	        if (!_isEqual(origValue[i], currentValue[i])) {
	          return false;
	        }
	      }
	      return true;
	    }
	    else if (origValue && typeof origValue === 'object') {
	      var keys = Object.keys(origValue), key;
	      if (!currentValue ||
	          typeof currentValue !== 'object' ||
	          (!firstPass && keys.length !== Object.keys(currentValue).length)
	      ) {
	        return false;
	      }
	      for (var i = 0, len = keys.length; i < len; i++) {
	        key = keys[i];
	        // since clipPath is in the statefull cache list and the clipPath objects
	        // would be iterated as an object, this would lead to possible infinite recursion
	        if (key === 'canvas') {
	          continue;
	        }
	        if (!_isEqual(origValue[key], currentValue[key])) {
	          return false;
	        }
	      }
	      return true;
	    }
	  }
	
	
	  fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
	
	    /**
	     * Returns true if object state (one of its state properties) was changed
	     * @param {String} [propertySet] optional name for the set of property we want to save
	     * @return {Boolean} true if instance' state has changed since `{@link fabric.Object#saveState}` was called
	     */
	    hasStateChanged: function(propertySet) {
	      propertySet = propertySet || originalSet;
	      var dashedPropertySet = '_' + propertySet;
	      if (Object.keys(this[dashedPropertySet]).length < this[propertySet].length) {
	        return true;
	      }
	      return !_isEqual(this[dashedPropertySet], this, true);
	    },
	
	    /**
	     * Saves state of an object
	     * @param {Object} [options] Object with additional `stateProperties` array to include when saving state
	     * @return {fabric.Object} thisArg
	     */
	    saveState: function(options) {
	      var propertySet = options && options.propertySet || originalSet,
	          destination = '_' + propertySet;
	      if (!this[destination]) {
	        return this.setupState(options);
	      }
	      saveProps(this, destination, this[propertySet]);
	      if (options && options.stateProperties) {
	        saveProps(this, destination, options.stateProperties);
	      }
	      return this;
	    },
	
	    /**
	     * Setups state of an object
	     * @param {Object} [options] Object with additional `stateProperties` array to include when saving state
	     * @return {fabric.Object} thisArg
	     */
	    setupState: function(options) {
	      options = options || { };
	      var propertySet = options.propertySet || originalSet;
	      options.propertySet = propertySet;
	      this['_' + propertySet] = { };
	      this.saveState(options);
	      return this;
	    }
	  });
	})();
	
	
	(function() {
	
	  var degreesToRadians = fabric.util.degreesToRadians;
	
	  fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
	
	    /**
	     * The object interactivity controls.
	     * @private
	     */
	    _controlsVisibility: null,
	
	    /**
	     * Determines which corner has been clicked
	     * @private
	     * @param {Object} pointer The pointer indicating the mouse position
	     * @return {String|Boolean} corner code (tl, tr, bl, br, etc.), or false if nothing is found
	     */
	    _findTargetCorner: function(pointer) {
	      // objects in group, anykind, are not self modificable,
	      // must not return an hovered corner.
	      if (!this.hasControls || this.group || (!this.canvas || this.canvas._activeObject !== this)) {
	        return false;
	      }
	
	      var ex = pointer.x,
	          ey = pointer.y,
	          xPoints,
	          lines;
	      this.__corner = 0;
	      for (var i in this.oCoords) {
	
	        if (!this.isControlVisible(i)) {
	          continue;
	        }
	
	        if (i === 'mtr' && !this.hasRotatingPoint) {
	          continue;
	        }
	
	        if (this.get('lockUniScaling') &&
	           (i === 'mt' || i === 'mr' || i === 'mb' || i === 'ml')) {
	          continue;
	        }
	
	        lines = this._getImageLines(this.oCoords[i].corner);
	
	        // debugging
	
	        // canvas.contextTop.fillRect(lines.bottomline.d.x, lines.bottomline.d.y, 2, 2);
	        // canvas.contextTop.fillRect(lines.bottomline.o.x, lines.bottomline.o.y, 2, 2);
	
	        // canvas.contextTop.fillRect(lines.leftline.d.x, lines.leftline.d.y, 2, 2);
	        // canvas.contextTop.fillRect(lines.leftline.o.x, lines.leftline.o.y, 2, 2);
	
	        // canvas.contextTop.fillRect(lines.topline.d.x, lines.topline.d.y, 2, 2);
	        // canvas.contextTop.fillRect(lines.topline.o.x, lines.topline.o.y, 2, 2);
	
	        // canvas.contextTop.fillRect(lines.rightline.d.x, lines.rightline.d.y, 2, 2);
	        // canvas.contextTop.fillRect(lines.rightline.o.x, lines.rightline.o.y, 2, 2);
	
	        xPoints = this._findCrossPoints({ x: ex, y: ey }, lines);
	        if (xPoints !== 0 && xPoints % 2 === 1) {
	          this.__corner = i;
	          return i;
	        }
	      }
	      return false;
	    },
	
	    /**
	     * Sets the coordinates of the draggable boxes in the corners of
	     * the image used to scale/rotate it.
	     * @private
	     */
	    _setCornerCoords: function() {
	      var coords = this.oCoords,
	          newTheta = degreesToRadians(45 - this.angle),
	          /* Math.sqrt(2 * Math.pow(this.cornerSize, 2)) / 2, */
	          /* 0.707106 stands for sqrt(2)/2 */
	          cornerHypotenuse = this.cornerSize * 0.707106,
	          cosHalfOffset = cornerHypotenuse * fabric.util.cos(newTheta),
	          sinHalfOffset = cornerHypotenuse * fabric.util.sin(newTheta),
	          x, y;
	
	      for (var point in coords) {
	        x = coords[point].x;
	        y = coords[point].y;
	        coords[point].corner = {
	          tl: {
	            x: x - sinHalfOffset,
	            y: y - cosHalfOffset
	          },
	          tr: {
	            x: x + cosHalfOffset,
	            y: y - sinHalfOffset
	          },
	          bl: {
	            x: x - cosHalfOffset,
	            y: y + sinHalfOffset
	          },
	          br: {
	            x: x + sinHalfOffset,
	            y: y + cosHalfOffset
	          }
	        };
	      }
	    },
	
	    /**
	     * Draws a colored layer behind the object, inside its selection borders.
	     * Requires public options: padding, selectionBackgroundColor
	     * this function is called when the context is transformed
	     * has checks to be skipped when the object is on a staticCanvas
	     * @param {CanvasRenderingContext2D} ctx Context to draw on
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    drawSelectionBackground: function(ctx) {
	      if (!this.selectionBackgroundColor ||
	        (this.canvas && !this.canvas.interactive) ||
	        (this.canvas && this.canvas._activeObject !== this)
	      ) {
	        return this;
	      }
	      ctx.save();
	      var center = this.getCenterPoint(), wh = this._calculateCurrentDimensions(),
	          vpt = this.canvas.viewportTransform;
	      ctx.translate(center.x, center.y);
	      ctx.scale(1 / vpt[0], 1 / vpt[3]);
	      ctx.rotate(degreesToRadians(this.angle));
	      ctx.fillStyle = this.selectionBackgroundColor;
	      ctx.fillRect(-wh.x / 2, -wh.y / 2, wh.x, wh.y);
	      ctx.restore();
	      return this;
	    },
	
	    /**
	     * Draws borders of an object's bounding box.
	     * Requires public properties: width, height
	     * Requires public options: padding, borderColor
	     * @param {CanvasRenderingContext2D} ctx Context to draw on
	     * @param {Object} styleOverride object to override the object style
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    drawBorders: function(ctx, styleOverride) {
	      styleOverride = styleOverride || {};
	      var wh = this._calculateCurrentDimensions(),
	          strokeWidth = 1 / this.borderScaleFactor,
	          width = wh.x + strokeWidth,
	          height = wh.y + strokeWidth,
	          drawRotatingPoint = typeof styleOverride.hasRotatingPoint !== 'undefined' ?
	            styleOverride.hasRotatingPoint : this.hasRotatingPoint,
	          hasControls = typeof styleOverride.hasControls !== 'undefined' ?
	            styleOverride.hasControls : this.hasControls,
	          rotatingPointOffset = typeof styleOverride.rotatingPointOffset !== 'undefined' ?
	            styleOverride.rotatingPointOffset : this.rotatingPointOffset;
	
	      ctx.save();
	      ctx.strokeStyle = styleOverride.borderColor || this.borderColor;
	      this._setLineDash(ctx, styleOverride.borderDashArray || this.borderDashArray, null);
	
	      ctx.strokeRect(
	        -width / 2,
	        -height / 2,
	        width,
	        height
	      );
	
	      if (drawRotatingPoint && this.isControlVisible('mtr') && hasControls) {
	
	        var rotateHeight = -height / 2;
	
	        ctx.beginPath();
	        ctx.moveTo(0, rotateHeight);
	        ctx.lineTo(0, rotateHeight - rotatingPointOffset);
	        ctx.stroke();
	      }
	
	      ctx.restore();
	      return this;
	    },
	
	    /**
	     * Draws borders of an object's bounding box when it is inside a group.
	     * Requires public properties: width, height
	     * Requires public options: padding, borderColor
	     * @param {CanvasRenderingContext2D} ctx Context to draw on
	     * @param {object} options object representing current object parameters
	     * @param {Object} styleOverride object to override the object style
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    drawBordersInGroup: function(ctx, options, styleOverride) {
	      styleOverride = styleOverride || {};
	      var p = this._getNonTransformedDimensions(),
	          matrix = fabric.util.customTransformMatrix(options.scaleX, options.scaleY, options.skewX),
	          wh = fabric.util.transformPoint(p, matrix),
	          strokeWidth = 1 / this.borderScaleFactor,
	          width = wh.x + strokeWidth,
	          height = wh.y + strokeWidth;
	
	      ctx.save();
	      this._setLineDash(ctx, styleOverride.borderDashArray || this.borderDashArray, null);
	      ctx.strokeStyle = styleOverride.borderColor || this.borderColor;
	
	      ctx.strokeRect(
	        -width / 2,
	        -height / 2,
	        width,
	        height
	      );
	
	      ctx.restore();
	      return this;
	    },
	
	    /**
	     * Draws corners of an object's bounding box.
	     * Requires public properties: width, height
	     * Requires public options: cornerSize, padding
	     * @param {CanvasRenderingContext2D} ctx Context to draw on
	     * @param {Object} styleOverride object to override the object style
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    drawControls: function(ctx, styleOverride) {
	      styleOverride = styleOverride || {};
	      var wh = this._calculateCurrentDimensions(),
	          width = wh.x,
	          height = wh.y,
	          scaleOffset = styleOverride.cornerSize || this.cornerSize,
	          left = -(width + scaleOffset) / 2,
	          top = -(height + scaleOffset) / 2,
	          transparentCorners = typeof styleOverride.transparentCorners !== 'undefined' ?
	            styleOverride.transparentCorners : this.transparentCorners,
	          hasRotatingPoint = typeof styleOverride.hasRotatingPoint !== 'undefined' ?
	            styleOverride.hasRotatingPoint : this.hasRotatingPoint,
	          methodName = transparentCorners ? 'stroke' : 'fill';
	
	      ctx.save();
	      ctx.strokeStyle = ctx.fillStyle = styleOverride.cornerColor || this.cornerColor;
	      if (!this.transparentCorners) {
	        ctx.strokeStyle = styleOverride.cornerStrokeColor || this.cornerStrokeColor;
	      }
	      this._setLineDash(ctx, styleOverride.cornerDashArray || this.cornerDashArray, null);
	
	      // top-left
	      this._drawControl('tl', ctx, methodName,
	        left,
	        top, styleOverride);
	
	      // top-right
	      this._drawControl('tr', ctx, methodName,
	        left + width,
	        top, styleOverride);
	
	      // bottom-left
	      this._drawControl('bl', ctx, methodName,
	        left,
	        top + height, styleOverride);
	
	      // bottom-right
	      this._drawControl('br', ctx, methodName,
	        left + width,
	        top + height, styleOverride);
	
	      if (!this.get('lockUniScaling')) {
	
	        // middle-top
	        this._drawControl('mt', ctx, methodName,
	          left + width / 2,
	          top, styleOverride);
	
	        // middle-bottom
	        this._drawControl('mb', ctx, methodName,
	          left + width / 2,
	          top + height, styleOverride);
	
	        // middle-right
	        this._drawControl('mr', ctx, methodName,
	          left + width,
	          top + height / 2, styleOverride);
	
	        // middle-left
	        this._drawControl('ml', ctx, methodName,
	          left,
	          top + height / 2, styleOverride);
	      }
	
	      // middle-top-rotate
	      if (hasRotatingPoint) {
	        this._drawControl('mtr', ctx, methodName,
	          left + width / 2,
	          top - this.rotatingPointOffset, styleOverride);
	      }
	
	      ctx.restore();
	
	      return this;
	    },
	
	    /**
	     * @private
	     */
	    _drawControl: function(control, ctx, methodName, left, top, styleOverride) {
	      styleOverride = styleOverride || {};
	      if (!this.isControlVisible(control)) {
	        return;
	      }
	      var size = this.cornerSize, stroke = !this.transparentCorners && this.cornerStrokeColor;
	      switch (styleOverride.cornerStyle || this.cornerStyle) {
	        case 'circle':
	          ctx.beginPath();
	          ctx.arc(left + size / 2, top + size / 2, size / 2, 0, 2 * Math.PI, false);
	          ctx[methodName]();
	          if (stroke) {
	            ctx.stroke();
	          }
	          break;
	        default:
	          this.transparentCorners || ctx.clearRect(left, top, size, size);
	          ctx[methodName + 'Rect'](left, top, size, size);
	          if (stroke) {
	            ctx.strokeRect(left, top, size, size);
	          }
	      }
	    },
	
	    /**
	     * Returns true if the specified control is visible, false otherwise.
	     * @param {String} controlName The name of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
	     * @returns {Boolean} true if the specified control is visible, false otherwise
	     */
	    isControlVisible: function(controlName) {
	      return this._getControlsVisibility()[controlName];
	    },
	
	    /**
	     * Sets the visibility of the specified control.
	     * @param {String} controlName The name of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
	     * @param {Boolean} visible true to set the specified control visible, false otherwise
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    setControlVisible: function(controlName, visible) {
	      this._getControlsVisibility()[controlName] = visible;
	      return this;
	    },
	
	    /**
	     * Sets the visibility state of object controls.
	     * @param {Object} [options] Options object
	     * @param {Boolean} [options.bl] true to enable the bottom-left control, false to disable it
	     * @param {Boolean} [options.br] true to enable the bottom-right control, false to disable it
	     * @param {Boolean} [options.mb] true to enable the middle-bottom control, false to disable it
	     * @param {Boolean} [options.ml] true to enable the middle-left control, false to disable it
	     * @param {Boolean} [options.mr] true to enable the middle-right control, false to disable it
	     * @param {Boolean} [options.mt] true to enable the middle-top control, false to disable it
	     * @param {Boolean} [options.tl] true to enable the top-left control, false to disable it
	     * @param {Boolean} [options.tr] true to enable the top-right control, false to disable it
	     * @param {Boolean} [options.mtr] true to enable the middle-top-rotate control, false to disable it
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    setControlsVisibility: function(options) {
	      options || (options = { });
	
	      for (var p in options) {
	        this.setControlVisible(p, options[p]);
	      }
	      return this;
	    },
	
	    /**
	     * Returns the instance of the control visibility set for this object.
	     * @private
	     * @returns {Object}
	     */
	    _getControlsVisibility: function() {
	      if (!this._controlsVisibility) {
	        this._controlsVisibility = {
	          tl: true,
	          tr: true,
	          br: true,
	          bl: true,
	          ml: true,
	          mt: true,
	          mr: true,
	          mb: true,
	          mtr: true
	        };
	      }
	      return this._controlsVisibility;
	    },
	
	    /**
	     * This callback function is called every time _discardActiveObject or _setActiveObject
	     * try to to deselect this object. If the function returns true, the process is cancelled
	     * @param {Object} [options] options sent from the upper functions
	     * @param {Event} [options.e] event if the process is generated by an event
	     */
	    onDeselect: function() {
	      // implemented by sub-classes, as needed.
	    },
	
	
	    /**
	     * This callback function is called every time _discardActiveObject or _setActiveObject
	     * try to to select this object. If the function returns true, the process is cancelled
	     * @param {Object} [options] options sent from the upper functions
	     * @param {Event} [options.e] event if the process is generated by an event
	     */
	    onSelect: function() {
	      // implemented by sub-classes, as needed.
	    }
	  });
	})();
	
	
	fabric.util.object.extend(fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {
	
	  /**
	   * Animation duration (in ms) for fx* methods
	   * @type Number
	   * @default
	   */
	  FX_DURATION: 500,
	
	  /**
	   * Centers object horizontally with animation.
	   * @param {fabric.Object} object Object to center
	   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
	   * @param {Function} [callbacks.onComplete] Invoked on completion
	   * @param {Function} [callbacks.onChange] Invoked on every step of animation
	   * @return {fabric.Canvas} thisArg
	   * @chainable
	   */
	  fxCenterObjectH: function (object, callbacks) {
	    callbacks = callbacks || { };
	
	    var empty = function() { },
	        onComplete = callbacks.onComplete || empty,
	        onChange = callbacks.onChange || empty,
	        _this = this;
	
	    fabric.util.animate({
	      startValue: object.left,
	      endValue: this.getCenter().left,
	      duration: this.FX_DURATION,
	      onChange: function(value) {
	        object.set('left', value);
	        _this.requestRenderAll();
	        onChange();
	      },
	      onComplete: function() {
	        object.setCoords();
	        onComplete();
	      }
	    });
	
	    return this;
	  },
	
	  /**
	   * Centers object vertically with animation.
	   * @param {fabric.Object} object Object to center
	   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
	   * @param {Function} [callbacks.onComplete] Invoked on completion
	   * @param {Function} [callbacks.onChange] Invoked on every step of animation
	   * @return {fabric.Canvas} thisArg
	   * @chainable
	   */
	  fxCenterObjectV: function (object, callbacks) {
	    callbacks = callbacks || { };
	
	    var empty = function() { },
	        onComplete = callbacks.onComplete || empty,
	        onChange = callbacks.onChange || empty,
	        _this = this;
	
	    fabric.util.animate({
	      startValue: object.top,
	      endValue: this.getCenter().top,
	      duration: this.FX_DURATION,
	      onChange: function(value) {
	        object.set('top', value);
	        _this.requestRenderAll();
	        onChange();
	      },
	      onComplete: function() {
	        object.setCoords();
	        onComplete();
	      }
	    });
	
	    return this;
	  },
	
	  /**
	   * Same as `fabric.Canvas#remove` but animated
	   * @param {fabric.Object} object Object to remove
	   * @param {Object} [callbacks] Callbacks object with optional "onComplete" and/or "onChange" properties
	   * @param {Function} [callbacks.onComplete] Invoked on completion
	   * @param {Function} [callbacks.onChange] Invoked on every step of animation
	   * @return {fabric.Canvas} thisArg
	   * @chainable
	   */
	  fxRemove: function (object, callbacks) {
	    callbacks = callbacks || { };
	
	    var empty = function() { },
	        onComplete = callbacks.onComplete || empty,
	        onChange = callbacks.onChange || empty,
	        _this = this;
	
	    fabric.util.animate({
	      startValue: object.opacity,
	      endValue: 0,
	      duration: this.FX_DURATION,
	      onChange: function(value) {
	        object.set('opacity', value);
	        _this.requestRenderAll();
	        onChange();
	      },
	      onComplete: function () {
	        _this.remove(object);
	        onComplete();
	      }
	    });
	
	    return this;
	  }
	});
	
	fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
	  /**
	   * Animates object's properties
	   * @param {String|Object} property Property to animate (if string) or properties to animate (if object)
	   * @param {Number|Object} value Value to animate property to (if string was given first) or options object
	   * @return {fabric.Object} thisArg
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#animation}
	   * @chainable
	   *
	   * As object — multiple properties
	   *
	   * object.animate({ left: ..., top: ... });
	   * object.animate({ left: ..., top: ... }, { duration: ... });
	   *
	   * As string — one property
	   *
	   * object.animate('left', ...);
	   * object.animate('left', { duration: ... });
	   *
	   */
	  animate: function() {
	    if (arguments[0] && typeof arguments[0] === 'object') {
	      var propsToAnimate = [], prop, skipCallbacks;
	      for (prop in arguments[0]) {
	        propsToAnimate.push(prop);
	      }
	      for (var i = 0, len = propsToAnimate.length; i < len; i++) {
	        prop = propsToAnimate[i];
	        skipCallbacks = i !== len - 1;
	        this._animate(prop, arguments[0][prop], arguments[1], skipCallbacks);
	      }
	    }
	    else {
	      this._animate.apply(this, arguments);
	    }
	    return this;
	  },
	
	  /**
	   * @private
	   * @param {String} property Property to animate
	   * @param {String} to Value to animate to
	   * @param {Object} [options] Options object
	   * @param {Boolean} [skipCallbacks] When true, callbacks like onchange and oncomplete are not invoked
	   */
	  _animate: function(property, to, options, skipCallbacks) {
	    var _this = this, propPair;
	
	    to = to.toString();
	
	    if (!options) {
	      options = { };
	    }
	    else {
	      options = fabric.util.object.clone(options);
	    }
	
	    if (~property.indexOf('.')) {
	      propPair = property.split('.');
	    }
	
	    var currentValue = propPair
	      ? this.get(propPair[0])[propPair[1]]
	      : this.get(property);
	
	    if (!('from' in options)) {
	      options.from = currentValue;
	    }
	
	    if (~to.indexOf('=')) {
	      to = currentValue + parseFloat(to.replace('=', ''));
	    }
	    else {
	      to = parseFloat(to);
	    }
	
	    fabric.util.animate({
	      startValue: options.from,
	      endValue: to,
	      byValue: options.by,
	      easing: options.easing,
	      duration: options.duration,
	      abort: options.abort && function() {
	        return options.abort.call(_this);
	      },
	      onChange: function(value, valueProgress, timeProgress) {
	        if (propPair) {
	          _this[propPair[0]][propPair[1]] = value;
	        }
	        else {
	          _this.set(property, value);
	        }
	        if (skipCallbacks) {
	          return;
	        }
	        options.onChange && options.onChange(value, valueProgress, timeProgress);
	      },
	      onComplete: function(value, valueProgress, timeProgress) {
	        if (skipCallbacks) {
	          return;
	        }
	
	        _this.setCoords();
	        options.onComplete && options.onComplete(value, valueProgress, timeProgress);
	      }
	    });
	  }
	});
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric = global.fabric || (global.fabric = { }),
	      extend = fabric.util.object.extend,
	      clone = fabric.util.object.clone,
	      coordProps = { x1: 1, x2: 1, y1: 1, y2: 1 },
	      supportsLineDash = fabric.StaticCanvas.supports('setLineDash');
	
	  if (fabric.Line) {
	    fabric.warn('fabric.Line is already defined');
	    return;
	  }
	
	  /**
	   * Line class
	   * @class fabric.Line
	   * @extends fabric.Object
	   * @see {@link fabric.Line#initialize} for constructor definition
	   */
	  fabric.Line = fabric.util.createClass(fabric.Object, /** @lends fabric.Line.prototype */ {
	
	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'line',
	
	    /**
	     * x value or first line edge
	     * @type Number
	     * @default
	     */
	    x1: 0,
	
	    /**
	     * y value or first line edge
	     * @type Number
	     * @default
	     */
	    y1: 0,
	
	    /**
	     * x value or second line edge
	     * @type Number
	     * @default
	     */
	    x2: 0,
	
	    /**
	     * y value or second line edge
	     * @type Number
	     * @default
	     */
	    y2: 0,
	
	    cacheProperties: fabric.Object.prototype.cacheProperties.concat('x1', 'x2', 'y1', 'y2'),
	
	    /**
	     * Constructor
	     * @param {Array} [points] Array of points
	     * @param {Object} [options] Options object
	     * @return {fabric.Line} thisArg
	     */
	    initialize: function(points, options) {
	      if (!points) {
	        points = [0, 0, 0, 0];
	      }
	
	      this.callSuper('initialize', options);
	
	      this.set('x1', points[0]);
	      this.set('y1', points[1]);
	      this.set('x2', points[2]);
	      this.set('y2', points[3]);
	
	      this._setWidthHeight(options);
	    },
	
	    /**
	     * @private
	     * @param {Object} [options] Options
	     */
	    _setWidthHeight: function(options) {
	      options || (options = { });
	
	      this.width = Math.abs(this.x2 - this.x1);
	      this.height = Math.abs(this.y2 - this.y1);
	
	      this.left = 'left' in options
	        ? options.left
	        : this._getLeftToOriginX();
	
	      this.top = 'top' in options
	        ? options.top
	        : this._getTopToOriginY();
	    },
	
	    /**
	     * @private
	     * @param {String} key
	     * @param {*} value
	     */
	    _set: function(key, value) {
	      this.callSuper('_set', key, value);
	      if (typeof coordProps[key] !== 'undefined') {
	        this._setWidthHeight();
	      }
	      return this;
	    },
	
	    /**
	     * @private
	     * @return {Number} leftToOriginX Distance from left edge of canvas to originX of Line.
	     */
	    _getLeftToOriginX: makeEdgeToOriginGetter(
	      { // property names
	        origin: 'originX',
	        axis1: 'x1',
	        axis2: 'x2',
	        dimension: 'width'
	      },
	      { // possible values of origin
	        nearest: 'left',
	        center: 'center',
	        farthest: 'right'
	      }
	    ),
	
	    /**
	     * @private
	     * @return {Number} topToOriginY Distance from top edge of canvas to originY of Line.
	     */
	    _getTopToOriginY: makeEdgeToOriginGetter(
	      { // property names
	        origin: 'originY',
	        axis1: 'y1',
	        axis2: 'y2',
	        dimension: 'height'
	      },
	      { // possible values of origin
	        nearest: 'top',
	        center: 'center',
	        farthest: 'bottom'
	      }
	    ),
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _render: function(ctx) {
	      ctx.beginPath();
	
	      if (!this.strokeDashArray || this.strokeDashArray && supportsLineDash) {
	        // move from center (of virtual box) to its left/top corner
	        // we can't assume x1, y1 is top left and x2, y2 is bottom right
	        var p = this.calcLinePoints();
	        ctx.moveTo(p.x1, p.y1);
	        ctx.lineTo(p.x2, p.y2);
	      }
	
	      ctx.lineWidth = this.strokeWidth;
	
	      // TODO: test this
	      // make sure setting "fill" changes color of a line
	      // (by copying fillStyle to strokeStyle, since line is stroked, not filled)
	      var origStrokeStyle = ctx.strokeStyle;
	      ctx.strokeStyle = this.stroke || ctx.fillStyle;
	      this.stroke && this._renderStroke(ctx);
	      ctx.strokeStyle = origStrokeStyle;
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderDashedStroke: function(ctx) {
	      var p = this.calcLinePoints();
	
	      ctx.beginPath();
	      fabric.util.drawDashedLine(ctx, p.x1, p.y1, p.x2, p.y2, this.strokeDashArray);
	      ctx.closePath();
	    },
	
	    /**
	     * This function is an helper for svg import. it returns the center of the object in the svg
	     * untransformed coordinates
	     * @private
	     * @return {Object} center point from element coordinates
	     */
	    _findCenterFromElement: function() {
	      return {
	        x: (this.x1 + this.x2) / 2,
	        y: (this.y1 + this.y2) / 2,
	      };
	    },
	
	    /**
	     * Returns object representation of an instance
	     * @methd toObject
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      return extend(this.callSuper('toObject', propertiesToInclude), this.calcLinePoints());
	    },
	
	    /*
	     * Calculate object dimensions from its properties
	     * @private
	     */
	    _getNonTransformedDimensions: function() {
	      var dim = this.callSuper('_getNonTransformedDimensions');
	      if (this.strokeLineCap === 'butt') {
	        if (this.width === 0) {
	          dim.y -= this.strokeWidth;
	        }
	        if (this.height === 0) {
	          dim.x -= this.strokeWidth;
	        }
	      }
	      return dim;
	    },
	
	    /**
	     * Recalculates line points given width and height
	     * @private
	     */
	    calcLinePoints: function() {
	      var xMult = this.x1 <= this.x2 ? -1 : 1,
	          yMult = this.y1 <= this.y2 ? -1 : 1,
	          x1 = (xMult * this.width * 0.5),
	          y1 = (yMult * this.height * 0.5),
	          x2 = (xMult * this.width * -0.5),
	          y2 = (yMult * this.height * -0.5);
	
	      return {
	        x1: x1,
	        x2: x2,
	        y1: y1,
	        y2: y2
	      };
	    },
	
	    /* _TO_SVG_START_ */
	    /**
	     * Returns svg representation of an instance
	     * @return {Array} an array of strings with the specific svg representation
	     * of the instance
	     */
	    _toSVG: function() {
	      var p = this.calcLinePoints();
	      return [
	        '<line ', 'COMMON_PARTS',
	        'x1="', p.x1,
	        '" y1="', p.y1,
	        '" x2="', p.x2,
	        '" y2="', p.y2,
	        '" />\n'
	      ];
	    },
	    /* _TO_SVG_END_ */
	  });
	
	  /* _FROM_SVG_START_ */
	  /**
	   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Line.fromElement})
	   * @static
	   * @memberOf fabric.Line
	   * @see http://www.w3.org/TR/SVG/shapes.html#LineElement
	   */
	  fabric.Line.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('x1 y1 x2 y2'.split(' '));
	
	  /**
	   * Returns fabric.Line instance from an SVG element
	   * @static
	   * @memberOf fabric.Line
	   * @param {SVGElement} element Element to parse
	   * @param {Object} [options] Options object
	   * @param {Function} [callback] callback function invoked after parsing
	   */
	  fabric.Line.fromElement = function(element, callback, options) {
	    options = options || { };
	    var parsedAttributes = fabric.parseAttributes(element, fabric.Line.ATTRIBUTE_NAMES),
	        points = [
	          parsedAttributes.x1 || 0,
	          parsedAttributes.y1 || 0,
	          parsedAttributes.x2 || 0,
	          parsedAttributes.y2 || 0
	        ];
	    callback(new fabric.Line(points, extend(parsedAttributes, options)));
	  };
	  /* _FROM_SVG_END_ */
	
	  /**
	   * Returns fabric.Line instance from an object representation
	   * @static
	   * @memberOf fabric.Line
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] invoked with new instance as first argument
	   */
	  fabric.Line.fromObject = function(object, callback) {
	    function _callback(instance) {
	      delete instance.points;
	      callback && callback(instance);
	    };
	    var options = clone(object, true);
	    options.points = [object.x1, object.y1, object.x2, object.y2];
	    fabric.Object._fromObject('Line', options, _callback, 'points');
	  };
	
	  /**
	   * Produces a function that calculates distance from canvas edge to Line origin.
	   */
	  function makeEdgeToOriginGetter(propertyNames, originValues) {
	    var origin = propertyNames.origin,
	        axis1 = propertyNames.axis1,
	        axis2 = propertyNames.axis2,
	        dimension = propertyNames.dimension,
	        nearest = originValues.nearest,
	        center = originValues.center,
	        farthest = originValues.farthest;
	
	    return function() {
	      switch (this.get(origin)) {
	        case nearest:
	          return Math.min(this.get(axis1), this.get(axis2));
	        case center:
	          return Math.min(this.get(axis1), this.get(axis2)) + (0.5 * this.get(dimension));
	        case farthest:
	          return Math.max(this.get(axis1), this.get(axis2));
	      }
	    };
	
	  }
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric = global.fabric || (global.fabric = { }),
	      pi = Math.PI;
	
	  if (fabric.Circle) {
	    fabric.warn('fabric.Circle is already defined.');
	    return;
	  }
	
	  /**
	   * Circle class
	   * @class fabric.Circle
	   * @extends fabric.Object
	   * @see {@link fabric.Circle#initialize} for constructor definition
	   */
	  fabric.Circle = fabric.util.createClass(fabric.Object, /** @lends fabric.Circle.prototype */ {
	
	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'circle',
	
	    /**
	     * Radius of this circle
	     * @type Number
	     * @default
	     */
	    radius: 0,
	
	    /**
	     * Start angle of the circle, moving clockwise
	     * deprectated type, this should be in degree, this was an oversight.
	     * probably will change to degrees in next major version
	     * @type Number
	     * @default 0
	     */
	    startAngle: 0,
	
	    /**
	     * End angle of the circle
	     * deprectated type, this should be in degree, this was an oversight.
	     * probably will change to degrees in next major version
	     * @type Number
	     * @default 2Pi
	     */
	    endAngle: pi * 2,
	
	    cacheProperties: fabric.Object.prototype.cacheProperties.concat('radius', 'startAngle', 'endAngle'),
	
	    /**
	     * @private
	     * @param {String} key
	     * @param {*} value
	     * @return {fabric.Circle} thisArg
	     */
	    _set: function(key, value) {
	      this.callSuper('_set', key, value);
	
	      if (key === 'radius') {
	        this.setRadius(value);
	      }
	
	      return this;
	    },
	
	    /**
	     * Returns object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      return this.callSuper('toObject', ['radius', 'startAngle', 'endAngle'].concat(propertiesToInclude));
	    },
	
	    /* _TO_SVG_START_ */
	
	    /**
	     * Returns svg representation of an instance
	     * @return {Array} an array of strings with the specific svg representation
	     * of the instance
	     */
	    _toSVG: function() {
	      var svgString, x = 0, y = 0,
	          angle = (this.endAngle - this.startAngle) % ( 2 * pi);
	
	      if (angle === 0) {
	        svgString = [
	          '<circle ', 'COMMON_PARTS',
	          'cx="' + x + '" cy="' + y + '" ',
	          'r="', this.radius,
	          '" />\n'
	        ];
	      }
	      else {
	        var startX = fabric.util.cos(this.startAngle) * this.radius,
	            startY = fabric.util.sin(this.startAngle) * this.radius,
	            endX = fabric.util.cos(this.endAngle) * this.radius,
	            endY = fabric.util.sin(this.endAngle) * this.radius,
	            largeFlag = angle > pi ? '1' : '0';
	        svgString = [
	          '<path d="M ' + startX + ' ' + startY,
	          ' A ' + this.radius + ' ' + this.radius,
	          ' 0 ', +largeFlag + ' 1', ' ' + endX + ' ' + endY,
	          '" ', 'COMMON_PARTS', ' />\n'
	        ];
	      }
	      return svgString;
	    },
	    /* _TO_SVG_END_ */
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx context to render on
	     */
	    _render: function(ctx) {
	      ctx.beginPath();
	      ctx.arc(
	        0,
	        0,
	        this.radius,
	        this.startAngle,
	        this.endAngle, false);
	      this._renderPaintInOrder(ctx);
	    },
	
	    /**
	     * Returns horizontal radius of an object (according to how an object is scaled)
	     * @return {Number}
	     */
	    getRadiusX: function() {
	      return this.get('radius') * this.get('scaleX');
	    },
	
	    /**
	     * Returns vertical radius of an object (according to how an object is scaled)
	     * @return {Number}
	     */
	    getRadiusY: function() {
	      return this.get('radius') * this.get('scaleY');
	    },
	
	    /**
	     * Sets radius of an object (and updates width accordingly)
	     * @return {fabric.Circle} thisArg
	     */
	    setRadius: function(value) {
	      this.radius = value;
	      return this.set('width', value * 2).set('height', value * 2);
	    },
	  });
	
	  /* _FROM_SVG_START_ */
	  /**
	   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Circle.fromElement})
	   * @static
	   * @memberOf fabric.Circle
	   * @see: http://www.w3.org/TR/SVG/shapes.html#CircleElement
	   */
	  fabric.Circle.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('cx cy r'.split(' '));
	
	  /**
	   * Returns {@link fabric.Circle} instance from an SVG element
	   * @static
	   * @memberOf fabric.Circle
	   * @param {SVGElement} element Element to parse
	   * @param {Function} [callback] Options callback invoked after parsing is finished
	   * @param {Object} [options] Options object
	   * @throws {Error} If value of `r` attribute is missing or invalid
	   */
	  fabric.Circle.fromElement = function(element, callback) {
	    var parsedAttributes = fabric.parseAttributes(element, fabric.Circle.ATTRIBUTE_NAMES);
	
	    if (!isValidRadius(parsedAttributes)) {
	      throw new Error('value of `r` attribute is required and can not be negative');
	    }
	
	    parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.radius;
	    parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.radius;
	    callback(new fabric.Circle(parsedAttributes));
	  };
	
	  /**
	   * @private
	   */
	  function isValidRadius(attributes) {
	    return (('radius' in attributes) && (attributes.radius >= 0));
	  }
	  /* _FROM_SVG_END_ */
	
	  /**
	   * Returns {@link fabric.Circle} instance from an object representation
	   * @static
	   * @memberOf fabric.Circle
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] invoked with new instance as first argument
	   * @return {Object} Instance of fabric.Circle
	   */
	  fabric.Circle.fromObject = function(object, callback) {
	    return fabric.Object._fromObject('Circle', object, callback);
	  };
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric = global.fabric || (global.fabric = { });
	
	  if (fabric.Triangle) {
	    fabric.warn('fabric.Triangle is already defined');
	    return;
	  }
	
	  /**
	   * Triangle class
	   * @class fabric.Triangle
	   * @extends fabric.Object
	   * @return {fabric.Triangle} thisArg
	   * @see {@link fabric.Triangle#initialize} for constructor definition
	   */
	  fabric.Triangle = fabric.util.createClass(fabric.Object, /** @lends fabric.Triangle.prototype */ {
	
	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'triangle',
	
	    /**
	     * Width is set to 100 to compensate the old initialize code that was setting it to 100
	     * @type Number
	     * @default
	     */
	    width: 100,
	
	    /**
	     * Height is set to 100 to compensate the old initialize code that was setting it to 100
	     * @type Number
	     * @default
	     */
	    height: 100,
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _render: function(ctx) {
	      var widthBy2 = this.width / 2,
	          heightBy2 = this.height / 2;
	
	      ctx.beginPath();
	      ctx.moveTo(-widthBy2, heightBy2);
	      ctx.lineTo(0, -heightBy2);
	      ctx.lineTo(widthBy2, heightBy2);
	      ctx.closePath();
	
	      this._renderPaintInOrder(ctx);
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderDashedStroke: function(ctx) {
	      var widthBy2 = this.width / 2,
	          heightBy2 = this.height / 2;
	
	      ctx.beginPath();
	      fabric.util.drawDashedLine(ctx, -widthBy2, heightBy2, 0, -heightBy2, this.strokeDashArray);
	      fabric.util.drawDashedLine(ctx, 0, -heightBy2, widthBy2, heightBy2, this.strokeDashArray);
	      fabric.util.drawDashedLine(ctx, widthBy2, heightBy2, -widthBy2, heightBy2, this.strokeDashArray);
	      ctx.closePath();
	    },
	
	    /* _TO_SVG_START_ */
	    /**
	     * Returns svg representation of an instance
	     * @return {Array} an array of strings with the specific svg representation
	     * of the instance
	     */
	    _toSVG: function() {
	      var widthBy2 = this.width / 2,
	          heightBy2 = this.height / 2,
	          points = [
	            -widthBy2 + ' ' + heightBy2,
	            '0 ' + -heightBy2,
	            widthBy2 + ' ' + heightBy2
	          ].join(',');
	      return [
	        '<polygon ', 'COMMON_PARTS',
	        'points="', points,
	        '" />'
	      ];
	    },
	    /* _TO_SVG_END_ */
	  });
	
	  /**
	   * Returns {@link fabric.Triangle} instance from an object representation
	   * @static
	   * @memberOf fabric.Triangle
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] invoked with new instance as first argument
	   */
	  fabric.Triangle.fromObject = function(object, callback) {
	    return fabric.Object._fromObject('Triangle', object, callback);
	  };
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric = global.fabric || (global.fabric = { }),
	      piBy2   = Math.PI * 2;
	
	  if (fabric.Ellipse) {
	    fabric.warn('fabric.Ellipse is already defined.');
	    return;
	  }
	
	  /**
	   * Ellipse class
	   * @class fabric.Ellipse
	   * @extends fabric.Object
	   * @return {fabric.Ellipse} thisArg
	   * @see {@link fabric.Ellipse#initialize} for constructor definition
	   */
	  fabric.Ellipse = fabric.util.createClass(fabric.Object, /** @lends fabric.Ellipse.prototype */ {
	
	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'ellipse',
	
	    /**
	     * Horizontal radius
	     * @type Number
	     * @default
	     */
	    rx:   0,
	
	    /**
	     * Vertical radius
	     * @type Number
	     * @default
	     */
	    ry:   0,
	
	    cacheProperties: fabric.Object.prototype.cacheProperties.concat('rx', 'ry'),
	
	    /**
	     * Constructor
	     * @param {Object} [options] Options object
	     * @return {fabric.Ellipse} thisArg
	     */
	    initialize: function(options) {
	      this.callSuper('initialize', options);
	      this.set('rx', options && options.rx || 0);
	      this.set('ry', options && options.ry || 0);
	    },
	
	    /**
	     * @private
	     * @param {String} key
	     * @param {*} value
	     * @return {fabric.Ellipse} thisArg
	     */
	    _set: function(key, value) {
	      this.callSuper('_set', key, value);
	      switch (key) {
	
	        case 'rx':
	          this.rx = value;
	          this.set('width', value * 2);
	          break;
	
	        case 'ry':
	          this.ry = value;
	          this.set('height', value * 2);
	          break;
	
	      }
	      return this;
	    },
	
	    /**
	     * Returns horizontal radius of an object (according to how an object is scaled)
	     * @return {Number}
	     */
	    getRx: function() {
	      return this.get('rx') * this.get('scaleX');
	    },
	
	    /**
	     * Returns Vertical radius of an object (according to how an object is scaled)
	     * @return {Number}
	     */
	    getRy: function() {
	      return this.get('ry') * this.get('scaleY');
	    },
	
	    /**
	     * Returns object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      return this.callSuper('toObject', ['rx', 'ry'].concat(propertiesToInclude));
	    },
	
	    /* _TO_SVG_START_ */
	    /**
	     * Returns svg representation of an instance
	     * @return {Array} an array of strings with the specific svg representation
	     * of the instance
	     */
	    _toSVG: function() {
	      return [
	        '<ellipse ', 'COMMON_PARTS',
	        'cx="0" cy="0" ',
	        'rx="', this.rx,
	        '" ry="', this.ry,
	        '" />\n'
	      ];
	    },
	    /* _TO_SVG_END_ */
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx context to render on
	     */
	    _render: function(ctx) {
	      ctx.beginPath();
	      ctx.save();
	      ctx.transform(1, 0, 0, this.ry / this.rx, 0, 0);
	      ctx.arc(
	        0,
	        0,
	        this.rx,
	        0,
	        piBy2,
	        false);
	      ctx.restore();
	      this._renderPaintInOrder(ctx);
	    },
	  });
	
	  /* _FROM_SVG_START_ */
	  /**
	   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Ellipse.fromElement})
	   * @static
	   * @memberOf fabric.Ellipse
	   * @see http://www.w3.org/TR/SVG/shapes.html#EllipseElement
	   */
	  fabric.Ellipse.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('cx cy rx ry'.split(' '));
	
	  /**
	   * Returns {@link fabric.Ellipse} instance from an SVG element
	   * @static
	   * @memberOf fabric.Ellipse
	   * @param {SVGElement} element Element to parse
	   * @param {Function} [callback] Options callback invoked after parsing is finished
	   * @return {fabric.Ellipse}
	   */
	  fabric.Ellipse.fromElement = function(element, callback) {
	
	    var parsedAttributes = fabric.parseAttributes(element, fabric.Ellipse.ATTRIBUTE_NAMES);
	
	    parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.rx;
	    parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.ry;
	    callback(new fabric.Ellipse(parsedAttributes));
	  };
	  /* _FROM_SVG_END_ */
	
	  /**
	   * Returns {@link fabric.Ellipse} instance from an object representation
	   * @static
	   * @memberOf fabric.Ellipse
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] invoked with new instance as first argument
	   * @return {fabric.Ellipse}
	   */
	  fabric.Ellipse.fromObject = function(object, callback) {
	    return fabric.Object._fromObject('Ellipse', object, callback);
	  };
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric = global.fabric || (global.fabric = { }),
	      extend = fabric.util.object.extend;
	
	  if (fabric.Rect) {
	    fabric.warn('fabric.Rect is already defined');
	    return;
	  }
	
	  /**
	   * Rectangle class
	   * @class fabric.Rect
	   * @extends fabric.Object
	   * @return {fabric.Rect} thisArg
	   * @see {@link fabric.Rect#initialize} for constructor definition
	   */
	  fabric.Rect = fabric.util.createClass(fabric.Object, /** @lends fabric.Rect.prototype */ {
	
	    /**
	     * List of properties to consider when checking if state of an object is changed ({@link fabric.Object#hasStateChanged})
	     * as well as for history (undo/redo) purposes
	     * @type Array
	     */
	    stateProperties: fabric.Object.prototype.stateProperties.concat('rx', 'ry'),
	
	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'rect',
	
	    /**
	     * Horizontal border radius
	     * @type Number
	     * @default
	     */
	    rx:   0,
	
	    /**
	     * Vertical border radius
	     * @type Number
	     * @default
	     */
	    ry:   0,
	
	    cacheProperties: fabric.Object.prototype.cacheProperties.concat('rx', 'ry'),
	
	    /**
	     * Constructor
	     * @param {Object} [options] Options object
	     * @return {Object} thisArg
	     */
	    initialize: function(options) {
	      this.callSuper('initialize', options);
	      this._initRxRy();
	    },
	
	    /**
	     * Initializes rx/ry attributes
	     * @private
	     */
	    _initRxRy: function() {
	      if (this.rx && !this.ry) {
	        this.ry = this.rx;
	      }
	      else if (this.ry && !this.rx) {
	        this.rx = this.ry;
	      }
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _render: function(ctx) {
	
	      // 1x1 case (used in spray brush) optimization was removed because
	      // with caching and higher zoom level this makes more damage than help
	
	      var rx = this.rx ? Math.min(this.rx, this.width / 2) : 0,
	          ry = this.ry ? Math.min(this.ry, this.height / 2) : 0,
	          w = this.width,
	          h = this.height,
	          x = -this.width / 2,
	          y = -this.height / 2,
	          isRounded = rx !== 0 || ry !== 0,
	          /* "magic number" for bezier approximations of arcs (http://itc.ktu.lt/itc354/Riskus354.pdf) */
	          k = 1 - 0.5522847498;
	      ctx.beginPath();
	
	      ctx.moveTo(x + rx, y);
	
	      ctx.lineTo(x + w - rx, y);
	      isRounded && ctx.bezierCurveTo(x + w - k * rx, y, x + w, y + k * ry, x + w, y + ry);
	
	      ctx.lineTo(x + w, y + h - ry);
	      isRounded && ctx.bezierCurveTo(x + w, y + h - k * ry, x + w - k * rx, y + h, x + w - rx, y + h);
	
	      ctx.lineTo(x + rx, y + h);
	      isRounded && ctx.bezierCurveTo(x + k * rx, y + h, x, y + h - k * ry, x, y + h - ry);
	
	      ctx.lineTo(x, y + ry);
	      isRounded && ctx.bezierCurveTo(x, y + k * ry, x + k * rx, y, x + rx, y);
	
	      ctx.closePath();
	
	      this._renderPaintInOrder(ctx);
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderDashedStroke: function(ctx) {
	      var x = -this.width / 2,
	          y = -this.height / 2,
	          w = this.width,
	          h = this.height;
	
	      ctx.beginPath();
	      fabric.util.drawDashedLine(ctx, x, y, x + w, y, this.strokeDashArray);
	      fabric.util.drawDashedLine(ctx, x + w, y, x + w, y + h, this.strokeDashArray);
	      fabric.util.drawDashedLine(ctx, x + w, y + h, x, y + h, this.strokeDashArray);
	      fabric.util.drawDashedLine(ctx, x, y + h, x, y, this.strokeDashArray);
	      ctx.closePath();
	    },
	
	    /**
	     * Returns object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      return this.callSuper('toObject', ['rx', 'ry'].concat(propertiesToInclude));
	    },
	
	    /* _TO_SVG_START_ */
	    /**
	     * Returns svg representation of an instance
	     * @return {Array} an array of strings with the specific svg representation
	     * of the instance
	     */
	    _toSVG: function() {
	      var x = -this.width / 2, y = -this.height / 2;
	      return [
	        '<rect ', 'COMMON_PARTS',
	        'x="', x, '" y="', y,
	        '" rx="', this.rx, '" ry="', this.ry,
	        '" width="', this.width, '" height="', this.height,
	        '" />\n'
	      ];
	    },
	    /* _TO_SVG_END_ */
	  });
	
	  /* _FROM_SVG_START_ */
	  /**
	   * List of attribute names to account for when parsing SVG element (used by `fabric.Rect.fromElement`)
	   * @static
	   * @memberOf fabric.Rect
	   * @see: http://www.w3.org/TR/SVG/shapes.html#RectElement
	   */
	  fabric.Rect.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat('x y rx ry width height'.split(' '));
	
	  /**
	   * Returns {@link fabric.Rect} instance from an SVG element
	   * @static
	   * @memberOf fabric.Rect
	   * @param {SVGElement} element Element to parse
	   * @param {Function} callback callback function invoked after parsing
	   * @param {Object} [options] Options object
	   */
	  fabric.Rect.fromElement = function(element, callback, options) {
	    if (!element) {
	      return callback(null);
	    }
	    options = options || { };
	
	    var parsedAttributes = fabric.parseAttributes(element, fabric.Rect.ATTRIBUTE_NAMES);
	
	    parsedAttributes.left = parsedAttributes.left || 0;
	    parsedAttributes.top  = parsedAttributes.top  || 0;
	    parsedAttributes.height  = parsedAttributes.height || 0;
	    parsedAttributes.width  = parsedAttributes.width || 0;
	    var rect = new fabric.Rect(extend((options ? fabric.util.object.clone(options) : { }), parsedAttributes));
	    rect.visible = rect.visible && rect.width > 0 && rect.height > 0;
	    callback(rect);
	  };
	  /* _FROM_SVG_END_ */
	
	  /**
	   * Returns {@link fabric.Rect} instance from an object representation
	   * @static
	   * @memberOf fabric.Rect
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] Callback to invoke when an fabric.Rect instance is created
	   */
	  fabric.Rect.fromObject = function(object, callback) {
	    return fabric.Object._fromObject('Rect', object, callback);
	  };
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric = global.fabric || (global.fabric = { }),
	      extend = fabric.util.object.extend,
	      min = fabric.util.array.min,
	      max = fabric.util.array.max,
	      toFixed = fabric.util.toFixed;
	
	  if (fabric.Polyline) {
	    fabric.warn('fabric.Polyline is already defined');
	    return;
	  }
	
	  /**
	   * Polyline class
	   * @class fabric.Polyline
	   * @extends fabric.Object
	   * @see {@link fabric.Polyline#initialize} for constructor definition
	   */
	  fabric.Polyline = fabric.util.createClass(fabric.Object, /** @lends fabric.Polyline.prototype */ {
	
	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'polyline',
	
	    /**
	     * Points array
	     * @type Array
	     * @default
	     */
	    points: null,
	
	    cacheProperties: fabric.Object.prototype.cacheProperties.concat('points'),
	
	    /**
	     * Constructor
	     * @param {Array} points Array of points (where each point is an object with x and y)
	     * @param {Object} [options] Options object
	     * @return {fabric.Polyline} thisArg
	     * @example
	     * var poly = new fabric.Polyline([
	     *     { x: 10, y: 10 },
	     *     { x: 50, y: 30 },
	     *     { x: 40, y: 70 },
	     *     { x: 60, y: 50 },
	     *     { x: 100, y: 150 },
	     *     { x: 40, y: 100 }
	     *   ], {
	     *   stroke: 'red',
	     *   left: 100,
	     *   top: 100
	     * });
	     */
	    initialize: function(points, options) {
	      options = options || {};
	      this.points = points || [];
	      this.callSuper('initialize', options);
	      this._setPositionDimensions(options);
	    },
	
	    _setPositionDimensions: function(options) {
	      var calcDim = this._calcDimensions(options), correctLeftTop;
	      this.width = calcDim.width;
	      this.height = calcDim.height;
	      if (!options.fromSVG) {
	        correctLeftTop = this.translateToGivenOrigin(
	          { x: calcDim.left - this.strokeWidth / 2, y: calcDim.top - this.strokeWidth / 2 },
	          'left',
	          'top',
	          this.originX,
	          this.originY
	        );
	      }
	      if (typeof options.left === 'undefined') {
	        this.left = options.fromSVG ? calcDim.left : correctLeftTop.x;
	      }
	      if (typeof options.top === 'undefined') {
	        this.top = options.fromSVG ? calcDim.top : correctLeftTop.y;
	      }
	      this.pathOffset = {
	        x: calcDim.left + this.width / 2,
	        y: calcDim.top + this.height / 2
	      };
	    },
	
	    /**
	     * Calculate the polygon min and max point from points array,
	     * returning an object with left, top, widht, height to measure the
	     * polygon size
	     * @return {Object} object.left X coordinate of the polygon leftmost point
	     * @return {Object} object.top Y coordinate of the polygon topmost point
	     * @return {Object} object.width distance between X coordinates of the polygon leftmost and rightmost point
	     * @return {Object} object.height distance between Y coordinates of the polygon topmost and bottommost point
	     * @private
	     */
	    _calcDimensions: function() {
	
	      var points = this.points,
	          minX = min(points, 'x') || 0,
	          minY = min(points, 'y') || 0,
	          maxX = max(points, 'x') || 0,
	          maxY = max(points, 'y') || 0,
	          width = (maxX - minX),
	          height = (maxY - minY);
	
	      return {
	        left: minX,
	        top: minY,
	        width: width,
	        height: height
	      };
	    },
	
	    /**
	     * Returns object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      return extend(this.callSuper('toObject', propertiesToInclude), {
	        points: this.points.concat()
	      });
	    },
	
	    /* _TO_SVG_START_ */
	    /**
	     * Returns svg representation of an instance
	     * @return {Array} an array of strings with the specific svg representation
	     * of the instance
	     */
	    _toSVG: function() {
	      var points = [], diffX = this.pathOffset.x, diffY = this.pathOffset.y,
	          NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;
	
	      for (var i = 0, len = this.points.length; i < len; i++) {
	        points.push(
	          toFixed(this.points[i].x - diffX, NUM_FRACTION_DIGITS), ',',
	          toFixed(this.points[i].y - diffY, NUM_FRACTION_DIGITS), ' '
	        );
	      }
	      return [
	        '<' + this.type + ' ', 'COMMON_PARTS',
	        'points="', points.join(''),
	        '" />\n'
	      ];
	    },
	    /* _TO_SVG_END_ */
	
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    commonRender: function(ctx) {
	      var point, len = this.points.length,
	          x = this.pathOffset.x,
	          y = this.pathOffset.y;
	
	      if (!len || isNaN(this.points[len - 1].y)) {
	        // do not draw if no points or odd points
	        // NaN comes from parseFloat of a empty string in parser
	        return false;
	      }
	      ctx.beginPath();
	      ctx.moveTo(this.points[0].x - x, this.points[0].y - y);
	      for (var i = 0; i < len; i++) {
	        point = this.points[i];
	        ctx.lineTo(point.x - x, point.y - y);
	      }
	      return true;
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _render: function(ctx) {
	      if (!this.commonRender(ctx)) {
	        return;
	      }
	      this._renderPaintInOrder(ctx);
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderDashedStroke: function(ctx) {
	      var p1, p2;
	
	      ctx.beginPath();
	      for (var i = 0, len = this.points.length; i < len; i++) {
	        p1 = this.points[i];
	        p2 = this.points[i + 1] || p1;
	        fabric.util.drawDashedLine(ctx, p1.x, p1.y, p2.x, p2.y, this.strokeDashArray);
	      }
	    },
	
	    /**
	     * Returns complexity of an instance
	     * @return {Number} complexity of this instance
	     */
	    complexity: function() {
	      return this.get('points').length;
	    }
	  });
	
	  /* _FROM_SVG_START_ */
	  /**
	   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Polyline.fromElement})
	   * @static
	   * @memberOf fabric.Polyline
	   * @see: http://www.w3.org/TR/SVG/shapes.html#PolylineElement
	   */
	  fabric.Polyline.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat();
	
	  /**
	   * Returns fabric.Polyline instance from an SVG element
	   * @static
	   * @memberOf fabric.Polyline
	   * @param {SVGElement} element Element to parser
	   * @param {Function} callback callback function invoked after parsing
	   * @param {Object} [options] Options object
	   */
	  fabric.Polyline.fromElementGenerator = function(_class) {
	    return function(element, callback, options) {
	      if (!element) {
	        return callback(null);
	      }
	      options || (options = { });
	
	      var points = fabric.parsePointsAttribute(element.getAttribute('points')),
	          parsedAttributes = fabric.parseAttributes(element, fabric[_class].ATTRIBUTE_NAMES);
	      parsedAttributes.fromSVG = true;
	      callback(new fabric[_class](points, extend(parsedAttributes, options)));
	    };
	  };
	
	  fabric.Polyline.fromElement = fabric.Polyline.fromElementGenerator('Polyline');
	
	  /* _FROM_SVG_END_ */
	
	  /**
	   * Returns fabric.Polyline instance from an object representation
	   * @static
	   * @memberOf fabric.Polyline
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
	   */
	  fabric.Polyline.fromObject = function(object, callback) {
	    return fabric.Object._fromObject('Polyline', object, callback, 'points');
	  };
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric = global.fabric || (global.fabric = { });
	
	  if (fabric.Polygon) {
	    fabric.warn('fabric.Polygon is already defined');
	    return;
	  }
	
	  /**
	   * Polygon class
	   * @class fabric.Polygon
	   * @extends fabric.Polyline
	   * @see {@link fabric.Polygon#initialize} for constructor definition
	   */
	  fabric.Polygon = fabric.util.createClass(fabric.Polyline, /** @lends fabric.Polygon.prototype */ {
	
	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'polygon',
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _render: function(ctx) {
	      if (!this.commonRender(ctx)) {
	        return;
	      }
	      ctx.closePath();
	      this._renderPaintInOrder(ctx);
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderDashedStroke: function(ctx) {
	      this.callSuper('_renderDashedStroke', ctx);
	      ctx.closePath();
	    },
	  });
	
	  /* _FROM_SVG_START_ */
	  /**
	   * List of attribute names to account for when parsing SVG element (used by `fabric.Polygon.fromElement`)
	   * @static
	   * @memberOf fabric.Polygon
	   * @see: http://www.w3.org/TR/SVG/shapes.html#PolygonElement
	   */
	  fabric.Polygon.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat();
	
	  /**
	   * Returns {@link fabric.Polygon} instance from an SVG element
	   * @static
	   * @memberOf fabric.Polygon
	   * @param {SVGElement} element Element to parse
	   * @param {Function} callback callback function invoked after parsing
	   * @param {Object} [options] Options object
	   */
	  fabric.Polygon.fromElement = fabric.Polyline.fromElementGenerator('Polygon');
	  /* _FROM_SVG_END_ */
	
	  /**
	   * Returns fabric.Polygon instance from an object representation
	   * @static
	   * @memberOf fabric.Polygon
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
	   */
	  fabric.Polygon.fromObject = function(object, callback) {
	    return fabric.Object._fromObject('Polygon', object, callback, 'points');
	  };
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric = global.fabric || (global.fabric = { }),
	      min = fabric.util.array.min,
	      max = fabric.util.array.max,
	      extend = fabric.util.object.extend,
	      _toString = Object.prototype.toString,
	      drawArc = fabric.util.drawArc,
	      toFixed = fabric.util.toFixed,
	      commandLengths = {
	        m: 2,
	        l: 2,
	        h: 1,
	        v: 1,
	        c: 6,
	        s: 4,
	        q: 4,
	        t: 2,
	        a: 7
	      },
	      repeatedCommands = {
	        m: 'l',
	        M: 'L'
	      };
	
	  if (fabric.Path) {
	    fabric.warn('fabric.Path is already defined');
	    return;
	  }
	
	  /**
	   * Path class
	   * @class fabric.Path
	   * @extends fabric.Object
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#path_and_pathgroup}
	   * @see {@link fabric.Path#initialize} for constructor definition
	   */
	  fabric.Path = fabric.util.createClass(fabric.Object, /** @lends fabric.Path.prototype */ {
	
	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'path',
	
	    /**
	     * Array of path points
	     * @type Array
	     * @default
	     */
	    path: null,
	
	    cacheProperties: fabric.Object.prototype.cacheProperties.concat('path', 'fillRule'),
	
	    stateProperties: fabric.Object.prototype.stateProperties.concat('path'),
	
	    /**
	     * Constructor
	     * @param {Array|String} path Path data (sequence of coordinates and corresponding "command" tokens)
	     * @param {Object} [options] Options object
	     * @return {fabric.Path} thisArg
	     */
	    initialize: function(path, options) {
	      options = options || { };
	      this.callSuper('initialize', options);
	
	      if (!path) {
	        path = [];
	      }
	
	      var fromArray = _toString.call(path) === '[object Array]';
	
	      this.path = fromArray
	        ? path
	        // one of commands (m,M,l,L,q,Q,c,C,etc.) followed by non-command characters (i.e. command values)
	        : path.match && path.match(/[mzlhvcsqta][^mzlhvcsqta]*/gi);
	
	      if (!this.path) {
	        return;
	      }
	
	      if (!fromArray) {
	        this.path = this._parsePath();
	      }
	
	      fabric.Polyline.prototype._setPositionDimensions.call(this, options);
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx context to render path on
	     */
	    _renderPathCommands: function(ctx) {
	      var current, // current instruction
	          previous = null,
	          subpathStartX = 0,
	          subpathStartY = 0,
	          x = 0, // current x
	          y = 0, // current y
	          controlX = 0, // current control point x
	          controlY = 0, // current control point y
	          tempX,
	          tempY,
	          l = -this.pathOffset.x,
	          t = -this.pathOffset.y;
	
	      ctx.beginPath();
	
	      for (var i = 0, len = this.path.length; i < len; ++i) {
	
	        current = this.path[i];
	
	        switch (current[0]) { // first letter
	
	          case 'l': // lineto, relative
	            x += current[1];
	            y += current[2];
	            ctx.lineTo(x + l, y + t);
	            break;
	
	          case 'L': // lineto, absolute
	            x = current[1];
	            y = current[2];
	            ctx.lineTo(x + l, y + t);
	            break;
	
	          case 'h': // horizontal lineto, relative
	            x += current[1];
	            ctx.lineTo(x + l, y + t);
	            break;
	
	          case 'H': // horizontal lineto, absolute
	            x = current[1];
	            ctx.lineTo(x + l, y + t);
	            break;
	
	          case 'v': // vertical lineto, relative
	            y += current[1];
	            ctx.lineTo(x + l, y + t);
	            break;
	
	          case 'V': // verical lineto, absolute
	            y = current[1];
	            ctx.lineTo(x + l, y + t);
	            break;
	
	          case 'm': // moveTo, relative
	            x += current[1];
	            y += current[2];
	            subpathStartX = x;
	            subpathStartY = y;
	            ctx.moveTo(x + l, y + t);
	            break;
	
	          case 'M': // moveTo, absolute
	            x = current[1];
	            y = current[2];
	            subpathStartX = x;
	            subpathStartY = y;
	            ctx.moveTo(x + l, y + t);
	            break;
	
	          case 'c': // bezierCurveTo, relative
	            tempX = x + current[5];
	            tempY = y + current[6];
	            controlX = x + current[3];
	            controlY = y + current[4];
	            ctx.bezierCurveTo(
	              x + current[1] + l, // x1
	              y + current[2] + t, // y1
	              controlX + l, // x2
	              controlY + t, // y2
	              tempX + l,
	              tempY + t
	            );
	            x = tempX;
	            y = tempY;
	            break;
	
	          case 'C': // bezierCurveTo, absolute
	            x = current[5];
	            y = current[6];
	            controlX = current[3];
	            controlY = current[4];
	            ctx.bezierCurveTo(
	              current[1] + l,
	              current[2] + t,
	              controlX + l,
	              controlY + t,
	              x + l,
	              y + t
	            );
	            break;
	
	          case 's': // shorthand cubic bezierCurveTo, relative
	
	            // transform to absolute x,y
	            tempX = x + current[3];
	            tempY = y + current[4];
	
	            if (previous[0].match(/[CcSs]/) === null) {
	              // If there is no previous command or if the previous command was not a C, c, S, or s,
	              // the control point is coincident with the current point
	              controlX = x;
	              controlY = y;
	            }
	            else {
	              // calculate reflection of previous control points
	              controlX = 2 * x - controlX;
	              controlY = 2 * y - controlY;
	            }
	
	            ctx.bezierCurveTo(
	              controlX + l,
	              controlY + t,
	              x + current[1] + l,
	              y + current[2] + t,
	              tempX + l,
	              tempY + t
	            );
	            // set control point to 2nd one of this command
	            // "... the first control point is assumed to be
	            // the reflection of the second control point on
	            // the previous command relative to the current point."
	            controlX = x + current[1];
	            controlY = y + current[2];
	
	            x = tempX;
	            y = tempY;
	            break;
	
	          case 'S': // shorthand cubic bezierCurveTo, absolute
	            tempX = current[3];
	            tempY = current[4];
	            if (previous[0].match(/[CcSs]/) === null) {
	              // If there is no previous command or if the previous command was not a C, c, S, or s,
	              // the control point is coincident with the current point
	              controlX = x;
	              controlY = y;
	            }
	            else {
	              // calculate reflection of previous control points
	              controlX = 2 * x - controlX;
	              controlY = 2 * y - controlY;
	            }
	            ctx.bezierCurveTo(
	              controlX + l,
	              controlY + t,
	              current[1] + l,
	              current[2] + t,
	              tempX + l,
	              tempY + t
	            );
	            x = tempX;
	            y = tempY;
	
	            // set control point to 2nd one of this command
	            // "... the first control point is assumed to be
	            // the reflection of the second control point on
	            // the previous command relative to the current point."
	            controlX = current[1];
	            controlY = current[2];
	
	            break;
	
	          case 'q': // quadraticCurveTo, relative
	            // transform to absolute x,y
	            tempX = x + current[3];
	            tempY = y + current[4];
	
	            controlX = x + current[1];
	            controlY = y + current[2];
	
	            ctx.quadraticCurveTo(
	              controlX + l,
	              controlY + t,
	              tempX + l,
	              tempY + t
	            );
	            x = tempX;
	            y = tempY;
	            break;
	
	          case 'Q': // quadraticCurveTo, absolute
	            tempX = current[3];
	            tempY = current[4];
	
	            ctx.quadraticCurveTo(
	              current[1] + l,
	              current[2] + t,
	              tempX + l,
	              tempY + t
	            );
	            x = tempX;
	            y = tempY;
	            controlX = current[1];
	            controlY = current[2];
	            break;
	
	          case 't': // shorthand quadraticCurveTo, relative
	
	            // transform to absolute x,y
	            tempX = x + current[1];
	            tempY = y + current[2];
	
	            if (previous[0].match(/[QqTt]/) === null) {
	              // If there is no previous command or if the previous command was not a Q, q, T or t,
	              // assume the control point is coincident with the current point
	              controlX = x;
	              controlY = y;
	            }
	            else {
	              // calculate reflection of previous control point
	              controlX = 2 * x - controlX;
	              controlY = 2 * y - controlY;
	            }
	
	            ctx.quadraticCurveTo(
	              controlX + l,
	              controlY + t,
	              tempX + l,
	              tempY + t
	            );
	            x = tempX;
	            y = tempY;
	
	            break;
	
	          case 'T':
	            tempX = current[1];
	            tempY = current[2];
	
	            if (previous[0].match(/[QqTt]/) === null) {
	              // If there is no previous command or if the previous command was not a Q, q, T or t,
	              // assume the control point is coincident with the current point
	              controlX = x;
	              controlY = y;
	            }
	            else {
	              // calculate reflection of previous control point
	              controlX = 2 * x - controlX;
	              controlY = 2 * y - controlY;
	            }
	            ctx.quadraticCurveTo(
	              controlX + l,
	              controlY + t,
	              tempX + l,
	              tempY + t
	            );
	            x = tempX;
	            y = tempY;
	            break;
	
	          case 'a':
	            // TODO: optimize this
	            drawArc(ctx, x + l, y + t, [
	              current[1],
	              current[2],
	              current[3],
	              current[4],
	              current[5],
	              current[6] + x + l,
	              current[7] + y + t
	            ]);
	            x += current[6];
	            y += current[7];
	            break;
	
	          case 'A':
	            // TODO: optimize this
	            drawArc(ctx, x + l, y + t, [
	              current[1],
	              current[2],
	              current[3],
	              current[4],
	              current[5],
	              current[6] + l,
	              current[7] + t
	            ]);
	            x = current[6];
	            y = current[7];
	            break;
	
	          case 'z':
	          case 'Z':
	            x = subpathStartX;
	            y = subpathStartY;
	            ctx.closePath();
	            break;
	        }
	        previous = current;
	      }
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx context to render path on
	     */
	    _render: function(ctx) {
	      this._renderPathCommands(ctx);
	      this._renderPaintInOrder(ctx);
	    },
	
	    /**
	     * Returns string representation of an instance
	     * @return {String} string representation of an instance
	     */
	    toString: function() {
	      return '#<fabric.Path (' + this.complexity() +
	        '): { "top": ' + this.top + ', "left": ' + this.left + ' }>';
	    },
	
	    /**
	     * Returns object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      return extend(this.callSuper('toObject', propertiesToInclude), {
	        path: this.path.map(function(item) { return item.slice(); }),
	      });
	    },
	
	    /**
	     * Returns dataless object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toDatalessObject: function(propertiesToInclude) {
	      var o = this.toObject(['sourcePath'].concat(propertiesToInclude));
	      if (o.sourcePath) {
	        delete o.path;
	      }
	      return o;
	    },
	
	    /* _TO_SVG_START_ */
	    /**
	     * Returns svg representation of an instance
	     * @return {Array} an array of strings with the specific svg representation
	     * of the instance
	     */
	    _toSVG: function() {
	      var path = this.path.map(function(path) {
	        return path.join(' ');
	      }).join(' ');
	      return [
	        '<path ', 'COMMON_PARTS',
	        'd="', path,
	        '" stroke-linecap="round" ',
	        '/>\n'
	      ];
	    },
	
	    _getOffsetTransform: function() {
	      var digits = fabric.Object.NUM_FRACTION_DIGITS;
	      return ' translate(' + toFixed(-this.pathOffset.x, digits) + ', ' +
	          toFixed(-this.pathOffset.y, digits) + ')';
	    },
	
	    /**
	     * Returns svg clipPath representation of an instance
	     * @param {Function} [reviver] Method for further parsing of svg representation.
	     * @return {String} svg representation of an instance
	     */
	    toClipPathSVG: function(reviver) {
	      var additionalTransform = this._getOffsetTransform();
	      return '\t' + this._createBaseClipPathSVGMarkup(
	        this._toSVG(), { reviver: reviver, additionalTransform: additionalTransform }
	      );
	    },
	
	    /**
	     * Returns svg representation of an instance
	     * @param {Function} [reviver] Method for further parsing of svg representation.
	     * @return {String} svg representation of an instance
	     */
	    toSVG: function(reviver) {
	      var additionalTransform = this._getOffsetTransform();
	      return this._createBaseSVGMarkup(this._toSVG(), { reviver: reviver, additionalTransform: additionalTransform  });
	    },
	    /* _TO_SVG_END_ */
	
	    /**
	     * Returns number representation of an instance complexity
	     * @return {Number} complexity of this instance
	     */
	    complexity: function() {
	      return this.path.length;
	    },
	
	    /**
	     * @private
	     */
	    _parsePath: function() {
	      var result = [],
	          coords = [],
	          currentPath,
	          parsed,
	          re = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/ig,
	          match,
	          coordsStr;
	
	      for (var i = 0, coordsParsed, len = this.path.length; i < len; i++) {
	        currentPath = this.path[i];
	
	        coordsStr = currentPath.slice(1).trim();
	        coords.length = 0;
	
	        while ((match = re.exec(coordsStr))) {
	          coords.push(match[0]);
	        }
	
	        coordsParsed = [currentPath.charAt(0)];
	
	        for (var j = 0, jlen = coords.length; j < jlen; j++) {
	          parsed = parseFloat(coords[j]);
	          if (!isNaN(parsed)) {
	            coordsParsed.push(parsed);
	          }
	        }
	
	        var command = coordsParsed[0],
	            commandLength = commandLengths[command.toLowerCase()],
	            repeatedCommand = repeatedCommands[command] || command;
	
	        if (coordsParsed.length - 1 > commandLength) {
	          for (var k = 1, klen = coordsParsed.length; k < klen; k += commandLength) {
	            result.push([command].concat(coordsParsed.slice(k, k + commandLength)));
	            command = repeatedCommand;
	          }
	        }
	        else {
	          result.push(coordsParsed);
	        }
	      }
	
	      return result;
	    },
	
	    /**
	     * @private
	     */
	    _calcDimensions: function() {
	
	      var aX = [],
	          aY = [],
	          current, // current instruction
	          previous = null,
	          subpathStartX = 0,
	          subpathStartY = 0,
	          x = 0, // current x
	          y = 0, // current y
	          controlX = 0, // current control point x
	          controlY = 0, // current control point y
	          tempX,
	          tempY,
	          bounds;
	
	      for (var i = 0, len = this.path.length; i < len; ++i) {
	
	        current = this.path[i];
	
	        switch (current[0]) { // first letter
	
	          case 'l': // lineto, relative
	            x += current[1];
	            y += current[2];
	            bounds = [];
	            break;
	
	          case 'L': // lineto, absolute
	            x = current[1];
	            y = current[2];
	            bounds = [];
	            break;
	
	          case 'h': // horizontal lineto, relative
	            x += current[1];
	            bounds = [];
	            break;
	
	          case 'H': // horizontal lineto, absolute
	            x = current[1];
	            bounds = [];
	            break;
	
	          case 'v': // vertical lineto, relative
	            y += current[1];
	            bounds = [];
	            break;
	
	          case 'V': // verical lineto, absolute
	            y = current[1];
	            bounds = [];
	            break;
	
	          case 'm': // moveTo, relative
	            x += current[1];
	            y += current[2];
	            subpathStartX = x;
	            subpathStartY = y;
	            bounds = [];
	            break;
	
	          case 'M': // moveTo, absolute
	            x = current[1];
	            y = current[2];
	            subpathStartX = x;
	            subpathStartY = y;
	            bounds = [];
	            break;
	
	          case 'c': // bezierCurveTo, relative
	            tempX = x + current[5];
	            tempY = y + current[6];
	            controlX = x + current[3];
	            controlY = y + current[4];
	            bounds = fabric.util.getBoundsOfCurve(x, y,
	              x + current[1], // x1
	              y + current[2], // y1
	              controlX, // x2
	              controlY, // y2
	              tempX,
	              tempY
	            );
	            x = tempX;
	            y = tempY;
	            break;
	
	          case 'C': // bezierCurveTo, absolute
	            controlX = current[3];
	            controlY = current[4];
	            bounds = fabric.util.getBoundsOfCurve(x, y,
	              current[1],
	              current[2],
	              controlX,
	              controlY,
	              current[5],
	              current[6]
	            );
	            x = current[5];
	            y = current[6];
	            break;
	
	          case 's': // shorthand cubic bezierCurveTo, relative
	
	            // transform to absolute x,y
	            tempX = x + current[3];
	            tempY = y + current[4];
	
	            if (previous[0].match(/[CcSs]/) === null) {
	              // If there is no previous command or if the previous command was not a C, c, S, or s,
	              // the control point is coincident with the current point
	              controlX = x;
	              controlY = y;
	            }
	            else {
	              // calculate reflection of previous control points
	              controlX = 2 * x - controlX;
	              controlY = 2 * y - controlY;
	            }
	
	            bounds = fabric.util.getBoundsOfCurve(x, y,
	              controlX,
	              controlY,
	              x + current[1],
	              y + current[2],
	              tempX,
	              tempY
	            );
	            // set control point to 2nd one of this command
	            // "... the first control point is assumed to be
	            // the reflection of the second control point on
	            // the previous command relative to the current point."
	            controlX = x + current[1];
	            controlY = y + current[2];
	            x = tempX;
	            y = tempY;
	            break;
	
	          case 'S': // shorthand cubic bezierCurveTo, absolute
	            tempX = current[3];
	            tempY = current[4];
	            if (previous[0].match(/[CcSs]/) === null) {
	              // If there is no previous command or if the previous command was not a C, c, S, or s,
	              // the control point is coincident with the current point
	              controlX = x;
	              controlY = y;
	            }
	            else {
	              // calculate reflection of previous control points
	              controlX = 2 * x - controlX;
	              controlY = 2 * y - controlY;
	            }
	            bounds = fabric.util.getBoundsOfCurve(x, y,
	              controlX,
	              controlY,
	              current[1],
	              current[2],
	              tempX,
	              tempY
	            );
	            x = tempX;
	            y = tempY;
	            // set control point to 2nd one of this command
	            // "... the first control point is assumed to be
	            // the reflection of the second control point on
	            // the previous command relative to the current point."
	            controlX = current[1];
	            controlY = current[2];
	            break;
	
	          case 'q': // quadraticCurveTo, relative
	            // transform to absolute x,y
	            tempX = x + current[3];
	            tempY = y + current[4];
	            controlX = x + current[1];
	            controlY = y + current[2];
	            bounds = fabric.util.getBoundsOfCurve(x, y,
	              controlX,
	              controlY,
	              controlX,
	              controlY,
	              tempX,
	              tempY
	            );
	            x = tempX;
	            y = tempY;
	            break;
	
	          case 'Q': // quadraticCurveTo, absolute
	            controlX = current[1];
	            controlY = current[2];
	            bounds = fabric.util.getBoundsOfCurve(x, y,
	              controlX,
	              controlY,
	              controlX,
	              controlY,
	              current[3],
	              current[4]
	            );
	            x = current[3];
	            y = current[4];
	            break;
	
	          case 't': // shorthand quadraticCurveTo, relative
	            // transform to absolute x,y
	            tempX = x + current[1];
	            tempY = y + current[2];
	            if (previous[0].match(/[QqTt]/) === null) {
	              // If there is no previous command or if the previous command was not a Q, q, T or t,
	              // assume the control point is coincident with the current point
	              controlX = x;
	              controlY = y;
	            }
	            else {
	              // calculate reflection of previous control point
	              controlX = 2 * x - controlX;
	              controlY = 2 * y - controlY;
	            }
	
	            bounds = fabric.util.getBoundsOfCurve(x, y,
	              controlX,
	              controlY,
	              controlX,
	              controlY,
	              tempX,
	              tempY
	            );
	            x = tempX;
	            y = tempY;
	
	            break;
	
	          case 'T':
	            tempX = current[1];
	            tempY = current[2];
	
	            if (previous[0].match(/[QqTt]/) === null) {
	              // If there is no previous command or if the previous command was not a Q, q, T or t,
	              // assume the control point is coincident with the current point
	              controlX = x;
	              controlY = y;
	            }
	            else {
	              // calculate reflection of previous control point
	              controlX = 2 * x - controlX;
	              controlY = 2 * y - controlY;
	            }
	            bounds = fabric.util.getBoundsOfCurve(x, y,
	              controlX,
	              controlY,
	              controlX,
	              controlY,
	              tempX,
	              tempY
	            );
	            x = tempX;
	            y = tempY;
	            break;
	
	          case 'a':
	            // TODO: optimize this
	            bounds = fabric.util.getBoundsOfArc(x, y,
	              current[1],
	              current[2],
	              current[3],
	              current[4],
	              current[5],
	              current[6] + x,
	              current[7] + y
	            );
	            x += current[6];
	            y += current[7];
	            break;
	
	          case 'A':
	            // TODO: optimize this
	            bounds = fabric.util.getBoundsOfArc(x, y,
	              current[1],
	              current[2],
	              current[3],
	              current[4],
	              current[5],
	              current[6],
	              current[7]
	            );
	            x = current[6];
	            y = current[7];
	            break;
	
	          case 'z':
	          case 'Z':
	            x = subpathStartX;
	            y = subpathStartY;
	            break;
	        }
	        previous = current;
	        bounds.forEach(function (point) {
	          aX.push(point.x);
	          aY.push(point.y);
	        });
	        aX.push(x);
	        aY.push(y);
	      }
	
	      var minX = min(aX) || 0,
	          minY = min(aY) || 0,
	          maxX = max(aX) || 0,
	          maxY = max(aY) || 0,
	          deltaX = maxX - minX,
	          deltaY = maxY - minY;
	
	      return {
	        left: minX,
	        top: minY,
	        width: deltaX,
	        height: deltaY
	      };
	    }
	  });
	
	  /**
	   * Creates an instance of fabric.Path from an object
	   * @static
	   * @memberOf fabric.Path
	   * @param {Object} object
	   * @param {Function} [callback] Callback to invoke when an fabric.Path instance is created
	   */
	  fabric.Path.fromObject = function(object, callback) {
	    if (typeof object.sourcePath === 'string') {
	      var pathUrl = object.sourcePath;
	      fabric.loadSVGFromURL(pathUrl, function (elements) {
	        var path = elements[0];
	        path.setOptions(object);
	        callback && callback(path);
	      });
	    }
	    else {
	      fabric.Object._fromObject('Path', object, callback, 'path');
	    }
	  };
	
	  /* _FROM_SVG_START_ */
	  /**
	   * List of attribute names to account for when parsing SVG element (used by `fabric.Path.fromElement`)
	   * @static
	   * @memberOf fabric.Path
	   * @see http://www.w3.org/TR/SVG/paths.html#PathElement
	   */
	  fabric.Path.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat(['d']);
	
	  /**
	   * Creates an instance of fabric.Path from an SVG <path> element
	   * @static
	   * @memberOf fabric.Path
	   * @param {SVGElement} element to parse
	   * @param {Function} callback Callback to invoke when an fabric.Path instance is created
	   * @param {Object} [options] Options object
	   * @param {Function} [callback] Options callback invoked after parsing is finished
	   */
	  fabric.Path.fromElement = function(element, callback, options) {
	    var parsedAttributes = fabric.parseAttributes(element, fabric.Path.ATTRIBUTE_NAMES);
	    parsedAttributes.fromSVG = true;
	    callback(new fabric.Path(parsedAttributes.d, extend(parsedAttributes, options)));
	  };
	  /* _FROM_SVG_END_ */
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric = global.fabric || (global.fabric = { }),
	      min = fabric.util.array.min,
	      max = fabric.util.array.max;
	
	  if (fabric.Group) {
	    return;
	  }
	
	  /**
	   * Group class
	   * @class fabric.Group
	   * @extends fabric.Object
	   * @mixes fabric.Collection
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#groups}
	   * @see {@link fabric.Group#initialize} for constructor definition
	   */
	  fabric.Group = fabric.util.createClass(fabric.Object, fabric.Collection, /** @lends fabric.Group.prototype */ {
	
	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'group',
	
	    /**
	     * Width of stroke
	     * @type Number
	     * @default
	     */
	    strokeWidth: 0,
	
	    /**
	     * Indicates if click events should also check for subtargets
	     * @type Boolean
	     * @default
	     */
	    subTargetCheck: false,
	
	    /**
	     * Groups are container, do not render anything on theyr own, ence no cache properties
	     * @type Array
	     * @default
	     */
	    cacheProperties: [],
	
	    /**
	     * setOnGroup is a method used for TextBox that is no more used since 2.0.0 The behavior is still
	     * available setting this boolean to true.
	     * @type Boolean
	     * @since 2.0.0
	     * @default
	     */
	    useSetOnGroup: false,
	
	    /**
	     * Constructor
	     * @param {Object} objects Group objects
	     * @param {Object} [options] Options object
	     * @param {Boolean} [isAlreadyGrouped] if true, objects have been grouped already.
	     * @return {Object} thisArg
	     */
	    initialize: function(objects, options, isAlreadyGrouped) {
	      options = options || {};
	      this._objects = [];
	      // if objects enclosed in a group have been grouped already,
	      // we cannot change properties of objects.
	      // Thus we need to set options to group without objects,
	      isAlreadyGrouped && this.callSuper('initialize', options);
	      this._objects = objects || [];
	      for (var i = this._objects.length; i--; ) {
	        this._objects[i].group = this;
	      }
	
	      if (!isAlreadyGrouped) {
	        var center = options && options.centerPoint;
	        // we want to set origins before calculating the bounding box.
	        // so that the topleft can be set with that in mind.
	        // if specific top and left are passed, are overwritten later
	        // with the callSuper('initialize', options)
	        if (options.originX !== undefined) {
	          this.originX = options.originX;
	        }
	        if (options.originY !== undefined) {
	          this.originY = options.originY;
	        }
	        // if coming from svg i do not want to calc bounds.
	        // i assume width and height are passed along options
	        center || this._calcBounds();
	        this._updateObjectsCoords(center);
	        delete options.centerPoint;
	        this.callSuper('initialize', options);
	      }
	      else {
	        this._updateObjectsACoords();
	      }
	
	      this.setCoords();
	    },
	
	    /**
	     * @private
	     * @param {Boolean} [skipCoordsChange] if true, coordinates of objects enclosed in a group do not change
	     */
	    _updateObjectsACoords: function() {
	      var ignoreZoom = true, skipAbsolute = true;
	      for (var i = this._objects.length; i--; ){
	        this._objects[i].setCoords(ignoreZoom, skipAbsolute);
	      }
	    },
	
	    /**
	     * @private
	     * @param {Boolean} [skipCoordsChange] if true, coordinates of objects enclosed in a group do not change
	     */
	    _updateObjectsCoords: function(center) {
	      var center = center || this.getCenterPoint();
	      for (var i = this._objects.length; i--; ){
	        this._updateObjectCoords(this._objects[i], center);
	      }
	    },
	
	    /**
	     * @private
	     * @param {Object} object
	     * @param {fabric.Point} center, current center of group.
	     */
	    _updateObjectCoords: function(object, center) {
	      var objectLeft = object.left,
	          objectTop = object.top,
	          ignoreZoom = true, skipAbsolute = true;
	
	      object.set({
	        left: objectLeft - center.x,
	        top: objectTop - center.y
	      });
	      object.group = this;
	      object.setCoords(ignoreZoom, skipAbsolute);
	    },
	
	    /**
	     * Returns string represenation of a group
	     * @return {String}
	     */
	    toString: function() {
	      return '#<fabric.Group: (' + this.complexity() + ')>';
	    },
	
	    /**
	     * Adds an object to a group; Then recalculates group's dimension, position.
	     * @param {Object} object
	     * @return {fabric.Group} thisArg
	     * @chainable
	     */
	    addWithUpdate: function(object) {
	      this._restoreObjectsState();
	      fabric.util.resetObjectTransform(this);
	      if (object) {
	        this._objects.push(object);
	        object.group = this;
	        object._set('canvas', this.canvas);
	      }
	      this._calcBounds();
	      this._updateObjectsCoords();
	      this.setCoords();
	      this.dirty = true;
	      return this;
	    },
	
	    /**
	     * Removes an object from a group; Then recalculates group's dimension, position.
	     * @param {Object} object
	     * @return {fabric.Group} thisArg
	     * @chainable
	     */
	    removeWithUpdate: function(object) {
	      this._restoreObjectsState();
	      fabric.util.resetObjectTransform(this);
	
	      this.remove(object);
	      this._calcBounds();
	      this._updateObjectsCoords();
	      this.setCoords();
	      this.dirty = true;
	      return this;
	    },
	
	    /**
	     * @private
	     */
	    _onObjectAdded: function(object) {
	      this.dirty = true;
	      object.group = this;
	      object._set('canvas', this.canvas);
	    },
	
	    /**
	     * @private
	     */
	    _onObjectRemoved: function(object) {
	      this.dirty = true;
	      delete object.group;
	    },
	
	    /**
	     * @private
	     */
	    _set: function(key, value) {
	      var i = this._objects.length;
	      if (this.useSetOnGroup) {
	        while (i--) {
	          this._objects[i].setOnGroup(key, value);
	        }
	      }
	      if (key === 'canvas') {
	        while (i--) {
	          this._objects[i]._set(key, value);
	        }
	      }
	      fabric.Object.prototype._set.call(this, key, value);
	    },
	
	    /**
	     * Returns object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      var _includeDefaultValues = this.includeDefaultValues;
	      var objsToObject = this._objects.map(function(obj) {
	        var originalDefaults = obj.includeDefaultValues;
	        obj.includeDefaultValues = _includeDefaultValues;
	        var _obj = obj.toObject(propertiesToInclude);
	        obj.includeDefaultValues = originalDefaults;
	        return _obj;
	      });
	      var obj = fabric.Object.prototype.toObject.call(this, propertiesToInclude);
	      obj.objects = objsToObject;
	      return obj;
	    },
	
	    /**
	     * Returns object representation of an instance, in dataless mode.
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toDatalessObject: function(propertiesToInclude) {
	      var objsToObject, sourcePath = this.sourcePath;
	      if (sourcePath) {
	        objsToObject = sourcePath;
	      }
	      else {
	        var _includeDefaultValues = this.includeDefaultValues;
	        objsToObject = this._objects.map(function(obj) {
	          var originalDefaults = obj.includeDefaultValues;
	          obj.includeDefaultValues = _includeDefaultValues;
	          var _obj = obj.toDatalessObject(propertiesToInclude);
	          obj.includeDefaultValues = originalDefaults;
	          return _obj;
	        });
	      }
	      var obj = fabric.Object.prototype.toDatalessObject.call(this, propertiesToInclude);
	      obj.objects = objsToObject;
	      return obj;
	    },
	
	    /**
	     * Renders instance on a given context
	     * @param {CanvasRenderingContext2D} ctx context to render instance on
	     */
	    render: function(ctx) {
	      this._transformDone = true;
	      this.callSuper('render', ctx);
	      this._transformDone = false;
	    },
	
	    /**
	     * Decide if the object should cache or not. Create its own cache level
	     * needsItsOwnCache should be used when the object drawing method requires
	     * a cache step. None of the fabric classes requires it.
	     * Generally you do not cache objects in groups because the group is already cached.
	     * @return {Boolean}
	     */
	    shouldCache: function() {
	      var ownCache = fabric.Object.prototype.shouldCache.call(this);
	      if (ownCache) {
	        for (var i = 0, len = this._objects.length; i < len; i++) {
	          if (this._objects[i].willDrawShadow()) {
	            this.ownCaching = false;
	            return false;
	          }
	        }
	      }
	      return ownCache;
	    },
	
	    /**
	     * Check if this object or a child object will cast a shadow
	     * @return {Boolean}
	     */
	    willDrawShadow: function() {
	      if (this.shadow) {
	        return fabric.Object.prototype.willDrawShadow.call(this);
	      }
	      for (var i = 0, len = this._objects.length; i < len; i++) {
	        if (this._objects[i].willDrawShadow()) {
	          return true;
	        }
	      }
	      return false;
	    },
	
	    /**
	     * Check if this group or its parent group are caching, recursively up
	     * @return {Boolean}
	     */
	    isOnACache: function() {
	      return this.ownCaching || (this.group && this.group.isOnACache());
	    },
	
	    /**
	     * Execute the drawing operation for an object on a specified context
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    drawObject: function(ctx) {
	      for (var i = 0, len = this._objects.length; i < len; i++) {
	        this._objects[i].render(ctx);
	      }
	      this._drawClipPath(ctx);
	    },
	
	    /**
	     * Check if cache is dirty
	     */
	    isCacheDirty: function(skipCanvas) {
	      if (this.callSuper('isCacheDirty', skipCanvas)) {
	        return true;
	      }
	      if (!this.statefullCache) {
	        return false;
	      }
	      for (var i = 0, len = this._objects.length; i < len; i++) {
	        if (this._objects[i].isCacheDirty(true)) {
	          if (this._cacheCanvas) {
	            // if this group has not a cache canvas there is nothing to clean
	            var x = this.cacheWidth / this.zoomX, y = this.cacheHeight / this.zoomY;
	            this._cacheContext.clearRect(-x / 2, -y / 2, x, y);
	          }
	          return true;
	        }
	      }
	      return false;
	    },
	
	    /**
	     * Retores original state of each of group objects (original state is that which was before group was created).
	     * @private
	     * @return {fabric.Group} thisArg
	     * @chainable
	     */
	    _restoreObjectsState: function() {
	      this._objects.forEach(this._restoreObjectState, this);
	      return this;
	    },
	
	    /**
	     * Realises the transform from this group onto the supplied object
	     * i.e. it tells you what would happen if the supplied object was in
	     * the group, and then the group was destroyed. It mutates the supplied
	     * object.
	     * @param {fabric.Object} object
	     * @return {fabric.Object} transformedObject
	     */
	    realizeTransform: function(object) {
	      var matrix = object.calcTransformMatrix(),
	          options = fabric.util.qrDecompose(matrix),
	          center = new fabric.Point(options.translateX, options.translateY);
	      object.flipX = false;
	      object.flipY = false;
	      object.set('scaleX', options.scaleX);
	      object.set('scaleY', options.scaleY);
	      object.skewX = options.skewX;
	      object.skewY = options.skewY;
	      object.angle = options.angle;
	      object.setPositionByOrigin(center, 'center', 'center');
	      return object;
	    },
	
	    /**
	     * Restores original state of a specified object in group
	     * @private
	     * @param {fabric.Object} object
	     * @return {fabric.Group} thisArg
	     */
	    _restoreObjectState: function(object) {
	      this.realizeTransform(object);
	      object.setCoords();
	      delete object.group;
	      return this;
	    },
	
	    /**
	     * Destroys a group (restoring state of its objects)
	     * @return {fabric.Group} thisArg
	     * @chainable
	     */
	    destroy: function() {
	      // when group is destroyed objects needs to get a repaint to be eventually
	      // displayed on canvas.
	      this._objects.forEach(function(object) {
	        object.set('dirty', true);
	      });
	      return this._restoreObjectsState();
	    },
	
	    /**
	     * make a group an active selection, remove the group from canvas
	     * the group has to be on canvas for this to work.
	     * @return {fabric.ActiveSelection} thisArg
	     * @chainable
	     */
	    toActiveSelection: function() {
	      if (!this.canvas) {
	        return;
	      }
	      var objects = this._objects, canvas = this.canvas;
	      this._objects = [];
	      var options = this.toObject();
	      delete options.objects;
	      var activeSelection = new fabric.ActiveSelection([]);
	      activeSelection.set(options);
	      activeSelection.type = 'activeSelection';
	      canvas.remove(this);
	      objects.forEach(function(object) {
	        object.group = activeSelection;
	        object.dirty = true;
	        canvas.add(object);
	      });
	      activeSelection.canvas = canvas;
	      activeSelection._objects = objects;
	      canvas._activeObject = activeSelection;
	      activeSelection.setCoords();
	      return activeSelection;
	    },
	
	    /**
	     * Destroys a group (restoring state of its objects)
	     * @return {fabric.Group} thisArg
	     * @chainable
	     */
	    ungroupOnCanvas: function() {
	      return this._restoreObjectsState();
	    },
	
	    /**
	     * Sets coordinates of all objects inside group
	     * @return {fabric.Group} thisArg
	     * @chainable
	     */
	    setObjectsCoords: function() {
	      var ignoreZoom = true, skipAbsolute = true;
	      this.forEachObject(function(object) {
	        object.setCoords(ignoreZoom, skipAbsolute);
	      });
	      return this;
	    },
	
	    /**
	     * @private
	     */
	    _calcBounds: function(onlyWidthHeight) {
	      var aX = [],
	          aY = [],
	          o, prop,
	          props = ['tr', 'br', 'bl', 'tl'],
	          i = 0, iLen = this._objects.length,
	          j, jLen = props.length,
	          ignoreZoom = true;
	
	      for ( ; i < iLen; ++i) {
	        o = this._objects[i];
	        o.setCoords(ignoreZoom);
	        for (j = 0; j < jLen; j++) {
	          prop = props[j];
	          aX.push(o.oCoords[prop].x);
	          aY.push(o.oCoords[prop].y);
	        }
	      }
	
	      this._getBounds(aX, aY, onlyWidthHeight);
	    },
	
	    /**
	     * @private
	     */
	    _getBounds: function(aX, aY, onlyWidthHeight) {
	      var minXY = new fabric.Point(min(aX), min(aY)),
	          maxXY = new fabric.Point(max(aX), max(aY)),
	          top = minXY.y || 0, left = minXY.x || 0,
	          width = (maxXY.x - minXY.x) || 0,
	          height = (maxXY.y - minXY.y) || 0;
	      this.width = width;
	      this.height = height;
	      if (!onlyWidthHeight) {
	        // the bounding box always finds the topleft most corner.
	        // whatever is the group origin, we set up here the left/top position.
	        this.setPositionByOrigin({ x: left, y: top }, 'left', 'top');
	      }
	    },
	
	    /* _TO_SVG_START_ */
	    /**
	     * Returns svg representation of an instance
	     * @param {Function} [reviver] Method for further parsing of svg representation.
	     * @return {String} svg representation of an instance
	     */
	    _toSVG: function(reviver) {
	      var svgString = ['<g ', 'COMMON_PARTS', ' >\n'];
	
	      for (var i = 0, len = this._objects.length; i < len; i++) {
	        svgString.push('\t\t', this._objects[i].toSVG(reviver));
	      }
	      svgString.push('</g>\n');
	      return svgString;
	    },
	
	    /**
	     * Returns styles-string for svg-export, specific version for group
	     * @return {String}
	     */
	    getSvgStyles: function() {
	      var opacity = typeof this.opacity !== 'undefined' && this.opacity !== 1 ?
	            'opacity: ' + this.opacity + ';' : '',
	          visibility = this.visible ? '' : ' visibility: hidden;';
	      return [
	        opacity,
	        this.getSvgFilter(),
	        visibility
	      ].join('');
	    },
	
	    /**
	     * Returns svg clipPath representation of an instance
	     * @param {Function} [reviver] Method for further parsing of svg representation.
	     * @return {String} svg representation of an instance
	     */
	    toClipPathSVG: function(reviver) {
	      var svgString = [];
	
	      for (var i = 0, len = this._objects.length; i < len; i++) {
	        svgString.push('\t', this._objects[i].toClipPathSVG(reviver));
	      }
	
	      return this._createBaseClipPathSVGMarkup(svgString, { reviver: reviver });
	    },
	    /* _TO_SVG_END_ */
	  });
	
	  /**
	   * Returns {@link fabric.Group} instance from an object representation
	   * @static
	   * @memberOf fabric.Group
	   * @param {Object} object Object to create a group from
	   * @param {Function} [callback] Callback to invoke when an group instance is created
	   */
	  fabric.Group.fromObject = function(object, callback) {
	    fabric.util.enlivenObjects(object.objects, function(enlivenedObjects) {
	      fabric.util.enlivenObjects([object.clipPath], function(enlivedClipPath) {
	        var options = fabric.util.object.clone(object, true);
	        options.clipPath = enlivedClipPath[0];
	        delete options.objects;
	        callback && callback(new fabric.Group(enlivenedObjects, options, true));
	      });
	    });
	  };
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric = global.fabric || (global.fabric = { });
	
	  if (fabric.ActiveSelection) {
	    return;
	  }
	
	  /**
	   * Group class
	   * @class fabric.ActiveSelection
	   * @extends fabric.Group
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#groups}
	   * @see {@link fabric.ActiveSelection#initialize} for constructor definition
	   */
	  fabric.ActiveSelection = fabric.util.createClass(fabric.Group, /** @lends fabric.ActiveSelection.prototype */ {
	
	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'activeSelection',
	
	    /**
	     * Constructor
	     * @param {Object} objects ActiveSelection objects
	     * @param {Object} [options] Options object
	     * @return {Object} thisArg
	     */
	    initialize: function(objects, options) {
	      options = options || {};
	      this._objects = objects || [];
	      for (var i = this._objects.length; i--; ) {
	        this._objects[i].group = this;
	      }
	
	      if (options.originX) {
	        this.originX = options.originX;
	      }
	      if (options.originY) {
	        this.originY = options.originY;
	      }
	      this._calcBounds();
	      this._updateObjectsCoords();
	      fabric.Object.prototype.initialize.call(this, options);
	      this.setCoords();
	    },
	
	    /**
	     * Change te activeSelection to a normal group,
	     * High level function that automatically adds it to canvas as
	     * active object. no events fired.
	     * @since 2.0.0
	     * @return {fabric.Group}
	     */
	    toGroup: function() {
	      var objects = this._objects.concat();
	      this._objects = [];
	      var options = fabric.Object.prototype.toObject.call(this);
	      var newGroup = new fabric.Group([]);
	      delete options.type;
	      newGroup.set(options);
	      objects.forEach(function(object) {
	        object.canvas.remove(object);
	        object.group = newGroup;
	      });
	      newGroup._objects = objects;
	      if (!this.canvas) {
	        return newGroup;
	      }
	      var canvas = this.canvas;
	      canvas.add(newGroup);
	      canvas._activeObject = newGroup;
	      newGroup.setCoords();
	      return newGroup;
	    },
	
	    /**
	     * If returns true, deselection is cancelled.
	     * @since 2.0.0
	     * @return {Boolean} [cancel]
	     */
	    onDeselect: function() {
	      this.destroy();
	      return false;
	    },
	
	    /**
	     * Returns string representation of a group
	     * @return {String}
	     */
	    toString: function() {
	      return '#<fabric.ActiveSelection: (' + this.complexity() + ')>';
	    },
	
	    /**
	     * Decide if the object should cache or not. Create its own cache level
	     * objectCaching is a global flag, wins over everything
	     * needsItsOwnCache should be used when the object drawing method requires
	     * a cache step. None of the fabric classes requires it.
	     * Generally you do not cache objects in groups because the group outside is cached.
	     * @return {Boolean}
	     */
	    shouldCache: function() {
	      return false;
	    },
	
	    /**
	     * Check if this group or its parent group are caching, recursively up
	     * @return {Boolean}
	     */
	    isOnACache: function() {
	      return false;
	    },
	
	    /**
	     * Renders controls and borders for the object
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {Object} [styleOverride] properties to override the object style
	     * @param {Object} [childrenOverride] properties to override the children overrides
	     */
	    _renderControls: function(ctx, styleOverride, childrenOverride) {
	      ctx.save();
	      ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
	      this.callSuper('_renderControls', ctx, styleOverride);
	      childrenOverride = childrenOverride || { };
	      if (typeof childrenOverride.hasControls === 'undefined') {
	        childrenOverride.hasControls = false;
	      }
	      if (typeof childrenOverride.hasRotatingPoint === 'undefined') {
	        childrenOverride.hasRotatingPoint = false;
	      }
	      childrenOverride.forActiveSelection = true;
	      for (var i = 0, len = this._objects.length; i < len; i++) {
	        this._objects[i]._renderControls(ctx, childrenOverride);
	      }
	      ctx.restore();
	    },
	  });
	
	  /**
	   * Returns {@link fabric.ActiveSelection} instance from an object representation
	   * @static
	   * @memberOf fabric.ActiveSelection
	   * @param {Object} object Object to create a group from
	   * @param {Function} [callback] Callback to invoke when an ActiveSelection instance is created
	   */
	  fabric.ActiveSelection.fromObject = function(object, callback) {
	    fabric.util.enlivenObjects(object.objects, function(enlivenedObjects) {
	      delete object.objects;
	      callback && callback(new fabric.ActiveSelection(enlivenedObjects, object, true));
	    });
	  };
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var extend = fabric.util.object.extend;
	
	  if (!global.fabric) {
	    global.fabric = { };
	  }
	
	  if (global.fabric.Image) {
	    fabric.warn('fabric.Image is already defined.');
	    return;
	  }
	
	  /**
	   * Image class
	   * @class fabric.Image
	   * @extends fabric.Object
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#images}
	   * @see {@link fabric.Image#initialize} for constructor definition
	   */
	  fabric.Image = fabric.util.createClass(fabric.Object, /** @lends fabric.Image.prototype */ {
	
	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'image',
	
	    /**
	     * crossOrigin value (one of "", "anonymous", "use-credentials")
	     * @see https://developer.mozilla.org/en-US/docs/HTML/CORS_settings_attributes
	     * @type String
	     * @default
	     */
	    crossOrigin: '',
	
	    /**
	     * Width of a stroke.
	     * For image quality a stroke multiple of 2 gives better results.
	     * @type Number
	     * @default
	     */
	    strokeWidth: 0,
	
	    /**
	     * When calling {@link fabric.Image.getSrc}, return value from element src with `element.getAttribute('src')`.
	     * This allows for relative urls as image src.
	     * @since 2.7.0
	     * @type Boolean
	     * @default
	     */
	    srcFromAttribute: false,
	
	    /**
	     * private
	     * contains last value of scaleX to detect
	     * if the Image got resized after the last Render
	     * @type Number
	     */
	    _lastScaleX: 1,
	
	    /**
	     * private
	     * contains last value of scaleY to detect
	     * if the Image got resized after the last Render
	     * @type Number
	     */
	    _lastScaleY: 1,
	
	    /**
	     * private
	     * contains last value of scaling applied by the apply filter chain
	     * @type Number
	     */
	    _filterScalingX: 1,
	
	    /**
	     * private
	     * contains last value of scaling applied by the apply filter chain
	     * @type Number
	     */
	    _filterScalingY: 1,
	
	    /**
	     * minimum scale factor under which any resizeFilter is triggered to resize the image
	     * 0 will disable the automatic resize. 1 will trigger automatically always.
	     * number bigger than 1 are not implemented yet.
	     * @type Number
	     */
	    minimumScaleTrigger: 0.5,
	
	    /**
	     * List of properties to consider when checking if
	     * state of an object is changed ({@link fabric.Object#hasStateChanged})
	     * as well as for history (undo/redo) purposes
	     * @type Array
	     */
	    stateProperties: fabric.Object.prototype.stateProperties.concat('cropX', 'cropY'),
	
	    /**
	     * key used to retrieve the texture representing this image
	     * @since 2.0.0
	     * @type String
	     * @default
	     */
	    cacheKey: '',
	
	    /**
	     * Image crop in pixels from original image size.
	     * @since 2.0.0
	     * @type Number
	     * @default
	     */
	    cropX: 0,
	
	    /**
	     * Image crop in pixels from original image size.
	     * @since 2.0.0
	     * @type Number
	     * @default
	     */
	    cropY: 0,
	
	    /**
	     * Constructor
	     * @param {HTMLImageElement | String} element Image element
	     * @param {Object} [options] Options object
	     * @param {function} [callback] callback function to call after eventual filters applied.
	     * @return {fabric.Image} thisArg
	     */
	    initialize: function(element, options) {
	      options || (options = { });
	      this.filters = [];
	      this.cacheKey = 'texture' + fabric.Object.__uid++;
	      this.callSuper('initialize', options);
	      this._initElement(element, options);
	    },
	
	    /**
	     * Returns image element which this instance if based on
	     * @return {HTMLImageElement} Image element
	     */
	    getElement: function() {
	      return this._element || {};
	    },
	
	    /**
	     * Sets image element for this instance to a specified one.
	     * If filters defined they are applied to new image.
	     * You might need to call `canvas.renderAll` and `object.setCoords` after replacing, to render new image and update controls area.
	     * @param {HTMLImageElement} element
	     * @param {Object} [options] Options object
	     * @return {fabric.Image} thisArg
	     * @chainable
	     */
	    setElement: function(element, options) {
	      this.removeTexture(this.cacheKey);
	      this.removeTexture(this.cacheKey + '_filtered');
	      this._element = element;
	      this._originalElement = element;
	      this._initConfig(options);
	      if (this.filters.length !== 0) {
	        this.applyFilters();
	      }
	      // resizeFilters work on the already filtered copy.
	      // we need to apply resizeFilters AFTER normal filters.
	      // applyResizeFilters is run more often than normal fiters
	      // and is triggered by user interactions rather than dev code
	      if (this.resizeFilter) {
	        this.applyResizeFilters();
	      }
	      return this;
	    },
	
	    /**
	     * Delete a single texture if in webgl mode
	     */
	    removeTexture: function(key) {
	      var backend = fabric.filterBackend;
	      if (backend && backend.evictCachesForKey) {
	        backend.evictCachesForKey(key);
	      }
	    },
	
	    /**
	     * Delete textures, reference to elements and eventually JSDOM cleanup
	     */
	    dispose: function() {
	      this.removeTexture(this.cacheKey);
	      this.removeTexture(this.cacheKey + '_filtered');
	      this._cacheContext = undefined;
	      ['_originalElement', '_element', '_filteredEl', '_cacheCanvas'].forEach((function(element) {
	        fabric.util.cleanUpJsdomNode(this[element]);
	        this[element] = undefined;
	      }).bind(this));
	    },
	
	    /**
	     * Sets crossOrigin value (on an instance and corresponding image element)
	     * @return {fabric.Image} thisArg
	     * @chainable
	     */
	    setCrossOrigin: function(value) {
	      this.crossOrigin = value;
	      this._element.crossOrigin = value;
	
	      return this;
	    },
	
	    /**
	     * Returns original size of an image
	     * @return {Object} Object with "width" and "height" properties
	     */
	    getOriginalSize: function() {
	      var element = this.getElement();
	      return {
	        width: element.naturalWidth || element.width,
	        height: element.naturalHeight || element.height
	      };
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _stroke: function(ctx) {
	      if (!this.stroke || this.strokeWidth === 0) {
	        return;
	      }
	      var w = this.width / 2, h = this.height / 2;
	      ctx.beginPath();
	      ctx.moveTo(-w, -h);
	      ctx.lineTo(w, -h);
	      ctx.lineTo(w, h);
	      ctx.lineTo(-w, h);
	      ctx.lineTo(-w, -h);
	      ctx.closePath();
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderDashedStroke: function(ctx) {
	      var x = -this.width / 2,
	          y = -this.height / 2,
	          w = this.width,
	          h = this.height;
	
	      ctx.save();
	      this._setStrokeStyles(ctx, this);
	
	      ctx.beginPath();
	      fabric.util.drawDashedLine(ctx, x, y, x + w, y, this.strokeDashArray);
	      fabric.util.drawDashedLine(ctx, x + w, y, x + w, y + h, this.strokeDashArray);
	      fabric.util.drawDashedLine(ctx, x + w, y + h, x, y + h, this.strokeDashArray);
	      fabric.util.drawDashedLine(ctx, x, y + h, x, y, this.strokeDashArray);
	      ctx.closePath();
	      ctx.restore();
	    },
	
	    /**
	     * Returns object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      var filters = [];
	
	      this.filters.forEach(function(filterObj) {
	        if (filterObj) {
	          filters.push(filterObj.toObject());
	        }
	      });
	      var object = extend(
	        this.callSuper(
	          'toObject',
	          ['crossOrigin', 'cropX', 'cropY'].concat(propertiesToInclude)
	        ), {
	          src: this.getSrc(),
	          filters: filters,
	        });
	      if (this.resizeFilter) {
	        object.resizeFilter = this.resizeFilter.toObject();
	      }
	      return object;
	    },
	
	    /**
	     * Returns true if an image has crop applied, inspecting values of cropX,cropY,width,hight.
	     * @return {Boolean}
	     */
	    hasCrop: function() {
	      return this.cropX || this.cropY || this.width < this._element.width || this.height < this._element.height;
	    },
	
	    /* _TO_SVG_START_ */
	    /**
	     * Returns svg representation of an instance
	     * @return {Array} an array of strings with the specific svg representation
	     * of the instance
	     */
	    _toSVG: function() {
	      var svgString = [], imageMarkup = [], strokeSvg,
	          x = -this.width / 2, y = -this.height / 2, clipPath = '';
	      if (this.hasCrop()) {
	        var clipPathId = fabric.Object.__uid++;
	        svgString.push(
	          '<clipPath id="imageCrop_' + clipPathId + '">\n',
	          '\t<rect x="' + x + '" y="' + y + '" width="' + this.width + '" height="' + this.height + '" />\n',
	          '</clipPath>\n'
	        );
	        clipPath = ' clip-path="url(#imageCrop_' + clipPathId + ')" ';
	      }
	      imageMarkup.push('\t<image ', 'COMMON_PARTS', 'xlink:href="', this.getSvgSrc(true),
	        '" x="', x - this.cropX, '" y="', y - this.cropY,
	        // we're essentially moving origin of transformation from top/left corner to the center of the shape
	        // by wrapping it in container <g> element with actual transformation, then offsetting object to the top/left
	        // so that object's center aligns with container's left/top
	        '" width="', this._element.width || this._element.naturalWidth,
	        '" height="', this._element.height || this._element.height,
	        '"', clipPath,
	        '></image>\n');
	
	      if (this.stroke || this.strokeDashArray) {
	        var origFill = this.fill;
	        this.fill = null;
	        strokeSvg = [
	          '\t<rect ',
	          'x="', x, '" y="', y,
	          '" width="', this.width, '" height="', this.height,
	          '" style="', this.getSvgStyles(),
	          '"/>\n'
	        ];
	        this.fill = origFill;
	      }
	      if (this.paintFirst !== 'fill') {
	        svgString = svgString.concat(strokeSvg, imageMarkup);
	      }
	      else {
	        svgString = svgString.concat(imageMarkup, strokeSvg);
	      }
	      return svgString;
	    },
	    /* _TO_SVG_END_ */
	
	    /**
	     * Returns source of an image
	     * @param {Boolean} filtered indicates if the src is needed for svg
	     * @return {String} Source of an image
	     */
	    getSrc: function(filtered) {
	      var element = filtered ? this._element : this._originalElement;
	      if (element) {
	        if (element.toDataURL) {
	          return element.toDataURL();
	        }
	
	        if (this.srcFromAttribute) {
	          return element.getAttribute('src');
	        }
	        else {
	          return element.src;
	        }
	      }
	      else {
	        return this.src || '';
	      }
	    },
	
	    /**
	     * Sets source of an image
	     * @param {String} src Source string (URL)
	     * @param {Function} [callback] Callback is invoked when image has been loaded (and all filters have been applied)
	     * @param {Object} [options] Options object
	     * @return {fabric.Image} thisArg
	     * @chainable
	     */
	    setSrc: function(src, callback, options) {
	      fabric.util.loadImage(src, function(img) {
	        this.setElement(img, options);
	        this._setWidthHeight();
	        callback && callback(this);
	      }, this, options && options.crossOrigin);
	      return this;
	    },
	
	    /**
	     * Returns string representation of an instance
	     * @return {String} String representation of an instance
	     */
	    toString: function() {
	      return '#<fabric.Image: { src: "' + this.getSrc() + '" }>';
	    },
	
	    applyResizeFilters: function() {
	      var filter = this.resizeFilter,
	          minimumScale = this.minimumScaleTrigger,
	          objectScale = this.getTotalObjectScaling(),
	          scaleX = objectScale.scaleX,
	          scaleY = objectScale.scaleY,
	          elementToFilter = this._filteredEl || this._originalElement;
	      if (this.group) {
	        this.set('dirty', true);
	      }
	      if (!filter || (scaleX > minimumScale && scaleY > minimumScale)) {
	        this._element = elementToFilter;
	        this._filterScalingX = 1;
	        this._filterScalingY = 1;
	        this._lastScaleX = scaleX;
	        this._lastScaleY = scaleY;
	        return;
	      }
	      if (!fabric.filterBackend) {
	        fabric.filterBackend = fabric.initFilterBackend();
	      }
	      var canvasEl = fabric.util.createCanvasElement(),
	          cacheKey = this._filteredEl ? (this.cacheKey + '_filtered') : this.cacheKey,
	          sourceWidth = elementToFilter.width, sourceHeight = elementToFilter.height;
	      canvasEl.width = sourceWidth;
	      canvasEl.height = sourceHeight;
	      this._element = canvasEl;
	      this._lastScaleX = filter.scaleX = scaleX;
	      this._lastScaleY = filter.scaleY = scaleY;
	      fabric.filterBackend.applyFilters(
	        [filter], elementToFilter, sourceWidth, sourceHeight, this._element, cacheKey);
	      this._filterScalingX = canvasEl.width / this._originalElement.width;
	      this._filterScalingY = canvasEl.height / this._originalElement.height;
	    },
	
	    /**
	     * Applies filters assigned to this image (from "filters" array) or from filter param
	     * @method applyFilters
	     * @param {Array} filters to be applied
	     * @param {Boolean} forResizing specify if the filter operation is a resize operation
	     * @return {thisArg} return the fabric.Image object
	     * @chainable
	     */
	    applyFilters: function(filters) {
	
	      filters = filters || this.filters || [];
	      filters = filters.filter(function(filter) { return filter && !filter.isNeutralState(); });
	      this.set('dirty', true);
	
	      // needs to clear out or WEBGL will not resize correctly
	      this.removeTexture(this.cacheKey + '_filtered');
	
	      if (filters.length === 0) {
	        this._element = this._originalElement;
	        this._filteredEl = null;
	        this._filterScalingX = 1;
	        this._filterScalingY = 1;
	        return this;
	      }
	
	      var imgElement = this._originalElement,
	          sourceWidth = imgElement.naturalWidth || imgElement.width,
	          sourceHeight = imgElement.naturalHeight || imgElement.height;
	
	      if (this._element === this._originalElement) {
	        // if the element is the same we need to create a new element
	        var canvasEl = fabric.util.createCanvasElement();
	        canvasEl.width = sourceWidth;
	        canvasEl.height = sourceHeight;
	        this._element = canvasEl;
	        this._filteredEl = canvasEl;
	      }
	      else {
	        // clear the existing element to get new filter data
	        // also dereference the eventual resized _element
	        this._element = this._filteredEl;
	        this._filteredEl.getContext('2d').clearRect(0, 0, sourceWidth, sourceHeight);
	        // we also need to resize again at next renderAll, so remove saved _lastScaleX/Y
	        this._lastScaleX = 1;
	        this._lastScaleY = 1;
	      }
	      if (!fabric.filterBackend) {
	        fabric.filterBackend = fabric.initFilterBackend();
	      }
	      fabric.filterBackend.applyFilters(
	        filters, this._originalElement, sourceWidth, sourceHeight, this._element, this.cacheKey);
	      if (this._originalElement.width !== this._element.width ||
	        this._originalElement.height !== this._element.height) {
	        this._filterScalingX = this._element.width / this._originalElement.width;
	        this._filterScalingY = this._element.height / this._originalElement.height;
	      }
	      return this;
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _render: function(ctx) {
	      if (this.isMoving !== true && this.resizeFilter && this._needsResize()) {
	        this.applyResizeFilters();
	      }
	      this._stroke(ctx);
	      this._renderPaintInOrder(ctx);
	    },
	
	    /**
	     * Decide if the object should cache or not. Create its own cache level
	     * needsItsOwnCache should be used when the object drawing method requires
	     * a cache step. None of the fabric classes requires it.
	     * Generally you do not cache objects in groups because the group outside is cached.
	     * This is the special image version where we would like to avoid caching where possible.
	     * Essentially images do not benefit from caching. They may require caching, and in that
	     * case we do it. Also caching an image usually ends in a loss of details.
	     * A full performance audit should be done.
	     * @return {Boolean}
	     */
	    shouldCache: function() {
	      return this.needsItsOwnCache();
	    },
	
	    _renderFill: function(ctx) {
	      var elementToDraw = this._element,
	          w = this.width, h = this.height,
	          sW = Math.min(elementToDraw.naturalWidth || elementToDraw.width, w * this._filterScalingX),
	          sH = Math.min(elementToDraw.naturalHeight || elementToDraw.height, h * this._filterScalingY),
	          x = -w / 2, y = -h / 2,
	          sX = Math.max(0, this.cropX * this._filterScalingX),
	          sY = Math.max(0, this.cropY * this._filterScalingY);
	
	      elementToDraw && ctx.drawImage(elementToDraw, sX, sY, sW, sH, x, y, w, h);
	    },
	
	    /**
	     * @private, needed to check if image needs resize
	     */
	    _needsResize: function() {
	      var scale = this.getTotalObjectScaling();
	      return (scale.scaleX !== this._lastScaleX || scale.scaleY !== this._lastScaleY);
	    },
	
	    /**
	     * @private
	     */
	    _resetWidthHeight: function() {
	      this.set(this.getOriginalSize());
	    },
	
	    /**
	     * The Image class's initialization method. This method is automatically
	     * called by the constructor.
	     * @private
	     * @param {HTMLImageElement|String} element The element representing the image
	     * @param {Object} [options] Options object
	     */
	    _initElement: function(element, options) {
	      this.setElement(fabric.util.getById(element), options);
	      fabric.util.addClass(this.getElement(), fabric.Image.CSS_CANVAS);
	    },
	
	    /**
	     * @private
	     * @param {Object} [options] Options object
	     */
	    _initConfig: function(options) {
	      options || (options = { });
	      this.setOptions(options);
	      this._setWidthHeight(options);
	      if (this._element && this.crossOrigin) {
	        this._element.crossOrigin = this.crossOrigin;
	      }
	    },
	
	    /**
	     * @private
	     * @param {Array} filters to be initialized
	     * @param {Function} callback Callback to invoke when all fabric.Image.filters instances are created
	     */
	    _initFilters: function(filters, callback) {
	      if (filters && filters.length) {
	        fabric.util.enlivenObjects(filters, function(enlivenedObjects) {
	          callback && callback(enlivenedObjects);
	        }, 'fabric.Image.filters');
	      }
	      else {
	        callback && callback();
	      }
	    },
	
	    /**
	     * @private
	     * Set the width and the height of the image object, using the element or the
	     * options.
	     * @param {Object} [options] Object with width/height properties
	     */
	    _setWidthHeight: function(options) {
	      options || (options = { });
	      var el = this.getElement();
	      this.width = options.width || el.naturalWidth || el.width || 0;
	      this.height = options.height || el.naturalHeight || el.height || 0;
	    },
	
	    /**
	     * Calculate offset for center and scale factor for the image in order to respect
	     * the preserveAspectRatio attribute
	     * @private
	     * @return {Object}
	     */
	    parsePreserveAspectRatioAttribute: function() {
	      var pAR = fabric.util.parsePreserveAspectRatioAttribute(this.preserveAspectRatio || ''),
	          rWidth = this._element.width, rHeight = this._element.height,
	          scaleX = 1, scaleY = 1, offsetLeft = 0, offsetTop = 0, cropX = 0, cropY = 0,
	          offset, pWidth = this.width, pHeight = this.height, parsedAttributes = { width: pWidth, height: pHeight };
	      if (pAR && (pAR.alignX !== 'none' || pAR.alignY !== 'none')) {
	        if (pAR.meetOrSlice === 'meet') {
	          scaleX = scaleY = fabric.util.findScaleToFit(this._element, parsedAttributes);
	          offset = (pWidth - rWidth * scaleX) / 2;
	          if (pAR.alignX === 'Min') {
	            offsetLeft = -offset;
	          }
	          if (pAR.alignX === 'Max') {
	            offsetLeft = offset;
	          }
	          offset = (pHeight - rHeight * scaleY) / 2;
	          if (pAR.alignY === 'Min') {
	            offsetTop = -offset;
	          }
	          if (pAR.alignY === 'Max') {
	            offsetTop = offset;
	          }
	        }
	        if (pAR.meetOrSlice === 'slice') {
	          scaleX = scaleY = fabric.util.findScaleToCover(this._element, parsedAttributes);
	          offset = rWidth - pWidth / scaleX;
	          if (pAR.alignX === 'Mid') {
	            cropX = offset / 2;
	          }
	          if (pAR.alignX === 'Max') {
	            cropX = offset;
	          }
	          offset = rHeight - pHeight / scaleY;
	          if (pAR.alignY === 'Mid') {
	            cropY = offset / 2;
	          }
	          if (pAR.alignY === 'Max') {
	            cropY = offset;
	          }
	          rWidth = pWidth / scaleX;
	          rHeight = pHeight / scaleY;
	        }
	      }
	      else {
	        scaleX = pWidth / rWidth;
	        scaleY = pHeight / rHeight;
	      }
	      return {
	        width: rWidth,
	        height: rHeight,
	        scaleX: scaleX,
	        scaleY: scaleY,
	        offsetLeft: offsetLeft,
	        offsetTop: offsetTop,
	        cropX: cropX,
	        cropY: cropY
	      };
	    }
	  });
	
	  /**
	   * Default CSS class name for canvas
	   * @static
	   * @type String
	   * @default
	   */
	  fabric.Image.CSS_CANVAS = 'canvas-img';
	
	  /**
	   * Alias for getSrc
	   * @static
	   */
	  fabric.Image.prototype.getSvgSrc = fabric.Image.prototype.getSrc;
	
	  /**
	   * Creates an instance of fabric.Image from its object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {Function} callback Callback to invoke when an image instance is created
	   */
	  fabric.Image.fromObject = function(_object, callback) {
	    var object = fabric.util.object.clone(_object);
	    fabric.util.loadImage(object.src, function(img, error) {
	      if (error) {
	        callback && callback(null, error);
	        return;
	      }
	      fabric.Image.prototype._initFilters.call(object, object.filters, function(filters) {
	        object.filters = filters || [];
	        fabric.Image.prototype._initFilters.call(object, [object.resizeFilter], function(resizeFilters) {
	          object.resizeFilter = resizeFilters[0];
	          fabric.util.enlivenObjects([object.clipPath], function(enlivedProps) {
	            object.clipPath = enlivedProps[0];
	            var image = new fabric.Image(img, object);
	            callback(image);
	          });
	        });
	      });
	    }, null, object.crossOrigin);
	  };
	
	  /**
	   * Creates an instance of fabric.Image from an URL string
	   * @static
	   * @param {String} url URL to create an image from
	   * @param {Function} [callback] Callback to invoke when image is created (newly created image is passed as a first argument)
	   * @param {Object} [imgOptions] Options object
	   */
	  fabric.Image.fromURL = function(url, callback, imgOptions) {
	    fabric.util.loadImage(url, function(img) {
	      callback && callback(new fabric.Image(img, imgOptions));
	    }, null, imgOptions && imgOptions.crossOrigin);
	  };
	
	  /* _FROM_SVG_START_ */
	  /**
	   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Image.fromElement})
	   * @static
	   * @see {@link http://www.w3.org/TR/SVG/struct.html#ImageElement}
	   */
	  fabric.Image.ATTRIBUTE_NAMES =
	    fabric.SHARED_ATTRIBUTES.concat('x y width height preserveAspectRatio xlink:href crossOrigin'.split(' '));
	
	  /**
	   * Returns {@link fabric.Image} instance from an SVG element
	   * @static
	   * @param {SVGElement} element Element to parse
	   * @param {Object} [options] Options object
	   * @param {Function} callback Callback to execute when fabric.Image object is created
	   * @return {fabric.Image} Instance of fabric.Image
	   */
	  fabric.Image.fromElement = function(element, callback, options) {
	    var parsedAttributes = fabric.parseAttributes(element, fabric.Image.ATTRIBUTE_NAMES);
	    fabric.Image.fromURL(parsedAttributes['xlink:href'], callback,
	      extend((options ? fabric.util.object.clone(options) : { }), parsedAttributes));
	  };
	  /* _FROM_SVG_END_ */
	
	})( true ? exports : this);
	
	
	fabric.util.object.extend(fabric.Object.prototype, /** @lends fabric.Object.prototype */ {
	
	  /**
	   * @private
	   * @return {Number} angle value
	   */
	  _getAngleValueForStraighten: function() {
	    var angle = this.angle % 360;
	    if (angle > 0) {
	      return Math.round((angle - 1) / 90) * 90;
	    }
	    return Math.round(angle / 90) * 90;
	  },
	
	  /**
	   * Straightens an object (rotating it from current angle to one of 0, 90, 180, 270, etc. depending on which is closer)
	   * @return {fabric.Object} thisArg
	   * @chainable
	   */
	  straighten: function() {
	    this.rotate(this._getAngleValueForStraighten());
	    return this;
	  },
	
	  /**
	   * Same as {@link fabric.Object.prototype.straighten} but with animation
	   * @param {Object} callbacks Object with callback functions
	   * @param {Function} [callbacks.onComplete] Invoked on completion
	   * @param {Function} [callbacks.onChange] Invoked on every step of animation
	   * @return {fabric.Object} thisArg
	   * @chainable
	   */
	  fxStraighten: function(callbacks) {
	    callbacks = callbacks || { };
	
	    var empty = function() { },
	        onComplete = callbacks.onComplete || empty,
	        onChange = callbacks.onChange || empty,
	        _this = this;
	
	    fabric.util.animate({
	      startValue: this.get('angle'),
	      endValue: this._getAngleValueForStraighten(),
	      duration: this.FX_DURATION,
	      onChange: function(value) {
	        _this.rotate(value);
	        onChange();
	      },
	      onComplete: function() {
	        _this.setCoords();
	        onComplete();
	      },
	    });
	
	    return this;
	  }
	});
	
	fabric.util.object.extend(fabric.StaticCanvas.prototype, /** @lends fabric.StaticCanvas.prototype */ {
	
	  /**
	   * Straightens object, then rerenders canvas
	   * @param {fabric.Object} object Object to straighten
	   * @return {fabric.Canvas} thisArg
	   * @chainable
	   */
	  straightenObject: function (object) {
	    object.straighten();
	    this.requestRenderAll();
	    return this;
	  },
	
	  /**
	   * Same as {@link fabric.Canvas.prototype.straightenObject}, but animated
	   * @param {fabric.Object} object Object to straighten
	   * @return {fabric.Canvas} thisArg
	   * @chainable
	   */
	  fxStraightenObject: function (object) {
	    object.fxStraighten({
	      onChange: this.requestRenderAllBound
	    });
	    return this;
	  }
	});
	
	
	(function() {
	
	  'use strict';
	
	  /**
	   * Tests if webgl supports certain precision
	   * @param {WebGL} Canvas WebGL context to test on
	   * @param {String} Precision to test can be any of following: 'lowp', 'mediump', 'highp'
	   * @returns {Boolean} Whether the user's browser WebGL supports given precision.
	   */
	  function testPrecision(gl, precision){
	    var fragmentSource = 'precision ' + precision + ' float;\nvoid main(){}';
	    var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
	    gl.shaderSource(fragmentShader, fragmentSource);
	    gl.compileShader(fragmentShader);
	    if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
	      return false;
	    }
	    return true;
	  }
	
	  /**
	   * Indicate whether this filtering backend is supported by the user's browser.
	   * @param {Number} tileSize check if the tileSize is supported
	   * @returns {Boolean} Whether the user's browser supports WebGL.
	   */
	  fabric.isWebglSupported = function(tileSize) {
	    if (fabric.isLikelyNode) {
	      return false;
	    }
	    tileSize = tileSize || fabric.WebglFilterBackend.prototype.tileSize;
	    var canvas = document.createElement('canvas');
	    var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
	    var isSupported = false;
	    // eslint-disable-next-line
	    if (gl) {
	      fabric.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
	      isSupported = fabric.maxTextureSize >= tileSize;
	      var precisions = ['highp', 'mediump', 'lowp'];
	      for (var i = 0; i < 3; i++){
	        if (testPrecision(gl, precisions[i])){
	          fabric.webGlPrecision = precisions[i];
	          break;
	        };
	      }
	    }
	    this.isSupported = isSupported;
	    return isSupported;
	  };
	
	  fabric.WebglFilterBackend = WebglFilterBackend;
	
	  /**
	   * WebGL filter backend.
	   */
	  function WebglFilterBackend(options) {
	    if (options && options.tileSize) {
	      this.tileSize = options.tileSize;
	    }
	    this.setupGLContext(this.tileSize, this.tileSize);
	    this.captureGPUInfo();
	  };
	
	  WebglFilterBackend.prototype = /** @lends fabric.WebglFilterBackend.prototype */ {
	
	    tileSize: 2048,
	
	    /**
	     * Experimental. This object is a sort of repository of help layers used to avoid
	     * of recreating them during frequent filtering. If you are previewing a filter with
	     * a slider you problably do not want to create help layers every filter step.
	     * in this object there will be appended some canvases, created once, resized sometimes
	     * cleared never. Clearing is left to the developer.
	     **/
	    resources: {
	
	    },
	
	    /**
	     * Setup a WebGL context suitable for filtering, and bind any needed event handlers.
	     */
	    setupGLContext: function(width, height) {
	      this.dispose();
	      this.createWebGLCanvas(width, height);
	      // eslint-disable-next-line
	      this.aPosition = new Float32Array([0, 0, 0, 1, 1, 0, 1, 1]);
	      this.chooseFastestCopyGLTo2DMethod(width, height);
	    },
	
	    /**
	     * Pick a method to copy data from GL context to 2d canvas.  In some browsers using
	     * putImageData is faster than drawImage for that specific operation.
	     */
	    chooseFastestCopyGLTo2DMethod: function(width, height) {
	      var canMeasurePerf = typeof window.performance !== 'undefined', canUseImageData;
	      try {
	        new ImageData(1, 1);
	        canUseImageData = true;
	      }
	      catch (e) {
	        canUseImageData = false;
	      }
	      // eslint-disable-next-line no-undef
	      var canUseArrayBuffer = typeof ArrayBuffer !== 'undefined';
	      // eslint-disable-next-line no-undef
	      var canUseUint8Clamped = typeof Uint8ClampedArray !== 'undefined';
	
	      if (!(canMeasurePerf && canUseImageData && canUseArrayBuffer && canUseUint8Clamped)) {
	        return;
	      }
	
	      var targetCanvas = fabric.util.createCanvasElement();
	      // eslint-disable-next-line no-undef
	      var imageBuffer = new ArrayBuffer(width * height * 4);
	      if (fabric.forceGLPutImageData) {
	        this.imageBuffer = imageBuffer;
	        this.copyGLTo2D = copyGLTo2DPutImageData;
	        return;
	      }
	      var testContext = {
	        imageBuffer: imageBuffer,
	        destinationWidth: width,
	        destinationHeight: height,
	        targetCanvas: targetCanvas
	      };
	      var startTime, drawImageTime, putImageDataTime;
	      targetCanvas.width = width;
	      targetCanvas.height = height;
	
	      startTime = window.performance.now();
	      copyGLTo2DDrawImage.call(testContext, this.gl, testContext);
	      drawImageTime = window.performance.now() - startTime;
	
	      startTime = window.performance.now();
	      copyGLTo2DPutImageData.call(testContext, this.gl, testContext);
	      putImageDataTime = window.performance.now() - startTime;
	
	      if (drawImageTime > putImageDataTime) {
	        this.imageBuffer = imageBuffer;
	        this.copyGLTo2D = copyGLTo2DPutImageData;
	      }
	      else {
	        this.copyGLTo2D = copyGLTo2DDrawImage;
	      }
	    },
	
	    /**
	     * Create a canvas element and associated WebGL context and attaches them as
	     * class properties to the GLFilterBackend class.
	     */
	    createWebGLCanvas: function(width, height) {
	      var canvas = fabric.util.createCanvasElement();
	      canvas.width = width;
	      canvas.height = height;
	      var glOptions = {
	            alpha: true,
	            premultipliedAlpha: false,
	            depth: false,
	            stencil: false,
	            antialias: false
	          },
	          gl = canvas.getContext('webgl', glOptions);
	      if (!gl) {
	        gl = canvas.getContext('experimental-webgl', glOptions);
	      }
	      if (!gl) {
	        return;
	      }
	      gl.clearColor(0, 0, 0, 0);
	      // this canvas can fire webglcontextlost and webglcontextrestored
	      this.canvas = canvas;
	      this.gl = gl;
	    },
	
	    /**
	     * Attempts to apply the requested filters to the source provided, drawing the filtered output
	     * to the provided target canvas.
	     *
	     * @param {Array} filters The filters to apply.
	     * @param {HTMLImageElement|HTMLCanvasElement} source The source to be filtered.
	     * @param {Number} width The width of the source input.
	     * @param {Number} height The height of the source input.
	     * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
	     * @param {String|undefined} cacheKey A key used to cache resources related to the source. If
	     * omitted, caching will be skipped.
	     */
	    applyFilters: function(filters, source, width, height, targetCanvas, cacheKey) {
	      var gl = this.gl;
	      var cachedTexture;
	      if (cacheKey) {
	        cachedTexture = this.getCachedTexture(cacheKey, source);
	      }
	      var pipelineState = {
	        originalWidth: source.width || source.originalWidth,
	        originalHeight: source.height || source.originalHeight,
	        sourceWidth: width,
	        sourceHeight: height,
	        destinationWidth: width,
	        destinationHeight: height,
	        context: gl,
	        sourceTexture: this.createTexture(gl, width, height, !cachedTexture && source),
	        targetTexture: this.createTexture(gl, width, height),
	        originalTexture: cachedTexture ||
	          this.createTexture(gl, width, height, !cachedTexture && source),
	        passes: filters.length,
	        webgl: true,
	        aPosition: this.aPosition,
	        programCache: this.programCache,
	        pass: 0,
	        filterBackend: this,
	        targetCanvas: targetCanvas
	      };
	      var tempFbo = gl.createFramebuffer();
	      gl.bindFramebuffer(gl.FRAMEBUFFER, tempFbo);
	      filters.forEach(function(filter) { filter && filter.applyTo(pipelineState); });
	      resizeCanvasIfNeeded(pipelineState);
	      this.copyGLTo2D(gl, pipelineState);
	      gl.bindTexture(gl.TEXTURE_2D, null);
	      gl.deleteTexture(pipelineState.sourceTexture);
	      gl.deleteTexture(pipelineState.targetTexture);
	      gl.deleteFramebuffer(tempFbo);
	      targetCanvas.getContext('2d').setTransform(1, 0, 0, 1, 0, 0);
	      return pipelineState;
	    },
	
	    /**
	     * Detach event listeners, remove references, and clean up caches.
	     */
	    dispose: function() {
	      if (this.canvas) {
	        this.canvas = null;
	        this.gl = null;
	      }
	      this.clearWebGLCaches();
	    },
	
	    /**
	     * Wipe out WebGL-related caches.
	     */
	    clearWebGLCaches: function() {
	      this.programCache = {};
	      this.textureCache = {};
	    },
	
	    /**
	     * Create a WebGL texture object.
	     *
	     * Accepts specific dimensions to initialize the textuer to or a source image.
	     *
	     * @param {WebGLRenderingContext} gl The GL context to use for creating the texture.
	     * @param {Number} width The width to initialize the texture at.
	     * @param {Number} height The height to initialize the texture.
	     * @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source for the texture data.
	     * @returns {WebGLTexture}
	     */
	    createTexture: function(gl, width, height, textureImageSource) {
	      var texture = gl.createTexture();
	      gl.bindTexture(gl.TEXTURE_2D, texture);
	      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
	      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
	      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
	      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
	      if (textureImageSource) {
	        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, textureImageSource);
	      }
	      else {
	        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
	      }
	      return texture;
	    },
	
	    /**
	     * Can be optionally used to get a texture from the cache array
	     *
	     * If an existing texture is not found, a new texture is created and cached.
	     *
	     * @param {String} uniqueId A cache key to use to find an existing texture.
	     * @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source to use to create the
	     * texture cache entry if one does not already exist.
	     */
	    getCachedTexture: function(uniqueId, textureImageSource) {
	      if (this.textureCache[uniqueId]) {
	        return this.textureCache[uniqueId];
	      }
	      else {
	        var texture = this.createTexture(
	          this.gl, textureImageSource.width, textureImageSource.height, textureImageSource);
	        this.textureCache[uniqueId] = texture;
	        return texture;
	      }
	    },
	
	    /**
	     * Clear out cached resources related to a source image that has been
	     * filtered previously.
	     *
	     * @param {String} cacheKey The cache key provided when the source image was filtered.
	     */
	    evictCachesForKey: function(cacheKey) {
	      if (this.textureCache[cacheKey]) {
	        this.gl.deleteTexture(this.textureCache[cacheKey]);
	        delete this.textureCache[cacheKey];
	      }
	    },
	
	    copyGLTo2D: copyGLTo2DDrawImage,
	
	    /**
	     * Attempt to extract GPU information strings from a WebGL context.
	     *
	     * Useful information when debugging or blacklisting specific GPUs.
	     *
	     * @returns {Object} A GPU info object with renderer and vendor strings.
	     */
	    captureGPUInfo: function() {
	      if (this.gpuInfo) {
	        return this.gpuInfo;
	      }
	      var gl = this.gl, gpuInfo = { renderer: '', vendor: '' };
	      if (!gl) {
	        return gpuInfo;
	      }
	      var ext = gl.getExtension('WEBGL_debug_renderer_info');
	      if (ext) {
	        var renderer = gl.getParameter(ext.UNMASKED_RENDERER_WEBGL);
	        var vendor = gl.getParameter(ext.UNMASKED_VENDOR_WEBGL);
	        if (renderer) {
	          gpuInfo.renderer = renderer.toLowerCase();
	        }
	        if (vendor) {
	          gpuInfo.vendor = vendor.toLowerCase();
	        }
	      }
	      this.gpuInfo = gpuInfo;
	      return gpuInfo;
	    },
	  };
	})();
	
	function resizeCanvasIfNeeded(pipelineState) {
	  var targetCanvas = pipelineState.targetCanvas,
	      width = targetCanvas.width, height = targetCanvas.height,
	      dWidth = pipelineState.destinationWidth,
	      dHeight = pipelineState.destinationHeight;
	
	  if (width !== dWidth || height !== dHeight) {
	    targetCanvas.width = dWidth;
	    targetCanvas.height = dHeight;
	  }
	}
	
	/**
	 * Copy an input WebGL canvas on to an output 2D canvas.
	 *
	 * The WebGL canvas is assumed to be upside down, with the top-left pixel of the
	 * desired output image appearing in the bottom-left corner of the WebGL canvas.
	 *
	 * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
	 * @param {HTMLCanvasElement} targetCanvas The 2D target canvas to copy on to.
	 * @param {Object} pipelineState The 2D target canvas to copy on to.
	 */
	function copyGLTo2DDrawImage(gl, pipelineState) {
	  var glCanvas = gl.canvas, targetCanvas = pipelineState.targetCanvas,
	      ctx = targetCanvas.getContext('2d');
	  ctx.translate(0, targetCanvas.height); // move it down again
	  ctx.scale(1, -1); // vertical flip
	  // where is my image on the big glcanvas?
	  var sourceY = glCanvas.height - targetCanvas.height;
	  ctx.drawImage(glCanvas, 0, sourceY, targetCanvas.width, targetCanvas.height, 0, 0,
	    targetCanvas.width, targetCanvas.height);
	}
	
	/**
	 * Copy an input WebGL canvas on to an output 2D canvas using 2d canvas' putImageData
	 * API. Measurably faster than using ctx.drawImage in Firefox (version 54 on OSX Sierra).
	 *
	 * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
	 * @param {HTMLCanvasElement} targetCanvas The 2D target canvas to copy on to.
	 * @param {Object} pipelineState The 2D target canvas to copy on to.
	 */
	function copyGLTo2DPutImageData(gl, pipelineState) {
	  var targetCanvas = pipelineState.targetCanvas, ctx = targetCanvas.getContext('2d'),
	      dWidth = pipelineState.destinationWidth,
	      dHeight = pipelineState.destinationHeight,
	      numBytes = dWidth * dHeight * 4;
	
	  // eslint-disable-next-line no-undef
	  var u8 = new Uint8Array(this.imageBuffer, 0, numBytes);
	  // eslint-disable-next-line no-undef
	  var u8Clamped = new Uint8ClampedArray(this.imageBuffer, 0, numBytes);
	
	  gl.readPixels(0, 0, dWidth, dHeight, gl.RGBA, gl.UNSIGNED_BYTE, u8);
	  var imgData = new ImageData(u8Clamped, dWidth, dHeight);
	  ctx.putImageData(imgData, 0, 0);
	}
	
	
	(function() {
	
	  'use strict';
	
	  var noop = function() {};
	
	  fabric.Canvas2dFilterBackend = Canvas2dFilterBackend;
	
	  /**
	   * Canvas 2D filter backend.
	   */
	  function Canvas2dFilterBackend() {};
	
	  Canvas2dFilterBackend.prototype = /** @lends fabric.Canvas2dFilterBackend.prototype */ {
	    evictCachesForKey: noop,
	    dispose: noop,
	    clearWebGLCaches: noop,
	
	    /**
	     * Experimental. This object is a sort of repository of help layers used to avoid
	     * of recreating them during frequent filtering. If you are previewing a filter with
	     * a slider you probably do not want to create help layers every filter step.
	     * in this object there will be appended some canvases, created once, resized sometimes
	     * cleared never. Clearing is left to the developer.
	     **/
	    resources: {
	
	    },
	
	    /**
	     * Apply a set of filters against a source image and draw the filtered output
	     * to the provided destination canvas.
	     *
	     * @param {EnhancedFilter} filters The filter to apply.
	     * @param {HTMLImageElement|HTMLCanvasElement} sourceElement The source to be filtered.
	     * @param {Number} sourceWidth The width of the source input.
	     * @param {Number} sourceHeight The height of the source input.
	     * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
	     */
	    applyFilters: function(filters, sourceElement, sourceWidth, sourceHeight, targetCanvas) {
	      var ctx = targetCanvas.getContext('2d');
	      ctx.drawImage(sourceElement, 0, 0, sourceWidth, sourceHeight);
	      var imageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
	      var originalImageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
	      var pipelineState = {
	        sourceWidth: sourceWidth,
	        sourceHeight: sourceHeight,
	        imageData: imageData,
	        originalEl: sourceElement,
	        originalImageData: originalImageData,
	        canvasEl: targetCanvas,
	        ctx: ctx,
	        filterBackend: this,
	      };
	      filters.forEach(function(filter) { filter.applyTo(pipelineState); });
	      if (pipelineState.imageData.width !== sourceWidth || pipelineState.imageData.height !== sourceHeight) {
	        targetCanvas.width = pipelineState.imageData.width;
	        targetCanvas.height = pipelineState.imageData.height;
	      }
	      ctx.putImageData(pipelineState.imageData, 0, 0);
	      return pipelineState;
	    },
	
	  };
	})();
	
	
	/**
	 * @namespace fabric.Image.filters
	 * @memberOf fabric.Image
	 * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#image_filters}
	 * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	 */
	fabric.Image = fabric.Image || { };
	fabric.Image.filters = fabric.Image.filters || { };
	
	/**
	 * Root filter class from which all filter classes inherit from
	 * @class fabric.Image.filters.BaseFilter
	 * @memberOf fabric.Image.filters
	 */
	fabric.Image.filters.BaseFilter = fabric.util.createClass(/** @lends fabric.Image.filters.BaseFilter.prototype */ {
	
	  /**
	   * Filter type
	   * @param {String} type
	   * @default
	   */
	  type: 'BaseFilter',
	
	  /**
	   * Array of attributes to send with buffers. do not modify
	   * @private
	   */
	
	  vertexSource: 'attribute vec2 aPosition;\n' +
	    'varying vec2 vTexCoord;\n' +
	    'void main() {\n' +
	      'vTexCoord = aPosition;\n' +
	      'gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n' +
	    '}',
	
	  fragmentSource: 'precision highp float;\n' +
	    'varying vec2 vTexCoord;\n' +
	    'uniform sampler2D uTexture;\n' +
	    'void main() {\n' +
	      'gl_FragColor = texture2D(uTexture, vTexCoord);\n' +
	    '}',
	
	  /**
	   * Constructor
	   * @param {Object} [options] Options object
	   */
	  initialize: function(options) {
	    if (options) {
	      this.setOptions(options);
	    }
	  },
	
	  /**
	   * Sets filter's properties from options
	   * @param {Object} [options] Options object
	   */
	  setOptions: function(options) {
	    for (var prop in options) {
	      this[prop] = options[prop];
	    }
	  },
	
	  /**
	   * Compile this filter's shader program.
	   *
	   * @param {WebGLRenderingContext} gl The GL canvas context to use for shader compilation.
	   * @param {String} fragmentSource fragmentShader source for compilation
	   * @param {String} vertexSource vertexShader source for compilation
	   */
	  createProgram: function(gl, fragmentSource, vertexSource) {
	    fragmentSource = fragmentSource || this.fragmentSource;
	    vertexSource = vertexSource || this.vertexSource;
	    if (fabric.webGlPrecision !== 'highp'){
	      fragmentSource = fragmentSource.replace(
	        /precision highp float/g,
	        'precision ' + fabric.webGlPrecision + ' float'
	      );
	    }
	    var vertexShader = gl.createShader(gl.VERTEX_SHADER);
	    gl.shaderSource(vertexShader, vertexSource);
	    gl.compileShader(vertexShader);
	    if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) {
	      throw new Error(
	        // eslint-disable-next-line prefer-template
	        'Vertex shader compile error for ' + this.type + ': ' +
	        gl.getShaderInfoLog(vertexShader)
	      );
	    }
	
	    var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
	    gl.shaderSource(fragmentShader, fragmentSource);
	    gl.compileShader(fragmentShader);
	    if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
	      throw new Error(
	        // eslint-disable-next-line prefer-template
	        'Fragment shader compile error for ' + this.type + ': ' +
	        gl.getShaderInfoLog(fragmentShader)
	      );
	    }
	
	    var program = gl.createProgram();
	    gl.attachShader(program, vertexShader);
	    gl.attachShader(program, fragmentShader);
	    gl.linkProgram(program);
	    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
	      throw new Error(
	        // eslint-disable-next-line prefer-template
	        'Shader link error for "${this.type}" ' +
	        gl.getProgramInfoLog(program)
	      );
	    }
	
	    var attributeLocations = this.getAttributeLocations(gl, program);
	    var uniformLocations = this.getUniformLocations(gl, program) || { };
	    uniformLocations.uStepW = gl.getUniformLocation(program, 'uStepW');
	    uniformLocations.uStepH = gl.getUniformLocation(program, 'uStepH');
	    return {
	      program: program,
	      attributeLocations: attributeLocations,
	      uniformLocations: uniformLocations
	    };
	  },
	
	  /**
	   * Return a map of attribute names to WebGLAttributeLocation objects.
	   *
	   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
	   * @param {WebGLShaderProgram} program The shader program from which to take attribute locations.
	   * @returns {Object} A map of attribute names to attribute locations.
	   */
	  getAttributeLocations: function(gl, program) {
	    return {
	      aPosition: gl.getAttribLocation(program, 'aPosition'),
	    };
	  },
	
	  /**
	   * Return a map of uniform names to WebGLUniformLocation objects.
	   *
	   * Intended to be overridden by subclasses.
	   *
	   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
	   * @param {WebGLShaderProgram} program The shader program from which to take uniform locations.
	   * @returns {Object} A map of uniform names to uniform locations.
	   */
	  getUniformLocations: function (/* gl, program */) {
	    // in case i do not need any special uniform i need to return an empty object
	    return { };
	  },
	
	  /**
	   * Send attribute data from this filter to its shader program on the GPU.
	   *
	   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
	   * @param {Object} attributeLocations A map of shader attribute names to their locations.
	   */
	  sendAttributeData: function(gl, attributeLocations, aPositionData) {
	    var attributeLocation = attributeLocations.aPosition;
	    var buffer = gl.createBuffer();
	    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
	    gl.enableVertexAttribArray(attributeLocation);
	    gl.vertexAttribPointer(attributeLocation, 2, gl.FLOAT, false, 0, 0);
	    gl.bufferData(gl.ARRAY_BUFFER, aPositionData, gl.STATIC_DRAW);
	  },
	
	  _setupFrameBuffer: function(options) {
	    var gl = options.context, width, height;
	    if (options.passes > 1) {
	      width = options.destinationWidth;
	      height = options.destinationHeight;
	      if (options.sourceWidth !== width || options.sourceHeight !== height) {
	        gl.deleteTexture(options.targetTexture);
	        options.targetTexture = options.filterBackend.createTexture(gl, width, height);
	      }
	      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D,
	        options.targetTexture, 0);
	    }
	    else {
	      // draw last filter on canvas and not to framebuffer.
	      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
	      gl.finish();
	    }
	  },
	
	  _swapTextures: function(options) {
	    options.passes--;
	    options.pass++;
	    var temp = options.targetTexture;
	    options.targetTexture = options.sourceTexture;
	    options.sourceTexture = temp;
	  },
	
	  /**
	   * Generic isNeutral implementation for one parameter based filters.
	   * Used only in image applyFilters to discard filters that will not have an effect
	   * on the image
	   * Other filters may need their own verison ( ColorMatrix, HueRotation, gamma, ComposedFilter )
	   * @param {Object} options
	   **/
	  isNeutralState: function(/* options */) {
	    var main = this.mainParameter,
	        _class = fabric.Image.filters[this.type].prototype;
	    if (main) {
	      if (Array.isArray(_class[main])) {
	        for (var i = _class[main].length; i--;) {
	          if (this[main][i] !== _class[main][i]) {
	            return false;
	          }
	        }
	        return true;
	      }
	      else {
	        return _class[main] === this[main];
	      }
	    }
	    else {
	      return false;
	    }
	  },
	
	  /**
	   * Apply this filter to the input image data provided.
	   *
	   * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
	   *
	   * @param {Object} options
	   * @param {Number} options.passes The number of filters remaining to be executed
	   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
	   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
	   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
	   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	   */
	  applyTo: function(options) {
	    if (options.webgl) {
	      this._setupFrameBuffer(options);
	      this.applyToWebGL(options);
	      this._swapTextures(options);
	    }
	    else {
	      this.applyTo2d(options);
	    }
	  },
	
	  /**
	   * Retrieves the cached shader.
	   * @param {Object} options
	   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	   */
	  retrieveShader: function(options) {
	    if (!options.programCache.hasOwnProperty(this.type)) {
	      options.programCache[this.type] = this.createProgram(options.context);
	    }
	    return options.programCache[this.type];
	  },
	
	  /**
	   * Apply this filter using webgl.
	   *
	   * @param {Object} options
	   * @param {Number} options.passes The number of filters remaining to be executed
	   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
	   * @param {WebGLTexture} options.originalTexture The texture of the original input image.
	   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
	   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
	   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	   */
	  applyToWebGL: function(options) {
	    var gl = options.context;
	    var shader = this.retrieveShader(options);
	    if (options.pass === 0 && options.originalTexture) {
	      gl.bindTexture(gl.TEXTURE_2D, options.originalTexture);
	    }
	    else {
	      gl.bindTexture(gl.TEXTURE_2D, options.sourceTexture);
	    }
	    gl.useProgram(shader.program);
	    this.sendAttributeData(gl, shader.attributeLocations, options.aPosition);
	
	    gl.uniform1f(shader.uniformLocations.uStepW, 1 / options.sourceWidth);
	    gl.uniform1f(shader.uniformLocations.uStepH, 1 / options.sourceHeight);
	
	    this.sendUniformData(gl, shader.uniformLocations);
	    gl.viewport(0, 0, options.destinationWidth, options.destinationHeight);
	    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
	  },
	
	  bindAdditionalTexture: function(gl, texture, textureUnit) {
	    gl.activeTexture(textureUnit);
	    gl.bindTexture(gl.TEXTURE_2D, texture);
	    // reset active texture to 0 as usual
	    gl.activeTexture(gl.TEXTURE0);
	  },
	
	  unbindAdditionalTexture: function(gl, textureUnit) {
	    gl.activeTexture(textureUnit);
	    gl.bindTexture(gl.TEXTURE_2D, null);
	    gl.activeTexture(gl.TEXTURE0);
	  },
	
	  getMainParameter: function() {
	    return this[this.mainParameter];
	  },
	
	  setMainParameter: function(value) {
	    this[this.mainParameter] = value;
	  },
	
	  /**
	   * Send uniform data from this filter to its shader program on the GPU.
	   *
	   * Intended to be overridden by subclasses.
	   *
	   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
	   * @param {Object} uniformLocations A map of shader uniform names to their locations.
	   */
	  sendUniformData: function(/* gl, uniformLocations */) {
	    // Intentionally left blank.  Override me in subclasses.
	  },
	
	  /**
	   * If needed by a 2d filter, this functions can create an helper canvas to be used
	   * remember that options.targetCanvas is available for use till end of chain.
	   */
	  createHelpLayer: function(options) {
	    if (!options.helpLayer) {
	      var helpLayer = document.createElement('canvas');
	      helpLayer.width = options.sourceWidth;
	      helpLayer.height = options.sourceHeight;
	      options.helpLayer = helpLayer;
	    }
	  },
	
	  /**
	   * Returns object representation of an instance
	   * @return {Object} Object representation of an instance
	   */
	  toObject: function() {
	    var object = { type: this.type }, mainP = this.mainParameter;
	    if (mainP) {
	      object[mainP] = this[mainP];
	    }
	    return object;
	  },
	
	  /**
	   * Returns a JSON representation of an instance
	   * @return {Object} JSON
	   */
	  toJSON: function() {
	    // delegate, not alias
	    return this.toObject();
	  }
	});
	
	fabric.Image.filters.BaseFilter.fromObject = function(object, callback) {
	  var filter = new fabric.Image.filters[object.type](object);
	  callback && callback(filter);
	  return filter;
	};
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;
	
	  /**
	   * Color Matrix filter class
	   * @class fabric.Image.filters.ColorMatrix
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.ColorMatrix#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @see {@Link http://www.webwasp.co.uk/tutorials/219/Color_Matrix_Filter.php}
	   * @see {@Link http://phoboslab.org/log/2013/11/fast-image-filters-with-webgl}
	   * @example <caption>Kodachrome filter</caption>
	   * var filter = new fabric.Image.filters.ColorMatrix({
	   *  matrix: [
	       1.1285582396593525, -0.3967382283601348, -0.03992559172921793, 0, 63.72958762196502,
	       -0.16404339962244616, 1.0835251566291304, -0.05498805115633132, 0, 24.732407896706203,
	       -0.16786010706155763, -0.5603416277695248, 1.6014850761964943, 0, 35.62982807460946,
	       0, 0, 0, 1, 0
	      ]
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   */
	  filters.ColorMatrix = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.ColorMatrix.prototype */ {
	
	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'ColorMatrix',
	
	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'uniform mat4 uColorMatrix;\n' +
	      'uniform vec4 uConstants;\n' +
	      'void main() {\n' +
	        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	        'color *= uColorMatrix;\n' +
	        'color += uConstants;\n' +
	        'gl_FragColor = color;\n' +
	      '}',
	
	    /**
	     * Colormatrix for pixels.
	     * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
	     * outside the -1, 1 range.
	     * 0.0039215686 is the part of 1 that get translated to 1 in 2d
	     * @param {Array} matrix array of 20 numbers.
	     * @default
	     */
	    matrix: [
	      1, 0, 0, 0, 0,
	      0, 1, 0, 0, 0,
	      0, 0, 1, 0, 0,
	      0, 0, 0, 1, 0
	    ],
	
	    mainParameter: 'matrix',
	
	    /**
	     * Lock the colormatrix on the color part, skipping alpha, manly for non webgl scenario
	     * to save some calculation
	     */
	    colorsOnly: true,
	
	    /**
	     * Constructor
	     * @param {Object} [options] Options object
	     */
	    initialize: function(options) {
	      this.callSuper('initialize', options);
	      // create a new array instead mutating the prototype with push
	      this.matrix = this.matrix.slice(0);
	    },
	
	    /**
	     * Apply the ColorMatrix operation to a Uint8Array representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8Array to be filtered.
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData,
	          data = imageData.data,
	          iLen = data.length,
	          m = this.matrix,
	          r, g, b, a, i, colorsOnly = this.colorsOnly;
	
	      for (i = 0; i < iLen; i += 4) {
	        r = data[i];
	        g = data[i + 1];
	        b = data[i + 2];
	        if (colorsOnly) {
	          data[i] = r * m[0] + g * m[1] + b * m[2] + m[4] * 255;
	          data[i + 1] = r * m[5] + g * m[6] + b * m[7] + m[9] * 255;
	          data[i + 2] = r * m[10] + g * m[11] + b * m[12] + m[14] * 255;
	        }
	        else {
	          a = data[i + 3];
	          data[i] = r * m[0] + g * m[1] + b * m[2] + a * m[3] + m[4] * 255;
	          data[i + 1] = r * m[5] + g * m[6] + b * m[7] + a * m[8] + m[9] * 255;
	          data[i + 2] = r * m[10] + g * m[11] + b * m[12] + a * m[13] + m[14] * 255;
	          data[i + 3] = r * m[15] + g * m[16] + b * m[17] + a * m[18] + m[19] * 255;
	        }
	      }
	    },
	
	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uColorMatrix: gl.getUniformLocation(program, 'uColorMatrix'),
	        uConstants: gl.getUniformLocation(program, 'uConstants'),
	      };
	    },
	
	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      var m = this.matrix,
	          matrix = [
	            m[0], m[1], m[2], m[3],
	            m[5], m[6], m[7], m[8],
	            m[10], m[11], m[12], m[13],
	            m[15], m[16], m[17], m[18]
	          ],
	          constants = [m[4], m[9], m[14], m[19]];
	      gl.uniformMatrix4fv(uniformLocations.uColorMatrix, false, matrix);
	      gl.uniform4fv(uniformLocations.uConstants, constants);
	    },
	  });
	
	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] function to invoke after filter creation
	   * @return {fabric.Image.filters.ColorMatrix} Instance of fabric.Image.filters.ColorMatrix
	   */
	  fabric.Image.filters.ColorMatrix.fromObject = fabric.Image.filters.BaseFilter.fromObject;
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;
	
	  /**
	   * Brightness filter class
	   * @class fabric.Image.filters.Brightness
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.Brightness#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Brightness({
	   *   brightness: 0.05
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   */
	  filters.Brightness = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Brightness.prototype */ {
	
	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Brightness',
	
	    /**
	     * Fragment source for the brightness program
	     */
	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform float uBrightness;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'void main() {\n' +
	        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	        'color.rgb += uBrightness;\n' +
	        'gl_FragColor = color;\n' +
	      '}',
	
	    /**
	     * Brightness value, from -1 to 1.
	     * translated to -255 to 255 for 2d
	     * 0.0039215686 is the part of 1 that get translated to 1 in 2d
	     * @param {Number} brightness
	     * @default
	     */
	    brightness: 0,
	
	    /**
	     * Describe the property that is the filter parameter
	     * @param {String} m
	     * @default
	     */
	    mainParameter: 'brightness',
	
	    /**
	    * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
	    *
	    * @param {Object} options
	    * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	    */
	    applyTo2d: function(options) {
	      if (this.brightness === 0) {
	        return;
	      }
	      var imageData = options.imageData,
	          data = imageData.data, i, len = data.length,
	          brightness = Math.round(this.brightness * 255);
	      for (i = 0; i < len; i += 4) {
	        data[i] = data[i] + brightness;
	        data[i + 1] = data[i + 1] + brightness;
	        data[i + 2] = data[i + 2] + brightness;
	      }
	    },
	
	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uBrightness: gl.getUniformLocation(program, 'uBrightness'),
	      };
	    },
	
	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      gl.uniform1f(uniformLocations.uBrightness, this.brightness);
	    },
	  });
	
	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Brightness} Instance of fabric.Image.filters.Brightness
	   */
	  fabric.Image.filters.Brightness.fromObject = fabric.Image.filters.BaseFilter.fromObject;
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric  = global.fabric || (global.fabric = { }),
	      extend = fabric.util.object.extend,
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;
	
	  /**
	   * Adapted from <a href="http://www.html5rocks.com/en/tutorials/canvas/imagefilters/">html5rocks article</a>
	   * @class fabric.Image.filters.Convolute
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.Convolute#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example <caption>Sharpen filter</caption>
	   * var filter = new fabric.Image.filters.Convolute({
	   *   matrix: [ 0, -1,  0,
	   *            -1,  5, -1,
	   *             0, -1,  0 ]
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   * canvas.renderAll();
	   * @example <caption>Blur filter</caption>
	   * var filter = new fabric.Image.filters.Convolute({
	   *   matrix: [ 1/9, 1/9, 1/9,
	   *             1/9, 1/9, 1/9,
	   *             1/9, 1/9, 1/9 ]
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   * canvas.renderAll();
	   * @example <caption>Emboss filter</caption>
	   * var filter = new fabric.Image.filters.Convolute({
	   *   matrix: [ 1,   1,  1,
	   *             1, 0.7, -1,
	   *            -1,  -1, -1 ]
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   * canvas.renderAll();
	   * @example <caption>Emboss filter with opaqueness</caption>
	   * var filter = new fabric.Image.filters.Convolute({
	   *   opaque: true,
	   *   matrix: [ 1,   1,  1,
	   *             1, 0.7, -1,
	   *            -1,  -1, -1 ]
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   * canvas.renderAll();
	   */
	  filters.Convolute = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Convolute.prototype */ {
	
	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Convolute',
	
	    /*
	     * Opaque value (true/false)
	     */
	    opaque: false,
	
	    /*
	     * matrix for the filter, max 9x9
	     */
	    matrix: [0, 0, 0, 0, 1, 0, 0, 0, 0],
	
	    /**
	     * Fragment source for the brightness program
	     */
	    fragmentSource: {
	      Convolute_3_1: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform float uMatrix[9];\n' +
	        'uniform float uStepW;\n' +
	        'uniform float uStepH;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = vec4(0, 0, 0, 0);\n' +
	          'for (float h = 0.0; h < 3.0; h+=1.0) {\n' +
	            'for (float w = 0.0; w < 3.0; w+=1.0) {\n' +
	              'vec2 matrixPos = vec2(uStepW * (w - 1), uStepH * (h - 1));\n' +
	              'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 3.0 + w)];\n' +
	            '}\n' +
	          '}\n' +
	          'gl_FragColor = color;\n' +
	        '}',
	      Convolute_3_0: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform float uMatrix[9];\n' +
	        'uniform float uStepW;\n' +
	        'uniform float uStepH;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = vec4(0, 0, 0, 1);\n' +
	          'for (float h = 0.0; h < 3.0; h+=1.0) {\n' +
	            'for (float w = 0.0; w < 3.0; w+=1.0) {\n' +
	              'vec2 matrixPos = vec2(uStepW * (w - 1.0), uStepH * (h - 1.0));\n' +
	              'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 3.0 + w)];\n' +
	            '}\n' +
	          '}\n' +
	          'float alpha = texture2D(uTexture, vTexCoord).a;\n' +
	          'gl_FragColor = color;\n' +
	          'gl_FragColor.a = alpha;\n' +
	        '}',
	      Convolute_5_1: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform float uMatrix[25];\n' +
	        'uniform float uStepW;\n' +
	        'uniform float uStepH;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = vec4(0, 0, 0, 0);\n' +
	          'for (float h = 0.0; h < 5.0; h+=1.0) {\n' +
	            'for (float w = 0.0; w < 5.0; w+=1.0) {\n' +
	              'vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\n' +
	              'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 5.0 + w)];\n' +
	            '}\n' +
	          '}\n' +
	          'gl_FragColor = color;\n' +
	        '}',
	      Convolute_5_0: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform float uMatrix[25];\n' +
	        'uniform float uStepW;\n' +
	        'uniform float uStepH;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = vec4(0, 0, 0, 1);\n' +
	          'for (float h = 0.0; h < 5.0; h+=1.0) {\n' +
	            'for (float w = 0.0; w < 5.0; w+=1.0) {\n' +
	              'vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\n' +
	              'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 5.0 + w)];\n' +
	            '}\n' +
	          '}\n' +
	          'float alpha = texture2D(uTexture, vTexCoord).a;\n' +
	          'gl_FragColor = color;\n' +
	          'gl_FragColor.a = alpha;\n' +
	        '}',
	      Convolute_7_1: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform float uMatrix[49];\n' +
	        'uniform float uStepW;\n' +
	        'uniform float uStepH;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = vec4(0, 0, 0, 0);\n' +
	          'for (float h = 0.0; h < 7.0; h+=1.0) {\n' +
	            'for (float w = 0.0; w < 7.0; w+=1.0) {\n' +
	              'vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\n' +
	              'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 7.0 + w)];\n' +
	            '}\n' +
	          '}\n' +
	          'gl_FragColor = color;\n' +
	        '}',
	      Convolute_7_0: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform float uMatrix[49];\n' +
	        'uniform float uStepW;\n' +
	        'uniform float uStepH;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = vec4(0, 0, 0, 1);\n' +
	          'for (float h = 0.0; h < 7.0; h+=1.0) {\n' +
	            'for (float w = 0.0; w < 7.0; w+=1.0) {\n' +
	              'vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\n' +
	              'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 7.0 + w)];\n' +
	            '}\n' +
	          '}\n' +
	          'float alpha = texture2D(uTexture, vTexCoord).a;\n' +
	          'gl_FragColor = color;\n' +
	          'gl_FragColor.a = alpha;\n' +
	        '}',
	      Convolute_9_1: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform float uMatrix[81];\n' +
	        'uniform float uStepW;\n' +
	        'uniform float uStepH;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = vec4(0, 0, 0, 0);\n' +
	          'for (float h = 0.0; h < 9.0; h+=1.0) {\n' +
	            'for (float w = 0.0; w < 9.0; w+=1.0) {\n' +
	              'vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\n' +
	              'color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 9.0 + w)];\n' +
	            '}\n' +
	          '}\n' +
	          'gl_FragColor = color;\n' +
	        '}',
	      Convolute_9_0: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform float uMatrix[81];\n' +
	        'uniform float uStepW;\n' +
	        'uniform float uStepH;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = vec4(0, 0, 0, 1);\n' +
	          'for (float h = 0.0; h < 9.0; h+=1.0) {\n' +
	            'for (float w = 0.0; w < 9.0; w+=1.0) {\n' +
	              'vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\n' +
	              'color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 9.0 + w)];\n' +
	            '}\n' +
	          '}\n' +
	          'float alpha = texture2D(uTexture, vTexCoord).a;\n' +
	          'gl_FragColor = color;\n' +
	          'gl_FragColor.a = alpha;\n' +
	        '}',
	    },
	
	    /**
	     * Constructor
	     * @memberOf fabric.Image.filters.Convolute.prototype
	     * @param {Object} [options] Options object
	     * @param {Boolean} [options.opaque=false] Opaque value (true/false)
	     * @param {Array} [options.matrix] Filter matrix
	     */
	
	
	    /**
	    * Retrieves the cached shader.
	    * @param {Object} options
	    * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	    * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	    */
	    retrieveShader: function(options) {
	      var size = Math.sqrt(this.matrix.length);
	      var cacheKey = this.type + '_' + size + '_' + (this.opaque ? 1 : 0);
	      var shaderSource = this.fragmentSource[cacheKey];
	      if (!options.programCache.hasOwnProperty(cacheKey)) {
	        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
	      }
	      return options.programCache[cacheKey];
	    },
	
	    /**
	     * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData,
	          data = imageData.data,
	          weights = this.matrix,
	          side = Math.round(Math.sqrt(weights.length)),
	          halfSide = Math.floor(side / 2),
	          sw = imageData.width,
	          sh = imageData.height,
	          output = options.ctx.createImageData(sw, sh),
	          dst = output.data,
	          // go through the destination image pixels
	          alphaFac = this.opaque ? 1 : 0,
	          r, g, b, a, dstOff,
	          scx, scy, srcOff, wt,
	          x, y, cx, cy;
	
	      for (y = 0; y < sh; y++) {
	        for (x = 0; x < sw; x++) {
	          dstOff = (y * sw + x) * 4;
	          // calculate the weighed sum of the source image pixels that
	          // fall under the convolution matrix
	          r = 0; g = 0; b = 0; a = 0;
	
	          for (cy = 0; cy < side; cy++) {
	            for (cx = 0; cx < side; cx++) {
	              scy = y + cy - halfSide;
	              scx = x + cx - halfSide;
	
	              // eslint-disable-next-line max-depth
	              if (scy < 0 || scy > sh || scx < 0 || scx > sw) {
	                continue;
	              }
	
	              srcOff = (scy * sw + scx) * 4;
	              wt = weights[cy * side + cx];
	
	              r += data[srcOff] * wt;
	              g += data[srcOff + 1] * wt;
	              b += data[srcOff + 2] * wt;
	              // eslint-disable-next-line max-depth
	              if (!alphaFac) {
	                a += data[srcOff + 3] * wt;
	              }
	            }
	          }
	          dst[dstOff] = r;
	          dst[dstOff + 1] = g;
	          dst[dstOff + 2] = b;
	          if (!alphaFac) {
	            dst[dstOff + 3] = a;
	          }
	          else {
	            dst[dstOff + 3] = data[dstOff + 3];
	          }
	        }
	      }
	      options.imageData = output;
	    },
	
	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uMatrix: gl.getUniformLocation(program, 'uMatrix'),
	        uOpaque: gl.getUniformLocation(program, 'uOpaque'),
	        uHalfSize: gl.getUniformLocation(program, 'uHalfSize'),
	        uSize: gl.getUniformLocation(program, 'uSize'),
	      };
	    },
	
	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      gl.uniform1fv(uniformLocations.uMatrix, this.matrix);
	    },
	
	    /**
	     * Returns object representation of an instance
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function() {
	      return extend(this.callSuper('toObject'), {
	        opaque: this.opaque,
	        matrix: this.matrix
	      });
	    }
	  });
	
	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Convolute} Instance of fabric.Image.filters.Convolute
	   */
	  fabric.Image.filters.Convolute.fromObject = fabric.Image.filters.BaseFilter.fromObject;
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;
	
	  /**
	   * Grayscale image filter class
	   * @class fabric.Image.filters.Grayscale
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Grayscale();
	   * object.filters.push(filter);
	   * object.applyFilters();
	   */
	  filters.Grayscale = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Grayscale.prototype */ {
	
	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Grayscale',
	
	    fragmentSource: {
	      average: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	          'float average = (color.r + color.b + color.g) / 3.0;\n' +
	          'gl_FragColor = vec4(average, average, average, color.a);\n' +
	        '}',
	      lightness: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform int uMode;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 col = texture2D(uTexture, vTexCoord);\n' +
	          'float average = (max(max(col.r, col.g),col.b) + min(min(col.r, col.g),col.b)) / 2.0;\n' +
	          'gl_FragColor = vec4(average, average, average, col.a);\n' +
	        '}',
	      luminosity: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform int uMode;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 col = texture2D(uTexture, vTexCoord);\n' +
	          'float average = 0.21 * col.r + 0.72 * col.g + 0.07 * col.b;\n' +
	          'gl_FragColor = vec4(average, average, average, col.a);\n' +
	        '}',
	    },
	
	
	    /**
	     * Grayscale mode, between 'average', 'lightness', 'luminosity'
	     * @param {String} type
	     * @default
	     */
	    mode: 'average',
	
	    mainParameter: 'mode',
	
	    /**
	     * Apply the Grayscale operation to a Uint8Array representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8Array to be filtered.
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData,
	          data = imageData.data, i,
	          len = data.length, value,
	          mode = this.mode;
	      for (i = 0; i < len; i += 4) {
	        if (mode === 'average') {
	          value = (data[i] + data[i + 1] + data[i + 2]) / 3;
	        }
	        else if (mode === 'lightness') {
	          value = (Math.min(data[i], data[i + 1], data[i + 2]) +
	            Math.max(data[i], data[i + 1], data[i + 2])) / 2;
	        }
	        else if (mode === 'luminosity') {
	          value = 0.21 * data[i] + 0.72 * data[i + 1] + 0.07 * data[i + 2];
	        }
	        data[i] = value;
	        data[i + 1] = value;
	        data[i + 2] = value;
	      }
	    },
	
	    /**
	     * Retrieves the cached shader.
	     * @param {Object} options
	     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	     */
	    retrieveShader: function(options) {
	      var cacheKey = this.type + '_' + this.mode;
	      if (!options.programCache.hasOwnProperty(cacheKey)) {
	        var shaderSource = this.fragmentSource[this.mode];
	        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
	      }
	      return options.programCache[cacheKey];
	    },
	
	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uMode: gl.getUniformLocation(program, 'uMode'),
	      };
	    },
	
	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      // default average mode.
	      var mode = 1;
	      gl.uniform1i(uniformLocations.uMode, mode);
	    },
	
	    /**
	     * Grayscale filter isNeutralState implementation
	     * The filter is never neutral
	     * on the image
	     **/
	    isNeutralState: function() {
	      return false;
	    },
	  });
	
	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Grayscale} Instance of fabric.Image.filters.Grayscale
	   */
	  fabric.Image.filters.Grayscale.fromObject = fabric.Image.filters.BaseFilter.fromObject;
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;
	
	  /**
	   * Invert filter class
	   * @class fabric.Image.filters.Invert
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Invert();
	   * object.filters.push(filter);
	   * object.applyFilters(canvas.renderAll.bind(canvas));
	   */
	  filters.Invert = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Invert.prototype */ {
	
	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Invert',
	
	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform int uInvert;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'void main() {\n' +
	        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	        'if (uInvert == 1) {\n' +
	          'gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,color.a);\n' +
	        '} else {\n' +
	          'gl_FragColor = color;\n' +
	        '}\n' +
	      '}',
	
	    /**
	     * Filter invert. if false, does nothing
	     * @param {Boolean} invert
	     * @default
	     */
	    invert: true,
	
	    mainParameter: 'invert',
	
	    /**
	     * Apply the Invert operation to a Uint8Array representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8Array to be filtered.
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData,
	          data = imageData.data, i,
	          len = data.length;
	      for (i = 0; i < len; i += 4) {
	        data[i] = 255 - data[i];
	        data[i + 1] = 255 - data[i + 1];
	        data[i + 2] = 255 - data[i + 2];
	      }
	    },
	
	    /**
	     * Invert filter isNeutralState implementation
	     * Used only in image applyFilters to discard filters that will not have an effect
	     * on the image
	     * @param {Object} options
	     **/
	    isNeutralState: function() {
	      return !this.invert;
	    },
	
	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uInvert: gl.getUniformLocation(program, 'uInvert'),
	      };
	    },
	
	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      gl.uniform1i(uniformLocations.uInvert, this.invert);
	    },
	  });
	
	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Invert} Instance of fabric.Image.filters.Invert
	   */
	  fabric.Image.filters.Invert.fromObject = fabric.Image.filters.BaseFilter.fromObject;
	
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric  = global.fabric || (global.fabric = { }),
	      extend = fabric.util.object.extend,
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;
	
	  /**
	   * Noise filter class
	   * @class fabric.Image.filters.Noise
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.Noise#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Noise({
	   *   noise: 700
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   * canvas.renderAll();
	   */
	  filters.Noise = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Noise.prototype */ {
	
	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Noise',
	
	    /**
	     * Fragment source for the noise program
	     */
	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform float uStepH;\n' +
	      'uniform float uNoise;\n' +
	      'uniform float uSeed;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'float rand(vec2 co, float seed, float vScale) {\n' +
	        'return fract(sin(dot(co.xy * vScale ,vec2(12.9898 , 78.233))) * 43758.5453 * (seed + 0.01) / 2.0);\n' +
	      '}\n' +
	      'void main() {\n' +
	        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	        'color.rgb += (0.5 - rand(vTexCoord, uSeed, 0.1 / uStepH)) * uNoise;\n' +
	        'gl_FragColor = color;\n' +
	      '}',
	
	    /**
	     * Describe the property that is the filter parameter
	     * @param {String} m
	     * @default
	     */
	    mainParameter: 'noise',
	
	    /**
	     * Noise value, from
	     * @param {Number} noise
	     * @default
	     */
	    noise: 0,
	
	    /**
	     * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	     */
	    applyTo2d: function(options) {
	      if (this.noise === 0) {
	        return;
	      }
	      var imageData = options.imageData,
	          data = imageData.data, i, len = data.length,
	          noise = this.noise, rand;
	
	      for (i = 0, len = data.length; i < len; i += 4) {
	
	        rand = (0.5 - Math.random()) * noise;
	
	        data[i] += rand;
	        data[i + 1] += rand;
	        data[i + 2] += rand;
	      }
	    },
	
	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uNoise: gl.getUniformLocation(program, 'uNoise'),
	        uSeed: gl.getUniformLocation(program, 'uSeed'),
	      };
	    },
	
	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      gl.uniform1f(uniformLocations.uNoise, this.noise / 255);
	      gl.uniform1f(uniformLocations.uSeed, Math.random());
	    },
	
	    /**
	     * Returns object representation of an instance
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function() {
	      return extend(this.callSuper('toObject'), {
	        noise: this.noise
	      });
	    }
	  });
	
	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Noise} Instance of fabric.Image.filters.Noise
	   */
	  fabric.Image.filters.Noise.fromObject = fabric.Image.filters.BaseFilter.fromObject;
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;
	
	  /**
	   * Pixelate filter class
	   * @class fabric.Image.filters.Pixelate
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.Pixelate#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Pixelate({
	   *   blocksize: 8
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   */
	  filters.Pixelate = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Pixelate.prototype */ {
	
	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Pixelate',
	
	    blocksize: 4,
	
	    mainParameter: 'blocksize',
	
	    /**
	     * Fragment source for the Pixelate program
	     */
	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform float uBlocksize;\n' +
	      'uniform float uStepW;\n' +
	      'uniform float uStepH;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'void main() {\n' +
	        'float blockW = uBlocksize * uStepW;\n' +
	        'float blockH = uBlocksize * uStepW;\n' +
	        'int posX = int(vTexCoord.x / blockW);\n' +
	        'int posY = int(vTexCoord.y / blockH);\n' +
	        'float fposX = float(posX);\n' +
	        'float fposY = float(posY);\n' +
	        'vec2 squareCoords = vec2(fposX * blockW, fposY * blockH);\n' +
	        'vec4 color = texture2D(uTexture, squareCoords);\n' +
	        'gl_FragColor = color;\n' +
	      '}',
	
	    /**
	     * Apply the Pixelate operation to a Uint8ClampedArray representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData,
	          data = imageData.data,
	          iLen = imageData.height,
	          jLen = imageData.width,
	          index, i, j, r, g, b, a,
	          _i, _j, _iLen, _jLen;
	
	      for (i = 0; i < iLen; i += this.blocksize) {
	        for (j = 0; j < jLen; j += this.blocksize) {
	
	          index = (i * 4) * jLen + (j * 4);
	
	          r = data[index];
	          g = data[index + 1];
	          b = data[index + 2];
	          a = data[index + 3];
	
	          _iLen = Math.min(i + this.blocksize, iLen);
	          _jLen = Math.min(j + this.blocksize, jLen);
	          for (_i = i; _i < _iLen; _i++) {
	            for (_j = j; _j < _jLen; _j++) {
	              index = (_i * 4) * jLen + (_j * 4);
	              data[index] = r;
	              data[index + 1] = g;
	              data[index + 2] = b;
	              data[index + 3] = a;
	            }
	          }
	        }
	      }
	    },
	
	    /**
	     * Indicate when the filter is not gonna apply changes to the image
	     **/
	    isNeutralState: function() {
	      return this.blocksize === 1;
	    },
	
	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uBlocksize: gl.getUniformLocation(program, 'uBlocksize'),
	        uStepW: gl.getUniformLocation(program, 'uStepW'),
	        uStepH: gl.getUniformLocation(program, 'uStepH'),
	      };
	    },
	
	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      gl.uniform1f(uniformLocations.uBlocksize, this.blocksize);
	    },
	  });
	
	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Pixelate} Instance of fabric.Image.filters.Pixelate
	   */
	  fabric.Image.filters.Pixelate.fromObject = fabric.Image.filters.BaseFilter.fromObject;
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric  = global.fabric || (global.fabric = { }),
	      extend = fabric.util.object.extend,
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;
	
	  /**
	   * Remove white filter class
	   * @class fabric.Image.filters.RemoveColor
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.RemoveColor#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.RemoveColor({
	   *   threshold: 0.2,
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   * canvas.renderAll();
	   */
	  filters.RemoveColor = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.RemoveColor.prototype */ {
	
	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'RemoveColor',
	
	    /**
	     * Color to remove, in any format understood by fabric.Color.
	     * @param {String} type
	     * @default
	     */
	    color: '#FFFFFF',
	
	    /**
	     * Fragment source for the brightness program
	     */
	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform vec4 uLow;\n' +
	      'uniform vec4 uHigh;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'void main() {\n' +
	        'gl_FragColor = texture2D(uTexture, vTexCoord);\n' +
	        'if(all(greaterThan(gl_FragColor.rgb,uLow.rgb)) && all(greaterThan(uHigh.rgb,gl_FragColor.rgb))) {\n' +
	          'gl_FragColor.a = 0.0;\n' +
	        '}\n' +
	      '}',
	
	    /**
	     * distance to actual color, as value up or down from each r,g,b
	     * between 0 and 1
	     **/
	    distance: 0.02,
	
	    /**
	     * For color to remove inside distance, use alpha channel for a smoother deletion
	     * NOT IMPLEMENTED YET
	     **/
	    useAlpha: false,
	
	    /**
	     * Constructor
	     * @memberOf fabric.Image.filters.RemoveWhite.prototype
	     * @param {Object} [options] Options object
	     * @param {Number} [options.color=#RRGGBB] Threshold value
	     * @param {Number} [options.distance=10] Distance value
	     */
	
	    /**
	     * Applies filter to canvas element
	     * @param {Object} canvasEl Canvas element to apply filter to
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData,
	          data = imageData.data, i,
	          distance = this.distance * 255,
	          r, g, b,
	          source = new fabric.Color(this.color).getSource(),
	          lowC = [
	            source[0] - distance,
	            source[1] - distance,
	            source[2] - distance,
	          ],
	          highC = [
	            source[0] + distance,
	            source[1] + distance,
	            source[2] + distance,
	          ];
	
	
	      for (i = 0; i < data.length; i += 4) {
	        r = data[i];
	        g = data[i + 1];
	        b = data[i + 2];
	
	        if (r > lowC[0] &&
	            g > lowC[1] &&
	            b > lowC[2] &&
	            r < highC[0] &&
	            g < highC[1] &&
	            b < highC[2]) {
	          data[i + 3] = 0;
	        }
	      }
	    },
	
	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uLow: gl.getUniformLocation(program, 'uLow'),
	        uHigh: gl.getUniformLocation(program, 'uHigh'),
	      };
	    },
	
	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      var source = new fabric.Color(this.color).getSource(),
	          distance = parseFloat(this.distance),
	          lowC = [
	            0 + source[0] / 255 - distance,
	            0 + source[1] / 255 - distance,
	            0 + source[2] / 255 - distance,
	            1
	          ],
	          highC = [
	            source[0] / 255 + distance,
	            source[1] / 255 + distance,
	            source[2] / 255 + distance,
	            1
	          ];
	      gl.uniform4fv(uniformLocations.uLow, lowC);
	      gl.uniform4fv(uniformLocations.uHigh, highC);
	    },
	
	    /**
	     * Returns object representation of an instance
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function() {
	      return extend(this.callSuper('toObject'), {
	        color: this.color,
	        distance: this.distance
	      });
	    }
	  });
	
	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.RemoveColor} Instance of fabric.Image.filters.RemoveWhite
	   */
	  fabric.Image.filters.RemoveColor.fromObject = fabric.Image.filters.BaseFilter.fromObject;
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;
	
	  var matrices = {
	    Brownie: [
	      0.59970,0.34553,-0.27082,0,0.186,
	      -0.03770,0.86095,0.15059,0,-0.1449,
	      0.24113,-0.07441,0.44972,0,-0.02965,
	      0,0,0,1,0
	    ],
	    Vintage: [
	      0.62793,0.32021,-0.03965,0,0.03784,
	      0.02578,0.64411,0.03259,0,0.02926,
	      0.04660,-0.08512,0.52416,0,0.02023,
	      0,0,0,1,0
	    ],
	    Kodachrome: [
	      1.12855,-0.39673,-0.03992,0,0.24991,
	      -0.16404,1.08352,-0.05498,0,0.09698,
	      -0.16786,-0.56034,1.60148,0,0.13972,
	      0,0,0,1,0
	    ],
	    Technicolor: [
	      1.91252,-0.85453,-0.09155,0,0.04624,
	      -0.30878,1.76589,-0.10601,0,-0.27589,
	      -0.23110,-0.75018,1.84759,0,0.12137,
	      0,0,0,1,0
	    ],
	    Polaroid: [
	      1.438,-0.062,-0.062,0,0,
	      -0.122,1.378,-0.122,0,0,
	      -0.016,-0.016,1.483,0,0,
	      0,0,0,1,0
	    ],
	    Sepia: [
	      0.393, 0.769, 0.189, 0, 0,
	      0.349, 0.686, 0.168, 0, 0,
	      0.272, 0.534, 0.131, 0, 0,
	      0, 0, 0, 1, 0
	    ],
	    BlackWhite: [
	      1.5, 1.5, 1.5, 0, -1,
	      1.5, 1.5, 1.5, 0, -1,
	      1.5, 1.5, 1.5, 0, -1,
	      0, 0, 0, 1, 0,
	    ]
	  };
	
	  for (var key in matrices) {
	    filters[key] = createClass(filters.ColorMatrix, /** @lends fabric.Image.filters.Sepia.prototype */ {
	
	      /**
	       * Filter type
	       * @param {String} type
	       * @default
	       */
	      type: key,
	
	      /**
	       * Colormatrix for the effect
	       * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
	       * outside the -1, 1 range.
	       * @param {Array} matrix array of 20 numbers.
	       * @default
	       */
	      matrix: matrices[key],
	
	      /**
	       * Lock the matrix export for this kind of static, parameter less filters.
	       */
	      mainParameter: false,
	      /**
	       * Lock the colormatrix on the color part, skipping alpha
	       */
	      colorsOnly: true,
	
	    });
	    fabric.Image.filters[key].fromObject = fabric.Image.filters.BaseFilter.fromObject;
	  }
	})( true ? exports : this);
	
	
	(function(global) {
	  'use strict';
	
	  var fabric = global.fabric,
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;
	
	  /**
	   * Color Blend filter class
	   * @class fabric.Image.filter.BlendColor
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @example
	   * var filter = new fabric.Image.filters.BlendColor({
	   *  color: '#000',
	   *  mode: 'multiply'
	   * });
	   *
	   * var filter = new fabric.Image.filters.BlendImage({
	   *  image: fabricImageObject,
	   *  mode: 'multiply',
	   *  alpha: 0.5
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   * canvas.renderAll();
	   */
	
	  filters.BlendColor = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Blend.prototype */ {
	    type: 'BlendColor',
	
	    /**
	     * Color to make the blend operation with. default to a reddish color since black or white
	     * gives always strong result.
	     **/
	    color: '#F95C63',
	
	    /**
	     * Blend mode for the filter: one of multiply, add, diff, screen, subtract,
	     * darken, lighten, overlay, exclusion, tint.
	     **/
	    mode: 'multiply',
	
	    /**
	     * alpha value. represent the strength of the blend color operation.
	     **/
	    alpha: 1,
	
	    /**
	     * Fragment source for the Multiply program
	     */
	    fragmentSource: {
	      multiply: 'gl_FragColor.rgb *= uColor.rgb;\n',
	      screen: 'gl_FragColor.rgb = 1.0 - (1.0 - gl_FragColor.rgb) * (1.0 - uColor.rgb);\n',
	      add: 'gl_FragColor.rgb += uColor.rgb;\n',
	      diff: 'gl_FragColor.rgb = abs(gl_FragColor.rgb - uColor.rgb);\n',
	      subtract: 'gl_FragColor.rgb -= uColor.rgb;\n',
	      lighten: 'gl_FragColor.rgb = max(gl_FragColor.rgb, uColor.rgb);\n',
	      darken: 'gl_FragColor.rgb = min(gl_FragColor.rgb, uColor.rgb);\n',
	      exclusion: 'gl_FragColor.rgb += uColor.rgb - 2.0 * (uColor.rgb * gl_FragColor.rgb);\n',
	      overlay: 'if (uColor.r < 0.5) {\n' +
	          'gl_FragColor.r *= 2.0 * uColor.r;\n' +
	        '} else {\n' +
	          'gl_FragColor.r = 1.0 - 2.0 * (1.0 - gl_FragColor.r) * (1.0 - uColor.r);\n' +
	        '}\n' +
	        'if (uColor.g < 0.5) {\n' +
	          'gl_FragColor.g *= 2.0 * uColor.g;\n' +
	        '} else {\n' +
	          'gl_FragColor.g = 1.0 - 2.0 * (1.0 - gl_FragColor.g) * (1.0 - uColor.g);\n' +
	        '}\n' +
	        'if (uColor.b < 0.5) {\n' +
	          'gl_FragColor.b *= 2.0 * uColor.b;\n' +
	        '} else {\n' +
	          'gl_FragColor.b = 1.0 - 2.0 * (1.0 - gl_FragColor.b) * (1.0 - uColor.b);\n' +
	        '}\n',
	      tint: 'gl_FragColor.rgb *= (1.0 - uColor.a);\n' +
	        'gl_FragColor.rgb += uColor.rgb;\n',
	    },
	
	    /**
	     * build the fragment source for the filters, joining the common part with
	     * the specific one.
	     * @param {String} mode the mode of the filter, a key of this.fragmentSource
	     * @return {String} the source to be compiled
	     * @private
	     */
	    buildSource: function(mode) {
	      return 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform vec4 uColor;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'void main() {\n' +
	          'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	          'gl_FragColor = color;\n' +
	          'if (color.a > 0.0) {\n' +
	            this.fragmentSource[mode] +
	          '}\n' +
	        '}';
	    },
	
	    /**
	     * Retrieves the cached shader.
	     * @param {Object} options
	     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	     */
	    retrieveShader: function(options) {
	      var cacheKey = this.type + '_' + this.mode, shaderSource;
	      if (!options.programCache.hasOwnProperty(cacheKey)) {
	        shaderSource = this.buildSource(this.mode);
	        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
	      }
	      return options.programCache[cacheKey];
	    },
	
	    /**
	     * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData,
	          data = imageData.data, iLen = data.length,
	          tr, tg, tb,
	          r, g, b,
	          source, alpha1 = 1 - this.alpha;
	
	      source = new fabric.Color(this.color).getSource();
	      tr = source[0] * this.alpha;
	      tg = source[1] * this.alpha;
	      tb = source[2] * this.alpha;
	
	      for (var i = 0; i < iLen; i += 4) {
	
	        r = data[i];
	        g = data[i + 1];
	        b = data[i + 2];
	
	        switch (this.mode) {
	          case 'multiply':
	            data[i] = r * tr / 255;
	            data[i + 1] = g * tg / 255;
	            data[i + 2] = b * tb / 255;
	            break;
	          case 'screen':
	            data[i] = 255 - (255 - r) * (255 - tr) / 255;
	            data[i + 1] = 255 - (255 - g) * (255 - tg) / 255;
	            data[i + 2] = 255 - (255 - b) * (255 - tb) / 255;
	            break;
	          case 'add':
	            data[i] = r + tr;
	            data[i + 1] = g + tg;
	            data[i + 2] = b + tb;
	            break;
	          case 'diff':
	          case 'difference':
	            data[i] = Math.abs(r - tr);
	            data[i + 1] = Math.abs(g - tg);
	            data[i + 2] = Math.abs(b - tb);
	            break;
	          case 'subtract':
	            data[i] = r - tr;
	            data[i + 1] = g - tg;
	            data[i + 2] = b - tb;
	            break;
	          case 'darken':
	            data[i] = Math.min(r, tr);
	            data[i + 1] = Math.min(g, tg);
	            data[i + 2] = Math.min(b, tb);
	            break;
	          case 'lighten':
	            data[i] = Math.max(r, tr);
	            data[i + 1] = Math.max(g, tg);
	            data[i + 2] = Math.max(b, tb);
	            break;
	          case 'overlay':
	            data[i] = tr < 128 ? (2 * r * tr / 255) : (255 - 2 * (255 - r) * (255 - tr) / 255);
	            data[i + 1] = tg < 128 ? (2 * g * tg / 255) : (255 - 2 * (255 - g) * (255 - tg) / 255);
	            data[i + 2] = tb < 128 ? (2 * b * tb / 255) : (255 - 2 * (255 - b) * (255 - tb) / 255);
	            break;
	          case 'exclusion':
	            data[i] = tr + r - ((2 * tr * r) / 255);
	            data[i + 1] = tg + g - ((2 * tg * g) / 255);
	            data[i + 2] = tb + b - ((2 * tb * b) / 255);
	            break;
	          case 'tint':
	            data[i] = tr + r * alpha1;
	            data[i + 1] = tg + g * alpha1;
	            data[i + 2] = tb + b * alpha1;
	        }
	      }
	    },
	
	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uColor: gl.getUniformLocation(program, 'uColor'),
	      };
	    },
	
	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      var source = new fabric.Color(this.color).getSource();
	      source[0] = this.alpha * source[0] / 255;
	      source[1] = this.alpha * source[1] / 255;
	      source[2] = this.alpha * source[2] / 255;
	      source[3] = this.alpha;
	      gl.uniform4fv(uniformLocations.uColor, source);
	    },
	
	    /**
	     * Returns object representation of an instance
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function() {
	      return {
	        type: this.type,
	        color: this.color,
	        mode: this.mode,
	        alpha: this.alpha
	      };
	    }
	  });
	
	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.BlendColor} Instance of fabric.Image.filters.BlendColor
	   */
	  fabric.Image.filters.BlendColor.fromObject = fabric.Image.filters.BaseFilter.fromObject;
	
	})( true ? exports : this);
	
	
	(function(global) {
	  'use strict';
	
	  var fabric = global.fabric,
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;
	
	  /**
	   * Image Blend filter class
	   * @class fabric.Image.filter.BlendImage
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @example
	   * var filter = new fabric.Image.filters.BlendColor({
	   *  color: '#000',
	   *  mode: 'multiply'
	   * });
	   *
	   * var filter = new fabric.Image.filters.BlendImage({
	   *  image: fabricImageObject,
	   *  mode: 'multiply',
	   *  alpha: 0.5
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   * canvas.renderAll();
	   */
	
	  filters.BlendImage = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.BlendImage.prototype */ {
	    type: 'BlendImage',
	
	    /**
	     * Color to make the blend operation with. default to a reddish color since black or white
	     * gives always strong result.
	     **/
	    image: null,
	
	    /**
	     * Blend mode for the filter: one of multiply, add, diff, screen, subtract,
	     * darken, lighten, overlay, exclusion, tint.
	     **/
	    mode: 'multiply',
	
	    /**
	     * alpha value. represent the strength of the blend image operation.
	     * not implemented.
	     **/
	    alpha: 1,
	
	    vertexSource: 'attribute vec2 aPosition;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'varying vec2 vTexCoord2;\n' +
	      'uniform mat3 uTransformMatrix;\n' +
	      'void main() {\n' +
	        'vTexCoord = aPosition;\n' +
	        'vTexCoord2 = (uTransformMatrix * vec3(aPosition, 1.0)).xy;\n' +
	        'gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n' +
	      '}',
	
	    /**
	     * Fragment source for the Multiply program
	     */
	    fragmentSource: {
	      multiply: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform sampler2D uImage;\n' +
	        'uniform vec4 uColor;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'varying vec2 vTexCoord2;\n' +
	        'void main() {\n' +
	          'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	          'vec4 color2 = texture2D(uImage, vTexCoord2);\n' +
	          'color.rgba *= color2.rgba;\n' +
	          'gl_FragColor = color;\n' +
	        '}',
	      mask: 'precision highp float;\n' +
	        'uniform sampler2D uTexture;\n' +
	        'uniform sampler2D uImage;\n' +
	        'uniform vec4 uColor;\n' +
	        'varying vec2 vTexCoord;\n' +
	        'varying vec2 vTexCoord2;\n' +
	        'void main() {\n' +
	          'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	          'vec4 color2 = texture2D(uImage, vTexCoord2);\n' +
	          'color.a = color2.a;\n' +
	          'gl_FragColor = color;\n' +
	        '}',
	    },
	
	    /**
	     * Retrieves the cached shader.
	     * @param {Object} options
	     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	     */
	    retrieveShader: function(options) {
	      var cacheKey = this.type + '_' + this.mode;
	      var shaderSource = this.fragmentSource[this.mode];
	      if (!options.programCache.hasOwnProperty(cacheKey)) {
	        options.programCache[cacheKey] = this.createProgram(options.context, shaderSource);
	      }
	      return options.programCache[cacheKey];
	    },
	
	    applyToWebGL: function(options) {
	      // load texture to blend.
	      var gl = options.context,
	          texture = this.createTexture(options.filterBackend, this.image);
	      this.bindAdditionalTexture(gl, texture, gl.TEXTURE1);
	      this.callSuper('applyToWebGL', options);
	      this.unbindAdditionalTexture(gl, gl.TEXTURE1);
	    },
	
	    createTexture: function(backend, image) {
	      return backend.getCachedTexture(image.cacheKey, image._element);
	    },
	
	    /**
	     * Calculate a transformMatrix to adapt the image to blend over
	     * @param {Object} options
	     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	     */
	    calculateMatrix: function() {
	      var image = this.image,
	          width = image._element.width,
	          height = image._element.height;
	      return [
	        1 / image.scaleX, 0, 0,
	        0, 1 / image.scaleY, 0,
	        -image.left / width, -image.top / height, 1
	      ];
	    },
	
	    /**
	     * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData,
	          resources = options.filterBackend.resources,
	          data = imageData.data, iLen = data.length,
	          width = imageData.width,
	          height = imageData.height,
	          tr, tg, tb, ta,
	          r, g, b, a,
	          canvas1, context, image = this.image, blendData;
	
	      if (!resources.blendImage) {
	        resources.blendImage = fabric.util.createCanvasElement();
	      }
	      canvas1 = resources.blendImage;
	      context = canvas1.getContext('2d');
	      if (canvas1.width !== width || canvas1.height !== height) {
	        canvas1.width = width;
	        canvas1.height = height;
	      }
	      else {
	        context.clearRect(0, 0, width, height);
	      }
	      context.setTransform(image.scaleX, 0, 0, image.scaleY, image.left, image.top);
	      context.drawImage(image._element, 0, 0, width, height);
	      blendData = context.getImageData(0, 0, width, height).data;
	      for (var i = 0; i < iLen; i += 4) {
	
	        r = data[i];
	        g = data[i + 1];
	        b = data[i + 2];
	        a = data[i + 3];
	
	        tr = blendData[i];
	        tg = blendData[i + 1];
	        tb = blendData[i + 2];
	        ta = blendData[i + 3];
	
	        switch (this.mode) {
	          case 'multiply':
	            data[i] = r * tr / 255;
	            data[i + 1] = g * tg / 255;
	            data[i + 2] = b * tb / 255;
	            data[i + 3] = a * ta / 255;
	            break;
	          case 'mask':
	            data[i + 3] = ta;
	            break;
	        }
	      }
	    },
	
	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uTransformMatrix: gl.getUniformLocation(program, 'uTransformMatrix'),
	        uImage: gl.getUniformLocation(program, 'uImage'),
	      };
	    },
	
	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      var matrix = this.calculateMatrix();
	      gl.uniform1i(uniformLocations.uImage, 1); // texture unit 1.
	      gl.uniformMatrix3fv(uniformLocations.uTransformMatrix, false, matrix);
	    },
	
	    /**
	     * Returns object representation of an instance
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function() {
	      return {
	        type: this.type,
	        image: this.image && this.image.toObject(),
	        mode: this.mode,
	        alpha: this.alpha
	      };
	    }
	  });
	
	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} callback to be invoked after filter creation
	   * @return {fabric.Image.filters.BlendImage} Instance of fabric.Image.filters.BlendImage
	   */
	  fabric.Image.filters.BlendImage.fromObject = function(object, callback) {
	    fabric.Image.fromObject(object.image, function(image) {
	      var options = fabric.util.object.clone(object);
	      options.image = image;
	      callback(new fabric.Image.filters.BlendImage(options));
	    });
	  };
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric  = global.fabric || (global.fabric = { }), pow = Math.pow, floor = Math.floor,
	      sqrt = Math.sqrt, abs = Math.abs, round = Math.round, sin = Math.sin,
	      ceil = Math.ceil,
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;
	
	  /**
	   * Resize image filter class
	   * @class fabric.Image.filters.Resize
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Resize();
	   * object.filters.push(filter);
	   * object.applyFilters(canvas.renderAll.bind(canvas));
	   */
	  filters.Resize = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Resize.prototype */ {
	
	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Resize',
	
	    /**
	     * Resize type
	     * for webgl resizeType is just lanczos, for canvas2d can be:
	     * bilinear, hermite, sliceHack, lanczos.
	     * @param {String} resizeType
	     * @default
	     */
	    resizeType: 'hermite',
	
	    /**
	     * Scale factor for resizing, x axis
	     * @param {Number} scaleX
	     * @default
	     */
	    scaleX: 1,
	
	    /**
	     * Scale factor for resizing, y axis
	     * @param {Number} scaleY
	     * @default
	     */
	    scaleY: 1,
	
	    /**
	     * LanczosLobes parameter for lanczos filter, valid for resizeType lanczos
	     * @param {Number} lanczosLobes
	     * @default
	     */
	    lanczosLobes: 3,
	
	
	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uDelta: gl.getUniformLocation(program, 'uDelta'),
	        uTaps: gl.getUniformLocation(program, 'uTaps'),
	      };
	    },
	
	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      gl.uniform2fv(uniformLocations.uDelta, this.horizontal ? [1 / this.width, 0] : [0, 1 / this.height]);
	      gl.uniform1fv(uniformLocations.uTaps, this.taps);
	    },
	
	    /**
	     * Retrieves the cached shader.
	     * @param {Object} options
	     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	     */
	    retrieveShader: function(options) {
	      var filterWindow = this.getFilterWindow(), cacheKey = this.type + '_' + filterWindow;
	      if (!options.programCache.hasOwnProperty(cacheKey)) {
	        var fragmentShader = this.generateShader(filterWindow);
	        options.programCache[cacheKey] = this.createProgram(options.context, fragmentShader);
	      }
	      return options.programCache[cacheKey];
	    },
	
	    getFilterWindow: function() {
	      var scale = this.tempScale;
	      return Math.ceil(this.lanczosLobes / scale);
	    },
	
	    getTaps: function() {
	      var lobeFunction = this.lanczosCreate(this.lanczosLobes), scale = this.tempScale,
	          filterWindow = this.getFilterWindow(), taps = new Array(filterWindow);
	      for (var i = 1; i <= filterWindow; i++) {
	        taps[i - 1] = lobeFunction(i * scale);
	      }
	      return taps;
	    },
	
	    /**
	     * Generate vertex and shader sources from the necessary steps numbers
	     * @param {Number} filterWindow
	     */
	    generateShader: function(filterWindow) {
	      var offsets = new Array(filterWindow),
	          fragmentShader = this.fragmentSourceTOP, filterWindow;
	
	      for (var i = 1; i <= filterWindow; i++) {
	        offsets[i - 1] = i + '.0 * uDelta';
	      }
	
	      fragmentShader += 'uniform float uTaps[' + filterWindow + '];\n';
	      fragmentShader += 'void main() {\n';
	      fragmentShader += '  vec4 color = texture2D(uTexture, vTexCoord);\n';
	      fragmentShader += '  float sum = 1.0;\n';
	
	      offsets.forEach(function(offset, i) {
	        fragmentShader += '  color += texture2D(uTexture, vTexCoord + ' + offset + ') * uTaps[' + i + '];\n';
	        fragmentShader += '  color += texture2D(uTexture, vTexCoord - ' + offset + ') * uTaps[' + i + '];\n';
	        fragmentShader += '  sum += 2.0 * uTaps[' + i + '];\n';
	      });
	      fragmentShader += '  gl_FragColor = color / sum;\n';
	      fragmentShader += '}';
	      return fragmentShader;
	    },
	
	    fragmentSourceTOP: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform vec2 uDelta;\n' +
	      'varying vec2 vTexCoord;\n',
	
	    /**
	     * Apply the resize filter to the image
	     * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
	     *
	     * @param {Object} options
	     * @param {Number} options.passes The number of filters remaining to be executed
	     * @param {Boolean} options.webgl Whether to use webgl to render the filter.
	     * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
	     * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
	     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	     */
	    applyTo: function(options) {
	      if (options.webgl) {
	        options.passes++;
	        this.width = options.sourceWidth;
	        this.horizontal = true;
	        this.dW = Math.round(this.width * this.scaleX);
	        this.dH = options.sourceHeight;
	        this.tempScale = this.dW / this.width;
	        this.taps = this.getTaps();
	        options.destinationWidth = this.dW;
	        this._setupFrameBuffer(options);
	        this.applyToWebGL(options);
	        this._swapTextures(options);
	        options.sourceWidth = options.destinationWidth;
	
	        this.height = options.sourceHeight;
	        this.horizontal = false;
	        this.dH = Math.round(this.height * this.scaleY);
	        this.tempScale = this.dH / this.height;
	        this.taps = this.getTaps();
	        options.destinationHeight = this.dH;
	        this._setupFrameBuffer(options);
	        this.applyToWebGL(options);
	        this._swapTextures(options);
	        options.sourceHeight = options.destinationHeight;
	      }
	      else {
	        this.applyTo2d(options);
	      }
	    },
	
	    isNeutralState: function() {
	      return this.scaleX === 1 && this.scaleY === 1;
	    },
	
	    lanczosCreate: function(lobes) {
	      return function(x) {
	        if (x >= lobes || x <= -lobes) {
	          return 0.0;
	        }
	        if (x < 1.19209290E-07 && x > -1.19209290E-07) {
	          return 1.0;
	        }
	        x *= Math.PI;
	        var xx = x / lobes;
	        return (sin(x) / x) * sin(xx) / xx;
	      };
	    },
	
	    /**
	     * Applies filter to canvas element
	     * @memberOf fabric.Image.filters.Resize.prototype
	     * @param {Object} canvasEl Canvas element to apply filter to
	     * @param {Number} scaleX
	     * @param {Number} scaleY
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData,
	          scaleX = this.scaleX,
	          scaleY = this.scaleY;
	
	      this.rcpScaleX = 1 / scaleX;
	      this.rcpScaleY = 1 / scaleY;
	
	      var oW = imageData.width, oH = imageData.height,
	          dW = round(oW * scaleX), dH = round(oH * scaleY),
	          newData;
	
	      if (this.resizeType === 'sliceHack') {
	        newData = this.sliceByTwo(options, oW, oH, dW, dH);
	      }
	      else if (this.resizeType === 'hermite') {
	        newData = this.hermiteFastResize(options, oW, oH, dW, dH);
	      }
	      else if (this.resizeType === 'bilinear') {
	        newData = this.bilinearFiltering(options, oW, oH, dW, dH);
	      }
	      else if (this.resizeType === 'lanczos') {
	        newData = this.lanczosResize(options, oW, oH, dW, dH);
	      }
	      options.imageData = newData;
	    },
	
	    /**
	     * Filter sliceByTwo
	     * @param {Object} canvasEl Canvas element to apply filter to
	     * @param {Number} oW Original Width
	     * @param {Number} oH Original Height
	     * @param {Number} dW Destination Width
	     * @param {Number} dH Destination Height
	     * @returns {ImageData}
	     */
	    sliceByTwo: function(options, oW, oH, dW, dH) {
	      var imageData = options.imageData,
	          mult = 0.5, doneW = false, doneH = false, stepW = oW * mult,
	          stepH = oH * mult, resources = fabric.filterBackend.resources,
	          tmpCanvas, ctx, sX = 0, sY = 0, dX = oW, dY = 0;
	      if (!resources.sliceByTwo) {
	        resources.sliceByTwo = document.createElement('canvas');
	      }
	      tmpCanvas = resources.sliceByTwo;
	      if (tmpCanvas.width < oW * 1.5 || tmpCanvas.height < oH) {
	        tmpCanvas.width = oW * 1.5;
	        tmpCanvas.height = oH;
	      }
	      ctx = tmpCanvas.getContext('2d');
	      ctx.clearRect(0, 0, oW * 1.5, oH);
	      ctx.putImageData(imageData, 0, 0);
	
	      dW = floor(dW);
	      dH = floor(dH);
	
	      while (!doneW || !doneH) {
	        oW = stepW;
	        oH = stepH;
	        if (dW < floor(stepW * mult)) {
	          stepW = floor(stepW * mult);
	        }
	        else {
	          stepW = dW;
	          doneW = true;
	        }
	        if (dH < floor(stepH * mult)) {
	          stepH = floor(stepH * mult);
	        }
	        else {
	          stepH = dH;
	          doneH = true;
	        }
	        ctx.drawImage(tmpCanvas, sX, sY, oW, oH, dX, dY, stepW, stepH);
	        sX = dX;
	        sY = dY;
	        dY += stepH;
	      }
	      return ctx.getImageData(sX, sY, dW, dH);
	    },
	
	    /**
	     * Filter lanczosResize
	     * @param {Object} canvasEl Canvas element to apply filter to
	     * @param {Number} oW Original Width
	     * @param {Number} oH Original Height
	     * @param {Number} dW Destination Width
	     * @param {Number} dH Destination Height
	     * @returns {ImageData}
	     */
	    lanczosResize: function(options, oW, oH, dW, dH) {
	
	      function process(u) {
	        var v, i, weight, idx, a, red, green,
	            blue, alpha, fX, fY;
	        center.x = (u + 0.5) * ratioX;
	        icenter.x = floor(center.x);
	        for (v = 0; v < dH; v++) {
	          center.y = (v + 0.5) * ratioY;
	          icenter.y = floor(center.y);
	          a = 0; red = 0; green = 0; blue = 0; alpha = 0;
	          for (i = icenter.x - range2X; i <= icenter.x + range2X; i++) {
	            if (i < 0 || i >= oW) {
	              continue;
	            }
	            fX = floor(1000 * abs(i - center.x));
	            if (!cacheLanc[fX]) {
	              cacheLanc[fX] = { };
	            }
	            for (var j = icenter.y - range2Y; j <= icenter.y + range2Y; j++) {
	              if (j < 0 || j >= oH) {
	                continue;
	              }
	              fY = floor(1000 * abs(j - center.y));
	              if (!cacheLanc[fX][fY]) {
	                cacheLanc[fX][fY] = lanczos(sqrt(pow(fX * rcpRatioX, 2) + pow(fY * rcpRatioY, 2)) / 1000);
	              }
	              weight = cacheLanc[fX][fY];
	              if (weight > 0) {
	                idx = (j * oW + i) * 4;
	                a += weight;
	                red += weight * srcData[idx];
	                green += weight * srcData[idx + 1];
	                blue += weight * srcData[idx + 2];
	                alpha += weight * srcData[idx + 3];
	              }
	            }
	          }
	          idx = (v * dW + u) * 4;
	          destData[idx] = red / a;
	          destData[idx + 1] = green / a;
	          destData[idx + 2] = blue / a;
	          destData[idx + 3] = alpha / a;
	        }
	
	        if (++u < dW) {
	          return process(u);
	        }
	        else {
	          return destImg;
	        }
	      }
	
	      var srcData = options.imageData.data,
	          destImg = options.ctx.createImageData(dW, dH),
	          destData = destImg.data,
	          lanczos = this.lanczosCreate(this.lanczosLobes),
	          ratioX = this.rcpScaleX, ratioY = this.rcpScaleY,
	          rcpRatioX = 2 / this.rcpScaleX, rcpRatioY = 2 / this.rcpScaleY,
	          range2X = ceil(ratioX * this.lanczosLobes / 2),
	          range2Y = ceil(ratioY * this.lanczosLobes / 2),
	          cacheLanc = { }, center = { }, icenter = { };
	
	      return process(0);
	    },
	
	    /**
	     * bilinearFiltering
	     * @param {Object} canvasEl Canvas element to apply filter to
	     * @param {Number} oW Original Width
	     * @param {Number} oH Original Height
	     * @param {Number} dW Destination Width
	     * @param {Number} dH Destination Height
	     * @returns {ImageData}
	     */
	    bilinearFiltering: function(options, oW, oH, dW, dH) {
	      var a, b, c, d, x, y, i, j, xDiff, yDiff, chnl,
	          color, offset = 0, origPix, ratioX = this.rcpScaleX,
	          ratioY = this.rcpScaleY,
	          w4 = 4 * (oW - 1), img = options.imageData,
	          pixels = img.data, destImage = options.ctx.createImageData(dW, dH),
	          destPixels = destImage.data;
	      for (i = 0; i < dH; i++) {
	        for (j = 0; j < dW; j++) {
	          x = floor(ratioX * j);
	          y = floor(ratioY * i);
	          xDiff = ratioX * j - x;
	          yDiff = ratioY * i - y;
	          origPix = 4 * (y * oW + x);
	
	          for (chnl = 0; chnl < 4; chnl++) {
	            a = pixels[origPix + chnl];
	            b = pixels[origPix + 4 + chnl];
	            c = pixels[origPix + w4 + chnl];
	            d = pixels[origPix + w4 + 4 + chnl];
	            color = a * (1 - xDiff) * (1 - yDiff) + b * xDiff * (1 - yDiff) +
	                    c * yDiff * (1 - xDiff) + d * xDiff * yDiff;
	            destPixels[offset++] = color;
	          }
	        }
	      }
	      return destImage;
	    },
	
	    /**
	     * hermiteFastResize
	     * @param {Object} canvasEl Canvas element to apply filter to
	     * @param {Number} oW Original Width
	     * @param {Number} oH Original Height
	     * @param {Number} dW Destination Width
	     * @param {Number} dH Destination Height
	     * @returns {ImageData}
	     */
	    hermiteFastResize: function(options, oW, oH, dW, dH) {
	      var ratioW = this.rcpScaleX, ratioH = this.rcpScaleY,
	          ratioWHalf = ceil(ratioW / 2),
	          ratioHHalf = ceil(ratioH / 2),
	          img = options.imageData, data = img.data,
	          img2 = options.ctx.createImageData(dW, dH), data2 = img2.data;
	      for (var j = 0; j < dH; j++) {
	        for (var i = 0; i < dW; i++) {
	          var x2 = (i + j * dW) * 4, weight = 0, weights = 0, weightsAlpha = 0,
	              gxR = 0, gxG = 0, gxB = 0, gxA = 0, centerY = (j + 0.5) * ratioH;
	          for (var yy = floor(j * ratioH); yy < (j + 1) * ratioH; yy++) {
	            var dy = abs(centerY - (yy + 0.5)) / ratioHHalf,
	                centerX = (i + 0.5) * ratioW, w0 = dy * dy;
	            for (var xx = floor(i * ratioW); xx < (i + 1) * ratioW; xx++) {
	              var dx = abs(centerX - (xx + 0.5)) / ratioWHalf,
	                  w = sqrt(w0 + dx * dx);
	              /* eslint-disable max-depth */
	              if (w > 1 && w < -1) {
	                continue;
	              }
	              //hermite filter
	              weight = 2 * w * w * w - 3 * w * w + 1;
	              if (weight > 0) {
	                dx = 4 * (xx + yy * oW);
	                //alpha
	                gxA += weight * data[dx + 3];
	                weightsAlpha += weight;
	                //colors
	                if (data[dx + 3] < 255) {
	                  weight = weight * data[dx + 3] / 250;
	                }
	                gxR += weight * data[dx];
	                gxG += weight * data[dx + 1];
	                gxB += weight * data[dx + 2];
	                weights += weight;
	              }
	              /* eslint-enable max-depth */
	            }
	          }
	          data2[x2] = gxR / weights;
	          data2[x2 + 1] = gxG / weights;
	          data2[x2 + 2] = gxB / weights;
	          data2[x2 + 3] = gxA / weightsAlpha;
	        }
	      }
	      return img2;
	    },
	
	    /**
	     * Returns object representation of an instance
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function() {
	      return {
	        type: this.type,
	        scaleX: this.scaleX,
	        scaleY: this.scaleY,
	        resizeType: this.resizeType,
	        lanczosLobes: this.lanczosLobes
	      };
	    }
	  });
	
	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Resize} Instance of fabric.Image.filters.Resize
	   */
	  fabric.Image.filters.Resize.fromObject = fabric.Image.filters.BaseFilter.fromObject;
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;
	
	  /**
	   * Contrast filter class
	   * @class fabric.Image.filters.Contrast
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.Contrast#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Contrast({
	   *   contrast: 40
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   */
	  filters.Contrast = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Contrast.prototype */ {
	
	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Contrast',
	
	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform float uContrast;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'void main() {\n' +
	        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	        'float contrastF = 1.015 * (uContrast + 1.0) / (1.0 * (1.015 - uContrast));\n' +
	        'color.rgb = contrastF * (color.rgb - 0.5) + 0.5;\n' +
	        'gl_FragColor = color;\n' +
	      '}',
	
	    contrast: 0,
	
	    mainParameter: 'contrast',
	
	    /**
	     * Constructor
	     * @memberOf fabric.Image.filters.Contrast.prototype
	     * @param {Object} [options] Options object
	     * @param {Number} [options.contrast=0] Value to contrast the image up (-1...1)
	     */
	
	    /**
	      * Apply the Contrast operation to a Uint8Array representing the pixels of an image.
	      *
	      * @param {Object} options
	      * @param {ImageData} options.imageData The Uint8Array to be filtered.
	      */
	    applyTo2d: function(options) {
	      if (this.contrast === 0) {
	        return;
	      }
	      var imageData = options.imageData, i, len,
	          data = imageData.data, len = data.length,
	          contrast = Math.floor(this.contrast * 255),
	          contrastF = 259 * (contrast + 255) / (255 * (259 - contrast));
	
	      for (i = 0; i < len; i += 4) {
	        data[i] = contrastF * (data[i] - 128) + 128;
	        data[i + 1] = contrastF * (data[i + 1] - 128) + 128;
	        data[i + 2] = contrastF * (data[i + 2] - 128) + 128;
	      }
	    },
	
	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uContrast: gl.getUniformLocation(program, 'uContrast'),
	      };
	    },
	
	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      gl.uniform1f(uniformLocations.uContrast, this.contrast);
	    },
	  });
	
	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Contrast} Instance of fabric.Image.filters.Contrast
	   */
	  fabric.Image.filters.Contrast.fromObject = fabric.Image.filters.BaseFilter.fromObject;
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;
	
	  /**
	   * Saturate filter class
	   * @class fabric.Image.filters.Saturation
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.Saturation#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Saturation({
	   *   saturation: 100
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   */
	  filters.Saturation = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Saturation.prototype */ {
	
	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Saturation',
	
	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform float uSaturation;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'void main() {\n' +
	        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	        'float rgMax = max(color.r, color.g);\n' +
	        'float rgbMax = max(rgMax, color.b);\n' +
	        'color.r += rgbMax != color.r ? (rgbMax - color.r) * uSaturation : 0.00;\n' +
	        'color.g += rgbMax != color.g ? (rgbMax - color.g) * uSaturation : 0.00;\n' +
	        'color.b += rgbMax != color.b ? (rgbMax - color.b) * uSaturation : 0.00;\n' +
	        'gl_FragColor = color;\n' +
	      '}',
	
	    saturation: 0,
	
	    mainParameter: 'saturation',
	
	    /**
	     * Constructor
	     * @memberOf fabric.Image.filters.Saturate.prototype
	     * @param {Object} [options] Options object
	     * @param {Number} [options.saturate=0] Value to saturate the image (-1...1)
	     */
	
	    /**
	     * Apply the Saturation operation to a Uint8ClampedArray representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
	     */
	    applyTo2d: function(options) {
	      if (this.saturation === 0) {
	        return;
	      }
	      var imageData = options.imageData,
	          data = imageData.data, len = data.length,
	          adjust = -this.saturation, i, max;
	
	      for (i = 0; i < len; i += 4) {
	        max = Math.max(data[i], data[i + 1], data[i + 2]);
	        data[i] += max !== data[i] ? (max - data[i]) * adjust : 0;
	        data[i + 1] += max !== data[i + 1] ? (max - data[i + 1]) * adjust : 0;
	        data[i + 2] += max !== data[i + 2] ? (max - data[i + 2]) * adjust : 0;
	      }
	    },
	
	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uSaturation: gl.getUniformLocation(program, 'uSaturation'),
	      };
	    },
	
	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      gl.uniform1f(uniformLocations.uSaturation, -this.saturation);
	    },
	  });
	
	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Saturation} Instance of fabric.Image.filters.Saturate
	   */
	  fabric.Image.filters.Saturation.fromObject = fabric.Image.filters.BaseFilter.fromObject;
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;
	
	  /**
	   * Blur filter class
	   * @class fabric.Image.filters.Blur
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.Blur#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Blur({
	   *   blur: 0.5
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   * canvas.renderAll();
	   */
	  filters.Blur = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Blur.prototype */ {
	
	    type: 'Blur',
	
	    /*
	'gl_FragColor = vec4(0.0);',
	'gl_FragColor += texture2D(texture, vTexCoord + -7 * uDelta)*0.0044299121055113265;',
	'gl_FragColor += texture2D(texture, vTexCoord + -6 * uDelta)*0.00895781211794;',
	'gl_FragColor += texture2D(texture, vTexCoord + -5 * uDelta)*0.0215963866053;',
	'gl_FragColor += texture2D(texture, vTexCoord + -4 * uDelta)*0.0443683338718;',
	'gl_FragColor += texture2D(texture, vTexCoord + -3 * uDelta)*0.0776744219933;',
	'gl_FragColor += texture2D(texture, vTexCoord + -2 * uDelta)*0.115876621105;',
	'gl_FragColor += texture2D(texture, vTexCoord + -1 * uDelta)*0.147308056121;',
	'gl_FragColor += texture2D(texture, vTexCoord              )*0.159576912161;',
	'gl_FragColor += texture2D(texture, vTexCoord + 1 * uDelta)*0.147308056121;',
	'gl_FragColor += texture2D(texture, vTexCoord + 2 * uDelta)*0.115876621105;',
	'gl_FragColor += texture2D(texture, vTexCoord + 3 * uDelta)*0.0776744219933;',
	'gl_FragColor += texture2D(texture, vTexCoord + 4 * uDelta)*0.0443683338718;',
	'gl_FragColor += texture2D(texture, vTexCoord + 5 * uDelta)*0.0215963866053;',
	'gl_FragColor += texture2D(texture, vTexCoord + 6 * uDelta)*0.00895781211794;',
	'gl_FragColor += texture2D(texture, vTexCoord + 7 * uDelta)*0.0044299121055113265;',
	*/
	
	    /* eslint-disable max-len */
	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform vec2 uDelta;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'const float nSamples = 15.0;\n' +
	      'vec3 v3offset = vec3(12.9898, 78.233, 151.7182);\n' +
	      'float random(vec3 scale) {\n' +
	        /* use the fragment position for a different seed per-pixel */
	        'return fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);\n' +
	      '}\n' +
	      'void main() {\n' +
	        'vec4 color = vec4(0.0);\n' +
	        'float total = 0.0;\n' +
	        'float offset = random(v3offset);\n' +
	        'for (float t = -nSamples; t <= nSamples; t++) {\n' +
	          'float percent = (t + offset - 0.5) / nSamples;\n' +
	          'float weight = 1.0 - abs(percent);\n' +
	          'color += texture2D(uTexture, vTexCoord + uDelta * percent) * weight;\n' +
	          'total += weight;\n' +
	        '}\n' +
	        'gl_FragColor = color / total;\n' +
	      '}',
	    /* eslint-enable max-len */
	
	    /**
	     * blur value, in percentage of image dimensions.
	     * specific to keep the image blur constant at different resolutions
	     * range bewteen 0 and 1.
	     */
	    blur: 0,
	
	    mainParameter: 'blur',
	
	    applyTo: function(options) {
	      if (options.webgl) {
	        // this aspectRatio is used to give the same blur to vertical and horizontal
	        this.aspectRatio = options.sourceWidth / options.sourceHeight;
	        options.passes++;
	        this._setupFrameBuffer(options);
	        this.horizontal = true;
	        this.applyToWebGL(options);
	        this._swapTextures(options);
	        this._setupFrameBuffer(options);
	        this.horizontal = false;
	        this.applyToWebGL(options);
	        this._swapTextures(options);
	      }
	      else {
	        this.applyTo2d(options);
	      }
	    },
	
	    applyTo2d: function(options) {
	      // paint canvasEl with current image data.
	      //options.ctx.putImageData(options.imageData, 0, 0);
	      options.imageData = this.simpleBlur(options);
	    },
	
	    simpleBlur: function(options) {
	      var resources = options.filterBackend.resources, canvas1, canvas2,
	          width = options.imageData.width,
	          height = options.imageData.height;
	
	      if (!resources.blurLayer1) {
	        resources.blurLayer1 = fabric.util.createCanvasElement();
	        resources.blurLayer2 = fabric.util.createCanvasElement();
	      }
	      canvas1 = resources.blurLayer1;
	      canvas2 = resources.blurLayer2;
	      if (canvas1.width !== width || canvas1.height !== height) {
	        canvas2.width = canvas1.width = width;
	        canvas2.height = canvas1.height = height;
	      }
	      var ctx1 = canvas1.getContext('2d'),
	          ctx2 = canvas2.getContext('2d'),
	          nSamples = 15,
	          random, percent, j, i,
	          blur = this.blur * 0.06 * 0.5;
	
	      // load first canvas
	      ctx1.putImageData(options.imageData, 0, 0);
	      ctx2.clearRect(0, 0, width, height);
	
	      for (i = -nSamples; i <= nSamples; i++) {
	        random = (Math.random() - 0.5) / 4;
	        percent = i / nSamples;
	        j = blur * percent * width + random;
	        ctx2.globalAlpha = 1 - Math.abs(percent);
	        ctx2.drawImage(canvas1, j, random);
	        ctx1.drawImage(canvas2, 0, 0);
	        ctx2.globalAlpha = 1;
	        ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
	      }
	      for (i = -nSamples; i <= nSamples; i++) {
	        random = (Math.random() - 0.5) / 4;
	        percent = i / nSamples;
	        j = blur * percent * height + random;
	        ctx2.globalAlpha = 1 - Math.abs(percent);
	        ctx2.drawImage(canvas1, random, j);
	        ctx1.drawImage(canvas2, 0, 0);
	        ctx2.globalAlpha = 1;
	        ctx2.clearRect(0, 0, canvas2.width, canvas2.height);
	      }
	      options.ctx.drawImage(canvas1, 0, 0);
	      var newImageData = options.ctx.getImageData(0, 0, canvas1.width, canvas1.height);
	      ctx1.globalAlpha = 1;
	      ctx1.clearRect(0, 0, canvas1.width, canvas1.height);
	      return newImageData;
	    },
	
	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        delta: gl.getUniformLocation(program, 'uDelta'),
	      };
	    },
	
	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      var delta = this.chooseRightDelta();
	      gl.uniform2fv(uniformLocations.delta, delta);
	    },
	
	    /**
	     * choose right value of image percentage to blur with
	     * @returns {Array} a numeric array with delta values
	     */
	    chooseRightDelta: function() {
	      var blurScale = 1, delta = [0, 0], blur;
	      if (this.horizontal) {
	        if (this.aspectRatio > 1) {
	          // image is wide, i want to shrink radius horizontal
	          blurScale = 1 / this.aspectRatio;
	        }
	      }
	      else {
	        if (this.aspectRatio < 1) {
	          // image is tall, i want to shrink radius vertical
	          blurScale = this.aspectRatio;
	        }
	      }
	      blur = blurScale * this.blur * 0.12;
	      if (this.horizontal) {
	        delta[0] = blur;
	      }
	      else {
	        delta[1] = blur;
	      }
	      return delta;
	    },
	  });
	
	  /**
	   * Deserialize a JSON definition of a BlurFilter into a concrete instance.
	   */
	  filters.Blur.fromObject = fabric.Image.filters.BaseFilter.fromObject;
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;
	
	  /**
	   * Gamma filter class
	   * @class fabric.Image.filters.Gamma
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.Gamma#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.Gamma({
	   *   brightness: 200
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   */
	  filters.Gamma = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Gamma.prototype */ {
	
	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'Gamma',
	
	    fragmentSource: 'precision highp float;\n' +
	      'uniform sampler2D uTexture;\n' +
	      'uniform vec3 uGamma;\n' +
	      'varying vec2 vTexCoord;\n' +
	      'void main() {\n' +
	        'vec4 color = texture2D(uTexture, vTexCoord);\n' +
	        'vec3 correction = (1.0 / uGamma);\n' +
	        'color.r = pow(color.r, correction.r);\n' +
	        'color.g = pow(color.g, correction.g);\n' +
	        'color.b = pow(color.b, correction.b);\n' +
	        'gl_FragColor = color;\n' +
	        'gl_FragColor.rgb *= color.a;\n' +
	      '}',
	
	    /**
	     * Gamma array value, from 0.01 to 2.2.
	     * @param {Array} gamma
	     * @default
	     */
	    gamma: [1, 1, 1],
	
	    /**
	     * Describe the property that is the filter parameter
	     * @param {String} m
	     * @default
	     */
	    mainParameter: 'gamma',
	
	    /**
	     * Constructor
	     * @param {Object} [options] Options object
	     */
	    initialize: function(options) {
	      this.gamma = [1, 1, 1];
	      filters.BaseFilter.prototype.initialize.call(this, options);
	    },
	
	    /**
	     * Apply the Gamma operation to a Uint8Array representing the pixels of an image.
	     *
	     * @param {Object} options
	     * @param {ImageData} options.imageData The Uint8Array to be filtered.
	     */
	    applyTo2d: function(options) {
	      var imageData = options.imageData, data = imageData.data,
	          gamma = this.gamma, len = data.length,
	          rInv = 1 / gamma[0], gInv = 1 / gamma[1],
	          bInv = 1 / gamma[2], i;
	
	      if (!this.rVals) {
	        // eslint-disable-next-line
	        this.rVals = new Uint8Array(256);
	        // eslint-disable-next-line
	        this.gVals = new Uint8Array(256);
	        // eslint-disable-next-line
	        this.bVals = new Uint8Array(256);
	      }
	
	      // This is an optimization - pre-compute a look-up table for each color channel
	      // instead of performing these pow calls for each pixel in the image.
	      for (i = 0, len = 256; i < len; i++) {
	        this.rVals[i] = Math.pow(i / 255, rInv) * 255;
	        this.gVals[i] = Math.pow(i / 255, gInv) * 255;
	        this.bVals[i] = Math.pow(i / 255, bInv) * 255;
	      }
	      for (i = 0, len = data.length; i < len; i += 4) {
	        data[i] = this.rVals[data[i]];
	        data[i + 1] = this.gVals[data[i + 1]];
	        data[i + 2] = this.bVals[data[i + 2]];
	      }
	    },
	
	    /**
	     * Return WebGL uniform locations for this filter's shader.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {WebGLShaderProgram} program This filter's compiled shader program.
	     */
	    getUniformLocations: function(gl, program) {
	      return {
	        uGamma: gl.getUniformLocation(program, 'uGamma'),
	      };
	    },
	
	    /**
	     * Send data from this filter to its shader program's uniforms.
	     *
	     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
	     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
	     */
	    sendUniformData: function(gl, uniformLocations) {
	      gl.uniform3fv(uniformLocations.uGamma, this.gamma);
	    },
	  });
	
	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.Gamma} Instance of fabric.Image.filters.Gamma
	   */
	  fabric.Image.filters.Gamma.fromObject = fabric.Image.filters.BaseFilter.fromObject;
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;
	
	  /**
	   * A container class that knows how to apply a sequence of filters to an input image.
	   */
	  filters.Composed = createClass(filters.BaseFilter, /** @lends fabric.Image.filters.Composed.prototype */ {
	
	    type: 'Composed',
	
	    /**
	     * A non sparse array of filters to apply
	     */
	    subFilters: [],
	
	    /**
	     * Constructor
	     * @param {Object} [options] Options object
	     */
	    initialize: function(options) {
	      this.callSuper('initialize', options);
	      // create a new array instead mutating the prototype with push
	      this.subFilters = this.subFilters.slice(0);
	    },
	
	    /**
	     * Apply this container's filters to the input image provided.
	     *
	     * @param {Object} options
	     * @param {Number} options.passes The number of filters remaining to be applied.
	     */
	    applyTo: function(options) {
	      options.passes += this.subFilters.length - 1;
	      this.subFilters.forEach(function(filter) {
	        filter.applyTo(options);
	      });
	    },
	
	    /**
	     * Serialize this filter into JSON.
	     *
	     * @returns {Object} A JSON representation of this filter.
	     */
	    toObject: function() {
	      return fabric.util.object.extend(this.callSuper('toObject'), {
	        subFilters: this.subFilters.map(function(filter) { return filter.toObject(); }),
	      });
	    },
	
	    isNeutralState: function() {
	      return !this.subFilters.some(function(filter) { return !filter.isNeutralState(); });
	    }
	  });
	
	  /**
	   * Deserialize a JSON definition of a ComposedFilter into a concrete instance.
	   */
	  fabric.Image.filters.Composed.fromObject = function(object, callback) {
	    var filters = object.subFilters || [],
	        subFilters = filters.map(function(filter) {
	          return new fabric.Image.filters[filter.type](filter);
	        }),
	        instance = new fabric.Image.filters.Composed({ subFilters: subFilters });
	    callback && callback(instance);
	    return instance;
	  };
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric  = global.fabric || (global.fabric = { }),
	      filters = fabric.Image.filters,
	      createClass = fabric.util.createClass;
	
	  /**
	   * HueRotation filter class
	   * @class fabric.Image.filters.HueRotation
	   * @memberOf fabric.Image.filters
	   * @extends fabric.Image.filters.BaseFilter
	   * @see {@link fabric.Image.filters.HueRotation#initialize} for constructor definition
	   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
	   * @example
	   * var filter = new fabric.Image.filters.HueRotation({
	   *   rotation: -0.5
	   * });
	   * object.filters.push(filter);
	   * object.applyFilters();
	   */
	  filters.HueRotation = createClass(filters.ColorMatrix, /** @lends fabric.Image.filters.HueRotation.prototype */ {
	
	    /**
	     * Filter type
	     * @param {String} type
	     * @default
	     */
	    type: 'HueRotation',
	
	    /**
	     * HueRotation value, from -1 to 1.
	     * the unit is radians
	     * @param {Number} myParameter
	     * @default
	     */
	    rotation: 0,
	
	    /**
	     * Describe the property that is the filter parameter
	     * @param {String} m
	     * @default
	     */
	    mainParameter: 'rotation',
	
	    calculateMatrix: function() {
	      var rad = this.rotation * Math.PI, cos = fabric.util.cos(rad), sin = fabric.util.sin(rad),
	          aThird = 1 / 3, aThirdSqtSin = Math.sqrt(aThird) * sin, OneMinusCos = 1 - cos;
	      this.matrix = [
	        1, 0, 0, 0, 0,
	        0, 1, 0, 0, 0,
	        0, 0, 1, 0, 0,
	        0, 0, 0, 1, 0
	      ];
	      this.matrix[0] = cos + OneMinusCos / 3;
	      this.matrix[1] = aThird * OneMinusCos - aThirdSqtSin;
	      this.matrix[2] = aThird * OneMinusCos + aThirdSqtSin;
	      this.matrix[5] = aThird * OneMinusCos + aThirdSqtSin;
	      this.matrix[6] = cos + aThird * OneMinusCos;
	      this.matrix[7] = aThird * OneMinusCos - aThirdSqtSin;
	      this.matrix[10] = aThird * OneMinusCos - aThirdSqtSin;
	      this.matrix[11] = aThird * OneMinusCos + aThirdSqtSin;
	      this.matrix[12] = cos + aThird * OneMinusCos;
	    },
	
	    /**
	     * HueRotation isNeutralState implementation
	     * Used only in image applyFilters to discard filters that will not have an effect
	     * on the image
	     * @param {Object} options
	     **/
	    isNeutralState: function(options) {
	      this.calculateMatrix();
	      return filters.BaseFilter.prototype.isNeutralState.call(this, options);
	    },
	
	    /**
	     * Apply this filter to the input image data provided.
	     *
	     * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
	     *
	     * @param {Object} options
	     * @param {Number} options.passes The number of filters remaining to be executed
	     * @param {Boolean} options.webgl Whether to use webgl to render the filter.
	     * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
	     * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
	     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
	     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
	     */
	    applyTo: function(options) {
	      this.calculateMatrix();
	      filters.BaseFilter.prototype.applyTo.call(this, options);
	    },
	
	  });
	
	  /**
	   * Returns filter instance from an object representation
	   * @static
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] to be invoked after filter creation
	   * @return {fabric.Image.filters.HueRotation} Instance of fabric.Image.filters.HueRotation
	   */
	  fabric.Image.filters.HueRotation.fromObject = fabric.Image.filters.BaseFilter.fromObject;
	
	})( true ? exports : this);
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric = global.fabric || (global.fabric = { }),
	      clone = fabric.util.object.clone;
	
	  if (fabric.Text) {
	    fabric.warn('fabric.Text is already defined');
	    return;
	  }
	
	  /**
	   * Text class
	   * @class fabric.Text
	   * @extends fabric.Object
	   * @return {fabric.Text} thisArg
	   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#text}
	   * @see {@link fabric.Text#initialize} for constructor definition
	   */
	  fabric.Text = fabric.util.createClass(fabric.Object, /** @lends fabric.Text.prototype */ {
	
	    /**
	     * Properties which when set cause object to change dimensions
	     * @type Array
	     * @private
	     */
	    _dimensionAffectingProps: [
	      'fontSize',
	      'fontWeight',
	      'fontFamily',
	      'fontStyle',
	      'lineHeight',
	      'text',
	      'charSpacing',
	      'textAlign',
	      'styles',
	    ],
	
	    /**
	     * @private
	     */
	    _reNewline: /\r?\n/,
	
	    /**
	     * Use this regular expression to filter for whitespaces that is not a new line.
	     * Mostly used when text is 'justify' aligned.
	     * @private
	     */
	    _reSpacesAndTabs: /[ \t\r]/g,
	
	    /**
	     * Use this regular expression to filter for whitespace that is not a new line.
	     * Mostly used when text is 'justify' aligned.
	     * @private
	     */
	    _reSpaceAndTab: /[ \t\r]/,
	
	    /**
	     * Use this regular expression to filter consecutive groups of non spaces.
	     * Mostly used when text is 'justify' aligned.
	     * @private
	     */
	    _reWords: /\S+/g,
	
	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type:                 'text',
	
	    /**
	     * Font size (in pixels)
	     * @type Number
	     * @default
	     */
	    fontSize:             40,
	
	    /**
	     * Font weight (e.g. bold, normal, 400, 600, 800)
	     * @type {(Number|String)}
	     * @default
	     */
	    fontWeight:           'normal',
	
	    /**
	     * Font family
	     * @type String
	     * @default
	     */
	    fontFamily:           'Times New Roman',
	
	    /**
	     * Text decoration underline.
	     * @type Boolean
	     * @default
	     */
	    underline:       false,
	
	    /**
	     * Text decoration overline.
	     * @type Boolean
	     * @default
	     */
	    overline:       false,
	
	    /**
	     * Text decoration linethrough.
	     * @type Boolean
	     * @default
	     */
	    linethrough:       false,
	
	    /**
	     * Text alignment. Possible values: "left", "center", "right", "justify",
	     * "justify-left", "justify-center" or "justify-right".
	     * @type String
	     * @default
	     */
	    textAlign:            'left',
	
	    /**
	     * Font style . Possible values: "", "normal", "italic" or "oblique".
	     * @type String
	     * @default
	     */
	    fontStyle:            'normal',
	
	    /**
	     * Line height
	     * @type Number
	     * @default
	     */
	    lineHeight:           1.16,
	
	    /**
	     * Superscript schema object (minimum overlap)
	     * @type {Object}
	     * @default
	     */
	    superscript: {
	      size:      0.60, // fontSize factor
	      baseline: -0.35  // baseline-shift factor (upwards)
	    },
	
	    /**
	     * Subscript schema object (minimum overlap)
	     * @type {Object}
	     * @default
	     */
	    subscript: {
	      size:      0.60, // fontSize factor
	      baseline:  0.11  // baseline-shift factor (downwards)
	    },
	
	    /**
	     * Background color of text lines
	     * @type String
	     * @default
	     */
	    textBackgroundColor:  '',
	
	    /**
	     * List of properties to consider when checking if
	     * state of an object is changed ({@link fabric.Object#hasStateChanged})
	     * as well as for history (undo/redo) purposes
	     * @type Array
	     */
	    stateProperties: fabric.Object.prototype.stateProperties.concat('fontFamily',
	      'fontWeight',
	      'fontSize',
	      'text',
	      'underline',
	      'overline',
	      'linethrough',
	      'textAlign',
	      'fontStyle',
	      'lineHeight',
	      'textBackgroundColor',
	      'charSpacing',
	      'styles'),
	
	    /**
	     * List of properties to consider when checking if cache needs refresh
	     * @type Array
	     */
	    cacheProperties: fabric.Object.prototype.cacheProperties.concat('fontFamily',
	      'fontWeight',
	      'fontSize',
	      'text',
	      'underline',
	      'overline',
	      'linethrough',
	      'textAlign',
	      'fontStyle',
	      'lineHeight',
	      'textBackgroundColor',
	      'charSpacing',
	      'styles'),
	
	    /**
	     * When defined, an object is rendered via stroke and this property specifies its color.
	     * <b>Backwards incompatibility note:</b> This property was named "strokeStyle" until v1.1.6
	     * @type String
	     * @default
	     */
	    stroke:               null,
	
	    /**
	     * Shadow object representing shadow of this shape.
	     * <b>Backwards incompatibility note:</b> This property was named "textShadow" (String) until v1.2.11
	     * @type fabric.Shadow
	     * @default
	     */
	    shadow:               null,
	
	    /**
	     * @private
	     */
	    _fontSizeFraction: 0.222,
	
	    /**
	     * @private
	     */
	    offsets: {
	      underline: 0.10,
	      linethrough: -0.315,
	      overline: -0.88
	    },
	
	    /**
	     * Text Line proportion to font Size (in pixels)
	     * @type Number
	     * @default
	     */
	    _fontSizeMult:             1.13,
	
	    /**
	     * additional space between characters
	     * expressed in thousands of em unit
	     * @type Number
	     * @default
	     */
	    charSpacing:             0,
	
	    /**
	     * Object containing character styles - top-level properties -> line numbers,
	     * 2nd-level properties - charater numbers
	     * @type Object
	     * @default
	     */
	    styles: null,
	
	    /**
	     * Reference to a context to measure text char or couple of chars
	     * the cacheContext of the canvas will be used or a freshly created one if the object is not on canvas
	     * once created it will be referenced on fabric._measuringContext to avoide creating a canvas for every
	     * text object created.
	     * @type {CanvasRenderingContext2D}
	     * @default
	     */
	    _measuringContext: null,
	
	    /**
	     * Baseline shift, stlyes only, keep at 0 for the main text object
	     * @type {Number}
	     * @default
	     */
	    deltaY: 0,
	
	    /**
	     * Array of properties that define a style unit (of 'styles').
	     * @type {Array}
	     * @default
	     */
	    _styleProperties: [
	      'stroke',
	      'strokeWidth',
	      'fill',
	      'fontFamily',
	      'fontSize',
	      'fontWeight',
	      'fontStyle',
	      'underline',
	      'overline',
	      'linethrough',
	      'deltaY',
	      'textBackgroundColor',
	    ],
	
	    /**
	     * contains characters bounding boxes
	     */
	    __charBounds: [],
	
	    /**
	     * use this size when measuring text. To avoid IE11 rounding errors
	     * @type {Number}
	     * @default
	     * @readonly
	     * @private
	     */
	    CACHE_FONT_SIZE: 400,
	
	    /**
	     * contains the min text width to avoid getting 0
	     * @type {Number}
	     * @default
	     */
	    MIN_TEXT_WIDTH: 2,
	
	    /**
	     * Constructor
	     * @param {String} text Text string
	     * @param {Object} [options] Options object
	     * @return {fabric.Text} thisArg
	     */
	    initialize: function(text, options) {
	      this.styles = options ? (options.styles || { }) : { };
	      this.text = text;
	      this.__skipDimension = true;
	      this.callSuper('initialize', options);
	      this.__skipDimension = false;
	      this.initDimensions();
	      this.setCoords();
	      this.setupState({ propertySet: '_dimensionAffectingProps' });
	    },
	
	    /**
	     * Return a contex for measurement of text string.
	     * if created it gets stored for reuse
	     * @param {String} text Text string
	     * @param {Object} [options] Options object
	     * @return {fabric.Text} thisArg
	     */
	    getMeasuringContext: function() {
	      // if we did not return we have to measure something.
	      if (!fabric._measuringContext) {
	        fabric._measuringContext = this.canvas && this.canvas.contextCache ||
	          fabric.util.createCanvasElement().getContext('2d');
	      }
	      return fabric._measuringContext;
	    },
	
	    /**
	     * @private
	     * Divides text into lines of text and lines of graphemes.
	     */
	    _splitText: function() {
	      var newLines = this._splitTextIntoLines(this.text);
	      this.textLines = newLines.lines;
	      this._textLines = newLines.graphemeLines;
	      this._unwrappedTextLines = newLines._unwrappedLines;
	      this._text = newLines.graphemeText;
	      return newLines;
	    },
	
	    /**
	     * Initialize or update text dimensions.
	     * Updates this.width and this.height with the proper values.
	     * Does not return dimensions.
	     */
	    initDimensions: function() {
	      if (this.__skipDimension) {
	        return;
	      }
	      this._splitText();
	      this._clearCache();
	      this.width = this.calcTextWidth() || this.cursorWidth || this.MIN_TEXT_WIDTH;
	      if (this.textAlign.indexOf('justify') !== -1) {
	        // once text is measured we need to make space fatter to make justified text.
	        this.enlargeSpaces();
	      }
	      this.height = this.calcTextHeight();
	      this.saveState({ propertySet: '_dimensionAffectingProps' });
	    },
	
	    /**
	     * Enlarge space boxes and shift the others
	     */
	    enlargeSpaces: function() {
	      var diffSpace, currentLineWidth, numberOfSpaces, accumulatedSpace, line, charBound, spaces;
	      for (var i = 0, len = this._textLines.length; i < len; i++) {
	        if (this.textAlign !== 'justify' && (i === len - 1 || this.isEndOfWrapping(i))) {
	          continue;
	        }
	        accumulatedSpace = 0;
	        line = this._textLines[i];
	        currentLineWidth = this.getLineWidth(i);
	        if (currentLineWidth < this.width && (spaces = this.textLines[i].match(this._reSpacesAndTabs))) {
	          numberOfSpaces = spaces.length;
	          diffSpace = (this.width - currentLineWidth) / numberOfSpaces;
	          for (var j = 0, jlen = line.length; j <= jlen; j++) {
	            charBound = this.__charBounds[i][j];
	            if (this._reSpaceAndTab.test(line[j])) {
	              charBound.width += diffSpace;
	              charBound.kernedWidth += diffSpace;
	              charBound.left += accumulatedSpace;
	              accumulatedSpace += diffSpace;
	            }
	            else {
	              charBound.left += accumulatedSpace;
	            }
	          }
	        }
	      }
	    },
	
	    /**
	     * Detect if the text line is ended with an hard break
	     * text and itext do not have wrapping, return false
	     * @return {Boolean}
	     */
	    isEndOfWrapping: function(lineIndex) {
	      return lineIndex === this._textLines.length - 1;
	    },
	
	    /**
	     * Detect if a line has a linebreak and so we need to account for it when moving
	     * and counting style.
	     * It return always for text and Itext.
	     * @return Number
	     */
	    missingNewlineOffset: function() {
	      return 1;
	    },
	
	    /**
	     * Returns string representation of an instance
	     * @return {String} String representation of text object
	     */
	    toString: function() {
	      return '#<fabric.Text (' + this.complexity() +
	        '): { "text": "' + this.text + '", "fontFamily": "' + this.fontFamily + '" }>';
	    },
	
	    /**
	     * Return the dimension and the zoom level needed to create a cache canvas
	     * big enough to host the object to be cached.
	     * @private
	     * @param {Object} dim.x width of object to be cached
	     * @param {Object} dim.y height of object to be cached
	     * @return {Object}.width width of canvas
	     * @return {Object}.height height of canvas
	     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
	     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
	     */
	    _getCacheCanvasDimensions: function() {
	      var dims = this.callSuper('_getCacheCanvasDimensions');
	      var fontSize = this.fontSize;
	      dims.width += fontSize * dims.zoomX;
	      dims.height += fontSize * dims.zoomY;
	      return dims;
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _render: function(ctx) {
	      this._setTextStyles(ctx);
	      this._renderTextLinesBackground(ctx);
	      this._renderTextDecoration(ctx, 'underline');
	      this._renderText(ctx);
	      this._renderTextDecoration(ctx, 'overline');
	      this._renderTextDecoration(ctx, 'linethrough');
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderText: function(ctx) {
	      if (this.paintFirst === 'stroke') {
	        this._renderTextStroke(ctx);
	        this._renderTextFill(ctx);
	      }
	      else {
	        this._renderTextFill(ctx);
	        this._renderTextStroke(ctx);
	      }
	    },
	
	    /**
	     * Set the font parameter of the context with the object properties or with charStyle
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {Object} [charStyle] object with font style properties
	     * @param {String} [charStyle.fontFamily] Font Family
	     * @param {Number} [charStyle.fontSize] Font size in pixels. ( without px suffix )
	     * @param {String} [charStyle.fontWeight] Font weight
	     * @param {String} [charStyle.fontStyle] Font style (italic|normal)
	     */
	    _setTextStyles: function(ctx, charStyle, forMeasuring) {
	      ctx.textBaseline = 'alphabetic';
	      ctx.font = this._getFontDeclaration(charStyle, forMeasuring);
	    },
	
	    /**
	     * calculate and return the text Width measuring each line.
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @return {Number} Maximum width of fabric.Text object
	     */
	    calcTextWidth: function() {
	      var maxWidth = this.getLineWidth(0);
	
	      for (var i = 1, len = this._textLines.length; i < len; i++) {
	        var currentLineWidth = this.getLineWidth(i);
	        if (currentLineWidth > maxWidth) {
	          maxWidth = currentLineWidth;
	        }
	      }
	      return maxWidth;
	    },
	
	    /**
	     * @private
	     * @param {String} method Method name ("fillText" or "strokeText")
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {String} line Text to render
	     * @param {Number} left Left position of text
	     * @param {Number} top Top position of text
	     * @param {Number} lineIndex Index of a line in a text
	     */
	    _renderTextLine: function(method, ctx, line, left, top, lineIndex) {
	      this._renderChars(method, ctx, line, left, top, lineIndex);
	    },
	
	    /**
	     * Renders the text background for lines, taking care of style
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderTextLinesBackground: function(ctx) {
	      if (!this.textBackgroundColor && !this.styleHas('textBackgroundColor')) {
	        return;
	      }
	      var lineTopOffset = 0, heightOfLine,
	          lineLeftOffset, originalFill = ctx.fillStyle,
	          line, lastColor,
	          leftOffset = this._getLeftOffset(),
	          topOffset = this._getTopOffset(),
	          boxStart = 0, boxWidth = 0, charBox, currentColor;
	
	      for (var i = 0, len = this._textLines.length; i < len; i++) {
	        heightOfLine = this.getHeightOfLine(i);
	        if (!this.textBackgroundColor && !this.styleHas('textBackgroundColor', i)) {
	          lineTopOffset += heightOfLine;
	          continue;
	        }
	        line = this._textLines[i];
	        lineLeftOffset = this._getLineLeftOffset(i);
	        boxWidth = 0;
	        boxStart = 0;
	        lastColor = this.getValueOfPropertyAt(i, 0, 'textBackgroundColor');
	        for (var j = 0, jlen = line.length; j < jlen; j++) {
	          charBox = this.__charBounds[i][j];
	          currentColor = this.getValueOfPropertyAt(i, j, 'textBackgroundColor');
	          if (currentColor !== lastColor) {
	            ctx.fillStyle = lastColor;
	            lastColor && ctx.fillRect(
	              leftOffset + lineLeftOffset + boxStart,
	              topOffset + lineTopOffset,
	              boxWidth,
	              heightOfLine / this.lineHeight
	            );
	            boxStart = charBox.left;
	            boxWidth = charBox.width;
	            lastColor = currentColor;
	          }
	          else {
	            boxWidth += charBox.kernedWidth;
	          }
	        }
	        if (currentColor) {
	          ctx.fillStyle = currentColor;
	          ctx.fillRect(
	            leftOffset + lineLeftOffset + boxStart,
	            topOffset + lineTopOffset,
	            boxWidth,
	            heightOfLine / this.lineHeight
	          );
	        }
	        lineTopOffset += heightOfLine;
	      }
	      ctx.fillStyle = originalFill;
	      // if there is text background color no
	      // other shadows should be casted
	      this._removeShadow(ctx);
	    },
	
	    /**
	     * @private
	     * @param {Object} decl style declaration for cache
	     * @param {String} decl.fontFamily fontFamily
	     * @param {String} decl.fontStyle fontStyle
	     * @param {String} decl.fontWeight fontWeight
	     * @return {Object} reference to cache
	     */
	    getFontCache: function(decl) {
	      var fontFamily = decl.fontFamily.toLowerCase();
	      if (!fabric.charWidthsCache[fontFamily]) {
	        fabric.charWidthsCache[fontFamily] = { };
	      }
	      var cache = fabric.charWidthsCache[fontFamily],
	          cacheProp = decl.fontStyle.toLowerCase() + '_' + (decl.fontWeight + '').toLowerCase();
	      if (!cache[cacheProp]) {
	        cache[cacheProp] = { };
	      }
	      return cache[cacheProp];
	    },
	
	    /**
	     * apply all the character style to canvas for rendering
	     * @private
	     * @param {String} _char
	     * @param {Number} lineIndex
	     * @param {Number} charIndex
	     * @param {Object} [decl]
	     */
	    _applyCharStyles: function(method, ctx, lineIndex, charIndex, styleDeclaration) {
	
	      this._setFillStyles(ctx, styleDeclaration);
	      this._setStrokeStyles(ctx, styleDeclaration);
	
	      ctx.font = this._getFontDeclaration(styleDeclaration);
	    },
	
	    /**
	     * measure and return the width of a single character.
	     * possibly overridden to accommodate different measure logic or
	     * to hook some external lib for character measurement
	     * @private
	     * @param {String} _char, char to be measured
	     * @param {Object} charStyle style of char to be measured
	     * @param {String} [previousChar] previous char
	     * @param {Object} [prevCharStyle] style of previous char
	     */
	    _measureChar: function(_char, charStyle, previousChar, prevCharStyle) {
	      // first i try to return from cache
	      var fontCache = this.getFontCache(charStyle), fontDeclaration = this._getFontDeclaration(charStyle),
	          previousFontDeclaration = this._getFontDeclaration(prevCharStyle), couple = previousChar + _char,
	          stylesAreEqual = fontDeclaration === previousFontDeclaration, width, coupleWidth, previousWidth,
	          fontMultiplier = charStyle.fontSize / this.CACHE_FONT_SIZE, kernedWidth;
	
	      if (previousChar && fontCache[previousChar] !== undefined) {
	        previousWidth = fontCache[previousChar];
	      }
	      if (fontCache[_char] !== undefined) {
	        kernedWidth = width = fontCache[_char];
	      }
	      if (stylesAreEqual && fontCache[couple] !== undefined) {
	        coupleWidth = fontCache[couple];
	        kernedWidth = coupleWidth - previousWidth;
	      }
	      if (width === undefined || previousWidth === undefined || coupleWidth === undefined) {
	        var ctx = this.getMeasuringContext();
	        // send a TRUE to specify measuring font size CACHE_FONT_SIZE
	        this._setTextStyles(ctx, charStyle, true);
	      }
	      if (width === undefined) {
	        kernedWidth = width = ctx.measureText(_char).width;
	        fontCache[_char] = width;
	      }
	      if (previousWidth === undefined && stylesAreEqual && previousChar) {
	        previousWidth = ctx.measureText(previousChar).width;
	        fontCache[previousChar] = previousWidth;
	      }
	      if (stylesAreEqual && coupleWidth === undefined) {
	        // we can measure the kerning couple and subtract the width of the previous character
	        coupleWidth = ctx.measureText(couple).width;
	        fontCache[couple] = coupleWidth;
	        kernedWidth = coupleWidth - previousWidth;
	      }
	      return { width: width * fontMultiplier, kernedWidth: kernedWidth * fontMultiplier };
	    },
	
	    /**
	     * Computes height of character at given position
	     * @param {Number} line the line index number
	     * @param {Number} _char the character index number
	     * @return {Number} fontSize of the character
	     */
	    getHeightOfChar: function(line, _char) {
	      return this.getValueOfPropertyAt(line, _char, 'fontSize');
	    },
	
	    /**
	     * measure a text line measuring all characters.
	     * @param {Number} lineIndex line number
	     * @return {Number} Line width
	     */
	    measureLine: function(lineIndex) {
	      var lineInfo = this._measureLine(lineIndex);
	      if (this.charSpacing !== 0) {
	        lineInfo.width -= this._getWidthOfCharSpacing();
	      }
	      if (lineInfo.width < 0) {
	        lineInfo.width = 0;
	      }
	      return lineInfo;
	    },
	
	    /**
	     * measure every grapheme of a line, populating __charBounds
	     * @param {Number} lineIndex
	     * @return {Object} object.width total width of characters
	     * @return {Object} object.widthOfSpaces length of chars that match this._reSpacesAndTabs
	     */
	    _measureLine: function(lineIndex) {
	      var width = 0, i, grapheme, line = this._textLines[lineIndex], prevGrapheme,
	          graphemeInfo, numOfSpaces = 0, lineBounds = new Array(line.length);
	
	      this.__charBounds[lineIndex] = lineBounds;
	      for (i = 0; i < line.length; i++) {
	        grapheme = line[i];
	        graphemeInfo = this._getGraphemeBox(grapheme, lineIndex, i, prevGrapheme);
	        lineBounds[i] = graphemeInfo;
	        width += graphemeInfo.kernedWidth;
	        prevGrapheme = grapheme;
	      }
	      // this latest bound box represent the last character of the line
	      // to simplify cursor handling in interactive mode.
	      lineBounds[i] = {
	        left: graphemeInfo ? graphemeInfo.left + graphemeInfo.width : 0,
	        width: 0,
	        kernedWidth: 0,
	        height: this.fontSize
	      };
	      return { width: width, numOfSpaces: numOfSpaces };
	    },
	
	    /**
	     * Measure and return the info of a single grapheme.
	     * needs the the info of previous graphemes already filled
	     * @private
	     * @param {String} grapheme to be measured
	     * @param {Number} lineIndex index of the line where the char is
	     * @param {Number} charIndex position in the line
	     * @param {String} [prevGrapheme] character preceding the one to be measured
	     */
	    _getGraphemeBox: function(grapheme, lineIndex, charIndex, prevGrapheme, skipLeft) {
	      var style = this.getCompleteStyleDeclaration(lineIndex, charIndex),
	          prevStyle = prevGrapheme ? this.getCompleteStyleDeclaration(lineIndex, charIndex - 1) : { },
	          info = this._measureChar(grapheme, style, prevGrapheme, prevStyle),
	          kernedWidth = info.kernedWidth,
	          width = info.width, charSpacing;
	
	      if (this.charSpacing !== 0) {
	        charSpacing = this._getWidthOfCharSpacing();
	        width += charSpacing;
	        kernedWidth += charSpacing;
	      }
	
	      var box = {
	        width: width,
	        left: 0,
	        height: style.fontSize,
	        kernedWidth: kernedWidth,
	        deltaY: style.deltaY,
	      };
	      if (charIndex > 0 && !skipLeft) {
	        var previousBox = this.__charBounds[lineIndex][charIndex - 1];
	        box.left = previousBox.left + previousBox.width + info.kernedWidth - info.width;
	      }
	      return box;
	    },
	
	    /**
	     * Calculate height of line at 'lineIndex'
	     * @param {Number} lineIndex index of line to calculate
	     * @return {Number}
	     */
	    getHeightOfLine: function(lineIndex) {
	      if (this.__lineHeights[lineIndex]) {
	        return this.__lineHeights[lineIndex];
	      }
	
	      var line = this._textLines[lineIndex],
	          // char 0 is measured before the line cycle because it nneds to char
	          // emptylines
	          maxHeight = this.getHeightOfChar(lineIndex, 0);
	      for (var i = 1, len = line.length; i < len; i++) {
	        maxHeight = Math.max(this.getHeightOfChar(lineIndex, i), maxHeight);
	      }
	
	      return this.__lineHeights[lineIndex] = maxHeight * this.lineHeight * this._fontSizeMult;
	    },
	
	    /**
	     * Calculate text box height
	     */
	    calcTextHeight: function() {
	      var lineHeight, height = 0;
	      for (var i = 0, len = this._textLines.length; i < len; i++) {
	        lineHeight = this.getHeightOfLine(i);
	        height += (i === len - 1 ? lineHeight / this.lineHeight : lineHeight);
	      }
	      return height;
	    },
	
	    /**
	     * @private
	     * @return {Number} Left offset
	     */
	    _getLeftOffset: function() {
	      return -this.width / 2;
	    },
	
	    /**
	     * @private
	     * @return {Number} Top offset
	     */
	    _getTopOffset: function() {
	      return -this.height / 2;
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {String} method Method name ("fillText" or "strokeText")
	     */
	    _renderTextCommon: function(ctx, method) {
	      ctx.save();
	      var lineHeights = 0, left = this._getLeftOffset(), top = this._getTopOffset(),
	          offsets = this._applyPatternGradientTransform(ctx, method === 'fillText' ? this.fill : this.stroke);
	      for (var i = 0, len = this._textLines.length; i < len; i++) {
	        var heightOfLine = this.getHeightOfLine(i),
	            maxHeight = heightOfLine / this.lineHeight,
	            leftOffset = this._getLineLeftOffset(i);
	        this._renderTextLine(
	          method,
	          ctx,
	          this._textLines[i],
	          left + leftOffset - offsets.offsetX,
	          top + lineHeights + maxHeight - offsets.offsetY,
	          i
	        );
	        lineHeights += heightOfLine;
	      }
	      ctx.restore();
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderTextFill: function(ctx) {
	      if (!this.fill && !this.styleHas('fill')) {
	        return;
	      }
	
	      this._renderTextCommon(ctx, 'fillText');
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderTextStroke: function(ctx) {
	      if ((!this.stroke || this.strokeWidth === 0) && this.isEmptyStyles()) {
	        return;
	      }
	
	      if (this.shadow && !this.shadow.affectStroke) {
	        this._removeShadow(ctx);
	      }
	
	      ctx.save();
	      this._setLineDash(ctx, this.strokeDashArray);
	      ctx.beginPath();
	      this._renderTextCommon(ctx, 'strokeText');
	      ctx.closePath();
	      ctx.restore();
	    },
	
	    /**
	     * @private
	     * @param {String} method
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {String} line Content of the line
	     * @param {Number} left
	     * @param {Number} top
	     * @param {Number} lineIndex
	     * @param {Number} charOffset
	     */
	    _renderChars: function(method, ctx, line, left, top, lineIndex) {
	      // set proper line offset
	      var lineHeight = this.getHeightOfLine(lineIndex),
	          isJustify = this.textAlign.indexOf('justify') !== -1,
	          actualStyle,
	          nextStyle,
	          charsToRender = '',
	          charBox,
	          boxWidth = 0,
	          timeToRender,
	          shortCut = !isJustify && this.charSpacing === 0 && this.isEmptyStyles(lineIndex);
	
	      ctx.save();
	      top -= lineHeight * this._fontSizeFraction / this.lineHeight;
	      if (shortCut) {
	        // render all the line in one pass without checking
	        this._renderChar(method, ctx, lineIndex, 0, this.textLines[lineIndex], left, top, lineHeight);
	        ctx.restore();
	        return;
	      }
	      for (var i = 0, len = line.length - 1; i <= len; i++) {
	        timeToRender = i === len || this.charSpacing;
	        charsToRender += line[i];
	        charBox = this.__charBounds[lineIndex][i];
	        if (boxWidth === 0) {
	          left += charBox.kernedWidth - charBox.width;
	          boxWidth += charBox.width;
	        }
	        else {
	          boxWidth += charBox.kernedWidth;
	        }
	        if (isJustify && !timeToRender) {
	          if (this._reSpaceAndTab.test(line[i])) {
	            timeToRender = true;
	          }
	        }
	        if (!timeToRender) {
	          // if we have charSpacing, we render char by char
	          actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
	          nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
	          timeToRender = this._hasStyleChanged(actualStyle, nextStyle);
	        }
	        if (timeToRender) {
	          this._renderChar(method, ctx, lineIndex, i, charsToRender, left, top, lineHeight);
	          charsToRender = '';
	          actualStyle = nextStyle;
	          left += boxWidth;
	          boxWidth = 0;
	        }
	      }
	      ctx.restore();
	    },
	
	    /**
	     * @private
	     * @param {String} method
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     * @param {Number} lineIndex
	     * @param {Number} charIndex
	     * @param {String} _char
	     * @param {Number} left Left coordinate
	     * @param {Number} top Top coordinate
	     * @param {Number} lineHeight Height of the line
	     */
	    _renderChar: function(method, ctx, lineIndex, charIndex, _char, left, top) {
	      var decl = this._getStyleDeclaration(lineIndex, charIndex),
	          fullDecl = this.getCompleteStyleDeclaration(lineIndex, charIndex),
	          shouldFill = method === 'fillText' && fullDecl.fill,
	          shouldStroke = method === 'strokeText' && fullDecl.stroke && fullDecl.strokeWidth;
	
	      if (!shouldStroke && !shouldFill) {
	        return;
	      }
	      decl && ctx.save();
	
	      this._applyCharStyles(method, ctx, lineIndex, charIndex, fullDecl);
	
	      if (decl && decl.textBackgroundColor) {
	        this._removeShadow(ctx);
	      }
	      if (decl && decl.deltaY) {
	        top += decl.deltaY;
	      }
	
	      shouldFill && ctx.fillText(_char, left, top);
	      shouldStroke && ctx.strokeText(_char, left, top);
	      decl && ctx.restore();
	    },
	
	    /**
	     * Turns the character into a 'superior figure' (i.e. 'superscript')
	     * @param {Number} start selection start
	     * @param {Number} end selection end
	     * @returns {fabric.Text} thisArg
	     * @chainable
	     */
	    setSuperscript: function(start, end) {
	      return this._setScript(start, end, this.superscript);
	    },
	
	    /**
	     * Turns the character into an 'inferior figure' (i.e. 'subscript')
	     * @param {Number} start selection start
	     * @param {Number} end selection end
	     * @returns {fabric.Text} thisArg
	     * @chainable
	     */
	    setSubscript: function(start, end) {
	      return this._setScript(start, end, this.subscript);
	    },
	
	    /**
	     * Applies 'schema' at given position
	     * @private
	     * @param {Number} start selection start
	     * @param {Number} end selection end
	     * @param {Number} schema
	     * @returns {fabric.Text} thisArg
	     * @chainable
	     */
	    _setScript: function(start, end, schema) {
	      var loc = this.get2DCursorLocation(start, true),
	          fontSize = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, 'fontSize'),
	          dy = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, 'deltaY'),
	          style = { fontSize: fontSize * schema.size, deltaY: dy + fontSize * schema.baseline };
	      this.setSelectionStyles(style, start, end);
	      return this;
	    },
	
	    /**
	     * @private
	     * @param {Object} prevStyle
	     * @param {Object} thisStyle
	     */
	    _hasStyleChanged: function(prevStyle, thisStyle) {
	      return prevStyle.fill !== thisStyle.fill ||
	              prevStyle.stroke !== thisStyle.stroke ||
	              prevStyle.strokeWidth !== thisStyle.strokeWidth ||
	              prevStyle.fontSize !== thisStyle.fontSize ||
	              prevStyle.fontFamily !== thisStyle.fontFamily ||
	              prevStyle.fontWeight !== thisStyle.fontWeight ||
	              prevStyle.fontStyle !== thisStyle.fontStyle ||
	              prevStyle.deltaY !== thisStyle.deltaY;
	    },
	
	    /**
	     * @private
	     * @param {Object} prevStyle
	     * @param {Object} thisStyle
	     */
	    _hasStyleChangedForSvg: function(prevStyle, thisStyle) {
	      return this._hasStyleChanged(prevStyle, thisStyle) ||
	        prevStyle.overline !== thisStyle.overline ||
	        prevStyle.underline !== thisStyle.underline ||
	        prevStyle.linethrough !== thisStyle.linethrough;
	    },
	
	    /**
	     * @private
	     * @param {Number} lineIndex index text line
	     * @return {Number} Line left offset
	     */
	    _getLineLeftOffset: function(lineIndex) {
	      var lineWidth = this.getLineWidth(lineIndex);
	      if (this.textAlign === 'center') {
	        return (this.width - lineWidth) / 2;
	      }
	      if (this.textAlign === 'right') {
	        return this.width - lineWidth;
	      }
	      if (this.textAlign === 'justify-center' && this.isEndOfWrapping(lineIndex)) {
	        return (this.width - lineWidth) / 2;
	      }
	      if (this.textAlign === 'justify-right' && this.isEndOfWrapping(lineIndex)) {
	        return this.width - lineWidth;
	      }
	      return 0;
	    },
	
	    /**
	     * @private
	     */
	    _clearCache: function() {
	      this.__lineWidths = [];
	      this.__lineHeights = [];
	      this.__charBounds = [];
	    },
	
	    /**
	     * @private
	     */
	    _shouldClearDimensionCache: function() {
	      var shouldClear = this._forceClearCache;
	      shouldClear || (shouldClear = this.hasStateChanged('_dimensionAffectingProps'));
	      if (shouldClear) {
	        this.dirty = true;
	        this._forceClearCache = false;
	      }
	      return shouldClear;
	    },
	
	    /**
	     * Measure a single line given its index. Used to calculate the initial
	     * text bounding box. The values are calculated and stored in __lineWidths cache.
	     * @private
	     * @param {Number} lineIndex line number
	     * @return {Number} Line width
	     */
	    getLineWidth: function(lineIndex) {
	      if (this.__lineWidths[lineIndex]) {
	        return this.__lineWidths[lineIndex];
	      }
	
	      var width, line = this._textLines[lineIndex], lineInfo;
	
	      if (line === '') {
	        width = 0;
	      }
	      else {
	        lineInfo = this.measureLine(lineIndex);
	        width = lineInfo.width;
	      }
	      this.__lineWidths[lineIndex] = width;
	      return width;
	    },
	
	    _getWidthOfCharSpacing: function() {
	      if (this.charSpacing !== 0) {
	        return this.fontSize * this.charSpacing / 1000;
	      }
	      return 0;
	    },
	
	    /**
	     * Retrieves the value of property at given character position
	     * @param {Number} lineIndex the line number
	     * @param {Number} charIndex the charater number
	     * @param {String} property the property name
	     * @returns the value of 'property'
	     */
	    getValueOfPropertyAt: function(lineIndex, charIndex, property) {
	      var charStyle = this._getStyleDeclaration(lineIndex, charIndex);
	      if (charStyle && typeof charStyle[property] !== 'undefined') {
	        return charStyle[property];
	      }
	      return this[property];
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _renderTextDecoration: function(ctx, type) {
	      if (!this[type] && !this.styleHas(type)) {
	        return;
	      }
	      var heightOfLine, size, _size,
	          lineLeftOffset, dy, _dy,
	          line, lastDecoration,
	          leftOffset = this._getLeftOffset(),
	          topOffset = this._getTopOffset(), top,
	          boxStart, boxWidth, charBox, currentDecoration,
	          maxHeight, currentFill, lastFill,
	          charSpacing = this._getWidthOfCharSpacing();
	
	      for (var i = 0, len = this._textLines.length; i < len; i++) {
	        heightOfLine = this.getHeightOfLine(i);
	        if (!this[type] && !this.styleHas(type, i)) {
	          topOffset += heightOfLine;
	          continue;
	        }
	        line = this._textLines[i];
	        maxHeight = heightOfLine / this.lineHeight;
	        lineLeftOffset = this._getLineLeftOffset(i);
	        boxStart = 0;
	        boxWidth = 0;
	        lastDecoration = this.getValueOfPropertyAt(i, 0, type);
	        lastFill = this.getValueOfPropertyAt(i, 0, 'fill');
	        top = topOffset + maxHeight * (1 - this._fontSizeFraction);
	        size = this.getHeightOfChar(i, 0);
	        dy = this.getValueOfPropertyAt(i, 0, 'deltaY');
	        for (var j = 0, jlen = line.length; j < jlen; j++) {
	          charBox = this.__charBounds[i][j];
	          currentDecoration = this.getValueOfPropertyAt(i, j, type);
	          currentFill = this.getValueOfPropertyAt(i, j, 'fill');
	          _size = this.getHeightOfChar(i, j);
	          _dy = this.getValueOfPropertyAt(i, j, 'deltaY');
	          if ((currentDecoration !== lastDecoration || currentFill !== lastFill || _size !== size || _dy !== dy) &&
	              boxWidth > 0) {
	            ctx.fillStyle = lastFill;
	            lastDecoration && lastFill && ctx.fillRect(
	              leftOffset + lineLeftOffset + boxStart,
	              top + this.offsets[type] * size + dy,
	              boxWidth,
	              this.fontSize / 15
	            );
	            boxStart = charBox.left;
	            boxWidth = charBox.width;
	            lastDecoration = currentDecoration;
	            lastFill = currentFill;
	            size = _size;
	            dy = _dy;
	          }
	          else {
	            boxWidth += charBox.kernedWidth;
	          }
	        }
	        ctx.fillStyle = currentFill;
	        currentDecoration && currentFill && ctx.fillRect(
	          leftOffset + lineLeftOffset + boxStart,
	          top + this.offsets[type] * size + dy,
	          boxWidth - charSpacing,
	          this.fontSize / 15
	        );
	        topOffset += heightOfLine;
	      }
	      // if there is text background color no
	      // other shadows should be casted
	      this._removeShadow(ctx);
	    },
	
	    /**
	     * return font declaration string for canvas context
	     * @param {Object} [styleObject] object
	     * @returns {String} font declaration formatted for canvas context.
	     */
	    _getFontDeclaration: function(styleObject, forMeasuring) {
	      var style = styleObject || this, family = this.fontFamily,
	          fontIsGeneric = fabric.Text.genericFonts.indexOf(family.toLowerCase()) > -1;
	      var fontFamily = family === undefined ||
	      family.indexOf('\'') > -1 || family.indexOf(',') > -1 ||
	      family.indexOf('"') > -1 || fontIsGeneric
	        ? style.fontFamily : '"' + style.fontFamily + '"';
	      return [
	        // node-canvas needs "weight style", while browsers need "style weight"
	        // verify if this can be fixed in JSDOM
	        (fabric.isLikelyNode ? style.fontWeight : style.fontStyle),
	        (fabric.isLikelyNode ? style.fontStyle : style.fontWeight),
	        forMeasuring ? this.CACHE_FONT_SIZE + 'px' : style.fontSize + 'px',
	        fontFamily
	      ].join(' ');
	    },
	
	    /**
	     * Renders text instance on a specified context
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    render: function(ctx) {
	      // do not render if object is not visible
	      if (!this.visible) {
	        return;
	      }
	      if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) {
	        return;
	      }
	      if (this._shouldClearDimensionCache()) {
	        this.initDimensions();
	      }
	      this.callSuper('render', ctx);
	    },
	
	    /**
	     * Returns the text as an array of lines.
	     * @param {String} text text to split
	     * @returns {Array} Lines in the text
	     */
	    _splitTextIntoLines: function(text) {
	      var lines = text.split(this._reNewline),
	          newLines = new Array(lines.length),
	          newLine = ['\n'],
	          newText = [];
	      for (var i = 0; i < lines.length; i++) {
	        newLines[i] = fabric.util.string.graphemeSplit(lines[i]);
	        newText = newText.concat(newLines[i], newLine);
	      }
	      newText.pop();
	      return { _unwrappedLines: newLines, lines: lines, graphemeText: newText, graphemeLines: newLines };
	    },
	
	    /**
	     * Returns object representation of an instance
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} Object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      var additionalProperties = [
	        'text',
	        'fontSize',
	        'fontWeight',
	        'fontFamily',
	        'fontStyle',
	        'lineHeight',
	        'underline',
	        'overline',
	        'linethrough',
	        'textAlign',
	        'textBackgroundColor',
	        'charSpacing',
	      ].concat(propertiesToInclude);
	      var obj = this.callSuper('toObject', additionalProperties);
	      obj.styles = clone(this.styles, true);
	      return obj;
	    },
	
	    /**
	     * Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
	     * @param {String|Object} key Property name or object (if object, iterate over the object properties)
	     * @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
	     * @return {fabric.Object} thisArg
	     * @chainable
	     */
	    set: function(key, value) {
	      this.callSuper('set', key, value);
	      var needsDims = false;
	      if (typeof key === 'object') {
	        for (var _key in key) {
	          needsDims = needsDims || this._dimensionAffectingProps.indexOf(_key) !== -1;
	        }
	      }
	      else {
	        needsDims = this._dimensionAffectingProps.indexOf(key) !== -1;
	      }
	      if (needsDims) {
	        this.initDimensions();
	        this.setCoords();
	      }
	      return this;
	    },
	
	    /**
	     * Returns complexity of an instance
	     * @return {Number} complexity
	     */
	    complexity: function() {
	      return 1;
	    }
	  });
	
	  /* _FROM_SVG_START_ */
	  /**
	   * List of attribute names to account for when parsing SVG element (used by {@link fabric.Text.fromElement})
	   * @static
	   * @memberOf fabric.Text
	   * @see: http://www.w3.org/TR/SVG/text.html#TextElement
	   */
	  fabric.Text.ATTRIBUTE_NAMES = fabric.SHARED_ATTRIBUTES.concat(
	    'x y dx dy font-family font-style font-weight font-size letter-spacing text-decoration text-anchor'.split(' '));
	
	  /**
	   * Default SVG font size
	   * @static
	   * @memberOf fabric.Text
	   */
	  fabric.Text.DEFAULT_SVG_FONT_SIZE = 16;
	
	  /**
	   * Returns fabric.Text instance from an SVG element (<b>not yet implemented</b>)
	   * @static
	   * @memberOf fabric.Text
	   * @param {SVGElement} element Element to parse
	   * @param {Function} callback callback function invoked after parsing
	   * @param {Object} [options] Options object
	   */
	  fabric.Text.fromElement = function(element, callback, options) {
	    if (!element) {
	      return callback(null);
	    }
	
	    var parsedAttributes = fabric.parseAttributes(element, fabric.Text.ATTRIBUTE_NAMES),
	        parsedAnchor = parsedAttributes.textAnchor || 'left';
	    options = fabric.util.object.extend((options ? clone(options) : { }), parsedAttributes);
	
	    options.top = options.top || 0;
	    options.left = options.left || 0;
	    if (parsedAttributes.textDecoration) {
	      var textDecoration = parsedAttributes.textDecoration;
	      if (textDecoration.indexOf('underline') !== -1) {
	        options.underline = true;
	      }
	      if (textDecoration.indexOf('overline') !== -1) {
	        options.overline = true;
	      }
	      if (textDecoration.indexOf('line-through') !== -1) {
	        options.linethrough = true;
	      }
	      delete options.textDecoration;
	    }
	    if ('dx' in parsedAttributes) {
	      options.left += parsedAttributes.dx;
	    }
	    if ('dy' in parsedAttributes) {
	      options.top += parsedAttributes.dy;
	    }
	    if (!('fontSize' in options)) {
	      options.fontSize = fabric.Text.DEFAULT_SVG_FONT_SIZE;
	    }
	
	    var textContent = '';
	
	    // The XML is not properly parsed in IE9 so a workaround to get
	    // textContent is through firstChild.data. Another workaround would be
	    // to convert XML loaded from a file to be converted using DOMParser (same way loadSVGFromString() does)
	    if (!('textContent' in element)) {
	      if ('firstChild' in element && element.firstChild !== null) {
	        if ('data' in element.firstChild && element.firstChild.data !== null) {
	          textContent = element.firstChild.data;
	        }
	      }
	    }
	    else {
	      textContent = element.textContent;
	    }
	
	    textContent = textContent.replace(/^\s+|\s+$|\n+/g, '').replace(/\s+/g, ' ');
	    var originalStrokeWidth = options.strokeWidth;
	    options.strokeWidth = 0;
	
	    var text = new fabric.Text(textContent, options),
	        textHeightScaleFactor = text.getScaledHeight() / text.height,
	        lineHeightDiff = (text.height + text.strokeWidth) * text.lineHeight - text.height,
	        scaledDiff = lineHeightDiff * textHeightScaleFactor,
	        textHeight = text.getScaledHeight() + scaledDiff,
	        offX = 0;
	    /*
	      Adjust positioning:
	        x/y attributes in SVG correspond to the bottom-left corner of text bounding box
	        fabric output by default at top, left.
	    */
	    if (parsedAnchor === 'center') {
	      offX = text.getScaledWidth() / 2;
	    }
	    if (parsedAnchor === 'right') {
	      offX = text.getScaledWidth();
	    }
	    text.set({
	      left: text.left - offX,
	      top: text.top - (textHeight - text.fontSize * (0.07 + text._fontSizeFraction)) / text.lineHeight,
	      strokeWidth: typeof originalStrokeWidth !== 'undefined' ? originalStrokeWidth : 1,
	    });
	    callback(text);
	  };
	  /* _FROM_SVG_END_ */
	
	  /**
	   * Returns fabric.Text instance from an object representation
	   * @static
	   * @memberOf fabric.Text
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] Callback to invoke when an fabric.Text instance is created
	   */
	  fabric.Text.fromObject = function(object, callback) {
	    return fabric.Object._fromObject('Text', object, callback, 'text');
	  };
	
	  fabric.Text.genericFonts = ['sans-serif', 'serif', 'cursive', 'fantasy', 'monospace'];
	
	  fabric.util.createAccessors && fabric.util.createAccessors(fabric.Text);
	
	})( true ? exports : this);
	
	
	(function() {
	  fabric.util.object.extend(fabric.Text.prototype, /** @lends fabric.Text.prototype */ {
	    /**
	     * Returns true if object has no styling or no styling in a line
	     * @param {Number} lineIndex , lineIndex is on wrapped lines.
	     * @return {Boolean}
	     */
	    isEmptyStyles: function(lineIndex) {
	      if (!this.styles) {
	        return true;
	      }
	      if (typeof lineIndex !== 'undefined' && !this.styles[lineIndex]) {
	        return true;
	      }
	      var obj = typeof lineIndex === 'undefined' ? this.styles : { line: this.styles[lineIndex] };
	      for (var p1 in obj) {
	        for (var p2 in obj[p1]) {
	          // eslint-disable-next-line no-unused-vars
	          for (var p3 in obj[p1][p2]) {
	            return false;
	          }
	        }
	      }
	      return true;
	    },
	
	    /**
	     * Returns true if object has a style property or has it ina specified line
	     * This function is used to detect if a text will use a particular property or not.
	     * @param {String} property to check for
	     * @param {Number} lineIndex to check the style on
	     * @return {Boolean}
	     */
	    styleHas: function(property, lineIndex) {
	      if (!this.styles || !property || property === '') {
	        return false;
	      }
	      if (typeof lineIndex !== 'undefined' && !this.styles[lineIndex]) {
	        return false;
	      }
	      var obj = typeof lineIndex === 'undefined' ? this.styles : { 0: this.styles[lineIndex] };
	      // eslint-disable-next-line
	      for (var p1 in obj) {
	        // eslint-disable-next-line
	        for (var p2 in obj[p1]) {
	          if (typeof obj[p1][p2][property] !== 'undefined') {
	            return true;
	          }
	        }
	      }
	      return false;
	    },
	
	    /**
	     * Check if characters in a text have a value for a property
	     * whose value matches the textbox's value for that property.  If so,
	     * the character-level property is deleted.  If the character
	     * has no other properties, then it is also deleted.  Finally,
	     * if the line containing that character has no other characters
	     * then it also is deleted.
	     *
	     * @param {string} property The property to compare between characters and text.
	     */
	    cleanStyle: function(property) {
	      if (!this.styles || !property || property === '') {
	        return false;
	      }
	      var obj = this.styles, stylesCount = 0, letterCount, stylePropertyValue,
	          allStyleObjectPropertiesMatch = true, graphemeCount = 0, styleObject;
	      // eslint-disable-next-line
	      for (var p1 in obj) {
	        letterCount = 0;
	        // eslint-disable-next-line
	        for (var p2 in obj[p1]) {
	          var styleObject = obj[p1][p2],
	              stylePropertyHasBeenSet = styleObject.hasOwnProperty(property);
	
	          stylesCount++;
	
	          if (stylePropertyHasBeenSet) {
	            if (!stylePropertyValue) {
	              stylePropertyValue = styleObject[property];
	            }
	            else if (styleObject[property] !== stylePropertyValue) {
	              allStyleObjectPropertiesMatch = false;
	            }
	
	            if (styleObject[property] === this[property]) {
	              delete styleObject[property];
	            }
	          }
	          else {
	            allStyleObjectPropertiesMatch = false;
	          }
	
	          if (Object.keys(styleObject).length !== 0) {
	            letterCount++;
	          }
	          else {
	            delete obj[p1][p2];
	          }
	        }
	
	        if (letterCount === 0) {
	          delete obj[p1];
	        }
	      }
	      // if every grapheme has the same style set then
	      // delete those styles and set it on the parent
	      for (var i = 0; i < this._textLines.length; i++) {
	        graphemeCount += this._textLines[i].length;
	      }
	      if (allStyleObjectPropertiesMatch && stylesCount === graphemeCount) {
	        this[property] = stylePropertyValue;
	        this.removeStyle(property);
	      }
	    },
	
	    /**
	     * Remove a style property or properties from all individual character styles
	     * in a text object.  Deletes the character style object if it contains no other style
	     * props.  Deletes a line style object if it contains no other character styles.
	     *
	     * @param {String} props The property to remove from character styles.
	     */
	    removeStyle: function(property) {
	      if (!this.styles || !property || property === '') {
	        return;
	      }
	      var obj = this.styles, line, lineNum, charNum;
	      for (lineNum in obj) {
	        line = obj[lineNum];
	        for (charNum in line) {
	          delete line[charNum][property];
	          if (Object.keys(line[charNum]).length === 0) {
	            delete line[charNum];
	          }
	        }
	        if (Object.keys(line).length === 0) {
	          delete obj[lineNum];
	        }
	      }
	    },
	
	    /**
	     * @private
	     */
	    _extendStyles: function(index, styles) {
	      var loc = this.get2DCursorLocation(index);
	
	      if (!this._getLineStyle(loc.lineIndex)) {
	        this._setLineStyle(loc.lineIndex);
	      }
	
	      if (!this._getStyleDeclaration(loc.lineIndex, loc.charIndex)) {
	        this._setStyleDeclaration(loc.lineIndex, loc.charIndex, {});
	      }
	
	      fabric.util.object.extend(this._getStyleDeclaration(loc.lineIndex, loc.charIndex), styles);
	    },
	
	    /**
	     * Returns 2d representation (lineIndex and charIndex) of cursor (or selection start)
	     * @param {Number} [selectionStart] Optional index. When not given, current selectionStart is used.
	     * @param {Boolean} [skipWrapping] consider the location for unwrapped lines. usefull to manage styles.
	     */
	    get2DCursorLocation: function(selectionStart, skipWrapping) {
	      if (typeof selectionStart === 'undefined') {
	        selectionStart = this.selectionStart;
	      }
	      var lines = skipWrapping ? this._unwrappedTextLines : this._textLines,
	          len = lines.length;
	      for (var i = 0; i < len; i++) {
	        if (selectionStart <= lines[i].length) {
	          return {
	            lineIndex: i,
	            charIndex: selectionStart
	          };
	        }
	        selectionStart -= lines[i].length + this.missingNewlineOffset(i);
	      }
	      return {
	        lineIndex: i - 1,
	        charIndex: lines[i - 1].length < selectionStart ? lines[i - 1].length : selectionStart
	      };
	    },
	
	    /**
	     * Gets style of a current selection/cursor (at the start position)
	     * if startIndex or endIndex are not provided, slectionStart or selectionEnd will be used.
	     * @param {Number} [startIndex] Start index to get styles at
	     * @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
	     * @param {Boolean} [complete] get full style or not
	     * @return {Array} styles an array with one, zero or more Style objects
	     */
	    getSelectionStyles: function(startIndex, endIndex, complete) {
	      if (typeof startIndex === 'undefined') {
	        startIndex = this.selectionStart || 0;
	      }
	      if (typeof endIndex === 'undefined') {
	        endIndex = this.selectionEnd || startIndex;
	      }
	      var styles = [];
	      for (var i = startIndex; i < endIndex; i++) {
	        styles.push(this.getStyleAtPosition(i, complete));
	      }
	      return styles;
	    },
	
	    /**
	     * Gets style of a current selection/cursor position
	     * @param {Number} position  to get styles at
	     * @param {Boolean} [complete] full style if true
	     * @return {Object} style Style object at a specified index
	     * @private
	     */
	    getStyleAtPosition: function(position, complete) {
	      var loc = this.get2DCursorLocation(position),
	          style = complete ? this.getCompleteStyleDeclaration(loc.lineIndex, loc.charIndex) :
	            this._getStyleDeclaration(loc.lineIndex, loc.charIndex);
	      return style || {};
	    },
	
	    /**
	     * Sets style of a current selection, if no selection exist, do not set anything.
	     * @param {Object} [styles] Styles object
	     * @param {Number} [startIndex] Start index to get styles at
	     * @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
	     * @return {fabric.IText} thisArg
	     * @chainable
	     */
	    setSelectionStyles: function(styles, startIndex, endIndex) {
	      if (typeof startIndex === 'undefined') {
	        startIndex = this.selectionStart || 0;
	      }
	      if (typeof endIndex === 'undefined') {
	        endIndex = this.selectionEnd || startIndex;
	      }
	      for (var i = startIndex; i < endIndex; i++) {
	        this._extendStyles(i, styles);
	      }
	      /* not included in _extendStyles to avoid clearing cache more than once */
	      this._forceClearCache = true;
	      return this;
	    },
	
	    /**
	     * get the reference, not a clone, of the style object for a given character
	     * @param {Number} lineIndex
	     * @param {Number} charIndex
	     * @return {Object} style object
	     */
	    _getStyleDeclaration: function(lineIndex, charIndex) {
	      var lineStyle = this.styles && this.styles[lineIndex];
	      if (!lineStyle) {
	        return null;
	      }
	      return lineStyle[charIndex];
	    },
	
	    /**
	     * return a new object that contains all the style property for a character
	     * the object returned is newly created
	     * @param {Number} lineIndex of the line where the character is
	     * @param {Number} charIndex position of the character on the line
	     * @return {Object} style object
	     */
	    getCompleteStyleDeclaration: function(lineIndex, charIndex) {
	      var style = this._getStyleDeclaration(lineIndex, charIndex) || { },
	          styleObject = { }, prop;
	      for (var i = 0; i < this._styleProperties.length; i++) {
	        prop = this._styleProperties[i];
	        styleObject[prop] = typeof style[prop] === 'undefined' ? this[prop] : style[prop];
	      }
	      return styleObject;
	    },
	
	    /**
	     * @param {Number} lineIndex
	     * @param {Number} charIndex
	     * @param {Object} style
	     * @private
	     */
	    _setStyleDeclaration: function(lineIndex, charIndex, style) {
	      this.styles[lineIndex][charIndex] = style;
	    },
	
	    /**
	     *
	     * @param {Number} lineIndex
	     * @param {Number} charIndex
	     * @private
	     */
	    _deleteStyleDeclaration: function(lineIndex, charIndex) {
	      delete this.styles[lineIndex][charIndex];
	    },
	
	    /**
	     * @param {Number} lineIndex
	     * @return {Boolean} if the line exists or not
	     * @private
	     */
	    _getLineStyle: function(lineIndex) {
	      return !!this.styles[lineIndex];
	    },
	
	    /**
	     * Set the line style to an empty object so that is initialized
	     * @param {Number} lineIndex
	     * @private
	     */
	    _setLineStyle: function(lineIndex) {
	      this.styles[lineIndex] = {};
	    },
	
	    /**
	     * @param {Number} lineIndex
	     * @private
	     */
	    _deleteLineStyle: function(lineIndex) {
	      delete this.styles[lineIndex];
	    }
	  });
	})();
	
	
	(function() {
	
	  function parseDecoration(object) {
	    if (object.textDecoration) {
	      object.textDecoration.indexOf('underline') > -1 && (object.underline = true);
	      object.textDecoration.indexOf('line-through') > -1 && (object.linethrough = true);
	      object.textDecoration.indexOf('overline') > -1 && (object.overline = true);
	      delete object.textDecoration;
	    }
	  }
	
	  /**
	   * IText class (introduced in <b>v1.4</b>) Events are also fired with "text:"
	   * prefix when observing canvas.
	   * @class fabric.IText
	   * @extends fabric.Text
	   * @mixes fabric.Observable
	   *
	   * @fires changed
	   * @fires selection:changed
	   * @fires editing:entered
	   * @fires editing:exited
	   *
	   * @return {fabric.IText} thisArg
	   * @see {@link fabric.IText#initialize} for constructor definition
	   *
	   * <p>Supported key combinations:</p>
	   * <pre>
	   *   Move cursor:                    left, right, up, down
	   *   Select character:               shift + left, shift + right
	   *   Select text vertically:         shift + up, shift + down
	   *   Move cursor by word:            alt + left, alt + right
	   *   Select words:                   shift + alt + left, shift + alt + right
	   *   Move cursor to line start/end:  cmd + left, cmd + right or home, end
	   *   Select till start/end of line:  cmd + shift + left, cmd + shift + right or shift + home, shift + end
	   *   Jump to start/end of text:      cmd + up, cmd + down
	   *   Select till start/end of text:  cmd + shift + up, cmd + shift + down or shift + pgUp, shift + pgDown
	   *   Delete character:               backspace
	   *   Delete word:                    alt + backspace
	   *   Delete line:                    cmd + backspace
	   *   Forward delete:                 delete
	   *   Copy text:                      ctrl/cmd + c
	   *   Paste text:                     ctrl/cmd + v
	   *   Cut text:                       ctrl/cmd + x
	   *   Select entire text:             ctrl/cmd + a
	   *   Quit editing                    tab or esc
	   * </pre>
	   *
	   * <p>Supported mouse/touch combination</p>
	   * <pre>
	   *   Position cursor:                click/touch
	   *   Create selection:               click/touch & drag
	   *   Create selection:               click & shift + click
	   *   Select word:                    double click
	   *   Select line:                    triple click
	   * </pre>
	   */
	  fabric.IText = fabric.util.createClass(fabric.Text, fabric.Observable, /** @lends fabric.IText.prototype */ {
	
	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'i-text',
	
	    /**
	     * Index where text selection starts (or where cursor is when there is no selection)
	     * @type Number
	     * @default
	     */
	    selectionStart: 0,
	
	    /**
	     * Index where text selection ends
	     * @type Number
	     * @default
	     */
	    selectionEnd: 0,
	
	    /**
	     * Color of text selection
	     * @type String
	     * @default
	     */
	    selectionColor: 'rgba(17,119,255,0.3)',
	
	    /**
	     * Indicates whether text is in editing mode
	     * @type Boolean
	     * @default
	     */
	    isEditing: false,
	
	    /**
	     * Indicates whether a text can be edited
	     * @type Boolean
	     * @default
	     */
	    editable: true,
	
	    /**
	     * Border color of text object while it's in editing mode
	     * @type String
	     * @default
	     */
	    editingBorderColor: 'rgba(102,153,255,0.25)',
	
	    /**
	     * Width of cursor (in px)
	     * @type Number
	     * @default
	     */
	    cursorWidth: 2,
	
	    /**
	     * Color of default cursor (when not overwritten by character style)
	     * @type String
	     * @default
	     */
	    cursorColor: '#333',
	
	    /**
	     * Delay between cursor blink (in ms)
	     * @type Number
	     * @default
	     */
	    cursorDelay: 1000,
	
	    /**
	     * Duration of cursor fadein (in ms)
	     * @type Number
	     * @default
	     */
	    cursorDuration: 600,
	
	    /**
	     * Indicates whether internal text char widths can be cached
	     * @type Boolean
	     * @default
	     */
	    caching: true,
	
	    /**
	     * @private
	     */
	    _reSpace: /\s|\n/,
	
	    /**
	     * @private
	     */
	    _currentCursorOpacity: 0,
	
	    /**
	     * @private
	     */
	    _selectionDirection: null,
	
	    /**
	     * @private
	     */
	    _abortCursorAnimation: false,
	
	    /**
	     * @private
	     */
	    __widthOfSpace: [],
	
	    /**
	     * Helps determining when the text is in composition, so that the cursor
	     * rendering is altered.
	     */
	    inCompositionMode: false,
	
	    /**
	     * Constructor
	     * @param {String} text Text string
	     * @param {Object} [options] Options object
	     * @return {fabric.IText} thisArg
	     */
	    initialize: function(text, options) {
	      this.callSuper('initialize', text, options);
	      this.initBehavior();
	    },
	
	    /**
	     * Sets selection start (left boundary of a selection)
	     * @param {Number} index Index to set selection start to
	     */
	    setSelectionStart: function(index) {
	      index = Math.max(index, 0);
	      this._updateAndFire('selectionStart', index);
	    },
	
	    /**
	     * Sets selection end (right boundary of a selection)
	     * @param {Number} index Index to set selection end to
	     */
	    setSelectionEnd: function(index) {
	      index = Math.min(index, this.text.length);
	      this._updateAndFire('selectionEnd', index);
	    },
	
	    /**
	     * @private
	     * @param {String} property 'selectionStart' or 'selectionEnd'
	     * @param {Number} index new position of property
	     */
	    _updateAndFire: function(property, index) {
	      if (this[property] !== index) {
	        this._fireSelectionChanged();
	        this[property] = index;
	      }
	      this._updateTextarea();
	    },
	
	    /**
	     * Fires the even of selection changed
	     * @private
	     */
	    _fireSelectionChanged: function() {
	      this.fire('selection:changed');
	      this.canvas && this.canvas.fire('text:selection:changed', { target: this });
	    },
	
	    /**
	     * Initialize text dimensions. Render all text on given context
	     * or on a offscreen canvas to get the text width with measureText.
	     * Updates this.width and this.height with the proper values.
	     * Does not return dimensions.
	     * @private
	     */
	    initDimensions: function() {
	      this.isEditing && this.initDelayedCursor();
	      this.clearContextTop();
	      this.callSuper('initDimensions');
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    render: function(ctx) {
	      this.clearContextTop();
	      this.callSuper('render', ctx);
	      // clear the cursorOffsetCache, so we ensure to calculate once per renderCursor
	      // the correct position but not at every cursor animation.
	      this.cursorOffsetCache = { };
	      this.renderCursorOrSelection();
	    },
	
	    /**
	     * @private
	     * @param {CanvasRenderingContext2D} ctx Context to render on
	     */
	    _render: function(ctx) {
	      this.callSuper('_render', ctx);
	    },
	
	    /**
	     * Prepare and clean the contextTop
	     */
	    clearContextTop: function(skipRestore) {
	      if (!this.isEditing || !this.canvas || !this.canvas.contextTop) {
	        return;
	      }
	      var ctx = this.canvas.contextTop, v = this.canvas.viewportTransform;
	      ctx.save();
	      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
	      this.transform(ctx);
	      this.transformMatrix && ctx.transform.apply(ctx, this.transformMatrix);
	      this._clearTextArea(ctx);
	      skipRestore || ctx.restore();
	    },
	
	    /**
	     * Renders cursor or selection (depending on what exists)
	     * it does on the contextTop. If contextTop is not available, do nothing.
	     */
	    renderCursorOrSelection: function() {
	      if (!this.isEditing || !this.canvas || !this.canvas.contextTop) {
	        return;
	      }
	      var boundaries = this._getCursorBoundaries(),
	          ctx = this.canvas.contextTop;
	      this.clearContextTop(true);
	      if (this.selectionStart === this.selectionEnd) {
	        this.renderCursor(boundaries, ctx);
	      }
	      else {
	        this.renderSelection(boundaries, ctx);
	      }
	      ctx.restore();
	    },
	
	    _clearTextArea: function(ctx) {
	      // we add 4 pixel, to be sure to do not leave any pixel out
	      var width = this.width + 4, height = this.height + 4;
	      ctx.clearRect(-width / 2, -height / 2, width, height);
	    },
	
	    /**
	     * Returns cursor boundaries (left, top, leftOffset, topOffset)
	     * @private
	     * @param {Array} chars Array of characters
	     * @param {String} typeOfBoundaries
	     */
	    _getCursorBoundaries: function(position) {
	
	      // left/top are left/top of entire text box
	      // leftOffset/topOffset are offset from that left/top point of a text box
	
	      if (typeof position === 'undefined') {
	        position = this.selectionStart;
	      }
	
	      var left = this._getLeftOffset(),
	          top = this._getTopOffset(),
	          offsets = this._getCursorBoundariesOffsets(position);
	
	      return {
	        left: left,
	        top: top,
	        leftOffset: offsets.left,
	        topOffset: offsets.top
	      };
	    },
	
	    /**
	     * @private
	     */
	    _getCursorBoundariesOffsets: function(position) {
	      if (this.cursorOffsetCache && 'top' in this.cursorOffsetCache) {
	        return this.cursorOffsetCache;
	      }
	      var lineLeftOffset,
	          lineIndex,
	          charIndex,
	          topOffset = 0,
	          leftOffset = 0,
	          boundaries,
	          cursorPosition = this.get2DCursorLocation(position);
	      charIndex = cursorPosition.charIndex;
	      lineIndex = cursorPosition.lineIndex;
	      for (var i = 0; i < lineIndex; i++) {
	        topOffset += this.getHeightOfLine(i);
	      }
	      lineLeftOffset = this._getLineLeftOffset(lineIndex);
	      var bound = this.__charBounds[lineIndex][charIndex];
	      bound && (leftOffset = bound.left);
	      if (this.charSpacing !== 0 && charIndex === this._textLines[lineIndex].length) {
	        leftOffset -= this._getWidthOfCharSpacing();
	      }
	      boundaries = {
	        top: topOffset,
	        left: lineLeftOffset + (leftOffset > 0 ? leftOffset : 0),
	      };
	      this.cursorOffsetCache = boundaries;
	      return this.cursorOffsetCache;
	    },
	
	    /**
	     * Renders cursor
	     * @param {Object} boundaries
	     * @param {CanvasRenderingContext2D} ctx transformed context to draw on
	     */
	    renderCursor: function(boundaries, ctx) {
	      var cursorLocation = this.get2DCursorLocation(),
	          lineIndex = cursorLocation.lineIndex,
	          charIndex = cursorLocation.charIndex > 0 ? cursorLocation.charIndex - 1 : 0,
	          charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, 'fontSize'),
	          multiplier = this.scaleX * this.canvas.getZoom(),
	          cursorWidth = this.cursorWidth / multiplier,
	          topOffset = boundaries.topOffset,
	          dy = this.getValueOfPropertyAt(lineIndex, charIndex, 'deltaY');
	
	      topOffset += (1 - this._fontSizeFraction) * this.getHeightOfLine(lineIndex) / this.lineHeight
	        - charHeight * (1 - this._fontSizeFraction);
	
	      if (this.inCompositionMode) {
	        this.renderSelection(boundaries, ctx);
	      }
	
	      ctx.fillStyle = this.getValueOfPropertyAt(lineIndex, charIndex, 'fill');
	      ctx.globalAlpha = this.__isMousedown ? 1 : this._currentCursorOpacity;
	      ctx.fillRect(
	        boundaries.left + boundaries.leftOffset - cursorWidth / 2,
	        topOffset + boundaries.top + dy,
	        cursorWidth,
	        charHeight);
	    },
	
	    /**
	     * Renders text selection
	     * @param {Object} boundaries Object with left/top/leftOffset/topOffset
	     * @param {CanvasRenderingContext2D} ctx transformed context to draw on
	     */
	    renderSelection: function(boundaries, ctx) {
	
	      var selectionStart = this.inCompositionMode ? this.hiddenTextarea.selectionStart : this.selectionStart,
	          selectionEnd = this.inCompositionMode ? this.hiddenTextarea.selectionEnd : this.selectionEnd,
	          isJustify = this.textAlign.indexOf('justify') !== -1,
	          start = this.get2DCursorLocation(selectionStart),
	          end = this.get2DCursorLocation(selectionEnd),
	          startLine = start.lineIndex,
	          endLine = end.lineIndex,
	          startChar = start.charIndex < 0 ? 0 : start.charIndex,
	          endChar = end.charIndex < 0 ? 0 : end.charIndex;
	
	      for (var i = startLine; i <= endLine; i++) {
	        var lineOffset = this._getLineLeftOffset(i) || 0,
	            lineHeight = this.getHeightOfLine(i),
	            realLineHeight = 0, boxStart = 0, boxEnd = 0;
	
	        if (i === startLine) {
	          boxStart = this.__charBounds[startLine][startChar].left;
	        }
	        if (i >= startLine && i < endLine) {
	          boxEnd = isJustify && !this.isEndOfWrapping(i) ? this.width : this.getLineWidth(i) || 5; // WTF is this 5?
	        }
	        else if (i === endLine) {
	          if (endChar === 0) {
	            boxEnd = this.__charBounds[endLine][endChar].left;
	          }
	          else {
	            var charSpacing = this._getWidthOfCharSpacing();
	            boxEnd = this.__charBounds[endLine][endChar - 1].left
	              + this.__charBounds[endLine][endChar - 1].width - charSpacing;
	          }
	        }
	        realLineHeight = lineHeight;
	        if (this.lineHeight < 1 || (i === endLine && this.lineHeight > 1)) {
	          lineHeight /= this.lineHeight;
	        }
	        if (this.inCompositionMode) {
	          ctx.fillStyle = this.compositionColor || 'black';
	          ctx.fillRect(
	            boundaries.left + lineOffset + boxStart,
	            boundaries.top + boundaries.topOffset + lineHeight,
	            boxEnd - boxStart,
	            1);
	        }
	        else {
	          ctx.fillStyle = this.selectionColor;
	          ctx.fillRect(
	            boundaries.left + lineOffset + boxStart,
	            boundaries.top + boundaries.topOffset,
	            boxEnd - boxStart,
	            lineHeight);
	        }
	
	
	        boundaries.topOffset += realLineHeight;
	      }
	    },
	
	    /**
	     * High level function to know the height of the cursor.
	     * the currentChar is the one that precedes the cursor
	     * Returns fontSize of char at the current cursor
	     * @return {Number} Character font size
	     */
	    getCurrentCharFontSize: function() {
	      var cp = this._getCurrentCharIndex();
	      return this.getValueOfPropertyAt(cp.l, cp.c, 'fontSize');
	    },
	
	    /**
	     * High level function to know the color of the cursor.
	     * the currentChar is the one that precedes the cursor
	     * Returns color (fill) of char at the current cursor
	     * @return {String} Character color (fill)
	     */
	    getCurrentCharColor: function() {
	      var cp = this._getCurrentCharIndex();
	      return this.getValueOfPropertyAt(cp.l, cp.c, 'fill');
	    },
	
	    /**
	     * Returns the cursor position for the getCurrent.. functions
	     * @private
	     */
	    _getCurrentCharIndex: function() {
	      var cursorPosition = this.get2DCursorLocation(this.selectionStart, true),
	          charIndex = cursorPosition.charIndex > 0 ? cursorPosition.charIndex - 1 : 0;
	      return { l: cursorPosition.lineIndex, c: charIndex };
	    }
	  });
	
	  /**
	   * Returns fabric.IText instance from an object representation
	   * @static
	   * @memberOf fabric.IText
	   * @param {Object} object Object to create an instance from
	   * @param {function} [callback] invoked with new instance as argument
	   */
	  fabric.IText.fromObject = function(object, callback) {
	    parseDecoration(object);
	    if (object.styles) {
	      for (var i in object.styles) {
	        for (var j in object.styles[i]) {
	          parseDecoration(object.styles[i][j]);
	        }
	      }
	    }
	    fabric.Object._fromObject('IText', object, callback, 'text');
	  };
	})();
	
	
	(function() {
	
	  var clone = fabric.util.object.clone;
	
	  fabric.util.object.extend(fabric.IText.prototype, /** @lends fabric.IText.prototype */ {
	
	    /**
	     * Initializes all the interactive behavior of IText
	     */
	    initBehavior: function() {
	      this.initAddedHandler();
	      this.initRemovedHandler();
	      this.initCursorSelectionHandlers();
	      this.initDoubleClickSimulation();
	      this.mouseMoveHandler = this.mouseMoveHandler.bind(this);
	    },
	
	    onDeselect: function() {
	      this.isEditing && this.exitEditing();
	      this.selected = false;
	    },
	
	    /**
	     * Initializes "added" event handler
	     */
	    initAddedHandler: function() {
	      var _this = this;
	      this.on('added', function() {
	        var canvas = _this.canvas;
	        if (canvas) {
	          if (!canvas._hasITextHandlers) {
	            canvas._hasITextHandlers = true;
	            _this._initCanvasHandlers(canvas);
	          }
	          canvas._iTextInstances = canvas._iTextInstances || [];
	          canvas._iTextInstances.push(_this);
	        }
	      });
	    },
	
	    initRemovedHandler: function() {
	      var _this = this;
	      this.on('removed', function() {
	        var canvas = _this.canvas;
	        if (canvas) {
	          canvas._iTextInstances = canvas._iTextInstances || [];
	          fabric.util.removeFromArray(canvas._iTextInstances, _this);
	          if (canvas._iTextInstances.length === 0) {
	            canvas._hasITextHandlers = false;
	            _this._removeCanvasHandlers(canvas);
	          }
	        }
	      });
	    },
	
	    /**
	     * register canvas event to manage exiting on other instances
	     * @private
	     */
	    _initCanvasHandlers: function(canvas) {
	      canvas._mouseUpITextHandler = function() {
	        if (canvas._iTextInstances) {
	          canvas._iTextInstances.forEach(function(obj) {
	            obj.__isMousedown = false;
	          });
	        }
	      };
	      canvas.on('mouse:up', canvas._mouseUpITextHandler);
	    },
	
	    /**
	     * remove canvas event to manage exiting on other instances
	     * @private
	     */
	    _removeCanvasHandlers: function(canvas) {
	      canvas.off('mouse:up', canvas._mouseUpITextHandler);
	    },
	
	    /**
	     * @private
	     */
	    _tick: function() {
	      this._currentTickState = this._animateCursor(this, 1, this.cursorDuration, '_onTickComplete');
	    },
	
	    /**
	     * @private
	     */
	    _animateCursor: function(obj, targetOpacity, duration, completeMethod) {
	
	      var tickState;
	
	      tickState = {
	        isAborted: false,
	        abort: function() {
	          this.isAborted = true;
	        },
	      };
	
	      obj.animate('_currentCursorOpacity', targetOpacity, {
	        duration: duration,
	        onComplete: function() {
	          if (!tickState.isAborted) {
	            obj[completeMethod]();
	          }
	        },
	        onChange: function() {
	          // we do not want to animate a selection, only cursor
	          if (obj.canvas && obj.selectionStart === obj.selectionEnd) {
	            obj.renderCursorOrSelection();
	          }
	        },
	        abort: function() {
	          return tickState.isAborted;
	        }
	      });
	      return tickState;
	    },
	
	    /**
	     * @private
	     */
	    _onTickComplete: function() {
	
	      var _this = this;
	
	      if (this._cursorTimeout1) {
	        clearTimeout(this._cursorTimeout1);
	      }
	      this._cursorTimeout1 = setTimeout(function() {
	        _this._currentTickCompleteState = _this._animateCursor(_this, 0, this.cursorDuration / 2, '_tick');
	      }, 100);
	    },
	
	    /**
	     * Initializes delayed cursor
	     */
	    initDelayedCursor: function(restart) {
	      var _this = this,
	          delay = restart ? 0 : this.cursorDelay;
	
	      this.abortCursorAnimation();
	      this._currentCursorOpacity = 1;
	      this._cursorTimeout2 = setTimeout(function() {
	        _this._tick();
	      }, delay);
	    },
	
	    /**
	     * Aborts cursor animation and clears all timeouts
	     */
	    abortCursorAnimation: function() {
	      var shouldClear = this._currentTickState || this._currentTickCompleteState,
	          canvas = this.canvas;
	      this._currentTickState && this._currentTickState.abort();
	      this._currentTickCompleteState && this._currentTickCompleteState.abort();
	
	      clearTimeout(this._cursorTimeout1);
	      clearTimeout(this._cursorTimeout2);
	
	      this._currentCursorOpacity = 0;
	      // to clear just itext area we need to transform the context
	      // it may not be worth it
	      if (shouldClear && canvas) {
	        canvas.clearContext(canvas.contextTop || canvas.contextContainer);
	      }
	
	    },
	
	    /**
	     * Selects entire text
	     * @return {fabric.IText} thisArg
	     * @chainable
	     */
	    selectAll: function() {
	      this.selectionStart = 0;
	      this.selectionEnd = this._text.length;
	      this._fireSelectionChanged();
	      this._updateTextarea();
	      return this;
	    },
	
	    /**
	     * Returns selected text
	     * @return {String}
	     */
	    getSelectedText: function() {
	      return this._text.slice(this.selectionStart, this.selectionEnd).join('');
	    },
	
	    /**
	     * Find new selection index representing start of current word according to current selection index
	     * @param {Number} startFrom Current selection index
	     * @return {Number} New selection index
	     */
	    findWordBoundaryLeft: function(startFrom) {
	      var offset = 0, index = startFrom - 1;
	
	      // remove space before cursor first
	      if (this._reSpace.test(this._text[index])) {
	        while (this._reSpace.test(this._text[index])) {
	          offset++;
	          index--;
	        }
	      }
	      while (/\S/.test(this._text[index]) && index > -1) {
	        offset++;
	        index--;
	      }
	
	      return startFrom - offset;
	    },
	
	    /**
	     * Find new selection index representing end of current word according to current selection index
	     * @param {Number} startFrom Current selection index
	     * @return {Number} New selection index
	     */
	    findWordBoundaryRight: function(startFrom) {
	      var offset = 0, index = startFrom;
	
	      // remove space after cursor first
	      if (this._reSpace.test(this._text[index])) {
	        while (this._reSpace.test(this._text[index])) {
	          offset++;
	          index++;
	        }
	      }
	      while (/\S/.test(this._text[index]) && index < this._text.length) {
	        offset++;
	        index++;
	      }
	
	      return startFrom + offset;
	    },
	
	    /**
	     * Find new selection index representing start of current line according to current selection index
	     * @param {Number} startFrom Current selection index
	     * @return {Number} New selection index
	     */
	    findLineBoundaryLeft: function(startFrom) {
	      var offset = 0, index = startFrom - 1;
	
	      while (!/\n/.test(this._text[index]) && index > -1) {
	        offset++;
	        index--;
	      }
	
	      return startFrom - offset;
	    },
	
	    /**
	     * Find new selection index representing end of current line according to current selection index
	     * @param {Number} startFrom Current selection index
	     * @return {Number} New selection index
	     */
	    findLineBoundaryRight: function(startFrom) {
	      var offset = 0, index = startFrom;
	
	      while (!/\n/.test(this._text[index]) && index < this._text.length) {
	        offset++;
	        index++;
	      }
	
	      return startFrom + offset;
	    },
	
	    /**
	     * Finds index corresponding to beginning or end of a word
	     * @param {Number} selectionStart Index of a character
	     * @param {Number} direction 1 or -1
	     * @return {Number} Index of the beginning or end of a word
	     */
	    searchWordBoundary: function(selectionStart, direction) {
	      var index     = this._reSpace.test(this._text[selectionStart]) ? selectionStart - 1 : selectionStart,
	          _char     = this._text[index],
	          reNonWord = /[ \n\.,;!\?\-]/;
	
	      while (!reNonWord.test(_char) && index > 0 && index < this._text.length) {
	        index += direction;
	        _char = this._text[index];
	      }
	      if (reNonWord.test(_char) && _char !== '\n') {
	        index += direction === 1 ? 0 : 1;
	      }
	      return index;
	    },
	
	    /**
	     * Selects a word based on the index
	     * @param {Number} selectionStart Index of a character
	     */
	    selectWord: function(selectionStart) {
	      selectionStart = selectionStart || this.selectionStart;
	      var newSelectionStart = this.searchWordBoundary(selectionStart, -1), /* search backwards */
	          newSelectionEnd = this.searchWordBoundary(selectionStart, 1); /* search forward */
	
	      this.selectionStart = newSelectionStart;
	      this.selectionEnd = newSelectionEnd;
	      this._fireSelectionChanged();
	      this._updateTextarea();
	      this.renderCursorOrSelection();
	    },
	
	    /**
	     * Selects a line based on the index
	     * @param {Number} selectionStart Index of a character
	     * @return {fabric.IText} thisArg
	     * @chainable
	     */
	    selectLine: function(selectionStart) {
	      selectionStart = selectionStart || this.selectionStart;
	      var newSelectionStart = this.findLineBoundaryLeft(selectionStart),
	          newSelectionEnd = this.findLineBoundaryRight(selectionStart);
	
	      this.selectionStart = newSelectionStart;
	      this.selectionEnd = newSelectionEnd;
	      this._fireSelectionChanged();
	      this._updateTextarea();
	      return this;
	    },
	
	    /**
	     * Enters editing state
	     * @return {fabric.IText} thisArg
	     * @chainable
	     */
	    enterEditing: function(e) {
	      if (this.isEditing || !this.editable) {
	        return;
	      }
	
	      if (this.canvas) {
	        this.canvas.calcOffset();
	        this.exitEditingOnOthers(this.canvas);
	      }
	
	      this.isEditing = true;
	
	      this.initHiddenTextarea(e);
	      this.hiddenTextarea.focus();
	      this.hiddenTextarea.value = this.text;
	      this._updateTextarea();
	      this._saveEditingProps();
	      this._setEditingProps();
	      this._textBeforeEdit = this.text;
	
	      this._tick();
	      this.fire('editing:entered');
	      this._fireSelectionChanged();
	      if (!this.canvas) {
	        return this;
	      }
	      this.canvas.fire('text:editing:entered', { target: this });
	      this.initMouseMoveHandler();
	      this.canvas.requestRenderAll();
	      return this;
	    },
	
	    exitEditingOnOthers: function(canvas) {
	      if (canvas._iTextInstances) {
	        canvas._iTextInstances.forEach(function(obj) {
	          obj.selected = false;
	          if (obj.isEditing) {
	            obj.exitEditing();
	          }
	        });
	      }
	    },
	
	    /**
	     * Initializes "mousemove" event handler
	     */
	    initMouseMoveHandler: function() {
	      this.canvas.on('mouse:move', this.mouseMoveHandler);
	    },
	
	    /**
	     * @private
	     */
	    mouseMoveHandler: function(options) {
	      if (!this.__isMousedown || !this.isEditing) {
	        return;
	      }
	
	      var newSelectionStart = this.getSelectionStartFromPointer(options.e),
	          currentStart = this.selectionStart,
	          currentEnd = this.selectionEnd;
	      if (
	        (newSelectionStart !== this.__selectionStartOnMouseDown || currentStart === currentEnd)
	        &&
	        (currentStart === newSelectionStart || currentEnd === newSelectionStart)
	      ) {
	        return;
	      }
	      if (newSelectionStart > this.__selectionStartOnMouseDown) {
	        this.selectionStart = this.__selectionStartOnMouseDown;
	        this.selectionEnd = newSelectionStart;
	      }
	      else {
	        this.selectionStart = newSelectionStart;
	        this.selectionEnd = this.__selectionStartOnMouseDown;
	      }
	      if (this.selectionStart !== currentStart || this.selectionEnd !== currentEnd) {
	        this.restartCursorIfNeeded();
	        this._fireSelectionChanged();
	        this._updateTextarea();
	        this.renderCursorOrSelection();
	      }
	    },
	
	    /**
	     * @private
	     */
	    _setEditingProps: function() {
	      this.hoverCursor = 'text';
	
	      if (this.canvas) {
	        this.canvas.defaultCursor = this.canvas.moveCursor = 'text';
	      }
	
	      this.borderColor = this.editingBorderColor;
	      this.hasControls = this.selectable = false;
	      this.lockMovementX = this.lockMovementY = true;
	    },
	
	    /**
	     * convert from textarea to grapheme indexes
	     */
	    fromStringToGraphemeSelection: function(start, end, text) {
	      var smallerTextStart = text.slice(0, start),
	          graphemeStart = fabric.util.string.graphemeSplit(smallerTextStart).length;
	      if (start === end) {
	        return { selectionStart: graphemeStart, selectionEnd: graphemeStart };
	      }
	      var smallerTextEnd = text.slice(start, end),
	          graphemeEnd = fabric.util.string.graphemeSplit(smallerTextEnd).length;
	      return { selectionStart: graphemeStart, selectionEnd: graphemeStart + graphemeEnd };
	    },
	
	    /**
	     * convert from fabric to textarea values
	     */
	    fromGraphemeToStringSelection: function(start, end, _text) {
	      var smallerTextStart = _text.slice(0, start),
	          graphemeStart = smallerTextStart.join('').length;
	      if (start === end) {
	        return { selectionStart: graphemeStart, selectionEnd: graphemeStart };
	      }
	      var smallerTextEnd = _text.slice(start, end),
	          graphemeEnd = smallerTextEnd.join('').length;
	      return { selectionStart: graphemeStart, selectionEnd: graphemeStart + graphemeEnd };
	    },
	
	    /**
	     * @private
	     */
	    _updateTextarea: function() {
	      this.cursorOffsetCache = { };
	      if (!this.hiddenTextarea) {
	        return;
	      }
	      if (!this.inCompositionMode) {
	        var newSelection = this.fromGraphemeToStringSelection(this.selectionStart, this.selectionEnd, this._text);
	        this.hiddenTextarea.selectionStart = newSelection.selectionStart;
	        this.hiddenTextarea.selectionEnd = newSelection.selectionEnd;
	      }
	      this.updateTextareaPosition();
	    },
	
	    /**
	     * @private
	     */
	    updateFromTextArea: function() {
	      if (!this.hiddenTextarea) {
	        return;
	      }
	      this.cursorOffsetCache = { };
	      this.text = this.hiddenTextarea.value;
	      if (this._shouldClearDimensionCache()) {
	        this.initDimensions();
	        this.setCoords();
	      }
	      var newSelection = this.fromStringToGraphemeSelection(
	        this.hiddenTextarea.selectionStart, this.hiddenTextarea.selectionEnd, this.hiddenTextarea.value);
	      this.selectionEnd = this.selectionStart = newSelection.selectionEnd;
	      if (!this.inCompositionMode) {
	        this.selectionStart = newSelection.selectionStart;
	      }
	      this.updateTextareaPosition();
	    },
	
	    /**
	     * @private
	     */
	    updateTextareaPosition: function() {
	      if (this.selectionStart === this.selectionEnd) {
	        var style = this._calcTextareaPosition();
	        this.hiddenTextarea.style.left = style.left;
	        this.hiddenTextarea.style.top = style.top;
	      }
	    },
	
	    /**
	     * @private
	     * @return {Object} style contains style for hiddenTextarea
	     */
	    _calcTextareaPosition: function() {
	      if (!this.canvas) {
	        return { x: 1, y: 1 };
	      }
	      var desiredPosition = this.inCompositionMode ? this.compositionStart : this.selectionStart,
	          boundaries = this._getCursorBoundaries(desiredPosition),
	          cursorLocation = this.get2DCursorLocation(desiredPosition),
	          lineIndex = cursorLocation.lineIndex,
	          charIndex = cursorLocation.charIndex,
	          charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, 'fontSize') * this.lineHeight,
	          leftOffset = boundaries.leftOffset,
	          m = this.calcTransformMatrix(),
	          p = {
	            x: boundaries.left + leftOffset,
	            y: boundaries.top + boundaries.topOffset + charHeight
	          },
	          upperCanvas = this.canvas.upperCanvasEl,
	          upperCanvasWidth = upperCanvas.width,
	          upperCanvasHeight = upperCanvas.height,
	          maxWidth = upperCanvasWidth - charHeight,
	          maxHeight = upperCanvasHeight - charHeight,
	          scaleX = upperCanvas.clientWidth / upperCanvasWidth,
	          scaleY = upperCanvas.clientHeight / upperCanvasHeight;
	
	      p = fabric.util.transformPoint(p, m);
	      p = fabric.util.transformPoint(p, this.canvas.viewportTransform);
	      p.x *= scaleX;
	      p.y *= scaleY;
	      if (p.x < 0) {
	        p.x = 0;
	      }
	      if (p.x > maxWidth) {
	        p.x = maxWidth;
	      }
	      if (p.y < 0) {
	        p.y = 0;
	      }
	      if (p.y > maxHeight) {
	        p.y = maxHeight;
	      }
	
	      // add canvas offset on document
	      p.x += this.canvas._offset.left;
	      p.y += this.canvas._offset.top;
	
	      return { left: p.x + 'px', top: p.y + 'px', fontSize: charHeight + 'px', charHeight: charHeight };
	    },
	
	    /**
	     * @private
	     */
	    _saveEditingProps: function() {
	      this._savedProps = {
	        hasControls: this.hasControls,
	        borderColor: this.borderColor,
	        lockMovementX: this.lockMovementX,
	        lockMovementY: this.lockMovementY,
	        hoverCursor: this.hoverCursor,
	        selectable: this.selectable,
	        defaultCursor: this.canvas && this.canvas.defaultCursor,
	        moveCursor: this.canvas && this.canvas.moveCursor
	      };
	    },
	
	    /**
	     * @private
	     */
	    _restoreEditingProps: function() {
	      if (!this._savedProps) {
	        return;
	      }
	
	      this.hoverCursor = this._savedProps.hoverCursor;
	      this.hasControls = this._savedProps.hasControls;
	      this.borderColor = this._savedProps.borderColor;
	      this.selectable = this._savedProps.selectable;
	      this.lockMovementX = this._savedProps.lockMovementX;
	      this.lockMovementY = this._savedProps.lockMovementY;
	
	      if (this.canvas) {
	        this.canvas.defaultCursor = this._savedProps.defaultCursor;
	        this.canvas.moveCursor = this._savedProps.moveCursor;
	      }
	    },
	
	    /**
	     * Exits from editing state
	     * @return {fabric.IText} thisArg
	     * @chainable
	     */
	    exitEditing: function() {
	      var isTextChanged = (this._textBeforeEdit !== this.text);
	      this.selected = false;
	      this.isEditing = false;
	
	      this.selectionEnd = this.selectionStart;
	
	      if (this.hiddenTextarea) {
	        this.hiddenTextarea.blur && this.hiddenTextarea.blur();
	        this.canvas && this.hiddenTextarea.parentNode.removeChild(this.hiddenTextarea);
	        this.hiddenTextarea = null;
	      }
	
	      this.abortCursorAnimation();
	      this._restoreEditingProps();
	      this._currentCursorOpacity = 0;
	      if (this._shouldClearDimensionCache()) {
	        this.initDimensions();
	        this.setCoords();
	      }
	      this.fire('editing:exited');
	      isTextChanged && this.fire('modified');
	      if (this.canvas) {
	        this.canvas.off('mouse:move', this.mouseMoveHandler);
	        this.canvas.fire('text:editing:exited', { target: this });
	        isTextChanged && this.canvas.fire('object:modified', { target: this });
	      }
	      return this;
	    },
	
	    /**
	     * @private
	     */
	    _removeExtraneousStyles: function() {
	      for (var prop in this.styles) {
	        if (!this._textLines[prop]) {
	          delete this.styles[prop];
	        }
	      }
	    },
	
	    /**
	     * remove and reflow a style block from start to end.
	     * @param {Number} start linear start position for removal (included in removal)
	     * @param {Number} end linear end position for removal ( excluded from removal )
	     */
	    removeStyleFromTo: function(start, end) {
	      var cursorStart = this.get2DCursorLocation(start, true),
	          cursorEnd = this.get2DCursorLocation(end, true),
	          lineStart = cursorStart.lineIndex,
	          charStart = cursorStart.charIndex,
	          lineEnd = cursorEnd.lineIndex,
	          charEnd = cursorEnd.charIndex,
	          i, styleObj;
	      if (lineStart !== lineEnd) {
	        // step1 remove the trailing of lineStart
	        if (this.styles[lineStart]) {
	          for (i = charStart; i < this._unwrappedTextLines[lineStart].length; i++) {
	            delete this.styles[lineStart][i];
	          }
	        }
	        // step2 move the trailing of lineEnd to lineStart if needed
	        if (this.styles[lineEnd]) {
	          for (i = charEnd; i < this._unwrappedTextLines[lineEnd].length; i++) {
	            styleObj = this.styles[lineEnd][i];
	            if (styleObj) {
	              this.styles[lineStart] || (this.styles[lineStart] = { });
	              this.styles[lineStart][charStart + i - charEnd] = styleObj;
	            }
	          }
	        }
	        // step3 detects lines will be completely removed.
	        for (i = lineStart + 1; i <= lineEnd; i++) {
	          delete this.styles[i];
	        }
	        // step4 shift remaining lines.
	        this.shiftLineStyles(lineEnd, lineStart - lineEnd);
	      }
	      else {
	        // remove and shift left on the same line
	        if (this.styles[lineStart]) {
	          styleObj = this.styles[lineStart];
	          var diff = charEnd - charStart, numericChar, _char;
	          for (i = charStart; i < charEnd; i++) {
	            delete styleObj[i];
	          }
	          for (_char in this.styles[lineStart]) {
	            numericChar = parseInt(_char, 10);
	            if (numericChar >= charEnd) {
	              styleObj[numericChar - diff] = styleObj[_char];
	              delete styleObj[_char];
	            }
	          }
	        }
	      }
	    },
	
	    /**
	     * Shifts line styles up or down
	     * @param {Number} lineIndex Index of a line
	     * @param {Number} offset Can any number?
	     */
	    shiftLineStyles: function(lineIndex, offset) {
	      // shift all line styles by offset upward or downward
	      // do not clone deep. we need new array, not new style objects
	      var clonedStyles = clone(this.styles);
	      for (var line in this.styles) {
	        var numericLine = parseInt(line, 10);
	        if (numericLine > lineIndex) {
	          this.styles[numericLine + offset] = clonedStyles[numericLine];
	          if (!clonedStyles[numericLine - offset]) {
	            delete this.styles[numericLine];
	          }
	        }
	      }
	    },
	
	    restartCursorIfNeeded: function() {
	      if (!this._currentTickState || this._currentTickState.isAborted
	        || !this._currentTickCompleteState || this._currentTickCompleteState.isAborted
	      ) {
	        this.initDelayedCursor();
	      }
	    },
	
	    /**
	     * Inserts new style object
	     * @param {Number} lineIndex Index of a line
	     * @param {Number} charIndex Index of a char
	     * @param {Number} qty number of lines to add
	     * @param {Array} copiedStyle Array of objects styles
	     */
	    insertNewlineStyleObject: function(lineIndex, charIndex, qty, copiedStyle) {
	      var currentCharStyle,
	          newLineStyles = {},
	          somethingAdded = false;
	
	      qty || (qty = 1);
	      this.shiftLineStyles(lineIndex, qty);
	      if (this.styles[lineIndex]) {
	        currentCharStyle = this.styles[lineIndex][charIndex === 0 ? charIndex : charIndex - 1];
	      }
	
	      // we clone styles of all chars
	      // after cursor onto the current line
	      for (var index in this.styles[lineIndex]) {
	        var numIndex = parseInt(index, 10);
	        if (numIndex >= charIndex) {
	          somethingAdded = true;
	          newLineStyles[numIndex - charIndex] = this.styles[lineIndex][index];
	          // remove lines from the previous line since they're on a new line now
	          delete this.styles[lineIndex][index];
	        }
	      }
	      if (somethingAdded) {
	        this.styles[lineIndex + qty] = newLineStyles;
	      }
	      else {
	        delete this.styles[lineIndex + qty];
	      }
	      // for the other lines
	      // we clone current char style onto the next (otherwise empty) line
	      while (qty > 1) {
	        qty--;
	        if (copiedStyle && copiedStyle[qty]) {
	          this.styles[lineIndex + qty] = { 0: clone(copiedStyle[qty]) };
	        }
	        else if (currentCharStyle) {
	          this.styles[lineIndex + qty] = { 0: clone(currentCharStyle) };
	        }
	        else {
	          delete this.styles[lineIndex + qty];
	        }
	      }
	      this._forceClearCache = true;
	    },
	
	    /**
	     * Inserts style object for a given line/char index
	     * @param {Number} lineIndex Index of a line
	     * @param {Number} charIndex Index of a char
	     * @param {Number} quantity number Style object to insert, if given
	     * @param {Array} copiedStyle array of style objects
	     */
	    insertCharStyleObject: function(lineIndex, charIndex, quantity, copiedStyle) {
	      if (!this.styles) {
	        this.styles = {};
	      }
	      var currentLineStyles       = this.styles[lineIndex],
	          currentLineStylesCloned = currentLineStyles ? clone(currentLineStyles) : {};
	
	      quantity || (quantity = 1);
	      // shift all char styles by quantity forward
	      // 0,1,2,3 -> (charIndex=2) -> 0,1,3,4 -> (insert 2) -> 0,1,2,3,4
	      for (var index in currentLineStylesCloned) {
	        var numericIndex = parseInt(index, 10);
	        if (numericIndex >= charIndex) {
	          currentLineStyles[numericIndex + quantity] = currentLineStylesCloned[numericIndex];
	          // only delete the style if there was nothing moved there
	          if (!currentLineStylesCloned[numericIndex - quantity]) {
	            delete currentLineStyles[numericIndex];
	          }
	        }
	      }
	      this._forceClearCache = true;
	      if (copiedStyle) {
	        while (quantity--) {
	          if (!Object.keys(copiedStyle[quantity]).length) {
	            continue;
	          }
	          if (!this.styles[lineIndex]) {
	            this.styles[lineIndex] = {};
	          }
	          this.styles[lineIndex][charIndex + quantity] = clone(copiedStyle[quantity]);
	        }
	        return;
	      }
	      if (!currentLineStyles) {
	        return;
	      }
	      var newStyle = currentLineStyles[charIndex ? charIndex - 1 : 1];
	      while (newStyle && quantity--) {
	        this.styles[lineIndex][charIndex + quantity] = clone(newStyle);
	      }
	    },
	
	    /**
	     * Inserts style object(s)
	     * @param {Array} insertedText Characters at the location where style is inserted
	     * @param {Number} start cursor index for inserting style
	     * @param {Array} [copiedStyle] array of style objects to insert.
	     */
	    insertNewStyleBlock: function(insertedText, start, copiedStyle) {
	      var cursorLoc = this.get2DCursorLocation(start, true),
	          addedLines = [0], linesLength = 0;
	      for (var i = 0; i < insertedText.length; i++) {
	        if (insertedText[i] === '\n') {
	          linesLength++;
	          addedLines[linesLength] = 0;
	        }
	        else {
	          addedLines[linesLength]++;
	        }
	      }
	      if (addedLines[0] > 0) {
	        this.insertCharStyleObject(cursorLoc.lineIndex, cursorLoc.charIndex, addedLines[0], copiedStyle);
	        copiedStyle = copiedStyle && copiedStyle.slice(addedLines[0] + 1);
	      }
	      linesLength && this.insertNewlineStyleObject(
	        cursorLoc.lineIndex, cursorLoc.charIndex + addedLines[0], linesLength);
	      for (var i = 1; i < linesLength; i++) {
	        if (addedLines[i] > 0) {
	          this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
	        }
	        else if (copiedStyle) {
	          this.styles[cursorLoc.lineIndex + i][0] = copiedStyle[0];
	        }
	        copiedStyle = copiedStyle && copiedStyle.slice(addedLines[i] + 1);
	      }
	      // we use i outside the loop to get it like linesLength
	      if (addedLines[i] > 0) {
	        this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
	      }
	    },
	
	    /**
	     * Set the selectionStart and selectionEnd according to the new position of cursor
	     * mimic the key - mouse navigation when shift is pressed.
	     */
	    setSelectionStartEndWithShift: function(start, end, newSelection) {
	      if (newSelection <= start) {
	        if (end === start) {
	          this._selectionDirection = 'left';
	        }
	        else if (this._selectionDirection === 'right') {
	          this._selectionDirection = 'left';
	          this.selectionEnd = start;
	        }
	        this.selectionStart = newSelection;
	      }
	      else if (newSelection > start && newSelection < end) {
	        if (this._selectionDirection === 'right') {
	          this.selectionEnd = newSelection;
	        }
	        else {
	          this.selectionStart = newSelection;
	        }
	      }
	      else {
	        // newSelection is > selection start and end
	        if (end === start) {
	          this._selectionDirection = 'right';
	        }
	        else if (this._selectionDirection === 'left') {
	          this._selectionDirection = 'right';
	          this.selectionStart = end;
	        }
	        this.selectionEnd = newSelection;
	      }
	    },
	
	    setSelectionInBoundaries: function() {
	      var length = this.text.length;
	      if (this.selectionStart > length) {
	        this.selectionStart = length;
	      }
	      else if (this.selectionStart < 0) {
	        this.selectionStart = 0;
	      }
	      if (this.selectionEnd > length) {
	        this.selectionEnd = length;
	      }
	      else if (this.selectionEnd < 0) {
	        this.selectionEnd = 0;
	      }
	    }
	  });
	})();
	
	
	fabric.util.object.extend(fabric.IText.prototype, /** @lends fabric.IText.prototype */ {
	  /**
	   * Initializes "dbclick" event handler
	   */
	  initDoubleClickSimulation: function() {
	
	    // for double click
	    this.__lastClickTime = +new Date();
	
	    // for triple click
	    this.__lastLastClickTime = +new Date();
	
	    this.__lastPointer = { };
	
	    this.on('mousedown', this.onMouseDown);
	  },
	
	  /**
	   * Default event handler to simulate triple click
	   * @private
	   */
	  onMouseDown: function(options) {
	    if (!this.canvas) {
	      return;
	    }
	    this.__newClickTime = +new Date();
	    var newPointer = options.pointer;
	    if (this.isTripleClick(newPointer)) {
	      this.fire('tripleclick', options);
	      this._stopEvent(options.e);
	    }
	    this.__lastLastClickTime = this.__lastClickTime;
	    this.__lastClickTime = this.__newClickTime;
	    this.__lastPointer = newPointer;
	    this.__lastIsEditing = this.isEditing;
	    this.__lastSelected = this.selected;
	  },
	
	  isTripleClick: function(newPointer) {
	    return this.__newClickTime - this.__lastClickTime < 500 &&
	        this.__lastClickTime - this.__lastLastClickTime < 500 &&
	        this.__lastPointer.x === newPointer.x &&
	        this.__lastPointer.y === newPointer.y;
	  },
	
	  /**
	   * @private
	   */
	  _stopEvent: function(e) {
	    e.preventDefault && e.preventDefault();
	    e.stopPropagation && e.stopPropagation();
	  },
	
	  /**
	   * Initializes event handlers related to cursor or selection
	   */
	  initCursorSelectionHandlers: function() {
	    this.initMousedownHandler();
	    this.initMouseupHandler();
	    this.initClicks();
	  },
	
	  /**
	   * Initializes double and triple click event handlers
	   */
	  initClicks: function() {
	    this.on('mousedblclick', function(options) {
	      this.selectWord(this.getSelectionStartFromPointer(options.e));
	    });
	    this.on('tripleclick', function(options) {
	      this.selectLine(this.getSelectionStartFromPointer(options.e));
	    });
	  },
	
	  /**
	   * Default event handler for the basic functionalities needed on _mouseDown
	   * can be overridden to do something different.
	   * Scope of this implementation is: find the click position, set selectionStart
	   * find selectionEnd, initialize the drawing of either cursor or selection area
	   */
	  _mouseDownHandler: function(options) {
	    if (!this.canvas || !this.editable || (options.e.button && options.e.button !== 1)) {
	      return;
	    }
	
	    this.__isMousedown = true;
	
	    if (this.selected) {
	      this.setCursorByClick(options.e);
	    }
	
	    if (this.isEditing) {
	      this.__selectionStartOnMouseDown = this.selectionStart;
	      if (this.selectionStart === this.selectionEnd) {
	        this.abortCursorAnimation();
	      }
	      this.renderCursorOrSelection();
	    }
	  },
	
	  /**
	   * Default event handler for the basic functionalities needed on mousedown:before
	   * can be overridden to do something different.
	   * Scope of this implementation is: verify the object is already selected when mousing down
	   */
	  _mouseDownHandlerBefore: function(options) {
	    if (!this.canvas || !this.editable || (options.e.button && options.e.button !== 1)) {
	      return;
	    }
	    if (this === this.canvas._activeObject) {
	      this.selected = true;
	    }
	  },
	
	  /**
	   * Initializes "mousedown" event handler
	   */
	  initMousedownHandler: function() {
	    this.on('mousedown', this._mouseDownHandler);
	    this.on('mousedown:before', this._mouseDownHandlerBefore);
	  },
	
	  /**
	   * Initializes "mouseup" event handler
	   */
	  initMouseupHandler: function() {
	    this.on('mouseup', this.mouseUpHandler);
	  },
	
	  /**
	   * standard hander for mouse up, overridable
	   * @private
	   */
	  mouseUpHandler: function(options) {
	    this.__isMousedown = false;
	    if (!this.editable || this.group ||
	      (options.transform && options.transform.actionPerformed) ||
	      (options.e.button && options.e.button !== 1)) {
	      return;
	    }
	
	    if (this.canvas) {
	      var currentActive = this.canvas._activeObject;
	      if (currentActive && currentActive !== this) {
	        // avoid running this logic when there is an active object
	        // this because is possible with shift click and fast clicks,
	        // to rapidly deselect and reselect this object and trigger an enterEdit
	        return;
	      }
	    }
	
	    if (this.__lastSelected && !this.__corner) {
	      this.selected = false;
	      this.__lastSelected = false;
	      this.enterEditing(options.e);
	      if (this.selectionStart === this.selectionEnd) {
	        this.initDelayedCursor(true);
	      }
	      else {
	        this.renderCursorOrSelection();
	      }
	    }
	    else {
	      this.selected = true;
	    }
	  },
	
	  /**
	   * Changes cursor location in a text depending on passed pointer (x/y) object
	   * @param {Event} e Event object
	   */
	  setCursorByClick: function(e) {
	    var newSelection = this.getSelectionStartFromPointer(e),
	        start = this.selectionStart, end = this.selectionEnd;
	    if (e.shiftKey) {
	      this.setSelectionStartEndWithShift(start, end, newSelection);
	    }
	    else {
	      this.selectionStart = newSelection;
	      this.selectionEnd = newSelection;
	    }
	    if (this.isEditing) {
	      this._fireSelectionChanged();
	      this._updateTextarea();
	    }
	  },
	
	  /**
	   * Returns index of a character corresponding to where an object was clicked
	   * @param {Event} e Event object
	   * @return {Number} Index of a character
	   */
	  getSelectionStartFromPointer: function(e) {
	    var mouseOffset = this.getLocalPointer(e),
	        prevWidth = 0,
	        width = 0,
	        height = 0,
	        charIndex = 0,
	        lineIndex = 0,
	        lineLeftOffset,
	        line;
	
	    for (var i = 0, len = this._textLines.length; i < len; i++) {
	      if (height <= mouseOffset.y) {
	        height += this.getHeightOfLine(i) * this.scaleY;
	        lineIndex = i;
	        if (i > 0) {
	          charIndex += this._textLines[i - 1].length + this.missingNewlineOffset(i - 1);
	        }
	      }
	      else {
	        break;
	      }
	    }
	    lineLeftOffset = this._getLineLeftOffset(lineIndex);
	    width = lineLeftOffset * this.scaleX;
	    line = this._textLines[lineIndex];
	    for (var j = 0, jlen = line.length; j < jlen; j++) {
	      prevWidth = width;
	      // i removed something about flipX here, check.
	      width += this.__charBounds[lineIndex][j].kernedWidth * this.scaleX;
	      if (width <= mouseOffset.x) {
	        charIndex++;
	      }
	      else {
	        break;
	      }
	    }
	    return this._getNewSelectionStartFromOffset(mouseOffset, prevWidth, width, charIndex, jlen);
	  },
	
	  /**
	   * @private
	   */
	  _getNewSelectionStartFromOffset: function(mouseOffset, prevWidth, width, index, jlen) {
	    // we need Math.abs because when width is after the last char, the offset is given as 1, while is 0
	    var distanceBtwLastCharAndCursor = mouseOffset.x - prevWidth,
	        distanceBtwNextCharAndCursor = width - mouseOffset.x,
	        offset = distanceBtwNextCharAndCursor > distanceBtwLastCharAndCursor ||
	          distanceBtwNextCharAndCursor < 0 ? 0 : 1,
	        newSelectionStart = index + offset;
	    // if object is horizontally flipped, mirror cursor location from the end
	    if (this.flipX) {
	      newSelectionStart = jlen - newSelectionStart;
	    }
	
	    if (newSelectionStart > this._text.length) {
	      newSelectionStart = this._text.length;
	    }
	
	    return newSelectionStart;
	  }
	});
	
	
	fabric.util.object.extend(fabric.IText.prototype, /** @lends fabric.IText.prototype */ {
	
	  /**
	   * Initializes hidden textarea (needed to bring up keyboard in iOS)
	   */
	  initHiddenTextarea: function() {
	    this.hiddenTextarea = fabric.document.createElement('textarea');
	    this.hiddenTextarea.setAttribute('autocapitalize', 'off');
	    this.hiddenTextarea.setAttribute('autocorrect', 'off');
	    this.hiddenTextarea.setAttribute('autocomplete', 'off');
	    this.hiddenTextarea.setAttribute('spellcheck', 'false');
	    this.hiddenTextarea.setAttribute('data-fabric-hiddentextarea', '');
	    this.hiddenTextarea.setAttribute('wrap', 'off');
	    var style = this._calcTextareaPosition();
	    // line-height: 1px; was removed from the style to fix this:
	    // https://bugs.chromium.org/p/chromium/issues/detail?id=870966
	    this.hiddenTextarea.style.cssText = 'position: absolute; top: ' + style.top +
	    '; left: ' + style.left + '; z-index: -999; opacity: 0; width: 1px; height: 1px; font-size: 1px;' +
	    ' paddingｰtop: ' + style.fontSize + ';';
	    fabric.document.body.appendChild(this.hiddenTextarea);
	
	    fabric.util.addListener(this.hiddenTextarea, 'keydown', this.onKeyDown.bind(this));
	    fabric.util.addListener(this.hiddenTextarea, 'keyup', this.onKeyUp.bind(this));
	    fabric.util.addListener(this.hiddenTextarea, 'input', this.onInput.bind(this));
	    fabric.util.addListener(this.hiddenTextarea, 'copy', this.copy.bind(this));
	    fabric.util.addListener(this.hiddenTextarea, 'cut', this.copy.bind(this));
	    fabric.util.addListener(this.hiddenTextarea, 'paste', this.paste.bind(this));
	    fabric.util.addListener(this.hiddenTextarea, 'compositionstart', this.onCompositionStart.bind(this));
	    fabric.util.addListener(this.hiddenTextarea, 'compositionupdate', this.onCompositionUpdate.bind(this));
	    fabric.util.addListener(this.hiddenTextarea, 'compositionend', this.onCompositionEnd.bind(this));
	
	    if (!this._clickHandlerInitialized && this.canvas) {
	      fabric.util.addListener(this.canvas.upperCanvasEl, 'click', this.onClick.bind(this));
	      this._clickHandlerInitialized = true;
	    }
	  },
	
	  /**
	   * For functionalities on keyDown
	   * Map a special key to a function of the instance/prototype
	   * If you need different behaviour for ESC or TAB or arrows, you have to change
	   * this map setting the name of a function that you build on the fabric.Itext or
	   * your prototype.
	   * the map change will affect all Instances unless you need for only some text Instances
	   * in that case you have to clone this object and assign your Instance.
	   * this.keysMap = fabric.util.object.clone(this.keysMap);
	   * The function must be in fabric.Itext.prototype.myFunction And will receive event as args[0]
	   */
	  keysMap: {
	    9:  'exitEditing',
	    27: 'exitEditing',
	    33: 'moveCursorUp',
	    34: 'moveCursorDown',
	    35: 'moveCursorRight',
	    36: 'moveCursorLeft',
	    37: 'moveCursorLeft',
	    38: 'moveCursorUp',
	    39: 'moveCursorRight',
	    40: 'moveCursorDown',
	  },
	
	  /**
	   * For functionalities on keyUp + ctrl || cmd
	   */
	  ctrlKeysMapUp: {
	    67: 'copy',
	    88: 'cut'
	  },
	
	  /**
	   * For functionalities on keyDown + ctrl || cmd
	   */
	  ctrlKeysMapDown: {
	    65: 'selectAll'
	  },
	
	  onClick: function() {
	    // No need to trigger click event here, focus is enough to have the keyboard appear on Android
	    this.hiddenTextarea && this.hiddenTextarea.focus();
	  },
	
	  /**
	   * Handles keyup event
	   * @param {Event} e Event object
	   */
	  onKeyDown: function(e) {
	    if (!this.isEditing || this.inCompositionMode) {
	      return;
	    }
	    if (e.keyCode in this.keysMap) {
	      this[this.keysMap[e.keyCode]](e);
	    }
	    else if ((e.keyCode in this.ctrlKeysMapDown) && (e.ctrlKey || e.metaKey)) {
	      this[this.ctrlKeysMapDown[e.keyCode]](e);
	    }
	    else {
	      return;
	    }
	    e.stopImmediatePropagation();
	    e.preventDefault();
	    if (e.keyCode >= 33 && e.keyCode <= 40) {
	      // if i press an arrow key just update selection
	      this.clearContextTop();
	      this.renderCursorOrSelection();
	    }
	    else {
	      this.canvas && this.canvas.requestRenderAll();
	    }
	  },
	
	  /**
	   * Handles keyup event
	   * We handle KeyUp because ie11 and edge have difficulties copy/pasting
	   * if a copy/cut event fired, keyup is dismissed
	   * @param {Event} e Event object
	   */
	  onKeyUp: function(e) {
	    if (!this.isEditing || this._copyDone || this.inCompositionMode) {
	      this._copyDone = false;
	      return;
	    }
	    if ((e.keyCode in this.ctrlKeysMapUp) && (e.ctrlKey || e.metaKey)) {
	      this[this.ctrlKeysMapUp[e.keyCode]](e);
	    }
	    else {
	      return;
	    }
	    e.stopImmediatePropagation();
	    e.preventDefault();
	    this.canvas && this.canvas.requestRenderAll();
	  },
	
	  /**
	   * Handles onInput event
	   * @param {Event} e Event object
	   */
	  onInput: function(e) {
	    var fromPaste = this.fromPaste;
	    this.fromPaste = false;
	    e && e.stopPropagation();
	    if (!this.isEditing) {
	      return;
	    }
	    // decisions about style changes.
	    var nextText = this._splitTextIntoLines(this.hiddenTextarea.value).graphemeText,
	        charCount = this._text.length,
	        nextCharCount = nextText.length,
	        removedText, insertedText,
	        charDiff = nextCharCount - charCount;
	    if (this.hiddenTextarea.value === '') {
	      this.styles = { };
	      this.updateFromTextArea();
	      this.fire('changed');
	      if (this.canvas) {
	        this.canvas.fire('text:changed', { target: this });
	        this.canvas.requestRenderAll();
	      }
	      return;
	    }
	
	    var textareaSelection = this.fromStringToGraphemeSelection(
	      this.hiddenTextarea.selectionStart,
	      this.hiddenTextarea.selectionEnd,
	      this.hiddenTextarea.value
	    );
	    var backDelete = this.selectionStart > textareaSelection.selectionStart;
	
	    if (this.selectionStart !== this.selectionEnd) {
	      removedText = this._text.slice(this.selectionStart, this.selectionEnd);
	      charDiff += this.selectionEnd - this.selectionStart;
	    }
	    else if (nextCharCount < charCount) {
	      if (backDelete) {
	        removedText = this._text.slice(this.selectionEnd + charDiff, this.selectionEnd);
	      }
	      else {
	        removedText = this._text.slice(this.selectionStart, this.selectionStart - charDiff);
	      }
	    }
	    insertedText = nextText.slice(textareaSelection.selectionEnd - charDiff, textareaSelection.selectionEnd);
	    if (removedText && removedText.length) {
	      if (this.selectionStart !== this.selectionEnd) {
	        this.removeStyleFromTo(this.selectionStart, this.selectionEnd);
	      }
	      else if (backDelete) {
	        // detect differencies between forwardDelete and backDelete
	        this.removeStyleFromTo(this.selectionEnd - removedText.length, this.selectionEnd);
	      }
	      else {
	        this.removeStyleFromTo(this.selectionEnd, this.selectionEnd + removedText.length);
	      }
	    }
	    if (insertedText.length) {
	      if (fromPaste && insertedText.join('') === fabric.copiedText && !fabric.disableStyleCopyPaste) {
	        this.insertNewStyleBlock(insertedText, this.selectionStart, fabric.copiedTextStyle);
	      }
	      else {
	        this.insertNewStyleBlock(insertedText, this.selectionStart);
	      }
	    }
	    this.updateFromTextArea();
	    this.fire('changed');
	    if (this.canvas) {
	      this.canvas.fire('text:changed', { target: this });
	      this.canvas.requestRenderAll();
	    }
	  },
	  /**
	   * Composition start
	   */
	  onCompositionStart: function() {
	    this.inCompositionMode = true;
	  },
	
	  /**
	   * Composition end
	   */
	  onCompositionEnd: function() {
	    this.inCompositionMode = false;
	  },
	
	  // /**
	  //  * Composition update
	  //  */
	  onCompositionUpdate: function(e) {
	    this.compositionStart = e.target.selectionStart;
	    this.compositionEnd = e.target.selectionEnd;
	    this.updateTextareaPosition();
	  },
	
	  /**
	   * Copies selected text
	   * @param {Event} e Event object
	   */
	  copy: function() {
	    if (this.selectionStart === this.selectionEnd) {
	      //do not cut-copy if no selection
	      return;
	    }
	
	    fabric.copiedText = this.getSelectedText();
	    if (!fabric.disableStyleCopyPaste) {
	      fabric.copiedTextStyle = this.getSelectionStyles(this.selectionStart, this.selectionEnd, true);
	    }
	    else {
	      fabric.copiedTextStyle = null;
	    }
	    this._copyDone = true;
	  },
	
	  /**
	   * Pastes text
	   * @param {Event} e Event object
	   */
	  paste: function() {
	    this.fromPaste = true;
	  },
	
	  /**
	   * @private
	   * @param {Event} e Event object
	   * @return {Object} Clipboard data object
	   */
	  _getClipboardData: function(e) {
	    return (e && e.clipboardData) || fabric.window.clipboardData;
	  },
	
	  /**
	   * Finds the width in pixels before the cursor on the same line
	   * @private
	   * @param {Number} lineIndex
	   * @param {Number} charIndex
	   * @return {Number} widthBeforeCursor width before cursor
	   */
	  _getWidthBeforeCursor: function(lineIndex, charIndex) {
	    var widthBeforeCursor = this._getLineLeftOffset(lineIndex), bound;
	
	    if (charIndex > 0) {
	      bound = this.__charBounds[lineIndex][charIndex - 1];
	      widthBeforeCursor += bound.left + bound.width;
	    }
	    return widthBeforeCursor;
	  },
	
	  /**
	   * Gets start offset of a selection
	   * @param {Event} e Event object
	   * @param {Boolean} isRight
	   * @return {Number}
	   */
	  getDownCursorOffset: function(e, isRight) {
	    var selectionProp = this._getSelectionForOffset(e, isRight),
	        cursorLocation = this.get2DCursorLocation(selectionProp),
	        lineIndex = cursorLocation.lineIndex;
	    // if on last line, down cursor goes to end of line
	    if (lineIndex === this._textLines.length - 1 || e.metaKey || e.keyCode === 34) {
	      // move to the end of a text
	      return this._text.length - selectionProp;
	    }
	    var charIndex = cursorLocation.charIndex,
	        widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex),
	        indexOnOtherLine = this._getIndexOnLine(lineIndex + 1, widthBeforeCursor),
	        textAfterCursor = this._textLines[lineIndex].slice(charIndex);
	    return textAfterCursor.length + indexOnOtherLine + 1 + this.missingNewlineOffset(lineIndex);
	  },
	
	  /**
	   * private
	   * Helps finding if the offset should be counted from Start or End
	   * @param {Event} e Event object
	   * @param {Boolean} isRight
	   * @return {Number}
	   */
	  _getSelectionForOffset: function(e, isRight) {
	    if (e.shiftKey && this.selectionStart !== this.selectionEnd && isRight) {
	      return this.selectionEnd;
	    }
	    else {
	      return this.selectionStart;
	    }
	  },
	
	  /**
	   * @param {Event} e Event object
	   * @param {Boolean} isRight
	   * @return {Number}
	   */
	  getUpCursorOffset: function(e, isRight) {
	    var selectionProp = this._getSelectionForOffset(e, isRight),
	        cursorLocation = this.get2DCursorLocation(selectionProp),
	        lineIndex = cursorLocation.lineIndex;
	    if (lineIndex === 0 || e.metaKey || e.keyCode === 33) {
	      // if on first line, up cursor goes to start of line
	      return -selectionProp;
	    }
	    var charIndex = cursorLocation.charIndex,
	        widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex),
	        indexOnOtherLine = this._getIndexOnLine(lineIndex - 1, widthBeforeCursor),
	        textBeforeCursor = this._textLines[lineIndex].slice(0, charIndex),
	        missingNewlineOffset = this.missingNewlineOffset(lineIndex - 1);
	    // return a negative offset
	    return -this._textLines[lineIndex - 1].length
	     + indexOnOtherLine - textBeforeCursor.length + (1 - missingNewlineOffset);
	  },
	
	  /**
	   * for a given width it founds the matching character.
	   * @private
	   */
	  _getIndexOnLine: function(lineIndex, width) {
	
	    var line = this._textLines[lineIndex],
	        lineLeftOffset = this._getLineLeftOffset(lineIndex),
	        widthOfCharsOnLine = lineLeftOffset,
	        indexOnLine = 0, charWidth, foundMatch;
	
	    for (var j = 0, jlen = line.length; j < jlen; j++) {
	      charWidth = this.__charBounds[lineIndex][j].width;
	      widthOfCharsOnLine += charWidth;
	      if (widthOfCharsOnLine > width) {
	        foundMatch = true;
	        var leftEdge = widthOfCharsOnLine - charWidth,
	            rightEdge = widthOfCharsOnLine,
	            offsetFromLeftEdge = Math.abs(leftEdge - width),
	            offsetFromRightEdge = Math.abs(rightEdge - width);
	
	        indexOnLine = offsetFromRightEdge < offsetFromLeftEdge ? j : (j - 1);
	        break;
	      }
	    }
	
	    // reached end
	    if (!foundMatch) {
	      indexOnLine = line.length - 1;
	    }
	
	    return indexOnLine;
	  },
	
	
	  /**
	   * Moves cursor down
	   * @param {Event} e Event object
	   */
	  moveCursorDown: function(e) {
	    if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) {
	      return;
	    }
	    this._moveCursorUpOrDown('Down', e);
	  },
	
	  /**
	   * Moves cursor up
	   * @param {Event} e Event object
	   */
	  moveCursorUp: function(e) {
	    if (this.selectionStart === 0 && this.selectionEnd === 0) {
	      return;
	    }
	    this._moveCursorUpOrDown('Up', e);
	  },
	
	  /**
	   * Moves cursor up or down, fires the events
	   * @param {String} direction 'Up' or 'Down'
	   * @param {Event} e Event object
	   */
	  _moveCursorUpOrDown: function(direction, e) {
	    // getUpCursorOffset
	    // getDownCursorOffset
	    var action = 'get' + direction + 'CursorOffset',
	        offset = this[action](e, this._selectionDirection === 'right');
	    if (e.shiftKey) {
	      this.moveCursorWithShift(offset);
	    }
	    else {
	      this.moveCursorWithoutShift(offset);
	    }
	    if (offset !== 0) {
	      this.setSelectionInBoundaries();
	      this.abortCursorAnimation();
	      this._currentCursorOpacity = 1;
	      this.initDelayedCursor();
	      this._fireSelectionChanged();
	      this._updateTextarea();
	    }
	  },
	
	  /**
	   * Moves cursor with shift
	   * @param {Number} offset
	   */
	  moveCursorWithShift: function(offset) {
	    var newSelection = this._selectionDirection === 'left'
	      ? this.selectionStart + offset
	      : this.selectionEnd + offset;
	    this.setSelectionStartEndWithShift(this.selectionStart, this.selectionEnd, newSelection);
	    return offset !== 0;
	  },
	
	  /**
	   * Moves cursor up without shift
	   * @param {Number} offset
	   */
	  moveCursorWithoutShift: function(offset) {
	    if (offset < 0) {
	      this.selectionStart += offset;
	      this.selectionEnd = this.selectionStart;
	    }
	    else {
	      this.selectionEnd += offset;
	      this.selectionStart = this.selectionEnd;
	    }
	    return offset !== 0;
	  },
	
	  /**
	   * Moves cursor left
	   * @param {Event} e Event object
	   */
	  moveCursorLeft: function(e) {
	    if (this.selectionStart === 0 && this.selectionEnd === 0) {
	      return;
	    }
	    this._moveCursorLeftOrRight('Left', e);
	  },
	
	  /**
	   * @private
	   * @return {Boolean} true if a change happened
	   */
	  _move: function(e, prop, direction) {
	    var newValue;
	    if (e.altKey) {
	      newValue = this['findWordBoundary' + direction](this[prop]);
	    }
	    else if (e.metaKey || e.keyCode === 35 ||  e.keyCode === 36 ) {
	      newValue = this['findLineBoundary' + direction](this[prop]);
	    }
	    else {
	      this[prop] += direction === 'Left' ? -1 : 1;
	      return true;
	    }
	    if (typeof newValue !== undefined && this[prop] !== newValue) {
	      this[prop] = newValue;
	      return true;
	    }
	  },
	
	  /**
	   * @private
	   */
	  _moveLeft: function(e, prop) {
	    return this._move(e, prop, 'Left');
	  },
	
	  /**
	   * @private
	   */
	  _moveRight: function(e, prop) {
	    return this._move(e, prop, 'Right');
	  },
	
	  /**
	   * Moves cursor left without keeping selection
	   * @param {Event} e
	   */
	  moveCursorLeftWithoutShift: function(e) {
	    var change = true;
	    this._selectionDirection = 'left';
	
	    // only move cursor when there is no selection,
	    // otherwise we discard it, and leave cursor on same place
	    if (this.selectionEnd === this.selectionStart && this.selectionStart !== 0) {
	      change = this._moveLeft(e, 'selectionStart');
	
	    }
	    this.selectionEnd = this.selectionStart;
	    return change;
	  },
	
	  /**
	   * Moves cursor left while keeping selection
	   * @param {Event} e
	   */
	  moveCursorLeftWithShift: function(e) {
	    if (this._selectionDirection === 'right' && this.selectionStart !== this.selectionEnd) {
	      return this._moveLeft(e, 'selectionEnd');
	    }
	    else if (this.selectionStart !== 0){
	      this._selectionDirection = 'left';
	      return this._moveLeft(e, 'selectionStart');
	    }
	  },
	
	  /**
	   * Moves cursor right
	   * @param {Event} e Event object
	   */
	  moveCursorRight: function(e) {
	    if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) {
	      return;
	    }
	    this._moveCursorLeftOrRight('Right', e);
	  },
	
	  /**
	   * Moves cursor right or Left, fires event
	   * @param {String} direction 'Left', 'Right'
	   * @param {Event} e Event object
	   */
	  _moveCursorLeftOrRight: function(direction, e) {
	    var actionName = 'moveCursor' + direction + 'With';
	    this._currentCursorOpacity = 1;
	
	    if (e.shiftKey) {
	      actionName += 'Shift';
	    }
	    else {
	      actionName += 'outShift';
	    }
	    if (this[actionName](e)) {
	      this.abortCursorAnimation();
	      this.initDelayedCursor();
	      this._fireSelectionChanged();
	      this._updateTextarea();
	    }
	  },
	
	  /**
	   * Moves cursor right while keeping selection
	   * @param {Event} e
	   */
	  moveCursorRightWithShift: function(e) {
	    if (this._selectionDirection === 'left' && this.selectionStart !== this.selectionEnd) {
	      return this._moveRight(e, 'selectionStart');
	    }
	    else if (this.selectionEnd !== this._text.length) {
	      this._selectionDirection = 'right';
	      return this._moveRight(e, 'selectionEnd');
	    }
	  },
	
	  /**
	   * Moves cursor right without keeping selection
	   * @param {Event} e Event object
	   */
	  moveCursorRightWithoutShift: function(e) {
	    var changed = true;
	    this._selectionDirection = 'right';
	
	    if (this.selectionStart === this.selectionEnd) {
	      changed = this._moveRight(e, 'selectionStart');
	      this.selectionEnd = this.selectionStart;
	    }
	    else {
	      this.selectionStart = this.selectionEnd;
	    }
	    return changed;
	  },
	
	  /**
	   * Removes characters from start/end
	   * start/end ar per grapheme position in _text array.
	   *
	   * @param {Number} start
	   * @param {Number} end default to start + 1
	   */
	  removeChars: function(start, end) {
	    if (typeof end === 'undefined') {
	      end = start + 1;
	    }
	    this.removeStyleFromTo(start, end);
	    this._text.splice(start, end - start);
	    this.text = this._text.join('');
	    this.set('dirty', true);
	    if (this._shouldClearDimensionCache()) {
	      this.initDimensions();
	      this.setCoords();
	    }
	    this._removeExtraneousStyles();
	  },
	
	  /**
	   * insert characters at start position, before start position.
	   * start  equal 1 it means the text get inserted between actual grapheme 0 and 1
	   * if style array is provided, it must be as the same length of text in graphemes
	   * if end is provided and is bigger than start, old text is replaced.
	   * start/end ar per grapheme position in _text array.
	   *
	   * @param {String} text text to insert
	   * @param {Array} style array of style objects
	   * @param {Number} start
	   * @param {Number} end default to start + 1
	   */
	  insertChars: function(text, style, start, end) {
	    if (typeof end === 'undefined') {
	      end = start;
	    }
	    if (end > start) {
	      this.removeStyleFromTo(start, end);
	    }
	    var graphemes = fabric.util.string.graphemeSplit(text);
	    this.insertNewStyleBlock(graphemes, start, style);
	    this._text = [].concat(this._text.slice(0, start), graphemes, this._text.slice(end));
	    this.text = this._text.join('');
	    this.set('dirty', true);
	    if (this._shouldClearDimensionCache()) {
	      this.initDimensions();
	      this.setCoords();
	    }
	    this._removeExtraneousStyles();
	  },
	
	});
	
	
	/* _TO_SVG_START_ */
	(function() {
	  var toFixed = fabric.util.toFixed,
	      multipleSpacesRegex = /  +/g;
	
	  fabric.util.object.extend(fabric.Text.prototype, /** @lends fabric.Text.prototype */ {
	
	    /**
	     * Returns SVG representation of an instance
	     * @param {Function} [reviver] Method for further parsing of svg representation.
	     * @return {String} svg representation of an instance
	     */
	    _toSVG: function() {
	      var offsets = this._getSVGLeftTopOffsets(),
	          textAndBg = this._getSVGTextAndBg(offsets.textTop, offsets.textLeft);
	      return this._wrapSVGTextAndBg(textAndBg);
	    },
	
	    /**
	     * Returns svg representation of an instance
	     * @param {Function} [reviver] Method for further parsing of svg representation.
	     * @return {String} svg representation of an instance
	     */
	    toSVG: function(reviver) {
	      return this._createBaseSVGMarkup(
	        this._toSVG(),
	        { reviver: reviver, noStyle: true, withShadow: true }
	      );
	    },
	
	    /**
	     * @private
	     */
	    _getSVGLeftTopOffsets: function() {
	      return {
	        textLeft: -this.width / 2,
	        textTop: -this.height / 2,
	        lineTop: this.getHeightOfLine(0)
	      };
	    },
	
	    /**
	     * @private
	     */
	    _wrapSVGTextAndBg: function(textAndBg) {
	      var noShadow = true,
	          textDecoration = this.getSvgTextDecoration(this);
	      return [
	        textAndBg.textBgRects.join(''),
	        '\t\t<text xml:space="preserve" ',
	        (this.fontFamily ? 'font-family="' + this.fontFamily.replace(/"/g, '\'') + '" ' : ''),
	        (this.fontSize ? 'font-size="' + this.fontSize + '" ' : ''),
	        (this.fontStyle ? 'font-style="' + this.fontStyle + '" ' : ''),
	        (this.fontWeight ? 'font-weight="' + this.fontWeight + '" ' : ''),
	        (textDecoration ? 'text-decoration="' + textDecoration + '" ' : ''),
	        'style="', this.getSvgStyles(noShadow), '"', this.addPaintOrder(), ' >',
	        textAndBg.textSpans.join(''),
	        '</text>\n'
	      ];
	    },
	
	    /**
	     * @private
	     * @param {Number} textTopOffset Text top offset
	     * @param {Number} textLeftOffset Text left offset
	     * @return {Object}
	     */
	    _getSVGTextAndBg: function(textTopOffset, textLeftOffset) {
	      var textSpans = [],
	          textBgRects = [],
	          height = textTopOffset, lineOffset;
	      // bounding-box background
	      this._setSVGBg(textBgRects);
	
	      // text and text-background
	      for (var i = 0, len = this._textLines.length; i < len; i++) {
	        lineOffset = this._getLineLeftOffset(i);
	        if (this.textBackgroundColor || this.styleHas('textBackgroundColor', i)) {
	          this._setSVGTextLineBg(textBgRects, i, textLeftOffset + lineOffset, height);
	        }
	        this._setSVGTextLineText(textSpans, i, textLeftOffset + lineOffset, height);
	        height += this.getHeightOfLine(i);
	      }
	
	      return {
	        textSpans: textSpans,
	        textBgRects: textBgRects
	      };
	    },
	
	    /**
	     * @private
	     */
	    _createTextCharSpan: function(_char, styleDecl, left, top) {
	      var shouldUseWhitespace = _char !== _char.trim() || _char.match(multipleSpacesRegex),
	          styleProps = this.getSvgSpanStyles(styleDecl, shouldUseWhitespace),
	          fillStyles = styleProps ? 'style="' + styleProps + '"' : '',
	          dy = styleDecl.deltaY, dySpan = '',
	          NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;
	      if (dy) {
	        dySpan = ' dy="' + toFixed(dy, NUM_FRACTION_DIGITS) + '" ';
	      }
	      return [
	        '<tspan x="', toFixed(left, NUM_FRACTION_DIGITS), '" y="',
	        toFixed(top, NUM_FRACTION_DIGITS), '" ', dySpan,
	        fillStyles, '>',
	        fabric.util.string.escapeXml(_char),
	        '</tspan>'
	      ].join('');
	    },
	
	    _setSVGTextLineText: function(textSpans, lineIndex, textLeftOffset, textTopOffset) {
	      // set proper line offset
	      var lineHeight = this.getHeightOfLine(lineIndex),
	          isJustify = this.textAlign.indexOf('justify') !== -1,
	          actualStyle,
	          nextStyle,
	          charsToRender = '',
	          charBox, style,
	          boxWidth = 0,
	          line = this._textLines[lineIndex],
	          timeToRender;
	
	      textTopOffset += lineHeight * (1 - this._fontSizeFraction) / this.lineHeight;
	      for (var i = 0, len = line.length - 1; i <= len; i++) {
	        timeToRender = i === len || this.charSpacing;
	        charsToRender += line[i];
	        charBox = this.__charBounds[lineIndex][i];
	        if (boxWidth === 0) {
	          textLeftOffset += charBox.kernedWidth - charBox.width;
	          boxWidth += charBox.width;
	        }
	        else {
	          boxWidth += charBox.kernedWidth;
	        }
	        if (isJustify && !timeToRender) {
	          if (this._reSpaceAndTab.test(line[i])) {
	            timeToRender = true;
	          }
	        }
	        if (!timeToRender) {
	          // if we have charSpacing, we render char by char
	          actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
	          nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
	          timeToRender = this._hasStyleChangedForSvg(actualStyle, nextStyle);
	        }
	        if (timeToRender) {
	          style = this._getStyleDeclaration(lineIndex, i) || { };
	          textSpans.push(this._createTextCharSpan(charsToRender, style, textLeftOffset, textTopOffset));
	          charsToRender = '';
	          actualStyle = nextStyle;
	          textLeftOffset += boxWidth;
	          boxWidth = 0;
	        }
	      }
	    },
	
	    _pushTextBgRect: function(textBgRects, color, left, top, width, height) {
	      var NUM_FRACTION_DIGITS = fabric.Object.NUM_FRACTION_DIGITS;
	      textBgRects.push(
	        '\t\t<rect ',
	        this._getFillAttributes(color),
	        ' x="',
	        toFixed(left, NUM_FRACTION_DIGITS),
	        '" y="',
	        toFixed(top, NUM_FRACTION_DIGITS),
	        '" width="',
	        toFixed(width, NUM_FRACTION_DIGITS),
	        '" height="',
	        toFixed(height, NUM_FRACTION_DIGITS),
	        '"></rect>\n');
	    },
	
	    _setSVGTextLineBg: function(textBgRects, i, leftOffset, textTopOffset) {
	      var line = this._textLines[i],
	          heightOfLine = this.getHeightOfLine(i) / this.lineHeight,
	          boxWidth = 0,
	          boxStart = 0,
	          charBox, currentColor,
	          lastColor = this.getValueOfPropertyAt(i, 0, 'textBackgroundColor');
	      for (var j = 0, jlen = line.length; j < jlen; j++) {
	        charBox = this.__charBounds[i][j];
	        currentColor = this.getValueOfPropertyAt(i, j, 'textBackgroundColor');
	        if (currentColor !== lastColor) {
	          lastColor && this._pushTextBgRect(textBgRects, lastColor, leftOffset + boxStart,
	            textTopOffset, boxWidth, heightOfLine);
	          boxStart = charBox.left;
	          boxWidth = charBox.width;
	          lastColor = currentColor;
	        }
	        else {
	          boxWidth += charBox.kernedWidth;
	        }
	      }
	      currentColor && this._pushTextBgRect(textBgRects, currentColor, leftOffset + boxStart,
	        textTopOffset, boxWidth, heightOfLine);
	    },
	
	    /**
	     * Adobe Illustrator (at least CS5) is unable to render rgba()-based fill values
	     * we work around it by "moving" alpha channel into opacity attribute and setting fill's alpha to 1
	     *
	     * @private
	     * @param {*} value
	     * @return {String}
	     */
	    _getFillAttributes: function(value) {
	      var fillColor = (value && typeof value === 'string') ? new fabric.Color(value) : '';
	      if (!fillColor || !fillColor.getSource() || fillColor.getAlpha() === 1) {
	        return 'fill="' + value + '"';
	      }
	      return 'opacity="' + fillColor.getAlpha() + '" fill="' + fillColor.setAlpha(1).toRgb() + '"';
	    },
	
	    /**
	     * @private
	     */
	    _getSVGLineTopOffset: function(lineIndex) {
	      var lineTopOffset = 0, lastHeight = 0;
	      for (var j = 0; j < lineIndex; j++) {
	        lineTopOffset += this.getHeightOfLine(j);
	      }
	      lastHeight = this.getHeightOfLine(j);
	      return {
	        lineTop: lineTopOffset,
	        offset: (this._fontSizeMult - this._fontSizeFraction) * lastHeight / (this.lineHeight * this._fontSizeMult)
	      };
	    },
	
	    /**
	     * Returns styles-string for svg-export
	     * @param {Boolean} skipShadow a boolean to skip shadow filter output
	     * @return {String}
	     */
	    getSvgStyles: function(skipShadow) {
	      var svgStyle = fabric.Object.prototype.getSvgStyles.call(this, skipShadow);
	      return svgStyle + ' white-space: pre;';
	    },
	  });
	})();
	/* _TO_SVG_END_ */
	
	
	(function(global) {
	
	  'use strict';
	
	  var fabric = global.fabric || (global.fabric = {});
	
	  /**
	   * Textbox class, based on IText, allows the user to resize the text rectangle
	   * and wraps lines automatically. Textboxes have their Y scaling locked, the
	   * user can only change width. Height is adjusted automatically based on the
	   * wrapping of lines.
	   * @class fabric.Textbox
	   * @extends fabric.IText
	   * @mixes fabric.Observable
	   * @return {fabric.Textbox} thisArg
	   * @see {@link fabric.Textbox#initialize} for constructor definition
	   */
	  fabric.Textbox = fabric.util.createClass(fabric.IText, fabric.Observable, {
	
	    /**
	     * Type of an object
	     * @type String
	     * @default
	     */
	    type: 'textbox',
	
	    /**
	     * Minimum width of textbox, in pixels.
	     * @type Number
	     * @default
	     */
	    minWidth: 20,
	
	    /**
	     * Minimum calculated width of a textbox, in pixels.
	     * fixed to 2 so that an empty textbox cannot go to 0
	     * and is still selectable without text.
	     * @type Number
	     * @default
	     */
	    dynamicMinWidth: 2,
	
	    /**
	     * Cached array of text wrapping.
	     * @type Array
	     */
	    __cachedLines: null,
	
	    /**
	     * Override standard Object class values
	     */
	    lockScalingFlip: true,
	
	    /**
	     * Override standard Object class values
	     * Textbox needs this on false
	     */
	    noScaleCache: false,
	
	    /**
	     * Properties which when set cause object to change dimensions
	     * @type Object
	     * @private
	     */
	    _dimensionAffectingProps: fabric.Text.prototype._dimensionAffectingProps.concat('width'),
	
	    /**
	     * Use this regular expression to split strings in breakable lines
	     * @private
	     */
	    _wordJoiners: /[ \t\r]/,
	
	    /**
	     * Use this boolean property in order to split strings that have no white space concept.
	     * this is a cheap way to help with chinese/japaense
	     * @type Boolean
	     * @since 2.6.0
	     */
	    splitByGrapheme: false,
	
	    /**
	     * Unlike superclass's version of this function, Textbox does not update
	     * its width.
	     * @private
	     * @override
	     */
	    initDimensions: function() {
	      if (this.__skipDimension) {
	        return;
	      }
	      this.isEditing && this.initDelayedCursor();
	      this.clearContextTop();
	      this._clearCache();
	      // clear dynamicMinWidth as it will be different after we re-wrap line
	      this.dynamicMinWidth = 0;
	      // wrap lines
	      this._styleMap = this._generateStyleMap(this._splitText());
	      // if after wrapping, the width is smaller than dynamicMinWidth, change the width and re-wrap
	      if (this.dynamicMinWidth > this.width) {
	        this._set('width', this.dynamicMinWidth);
	      }
	      if (this.textAlign.indexOf('justify') !== -1) {
	        // once text is measured we need to make space fatter to make justified text.
	        this.enlargeSpaces();
	      }
	      // clear cache and re-calculate height
	      this.height = this.calcTextHeight();
	      this.saveState({ propertySet: '_dimensionAffectingProps' });
	    },
	
	    /**
	     * Generate an object that translates the style object so that it is
	     * broken up by visual lines (new lines and automatic wrapping).
	     * The original text styles object is broken up by actual lines (new lines only),
	     * which is only sufficient for Text / IText
	     * @private
	     */
	    _generateStyleMap: function(textInfo) {
	      var realLineCount     = 0,
	          realLineCharCount = 0,
	          charCount         = 0,
	          map               = {};
	
	      for (var i = 0; i < textInfo.graphemeLines.length; i++) {
	        if (textInfo.graphemeText[charCount] === '\n' && i > 0) {
	          realLineCharCount = 0;
	          charCount++;
	          realLineCount++;
	        }
	        else if (!this.splitByGrapheme && this._reSpaceAndTab.test(textInfo.graphemeText[charCount]) && i > 0) {
	          // this case deals with space's that are removed from end of lines when wrapping
	          realLineCharCount++;
	          charCount++;
	        }
	
	        map[i] = { line: realLineCount, offset: realLineCharCount };
	
	        charCount += textInfo.graphemeLines[i].length;
	        realLineCharCount += textInfo.graphemeLines[i].length;
	      }
	
	      return map;
	    },
	
	    /**
	     * Returns true if object has a style property or has it on a specified line
	     * @param {Number} lineIndex
	     * @return {Boolean}
	     */
	    styleHas: function(property, lineIndex) {
	      if (this._styleMap && !this.isWrapping) {
	        var map = this._styleMap[lineIndex];
	        if (map) {
	          lineIndex = map.line;
	        }
	      }
	      return fabric.Text.prototype.styleHas.call(this, property, lineIndex);
	    },
	
	    /**
	     * Returns true if object has no styling or no styling in a line
	     * @param {Number} lineIndex , lineIndex is on wrapped lines.
	     * @return {Boolean}
	     */
	    isEmptyStyles: function(lineIndex) {
	      var offset = 0, nextLineIndex = lineIndex + 1, nextOffset, obj, shouldLimit = false;
	      var map = this._styleMap[lineIndex];
	      var mapNextLine = this._styleMap[lineIndex + 1];
	      if (map) {
	        lineIndex = map.line;
	        offset = map.offset;
	      }
	      if (mapNextLine) {
	        nextLineIndex = mapNextLine.line;
	        shouldLimit = nextLineIndex === lineIndex;
	        nextOffset = mapNextLine.offset;
	      }
	      obj = typeof lineIndex === 'undefined' ? this.styles : { line: this.styles[lineIndex] };
	      for (var p1 in obj) {
	        for (var p2 in obj[p1]) {
	          if (p2 >= offset && (!shouldLimit || p2 < nextOffset)) {
	            // eslint-disable-next-line no-unused-vars
	            for (var p3 in obj[p1][p2]) {
	              return false;
	            }
	          }
	        }
	      }
	      return true;
	    },
	
	    /**
	     * @param {Number} lineIndex
	     * @param {Number} charIndex
	     * @private
	     */
	    _getStyleDeclaration: function(lineIndex, charIndex) {
	      if (this._styleMap && !this.isWrapping) {
	        var map = this._styleMap[lineIndex];
	        if (!map) {
	          return null;
	        }
	        lineIndex = map.line;
	        charIndex = map.offset + charIndex;
	      }
	      return this.callSuper('_getStyleDeclaration', lineIndex, charIndex);
	    },
	
	    /**
	     * @param {Number} lineIndex
	     * @param {Number} charIndex
	     * @param {Object} style
	     * @private
	     */
	    _setStyleDeclaration: function(lineIndex, charIndex, style) {
	      var map = this._styleMap[lineIndex];
	      lineIndex = map.line;
	      charIndex = map.offset + charIndex;
	
	      this.styles[lineIndex][charIndex] = style;
	    },
	
	    /**
	     * @param {Number} lineIndex
	     * @param {Number} charIndex
	     * @private
	     */
	    _deleteStyleDeclaration: function(lineIndex, charIndex) {
	      var map = this._styleMap[lineIndex];
	      lineIndex = map.line;
	      charIndex = map.offset + charIndex;
	      delete this.styles[lineIndex][charIndex];
	    },
	
	    /**
	     * probably broken need a fix
	     * Returns the real style line that correspond to the wrapped lineIndex line
	     * Used just to verify if the line does exist or not.
	     * @param {Number} lineIndex
	     * @returns {Boolean} if the line exists or not
	     * @private
	     */
	    _getLineStyle: function(lineIndex) {
	      var map = this._styleMap[lineIndex];
	      return !!this.styles[map.line];
	    },
	
	    /**
	     * Set the line style to an empty object so that is initialized
	     * @param {Number} lineIndex
	     * @param {Object} style
	     * @private
	     */
	    _setLineStyle: function(lineIndex) {
	      var map = this._styleMap[lineIndex];
	      this.styles[map.line] = {};
	    },
	
	    /**
	     * Wraps text using the 'width' property of Textbox. First this function
	     * splits text on newlines, so we preserve newlines entered by the user.
	     * Then it wraps each line using the width of the Textbox by calling
	     * _wrapLine().
	     * @param {Array} lines The string array of text that is split into lines
	     * @param {Number} desiredWidth width you want to wrap to
	     * @returns {Array} Array of lines
	     */
	    _wrapText: function(lines, desiredWidth) {
	      var wrapped = [], i;
	      this.isWrapping = true;
	      for (i = 0; i < lines.length; i++) {
	        wrapped = wrapped.concat(this._wrapLine(lines[i], i, desiredWidth));
	      }
	      this.isWrapping = false;
	      return wrapped;
	    },
	
	    /**
	     * Helper function to measure a string of text, given its lineIndex and charIndex offset
	     * it gets called when charBounds are not available yet.
	     * @param {CanvasRenderingContext2D} ctx
	     * @param {String} text
	     * @param {number} lineIndex
	     * @param {number} charOffset
	     * @returns {number}
	     * @private
	     */
	    _measureWord: function(word, lineIndex, charOffset) {
	      var width = 0, prevGrapheme, skipLeft = true;
	      charOffset = charOffset || 0;
	      for (var i = 0, len = word.length; i < len; i++) {
	        var box = this._getGraphemeBox(word[i], lineIndex, i + charOffset, prevGrapheme, skipLeft);
	        width += box.kernedWidth;
	        prevGrapheme = word[i];
	      }
	      return width;
	    },
	
	    /**
	     * Wraps a line of text using the width of the Textbox and a context.
	     * @param {Array} line The grapheme array that represent the line
	     * @param {Number} lineIndex
	     * @param {Number} desiredWidth width you want to wrap the line to
	     * @param {Number} reservedSpace space to remove from wrapping for custom functionalities
	     * @returns {Array} Array of line(s) into which the given text is wrapped
	     * to.
	     */
	    _wrapLine: function(_line, lineIndex, desiredWidth, reservedSpace) {
	      var lineWidth = 0,
	          splitByGrapheme = this.splitByGrapheme,
	          graphemeLines = [],
	          line = [],
	          // spaces in different languges?
	          words = splitByGrapheme ? fabric.util.string.graphemeSplit(_line) : _line.split(this._wordJoiners),
	          word = '',
	          offset = 0,
	          infix = splitByGrapheme ? '' : ' ',
	          wordWidth = 0,
	          infixWidth = 0,
	          largestWordWidth = 0,
	          lineJustStarted = true,
	          additionalSpace = splitByGrapheme ? 0 : this._getWidthOfCharSpacing(),
	          reservedSpace = reservedSpace || 0;
	      // fix a difference between split and graphemeSplit
	      if (words.length === 0) {
	        words.push([]);
	      }
	      desiredWidth -= reservedSpace;
	      for (var i = 0; i < words.length; i++) {
	        // if using splitByGrapheme words are already in graphemes.
	        word = splitByGrapheme ? words[i] : fabric.util.string.graphemeSplit(words[i]);
	        wordWidth = this._measureWord(word, lineIndex, offset);
	        offset += word.length;
	
	        lineWidth += infixWidth + wordWidth - additionalSpace;
	
	        if (lineWidth >= desiredWidth && !lineJustStarted) {
	          graphemeLines.push(line);
	          line = [];
	          lineWidth = wordWidth;
	          lineJustStarted = true;
	        }
	        else {
	          lineWidth += additionalSpace;
	        }
	
	        if (!lineJustStarted && !splitByGrapheme) {
	          line.push(infix);
	        }
	        line = line.concat(word);
	
	        infixWidth = this._measureWord([infix], lineIndex, offset);
	        offset++;
	        lineJustStarted = false;
	        // keep track of largest word
	        if (wordWidth > largestWordWidth) {
	          largestWordWidth = wordWidth;
	        }
	      }
	
	      i && graphemeLines.push(line);
	
	      if (largestWordWidth + reservedSpace > this.dynamicMinWidth) {
	        this.dynamicMinWidth = largestWordWidth - additionalSpace + reservedSpace;
	      }
	
	      return graphemeLines;
	    },
	
	    /**
	     * Detect if the text line is ended with an hard break
	     * text and itext do not have wrapping, return false
	     * @param {Number} lineIndex text to split
	     * @return {Boolean}
	     */
	    isEndOfWrapping: function(lineIndex) {
	      if (!this._styleMap[lineIndex + 1]) {
	        // is last line, return true;
	        return true;
	      }
	      if (this._styleMap[lineIndex + 1].line !== this._styleMap[lineIndex].line) {
	        // this is last line before a line break, return true;
	        return true;
	      }
	      return false;
	    },
	
	    /**
	     * Detect if a line has a linebreak and so we need to account for it when moving
	     * and counting style.
	     * @return Number
	     */
	    missingNewlineOffset: function(lineIndex) {
	      if (this.splitByGrapheme) {
	        return this.isEndOfWrapping(lineIndex) ? 1 : 0;
	      }
	      return 1;
	    },
	
	    /**
	    * Gets lines of text to render in the Textbox. This function calculates
	    * text wrapping on the fly every time it is called.
	    * @param {String} text text to split
	    * @returns {Array} Array of lines in the Textbox.
	    * @override
	    */
	    _splitTextIntoLines: function(text) {
	      var newText = fabric.Text.prototype._splitTextIntoLines.call(this, text),
	          graphemeLines = this._wrapText(newText.lines, this.width),
	          lines = new Array(graphemeLines.length);
	      for (var i = 0; i < graphemeLines.length; i++) {
	        lines[i] = graphemeLines[i].join('');
	      }
	      newText.lines = lines;
	      newText.graphemeLines = graphemeLines;
	      return newText;
	    },
	
	    getMinWidth: function() {
	      return Math.max(this.minWidth, this.dynamicMinWidth);
	    },
	
	    _removeExtraneousStyles: function() {
	      var linesToKeep = {};
	      for (var prop in this._styleMap) {
	        if (this._textLines[prop]) {
	          linesToKeep[this._styleMap[prop].line] = 1;
	        }
	      }
	      for (var prop in this.styles) {
	        if (!linesToKeep[prop]) {
	          delete this.styles[prop];
	        }
	      }
	    },
	
	    /**
	     * Returns object representation of an instance
	     * @method toObject
	     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
	     * @return {Object} object representation of an instance
	     */
	    toObject: function(propertiesToInclude) {
	      return this.callSuper('toObject', ['minWidth', 'splitByGrapheme'].concat(propertiesToInclude));
	    }
	  });
	
	  /**
	   * Returns fabric.Textbox instance from an object representation
	   * @static
	   * @memberOf fabric.Textbox
	   * @param {Object} object Object to create an instance from
	   * @param {Function} [callback] Callback to invoke when an fabric.Textbox instance is created
	   */
	  fabric.Textbox.fromObject = function(object, callback) {
	    return fabric.Object._fromObject('Textbox', object, callback, 'text');
	  };
	})( true ? exports : this);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(521).Buffer))

/***/ }),
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"credits-dialog__content\">\n  <div class=\"credits-dialog__header\">\n    <img src=\"" + __webpack_require__(894) + "\" alt=\"Circonopoly\"/>\n  </div>\n\n  <div class=\"credits-dialog__body\">\n\n    <div class=\"credit-dialog__credit-block\">\n      <p data-localize=\"global.credits.text.initiative\"></p>\n      <div class=\"credits-dialog__logos-wrapper\">\n        <a class=\"btn btn-link\" href=\"http://www.pomwvl.be/\" target=\"_blank\">\n          <img src=\"" + __webpack_require__(898) + "\" alt=\"POM\"/>\n        </a>\n        <a class=\"btn btn-link\" href=\"https://www.cobot.be/\" target=\"_blank\">\n          <img src=\"" + __webpack_require__(896) + "\" alt=\"cobot\"/>\n        </a>\n        <a class=\"btn btn-link\" href=\"https://www.plastiq.be/nl\" target=\"_blank\">\n          <img src=\"" + __webpack_require__(897) + "\" alt=\"plastIQ\"/>\n        </a>\n      </div>\n    </div>\n\n    <div class=\"credit-dialog__credit-block mt-1\">\n      <p data-localize=\"global.credits.text.realised\"></p>\n      <div class=\"credits-dialog__logos-wrapper mt-3\">\n        <a class=\"btn btn-link\" href=\"https://www.cartamundi-digital.com\" target=\"_blank\">\n          <img src=\"" + __webpack_require__(893) + "\" alt=\"Cartamundi-Digital\"/>\n        </a>\n        <a class=\"btn btn-link\" href=\"https://switchrs.com/\" target=\"_blank\">\n          <img src=\"" + __webpack_require__(900) + "\" alt=\"switchrs\"/>\n        </a>\n        <span data-localize=\"global.credits.text.ism\"></span>\n        <a class=\"btn btn-link\" href=\"https://www.rhizo.be/\" target=\"_blank\">\n          <img src=\"" + __webpack_require__(899) + "\" alt=\"rhizo\"/>\n        </a>\n        <a class=\"btn btn-link\" href=\"https://www.vti-tielt.be/\" target=\"_blank\">\n          <img src=\"" + __webpack_require__(901) + "\" alt=\"VTI Tielt\"/>\n        </a>\n      </div>\n    </div>\n\n    <div class=\"credit-dialog__credit-block mt-4\">\n      <p data-localize=\"global.credits.text.support\"></p>\n      <div class=\"credits-dialog__logos-wrapper\">\n        <a class=\"btn btn-link\" href=\"https://vlaanderen-circulair.be/nl\" target=\"_blank\">\n          <img src=\"" + __webpack_require__(895) + "\" alt=\"Vlaanderen circulair\"/>\n        </a>\n      </div>\n    </div>\n  </div>\n\n  <div class=\"credits-dialog__footer\">\n    <a href=\"/privacy-policy\" class=\"btn btn-link\" target=\"_blank\"\n       data-localize=\"global.credits.footer.links.privacy_policy\"></a>\n    <a href=\"/eula\" class=\"btn btn-link\" target=\"_blank\"\n       data-localize=\"global.credits.footer.links.terms_and_conditions\"></a>\n  </div>\n</div>\n";

/***/ }),
/* 794 */,
/* 795 */,
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"game-progress-controller\">\n  <div class=\"game-progress__loader\">\n    <img src=\"" + __webpack_require__(211) + "\" alt=\"Loading...\"/>\n    <p class=\"loading-text\" data-localize=\"teacher_platform.game_progress.loading.text\"></p>\n  </div>\n\n  <div class=\"game-progress__wrapper\">\n    <div class=\"game-progress__overview\">\n      <div class=\"game-progress__canvas-wrapper\">\n        <div class=\"game-progress__canvas\">\n          <!--Generated-->\n        </div>\n      </div>\n\n      <div class=\"game-progress__round-selector\">\n        <h6 data-localize=\"teacher_platform.game_progress.round_selector.label\"></h6>\n        <ol role=\"tablist\">\n          <li class=\"active\" role=\"tab\" aria-selected=\"true\">\n            <button class=\"btn select-round-btn\" type=\"button\" data-gp-round-index=\"1\">1</button>\n          </li>\n          <li role=\"tab\">\n            <button class=\"btn select-round-btn\" type=\"button\" data-gp-round-index=\"2\">2</button>\n          </li>\n          <li role=\"tab\">\n            <button class=\"btn select-round-btn\" type=\"button\" data-gp-round-index=\"3\">3</button>\n          </li>\n          <li role=\"tab\">\n            <button class=\"btn select-round-btn\" type=\"button\" data-gp-round-index=\"4\">4</button>\n          </li>\n          <li role=\"tab\">\n            <button class=\"btn select-round-btn\" type=\"button\" data-gp-round-index=\"5\">5</button>\n          </li>\n        </ol>\n      </div>\n    </div>\n\n    <div class=\"gp-action-bar gp-action-bar__bottom\">\n      <div class=\"game-progress__block gp__block-data\">\n        <h6 class=\"game-progress__label\">\n          <span data-localize=\"teacher_platform.game_progress.overview.labels.round\"></span>\n          <span data-game-progress-round=\"1\"></span>\n        </h6>\n\n        <div class=\"game-progress__value-wrapper\">\n          <div class=\"gp-data gp-data__budget\" data-game-progress-budget=\"0\"></div>\n          <div class=\"gp-data gp-data__points\" data-game-progress-points=\"0\"></div>\n        </div>\n      </div>\n\n      <div class=\"game-progress__block gp__block-event\">\n        <h6 class=\"game-progress__label\" data-localize=\"teacher_platform.game_progress.overview.labels.event\"></h6>\n\n        <div class=\"game-progress__value-wrapper\">\n          <div class=\"game-progress__event\" data-game-progress-event=\"\">\n            <!--Generated-->\n          </div>\n        </div>\n      </div>\n\n      <div class=\"game-progress__block gp__block-investments\">\n        <h6 class=\"game-progress__label\"\n            data-localize=\"teacher_platform.game_progress.overview.labels.investments\"></h6>\n\n        <div class=\"game-progress__value-wrapper\">\n          <div class=\"game-progress__investment\" data-game-progress-investment-1=\"\">\n            <!--Generated-->\n          </div>\n\n          <div class=\"game-progress__investment\" data-game-progress-investment-2=\"\">\n            <!--Generated-->\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 809 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Sizzle CSS Selector Engine v2.3.4
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2019-04-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) &&
	
					// Support: IE 8 only
					// Exclude object elements
					(nodeType !== 1 || context.nodeName.toLowerCase() !== "object") ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 && rdescend.test( selector ) ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem.namespaceURI,
			docElem = (elem.ownerDocument || elem).documentElement;
	
		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	// EXPOSE
	var _sizzle = window.Sizzle;
	
	Sizzle.noConflict = function() {
		if ( window.Sizzle === Sizzle ) {
			window.Sizzle = _sizzle;
		}
	
		return Sizzle;
	};
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return Sizzle; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	// Sizzle requires that there be a global window in Common-JS like environments
	} else if ( typeof module !== "undefined" && module.exports ) {
		module.exports = Sizzle;
	} else {
		window.Sizzle = Sizzle;
	}
	// EXPOSE
	
	})( window );


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(20),
		__webpack_require__(396),
		__webpack_require__(397),
		__webpack_require__(206)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, isFunction, nonce, rquery ) {
	
	"use strict";
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(326),
		__webpack_require__(20),
		__webpack_require__(821),
		__webpack_require__(206),
		__webpack_require__(210),
		__webpack_require__(243),
		__webpack_require__(25)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, stripAndCollapse, isFunction ) {
	
	"use strict";
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	return jQuery.parseXML;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(21),
		__webpack_require__(206)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document ) {
	
	"use strict";
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return window.location;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(201),
		__webpack_require__(206)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, support ) {
	
	"use strict";
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(818),
		__webpack_require__(398),
		__webpack_require__(819),
		__webpack_require__(820)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	// Return jQuery for attributes-only inclusion
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(199),
		__webpack_require__(200),
		__webpack_require__(324),
		__webpack_require__(58),
		__webpack_require__(25)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, nodeName, support, rnothtmlwhite ) {
	
	"use strict";
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(326),
		__webpack_require__(20),
		__webpack_require__(58),
		__webpack_require__(48),
		__webpack_require__(40)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, stripAndCollapse, isFunction, rnothtmlwhite, dataPriv ) {
	
	"use strict";
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(326),
		__webpack_require__(324),
		__webpack_require__(200),
		__webpack_require__(20),
	
		__webpack_require__(40)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, stripAndCollapse, support, nodeName, isFunction ) {
	
	"use strict";
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(21),
		__webpack_require__(401),
		__webpack_require__(411),
	
		// This is the only module that needs core/support
		__webpack_require__(823)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, rsingleTag, buildFragment, support ) {
	
	"use strict";
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	return jQuery.parseHTML;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(21),
		__webpack_require__(201)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( document, support ) {
	
	"use strict";
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	return support;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(25)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(48),
		__webpack_require__(407)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, dataPriv, isHiddenWithinTree ) {
	
	"use strict";
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	return showHide;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(328)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( cssExpand ) {
		"use strict";
	
		return new RegExp( cssExpand.join( "|" ), "i" );
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(199),
		__webpack_require__(220),
		__webpack_require__(48),
		__webpack_require__(410)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, camelCase, dataPriv, dataUser ) {
	
	"use strict";
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(208)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(200),
		__webpack_require__(220),
		__webpack_require__(207),
		__webpack_require__(20),
		__webpack_require__(223),
		__webpack_require__(246),
	
		__webpack_require__(834)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, nodeName, camelCase, toType, isFunction, isWindow, slice ) {
	
	"use strict";
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(199),
		__webpack_require__(223),
		__webpack_require__(221)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, isWindow ) {
	
	"use strict";
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(405),
	
		__webpack_require__(221)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, finalPropName ) {
	
	"use strict";
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
						jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(25),
		__webpack_require__(331)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(209)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
	
		__webpack_require__(209),
		__webpack_require__(332)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(48),
		__webpack_require__(836),
	
		__webpack_require__(209),
		__webpack_require__(332)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, dataPriv, support ) {
	
	"use strict";
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(201)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( support ) {
	
	"use strict";
	
	support.focusin = "onfocusin" in window;
	
	return support;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, noGlobal ) {
	
	"use strict";
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(206)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	jQuery._evalUrl = function( url, options ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options );
			}
		} );
	};
	
	return jQuery._evalUrl;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(21),
		__webpack_require__(201)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( document, support ) {
	
	"use strict";
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	
	return support;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(199),
		__webpack_require__(21),
		__webpack_require__(245),
		__webpack_require__(20),
		__webpack_require__(329),
		__webpack_require__(404),
		__webpack_require__(402),
		__webpack_require__(327),
		__webpack_require__(223),
		__webpack_require__(40),
		__webpack_require__(221),
		__webpack_require__(25) // contains
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, document, documentElement, isFunction, rnumnonpx,
	             curCSS, addGetHookIf, support, isWindow ) {
	
	"use strict";
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(333),
		__webpack_require__(331) // Delay is optional because of this dependency
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	return jQuery.fn.delay;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(810)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, Sizzle ) {
	
	"use strict";
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	return function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	return function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(421)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( fnToString ) {
		"use strict";
	
		return fnToString.call( Object );
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return Object.getPrototypeOf;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(7),
		__webpack_require__(20),
		__webpack_require__(40),
		__webpack_require__(243), // clone
		__webpack_require__(210) // parent, contents
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, isFunction ) {
	
	"use strict";
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 849 */,
/* 850 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 851 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12.043\" height=\"8.167\" viewBox=\"0 0 12.043 8.167\">\n  <g transform=\"translate(-40.457 -127.5)\">\n    <path d=\"M-1728.005,1797.938l3.083,3.083-3.083,3.083\" transform=\"translate(-1683.051 1932.604) rotate(180)\"\n          fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"2\"/>\n    <line x2=\"9\" transform=\"translate(42.5 131.5)\" fill=\"none\" stroke=\"#0a2b30\" stroke-linecap=\"round\"\n          stroke-width=\"2\"/>\n  </g>\n</svg>\n"

/***/ }),
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */
/***/ (function(module, exports) {

	module.exports = "\"use strict\";\n\nvar _typeof = typeof Symbol === \"function\" && typeof Symbol.iterator === \"symbol\" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === \"function\" && obj.constructor === Symbol && obj !== Symbol.prototype ? \"symbol\" : typeof obj; };\n\n/*! modernizr 3.3.1 (Custom Build) | MIT *\n * https://modernizr.com/download/?-filereader-setclasses !*/\n!function (e, n, s) {\n  function o(e, n) {\n    return (typeof e === \"undefined\" ? \"undefined\" : _typeof(e)) === n;\n  }function a() {\n    var e, n, s, a, i, f, r;for (var c in l) {\n      if (l.hasOwnProperty(c)) {\n        if (e = [], n = l[c], n.name && (e.push(n.name.toLowerCase()), n.options && n.options.aliases && n.options.aliases.length)) for (s = 0; s < n.options.aliases.length; s++) {\n          e.push(n.options.aliases[s].toLowerCase());\n        }for (a = o(n.fn, \"function\") ? n.fn() : n.fn, i = 0; i < e.length; i++) {\n          f = e[i], r = f.split(\".\"), 1 === r.length ? Modernizr[r[0]] = a : (!Modernizr[r[0]] || Modernizr[r[0]] instanceof Boolean || (Modernizr[r[0]] = new Boolean(Modernizr[r[0]])), Modernizr[r[0]][r[1]] = a), t.push((a ? \"\" : \"no-\") + r.join(\"-\"));\n        }\n      }\n    }\n  }function i(e) {\n    var n = r.className,\n        s = Modernizr._config.classPrefix || \"\";if (c && (n = n.baseVal), Modernizr._config.enableJSClass) {\n      var o = new RegExp(\"(^|\\\\s)\" + s + \"no-js(\\\\s|$)\");n = n.replace(o, \"$1\" + s + \"js$2\");\n    }Modernizr._config.enableClasses && (n += \" \" + s + e.join(\" \" + s), c ? r.className.baseVal = n : r.className = n);\n  }var t = [],\n      l = [],\n      f = { _version: \"3.3.1\", _config: { classPrefix: \"\", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function on(e, n) {\n      var s = this;setTimeout(function () {\n        n(s[e]);\n      }, 0);\n    }, addTest: function addTest(e, n, s) {\n      l.push({ name: e, fn: n, options: s });\n    }, addAsyncTest: function addAsyncTest(e) {\n      l.push({ name: null, fn: e });\n    } },\n      Modernizr = function Modernizr() {};Modernizr.prototype = f, Modernizr = new Modernizr(), Modernizr.addTest(\"filereader\", !!(e.File && e.FileList && e.FileReader));var r = n.documentElement,\n      c = \"svg\" === r.nodeName.toLowerCase();a(), i(t), delete f.addTest, delete f.addAsyncTest;for (var u = 0; u < Modernizr._q.length; u++) {\n    Modernizr._q[u]();\n  }e.Modernizr = Modernizr;\n}(window, document);"

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	module.exports = "\"use strict\";\n\nvar _typeof = typeof Symbol === \"function\" && typeof Symbol.iterator === \"symbol\" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === \"function\" && obj.constructor === Symbol && obj !== Symbol.prototype ? \"symbol\" : typeof obj; };\n\n/* == jquery mousewheel plugin == Version: 3.1.13, License: MIT License (MIT) */\n!function (a) {\n  \"function\" == typeof define && define.amd ? define([\"jquery\"], a) : \"object\" == (typeof exports === \"undefined\" ? \"undefined\" : _typeof(exports)) ? module.exports = a : a(jQuery);\n}(function (a) {\n  function b(b) {\n    var g = b || window.event,\n        h = i.call(arguments, 1),\n        j = 0,\n        l = 0,\n        m = 0,\n        n = 0,\n        o = 0,\n        p = 0;if (b = a.event.fix(g), b.type = \"mousewheel\", \"detail\" in g && (m = -1 * g.detail), \"wheelDelta\" in g && (m = g.wheelDelta), \"wheelDeltaY\" in g && (m = g.wheelDeltaY), \"wheelDeltaX\" in g && (l = -1 * g.wheelDeltaX), \"axis\" in g && g.axis === g.HORIZONTAL_AXIS && (l = -1 * m, m = 0), j = 0 === m ? l : m, \"deltaY\" in g && (m = -1 * g.deltaY, j = m), \"deltaX\" in g && (l = g.deltaX, 0 === m && (j = -1 * l)), 0 !== m || 0 !== l) {\n      if (1 === g.deltaMode) {\n        var q = a.data(this, \"mousewheel-line-height\");j *= q, m *= q, l *= q;\n      } else if (2 === g.deltaMode) {\n        var r = a.data(this, \"mousewheel-page-height\");j *= r, m *= r, l *= r;\n      }if (n = Math.max(Math.abs(m), Math.abs(l)), (!f || f > n) && (f = n, d(g, n) && (f /= 40)), d(g, n) && (j /= 40, l /= 40, m /= 40), j = Math[j >= 1 ? \"floor\" : \"ceil\"](j / f), l = Math[l >= 1 ? \"floor\" : \"ceil\"](l / f), m = Math[m >= 1 ? \"floor\" : \"ceil\"](m / f), k.settings.normalizeOffset && this.getBoundingClientRect) {\n        var s = this.getBoundingClientRect();o = b.clientX - s.left, p = b.clientY - s.top;\n      }return b.deltaX = l, b.deltaY = m, b.deltaFactor = f, b.offsetX = o, b.offsetY = p, b.deltaMode = 0, h.unshift(b, j, l, m), e && clearTimeout(e), e = setTimeout(c, 200), (a.event.dispatch || a.event.handle).apply(this, h);\n    }\n  }function c() {\n    f = null;\n  }function d(a, b) {\n    return k.settings.adjustOldDeltas && \"mousewheel\" === a.type && b % 120 === 0;\n  }var e,\n      f,\n      g = [\"wheel\", \"mousewheel\", \"DOMMouseScroll\", \"MozMousePixelScroll\"],\n      h = \"onwheel\" in document || document.documentMode >= 9 ? [\"wheel\"] : [\"mousewheel\", \"DomMouseScroll\", \"MozMousePixelScroll\"],\n      i = Array.prototype.slice;if (a.event.fixHooks) for (var j = g.length; j;) {\n    a.event.fixHooks[g[--j]] = a.event.mouseHooks;\n  }var k = a.event.special.mousewheel = { version: \"3.1.12\", setup: function setup() {\n      if (this.addEventListener) for (var c = h.length; c;) {\n        this.addEventListener(h[--c], b, !1);\n      } else this.onmousewheel = b;a.data(this, \"mousewheel-line-height\", k.getLineHeight(this)), a.data(this, \"mousewheel-page-height\", k.getPageHeight(this));\n    }, teardown: function teardown() {\n      if (this.removeEventListener) for (var c = h.length; c;) {\n        this.removeEventListener(h[--c], b, !1);\n      } else this.onmousewheel = null;a.removeData(this, \"mousewheel-line-height\"), a.removeData(this, \"mousewheel-page-height\");\n    }, getLineHeight: function getLineHeight(b) {\n      var c = a(b),\n          d = c[\"offsetParent\" in a.fn ? \"offsetParent\" : \"parent\"]();return d.length || (d = a(\"body\")), parseInt(d.css(\"fontSize\"), 10) || parseInt(c.css(\"fontSize\"), 10) || 16;\n    }, getPageHeight: function getPageHeight(b) {\n      return a(b).height();\n    }, settings: { adjustOldDeltas: !0, normalizeOffset: !0 } };a.fn.extend({ mousewheel: function mousewheel(a) {\n      return a ? this.bind(\"mousewheel\", a) : this.trigger(\"mousewheel\");\n    }, unmousewheel: function unmousewheel(a) {\n      return this.unbind(\"mousewheel\", a);\n    } });\n});!function (a) {\n  \"function\" == typeof define && define.amd ? define([\"jquery\"], a) : \"object\" == (typeof exports === \"undefined\" ? \"undefined\" : _typeof(exports)) ? module.exports = a : a(jQuery);\n}(function (a) {\n  function b(b) {\n    var g = b || window.event,\n        h = i.call(arguments, 1),\n        j = 0,\n        l = 0,\n        m = 0,\n        n = 0,\n        o = 0,\n        p = 0;if (b = a.event.fix(g), b.type = \"mousewheel\", \"detail\" in g && (m = -1 * g.detail), \"wheelDelta\" in g && (m = g.wheelDelta), \"wheelDeltaY\" in g && (m = g.wheelDeltaY), \"wheelDeltaX\" in g && (l = -1 * g.wheelDeltaX), \"axis\" in g && g.axis === g.HORIZONTAL_AXIS && (l = -1 * m, m = 0), j = 0 === m ? l : m, \"deltaY\" in g && (m = -1 * g.deltaY, j = m), \"deltaX\" in g && (l = g.deltaX, 0 === m && (j = -1 * l)), 0 !== m || 0 !== l) {\n      if (1 === g.deltaMode) {\n        var q = a.data(this, \"mousewheel-line-height\");j *= q, m *= q, l *= q;\n      } else if (2 === g.deltaMode) {\n        var r = a.data(this, \"mousewheel-page-height\");j *= r, m *= r, l *= r;\n      }if (n = Math.max(Math.abs(m), Math.abs(l)), (!f || f > n) && (f = n, d(g, n) && (f /= 40)), d(g, n) && (j /= 40, l /= 40, m /= 40), j = Math[j >= 1 ? \"floor\" : \"ceil\"](j / f), l = Math[l >= 1 ? \"floor\" : \"ceil\"](l / f), m = Math[m >= 1 ? \"floor\" : \"ceil\"](m / f), k.settings.normalizeOffset && this.getBoundingClientRect) {\n        var s = this.getBoundingClientRect();o = b.clientX - s.left, p = b.clientY - s.top;\n      }return b.deltaX = l, b.deltaY = m, b.deltaFactor = f, b.offsetX = o, b.offsetY = p, b.deltaMode = 0, h.unshift(b, j, l, m), e && clearTimeout(e), e = setTimeout(c, 200), (a.event.dispatch || a.event.handle).apply(this, h);\n    }\n  }function c() {\n    f = null;\n  }function d(a, b) {\n    return k.settings.adjustOldDeltas && \"mousewheel\" === a.type && b % 120 === 0;\n  }var e,\n      f,\n      g = [\"wheel\", \"mousewheel\", \"DOMMouseScroll\", \"MozMousePixelScroll\"],\n      h = \"onwheel\" in document || document.documentMode >= 9 ? [\"wheel\"] : [\"mousewheel\", \"DomMouseScroll\", \"MozMousePixelScroll\"],\n      i = Array.prototype.slice;if (a.event.fixHooks) for (var j = g.length; j;) {\n    a.event.fixHooks[g[--j]] = a.event.mouseHooks;\n  }var k = a.event.special.mousewheel = { version: \"3.1.12\", setup: function setup() {\n      if (this.addEventListener) for (var c = h.length; c;) {\n        this.addEventListener(h[--c], b, !1);\n      } else this.onmousewheel = b;a.data(this, \"mousewheel-line-height\", k.getLineHeight(this)), a.data(this, \"mousewheel-page-height\", k.getPageHeight(this));\n    }, teardown: function teardown() {\n      if (this.removeEventListener) for (var c = h.length; c;) {\n        this.removeEventListener(h[--c], b, !1);\n      } else this.onmousewheel = null;a.removeData(this, \"mousewheel-line-height\"), a.removeData(this, \"mousewheel-page-height\");\n    }, getLineHeight: function getLineHeight(b) {\n      var c = a(b),\n          d = c[\"offsetParent\" in a.fn ? \"offsetParent\" : \"parent\"]();return d.length || (d = a(\"body\")), parseInt(d.css(\"fontSize\"), 10) || parseInt(c.css(\"fontSize\"), 10) || 16;\n    }, getPageHeight: function getPageHeight(b) {\n      return a(b).height();\n    }, settings: { adjustOldDeltas: !0, normalizeOffset: !0 } };a.fn.extend({ mousewheel: function mousewheel(a) {\n      return a ? this.bind(\"mousewheel\", a) : this.trigger(\"mousewheel\");\n    }, unmousewheel: function unmousewheel(a) {\n      return this.unbind(\"mousewheel\", a);\n    } });\n});\n/* == malihu jquery custom scrollbar plugin == Version: 3.1.5, License: MIT License (MIT) */\n!function (e) {\n  \"function\" == typeof define && define.amd ? define([\"jquery\"], e) : \"undefined\" != typeof module && module.exports ? module.exports = e : e(jQuery, window, document);\n}(function (e) {\n  !function (t) {\n    var o = \"function\" == typeof define && define.amd,\n        a = \"undefined\" != typeof module && module.exports,\n        n = \"https:\" == document.location.protocol ? \"https:\" : \"http:\",\n        i = \"cdnjs.cloudflare.com/ajax/libs/jquery-mousewheel/3.1.13/jquery.mousewheel.min.js\";o || (a ? require(\"jquery-mousewheel\")(e) : e.event.special.mousewheel || e(\"head\").append(decodeURI(\"%3Cscript src=\" + n + \"//\" + i + \"%3E%3C/script%3E\"))), t();\n  }(function () {\n    var t,\n        o = \"mCustomScrollbar\",\n        a = \"mCS\",\n        n = \".mCustomScrollbar\",\n        i = { setTop: 0, setLeft: 0, axis: \"y\", scrollbarPosition: \"inside\", scrollInertia: 950, autoDraggerLength: !0, alwaysShowScrollbar: 0, snapOffset: 0, mouseWheel: { enable: !0, scrollAmount: \"auto\", axis: \"y\", deltaFactor: \"auto\", disableOver: [\"select\", \"option\", \"keygen\", \"datalist\", \"textarea\"] }, scrollButtons: { scrollType: \"stepless\", scrollAmount: \"auto\" }, keyboard: { enable: !0, scrollType: \"stepless\", scrollAmount: \"auto\" }, contentTouchScroll: 25, documentTouchScroll: !0, advanced: { autoScrollOnFocus: \"input,textarea,select,button,datalist,keygen,a[tabindex],area,object,[contenteditable='true']\", updateOnContentResize: !0, updateOnImageLoad: \"auto\", autoUpdateTimeout: 60 }, theme: \"light\", callbacks: { onTotalScrollOffset: 0, onTotalScrollBackOffset: 0, alwaysTriggerOffsets: !0 } },\n        r = 0,\n        l = {},\n        s = window.attachEvent && !window.addEventListener ? 1 : 0,\n        c = !1,\n        d = [\"mCSB_dragger_onDrag\", \"mCSB_scrollTools_onDrag\", \"mCS_img_loaded\", \"mCS_disabled\", \"mCS_destroyed\", \"mCS_no_scrollbar\", \"mCS-autoHide\", \"mCS-dir-rtl\", \"mCS_no_scrollbar_y\", \"mCS_no_scrollbar_x\", \"mCS_y_hidden\", \"mCS_x_hidden\", \"mCSB_draggerContainer\", \"mCSB_buttonUp\", \"mCSB_buttonDown\", \"mCSB_buttonLeft\", \"mCSB_buttonRight\"],\n        u = { init: function init(t) {\n        var t = e.extend(!0, {}, i, t),\n            o = f.call(this);if (t.live) {\n          var s = t.liveSelector || this.selector || n,\n              c = e(s);if (\"off\" === t.live) return void m(s);l[s] = setTimeout(function () {\n            c.mCustomScrollbar(t), \"once\" === t.live && c.length && m(s);\n          }, 500);\n        } else m(s);return t.setWidth = t.set_width ? t.set_width : t.setWidth, t.setHeight = t.set_height ? t.set_height : t.setHeight, t.axis = t.horizontalScroll ? \"x\" : p(t.axis), t.scrollInertia = t.scrollInertia > 0 && t.scrollInertia < 17 ? 17 : t.scrollInertia, \"object\" != _typeof(t.mouseWheel) && 1 == t.mouseWheel && (t.mouseWheel = { enable: !0, scrollAmount: \"auto\", axis: \"y\", preventDefault: !1, deltaFactor: \"auto\", normalizeDelta: !1, invert: !1 }), t.mouseWheel.scrollAmount = t.mouseWheelPixels ? t.mouseWheelPixels : t.mouseWheel.scrollAmount, t.mouseWheel.normalizeDelta = t.advanced.normalizeMouseWheelDelta ? t.advanced.normalizeMouseWheelDelta : t.mouseWheel.normalizeDelta, t.scrollButtons.scrollType = g(t.scrollButtons.scrollType), h(t), e(o).each(function () {\n          var o = e(this);if (!o.data(a)) {\n            o.data(a, { idx: ++r, opt: t, scrollRatio: { y: null, x: null }, overflowed: null, contentReset: { y: null, x: null }, bindEvents: !1, tweenRunning: !1, sequential: {}, langDir: o.css(\"direction\"), cbOffsets: null, trigger: null, poll: { size: { o: 0, n: 0 }, img: { o: 0, n: 0 }, change: { o: 0, n: 0 } } });var n = o.data(a),\n                i = n.opt,\n                l = o.data(\"mcs-axis\"),\n                s = o.data(\"mcs-scrollbar-position\"),\n                c = o.data(\"mcs-theme\");l && (i.axis = l), s && (i.scrollbarPosition = s), c && (i.theme = c, h(i)), v.call(this), n && i.callbacks.onCreate && \"function\" == typeof i.callbacks.onCreate && i.callbacks.onCreate.call(this), e(\"#mCSB_\" + n.idx + \"_container img:not(.\" + d[2] + \")\").addClass(d[2]), u.update.call(null, o);\n          }\n        });\n      }, update: function update(t, o) {\n        var n = t || f.call(this);return e(n).each(function () {\n          var t = e(this);if (t.data(a)) {\n            var n = t.data(a),\n                i = n.opt,\n                r = e(\"#mCSB_\" + n.idx + \"_container\"),\n                l = e(\"#mCSB_\" + n.idx),\n                s = [e(\"#mCSB_\" + n.idx + \"_dragger_vertical\"), e(\"#mCSB_\" + n.idx + \"_dragger_horizontal\")];if (!r.length) return;n.tweenRunning && Q(t), o && n && i.callbacks.onBeforeUpdate && \"function\" == typeof i.callbacks.onBeforeUpdate && i.callbacks.onBeforeUpdate.call(this), t.hasClass(d[3]) && t.removeClass(d[3]), t.hasClass(d[4]) && t.removeClass(d[4]), l.css(\"max-height\", \"none\"), l.height() !== t.height() && l.css(\"max-height\", t.height()), _.call(this), \"y\" === i.axis || i.advanced.autoExpandHorizontalScroll || r.css(\"width\", x(r)), n.overflowed = y.call(this), M.call(this), i.autoDraggerLength && S.call(this), b.call(this), T.call(this);var c = [Math.abs(r[0].offsetTop), Math.abs(r[0].offsetLeft)];\"x\" !== i.axis && (n.overflowed[0] ? s[0].height() > s[0].parent().height() ? B.call(this) : (G(t, c[0].toString(), { dir: \"y\", dur: 0, overwrite: \"none\" }), n.contentReset.y = null) : (B.call(this), \"y\" === i.axis ? k.call(this) : \"yx\" === i.axis && n.overflowed[1] && G(t, c[1].toString(), { dir: \"x\", dur: 0, overwrite: \"none\" }))), \"y\" !== i.axis && (n.overflowed[1] ? s[1].width() > s[1].parent().width() ? B.call(this) : (G(t, c[1].toString(), { dir: \"x\", dur: 0, overwrite: \"none\" }), n.contentReset.x = null) : (B.call(this), \"x\" === i.axis ? k.call(this) : \"yx\" === i.axis && n.overflowed[0] && G(t, c[0].toString(), { dir: \"y\", dur: 0, overwrite: \"none\" }))), o && n && (2 === o && i.callbacks.onImageLoad && \"function\" == typeof i.callbacks.onImageLoad ? i.callbacks.onImageLoad.call(this) : 3 === o && i.callbacks.onSelectorChange && \"function\" == typeof i.callbacks.onSelectorChange ? i.callbacks.onSelectorChange.call(this) : i.callbacks.onUpdate && \"function\" == typeof i.callbacks.onUpdate && i.callbacks.onUpdate.call(this)), N.call(this);\n          }\n        });\n      }, scrollTo: function scrollTo(t, o) {\n        if (\"undefined\" != typeof t && null != t) {\n          var n = f.call(this);return e(n).each(function () {\n            var n = e(this);if (n.data(a)) {\n              var i = n.data(a),\n                  r = i.opt,\n                  l = { trigger: \"external\", scrollInertia: r.scrollInertia, scrollEasing: \"mcsEaseInOut\", moveDragger: !1, timeout: 60, callbacks: !0, onStart: !0, onUpdate: !0, onComplete: !0 },\n                  s = e.extend(!0, {}, l, o),\n                  c = Y.call(this, t),\n                  d = s.scrollInertia > 0 && s.scrollInertia < 17 ? 17 : s.scrollInertia;c[0] = X.call(this, c[0], \"y\"), c[1] = X.call(this, c[1], \"x\"), s.moveDragger && (c[0] *= i.scrollRatio.y, c[1] *= i.scrollRatio.x), s.dur = ne() ? 0 : d, setTimeout(function () {\n                null !== c[0] && \"undefined\" != typeof c[0] && \"x\" !== r.axis && i.overflowed[0] && (s.dir = \"y\", s.overwrite = \"all\", G(n, c[0].toString(), s)), null !== c[1] && \"undefined\" != typeof c[1] && \"y\" !== r.axis && i.overflowed[1] && (s.dir = \"x\", s.overwrite = \"none\", G(n, c[1].toString(), s));\n              }, s.timeout);\n            }\n          });\n        }\n      }, stop: function stop() {\n        var t = f.call(this);return e(t).each(function () {\n          var t = e(this);t.data(a) && Q(t);\n        });\n      }, disable: function disable(t) {\n        var o = f.call(this);return e(o).each(function () {\n          var o = e(this);if (o.data(a)) {\n            o.data(a);N.call(this, \"remove\"), k.call(this), t && B.call(this), M.call(this, !0), o.addClass(d[3]);\n          }\n        });\n      }, destroy: function destroy() {\n        var t = f.call(this);return e(t).each(function () {\n          var n = e(this);if (n.data(a)) {\n            var i = n.data(a),\n                r = i.opt,\n                l = e(\"#mCSB_\" + i.idx),\n                s = e(\"#mCSB_\" + i.idx + \"_container\"),\n                c = e(\".mCSB_\" + i.idx + \"_scrollbar\");r.live && m(r.liveSelector || e(t).selector), N.call(this, \"remove\"), k.call(this), B.call(this), n.removeData(a), $(this, \"mcs\"), c.remove(), s.find(\"img.\" + d[2]).removeClass(d[2]), l.replaceWith(s.contents()), n.removeClass(o + \" _\" + a + \"_\" + i.idx + \" \" + d[6] + \" \" + d[7] + \" \" + d[5] + \" \" + d[3]).addClass(d[4]);\n          }\n        });\n      } },\n        f = function f() {\n      return \"object\" != _typeof(e(this)) || e(this).length < 1 ? n : this;\n    },\n        h = function h(t) {\n      var o = [\"rounded\", \"rounded-dark\", \"rounded-dots\", \"rounded-dots-dark\"],\n          a = [\"rounded-dots\", \"rounded-dots-dark\", \"3d\", \"3d-dark\", \"3d-thick\", \"3d-thick-dark\", \"inset\", \"inset-dark\", \"inset-2\", \"inset-2-dark\", \"inset-3\", \"inset-3-dark\"],\n          n = [\"minimal\", \"minimal-dark\"],\n          i = [\"minimal\", \"minimal-dark\"],\n          r = [\"minimal\", \"minimal-dark\"];t.autoDraggerLength = e.inArray(t.theme, o) > -1 ? !1 : t.autoDraggerLength, t.autoExpandScrollbar = e.inArray(t.theme, a) > -1 ? !1 : t.autoExpandScrollbar, t.scrollButtons.enable = e.inArray(t.theme, n) > -1 ? !1 : t.scrollButtons.enable, t.autoHideScrollbar = e.inArray(t.theme, i) > -1 ? !0 : t.autoHideScrollbar, t.scrollbarPosition = e.inArray(t.theme, r) > -1 ? \"outside\" : t.scrollbarPosition;\n    },\n        m = function m(e) {\n      l[e] && (clearTimeout(l[e]), $(l, e));\n    },\n        p = function p(e) {\n      return \"yx\" === e || \"xy\" === e || \"auto\" === e ? \"yx\" : \"x\" === e || \"horizontal\" === e ? \"x\" : \"y\";\n    },\n        g = function g(e) {\n      return \"stepped\" === e || \"pixels\" === e || \"step\" === e || \"click\" === e ? \"stepped\" : \"stepless\";\n    },\n        v = function v() {\n      var t = e(this),\n          n = t.data(a),\n          i = n.opt,\n          r = i.autoExpandScrollbar ? \" \" + d[1] + \"_expand\" : \"\",\n          l = [\"<div id='mCSB_\" + n.idx + \"_scrollbar_vertical' class='mCSB_scrollTools mCSB_\" + n.idx + \"_scrollbar mCS-\" + i.theme + \" mCSB_scrollTools_vertical\" + r + \"'><div class='\" + d[12] + \"'><div id='mCSB_\" + n.idx + \"_dragger_vertical' class='mCSB_dragger' style='position:absolute;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>\", \"<div id='mCSB_\" + n.idx + \"_scrollbar_horizontal' class='mCSB_scrollTools mCSB_\" + n.idx + \"_scrollbar mCS-\" + i.theme + \" mCSB_scrollTools_horizontal\" + r + \"'><div class='\" + d[12] + \"'><div id='mCSB_\" + n.idx + \"_dragger_horizontal' class='mCSB_dragger' style='position:absolute;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>\"],\n          s = \"yx\" === i.axis ? \"mCSB_vertical_horizontal\" : \"x\" === i.axis ? \"mCSB_horizontal\" : \"mCSB_vertical\",\n          c = \"yx\" === i.axis ? l[0] + l[1] : \"x\" === i.axis ? l[1] : l[0],\n          u = \"yx\" === i.axis ? \"<div id='mCSB_\" + n.idx + \"_container_wrapper' class='mCSB_container_wrapper' />\" : \"\",\n          f = i.autoHideScrollbar ? \" \" + d[6] : \"\",\n          h = \"x\" !== i.axis && \"rtl\" === n.langDir ? \" \" + d[7] : \"\";i.setWidth && t.css(\"width\", i.setWidth), i.setHeight && t.css(\"height\", i.setHeight), i.setLeft = \"y\" !== i.axis && \"rtl\" === n.langDir ? \"989999px\" : i.setLeft, t.addClass(o + \" _\" + a + \"_\" + n.idx + f + h).wrapInner(\"<div id='mCSB_\" + n.idx + \"' class='mCustomScrollBox mCS-\" + i.theme + \" \" + s + \"'><div id='mCSB_\" + n.idx + \"_container' class='mCSB_container' style='position:relative; top:\" + i.setTop + \"; left:\" + i.setLeft + \";' dir='\" + n.langDir + \"' /></div>\");var m = e(\"#mCSB_\" + n.idx),\n          p = e(\"#mCSB_\" + n.idx + \"_container\");\"y\" === i.axis || i.advanced.autoExpandHorizontalScroll || p.css(\"width\", x(p)), \"outside\" === i.scrollbarPosition ? (\"static\" === t.css(\"position\") && t.css(\"position\", \"relative\"), t.css(\"overflow\", \"visible\"), m.addClass(\"mCSB_outside\").after(c)) : (m.addClass(\"mCSB_inside\").append(c), p.wrap(u)), w.call(this);var g = [e(\"#mCSB_\" + n.idx + \"_dragger_vertical\"), e(\"#mCSB_\" + n.idx + \"_dragger_horizontal\")];g[0].css(\"min-height\", g[0].height()), g[1].css(\"min-width\", g[1].width());\n    },\n        x = function x(t) {\n      var o = [t[0].scrollWidth, Math.max.apply(Math, t.children().map(function () {\n        return e(this).outerWidth(!0);\n      }).get())],\n          a = t.parent().width();return o[0] > a ? o[0] : o[1] > a ? o[1] : \"100%\";\n    },\n        _ = function _() {\n      var t = e(this),\n          o = t.data(a),\n          n = o.opt,\n          i = e(\"#mCSB_\" + o.idx + \"_container\");if (n.advanced.autoExpandHorizontalScroll && \"y\" !== n.axis) {\n        i.css({ width: \"auto\", \"min-width\": 0, \"overflow-x\": \"scroll\" });var r = Math.ceil(i[0].scrollWidth);3 === n.advanced.autoExpandHorizontalScroll || 2 !== n.advanced.autoExpandHorizontalScroll && r > i.parent().width() ? i.css({ width: r, \"min-width\": \"100%\", \"overflow-x\": \"inherit\" }) : i.css({ \"overflow-x\": \"inherit\", position: \"absolute\" }).wrap(\"<div class='mCSB_h_wrapper' style='position:relative; left:0; width:999999px;' />\").css({ width: Math.ceil(i[0].getBoundingClientRect().right + .4) - Math.floor(i[0].getBoundingClientRect().left), \"min-width\": \"100%\", position: \"relative\" }).unwrap();\n      }\n    },\n        w = function w() {\n      var t = e(this),\n          o = t.data(a),\n          n = o.opt,\n          i = e(\".mCSB_\" + o.idx + \"_scrollbar:first\"),\n          r = oe(n.scrollButtons.tabindex) ? \"tabindex='\" + n.scrollButtons.tabindex + \"'\" : \"\",\n          l = [\"<a href='#' class='\" + d[13] + \"' \" + r + \" />\", \"<a href='#' class='\" + d[14] + \"' \" + r + \" />\", \"<a href='#' class='\" + d[15] + \"' \" + r + \" />\", \"<a href='#' class='\" + d[16] + \"' \" + r + \" />\"],\n          s = [\"x\" === n.axis ? l[2] : l[0], \"x\" === n.axis ? l[3] : l[1], l[2], l[3]];n.scrollButtons.enable && i.prepend(s[0]).append(s[1]).next(\".mCSB_scrollTools\").prepend(s[2]).append(s[3]);\n    },\n        S = function S() {\n      var t = e(this),\n          o = t.data(a),\n          n = e(\"#mCSB_\" + o.idx),\n          i = e(\"#mCSB_\" + o.idx + \"_container\"),\n          r = [e(\"#mCSB_\" + o.idx + \"_dragger_vertical\"), e(\"#mCSB_\" + o.idx + \"_dragger_horizontal\")],\n          l = [n.height() / i.outerHeight(!1), n.width() / i.outerWidth(!1)],\n          c = [parseInt(r[0].css(\"min-height\")), Math.round(l[0] * r[0].parent().height()), parseInt(r[1].css(\"min-width\")), Math.round(l[1] * r[1].parent().width())],\n          d = s && c[1] < c[0] ? c[0] : c[1],\n          u = s && c[3] < c[2] ? c[2] : c[3];r[0].css({ height: d, \"max-height\": r[0].parent().height() - 10 }).find(\".mCSB_dragger_bar\").css({ \"line-height\": c[0] + \"px\" }), r[1].css({ width: u, \"max-width\": r[1].parent().width() - 10 });\n    },\n        b = function b() {\n      var t = e(this),\n          o = t.data(a),\n          n = e(\"#mCSB_\" + o.idx),\n          i = e(\"#mCSB_\" + o.idx + \"_container\"),\n          r = [e(\"#mCSB_\" + o.idx + \"_dragger_vertical\"), e(\"#mCSB_\" + o.idx + \"_dragger_horizontal\")],\n          l = [i.outerHeight(!1) - n.height(), i.outerWidth(!1) - n.width()],\n          s = [l[0] / (r[0].parent().height() - r[0].height()), l[1] / (r[1].parent().width() - r[1].width())];o.scrollRatio = { y: s[0], x: s[1] };\n    },\n        C = function C(e, t, o) {\n      var a = o ? d[0] + \"_expanded\" : \"\",\n          n = e.closest(\".mCSB_scrollTools\");\"active\" === t ? (e.toggleClass(d[0] + \" \" + a), n.toggleClass(d[1]), e[0]._draggable = e[0]._draggable ? 0 : 1) : e[0]._draggable || (\"hide\" === t ? (e.removeClass(d[0]), n.removeClass(d[1])) : (e.addClass(d[0]), n.addClass(d[1])));\n    },\n        y = function y() {\n      var t = e(this),\n          o = t.data(a),\n          n = e(\"#mCSB_\" + o.idx),\n          i = e(\"#mCSB_\" + o.idx + \"_container\"),\n          r = null == o.overflowed ? i.height() : i.outerHeight(!1),\n          l = null == o.overflowed ? i.width() : i.outerWidth(!1),\n          s = i[0].scrollHeight,\n          c = i[0].scrollWidth;return s > r && (r = s), c > l && (l = c), [r > n.height(), l > n.width()];\n    },\n        B = function B() {\n      var t = e(this),\n          o = t.data(a),\n          n = o.opt,\n          i = e(\"#mCSB_\" + o.idx),\n          r = e(\"#mCSB_\" + o.idx + \"_container\"),\n          l = [e(\"#mCSB_\" + o.idx + \"_dragger_vertical\"), e(\"#mCSB_\" + o.idx + \"_dragger_horizontal\")];if (Q(t), (\"x\" !== n.axis && !o.overflowed[0] || \"y\" === n.axis && o.overflowed[0]) && (l[0].add(r).css(\"top\", 0), G(t, \"_resetY\")), \"y\" !== n.axis && !o.overflowed[1] || \"x\" === n.axis && o.overflowed[1]) {\n        var s = dx = 0;\"rtl\" === o.langDir && (s = i.width() - r.outerWidth(!1), dx = Math.abs(s / o.scrollRatio.x)), r.css(\"left\", s), l[1].css(\"left\", dx), G(t, \"_resetX\");\n      }\n    },\n        T = function T() {\n      function t() {\n        r = setTimeout(function () {\n          e.event.special.mousewheel ? (clearTimeout(r), W.call(o[0])) : t();\n        }, 100);\n      }var o = e(this),\n          n = o.data(a),\n          i = n.opt;if (!n.bindEvents) {\n        if (I.call(this), i.contentTouchScroll && D.call(this), E.call(this), i.mouseWheel.enable) {\n          var r;t();\n        }P.call(this), U.call(this), i.advanced.autoScrollOnFocus && H.call(this), i.scrollButtons.enable && F.call(this), i.keyboard.enable && q.call(this), n.bindEvents = !0;\n      }\n    },\n        k = function k() {\n      var t = e(this),\n          o = t.data(a),\n          n = o.opt,\n          i = a + \"_\" + o.idx,\n          r = \".mCSB_\" + o.idx + \"_scrollbar\",\n          l = e(\"#mCSB_\" + o.idx + \",#mCSB_\" + o.idx + \"_container,#mCSB_\" + o.idx + \"_container_wrapper,\" + r + \" .\" + d[12] + \",#mCSB_\" + o.idx + \"_dragger_vertical,#mCSB_\" + o.idx + \"_dragger_horizontal,\" + r + \">a\"),\n          s = e(\"#mCSB_\" + o.idx + \"_container\");n.advanced.releaseDraggableSelectors && l.add(e(n.advanced.releaseDraggableSelectors)), n.advanced.extraDraggableSelectors && l.add(e(n.advanced.extraDraggableSelectors)), o.bindEvents && (e(document).add(e(!A() || top.document)).unbind(\".\" + i), l.each(function () {\n        e(this).unbind(\".\" + i);\n      }), clearTimeout(t[0]._focusTimeout), $(t[0], \"_focusTimeout\"), clearTimeout(o.sequential.step), $(o.sequential, \"step\"), clearTimeout(s[0].onCompleteTimeout), $(s[0], \"onCompleteTimeout\"), o.bindEvents = !1);\n    },\n        M = function M(t) {\n      var o = e(this),\n          n = o.data(a),\n          i = n.opt,\n          r = e(\"#mCSB_\" + n.idx + \"_container_wrapper\"),\n          l = r.length ? r : e(\"#mCSB_\" + n.idx + \"_container\"),\n          s = [e(\"#mCSB_\" + n.idx + \"_scrollbar_vertical\"), e(\"#mCSB_\" + n.idx + \"_scrollbar_horizontal\")],\n          c = [s[0].find(\".mCSB_dragger\"), s[1].find(\".mCSB_dragger\")];\"x\" !== i.axis && (n.overflowed[0] && !t ? (s[0].add(c[0]).add(s[0].children(\"a\")).css(\"display\", \"block\"), l.removeClass(d[8] + \" \" + d[10])) : (i.alwaysShowScrollbar ? (2 !== i.alwaysShowScrollbar && c[0].css(\"display\", \"none\"), l.removeClass(d[10])) : (s[0].css(\"display\", \"none\"), l.addClass(d[10])), l.addClass(d[8]))), \"y\" !== i.axis && (n.overflowed[1] && !t ? (s[1].add(c[1]).add(s[1].children(\"a\")).css(\"display\", \"block\"), l.removeClass(d[9] + \" \" + d[11])) : (i.alwaysShowScrollbar ? (2 !== i.alwaysShowScrollbar && c[1].css(\"display\", \"none\"), l.removeClass(d[11])) : (s[1].css(\"display\", \"none\"), l.addClass(d[11])), l.addClass(d[9]))), n.overflowed[0] || n.overflowed[1] ? o.removeClass(d[5]) : o.addClass(d[5]);\n    },\n        O = function O(t) {\n      var o = t.type,\n          a = t.target.ownerDocument !== document && null !== frameElement ? [e(frameElement).offset().top, e(frameElement).offset().left] : null,\n          n = A() && t.target.ownerDocument !== top.document && null !== frameElement ? [e(t.view.frameElement).offset().top, e(t.view.frameElement).offset().left] : [0, 0];switch (o) {case \"pointerdown\":case \"MSPointerDown\":case \"pointermove\":case \"MSPointerMove\":case \"pointerup\":case \"MSPointerUp\":\n          return a ? [t.originalEvent.pageY - a[0] + n[0], t.originalEvent.pageX - a[1] + n[1], !1] : [t.originalEvent.pageY, t.originalEvent.pageX, !1];case \"touchstart\":case \"touchmove\":case \"touchend\":\n          var i = t.originalEvent.touches[0] || t.originalEvent.changedTouches[0],\n              r = t.originalEvent.touches.length || t.originalEvent.changedTouches.length;return t.target.ownerDocument !== document ? [i.screenY, i.screenX, r > 1] : [i.pageY, i.pageX, r > 1];default:\n          return a ? [t.pageY - a[0] + n[0], t.pageX - a[1] + n[1], !1] : [t.pageY, t.pageX, !1];}\n    },\n        I = function I() {\n      function t(e, t, a, n) {\n        if (h[0].idleTimer = d.scrollInertia < 233 ? 250 : 0, o.attr(\"id\") === f[1]) var i = \"x\",\n            s = (o[0].offsetLeft - t + n) * l.scrollRatio.x;else var i = \"y\",\n            s = (o[0].offsetTop - e + a) * l.scrollRatio.y;G(r, s.toString(), { dir: i, drag: !0 });\n      }var o,\n          n,\n          i,\n          r = e(this),\n          l = r.data(a),\n          d = l.opt,\n          u = a + \"_\" + l.idx,\n          f = [\"mCSB_\" + l.idx + \"_dragger_vertical\", \"mCSB_\" + l.idx + \"_dragger_horizontal\"],\n          h = e(\"#mCSB_\" + l.idx + \"_container\"),\n          m = e(\"#\" + f[0] + \",#\" + f[1]),\n          p = d.advanced.releaseDraggableSelectors ? m.add(e(d.advanced.releaseDraggableSelectors)) : m,\n          g = d.advanced.extraDraggableSelectors ? e(!A() || top.document).add(e(d.advanced.extraDraggableSelectors)) : e(!A() || top.document);m.bind(\"contextmenu.\" + u, function (e) {\n        e.preventDefault();\n      }).bind(\"mousedown.\" + u + \" touchstart.\" + u + \" pointerdown.\" + u + \" MSPointerDown.\" + u, function (t) {\n        if (t.stopImmediatePropagation(), t.preventDefault(), ee(t)) {\n          c = !0, s && (document.onselectstart = function () {\n            return !1;\n          }), L.call(h, !1), Q(r), o = e(this);var a = o.offset(),\n              l = O(t)[0] - a.top,\n              u = O(t)[1] - a.left,\n              f = o.height() + a.top,\n              m = o.width() + a.left;f > l && l > 0 && m > u && u > 0 && (n = l, i = u), C(o, \"active\", d.autoExpandScrollbar);\n        }\n      }).bind(\"touchmove.\" + u, function (e) {\n        e.stopImmediatePropagation(), e.preventDefault();var a = o.offset(),\n            r = O(e)[0] - a.top,\n            l = O(e)[1] - a.left;t(n, i, r, l);\n      }), e(document).add(g).bind(\"mousemove.\" + u + \" pointermove.\" + u + \" MSPointerMove.\" + u, function (e) {\n        if (o) {\n          var a = o.offset(),\n              r = O(e)[0] - a.top,\n              l = O(e)[1] - a.left;if (n === r && i === l) return;t(n, i, r, l);\n        }\n      }).add(p).bind(\"mouseup.\" + u + \" touchend.\" + u + \" pointerup.\" + u + \" MSPointerUp.\" + u, function () {\n        o && (C(o, \"active\", d.autoExpandScrollbar), o = null), c = !1, s && (document.onselectstart = null), L.call(h, !0);\n      });\n    },\n        D = function D() {\n      function o(e) {\n        if (!te(e) || c || O(e)[2]) return void (t = 0);t = 1, b = 0, C = 0, d = 1, y.removeClass(\"mCS_touch_action\");var o = I.offset();u = O(e)[0] - o.top, f = O(e)[1] - o.left, z = [O(e)[0], O(e)[1]];\n      }function n(e) {\n        if (te(e) && !c && !O(e)[2] && (T.documentTouchScroll || e.preventDefault(), e.stopImmediatePropagation(), (!C || b) && d)) {\n          g = K();var t = M.offset(),\n              o = O(e)[0] - t.top,\n              a = O(e)[1] - t.left,\n              n = \"mcsLinearOut\";if (E.push(o), W.push(a), z[2] = Math.abs(O(e)[0] - z[0]), z[3] = Math.abs(O(e)[1] - z[1]), B.overflowed[0]) var i = D[0].parent().height() - D[0].height(),\n              r = u - o > 0 && o - u > -(i * B.scrollRatio.y) && (2 * z[3] < z[2] || \"yx\" === T.axis);if (B.overflowed[1]) var l = D[1].parent().width() - D[1].width(),\n              h = f - a > 0 && a - f > -(l * B.scrollRatio.x) && (2 * z[2] < z[3] || \"yx\" === T.axis);r || h ? (U || e.preventDefault(), b = 1) : (C = 1, y.addClass(\"mCS_touch_action\")), U && e.preventDefault(), w = \"yx\" === T.axis ? [u - o, f - a] : \"x\" === T.axis ? [null, f - a] : [u - o, null], I[0].idleTimer = 250, B.overflowed[0] && s(w[0], R, n, \"y\", \"all\", !0), B.overflowed[1] && s(w[1], R, n, \"x\", L, !0);\n        }\n      }function i(e) {\n        if (!te(e) || c || O(e)[2]) return void (t = 0);t = 1, e.stopImmediatePropagation(), Q(y), p = K();var o = M.offset();h = O(e)[0] - o.top, m = O(e)[1] - o.left, E = [], W = [];\n      }function r(e) {\n        if (te(e) && !c && !O(e)[2]) {\n          d = 0, e.stopImmediatePropagation(), b = 0, C = 0, v = K();var t = M.offset(),\n              o = O(e)[0] - t.top,\n              a = O(e)[1] - t.left;if (!(v - g > 30)) {\n            _ = 1e3 / (v - p);var n = \"mcsEaseOut\",\n                i = 2.5 > _,\n                r = i ? [E[E.length - 2], W[W.length - 2]] : [0, 0];x = i ? [o - r[0], a - r[1]] : [o - h, a - m];var u = [Math.abs(x[0]), Math.abs(x[1])];_ = i ? [Math.abs(x[0] / 4), Math.abs(x[1] / 4)] : [_, _];var f = [Math.abs(I[0].offsetTop) - x[0] * l(u[0] / _[0], _[0]), Math.abs(I[0].offsetLeft) - x[1] * l(u[1] / _[1], _[1])];w = \"yx\" === T.axis ? [f[0], f[1]] : \"x\" === T.axis ? [null, f[1]] : [f[0], null], S = [4 * u[0] + T.scrollInertia, 4 * u[1] + T.scrollInertia];var y = parseInt(T.contentTouchScroll) || 0;w[0] = u[0] > y ? w[0] : 0, w[1] = u[1] > y ? w[1] : 0, B.overflowed[0] && s(w[0], S[0], n, \"y\", L, !1), B.overflowed[1] && s(w[1], S[1], n, \"x\", L, !1);\n          }\n        }\n      }function l(e, t) {\n        var o = [1.5 * t, 2 * t, t / 1.5, t / 2];return e > 90 ? t > 4 ? o[0] : o[3] : e > 60 ? t > 3 ? o[3] : o[2] : e > 30 ? t > 8 ? o[1] : t > 6 ? o[0] : t > 4 ? t : o[2] : t > 8 ? t : o[3];\n      }function s(e, t, o, a, n, i) {\n        e && G(y, e.toString(), { dur: t, scrollEasing: o, dir: a, overwrite: n, drag: i });\n      }var d,\n          u,\n          f,\n          h,\n          m,\n          p,\n          g,\n          v,\n          x,\n          _,\n          w,\n          S,\n          b,\n          C,\n          y = e(this),\n          B = y.data(a),\n          T = B.opt,\n          k = a + \"_\" + B.idx,\n          M = e(\"#mCSB_\" + B.idx),\n          I = e(\"#mCSB_\" + B.idx + \"_container\"),\n          D = [e(\"#mCSB_\" + B.idx + \"_dragger_vertical\"), e(\"#mCSB_\" + B.idx + \"_dragger_horizontal\")],\n          E = [],\n          W = [],\n          R = 0,\n          L = \"yx\" === T.axis ? \"none\" : \"all\",\n          z = [],\n          P = I.find(\"iframe\"),\n          H = [\"touchstart.\" + k + \" pointerdown.\" + k + \" MSPointerDown.\" + k, \"touchmove.\" + k + \" pointermove.\" + k + \" MSPointerMove.\" + k, \"touchend.\" + k + \" pointerup.\" + k + \" MSPointerUp.\" + k],\n          U = void 0 !== document.body.style.touchAction && \"\" !== document.body.style.touchAction;I.bind(H[0], function (e) {\n        o(e);\n      }).bind(H[1], function (e) {\n        n(e);\n      }), M.bind(H[0], function (e) {\n        i(e);\n      }).bind(H[2], function (e) {\n        r(e);\n      }), P.length && P.each(function () {\n        e(this).bind(\"load\", function () {\n          A(this) && e(this.contentDocument || this.contentWindow.document).bind(H[0], function (e) {\n            o(e), i(e);\n          }).bind(H[1], function (e) {\n            n(e);\n          }).bind(H[2], function (e) {\n            r(e);\n          });\n        });\n      });\n    },\n        E = function E() {\n      function o() {\n        return window.getSelection ? window.getSelection().toString() : document.selection && \"Control\" != document.selection.type ? document.selection.createRange().text : 0;\n      }function n(e, t, o) {\n        d.type = o && i ? \"stepped\" : \"stepless\", d.scrollAmount = 10, j(r, e, t, \"mcsLinearOut\", o ? 60 : null);\n      }var i,\n          r = e(this),\n          l = r.data(a),\n          s = l.opt,\n          d = l.sequential,\n          u = a + \"_\" + l.idx,\n          f = e(\"#mCSB_\" + l.idx + \"_container\"),\n          h = f.parent();f.bind(\"mousedown.\" + u, function () {\n        t || i || (i = 1, c = !0);\n      }).add(document).bind(\"mousemove.\" + u, function (e) {\n        if (!t && i && o()) {\n          var a = f.offset(),\n              r = O(e)[0] - a.top + f[0].offsetTop,\n              c = O(e)[1] - a.left + f[0].offsetLeft;r > 0 && r < h.height() && c > 0 && c < h.width() ? d.step && n(\"off\", null, \"stepped\") : (\"x\" !== s.axis && l.overflowed[0] && (0 > r ? n(\"on\", 38) : r > h.height() && n(\"on\", 40)), \"y\" !== s.axis && l.overflowed[1] && (0 > c ? n(\"on\", 37) : c > h.width() && n(\"on\", 39)));\n        }\n      }).bind(\"mouseup.\" + u + \" dragend.\" + u, function () {\n        t || (i && (i = 0, n(\"off\", null)), c = !1);\n      });\n    },\n        W = function W() {\n      function t(t, a) {\n        if (Q(o), !z(o, t.target)) {\n          var r = \"auto\" !== i.mouseWheel.deltaFactor ? parseInt(i.mouseWheel.deltaFactor) : s && t.deltaFactor < 100 ? 100 : t.deltaFactor || 100,\n              d = i.scrollInertia;if (\"x\" === i.axis || \"x\" === i.mouseWheel.axis) var u = \"x\",\n              f = [Math.round(r * n.scrollRatio.x), parseInt(i.mouseWheel.scrollAmount)],\n              h = \"auto\" !== i.mouseWheel.scrollAmount ? f[1] : f[0] >= l.width() ? .9 * l.width() : f[0],\n              m = Math.abs(e(\"#mCSB_\" + n.idx + \"_container\")[0].offsetLeft),\n              p = c[1][0].offsetLeft,\n              g = c[1].parent().width() - c[1].width(),\n              v = \"y\" === i.mouseWheel.axis ? t.deltaY || a : t.deltaX;else var u = \"y\",\n              f = [Math.round(r * n.scrollRatio.y), parseInt(i.mouseWheel.scrollAmount)],\n              h = \"auto\" !== i.mouseWheel.scrollAmount ? f[1] : f[0] >= l.height() ? .9 * l.height() : f[0],\n              m = Math.abs(e(\"#mCSB_\" + n.idx + \"_container\")[0].offsetTop),\n              p = c[0][0].offsetTop,\n              g = c[0].parent().height() - c[0].height(),\n              v = t.deltaY || a;\"y\" === u && !n.overflowed[0] || \"x\" === u && !n.overflowed[1] || ((i.mouseWheel.invert || t.webkitDirectionInvertedFromDevice) && (v = -v), i.mouseWheel.normalizeDelta && (v = 0 > v ? -1 : 1), (v > 0 && 0 !== p || 0 > v && p !== g || i.mouseWheel.preventDefault) && (t.stopImmediatePropagation(), t.preventDefault()), t.deltaFactor < 5 && !i.mouseWheel.normalizeDelta && (h = t.deltaFactor, d = 17), G(o, (m - v * h).toString(), { dir: u, dur: d }));\n        }\n      }if (e(this).data(a)) {\n        var o = e(this),\n            n = o.data(a),\n            i = n.opt,\n            r = a + \"_\" + n.idx,\n            l = e(\"#mCSB_\" + n.idx),\n            c = [e(\"#mCSB_\" + n.idx + \"_dragger_vertical\"), e(\"#mCSB_\" + n.idx + \"_dragger_horizontal\")],\n            d = e(\"#mCSB_\" + n.idx + \"_container\").find(\"iframe\");d.length && d.each(function () {\n          e(this).bind(\"load\", function () {\n            A(this) && e(this.contentDocument || this.contentWindow.document).bind(\"mousewheel.\" + r, function (e, o) {\n              t(e, o);\n            });\n          });\n        }), l.bind(\"mousewheel.\" + r, function (e, o) {\n          t(e, o);\n        });\n      }\n    },\n        R = new Object(),\n        A = function A(t) {\n      var o = !1,\n          a = !1,\n          n = null;if (void 0 === t ? a = \"#empty\" : void 0 !== e(t).attr(\"id\") && (a = e(t).attr(\"id\")), a !== !1 && void 0 !== R[a]) return R[a];if (t) {\n        try {\n          var i = t.contentDocument || t.contentWindow.document;n = i.body.innerHTML;\n        } catch (r) {}o = null !== n;\n      } else {\n        try {\n          var i = top.document;n = i.body.innerHTML;\n        } catch (r) {}o = null !== n;\n      }return a !== !1 && (R[a] = o), o;\n    },\n        L = function L(e) {\n      var t = this.find(\"iframe\");if (t.length) {\n        var o = e ? \"auto\" : \"none\";t.css(\"pointer-events\", o);\n      }\n    },\n        z = function z(t, o) {\n      var n = o.nodeName.toLowerCase(),\n          i = t.data(a).opt.mouseWheel.disableOver,\n          r = [\"select\", \"textarea\"];return e.inArray(n, i) > -1 && !(e.inArray(n, r) > -1 && !e(o).is(\":focus\"));\n    },\n        P = function P() {\n      var t,\n          o = e(this),\n          n = o.data(a),\n          i = a + \"_\" + n.idx,\n          r = e(\"#mCSB_\" + n.idx + \"_container\"),\n          l = r.parent(),\n          s = e(\".mCSB_\" + n.idx + \"_scrollbar .\" + d[12]);s.bind(\"mousedown.\" + i + \" touchstart.\" + i + \" pointerdown.\" + i + \" MSPointerDown.\" + i, function (o) {\n        c = !0, e(o.target).hasClass(\"mCSB_dragger\") || (t = 1);\n      }).bind(\"touchend.\" + i + \" pointerup.\" + i + \" MSPointerUp.\" + i, function () {\n        c = !1;\n      }).bind(\"click.\" + i, function (a) {\n        if (t && (t = 0, e(a.target).hasClass(d[12]) || e(a.target).hasClass(\"mCSB_draggerRail\"))) {\n          Q(o);var i = e(this),\n              s = i.find(\".mCSB_dragger\");if (i.parent(\".mCSB_scrollTools_horizontal\").length > 0) {\n            if (!n.overflowed[1]) return;var c = \"x\",\n                u = a.pageX > s.offset().left ? -1 : 1,\n                f = Math.abs(r[0].offsetLeft) - u * (.9 * l.width());\n          } else {\n            if (!n.overflowed[0]) return;var c = \"y\",\n                u = a.pageY > s.offset().top ? -1 : 1,\n                f = Math.abs(r[0].offsetTop) - u * (.9 * l.height());\n          }G(o, f.toString(), { dir: c, scrollEasing: \"mcsEaseInOut\" });\n        }\n      });\n    },\n        H = function H() {\n      var t = e(this),\n          o = t.data(a),\n          n = o.opt,\n          i = a + \"_\" + o.idx,\n          r = e(\"#mCSB_\" + o.idx + \"_container\"),\n          l = r.parent();r.bind(\"focusin.\" + i, function () {\n        var o = e(document.activeElement),\n            a = r.find(\".mCustomScrollBox\").length,\n            i = 0;o.is(n.advanced.autoScrollOnFocus) && (Q(t), clearTimeout(t[0]._focusTimeout), t[0]._focusTimer = a ? (i + 17) * a : 0, t[0]._focusTimeout = setTimeout(function () {\n          var e = [ae(o)[0], ae(o)[1]],\n              a = [r[0].offsetTop, r[0].offsetLeft],\n              s = [a[0] + e[0] >= 0 && a[0] + e[0] < l.height() - o.outerHeight(!1), a[1] + e[1] >= 0 && a[0] + e[1] < l.width() - o.outerWidth(!1)],\n              c = \"yx\" !== n.axis || s[0] || s[1] ? \"all\" : \"none\";\"x\" === n.axis || s[0] || G(t, e[0].toString(), { dir: \"y\", scrollEasing: \"mcsEaseInOut\", overwrite: c, dur: i }), \"y\" === n.axis || s[1] || G(t, e[1].toString(), { dir: \"x\", scrollEasing: \"mcsEaseInOut\", overwrite: c, dur: i });\n        }, t[0]._focusTimer));\n      });\n    },\n        U = function U() {\n      var t = e(this),\n          o = t.data(a),\n          n = a + \"_\" + o.idx,\n          i = e(\"#mCSB_\" + o.idx + \"_container\").parent();i.bind(\"scroll.\" + n, function () {\n        0 === i.scrollTop() && 0 === i.scrollLeft() || e(\".mCSB_\" + o.idx + \"_scrollbar\").css(\"visibility\", \"hidden\");\n      });\n    },\n        F = function F() {\n      var t = e(this),\n          o = t.data(a),\n          n = o.opt,\n          i = o.sequential,\n          r = a + \"_\" + o.idx,\n          l = \".mCSB_\" + o.idx + \"_scrollbar\",\n          s = e(l + \">a\");s.bind(\"contextmenu.\" + r, function (e) {\n        e.preventDefault();\n      }).bind(\"mousedown.\" + r + \" touchstart.\" + r + \" pointerdown.\" + r + \" MSPointerDown.\" + r + \" mouseup.\" + r + \" touchend.\" + r + \" pointerup.\" + r + \" MSPointerUp.\" + r + \" mouseout.\" + r + \" pointerout.\" + r + \" MSPointerOut.\" + r + \" click.\" + r, function (a) {\n        function r(e, o) {\n          i.scrollAmount = n.scrollButtons.scrollAmount, j(t, e, o);\n        }if (a.preventDefault(), ee(a)) {\n          var l = e(this).attr(\"class\");switch (i.type = n.scrollButtons.scrollType, a.type) {case \"mousedown\":case \"touchstart\":case \"pointerdown\":case \"MSPointerDown\":\n              if (\"stepped\" === i.type) return;c = !0, o.tweenRunning = !1, r(\"on\", l);break;case \"mouseup\":case \"touchend\":case \"pointerup\":case \"MSPointerUp\":case \"mouseout\":case \"pointerout\":case \"MSPointerOut\":\n              if (\"stepped\" === i.type) return;c = !1, i.dir && r(\"off\", l);break;case \"click\":\n              if (\"stepped\" !== i.type || o.tweenRunning) return;r(\"on\", l);}\n        }\n      });\n    },\n        q = function q() {\n      function t(t) {\n        function a(e, t) {\n          r.type = i.keyboard.scrollType, r.scrollAmount = i.keyboard.scrollAmount, \"stepped\" === r.type && n.tweenRunning || j(o, e, t);\n        }switch (t.type) {case \"blur\":\n            n.tweenRunning && r.dir && a(\"off\", null);break;case \"keydown\":case \"keyup\":\n            var l = t.keyCode ? t.keyCode : t.which,\n                s = \"on\";if (\"x\" !== i.axis && (38 === l || 40 === l) || \"y\" !== i.axis && (37 === l || 39 === l)) {\n              if ((38 === l || 40 === l) && !n.overflowed[0] || (37 === l || 39 === l) && !n.overflowed[1]) return;\"keyup\" === t.type && (s = \"off\"), e(document.activeElement).is(u) || (t.preventDefault(), t.stopImmediatePropagation(), a(s, l));\n            } else if (33 === l || 34 === l) {\n              if ((n.overflowed[0] || n.overflowed[1]) && (t.preventDefault(), t.stopImmediatePropagation()), \"keyup\" === t.type) {\n                Q(o);var f = 34 === l ? -1 : 1;if (\"x\" === i.axis || \"yx\" === i.axis && n.overflowed[1] && !n.overflowed[0]) var h = \"x\",\n                    m = Math.abs(c[0].offsetLeft) - f * (.9 * d.width());else var h = \"y\",\n                    m = Math.abs(c[0].offsetTop) - f * (.9 * d.height());G(o, m.toString(), { dir: h, scrollEasing: \"mcsEaseInOut\" });\n              }\n            } else if ((35 === l || 36 === l) && !e(document.activeElement).is(u) && ((n.overflowed[0] || n.overflowed[1]) && (t.preventDefault(), t.stopImmediatePropagation()), \"keyup\" === t.type)) {\n              if (\"x\" === i.axis || \"yx\" === i.axis && n.overflowed[1] && !n.overflowed[0]) var h = \"x\",\n                  m = 35 === l ? Math.abs(d.width() - c.outerWidth(!1)) : 0;else var h = \"y\",\n                  m = 35 === l ? Math.abs(d.height() - c.outerHeight(!1)) : 0;G(o, m.toString(), { dir: h, scrollEasing: \"mcsEaseInOut\" });\n            }}\n      }var o = e(this),\n          n = o.data(a),\n          i = n.opt,\n          r = n.sequential,\n          l = a + \"_\" + n.idx,\n          s = e(\"#mCSB_\" + n.idx),\n          c = e(\"#mCSB_\" + n.idx + \"_container\"),\n          d = c.parent(),\n          u = \"input,textarea,select,datalist,keygen,[contenteditable='true']\",\n          f = c.find(\"iframe\"),\n          h = [\"blur.\" + l + \" keydown.\" + l + \" keyup.\" + l];f.length && f.each(function () {\n        e(this).bind(\"load\", function () {\n          A(this) && e(this.contentDocument || this.contentWindow.document).bind(h[0], function (e) {\n            t(e);\n          });\n        });\n      }), s.attr(\"tabindex\", \"0\").bind(h[0], function (e) {\n        t(e);\n      });\n    },\n        j = function j(t, o, n, i, r) {\n      function l(e) {\n        u.snapAmount && (f.scrollAmount = u.snapAmount instanceof Array ? \"x\" === f.dir[0] ? u.snapAmount[1] : u.snapAmount[0] : u.snapAmount);var o = \"stepped\" !== f.type,\n            a = r ? r : e ? o ? p / 1.5 : g : 1e3 / 60,\n            n = e ? o ? 7.5 : 40 : 2.5,\n            s = [Math.abs(h[0].offsetTop), Math.abs(h[0].offsetLeft)],\n            d = [c.scrollRatio.y > 10 ? 10 : c.scrollRatio.y, c.scrollRatio.x > 10 ? 10 : c.scrollRatio.x],\n            m = \"x\" === f.dir[0] ? s[1] + f.dir[1] * (d[1] * n) : s[0] + f.dir[1] * (d[0] * n),\n            v = \"x\" === f.dir[0] ? s[1] + f.dir[1] * parseInt(f.scrollAmount) : s[0] + f.dir[1] * parseInt(f.scrollAmount),\n            x = \"auto\" !== f.scrollAmount ? v : m,\n            _ = i ? i : e ? o ? \"mcsLinearOut\" : \"mcsEaseInOut\" : \"mcsLinear\",\n            w = !!e;return e && 17 > a && (x = \"x\" === f.dir[0] ? s[1] : s[0]), G(t, x.toString(), { dir: f.dir[0], scrollEasing: _, dur: a, onComplete: w }), e ? void (f.dir = !1) : (clearTimeout(f.step), void (f.step = setTimeout(function () {\n          l();\n        }, a)));\n      }function s() {\n        clearTimeout(f.step), $(f, \"step\"), Q(t);\n      }var c = t.data(a),\n          u = c.opt,\n          f = c.sequential,\n          h = e(\"#mCSB_\" + c.idx + \"_container\"),\n          m = \"stepped\" === f.type,\n          p = u.scrollInertia < 26 ? 26 : u.scrollInertia,\n          g = u.scrollInertia < 1 ? 17 : u.scrollInertia;switch (o) {case \"on\":\n          if (f.dir = [n === d[16] || n === d[15] || 39 === n || 37 === n ? \"x\" : \"y\", n === d[13] || n === d[15] || 38 === n || 37 === n ? -1 : 1], Q(t), oe(n) && \"stepped\" === f.type) return;l(m);break;case \"off\":\n          s(), (m || c.tweenRunning && f.dir) && l(!0);}\n    },\n        Y = function Y(t) {\n      var o = e(this).data(a).opt,\n          n = [];return \"function\" == typeof t && (t = t()), t instanceof Array ? n = t.length > 1 ? [t[0], t[1]] : \"x\" === o.axis ? [null, t[0]] : [t[0], null] : (n[0] = t.y ? t.y : t.x || \"x\" === o.axis ? null : t, n[1] = t.x ? t.x : t.y || \"y\" === o.axis ? null : t), \"function\" == typeof n[0] && (n[0] = n[0]()), \"function\" == typeof n[1] && (n[1] = n[1]()), n;\n    },\n        X = function X(t, o) {\n      if (null != t && \"undefined\" != typeof t) {\n        var n = e(this),\n            i = n.data(a),\n            r = i.opt,\n            l = e(\"#mCSB_\" + i.idx + \"_container\"),\n            s = l.parent(),\n            c = typeof t === \"undefined\" ? \"undefined\" : _typeof(t);o || (o = \"x\" === r.axis ? \"x\" : \"y\");var d = \"x\" === o ? l.outerWidth(!1) - s.width() : l.outerHeight(!1) - s.height(),\n            f = \"x\" === o ? l[0].offsetLeft : l[0].offsetTop,\n            h = \"x\" === o ? \"left\" : \"top\";switch (c) {case \"function\":\n            return t();case \"object\":\n            var m = t.jquery ? t : e(t);if (!m.length) return;return \"x\" === o ? ae(m)[1] : ae(m)[0];case \"string\":case \"number\":\n            if (oe(t)) return Math.abs(t);if (-1 !== t.indexOf(\"%\")) return Math.abs(d * parseInt(t) / 100);if (-1 !== t.indexOf(\"-=\")) return Math.abs(f - parseInt(t.split(\"-=\")[1]));if (-1 !== t.indexOf(\"+=\")) {\n              var p = f + parseInt(t.split(\"+=\")[1]);return p >= 0 ? 0 : Math.abs(p);\n            }if (-1 !== t.indexOf(\"px\") && oe(t.split(\"px\")[0])) return Math.abs(t.split(\"px\")[0]);if (\"top\" === t || \"left\" === t) return 0;if (\"bottom\" === t) return Math.abs(s.height() - l.outerHeight(!1));if (\"right\" === t) return Math.abs(s.width() - l.outerWidth(!1));if (\"first\" === t || \"last\" === t) {\n              var m = l.find(\":\" + t);return \"x\" === o ? ae(m)[1] : ae(m)[0];\n            }return e(t).length ? \"x\" === o ? ae(e(t))[1] : ae(e(t))[0] : (l.css(h, t), void u.update.call(null, n[0]));}\n      }\n    },\n        N = function N(t) {\n      function o() {\n        return clearTimeout(f[0].autoUpdate), 0 === l.parents(\"html\").length ? void (l = null) : void (f[0].autoUpdate = setTimeout(function () {\n          return c.advanced.updateOnSelectorChange && (s.poll.change.n = i(), s.poll.change.n !== s.poll.change.o) ? (s.poll.change.o = s.poll.change.n, void r(3)) : c.advanced.updateOnContentResize && (s.poll.size.n = l[0].scrollHeight + l[0].scrollWidth + f[0].offsetHeight + l[0].offsetHeight + l[0].offsetWidth, s.poll.size.n !== s.poll.size.o) ? (s.poll.size.o = s.poll.size.n, void r(1)) : !c.advanced.updateOnImageLoad || \"auto\" === c.advanced.updateOnImageLoad && \"y\" === c.axis || (s.poll.img.n = f.find(\"img\").length, s.poll.img.n === s.poll.img.o) ? void ((c.advanced.updateOnSelectorChange || c.advanced.updateOnContentResize || c.advanced.updateOnImageLoad) && o()) : (s.poll.img.o = s.poll.img.n, void f.find(\"img\").each(function () {\n            n(this);\n          }));\n        }, c.advanced.autoUpdateTimeout));\n      }function n(t) {\n        function o(e, t) {\n          return function () {\n            return t.apply(e, arguments);\n          };\n        }function a() {\n          this.onload = null, e(t).addClass(d[2]), r(2);\n        }if (e(t).hasClass(d[2])) return void r();var n = new Image();n.onload = o(n, a), n.src = t.src;\n      }function i() {\n        c.advanced.updateOnSelectorChange === !0 && (c.advanced.updateOnSelectorChange = \"*\");var e = 0,\n            t = f.find(c.advanced.updateOnSelectorChange);return c.advanced.updateOnSelectorChange && t.length > 0 && t.each(function () {\n          e += this.offsetHeight + this.offsetWidth;\n        }), e;\n      }function r(e) {\n        clearTimeout(f[0].autoUpdate), u.update.call(null, l[0], e);\n      }var l = e(this),\n          s = l.data(a),\n          c = s.opt,\n          f = e(\"#mCSB_\" + s.idx + \"_container\");return t ? (clearTimeout(f[0].autoUpdate), void $(f[0], \"autoUpdate\")) : void o();\n    },\n        V = function V(e, t, o) {\n      return Math.round(e / t) * t - o;\n    },\n        Q = function Q(t) {\n      var o = t.data(a),\n          n = e(\"#mCSB_\" + o.idx + \"_container,#mCSB_\" + o.idx + \"_container_wrapper,#mCSB_\" + o.idx + \"_dragger_vertical,#mCSB_\" + o.idx + \"_dragger_horizontal\");n.each(function () {\n        Z.call(this);\n      });\n    },\n        G = function G(t, o, n) {\n      function i(e) {\n        return s && c.callbacks[e] && \"function\" == typeof c.callbacks[e];\n      }function r() {\n        return [c.callbacks.alwaysTriggerOffsets || w >= S[0] + y, c.callbacks.alwaysTriggerOffsets || -B >= w];\n      }function l() {\n        var e = [h[0].offsetTop, h[0].offsetLeft],\n            o = [x[0].offsetTop, x[0].offsetLeft],\n            a = [h.outerHeight(!1), h.outerWidth(!1)],\n            i = [f.height(), f.width()];t[0].mcs = { content: h, top: e[0], left: e[1], draggerTop: o[0], draggerLeft: o[1], topPct: Math.round(100 * Math.abs(e[0]) / (Math.abs(a[0]) - i[0])), leftPct: Math.round(100 * Math.abs(e[1]) / (Math.abs(a[1]) - i[1])), direction: n.dir };\n      }var s = t.data(a),\n          c = s.opt,\n          d = { trigger: \"internal\", dir: \"y\", scrollEasing: \"mcsEaseOut\", drag: !1, dur: c.scrollInertia, overwrite: \"all\", callbacks: !0, onStart: !0, onUpdate: !0, onComplete: !0 },\n          n = e.extend(d, n),\n          u = [n.dur, n.drag ? 0 : n.dur],\n          f = e(\"#mCSB_\" + s.idx),\n          h = e(\"#mCSB_\" + s.idx + \"_container\"),\n          m = h.parent(),\n          p = c.callbacks.onTotalScrollOffset ? Y.call(t, c.callbacks.onTotalScrollOffset) : [0, 0],\n          g = c.callbacks.onTotalScrollBackOffset ? Y.call(t, c.callbacks.onTotalScrollBackOffset) : [0, 0];if (s.trigger = n.trigger, 0 === m.scrollTop() && 0 === m.scrollLeft() || (e(\".mCSB_\" + s.idx + \"_scrollbar\").css(\"visibility\", \"visible\"), m.scrollTop(0).scrollLeft(0)), \"_resetY\" !== o || s.contentReset.y || (i(\"onOverflowYNone\") && c.callbacks.onOverflowYNone.call(t[0]), s.contentReset.y = 1), \"_resetX\" !== o || s.contentReset.x || (i(\"onOverflowXNone\") && c.callbacks.onOverflowXNone.call(t[0]), s.contentReset.x = 1), \"_resetY\" !== o && \"_resetX\" !== o) {\n        if (!s.contentReset.y && t[0].mcs || !s.overflowed[0] || (i(\"onOverflowY\") && c.callbacks.onOverflowY.call(t[0]), s.contentReset.x = null), !s.contentReset.x && t[0].mcs || !s.overflowed[1] || (i(\"onOverflowX\") && c.callbacks.onOverflowX.call(t[0]), s.contentReset.x = null), c.snapAmount) {\n          var v = c.snapAmount instanceof Array ? \"x\" === n.dir ? c.snapAmount[1] : c.snapAmount[0] : c.snapAmount;o = V(o, v, c.snapOffset);\n        }switch (n.dir) {case \"x\":\n            var x = e(\"#mCSB_\" + s.idx + \"_dragger_horizontal\"),\n                _ = \"left\",\n                w = h[0].offsetLeft,\n                S = [f.width() - h.outerWidth(!1), x.parent().width() - x.width()],\n                b = [o, 0 === o ? 0 : o / s.scrollRatio.x],\n                y = p[1],\n                B = g[1],\n                T = y > 0 ? y / s.scrollRatio.x : 0,\n                k = B > 0 ? B / s.scrollRatio.x : 0;break;case \"y\":\n            var x = e(\"#mCSB_\" + s.idx + \"_dragger_vertical\"),\n                _ = \"top\",\n                w = h[0].offsetTop,\n                S = [f.height() - h.outerHeight(!1), x.parent().height() - x.height()],\n                b = [o, 0 === o ? 0 : o / s.scrollRatio.y],\n                y = p[0],\n                B = g[0],\n                T = y > 0 ? y / s.scrollRatio.y : 0,\n                k = B > 0 ? B / s.scrollRatio.y : 0;}b[1] < 0 || 0 === b[0] && 0 === b[1] ? b = [0, 0] : b[1] >= S[1] ? b = [S[0], S[1]] : b[0] = -b[0], t[0].mcs || (l(), i(\"onInit\") && c.callbacks.onInit.call(t[0])), clearTimeout(h[0].onCompleteTimeout), J(x[0], _, Math.round(b[1]), u[1], n.scrollEasing), !s.tweenRunning && (0 === w && b[0] >= 0 || w === S[0] && b[0] <= S[0]) || J(h[0], _, Math.round(b[0]), u[0], n.scrollEasing, n.overwrite, { onStart: function onStart() {\n            n.callbacks && n.onStart && !s.tweenRunning && (i(\"onScrollStart\") && (l(), c.callbacks.onScrollStart.call(t[0])), s.tweenRunning = !0, C(x), s.cbOffsets = r());\n          }, onUpdate: function onUpdate() {\n            n.callbacks && n.onUpdate && i(\"whileScrolling\") && (l(), c.callbacks.whileScrolling.call(t[0]));\n          }, onComplete: function onComplete() {\n            if (n.callbacks && n.onComplete) {\n              \"yx\" === c.axis && clearTimeout(h[0].onCompleteTimeout);var e = h[0].idleTimer || 0;h[0].onCompleteTimeout = setTimeout(function () {\n                i(\"onScroll\") && (l(), c.callbacks.onScroll.call(t[0])), i(\"onTotalScroll\") && b[1] >= S[1] - T && s.cbOffsets[0] && (l(), c.callbacks.onTotalScroll.call(t[0])), i(\"onTotalScrollBack\") && b[1] <= k && s.cbOffsets[1] && (l(), c.callbacks.onTotalScrollBack.call(t[0])), s.tweenRunning = !1, h[0].idleTimer = 0, C(x, \"hide\");\n              }, e);\n            }\n          } });\n      }\n    },\n        J = function J(e, t, o, a, n, i, r) {\n      function l() {\n        S.stop || (x || m.call(), x = K() - v, s(), x >= S.time && (S.time = x > S.time ? x + f - (x - S.time) : x + f - 1, S.time < x + 1 && (S.time = x + 1)), S.time < a ? S.id = h(l) : g.call());\n      }function s() {\n        a > 0 ? (S.currVal = u(S.time, _, b, a, n), w[t] = Math.round(S.currVal) + \"px\") : w[t] = o + \"px\", p.call();\n      }function c() {\n        f = 1e3 / 60, S.time = x + f, h = window.requestAnimationFrame ? window.requestAnimationFrame : function (e) {\n          return s(), setTimeout(e, .01);\n        }, S.id = h(l);\n      }function d() {\n        null != S.id && (window.requestAnimationFrame ? window.cancelAnimationFrame(S.id) : clearTimeout(S.id), S.id = null);\n      }function u(e, t, o, a, n) {\n        switch (n) {case \"linear\":case \"mcsLinear\":\n            return o * e / a + t;case \"mcsLinearOut\":\n            return e /= a, e--, o * Math.sqrt(1 - e * e) + t;case \"easeInOutSmooth\":\n            return e /= a / 2, 1 > e ? o / 2 * e * e + t : (e--, -o / 2 * (e * (e - 2) - 1) + t);case \"easeInOutStrong\":\n            return e /= a / 2, 1 > e ? o / 2 * Math.pow(2, 10 * (e - 1)) + t : (e--, o / 2 * (-Math.pow(2, -10 * e) + 2) + t);case \"easeInOut\":case \"mcsEaseInOut\":\n            return e /= a / 2, 1 > e ? o / 2 * e * e * e + t : (e -= 2, o / 2 * (e * e * e + 2) + t);case \"easeOutSmooth\":\n            return e /= a, e--, -o * (e * e * e * e - 1) + t;case \"easeOutStrong\":\n            return o * (-Math.pow(2, -10 * e / a) + 1) + t;case \"easeOut\":case \"mcsEaseOut\":default:\n            var i = (e /= a) * e,\n                r = i * e;return t + o * (.499999999999997 * r * i + -2.5 * i * i + 5.5 * r + -6.5 * i + 4 * e);}\n      }e._mTween || (e._mTween = { top: {}, left: {} });var f,\n          h,\n          r = r || {},\n          m = r.onStart || function () {},\n          p = r.onUpdate || function () {},\n          g = r.onComplete || function () {},\n          v = K(),\n          x = 0,\n          _ = e.offsetTop,\n          w = e.style,\n          S = e._mTween[t];\"left\" === t && (_ = e.offsetLeft);var b = o - _;S.stop = 0, \"none\" !== i && d(), c();\n    },\n        K = function K() {\n      return window.performance && window.performance.now ? window.performance.now() : window.performance && window.performance.webkitNow ? window.performance.webkitNow() : Date.now ? Date.now() : new Date().getTime();\n    },\n        Z = function Z() {\n      var e = this;e._mTween || (e._mTween = { top: {}, left: {} });for (var t = [\"top\", \"left\"], o = 0; o < t.length; o++) {\n        var a = t[o];e._mTween[a].id && (window.requestAnimationFrame ? window.cancelAnimationFrame(e._mTween[a].id) : clearTimeout(e._mTween[a].id), e._mTween[a].id = null, e._mTween[a].stop = 1);\n      }\n    },\n        $ = function $(e, t) {\n      try {\n        delete e[t];\n      } catch (o) {\n        e[t] = null;\n      }\n    },\n        ee = function ee(e) {\n      return !(e.which && 1 !== e.which);\n    },\n        te = function te(e) {\n      var t = e.originalEvent.pointerType;return !(t && \"touch\" !== t && 2 !== t);\n    },\n        oe = function oe(e) {\n      return !isNaN(parseFloat(e)) && isFinite(e);\n    },\n        ae = function ae(e) {\n      var t = e.parents(\".mCSB_container\");return [e.offset().top - t.offset().top, e.offset().left - t.offset().left];\n    },\n        ne = function ne() {\n      function e() {\n        var e = [\"webkit\", \"moz\", \"ms\", \"o\"];if (\"hidden\" in document) return \"hidden\";for (var t = 0; t < e.length; t++) {\n          if (e[t] + \"Hidden\" in document) return e[t] + \"Hidden\";\n        }return null;\n      }var t = e();return t ? document[t] : !1;\n    };e.fn[o] = function (t) {\n      return u[t] ? u[t].apply(this, Array.prototype.slice.call(arguments, 1)) : \"object\" != (typeof t === \"undefined\" ? \"undefined\" : _typeof(t)) && t ? void e.error(\"Method \" + t + \" does not exist\") : u.init.apply(this, arguments);\n    }, e[o] = function (t) {\n      return u[t] ? u[t].apply(this, Array.prototype.slice.call(arguments, 1)) : \"object\" != (typeof t === \"undefined\" ? \"undefined\" : _typeof(t)) && t ? void e.error(\"Method \" + t + \" does not exist\") : u.init.apply(this, arguments);\n    }, e[o].defaults = i, window[o] = !0, e(window).bind(\"load\", function () {\n      e(n)[o](), e.extend(e.expr[\":\"], { mcsInView: e.expr[\":\"].mcsInView || function (t) {\n          var o,\n              a,\n              n = e(t),\n              i = n.parents(\".mCSB_container\");if (i.length) return o = i.parent(), a = [i[0].offsetTop, i[0].offsetLeft], a[0] + ae(n)[0] >= 0 && a[0] + ae(n)[0] < o.height() - n.outerHeight(!1) && a[1] + ae(n)[1] >= 0 && a[1] + ae(n)[1] < o.width() - n.outerWidth(!1);\n        }, mcsInSight: e.expr[\":\"].mcsInSight || function (t, o, a) {\n          var n,\n              i,\n              r,\n              l,\n              s = e(t),\n              c = s.parents(\".mCSB_container\"),\n              d = \"exact\" === a[3] ? [[1, 0], [1, 0]] : [[.9, .1], [.6, .4]];if (c.length) return n = [s.outerHeight(!1), s.outerWidth(!1)], r = [c[0].offsetTop + ae(s)[0], c[0].offsetLeft + ae(s)[1]], i = [c.parent()[0].offsetHeight, c.parent()[0].offsetWidth], l = [n[0] < i[0] ? d[0] : d[1], n[1] < i[1] ? d[0] : d[1]], r[0] - i[0] * l[0][0] < 0 && r[0] + n[0] - i[0] * l[0][1] >= 0 && r[1] - i[1] * l[1][0] < 0 && r[1] + n[1] - i[1] * l[1][1] >= 0;\n        }, mcsOverflow: e.expr[\":\"].mcsOverflow || function (t) {\n          var o = e(t).data(a);if (o) return o.overflowed[0] || o.overflowed[1];\n        } });\n    });\n  });\n});"

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	module.exports = "!function(e){if(!e.hasInitialised){var t={escapeRegExp:function(e){return e.replace(/[\\-\\[\\]\\/\\{\\}\\(\\)\\*\\+\\?\\.\\\\\\^\\$\\|]/g,\"\\\\$&\")},hasClass:function(e,t){var i=\" \";return 1===e.nodeType&&(i+e.className+i).replace(/[\\n\\t]/g,i).indexOf(i+t+i)>=0},addClass:function(e,t){e.className+=\" \"+t},removeClass:function(e,t){var i=new RegExp(\"\\\\b\"+this.escapeRegExp(t)+\"\\\\b\");e.className=e.className.replace(i,\"\")},interpolateString:function(e,t){return e.replace(/{{([a-z][a-z0-9\\-_]*)}}/gi,function(e){return t(arguments[1])||\"\"})},getCookie:function(e){var t=(\"; \"+document.cookie).split(\"; \"+e+\"=\");return t.length<2?void 0:t.pop().split(\";\").shift()},setCookie:function(e,t,i,n,o,s){var r=new Date;r.setHours(r.getHours()+24*(i||365));var a=[e+\"=\"+t,\"expires=\"+r.toUTCString(),\"path=\"+(o||\"/\")];n&&a.push(\"domain=\"+n),s&&a.push(\"secure\"),document.cookie=a.join(\";\")},deepExtend:function(e,t){for(var i in t)t.hasOwnProperty(i)&&(i in e&&this.isPlainObject(e[i])&&this.isPlainObject(t[i])?this.deepExtend(e[i],t[i]):e[i]=t[i]);return e},throttle:function(e,t){var i=!1;return function(){i||(e.apply(this,arguments),i=!0,setTimeout(function(){i=!1},t))}},hash:function(e){var t,i,n=0;if(0===e.length)return n;for(t=0,i=e.length;t<i;++t)n=(n<<5)-n+e.charCodeAt(t),n|=0;return n},normaliseHex:function(e){return\"#\"==e[0]&&(e=e.substr(1)),3==e.length&&(e=e[0]+e[0]+e[1]+e[1]+e[2]+e[2]),e},getContrast:function(e){return e=this.normaliseHex(e),(299*parseInt(e.substr(0,2),16)+587*parseInt(e.substr(2,2),16)+114*parseInt(e.substr(4,2),16))/1e3>=128?\"#000\":\"#fff\"},getLuminance:function(e){var t=parseInt(this.normaliseHex(e),16),i=38+(t>>16),n=38+(t>>8&255),o=38+(255&t);return\"#\"+(16777216+65536*(i<255?i<1?0:i:255)+256*(n<255?n<1?0:n:255)+(o<255?o<1?0:o:255)).toString(16).slice(1)},isMobile:function(){return/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)},isPlainObject:function(e){return\"object\"==typeof e&&null!==e&&e.constructor==Object},traverseDOMPath:function(e,i){return e&&e.parentNode?t.hasClass(e,i)?e:this.traverseDOMPath(e.parentNode,i):null}};e.status={deny:\"deny\",allow:\"allow\",dismiss:\"dismiss\"},e.transitionEnd=function(){var e=document.createElement(\"div\"),t={t:\"transitionend\",OT:\"oTransitionEnd\",msT:\"MSTransitionEnd\",MozT:\"transitionend\",WebkitT:\"webkitTransitionEnd\"};for(var i in t)if(t.hasOwnProperty(i)&&void 0!==e.style[i+\"ransition\"])return t[i];return\"\"}(),e.hasTransition=!!e.transitionEnd;var i=Object.keys(e.status).map(t.escapeRegExp);e.customStyles={},e.Popup=function(){var n={enabled:!0,container:null,cookie:{name:\"cookieconsent_status\",path:\"/\",domain:\"\",expiryDays:365,secure:!1},onPopupOpen:function(){},onPopupClose:function(){},onInitialise:function(e){},onStatusChange:function(e,t){},onRevokeChoice:function(){},onNoCookieLaw:function(e,t){},content:{header:\"Cookies used on the website!\",message:\"This website uses cookies to ensure you get the best experience on our website.\",dismiss:\"Got it!\",allow:\"Allow cookies\",deny:\"Decline\",link:\"Learn more\",href:\"https://www.cookiesandyou.com\",close:\"&#x274c;\",target:\"_blank\",policy:\"Cookie Policy\"},elements:{header:'<span class=\"cc-header\">{{header}}</span>&nbsp;',message:'<span id=\"cookieconsent:desc\" class=\"cc-message\">{{message}}</span>',messagelink:'<span id=\"cookieconsent:desc\" class=\"cc-message\">{{message}} <a aria-label=\"learn more about cookies\" role=button tabindex=\"0\" class=\"cc-link\" href=\"{{href}}\" rel=\"noopener noreferrer nofollow\" target=\"{{target}}\">{{link}}</a></span>',dismiss:'<a aria-label=\"dismiss cookie message\" role=button tabindex=\"0\" class=\"cc-btn cc-dismiss\">{{dismiss}}</a>',allow:'<a aria-label=\"allow cookies\" role=button tabindex=\"0\"  class=\"cc-btn cc-allow\">{{allow}}</a>',deny:'<a aria-label=\"deny cookies\" role=button tabindex=\"0\" class=\"cc-btn cc-deny\">{{deny}}</a>',link:'<a aria-label=\"learn more about cookies\" role=button tabindex=\"0\" class=\"cc-link\" href=\"{{href}}\" rel=\"noopener noreferrer nofollow\" target=\"{{target}}\">{{link}}</a>',close:'<span aria-label=\"dismiss cookie message\" role=button tabindex=\"0\" class=\"cc-close\">{{close}}</span>'},window:'<div role=\"dialog\" aria-live=\"polite\" aria-label=\"cookieconsent\" aria-describedby=\"cookieconsent:desc\" class=\"cc-window {{classes}}\">\\x3c!--googleoff: all--\\x3e{{children}}\\x3c!--googleon: all--\\x3e</div>',revokeBtn:'<div class=\"cc-revoke {{classes}}\">{{policy}}</div>',compliance:{info:'<div class=\"cc-compliance\">{{dismiss}}</div>',\"opt-in\":'<div class=\"cc-compliance cc-highlight\">{{deny}}{{allow}}</div>',\"opt-out\":'<div class=\"cc-compliance cc-highlight\">{{deny}}{{allow}}</div>'},type:\"info\",layouts:{basic:\"{{messagelink}}{{compliance}}\",\"basic-close\":\"{{messagelink}}{{compliance}}{{close}}\",\"basic-header\":\"{{header}}{{message}}{{link}}{{compliance}}\"},layout:\"basic\",position:\"bottom\",theme:\"block\",static:!1,palette:null,revokable:!1,animateRevokable:!0,showLink:!0,dismissOnScroll:!1,dismissOnTimeout:!1,dismissOnWindowClick:!1,ignoreClicksFrom:[\"cc-revoke\",\"cc-btn\"],autoOpen:!0,autoAttach:!0,whitelistPage:[],blacklistPage:[],overrideHTML:null};function o(){this.initialise.apply(this,arguments)}function s(e){this.openingTimeout=null,t.removeClass(e,\"cc-invisible\")}function r(t){t.style.display=\"none\",t.removeEventListener(e.transitionEnd,this.afterTransition),this.afterTransition=null}function a(){var e=this.options.position.split(\"-\"),t=[];return e.forEach(function(e){t.push(\"cc-\"+e)}),t}function c(n){var o=this.options,s=document.createElement(\"div\"),r=o.container&&1===o.container.nodeType?o.container:document.body;s.innerHTML=n;var a=s.children[0];return a.style.display=\"none\",t.hasClass(a,\"cc-window\")&&e.hasTransition&&t.addClass(a,\"cc-invisible\"),this.onButtonClick=function(n){var o=t.traverseDOMPath(n.target,\"cc-btn\")||n.target;if(t.hasClass(o,\"cc-btn\")){var s=o.className.match(new RegExp(\"\\\\bcc-(\"+i.join(\"|\")+\")\\\\b\")),r=s&&s[1]||!1;r&&(this.setStatus(r),this.close(!0))}t.hasClass(o,\"cc-close\")&&(this.setStatus(e.status.dismiss),this.close(!0));t.hasClass(o,\"cc-revoke\")&&this.revokeChoice()}.bind(this),a.addEventListener(\"click\",this.onButtonClick),o.autoAttach&&(r.firstChild?r.insertBefore(a,r.firstChild):r.appendChild(a)),a}function l(e){return\"000000\"==(e=t.normaliseHex(e))?\"#222\":t.getLuminance(e)}function u(e,t){for(var i=0,n=e.length;i<n;++i){var o=e[i];if(o instanceof RegExp&&o.test(t)||\"string\"==typeof o&&o.length&&o===t)return!0}return!1}return o.prototype.initialise=function(i){this.options&&this.destroy(),t.deepExtend(this.options={},n),t.isPlainObject(i)&&t.deepExtend(this.options,i),function(){var t=this.options.onInitialise.bind(this);if(!window.navigator.cookieEnabled)return t(e.status.deny),!0;if(window.CookiesOK||window.navigator.CookiesOK)return t(e.status.allow),!0;var i=Object.keys(e.status),n=this.getStatus(),o=i.indexOf(n)>=0;o&&t(n);return o}.call(this)&&(this.options.enabled=!1),u(this.options.blacklistPage,location.pathname)&&(this.options.enabled=!1),u(this.options.whitelistPage,location.pathname)&&(this.options.enabled=!0);var o=this.options.window.replace(\"{{classes}}\",function(){var i=this.options,n=\"top\"==i.position||\"bottom\"==i.position?\"banner\":\"floating\";t.isMobile()&&(n=\"floating\");var o=[\"cc-\"+n,\"cc-type-\"+i.type,\"cc-theme-\"+i.theme];i.static&&o.push(\"cc-static\");o.push.apply(o,a.call(this));(function(i){var n=t.hash(JSON.stringify(i)),o=\"cc-color-override-\"+n,s=t.isPlainObject(i);this.customStyleSelector=s?o:null,s&&function(i,n,o){if(e.customStyles[i])return void++e.customStyles[i].references;var s={},r=n.popup,a=n.button,c=n.highlight;r&&(r.text=r.text?r.text:t.getContrast(r.background),r.link=r.link?r.link:r.text,s[o+\".cc-window\"]=[\"color: \"+r.text,\"background-color: \"+r.background],s[o+\".cc-revoke\"]=[\"color: \"+r.text,\"background-color: \"+r.background],s[o+\" .cc-link,\"+o+\" .cc-link:active,\"+o+\" .cc-link:visited\"]=[\"color: \"+r.link],a&&(a.text=a.text?a.text:t.getContrast(a.background),a.border=a.border?a.border:\"transparent\",s[o+\" .cc-btn\"]=[\"color: \"+a.text,\"border-color: \"+a.border,\"background-color: \"+a.background],a.padding&&s[o+\" .cc-btn\"].push(\"padding: \"+a.padding),\"transparent\"!=a.background&&(s[o+\" .cc-btn:hover, \"+o+\" .cc-btn:focus\"]=[\"background-color: \"+(a.hover||l(a.background))]),c?(c.text=c.text?c.text:t.getContrast(c.background),c.border=c.border?c.border:\"transparent\",s[o+\" .cc-highlight .cc-btn:first-child\"]=[\"color: \"+c.text,\"border-color: \"+c.border,\"background-color: \"+c.background]):s[o+\" .cc-highlight .cc-btn:first-child\"]=[\"color: \"+r.text]));var u=document.createElement(\"style\");document.head.appendChild(u),e.customStyles[i]={references:1,element:u.sheet};var h=-1;for(var p in s)s.hasOwnProperty(p)&&u.sheet.insertRule(p+\"{\"+s[p].join(\";\")+\"}\",++h)}(n,i,\".\"+o);return s}).call(this,this.options.palette);this.customStyleSelector&&o.push(this.customStyleSelector);return o}.call(this).join(\" \")).replace(\"{{children}}\",function(){var e={},i=this.options;i.showLink||(i.elements.link=\"\",i.elements.messagelink=i.elements.message);Object.keys(i.elements).forEach(function(n){e[n]=t.interpolateString(i.elements[n],function(e){var t=i.content[e];return e&&\"string\"==typeof t&&t.length?t:\"\"})});var n=i.compliance[i.type];n||(n=i.compliance.info);e.compliance=t.interpolateString(n,function(t){return e[t]});var o=i.layouts[i.layout];o||(o=i.layouts.basic);return t.interpolateString(o,function(t){return e[t]})}.call(this)),s=this.options.overrideHTML;if(\"string\"==typeof s&&s.length&&(o=s),this.options.static){var r=c.call(this,'<div class=\"cc-grower\">'+o+\"</div>\");r.style.display=\"\",this.element=r.firstChild,this.element.style.display=\"none\",t.addClass(this.element,\"cc-invisible\")}else this.element=c.call(this,o);(function(){var i=this.setStatus.bind(this),n=this.close.bind(this),o=this.options.dismissOnTimeout;\"number\"==typeof o&&o>=0&&(this.dismissTimeout=window.setTimeout(function(){i(e.status.dismiss),n(!0)},Math.floor(o)));var s=this.options.dismissOnScroll;if(\"number\"==typeof s&&s>=0){var r=function(t){window.pageYOffset>Math.floor(s)&&(i(e.status.dismiss),n(!0),window.removeEventListener(\"scroll\",r),this.onWindowScroll=null)};this.options.enabled&&(this.onWindowScroll=r,window.addEventListener(\"scroll\",r))}var a=this.options.dismissOnWindowClick,c=this.options.ignoreClicksFrom;if(a){var l=function(o){for(var s=!1,r=o.path.length,a=c.length,u=0;u<r;u++)if(!s)for(var h=0;h<a;h++)s||(s=t.hasClass(o.path[u],c[h]));s||(i(e.status.dismiss),n(!0),window.removeEventListener(\"click\",l),window.removeEventListener(\"touchend\",l),this.onWindowClick=null)}.bind(this);this.options.enabled&&(this.onWindowClick=l,window.addEventListener(\"click\",l),window.addEventListener(\"touchend\",l))}}).call(this),function(){\"info\"!=this.options.type&&(this.options.revokable=!0);t.isMobile()&&(this.options.animateRevokable=!1);if(this.options.revokable){var e=a.call(this);this.options.animateRevokable&&e.push(\"cc-animate\"),this.customStyleSelector&&e.push(this.customStyleSelector);var i=this.options.revokeBtn.replace(\"{{classes}}\",e.join(\" \")).replace(\"{{policy}}\",this.options.content.policy);this.revokeBtn=c.call(this,i);var n=this.revokeBtn;if(this.options.animateRevokable){var o=t.throttle(function(e){var i=!1,o=window.innerHeight-20;t.hasClass(n,\"cc-top\")&&e.clientY<20&&(i=!0),t.hasClass(n,\"cc-bottom\")&&e.clientY>o&&(i=!0),i?t.hasClass(n,\"cc-active\")||t.addClass(n,\"cc-active\"):t.hasClass(n,\"cc-active\")&&t.removeClass(n,\"cc-active\")},200);this.onMouseMove=o,window.addEventListener(\"mousemove\",o)}}}.call(this),this.options.autoOpen&&this.autoOpen()},o.prototype.destroy=function(){this.onButtonClick&&this.element&&(this.element.removeEventListener(\"click\",this.onButtonClick),this.onButtonClick=null),this.dismissTimeout&&(clearTimeout(this.dismissTimeout),this.dismissTimeout=null),this.onWindowScroll&&(window.removeEventListener(\"scroll\",this.onWindowScroll),this.onWindowScroll=null),this.onWindowClick&&(window.removeEventListener(\"click\",this.onWindowClick),this.onWindowClick=null),this.onMouseMove&&(window.removeEventListener(\"mousemove\",this.onMouseMove),this.onMouseMove=null),this.element&&this.element.parentNode&&this.element.parentNode.removeChild(this.element),this.element=null,this.revokeBtn&&this.revokeBtn.parentNode&&this.revokeBtn.parentNode.removeChild(this.revokeBtn),this.revokeBtn=null,function(i){if(t.isPlainObject(i)){var n=t.hash(JSON.stringify(i)),o=e.customStyles[n];if(o&&!--o.references){var s=o.element.ownerNode;s&&s.parentNode&&s.parentNode.removeChild(s),e.customStyles[n]=null}}}(this.options.palette),this.options=null},o.prototype.open=function(t){if(this.element)return this.isOpen()||(e.hasTransition?this.fadeIn():this.element.style.display=\"\",this.options.revokable&&this.toggleRevokeButton(),this.options.onPopupOpen.call(this)),this},o.prototype.close=function(t){if(this.element)return this.isOpen()&&(e.hasTransition?this.fadeOut():this.element.style.display=\"none\",t&&this.options.revokable&&this.toggleRevokeButton(!0),this.options.onPopupClose.call(this)),this},o.prototype.fadeIn=function(){var i=this.element;if(e.hasTransition&&i&&(this.afterTransition&&r.call(this,i),t.hasClass(i,\"cc-invisible\"))){if(i.style.display=\"\",this.options.static){var n=this.element.clientHeight;this.element.parentNode.style.maxHeight=n+\"px\"}this.openingTimeout=setTimeout(s.bind(this,i),20)}},o.prototype.fadeOut=function(){var i=this.element;e.hasTransition&&i&&(this.openingTimeout&&(clearTimeout(this.openingTimeout),s.bind(this,i)),t.hasClass(i,\"cc-invisible\")||(this.options.static&&(this.element.parentNode.style.maxHeight=\"\"),this.afterTransition=r.bind(this,i),i.addEventListener(e.transitionEnd,this.afterTransition),t.addClass(i,\"cc-invisible\")))},o.prototype.isOpen=function(){return this.element&&\"\"==this.element.style.display&&(!e.hasTransition||!t.hasClass(this.element,\"cc-invisible\"))},o.prototype.toggleRevokeButton=function(e){this.revokeBtn&&(this.revokeBtn.style.display=e?\"\":\"none\")},o.prototype.revokeChoice=function(e){this.options.enabled=!0,this.clearStatus(),this.options.onRevokeChoice.call(this),e||this.autoOpen()},o.prototype.hasAnswered=function(t){return Object.keys(e.status).indexOf(this.getStatus())>=0},o.prototype.hasConsented=function(t){var i=this.getStatus();return i==e.status.allow||i==e.status.dismiss},o.prototype.autoOpen=function(e){!this.hasAnswered()&&this.options.enabled?this.open():this.hasAnswered()&&this.options.revokable&&this.toggleRevokeButton(!0)},o.prototype.setStatus=function(i){var n=this.options.cookie,o=t.getCookie(n.name),s=Object.keys(e.status).indexOf(o)>=0;Object.keys(e.status).indexOf(i)>=0?(t.setCookie(n.name,i,n.expiryDays,n.domain,n.path,n.secure),this.options.onStatusChange.call(this,i,s)):this.clearStatus()},o.prototype.getStatus=function(){return t.getCookie(this.options.cookie.name)},o.prototype.clearStatus=function(){var e=this.options.cookie;t.setCookie(e.name,\"\",-1,e.domain,e.path)},o}(),e.Location=function(){var e={timeout:5e3,services:[\"ipinfo\"],serviceDefinitions:{ipinfo:function(){return{url:\"//ipinfo.io\",headers:[\"Accept: application/json\"],callback:function(e,t){try{var i=JSON.parse(t);return i.error?s(i):{code:i.country}}catch(e){return s({error:\"Invalid response (\"+e+\")\"})}}}},ipinfodb:function(e){return{url:\"//api.ipinfodb.com/v3/ip-country/?key={api_key}&format=json&callback={callback}\",isScript:!0,callback:function(e,t){try{var i=JSON.parse(t);return\"ERROR\"==i.statusCode?s({error:i.statusMessage}):{code:i.countryCode}}catch(e){return s({error:\"Invalid response (\"+e+\")\"})}}}},maxmind:function(){return{url:\"//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js\",isScript:!0,callback:function(e){window.geoip2?geoip2.country(function(t){try{e({code:t.country.iso_code})}catch(t){e(s(t))}},function(t){e(s(t))}):e(new Error(\"Unexpected response format. The downloaded script should have exported `geoip2` to the global scope\"))}}}}};function i(i){t.deepExtend(this.options={},e),t.isPlainObject(i)&&t.deepExtend(this.options,i),this.currentServiceIndex=-1}function n(e,t,i){var n,o=document.createElement(\"script\");o.type=\"text/\"+(e.type||\"javascript\"),o.src=e.src||e,o.async=!1,o.onreadystatechange=o.onload=function(){var e=o.readyState;clearTimeout(n),t.done||e&&!/loaded|complete/.test(e)||(t.done=!0,t(),o.onreadystatechange=o.onload=null)},document.body.appendChild(o),n=setTimeout(function(){t.done=!0,t(),o.onreadystatechange=o.onload=null},i)}function o(e,t,i,n,o){var s=new(window.XMLHttpRequest||window.ActiveXObject)(\"MSXML2.XMLHTTP.3.0\");if(s.open(n?\"POST\":\"GET\",e,1),s.setRequestHeader(\"Content-type\",\"application/x-www-form-urlencoded\"),Array.isArray(o))for(var r=0,a=o.length;r<a;++r){var c=o[r].split(\":\",2);s.setRequestHeader(c[0].replace(/^\\s+|\\s+$/g,\"\"),c[1].replace(/^\\s+|\\s+$/g,\"\"))}\"function\"==typeof t&&(s.onreadystatechange=function(){s.readyState>3&&t(s)}),s.send(n)}function s(e){return new Error(\"Error [\"+(e.code||\"UNKNOWN\")+\"]: \"+e.error)}return i.prototype.getNextService=function(){var e;do{e=this.getServiceByIdx(++this.currentServiceIndex)}while(this.currentServiceIndex<this.options.services.length&&!e);return e},i.prototype.getServiceByIdx=function(e){var i=this.options.services[e];if(\"function\"==typeof i){var n=i();return n.name&&t.deepExtend(n,this.options.serviceDefinitions[n.name](n)),n}return\"string\"==typeof i?this.options.serviceDefinitions[i]():t.isPlainObject(i)?this.options.serviceDefinitions[i.name](i):null},i.prototype.locate=function(e,t){var i=this.getNextService();i?(this.callbackComplete=e,this.callbackError=t,this.runService(i,this.runNextServiceOnError.bind(this))):t(new Error(\"No services to run\"))},i.prototype.setupUrl=function(e){var t=this.getCurrentServiceOpts();return e.url.replace(/\\{(.*?)\\}/g,function(i,n){if(\"callback\"===n){var o=\"callback\"+Date.now();return window[o]=function(t){e.__JSONP_DATA=JSON.stringify(t)},o}if(n in t.interpolateUrl)return t.interpolateUrl[n]})},i.prototype.runService=function(e,t){var i=this;e&&e.url&&e.callback&&(e.isScript?n:o)(this.setupUrl(e),function(n){var o=n?n.responseText:\"\";e.__JSONP_DATA&&(o=e.__JSONP_DATA,delete e.__JSONP_DATA),i.runServiceCallback.call(i,t,e,o)},this.options.timeout,e.data,e.headers)},i.prototype.runServiceCallback=function(e,t,i){var n=this,o=t.callback(function(t){o||n.onServiceResult.call(n,e,t)},i);o&&this.onServiceResult.call(this,e,o)},i.prototype.onServiceResult=function(e,t){t instanceof Error||t&&t.error?e.call(this,t,null):e.call(this,null,t)},i.prototype.runNextServiceOnError=function(e,t){if(e){this.logError(e);var i=this.getNextService();i?this.runService(i,this.runNextServiceOnError.bind(this)):this.completeService.call(this,this.callbackError,new Error(\"All services failed\"))}else this.completeService.call(this,this.callbackComplete,t)},i.prototype.getCurrentServiceOpts=function(){var e=this.options.services[this.currentServiceIndex];return\"string\"==typeof e?{name:e}:\"function\"==typeof e?e():t.isPlainObject(e)?e:{}},i.prototype.completeService=function(e,t){this.currentServiceIndex=-1,e&&e(t)},i.prototype.logError=function(e){var t=this.currentServiceIndex,i=this.getServiceByIdx(t);console.warn(\"The service[\"+t+\"] (\"+i.url+\") responded with the following error\",e)},i}(),e.Law=function(){var e={regionalLaw:!0,hasLaw:[\"AT\",\"BE\",\"BG\",\"HR\",\"CZ\",\"CY\",\"DK\",\"EE\",\"FI\",\"FR\",\"DE\",\"EL\",\"HU\",\"IE\",\"IT\",\"LV\",\"LT\",\"LU\",\"MT\",\"NL\",\"PL\",\"PT\",\"SK\",\"ES\",\"SE\",\"GB\",\"UK\",\"GR\",\"EU\"],revokable:[\"HR\",\"CY\",\"DK\",\"EE\",\"FR\",\"DE\",\"LV\",\"LT\",\"NL\",\"PT\",\"ES\"],explicitAction:[\"HR\",\"IT\",\"ES\"]};function i(e){this.initialise.apply(this,arguments)}return i.prototype.initialise=function(i){t.deepExtend(this.options={},e),t.isPlainObject(i)&&t.deepExtend(this.options,i)},i.prototype.get=function(e){var t=this.options;return{hasLaw:t.hasLaw.indexOf(e)>=0,revokable:t.revokable.indexOf(e)>=0,explicitAction:t.explicitAction.indexOf(e)>=0}},i.prototype.applyLaw=function(e,t){var i=this.get(t);return i.hasLaw||(e.enabled=!1,\"function\"==typeof e.onNoCookieLaw&&e.onNoCookieLaw(t,i)),this.options.regionalLaw&&(i.revokable&&(e.revokable=!0),i.explicitAction&&(e.dismissOnScroll=!1,e.dismissOnTimeout=!1)),e},i}(),e.initialise=function(i,n,o){var s=new e.Law(i.law);n||(n=function(){}),o||(o=function(){});var r=Object.keys(e.status),a=t.getCookie(\"cookieconsent_status\");r.indexOf(a)>=0?n(new e.Popup(i)):e.getCountryCode(i,function(t){delete i.law,delete i.location,t.code&&(i=s.applyLaw(i,t.code)),n(new e.Popup(i))},function(t){delete i.law,delete i.location,o(t,new e.Popup(i))})},e.getCountryCode=function(t,i,n){t.law&&t.law.countryCode?i({code:t.law.countryCode}):t.location?new e.Location(t.location).locate(function(e){i(e||{})},n):i({})},e.utils=t,e.hasInitialised=!0,window.cookieconsent=e}}(window.cookieconsent||{});"

/***/ }),
/* 859 */
/***/ (function(module, exports) {

	module.exports = "/*!\n * Quill Editor v1.3.7\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */\n!function(t,e){\"object\"==typeof exports&&\"object\"==typeof module?module.exports=e():\"function\"==typeof define&&define.amd?define([],e):\"object\"==typeof exports?exports.Quill=e():t.Quill=e()}(\"undefined\"!=typeof self?self:this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,\"a\",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p=\"\",e(e.s=45)}([function(t,e,n){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0});var r=n(17),o=n(18),i=n(19),l=n(48),a=n(49),s=n(50),u=n(51),c=n(52),f=n(11),h=n(29),p=n(30),d=n(28),y=n(1),v={Scope:y.Scope,create:y.create,find:y.find,query:y.query,register:y.register,Container:r.default,Format:o.default,Leaf:i.default,Embed:u.default,Scroll:l.default,Block:s.default,Inline:a.default,Text:c.default,Attributor:{Attribute:f.default,Class:h.default,Style:p.default,Store:d.default}};e.default=v},function(t,e,n){\"use strict\";function r(t,e){var n=i(t);if(null==n)throw new s(\"Unable to create \"+t+\" blot\");var r=n;return new r(t instanceof Node||t.nodeType===Node.TEXT_NODE?t:r.create(e),e)}function o(t,n){return void 0===n&&(n=!1),null==t?null:null!=t[e.DATA_KEY]?t[e.DATA_KEY].blot:n?o(t.parentNode,n):null}function i(t,e){void 0===e&&(e=p.ANY);var n;if(\"string\"==typeof t)n=h[t]||u[t];else if(t instanceof Text||t.nodeType===Node.TEXT_NODE)n=h.text;else if(\"number\"==typeof t)t&p.LEVEL&p.BLOCK?n=h.block:t&p.LEVEL&p.INLINE&&(n=h.inline);else if(t instanceof HTMLElement){var r=(t.getAttribute(\"class\")||\"\").split(/\\s+/);for(var o in r)if(n=c[r[o]])break;n=n||f[t.tagName]}return null==n?null:e&p.LEVEL&n.scope&&e&p.TYPE&n.scope?n:null}function l(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];if(t.length>1)return t.map(function(t){return l(t)});var n=t[0];if(\"string\"!=typeof n.blotName&&\"string\"!=typeof n.attrName)throw new s(\"Invalid definition\");if(\"abstract\"===n.blotName)throw new s(\"Cannot register abstract class\");if(h[n.blotName||n.attrName]=n,\"string\"==typeof n.keyName)u[n.keyName]=n;else if(null!=n.className&&(c[n.className]=n),null!=n.tagName){Array.isArray(n.tagName)?n.tagName=n.tagName.map(function(t){return t.toUpperCase()}):n.tagName=n.tagName.toUpperCase();var r=Array.isArray(n.tagName)?n.tagName:[n.tagName];r.forEach(function(t){null!=f[t]&&null!=n.className||(f[t]=n)})}return n}var a=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,\"__esModule\",{value:!0});var s=function(t){function e(e){var n=this;return e=\"[Parchment] \"+e,n=t.call(this,e)||this,n.message=e,n.name=n.constructor.name,n}return a(e,t),e}(Error);e.ParchmentError=s;var u={},c={},f={},h={};e.DATA_KEY=\"__blot\";var p;!function(t){t[t.TYPE=3]=\"TYPE\",t[t.LEVEL=12]=\"LEVEL\",t[t.ATTRIBUTE=13]=\"ATTRIBUTE\",t[t.BLOT=14]=\"BLOT\",t[t.INLINE=7]=\"INLINE\",t[t.BLOCK=11]=\"BLOCK\",t[t.BLOCK_BLOT=10]=\"BLOCK_BLOT\",t[t.INLINE_BLOT=6]=\"INLINE_BLOT\",t[t.BLOCK_ATTRIBUTE=9]=\"BLOCK_ATTRIBUTE\",t[t.INLINE_ATTRIBUTE=5]=\"INLINE_ATTRIBUTE\",t[t.ANY=15]=\"ANY\"}(p=e.Scope||(e.Scope={})),e.create=r,e.find=o,e.query=i,e.register=l},function(t,e){\"use strict\";var n=Object.prototype.hasOwnProperty,r=Object.prototype.toString,o=Object.defineProperty,i=Object.getOwnPropertyDescriptor,l=function(t){return\"function\"==typeof Array.isArray?Array.isArray(t):\"[object Array]\"===r.call(t)},a=function(t){if(!t||\"[object Object]\"!==r.call(t))return!1;var e=n.call(t,\"constructor\"),o=t.constructor&&t.constructor.prototype&&n.call(t.constructor.prototype,\"isPrototypeOf\");if(t.constructor&&!e&&!o)return!1;var i;for(i in t);return void 0===i||n.call(t,i)},s=function(t,e){o&&\"__proto__\"===e.name?o(t,e.name,{enumerable:!0,configurable:!0,value:e.newValue,writable:!0}):t[e.name]=e.newValue},u=function(t,e){if(\"__proto__\"===e){if(!n.call(t,e))return;if(i)return i(t,e).value}return t[e]};t.exports=function t(){var e,n,r,o,i,c,f=arguments[0],h=1,p=arguments.length,d=!1;for(\"boolean\"==typeof f&&(d=f,f=arguments[1]||{},h=2),(null==f||\"object\"!=typeof f&&\"function\"!=typeof f)&&(f={});h<p;++h)if(null!=(e=arguments[h]))for(n in e)r=u(f,n),o=u(e,n),f!==o&&(d&&o&&(a(o)||(i=l(o)))?(i?(i=!1,c=r&&l(r)?r:[]):c=r&&a(r)?r:{},s(f,{name:n,newValue:t(d,c,o)})):void 0!==o&&s(f,{name:n,newValue:o}));return f}},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function i(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function l(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function a(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return null==t?e:(\"function\"==typeof t.formats&&(e=(0,f.default)(e,t.formats())),null==t.parent||\"scroll\"==t.parent.blotName||t.parent.statics.scope!==t.statics.scope?e:a(t.parent,e))}Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=e.BlockEmbed=e.bubbleFormats=void 0;var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},c=n(2),f=r(c),h=n(4),p=r(h),d=n(0),y=r(d),v=n(14),b=r(v),g=n(5),m=r(g),_=n(8),O=r(_),w=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),s(e,[{key:\"attach\",value:function(){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"attach\",this).call(this),this.attributes=new y.default.Attributor.Store(this.domNode)}},{key:\"delta\",value:function(){return(new p.default).insert(this.value(),(0,f.default)(this.formats(),this.attributes.values()))}},{key:\"format\",value:function(t,e){var n=y.default.query(t,y.default.Scope.BLOCK_ATTRIBUTE);null!=n&&this.attributes.attribute(n,e)}},{key:\"formatAt\",value:function(t,e,n,r){this.format(n,r)}},{key:\"insertAt\",value:function(t,n,r){if(\"string\"==typeof n&&n.endsWith(\"\\n\")){var o=y.default.create(x.blotName);this.parent.insertBefore(o,0===t?this:this.next),o.insertAt(0,n.slice(0,-1))}else u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"insertAt\",this).call(this,t,n,r)}}]),e}(y.default.Embed);w.scope=y.default.Scope.BLOCK_BLOT;var x=function(t){function e(t){o(this,e);var n=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return n.cache={},n}return l(e,t),s(e,[{key:\"delta\",value:function(){return null==this.cache.delta&&(this.cache.delta=this.descendants(y.default.Leaf).reduce(function(t,e){return 0===e.length()?t:t.insert(e.value(),a(e))},new p.default).insert(\"\\n\",a(this))),this.cache.delta}},{key:\"deleteAt\",value:function(t,n){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"deleteAt\",this).call(this,t,n),this.cache={}}},{key:\"formatAt\",value:function(t,n,r,o){n<=0||(y.default.query(r,y.default.Scope.BLOCK)?t+n===this.length()&&this.format(r,o):u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"formatAt\",this).call(this,t,Math.min(n,this.length()-t-1),r,o),this.cache={})}},{key:\"insertAt\",value:function(t,n,r){if(null!=r)return u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"insertAt\",this).call(this,t,n,r);if(0!==n.length){var o=n.split(\"\\n\"),i=o.shift();i.length>0&&(t<this.length()-1||null==this.children.tail?u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"insertAt\",this).call(this,Math.min(t,this.length()-1),i):this.children.tail.insertAt(this.children.tail.length(),i),this.cache={});var l=this;o.reduce(function(t,e){return l=l.split(t,!0),l.insertAt(0,e),e.length},t+i.length)}}},{key:\"insertBefore\",value:function(t,n){var r=this.children.head;u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"insertBefore\",this).call(this,t,n),r instanceof b.default&&r.remove(),this.cache={}}},{key:\"length\",value:function(){return null==this.cache.length&&(this.cache.length=u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"length\",this).call(this)+1),this.cache.length}},{key:\"moveChildren\",value:function(t,n){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"moveChildren\",this).call(this,t,n),this.cache={}}},{key:\"optimize\",value:function(t){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"optimize\",this).call(this,t),this.cache={}}},{key:\"path\",value:function(t){return u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"path\",this).call(this,t,!0)}},{key:\"removeChild\",value:function(t){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"removeChild\",this).call(this,t),this.cache={}}},{key:\"split\",value:function(t){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(n&&(0===t||t>=this.length()-1)){var r=this.clone();return 0===t?(this.parent.insertBefore(r,this),this):(this.parent.insertBefore(r,this.next),r)}var o=u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"split\",this).call(this,t,n);return this.cache={},o}}]),e}(y.default.Block);x.blotName=\"block\",x.tagName=\"P\",x.defaultChild=\"break\",x.allowedChildren=[m.default,y.default.Embed,O.default],e.bubbleFormats=a,e.BlockEmbed=w,e.default=x},function(t,e,n){var r=n(54),o=n(12),i=n(2),l=n(20),a=String.fromCharCode(0),s=function(t){Array.isArray(t)?this.ops=t:null!=t&&Array.isArray(t.ops)?this.ops=t.ops:this.ops=[]};s.prototype.insert=function(t,e){var n={};return 0===t.length?this:(n.insert=t,null!=e&&\"object\"==typeof e&&Object.keys(e).length>0&&(n.attributes=e),this.push(n))},s.prototype.delete=function(t){return t<=0?this:this.push({delete:t})},s.prototype.retain=function(t,e){if(t<=0)return this;var n={retain:t};return null!=e&&\"object\"==typeof e&&Object.keys(e).length>0&&(n.attributes=e),this.push(n)},s.prototype.push=function(t){var e=this.ops.length,n=this.ops[e-1];if(t=i(!0,{},t),\"object\"==typeof n){if(\"number\"==typeof t.delete&&\"number\"==typeof n.delete)return this.ops[e-1]={delete:n.delete+t.delete},this;if(\"number\"==typeof n.delete&&null!=t.insert&&(e-=1,\"object\"!=typeof(n=this.ops[e-1])))return this.ops.unshift(t),this;if(o(t.attributes,n.attributes)){if(\"string\"==typeof t.insert&&\"string\"==typeof n.insert)return this.ops[e-1]={insert:n.insert+t.insert},\"object\"==typeof t.attributes&&(this.ops[e-1].attributes=t.attributes),this;if(\"number\"==typeof t.retain&&\"number\"==typeof n.retain)return this.ops[e-1]={retain:n.retain+t.retain},\"object\"==typeof t.attributes&&(this.ops[e-1].attributes=t.attributes),this}}return e===this.ops.length?this.ops.push(t):this.ops.splice(e,0,t),this},s.prototype.chop=function(){var t=this.ops[this.ops.length-1];return t&&t.retain&&!t.attributes&&this.ops.pop(),this},s.prototype.filter=function(t){return this.ops.filter(t)},s.prototype.forEach=function(t){this.ops.forEach(t)},s.prototype.map=function(t){return this.ops.map(t)},s.prototype.partition=function(t){var e=[],n=[];return this.forEach(function(r){(t(r)?e:n).push(r)}),[e,n]},s.prototype.reduce=function(t,e){return this.ops.reduce(t,e)},s.prototype.changeLength=function(){return this.reduce(function(t,e){return e.insert?t+l.length(e):e.delete?t-e.delete:t},0)},s.prototype.length=function(){return this.reduce(function(t,e){return t+l.length(e)},0)},s.prototype.slice=function(t,e){t=t||0,\"number\"!=typeof e&&(e=1/0);for(var n=[],r=l.iterator(this.ops),o=0;o<e&&r.hasNext();){var i;o<t?i=r.next(t-o):(i=r.next(e-o),n.push(i)),o+=l.length(i)}return new s(n)},s.prototype.compose=function(t){var e=l.iterator(this.ops),n=l.iterator(t.ops),r=[],i=n.peek();if(null!=i&&\"number\"==typeof i.retain&&null==i.attributes){for(var a=i.retain;\"insert\"===e.peekType()&&e.peekLength()<=a;)a-=e.peekLength(),r.push(e.next());i.retain-a>0&&n.next(i.retain-a)}for(var u=new s(r);e.hasNext()||n.hasNext();)if(\"insert\"===n.peekType())u.push(n.next());else if(\"delete\"===e.peekType())u.push(e.next());else{var c=Math.min(e.peekLength(),n.peekLength()),f=e.next(c),h=n.next(c);if(\"number\"==typeof h.retain){var p={};\"number\"==typeof f.retain?p.retain=c:p.insert=f.insert;var d=l.attributes.compose(f.attributes,h.attributes,\"number\"==typeof f.retain);if(d&&(p.attributes=d),u.push(p),!n.hasNext()&&o(u.ops[u.ops.length-1],p)){var y=new s(e.rest());return u.concat(y).chop()}}else\"number\"==typeof h.delete&&\"number\"==typeof f.retain&&u.push(h)}return u.chop()},s.prototype.concat=function(t){var e=new s(this.ops.slice());return t.ops.length>0&&(e.push(t.ops[0]),e.ops=e.ops.concat(t.ops.slice(1))),e},s.prototype.diff=function(t,e){if(this.ops===t.ops)return new s;var n=[this,t].map(function(e){return e.map(function(n){if(null!=n.insert)return\"string\"==typeof n.insert?n.insert:a;var r=e===t?\"on\":\"with\";throw new Error(\"diff() called \"+r+\" non-document\")}).join(\"\")}),i=new s,u=r(n[0],n[1],e),c=l.iterator(this.ops),f=l.iterator(t.ops);return u.forEach(function(t){for(var e=t[1].length;e>0;){var n=0;switch(t[0]){case r.INSERT:n=Math.min(f.peekLength(),e),i.push(f.next(n));break;case r.DELETE:n=Math.min(e,c.peekLength()),c.next(n),i.delete(n);break;case r.EQUAL:n=Math.min(c.peekLength(),f.peekLength(),e);var a=c.next(n),s=f.next(n);o(a.insert,s.insert)?i.retain(n,l.attributes.diff(a.attributes,s.attributes)):i.push(s).delete(n)}e-=n}}),i.chop()},s.prototype.eachLine=function(t,e){e=e||\"\\n\";for(var n=l.iterator(this.ops),r=new s,o=0;n.hasNext();){if(\"insert\"!==n.peekType())return;var i=n.peek(),a=l.length(i)-n.peekLength(),u=\"string\"==typeof i.insert?i.insert.indexOf(e,a)-a:-1;if(u<0)r.push(n.next());else if(u>0)r.push(n.next(u));else{if(!1===t(r,n.next(1).attributes||{},o))return;o+=1,r=new s}}r.length()>0&&t(r,{},o)},s.prototype.transform=function(t,e){if(e=!!e,\"number\"==typeof t)return this.transformPosition(t,e);for(var n=l.iterator(this.ops),r=l.iterator(t.ops),o=new s;n.hasNext()||r.hasNext();)if(\"insert\"!==n.peekType()||!e&&\"insert\"===r.peekType())if(\"insert\"===r.peekType())o.push(r.next());else{var i=Math.min(n.peekLength(),r.peekLength()),a=n.next(i),u=r.next(i);if(a.delete)continue;u.delete?o.push(u):o.retain(i,l.attributes.transform(a.attributes,u.attributes,e))}else o.retain(l.length(n.next()));return o.chop()},s.prototype.transformPosition=function(t,e){e=!!e;for(var n=l.iterator(this.ops),r=0;n.hasNext()&&r<=t;){var o=n.peekLength(),i=n.peekType();n.next(),\"delete\"!==i?(\"insert\"===i&&(r<t||!e)&&(t+=o),r+=o):t-=Math.min(o,t-r)}return t},t.exports=s},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function i(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function l(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0});var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=n(8),c=r(u),f=n(0),h=r(f),p=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),a(e,[{key:\"formatAt\",value:function(t,n,r,o){if(e.compare(this.statics.blotName,r)<0&&h.default.query(r,h.default.Scope.BLOT)){var i=this.isolate(t,n);o&&i.wrap(r,o)}else s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"formatAt\",this).call(this,t,n,r,o)}},{key:\"optimize\",value:function(t){if(s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"optimize\",this).call(this,t),this.parent instanceof e&&e.compare(this.statics.blotName,this.parent.statics.blotName)>0){var n=this.parent.isolate(this.offset(),this.length());this.moveChildren(n),n.wrap(this)}}}],[{key:\"compare\",value:function(t,n){var r=e.order.indexOf(t),o=e.order.indexOf(n);return r>=0||o>=0?r-o:t===n?0:t<n?-1:1}}]),e}(h.default.Inline);p.allowedChildren=[p,h.default.Embed,c.default],p.order=[\"cursor\",\"inline\",\"underline\",\"strike\",\"italic\",\"bold\",\"script\",\"link\",\"code\"],e.default=p},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function l(t,e){if(e=(0,N.default)(!0,{container:t,modules:{clipboard:!0,keyboard:!0,history:!0}},e),e.theme&&e.theme!==S.DEFAULTS.theme){if(e.theme=S.import(\"themes/\"+e.theme),null==e.theme)throw new Error(\"Invalid theme \"+e.theme+\". Did you register it?\")}else e.theme=T.default;var n=(0,N.default)(!0,{},e.theme.DEFAULTS);[n,e].forEach(function(t){t.modules=t.modules||{},Object.keys(t.modules).forEach(function(e){!0===t.modules[e]&&(t.modules[e]={})})});var r=Object.keys(n.modules).concat(Object.keys(e.modules)),o=r.reduce(function(t,e){var n=S.import(\"modules/\"+e);return null==n?P.error(\"Cannot load \"+e+\" module. Are you sure you registered it?\"):t[e]=n.DEFAULTS||{},t},{});return null!=e.modules&&e.modules.toolbar&&e.modules.toolbar.constructor!==Object&&(e.modules.toolbar={container:e.modules.toolbar}),e=(0,N.default)(!0,{},S.DEFAULTS,{modules:o},n,e),[\"bounds\",\"container\",\"scrollingContainer\"].forEach(function(t){\"string\"==typeof e[t]&&(e[t]=document.querySelector(e[t]))}),e.modules=Object.keys(e.modules).reduce(function(t,n){return e.modules[n]&&(t[n]=e.modules[n]),t},{}),e}function a(t,e,n,r){if(this.options.strict&&!this.isEnabled()&&e===g.default.sources.USER)return new d.default;var o=null==n?null:this.getSelection(),i=this.editor.delta,l=t();if(null!=o&&(!0===n&&(n=o.index),null==r?o=u(o,l,e):0!==r&&(o=u(o,n,r,e)),this.setSelection(o,g.default.sources.SILENT)),l.length()>0){var a,s=[g.default.events.TEXT_CHANGE,l,i,e];if((a=this.emitter).emit.apply(a,[g.default.events.EDITOR_CHANGE].concat(s)),e!==g.default.sources.SILENT){var c;(c=this.emitter).emit.apply(c,s)}}return l}function s(t,e,n,r,o){var i={};return\"number\"==typeof t.index&&\"number\"==typeof t.length?\"number\"!=typeof e?(o=r,r=n,n=e,e=t.length,t=t.index):(e=t.length,t=t.index):\"number\"!=typeof e&&(o=r,r=n,n=e,e=0),\"object\"===(void 0===n?\"undefined\":c(n))?(i=n,o=r):\"string\"==typeof n&&(null!=r?i[n]=r:o=n),o=o||g.default.sources.API,[t,e,i,o]}function u(t,e,n,r){if(null==t)return null;var o=void 0,i=void 0;if(e instanceof d.default){var l=[t.index,t.index+t.length].map(function(t){return e.transformPosition(t,r!==g.default.sources.USER)}),a=f(l,2);o=a[0],i=a[1]}else{var s=[t.index,t.index+t.length].map(function(t){return t<e||t===e&&r===g.default.sources.USER?t:n>=0?t+n:Math.max(e,t+n)}),u=f(s,2);o=u[0],i=u[1]}return new x.Range(o,i-o)}Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=e.overload=e.expandConfig=void 0;var c=\"function\"==typeof Symbol&&\"symbol\"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&\"function\"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?\"symbol\":typeof t},f=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError(\"Invalid attempt to destructure non-iterable instance\")}}(),h=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}();n(53);var p=n(4),d=r(p),y=n(57),v=r(y),b=n(9),g=r(b),m=n(7),_=r(m),O=n(0),w=r(O),x=n(22),k=r(x),E=n(2),N=r(E),j=n(10),A=r(j),q=n(32),T=r(q),P=(0,A.default)(\"quill\"),S=function(){function t(e){var n=this,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(i(this,t),this.options=l(e,r),this.container=this.options.container,null==this.container)return P.error(\"Invalid Quill container\",e);this.options.debug&&t.debug(this.options.debug);var o=this.container.innerHTML.trim();this.container.classList.add(\"ql-container\"),this.container.innerHTML=\"\",this.container.__quill=this,this.root=this.addContainer(\"ql-editor\"),this.root.classList.add(\"ql-blank\"),this.root.setAttribute(\"data-gramm\",!1),this.scrollingContainer=this.options.scrollingContainer||this.root,this.emitter=new g.default,this.scroll=w.default.create(this.root,{emitter:this.emitter,whitelist:this.options.formats}),this.editor=new v.default(this.scroll),this.selection=new k.default(this.scroll,this.emitter),this.theme=new this.options.theme(this,this.options),this.keyboard=this.theme.addModule(\"keyboard\"),this.clipboard=this.theme.addModule(\"clipboard\"),this.history=this.theme.addModule(\"history\"),this.theme.init(),this.emitter.on(g.default.events.EDITOR_CHANGE,function(t){t===g.default.events.TEXT_CHANGE&&n.root.classList.toggle(\"ql-blank\",n.editor.isBlank())}),this.emitter.on(g.default.events.SCROLL_UPDATE,function(t,e){var r=n.selection.lastRange,o=r&&0===r.length?r.index:void 0;a.call(n,function(){return n.editor.update(null,e,o)},t)});var s=this.clipboard.convert(\"<div class='ql-editor' style=\\\"white-space: normal;\\\">\"+o+\"<p><br></p></div>\");this.setContents(s),this.history.clear(),this.options.placeholder&&this.root.setAttribute(\"data-placeholder\",this.options.placeholder),this.options.readOnly&&this.disable()}return h(t,null,[{key:\"debug\",value:function(t){!0===t&&(t=\"log\"),A.default.level(t)}},{key:\"find\",value:function(t){return t.__quill||w.default.find(t)}},{key:\"import\",value:function(t){return null==this.imports[t]&&P.error(\"Cannot import \"+t+\". Are you sure it was registered?\"),this.imports[t]}},{key:\"register\",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(\"string\"!=typeof t){var o=t.attrName||t.blotName;\"string\"==typeof o?this.register(\"formats/\"+o,t,e):Object.keys(t).forEach(function(r){n.register(r,t[r],e)})}else null==this.imports[t]||r||P.warn(\"Overwriting \"+t+\" with\",e),this.imports[t]=e,(t.startsWith(\"blots/\")||t.startsWith(\"formats/\"))&&\"abstract\"!==e.blotName?w.default.register(e):t.startsWith(\"modules\")&&\"function\"==typeof e.register&&e.register()}}]),h(t,[{key:\"addContainer\",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;if(\"string\"==typeof t){var n=t;t=document.createElement(\"div\"),t.classList.add(n)}return this.container.insertBefore(t,e),t}},{key:\"blur\",value:function(){this.selection.setRange(null)}},{key:\"deleteText\",value:function(t,e,n){var r=this,o=s(t,e,n),i=f(o,4);return t=i[0],e=i[1],n=i[3],a.call(this,function(){return r.editor.deleteText(t,e)},n,t,-1*e)}},{key:\"disable\",value:function(){this.enable(!1)}},{key:\"enable\",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];this.scroll.enable(t),this.container.classList.toggle(\"ql-disabled\",!t)}},{key:\"focus\",value:function(){var t=this.scrollingContainer.scrollTop;this.selection.focus(),this.scrollingContainer.scrollTop=t,this.scrollIntoView()}},{key:\"format\",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:g.default.sources.API;return a.call(this,function(){var r=n.getSelection(!0),i=new d.default;if(null==r)return i;if(w.default.query(t,w.default.Scope.BLOCK))i=n.editor.formatLine(r.index,r.length,o({},t,e));else{if(0===r.length)return n.selection.format(t,e),i;i=n.editor.formatText(r.index,r.length,o({},t,e))}return n.setSelection(r,g.default.sources.SILENT),i},r)}},{key:\"formatLine\",value:function(t,e,n,r,o){var i=this,l=void 0,u=s(t,e,n,r,o),c=f(u,4);return t=c[0],e=c[1],l=c[2],o=c[3],a.call(this,function(){return i.editor.formatLine(t,e,l)},o,t,0)}},{key:\"formatText\",value:function(t,e,n,r,o){var i=this,l=void 0,u=s(t,e,n,r,o),c=f(u,4);return t=c[0],e=c[1],l=c[2],o=c[3],a.call(this,function(){return i.editor.formatText(t,e,l)},o,t,0)}},{key:\"getBounds\",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=void 0;n=\"number\"==typeof t?this.selection.getBounds(t,e):this.selection.getBounds(t.index,t.length);var r=this.container.getBoundingClientRect();return{bottom:n.bottom-r.top,height:n.height,left:n.left-r.left,right:n.right-r.left,top:n.top-r.top,width:n.width}}},{key:\"getContents\",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.getLength()-t,n=s(t,e),r=f(n,2);return t=r[0],e=r[1],this.editor.getContents(t,e)}},{key:\"getFormat\",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.getSelection(!0),e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return\"number\"==typeof t?this.editor.getFormat(t,e):this.editor.getFormat(t.index,t.length)}},{key:\"getIndex\",value:function(t){return t.offset(this.scroll)}},{key:\"getLength\",value:function(){return this.scroll.length()}},{key:\"getLeaf\",value:function(t){return this.scroll.leaf(t)}},{key:\"getLine\",value:function(t){return this.scroll.line(t)}},{key:\"getLines\",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Number.MAX_VALUE;return\"number\"!=typeof t?this.scroll.lines(t.index,t.length):this.scroll.lines(t,e)}},{key:\"getModule\",value:function(t){return this.theme.modules[t]}},{key:\"getSelection\",value:function(){return arguments.length>0&&void 0!==arguments[0]&&arguments[0]&&this.focus(),this.update(),this.selection.getRange()[0]}},{key:\"getText\",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.getLength()-t,n=s(t,e),r=f(n,2);return t=r[0],e=r[1],this.editor.getText(t,e)}},{key:\"hasFocus\",value:function(){return this.selection.hasFocus()}},{key:\"insertEmbed\",value:function(e,n,r){var o=this,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:t.sources.API;return a.call(this,function(){return o.editor.insertEmbed(e,n,r)},i,e)}},{key:\"insertText\",value:function(t,e,n,r,o){var i=this,l=void 0,u=s(t,0,n,r,o),c=f(u,4);return t=c[0],l=c[2],o=c[3],a.call(this,function(){return i.editor.insertText(t,e,l)},o,t,e.length)}},{key:\"isEnabled\",value:function(){return!this.container.classList.contains(\"ql-disabled\")}},{key:\"off\",value:function(){return this.emitter.off.apply(this.emitter,arguments)}},{key:\"on\",value:function(){return this.emitter.on.apply(this.emitter,arguments)}},{key:\"once\",value:function(){return this.emitter.once.apply(this.emitter,arguments)}},{key:\"pasteHTML\",value:function(t,e,n){this.clipboard.dangerouslyPasteHTML(t,e,n)}},{key:\"removeFormat\",value:function(t,e,n){var r=this,o=s(t,e,n),i=f(o,4);return t=i[0],e=i[1],n=i[3],a.call(this,function(){return r.editor.removeFormat(t,e)},n,t)}},{key:\"scrollIntoView\",value:function(){this.selection.scrollIntoView(this.scrollingContainer)}},{key:\"setContents\",value:function(t){var e=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:g.default.sources.API;return a.call(this,function(){t=new d.default(t);var n=e.getLength(),r=e.editor.deleteText(0,n),o=e.editor.applyDelta(t),i=o.ops[o.ops.length-1];return null!=i&&\"string\"==typeof i.insert&&\"\\n\"===i.insert[i.insert.length-1]&&(e.editor.deleteText(e.getLength()-1,1),o.delete(1)),r.compose(o)},n)}},{key:\"setSelection\",value:function(e,n,r){if(null==e)this.selection.setRange(null,n||t.sources.API);else{var o=s(e,n,r),i=f(o,4);e=i[0],n=i[1],r=i[3],this.selection.setRange(new x.Range(e,n),r),r!==g.default.sources.SILENT&&this.selection.scrollIntoView(this.scrollingContainer)}}},{key:\"setText\",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:g.default.sources.API,n=(new d.default).insert(t);return this.setContents(n,e)}},{key:\"update\",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:g.default.sources.USER,e=this.scroll.update(t);return this.selection.update(t),e}},{key:\"updateContents\",value:function(t){var e=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:g.default.sources.API;return a.call(this,function(){return t=new d.default(t),e.editor.applyDelta(t,n)},n,!0)}}]),t}();S.DEFAULTS={bounds:null,formats:null,modules:{},placeholder:\"\",readOnly:!1,scrollingContainer:null,strict:!0,theme:\"default\"},S.events=g.default.events,S.sources=g.default.sources,S.version=\"1.3.7\",S.imports={delta:d.default,parchment:w.default,\"core/module\":_.default,\"core/theme\":T.default},e.expandConfig=l,e.overload=s,e.default=S},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}Object.defineProperty(e,\"__esModule\",{value:!0});var o=function t(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};r(this,t),this.quill=e,this.options=n};o.DEFAULTS={},e.default=o},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function o(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function i(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0});var l=n(0),a=function(t){return t&&t.__esModule?t:{default:t}}(l),s=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),e}(a.default.Text);e.default=s},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function i(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function l(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0});var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=n(58),c=r(u),f=n(10),h=r(f),p=(0,h.default)(\"quill:events\");[\"selectionchange\",\"mousedown\",\"mouseup\",\"click\"].forEach(function(t){document.addEventListener(t,function(){for(var t=arguments.length,e=Array(t),n=0;n<t;n++)e[n]=arguments[n];[].slice.call(document.querySelectorAll(\".ql-container\")).forEach(function(t){if(t.__quill&&t.__quill.emitter){var n;(n=t.__quill.emitter).handleDOM.apply(n,e)}})})});var d=function(t){function e(){o(this,e);var t=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return t.listeners={},t.on(\"error\",p.error),t}return l(e,t),a(e,[{key:\"emit\",value:function(){p.log.apply(p,arguments),s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"emit\",this).apply(this,arguments)}},{key:\"handleDOM\",value:function(t){for(var e=arguments.length,n=Array(e>1?e-1:0),r=1;r<e;r++)n[r-1]=arguments[r];(this.listeners[t.type]||[]).forEach(function(e){var r=e.node,o=e.handler;(t.target===r||r.contains(t.target))&&o.apply(void 0,[t].concat(n))})}},{key:\"listenDOM\",value:function(t,e,n){this.listeners[t]||(this.listeners[t]=[]),this.listeners[t].push({node:e,handler:n})}}]),e}(c.default);d.events={EDITOR_CHANGE:\"editor-change\",SCROLL_BEFORE_UPDATE:\"scroll-before-update\",SCROLL_OPTIMIZE:\"scroll-optimize\",SCROLL_UPDATE:\"scroll-update\",SELECTION_CHANGE:\"selection-change\",TEXT_CHANGE:\"text-change\"},d.sources={API:\"api\",SILENT:\"silent\",USER:\"user\"},e.default=d},function(t,e,n){\"use strict\";function r(t){if(i.indexOf(t)<=i.indexOf(l)){for(var e,n=arguments.length,r=Array(n>1?n-1:0),o=1;o<n;o++)r[o-1]=arguments[o];(e=console)[t].apply(e,r)}}function o(t){return i.reduce(function(e,n){return e[n]=r.bind(console,n,t),e},{})}Object.defineProperty(e,\"__esModule\",{value:!0});var i=[\"error\",\"warn\",\"log\",\"info\"],l=\"warn\";r.level=o.level=function(t){l=t},e.default=o},function(t,e,n){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0});var r=n(1),o=function(){function t(t,e,n){void 0===n&&(n={}),this.attrName=t,this.keyName=e;var o=r.Scope.TYPE&r.Scope.ATTRIBUTE;null!=n.scope?this.scope=n.scope&r.Scope.LEVEL|o:this.scope=r.Scope.ATTRIBUTE,null!=n.whitelist&&(this.whitelist=n.whitelist)}return t.keys=function(t){return[].map.call(t.attributes,function(t){return t.name})},t.prototype.add=function(t,e){return!!this.canAdd(t,e)&&(t.setAttribute(this.keyName,e),!0)},t.prototype.canAdd=function(t,e){return null!=r.query(t,r.Scope.BLOT&(this.scope|r.Scope.TYPE))&&(null==this.whitelist||(\"string\"==typeof e?this.whitelist.indexOf(e.replace(/[\"']/g,\"\"))>-1:this.whitelist.indexOf(e)>-1))},t.prototype.remove=function(t){t.removeAttribute(this.keyName)},t.prototype.value=function(t){var e=t.getAttribute(this.keyName);return this.canAdd(t,e)&&e?e:\"\"},t}();e.default=o},function(t,e,n){function r(t){return null===t||void 0===t}function o(t){return!(!t||\"object\"!=typeof t||\"number\"!=typeof t.length)&&(\"function\"==typeof t.copy&&\"function\"==typeof t.slice&&!(t.length>0&&\"number\"!=typeof t[0]))}function i(t,e,n){var i,c;if(r(t)||r(e))return!1;if(t.prototype!==e.prototype)return!1;if(s(t))return!!s(e)&&(t=l.call(t),e=l.call(e),u(t,e,n));if(o(t)){if(!o(e))return!1;if(t.length!==e.length)return!1;for(i=0;i<t.length;i++)if(t[i]!==e[i])return!1;return!0}try{var f=a(t),h=a(e)}catch(t){return!1}if(f.length!=h.length)return!1;for(f.sort(),h.sort(),i=f.length-1;i>=0;i--)if(f[i]!=h[i])return!1;for(i=f.length-1;i>=0;i--)if(c=f[i],!u(t[c],e[c],n))return!1;return typeof t==typeof e}var l=Array.prototype.slice,a=n(55),s=n(56),u=t.exports=function(t,e,n){return n||(n={}),t===e||(t instanceof Date&&e instanceof Date?t.getTime()===e.getTime():!t||!e||\"object\"!=typeof t&&\"object\"!=typeof e?n.strict?t===e:t==e:i(t,e,n))}},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function i(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function l(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=e.Code=void 0;var a=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError(\"Invalid attempt to destructure non-iterable instance\")}}(),s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},c=n(4),f=r(c),h=n(0),p=r(h),d=n(3),y=r(d),v=n(5),b=r(v),g=n(8),m=r(g),_=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),e}(b.default);_.blotName=\"code\",_.tagName=\"CODE\";var O=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),s(e,[{key:\"delta\",value:function(){var t=this,e=this.domNode.textContent;return e.endsWith(\"\\n\")&&(e=e.slice(0,-1)),e.split(\"\\n\").reduce(function(e,n){return e.insert(n).insert(\"\\n\",t.formats())},new f.default)}},{key:\"format\",value:function(t,n){if(t!==this.statics.blotName||!n){var r=this.descendant(m.default,this.length()-1),o=a(r,1),i=o[0];null!=i&&i.deleteAt(i.length()-1,1),u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"format\",this).call(this,t,n)}}},{key:\"formatAt\",value:function(t,n,r,o){if(0!==n&&null!=p.default.query(r,p.default.Scope.BLOCK)&&(r!==this.statics.blotName||o!==this.statics.formats(this.domNode))){var i=this.newlineIndex(t);if(!(i<0||i>=t+n)){var l=this.newlineIndex(t,!0)+1,a=i-l+1,s=this.isolate(l,a),u=s.next;s.format(r,o),u instanceof e&&u.formatAt(0,t-l+n-a,r,o)}}}},{key:\"insertAt\",value:function(t,e,n){if(null==n){var r=this.descendant(m.default,t),o=a(r,2),i=o[0],l=o[1];i.insertAt(l,e)}}},{key:\"length\",value:function(){var t=this.domNode.textContent.length;return this.domNode.textContent.endsWith(\"\\n\")?t:t+1}},{key:\"newlineIndex\",value:function(t){if(arguments.length>1&&void 0!==arguments[1]&&arguments[1])return this.domNode.textContent.slice(0,t).lastIndexOf(\"\\n\");var e=this.domNode.textContent.slice(t).indexOf(\"\\n\");return e>-1?t+e:-1}},{key:\"optimize\",value:function(t){this.domNode.textContent.endsWith(\"\\n\")||this.appendChild(p.default.create(\"text\",\"\\n\")),u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"optimize\",this).call(this,t);var n=this.next;null!=n&&n.prev===this&&n.statics.blotName===this.statics.blotName&&this.statics.formats(this.domNode)===n.statics.formats(n.domNode)&&(n.optimize(t),n.moveChildren(this),n.remove())}},{key:\"replace\",value:function(t){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"replace\",this).call(this,t),[].slice.call(this.domNode.querySelectorAll(\"*\")).forEach(function(t){var e=p.default.find(t);null==e?t.parentNode.removeChild(t):e instanceof p.default.Embed?e.remove():e.unwrap()})}}],[{key:\"create\",value:function(t){var n=u(e.__proto__||Object.getPrototypeOf(e),\"create\",this).call(this,t);return n.setAttribute(\"spellcheck\",!1),n}},{key:\"formats\",value:function(){return!0}}]),e}(y.default);O.blotName=\"code-block\",O.tagName=\"PRE\",O.TAB=\"  \",e.Code=_,e.default=O},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function o(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function i(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(0),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:\"insertInto\",value:function(t,n){0===t.children.length?a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"insertInto\",this).call(this,t,n):this.remove()}},{key:\"length\",value:function(){return 0}},{key:\"value\",value:function(){return\"\"}}],[{key:\"value\",value:function(){}}]),e}(u.default.Embed);c.blotName=\"break\",c.tagName=\"BR\",e.default=c},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function o(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function i(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function l(t,e){var n=document.createElement(\"a\");n.href=t;var r=n.href.slice(0,n.href.indexOf(\":\"));return e.indexOf(r)>-1}Object.defineProperty(e,\"__esModule\",{value:!0}),e.sanitize=e.default=void 0;var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=n(5),c=function(t){return t&&t.__esModule?t:{default:t}}(u),f=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),a(e,[{key:\"format\",value:function(t,n){if(t!==this.statics.blotName||!n)return s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"format\",this).call(this,t,n);n=this.constructor.sanitize(n),this.domNode.setAttribute(\"href\",n)}}],[{key:\"create\",value:function(t){var n=s(e.__proto__||Object.getPrototypeOf(e),\"create\",this).call(this,t);return t=this.sanitize(t),n.setAttribute(\"href\",t),n.setAttribute(\"rel\",\"noopener noreferrer\"),n.setAttribute(\"target\",\"_blank\"),n}},{key:\"formats\",value:function(t){return t.getAttribute(\"href\")}},{key:\"sanitize\",value:function(t){return l(t,this.PROTOCOL_WHITELIST)?t:this.SANITIZED_URL}}]),e}(c.default);f.blotName=\"link\",f.tagName=\"A\",f.SANITIZED_URL=\"about:blank\",f.PROTOCOL_WHITELIST=[\"http\",\"https\",\"mailto\",\"tel\"],e.default=f,e.sanitize=l},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function i(t,e){t.setAttribute(e,!(\"true\"===t.getAttribute(e)))}Object.defineProperty(e,\"__esModule\",{value:!0});var l=\"function\"==typeof Symbol&&\"symbol\"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&\"function\"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?\"symbol\":typeof t},a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=n(25),u=r(s),c=n(106),f=r(c),h=0,p=function(){function t(e){var n=this;o(this,t),this.select=e,this.container=document.createElement(\"span\"),this.buildPicker(),this.select.style.display=\"none\",this.select.parentNode.insertBefore(this.container,this.select),this.label.addEventListener(\"mousedown\",function(){n.togglePicker()}),this.label.addEventListener(\"keydown\",function(t){switch(t.keyCode){case u.default.keys.ENTER:n.togglePicker();break;case u.default.keys.ESCAPE:n.escape(),t.preventDefault()}}),this.select.addEventListener(\"change\",this.update.bind(this))}return a(t,[{key:\"togglePicker\",value:function(){this.container.classList.toggle(\"ql-expanded\"),i(this.label,\"aria-expanded\"),i(this.options,\"aria-hidden\")}},{key:\"buildItem\",value:function(t){var e=this,n=document.createElement(\"span\");return n.tabIndex=\"0\",n.setAttribute(\"role\",\"button\"),n.classList.add(\"ql-picker-item\"),t.hasAttribute(\"value\")&&n.setAttribute(\"data-value\",t.getAttribute(\"value\")),t.textContent&&n.setAttribute(\"data-label\",t.textContent),n.addEventListener(\"click\",function(){e.selectItem(n,!0)}),n.addEventListener(\"keydown\",function(t){switch(t.keyCode){case u.default.keys.ENTER:e.selectItem(n,!0),t.preventDefault();break;case u.default.keys.ESCAPE:e.escape(),t.preventDefault()}}),n}},{key:\"buildLabel\",value:function(){var t=document.createElement(\"span\");return t.classList.add(\"ql-picker-label\"),t.innerHTML=f.default,t.tabIndex=\"0\",t.setAttribute(\"role\",\"button\"),t.setAttribute(\"aria-expanded\",\"false\"),this.container.appendChild(t),t}},{key:\"buildOptions\",value:function(){var t=this,e=document.createElement(\"span\");e.classList.add(\"ql-picker-options\"),e.setAttribute(\"aria-hidden\",\"true\"),e.tabIndex=\"-1\",e.id=\"ql-picker-options-\"+h,h+=1,this.label.setAttribute(\"aria-controls\",e.id),this.options=e,[].slice.call(this.select.options).forEach(function(n){var r=t.buildItem(n);e.appendChild(r),!0===n.selected&&t.selectItem(r)}),this.container.appendChild(e)}},{key:\"buildPicker\",value:function(){var t=this;[].slice.call(this.select.attributes).forEach(function(e){t.container.setAttribute(e.name,e.value)}),this.container.classList.add(\"ql-picker\"),this.label=this.buildLabel(),this.buildOptions()}},{key:\"escape\",value:function(){var t=this;this.close(),setTimeout(function(){return t.label.focus()},1)}},{key:\"close\",value:function(){this.container.classList.remove(\"ql-expanded\"),this.label.setAttribute(\"aria-expanded\",\"false\"),this.options.setAttribute(\"aria-hidden\",\"true\")}},{key:\"selectItem\",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=this.container.querySelector(\".ql-selected\");if(t!==n&&(null!=n&&n.classList.remove(\"ql-selected\"),null!=t&&(t.classList.add(\"ql-selected\"),this.select.selectedIndex=[].indexOf.call(t.parentNode.children,t),t.hasAttribute(\"data-value\")?this.label.setAttribute(\"data-value\",t.getAttribute(\"data-value\")):this.label.removeAttribute(\"data-value\"),t.hasAttribute(\"data-label\")?this.label.setAttribute(\"data-label\",t.getAttribute(\"data-label\")):this.label.removeAttribute(\"data-label\"),e))){if(\"function\"==typeof Event)this.select.dispatchEvent(new Event(\"change\"));else if(\"object\"===(\"undefined\"==typeof Event?\"undefined\":l(Event))){var r=document.createEvent(\"Event\");r.initEvent(\"change\",!0,!0),this.select.dispatchEvent(r)}this.close()}}},{key:\"update\",value:function(){var t=void 0;if(this.select.selectedIndex>-1){var e=this.container.querySelector(\".ql-picker-options\").children[this.select.selectedIndex];t=this.select.options[this.select.selectedIndex],this.selectItem(e)}else this.selectItem(null);var n=null!=t&&t!==this.select.querySelector(\"option[selected]\");this.label.classList.toggle(\"ql-active\",n)}}]),t}();e.default=p},function(t,e,n){\"use strict\";function r(t){var e=a.find(t);if(null==e)try{e=a.create(t)}catch(n){e=a.create(a.Scope.INLINE),[].slice.call(t.childNodes).forEach(function(t){e.domNode.appendChild(t)}),t.parentNode&&t.parentNode.replaceChild(e.domNode,t),e.attach()}return e}var o=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,\"__esModule\",{value:!0});var i=n(47),l=n(27),a=n(1),s=function(t){function e(e){var n=t.call(this,e)||this;return n.build(),n}return o(e,t),e.prototype.appendChild=function(t){this.insertBefore(t)},e.prototype.attach=function(){t.prototype.attach.call(this),this.children.forEach(function(t){t.attach()})},e.prototype.build=function(){var t=this;this.children=new i.default,[].slice.call(this.domNode.childNodes).reverse().forEach(function(e){try{var n=r(e);t.insertBefore(n,t.children.head||void 0)}catch(t){if(t instanceof a.ParchmentError)return;throw t}})},e.prototype.deleteAt=function(t,e){if(0===t&&e===this.length())return this.remove();this.children.forEachAt(t,e,function(t,e,n){t.deleteAt(e,n)})},e.prototype.descendant=function(t,n){var r=this.children.find(n),o=r[0],i=r[1];return null==t.blotName&&t(o)||null!=t.blotName&&o instanceof t?[o,i]:o instanceof e?o.descendant(t,i):[null,-1]},e.prototype.descendants=function(t,n,r){void 0===n&&(n=0),void 0===r&&(r=Number.MAX_VALUE);var o=[],i=r;return this.children.forEachAt(n,r,function(n,r,l){(null==t.blotName&&t(n)||null!=t.blotName&&n instanceof t)&&o.push(n),n instanceof e&&(o=o.concat(n.descendants(t,r,i))),i-=l}),o},e.prototype.detach=function(){this.children.forEach(function(t){t.detach()}),t.prototype.detach.call(this)},e.prototype.formatAt=function(t,e,n,r){this.children.forEachAt(t,e,function(t,e,o){t.formatAt(e,o,n,r)})},e.prototype.insertAt=function(t,e,n){var r=this.children.find(t),o=r[0],i=r[1];if(o)o.insertAt(i,e,n);else{var l=null==n?a.create(\"text\",e):a.create(e,n);this.appendChild(l)}},e.prototype.insertBefore=function(t,e){if(null!=this.statics.allowedChildren&&!this.statics.allowedChildren.some(function(e){return t instanceof e}))throw new a.ParchmentError(\"Cannot insert \"+t.statics.blotName+\" into \"+this.statics.blotName);t.insertInto(this,e)},e.prototype.length=function(){return this.children.reduce(function(t,e){return t+e.length()},0)},e.prototype.moveChildren=function(t,e){this.children.forEach(function(n){t.insertBefore(n,e)})},e.prototype.optimize=function(e){if(t.prototype.optimize.call(this,e),0===this.children.length)if(null!=this.statics.defaultChild){var n=a.create(this.statics.defaultChild);this.appendChild(n),n.optimize(e)}else this.remove()},e.prototype.path=function(t,n){void 0===n&&(n=!1);var r=this.children.find(t,n),o=r[0],i=r[1],l=[[this,t]];return o instanceof e?l.concat(o.path(i,n)):(null!=o&&l.push([o,i]),l)},e.prototype.removeChild=function(t){this.children.remove(t)},e.prototype.replace=function(n){n instanceof e&&n.moveChildren(this),t.prototype.replace.call(this,n)},e.prototype.split=function(t,e){if(void 0===e&&(e=!1),!e){if(0===t)return this;if(t===this.length())return this.next}var n=this.clone();return this.parent.insertBefore(n,this.next),this.children.forEachAt(t,this.length(),function(t,r,o){t=t.split(r,e),n.appendChild(t)}),n},e.prototype.unwrap=function(){this.moveChildren(this.parent,this.next),this.remove()},e.prototype.update=function(t,e){var n=this,o=[],i=[];t.forEach(function(t){t.target===n.domNode&&\"childList\"===t.type&&(o.push.apply(o,t.addedNodes),i.push.apply(i,t.removedNodes))}),i.forEach(function(t){if(!(null!=t.parentNode&&\"IFRAME\"!==t.tagName&&document.body.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_CONTAINED_BY)){var e=a.find(t);null!=e&&(null!=e.domNode.parentNode&&e.domNode.parentNode!==n.domNode||e.detach())}}),o.filter(function(t){return t.parentNode==n.domNode}).sort(function(t,e){return t===e?0:t.compareDocumentPosition(e)&Node.DOCUMENT_POSITION_FOLLOWING?1:-1}).forEach(function(t){var e=null;null!=t.nextSibling&&(e=a.find(t.nextSibling));var o=r(t);o.next==e&&null!=o.next||(null!=o.parent&&o.parent.removeChild(n),n.insertBefore(o,e||void 0))})},e}(l.default);e.default=s},function(t,e,n){\"use strict\";var r=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,\"__esModule\",{value:!0});var o=n(11),i=n(28),l=n(17),a=n(1),s=function(t){function e(e){var n=t.call(this,e)||this;return n.attributes=new i.default(n.domNode),n}return r(e,t),e.formats=function(t){return\"string\"==typeof this.tagName||(Array.isArray(this.tagName)?t.tagName.toLowerCase():void 0)},e.prototype.format=function(t,e){var n=a.query(t);n instanceof o.default?this.attributes.attribute(n,e):e&&(null==n||t===this.statics.blotName&&this.formats()[t]===e||this.replaceWith(t,e))},e.prototype.formats=function(){var t=this.attributes.values(),e=this.statics.formats(this.domNode);return null!=e&&(t[this.statics.blotName]=e),t},e.prototype.replaceWith=function(e,n){var r=t.prototype.replaceWith.call(this,e,n);return this.attributes.copy(r),r},e.prototype.update=function(e,n){var r=this;t.prototype.update.call(this,e,n),e.some(function(t){return t.target===r.domNode&&\"attributes\"===t.type})&&this.attributes.build()},e.prototype.wrap=function(n,r){var o=t.prototype.wrap.call(this,n,r);return o instanceof e&&o.statics.scope===this.statics.scope&&this.attributes.move(o),o},e}(l.default);e.default=s},function(t,e,n){\"use strict\";var r=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,\"__esModule\",{value:!0});var o=n(27),i=n(1),l=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return r(e,t),e.value=function(t){return!0},e.prototype.index=function(t,e){return this.domNode===t||this.domNode.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_CONTAINED_BY?Math.min(e,1):-1},e.prototype.position=function(t,e){var n=[].indexOf.call(this.parent.domNode.childNodes,this.domNode);return t>0&&(n+=1),[this.parent.domNode,n]},e.prototype.value=function(){var t;return t={},t[this.statics.blotName]=this.statics.value(this.domNode)||!0,t},e.scope=i.Scope.INLINE_BLOT,e}(o.default);e.default=l},function(t,e,n){function r(t){this.ops=t,this.index=0,this.offset=0}var o=n(12),i=n(2),l={attributes:{compose:function(t,e,n){\"object\"!=typeof t&&(t={}),\"object\"!=typeof e&&(e={});var r=i(!0,{},e);n||(r=Object.keys(r).reduce(function(t,e){return null!=r[e]&&(t[e]=r[e]),t},{}));for(var o in t)void 0!==t[o]&&void 0===e[o]&&(r[o]=t[o]);return Object.keys(r).length>0?r:void 0},diff:function(t,e){\"object\"!=typeof t&&(t={}),\"object\"!=typeof e&&(e={});var n=Object.keys(t).concat(Object.keys(e)).reduce(function(n,r){return o(t[r],e[r])||(n[r]=void 0===e[r]?null:e[r]),n},{});return Object.keys(n).length>0?n:void 0},transform:function(t,e,n){if(\"object\"!=typeof t)return e;if(\"object\"==typeof e){if(!n)return e;var r=Object.keys(e).reduce(function(n,r){return void 0===t[r]&&(n[r]=e[r]),n},{});return Object.keys(r).length>0?r:void 0}}},iterator:function(t){return new r(t)},length:function(t){return\"number\"==typeof t.delete?t.delete:\"number\"==typeof t.retain?t.retain:\"string\"==typeof t.insert?t.insert.length:1}};r.prototype.hasNext=function(){return this.peekLength()<1/0},r.prototype.next=function(t){t||(t=1/0);var e=this.ops[this.index];if(e){var n=this.offset,r=l.length(e);if(t>=r-n?(t=r-n,this.index+=1,this.offset=0):this.offset+=t,\"number\"==typeof e.delete)return{delete:t};var o={};return e.attributes&&(o.attributes=e.attributes),\"number\"==typeof e.retain?o.retain=t:\"string\"==typeof e.insert?o.insert=e.insert.substr(n,t):o.insert=e.insert,o}return{retain:1/0}},r.prototype.peek=function(){return this.ops[this.index]},r.prototype.peekLength=function(){return this.ops[this.index]?l.length(this.ops[this.index])-this.offset:1/0},r.prototype.peekType=function(){return this.ops[this.index]?\"number\"==typeof this.ops[this.index].delete?\"delete\":\"number\"==typeof this.ops[this.index].retain?\"retain\":\"insert\":\"retain\"},r.prototype.rest=function(){if(this.hasNext()){if(0===this.offset)return this.ops.slice(this.index);var t=this.offset,e=this.index,n=this.next(),r=this.ops.slice(this.index);return this.offset=t,this.index=e,[n].concat(r)}return[]},t.exports=l},function(t,e){var n=function(){\"use strict\";function t(t,e){return null!=e&&t instanceof e}function e(n,r,o,i,c){function f(n,o){if(null===n)return null;if(0===o)return n;var y,v;if(\"object\"!=typeof n)return n;if(t(n,a))y=new a;else if(t(n,s))y=new s;else if(t(n,u))y=new u(function(t,e){n.then(function(e){t(f(e,o-1))},function(t){e(f(t,o-1))})});else if(e.__isArray(n))y=[];else if(e.__isRegExp(n))y=new RegExp(n.source,l(n)),n.lastIndex&&(y.lastIndex=n.lastIndex);else if(e.__isDate(n))y=new Date(n.getTime());else{if(d&&Buffer.isBuffer(n))return y=Buffer.allocUnsafe?Buffer.allocUnsafe(n.length):new Buffer(n.length),n.copy(y),y;t(n,Error)?y=Object.create(n):void 0===i?(v=Object.getPrototypeOf(n),y=Object.create(v)):(y=Object.create(i),v=i)}if(r){var b=h.indexOf(n);if(-1!=b)return p[b];h.push(n),p.push(y)}t(n,a)&&n.forEach(function(t,e){var n=f(e,o-1),r=f(t,o-1);y.set(n,r)}),t(n,s)&&n.forEach(function(t){var e=f(t,o-1);y.add(e)});for(var g in n){var m;v&&(m=Object.getOwnPropertyDescriptor(v,g)),m&&null==m.set||(y[g]=f(n[g],o-1))}if(Object.getOwnPropertySymbols)for(var _=Object.getOwnPropertySymbols(n),g=0;g<_.length;g++){var O=_[g],w=Object.getOwnPropertyDescriptor(n,O);(!w||w.enumerable||c)&&(y[O]=f(n[O],o-1),w.enumerable||Object.defineProperty(y,O,{enumerable:!1}))}if(c)for(var x=Object.getOwnPropertyNames(n),g=0;g<x.length;g++){var k=x[g],w=Object.getOwnPropertyDescriptor(n,k);w&&w.enumerable||(y[k]=f(n[k],o-1),Object.defineProperty(y,k,{enumerable:!1}))}return y}\"object\"==typeof r&&(o=r.depth,i=r.prototype,c=r.includeNonEnumerable,r=r.circular);var h=[],p=[],d=\"undefined\"!=typeof Buffer;return void 0===r&&(r=!0),void 0===o&&(o=1/0),f(n,o)}function n(t){return Object.prototype.toString.call(t)}function r(t){return\"object\"==typeof t&&\"[object Date]\"===n(t)}function o(t){return\"object\"==typeof t&&\"[object Array]\"===n(t)}function i(t){return\"object\"==typeof t&&\"[object RegExp]\"===n(t)}function l(t){var e=\"\";return t.global&&(e+=\"g\"),t.ignoreCase&&(e+=\"i\"),t.multiline&&(e+=\"m\"),e}var a;try{a=Map}catch(t){a=function(){}}var s;try{s=Set}catch(t){s=function(){}}var u;try{u=Promise}catch(t){u=function(){}}return e.clonePrototype=function(t){if(null===t)return null;var e=function(){};return e.prototype=t,new e},e.__objToStr=n,e.__isDate=r,e.__isArray=o,e.__isRegExp=i,e.__getRegExpFlags=l,e}();\"object\"==typeof t&&t.exports&&(t.exports=n)},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}function i(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function l(t,e){try{e.parentNode}catch(t){return!1}return e instanceof Text&&(e=e.parentNode),t.contains(e)}Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=e.Range=void 0;var a=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError(\"Invalid attempt to destructure non-iterable instance\")}}(),s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(0),c=r(u),f=n(21),h=r(f),p=n(12),d=r(p),y=n(9),v=r(y),b=n(10),g=r(b),m=(0,g.default)(\"quill:selection\"),_=function t(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;i(this,t),this.index=e,this.length=n},O=function(){function t(e,n){var r=this;i(this,t),this.emitter=n,this.scroll=e,this.composing=!1,this.mouseDown=!1,this.root=this.scroll.domNode,this.cursor=c.default.create(\"cursor\",this),this.lastRange=this.savedRange=new _(0,0),this.handleComposition(),this.handleDragging(),this.emitter.listenDOM(\"selectionchange\",document,function(){r.mouseDown||setTimeout(r.update.bind(r,v.default.sources.USER),1)}),this.emitter.on(v.default.events.EDITOR_CHANGE,function(t,e){t===v.default.events.TEXT_CHANGE&&e.length()>0&&r.update(v.default.sources.SILENT)}),this.emitter.on(v.default.events.SCROLL_BEFORE_UPDATE,function(){if(r.hasFocus()){var t=r.getNativeRange();null!=t&&t.start.node!==r.cursor.textNode&&r.emitter.once(v.default.events.SCROLL_UPDATE,function(){try{r.setNativeRange(t.start.node,t.start.offset,t.end.node,t.end.offset)}catch(t){}})}}),this.emitter.on(v.default.events.SCROLL_OPTIMIZE,function(t,e){if(e.range){var n=e.range,o=n.startNode,i=n.startOffset,l=n.endNode,a=n.endOffset;r.setNativeRange(o,i,l,a)}}),this.update(v.default.sources.SILENT)}return s(t,[{key:\"handleComposition\",value:function(){var t=this;this.root.addEventListener(\"compositionstart\",function(){t.composing=!0}),this.root.addEventListener(\"compositionend\",function(){if(t.composing=!1,t.cursor.parent){var e=t.cursor.restore();if(!e)return;setTimeout(function(){t.setNativeRange(e.startNode,e.startOffset,e.endNode,e.endOffset)},1)}})}},{key:\"handleDragging\",value:function(){var t=this;this.emitter.listenDOM(\"mousedown\",document.body,function(){t.mouseDown=!0}),this.emitter.listenDOM(\"mouseup\",document.body,function(){t.mouseDown=!1,t.update(v.default.sources.USER)})}},{key:\"focus\",value:function(){this.hasFocus()||(this.root.focus(),this.setRange(this.savedRange))}},{key:\"format\",value:function(t,e){if(null==this.scroll.whitelist||this.scroll.whitelist[t]){this.scroll.update();var n=this.getNativeRange();if(null!=n&&n.native.collapsed&&!c.default.query(t,c.default.Scope.BLOCK)){if(n.start.node!==this.cursor.textNode){var r=c.default.find(n.start.node,!1);if(null==r)return;if(r instanceof c.default.Leaf){var o=r.split(n.start.offset);r.parent.insertBefore(this.cursor,o)}else r.insertBefore(this.cursor,n.start.node);this.cursor.attach()}this.cursor.format(t,e),this.scroll.optimize(),this.setNativeRange(this.cursor.textNode,this.cursor.textNode.data.length),this.update()}}}},{key:\"getBounds\",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=this.scroll.length();t=Math.min(t,n-1),e=Math.min(t+e,n-1)-t;var r=void 0,o=this.scroll.leaf(t),i=a(o,2),l=i[0],s=i[1];if(null==l)return null;var u=l.position(s,!0),c=a(u,2);r=c[0],s=c[1];var f=document.createRange();if(e>0){f.setStart(r,s);var h=this.scroll.leaf(t+e),p=a(h,2);if(l=p[0],s=p[1],null==l)return null;var d=l.position(s,!0),y=a(d,2);return r=y[0],s=y[1],f.setEnd(r,s),f.getBoundingClientRect()}var v=\"left\",b=void 0;return r instanceof Text?(s<r.data.length?(f.setStart(r,s),f.setEnd(r,s+1)):(f.setStart(r,s-1),f.setEnd(r,s),v=\"right\"),b=f.getBoundingClientRect()):(b=l.domNode.getBoundingClientRect(),s>0&&(v=\"right\")),{bottom:b.top+b.height,height:b.height,left:b[v],right:b[v],top:b.top,width:0}}},{key:\"getNativeRange\",value:function(){var t=document.getSelection();if(null==t||t.rangeCount<=0)return null;var e=t.getRangeAt(0);if(null==e)return null;var n=this.normalizeNative(e);return m.info(\"getNativeRange\",n),n}},{key:\"getRange\",value:function(){var t=this.getNativeRange();return null==t?[null,null]:[this.normalizedToRange(t),t]}},{key:\"hasFocus\",value:function(){return document.activeElement===this.root}},{key:\"normalizedToRange\",value:function(t){var e=this,n=[[t.start.node,t.start.offset]];t.native.collapsed||n.push([t.end.node,t.end.offset]);var r=n.map(function(t){var n=a(t,2),r=n[0],o=n[1],i=c.default.find(r,!0),l=i.offset(e.scroll);return 0===o?l:i instanceof c.default.Container?l+i.length():l+i.index(r,o)}),i=Math.min(Math.max.apply(Math,o(r)),this.scroll.length()-1),l=Math.min.apply(Math,[i].concat(o(r)));return new _(l,i-l)}},{key:\"normalizeNative\",value:function(t){if(!l(this.root,t.startContainer)||!t.collapsed&&!l(this.root,t.endContainer))return null;var e={start:{node:t.startContainer,offset:t.startOffset},end:{node:t.endContainer,offset:t.endOffset},native:t};return[e.start,e.end].forEach(function(t){for(var e=t.node,n=t.offset;!(e instanceof Text)&&e.childNodes.length>0;)if(e.childNodes.length>n)e=e.childNodes[n],n=0;else{if(e.childNodes.length!==n)break;e=e.lastChild,n=e instanceof Text?e.data.length:e.childNodes.length+1}t.node=e,t.offset=n}),e}},{key:\"rangeToNative\",value:function(t){var e=this,n=t.collapsed?[t.index]:[t.index,t.index+t.length],r=[],o=this.scroll.length();return n.forEach(function(t,n){t=Math.min(o-1,t);var i=void 0,l=e.scroll.leaf(t),s=a(l,2),u=s[0],c=s[1],f=u.position(c,0!==n),h=a(f,2);i=h[0],c=h[1],r.push(i,c)}),r.length<2&&(r=r.concat(r)),r}},{key:\"scrollIntoView\",value:function(t){var e=this.lastRange;if(null!=e){var n=this.getBounds(e.index,e.length);if(null!=n){var r=this.scroll.length()-1,o=this.scroll.line(Math.min(e.index,r)),i=a(o,1),l=i[0],s=l;if(e.length>0){var u=this.scroll.line(Math.min(e.index+e.length,r));s=a(u,1)[0]}if(null!=l&&null!=s){var c=t.getBoundingClientRect();n.top<c.top?t.scrollTop-=c.top-n.top:n.bottom>c.bottom&&(t.scrollTop+=n.bottom-c.bottom)}}}}},{key:\"setNativeRange\",value:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:t,r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:e,o=arguments.length>4&&void 0!==arguments[4]&&arguments[4];if(m.info(\"setNativeRange\",t,e,n,r),null==t||null!=this.root.parentNode&&null!=t.parentNode&&null!=n.parentNode){var i=document.getSelection();if(null!=i)if(null!=t){this.hasFocus()||this.root.focus();var l=(this.getNativeRange()||{}).native;if(null==l||o||t!==l.startContainer||e!==l.startOffset||n!==l.endContainer||r!==l.endOffset){\"BR\"==t.tagName&&(e=[].indexOf.call(t.parentNode.childNodes,t),t=t.parentNode),\"BR\"==n.tagName&&(r=[].indexOf.call(n.parentNode.childNodes,n),n=n.parentNode);var a=document.createRange();a.setStart(t,e),a.setEnd(n,r),i.removeAllRanges(),i.addRange(a)}}else i.removeAllRanges(),this.root.blur(),document.body.focus()}}},{key:\"setRange\",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:v.default.sources.API;if(\"string\"==typeof e&&(n=e,e=!1),m.info(\"setRange\",t),null!=t){var r=this.rangeToNative(t);this.setNativeRange.apply(this,o(r).concat([e]))}else this.setNativeRange(null);this.update(n)}},{key:\"update\",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:v.default.sources.USER,e=this.lastRange,n=this.getRange(),r=a(n,2),o=r[0],i=r[1];if(this.lastRange=o,null!=this.lastRange&&(this.savedRange=this.lastRange),!(0,d.default)(e,this.lastRange)){var l;!this.composing&&null!=i&&i.native.collapsed&&i.start.node!==this.cursor.textNode&&this.cursor.restore();var s=[v.default.events.SELECTION_CHANGE,(0,h.default)(this.lastRange),(0,h.default)(e),t];if((l=this.emitter).emit.apply(l,[v.default.events.EDITOR_CHANGE].concat(s)),t!==v.default.sources.SILENT){var u;(u=this.emitter).emit.apply(u,s)}}}}]),t}();e.Range=_,e.default=O},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function i(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function l(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0});var a=n(0),s=r(a),u=n(3),c=r(u),f=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),e}(s.default.Container);f.allowedChildren=[c.default,u.BlockEmbed,f],e.default=f},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function o(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function i(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0}),e.ColorStyle=e.ColorClass=e.ColorAttributor=void 0;var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(0),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:\"value\",value:function(t){var n=a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"value\",this).call(this,t);return n.startsWith(\"rgb(\")?(n=n.replace(/^[^\\d]+/,\"\").replace(/[^\\d]+$/,\"\"),\"#\"+n.split(\",\").map(function(t){return(\"00\"+parseInt(t).toString(16)).slice(-2)}).join(\"\")):n}}]),e}(u.default.Attributor.Style),f=new u.default.Attributor.Class(\"color\",\"ql-color\",{scope:u.default.Scope.INLINE}),h=new c(\"color\",\"color\",{scope:u.default.Scope.INLINE});e.ColorAttributor=c,e.ColorClass=f,e.ColorStyle=h},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function l(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function a(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function s(t,e){var n,r=t===D.keys.LEFT?\"prefix\":\"suffix\";return n={key:t,shiftKey:e,altKey:null},o(n,r,/^$/),o(n,\"handler\",function(n){var r=n.index;t===D.keys.RIGHT&&(r+=n.length+1);var o=this.quill.getLeaf(r);return!(b(o,1)[0]instanceof T.default.Embed)||(t===D.keys.LEFT?e?this.quill.setSelection(n.index-1,n.length+1,S.default.sources.USER):this.quill.setSelection(n.index-1,S.default.sources.USER):e?this.quill.setSelection(n.index,n.length+1,S.default.sources.USER):this.quill.setSelection(n.index+n.length+1,S.default.sources.USER),!1)}),n}function u(t,e){if(!(0===t.index||this.quill.getLength()<=1)){var n=this.quill.getLine(t.index),r=b(n,1),o=r[0],i={};if(0===e.offset){var l=this.quill.getLine(t.index-1),a=b(l,1),s=a[0];if(null!=s&&s.length()>1){var u=o.formats(),c=this.quill.getFormat(t.index-1,1);i=A.default.attributes.diff(u,c)||{}}}var f=/[\\uD800-\\uDBFF][\\uDC00-\\uDFFF]$/.test(e.prefix)?2:1;this.quill.deleteText(t.index-f,f,S.default.sources.USER),Object.keys(i).length>0&&this.quill.formatLine(t.index-f,f,i,S.default.sources.USER),this.quill.focus()}}function c(t,e){var n=/^[\\uD800-\\uDBFF][\\uDC00-\\uDFFF]/.test(e.suffix)?2:1;if(!(t.index>=this.quill.getLength()-n)){var r={},o=0,i=this.quill.getLine(t.index),l=b(i,1),a=l[0];if(e.offset>=a.length()-1){var s=this.quill.getLine(t.index+1),u=b(s,1),c=u[0];if(c){var f=a.formats(),h=this.quill.getFormat(t.index,1);r=A.default.attributes.diff(f,h)||{},o=c.length()}}this.quill.deleteText(t.index,n,S.default.sources.USER),Object.keys(r).length>0&&this.quill.formatLine(t.index+o-1,n,r,S.default.sources.USER)}}function f(t){var e=this.quill.getLines(t),n={};if(e.length>1){var r=e[0].formats(),o=e[e.length-1].formats();n=A.default.attributes.diff(o,r)||{}}this.quill.deleteText(t,S.default.sources.USER),Object.keys(n).length>0&&this.quill.formatLine(t.index,1,n,S.default.sources.USER),this.quill.setSelection(t.index,S.default.sources.SILENT),this.quill.focus()}function h(t,e){var n=this;t.length>0&&this.quill.scroll.deleteAt(t.index,t.length);var r=Object.keys(e.format).reduce(function(t,n){return T.default.query(n,T.default.Scope.BLOCK)&&!Array.isArray(e.format[n])&&(t[n]=e.format[n]),t},{});this.quill.insertText(t.index,\"\\n\",r,S.default.sources.USER),this.quill.setSelection(t.index+1,S.default.sources.SILENT),this.quill.focus(),Object.keys(e.format).forEach(function(t){null==r[t]&&(Array.isArray(e.format[t])||\"link\"!==t&&n.quill.format(t,e.format[t],S.default.sources.USER))})}function p(t){return{key:D.keys.TAB,shiftKey:!t,format:{\"code-block\":!0},handler:function(e){var n=T.default.query(\"code-block\"),r=e.index,o=e.length,i=this.quill.scroll.descendant(n,r),l=b(i,2),a=l[0],s=l[1];if(null!=a){var u=this.quill.getIndex(a),c=a.newlineIndex(s,!0)+1,f=a.newlineIndex(u+s+o),h=a.domNode.textContent.slice(c,f).split(\"\\n\");s=0,h.forEach(function(e,i){t?(a.insertAt(c+s,n.TAB),s+=n.TAB.length,0===i?r+=n.TAB.length:o+=n.TAB.length):e.startsWith(n.TAB)&&(a.deleteAt(c+s,n.TAB.length),s-=n.TAB.length,0===i?r-=n.TAB.length:o-=n.TAB.length),s+=e.length+1}),this.quill.update(S.default.sources.USER),this.quill.setSelection(r,o,S.default.sources.SILENT)}}}}function d(t){return{key:t[0].toUpperCase(),shortKey:!0,handler:function(e,n){this.quill.format(t,!n.format[t],S.default.sources.USER)}}}function y(t){if(\"string\"==typeof t||\"number\"==typeof t)return y({key:t});if(\"object\"===(void 0===t?\"undefined\":v(t))&&(t=(0,_.default)(t,!1)),\"string\"==typeof t.key)if(null!=D.keys[t.key.toUpperCase()])t.key=D.keys[t.key.toUpperCase()];else{if(1!==t.key.length)return null;t.key=t.key.toUpperCase().charCodeAt(0)}return t.shortKey&&(t[B]=t.shortKey,delete t.shortKey),t}Object.defineProperty(e,\"__esModule\",{value:!0}),e.SHORTKEY=e.default=void 0;var v=\"function\"==typeof Symbol&&\"symbol\"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&\"function\"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?\"symbol\":typeof t},b=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError(\"Invalid attempt to destructure non-iterable instance\")}}(),g=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),m=n(21),_=r(m),O=n(12),w=r(O),x=n(2),k=r(x),E=n(4),N=r(E),j=n(20),A=r(j),q=n(0),T=r(q),P=n(6),S=r(P),C=n(10),L=r(C),M=n(7),R=r(M),I=(0,L.default)(\"quill:keyboard\"),B=/Mac/i.test(navigator.platform)?\"metaKey\":\"ctrlKey\",D=function(t){function e(t,n){i(this,e);var r=l(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.bindings={},Object.keys(r.options.bindings).forEach(function(e){(\"list autofill\"!==e||null==t.scroll.whitelist||t.scroll.whitelist.list)&&r.options.bindings[e]&&r.addBinding(r.options.bindings[e])}),r.addBinding({key:e.keys.ENTER,shiftKey:null},h),r.addBinding({key:e.keys.ENTER,metaKey:null,ctrlKey:null,altKey:null},function(){}),/Firefox/i.test(navigator.userAgent)?(r.addBinding({key:e.keys.BACKSPACE},{collapsed:!0},u),r.addBinding({key:e.keys.DELETE},{collapsed:!0},c)):(r.addBinding({key:e.keys.BACKSPACE},{collapsed:!0,prefix:/^.?$/},u),r.addBinding({key:e.keys.DELETE},{collapsed:!0,suffix:/^.?$/},c)),r.addBinding({key:e.keys.BACKSPACE},{collapsed:!1},f),r.addBinding({key:e.keys.DELETE},{collapsed:!1},f),r.addBinding({key:e.keys.BACKSPACE,altKey:null,ctrlKey:null,metaKey:null,shiftKey:null},{collapsed:!0,offset:0},u),r.listen(),r}return a(e,t),g(e,null,[{key:\"match\",value:function(t,e){return e=y(e),![\"altKey\",\"ctrlKey\",\"metaKey\",\"shiftKey\"].some(function(n){return!!e[n]!==t[n]&&null!==e[n]})&&e.key===(t.which||t.keyCode)}}]),g(e,[{key:\"addBinding\",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=y(t);if(null==r||null==r.key)return I.warn(\"Attempted to add invalid keyboard binding\",r);\"function\"==typeof e&&(e={handler:e}),\"function\"==typeof n&&(n={handler:n}),r=(0,k.default)(r,e,n),this.bindings[r.key]=this.bindings[r.key]||[],this.bindings[r.key].push(r)}},{key:\"listen\",value:function(){var t=this;this.quill.root.addEventListener(\"keydown\",function(n){if(!n.defaultPrevented){var r=n.which||n.keyCode,o=(t.bindings[r]||[]).filter(function(t){return e.match(n,t)});if(0!==o.length){var i=t.quill.getSelection();if(null!=i&&t.quill.hasFocus()){var l=t.quill.getLine(i.index),a=b(l,2),s=a[0],u=a[1],c=t.quill.getLeaf(i.index),f=b(c,2),h=f[0],p=f[1],d=0===i.length?[h,p]:t.quill.getLeaf(i.index+i.length),y=b(d,2),g=y[0],m=y[1],_=h instanceof T.default.Text?h.value().slice(0,p):\"\",O=g instanceof T.default.Text?g.value().slice(m):\"\",x={collapsed:0===i.length,empty:0===i.length&&s.length()<=1,format:t.quill.getFormat(i),offset:u,prefix:_,suffix:O};o.some(function(e){if(null!=e.collapsed&&e.collapsed!==x.collapsed)return!1;if(null!=e.empty&&e.empty!==x.empty)return!1;if(null!=e.offset&&e.offset!==x.offset)return!1;if(Array.isArray(e.format)){if(e.format.every(function(t){return null==x.format[t]}))return!1}else if(\"object\"===v(e.format)&&!Object.keys(e.format).every(function(t){return!0===e.format[t]?null!=x.format[t]:!1===e.format[t]?null==x.format[t]:(0,w.default)(e.format[t],x.format[t])}))return!1;return!(null!=e.prefix&&!e.prefix.test(x.prefix))&&(!(null!=e.suffix&&!e.suffix.test(x.suffix))&&!0!==e.handler.call(t,i,x))})&&n.preventDefault()}}}})}}]),e}(R.default);D.keys={BACKSPACE:8,TAB:9,ENTER:13,ESCAPE:27,LEFT:37,UP:38,RIGHT:39,DOWN:40,DELETE:46},D.DEFAULTS={bindings:{bold:d(\"bold\"),italic:d(\"italic\"),underline:d(\"underline\"),indent:{key:D.keys.TAB,format:[\"blockquote\",\"indent\",\"list\"],handler:function(t,e){if(e.collapsed&&0!==e.offset)return!0;this.quill.format(\"indent\",\"+1\",S.default.sources.USER)}},outdent:{key:D.keys.TAB,shiftKey:!0,format:[\"blockquote\",\"indent\",\"list\"],handler:function(t,e){if(e.collapsed&&0!==e.offset)return!0;this.quill.format(\"indent\",\"-1\",S.default.sources.USER)}},\"outdent backspace\":{key:D.keys.BACKSPACE,collapsed:!0,shiftKey:null,metaKey:null,ctrlKey:null,altKey:null,format:[\"indent\",\"list\"],offset:0,handler:function(t,e){null!=e.format.indent?this.quill.format(\"indent\",\"-1\",S.default.sources.USER):null!=e.format.list&&this.quill.format(\"list\",!1,S.default.sources.USER)}},\"indent code-block\":p(!0),\"outdent code-block\":p(!1),\"remove tab\":{key:D.keys.TAB,shiftKey:!0,collapsed:!0,prefix:/\\t$/,handler:function(t){this.quill.deleteText(t.index-1,1,S.default.sources.USER)}},tab:{key:D.keys.TAB,handler:function(t){this.quill.history.cutoff();var e=(new N.default).retain(t.index).delete(t.length).insert(\"\\t\");this.quill.updateContents(e,S.default.sources.USER),this.quill.history.cutoff(),this.quill.setSelection(t.index+1,S.default.sources.SILENT)}},\"list empty enter\":{key:D.keys.ENTER,collapsed:!0,format:[\"list\"],empty:!0,handler:function(t,e){this.quill.format(\"list\",!1,S.default.sources.USER),e.format.indent&&this.quill.format(\"indent\",!1,S.default.sources.USER)}},\"checklist enter\":{key:D.keys.ENTER,collapsed:!0,format:{list:\"checked\"},handler:function(t){var e=this.quill.getLine(t.index),n=b(e,2),r=n[0],o=n[1],i=(0,k.default)({},r.formats(),{list:\"checked\"}),l=(new N.default).retain(t.index).insert(\"\\n\",i).retain(r.length()-o-1).retain(1,{list:\"unchecked\"});this.quill.updateContents(l,S.default.sources.USER),this.quill.setSelection(t.index+1,S.default.sources.SILENT),this.quill.scrollIntoView()}},\"header enter\":{key:D.keys.ENTER,collapsed:!0,format:[\"header\"],suffix:/^$/,handler:function(t,e){var n=this.quill.getLine(t.index),r=b(n,2),o=r[0],i=r[1],l=(new N.default).retain(t.index).insert(\"\\n\",e.format).retain(o.length()-i-1).retain(1,{header:null});this.quill.updateContents(l,S.default.sources.USER),this.quill.setSelection(t.index+1,S.default.sources.SILENT),this.quill.scrollIntoView()}},\"list autofill\":{key:\" \",collapsed:!0,format:{list:!1},prefix:/^\\s*?(\\d+\\.|-|\\*|\\[ ?\\]|\\[x\\])$/,handler:function(t,e){var n=e.prefix.length,r=this.quill.getLine(t.index),o=b(r,2),i=o[0],l=o[1];if(l>n)return!0;var a=void 0;switch(e.prefix.trim()){case\"[]\":case\"[ ]\":a=\"unchecked\";break;case\"[x]\":a=\"checked\";break;case\"-\":case\"*\":a=\"bullet\";break;default:a=\"ordered\"}this.quill.insertText(t.index,\" \",S.default.sources.USER),this.quill.history.cutoff();var s=(new N.default).retain(t.index-l).delete(n+1).retain(i.length()-2-l).retain(1,{list:a});this.quill.updateContents(s,S.default.sources.USER),this.quill.history.cutoff(),this.quill.setSelection(t.index-n,S.default.sources.SILENT)}},\"code exit\":{key:D.keys.ENTER,collapsed:!0,format:[\"code-block\"],prefix:/\\n\\n$/,suffix:/^\\s+$/,handler:function(t){var e=this.quill.getLine(t.index),n=b(e,2),r=n[0],o=n[1],i=(new N.default).retain(t.index+r.length()-o-2).retain(1,{\"code-block\":null}).delete(1);this.quill.updateContents(i,S.default.sources.USER)}},\"embed left\":s(D.keys.LEFT,!1),\"embed left shift\":s(D.keys.LEFT,!0),\"embed right\":s(D.keys.RIGHT,!1),\"embed right shift\":s(D.keys.RIGHT,!0)}},e.default=D,e.SHORTKEY=B},function(t,e,n){\"use strict\";t.exports={align:{\"\":n(75),center:n(76),right:n(77),justify:n(78)},background:n(79),blockquote:n(80),bold:n(81),clean:n(82),code:n(40),\"code-block\":n(40),color:n(83),direction:{\"\":n(84),rtl:n(85)},float:{center:n(86),full:n(87),left:n(88),right:n(89)},formula:n(90),header:{1:n(91),2:n(92)},italic:n(93),image:n(94),indent:{\"+1\":n(95),\"-1\":n(96)},link:n(97),list:{ordered:n(98),bullet:n(99),check:n(100)},script:{sub:n(101),super:n(102)},strike:n(103),underline:n(104),video:n(105)}},function(t,e,n){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0});var r=n(1),o=function(){function t(t){this.domNode=t,this.domNode[r.DATA_KEY]={blot:this}}return Object.defineProperty(t.prototype,\"statics\",{get:function(){return this.constructor},enumerable:!0,configurable:!0}),t.create=function(t){if(null==this.tagName)throw new r.ParchmentError(\"Blot definition missing tagName\");var e;return Array.isArray(this.tagName)?(\"string\"==typeof t&&(t=t.toUpperCase(),parseInt(t).toString()===t&&(t=parseInt(t))),e=\"number\"==typeof t?document.createElement(this.tagName[t-1]):this.tagName.indexOf(t)>-1?document.createElement(t):document.createElement(this.tagName[0])):e=document.createElement(this.tagName),this.className&&e.classList.add(this.className),e},t.prototype.attach=function(){null!=this.parent&&(this.scroll=this.parent.scroll)},t.prototype.clone=function(){var t=this.domNode.cloneNode(!1);return r.create(t)},t.prototype.detach=function(){null!=this.parent&&this.parent.removeChild(this),delete this.domNode[r.DATA_KEY]},t.prototype.deleteAt=function(t,e){this.isolate(t,e).remove()},t.prototype.formatAt=function(t,e,n,o){var i=this.isolate(t,e);if(null!=r.query(n,r.Scope.BLOT)&&o)i.wrap(n,o);else if(null!=r.query(n,r.Scope.ATTRIBUTE)){var l=r.create(this.statics.scope);i.wrap(l),l.format(n,o)}},t.prototype.insertAt=function(t,e,n){var o=null==n?r.create(\"text\",e):r.create(e,n),i=this.split(t);this.parent.insertBefore(o,i)},t.prototype.insertInto=function(t,e){void 0===e&&(e=null),null!=this.parent&&this.parent.children.remove(this);var n=null;t.children.insertBefore(this,e),null!=e&&(n=e.domNode),this.domNode.parentNode==t.domNode&&this.domNode.nextSibling==n||t.domNode.insertBefore(this.domNode,n),this.parent=t,this.attach()},t.prototype.isolate=function(t,e){var n=this.split(t);return n.split(e),n},t.prototype.length=function(){return 1},t.prototype.offset=function(t){return void 0===t&&(t=this.parent),null==this.parent||this==t?0:this.parent.children.offset(this)+this.parent.offset(t)},t.prototype.optimize=function(t){null!=this.domNode[r.DATA_KEY]&&delete this.domNode[r.DATA_KEY].mutations},t.prototype.remove=function(){null!=this.domNode.parentNode&&this.domNode.parentNode.removeChild(this.domNode),this.detach()},t.prototype.replace=function(t){null!=t.parent&&(t.parent.insertBefore(this,t.next),t.remove())},t.prototype.replaceWith=function(t,e){var n=\"string\"==typeof t?r.create(t,e):t;return n.replace(this),n},t.prototype.split=function(t,e){return 0===t?this:this.next},t.prototype.update=function(t,e){},t.prototype.wrap=function(t,e){var n=\"string\"==typeof t?r.create(t,e):t;return null!=this.parent&&this.parent.insertBefore(n,this.next),n.appendChild(this),n},t.blotName=\"abstract\",t}();e.default=o},function(t,e,n){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0});var r=n(11),o=n(29),i=n(30),l=n(1),a=function(){function t(t){this.attributes={},this.domNode=t,this.build()}return t.prototype.attribute=function(t,e){e?t.add(this.domNode,e)&&(null!=t.value(this.domNode)?this.attributes[t.attrName]=t:delete this.attributes[t.attrName]):(t.remove(this.domNode),delete this.attributes[t.attrName])},t.prototype.build=function(){var t=this;this.attributes={};var e=r.default.keys(this.domNode),n=o.default.keys(this.domNode),a=i.default.keys(this.domNode);e.concat(n).concat(a).forEach(function(e){var n=l.query(e,l.Scope.ATTRIBUTE);n instanceof r.default&&(t.attributes[n.attrName]=n)})},t.prototype.copy=function(t){var e=this;Object.keys(this.attributes).forEach(function(n){var r=e.attributes[n].value(e.domNode);t.format(n,r)})},t.prototype.move=function(t){var e=this;this.copy(t),Object.keys(this.attributes).forEach(function(t){e.attributes[t].remove(e.domNode)}),this.attributes={}},t.prototype.values=function(){var t=this;return Object.keys(this.attributes).reduce(function(e,n){return e[n]=t.attributes[n].value(t.domNode),e},{})},t}();e.default=a},function(t,e,n){\"use strict\";function r(t,e){return(t.getAttribute(\"class\")||\"\").split(/\\s+/).filter(function(t){return 0===t.indexOf(e+\"-\")})}var o=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,\"__esModule\",{value:!0});var i=n(11),l=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.keys=function(t){return(t.getAttribute(\"class\")||\"\").split(/\\s+/).map(function(t){return t.split(\"-\").slice(0,-1).join(\"-\")})},e.prototype.add=function(t,e){return!!this.canAdd(t,e)&&(this.remove(t),t.classList.add(this.keyName+\"-\"+e),!0)},e.prototype.remove=function(t){r(t,this.keyName).forEach(function(e){t.classList.remove(e)}),0===t.classList.length&&t.removeAttribute(\"class\")},e.prototype.value=function(t){var e=r(t,this.keyName)[0]||\"\",n=e.slice(this.keyName.length+1);return this.canAdd(t,n)?n:\"\"},e}(i.default);e.default=l},function(t,e,n){\"use strict\";function r(t){var e=t.split(\"-\"),n=e.slice(1).map(function(t){return t[0].toUpperCase()+t.slice(1)}).join(\"\");return e[0]+n}var o=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,\"__esModule\",{value:!0});var i=n(11),l=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.keys=function(t){return(t.getAttribute(\"style\")||\"\").split(\";\").map(function(t){return t.split(\":\")[0].trim()})},e.prototype.add=function(t,e){return!!this.canAdd(t,e)&&(t.style[r(this.keyName)]=e,!0)},e.prototype.remove=function(t){t.style[r(this.keyName)]=\"\",t.getAttribute(\"style\")||t.removeAttribute(\"style\")},e.prototype.value=function(t){var e=t.style[r(this.keyName)];return this.canAdd(t,e)?e:\"\"},e}(i.default);e.default=l},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function i(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function l(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0});var a=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError(\"Invalid attempt to destructure non-iterable instance\")}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),c=n(0),f=r(c),h=n(8),p=r(h),d=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return r.selection=n,r.textNode=document.createTextNode(e.CONTENTS),r.domNode.appendChild(r.textNode),r._length=0,r}return l(e,t),u(e,null,[{key:\"value\",value:function(){}}]),u(e,[{key:\"detach\",value:function(){null!=this.parent&&this.parent.removeChild(this)}},{key:\"format\",value:function(t,n){if(0!==this._length)return s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"format\",this).call(this,t,n);for(var r=this,o=0;null!=r&&r.statics.scope!==f.default.Scope.BLOCK_BLOT;)o+=r.offset(r.parent),r=r.parent;null!=r&&(this._length=e.CONTENTS.length,r.optimize(),r.formatAt(o,e.CONTENTS.length,t,n),this._length=0)}},{key:\"index\",value:function(t,n){return t===this.textNode?0:s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"index\",this).call(this,t,n)}},{key:\"length\",value:function(){return this._length}},{key:\"position\",value:function(){return[this.textNode,this.textNode.data.length]}},{key:\"remove\",value:function(){s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"remove\",this).call(this),this.parent=null}},{key:\"restore\",value:function(){if(!this.selection.composing&&null!=this.parent){var t=this.textNode,n=this.selection.getNativeRange(),r=void 0,o=void 0,i=void 0;if(null!=n&&n.start.node===t&&n.end.node===t){var l=[t,n.start.offset,n.end.offset];r=l[0],o=l[1],i=l[2]}for(;null!=this.domNode.lastChild&&this.domNode.lastChild!==this.textNode;)this.domNode.parentNode.insertBefore(this.domNode.lastChild,this.domNode);if(this.textNode.data!==e.CONTENTS){var s=this.textNode.data.split(e.CONTENTS).join(\"\");this.next instanceof p.default?(r=this.next.domNode,this.next.insertAt(0,s),this.textNode.data=e.CONTENTS):(this.textNode.data=s,this.parent.insertBefore(f.default.create(this.textNode),this),this.textNode=document.createTextNode(e.CONTENTS),this.domNode.appendChild(this.textNode))}if(this.remove(),null!=o){var u=[o,i].map(function(t){return Math.max(0,Math.min(r.data.length,t-1))}),c=a(u,2);return o=c[0],i=c[1],{startNode:r,startOffset:o,endNode:r,endOffset:i}}}}},{key:\"update\",value:function(t,e){var n=this;if(t.some(function(t){return\"characterData\"===t.type&&t.target===n.textNode})){var r=this.restore();r&&(e.range=r)}}},{key:\"value\",value:function(){return\"\"}}]),e}(f.default.Embed);d.blotName=\"cursor\",d.className=\"ql-cursor\",d.tagName=\"span\",d.CONTENTS=\"\\ufeff\",e.default=d},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}Object.defineProperty(e,\"__esModule\",{value:!0});var o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function(){function t(e,n){r(this,t),this.quill=e,this.options=n,this.modules={}}return o(t,[{key:\"init\",value:function(){var t=this;Object.keys(this.options.modules).forEach(function(e){null==t.modules[e]&&t.addModule(e)})}},{key:\"addModule\",value:function(t){var e=this.quill.constructor.import(\"modules/\"+t);return this.modules[t]=new e(this.quill,this.options.modules[t]||{}),this.modules[t]}}]),t}();i.DEFAULTS={modules:{}},i.themes={default:i},e.default=i},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function i(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function l(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0});var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=n(0),c=r(u),f=n(8),h=r(f),p=\"\\ufeff\",d=function(t){function e(t){o(this,e);var n=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return n.contentNode=document.createElement(\"span\"),n.contentNode.setAttribute(\"contenteditable\",!1),[].slice.call(n.domNode.childNodes).forEach(function(t){n.contentNode.appendChild(t)}),n.leftGuard=document.createTextNode(p),n.rightGuard=document.createTextNode(p),n.domNode.appendChild(n.leftGuard),n.domNode.appendChild(n.contentNode),n.domNode.appendChild(n.rightGuard),n}return l(e,t),a(e,[{key:\"index\",value:function(t,n){return t===this.leftGuard?0:t===this.rightGuard?1:s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"index\",this).call(this,t,n)}},{key:\"restore\",value:function(t){var e=void 0,n=void 0,r=t.data.split(p).join(\"\");if(t===this.leftGuard)if(this.prev instanceof h.default){var o=this.prev.length();this.prev.insertAt(o,r),e={startNode:this.prev.domNode,startOffset:o+r.length}}else n=document.createTextNode(r),this.parent.insertBefore(c.default.create(n),this),e={startNode:n,startOffset:r.length};else t===this.rightGuard&&(this.next instanceof h.default?(this.next.insertAt(0,r),e={startNode:this.next.domNode,startOffset:r.length}):(n=document.createTextNode(r),this.parent.insertBefore(c.default.create(n),this.next),e={startNode:n,startOffset:r.length}));return t.data=p,e}},{key:\"update\",value:function(t,e){var n=this;t.forEach(function(t){if(\"characterData\"===t.type&&(t.target===n.leftGuard||t.target===n.rightGuard)){var r=n.restore(t.target);r&&(e.range=r)}})}}]),e}(c.default.Embed);e.default=d},function(t,e,n){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.AlignStyle=e.AlignClass=e.AlignAttribute=void 0;var r=n(0),o=function(t){return t&&t.__esModule?t:{default:t}}(r),i={scope:o.default.Scope.BLOCK,whitelist:[\"right\",\"center\",\"justify\"]},l=new o.default.Attributor.Attribute(\"align\",\"align\",i),a=new o.default.Attributor.Class(\"align\",\"ql-align\",i),s=new o.default.Attributor.Style(\"align\",\"text-align\",i);e.AlignAttribute=l,e.AlignClass=a,e.AlignStyle=s},function(t,e,n){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.BackgroundStyle=e.BackgroundClass=void 0;var r=n(0),o=function(t){return t&&t.__esModule?t:{default:t}}(r),i=n(24),l=new o.default.Attributor.Class(\"background\",\"ql-bg\",{scope:o.default.Scope.INLINE}),a=new i.ColorAttributor(\"background\",\"background-color\",{scope:o.default.Scope.INLINE});e.BackgroundClass=l,e.BackgroundStyle=a},function(t,e,n){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.DirectionStyle=e.DirectionClass=e.DirectionAttribute=void 0;var r=n(0),o=function(t){return t&&t.__esModule?t:{default:t}}(r),i={scope:o.default.Scope.BLOCK,whitelist:[\"rtl\"]},l=new o.default.Attributor.Attribute(\"direction\",\"dir\",i),a=new o.default.Attributor.Class(\"direction\",\"ql-direction\",i),s=new o.default.Attributor.Style(\"direction\",\"direction\",i);e.DirectionAttribute=l,e.DirectionClass=a,e.DirectionStyle=s},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function o(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function i(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0}),e.FontClass=e.FontStyle=void 0;var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(0),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c={scope:u.default.Scope.INLINE,whitelist:[\"serif\",\"monospace\"]},f=new u.default.Attributor.Class(\"font\",\"ql-font\",c),h=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:\"value\",value:function(t){return a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"value\",this).call(this,t).replace(/[\"']/g,\"\")}}]),e}(u.default.Attributor.Style),p=new h(\"font\",\"font-family\",c);e.FontStyle=p,e.FontClass=f},function(t,e,n){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.SizeStyle=e.SizeClass=void 0;var r=n(0),o=function(t){return t&&t.__esModule?t:{default:t}}(r),i=new o.default.Attributor.Class(\"size\",\"ql-size\",{scope:o.default.Scope.INLINE,whitelist:[\"small\",\"large\",\"huge\"]}),l=new o.default.Attributor.Style(\"size\",\"font-size\",{scope:o.default.Scope.INLINE,whitelist:[\"10px\",\"18px\",\"32px\"]});e.SizeClass=i,e.SizeStyle=l},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function o(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function i(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(5),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:\"optimize\",value:function(t){a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"optimize\",this).call(this,t),this.domNode.tagName!==this.statics.tagName[0]&&this.replaceWith(this.statics.blotName)}}],[{key:\"create\",value:function(){return a(e.__proto__||Object.getPrototypeOf(e),\"create\",this).call(this)}},{key:\"formats\",value:function(){return!0}}]),e}(u.default);c.blotName=\"bold\",c.tagName=[\"STRONG\",\"B\"],e.default=c},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>'},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function o(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function i(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(16),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(t,n){r(this,e);var i=o(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return i.label.innerHTML=n,i.container.classList.add(\"ql-color-picker\"),[].slice.call(i.container.querySelectorAll(\".ql-picker-item\"),0,7).forEach(function(t){t.classList.add(\"ql-primary\")}),i}return i(e,t),l(e,[{key:\"buildItem\",value:function(t){var n=a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"buildItem\",this).call(this,t);return n.style.backgroundColor=t.getAttribute(\"value\")||\"\",n}},{key:\"selectItem\",value:function(t,n){a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"selectItem\",this).call(this,t,n);var r=this.label.querySelector(\".ql-color-label\"),o=t?t.getAttribute(\"data-value\")||\"\":\"\";r&&(\"line\"===r.tagName?r.style.stroke=o:r.style.fill=o)}}]),e}(u.default);e.default=c},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function o(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function i(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(16),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(t,n){r(this,e);var i=o(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return i.container.classList.add(\"ql-icon-picker\"),[].forEach.call(i.container.querySelectorAll(\".ql-picker-item\"),function(t){t.innerHTML=n[t.getAttribute(\"data-value\")||\"\"]}),i.defaultItem=i.container.querySelector(\".ql-selected\"),i.selectItem(i.defaultItem),i}return i(e,t),l(e,[{key:\"selectItem\",value:function(t,n){a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"selectItem\",this).call(this,t,n),t=t||this.defaultItem,this.label.innerHTML=t.innerHTML}}]),e}(u.default);e.default=c},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}Object.defineProperty(e,\"__esModule\",{value:!0});var o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function(){function t(e,n){var o=this;r(this,t),this.quill=e,this.boundsContainer=n||document.body,this.root=e.addContainer(\"ql-tooltip\"),this.root.innerHTML=this.constructor.TEMPLATE,this.quill.root===this.quill.scrollingContainer&&this.quill.root.addEventListener(\"scroll\",function(){o.root.style.marginTop=-1*o.quill.root.scrollTop+\"px\"}),this.hide()}return o(t,[{key:\"hide\",value:function(){this.root.classList.add(\"ql-hidden\")}},{key:\"position\",value:function(t){var e=t.left+t.width/2-this.root.offsetWidth/2,n=t.bottom+this.quill.root.scrollTop;this.root.style.left=e+\"px\",this.root.style.top=n+\"px\",this.root.classList.remove(\"ql-flip\");var r=this.boundsContainer.getBoundingClientRect(),o=this.root.getBoundingClientRect(),i=0;if(o.right>r.right&&(i=r.right-o.right,this.root.style.left=e+i+\"px\"),o.left<r.left&&(i=r.left-o.left,this.root.style.left=e+i+\"px\"),o.bottom>r.bottom){var l=o.bottom-o.top,a=t.bottom-t.top+l;this.root.style.top=n-a+\"px\",this.root.classList.add(\"ql-flip\")}return i}},{key:\"show\",value:function(){this.root.classList.remove(\"ql-editing\"),this.root.classList.remove(\"ql-hidden\")}}]),t}();e.default=i},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function i(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function l(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function a(t){var e=t.match(/^(?:(https?):\\/\\/)?(?:(?:www|m)\\.)?youtube\\.com\\/watch.*v=([a-zA-Z0-9_-]+)/)||t.match(/^(?:(https?):\\/\\/)?(?:(?:www|m)\\.)?youtu\\.be\\/([a-zA-Z0-9_-]+)/);return e?(e[1]||\"https\")+\"://www.youtube.com/embed/\"+e[2]+\"?showinfo=0\":(e=t.match(/^(?:(https?):\\/\\/)?(?:www\\.)?vimeo\\.com\\/(\\d+)/))?(e[1]||\"https\")+\"://player.vimeo.com/video/\"+e[2]+\"/\":t}function s(t,e){var n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];e.forEach(function(e){var r=document.createElement(\"option\");e===n?r.setAttribute(\"selected\",\"selected\"):r.setAttribute(\"value\",e),t.appendChild(r)})}Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=e.BaseTooltip=void 0;var u=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),c=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},f=n(2),h=r(f),p=n(4),d=r(p),y=n(9),v=r(y),b=n(25),g=r(b),m=n(32),_=r(m),O=n(41),w=r(O),x=n(42),k=r(x),E=n(16),N=r(E),j=n(43),A=r(j),q=[!1,\"center\",\"right\",\"justify\"],T=[\"#000000\",\"#e60000\",\"#ff9900\",\"#ffff00\",\"#008a00\",\"#0066cc\",\"#9933ff\",\"#ffffff\",\"#facccc\",\"#ffebcc\",\"#ffffcc\",\"#cce8cc\",\"#cce0f5\",\"#ebd6ff\",\"#bbbbbb\",\"#f06666\",\"#ffc266\",\"#ffff66\",\"#66b966\",\"#66a3e0\",\"#c285ff\",\"#888888\",\"#a10000\",\"#b26b00\",\"#b2b200\",\"#006100\",\"#0047b2\",\"#6b24b2\",\"#444444\",\"#5c0000\",\"#663d00\",\"#666600\",\"#003700\",\"#002966\",\"#3d1466\"],P=[!1,\"serif\",\"monospace\"],S=[\"1\",\"2\",\"3\",!1],C=[\"small\",!1,\"large\",\"huge\"],L=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n)),l=function e(n){if(!document.body.contains(t.root))return document.body.removeEventListener(\"click\",e);null==r.tooltip||r.tooltip.root.contains(n.target)||document.activeElement===r.tooltip.textbox||r.quill.hasFocus()||r.tooltip.hide(),null!=r.pickers&&r.pickers.forEach(function(t){t.container.contains(n.target)||t.close()})};return t.emitter.listenDOM(\"click\",document.body,l),r}return l(e,t),u(e,[{key:\"addModule\",value:function(t){var n=c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"addModule\",this).call(this,t);return\"toolbar\"===t&&this.extendToolbar(n),n}},{key:\"buildButtons\",value:function(t,e){t.forEach(function(t){(t.getAttribute(\"class\")||\"\").split(/\\s+/).forEach(function(n){if(n.startsWith(\"ql-\")&&(n=n.slice(\"ql-\".length),null!=e[n]))if(\"direction\"===n)t.innerHTML=e[n][\"\"]+e[n].rtl;else if(\"string\"==typeof e[n])t.innerHTML=e[n];else{var r=t.value||\"\";null!=r&&e[n][r]&&(t.innerHTML=e[n][r])}})})}},{key:\"buildPickers\",value:function(t,e){var n=this;this.pickers=t.map(function(t){if(t.classList.contains(\"ql-align\"))return null==t.querySelector(\"option\")&&s(t,q),new k.default(t,e.align);if(t.classList.contains(\"ql-background\")||t.classList.contains(\"ql-color\")){var n=t.classList.contains(\"ql-background\")?\"background\":\"color\";return null==t.querySelector(\"option\")&&s(t,T,\"background\"===n?\"#ffffff\":\"#000000\"),new w.default(t,e[n])}return null==t.querySelector(\"option\")&&(t.classList.contains(\"ql-font\")?s(t,P):t.classList.contains(\"ql-header\")?s(t,S):t.classList.contains(\"ql-size\")&&s(t,C)),new N.default(t)});var r=function(){n.pickers.forEach(function(t){t.update()})};this.quill.on(v.default.events.EDITOR_CHANGE,r)}}]),e}(_.default);L.DEFAULTS=(0,h.default)(!0,{},_.default.DEFAULTS,{modules:{toolbar:{handlers:{formula:function(){this.quill.theme.tooltip.edit(\"formula\")},image:function(){var t=this,e=this.container.querySelector(\"input.ql-image[type=file]\");null==e&&(e=document.createElement(\"input\"),e.setAttribute(\"type\",\"file\"),e.setAttribute(\"accept\",\"image/png, image/gif, image/jpeg, image/bmp, image/x-icon\"),e.classList.add(\"ql-image\"),e.addEventListener(\"change\",function(){if(null!=e.files&&null!=e.files[0]){var n=new FileReader;n.onload=function(n){var r=t.quill.getSelection(!0);t.quill.updateContents((new d.default).retain(r.index).delete(r.length).insert({image:n.target.result}),v.default.sources.USER),t.quill.setSelection(r.index+1,v.default.sources.SILENT),e.value=\"\"},n.readAsDataURL(e.files[0])}}),this.container.appendChild(e)),e.click()},video:function(){this.quill.theme.tooltip.edit(\"video\")}}}}});var M=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.textbox=r.root.querySelector('input[type=\"text\"]'),r.listen(),r}return l(e,t),u(e,[{key:\"listen\",value:function(){var t=this;this.textbox.addEventListener(\"keydown\",function(e){g.default.match(e,\"enter\")?(t.save(),e.preventDefault()):g.default.match(e,\"escape\")&&(t.cancel(),e.preventDefault())})}},{key:\"cancel\",value:function(){this.hide()}},{key:\"edit\",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:\"link\",e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;this.root.classList.remove(\"ql-hidden\"),this.root.classList.add(\"ql-editing\"),null!=e?this.textbox.value=e:t!==this.root.getAttribute(\"data-mode\")&&(this.textbox.value=\"\"),this.position(this.quill.getBounds(this.quill.selection.savedRange)),this.textbox.select(),this.textbox.setAttribute(\"placeholder\",this.textbox.getAttribute(\"data-\"+t)||\"\"),this.root.setAttribute(\"data-mode\",t)}},{key:\"restoreFocus\",value:function(){var t=this.quill.scrollingContainer.scrollTop;this.quill.focus(),this.quill.scrollingContainer.scrollTop=t}},{key:\"save\",value:function(){var t=this.textbox.value;switch(this.root.getAttribute(\"data-mode\")){case\"link\":var e=this.quill.root.scrollTop;this.linkRange?(this.quill.formatText(this.linkRange,\"link\",t,v.default.sources.USER),delete this.linkRange):(this.restoreFocus(),this.quill.format(\"link\",t,v.default.sources.USER)),this.quill.root.scrollTop=e;break;case\"video\":t=a(t);case\"formula\":if(!t)break;var n=this.quill.getSelection(!0);if(null!=n){var r=n.index+n.length;this.quill.insertEmbed(r,this.root.getAttribute(\"data-mode\"),t,v.default.sources.USER),\"formula\"===this.root.getAttribute(\"data-mode\")&&this.quill.insertText(r+1,\" \",v.default.sources.USER),this.quill.setSelection(r+2,v.default.sources.USER)}}this.textbox.value=\"\",this.hide()}}]),e}(A.default);e.BaseTooltip=M,e.default=L},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,\"__esModule\",{value:!0});var o=n(46),i=r(o),l=n(34),a=n(36),s=n(62),u=n(63),c=r(u),f=n(64),h=r(f),p=n(65),d=r(p),y=n(35),v=n(24),b=n(37),g=n(38),m=n(39),_=r(m),O=n(66),w=r(O),x=n(15),k=r(x),E=n(67),N=r(E),j=n(68),A=r(j),q=n(69),T=r(q),P=n(70),S=r(P),C=n(71),L=r(C),M=n(13),R=r(M),I=n(72),B=r(I),D=n(73),U=r(D),F=n(74),H=r(F),K=n(26),z=r(K),V=n(16),Z=r(V),W=n(41),G=r(W),Y=n(42),X=r(Y),$=n(43),Q=r($),J=n(107),tt=r(J),et=n(108),nt=r(et);i.default.register({\"attributors/attribute/direction\":a.DirectionAttribute,\"attributors/class/align\":l.AlignClass,\"attributors/class/background\":y.BackgroundClass,\"attributors/class/color\":v.ColorClass,\"attributors/class/direction\":a.DirectionClass,\"attributors/class/font\":b.FontClass,\"attributors/class/size\":g.SizeClass,\"attributors/style/align\":l.AlignStyle,\"attributors/style/background\":y.BackgroundStyle,\"attributors/style/color\":v.ColorStyle,\"attributors/style/direction\":a.DirectionStyle,\"attributors/style/font\":b.FontStyle,\"attributors/style/size\":g.SizeStyle},!0),i.default.register({\"formats/align\":l.AlignClass,\"formats/direction\":a.DirectionClass,\"formats/indent\":s.IndentClass,\"formats/background\":y.BackgroundStyle,\"formats/color\":v.ColorStyle,\"formats/font\":b.FontClass,\"formats/size\":g.SizeClass,\"formats/blockquote\":c.default,\"formats/code-block\":R.default,\"formats/header\":h.default,\"formats/list\":d.default,\"formats/bold\":_.default,\"formats/code\":M.Code,\"formats/italic\":w.default,\"formats/link\":k.default,\"formats/script\":N.default,\"formats/strike\":A.default,\"formats/underline\":T.default,\"formats/image\":S.default,\"formats/video\":L.default,\"formats/list/item\":p.ListItem,\"modules/formula\":B.default,\"modules/syntax\":U.default,\"modules/toolbar\":H.default,\"themes/bubble\":tt.default,\"themes/snow\":nt.default,\"ui/icons\":z.default,\"ui/picker\":Z.default,\"ui/icon-picker\":X.default,\"ui/color-picker\":G.default,\"ui/tooltip\":Q.default},!0),e.default=i.default},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,\"__esModule\",{value:!0});var o=n(0),i=r(o),l=n(6),a=r(l),s=n(3),u=r(s),c=n(14),f=r(c),h=n(23),p=r(h),d=n(31),y=r(d),v=n(33),b=r(v),g=n(5),m=r(g),_=n(59),O=r(_),w=n(8),x=r(w),k=n(60),E=r(k),N=n(61),j=r(N),A=n(25),q=r(A);a.default.register({\"blots/block\":u.default,\"blots/block/embed\":s.BlockEmbed,\"blots/break\":f.default,\"blots/container\":p.default,\"blots/cursor\":y.default,\"blots/embed\":b.default,\"blots/inline\":m.default,\"blots/scroll\":O.default,\"blots/text\":x.default,\"modules/clipboard\":E.default,\"modules/history\":j.default,\"modules/keyboard\":q.default}),i.default.register(u.default,f.default,y.default,m.default,O.default,x.default),e.default=a.default},function(t,e,n){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0});var r=function(){function t(){this.head=this.tail=null,this.length=0}return t.prototype.append=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];this.insertBefore(t[0],null),t.length>1&&this.append.apply(this,t.slice(1))},t.prototype.contains=function(t){for(var e,n=this.iterator();e=n();)if(e===t)return!0;return!1},t.prototype.insertBefore=function(t,e){t&&(t.next=e,null!=e?(t.prev=e.prev,null!=e.prev&&(e.prev.next=t),e.prev=t,e===this.head&&(this.head=t)):null!=this.tail?(this.tail.next=t,t.prev=this.tail,this.tail=t):(t.prev=null,this.head=this.tail=t),this.length+=1)},t.prototype.offset=function(t){for(var e=0,n=this.head;null!=n;){if(n===t)return e;e+=n.length(),n=n.next}return-1},t.prototype.remove=function(t){this.contains(t)&&(null!=t.prev&&(t.prev.next=t.next),null!=t.next&&(t.next.prev=t.prev),t===this.head&&(this.head=t.next),t===this.tail&&(this.tail=t.prev),this.length-=1)},t.prototype.iterator=function(t){return void 0===t&&(t=this.head),function(){var e=t;return null!=t&&(t=t.next),e}},t.prototype.find=function(t,e){void 0===e&&(e=!1);for(var n,r=this.iterator();n=r();){var o=n.length();if(t<o||e&&t===o&&(null==n.next||0!==n.next.length()))return[n,t];t-=o}return[null,0]},t.prototype.forEach=function(t){for(var e,n=this.iterator();e=n();)t(e)},t.prototype.forEachAt=function(t,e,n){if(!(e<=0))for(var r,o=this.find(t),i=o[0],l=o[1],a=t-l,s=this.iterator(i);(r=s())&&a<t+e;){var u=r.length();t>a?n(r,t-a,Math.min(e,a+u-t)):n(r,0,Math.min(u,t+e-a)),a+=u}},t.prototype.map=function(t){return this.reduce(function(e,n){return e.push(t(n)),e},[])},t.prototype.reduce=function(t,e){for(var n,r=this.iterator();n=r();)e=t(e,n);return e},t}();e.default=r},function(t,e,n){\"use strict\";var r=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,\"__esModule\",{value:!0});var o=n(17),i=n(1),l={attributes:!0,characterData:!0,characterDataOldValue:!0,childList:!0,subtree:!0},a=function(t){function e(e){var n=t.call(this,e)||this;return n.scroll=n,n.observer=new MutationObserver(function(t){n.update(t)}),n.observer.observe(n.domNode,l),n.attach(),n}return r(e,t),e.prototype.detach=function(){t.prototype.detach.call(this),this.observer.disconnect()},e.prototype.deleteAt=function(e,n){this.update(),0===e&&n===this.length()?this.children.forEach(function(t){t.remove()}):t.prototype.deleteAt.call(this,e,n)},e.prototype.formatAt=function(e,n,r,o){this.update(),t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.insertAt=function(e,n,r){this.update(),t.prototype.insertAt.call(this,e,n,r)},e.prototype.optimize=function(e,n){var r=this;void 0===e&&(e=[]),void 0===n&&(n={}),t.prototype.optimize.call(this,n);for(var l=[].slice.call(this.observer.takeRecords());l.length>0;)e.push(l.pop());for(var a=function(t,e){void 0===e&&(e=!0),null!=t&&t!==r&&null!=t.domNode.parentNode&&(null==t.domNode[i.DATA_KEY].mutations&&(t.domNode[i.DATA_KEY].mutations=[]),e&&a(t.parent))},s=function(t){null!=t.domNode[i.DATA_KEY]&&null!=t.domNode[i.DATA_KEY].mutations&&(t instanceof o.default&&t.children.forEach(s),t.optimize(n))},u=e,c=0;u.length>0;c+=1){if(c>=100)throw new Error(\"[Parchment] Maximum optimize iterations reached\");for(u.forEach(function(t){var e=i.find(t.target,!0);null!=e&&(e.domNode===t.target&&(\"childList\"===t.type?(a(i.find(t.previousSibling,!1)),[].forEach.call(t.addedNodes,function(t){var e=i.find(t,!1);a(e,!1),e instanceof o.default&&e.children.forEach(function(t){a(t,!1)})})):\"attributes\"===t.type&&a(e.prev)),a(e))}),this.children.forEach(s),u=[].slice.call(this.observer.takeRecords()),l=u.slice();l.length>0;)e.push(l.pop())}},e.prototype.update=function(e,n){var r=this;void 0===n&&(n={}),e=e||this.observer.takeRecords(),e.map(function(t){var e=i.find(t.target,!0);return null==e?null:null==e.domNode[i.DATA_KEY].mutations?(e.domNode[i.DATA_KEY].mutations=[t],e):(e.domNode[i.DATA_KEY].mutations.push(t),null)}).forEach(function(t){null!=t&&t!==r&&null!=t.domNode[i.DATA_KEY]&&t.update(t.domNode[i.DATA_KEY].mutations||[],n)}),null!=this.domNode[i.DATA_KEY].mutations&&t.prototype.update.call(this,this.domNode[i.DATA_KEY].mutations,n),this.optimize(e,n)},e.blotName=\"scroll\",e.defaultChild=\"block\",e.scope=i.Scope.BLOCK_BLOT,e.tagName=\"DIV\",e}(o.default);e.default=a},function(t,e,n){\"use strict\";function r(t,e){if(Object.keys(t).length!==Object.keys(e).length)return!1;for(var n in t)if(t[n]!==e[n])return!1;return!0}var o=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,\"__esModule\",{value:!0});var i=n(18),l=n(1),a=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return o(e,t),e.formats=function(n){if(n.tagName!==e.tagName)return t.formats.call(this,n)},e.prototype.format=function(n,r){var o=this;n!==this.statics.blotName||r?t.prototype.format.call(this,n,r):(this.children.forEach(function(t){t instanceof i.default||(t=t.wrap(e.blotName,!0)),o.attributes.copy(t)}),this.unwrap())},e.prototype.formatAt=function(e,n,r,o){if(null!=this.formats()[r]||l.query(r,l.Scope.ATTRIBUTE)){this.isolate(e,n).format(r,o)}else t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.optimize=function(n){t.prototype.optimize.call(this,n);var o=this.formats();if(0===Object.keys(o).length)return this.unwrap();var i=this.next;i instanceof e&&i.prev===this&&r(o,i.formats())&&(i.moveChildren(this),i.remove())},e.blotName=\"inline\",e.scope=l.Scope.INLINE_BLOT,e.tagName=\"SPAN\",e}(i.default);e.default=a},function(t,e,n){\"use strict\";var r=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,\"__esModule\",{value:!0});var o=n(18),i=n(1),l=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return r(e,t),e.formats=function(n){var r=i.query(e.blotName).tagName;if(n.tagName!==r)return t.formats.call(this,n)},e.prototype.format=function(n,r){null!=i.query(n,i.Scope.BLOCK)&&(n!==this.statics.blotName||r?t.prototype.format.call(this,n,r):this.replaceWith(e.blotName))},e.prototype.formatAt=function(e,n,r,o){null!=i.query(r,i.Scope.BLOCK)?this.format(r,o):t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.insertAt=function(e,n,r){if(null==r||null!=i.query(n,i.Scope.INLINE))t.prototype.insertAt.call(this,e,n,r);else{var o=this.split(e),l=i.create(n,r);o.parent.insertBefore(l,o)}},e.prototype.update=function(e,n){navigator.userAgent.match(/Trident/)?this.build():t.prototype.update.call(this,e,n)},e.blotName=\"block\",e.scope=i.Scope.BLOCK_BLOT,e.tagName=\"P\",e}(o.default);e.default=l},function(t,e,n){\"use strict\";var r=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,\"__esModule\",{value:!0});var o=n(19),i=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return r(e,t),e.formats=function(t){},e.prototype.format=function(e,n){t.prototype.formatAt.call(this,0,this.length(),e,n)},e.prototype.formatAt=function(e,n,r,o){0===e&&n===this.length()?this.format(r,o):t.prototype.formatAt.call(this,e,n,r,o)},e.prototype.formats=function(){return this.statics.formats(this.domNode)},e}(o.default);e.default=i},function(t,e,n){\"use strict\";var r=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])};return function(e,n){function r(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r)}}();Object.defineProperty(e,\"__esModule\",{value:!0});var o=n(19),i=n(1),l=function(t){function e(e){var n=t.call(this,e)||this;return n.text=n.statics.value(n.domNode),n}return r(e,t),e.create=function(t){return document.createTextNode(t)},e.value=function(t){var e=t.data;return e.normalize&&(e=e.normalize()),e},e.prototype.deleteAt=function(t,e){this.domNode.data=this.text=this.text.slice(0,t)+this.text.slice(t+e)},e.prototype.index=function(t,e){return this.domNode===t?e:-1},e.prototype.insertAt=function(e,n,r){null==r?(this.text=this.text.slice(0,e)+n+this.text.slice(e),this.domNode.data=this.text):t.prototype.insertAt.call(this,e,n,r)},e.prototype.length=function(){return this.text.length},e.prototype.optimize=function(n){t.prototype.optimize.call(this,n),this.text=this.statics.value(this.domNode),0===this.text.length?this.remove():this.next instanceof e&&this.next.prev===this&&(this.insertAt(this.length(),this.next.value()),this.next.remove())},e.prototype.position=function(t,e){return void 0===e&&(e=!1),[this.domNode,t]},e.prototype.split=function(t,e){if(void 0===e&&(e=!1),!e){if(0===t)return this;if(t===this.length())return this.next}var n=i.create(this.domNode.splitText(t));return this.parent.insertBefore(n,this.next),this.text=this.statics.value(this.domNode),n},e.prototype.update=function(t,e){var n=this;t.some(function(t){return\"characterData\"===t.type&&t.target===n.domNode})&&(this.text=this.statics.value(this.domNode))},e.prototype.value=function(){return this.text},e.blotName=\"text\",e.scope=i.Scope.INLINE_BLOT,e}(o.default);e.default=l},function(t,e,n){\"use strict\";var r=document.createElement(\"div\");if(r.classList.toggle(\"test-class\",!1),r.classList.contains(\"test-class\")){var o=DOMTokenList.prototype.toggle;DOMTokenList.prototype.toggle=function(t,e){return arguments.length>1&&!this.contains(t)==!e?e:o.call(this,t)}}String.prototype.startsWith||(String.prototype.startsWith=function(t,e){return e=e||0,this.substr(e,t.length)===t}),String.prototype.endsWith||(String.prototype.endsWith=function(t,e){var n=this.toString();(\"number\"!=typeof e||!isFinite(e)||Math.floor(e)!==e||e>n.length)&&(e=n.length),e-=t.length;var r=n.indexOf(t,e);return-1!==r&&r===e}),Array.prototype.find||Object.defineProperty(Array.prototype,\"find\",{value:function(t){if(null===this)throw new TypeError(\"Array.prototype.find called on null or undefined\");if(\"function\"!=typeof t)throw new TypeError(\"predicate must be a function\");for(var e,n=Object(this),r=n.length>>>0,o=arguments[1],i=0;i<r;i++)if(e=n[i],t.call(o,e,i,n))return e}}),document.addEventListener(\"DOMContentLoaded\",function(){document.execCommand(\"enableObjectResizing\",!1,!1),document.execCommand(\"autoUrlDetect\",!1,!1)})},function(t,e){function n(t,e,n){if(t==e)return t?[[v,t]]:[];(n<0||t.length<n)&&(n=null);var o=l(t,e),i=t.substring(0,o);t=t.substring(o),e=e.substring(o),o=a(t,e);var s=t.substring(t.length-o);t=t.substring(0,t.length-o),e=e.substring(0,e.length-o);var c=r(t,e);return i&&c.unshift([v,i]),s&&c.push([v,s]),u(c),null!=n&&(c=f(c,n)),c=h(c)}function r(t,e){var r;if(!t)return[[y,e]];if(!e)return[[d,t]];var i=t.length>e.length?t:e,l=t.length>e.length?e:t,a=i.indexOf(l);if(-1!=a)return r=[[y,i.substring(0,a)],[v,l],[y,i.substring(a+l.length)]],t.length>e.length&&(r[0][0]=r[2][0]=d),r;if(1==l.length)return[[d,t],[y,e]];var u=s(t,e);if(u){var c=u[0],f=u[1],h=u[2],p=u[3],b=u[4],g=n(c,h),m=n(f,p);return g.concat([[v,b]],m)}return o(t,e)}function o(t,e){for(var n=t.length,r=e.length,o=Math.ceil((n+r)/2),l=o,a=2*o,s=new Array(a),u=new Array(a),c=0;c<a;c++)s[c]=-1,u[c]=-1;s[l+1]=0,u[l+1]=0;for(var f=n-r,h=f%2!=0,p=0,v=0,b=0,g=0,m=0;m<o;m++){for(var _=-m+p;_<=m-v;_+=2){var O,w=l+_;O=_==-m||_!=m&&s[w-1]<s[w+1]?s[w+1]:s[w-1]+1;for(var x=O-_;O<n&&x<r&&t.charAt(O)==e.charAt(x);)O++,x++;if(s[w]=O,O>n)v+=2;else if(x>r)p+=2;else if(h){var k=l+f-_;if(k>=0&&k<a&&-1!=u[k]){var E=n-u[k];if(O>=E)return i(t,e,O,x)}}}for(var N=-m+b;N<=m-g;N+=2){var E,k=l+N;E=N==-m||N!=m&&u[k-1]<u[k+1]?u[k+1]:u[k-1]+1;for(var j=E-N;E<n&&j<r&&t.charAt(n-E-1)==e.charAt(r-j-1);)E++,j++;if(u[k]=E,E>n)g+=2;else if(j>r)b+=2;else if(!h){var w=l+f-N;if(w>=0&&w<a&&-1!=s[w]){var O=s[w],x=l+O-w;if(E=n-E,O>=E)return i(t,e,O,x)}}}}return[[d,t],[y,e]]}function i(t,e,r,o){var i=t.substring(0,r),l=e.substring(0,o),a=t.substring(r),s=e.substring(o),u=n(i,l),c=n(a,s);return u.concat(c)}function l(t,e){if(!t||!e||t.charAt(0)!=e.charAt(0))return 0;for(var n=0,r=Math.min(t.length,e.length),o=r,i=0;n<o;)t.substring(i,o)==e.substring(i,o)?(n=o,i=n):r=o,o=Math.floor((r-n)/2+n);return o}function a(t,e){if(!t||!e||t.charAt(t.length-1)!=e.charAt(e.length-1))return 0;for(var n=0,r=Math.min(t.length,e.length),o=r,i=0;n<o;)t.substring(t.length-o,t.length-i)==e.substring(e.length-o,e.length-i)?(n=o,i=n):r=o,o=Math.floor((r-n)/2+n);return o}function s(t,e){function n(t,e,n){for(var r,o,i,s,u=t.substring(n,n+Math.floor(t.length/4)),c=-1,f=\"\";-1!=(c=e.indexOf(u,c+1));){var h=l(t.substring(n),e.substring(c)),p=a(t.substring(0,n),e.substring(0,c));f.length<p+h&&(f=e.substring(c-p,c)+e.substring(c,c+h),r=t.substring(0,n-p),o=t.substring(n+h),i=e.substring(0,c-p),s=e.substring(c+h))}return 2*f.length>=t.length?[r,o,i,s,f]:null}var r=t.length>e.length?t:e,o=t.length>e.length?e:t;if(r.length<4||2*o.length<r.length)return null;var i,s=n(r,o,Math.ceil(r.length/4)),u=n(r,o,Math.ceil(r.length/2));if(!s&&!u)return null;i=u?s&&s[4].length>u[4].length?s:u:s;var c,f,h,p;return t.length>e.length?(c=i[0],f=i[1],h=i[2],p=i[3]):(h=i[0],p=i[1],c=i[2],f=i[3]),[c,f,h,p,i[4]]}function u(t){t.push([v,\"\"]);for(var e,n=0,r=0,o=0,i=\"\",s=\"\";n<t.length;)switch(t[n][0]){case y:o++,s+=t[n][1],n++;break;case d:r++,i+=t[n][1],n++;break;case v:r+o>1?(0!==r&&0!==o&&(e=l(s,i),0!==e&&(n-r-o>0&&t[n-r-o-1][0]==v?t[n-r-o-1][1]+=s.substring(0,e):(t.splice(0,0,[v,s.substring(0,e)]),n++),s=s.substring(e),i=i.substring(e)),0!==(e=a(s,i))&&(t[n][1]=s.substring(s.length-e)+t[n][1],s=s.substring(0,s.length-e),i=i.substring(0,i.length-e))),0===r?t.splice(n-o,r+o,[y,s]):0===o?t.splice(n-r,r+o,[d,i]):t.splice(n-r-o,r+o,[d,i],[y,s]),n=n-r-o+(r?1:0)+(o?1:0)+1):0!==n&&t[n-1][0]==v?(t[n-1][1]+=t[n][1],t.splice(n,1)):n++,o=0,r=0,i=\"\",s=\"\"}\"\"===t[t.length-1][1]&&t.pop();var c=!1;for(n=1;n<t.length-1;)t[n-1][0]==v&&t[n+1][0]==v&&(t[n][1].substring(t[n][1].length-t[n-1][1].length)==t[n-1][1]?(t[n][1]=t[n-1][1]+t[n][1].substring(0,t[n][1].length-t[n-1][1].length),t[n+1][1]=t[n-1][1]+t[n+1][1],t.splice(n-1,1),c=!0):t[n][1].substring(0,t[n+1][1].length)==t[n+1][1]&&(t[n-1][1]+=t[n+1][1],t[n][1]=t[n][1].substring(t[n+1][1].length)+t[n+1][1],t.splice(n+1,1),c=!0)),n++;c&&u(t)}function c(t,e){if(0===e)return[v,t];for(var n=0,r=0;r<t.length;r++){var o=t[r];if(o[0]===d||o[0]===v){var i=n+o[1].length;if(e===i)return[r+1,t];if(e<i){t=t.slice();var l=e-n,a=[o[0],o[1].slice(0,l)],s=[o[0],o[1].slice(l)];return t.splice(r,1,a,s),[r+1,t]}n=i}}throw new Error(\"cursor_pos is out of bounds!\")}function f(t,e){var n=c(t,e),r=n[1],o=n[0],i=r[o],l=r[o+1];if(null==i)return t;if(i[0]!==v)return t;if(null!=l&&i[1]+l[1]===l[1]+i[1])return r.splice(o,2,l,i),p(r,o,2);if(null!=l&&0===l[1].indexOf(i[1])){r.splice(o,2,[l[0],i[1]],[0,i[1]]);var a=l[1].slice(i[1].length);return a.length>0&&r.splice(o+2,0,[l[0],a]),p(r,o,3)}return t}function h(t){for(var e=!1,n=function(t){return t.charCodeAt(0)>=56320&&t.charCodeAt(0)<=57343},r=2;r<t.length;r+=1)t[r-2][0]===v&&function(t){return t.charCodeAt(t.length-1)>=55296&&t.charCodeAt(t.length-1)<=56319}(t[r-2][1])&&t[r-1][0]===d&&n(t[r-1][1])&&t[r][0]===y&&n(t[r][1])&&(e=!0,t[r-1][1]=t[r-2][1].slice(-1)+t[r-1][1],t[r][1]=t[r-2][1].slice(-1)+t[r][1],t[r-2][1]=t[r-2][1].slice(0,-1));if(!e)return t;for(var o=[],r=0;r<t.length;r+=1)t[r][1].length>0&&o.push(t[r]);return o}function p(t,e,n){for(var r=e+n-1;r>=0&&r>=e-1;r--)if(r+1<t.length){var o=t[r],i=t[r+1];o[0]===i[1]&&t.splice(r,2,[o[0],o[1]+i[1]])}return t}var d=-1,y=1,v=0,b=n;b.INSERT=y,b.DELETE=d,b.EQUAL=v,t.exports=b},function(t,e){function n(t){var e=[];for(var n in t)e.push(n);return e}e=t.exports=\"function\"==typeof Object.keys?Object.keys:n,e.shim=n},function(t,e){function n(t){return\"[object Arguments]\"==Object.prototype.toString.call(t)}function r(t){return t&&\"object\"==typeof t&&\"number\"==typeof t.length&&Object.prototype.hasOwnProperty.call(t,\"callee\")&&!Object.prototype.propertyIsEnumerable.call(t,\"callee\")||!1}var o=\"[object Arguments]\"==function(){return Object.prototype.toString.call(arguments)}();e=t.exports=o?n:r,e.supported=n,e.unsupported=r},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function l(t,e){return Object.keys(e).reduce(function(n,r){return null==t[r]?n:(e[r]===t[r]?n[r]=e[r]:Array.isArray(e[r])?e[r].indexOf(t[r])<0&&(n[r]=e[r].concat([t[r]])):n[r]=[e[r],t[r]],n)},{})}function a(t){return t.reduce(function(t,e){if(1===e.insert){var n=(0,N.default)(e.attributes);return delete n.image,t.insert({image:e.attributes.image},n)}if(null==e.attributes||!0!==e.attributes.list&&!0!==e.attributes.bullet||(e=(0,N.default)(e),e.attributes.list?e.attributes.list=\"ordered\":(e.attributes.list=\"bullet\",delete e.attributes.bullet)),\"string\"==typeof e.insert){var r=e.insert.replace(/\\r\\n/g,\"\\n\").replace(/\\r/g,\"\\n\");return t.insert(r,e.attributes)}return t.push(e)},new h.default)}Object.defineProperty(e,\"__esModule\",{value:!0});var s=\"function\"==typeof Symbol&&\"symbol\"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&\"function\"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?\"symbol\":typeof t},u=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError(\"Invalid attempt to destructure non-iterable instance\")}}(),c=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),f=n(4),h=r(f),p=n(20),d=r(p),y=n(0),v=r(y),b=n(13),g=r(b),m=n(31),_=r(m),O=n(3),w=r(O),x=n(14),k=r(x),E=n(21),N=r(E),j=n(12),A=r(j),q=n(2),T=r(q),P=/^[ -~]*$/,S=function(){function t(e){i(this,t),this.scroll=e,this.delta=this.getDelta()}return c(t,[{key:\"applyDelta\",value:function(t){var e=this,n=!1;this.scroll.update();var r=this.scroll.length();return this.scroll.batchStart(),t=a(t),t.reduce(function(t,o){var i=o.retain||o.delete||o.insert.length||1,l=o.attributes||{};if(null!=o.insert){if(\"string\"==typeof o.insert){var a=o.insert;a.endsWith(\"\\n\")&&n&&(n=!1,a=a.slice(0,-1)),t>=r&&!a.endsWith(\"\\n\")&&(n=!0),e.scroll.insertAt(t,a);var c=e.scroll.line(t),f=u(c,2),h=f[0],p=f[1],y=(0,T.default)({},(0,O.bubbleFormats)(h));if(h instanceof w.default){var b=h.descendant(v.default.Leaf,p),g=u(b,1),m=g[0];y=(0,T.default)(y,(0,O.bubbleFormats)(m))}l=d.default.attributes.diff(y,l)||{}}else if(\"object\"===s(o.insert)){var _=Object.keys(o.insert)[0];if(null==_)return t;e.scroll.insertAt(t,_,o.insert[_])}r+=i}return Object.keys(l).forEach(function(n){e.scroll.formatAt(t,i,n,l[n])}),t+i},0),t.reduce(function(t,n){return\"number\"==typeof n.delete?(e.scroll.deleteAt(t,n.delete),t):t+(n.retain||n.insert.length||1)},0),this.scroll.batchEnd(),this.update(t)}},{key:\"deleteText\",value:function(t,e){return this.scroll.deleteAt(t,e),this.update((new h.default).retain(t).delete(e))}},{key:\"formatLine\",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return this.scroll.update(),Object.keys(r).forEach(function(o){if(null==n.scroll.whitelist||n.scroll.whitelist[o]){var i=n.scroll.lines(t,Math.max(e,1)),l=e;i.forEach(function(e){var i=e.length();if(e instanceof g.default){var a=t-e.offset(n.scroll),s=e.newlineIndex(a+l)-a+1;e.formatAt(a,s,o,r[o])}else e.format(o,r[o]);l-=i})}}),this.scroll.optimize(),this.update((new h.default).retain(t).retain(e,(0,N.default)(r)))}},{key:\"formatText\",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return Object.keys(r).forEach(function(o){n.scroll.formatAt(t,e,o,r[o])}),this.update((new h.default).retain(t).retain(e,(0,N.default)(r)))}},{key:\"getContents\",value:function(t,e){return this.delta.slice(t,t+e)}},{key:\"getDelta\",value:function(){return this.scroll.lines().reduce(function(t,e){return t.concat(e.delta())},new h.default)}},{key:\"getFormat\",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=[],r=[];0===e?this.scroll.path(t).forEach(function(t){var e=u(t,1),o=e[0];o instanceof w.default?n.push(o):o instanceof v.default.Leaf&&r.push(o)}):(n=this.scroll.lines(t,e),r=this.scroll.descendants(v.default.Leaf,t,e));var o=[n,r].map(function(t){if(0===t.length)return{};for(var e=(0,O.bubbleFormats)(t.shift());Object.keys(e).length>0;){var n=t.shift();if(null==n)return e;e=l((0,O.bubbleFormats)(n),e)}return e});return T.default.apply(T.default,o)}},{key:\"getText\",value:function(t,e){return this.getContents(t,e).filter(function(t){return\"string\"==typeof t.insert}).map(function(t){return t.insert}).join(\"\")}},{key:\"insertEmbed\",value:function(t,e,n){return this.scroll.insertAt(t,e,n),this.update((new h.default).retain(t).insert(o({},e,n)))}},{key:\"insertText\",value:function(t,e){var n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return e=e.replace(/\\r\\n/g,\"\\n\").replace(/\\r/g,\"\\n\"),this.scroll.insertAt(t,e),Object.keys(r).forEach(function(o){n.scroll.formatAt(t,e.length,o,r[o])}),this.update((new h.default).retain(t).insert(e,(0,N.default)(r)))}},{key:\"isBlank\",value:function(){if(0==this.scroll.children.length)return!0;if(this.scroll.children.length>1)return!1;var t=this.scroll.children.head;return t.statics.blotName===w.default.blotName&&(!(t.children.length>1)&&t.children.head instanceof k.default)}},{key:\"removeFormat\",value:function(t,e){var n=this.getText(t,e),r=this.scroll.line(t+e),o=u(r,2),i=o[0],l=o[1],a=0,s=new h.default;null!=i&&(a=i instanceof g.default?i.newlineIndex(l)-l+1:i.length()-l,s=i.delta().slice(l,l+a-1).insert(\"\\n\"));var c=this.getContents(t,e+a),f=c.diff((new h.default).insert(n).concat(s)),p=(new h.default).retain(t).concat(f);return this.applyDelta(p)}},{key:\"update\",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0,r=this.delta;if(1===e.length&&\"characterData\"===e[0].type&&e[0].target.data.match(P)&&v.default.find(e[0].target)){var o=v.default.find(e[0].target),i=(0,O.bubbleFormats)(o),l=o.offset(this.scroll),a=e[0].oldValue.replace(_.default.CONTENTS,\"\"),s=(new h.default).insert(a),u=(new h.default).insert(o.value());t=(new h.default).retain(l).concat(s.diff(u,n)).reduce(function(t,e){return e.insert?t.insert(e.insert,i):t.push(e)},new h.default),this.delta=r.compose(t)}else this.delta=this.getDelta(),t&&(0,A.default)(r.compose(t),this.delta)||(t=r.diff(this.delta,n));return t}}]),t}();e.default=S},function(t,e){\"use strict\";function n(){}function r(t,e,n){this.fn=t,this.context=e,this.once=n||!1}function o(){this._events=new n,this._eventsCount=0}var i=Object.prototype.hasOwnProperty,l=\"~\";Object.create&&(n.prototype=Object.create(null),(new n).__proto__||(l=!1)),o.prototype.eventNames=function(){var t,e,n=[];if(0===this._eventsCount)return n;for(e in t=this._events)i.call(t,e)&&n.push(l?e.slice(1):e);return Object.getOwnPropertySymbols?n.concat(Object.getOwnPropertySymbols(t)):n},o.prototype.listeners=function(t,e){var n=l?l+t:t,r=this._events[n];if(e)return!!r;if(!r)return[];if(r.fn)return[r.fn];for(var o=0,i=r.length,a=new Array(i);o<i;o++)a[o]=r[o].fn;return a},o.prototype.emit=function(t,e,n,r,o,i){var a=l?l+t:t;if(!this._events[a])return!1;var s,u,c=this._events[a],f=arguments.length;if(c.fn){switch(c.once&&this.removeListener(t,c.fn,void 0,!0),f){case 1:return c.fn.call(c.context),!0;case 2:return c.fn.call(c.context,e),!0;case 3:return c.fn.call(c.context,e,n),!0;case 4:return c.fn.call(c.context,e,n,r),!0;case 5:return c.fn.call(c.context,e,n,r,o),!0;case 6:return c.fn.call(c.context,e,n,r,o,i),!0}for(u=1,s=new Array(f-1);u<f;u++)s[u-1]=arguments[u];c.fn.apply(c.context,s)}else{var h,p=c.length;for(u=0;u<p;u++)switch(c[u].once&&this.removeListener(t,c[u].fn,void 0,!0),f){case 1:c[u].fn.call(c[u].context);break;case 2:c[u].fn.call(c[u].context,e);break;case 3:c[u].fn.call(c[u].context,e,n);break;case 4:c[u].fn.call(c[u].context,e,n,r);break;default:if(!s)for(h=1,s=new Array(f-1);h<f;h++)s[h-1]=arguments[h];c[u].fn.apply(c[u].context,s)}}return!0},o.prototype.on=function(t,e,n){var o=new r(e,n||this),i=l?l+t:t;return this._events[i]?this._events[i].fn?this._events[i]=[this._events[i],o]:this._events[i].push(o):(this._events[i]=o,this._eventsCount++),this},o.prototype.once=function(t,e,n){var o=new r(e,n||this,!0),i=l?l+t:t;return this._events[i]?this._events[i].fn?this._events[i]=[this._events[i],o]:this._events[i].push(o):(this._events[i]=o,this._eventsCount++),this},o.prototype.removeListener=function(t,e,r,o){var i=l?l+t:t;if(!this._events[i])return this;if(!e)return 0==--this._eventsCount?this._events=new n:delete this._events[i],this;var a=this._events[i];if(a.fn)a.fn!==e||o&&!a.once||r&&a.context!==r||(0==--this._eventsCount?this._events=new n:delete this._events[i]);else{for(var s=0,u=[],c=a.length;s<c;s++)(a[s].fn!==e||o&&!a[s].once||r&&a[s].context!==r)&&u.push(a[s]);u.length?this._events[i]=1===u.length?u[0]:u:0==--this._eventsCount?this._events=new n:delete this._events[i]}return this},o.prototype.removeAllListeners=function(t){var e;return t?(e=l?l+t:t,this._events[e]&&(0==--this._eventsCount?this._events=new n:delete this._events[e])):(this._events=new n,this._eventsCount=0),this},o.prototype.off=o.prototype.removeListener,o.prototype.addListener=o.prototype.on,o.prototype.setMaxListeners=function(){return this},o.prefixed=l,o.EventEmitter=o,void 0!==t&&(t.exports=o)},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function i(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function l(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function a(t){return t instanceof v.default||t instanceof y.BlockEmbed}Object.defineProperty(e,\"__esModule\",{value:!0});var s=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError(\"Invalid attempt to destructure non-iterable instance\")}}(),u=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),c=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},f=n(0),h=r(f),p=n(9),d=r(p),y=n(3),v=r(y),b=n(14),g=r(b),m=n(13),_=r(m),O=n(23),w=r(O),x=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return r.emitter=n.emitter,Array.isArray(n.whitelist)&&(r.whitelist=n.whitelist.reduce(function(t,e){return t[e]=!0,t},{})),r.domNode.addEventListener(\"DOMNodeInserted\",function(){}),r.optimize(),r.enable(),r}return l(e,t),u(e,[{key:\"batchStart\",value:function(){this.batch=!0}},{key:\"batchEnd\",value:function(){this.batch=!1,this.optimize()}},{key:\"deleteAt\",value:function(t,n){var r=this.line(t),o=s(r,2),i=o[0],l=o[1],a=this.line(t+n),u=s(a,1),f=u[0];if(c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"deleteAt\",this).call(this,t,n),null!=f&&i!==f&&l>0){if(i instanceof y.BlockEmbed||f instanceof y.BlockEmbed)return void this.optimize();if(i instanceof _.default){var h=i.newlineIndex(i.length(),!0);if(h>-1&&(i=i.split(h+1))===f)return void this.optimize()}else if(f instanceof _.default){var p=f.newlineIndex(0);p>-1&&f.split(p+1)}var d=f.children.head instanceof g.default?null:f.children.head;i.moveChildren(f,d),i.remove()}this.optimize()}},{key:\"enable\",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];this.domNode.setAttribute(\"contenteditable\",t)}},{key:\"formatAt\",value:function(t,n,r,o){(null==this.whitelist||this.whitelist[r])&&(c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"formatAt\",this).call(this,t,n,r,o),this.optimize())}},{key:\"insertAt\",value:function(t,n,r){if(null==r||null==this.whitelist||this.whitelist[n]){if(t>=this.length())if(null==r||null==h.default.query(n,h.default.Scope.BLOCK)){var o=h.default.create(this.statics.defaultChild);this.appendChild(o),null==r&&n.endsWith(\"\\n\")&&(n=n.slice(0,-1)),o.insertAt(0,n,r)}else{var i=h.default.create(n,r);this.appendChild(i)}else c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"insertAt\",this).call(this,t,n,r);this.optimize()}}},{key:\"insertBefore\",value:function(t,n){if(t.statics.scope===h.default.Scope.INLINE_BLOT){var r=h.default.create(this.statics.defaultChild);r.appendChild(t),t=r}c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"insertBefore\",this).call(this,t,n)}},{key:\"leaf\",value:function(t){return this.path(t).pop()||[null,-1]}},{key:\"line\",value:function(t){return t===this.length()?this.line(t-1):this.descendant(a,t)}},{key:\"lines\",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Number.MAX_VALUE;return function t(e,n,r){var o=[],i=r;return e.children.forEachAt(n,r,function(e,n,r){a(e)?o.push(e):e instanceof h.default.Container&&(o=o.concat(t(e,n,i))),i-=r}),o}(this,t,e)}},{key:\"optimize\",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};!0!==this.batch&&(c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"optimize\",this).call(this,t,n),t.length>0&&this.emitter.emit(d.default.events.SCROLL_OPTIMIZE,t,n))}},{key:\"path\",value:function(t){return c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"path\",this).call(this,t).slice(1)}},{key:\"update\",value:function(t){if(!0!==this.batch){var n=d.default.sources.USER;\"string\"==typeof t&&(n=t),Array.isArray(t)||(t=this.observer.takeRecords()),t.length>0&&this.emitter.emit(d.default.events.SCROLL_BEFORE_UPDATE,n,t),c(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"update\",this).call(this,t.concat([])),t.length>0&&this.emitter.emit(d.default.events.SCROLL_UPDATE,n,t)}}}]),e}(h.default.Scroll);x.blotName=\"scroll\",x.className=\"ql-editor\",x.tagName=\"DIV\",x.defaultChild=\"block\",x.allowedChildren=[v.default,y.BlockEmbed,w.default],e.default=x},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function l(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function a(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function s(t,e,n){return\"object\"===(void 0===e?\"undefined\":x(e))?Object.keys(e).reduce(function(t,n){return s(t,n,e[n])},t):t.reduce(function(t,r){return r.attributes&&r.attributes[e]?t.push(r):t.insert(r.insert,(0,j.default)({},o({},e,n),r.attributes))},new q.default)}function u(t){if(t.nodeType!==Node.ELEMENT_NODE)return{};return t[\"__ql-computed-style\"]||(t[\"__ql-computed-style\"]=window.getComputedStyle(t))}function c(t,e){for(var n=\"\",r=t.ops.length-1;r>=0&&n.length<e.length;--r){var o=t.ops[r];if(\"string\"!=typeof o.insert)break;n=o.insert+n}return n.slice(-1*e.length)===e}function f(t){return 0!==t.childNodes.length&&[\"block\",\"list-item\"].indexOf(u(t).display)>-1}function h(t,e,n){return t.nodeType===t.TEXT_NODE?n.reduce(function(e,n){return n(t,e)},new q.default):t.nodeType===t.ELEMENT_NODE?[].reduce.call(t.childNodes||[],function(r,o){var i=h(o,e,n);return o.nodeType===t.ELEMENT_NODE&&(i=e.reduce(function(t,e){return e(o,t)},i),i=(o[W]||[]).reduce(function(t,e){return e(o,t)},i)),r.concat(i)},new q.default):new q.default}function p(t,e,n){return s(n,t,!0)}function d(t,e){var n=P.default.Attributor.Attribute.keys(t),r=P.default.Attributor.Class.keys(t),o=P.default.Attributor.Style.keys(t),i={};return n.concat(r).concat(o).forEach(function(e){var n=P.default.query(e,P.default.Scope.ATTRIBUTE);null!=n&&(i[n.attrName]=n.value(t),i[n.attrName])||(n=Y[e],null==n||n.attrName!==e&&n.keyName!==e||(i[n.attrName]=n.value(t)||void 0),null==(n=X[e])||n.attrName!==e&&n.keyName!==e||(n=X[e],i[n.attrName]=n.value(t)||void 0))}),Object.keys(i).length>0&&(e=s(e,i)),e}function y(t,e){var n=P.default.query(t);if(null==n)return e;if(n.prototype instanceof P.default.Embed){var r={},o=n.value(t);null!=o&&(r[n.blotName]=o,e=(new q.default).insert(r,n.formats(t)))}else\"function\"==typeof n.formats&&(e=s(e,n.blotName,n.formats(t)));return e}function v(t,e){return c(e,\"\\n\")||e.insert(\"\\n\"),e}function b(){return new q.default}function g(t,e){var n=P.default.query(t);if(null==n||\"list-item\"!==n.blotName||!c(e,\"\\n\"))return e;for(var r=-1,o=t.parentNode;!o.classList.contains(\"ql-clipboard\");)\"list\"===(P.default.query(o)||{}).blotName&&(r+=1),o=o.parentNode;return r<=0?e:e.compose((new q.default).retain(e.length()-1).retain(1,{indent:r}))}function m(t,e){return c(e,\"\\n\")||(f(t)||e.length()>0&&t.nextSibling&&f(t.nextSibling))&&e.insert(\"\\n\"),e}function _(t,e){if(f(t)&&null!=t.nextElementSibling&&!c(e,\"\\n\\n\")){var n=t.offsetHeight+parseFloat(u(t).marginTop)+parseFloat(u(t).marginBottom);t.nextElementSibling.offsetTop>t.offsetTop+1.5*n&&e.insert(\"\\n\")}return e}function O(t,e){var n={},r=t.style||{};return r.fontStyle&&\"italic\"===u(t).fontStyle&&(n.italic=!0),r.fontWeight&&(u(t).fontWeight.startsWith(\"bold\")||parseInt(u(t).fontWeight)>=700)&&(n.bold=!0),Object.keys(n).length>0&&(e=s(e,n)),parseFloat(r.textIndent||0)>0&&(e=(new q.default).insert(\"\\t\").concat(e)),e}function w(t,e){var n=t.data;if(\"O:P\"===t.parentNode.tagName)return e.insert(n.trim());if(0===n.trim().length&&t.parentNode.classList.contains(\"ql-clipboard\"))return e;if(!u(t.parentNode).whiteSpace.startsWith(\"pre\")){var r=function(t,e){return e=e.replace(/[^\\u00a0]/g,\"\"),e.length<1&&t?\" \":e};n=n.replace(/\\r\\n/g,\" \").replace(/\\n/g,\" \"),n=n.replace(/\\s\\s+/g,r.bind(r,!0)),(null==t.previousSibling&&f(t.parentNode)||null!=t.previousSibling&&f(t.previousSibling))&&(n=n.replace(/^\\s+/,r.bind(r,!1))),(null==t.nextSibling&&f(t.parentNode)||null!=t.nextSibling&&f(t.nextSibling))&&(n=n.replace(/\\s+$/,r.bind(r,!1)))}return e.insert(n)}Object.defineProperty(e,\"__esModule\",{value:!0}),e.matchText=e.matchSpacing=e.matchNewline=e.matchBlot=e.matchAttributor=e.default=void 0;var x=\"function\"==typeof Symbol&&\"symbol\"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&\"function\"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?\"symbol\":typeof t},k=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError(\"Invalid attempt to destructure non-iterable instance\")}}(),E=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),N=n(2),j=r(N),A=n(4),q=r(A),T=n(0),P=r(T),S=n(6),C=r(S),L=n(10),M=r(L),R=n(7),I=r(R),B=n(34),D=n(35),U=n(13),F=r(U),H=n(24),K=n(36),z=n(37),V=n(38),Z=(0,M.default)(\"quill:clipboard\"),W=\"__ql-matcher\",G=[[Node.TEXT_NODE,w],[Node.TEXT_NODE,m],[\"br\",v],[Node.ELEMENT_NODE,m],[Node.ELEMENT_NODE,y],[Node.ELEMENT_NODE,_],[Node.ELEMENT_NODE,d],[Node.ELEMENT_NODE,O],[\"li\",g],[\"b\",p.bind(p,\"bold\")],[\"i\",p.bind(p,\"italic\")],[\"style\",b]],Y=[B.AlignAttribute,K.DirectionAttribute].reduce(function(t,e){return t[e.keyName]=e,t},{}),X=[B.AlignStyle,D.BackgroundStyle,H.ColorStyle,K.DirectionStyle,z.FontStyle,V.SizeStyle].reduce(function(t,e){return t[e.keyName]=e,t},{}),$=function(t){function e(t,n){i(this,e);var r=l(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.root.addEventListener(\"paste\",r.onPaste.bind(r)),r.container=r.quill.addContainer(\"ql-clipboard\"),r.container.setAttribute(\"contenteditable\",!0),r.container.setAttribute(\"tabindex\",-1),r.matchers=[],G.concat(r.options.matchers).forEach(function(t){var e=k(t,2),o=e[0],i=e[1];(n.matchVisual||i!==_)&&r.addMatcher(o,i)}),r}return a(e,t),E(e,[{key:\"addMatcher\",value:function(t,e){this.matchers.push([t,e])}},{key:\"convert\",value:function(t){if(\"string\"==typeof t)return this.container.innerHTML=t.replace(/\\>\\r?\\n +\\</g,\"><\"),this.convert();var e=this.quill.getFormat(this.quill.selection.savedRange.index);if(e[F.default.blotName]){var n=this.container.innerText;return this.container.innerHTML=\"\",(new q.default).insert(n,o({},F.default.blotName,e[F.default.blotName]))}var r=this.prepareMatching(),i=k(r,2),l=i[0],a=i[1],s=h(this.container,l,a);return c(s,\"\\n\")&&null==s.ops[s.ops.length-1].attributes&&(s=s.compose((new q.default).retain(s.length()-1).delete(1))),Z.log(\"convert\",this.container.innerHTML,s),this.container.innerHTML=\"\",s}},{key:\"dangerouslyPasteHTML\",value:function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:C.default.sources.API;if(\"string\"==typeof t)this.quill.setContents(this.convert(t),e),this.quill.setSelection(0,C.default.sources.SILENT);else{var r=this.convert(e);this.quill.updateContents((new q.default).retain(t).concat(r),n),this.quill.setSelection(t+r.length(),C.default.sources.SILENT)}}},{key:\"onPaste\",value:function(t){var e=this;if(!t.defaultPrevented&&this.quill.isEnabled()){var n=this.quill.getSelection(),r=(new q.default).retain(n.index),o=this.quill.scrollingContainer.scrollTop;this.container.focus(),this.quill.selection.update(C.default.sources.SILENT),setTimeout(function(){r=r.concat(e.convert()).delete(n.length),e.quill.updateContents(r,C.default.sources.USER),e.quill.setSelection(r.length()-n.length,C.default.sources.SILENT),e.quill.scrollingContainer.scrollTop=o,e.quill.focus()},1)}}},{key:\"prepareMatching\",value:function(){var t=this,e=[],n=[];return this.matchers.forEach(function(r){var o=k(r,2),i=o[0],l=o[1];switch(i){case Node.TEXT_NODE:n.push(l);break;case Node.ELEMENT_NODE:e.push(l);break;default:[].forEach.call(t.container.querySelectorAll(i),function(t){t[W]=t[W]||[],t[W].push(l)})}}),[e,n]}}]),e}(I.default);$.DEFAULTS={matchers:[],matchVisual:!0},e.default=$,e.matchAttributor=d,e.matchBlot=y,e.matchNewline=m,e.matchSpacing=_,e.matchText=w},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function i(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function l(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function a(t){var e=t.ops[t.ops.length-1];return null!=e&&(null!=e.insert?\"string\"==typeof e.insert&&e.insert.endsWith(\"\\n\"):null!=e.attributes&&Object.keys(e.attributes).some(function(t){return null!=f.default.query(t,f.default.Scope.BLOCK)}))}function s(t){var e=t.reduce(function(t,e){return t+=e.delete||0},0),n=t.length()-e;return a(t)&&(n-=1),n}Object.defineProperty(e,\"__esModule\",{value:!0}),e.getLastChangeIndex=e.default=void 0;var u=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),c=n(0),f=r(c),h=n(6),p=r(h),d=n(7),y=r(d),v=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.lastRecorded=0,r.ignoreChange=!1,r.clear(),r.quill.on(p.default.events.EDITOR_CHANGE,function(t,e,n,o){t!==p.default.events.TEXT_CHANGE||r.ignoreChange||(r.options.userOnly&&o!==p.default.sources.USER?r.transform(e):r.record(e,n))}),r.quill.keyboard.addBinding({key:\"Z\",shortKey:!0},r.undo.bind(r)),r.quill.keyboard.addBinding({key:\"Z\",shortKey:!0,shiftKey:!0},r.redo.bind(r)),/Win/i.test(navigator.platform)&&r.quill.keyboard.addBinding({key:\"Y\",shortKey:!0},r.redo.bind(r)),r}return l(e,t),u(e,[{key:\"change\",value:function(t,e){if(0!==this.stack[t].length){var n=this.stack[t].pop();this.stack[e].push(n),this.lastRecorded=0,this.ignoreChange=!0,this.quill.updateContents(n[t],p.default.sources.USER),this.ignoreChange=!1;var r=s(n[t]);this.quill.setSelection(r)}}},{key:\"clear\",value:function(){this.stack={undo:[],redo:[]}}},{key:\"cutoff\",value:function(){this.lastRecorded=0}},{key:\"record\",value:function(t,e){if(0!==t.ops.length){this.stack.redo=[];var n=this.quill.getContents().diff(e),r=Date.now();if(this.lastRecorded+this.options.delay>r&&this.stack.undo.length>0){var o=this.stack.undo.pop();n=n.compose(o.undo),t=o.redo.compose(t)}else this.lastRecorded=r;this.stack.undo.push({redo:t,undo:n}),this.stack.undo.length>this.options.maxStack&&this.stack.undo.shift()}}},{key:\"redo\",value:function(){this.change(\"redo\",\"undo\")}},{key:\"transform\",value:function(t){this.stack.undo.forEach(function(e){e.undo=t.transform(e.undo,!0),e.redo=t.transform(e.redo,!0)}),this.stack.redo.forEach(function(e){e.undo=t.transform(e.undo,!0),e.redo=t.transform(e.redo,!0)})}},{key:\"undo\",value:function(){this.change(\"undo\",\"redo\")}}]),e}(y.default);v.DEFAULTS={delay:1e3,maxStack:100,userOnly:!1},e.default=v,e.getLastChangeIndex=s},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function o(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function i(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0}),e.IndentClass=void 0;var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(0),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:\"add\",value:function(t,n){if(\"+1\"===n||\"-1\"===n){var r=this.value(t)||0;n=\"+1\"===n?r+1:r-1}return 0===n?(this.remove(t),!0):a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"add\",this).call(this,t,n)}},{key:\"canAdd\",value:function(t,n){return a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"canAdd\",this).call(this,t,n)||a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"canAdd\",this).call(this,t,parseInt(n))}},{key:\"value\",value:function(t){return parseInt(a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"value\",this).call(this,t))||void 0}}]),e}(u.default.Attributor.Class),f=new c(\"indent\",\"ql-indent\",{scope:u.default.Scope.BLOCK,whitelist:[1,2,3,4,5,6,7,8]});e.IndentClass=f},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function o(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function i(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0});var l=n(3),a=function(t){return t&&t.__esModule?t:{default:t}}(l),s=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),e}(a.default);s.blotName=\"blockquote\",s.tagName=\"blockquote\",e.default=s},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function o(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function i(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=n(3),s=function(t){return t&&t.__esModule?t:{default:t}}(a),u=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,null,[{key:\"formats\",value:function(t){return this.tagName.indexOf(t.tagName)+1}}]),e}(s.default);u.blotName=\"header\",u.tagName=[\"H1\",\"H2\",\"H3\",\"H4\",\"H5\",\"H6\"],e.default=u},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function l(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function a(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=e.ListItem=void 0;var s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},c=n(0),f=r(c),h=n(3),p=r(h),d=n(23),y=r(d),v=function(t){function e(){return i(this,e),l(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return a(e,t),s(e,[{key:\"format\",value:function(t,n){t!==b.blotName||n?u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"format\",this).call(this,t,n):this.replaceWith(f.default.create(this.statics.scope))}},{key:\"remove\",value:function(){null==this.prev&&null==this.next?this.parent.remove():u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"remove\",this).call(this)}},{key:\"replaceWith\",value:function(t,n){return this.parent.isolate(this.offset(this.parent),this.length()),t===this.parent.statics.blotName?(this.parent.replaceWith(t,n),this):(this.parent.unwrap(),u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"replaceWith\",this).call(this,t,n))}}],[{key:\"formats\",value:function(t){return t.tagName===this.tagName?void 0:u(e.__proto__||Object.getPrototypeOf(e),\"formats\",this).call(this,t)}}]),e}(p.default);v.blotName=\"list-item\",v.tagName=\"LI\";var b=function(t){function e(t){i(this,e);var n=l(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t)),r=function(e){if(e.target.parentNode===t){var r=n.statics.formats(t),o=f.default.find(e.target);\"checked\"===r?o.format(\"list\",\"unchecked\"):\"unchecked\"===r&&o.format(\"list\",\"checked\")}};return t.addEventListener(\"touchstart\",r),t.addEventListener(\"mousedown\",r),n}return a(e,t),s(e,null,[{key:\"create\",value:function(t){var n=\"ordered\"===t?\"OL\":\"UL\",r=u(e.__proto__||Object.getPrototypeOf(e),\"create\",this).call(this,n);return\"checked\"!==t&&\"unchecked\"!==t||r.setAttribute(\"data-checked\",\"checked\"===t),r}},{key:\"formats\",value:function(t){return\"OL\"===t.tagName?\"ordered\":\"UL\"===t.tagName?t.hasAttribute(\"data-checked\")?\"true\"===t.getAttribute(\"data-checked\")?\"checked\":\"unchecked\":\"bullet\":void 0}}]),s(e,[{key:\"format\",value:function(t,e){this.children.length>0&&this.children.tail.format(t,e)}},{key:\"formats\",value:function(){return o({},this.statics.blotName,this.statics.formats(this.domNode))}},{key:\"insertBefore\",value:function(t,n){if(t instanceof v)u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"insertBefore\",this).call(this,t,n);else{var r=null==n?this.length():n.offset(this),o=this.split(r);o.parent.insertBefore(t,o)}}},{key:\"optimize\",value:function(t){u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"optimize\",this).call(this,t);var n=this.next;null!=n&&n.prev===this&&n.statics.blotName===this.statics.blotName&&n.domNode.tagName===this.domNode.tagName&&n.domNode.getAttribute(\"data-checked\")===this.domNode.getAttribute(\"data-checked\")&&(n.moveChildren(this),n.remove())}},{key:\"replace\",value:function(t){if(t.statics.blotName!==this.statics.blotName){var n=f.default.create(this.statics.defaultChild);t.moveChildren(n),this.appendChild(n)}u(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"replace\",this).call(this,t)}}]),e}(y.default);b.blotName=\"list\",b.scope=f.default.Scope.BLOCK_BLOT,b.tagName=[\"OL\",\"UL\"],b.defaultChild=\"list-item\",b.allowedChildren=[v],e.ListItem=v,e.default=b},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function o(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function i(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0});var l=n(39),a=function(t){return t&&t.__esModule?t:{default:t}}(l),s=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),e}(a.default);s.blotName=\"italic\",s.tagName=[\"EM\",\"I\"],e.default=s},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function o(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function i(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(5),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,null,[{key:\"create\",value:function(t){return\"super\"===t?document.createElement(\"sup\"):\"sub\"===t?document.createElement(\"sub\"):a(e.__proto__||Object.getPrototypeOf(e),\"create\",this).call(this,t)}},{key:\"formats\",value:function(t){return\"SUB\"===t.tagName?\"sub\":\"SUP\"===t.tagName?\"super\":void 0}}]),e}(u.default);c.blotName=\"script\",c.tagName=[\"SUB\",\"SUP\"],e.default=c},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function o(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function i(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0});var l=n(5),a=function(t){return t&&t.__esModule?t:{default:t}}(l),s=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),e}(a.default);s.blotName=\"strike\",s.tagName=\"S\",e.default=s},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function o(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function i(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0});var l=n(5),a=function(t){return t&&t.__esModule?t:{default:t}}(l),s=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),e}(a.default);s.blotName=\"underline\",s.tagName=\"U\",e.default=s},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function o(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function i(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(0),u=function(t){return t&&t.__esModule?t:{default:t}}(s),c=n(15),f=[\"alt\",\"height\",\"width\"],h=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:\"format\",value:function(t,n){f.indexOf(t)>-1?n?this.domNode.setAttribute(t,n):this.domNode.removeAttribute(t):a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"format\",this).call(this,t,n)}}],[{key:\"create\",value:function(t){var n=a(e.__proto__||Object.getPrototypeOf(e),\"create\",this).call(this,t);return\"string\"==typeof t&&n.setAttribute(\"src\",this.sanitize(t)),n}},{key:\"formats\",value:function(t){return f.reduce(function(e,n){return t.hasAttribute(n)&&(e[n]=t.getAttribute(n)),e},{})}},{key:\"match\",value:function(t){return/\\.(jpe?g|gif|png)$/.test(t)||/^data:image\\/.+;base64/.test(t)}},{key:\"sanitize\",value:function(t){return(0,c.sanitize)(t,[\"http\",\"https\",\"data\"])?t:\"//:0\"}},{key:\"value\",value:function(t){return t.getAttribute(\"src\")}}]),e}(u.default.Embed);h.blotName=\"image\",h.tagName=\"IMG\",e.default=h},function(t,e,n){\"use strict\";function r(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function o(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function i(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0});var l=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=n(3),u=n(15),c=function(t){return t&&t.__esModule?t:{default:t}}(u),f=[\"height\",\"width\"],h=function(t){function e(){return r(this,e),o(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return i(e,t),l(e,[{key:\"format\",value:function(t,n){f.indexOf(t)>-1?n?this.domNode.setAttribute(t,n):this.domNode.removeAttribute(t):a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"format\",this).call(this,t,n)}}],[{key:\"create\",value:function(t){var n=a(e.__proto__||Object.getPrototypeOf(e),\"create\",this).call(this,t);return n.setAttribute(\"frameborder\",\"0\"),n.setAttribute(\"allowfullscreen\",!0),n.setAttribute(\"src\",this.sanitize(t)),n}},{key:\"formats\",value:function(t){return f.reduce(function(e,n){return t.hasAttribute(n)&&(e[n]=t.getAttribute(n)),e},{})}},{key:\"sanitize\",value:function(t){return c.default.sanitize(t)}},{key:\"value\",value:function(t){return t.getAttribute(\"src\")}}]),e}(s.BlockEmbed);h.blotName=\"video\",h.className=\"ql-video\",h.tagName=\"IFRAME\",e.default=h},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function i(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function l(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=e.FormulaBlot=void 0;var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=n(33),c=r(u),f=n(6),h=r(f),p=n(7),d=r(p),y=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),a(e,null,[{key:\"create\",value:function(t){var n=s(e.__proto__||Object.getPrototypeOf(e),\"create\",this).call(this,t);return\"string\"==typeof t&&(window.katex.render(t,n,{throwOnError:!1,errorColor:\"#f00\"}),n.setAttribute(\"data-value\",t)),n}},{key:\"value\",value:function(t){return t.getAttribute(\"data-value\")}}]),e}(c.default);y.blotName=\"formula\",y.className=\"ql-formula\",y.tagName=\"SPAN\";var v=function(t){function e(){o(this,e);var t=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));if(null==window.katex)throw new Error(\"Formula module requires KaTeX.\");return t}return l(e,t),a(e,null,[{key:\"register\",value:function(){h.default.register(y,!0)}}]),e}(d.default);e.FormulaBlot=y,e.default=v},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function i(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function l(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=e.CodeToken=e.CodeBlock=void 0;var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=n(0),c=r(u),f=n(6),h=r(f),p=n(7),d=r(p),y=n(13),v=r(y),b=function(t){function e(){return o(this,e),i(this,(e.__proto__||Object.getPrototypeOf(e)).apply(this,arguments))}return l(e,t),a(e,[{key:\"replaceWith\",value:function(t){this.domNode.textContent=this.domNode.textContent,this.attach(),s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"replaceWith\",this).call(this,t)}},{key:\"highlight\",value:function(t){var e=this.domNode.textContent;this.cachedText!==e&&((e.trim().length>0||null==this.cachedText)&&(this.domNode.innerHTML=t(e),this.domNode.normalize(),this.attach()),this.cachedText=e)}}]),e}(v.default);b.className=\"ql-syntax\";var g=new c.default.Attributor.Class(\"token\",\"hljs\",{scope:c.default.Scope.INLINE}),m=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));if(\"function\"!=typeof r.options.highlight)throw new Error(\"Syntax module requires highlight.js. Please include the library on the page before Quill.\");var l=null;return r.quill.on(h.default.events.SCROLL_OPTIMIZE,function(){clearTimeout(l),l=setTimeout(function(){r.highlight(),l=null},r.options.interval)}),r.highlight(),r}return l(e,t),a(e,null,[{key:\"register\",value:function(){h.default.register(g,!0),h.default.register(b,!0)}}]),a(e,[{key:\"highlight\",value:function(){var t=this;if(!this.quill.selection.composing){this.quill.update(h.default.sources.USER);var e=this.quill.getSelection();this.quill.scroll.descendants(b).forEach(function(e){e.highlight(t.options.highlight)}),this.quill.update(h.default.sources.SILENT),null!=e&&this.quill.setSelection(e,h.default.sources.SILENT)}}}]),e}(d.default);m.DEFAULTS={highlight:function(){return null==window.hljs?null:function(t){return window.hljs.highlightAuto(t).value}}(),interval:1e3},e.CodeBlock=b,e.CodeToken=g,e.default=m},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function i(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function l(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function a(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function s(t,e,n){var r=document.createElement(\"button\");r.setAttribute(\"type\",\"button\"),r.classList.add(\"ql-\"+e),null!=n&&(r.value=n),t.appendChild(r)}function u(t,e){Array.isArray(e[0])||(e=[e]),e.forEach(function(e){var n=document.createElement(\"span\");n.classList.add(\"ql-formats\"),e.forEach(function(t){if(\"string\"==typeof t)s(n,t);else{var e=Object.keys(t)[0],r=t[e];Array.isArray(r)?c(n,e,r):s(n,e,r)}}),t.appendChild(n)})}function c(t,e,n){var r=document.createElement(\"select\");r.classList.add(\"ql-\"+e),n.forEach(function(t){var e=document.createElement(\"option\");!1!==t?e.setAttribute(\"value\",t):e.setAttribute(\"selected\",\"selected\"),r.appendChild(e)}),t.appendChild(r)}Object.defineProperty(e,\"__esModule\",{value:!0}),e.addControls=e.default=void 0;var f=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError(\"Invalid attempt to destructure non-iterable instance\")}}(),h=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),p=n(4),d=r(p),y=n(0),v=r(y),b=n(6),g=r(b),m=n(10),_=r(m),O=n(7),w=r(O),x=(0,_.default)(\"quill:toolbar\"),k=function(t){function e(t,n){i(this,e);var r=l(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));if(Array.isArray(r.options.container)){var o=document.createElement(\"div\");u(o,r.options.container),t.container.parentNode.insertBefore(o,t.container),r.container=o}else\"string\"==typeof r.options.container?r.container=document.querySelector(r.options.container):r.container=r.options.container;if(!(r.container instanceof HTMLElement)){var a;return a=x.error(\"Container required for toolbar\",r.options),l(r,a)}return r.container.classList.add(\"ql-toolbar\"),r.controls=[],r.handlers={},Object.keys(r.options.handlers).forEach(function(t){r.addHandler(t,r.options.handlers[t])}),[].forEach.call(r.container.querySelectorAll(\"button, select\"),function(t){r.attach(t)}),r.quill.on(g.default.events.EDITOR_CHANGE,function(t,e){t===g.default.events.SELECTION_CHANGE&&r.update(e)}),r.quill.on(g.default.events.SCROLL_OPTIMIZE,function(){var t=r.quill.selection.getRange(),e=f(t,1),n=e[0];r.update(n)}),r}return a(e,t),h(e,[{key:\"addHandler\",value:function(t,e){this.handlers[t]=e}},{key:\"attach\",value:function(t){var e=this,n=[].find.call(t.classList,function(t){return 0===t.indexOf(\"ql-\")});if(n){if(n=n.slice(\"ql-\".length),\"BUTTON\"===t.tagName&&t.setAttribute(\"type\",\"button\"),null==this.handlers[n]){if(null!=this.quill.scroll.whitelist&&null==this.quill.scroll.whitelist[n])return void x.warn(\"ignoring attaching to disabled format\",n,t);if(null==v.default.query(n))return void x.warn(\"ignoring attaching to nonexistent format\",n,t)}var r=\"SELECT\"===t.tagName?\"change\":\"click\";t.addEventListener(r,function(r){var i=void 0;if(\"SELECT\"===t.tagName){if(t.selectedIndex<0)return;var l=t.options[t.selectedIndex];i=!l.hasAttribute(\"selected\")&&(l.value||!1)}else i=!t.classList.contains(\"ql-active\")&&(t.value||!t.hasAttribute(\"value\")),r.preventDefault();e.quill.focus();var a=e.quill.selection.getRange(),s=f(a,1),u=s[0];if(null!=e.handlers[n])e.handlers[n].call(e,i);else if(v.default.query(n).prototype instanceof v.default.Embed){if(!(i=prompt(\"Enter \"+n)))return;e.quill.updateContents((new d.default).retain(u.index).delete(u.length).insert(o({},n,i)),g.default.sources.USER)}else e.quill.format(n,i,g.default.sources.USER);e.update(u)}),this.controls.push([n,t])}}},{key:\"update\",value:function(t){var e=null==t?{}:this.quill.getFormat(t);this.controls.forEach(function(n){var r=f(n,2),o=r[0],i=r[1];if(\"SELECT\"===i.tagName){var l=void 0;if(null==t)l=null;else if(null==e[o])l=i.querySelector(\"option[selected]\");else if(!Array.isArray(e[o])){var a=e[o];\"string\"==typeof a&&(a=a.replace(/\\\"/g,'\\\\\"')),l=i.querySelector('option[value=\"'+a+'\"]')}null==l?(i.value=\"\",i.selectedIndex=-1):l.selected=!0}else if(null==t)i.classList.remove(\"ql-active\");else if(i.hasAttribute(\"value\")){var s=e[o]===i.getAttribute(\"value\")||null!=e[o]&&e[o].toString()===i.getAttribute(\"value\")||null==e[o]&&!i.getAttribute(\"value\");i.classList.toggle(\"ql-active\",s)}else i.classList.toggle(\"ql-active\",null!=e[o])})}}]),e}(w.default);k.DEFAULTS={},k.DEFAULTS={container:null,handlers:{clean:function(){var t=this,e=this.quill.getSelection();if(null!=e)if(0==e.length){var n=this.quill.getFormat();Object.keys(n).forEach(function(e){null!=v.default.query(e,v.default.Scope.INLINE)&&t.quill.format(e,!1)})}else this.quill.removeFormat(e,g.default.sources.USER)},direction:function(t){var e=this.quill.getFormat().align;\"rtl\"===t&&null==e?this.quill.format(\"align\",\"right\",g.default.sources.USER):t||\"right\"!==e||this.quill.format(\"align\",!1,g.default.sources.USER),this.quill.format(\"direction\",t,g.default.sources.USER)},indent:function(t){var e=this.quill.getSelection(),n=this.quill.getFormat(e),r=parseInt(n.indent||0);if(\"+1\"===t||\"-1\"===t){var o=\"+1\"===t?1:-1;\"rtl\"===n.direction&&(o*=-1),this.quill.format(\"indent\",r+o,g.default.sources.USER)}},link:function(t){!0===t&&(t=prompt(\"Enter link URL:\")),this.quill.format(\"link\",t,g.default.sources.USER)},list:function(t){var e=this.quill.getSelection(),n=this.quill.getFormat(e);\"check\"===t?\"checked\"===n.list||\"unchecked\"===n.list?this.quill.format(\"list\",!1,g.default.sources.USER):this.quill.format(\"list\",\"unchecked\",g.default.sources.USER):this.quill.format(\"list\",t,g.default.sources.USER)}}},e.default=k,e.addControls=u},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>'},function(t,e){t.exports='<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>'},function(t,e){t.exports='<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>'},function(t,e){t.exports='<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>'},function(t,e){t.exports='<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>'},function(t,e){t.exports='<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>'},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function i(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function l(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0}),e.default=e.BubbleTooltip=void 0;var a=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},s=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(2),c=r(u),f=n(9),h=r(f),p=n(44),d=r(p),y=n(22),v=n(26),b=r(v),g=[[\"bold\",\"italic\",\"link\"],[{header:1},{header:2},\"blockquote\"]],m=function(t){function e(t,n){o(this,e),null!=n.modules.toolbar&&null==n.modules.toolbar.container&&(n.modules.toolbar.container=g);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.container.classList.add(\"ql-bubble\"),r}return l(e,t),s(e,[{key:\"extendToolbar\",value:function(t){this.tooltip=new _(this.quill,this.options.bounds),this.tooltip.root.appendChild(t.container),this.buildButtons([].slice.call(t.container.querySelectorAll(\"button\")),b.default),this.buildPickers([].slice.call(t.container.querySelectorAll(\"select\")),b.default)}}]),e}(d.default);m.DEFAULTS=(0,c.default)(!0,{},d.default.DEFAULTS,{modules:{toolbar:{handlers:{link:function(t){t?this.quill.theme.tooltip.edit():this.quill.format(\"link\",!1)}}}}});var _=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.on(h.default.events.EDITOR_CHANGE,function(t,e,n,o){if(t===h.default.events.SELECTION_CHANGE)if(null!=e&&e.length>0&&o===h.default.sources.USER){r.show(),r.root.style.left=\"0px\",r.root.style.width=\"\",r.root.style.width=r.root.offsetWidth+\"px\";var i=r.quill.getLines(e.index,e.length);if(1===i.length)r.position(r.quill.getBounds(e));else{var l=i[i.length-1],a=r.quill.getIndex(l),s=Math.min(l.length()-1,e.index+e.length-a),u=r.quill.getBounds(new y.Range(a,s));r.position(u)}}else document.activeElement!==r.textbox&&r.quill.hasFocus()&&r.hide()}),r}return l(e,t),s(e,[{key:\"listen\",value:function(){var t=this;a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"listen\",this).call(this),this.root.querySelector(\".ql-close\").addEventListener(\"click\",function(){t.root.classList.remove(\"ql-editing\")}),this.quill.on(h.default.events.SCROLL_OPTIMIZE,function(){setTimeout(function(){if(!t.root.classList.contains(\"ql-hidden\")){var e=t.quill.getSelection();null!=e&&t.position(t.quill.getBounds(e))}},1)})}},{key:\"cancel\",value:function(){this.show()}},{key:\"position\",value:function(t){var n=a(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"position\",this).call(this,t),r=this.root.querySelector(\".ql-tooltip-arrow\");if(r.style.marginLeft=\"\",0===n)return n;r.style.marginLeft=-1*n-r.offsetWidth/2+\"px\"}}]),e}(p.BaseTooltip);_.TEMPLATE=['<span class=\"ql-tooltip-arrow\"></span>','<div class=\"ql-tooltip-editor\">','<input type=\"text\" data-formula=\"e=mc^2\" data-link=\"https://quilljs.com\" data-video=\"Embed URL\">','<a class=\"ql-close\"></a>',\"</div>\"].join(\"\"),e.BubbleTooltip=_,e.default=m},function(t,e,n){\"use strict\";function r(t){return t&&t.__esModule?t:{default:t}}function o(t,e){if(!(t instanceof e))throw new TypeError(\"Cannot call a class as a function\")}function i(t,e){if(!t)throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\");return!e||\"object\"!=typeof e&&\"function\"!=typeof e?t:e}function l(t,e){if(\"function\"!=typeof e&&null!==e)throw new TypeError(\"Super expression must either be null or a function, not \"+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,\"__esModule\",{value:!0});var a=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var l,a=t[Symbol.iterator]();!(r=(l=a.next()).done)&&(n.push(l.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&a.return&&a.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError(\"Invalid attempt to destructure non-iterable instance\")}}(),s=function t(e,n,r){null===e&&(e=Function.prototype);var o=Object.getOwnPropertyDescriptor(e,n);if(void 0===o){var i=Object.getPrototypeOf(e);return null===i?void 0:t(i,n,r)}if(\"value\"in o)return o.value;var l=o.get;if(void 0!==l)return l.call(r)},u=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,\"value\"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),c=n(2),f=r(c),h=n(9),p=r(h),d=n(44),y=r(d),v=n(15),b=r(v),g=n(22),m=n(26),_=r(m),O=[[{header:[\"1\",\"2\",\"3\",!1]}],[\"bold\",\"italic\",\"underline\",\"link\"],[{list:\"ordered\"},{list:\"bullet\"}],[\"clean\"]],w=function(t){function e(t,n){o(this,e),null!=n.modules.toolbar&&null==n.modules.toolbar.container&&(n.modules.toolbar.container=O);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.quill.container.classList.add(\"ql-snow\"),r}return l(e,t),u(e,[{key:\"extendToolbar\",value:function(t){t.container.classList.add(\"ql-snow\"),this.buildButtons([].slice.call(t.container.querySelectorAll(\"button\")),_.default),this.buildPickers([].slice.call(t.container.querySelectorAll(\"select\")),_.default),this.tooltip=new x(this.quill,this.options.bounds),t.container.querySelector(\".ql-link\")&&this.quill.keyboard.addBinding({key:\"K\",shortKey:!0},function(e,n){t.handlers.link.call(t,!n.format.link)})}}]),e}(y.default);w.DEFAULTS=(0,f.default)(!0,{},y.default.DEFAULTS,{modules:{toolbar:{handlers:{link:function(t){if(t){var e=this.quill.getSelection();if(null==e||0==e.length)return;var n=this.quill.getText(e);/^\\S+@\\S+\\.\\S+$/.test(n)&&0!==n.indexOf(\"mailto:\")&&(n=\"mailto:\"+n);this.quill.theme.tooltip.edit(\"link\",n)}else this.quill.format(\"link\",!1)}}}}});var x=function(t){function e(t,n){o(this,e);var r=i(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t,n));return r.preview=r.root.querySelector(\"a.ql-preview\"),r}return l(e,t),u(e,[{key:\"listen\",value:function(){var t=this;s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"listen\",this).call(this),this.root.querySelector(\"a.ql-action\").addEventListener(\"click\",function(e){t.root.classList.contains(\"ql-editing\")?t.save():t.edit(\"link\",t.preview.textContent),e.preventDefault()}),this.root.querySelector(\"a.ql-remove\").addEventListener(\"click\",function(e){if(null!=t.linkRange){var n=t.linkRange;t.restoreFocus(),t.quill.formatText(n,\"link\",!1,p.default.sources.USER),delete t.linkRange}e.preventDefault(),t.hide()}),this.quill.on(p.default.events.SELECTION_CHANGE,function(e,n,r){if(null!=e){if(0===e.length&&r===p.default.sources.USER){var o=t.quill.scroll.descendant(b.default,e.index),i=a(o,2),l=i[0],s=i[1];if(null!=l){t.linkRange=new g.Range(e.index-s,l.length());var u=b.default.formats(l.domNode);return t.preview.textContent=u,t.preview.setAttribute(\"href\",u),t.show(),void t.position(t.quill.getBounds(t.linkRange))}}else delete t.linkRange;t.hide()}})}},{key:\"show\",value:function(){s(e.prototype.__proto__||Object.getPrototypeOf(e.prototype),\"show\",this).call(this),this.root.removeAttribute(\"data-mode\")}}]),e}(d.BaseTooltip);x.TEMPLATE=['<a class=\"ql-preview\" rel=\"noopener noreferrer\" target=\"_blank\" href=\"about:blank\"></a>','<input type=\"text\" data-formula=\"e=mc^2\" data-link=\"https://quilljs.com\" data-video=\"Embed URL\">','<a class=\"ql-action\"></a>','<a class=\"ql-remove\"></a>'].join(\"\"),e.default=w}]).default});\n//# sourceMappingURL=quill.min.js.map"

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(248)(__webpack_require__(857))

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(248)(__webpack_require__(859))

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(248)(__webpack_require__(856))

/***/ }),
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAARCAYAAACLkmHIAAAABHNCSVQICAgIfAhkiAAABj5JREFUWIXdl32MnFUVxn/nnZnV/Zx7rlRsa112d1pIazHSEAqpsZJYSmlSkmLXtqEJqI1IQIiASSvQGtFKImICRD4MIdFCETRiqBKBriG2fNcIfnV3Z7u22wIt7ztLd5fuzsw9/rEz7VJ36qoJVp+/zjnvOc+557k3ufcV/g+RZ/bNYNeD6MnyhLC6jd5Hesn1C5Jup3smQATUqeo2p9rlVHdks9kFU23eorosq3rjfzjDvwVV3aiqTwI41cPZbPazAPuYMxP4Zm1BbJthgwAGc/vILTbYHWGv7iV3/l5ap0eq+qDBdMw2CbwkIhdXms53zi1W1Y+dwJpu9v78+vr6mSlYK7DMOfdJIKWqi5xzi4GGiQVNTU3TnHOtAM65T1TtE9Hc3DynpaVl9oRQQ5P3c0/Ma/J+XoAZx8aE24FegBL20VpCAi+00bNWYP24G91syA4hXJsi+nJAdgbSa9IGSzFbWSgUuoCuY+UijwiUEWl33t9SiOM7VHUDIteY2QD19dditgioR+TKxsbG2wx+KyJ/Vu9dyazzSJL8Tr3/NdCKWYPz/hmBC8zsA6p6b5IkW1R1J/DjJEnuSaVSN4pIEfiKU30IWASUVHV3kiSfb/J+bgZeBPoRmYvZdgCBmwx2A/laahj2aj3RcoEy9DzaS26GwPdAIoiuLxIOGfaDCHklLSK+KHLoRJIkjucBZL2/QcyuAu5AZIOFsLwiIKq6VUQ6kji+BoDh4RSA8/43KehU1SNmtqSQJPXOuUuAx5IkaXDOXUwU3Q1smWyAeu9nCawrjo2dPjQ0NKTeD2ez2Y2YXQ1sTZJkvapuBC44yamYKMm2dnouFyhWIx303NlL++tC9IQg1wEHOuiZCZCuwRI5718AgpjVm0hLJd5oZu9MVtDc3HxmOpPZYWZ7BHImMlCCxjSMAqPlKHojDUeBo2WRt9Lgao2QGhtroq6OoaGhd4CjZhYAjcAD+6YmREUObGs7Pev2kju3Hyu20vvKQXLTRgitHeSfzjN7KdhThpyWJ9cF3BMZvJkOYU6FI+OcO6OlpWWBwFmFOF5Yhq8D9s+ap1KpToNdhSRZbPD4VGrGF82omY1vThSlDco1c0VGAzRW7LqT5VYEebadnnV5cjcZsqtM9HIvuc3vwmtC6qVecs+20f1cRFgpUAfyabBZaTO7VUQecKqXInIWMFAaG7s6SqVKTvVnAtMMdk5hvtcwu855/yNgucE3piKKwFMm8lXn/TTMLi2LLKs9JNsFfui8PyzwBcY3rFbumFBeI1DuRc4+3k9umWB/Zj9zZpzBnu15cveDfAkgGkySewVWINJHCN8pxPHKkZGRg4UkmY5ZVwjh1kIcr6402lQsFg9WSUMITwf4KUChUPg5ZucQwh8CrBiM4/tLsA+zbwFU7NsASiJ/q9pJkmwJ5fJqM9uP2YVH4niXiBwy2DxeBphtLhaLBwbj+NFyqbSQEOISrEqS5CeVdR27fY4PbL9qp+/Nir19cuHsj7PYMwCQwh6asFH/+2hoaJgBMDIycqCP2ecZPG/wcAfda6o5eWY/Bqys+gZDaey8Vnr+BNBPx4Iy0csQboje9wn+Eb8ANgAbAZxzKybJ+WA2m10CoKq3n/gxk8l8PJPJzHtv1M6d6LXR3QlWOVl2KIJPVQUBKCFLqvapIMoB4NvAYWC+iZwJkPW+U1Xvc6p3Aekoijqy2Ww7MKuxsfEjzrkrsqp3t3i/dDJSQXJ5cquO+5Tb6FkHtiuCy9vo/n31Wz+5eYJ8rerXupL/G+gHTo/gNADMzk6SZL1TvUtVU4AfHBzMq+q+4eHhN1T1Gcz6BC4zeKIG58N5cp8T5EmwvX2wFlgYkF/2knsAeAv4cAn5okCmWnQqnJQqmhl/xwAgZkdV9T7M9kyWbCKbCoXCcwLDtSklArksYHcGuEiwxwUujLAlEfKiwEJBrpooCJwaJ6UZuAS4AugEllfirwcYjUTeTkRMzd77Jgmh7Jz7bhD5CxCovIsy2MAYhHFBAGwEeBAYDcjC4wQG8DzQKOO/E+O08PapcPucA7QAfwWOXfdZ71eVx8a60nV1WwpxfOW/QpinYx1E32f8BTxFmBl0BYY6TwVRJoWqzjezD41GUc+7cbz//ez9d0Ryedx92VNRAAAAAElFTkSuQmCC"

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/images/logo_circonopoly.8766b90.png";

/***/ }),
/* 895 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 896 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 897 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 898 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 899 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 900 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 901 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 902 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 903 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKUAAABhCAYAAAC3UmF4AAAABHNCSVQICAgIfAhkiAAAHQlJREFUeJztfXlwHNeZ3+973T0zuEiKAElcvA+RIEFSJ8VTomSvDlsrH+IYAC07SlXKccVVqVQlcuzVZumNN1lXNt7YWe+VrXDXEq+hZVurWlGSHVGUKIqiRPE+wPvAQYAgQVwEpo/35Y+e6emeGdxzkaNf1QDT3a9fv+n+9Xvv+953AJ/jc+QYKNsNGAocChXrwqwWFlczqIoFTYeUE5kwgZhKQFzCoEICesHcw4RuYuoB+CZAzUJQk8Vmk7+49Co980w4279nvOBQaLIuzGq2uFoQqplRScAECSoh4hIGJoChEagXQDeDewjoZKJOYjQJQU0qK00AmikYtLL9ewZDTpGSQ6GCMOmPCUlPMegpEBakqmowHwLwliDapUL9KJcfShQcCk3WYX0RkE8x6EsETElNxWww0YfE/BYU2uV/vuFoSupNEbJOSn799RJD7/2qZKon4HEAvgxctgvMu5jENn9n9y76zneMDFxzROBQqDxMZh0xNgBYiQw8Iwa3AvitAtqqbqj/kIg43dccClkhJTNTeOf2Zwnym2A8C6LAoIV9PpA/APj9oEAA8AdAgQDI77e/axpY18HhAWBgABwOA+EB8MAAEA7b+40hOXeTwb9SQP+oBRs+SvmPHQF48+aAUeyvl8wbibEeRCJpQSLA57d/e+QekD8Q+R65R6oKdv9+133g8ADQ3w9IOXhbwJcJtI2l2ByoqzuTrt88FDJKSt60SeiLFnwDxH8C0L1JC2kaREUlRGU1REUloKrjv/DAAGRrM2RzM2Rb66APhYE9CvCnWrDh3fFfdHjwG28Uhvt7/i0YLxFhWtJCBYUQlVVQKqtAU6cBIjlfR3Xdnh7IlibIlmZwx/VBCrEEEGKSmwLBFxrHfdFRICOkZGbSd26vZ8gfEWheQoHiYiiV1RCVVaCyKXaPkC5YFmTbNeehIJxE/mHeL4j+KF3k5M2bA+FC3/eI6AcAJscfp3smQ1RW2fdj0j3paEIMum6/sC3NkK0tgJUw1WYAr0GKH/nr6o6ntzE20k5KY8erqyXEL0BYlnDxyaVQF9eCyivS3YzkYIa8cgnmieNAX2+yEv/Cgv9D4PmNZ1N1yfDOLXXM+B8Eqo4/JqqqoSxZCpowMVWXGx1ME9a5M7AaTwN6wstqMfjv/dBepmDwZjqbkTZScig0Q2fjJyCqS7hoaZlNxmnl6br86DAUOZkNAv1cCxT9iJ57rmesl9BDWx5g0C8ArIg/JqqmQ1lSmz0yxsM0YZ0/C+v0qSTk5FvM+BP/1Mq/pvXrzXRcPi2kDO/Y+hUQXgFQ7LlYrpExHsyQVy7DOnUc3OPlHwPNAvw1X3DjgVFVuWmT0Bff+0NI+aN4AUZUT7d7xpIJKWh8GjAUOZk/8ZH2PAWDV1J92ZSSkt980x/u7fxLAn3Xc5GyKTYZpyafy+ccmCGvXoZ1MoGcJjP/IPCNjX8xomq2bi0Lq/gNAWvc+0X1DLtnzFUyxsOy7GE9kZxdTLI+sOGbu1J5uZSRkrdvn6sL+TqAxU7ldxoZ48EMefUKrJPHPORk8C4/tHoKBrsGO9UIbV1jgV8j0NToPjF9BpTFdxAZ4xElZ+Mpj4BIwE+1KRXfT9VwnhJS6qEtDzPwNkCTovuUxbVQapakovrsQ0qYBz6CvBobqRh8zm+Jx6m+/mp88fDOLXVgegWArc8SAurK1RCVCbLNnQk9DGPPbvCtTmcXM+/2h61n6Vvf6htv9eMmpbFz+x9Ilr8FUBDdp65YCTFj1nirzjmYhz6FPBcTxBncSoIe9z/fcDq6Tw9t+R6Dfo7ovVVVaOvWg0rLMt7etMI0Yez7ANx2zb33kE8reJy++tVb46l6XKRM2iOsXgtRXjmeanMa1umTsI4dce3hWwQ86QtuPBDesfUnILzkHAoEoD36eO5I1akGM8yP93lGEACnfYr1OH39hdaxVjtmUoZ3bP06CDudOjQN2trH7r4eIQnkpYswP/0Y4MgSMXMfkXidwQ1OoaJi+NY/ARQUZqmVmUOSEeSK36SHqaGhbSz1jYmUxs5tj0nm3yHaQwYC0B574s6dwI8B3HYNxofvu1ZAGGACyF6R0datB3yZsC3JDViNp2AdPRzbwTjuCxStGotud9Sk1Ldvf4iF9R5Adhfg88P3xaeAwru/R4gHd1yH8d7/i/WYAKhkArQvPJmaNfs7DPLCOZgHP3G2Gdjrh/oEBYP6aOoZ1er+wPbtC1hY7ziEFALausfykpBAROX10CPenSw9JM0niDnzIObFTGAJWKPD3MmbNo2KZyMuzG+8UQiSHrWPumIV6J4Ee4K8gpg5C8q9i5xt7u2Fse+DLLYou1CX3w+aMtW96w/1RQt+PJo6RkxK/XbPZiI4eh5lYQ1E9fTRXOuuhVK7zLN0yu1ttoI5H0EEbfU6UHGJax/+s7Fjy7qRVjEiUuo7t74IQtA5qaISSm2C0U/+ggjaqrWgCTFBzzp2xKNczitomi3oxebVZBHt4K1bR6SaGZaUHAqVM+PnTu0lE6CuXDPUKfkJVYW2dj2gafY2M8z9Hw5p5X1Xo6gI2up1jm0sAeW6gl+M5NRhSamz+TNErX18fmiPrgcUZRytvYtRWAhtzaPOg+CenvwdxgHQ1GlQH3jItQNBY8eW9cOeN9TBiD5yd3RbXbEKYsbM8bRz3JCXL4O7B7WDABUWQcydm8EWJcI6dgTW6ZP2hhDwPf1s3mooAMB4f7ezHMngC/7ie2qGcnkeVJkWMUP7vxThLU2YmHVCclsbrMOHhi0nqqqAwOC+aOmGsrAG1oVzgK4DUsI4eADa2sey1p5sQ112H4x3bOs2As3Rezr/CMB/Gaz8oMN3uO/Wdwk026n4vgdS2c6xgV3zs6JiUGmp8/GQUGbZpVvToCxyLPjA11rB7WNacbsrQBMneTs0ou9zKDSoD3tSUnIo5AOzY1hA5RU5ZxOpzJ8Pdc1a5yMqc8sIRJm3AChwDKdgnjqRxdZkH+rS5W6HQJ/O5n8crGxSUhow/hWBHG8udel9qW1hCsC9PeCOjtinfyDbTfJCCKi1y51Nbm8Dd6bV3yq3UVBov6hREH+Xt2xJ6qqZQEretElI4IdOgZmzQRNzz/RKnjsH88O9zodbW7LdpASImbM89846mREP1ZyFUrPEpbukEl3F95KVSyBleNGCLxHIngAQQf1cST4uuEcZ2dIM9N/OYmuyDJ8PysIaZ5MJ3+NQKEG/mEBKIn4h+l1ZsNAzL8olUHk5xL0LnQ/dk2an/TEifj5uXbqYxdZkH8qChYDfFkoJNNWE+cX4Mh5S8i9/WQTGV5wK5iePrJILEOUVUBYudD65SkoAnrmUdfF8FluSA1AUKLPnOJuS+ZvxRTykNPxaA4jsdbLi4qz1krKxcdh5It+6BXmmEfLsWfD19iEFHXn2LIx33oZsbk5Hc4eFmFYekzz7+vJb4IFtO+HC13nzZo9S2aM8Z+IvOydmyc/GOn0astH2wzI7OqA+vAJUUQGYJuT1DqecHGIYlNeuQcyaDQgB2dho+ysDsD79BCSEXV8moaqg0jInmJRsboKSxyZ/VFpmL1VbFkAU0Av9TwH4bfS401MyM4H5CedAFuL7yAsXHEJGYX5yANbBgzB2vQl5YWRDn3XsGIy334L16ScOId31cVvmFdnu3kHmsSIdAEDk4RcRPMtdTk9pvLb9ARAVAQCEsIecDEJevgTrWCygLJVNsXsWZsgml2t1IABRWgoUF4MKi0ABP/h2P/h2H7jH1l3CNO1oYq7hmsrK7GPMMD/eD3X1GnslKEMQ5RWOFyTfvGH3Enls2CLKKyGbmwAADHiMNBxSSsnro/p2mjI1JXEQRwpubYV1OOZ0pNQuhZgzB9apk5BnInE7i4uhzJ8PMX1GQqhAz5ZpQl66COvsWXvtmQjKAw9AVFXD+uwg5NWrNjE/2gd11WrQ5MwMozTpHsDvtyNLMIM7ruduTKUMIG4kXsqh0ORoNDf3nPLxQU5IO6xLl5zvVFYGMceWzpRFNXavyDzyB6iqEPPmQ8yeA9nSAiopAU2yPTiU5fdBtrfbxIjEqVQyRErAvq/ysv1bZXsblDwmJQoLQRMmgLu7AQA6GY8B+DXgJiXjvmiXEycdpR1KTQ3MzpuAYYA7OmAdPQpl6VIASFxz7+uDbGmBvN4O7u21CVZQACopgZg6FaK6GtB8gKJATHe5a1gWzI8/jsXAKSyEMjcxfms6IcorY6TsvIn8HbxtiGkVsCKkBNNDcJOS33zTr/fecp5+pv23aeJEqI+shLnvQ7sHu3gBVDoZosoVe8fQYR056sxDPOjrA/f1wbp2DdapU1CWLk3wH7LONIKvt9sbgQC0NWsz7pftjsrLvWMOdZkU3N4GGfl9Yuq0eOetnIRHt8xwlJcqABjd3QsdOTxLdog0eTJEebkjnHhCOfb3w9i7F7jtip2kKPa6MhFgSXDXLdu11TBgHTwI2dwM9cGHHGGCXHNkZfacrOhgye+Pbdy+bbc3RaG0ZXsbrKglkhBQ7gRS+l1cI3YsswUAMMl5SQtmEv39MWm5sDCmS5QS5v6PvISELQypa9fZpmuPPgoxe7bnOF+7BvOzg852VG8JANaF89nxnXGTkjnhN+Ud3PfDFQtfRP7OTV4wc3ALO8qiGqcHsU6edCbDIx5uI709t7RAXrls7/P7Y24S4TBk65jjL40Pvtj95d6kcdbzBuTl2sSoKZst6Eie4nidZYiU3NXl0UtyV8TvRoiYwW5fL+T5c/Z3TYNSs3hE7hDqAw/avatlwTpxwp6bKgqUGTMhz9qBmKzjxyAvXgAAUFERlNqlGQm1Qn4/OBINlwf6s59dK5uIG5V1RSkH0GkP367YkvEF0wV56SL4xg3nA9MOAkvTYrlirMuxEHPKkiUg/8h6SiosiPWKuh7rFYuLYw5cAwPOteWVK5CZWuVxv/RWnrrfRqEoHn04qRwAIj0lgRxSZqqnTJKvxZ6gz5/vbDp+LUJAVE8flZ+LMnOWo3jntjag2pbklbnzPD10FJSsPWkA+f2IRhriMfgS8Y0OO4tY/P6e7tj37q6kWgoqKABNztwq1ogQCNhCHwCSLlLC1VNSpqVvvx/aU08nPcTRxk6aNPoVpsJCezg2TbDLsFbMmeMo56HrMHa9OaZmjxnukWgML4J18gTktaGt7OXlS7G5tAuienrOBZIgv995zmCblPaTJmhOKU1LPDNbiOZUHGubooKRPqpIdGkFuYW1DPXOOQ0tdj8s4ekpud9ZQc70A5TSNpQAAEV4o7gFAkAk4eWYEP0t7kAAzOCbN22VjJn55LXsvr9jMMigsjIIJXHU4O4uJ4MFTZyYdAEk54ZuwJPMVYHSD0RXdBh9UR1usvlKuhtlfrg31rClSyEilslUWAgeGADfuuUIQiNGf39MeHJFALNOnXQk8KzAdX9JHf0I4PYnd8M6ftRRnosZswYtl2vggf7Yd0IvEBm+BagvVihDpBwkFrjb3MxtPhdV34wUVlSVBECZGXOEl5cS51oAwFpmIu+6H0I+RvtNgItvDO4Foj0loS9ZoXRCuffeiM7OHs5kUxPQ1xtRDxmAqkHMnmUnr5QS1pkzUBYtGqZWG/J6B+R52yCYJk8GSuyekm/cAAz7elRaamfMhb0EmSnLKA677m++k1LXPVGPfYbdOdoqIUKLk+jA/SanE0LEpGDYUph11DaClRcuQixYAGg+iLlz7eHWNGEdH5nftHUkYptJBGVZzEVYXoy5UCiLajJq5OvgdkwTkHFNR44hgWsTJ7YDkeGbGM7Y6HmTMwgxfbojZVtnzzg9mrKoJmZdM9JY4pFyypIlTg4b7u52dHc0cWJ2CGkY3qD9RcVDFM4DeIfupmgkNgEAqhSxCVt/hnrKeKgqaEok5pFpQrZEdHFEUB95BFQ2ivw8RFBqayHmxJb0o3aMQObtRaPwvPBCpNYiy+cDioqAoiKv2imH4ZVfyHHAsic106ZdxvVWC4ACKW2pNcPzHXnpIrglphT2xMz2+6GuXgPr9CnIxsZh61JXrEiwVHerSKzG05E5ZYYTUbkl7xTbrCoLFtqO/ncQ3MM3MRxS2sP3+vUmg52F5kz7JXNrC6wjsdRyyrJlSYdXMWlSwr5koJKShH1i1iyIWZE8Asww9380ZPDVdMAdA52K83zohu2770DgXOxrBAQ45jcyw8GiLJeahsrKbNtHAGCGdfIErBPHR60V4O5uWIcOeYWbpctiBhGWZTuRZRCW6766rdDzFW6eMZNjkKDGdmIPEb4WLawsXY5MQZk7F2bE2MLx0ampgfnxfme1R54/P+LQLOahQ7FVoiuXwZ2dUJYt8/roKIrtGZkpSOkxKBF3gGV4OsE3b7oT2rMfyp7ohkNKwcoeJtuUiru77OhgGUp2SVOnQnnwQViffgrAVpTLpqueJShneXAEcAgZgbx6BfJaa6w+RYG6Zo0nxUi6IdtaY9buQjg60nyFbPWE0DlIwaBj8ewM3766uiMAO95MsiWzQ7ioqob68IrYjiiB/H4oS5aMXvAKBKDU1sasi6L1qapNyAwPn+77SaVlKfPNuVPhmSIyv+c+5l3ZZ/xz0pMyBKqosIkZfWA+H7S1ayHmzoP25FMeFc9QUGprof3BkxBz5kJ9ZGWsPlWFumZtVuZzssW1fJqFkDg5hXDYI0wLId5yH/aGAhS8Pfpdtl/LinMVVVRAXbUaYvoMaGvXAVEFs6pCTBmZCkeUx6Kc0ZQpUFevset79LGsRCXmri7Apf5QZs4aovTdD/fQzeB29fm6d93HPWOin327dDY6QXQPLAt8vT0roUWorAzKMDpE6/ChEfnrAPY6t5KNFZwI3Ea5VFqWF4nph4J7FBagbUTkWarz9JQUDFoMei26bZ07k/YG3vVghnU+ZiqnzMjvXhIDA56pDARtiy+SYC2qEJxCsqXZjhCWK3ALB6oaCy/t8utJKJdlyIvngb6IERZR1hNkZRvm8aPOtJDBTb7n6z+OL5NASnVD/W4ATtIX88jIhshMgO6ZHHONME1QYQGUhQu9XoHFxUAgR+K0WxbM48ecTVE9PeOhYnIKfX2Ql1x2sYyfJSuWJBA/MRh/5pzXcd3Jq5d1+HxQH3zQ2bSOHrUDDkSDqQrhld6zDOvcGcBlhKHULMlia7IP8+hhx0qKGR1+0pJmtU3qIug7dWYHAGcilFO95dRpMZ9uy4L5yQHnmLJsWdJ176zAMDx5c0T1dMeMLh/BXbcgm2J+/AT+CwoGk5qkJSUlbdokifjH3gozu048FJTFSxJWY0RlVU7N16zGUx6/ImVxbRZbk33EdWxdvkF6SWCIhKHa8w2vAOxEiDKPHhq5kW26QQR1xSOxVZ6iIij335/dNrkxMODJ8y1mzs7vXjJuCkjgl93LivEYlJS27ohfBCIBHeInqdlGYSG0x5+Act/9UFetzqn44eap47GFB02Dujz3cltmEubhz2IbzJ9pGxoG7SWBIUgJAP7gN48R8/92Kj9yKOXBPseFggKIGTNAOZTgna+3x4JyAVCX3++JtJZvsBpPuZcULbDy7XhleTyGjYWiBYpfZsDuew0Dxp7dORVxIpfAPd0w9u5xpjlUWgYxa84wZ929kK0tsI7GEiwQ8DN/Xd2w3n/DkpKee65HIaoHRzLA3+6zb3w2go7mMgYGYOx5NybcaBq0R1Znt01ZBHd2wtz3gXtPo1ZQ8scjOXdEUaO0DfXvQdDLTvU3OmDu3zfKZt7FsCwY77/rcbrTVq7xhovJJ/T3w3h/t7vj6vVJ5Uv07LMjSuE74lBm/g0N/53B70S3ZfNVWMcTQ+rlHZhh7tsbC/oKO7RK3ubIMQx7xIhZlYNBdVRXN+JMqaOKr+f3Fz8PhjMnsE6dSBpyLp9gHTnksQISZVPyVycpJYy9ezyxMgG8HAjW/8toqhkVKem553p8Fr7AYEc3ZB74KCsGwbkAq/EUrLNel1/Z1RX/UPIDzDA/2e8kRbV38d/6gw1/NsRZSTGmRWIOhWaE2TxABCf3jrL8/pzOD55SMMP89IBHb8vMIJeFu7Zqbf4M4boOY98HsTxFAMB4zRes3zCc+icZxpSAkYLBK8TiC2B2HJmtw5/B/Hhf7qz6pAu6DmP37+OtXc4IwosAbNHbNGG8vxvWmdPJ67iLwD3d0H/3loeQDH7HN7WibiyEBMZISgDw19Udh0KrGOzk/pBXLsPY/XvPJPdugvMAbri9Jfmwj9SVvuDGfxQkvgTAEcGtI4fu6heV267B+P3bcfmA+HV/Z++Xaf36UQYUjWHcNl68bdv0sCLfJVdyHhQUQnt0fcbT6aUT3HYNxr4PPEYWzPy+v3DC025Vhx7a8jADbwPkhPOg0jJoa9bdVSs71tlGWO7lQwAM/hv/hoZ/N9YeMoqUGB7yr/+pVDe13wGILfKqKtRHVmctmFQqYZ05DSvBfI9f93X2bqDvfCchRnX4V1sXsuR3CRRzW7xbXlRmW7iN17oQ/bF/Q/2Pk580OqTMGpZDoQIdxj8A1ODeL2bMglq77I5UJPOtTpiHP/NO4AELwJ/6NtT/16F6BA6FynWYrwFY5ewUwg5EtbAmtxIejBCytRnW4QT7h14wXvB/o+G3qbpOyk209R3b/jUT/xXcCaOEgDJvgR2H+05wB+jrg3n8SEJvwOB2BfR1Ldiwd5AzveVDIUVn87+B8JLngM8HpWYJlLnzR5+KJQvgzpswDx2Mm0sDAE74LPoy1ddfSnbeWJEWv4Hw9u2LIOTrALweXZpmP4x5C3LzYeg6rFMnbN1jnHDCzLv9FgWpoSHhyQyHgZ2vPk0sXgXgzXhfVAS1dnlmYxqNBr299st59UrCIWb8nb9k0r+PBjpNJdLmzMKbNwf0Iv8PAHwfgHeGX1gItXYZRK64m1oWrHNnbPeFuCwUzOgQoB9qwbp/GM8Enn/9y6m6qfwEoG8j7r7TpElQ73swd+ILhcP2y3nuTDLNwVkB/Bst2LAn2ampQNo9rPi1LXN0k/4XCM8mHCwogKisglJZDZo6LbO9p2lCXmuBbG62IzYYCfKKxYy/85P6QwoGUxbI0pbO6f8AWBp/jCZMtN06qqozn/NmYACytRmyuQmyLWl0lF4w/9h3q/enyYS7VCJjbn/Gzm2rJMuXAPrDpNdVVYjyCoiqaoiKqvQIAv23IVuaYTU32WH5kusPdQa/Asg/DwRfOJeswHjBmzYJffH8r4DpZbg1Fm4EAhAVVRBVVRDTKtLywnJ3F2SLTcRB/fvtBZK/8WnmT+lr385IEICM+6KGf7V1ISz8J4BfAFFy5hGByqZAVFVDqZo+Lsmdb3XGbrwrkm4SdIH5b32k/U8KBq8PVTCVMEJbH5WMl0B4ZtBCimK/sJVVEJXVYxcWmcEd1yGbm2A1X/VkqkgoCr4Cor/0B0r+fqQmZ6lC1hyk+df/VGqYalCCGghYPWRbFAXw+UCaz/7v8wFa5L+qgg3DtoY3dDsvj66DDfv/kMbIzAYIb4Owxcfa64O5fGYCHArN1tmoB+jbICwYsrCqDn4/hHDuh30PwoBu2PfF0AcbHaKt6AHTbwR4q0ra7ykYzEryyJzw2udt26brCm9k4BkCViIu8FaKr3YbTO8R6A3NlDto48Yhu89sQA9tWc6gb4DxNAjLhj9jPOAbYPwOoN/4bof/mV58MTs5a1zICVK6wa++OkH30xdY0tNEfB8zVbutkUYJi4FrBFwmYD+ReFtl8R4Fg3eMkxG/9kqFYYknGXgGwEIwqkE01gCbOjNaAL5IQuwhwlva8cZPaNOmnPJtyTlSJgOHQj5YVqWpcLUFmkgkS4gxQRKVkORCBnqFoB6W6GYhewQpNzWymmH5WrM1BKUT/MYbheFwd5XCospiTCCSJSRFCQueAIbGzD1CUA8z9QhCJ1vUqfn0Jvrat9qHr/1zfI7PkYD/D6HjBA//PvPjAAAAAElFTkSuQmCC"

/***/ }),
/* 904 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ })
]);


// WEBPACK FOOTER //
// js/vendor.73a7572c729658733ffd.js